/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1033);
	module.exports = __webpack_require__(1050);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(102);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var _isPlaceholder = __webpack_require__(149);
	
	
	/**
	 * Optimized internal two-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry2(fn) {
	  return function f2(a, b) {
	    switch (arguments.length) {
	      case 0:
	        return f2;
	      case 1:
	        return _isPlaceholder(a) ? f2
	             : _curry1(function(_b) { return fn(a, _b); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f2
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b); })
	             : fn(a, b);
	    }
	  };
	};


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(696)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1130)(module)))

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withTheme = exports.ThemeProvider = exports.injectGlobal = exports.keyframes = exports.css = undefined;
	
	var _generateAlphabeticName = __webpack_require__(1162);
	
	var _generateAlphabeticName2 = _interopRequireDefault(_generateAlphabeticName);
	
	var _css = __webpack_require__(178);
	
	var _css2 = _interopRequireDefault(_css);
	
	var _injectGlobal = __webpack_require__(1154);
	
	var _injectGlobal2 = _interopRequireDefault(_injectGlobal);
	
	var _StyledComponent = __webpack_require__(1160);
	
	var _StyledComponent2 = _interopRequireDefault(_StyledComponent);
	
	var _styled2 = __webpack_require__(1156);
	
	var _styled3 = _interopRequireDefault(_styled2);
	
	var _keyframes2 = __webpack_require__(1155);
	
	var _keyframes3 = _interopRequireDefault(_keyframes2);
	
	var _ComponentStyle2 = __webpack_require__(1159);
	
	var _ComponentStyle3 = _interopRequireDefault(_ComponentStyle2);
	
	var _ThemeProvider = __webpack_require__(134);
	
	var _ThemeProvider2 = _interopRequireDefault(_ThemeProvider);
	
	var _withTheme = __webpack_require__(1157);
	
	var _withTheme2 = _interopRequireDefault(_withTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Instantiate singletons */
	
	
	/* Import components */
	
	
	/* Import singleton constructors */
	var keyframes = (0, _keyframes3.default)(_generateAlphabeticName2.default);
	
	/* Import Higher Order Components */
	
	
	/* Import singletons */
	
	var styled = (0, _styled3.default)((0, _StyledComponent2.default)((0, _ComponentStyle3.default)(_generateAlphabeticName2.default)));
	
	/* Export everything */
	exports.default = styled;
	exports.css = _css2.default;
	exports.keyframes = keyframes;
	exports.injectGlobal = _injectGlobal2.default;
	exports.ThemeProvider = _ThemeProvider2.default;
	exports.withTheme = _withTheme2.default;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Metrics = exports.Fonts = exports.Colors = undefined;
	
	var _Colors = __webpack_require__(242);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _Fonts = __webpack_require__(1035);
	
	var _Fonts2 = _interopRequireDefault(_Fonts);
	
	var _Metrics = __webpack_require__(1036);
	
	var _Metrics2 = _interopRequireDefault(_Metrics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Colors = _Colors2.default;
	exports.Fonts = _Fonts2.default;
	exports.Metrics = _Metrics2.default;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var _isPlaceholder = __webpack_require__(149);
	
	
	/**
	 * Optimized internal one-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry1(fn) {
	  return function f1(a) {
	    if (arguments.length === 0 || _isPlaceholder(a)) {
	      return f1;
	    } else {
	      return fn.apply(this, arguments);
	    }
	  };
	};


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.I18nextProvider = exports.Interpolate = exports.translate = exports.loadNamespaces = undefined;
	
	var _translate = __webpack_require__(999);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _interpolate = __webpack_require__(997);
	
	var _interpolate2 = _interopRequireDefault(_interpolate);
	
	var _I18nextProvider = __webpack_require__(996);
	
	var _I18nextProvider2 = _interopRequireDefault(_I18nextProvider);
	
	var _loadNamespaces = __webpack_require__(998);
	
	var _loadNamespaces2 = _interopRequireDefault(_loadNamespaces);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.loadNamespaces = _loadNamespaces2.default;
	exports.translate = _translate2.default;
	exports.Interpolate = _interpolate2.default;
	exports.I18nextProvider = _I18nextProvider2.default;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(699)();
	}


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var _curry2 = __webpack_require__(2);
	var _isPlaceholder = __webpack_require__(149);
	
	
	/**
	 * Optimized internal three-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry3(fn) {
	  return function f3(a, b, c) {
	    switch (arguments.length) {
	      case 0:
	        return f3;
	      case 1:
	        return _isPlaceholder(a) ? f3
	             : _curry2(function(_b, _c) { return fn(a, _b, _c); });
	      case 2:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f3
	             : _isPlaceholder(a) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _curry1(function(_c) { return fn(a, b, _c); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3
	             : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function(_a, _b) { return fn(_a, _b, c); })
	             : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b, c); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b, c); })
	             : _isPlaceholder(c) ? _curry1(function(_c) { return fn(a, b, _c); })
	             : fn(a, b, c);
	    }
	  };
	};


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  ', ';\n  width: ', ';\n  display: inline-block;\n  border: 1px solid ', ';\n      border-radius: 0;\n  padding: ', ' ', ';\n  background: ', ';\n  cursor: pointer;\n  color: ', ';\n  outline: none;\n  text-transform: uppercase;\n  pointer-events: ', ';\n\n  &:hover{\n    border: 1px solid ', ';\n    border-radius: 0;\n    background: ', ';\n    color: ', '\n'], ['\n  ', ';\n  width: ', ';\n  display: inline-block;\n  border: 1px solid ', ';\n      border-radius: 0;\n  padding: ', ' ', ';\n  background: ', ';\n  cursor: pointer;\n  color: ', ';\n  outline: none;\n  text-transform: uppercase;\n  pointer-events: ', ';\n\n  &:hover{\n    border: 1px solid ', ';\n    border-radius: 0;\n    background: ', ';\n    color: ', '\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  label: _react.PropTypes.string.isRequired,
	  onClick: _react.PropTypes.func.isRequired,
	  disabled: _react.PropTypes.bool,
	  grey: _react.PropTypes.bool,
	  success: _react.PropTypes.bool,
	  cancel: _react.PropTypes.bool,
	  primary: _react.PropTypes.bool,
	  secondary: _react.PropTypes.bool,
	  fullWidth: _react.PropTypes.bool,
	  link: _react.PropTypes.bool
	};
	
	var ButtonContainer = _styledComponents2.default.button(_templateObject, _Themes.Fonts.style.Button, function (props) {
	  return props.fullWidth ? '100%' : 'auto';
	}, function (props) {
	  return props.disabled || props.grey || props.success || props.cancel || props.primary || props.secondary || props.link ? 'transparent' : _Themes.Colors.primary;
	}, _Themes.Metrics.margins.small, _Themes.Metrics.margins.large, function (props) {
	  if (props.disabled) {
	    return _Themes.Colors.lightGrey;
	  }
	  if (props.grey) {
	    return _Themes.Colors.darkGrey;
	  }
	  if (props.success) {
	    return _Themes.Colors.greenBlue;
	  }
	  if (props.cancel) {
	    return _Themes.Colors.red;
	  }
	  if (props.primary) {
	    return _Themes.Colors.primary;
	  }
	  if (props.secondary) {
	    return _Themes.Colors.black;
	  }
	  return 'transparent';
	}, function (props) {
	  return props.disabled || props.grey || props.success || props.cancel || props.primary || props.secondary ? _Themes.Colors.white : props.link ? _Themes.Colors.black : _Themes.Colors.primary;
	}, function (props) {
	  return props.disabled ? 'none' : 'inherit';
	}, function (props) {
	  if (props.disabled) {
	    return _Themes.Colors.lightGrey;
	  }
	  if (props.grey) {
	    return _Themes.Colors.darkGrey;
	  }
	  if (props.success) {
	    return _Themes.Colors.greenBlue;
	  }
	  if (props.cancel) {
	    return _Themes.Colors.red;
	  }
	  if (props.primary) {
	    return _Themes.Colors.primary;
	  }
	  if (props.secondary) {
	    return _Themes.Colors.black;
	  }
	  return 'transparent';
	}, function (props) {
	  return props.disabled || props.grey || props.success || props.cancel || props.secondary || props.link ? 'transparent' : _Themes.Colors.primary;
	}, function (props) {
	  if (props.disabled) {
	    return _Themes.Colors.lightGrey;
	  }
	  if (props.grey) {
	    return _Themes.Colors.darkGrey;
	  }
	  if (props.success) {
	    return _Themes.Colors.greenBlue;
	  }
	  if (props.cancel) {
	    return _Themes.Colors.red;
	  }
	  if (props.secondary) {
	    return _Themes.Colors.black;
	  }
	  if (props.link) {
	    return _Themes.Colors.darkgrey;
	  }
	  return _Themes.Colors.white;
	});
	
	var Button = function Button(props) {
	  var label = props.label;
	  var onClick = props.onClick;
	
	
	  return _react2.default.createElement(
	    ButtonContainer,
	    Object.assign({ onTap: onClick }, props),
	    label
	  );
	};
	
	Button.propTypes = propTypes;
	
	exports.default = Button;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  F: __webpack_require__(707),
	  T: __webpack_require__(708),
	  __: __webpack_require__(709),
	  add: __webpack_require__(143),
	  addIndex: __webpack_require__(710),
	  adjust: __webpack_require__(409),
	  all: __webpack_require__(711),
	  allPass: __webpack_require__(712),
	  always: __webpack_require__(94),
	  and: __webpack_require__(410),
	  any: __webpack_require__(411),
	  anyPass: __webpack_require__(713),
	  ap: __webpack_require__(200),
	  aperture: __webpack_require__(714),
	  append: __webpack_require__(715),
	  apply: __webpack_require__(412),
	  applySpec: __webpack_require__(716),
	  ascend: __webpack_require__(717),
	  assoc: __webpack_require__(144),
	  assocPath: __webpack_require__(413),
	  binary: __webpack_require__(718),
	  bind: __webpack_require__(414),
	  both: __webpack_require__(719),
	  call: __webpack_require__(720),
	  chain: __webpack_require__(201),
	  clamp: __webpack_require__(721),
	  clone: __webpack_require__(722),
	  comparator: __webpack_require__(723),
	  complement: __webpack_require__(724),
	  compose: __webpack_require__(202),
	  composeK: __webpack_require__(415),
	  composeP: __webpack_require__(725),
	  concat: __webpack_require__(203),
	  cond: __webpack_require__(726),
	  construct: __webpack_require__(727),
	  constructN: __webpack_require__(416),
	  contains: __webpack_require__(728),
	  converge: __webpack_require__(417),
	  countBy: __webpack_require__(729),
	  curry: __webpack_require__(145),
	  curryN: __webpack_require__(35),
	  dec: __webpack_require__(730),
	  descend: __webpack_require__(731),
	  defaultTo: __webpack_require__(418),
	  difference: __webpack_require__(419),
	  differenceWith: __webpack_require__(420),
	  dissoc: __webpack_require__(421),
	  dissocPath: __webpack_require__(732),
	  divide: __webpack_require__(733),
	  drop: __webpack_require__(422),
	  dropLast: __webpack_require__(734),
	  dropLastWhile: __webpack_require__(735),
	  dropRepeats: __webpack_require__(736),
	  dropRepeatsWith: __webpack_require__(423),
	  dropWhile: __webpack_require__(737),
	  either: __webpack_require__(738),
	  empty: __webpack_require__(424),
	  eqBy: __webpack_require__(739),
	  eqProps: __webpack_require__(740),
	  equals: __webpack_require__(54),
	  evolve: __webpack_require__(741),
	  filter: __webpack_require__(204),
	  find: __webpack_require__(742),
	  findIndex: __webpack_require__(743),
	  findLast: __webpack_require__(744),
	  findLastIndex: __webpack_require__(745),
	  flatten: __webpack_require__(746),
	  flip: __webpack_require__(146),
	  forEach: __webpack_require__(747),
	  forEachObjIndexed: __webpack_require__(748),
	  fromPairs: __webpack_require__(749),
	  groupBy: __webpack_require__(750),
	  groupWith: __webpack_require__(751),
	  gt: __webpack_require__(752),
	  gte: __webpack_require__(753),
	  has: __webpack_require__(754),
	  hasIn: __webpack_require__(755),
	  head: __webpack_require__(756),
	  identical: __webpack_require__(425),
	  identity: __webpack_require__(205),
	  ifElse: __webpack_require__(757),
	  inc: __webpack_require__(758),
	  indexBy: __webpack_require__(759),
	  indexOf: __webpack_require__(760),
	  init: __webpack_require__(761),
	  insert: __webpack_require__(762),
	  insertAll: __webpack_require__(763),
	  intersection: __webpack_require__(798),
	  intersectionWith: __webpack_require__(799),
	  intersperse: __webpack_require__(800),
	  into: __webpack_require__(801),
	  invert: __webpack_require__(802),
	  invertObj: __webpack_require__(803),
	  invoker: __webpack_require__(111),
	  is: __webpack_require__(440),
	  isArrayLike: __webpack_require__(112),
	  isEmpty: __webpack_require__(804),
	  isNil: __webpack_require__(805),
	  join: __webpack_require__(806),
	  juxt: __webpack_require__(441),
	  keys: __webpack_require__(56),
	  keysIn: __webpack_require__(807),
	  last: __webpack_require__(442),
	  lastIndexOf: __webpack_require__(808),
	  length: __webpack_require__(443),
	  lens: __webpack_require__(152),
	  lensIndex: __webpack_require__(809),
	  lensPath: __webpack_require__(810),
	  lensProp: __webpack_require__(811),
	  lift: __webpack_require__(153),
	  liftN: __webpack_require__(444),
	  lt: __webpack_require__(812),
	  lte: __webpack_require__(813),
	  map: __webpack_require__(43),
	  mapAccum: __webpack_require__(814),
	  mapAccumRight: __webpack_require__(815),
	  mapObjIndexed: __webpack_require__(816),
	  match: __webpack_require__(817),
	  mathMod: __webpack_require__(818),
	  max: __webpack_require__(95),
	  maxBy: __webpack_require__(819),
	  mean: __webpack_require__(445),
	  median: __webpack_require__(820),
	  memoize: __webpack_require__(821),
	  merge: __webpack_require__(822),
	  mergeAll: __webpack_require__(823),
	  mergeWith: __webpack_require__(824),
	  mergeWithKey: __webpack_require__(446),
	  min: __webpack_require__(825),
	  minBy: __webpack_require__(826),
	  modulo: __webpack_require__(827),
	  multiply: __webpack_require__(447),
	  nAry: __webpack_require__(154),
	  negate: __webpack_require__(828),
	  none: __webpack_require__(829),
	  not: __webpack_require__(448),
	  nth: __webpack_require__(113),
	  nthArg: __webpack_require__(830),
	  objOf: __webpack_require__(449),
	  of: __webpack_require__(831),
	  omit: __webpack_require__(832),
	  once: __webpack_require__(833),
	  or: __webpack_require__(450),
	  over: __webpack_require__(451),
	  pair: __webpack_require__(834),
	  partial: __webpack_require__(835),
	  partialRight: __webpack_require__(836),
	  partition: __webpack_require__(837),
	  path: __webpack_require__(114),
	  pathEq: __webpack_require__(838),
	  pathOr: __webpack_require__(839),
	  pathSatisfies: __webpack_require__(840),
	  pick: __webpack_require__(841),
	  pickAll: __webpack_require__(452),
	  pickBy: __webpack_require__(842),
	  pipe: __webpack_require__(453),
	  pipeK: __webpack_require__(843),
	  pipeP: __webpack_require__(454),
	  pluck: __webpack_require__(115),
	  prepend: __webpack_require__(455),
	  product: __webpack_require__(844),
	  project: __webpack_require__(845),
	  prop: __webpack_require__(210),
	  propEq: __webpack_require__(846),
	  propIs: __webpack_require__(847),
	  propOr: __webpack_require__(848),
	  propSatisfies: __webpack_require__(849),
	  props: __webpack_require__(850),
	  range: __webpack_require__(851),
	  reduce: __webpack_require__(57),
	  reduceBy: __webpack_require__(155),
	  reduceRight: __webpack_require__(456),
	  reduceWhile: __webpack_require__(852),
	  reduced: __webpack_require__(853),
	  reject: __webpack_require__(156),
	  remove: __webpack_require__(854),
	  repeat: __webpack_require__(855),
	  replace: __webpack_require__(856),
	  reverse: __webpack_require__(157),
	  scan: __webpack_require__(857),
	  sequence: __webpack_require__(457),
	  set: __webpack_require__(858),
	  slice: __webpack_require__(82),
	  sort: __webpack_require__(859),
	  sortBy: __webpack_require__(860),
	  sortWith: __webpack_require__(861),
	  split: __webpack_require__(862),
	  splitAt: __webpack_require__(863),
	  splitEvery: __webpack_require__(864),
	  splitWhen: __webpack_require__(865),
	  subtract: __webpack_require__(866),
	  sum: __webpack_require__(458),
	  symmetricDifference: __webpack_require__(867),
	  symmetricDifferenceWith: __webpack_require__(868),
	  tail: __webpack_require__(211),
	  take: __webpack_require__(459),
	  takeLast: __webpack_require__(869),
	  takeLastWhile: __webpack_require__(870),
	  takeWhile: __webpack_require__(871),
	  tap: __webpack_require__(872),
	  test: __webpack_require__(873),
	  times: __webpack_require__(460),
	  toLower: __webpack_require__(874),
	  toPairs: __webpack_require__(875),
	  toPairsIn: __webpack_require__(876),
	  toString: __webpack_require__(116),
	  toUpper: __webpack_require__(877),
	  transduce: __webpack_require__(878),
	  transpose: __webpack_require__(879),
	  traverse: __webpack_require__(880),
	  trim: __webpack_require__(881),
	  tryCatch: __webpack_require__(882),
	  type: __webpack_require__(212),
	  unapply: __webpack_require__(883),
	  unary: __webpack_require__(884),
	  uncurryN: __webpack_require__(885),
	  unfold: __webpack_require__(886),
	  union: __webpack_require__(887),
	  unionWith: __webpack_require__(888),
	  uniq: __webpack_require__(213),
	  uniqBy: __webpack_require__(461),
	  uniqWith: __webpack_require__(214),
	  unless: __webpack_require__(889),
	  unnest: __webpack_require__(890),
	  until: __webpack_require__(891),
	  update: __webpack_require__(462),
	  useWith: __webpack_require__(463),
	  values: __webpack_require__(464),
	  valuesIn: __webpack_require__(892),
	  view: __webpack_require__(893),
	  when: __webpack_require__(894),
	  where: __webpack_require__(465),
	  whereEq: __webpack_require__(895),
	  without: __webpack_require__(896),
	  xprod: __webpack_require__(897),
	  zip: __webpack_require__(898),
	  zipObj: __webpack_require__(899),
	  zipWith: __webpack_require__(900)
	};


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral([''], ['']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n'], ['\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  ', ';\n  color: ', ';\n'], ['\n  margin-top: ', ';\n  ', ';\n  color: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  width: 100%;\n  border-radius: 4px;\n  background: ', ';\n  border: ', ';\n'], ['\n  width: 100%;\n  border-radius: 4px;\n  background: ', ';\n  border: ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  background: none;\n  ', ';\n  color: ', ';\n  width: 100%;\n  min-height: ', ';\n  border: none;\n  padding: 0 ', ';\n  outline: none;\n\n  &::-webkit-input-placeholder {\n    /* Chrome/Opera/Safari */\n    height: ', ';\n    color: ', ';\n  }\n  &::-moz-placeholder {\n    /* Firefox 19+ */\n    height: ', ';\n    color: ', ';\n  }\n  &:-ms-input-placeholder {\n    /* IE 10+ */\n    height: ', ';\n    color: ', ';\n  }\n  &:-moz-placeholder {\n    /* Firefox 18- */\n    height: ', ';\n    color: ', ';\n  }\n'], ['\n  background: none;\n  ', ';\n  color: ', ';\n  width: 100%;\n  min-height: ', ';\n  border: none;\n  padding: 0 ', ';\n  outline: none;\n\n  &::-webkit-input-placeholder {\n    /* Chrome/Opera/Safari */\n    height: ', ';\n    color: ', ';\n  }\n  &::-moz-placeholder {\n    /* Firefox 19+ */\n    height: ', ';\n    color: ', ';\n  }\n  &:-ms-input-placeholder {\n    /* IE 10+ */\n    height: ', ';\n    color: ', ';\n  }\n  &:-moz-placeholder {\n    /* Firefox 18- */\n    height: ', ';\n    color: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var Title = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.margins.small, _Themes.Fonts.style.Label, _Themes.Colors.black);
	
	var Error = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.tiny, _Themes.Fonts.style.Input, _Themes.Colors.red);
	
	var FormContainer = _styledComponents2.default.div(_templateObject4, _Themes.Colors.white, _Themes.Metrics.borders.default);
	
	var InputContainer = _styledComponents2.default.input(_templateObject5, _Themes.Fonts.style.Input, _Themes.Colors.black, _Themes.Metrics.components.inputFormHeight, _Themes.Metrics.margins.small, _Themes.Metrics.components.inputFormHeight, _Themes.Colors.darkGrey, _Themes.Metrics.components.inputFormHeight, _Themes.Colors.darkGrey, _Themes.Metrics.components.inputFormHeight, _Themes.Colors.darkGrey, _Themes.Metrics.components.inputFormHeight, _Themes.Colors.darkGrey);
	
	var Input = function (_Component) {
	  _inherits(Input, _Component);
	
	  function Input() {
	    _classCallCheck(this, Input);
	
	    return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
	  }
	
	  _createClass(Input, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var title = _props.title;
	      var error = _props.error;
	      var handleChange = _props.handleChange;
	      var value = _props.value;
	      var name = _props.name;
	      var type = _props.type;
	      var placeholder = _props.placeholder;
	      var required = _props.required;
	      var handleBlur = _props.handleBlur;
	      var className = _props.className;
	      var handleKeyPress = _props.handleKeyPress;
	
	
	      return _react2.default.createElement(
	        Container,
	        { className: 'inputForm ' + className },
	        title && _react2.default.createElement(
	          Title,
	          { className: 'inputTitle' },
	          title,
	          required && '*'
	        ),
	        _react2.default.createElement(
	          FormContainer,
	          {
	            className: 'formContainer',
	            tabIndex: '-1',
	            onBlur: handleBlur },
	          _react2.default.createElement(InputContainer, {
	            onKeyPress: handleKeyPress,
	            placeholder: placeholder,
	            onChange: handleChange,
	            name: name,
	            type: type,
	            value: value,
	            required: required
	          })
	        ),
	        error && _react2.default.createElement(
	          Error,
	          { className: 'error' },
	          error
	        )
	      );
	    }
	  }]);
	
	  return Input;
	}(_react.Component);
	
	Input.propTypes = {
	  name: _react.PropTypes.string,
	  title: _react.PropTypes.node,
	  placeholder: _react.PropTypes.string,
	  required: _react.PropTypes.bool,
	  handleChange: _react.PropTypes.func.isRequired,
	  handleBlur: _react.PropTypes.func,
	  width: _react.PropTypes.string,
	  type: _react.PropTypes.string,
	  value: _react.PropTypes.string,
	  error: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	  handleKeyPress: _react.PropTypes.func
	};
	
	Input.defaultPropTypes = {
	  type: 'text',
	  value: ''
	};
	exports.default = Input;

/***/ },
/* 14 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 15 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	var es5 = __webpack_require__(92);
	var canEvaluate = typeof navigator == "undefined";
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	var globalObject = typeof self !== "undefined" ? self :
	    typeof window !== "undefined" ? window :
	    typeof global !== "undefined" ? global :
	    this !== undefined ? this : null;
	
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return typeof value === "function" ||
	           typeof value === "object" && value !== null;
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function FakeConstructor() {}
	    FakeConstructor.prototype = obj;
	    var l = 8;
	    while (l--) new FakeConstructor();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function isError(obj) {
	    return obj !== null &&
	           typeof obj === "object" &&
	           typeof obj.message === "string" &&
	           typeof obj.name === "string";
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return isError(obj) && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var asArray = function(v) {
	    if (es5.isArray(v)) {
	        return v;
	    }
	    return null;
	};
	
	if (typeof Symbol !== "undefined" && Symbol.iterator) {
	    var ArrayFrom = typeof Array.from === "function" ? function(v) {
	        return Array.from(v);
	    } : function(v) {
	        var ret = [];
	        var it = v[Symbol.iterator]();
	        var itResult;
	        while (!((itResult = it.next()).done)) {
	            ret.push(itResult.value);
	        }
	        return ret;
	    };
	
	    asArray = function(v) {
	        if (es5.isArray(v)) {
	            return v;
	        } else if (v != null && typeof v[Symbol.iterator] === "function") {
	            return ArrayFrom(v);
	        }
	        return null;
	    };
	}
	
	var isNode = typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]";
	
	var hasEnvVariables = typeof process !== "undefined" &&
	    "object" !== "undefined";
	
	function env(key) {
	    return hasEnvVariables ? ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://api.hvb-investments.com"})[key] : undefined;
	}
	
	function getNativePromise() {
	    if (typeof Promise === "function") {
	        try {
	            var promise = new Promise(function(){});
	            if ({}.toString.call(promise) === "[object Promise]") {
	                return Promise;
	            }
	        } catch (e) {}
	    }
	}
	
	function domainBind(self, cb) {
	    return self.bind(cb);
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    asArray: asArray,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    isError: isError,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: isNode,
	    hasEnvVariables: hasEnvVariables,
	    env: env,
	    global: globalObject,
	    getNativePromise: getNativePromise,
	    domainBind: domainBind
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version = process.versions.node.split(".").map(Number);
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(48)))

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GoldenB = exports.GoldenA = exports.Quarter = exports.Third = exports.Half = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _templateObject = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  display: inline-block;\n  vertical-align: ', ';\n  padding-left: ', 'px;\n  padding-right: ', 'px;\n  width: 100%;\n  ', '\n  ', ' {\n    ', '\n  }\n  ', ' {\n    ', '\n  }\n  ', ' {\n    ', '\n  }\n'], ['\n  box-sizing: border-box;\n  display: inline-block;\n  vertical-align: ', ';\n  padding-left: ', 'px;\n  padding-right: ', 'px;\n  width: 100%;\n  ', '\n  ', ' {\n    ', '\n  }\n  ', ' {\n    ', '\n  }\n  ', ' {\n    ', '\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var breakpoints = {
	  small: '40em',
	  medium: '52em',
	  large: '64em'
	};
	
	var ms = function ms(size) {
	  return '@media screen and (min-width: ' + size + ')';
	};
	var mx = function mx(point) {
	  return function (props) {
	    return _typeof(props.theme.breakpoints) === 'object' ? ms(props.theme.breakpoints[point]) : ms(breakpoints[point]);
	  };
	};
	
	var pad = function pad(props) {
	  return typeof props.theme.gutter === 'number' ? props.theme.gutter : 32;
	};
	
	var p = function p(n) {
	  return typeof n !== 'undefined' ? n * 100 + '%' : null;
	};
	
	var width = function width(key) {
	  return function (props) {
	    return props[key] ? 'width: ' + p(props[key]) + ';' : null;
	  };
	};
	
	var align = function align(props) {
	  return props.align || 'top';
	};
	
	var Grid = (0, _styledComponents2.default)('div')(_templateObject, align, pad, pad, width('xs'), mx('small'), width('sm'), mx('medium'), width('md'), mx('large'), width('lg'));
	
	var Half = exports.Half = function Half(props) {
	  return _react2.default.createElement(Grid, _extends({}, props, { sm: 1 / 2 }));
	};
	var Third = exports.Third = function Third(props) {
	  return _react2.default.createElement(Grid, _extends({}, props, { sm: 1 / 3 }));
	};
	var Quarter = exports.Quarter = function Quarter(props) {
	  return _react2.default.createElement(Grid, _extends({}, props, { md: 1 / 4 }));
	};
	
	var φ = (1 + Math.sqrt(5)) / 2;
	var ga = φ - 1;
	var gb = 1 - ga;
	
	var GoldenA = exports.GoldenA = function GoldenA(props) {
	  return _react2.default.createElement(Grid, _extends({}, props, { sm: ga }));
	};
	var GoldenB = exports.GoldenB = function GoldenB(props) {
	  return _react2.default.createElement(Grid, _extends({}, props, { sm: gb }));
	};
	
	exports.default = Grid;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchPublicCategories = exports.fetchCategories = exports.findPropertiesById = exports.findPropertyById = exports.findProperties = exports.findCityByName = exports.searchPublicContinent = exports.searchPublicCountry = exports.searchPublicCity = exports.searchProperties = exports.findCategoryByName = exports.searchCountries = exports.searchCitieswithProperties = exports.searchCountriesWithProperties = exports.searchContinentsWithProperties = exports.searchContinents = exports.searchCities = exports.searchCategories = exports.searchLocations = undefined;
	
	var _axios = __webpack_require__(86);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(88);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _Constants = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var searchLocations = exports.searchLocations = function searchLocations() {
	  var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/preference/search_locations', criteria);
	};
	
	var searchCategories = exports.searchCategories = function searchCategories() {
	  var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/category/find', criteria);
	};
	
	var searchCities = exports.searchCities = function searchCities() {
	  var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/city/find', criteria);
	};
	
	var searchContinents = exports.searchContinents = function searchContinents() {
	  var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/continent/find', criteria);
	};
	
	var searchContinentsWithProperties = exports.searchContinentsWithProperties = function searchContinentsWithProperties() {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/continent/search');
	};
	
	var searchCountriesWithProperties = exports.searchCountriesWithProperties = function searchCountriesWithProperties(_ref) {
	  var id = _ref.id;
	  var _ref$skip = _ref.skip;
	  var skip = _ref$skip === undefined ? 0 : _ref$skip;
	  var _ref$limit = _ref.limit;
	  var limit = _ref$limit === undefined ? 30 : _ref$limit;
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/country/search', {
	    continentId: id,
	    skip: skip,
	    limit: limit
	  });
	};
	
	var searchCitieswithProperties = exports.searchCitieswithProperties = function searchCitieswithProperties(_ref2) {
	  var id = _ref2.id;
	  var _ref2$skip = _ref2.skip;
	  var skip = _ref2$skip === undefined ? 0 : _ref2$skip;
	  var _ref2$limit = _ref2.limit;
	  var limit = _ref2$limit === undefined ? 30 : _ref2$limit;
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/city/search', {
	    countryId: id,
	    skip: skip,
	    limit: limit
	  });
	};
	
	var searchCountries = exports.searchCountries = function searchCountries() {
	  var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/country/find', criteria);
	};
	
	var findCategoryByName = exports.findCategoryByName = function findCategoryByName(name) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/category/find', {
	    where: {
	      name: {
	        startsWith: name
	      }
	    }
	  });
	};
	
	var searchProperties = exports.searchProperties = function searchProperties() {
	  var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/property/find', criteria);
	};
	
	var searchPublicCity = exports.searchPublicCity = function searchPublicCity() {
	  var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/public/city', criteria);
	};
	
	var searchPublicCountry = exports.searchPublicCountry = function searchPublicCountry() {
	  var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/public/country', criteria);
	};
	
	var searchPublicContinent = exports.searchPublicContinent = function searchPublicContinent() {
	  var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/public/continent', criteria);
	};
	
	var findCityByName = exports.findCityByName = function findCityByName(city) {
	  return _axios2.default.get(_config2.default.SERVER_URL + '/city?where={"city":{"contains":"' + city + '"}}&sort="city ASC"');
	};
	
	var findProperties = exports.findProperties = function findProperties(_ref3) {
	  var _ref3$settings = _ref3.settings;
	  var settings = _ref3$settings === undefined ? {} : _ref3$settings;
	  var _ref3$skip = _ref3.skip;
	  var skip = _ref3$skip === undefined ? 0 : _ref3$skip;
	  var _ref3$limit = _ref3.limit;
	  var limit = _ref3$limit === undefined ? 30 : _ref3$limit;
	
	  var criteria = _ramda2.default.clone(settings);
	
	  var params = {
	    limit: limit,
	    skip: skip,
	    sort: 'title ASC'
	  };
	
	  criteria.preferredCategories = criteria.preferredCategories ? criteria.preferredCategories.map(function (category) {
	    return category.id;
	  }) : [];
	  criteria.preferredCities = criteria.preferredCities ? criteria.preferredCities.map(function (city) {
	    return city.id;
	  }) : [];
	  criteria.preferredCountries = criteria.preferredCountries ? criteria.preferredCountries.map(function (country) {
	    return country.id;
	  }) : [];
	  criteria.preferredRegions = criteria.preferredRegions ? criteria.preferredRegions.map(function (region) {
	    return region.id;
	  }) : [];
	
	  if (criteria.maxInvestment === _Constants.maxPrice) {
	    delete criteria.maxInvestment;
	  }
	
	  if (criteria.maxNoRooms === _Constants.maxRooms) {
	    delete criteria.maxNoRooms;
	  }
	
	  if (criteria.maxYield === _Constants.maxYield) {
	    delete criteria.maxYield;
	  }
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/property/search', {
	    criteria: criteria,
	    params: params
	  });
	};
	
	var findPropertyById = exports.findPropertyById = function findPropertyById(id) {
	  return _axios2.default.get(_config2.default.SERVER_URL + '/property/' + id);
	};
	
	var findPropertiesById = exports.findPropertiesById = function findPropertiesById(ids) {
	  var propertyIds = ids.map(function (id) {
	    return '"' + id + '"';
	  });
	  return _axios2.default.get(_config2.default.SERVER_URL + '/property/?where={"id":[' + propertyIds + ']}');
	};
	
	var fetchCategories = exports.fetchCategories = function fetchCategories() {
	  var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/category/find', criteria);
	};
	
	var fetchPublicCategories = exports.fetchPublicCategories = function fetchPublicCategories() {
	  var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/public/category', criteria);
	};

/***/ },
/* 19 */
[1179, 63],
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding-left: calc((100% - ', ')/2);\n  padding-right: calc((100% - ', ')/2);\n  padding-bottom: ', ';\n  ', ';\n\n  @media screen and (max-width: ', ') {\n    padding-left: calc((100% - ', ')/2);\n    padding-right: calc((100% - ', ')/2);\n  }\n\n  @media screen and (max-width: ', ') {\n    padding-left: ', ';\n    padding-right: ', ';\n  }\n\n  @media screen and (min-width: ', ') {\n    padding-left: calc((100% - ', ')/2);\n    padding-right: calc((100% - ', ')/2);\n  }\n'], ['\n  padding-left: calc((100% - ', ')/2);\n  padding-right: calc((100% - ', ')/2);\n  padding-bottom: ', ';\n  ', ';\n\n  @media screen and (max-width: ', ') {\n    padding-left: calc((100% - ', ')/2);\n    padding-right: calc((100% - ', ')/2);\n  }\n\n  @media screen and (max-width: ', ') {\n    padding-left: ', ';\n    padding-right: ', ';\n  }\n\n  @media screen and (min-width: ', ') {\n    padding-left: calc((100% - ', ')/2);\n    padding-right: calc((100% - ', ')/2);\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.section(_templateObject, _Themes.Metrics.grid.desktop, _Themes.Metrics.grid.desktop, _Themes.Metrics.margins.base, function (props) {
	  return props.customStyle;
	}, _Themes.Metrics.breakpoints.tablet, _Themes.Metrics.grid.tablet, _Themes.Metrics.grid.tablet, _Themes.Metrics.breakpoints.mobile, _Themes.Metrics.components.themeMobileMargins, _Themes.Metrics.components.themeMobileMargins, _Themes.Metrics.breakpoints.giant, _Themes.Metrics.grid.giant, _Themes.Metrics.grid.giant);
	
	var ThemeContainer = function ThemeContainer(props) {
	  var children = props.children;
	
	  return _react2.default.createElement(
	    Container,
	    props,
	    children
	  );
	};
	
	ThemeContainer.propTypes = {
	  children: _react.PropTypes.node,
	  customStyle: _react.PropTypes.node
	};
	
	exports.default = ThemeContainer;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var DOMProperty = __webpack_require__(97);
	var ReactDOMComponentFlags = __webpack_require__(481);
	
	var invariant = __webpack_require__(12);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.customizeSearchCriteria = exports.isElementSelected = exports.isUserFavorite = exports.isErrorOfInvalidAttribute = exports.sortArray = exports.isElementInArray = exports.addOrRemoveObjectFromList = exports.numberWithCommas = exports.unslugify = exports.slugify = exports.SortTypes = undefined;
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _Constants = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SortTypes = exports.SortTypes = {
	  ASC: -1,
	  DESC: 1
	};
	
	var slugify = exports.slugify = function slugify(text) {
	  return text.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
	  .replace(/[^\w-]+/g, '') // Remove all non-word chars
	  .replace(/--+/g, '-') // Replace multiple - with single -
	  .replace(/^-+/, '') // Trim - from start of text
	  .replace(/-+$/, ''); // Trim - from end of text
	};
	
	var unslugify = exports.unslugify = function unslugify(text) {
	  return text.toString().replace(/\b\w/g, function (l) {
	    return l.toUpperCase();
	  }) // Capitalize
	  .replace('-', ' '); // Replace - with spaces
	};
	
	var numberWithCommas = exports.numberWithCommas = function numberWithCommas(number) {
	  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	};
	
	var addOrRemoveObjectFromList = exports.addOrRemoveObjectFromList = function addOrRemoveObjectFromList(list, object) {
	  var prop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
	
	  var index = _ramda2.default.findIndex(_ramda2.default.propEq(prop, object[prop]))(list);
	  if (index >= 0) {
	    return _ramda2.default.remove(index, 1, list);
	  }
	  return _ramda2.default.append(object, list);
	};
	
	var isElementInArray = exports.isElementInArray = function isElementInArray(list, object) {
	  var prop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
	
	  return _ramda2.default.findIndex(_ramda2.default.propEq(prop, object.id))(list) !== -1;
	};
	
	var sortArray = exports.sortArray = function sortArray(keyObj, elements) {
	  var list = _ramda2.default.clone(elements);
	  var sortKey = _ramda2.default.clone(keyObj);
	
	  if (elements.length === 0) {
	    return;
	  }
	
	  var direction = sortKey.sort === (SortTypes.DESC || null) ? SortTypes.ASC : SortTypes.DESC;
	
	  list.sort(function (elementA, elementB) {
	    var valueA = sortKey.sortAccessor ? sortKey.sortAccessor(elementA) : sortKey.accessor ? sortKey.accessor(elementA) : elementA[sortKey.key];
	
	    var valueB = sortKey.sortAccessor ? sortKey.sortAccessor(elementB) : sortKey.accessor ? sortKey.accessor(elementB) : elementB[sortKey.key];
	
	    var sortVal = 0;
	
	    if (valueA.toLowerCase) {
	      valueA = valueA.toLowerCase();
	    }
	
	    if (valueB.toLowerCase) {
	      valueB = valueB.toLowerCase();
	    }
	
	    if (valueA > valueB) {
	      sortVal = 1;
	    }
	    if (valueA < valueB) {
	      sortVal = -1;
	    }
	    sortVal *= direction;
	    return sortVal;
	  });
	
	  sortKey.sort = direction;
	
	  return {
	    list: list,
	    sortKey: sortKey
	  };
	};
	
	var isErrorOfInvalidAttribute = exports.isErrorOfInvalidAttribute = function isErrorOfInvalidAttribute() {
	  var errorResponse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var attribute = arguments[1];
	  var rule = arguments[2];
	
	  return errorResponse.data && errorResponse.data.invalidAttributes && errorResponse.data.invalidAttributes[attribute] && errorResponse.data.invalidAttributes[attribute].rule === rule;
	};
	
	var isUserFavorite = exports.isUserFavorite = function isUserFavorite(user, property) {
	  var pred = function pred(d) {
	    return d.id === property.id;
	  };
	  return _ramda2.default.filter(pred, user.preferredProperties).length > 0;
	};
	
	var isElementSelected = exports.isElementSelected = function isElementSelected(el, list) {
	  return _ramda2.default.findIndex(_ramda2.default.propEq('id', el.id))(list) !== -1;
	};
	
	var customizeSearchCriteria = exports.customizeSearchCriteria = function customizeSearchCriteria(criteria) {
	  var query = _ramda2.default.clone(criteria);
	
	  query.preferredCategories = query.preferredCategories ? query.preferredCategories.map(function (category) {
	    return category.id;
	  }) : [];
	  query.preferredCities = query.preferredCities ? query.preferredCities.map(function (city) {
	    return city.id;
	  }) : [];
	  query.preferredCountries = query.preferredCountries ? query.preferredCountries.map(function (country) {
	    return country.id;
	  }) : [];
	  query.preferredRegions = query.preferredRegions ? query.preferredRegions.map(function (region) {
	    return region.id;
	  }) : [];
	
	  if (query.maxInvestment === _Constants.maxPrice) {
	    delete query.maxInvestment;
	  }
	
	  if (query.maxNoRooms === _Constants.maxRooms) {
	    delete query.maxNoRooms;
	  }
	
	  if (query.maxYield === _Constants.maxYield) {
	    delete query.maxYield;
	  }
	
	  return query;
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  backgroundColor: ', ';\n'], ['\n  width: 100%;\n  backgroundColor: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 40px;\n  padding: 0 ', ';\n  backgroundColor: ', ';\n  color: ', ';\n'], ['\n  width: 100%;\n  height: 40px;\n  padding: 0 ', ';\n  backgroundColor: ', ';\n  color: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  ', ';\n  text-transform: uppercase;\n  color: ', ';\n  padding: 13px 0;\n'], ['\n  ', ';\n  text-transform: uppercase;\n  color: ', ';\n  padding: 13px 0;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  width: 100%;\n  padding: ', ';\n  max-height: calc(100% - 40px);\n  overflow-y: scroll;\n'], ['\n  width: 100%;\n  padding: ', ';\n  max-height: calc(100% - 40px);\n  overflow-y: scroll;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Card = _styledComponents2.default.div(_templateObject, _Themes.Colors.white);
	
	var CardHeader = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.components.cardContainerSpacing, _Themes.Colors.black, _Themes.Colors.white);
	
	var Title = _styledComponents2.default.div(_templateObject3, _Themes.Fonts.style.Text, _Themes.Colors.white);
	
	var CardContent = _styledComponents2.default.div(_templateObject4, _Themes.Metrics.margins.large);
	
	var CardContainer = function CardContainer(props) {
	  var children = props.children;
	  var title = props.title;
	  var className = props.className;
	  var id = props.id;
	
	
	  return _react2.default.createElement(
	    Card,
	    { className: className, id: id },
	    _react2.default.createElement(
	      CardHeader,
	      null,
	      _react2.default.createElement(
	        Title,
	        null,
	        title
	      )
	    ),
	    _react2.default.createElement(
	      CardContent,
	      null,
	      children
	    )
	  );
	};
	
	CardContainer.propTypes = {
	  title: _react.PropTypes.node,
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string,
	  id: _react.PropTypes.string
	};
	
	exports.default = CardContainer;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(71);
	var _isTransformer = __webpack_require__(209);
	
	
	/**
	 * Returns a function that dispatches with different strategies based on the
	 * object in list position (last argument). If it is an array, executes [fn].
	 * Otherwise, if it has a function with one of the given method names, it will
	 * execute that function (functor case). Otherwise, if it is a transformer,
	 * uses transducer [xf] to return a new transformer (transducer case).
	 * Otherwise, it will default to executing [fn].
	 *
	 * @private
	 * @param {Array} methodNames properties to check for a custom implementation
	 * @param {Function} xf transducer to initialize if object is transformer
	 * @param {Function} fn default ramda implementation
	 * @return {Function} A function that dispatches on object in list position
	 */
	module.exports = function _dispatchable(methodNames, xf, fn) {
	  return function() {
	    if (arguments.length === 0) {
	      return fn();
	    }
	    var args = Array.prototype.slice.call(arguments, 0);
	    var obj = args.pop();
	    if (!_isArray(obj)) {
	      var idx = 0;
	      while (idx < methodNames.length) {
	        if (typeof obj[methodNames[idx]] === 'function') {
	          return obj[methodNames[idx]].apply(obj, args);
	        }
	        idx += 1;
	      }
	      if (_isTransformer(obj)) {
	        var transducer = xf.apply(null, args);
	        return transducer(obj);
	      }
	    }
	    return fn.apply(this, arguments);
	  };
	};


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var assign = __webpack_require__(15);
	
	function autoBind(object) {
	  var proto = object.constructor.prototype;
	
	  var names = Object.getOwnPropertyNames(proto).filter(function (key) {
	    return key != 'constructor' && key != 'render' && typeof proto[key] == 'function';
	  });
	
	  names.push('setState');
	  names.forEach(function (key) {
	    object[key] = object[key].bind(object);
	  });
	
	  return object;
	}
	
	var ReactClass = (function (_React$Component) {
	  _inherits(ReactClass, _React$Component);
	
	  function ReactClass(props) {
	    _classCallCheck(this, ReactClass);
	
	    _get(Object.getPrototypeOf(ReactClass.prototype), 'constructor', this).call(this, props);
	    autoBind(this);
	  }
	
	  _createClass(ReactClass, [{
	    key: 'prepareProps',
	    value: function prepareProps(thisProps) {
	
	      var props = assign({}, thisProps);
	
	      props.style = this.prepareStyle(props);
	      props.className = this.prepareClassName(props);
	
	      return props;
	    }
	  }, {
	    key: 'prepareClassName',
	    value: function prepareClassName(props) {
	      var className = props.className || '';
	
	      var defaultProps = this.constructor.defaultProps;
	
	      if (defaultProps && defaultProps.defaultClassName != null) {
	        className += ' ' + defaultProps.defaultClassName;
	      }
	
	      return className;
	    }
	  }, {
	    key: 'prepareStyle',
	    value: function prepareStyle(props) {
	      var defaultStyle;
	
	      if (this.constructor.defaultProps) {
	        defaultStyle = this.constructor.defaultProps.defaultStyle;
	      }
	
	      return assign({}, defaultStyle, props.style);
	    }
	  }]);
	
	  return ReactClass;
	})(React.Component);
	
	module.exports = ReactClass;

/***/ },
/* 26 */
/***/ function(module, exports) {

	/* eslint-disable no-unused-vars */
	'use strict';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 27 */
/***/ function(module, exports) {

	module.exports = {
	  init: function() {
	    return this.xf['@@transducer/init']();
	  },
	  result: function(result) {
	    return this.xf['@@transducer/result'](result);
	  }
	};


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/* todo: I want this to actually be an array of Function | string but that causes errors */
	if (true) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_GlamorRule", {
	  value: __webpack_require__(8).shape({
	    cssText: __webpack_require__(8).string.isRequired
	  })
	});
	
	/* eslint-disable no-undef */

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n'], ['\n  ', ';\n  color: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	var _index = __webpack_require__(42);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject, _Themes.Metrics.margins.base);
	
	var Header = _styledComponents2.default.div(_templateObject2, _Themes.Fonts.style.Header, _Themes.Colors.primary);
	
	var ErrorModal = function (_Component) {
	  _inherits(ErrorModal, _Component);
	
	  function ErrorModal() {
	    _classCallCheck(this, ErrorModal);
	
	    return _possibleConstructorReturn(this, (ErrorModal.__proto__ || Object.getPrototypeOf(ErrorModal)).apply(this, arguments));
	  }
	
	  _createClass(ErrorModal, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var visible = this.props.visible;
	
	      return visible !== nextProps.visible;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var visible = _props.visible;
	      var closeAction = _props.closeAction;
	      var header = _props.header;
	      var message = _props.message;
	      var backAction = _props.backAction;
	
	      return _react2.default.createElement(
	        _index2.default,
	        {
	          header: _react2.default.createElement(
	            Header,
	            null,
	            header
	          ),
	          visible: visible,
	          closeAction: closeAction,
	          backAction: backAction },
	        _react2.default.createElement(
	          'div',
	          null,
	          message
	        ),
	        _react2.default.createElement(CustomButton, { onClick: closeAction, label: 'OK' })
	      );
	    }
	  }]);
	
	  return ErrorModal;
	}(_react.Component);
	
	ErrorModal.propTypes = {
	  visible: _react.PropTypes.bool,
	  message: _react.PropTypes.node,
	  closeAction: _react.PropTypes.func,
	  backAction: _react.PropTypes.func,
	  header: _react.PropTypes.node
	};
	
	exports.default = ErrorModal;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.uploadNda = exports.deleteCountry = exports.createCountry = exports.updateCountry = exports.deleteContinent = exports.createContinent = exports.updateContinent = exports.addUsersToProperties = exports.exportPropertiesToCsv = exports.deleteCity = exports.createCity = exports.updateCity = exports.createProperty = exports.deleteProperty = exports.updateProperty = exports.findUsersByName = exports.filterUsers = exports.findUserById = exports.searchUsers = exports.findUsers = exports.deleteUser = exports.updateUser = exports.createUser = exports.rejectUsers = exports.acceptUsers = exports.deleteCategory = exports.createCategory = exports.updateCategory = exports.deleteAdmin = exports.createAdmin = exports.updateAdmin = exports.searchProperties = exports.searchAdmins = undefined;
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _axios = __webpack_require__(86);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(88);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Utils = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* globals FormData */
	var searchAdmins = exports.searchAdmins = function searchAdmins() {
	  var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/admin/find', criteria);
	};
	
	var searchProperties = exports.searchProperties = function searchProperties() {
	  var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/property/find', criteria);
	};
	
	var updateAdmin = exports.updateAdmin = function updateAdmin(admin) {
	  return _axios2.default.put(_config2.default.SERVER_URL + '/admin/' + admin.id, admin);
	};
	
	var createAdmin = exports.createAdmin = function createAdmin(admin) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/admin', admin);
	};
	
	var deleteAdmin = exports.deleteAdmin = function deleteAdmin(adminId) {
	  return _axios2.default.delete(_config2.default.SERVER_URL + '/admin/' + adminId);
	};
	
	var updateCategory = exports.updateCategory = function updateCategory(category) {
	  return _axios2.default.put(_config2.default.SERVER_URL + '/category/' + category.id, category);
	};
	
	var createCategory = exports.createCategory = function createCategory(category) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/category', { name: category });
	};
	
	var deleteCategory = exports.deleteCategory = function deleteCategory(id) {
	  return _axios2.default.delete(_config2.default.SERVER_URL + '/category/' + id);
	};
	
	var acceptUsers = exports.acceptUsers = function acceptUsers(users) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user/accept', {
	    id: users.map(function (user) {
	      return user.id;
	    })
	  });
	};
	
	var rejectUsers = exports.rejectUsers = function rejectUsers(users) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user/reject', {
	    id: users.map(function (user) {
	      return user.id;
	    })
	  });
	};
	
	var createUser = exports.createUser = function createUser(user) {
	  var userData = _ramda2.default.clone(user);
	  delete user.picture;
	  if (userData.picture && userData.picture.file) {
	    return _axios2.default.post(_config2.default.SERVER_URL + '/user', user).then(function (response) {
	      var userId = response.data.id;
	      var formData = new FormData();
	      formData.append('id', userId);
	      formData.append('file', userData.picture.file);
	      return _axios2.default.post(_config2.default.SERVER_URL + '/user/' + userId + '/picture', formData, { headers: { 'content-type': 'multipart/form-data' } });
	    }).catch(function (error) {
	      return console.log(error);
	    });
	  } else {
	    return _axios2.default.post(_config2.default.SERVER_URL + '/user', user);
	  }
	};
	
	var updateUser = exports.updateUser = function updateUser(user) {
	  var userData = _ramda2.default.clone(user);
	  delete user.picture;
	  if (userData.picture && userData.picture.file) {
	    return _axios2.default.put(_config2.default.SERVER_URL + '/user/' + user.id, user).then(function (response) {
	      var userId = response.data.id;
	      var formData = new FormData();
	      formData.append('id', userId);
	      formData.append('file', userData.picture.file);
	      return _axios2.default.post(_config2.default.SERVER_URL + '/user/' + userId + '/picture', formData, { headers: { 'content-type': 'multipart/form-data' } });
	    }).catch(function (error) {
	      return console.log(error);
	    });
	  } else {
	    return _axios2.default.put(_config2.default.SERVER_URL + '/user/' + user.id, user);
	  }
	};
	
	var deleteUser = exports.deleteUser = function deleteUser(user) {
	  return _axios2.default.delete(_config2.default.SERVER_URL + '/user/' + user.id);
	};
	
	var findUsers = exports.findUsers = function findUsers(_ref) {
	  var _ref$query = _ref.query;
	  var query = _ref$query === undefined ? {} : _ref$query;
	  var _ref$skip = _ref.skip;
	  var skip = _ref$skip === undefined ? 0 : _ref$skip;
	  var _ref$limit = _ref.limit;
	  var limit = _ref$limit === undefined ? 30 : _ref$limit;
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user/search', { query: query, skip: skip, limit: limit });
	};
	
	var searchUsers = exports.searchUsers = function searchUsers() {
	  var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user/find', criteria);
	};
	
	var findUserById = exports.findUserById = function findUserById(id) {
	  return _axios2.default.get(_config2.default.SERVER_URL + '/user/' + id);
	};
	
	var filterUsers = exports.filterUsers = function filterUsers(search) {
	  var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;
	
	  var query = _ramda2.default.clone(search);
	  query.preferredCategories = query.preferredCategories && query.preferredCategories.map(function (el) {
	    return el.id;
	  }) || [];
	  query.preferredCities = query.preferredCities && query.preferredCities.map(function (el) {
	    return el.id;
	  }) || [];
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user/searchUsers', {
	    skip: skip,
	    limit: limit,
	    query: query
	  });
	};
	
	var findUsersByName = exports.findUsersByName = function findUsersByName(name) {
	  return _axios2.default.get(_config2.default.SERVER_URL + '/user?where={"firstName":{"contains":"' + name + '"}}&sort="name ASC"');
	};
	
	var updateProperty = exports.updateProperty = function updateProperty(property) {
	  if (property.picture.file) {
	    var formData = new FormData();
	    formData.append('id', property.id);
	    formData.append('property', property.property);
	    formData.append('file', property.picture.file);
	    return _axios2.default.post(_config2.default.SERVER_URL + '/property/' + property.id + '/picture', formData, {
	      headers: { 'content-type': 'multipart/form-data' }
	    }).then(function () {
	      delete property.picture;
	      return _axios2.default.put(_config2.default.SERVER_URL + '/property/' + property.id, property);
	    }).catch(function (error) {
	      return console.log(error);
	    });
	  } else {
	    return _axios2.default.put(_config2.default.SERVER_URL + '/property/' + property.id, property);
	  }
	};
	
	var deleteProperty = exports.deleteProperty = function deleteProperty(id) {
	  return _axios2.default.delete(_config2.default.SERVER_URL + '/property/' + id);
	};
	
	var createProperty = exports.createProperty = function createProperty(property) {
	  var propertyToCreate = _ramda2.default.clone(property);
	
	  if (propertyToCreate.area === '') {
	    delete propertyToCreate.area;
	  }
	
	  if (propertyToCreate.usableArea === '') {
	    delete propertyToCreate.usableArea;
	  }
	
	  if (property.picture) {
	    delete propertyToCreate.picture;
	    return _axios2.default.post(_config2.default.SERVER_URL + '/property/', propertyToCreate).then(function (response) {
	      var prop = response.data;
	      var formData = new FormData();
	      formData.append('id', prop.id);
	      formData.append('file', property.picture.file);
	      return _axios2.default.post(_config2.default.SERVER_URL + '/property/' + prop.id + '/picture', formData, { headers: { 'content-type': 'multipart/form-data' } });
	    }).catch(function (error) {
	      return console.log(error);
	    });
	  } else {
	    return _axios2.default.post(_config2.default.SERVER_URL + '/property/', propertyToCreate);
	  }
	};
	
	var updateCity = exports.updateCity = function updateCity(city) {
	  var data = _ramda2.default.clone(city);
	  delete data.picture;
	  data.country = data.country.id;
	  if (city.picture.file) {
	    var formData = new FormData();
	    formData.append('id', city.id);
	    formData.append('file', city.picture.file);
	    return _axios2.default.post(_config2.default.SERVER_URL + '/city/' + city.id + '/picture', formData, {
	      headers: { 'content-type': 'multipart/form-data' }
	    }).then(function (response) {
	      return _axios2.default.put(_config2.default.SERVER_URL + '/city/' + city.id, data);
	    }).catch(function (error) {
	      return console.log(error);
	    });
	  } else {
	    return _axios2.default.put(_config2.default.SERVER_URL + '/city/' + city.id, data);
	  }
	};
	
	var createCity = exports.createCity = function createCity(city) {
	  var cityData = _ramda2.default.clone(city);
	  delete city.picture;
	  if (cityData.picture && cityData.picture.file) {
	    return _axios2.default.post(_config2.default.SERVER_URL + '/city', city).then(function (response) {
	      var cityId = response.data.id;
	      var formData = new FormData();
	      formData.append('id', cityId);
	      formData.append('file', cityData.picture.file);
	      return _axios2.default.post(_config2.default.SERVER_URL + '/city/' + cityId + '/picture', formData, { headers: { 'content-type': 'multipart/form-data' } });
	    }).catch(function (error) {
	      return console.log(error);
	    });
	  } else {
	    return _axios2.default.post(_config2.default.SERVER_URL + '/city', city);
	  }
	};
	
	var deleteCity = exports.deleteCity = function deleteCity(id) {
	  return _axios2.default.delete(_config2.default.SERVER_URL + '/city/' + id);
	};
	
	var exportPropertiesToCsv = exports.exportPropertiesToCsv = function exportPropertiesToCsv(query) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/property/export_properties', {
	    criteria: (0, _Utils.customizeSearchCriteria)(query),
	    columns: ['title', 'country', 'city', 'continent', 'category', 'price', 'noRooms', 'yield', 'usableArea']
	  });
	};
	
	var addUsersToProperties = exports.addUsersToProperties = function addUsersToProperties(propertiesIds, usersIds) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/property/add_permission', {
	    usersIds: usersIds,
	    propertiesIds: propertiesIds
	  });
	};
	
	var updateContinent = exports.updateContinent = function updateContinent(continent) {
	  var data = _ramda2.default.clone(continent);
	  delete data.picture;
	  delete data.countries;
	  delete continent.countries;
	  if (continent.picture.file) {
	    var formData = new FormData();
	    formData.append('id', continent.id);
	    formData.append('file', continent.picture.file);
	    return _axios2.default.post(_config2.default.SERVER_URL + '/continent/' + continent.id + '/picture', formData, { headers: { 'content-type': 'multipart/form-data' } }).then(function (response) {
	      return _axios2.default.put(_config2.default.SERVER_URL + '/continent/' + continent.id, data);
	    }).catch(function (error) {
	      return console.log(error);
	    });
	  } else {
	    return _axios2.default.put(_config2.default.SERVER_URL + '/continent/' + continent.id, data);
	  }
	};
	
	var createContinent = exports.createContinent = function createContinent(continent) {
	  var continentData = _ramda2.default.clone(continent);
	  delete continent.picture;
	  if (continentData.picture && continentData.picture.file) {
	    return _axios2.default.post(_config2.default.SERVER_URL + '/continent', continent).then(function (response) {
	      var continentId = response.data.id;
	      var formData = new FormData();
	      formData.append('id', continentId);
	      formData.append('file', continentData.picture.file);
	      return _axios2.default.post(_config2.default.SERVER_URL + '/continent/' + continentId + '/picture', formData, { headers: { 'content-type': 'multipart/form-data' } });
	    }).catch(function (error) {
	      return console.log(error);
	    });
	  } else {
	    return _axios2.default.post(_config2.default.SERVER_URL + '/continent', continent);
	  }
	};
	
	var deleteContinent = exports.deleteContinent = function deleteContinent(id) {
	  return _axios2.default.delete(_config2.default.SERVER_URL + '/continent/' + id);
	};
	
	var updateCountry = exports.updateCountry = function updateCountry(country) {
	  country.continent = country.continent.id;
	  var data = _ramda2.default.clone(country);
	  delete data.picture;
	  delete data.cities;
	  delete country.cities;
	  if (country.picture.file) {
	    var formData = new FormData();
	    formData.append('id', country.id);
	    formData.append('file', country.picture.file);
	    return _axios2.default.post(_config2.default.SERVER_URL + '/country/' + country.id + '/picture', formData, {
	      headers: { 'content-type': 'multipart/form-data' }
	    }).then(function (response) {
	      return _axios2.default.put(_config2.default.SERVER_URL + '/country/' + country.id, data);
	    }).catch(function (error) {
	      return console.log(error);
	    });
	  } else {
	    return _axios2.default.put(_config2.default.SERVER_URL + '/country/' + country.id, data);
	  }
	};
	
	var createCountry = exports.createCountry = function createCountry(country) {
	  var countryData = _ramda2.default.clone(country);
	  delete country.picture;
	  if (countryData.picture && countryData.picture.file) {
	    return _axios2.default.post(_config2.default.SERVER_URL + '/country', country).then(function (response) {
	      var countryId = response.data.id;
	      var formData = new FormData();
	      formData.append('id', countryId);
	      formData.append('file', countryData.picture.file);
	      return _axios2.default.post(_config2.default.SERVER_URL + '/country/' + countryId + '/picture', formData, { headers: { 'content-type': 'multipart/form-data' } });
	    }).catch(function (error) {
	      return console.log(error);
	    });
	  } else {
	    return _axios2.default.post(_config2.default.SERVER_URL + '/continent', country);
	  }
	};
	
	var deleteCountry = exports.deleteCountry = function deleteCountry(id) {
	  return _axios2.default.delete(_config2.default.SERVER_URL + '/country/' + id);
	};
	
	var uploadNda = exports.uploadNda = function uploadNda(user) {
	  var formData = new FormData();
	  formData.append('id', user.id);
	  formData.append('file', user.nda);
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user/' + user.id + '/nda', formData, {
	    headers: { 'content-type': 'multipart/form-data' }
	  });
	};

/***/ },
/* 32 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (args.length == 1 && Array.isArray(args[0])) {
	    args = args[0];
	  }
	
	  return args.filter(function (x) {
	    return !!x;
	  }).join(' ');
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This function will be used to convert a date to a moment.
	 *
	 * It accepts input as sring, date or moment
	 *
	 * @param  {String/Date/Moment} value
	 *
	 * @param  {String} [dateFormat] if value is string, it will be parsed to a moment
	 * using this format.
	 * You can skip this argument and only specify the config instead,
	 * where you can have a dateFormat property
	 *
	 * @param  {Object} [config]
	 * @param  {String} [config.dateFormat] a dateFormat string
	 * @param  {String} [config.locale] a locale
	 * @param  {Boolean} [config.strict] whether to perform strict parsing on strings
	 *
	 * @return {Moment}
	 */
	
	exports.default = function (value, dateFormat, config) {
	  if ((typeof dateFormat === 'undefined' ? 'undefined' : _typeof(dateFormat)) === 'object') {
	    config = dateFormat;
	    dateFormat = null;
	  }
	
	  var strict = !!(config && config.strict);
	  var locale = config && config.locale;
	
	  dateFormat = dateFormat || config && config.dateFormat || 'YYYY-MM-DD';
	
	  if (typeof value == 'string') {
	    return (0, _moment2.default)(value, dateFormat, locale, strict);
	  }
	
	  value = value == null ? new Date() : value;
	
	  return (0, _moment2.default)(value, undefined, locale, strict);
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sortOptionsDefault = exports.preferenceDefault = exports.propertyDefault = exports.tableKeysDefault = exports.adminDefault = exports.categoryDefault = exports.countryDefault = exports.continentDefault = exports.cityDefault = exports.searchQueryDefault = exports.userDefault = undefined;
	
	var _Constants = __webpack_require__(52);
	
	var _index = __webpack_require__(22);
	
	var userDefault = exports.userDefault = {
	  id: '',
	  firstName: '',
	  lastName: '',
	  password: '',
	  phoneNumber: '',
	  address: '',
	  gender: 'male',
	  company: '',
	  email: '',
	  city: '',
	  linkedinId: '',
	  country: '',
	  description: '',
	  linkedinUrl: '',
	  skypeName: '',
	  hasFullAccess: true,
	  picture: '',
	  isActive: false,
	  origin: '',
	  ambassador: '',
	  minInvestment: 0,
	  maxInvestment: _Constants.maxPrice,
	  minNoRooms: 0,
	  maxNoRooms: _Constants.maxRooms,
	  minYield: 0,
	  maxYield: _Constants.maxYield,
	  minArea: 0,
	  maxArea: _Constants.maxArea,
	  preferredCategories: [],
	  preferredCities: [],
	  preferredCountries: [],
	  preferredRegions: [],
	  recommendedBy: '',
	  reasonHvbMember: ''
	};
	
	var searchQueryDefault = exports.searchQueryDefault = {
	  minInvestment: 0,
	  maxInvestment: _Constants.maxPrice,
	  minNoRooms: 0,
	  maxNoRooms: _Constants.maxRooms,
	  minYield: 0,
	  maxYield: _Constants.maxYield,
	  preferredCategories: [],
	  preferredCities: [],
	  preferredCountries: [],
	  preferredRegions: []
	};
	
	var cityDefault = exports.cityDefault = {
	  city: '',
	  country: '',
	  picture: null,
	  description: '',
	  latlng: {
	    lat: '',
	    lng: ''
	  }
	};
	
	var continentDefault = exports.continentDefault = {
	  name: '',
	  picture: null,
	  description: ''
	};
	
	var countryDefault = exports.countryDefault = {
	  name: '',
	  continent: '',
	  picture: null,
	  description: ''
	};
	
	var categoryDefault = exports.categoryDefault = {
	  name: ''
	};
	
	var adminDefault = exports.adminDefault = {
	  name: '',
	  email: ''
	};
	
	var tableKeysDefault = exports.tableKeysDefault = [{
	  title: 'Title',
	  key: 'title',
	  width: 300,
	  className: 'title',
	  sort: null
	}, {
	  title: 'Continent',
	  key: 'continent',
	  width: 150,
	  accessor: function accessor(d) {
	    return d.continent.name;
	  },
	  sort: null
	}, {
	  title: 'Country',
	  key: 'country',
	  width: 150,
	  accessor: function accessor(d) {
	    return d.country.name;
	  },
	  sort: null
	}, {
	  title: 'City',
	  key: 'city',
	  width: 200,
	  accessor: function accessor(d) {
	    return d.city.city;
	  },
	  sort: null
	}, {
	  title: 'Category',
	  key: 'category',
	  width: 250,
	  accessor: function accessor(d) {
	    return d.category.name;
	  },
	  sort: null
	}, {
	  title: 'Keys',
	  key: 'noRooms',
	  width: 100,
	  sort: null
	}, {
	  title: 'Portfolio',
	  key: 'portfolio',
	  width: 100,
	  accessor: function accessor(d) {
	    return d.portfolio ? 'Yes' : 'No';
	  },
	  sort: null
	}, {
	  title: 'Price',
	  key: 'price',
	  width: 100,
	  unit: '€',
	  accessor: function accessor(d) {
	    return (0, _index.numberWithCommas)(d.price);
	  },
	  sortAccessor: function sortAccessor(d) {
	    return d.price;
	  },
	  sort: null
	}, {
	  title: 'Yield',
	  key: 'yield',
	  width: 100,
	  unit: '%',
	  sort: null
	}, {
	  title: 'Area',
	  key: 'area',
	  width: 100,
	  unit: 'm2',
	  accessor: function accessor(d) {
	    return (0, _index.numberWithCommas)(d.area);
	  },
	  sortAccessor: function sortAccessor(d) {
	    return d.area;
	  },
	  sort: null
	}];
	
	var propertyDefault = exports.propertyDefault = {
	  area: '',
	  category: null,
	  city: null,
	  continent: null,
	  country: null,
	  description: '',
	  exclusivity: false,
	  fullAccess: false,
	  lead: '',
	  noRooms: '',
	  portfolio: false,
	  price: '',
	  realLocation: '',
	  sold: false,
	  title: '',
	  usableArea: '',
	  useDefaultPictures: false,
	  usersFavorites: [],
	  usersHaveAccess: [],
	  published: false,
	  picture: null,
	  yield: '',
	  latlng: null
	};
	
	var preferenceDefault = exports.preferenceDefault = {
	  name: '',
	  city: [],
	  continent: [],
	  country: [],
	  category: [],
	  minNoRooms: 0,
	  maxNoRooms: _Constants.maxRooms,
	  minYield: 0,
	  maxYield: _Constants.maxYield,
	  minPrice: 0,
	  maxPrice: _Constants.maxPrice,
	  minArea: 0,
	  maxArea: _Constants.maxArea
	};
	
	var sortOptionsDefault = exports.sortOptionsDefault = [{
	  label: 'Price Ascending',
	  key: 'price',
	  direction: _index.SortTypes.ASC
	}, {
	  label: 'Price Descending',
	  key: 'price',
	  direction: _index.SortTypes.DESC
	}, {
	  label: 'Yield Ascending',
	  key: 'yield',
	  direction: _index.SortTypes.ASC
	}, {
	  label: 'Yield Descending',
	  key: 'yield',
	  direction: _index.SortTypes.DESC
	}, {
	  label: 'Keys Ascending',
	  key: 'noRooms',
	  direction: _index.SortTypes.ASC
	}, {
	  label: 'Keys Descending',
	  key: 'noRooms',
	  direction: _index.SortTypes.DESC
	}];

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(55);
	var _curry1 = __webpack_require__(6);
	var _curry2 = __webpack_require__(2);
	var _curryN = __webpack_require__(147);
	
	
	/**
	 * Returns a curried equivalent of the provided function, with the specified
	 * arity. The curried function has two unusual capabilities. First, its
	 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value `R.__` may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is `R.__`, the
	 * following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curry
	 * @example
	 *
	 *      var sumArgs = (...args) => R.sum(args);
	 *
	 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	module.exports = _curry2(function curryN(length, fn) {
	  if (length === 1) {
	    return _curry1(fn);
	  }
	  return _arity(length, _curryN(length, [], fn));
	});


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: ', 'px;\n  background-color: ', ';\n  border-bottom: solid 1px ', ';\n  display: table;\n'], ['\n  width: 100%;\n  height: ', 'px;\n  background-color: ', ';\n  border-bottom: solid 1px ', ';\n  display: table;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: ', ';\n  display: table-cell;\n  vertical-align: middle;\n\n  & > * {\n    margin-top: ', ';\n    margin-bottom: ', ';\n  }\n'], ['\n  width: ', ';\n  display: table-cell;\n  vertical-align: middle;\n\n  & > * {\n    margin-top: ', ';\n    margin-bottom: ', ';\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  padding-left: 12px;\n\n  & > * {\n    float: left;\n  }\n'], ['\n  padding-left: 12px;\n\n  & > * {\n    float: left;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  & > * {\n    float: right;\n  }\n'], ['\n  & > * {\n    float: right;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  display: inline-block;\n  white-space: nowrap;\n\n  &.rightSideAction {\n    margin-right: ', ';\n  }\n\n  &.leftSideAction {\n    margin-left: ', ';\n  }\n'], ['\n  display: inline-block;\n  white-space: nowrap;\n\n  &.rightSideAction {\n    margin-right: ', ';\n  }\n\n  &.leftSideAction {\n    margin-left: ', ';\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  display: table-cell;\n  vertical-align: middle;\n\n  & > * {\n    float: right;\n    margin-top: ', ';\n    margin-bottom: ', ';\n  }\n'], ['\n  display: table-cell;\n  vertical-align: middle;\n\n  & > * {\n    float: right;\n    margin-top: ', ';\n    margin-bottom: ', ';\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  margin-right: 32px;\n  height: ', 'px;\n'], ['\n  margin-right: 32px;\n  height: ', 'px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(29);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ProfileDropdownSettings = __webpack_require__(1045);
	
	var _ProfileDropdownSettings2 = _interopRequireDefault(_ProfileDropdownSettings);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var NavbarContainer = _styledComponents2.default.div(_templateObject, _Themes.Metrics.components.adminNavbar, _Themes.Colors.white, _Themes.Colors.lightGrey);
	
	var NavbarDynamicPart = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.onlySide ? '100%' : props.bothSides ? '50%' : 'auto';
	}, _Themes.Metrics.margins.tiny, _Themes.Metrics.margins.tiny);
	
	var LeftSide = (0, _styledComponents2.default)(NavbarDynamicPart)(_templateObject3);
	
	var RightSide = (0, _styledComponents2.default)(NavbarDynamicPart)(_templateObject4);
	
	var NavbarAction = (0, _styledComponents2.default)(_Button2.default)(_templateObject5, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium);
	
	var ProfileSettingsSide = _styledComponents2.default.div(_templateObject6, _Themes.Metrics.margins.tiny, _Themes.Metrics.margins.tiny);
	
	var ProfileSettingsContainer = _styledComponents2.default.div(_templateObject7, _Themes.Metrics.components.adminAvatarSize);
	
	var AdminNavbar = function (_Component) {
	  _inherits(AdminNavbar, _Component);
	
	  function AdminNavbar() {
	    _classCallCheck(this, AdminNavbar);
	
	    return _possibleConstructorReturn(this, (AdminNavbar.__proto__ || Object.getPrototypeOf(AdminNavbar)).apply(this, arguments));
	  }
	
	  _createClass(AdminNavbar, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _props = this.props;
	      var rightSideActions = _props.rightSideActions;
	      var leftSideActions = _props.leftSideActions;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	
	      if (!(0, _immutable.fromJS)(nextProps.rightSideActions).equals((0, _immutable.fromJS)(rightSideActions)) || !(0, _immutable.fromJS)(nextProps.leftSideActions).equals((0, _immutable.fromJS)(leftSideActions)) || !(0, _immutable.fromJS)(nextProps.admin).equals((0, _immutable.fromJS)(admin)) || !(0, _immutable.fromJS)(nextProps.dropdownLinks).equals((0, _immutable.fromJS)(dropdownLinks))) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var rightSideActions = _props2.rightSideActions;
	      var leftSideActions = _props2.leftSideActions;
	      var admin = _props2.admin;
	      var dropdownLinks = _props2.dropdownLinks;
	
	
	      return _react2.default.createElement(
	        NavbarContainer,
	        null,
	        _react2.default.createElement(
	          LeftSide,
	          {
	            bothSides: leftSideActions.length && rightSideActions.length,
	            onlySide: leftSideActions.length && !rightSideActions.length
	          },
	          leftSideActions && leftSideActions.map(function (action, index) {
	            return _react2.default.createElement(NavbarAction, Object.assign({
	              key: 'navbar-left-action-' + index,
	              className: 'leftSideAction'
	            }, action));
	          })
	        ),
	        _react2.default.createElement(
	          RightSide,
	          {
	            bothSides: leftSideActions.length && rightSideActions.length,
	            onlySide: !leftSideActions.length && rightSideActions.length
	          },
	          rightSideActions && rightSideActions.map(function (action, index) {
	            return _react2.default.createElement(NavbarAction, Object.assign({
	              key: 'navbar-right-action-' + index,
	              className: 'rightSideAction'
	            }, action));
	          })
	        ),
	        _react2.default.createElement(
	          ProfileSettingsSide,
	          null,
	          _react2.default.createElement(
	            ProfileSettingsContainer,
	            null,
	            _react2.default.createElement(_ProfileDropdownSettings2.default, {
	              admin: admin,
	              dropdownLinks: dropdownLinks
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminNavbar;
	}(_react.Component);
	
	AdminNavbar.propTypes = {
	  rightSideActions: _react.PropTypes.array,
	  leftSideActions: _react.PropTypes.array,
	  admin: _react.PropTypes.object,
	  dropdownLinks: _react.PropTypes.array
	};
	
	AdminNavbar.defaultProps = {
	  rightSideActions: [],
	  leftSideActions: []
	};
	
	exports.default = AdminNavbar;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n'], ['\n  ', ';\n  color: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	var _index = __webpack_require__(42);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _TileWithIcon = __webpack_require__(1049);
	
	var _TileWithIcon2 = _interopRequireDefault(_TileWithIcon);
	
	var _CheckCircle = __webpack_require__(1111);
	
	var _CheckCircle2 = _interopRequireDefault(_CheckCircle);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject, _Themes.Metrics.margins.base);
	
	var Header = _styledComponents2.default.div(_templateObject2, _Themes.Fonts.style.Header, _Themes.Colors.primary);
	
	var SuccesModal = function (_Component) {
	  _inherits(SuccesModal, _Component);
	
	  function SuccesModal() {
	    _classCallCheck(this, SuccesModal);
	
	    return _possibleConstructorReturn(this, (SuccesModal.__proto__ || Object.getPrototypeOf(SuccesModal)).apply(this, arguments));
	  }
	
	  _createClass(SuccesModal, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var visible = this.props.visible;
	
	      return visible !== nextProps.visible;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var visible = _props.visible;
	      var closeAction = _props.closeAction;
	      var header = _props.header;
	      var message = _props.message;
	      var backAction = _props.backAction;
	
	      return _react2.default.createElement(
	        _index2.default,
	        {
	          header: _react2.default.createElement(
	            Header,
	            null,
	            header
	          ),
	          visible: visible,
	          closeAction: closeAction,
	          backAction: backAction },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_TileWithIcon2.default, { text: message, icon: _react2.default.createElement(_CheckCircle2.default, null) })
	        ),
	        _react2.default.createElement(CustomButton, { onClick: closeAction, label: 'OK' })
	      );
	    }
	  }]);
	
	  return SuccesModal;
	}(_react.Component);
	
	SuccesModal.propTypes = {
	  visible: _react.PropTypes.bool,
	  message: _react.PropTypes.node,
	  closeAction: _react.PropTypes.func,
	  backAction: _react.PropTypes.func,
	  header: _react.PropTypes.node
	};
	
	exports.default = SuccesModal;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 39 */
/***/ function(module, exports) {

	module.exports = function _has(prop, obj) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	};


/***/ },
/* 40 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Item = exports.Flex = undefined;
	
	var _Flex = __webpack_require__(992);
	
	Object.defineProperty(exports, 'Flex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Flex).default;
	  }
	});
	
	var _Item = __webpack_require__(993);
	
	Object.defineProperty(exports, 'Item', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Item).default;
	  }
	});
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  Flex: _Flex2.default,
	  Item: _Item2.default
	};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-top: -', ';\n  fill: ', '\n'], ['\n  margin-top: -', ';\n  fill: ', '\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  right: ', ';\n  top: ', ';\n  z-index: 1;\n  transition: ease transform 0.2s;\n'], ['\n  position: absolute;\n  right: ', ';\n  top: ', ';\n  z-index: 1;\n  transition: ease transform 0.2s;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  position: fixed;\n  display: ', ';\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 3;\n  ', ';\n'], ['\n  position: fixed;\n  display: ', ';\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 3;\n  ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  width: 100vw;\n  height: 100vh;\n  backgroundColor: ', ';\n'], ['\n  position: absolute;\n  width: 100vw;\n  height: 100vh;\n  backgroundColor: ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  background: ', ';\n  z-Index: 2;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: ', ';\n  max-height: ', ';\n  overflow: hidden;\n  @media screen and (max-width: ', ') {\n    height: 100vh;\n    width: 100vw;\n    max-height: none;\n    box-shadow: none;\n  }\n'], ['\n  background: ', ';\n  z-Index: 2;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: ', ';\n  max-height: ', ';\n  overflow: hidden;\n  @media screen and (max-width: ', ') {\n    height: 100vh;\n    width: 100vw;\n    max-height: none;\n    box-shadow: none;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  height: auto;\n  padding: ', ';\n  text-align: center;\n  position: relative;\n  ', ';\n  color: ', ';\n\n  .back {\n    position: absolute;\n    top: ', ';\n    left: ', ';\n    cursor: pointer;\n  }\n'], ['\n  height: auto;\n  padding: ', ';\n  text-align: center;\n  position: relative;\n  ', ';\n  color: ', ';\n\n  .back {\n    position: absolute;\n    top: ', ';\n    left: ', ';\n    cursor: pointer;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  height: auto;\n  padding: ', ' 0;\n  text-align: center;\n'], ['\n  height: auto;\n  padding: ', ' 0;\n  text-align: center;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  padding: ', ' 80px;\n  max-height: ', ';\n  overflow-y: scroll;\n  text-align: center;\n\n  @media screen and (max-width: ', ') {\n    padding: ', ' ', ';\n    max-height: 80vh;\n  }\n'], ['\n  padding: ', ' 80px;\n  max-height: ', ';\n  overflow-y: scroll;\n  text-align: center;\n\n  @media screen and (max-width: ', ') {\n    padding: ', ' ', ';\n    max-height: 80vh;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _CloseIcon = __webpack_require__(65);
	
	var _CloseIcon2 = _interopRequireDefault(_CloseIcon);
	
	var _Themes = __webpack_require__(5);
	
	var _LeftArrow = __webpack_require__(1115);
	
	var _LeftArrow2 = _interopRequireDefault(_LeftArrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var LeftArrowContainer = (0, _styledComponents2.default)(_LeftArrow2.default)(_templateObject, _Themes.Metrics.margins.small, _Themes.Colors.darkGrey);
	
	var Close = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base);
	
	var Container = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.visible ? 'block' : 'none';
	}, _Themes.Fonts.style.Text);
	
	var Overlay = _styledComponents2.default.div(_templateObject4, _Themes.Colors.overlay);
	
	var ModalContainer = _styledComponents2.default.div(_templateObject5, _Themes.Colors.white, _Themes.Metrics.components.modalWidth, _Themes.Metrics.components.modalHeight, _Themes.Metrics.breakpoints.mobile);
	
	var HeaderContainer = _styledComponents2.default.div(_templateObject6, _Themes.Metrics.margins.large, _Themes.Fonts.style.Header, _Themes.Colors.primary, _Themes.Metrics.margins.larger, _Themes.Metrics.margins.larger);
	
	var FooterContainer = _styledComponents2.default.div(_templateObject7, _Themes.Metrics.margins.base);
	
	var BodyContainer = _styledComponents2.default.div(_templateObject8, _Themes.Metrics.margins.large, _Themes.Metrics.components.modalContainer, _Themes.Metrics.breakpoints.mobile, _Themes.Metrics.margins.large, _Themes.Metrics.margins.big);
	
	var Modal = function Modal(props) {
	  var children = props.children;
	  var closeAction = props.closeAction;
	  var visible = props.visible;
	  var header = props.header;
	  var footer = props.footer;
	  var style = props.style;
	  var backAction = props.backAction;
	  var modalClassName = props.modalClassName;
	
	
	  var headerComponent = header ? _react2.default.createElement(
	    HeaderContainer,
	    { className: 'header' },
	    backAction && _react2.default.createElement(LeftArrowContainer, { className: 'back', onClick: function onClick() {
	        return backAction();
	      } }),
	    header
	  ) : '';
	
	  var footerContainer = footer ? _react2.default.createElement(
	    FooterContainer,
	    null,
	    footer
	  ) : '';
	
	  var closeIcon = closeAction ? _react2.default.createElement(
	    Close,
	    { onClick: closeAction },
	    _react2.default.createElement(_CloseIcon2.default, null)
	  ) : '';
	
	  return _react2.default.createElement(
	    Container,
	    Object.assign({ visible: visible, className: modalClassName }, props),
	    _react2.default.createElement(Overlay, null),
	    _react2.default.createElement(
	      ModalContainer,
	      { className: 'modalContainer' },
	      closeIcon,
	      headerComponent,
	      _react2.default.createElement(
	        BodyContainer,
	        { style: style, id: 'modal-body' },
	        children
	      ),
	      footerContainer
	    )
	  );
	};
	
	Modal.propTypes = {
	  visible: _react.PropTypes.bool,
	  children: _react.PropTypes.node,
	  closeAction: _react.PropTypes.func,
	  backAction: _react.PropTypes.func,
	  header: _react.PropTypes.node,
	  footer: _react.PropTypes.node,
	  style: _react.PropTypes.object,
	  modalClassName: _react.PropTypes.string
	};
	
	exports.default = Modal;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _map = __webpack_require__(151);
	var _reduce = __webpack_require__(49);
	var _xmap = __webpack_require__(794);
	var curryN = __webpack_require__(35);
	var keys = __webpack_require__(56);
	
	
	/**
	 * Takes a function and
	 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
	 * applies the function to each of the functor's values, and returns
	 * a functor of the same shape.
	 *
	 * Ramda provides suitable `map` implementations for `Array` and `Object`,
	 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
	 *
	 * Dispatches to the `map` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * Also treats functions as functors and will compose them together.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => (a -> b) -> f a -> f b
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {Array} list The list to be iterated over.
	 * @return {Array} The new list.
	 * @see R.transduce, R.addIndex
	 * @example
	 *
	 *      var double = x => x * 2;
	 *
	 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
	 *
	 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
	 * @symb R.map(f, [a, b]) = [f(a), f(b)]
	 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
	 * @symb R.map(f, functor_o) = functor_o.map(f)
	 */
	module.exports = _curry2(_dispatchable(['map'], _xmap, function map(fn, functor) {
	  switch (Object.prototype.toString.call(functor)) {
	    case '[object Function]':
	      return curryN(functor.length, function() {
	        return fn.call(this, functor.apply(this, arguments));
	      });
	    case '[object Object]':
	      return _reduce(function(acc, key) {
	        acc[key] = fn(functor[key]);
	        return acc;
	      }, {}, keys(functor));
	    default:
	      return _map(fn, functor);
	  }
	}));


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateForm = exports.validateInput = exports.filledForm = exports.validadeMaxLength = exports.validadeMinLength = exports.validateNumber = exports.validatePhoneNumber = exports.validateEmail = undefined;
	
	var _libphonenumberJs = __webpack_require__(695);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
	var numberRegex = /^[0-9]+$/;
	var alternatePhonePrefixRegex = /^00/;
	
	var validateEmail = exports.validateEmail = function validateEmail(email) {
	  return emailRegex.test(email);
	};
	
	var validatePhoneNumber = exports.validatePhoneNumber = function validatePhoneNumber(phoneNumber) {
	  if (alternatePhonePrefixRegex.test(phoneNumber)) {
	    // begins with 00, should use a + instead
	    phoneNumber = phoneNumber.replace(alternatePhonePrefixRegex, '+');
	  }
	
	  return (0, _libphonenumberJs.isValidNumber)((0, _libphonenumberJs.format)((0, _libphonenumberJs.parse)(phoneNumber), 'International'));
	};
	
	var validateNumber = exports.validateNumber = function validateNumber(n) {
	  var nAsString = typeof n === 'number' ? n.toString() : n;
	  return numberRegex.test(nAsString);
	};
	
	var validadeMinLength = exports.validadeMinLength = function validadeMinLength(value, min) {
	  return value.length >= min;
	};
	
	var validadeMaxLength = exports.validadeMaxLength = function validadeMaxLength(value, max) {
	  return value.length <= max;
	};
	
	var filledForm = exports.filledForm = function filledForm(value) {
	  return value.length > 0;
	};
	
	var validateInput = exports.validateInput = function validateInput(name, value, errors) {
	  var newErrors = Object.assign({}, errors);
	  switch (name) {
	    case 'email':
	      newErrors[name] = validateEmail(value) ? '' : 'The email is not valid';
	      return newErrors;
	    case 'phoneNumber':
	      newErrors[name] = validatePhoneNumber(value) ? '' : 'The field is not a phone number';
	      return newErrors;
	    case 'usableArea':
	    case 'area':
	    case 'yield':
	    case 'noRooms':
	    case 'price':
	      newErrors[name] = validateNumber(value) ? '' : 'The field must be a number';
	      return newErrors;
	    default:
	      newErrors[name] = value && !_ramda2.default.isEmpty(value) ? '' : 'This field is required';
	      return newErrors;
	  }
	};
	
	var validateForm = exports.validateForm = function validateForm(values, errors) {
	  var requiredFields = document.querySelectorAll('[required]');
	  var newErrors = _ramda2.default.clone(errors);
	  var valid = true;
	  requiredFields.forEach(function (field) {
	    var fieldIdentifier = field.name || field.id;
	    newErrors = validateInput(fieldIdentifier, values[fieldIdentifier], newErrors);
	    valid = valid && !newErrors[fieldIdentifier];
	  });
	  return {
	    valid: valid,
	    errors: newErrors
	  };
	};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: ', ';\n  background: rgba(0, 0, 0, 0.4);\n  left: 0;\n  top: 0;\n  z-index: 5;\n'], ['\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: ', ';\n  background: rgba(0, 0, 0, 0.4);\n  left: 0;\n  top: 0;\n  z-index: 5;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: table-cell;\n  vertical-align: middle;\n'], ['\n  display: table-cell;\n  vertical-align: middle;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-left: calc((100% - ', 'px)/2);\n  width: ', 'px;\n  height: ', 'px;\n'], ['\n  margin-left: calc((100% - ', 'px)/2);\n  width: ', 'px;\n  height: ', 'px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var bodymovin;
	if (process.browser) {
	  bodymovin = __webpack_require__(642);
	}
	
	var Container = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.visible ? 'table' : 'none';
	});
	
	var LoaderContainer = _styledComponents2.default.div(_templateObject2);
	
	var LoaderSpining = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.width;
	}, function (props) {
	  return props.width;
	}, function (props) {
	  return props.height;
	});
	
	var Loader = function (_Component) {
	  _inherits(Loader, _Component);
	
	  function Loader(props) {
	    _classCallCheck(this, Loader);
	
	    var _this = _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).call(this, props));
	
	    _this.container = null;
	    _this.params = {
	      container: null,
	      renderer: 'svg',
	      prerender: true,
	      loop: true,
	      autoplay: true,
	      path: '/loader.json'
	    };
	    return _this;
	  }
	
	  _createClass(Loader, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (process.browser) {
	        this.params.container = this.container;
	        this.anim = bodymovin.loadAnimation(this.params);
	        window.onresize = this.anim.resize.bind(this.anim);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var visible = _props.visible;
	      var height = _props.height;
	      var width = _props.width;
	
	      return _react2.default.createElement(
	        Container,
	        Object.assign({ visible: visible }, this.props),
	        _react2.default.createElement(
	          LoaderContainer,
	          { height: height, width: width },
	          _react2.default.createElement(LoaderSpining, {
	            height: height,
	            width: width,
	            innerRef: function innerRef(div) {
	              _this2.container = div;
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return Loader;
	}(_react.Component);
	
	Loader.propTypes = {
	  visible: _react.PropTypes.bool,
	  width: _react2.default.PropTypes.number,
	  height: _react2.default.PropTypes.number
	};
	
	Loader.defaultProps = {
	  width: 100,
	  height: 100
	};
	
	exports.default = Loader;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  ', ';\n  ', ';\n'], ['\n  margin-top: ', ';\n  ', ';\n  ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n'], ['\n  ', ';\n  color: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	var _index = __webpack_require__(42);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject, _Themes.Metrics.margins.base, function (props) {
	  return props.left ? 'margin-left: ' + _Themes.Metrics.margins.small : 'margin-left: 0';
	}, function (props) {
	  return props.right ? 'margin-right: ' + _Themes.Metrics.margins.small : 'margin-right: 0';
	});
	
	var Header = _styledComponents2.default.div(_templateObject2, _Themes.Fonts.style.Header, _Themes.Colors.primary);
	
	var DialogModal = function (_Component) {
	  _inherits(DialogModal, _Component);
	
	  function DialogModal() {
	    _classCallCheck(this, DialogModal);
	
	    return _possibleConstructorReturn(this, (DialogModal.__proto__ || Object.getPrototypeOf(DialogModal)).apply(this, arguments));
	  }
	
	  _createClass(DialogModal, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var visible = this.props.visible;
	
	      return visible !== nextProps.visible;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var visible = _props.visible;
	      var closeAction = _props.closeAction;
	      var header = _props.header;
	      var message = _props.message;
	      var buttons = _props.buttons;
	
	      return _react2.default.createElement(
	        _index2.default,
	        {
	          header: _react2.default.createElement(
	            Header,
	            null,
	            header
	          ),
	          visible: visible,
	          closeAction: closeAction },
	        _react2.default.createElement(
	          'div',
	          null,
	          message
	        ),
	        _react2.default.createElement(CustomButton, {
	          right: true,
	          onClick: buttons.cancel.onClick,
	          label: buttons.cancel.label
	        }),
	        _react2.default.createElement(CustomButton, {
	          left: true,
	          onClick: buttons.apply.onClick,
	          label: buttons.apply.label
	        })
	      );
	    }
	  }]);
	
	  return DialogModal;
	}(_react.Component);
	
	DialogModal.propTypes = {
	  visible: _react.PropTypes.bool,
	  message: _react.PropTypes.node,
	  closeAction: _react.PropTypes.func,
	  backAction: _react.PropTypes.func,
	  header: _react.PropTypes.node,
	  buttons: _react.PropTypes.object.isRequired
	};
	
	exports.default = DialogModal;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(263);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 48 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var _xwrap = __webpack_require__(439);
	var bind = __webpack_require__(414);
	var isArrayLike = __webpack_require__(112);
	
	
	module.exports = (function() {
	  function _arrayReduce(xf, acc, list) {
	    var idx = 0;
	    var len = list.length;
	    while (idx < len) {
	      acc = xf['@@transducer/step'](acc, list[idx]);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      idx += 1;
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _iterableReduce(xf, acc, iter) {
	    var step = iter.next();
	    while (!step.done) {
	      acc = xf['@@transducer/step'](acc, step.value);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      step = iter.next();
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _methodReduce(xf, acc, obj) {
	    return xf['@@transducer/result'](obj.reduce(bind(xf['@@transducer/step'], xf), acc));
	  }
	
	  var symIterator = (typeof Symbol !== 'undefined') ? Symbol.iterator : '@@iterator';
	  return function _reduce(fn, acc, list) {
	    if (typeof fn === 'function') {
	      fn = _xwrap(fn);
	    }
	    if (isArrayLike(list)) {
	      return _arrayReduce(fn, acc, list);
	    }
	    if (typeof list.reduce === 'function') {
	      return _methodReduce(fn, acc, list);
	    }
	    if (list[symIterator] != null) {
	      return _iterableReduce(fn, acc, list[symIterator]());
	    }
	    if (typeof list.next === 'function') {
	      return _iterableReduce(fn, acc, list);
	    }
	    throw new TypeError('reduce: list must be array or iterable');
	  };
	}());


/***/ },
/* 50 */
/***/ function(module, exports) {

	/**
	 * Private `concat` function to merge two array-like objects.
	 *
	 * @private
	 * @param {Array|Arguments} [set1=[]] An array-like object.
	 * @param {Array|Arguments} [set2=[]] An array-like object.
	 * @return {Array} A new, merged array.
	 * @example
	 *
	 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 */
	module.exports = function _concat(set1, set2) {
	  set1 = set1 || [];
	  set2 = set2 || [];
	  var idx;
	  var len1 = set1.length;
	  var len2 = set2.length;
	  var result = [];
	
	  idx = 0;
	  while (idx < len1) {
	    result[result.length] = set1[idx];
	    idx += 1;
	  }
	  idx = 0;
	  while (idx < len2) {
	    result[result.length] = set2[idx];
	    idx += 1;
	  }
	  return result;
	};


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 52 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var maxPrice = exports.maxPrice = 500000000;
	var maxArea = exports.maxArea = 135000;
	var maxRooms = exports.maxRooms = 500;
	var maxYield = exports.maxYield = 30;
	var defaultLimit = exports.defaultLimit = 100;
	var defaultPriceStep = exports.defaultPriceStep = 1000000;
	var defaultAreaStep = exports.defaultAreaStep = 1000;
	var defaultRoomsStep = exports.defaultRoomsStep = 5;
	var defaultYieldStep = exports.defaultYieldStep = 1;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(170);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _AuthSources = __webpack_require__(75);
	
	var _ErrorMessages = __webpack_require__(243);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuthActions = function () {
	  function AuthActions() {
	    _classCallCheck(this, AuthActions);
	  }
	
	  _createClass(AuthActions, [{
	    key: 'validateCode',
	    value: function validateCode(id, code) {
	      var _this = this;
	
	      return function (dispatch) {
	        dispatch();
	        (0, _AuthSources.validateUserCode)(id, code).then(function (response) {
	          return _this.loginSuccess(response.data);
	        }).catch(function (error) {
	          if (error.response.status === 403) {
	            return _this.loginFailed(error.response.data);
	          } else {
	            return _this.loginFailed(_ErrorMessages.errorMessages.general);
	          }
	        });
	      };
	    }
	  }, {
	    key: 'storeToken',
	    value: function storeToken(data) {
	      return data;
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      return true;
	    }
	  }, {
	    key: 'loginSuccess',
	    value: function loginSuccess(data) {
	      return data;
	    }
	  }, {
	    key: 'loginFailed',
	    value: function loginFailed(errorMessage) {
	      return errorMessage;
	    }
	  }, {
	    key: 'loginAdmin',
	    value: function loginAdmin(email, password) {
	      var _this2 = this;
	
	      return function (dispatch) {
	        dispatch();
	        (0, _AuthSources.loginAdmin)(email, password).then(function (response) {
	          return _this2.loginAdminSuccess(response.data);
	        }).catch(function (error) {
	          if (error.response.status === 403) {
	            return _this2.loginFailed(_ErrorMessages.errorMessages.emailOrPassWrong);
	          } else {
	            return _this2.loginFailed(_ErrorMessages.errorMessages.general);
	          }
	        });
	      };
	    }
	  }, {
	    key: 'loginAdminSuccess',
	    value: function loginAdminSuccess(data) {
	      return data;
	    }
	  }, {
	    key: 'logoutAdmin',
	    value: function logoutAdmin() {
	      return true;
	    }
	  }, {
	    key: 'updateToken',
	    value: function updateToken(token) {
	      return token;
	    }
	  }, {
	    key: 'cleanError',
	    value: function cleanError() {
	      return true;
	    }
	  }]);
	
	  return AuthActions;
	}();
	
	module.exports = _alt2.default.createActions(AuthActions);

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _equals = __webpack_require__(769);
	
	
	/**
	 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
	 * cyclical data structures.
	 *
	 * Dispatches symmetrically to the `equals` methods of both arguments, if
	 * present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> b -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      R.equals(1, 1); //=> true
	 *      R.equals(1, '1'); //=> false
	 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
	 *
	 *      var a = {}; a.v = a;
	 *      var b = {}; b.v = b;
	 *      R.equals(a, b); //=> true
	 */
	module.exports = _curry2(function equals(a, b) {
	  return _equals(a, b, [], []);
	});


/***/ },
/* 55 */
/***/ function(module, exports) {

	module.exports = function _arity(n, fn) {
	  /* eslint-disable no-unused-vars */
	  switch (n) {
	    case 0: return function() { return fn.apply(this, arguments); };
	    case 1: return function(a0) { return fn.apply(this, arguments); };
	    case 2: return function(a0, a1) { return fn.apply(this, arguments); };
	    case 3: return function(a0, a1, a2) { return fn.apply(this, arguments); };
	    case 4: return function(a0, a1, a2, a3) { return fn.apply(this, arguments); };
	    case 5: return function(a0, a1, a2, a3, a4) { return fn.apply(this, arguments); };
	    case 6: return function(a0, a1, a2, a3, a4, a5) { return fn.apply(this, arguments); };
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) { return fn.apply(this, arguments); };
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) { return fn.apply(this, arguments); };
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) { return fn.apply(this, arguments); };
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) { return fn.apply(this, arguments); };
	    default: throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
	  }
	};


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var _has = __webpack_require__(39);
	var _isArguments = __webpack_require__(432);
	
	
	/**
	 * Returns a list containing the names of all the enumerable own properties of
	 * the supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own properties.
	 * @example
	 *
	 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
	 */
	module.exports = (function() {
	  // cover IE < 9 keys issues
	  var hasEnumBug = !({toString: null}).propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
	                            'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	  // Safari bug
	  var hasArgsEnumBug = (function() {
	    'use strict';
	    return arguments.propertyIsEnumerable('length');
	  }());
	
	  var contains = function contains(list, item) {
	    var idx = 0;
	    while (idx < list.length) {
	      if (list[idx] === item) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  };
	
	  return typeof Object.keys === 'function' && !hasArgsEnumBug ?
	    _curry1(function keys(obj) {
	      return Object(obj) !== obj ? [] : Object.keys(obj);
	    }) :
	    _curry1(function keys(obj) {
	      if (Object(obj) !== obj) {
	        return [];
	      }
	      var prop, nIdx;
	      var ks = [];
	      var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
	      for (prop in obj) {
	        if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
	          ks[ks.length] = prop;
	        }
	      }
	      if (hasEnumBug) {
	        nIdx = nonEnumerableProps.length - 1;
	        while (nIdx >= 0) {
	          prop = nonEnumerableProps[nIdx];
	          if (_has(prop, obj) && !contains(ks, prop)) {
	            ks[ks.length] = prop;
	          }
	          nIdx -= 1;
	        }
	      }
	      return ks;
	    });
	}());


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	var _reduce = __webpack_require__(49);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It may use
	 * `R.reduced` to shortcut the iteration.
	 *
	 * The arguments' order of `reduceRight`'s iterator function is *(value, acc)*.
	 *
	 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
	 *
	 * Dispatches to the `reduce` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduced, R.addIndex, R.reduceRight
	 * @example
	 *
	 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
	 *                -               -10
	 *               / \              / \
	 *              -   4           -6   4
	 *             / \              / \
	 *            -   3   ==>     -3   3
	 *           / \              / \
	 *          -   2           -1   2
	 *         / \              / \
	 *        0   1            0   1
	 *
	 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
	 */
	module.exports = _curry3(_reduce);


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(929);


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(15);
	
	var CallbackQueue = __webpack_require__(479);
	var PooledClass = __webpack_require__(85);
	var ReactFeatureFlags = __webpack_require__(484);
	var ReactReconciler = __webpack_require__(98);
	var Transaction = __webpack_require__(165);
	
	var invariant = __webpack_require__(12);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral([''], ['']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n  background: white;\n  border: ', ';\n  cursor: pointer;\n  border-radius: ', ';\n  min-height: ', ';\n  padding: calc(', ' - 1px);\n  .dropdown-header {\n    ', ';\n    color: ', ';\n    position: relative;\n    .placeholder {\n      ', ';\n      color: ', ';\n    }\n    .arrow {\n      position: absolute;\n      right: 10px;\n      right: 0;\n      top: -', ';\n      transform: rotate(180deg);\n      fill: ', ';\n      &.open {\n        transform: rotate(0deg);\n      }\n    }\n  }\n\n  .dropdown-list {\n    display: ', ';\n    position: absolute;\n    left: -1px;\n    z-index: 2;\n    width: calc(100% + 2px);\n    background: white;\n    border: ', ';\n    border-top: none;\n    border-radius: ', ';\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    ', ';\n    color: ', ';\n  }\n'], ['\n  position: relative;\n  background: white;\n  border: ', ';\n  cursor: pointer;\n  border-radius: ', ';\n  min-height: ', ';\n  padding: calc(', ' - 1px);\n  .dropdown-header {\n    ', ';\n    color: ', ';\n    position: relative;\n    .placeholder {\n      ', ';\n      color: ', ';\n    }\n    .arrow {\n      position: absolute;\n      right: 10px;\n      right: 0;\n      top: -', ';\n      transform: rotate(180deg);\n      fill: ', ';\n      &.open {\n        transform: rotate(0deg);\n      }\n    }\n  }\n\n  .dropdown-list {\n    display: ', ';\n    position: absolute;\n    left: -1px;\n    z-index: 2;\n    width: calc(100% + 2px);\n    background: white;\n    border: ', ';\n    border-top: none;\n    border-radius: ', ';\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    ', ';\n    color: ', ';\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n  margin-top: ', ';\n'], ['\n  ', ';\n  color: ', ';\n  margin-top: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Themes = __webpack_require__(5);
	
	var _immutable = __webpack_require__(29);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _List = __webpack_require__(124);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(125);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Arrow = __webpack_require__(101);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var DropdownContainer = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.borders.default, _Themes.Metrics.borders.defaultRadius, _Themes.Metrics.components.inputFormHeight, _Themes.Metrics.margins.small, _Themes.Fonts.style.Input, _Themes.Colors.black, _Themes.Fonts.style.Input, _Themes.Colors.darkGrey, _Themes.Metrics.margins.tiny, _Themes.Colors.primary, function (props) {
	  return props.open ? 'block' : 'none';
	}, _Themes.Metrics.borders.headerBorder, _Themes.Metrics.borders.defaultRadius, _Themes.Fonts.style.Input, _Themes.Colors.black);
	
	var Error = _styledComponents2.default.div(_templateObject3, _Themes.Fonts.style.Input, _Themes.Colors.red, _Themes.Metrics.margins.tiny);
	
	var Dropdown = function (_Component) {
	  _inherits(Dropdown, _Component);
	
	  function Dropdown(props) {
	    _classCallCheck(this, Dropdown);
	
	    var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));
	
	    _this.state = {
	      open: false
	    };
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(Dropdown, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var _props = this.props;
	      var options = _props.options;
	      var selectedOption = _props.selectedOption;
	      var error = _props.error;
	      var open = this.state.open;
	
	      if (!(0, _immutable.fromJS)(options).equals((0, _immutable.fromJS)(nextProps.options)) || selectedOption !== nextProps.selectedOption || error !== nextProps.error || open !== nextState.open) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      this.setState({ open: !this.state.open });
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        if (_this2.props.handleBlur) {
	          _this2.props.handleBlur();
	        }
	        _this2.setState({
	          open: false,
	          value: ''
	        });
	      }, 250);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props;
	      var placeholder = _props2.placeholder;
	      var handleSelect = _props2.handleSelect;
	      var selectedOption = _props2.selectedOption;
	      var options = _props2.options;
	      var accessor = _props2.accessor;
	      var name = _props2.name;
	      var required = _props2.required;
	      var error = _props2.error;
	      var className = _props2.className;
	
	
	      var list = options.length > 0 ? options.map(function (el, index) {
	        return _react2.default.createElement(
	          _ListItem2.default,
	          {
	            key: index,
	            value: el,
	            onClick: function onClick() {
	              handleSelect(el);
	              _this3.handleBlur();
	            } },
	          accessor ? accessor(options[index]) : '' + options[index]
	        );
	      }) : _react2.default.createElement(
	        'span',
	        null,
	        'There are no elements'
	      );
	
	      var header = selectedOption !== null && (accessor ? accessor(selectedOption) : selectedOption) || _react2.default.createElement(
	        'span',
	        { className: 'placeholder' },
	        placeholder
	      );
	
	      return _react2.default.createElement(
	        DropdownContainer,
	        { required: required, id: name },
	        _react2.default.createElement(
	          Container,
	          {
	            onBlur: this.handleBlur,
	            onClick: this.handleClick,
	            open: this.state.open,
	            tabIndex: '-1',
	            className: className + ' dropdown-component' },
	          _react2.default.createElement(
	            'div',
	            { className: 'dropdown-header' },
	            header,
	            _react2.default.createElement(_Arrow2.default, { className: 'arrow ' + (this.state.open && 'open') })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'dropdown-list' },
	            _react2.default.createElement(
	              _List2.default,
	              { className: 'list', hide: !this.state.open },
	              list
	            )
	          )
	        ),
	        error && _react2.default.createElement(
	          Error,
	          null,
	          error
	        )
	      );
	    }
	  }]);
	
	  return Dropdown;
	}(_react.Component);
	
	Dropdown.propTypes = {
	  options: _react.PropTypes.array.isRequired,
	  selectedOption: _react.PropTypes.any,
	  placeholder: _react.PropTypes.string.isRequired,
	  handleSelect: _react.PropTypes.func,
	  accessor: _react.PropTypes.func,
	  error: _react.PropTypes.string,
	  handleBlur: _react.PropTypes.func,
	  name: _react.PropTypes.string,
	  required: _react.PropTypes.bool,
	  className: _react.PropTypes.string
	};
	
	exports.default = Dropdown;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(277);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var PooledClass = __webpack_require__(85);
	
	var emptyFunction = __webpack_require__(63);
	var warning = __webpack_require__(19);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 63 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  .input-container {\n    width: ', ';\n    height: auto;\n    border: ', ';\n    border-radius: ', ';\n    color: black;\n    cursor: pointer;\n    background: ', ';\n    position: relative;\n    outline: none;\n    position: relative;\n\n    border-bottom: ', ';\n    border-bottom-left-radius: ', ';\n    border-bottom-right-radius: ', ';\n\n    .formContainer {\n      border: none;\n    }\n\n    .list {\n      margin: ', ';\n    }\n  }\n\n  .dropdown-list {\n    display: ', ';\n    position: absolute;\n    background: white;\n    width: 100%;\n    border: ', ';\n    border-top: none;\n    border-radius: ', ';\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n    top: 30px;\n    z-index: 1;\n  }\n\n  .tags {\n    margin-top: ', ';\n    height: auto;\n    margin-bottom: ', ';\n    text-align: left;\n  }\n\n  &.search {\n    .input-container {\n      border: none;\n    }\n\n    .dropdown-list {\n      border: none;\n      position: inherit !important;\n      padding: 0px;\n      top: 0px;\n    }\n  }\n'], ['\n  position: relative;\n  .input-container {\n    width: ', ';\n    height: auto;\n    border: ', ';\n    border-radius: ', ';\n    color: black;\n    cursor: pointer;\n    background: ', ';\n    position: relative;\n    outline: none;\n    position: relative;\n\n    border-bottom: ', ';\n    border-bottom-left-radius: ', ';\n    border-bottom-right-radius: ', ';\n\n    .formContainer {\n      border: none;\n    }\n\n    .list {\n      margin: ', ';\n    }\n  }\n\n  .dropdown-list {\n    display: ', ';\n    position: absolute;\n    background: white;\n    width: 100%;\n    border: ', ';\n    border-top: none;\n    border-radius: ', ';\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n    top: 30px;\n    z-index: 1;\n  }\n\n  .tags {\n    margin-top: ', ';\n    height: auto;\n    margin-bottom: ', ';\n    text-align: left;\n  }\n\n  &.search {\n    .input-container {\n      border: none;\n    }\n\n    .dropdown-list {\n      border: none;\n      position: inherit !important;\n      padding: 0px;\n      top: 0px;\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['margin-left: ', ';'], ['margin-left: ', ';']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n  margin-top: ', ';\n'], ['\n  ', ';\n  color: ', ';\n  margin-top: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(29);
	
	var _Themes = __webpack_require__(5);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _List = __webpack_require__(124);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(125);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Tag = __webpack_require__(127);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _CloseIcon = __webpack_require__(65);
	
	var _CloseIcon2 = _interopRequireDefault(_CloseIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.width ? props.width : 'auto';
	}, _Themes.Metrics.borders.default, _Themes.Metrics.borders.defaultRadius, _Themes.Colors.white, function (props) {
	  return props.open ? 0 : _Themes.Metrics.borders.default;
	}, function (props) {
	  return props.open ? 0 : _Themes.Metrics.borders.defaultRadius;
	}, function (props) {
	  return props.open ? 0 : _Themes.Metrics.borders.defaultRadius;
	}, _Themes.Metrics.margins.small, function (props) {
	  return props.open ? 'block' : 'none';
	}, _Themes.Metrics.borders.default, _Themes.Metrics.borders.defaultRadius, _Themes.Metrics.margins.tiny, _Themes.Metrics.margins.small);
	
	var NoElements = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.margins.small);
	
	var Error = _styledComponents2.default.div(_templateObject3, _Themes.Fonts.style.Input, _Themes.Colors.red, _Themes.Metrics.margins.tiny);
	
	var SearchableDropdown = function (_Component) {
	  _inherits(SearchableDropdown, _Component);
	
	  function SearchableDropdown(props) {
	    _classCallCheck(this, SearchableDropdown);
	
	    var _this = _possibleConstructorReturn(this, (SearchableDropdown.__proto__ || Object.getPrototypeOf(SearchableDropdown)).call(this, props));
	
	    _this.state = {
	      open: false
	    };
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleSearch = _this.handleSearch.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    return _this;
	  }
	
	  _createClass(SearchableDropdown, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var open = this.state.open;
	      var _props = this.props;
	      var options = _props.options;
	      var value = _props.value;
	      var selectedOptions = _props.selectedOptions;
	      var error = _props.error;
	
	
	      if (options && !(0, _immutable.fromJS)(options).equals((0, _immutable.fromJS)(nextProps.options)) || selectedOptions && !(0, _immutable.fromJS)(selectedOptions).equals((0, _immutable.fromJS)(nextProps.selectedOptions)) || error !== nextProps.error || value !== nextProps.value || open !== nextState.open) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'handleSearch',
	    value: function handleSearch(event) {
	      this.setState({ open: true });
	      this.props.handleSearch(event);
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(el) {
	      var _this2 = this;
	
	      this.setState({ open: !this.state.open }, function () {
	        _this2.props.handleSelect(el);
	      });
	    }
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus() {
	      clearTimeout(this.timer);
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur() {
	      var _this3 = this;
	
	      setTimeout(function () {
	        _this3.setState({
	          open: false
	        });
	      }, 250);
	      if (this.props.handleBlur) {
	        this.props.handleBlur();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props;
	      var placeholder = _props2.placeholder;
	      var handleSelect = _props2.handleSelect;
	      var options = _props2.options;
	      var value = _props2.value;
	      var showTags = _props2.showTags;
	      var accessor = _props2.accessor;
	      var tagsAccessor = _props2.tagsAccessor;
	      var required = _props2.required;
	      var handleInputBlur = _props2.handleInputBlur;
	      var error = _props2.error;
	      var inputName = _props2.inputName;
	      var className = _props2.className;
	
	
	      var list = options.length > 0 ? options.map(function (el, index) {
	        return _react2.default.createElement(
	          _ListItem2.default,
	          {
	            key: index,
	            value: el,
	            onClick: function onClick() {
	              _this4.handleClick(el);
	            } },
	          accessor(el)
	        );
	      }) : _react2.default.createElement(
	        NoElements,
	        null,
	        'No elements found'
	      );
	
	      var tags = showTags && this.props.selectedOptions && this.props.selectedOptions.map(function (el, index) {
	        return _react2.default.createElement(_Tag2.default, {
	          key: 'Tag-' + index + '-index',
	          text: tagsAccessor(el),
	          icon: _react2.default.createElement(_CloseIcon2.default, { onClick: function onClick() {
	              return handleSelect(el);
	            } })
	        });
	      });
	
	      return _react2.default.createElement(
	        Container,
	        {
	          onFocus: this.handleFocus,
	          onBlur: this.handleBlur,
	          open: this.state.open,
	          tabIndex: '-1',
	          className: className + ' searchable-dropdown' },
	        _react2.default.createElement(
	          'div',
	          { className: 'dropdown-header input-container' },
	          _react2.default.createElement(_Input2.default, {
	            name: inputName,
	            required: required,
	            placeholder: placeholder,
	            handleChange: this.handleSearch,
	            value: value,
	            handleBlur: handleInputBlur
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'dropdown-list' },
	          _react2.default.createElement(
	            _List2.default,
	            { className: 'list', hide: !this.state.open },
	            list
	          )
	        ),
	        error && _react2.default.createElement(
	          Error,
	          null,
	          error
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tags' },
	          tags
	        )
	      );
	    }
	  }]);
	
	  return SearchableDropdown;
	}(_react.Component);
	
	SearchableDropdown.propTypes = {
	  options: _react.PropTypes.array.isRequired,
	  value: _react.PropTypes.string.isRequired,
	  selectedOptions: _react.PropTypes.array,
	  showTags: _react.PropTypes.bool,
	  placeholder: _react.PropTypes.string.isRequired,
	  handleSelect: _react.PropTypes.func.isRequired,
	  handleSearch: _react.PropTypes.func.isRequired,
	  accessor: _react.PropTypes.func.isRequired,
	  tagsAccessor: _react.PropTypes.func,
	  handleBlur: _react.PropTypes.func,
	  error: _react.PropTypes.string,
	  handleInputBlur: _react.PropTypes.func,
	  required: _react.PropTypes.bool,
	  inputName: _react.PropTypes.string,
	  className: _react.PropTypes.string
	};
	
	exports.default = SearchableDropdown;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  svg {\n    transition: ease transform 0.2s;\n    cursor: pointer;\n\n    &:hover {\n      transform: scale(1.1);\n      transition: ease transform 0.2s;\n    }\n  }\n'], ['\n  svg {\n    transition: ease transform 0.2s;\n    cursor: pointer;\n\n    &:hover {\n      transform: scale(1.1);\n      transition: ease transform 0.2s;\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Close = _styledComponents2.default.div(_templateObject);
	
	var CloseIcon = function CloseIcon(props) {
	  return _react2.default.createElement(
	    Close,
	    props,
	    _react2.default.createElement(
	      'svg',
	      { width: '24', height: '24', viewBox: '0 0 24 24' },
	      _react2.default.createElement('path', { d: 'M12,13.4142136 L5.70710678,19.7071068 C5.31658249,20.0976311 4.68341751,20.0976311 4.29289322,19.7071068 C3.90236893,19.3165825 3.90236893,18.6834175 4.29289322,18.2928932 L10.5857864,12 L4.29289322,5.70710678 C3.90236893,5.31658249 3.90236893,4.68341751 4.29289322,4.29289322 C4.68341751,3.90236893 5.31658249,3.90236893 5.70710678,4.29289322 L12,10.5857864 L18.2928932,4.29289322 C18.6834175,3.90236893 19.3165825,3.90236893 19.7071068,4.29289322 C20.0976311,4.68341751 20.0976311,5.31658249 19.7071068,5.70710678 L13.4142136,12 L19.7071068,18.2928932 C20.0976311,18.6834175 20.0976311,19.3165825 19.7071068,19.7071068 C19.3165825,20.0976311 18.6834175,20.0976311 18.2928932,19.7071068 L12,13.4142136 Z' })
	    )
	  );
	};
	
	exports.default = CloseIcon;

/***/ },
/* 66 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 67 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = warnOnce;
	var printed = {};
	
	function warnOnce(message) {
	    if (printed[message]) return;
	    printed[message] = true;
	
	    if (typeof console !== 'undefined' && console.warn) console.warn(message);
	}
	module.exports = exports['default'];

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var es5 = __webpack_require__(92);
	var Objectfreeze = es5.freeze;
	var util = __webpack_require__(16);
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
	        value: errorTypes,
	        writable: false,
	        enumerable: false,
	        configurable: false
	    });
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 70 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var consoleLogger = {
	  type: 'logger',
	
	  log: function log(args) {
	    this._output('log', args);
	  },
	  warn: function warn(args) {
	    this._output('warn', args);
	  },
	  error: function error(args) {
	    this._output('error', args);
	  },
	  _output: function _output(type, args) {
	    if (console && console[type]) console[type].apply(console, Array.prototype.slice.call(args));
	  }
	};
	
	var Logger = function () {
	  function Logger(concreteLogger) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Logger);
	
	    this.init(concreteLogger, options);
	  }
	
	  Logger.prototype.init = function init(concreteLogger) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    this.prefix = options.prefix || 'i18next:';
	    this.logger = concreteLogger || consoleLogger;
	    this.options = options;
	    this.debug = options.debug === false ? false : true;
	  };
	
	  Logger.prototype.setDebug = function setDebug(bool) {
	    this.debug = bool;
	  };
	
	  Logger.prototype.log = function log() {
	    this.forward(arguments, 'log', '', true);
	  };
	
	  Logger.prototype.warn = function warn() {
	    this.forward(arguments, 'warn', '', true);
	  };
	
	  Logger.prototype.error = function error() {
	    this.forward(arguments, 'error', '');
	  };
	
	  Logger.prototype.deprecate = function deprecate() {
	    this.forward(arguments, 'warn', 'WARNING DEPRECATED: ', true);
	  };
	
	  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
	    if (debugOnly && !this.debug) return;
	    if (typeof args[0] === 'string') args[0] = prefix + this.prefix + ' ' + args[0];
	    this.logger[lvl](args);
	  };
	
	  Logger.prototype.create = function create(moduleName) {
	    var sub = new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
	
	    return sub;
	  };
	
	  // createInstance(options = {}) {
	  //   return new Logger(options, callback);
	  // }
	
	  return Logger;
	}();
	
	;
	
	exports.default = new Logger();

/***/ },
/* 71 */
/***/ function(module, exports) {

	/**
	 * Tests whether or not an object is an array.
	 *
	 * @private
	 * @param {*} val The object to test.
	 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
	 * @example
	 *
	 *      _isArray([]); //=> true
	 *      _isArray(null); //=> false
	 *      _isArray({}); //=> false
	 */
	module.exports = Array.isArray || function _isArray(val) {
	  return (val != null &&
	          val.length >= 0 &&
	          Object.prototype.toString.call(val) === '[object Array]');
	};


/***/ },
/* 72 */
/***/ function(module, exports) {

	module.exports = function _reduced(x) {
	  return x && x['@@transducer/reduced'] ? x :
	    {
	      '@@transducer/value': x,
	      '@@transducer/reduced': true
	    };
	};


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  .textAreaTitle {\n    margin-bottom: ', ';\n    ', ';\n    color: ', ';\n  }\n\n  .error {\n    ', ';\n    color: ', ';\n  }\n\n  textarea {\n    width: 100%;\n    padding: ', ';\n    min-height: 100px;\n    border: ', ';\n    border-radius: ', ';\n    outline: none;\n    ', ';\n    color: ', ';\n    resize: none;\n    &::-webkit-input-placeholder {\n      height: ', ';\n      color: ', ';\n    }\n    &::-moz-placeholder {\n      /* Firefox 19+ */\n      height: ', ';\n      color: ', ';\n    }\n    &:-ms-input-placeholder {\n      /* IE 10+ */\n      height: ', ';\n      color: ', ';\n    }\n    &:-moz-placeholder {\n      /* Firefox 18- */\n      height: ', ';\n      color: ', ';\n    }\n  }\n'], ['\n  .textAreaTitle {\n    margin-bottom: ', ';\n    ', ';\n    color: ', ';\n  }\n\n  .error {\n    ', ';\n    color: ', ';\n  }\n\n  textarea {\n    width: 100%;\n    padding: ', ';\n    min-height: 100px;\n    border: ', ';\n    border-radius: ', ';\n    outline: none;\n    ', ';\n    color: ', ';\n    resize: none;\n    &::-webkit-input-placeholder {\n      height: ', ';\n      color: ', ';\n    }\n    &::-moz-placeholder {\n      /* Firefox 19+ */\n      height: ', ';\n      color: ', ';\n    }\n    &:-ms-input-placeholder {\n      /* IE 10+ */\n      height: ', ';\n      color: ', ';\n    }\n    &:-moz-placeholder {\n      /* Firefox 18- */\n      height: ', ';\n      color: ', ';\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject, _Themes.Metrics.margins.small, _Themes.Fonts.style.Label, _Themes.Colors.black, _Themes.Fonts.style.Input, _Themes.Colors.red, _Themes.Metrics.margins.tiny, _Themes.Metrics.borders.default, _Themes.Metrics.borders.defaultRadius, _Themes.Fonts.style.Input, _Themes.Colors.black, _Themes.Metrics.components.inputFormHeight, _Themes.Colors.darkGrey, _Themes.Metrics.components.inputFormHeight, _Themes.Colors.darkGrey, _Themes.Metrics.components.inputFormHeight, _Themes.Colors.darkGrey, _Themes.Metrics.components.inputFormHeight, _Themes.Colors.darkGrey);
	
	var Textarea = function (_Component) {
	  _inherits(Textarea, _Component);
	
	  function Textarea() {
	    _classCallCheck(this, Textarea);
	
	    return _possibleConstructorReturn(this, (Textarea.__proto__ || Object.getPrototypeOf(Textarea)).apply(this, arguments));
	  }
	
	  _createClass(Textarea, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _props = this.props;
	      var value = _props.value;
	      var error = _props.error;
	
	      if (value !== nextProps.value || error !== nextProps.error) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var title = _props2.title;
	      var placeholder = _props2.placeholder;
	      var required = _props2.required;
	      var value = _props2.value;
	      var handleChange = _props2.handleChange;
	      var error = _props2.error;
	      var handleBlur = _props2.handleBlur;
	      var name = _props2.name;
	
	
	      var inputTitle = title ? _react2.default.createElement(
	        'div',
	        { className: 'textAreaTitle' },
	        title,
	        required ? '*' : ''
	      ) : null;
	
	      return _react2.default.createElement(
	        Container,
	        { className: 'textAreaForm', tabIndex: '-1', onBlur: handleBlur },
	        inputTitle,
	        _react2.default.createElement('textarea', {
	          required: required,
	          placeholder: placeholder,
	          value: value,
	          onChange: handleChange,
	          name: name
	        }),
	        error && _react2.default.createElement(
	          'div',
	          { className: 'error' },
	          error
	        )
	      );
	    }
	  }]);
	
	  return Textarea;
	}(_react.Component);
	
	Textarea.propTypes = {
	  title: _react.PropTypes.string,
	  placeholder: _react.PropTypes.string,
	  required: _react.PropTypes.bool,
	  handleChange: _react.PropTypes.func.isRequired,
	  value: _react.PropTypes.string,
	  error: _react.PropTypes.string,
	  handleBlur: _react.PropTypes.func,
	  name: _react.PropTypes.string
	};
	
	Textarea.defaultProps = {
	  value: ''
	};
	
	exports.default = Textarea;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resendCode = exports.validateUserCode = exports.resendConfirmationEmail = exports.updatePassword = exports.requireAdminAuth = exports.requireAuth = exports.updateUser = exports.loggedUser = exports.registerUser = exports.validateAdminToken = exports.validateToken = exports.resetPassword = exports.loginAdmin = exports.loginUser = undefined;
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _jwtDecode = __webpack_require__(196);
	
	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);
	
	var _axios = __webpack_require__(86);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(88);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* globals FormData */
	var loginUser = exports.loginUser = function loginUser(_ref) {
	  var email = _ref.email;
	  var _ref$password = _ref.password;
	  var password = _ref$password === undefined ? null : _ref$password;
	  var _ref$linkedinId = _ref.linkedinId;
	  var linkedinId = _ref$linkedinId === undefined ? null : _ref$linkedinId;
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user/login', {
	    email: email,
	    password: password,
	    linkedinId: linkedinId
	  });
	};
	
	var loginAdmin = exports.loginAdmin = function loginAdmin(email, password) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/admin/login', {
	    email: email,
	    password: password
	  });
	};
	
	var resetPassword = exports.resetPassword = function resetPassword(email) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user/reset_password', {
	    email: email
	  });
	};
	
	var validateToken = exports.validateToken = function validateToken(token) {
	  if (!token) {
	    return false;
	  } else {
	    var decoded = (0, _jwtDecode2.default)(token);
	    return decoded.exp < new Date().getTime() && !decoded.isAdmin;
	  }
	};
	
	var validateAdminToken = exports.validateAdminToken = function validateAdminToken(token) {
	  if (!token) {
	    return false;
	  } else {
	    var decoded = (0, _jwtDecode2.default)(token);
	    return decoded.exp < new Date().getTime() && decoded.isAdmin;
	  }
	};
	
	var registerUser = exports.registerUser = function registerUser(user) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user', user);
	};
	
	var loggedUser = exports.loggedUser = function loggedUser() {
	  return _axios2.default.get(_config2.default.SERVER_URL + '/user/me');
	};
	
	var updateUser = exports.updateUser = function updateUser(user) {
	  var userData = _ramda2.default.clone(user);
	  delete user.picture;
	  delete user.preferences;
	  if (userData.picture && userData.picture.file) {
	    var formData = new FormData();
	    formData.append('id', userData.id);
	    formData.append('file', userData.picture.file);
	    return _axios2.default.post(_config2.default.SERVER_URL + '/user/' + userData.id + '/picture', formData, {
	      headers: { 'content-type': 'multipart/form-data' }
	    }).then(function (response) {
	      return _axios2.default.put(_config2.default.SERVER_URL + '/user/' + user.id, user);
	    }).catch(function (error) {
	      return console.log(error);
	    });
	  } else {
	    return _axios2.default.put(_config2.default.SERVER_URL + '/user/' + user.id, user);
	  }
	};
	
	var requireAuth = exports.requireAuth = function requireAuth(nextState, replace) {
	  var token = window.localStorage.getItem('hvbToken');
	  if (!validateToken(token)) {
	    replace({
	      pathname: '/landing',
	      state: { nextPathname: nextState.location.pathname }
	    });
	  } else {
	    var decoded = (0, _jwtDecode2.default)(token);
	    if (!decoded.user.nda) {
	      window.location = '/landing/signup/ncnda?state=pending';
	    }
	  }
	};
	
	var requireAdminAuth = exports.requireAdminAuth = function requireAdminAuth(nextState, replace) {
	  if (!validateAdminToken(window.localStorage.getItem('hvbToken'))) {
	    replace({
	      pathname: '/admin-login',
	      state: { nextPathname: nextState.location.pathname }
	    });
	  }
	};
	
	var updatePassword = exports.updatePassword = function updatePassword(currentPassword, newPassword) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user/change_password', {
	    currentPassword: currentPassword,
	    newPassword: newPassword
	  });
	};
	
	var resendConfirmationEmail = exports.resendConfirmationEmail = function resendConfirmationEmail(id) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user/resend_activation', { id: id });
	};
	
	var validateUserCode = exports.validateUserCode = function validateUserCode(id, code) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user/validate_code', { id: id, code: code });
	};
	
	var resendCode = exports.resendCode = function resendCode(id) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user/resend_code', { id: id });
	};

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generateCommissionAgreement = exports.generateSalesMandate = exports.generateNCNDAWebsiteAgreement = exports.generateCollaborationAgreement = exports.generateAmbassadorAgreement = exports.generateWebNda = exports.generateLetterOfIntent = undefined;
	
	var _axios = __webpack_require__(86);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(88);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var generateLetterOfIntent = exports.generateLetterOfIntent = function generateLetterOfIntent() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/contracts/letter_of_intent', {
	    options: options
	  });
	};
	
	var generateWebNda = exports.generateWebNda = function generateWebNda() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/contracts/web_nda', {
	    options: options
	  });
	};
	
	var generateAmbassadorAgreement = exports.generateAmbassadorAgreement = function generateAmbassadorAgreement() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/contracts/ambassador_agreement', {
	    options: options
	  });
	};
	
	var generateCollaborationAgreement = exports.generateCollaborationAgreement = function generateCollaborationAgreement() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/contracts/collaboration_agreement', {
	    options: options
	  });
	};
	
	var generateNCNDAWebsiteAgreement = exports.generateNCNDAWebsiteAgreement = function generateNCNDAWebsiteAgreement() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/contracts/ncnda_website_agreement', {
	    options: options
	  });
	};
	
	var generateSalesMandate = exports.generateSalesMandate = function generateSalesMandate() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/contracts/sales_mandate_agreement', {
	    options: options
	  });
	};
	
	var generateCommissionAgreement = exports.generateCommissionAgreement = function generateCommissionAgreement() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/contracts/commission_agreement', {
	    options: options
	  });
	};

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackArrow = function BackArrow(props) {
	  return _react2.default.createElement(
	    'svg',
	    Object.assign({
	      width: '20',
	      height: '14',
	      viewBox: '0 0 20 14',
	      xmlns: 'http://www.w3.org/2000/svg',
	      xmlnsXlink: 'http://www.w3.org/1999/xlink'
	    }, props),
	    _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement('path', {
	        d: 'M5.104 12.875H21.09c.502 0 .909-.392.909-.875s-.407-.875-.91-.875H5.105l4.812-4.631a.852.852 0 0 0 0-1.238.934.934 0 0 0-1.286 0l-6.364 6.125a.852.852 0 0 0 0 1.238l6.364 6.125a.934.934 0 0 0 1.286 0 .852.852 0 0 0 0-1.238l-4.812-4.631z',
	        id: 'backArrowA'
	      })
	    ),
	    _react2.default.createElement(
	      'g',
	      { transform: 'translate(-2 -5)', fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { d: 'M0 0h24v24H0z' }),
	      _react2.default.createElement(
	        'mask',
	        { id: 'backArrowB', fill: '#fff' },
	        _react2.default.createElement('use', { xlinkHref: '#backArrowA' })
	      ),
	      _react2.default.createElement('path', { d: 'M0 0h100v40H0z', mask: 'url(#backArrowB)', fill: '#2D3030' })
	    )
	  );
	};
	
	exports.default = BackArrow;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 79 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isMutableObject = isMutableObject;
	exports.eachObject = eachObject;
	exports.assign = assign;
	var isFunction = exports.isFunction = function isFunction(x) {
	  return typeof x === 'function';
	};
	
	function isMutableObject(target) {
	  var Ctor = target.constructor;
	
	  return !!target && Object.prototype.toString.call(target) === '[object Object]' && isFunction(Ctor) && !Object.isFrozen(target) && (Ctor instanceof Ctor || target.type === 'AltStore');
	}
	
	function eachObject(f, o) {
	  o.forEach(function (from) {
	    Object.keys(Object(from)).forEach(function (key) {
	      f(key, from[key]);
	    });
	  });
	}
	
	function assign(target) {
	  for (var _len = arguments.length, source = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    source[_key - 1] = arguments[_key];
	  }
	
	  eachObject(function (key, value) {
	    return target[key] = value;
	  }, source);
	  return target;
	}

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = __webpack_require__(628)();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var _indexOf = __webpack_require__(431);
	
	
	module.exports = function _contains(a, list) {
	  return _indexOf(list, a, 0) >= 0;
	};


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(110);
	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Returns the elements of the given list or string (or object with a `slice`
	 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
	 *
	 * Dispatches to the `slice` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @sig Number -> Number -> String -> String
	 * @param {Number} fromIndex The start index (inclusive).
	 * @param {Number} toIndex The end index (exclusive).
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
	 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
	 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
	 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
	 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
	 */
	module.exports = _curry3(_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
	  return Array.prototype.slice.call(list, fromIndex, toIndex);
	}));


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var filter = function filter(object) {
	  return Object.keys(object).reduce(function (acc, prop) {
	    var value = object[prop];
	
	    if (value !== undefined) {
	      acc[prop] = value;
	    }
	
	    return acc;
	  }, {});
	};
	
	exports.default = function (target) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return _objectAssign2.default.apply(undefined, [target].concat(_toConsumableArray(args.map(filter))));
	};

/***/ },
/* 84 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (className) {
	
	  return function (element, modifier) {
	    var el = element ? '-' + element : '';
	    var mod = modifier ? '--' + modifier : '';
	
	    return '' + className + el + mod;
	  };
	};

/***/ },
/* 85 */
[1180, 14, 12],
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(557);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (process.browser) {
	  var token = window.localStorage.getItem('hvbToken');
	  if (token) {
	    _axios2.default.defaults.headers['Authorization'] = 'BEARER ' + token;
	  }
	}
	
	exports.default = _axios2.default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  height: ', 'px;\n  width: ', 'px;\n'], ['\n  position: relative;\n  height: ', 'px;\n  width: ', 'px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  height: ', 'px;\n  width: ', 'px;\n  border: ', ';\n  border-radius: 50%;\n  background: url(\'', '\') no-repeat center;\n  background-size: cover;\n'], ['\n  position: absolute;\n  height: ', 'px;\n  width: ', 'px;\n  border: ', ';\n  border-radius: 50%;\n  background: url(\'', '\') no-repeat center;\n  background-size: cover;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _EditPictureButton = __webpack_require__(1038);
	
	var _EditPictureButton2 = _interopRequireDefault(_EditPictureButton);
	
	var _UploadPicture = __webpack_require__(128);
	
	var _UploadPicture2 = _interopRequireDefault(_UploadPicture);
	
	var _Themes = __webpack_require__(5);
	
	var _default_user = __webpack_require__(1123);
	
	var _default_user2 = _interopRequireDefault(_default_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var AvatarContainer = _styledComponents2.default.div(_templateObject, function (props) {
	  return parseInt(props.size, 10) || 38;
	}, function (props) {
	  return parseInt(props.size, 10) || 38;
	});
	
	var Picture = _styledComponents2.default.div(_templateObject2, function (props) {
	  return parseInt(props.size, 10) || 38;
	}, function (props) {
	  return parseInt(props.size, 10) || 38;
	}, function (props) {
	  return props.withBorder ? 'solid 1px ' + _Themes.Colors.black : 'none';
	}, function (props) {
	  return props.imageSrc;
	});
	
	var Avatar = function (_Component) {
	  _inherits(Avatar, _Component);
	
	  function Avatar() {
	    _classCallCheck(this, Avatar);
	
	    return _possibleConstructorReturn(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).apply(this, arguments));
	  }
	
	  _createClass(Avatar, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var imageSrc = this.props.imageSrc;
	
	      if (nextProps.error || nextProps.imageSrc !== imageSrc) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var onEdit = _props.onEdit;
	      var size = _props.size;
	      var handleError = _props.handleError;
	      var error = _props.error;
	      var imageSrc = _props.imageSrc;
	      var withBorder = _props.withBorder;
	      var buttonClass = _props.buttonClass;
	
	      return onEdit ? _react2.default.createElement(
	        _UploadPicture2.default,
	        {
	          uploadButton: _react2.default.createElement(_EditPictureButton2.default, { className: buttonClass, pictureSize: size }),
	          handleUploaded: onEdit,
	          handleError: handleError,
	          error: error },
	        _react2.default.createElement(
	          AvatarContainer,
	          this.props,
	          _react2.default.createElement(Picture, {
	            size: size,
	            imageSrc: imageSrc || _default_user2.default,
	            widthBorder: withBorder,
	            className: 'picture'
	          })
	        )
	      ) : _react2.default.createElement(
	        AvatarContainer,
	        this.props,
	        _react2.default.createElement(Picture, {
	          size: size,
	          imageSrc: imageSrc || _default_user2.default,
	          widthBorder: withBorder,
	          className: 'picture'
	        })
	      );
	    }
	  }]);
	
	  return Avatar;
	}(_react.Component);
	
	Avatar.propTypes = {
	  imageSrc: _react.PropTypes.string,
	  size: _react.PropTypes.number,
	  withBorder: _react.PropTypes.bool,
	  onEdit: _react.PropTypes.func,
	  handleError: _react.PropTypes.func,
	  error: _react.PropTypes.string,
	  buttonClass: _react.PropTypes.string
	};
	
	exports.default = Avatar;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var API_URL = ("https://api.hvb-investments.com") || 'https://localhost:1337';
	
	var config = {
	  Oauth2: {
	    clientId: '77s1wlmrmf0zi5',
	    authCalbackURI: API_URL + '/user/linkedin_authenticate',
	    state: 'SHZiQXBw',
	    scope: ['r_fullprofile', 'r_emailaddress']
	  },
	  SERVER_URL: API_URL,
	  DEMO_EMAIL: 'test@hvb.ch'
	};
	
	exports.default = config;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Trash = function Trash(props) {
	  return _react2.default.createElement(
	    'svg',
	    Object.assign({
	      width: '22',
	      height: '24',
	      xmlns: 'http://www.w3.org/2000/svg',
	      xmlnsXlink: 'http://www.w3.org/1999/xlink'
	    }, props),
	    _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement('path', {
	        d: 'M17.833 20.487H6.167V7.296H4.5v13.947c0 .418.373.757.833.757h13.334c.46 0 .833-.339.833-.757V7.296h-1.667v13.191zm3.334-13.191c.46 0 .833-.34.833-.757 0-.418-.373-.756-.833-.756H2.833c-.46 0-.833.338-.833.756s.373.757.833.757h18.334zm-10 9.273c0 .492.373.892.833.892.46 0 .833-.4.833-.892v-5.355c0-.493-.373-.892-.833-.892-.46 0-.833.4-.833.892v5.355zm-3.334 0c0 .492.373.892.834.892.46 0 .833-.4.833-.892v-5.355c0-.493-.373-.892-.833-.892-.46 0-.834.4-.834.892v5.355zm6.667 0c0 .492.373.892.833.892.46 0 .834-.4.834-.892v-5.355c0-.493-.373-.892-.834-.892-.46 0-.833.4-.833.892v5.355zm-5-13.056h5v2.27h1.667V2.757c0-.418-.373-.757-.834-.757H8.667c-.46 0-.834.339-.834.757v3.026H9.5v-2.27z',
	        id: 'Trasha'
	      })
	    ),
	    _react2.default.createElement(
	      'g',
	      { transform: 'translate(-2 -2)', fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { d: 'M0 0h24v24H0z' }),
	      _react2.default.createElement(
	        'mask',
	        { id: 'Trashb', fill: '#fff' },
	        _react2.default.createElement('use', { xlinkHref: '#Trasha' })
	      ),
	      _react2.default.createElement('path', { d: 'M0 0h100v40H0z', mask: 'url(#Trashb)', fill: '#2D3030' })
	    )
	  );
	};
	
	exports.default = Trash;

/***/ },
/* 90 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(272)('wks');
	var uid = __webpack_require__(274);
	var Symbol = __webpack_require__(90).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 92 */
/***/ function(module, exports) {

	var isES5 = (function(){
	    "use strict";
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(69);
	
	var _Actions = __webpack_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	
	
	/**
	 * Returns a function that always returns the given value. Note that for
	 * non-primitives the value returned is a reference to the original value.
	 *
	 * This function is known as `const`, `constant`, or `K` (for K combinator) in
	 * other languages and libraries.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> (* -> a)
	 * @param {*} val The value to wrap in a function
	 * @return {Function} A Function :: * -> val.
	 * @example
	 *
	 *      var t = R.always('Tee');
	 *      t(); //=> 'Tee'
	 */
	module.exports = _curry1(function always(val) {
	  return function() {
	    return val;
	  };
	});


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns the larger of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.maxBy, R.min
	 * @example
	 *
	 *      R.max(789, 123); //=> 789
	 *      R.max('a', 'b'); //=> 'b'
	 */
	module.exports = _curry2(function max(a, b) { return b > a ? b : a; });


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(221);
	var setInnerHTML = __webpack_require__(167);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(229);
	var setTextContent = __webpack_require__(497);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(12);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(952);
	var ReactInstrumentation = __webpack_require__(51);
	
	var warning = __webpack_require__(19);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Arrow = function Arrow(props) {
	  return _react2.default.createElement(
	    'svg',
	    Object.assign({ width: '24', height: '24', viewBox: '0 0 24 24' }, props),
	    _react2.default.createElement('path', { id: 'a', d: 'M15.498 15L17 13.614 12 9l-5 4.614L8.502 15 12 11.772z' })
	  );
	};
	
	exports.default = Arrow;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var ReactBaseClasses = __webpack_require__(527);
	var ReactChildren = __webpack_require__(1141);
	var ReactDOMFactories = __webpack_require__(1142);
	var ReactElement = __webpack_require__(103);
	var ReactPropTypes = __webpack_require__(1143);
	var ReactVersion = __webpack_require__(1144);
	
	var createReactClass = __webpack_require__(1145);
	var onlyChild = __webpack_require__(1149);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var ReactCurrentOwner = __webpack_require__(66);
	
	var warning = __webpack_require__(177);
	var canDefineProperty = __webpack_require__(531);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(529);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 104 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.5.1' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(186)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(138);
	var createDesc = __webpack_require__(270);
	module.exports = __webpack_require__(105) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 107 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventEmitter = function () {
		function EventEmitter() {
			_classCallCheck(this, EventEmitter);
	
			this.observers = {};
		}
	
		EventEmitter.prototype.on = function on(events, listener) {
			var _this = this;
	
			events.split(' ').forEach(function (event) {
				_this.observers[event] = _this.observers[event] || [];
				_this.observers[event].push(listener);
			});
		};
	
		EventEmitter.prototype.off = function off(event, listener) {
			var _this2 = this;
	
			if (!this.observers[event]) {
				return;
			}
	
			this.observers[event].forEach(function () {
				if (!listener) {
					delete _this2.observers[event];
				} else {
					var index = _this2.observers[event].indexOf(listener);
					if (index > -1) {
						_this2.observers[event].splice(index, 1);
					}
				}
			});
		};
	
		EventEmitter.prototype.emit = function emit(event) {
			for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
				args[_key - 1] = arguments[_key];
			}
	
			if (this.observers[event]) {
				var cloned = [].concat(this.observers[event]);
				cloned.forEach(function (observer) {
					observer.apply(undefined, args);
				});
			}
	
			if (this.observers['*']) {
				var _cloned = [].concat(this.observers['*']);
				_cloned.forEach(function (observer) {
					var _ref;
	
					observer.apply(observer, (_ref = [event]).concat.apply(_ref, args));
				});
			}
		};
	
		return EventEmitter;
	}();
	
	exports.default = EventEmitter;

/***/ },
/* 108 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeString = makeString;
	exports.copy = copy;
	exports.setPath = setPath;
	exports.pushPath = pushPath;
	exports.getPath = getPath;
	exports.deepExtend = deepExtend;
	exports.regexEscape = regexEscape;
	exports.escape = escape;
	function makeString(object) {
	  if (object == null) return '';
	  return '' + object;
	}
	
	function copy(a, s, t) {
	  a.forEach(function (m) {
	    if (s[m]) t[m] = s[m];
	  });
	}
	
	function getLastOfPath(object, path, Empty) {
	  function cleanKey(key) {
	    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
	  }
	
	  function canNotTraverseDeeper() {
	    return !object || typeof object === 'string';
	  }
	
	  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
	  while (stack.length > 1) {
	    if (canNotTraverseDeeper()) return {};
	
	    var key = cleanKey(stack.shift());
	    if (!object[key] && Empty) object[key] = new Empty();
	    object = object[key];
	  }
	
	  if (canNotTraverseDeeper()) return {};
	  return {
	    obj: object,
	    k: cleanKey(stack.shift())
	  };
	}
	
	function setPath(object, path, newValue) {
	  var _getLastOfPath = getLastOfPath(object, path, Object),
	      obj = _getLastOfPath.obj,
	      k = _getLastOfPath.k;
	
	  obj[k] = newValue;
	}
	
	function pushPath(object, path, newValue, concat) {
	  var _getLastOfPath2 = getLastOfPath(object, path, Object),
	      obj = _getLastOfPath2.obj,
	      k = _getLastOfPath2.k;
	
	  obj[k] = obj[k] || [];
	  if (concat) obj[k] = obj[k].concat(newValue);
	  if (!concat) obj[k].push(newValue);
	}
	
	function getPath(object, path) {
	  var _getLastOfPath3 = getLastOfPath(object, path),
	      obj = _getLastOfPath3.obj,
	      k = _getLastOfPath3.k;
	
	  if (!obj) return undefined;
	  return obj[k];
	}
	
	function deepExtend(target, source, overwrite) {
	  for (var prop in source) {
	    if (prop in target) {
	      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
	      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
	        if (overwrite) target[prop] = source[prop];
	      } else {
	        deepExtend(target[prop], source[prop], overwrite);
	      }
	    } else {
	      target[prop] = source[prop];
	    }
	  }return target;
	}
	
	function regexEscape(str) {
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	}
	
	/* eslint-disable */
	var _entityMap = {
	  "&": "&amp;",
	  "<": "&lt;",
	  ">": "&gt;",
	  '"': '&quot;',
	  "'": '&#39;',
	  "/": '&#x2F;'
	};
	/* eslint-enable */
	
	function escape(data) {
	  if (typeof data === 'string') {
	    return data.replace(/[&<>"'\/]/g, function (s) {
	      return _entityMap[s];
	    });
	  } else {
	    return data;
	  }
	}

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.VALID_PUNCTUATION = exports.VALID_DIGITS = exports.PLUS_CHARS = undefined;
	
	var _getIterator2 = __webpack_require__(183);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _extends2 = __webpack_require__(579);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = parse;
	exports.normalize = normalize;
	exports.replace_characters = replace_characters;
	exports.is_viable_phone_number = is_viable_phone_number;
	exports.extract_formatted_phone_number = extract_formatted_phone_number;
	exports.parse_phone_number = parse_phone_number;
	exports.parse_phone_number_and_country_phone_code = parse_phone_number_and_country_phone_code;
	exports.strip_national_prefix = strip_national_prefix;
	exports.find_country_code = find_country_code;
	exports.get_number_type = get_number_type;
	exports.is_of_type = is_of_type;
	exports.is_national_prefix_required = is_national_prefix_required;
	
	var _common = __webpack_require__(197);
	
	var _metadata = __webpack_require__(142);
	
	var _format = __webpack_require__(198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PLUS_CHARS = exports.PLUS_CHARS = '+\uFF0B';
	
	// Digits accepted in phone numbers
	// (ascii, fullwidth, arabic-indic, and eastern arabic digits).
	// This is a port of Google Android `libphonenumber`'s
	// `phonenumberutil.js` of 17th November, 2016.
	//
	// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
	
	var VALID_DIGITS = exports.VALID_DIGITS = '0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9';
	
	// `DASHES` will be right after the opening square bracket of the "character class"
	var DASHES = '-\u2010-\u2015\u2212\u30FC\uFF0D';
	var SLASHES = '\uFF0F/';
	var DOTS = '\uFF0E.';
	var WHITESPACE = ' \xA0\xAD\u200B\u2060\u3000';
	var BRACKETS = '()\uFF08\uFF09\uFF3B\uFF3D\\[\\]';
	var TILDES = '~\u2053\u223C\uFF5E';
	
	// Regular expression of acceptable punctuation found in phone numbers. This
	// excludes punctuation found as a leading character only. This consists of dash
	// characters, white space characters, full stops, slashes, square brackets,
	// parentheses and tildes. Full-width variants are also present.
	var VALID_PUNCTUATION = exports.VALID_PUNCTUATION = '' + DASHES + SLASHES + DOTS + WHITESPACE + BRACKETS + TILDES;
	
	//  Regular expression of viable phone numbers. This is location independent.
	//  Checks we have at least three leading digits, and only valid punctuation,
	//  alpha characters and digits in the phone number. Does not include extension
	//  data. The symbol 'x' is allowed here as valid punctuation since it is often
	//  used as a placeholder for carrier codes, for example in Brazilian phone
	//  numbers. We also allow multiple '+' characters at the start.
	//
	//  Corresponds to the following:
	//  [digits]{minLengthNsn}|
	//  plus_sign*
	//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
	//
	//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
	//  they are entered as "15" etc, but only if there is no punctuation in them.
	//  The second expression restricts the number of digits to three or more, but
	//  then allows them to be in international form, and to have alpha-characters
	//  and punctuation. We split up the two reg-exes here and combine them when
	//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
	//  with ^ and append $ to each branch.
	//
	//  Note VALID_PUNCTUATION starts with a -, so must be the first in the range.
	//  (wtf did they mean by saying that; probably nothing)
	//
	var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}';
	//
	// And this is the second reg-exp:
	// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
	//
	var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*';
	
	// The combined regular expression for valid phone numbers:
	//
	var VALID_PHONE_NUMBER_PATTERN = new RegExp(
	// Either a short two-digit-only phone number
	'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' +
	// Or a longer fully parsed phone number (min 3 characters)
	'^' + VALID_PHONE_NUMBER +
	// screw phone number extensions
	// '(?:' + EXTN_PATTERNS_FOR_PARSING + ')?' +
	'$', 'i');
	
	// This consists of the plus symbol, digits, and arabic-indic digits.
	var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']');
	
	// Regular expression of trailing characters that we want to remove.
	var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + ']+$');
	
	var LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+');
	
	// These mappings map a character (key) to a specific digit that should
	// replace it for normalization purposes. Non-European digits that
	// may be used in phone numbers are mapped to a European equivalent.
	var DIGIT_MAPPINGS = {
		'0': '0',
		'1': '1',
		'2': '2',
		'3': '3',
		'4': '4',
		'5': '5',
		'6': '6',
		'7': '7',
		'8': '8',
		'9': '9',
		'\uFF10': '0', // Fullwidth digit 0
		'\uFF11': '1', // Fullwidth digit 1
		'\uFF12': '2', // Fullwidth digit 2
		'\uFF13': '3', // Fullwidth digit 3
		'\uFF14': '4', // Fullwidth digit 4
		'\uFF15': '5', // Fullwidth digit 5
		'\uFF16': '6', // Fullwidth digit 6
		'\uFF17': '7', // Fullwidth digit 7
		'\uFF18': '8', // Fullwidth digit 8
		'\uFF19': '9', // Fullwidth digit 9
		'\u0660': '0', // Arabic-indic digit 0
		'\u0661': '1', // Arabic-indic digit 1
		'\u0662': '2', // Arabic-indic digit 2
		'\u0663': '3', // Arabic-indic digit 3
		'\u0664': '4', // Arabic-indic digit 4
		'\u0665': '5', // Arabic-indic digit 5
		'\u0666': '6', // Arabic-indic digit 6
		'\u0667': '7', // Arabic-indic digit 7
		'\u0668': '8', // Arabic-indic digit 8
		'\u0669': '9', // Arabic-indic digit 9
		'\u06F0': '0', // Eastern-Arabic digit 0
		'\u06F1': '1', // Eastern-Arabic digit 1
		'\u06F2': '2', // Eastern-Arabic digit 2
		'\u06F3': '3', // Eastern-Arabic digit 3
		'\u06F4': '4', // Eastern-Arabic digit 4
		'\u06F5': '5', // Eastern-Arabic digit 5
		'\u06F6': '6', // Eastern-Arabic digit 6
		'\u06F7': '7', // Eastern-Arabic digit 7
		'\u06F8': '8', // Eastern-Arabic digit 8
		'\u06F9': '9' // Eastern-Arabic digit 9
	};
	
	// The maximum length of the country calling code.
	var MAX_LENGTH_COUNTRY_CODE = 3;
	
	// The minimum length of the national significant number.
	var MIN_LENGTH_FOR_NSN = 2;
	
	// The ITU says the maximum length should be 15,
	// but one can find longer numbers in Germany.
	var MAX_LENGTH_FOR_NSN = 17;
	
	// We don't allow input strings for parsing to be longer than 250 chars.
	// This prevents malicious input from consuming CPU.
	var MAX_INPUT_STRING_LENGTH = 250;
	
	var default_options = {
		country: {}
	};
	
	// `options`:
	//  {
	//    country:
	//    {
	//      restrict - (a two-letter country code)
	//                 the phone number must be in this country
	//
	//      default - (a two-letter country code)
	//                default country to use for phone number parsing and validation
	//                (if no country code could be derived from the phone number)
	//    }
	//  }
	//
	// Returns `{ country, number }`
	//
	// Example use cases:
	//
	// ```js
	// parse('8 (800) 555-35-35', 'RU')
	// parse('8 (800) 555-35-35', 'RU', metadata)
	// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
	// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
	// parse('+7 800 555 35 35')
	// parse('+7 800 555 35 35', metadata)
	// ```
	//
	function parse(first_argument, second_argument, third_argument) {
		var _sort_out_arguments = sort_out_arguments(first_argument, second_argument, third_argument),
		    text = _sort_out_arguments.text,
		    options = _sort_out_arguments.options,
		    metadata = _sort_out_arguments.metadata;
	
		if (!options) {
			options = (0, _extends3.default)({}, default_options);
		}
	
		// Validate country codes
	
		// Validate `default` country
		if (options.country.default && !metadata.countries[options.country.default]) {
			throw new Error('Unknown country code: ' + options.country.default);
		}
	
		// Validate `restrict` country
		if (options.country.restrict && !metadata.countries[options.country.restrict]) {
			throw new Error('Unknown country code: ' + options.country.restrict);
		}
	
		// Parse the phone number
	
		var formatted_phone_number = extract_formatted_phone_number(text);
	
		// If the phone number is not viable, then abort.
		if (!is_viable_phone_number(formatted_phone_number)) {
			return {};
		}
	
		var _parse_phone_number_a = parse_phone_number_and_country_phone_code(formatted_phone_number, metadata),
		    country_phone_code = _parse_phone_number_a.country_phone_code,
		    number = _parse_phone_number_a.number;
	
		// Maybe invalid country phone code encountered
	
	
		if (!country_phone_code && !number) {
			return {};
		}
	
		var country = void 0;
		var country_metadata = void 0;
	
		// Whether the phone number is formatted as an international phone number
		var is_international = false;
	
		if (country_phone_code) {
			is_international = true;
	
			// Check country restriction
			if (options.country.restrict && country_phone_code !== (0, _metadata.get_phone_code)(metadata.countries[options.country.restrict])) {
				return {};
			}
	
			// Formatting information for regions which share
			// a country calling code is contained by only one region
			// for performance reasons. For example, for NANPA region
			// ("North American Numbering Plan Administration",
			//  which includes USA, Canada, Cayman Islands, Bahamas, etc)
			// it will be contained in the metadata for `US`.
			country_metadata = (0, _metadata.get_metadata_by_country_phone_code)(country_phone_code, metadata);
	
			// `country` will be set later,
			// because, for example, for NANPA countries
			// there are several countries corresponding
			// to the same `1` country phone code.
			// Therefore, to reliably determine the exact country,
			// national (significant) number should be parsed first.
		} else if (options.country.restrict || options.country.default) {
			country = options.country.restrict || options.country.default;
			country_metadata = metadata.countries[country];
	
			number = normalize(text);
		}
	
		if (!country_metadata) {
			return {};
		}
	
		var national_number = strip_national_prefix(number, country_metadata);
	
		var did_have_national_prefix = national_number !== number;
	
		if (!is_international && !did_have_national_prefix && is_national_prefix_required(national_number, country_metadata)) {
			return {};
		}
	
		// Sometimes there are several countries
		// corresponding to the same country phone code
		// (e.g. NANPA countries all having `1` country phone code).
		// Therefore, to reliably determine the exact country,
		// national (significant) number should have been parsed first.
		//
		if (!country) {
			// When `metadata.json` is generated, all "ambiguous" country phone codes
			// get their countries populated with the full set of
			// "phone number type" regular expressions.
			country = find_country_code(country_phone_code, national_number, metadata);
	
			// Just in case there appears to be a bug in Google's metadata
			// and the exact country could not be extracted from the phone number.
			/* istanbul ignore if */
			if (!country) {
				return {};
			}
	
			// Update metadata to be for this specific country
			country_metadata = metadata.countries[country];
		}
	
		// Validate national (significant) number length.
		//
		// A sidenote:
		//
		// They say that sometimes national (significant) numbers
		// can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
		// https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
		// Such numbers will just be discarded.
		//
		if (national_number.length > MAX_LENGTH_FOR_NSN) {
			return {};
		}
	
		// National number pattern is different for each country,
		// even for those ones which are part of the "NANPA" group.
		var national_number_rule = new RegExp((0, _metadata.get_national_number_pattern)(country_metadata));
	
		// Check if national phone number pattern matches the number
		if (!(0, _common.matches_entirely)(national_number, national_number_rule)) {
			return {};
		}
	
		return { country: country, phone: national_number };
	}
	
	// Normalizes a string of characters representing a phone number.
	// This converts wide-ascii and arabic-indic numerals to European numerals,
	// and strips punctuation and alpha characters.
	function normalize(number) {
		return replace_characters(number, DIGIT_MAPPINGS);
	}
	
	// For any character not being part of `replacements`
	// it is removed from the phone number.
	function replace_characters(text, replacements) {
		var replaced = '';
	
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;
	
		try {
			for (var _iterator = (0, _getIterator3.default)(text), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var character = _step.value;
	
				var replacement = replacements[character.toUpperCase()];
	
				if (replacement !== undefined) {
					replaced += replacement;
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	
		return replaced;
	}
	
	// Checks to see if the string of characters could possibly be a phone number at
	// all. At the moment, checks to see that the string begins with at least 2
	// digits, ignoring any punctuation commonly found in phone numbers. This method
	// does not require the number to be normalized in advance - but does assume
	// that leading non-number symbols have been removed, such as by the method
	// `extract_possible_number`.
	//
	function is_viable_phone_number(number) {
		return number.length >= MIN_LENGTH_FOR_NSN && (0, _common.matches_entirely)(number, VALID_PHONE_NUMBER_PATTERN);
	}
	
	function extract_formatted_phone_number(text) {
		if (!text || text.length > MAX_INPUT_STRING_LENGTH) {
			return '';
		}
	
		// Attempt to extract a possible number from the string passed in
	
		var starts_at = text.search(PHONE_NUMBER_START_PATTERN);
	
		if (starts_at < 0) {
			return '';
		}
	
		return text
		// Trim everything to the left of the phone number
		.slice(starts_at)
		// Remove trailing non-numerical characters
		.replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
	}
	
	// Parses a formatted phone number.
	function parse_phone_number(number) {
		if (!number) {
			return '';
		}
	
		var is_international = LEADING_PLUS_CHARS_PATTERN.test(number);
	
		// Remove non-digits
		// (and strip the possible leading '+')
		number = normalize(number);
	
		if (is_international) {
			return '+' + number;
		}
	
		return number;
	}
	
	// Parses a formatted phone number
	// and returns `{ country_phone_code, number }`
	// where `number` is the national (significant) phone number.
	//
	// (aka `maybeExtractCountryPhoneCode`)
	//
	function parse_phone_number_and_country_phone_code(number, metadata) {
		number = parse_phone_number(number);
	
		if (!number) {
			return {};
		}
	
		// If this is not an international phone number,
		// then don't extract country phone code.
		if (number[0] !== '+') {
			return { number: number };
		}
	
		// Strip the leading '+' sign
		number = number.slice(1);
	
		// Fast abortion: country codes do not begin with a '0'
		if (number[0] === '0') {
			return {};
		}
	
		// The thing with country phone codes
		// is that they are orthogonal to each other
		// i.e. there's no such country phone code A
		// for which country phone code B exists
		// where B starts with A.
		// Therefore, while scanning digits,
		// if a valid country code is found,
		// that means that it is the country code.
		//
		var i = 1;
		while (i <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
			var country_phone_code = number.slice(0, i);
	
			if (metadata.country_phone_code_to_countries[country_phone_code]) {
				return { country_phone_code: country_phone_code, number: number.slice(i) };
			}
	
			i++;
		}
	
		return {};
	}
	
	// Strips any national prefix (such as 0, 1) present in the number provided
	function strip_national_prefix(number, country_metadata) {
		var national_prefix_for_parsing = (0, _metadata.get_national_prefix_for_parsing)(country_metadata);
	
		if (!number || !national_prefix_for_parsing) {
			return number;
		}
	
		// Attempt to parse the first digits as a national prefix
		var national_prefix_pattern = new RegExp('^(?:' + national_prefix_for_parsing + ')');
		var national_prefix_matcher = national_prefix_pattern.exec(number);
	
		// If no national prefix is present in the phone number,
		// but if the national prefix is optional for this country,
		// then consider this phone number valid.
		//
		// Google's reference `libphonenumber` implementation
		// wouldn't recognize such phone numbers as valid,
		// but I think it would perfectly make sense
		// to consider such phone numbers as valid
		// because if a national phone number was originally
		// formatted without the national prefix
		// then it must be parseable back into the original national number.
		// In other words, `parse(format(number))`
		// must always be equal to `number`.
		//
		if (!national_prefix_matcher) {
			return number;
		}
	
		var national_prefix_transform_rule = (0, _metadata.get_national_prefix_transform_rule)(country_metadata);
	
		var national_significant_number = void 0;
	
		// `national_prefix_for_parsing` capturing groups
		// (used only for really messy cases: Argentina, Brazil, Mexico, Somalia)
		var any_groups_were_captured = national_prefix_matcher[national_prefix_matcher.length - 1];
	
		// If the national number tranformation is needed then do it
		if (national_prefix_transform_rule && any_groups_were_captured) {
			national_significant_number = number.replace(national_prefix_pattern, national_prefix_transform_rule);
		}
		// Else, no transformation is necessary,
		// and just strip the national prefix.
		else {
				national_significant_number = number.slice(national_prefix_matcher[0].length);
			}
	
		// Verify the parsed national (significant) number for this country
		var national_number_rule = new RegExp((0, _metadata.get_national_number_pattern)(country_metadata));
	
		// If the original number was viable, and the resultant number is not,
		// then prefer the original phone number.
		if ((0, _common.matches_entirely)(number, national_number_rule) && !(0, _common.matches_entirely)(national_significant_number, national_number_rule)) {
			return number;
		}
	
		// Return the parsed national (significant) number
		return national_significant_number;
	}
	
	function find_country_code(country_phone_code, national_phone_number, metadata) {
		// Is always non-empty, because `country_phone_code` is always valid
		var possible_countries = metadata.country_phone_code_to_countries[country_phone_code];
	
		// If there's just one country corresponding to the country code,
		// then just return it, without further phone number digits validation.
		if (possible_countries.length === 1) {
			return possible_countries[0];
		}
	
		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;
	
		try {
			for (var _iterator2 = (0, _getIterator3.default)(possible_countries), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var country_code = _step2.value;
	
				var country = metadata.countries[country_code];
	
				// Leading digits check would be the simplest one
				if ((0, _metadata.get_leading_digits)(country)) {
					if (national_phone_number && national_phone_number.search((0, _metadata.get_leading_digits)(country)) === 0) {
						return country_code;
					}
				}
				// Else perform full validation with all of those bulky
				// fixed-line/mobile/etc regular expressions.
				else if (get_number_type(national_phone_number, country_code, metadata)) {
						return country_code;
					}
			}
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2.return) {
					_iterator2.return();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}
	}
	
	// Finds out national phone number type (fixed line, mobile, etc)
	function get_number_type(national_number, country_code, metadata) {
		var country_metadata = metadata.countries[country_code];
	
		// Is this national number even valid for this country
		if (!is_of_type(national_number, (0, _metadata.get_national_number_pattern)(country_metadata))) {
			return;
		}
	
		if (is_of_type(national_number, (0, _metadata.get_type_mobile)(country_metadata))) {
			// Because duplicate regular expressions are removed
			// to reduce metadata size, if there's no "fixed line" pattern
			// then it means it was removed due to being a duplicate of some other pattern.
			//
			// Also, many times fixed line phone number regular expressions
			// are the same as mobile phone number regular expressions,
			// so in these cases there's no differentiation between them.
			//
			// (no such country in the metadata, therefore no unit test for this `if`)
			/* istanbul ignore if */
			if (!(0, _metadata.get_type_fixed_line)(country_metadata) || (0, _metadata.get_type_fixed_line)(country_metadata) === (0, _metadata.get_type_mobile)(country_metadata)) {
				return 'FIXED_LINE_OR_MOBILE';
			}
	
			return 'MOBILE';
		}
	
		// Is it fixed line number
		if (is_of_type(national_number, (0, _metadata.get_type_fixed_line)(country_metadata))) {
			// Because duplicate regular expressions are removed
			// to reduce metadata size, if there's no "mobile" pattern
			// then it means it was removed due to being a duplicate of some other pattern.
			//
			// Also, many times fixed line phone number regular expressions
			// are the same as mobile phone number regular expressions,
			// so in these cases there's no differentiation between them.
			//
			if (!(0, _metadata.get_type_mobile)(country_metadata) || (0, _metadata.get_type_mobile)(country_metadata) === (0, _metadata.get_type_fixed_line)(country_metadata)) {
				return 'FIXED_LINE_OR_MOBILE';
			}
	
			return 'FIXED_LINE';
		}
	
		if (is_of_type(national_number, (0, _metadata.get_type_toll_free)(country_metadata))) {
			return 'TOLL_FREE';
		}
	
		if (is_of_type(national_number, (0, _metadata.get_type_premium_rate)(country_metadata))) {
			return 'PREMIUM_RATE';
		}
	
		if (is_of_type(national_number, (0, _metadata.get_type_personal_number)(country_metadata))) {
			return 'PERSONAL_NUMBER';
		}
	
		/* istanbul ignore if */
		if (is_of_type(national_number, (0, _metadata.get_type_voice_mail)(country_metadata))) {
			return 'VOICEMAIL';
		}
	
		/* istanbul ignore if */
		if (is_of_type(national_number, (0, _metadata.get_type_uan)(country_metadata))) {
			return 'UAN';
		}
	
		/* istanbul ignore if */
		if (is_of_type(national_number, (0, _metadata.get_type_pager)(country_metadata))) {
			return 'PAGER';
		}
	
		/* istanbul ignore if */
		if (is_of_type(national_number, (0, _metadata.get_type_voip)(country_metadata))) {
			return 'VOIP';
		}
	
		/* istanbul ignore if */
		if (is_of_type(national_number, (0, _metadata.get_type_shared_cost)(country_metadata))) {
			return 'SHARED_COST';
		}
	}
	
	function is_of_type(national_number, type) {
		// // Check if any possible number lengths are present;
		// // if so, we use them to avoid checking
		// // the validation pattern if they don't match.
		// // If they are absent, this means they match
		// // the general description, which we have
		// // already checked before a specific number type.
		// if (get_possible_lengths(type) &&
		// 	get_possible_lengths(type).indexOf(national_number.length) === -1)
		// {
		// 	return false
		// }
	
		// get_type_pattern(type) === type
		return (0, _common.matches_entirely)(national_number, type);
	}
	
	function is_national_prefix_required(national_number, country_metadata) {
		var format = (0, _format.choose_format_for_number)((0, _metadata.get_formats)(country_metadata), national_number);
	
		if (format) {
			return (0, _metadata.get_format_national_prefix_is_mandatory_when_formatting)(format, country_metadata);
		}
	}
	
	// Sort out arguments
	function sort_out_arguments(first_argument, second_argument, third_argument) {
		var text = void 0;
		var options = void 0;
		var metadata = void 0;
	
		if (typeof first_argument === 'string') {
			text = first_argument;
		}
	
		// Covert `resrict` country to an `options` object
		if (typeof second_argument === 'string') {
			var restrict_to_country = second_argument;
	
			options = (0, _extends3.default)({}, default_options, {
	
				country: {
					restrict: restrict_to_country
				}
			});
	
			metadata = third_argument;
		} else {
			// Differentiate `metadata` from `options`
			if (second_argument && second_argument.countries) {
				metadata = second_argument;
			} else {
				options = second_argument;
				metadata = third_argument;
			}
		}
	
		// Sanity check
		if (!metadata) {
			throw new Error('Metadata not passed');
		}
	
		return { text: text, options: options, metadata: metadata };
	}
	//# sourceMappingURL=parse.js.map

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(71);
	
	
	/**
	 * This checks whether a function has a [methodname] function. If it isn't an
	 * array it will execute that function otherwise it will default to the ramda
	 * implementation.
	 *
	 * @private
	 * @param {Function} fn ramda implemtation
	 * @param {String} methodname property to check for a custom implementation
	 * @return {Object} Whatever the return value of the method is.
	 */
	module.exports = function _checkForMethod(methodname, fn) {
	  return function() {
	    var length = arguments.length;
	    if (length === 0) {
	      return fn();
	    }
	    var obj = arguments[length - 1];
	    return (_isArray(obj) || typeof obj[methodname] !== 'function') ?
	      fn.apply(this, arguments) :
	      obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
	  };
	};


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _isFunction = __webpack_require__(148);
	var curryN = __webpack_require__(35);
	var toString = __webpack_require__(116);
	
	
	/**
	 * Turns a named method with a specified arity into a function that can be
	 * called directly supplied with arguments and a target object.
	 *
	 * The returned function is curried and accepts `arity + 1` parameters where
	 * the final parameter is the target object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
	 * @param {Number} arity Number of arguments the returned function should take
	 *        before the target object.
	 * @param {String} method Name of the method to call.
	 * @return {Function} A new curried function.
	 * @example
	 *
	 *      var sliceFrom = R.invoker(1, 'slice');
	 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
	 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
	 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
	 * @symb R.invoker(0, 'method')(o) = o['method']()
	 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
	 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
	 */
	module.exports = _curry2(function invoker(arity, method) {
	  return curryN(arity + 1, function() {
	    var target = arguments[arity];
	    if (target != null && _isFunction(target[method])) {
	      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
	    }
	    throw new TypeError(toString(target) + ' does not have a method named "' + method + '"');
	  });
	});


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var _isArray = __webpack_require__(71);
	var _isString = __webpack_require__(150);
	
	
	/**
	 * Tests whether or not an object is similar to an array.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Type
	 * @category List
	 * @sig * -> Boolean
	 * @param {*} x The object to test.
	 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
	 * @deprecated since v0.23.0
	 * @example
	 *
	 *      R.isArrayLike([]); //=> true
	 *      R.isArrayLike(true); //=> false
	 *      R.isArrayLike({}); //=> false
	 *      R.isArrayLike({length: 10}); //=> false
	 *      R.isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
	 */
	module.exports = _curry1(function isArrayLike(x) {
	  if (_isArray(x)) { return true; }
	  if (!x) { return false; }
	  if (typeof x !== 'object') { return false; }
	  if (_isString(x)) { return false; }
	  if (x.nodeType === 1) { return !!x.length; }
	  if (x.length === 0) { return true; }
	  if (x.length > 0) {
	    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
	  }
	  return false;
	});


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _isString = __webpack_require__(150);
	
	
	/**
	 * Returns the nth element of the given list or string. If n is negative the
	 * element at index length + n is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> a | Undefined
	 * @sig Number -> String -> String
	 * @param {Number} offset
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      var list = ['foo', 'bar', 'baz', 'quux'];
	 *      R.nth(1, list); //=> 'bar'
	 *      R.nth(-1, list); //=> 'quux'
	 *      R.nth(-99, list); //=> undefined
	 *
	 *      R.nth(2, 'abc'); //=> 'c'
	 *      R.nth(3, 'abc'); //=> ''
	 * @symb R.nth(-1, [a, b, c]) = c
	 * @symb R.nth(0, [a, b, c]) = a
	 * @symb R.nth(1, [a, b, c]) = b
	 */
	module.exports = _curry2(function nth(offset, list) {
	  var idx = offset < 0 ? list.length + offset : offset;
	  return _isString(list) ? list.charAt(idx) : list[idx];
	});


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Retrieve the value at a given path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> {a} -> a | Undefined
	 * @param {Array} path The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path`.
	 * @see R.prop
	 * @example
	 *
	 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
	 */
	module.exports = _curry2(function path(paths, obj) {
	  var val = obj;
	  var idx = 0;
	  while (idx < paths.length) {
	    if (val == null) {
	      return;
	    }
	    val = val[paths[idx]];
	    idx += 1;
	  }
	  return val;
	});


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var map = __webpack_require__(43);
	var prop = __webpack_require__(210);
	
	
	/**
	 * Returns a new list by plucking the same named property off all objects in
	 * the list supplied.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig k -> [{k: v}] -> [v]
	 * @param {Number|String} key The key name to pluck off of each object.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of values for the given key.
	 * @see R.props
	 * @example
	 *
	 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
	 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
	 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
	 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
	 */
	module.exports = _curry2(function pluck(p, list) {
	  return map(prop(p), list);
	});


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var _toString = __webpack_require__(781);
	
	
	/**
	 * Returns the string representation of the given value. `eval`'ing the output
	 * should result in a value equivalent to the input value. Many of the built-in
	 * `toString` methods do not satisfy this requirement.
	 *
	 * If the given value is an `[object Object]` with a `toString` method other
	 * than `Object.prototype.toString`, this method is invoked with no arguments
	 * to produce the return value. This means user-defined constructor functions
	 * can provide a suitable `toString` method. For example:
	 *
	 *     function Point(x, y) {
	 *       this.x = x;
	 *       this.y = y;
	 *     }
	 *
	 *     Point.prototype.toString = function() {
	 *       return 'new Point(' + this.x + ', ' + this.y + ')';
	 *     };
	 *
	 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category String
	 * @sig * -> String
	 * @param {*} val
	 * @return {String}
	 * @example
	 *
	 *      R.toString(42); //=> '42'
	 *      R.toString('abc'); //=> '"abc"'
	 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
	 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
	 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
	 */
	module.exports = _curry1(function toString(val) { return _toString(val, []); });


/***/ },
/* 117 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (a, b) {
	  if (a && b) {
	    return function () {
	      a.apply(undefined, arguments);
	      b.apply(undefined, arguments);
	    };
	  }
	
	  return a || b;
	};

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var EventPluginRegistry = __webpack_require__(222);
	var EventPluginUtils = __webpack_require__(223);
	var ReactErrorUtils = __webpack_require__(227);
	
	var accumulateInto = __webpack_require__(490);
	var forEachAccumulated = __webpack_require__(491);
	var invariant = __webpack_require__(12);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(118);
	var EventPluginUtils = __webpack_require__(223);
	
	var accumulateInto = __webpack_require__(490);
	var forEachAccumulated = __webpack_require__(491);
	var warning = __webpack_require__(19);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 120 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(62);
	
	var getEventTarget = __webpack_require__(232);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var assign = __webpack_require__(15);
	
	var inlineBlockStyle = {
	  display: 'inline-block'
	};
	
	module.exports = React.createClass({
	
	  displayName: 'ReactInlineBlock',
	
	  render: function render() {
	    var style = assign({}, this.props.style, inlineBlockStyle);
	    var props = assign({}, this.props, { style: style });
	
	    return React.createElement('div', props);
	  }
	});

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(8);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]);
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  max-height: ', ';\n  overflow-y: scroll;\n  display: ', ';\n  text-align: left;\n  ', ';\n'], ['\n  margin-top: ', ';\n  max-height: ', ';\n  overflow-y: scroll;\n  display: ', ';\n  text-align: left;\n  ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  elements: _react.PropTypes.array,
	  children: _react.PropTypes.node
	};
	
	var ListContainer = _styledComponents2.default.div(_templateObject, _Themes.Metrics.margins.small, _Themes.Metrics.components.listSize, function (props) {
	  return props.hide ? 'none' : 'block';
	}, _Themes.Fonts.style.Text);
	
	var List = function List(props) {
	  var children = props.children;
	
	  return _react2.default.createElement(
	    ListContainer,
	    props,
	    children
	  );
	};
	
	List.propTypes = propTypes;
	
	exports.default = List;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding: ', ' 0;\n  padding-left: ', ';\n  ', ';\n\n  &:hover {\n    background: ', ';\n    cursor: pointer;\n  }\n\n  svg {\n    float: right;\n  }\n'], ['\n  padding: ', ' 0;\n  padding-left: ', ';\n  ', ';\n\n  &:hover {\n    background: ', ';\n    cursor: pointer;\n  }\n\n  svg {\n    float: right;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  onClick: _react.PropTypes.func,
	  odd: _react.PropTypes.bool,
	  children: _react.PropTypes.node
	};
	
	var ListItemContainer = _styledComponents2.default.div(_templateObject, _Themes.Metrics.margins.small, _Themes.Metrics.margins.small, _Themes.Fonts.style.Text, _Themes.Colors.lightGrey);
	
	var ListItem = function ListItem(props) {
	  var children = props.children;
	
	  return _react2.default.createElement(
	    ListItemContainer,
	    props,
	    children
	  );
	};
	
	ListItem.propTypes = propTypes;
	
	exports.default = ListItem;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: ', ';\n\n  .title {\n    ', ';\n    color: ', ';\n  }\n\n  .values {\n    margin: ', ' 0;\n    ', ';\n    color: ', ';\n  }\n\n  .input-range {\n    width: calc(100% - 8px);\n    margin-left: 3px;\n  }\n\n  .input-range__track {\n    height: 3px;\n    border-radius: 8px;\n    background: #d8d8d8;\n  }\n\n  .input-range__track--active {\n    background: ', ';\n  }\n\n  .input-range__slider {\n    border: 1px solid ', ';\n    background: ', ';\n  }\n  .input-range__label-container {\n    display: none;\n  }\n'], ['\n  width: ', ';\n\n  .title {\n    ', ';\n    color: ', ';\n  }\n\n  .values {\n    margin: ', ' 0;\n    ', ';\n    color: ', ';\n  }\n\n  .input-range {\n    width: calc(100% - 8px);\n    margin-left: 3px;\n  }\n\n  .input-range__track {\n    height: 3px;\n    border-radius: 8px;\n    background: #d8d8d8;\n  }\n\n  .input-range__track--active {\n    background: ', ';\n  }\n\n  .input-range__slider {\n    border: 1px solid ', ';\n    background: ', ';\n  }\n  .input-range__label-container {\n    display: none;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactInputRange = __webpack_require__(1000);
	
	var _reactInputRange2 = _interopRequireDefault(_reactInputRange);
	
	__webpack_require__(647);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	var _Utils = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  max: _react.PropTypes.number,
	  min: _react.PropTypes.number,
	  title: _react.PropTypes.node,
	  unit: _react.PropTypes.string,
	  rightUnit: _react.PropTypes.bool,
	  step: _react.PropTypes.number,
	  handleChange: _react.PropTypes.func,
	  maxValue: _react.PropTypes.number,
	  minValue: _react.PropTypes.number,
	  format: _react.PropTypes.func
	};
	
	var Range = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.width ? props.width : 'auto';
	}, _Themes.Fonts.style.Label, _Themes.Colors.black, _Themes.Metrics.margins.small, _Themes.Fonts.style.Input, _Themes.Colors.black, _Themes.Colors.primary, _Themes.Colors.primary, _Themes.Colors.white);
	
	var defaultProps = {
	  min: 0,
	  max: 100,
	  step: 1,
	  unit: '',
	  minValue: 0,
	  maxValue: 100
	};
	
	var RangePicker = function (_Component) {
	  _inherits(RangePicker, _Component);
	
	  function RangePicker(props) {
	    _classCallCheck(this, RangePicker);
	
	    var _this = _possibleConstructorReturn(this, (RangePicker.__proto__ || Object.getPrototypeOf(RangePicker)).call(this, props));
	
	    _this.state = {
	      value: {
	        min: props.minValue,
	        max: props.maxValue
	      }
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(RangePicker, [{
	    key: 'handleChange',
	    value: function handleChange(value) {
	      this.setState({ value: value });
	      if (this.props.handleChange) {
	        this.props.handleChange(value);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.minValue !== nextProps.minValue || this.props.maxValue !== nextProps.maxValue) {
	        this.setState({
	          value: {
	            min: nextProps.minValue,
	            max: nextProps.maxValue
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var min = _props.min;
	      var max = _props.max;
	      var title = _props.title;
	      var unit = _props.unit;
	      var rightUnit = _props.rightUnit;
	      var step = _props.step;
	
	
	      var maxValueLabel = !rightUnit ? '' + unit + (0, _Utils.numberWithCommas)(this.state.value.max) : '' + (0, _Utils.numberWithCommas)(this.state.value.max) + unit;
	
	      if (this.state.value.max === max) {
	        maxValueLabel += '+';
	      }
	
	      var minValueLabel = !rightUnit ? '' + unit + (0, _Utils.numberWithCommas)(this.state.value.min) : '' + (0, _Utils.numberWithCommas)(this.state.value.min) + unit;
	
	      return _react2.default.createElement(
	        Range,
	        Object.assign({}, this.props, { className: 'picker' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'title' },
	          title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'values' },
	          minValueLabel,
	          ' - ',
	          maxValueLabel
	        ),
	        _react2.default.createElement(_reactInputRange2.default, {
	          maxValue: max,
	          minValue: min,
	          step: step,
	          value: this.state.value,
	          onChange: this.handleChange
	        })
	      );
	    }
	  }]);
	
	  return RangePicker;
	}(_react.Component);
	
	RangePicker.propTypes = propTypes;
	RangePicker.defaultProps = defaultProps;
	
	exports.default = RangePicker;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding: ', ';\n  margin-right: ', ';\n  margin-top: ', ';\n  display: inline-block;\n  background: ', ';\n  border-radius: ', ';\n'], ['\n  padding: ', ';\n  margin-right: ', ';\n  margin-top: ', ';\n  display: inline-block;\n  background: ', ';\n  border-radius: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: inline-block;\n  ', ';\n  color: ', ';\n'], ['\n  display: inline-block;\n  ', ';\n  color: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  display: inline-block;\n  margin-left: ', ';\n  vertical-align: middle;\n\n  svg {\n    width: 16px;\n    height: 16px;\n    vertical-align: middle;\n    fill: ', ';\n    cursor: pointer;\n  }\n'], ['\n  display: inline-block;\n  margin-left: ', ';\n  vertical-align: middle;\n\n  svg {\n    width: 16px;\n    height: 16px;\n    vertical-align: middle;\n    fill: ', ';\n    cursor: pointer;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  text: _react.PropTypes.string.isRequired,
	  icon: _react.PropTypes.node,
	  color: _react.PropTypes.string
	};
	
	var TagContainer = _styledComponents2.default.span(_templateObject, _Themes.Metrics.margins.small, _Themes.Metrics.margins.tiny, _Themes.Metrics.margins.tiny, function (props) {
	  return props.color ? props.color : _Themes.Colors.darkGrey;
	}, _Themes.Metrics.borders.defaultRadius);
	
	var TextContainer = _styledComponents2.default.span(_templateObject2, _Themes.Fonts.style.Input, _Themes.Colors.white);
	var IconContainer = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.small, _Themes.Colors.white);
	
	var Tag = function Tag(props) {
	  var text = props.text;
	  var icon = props.icon;
	
	
	  var tagIcon = icon ? _react2.default.createElement(
	    IconContainer,
	    null,
	    icon
	  ) : null;
	
	  return _react2.default.createElement(
	    TagContainer,
	    props,
	    _react2.default.createElement(
	      TextContainer,
	      null,
	      text
	    ),
	    tagIcon
	  );
	};
	
	Tag.propTypes = propTypes;
	
	exports.default = Tag;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral([''], ['']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n  height: 100%;\n  width: 100%;\n\n  #picture-upload {\n    display: none;\n  }\n\n  #default-button {\n    pointer-events: none;\n  }\n'], ['\n  position: relative;\n  height: 100%;\n  width: 100%;\n\n  #picture-upload {\n    display: none;\n  }\n\n  #default-button {\n    pointer-events: none;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  ', ';\n  color: ', ';\n'], ['\n  margin-top: ', ';\n  ', ';\n  color: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* globals FileReader */
	
	
	var OuterContainer = _styledComponents2.default.div(_templateObject);
	
	var InnerContainer = _styledComponents2.default.div(_templateObject2);
	
	var Error = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.tiny, _Themes.Fonts.style.Input, _Themes.Colors.red);
	
	var UploadPicture = function (_Component) {
	  _inherits(UploadPicture, _Component);
	
	  function UploadPicture(props) {
	    _classCallCheck(this, UploadPicture);
	
	    var _this = _possibleConstructorReturn(this, (UploadPicture.__proto__ || Object.getPrototypeOf(UploadPicture)).call(this, props));
	
	    _this.handlePictureChange = _this.handlePictureChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(UploadPicture, [{
	    key: 'handlePictureChange',
	    value: function handlePictureChange(event) {
	      var _this2 = this;
	
	      if (event.target.files) {
	        var reader = new FileReader();
	        var file = event.target.files[0];
	        // Calc the size in MB
	        var fileSize = file.size / 1024 / 1024;
	        switch (file.type) {
	          case 'image/png':
	          case 'image/jpeg':
	          case 'image/tiff':
	          case 'image/gif':
	            break;
	          default:
	            this.props.handleError('Wrong image type');
	            return;
	        }
	        if (fileSize > 2) {
	          this.props.handleError('Image cannot be greater than 2mb');
	        } else {
	          reader.readAsDataURL(file);
	          reader.onloadend = function () {
	            _this2.props.handleUploaded(file, reader.result);
	          };
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var uploadButton = _props.uploadButton;
	      var error = _props.error;
	
	      return _react2.default.createElement(
	        OuterContainer,
	        null,
	        _react2.default.createElement(
	          InnerContainer,
	          this.props,
	          children,
	          _react2.default.createElement('input', {
	            type: 'file',
	            name: 'picture-upload',
	            id: 'picture-upload',
	            onChange: this.handlePictureChange
	          }),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'picture-upload', className: 'uploadButtonContainer' },
	            uploadButton || _react2.default.createElement(_Button2.default, { id: 'default-button', label: 'Upload' })
	          )
	        ),
	        error && _react2.default.createElement(
	          Error,
	          { className: 'error' },
	          error
	        )
	      );
	    }
	  }]);
	
	  return UploadPicture;
	}(_react.Component);
	
	UploadPicture.propTypes = {
	  uploadButton: _react.PropTypes.node,
	  handleUploaded: _react.PropTypes.func.isRequired,
	  handleError: _react.PropTypes.func,
	  error: _react.PropTypes.string,
	  children: _react.PropTypes.node
	};
	
	exports.default = UploadPicture;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(170);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _AuthActions = __webpack_require__(53);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _jwtDecode = __webpack_require__(196);
	
	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);
	
	var _axios = __webpack_require__(86);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuthStore = function () {
	  function AuthStore() {
	    _classCallCheck(this, AuthStore);
	
	    this.hvbToken = window.localStorage.getItem('hvbToken');
	    this.user = this.hvbToken ? (0, _jwtDecode2.default)(this.hvbToken).user : null;
	    this.admin = this.hvbToken ? (0, _jwtDecode2.default)(this.hvbToken).admin : null;
	    this.fetching = false;
	    this.errorMessage = null;
	
	    this.bindListeners({
	      loginSuccess: _AuthActions2.default.LOGIN_SUCCESS,
	      loginFailed: _AuthActions2.default.LOGIN_FAILED,
	      logout: _AuthActions2.default.LOGOUT,
	      loginAdmin: _AuthActions2.default.LOGIN_ADMIN,
	      loginAdminSuccess: _AuthActions2.default.LOGIN_ADMIN_SUCCESS,
	      logoutAdmin: _AuthActions2.default.LOGOUT_ADMIN,
	      updateToken: _AuthActions2.default.UPDATE_TOKEN,
	      storeToken: _AuthActions2.default.STORE_TOKEN,
	      cleanError: _AuthActions2.default.CLEAN_ERROR
	    });
	  }
	
	  _createClass(AuthStore, [{
	    key: 'cleanError',
	    value: function cleanError() {
	      this.fetching = false;
	      this.errorMessage = null;
	    }
	  }, {
	    key: 'loginAdmin',
	    value: function loginAdmin() {
	      this.fetching = true;
	    }
	  }, {
	    key: 'loginAdminSuccess',
	    value: function loginAdminSuccess(data) {
	      this.fetching = false;
	      window.localStorage.setItem('hvbToken', data.authToken);
	      _axios2.default.defaults.headers['Authorization'] = 'BEARER ' + window.localStorage.getItem('hvbToken');
	      this.hvbToken = window.localStorage.getItem('hvbToken');
	      this.admin = data.admin;
	      this.errorMessage = null;
	    }
	  }, {
	    key: 'loginSuccess',
	    value: function loginSuccess(data) {
	      this.fetching = false;
	      window.localStorage.setItem('hvbToken', data.authToken);
	      this.hvbToken = window.localStorage.getItem('hvbToken');
	      _axios2.default.defaults.headers['Authorization'] = 'BEARER ' + window.localStorage.getItem('hvbToken');
	      this.user = data.user;
	      this.errorMessage = null;
	      window.location = '/';
	    }
	  }, {
	    key: 'logoutAdmin',
	    value: function logoutAdmin() {
	      this.fetching = false;
	      this.admin = null;
	      window.localStorage.removeItem('hvbToken');
	      _axios2.default.defaults.headers['Authorization'] = 'BEARER ' + null;
	      this.hvbToken = null;
	      this.errorMessage = null;
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      this.fetching = false;
	      this.user = null;
	      window.localStorage.removeItem('hvbToken');
	      _axios2.default.defaults.headers['Authorization'] = 'BEARER ' + null;
	      this.hvbToken = null;
	      this.errorMessage = null;
	    }
	  }, {
	    key: 'loginFailed',
	    value: function loginFailed(errorMessage) {
	      this.errorMessage = errorMessage;
	      this.fetching = false;
	    }
	  }, {
	    key: 'updateToken',
	    value: function updateToken(token) {
	      this.hvbToken = token;
	      window.localStorage.setItem('hvbToken', token);
	      this.user = (0, _jwtDecode2.default)(token).user;
	    }
	  }, {
	    key: 'storeToken',
	    value: function storeToken(data) {
	      this.fetching = false;
	      window.localStorage.setItem('hvbToken', data.authToken);
	      this.hvbToken = data.authToken;
	      _axios2.default.defaults.headers['Authorization'] = 'BEARER ' + data.authToken;
	      this.errorMessage = null;
	    }
	  }]);
	
	  return AuthStore;
	}();
	
	module.exports = _alt2.default.createStore(AuthStore, 'AuthStore');

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Add = function Add(props) {
	  return _react2.default.createElement(
	    'svg',
	    Object.assign({
	      width: '21',
	      height: '21',
	      xmlns: 'http://www.w3.org/2000/svg',
	      xmlnsXlink: 'http://www.w3.org/1999/xlink'
	    }, props),
	    _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement('path', {
	        d: 'M11.4583333 13.5416667v8.4280303c0 .5229969.4663701.9469697 1.0416667.9469697.5752966 0 1.0416667-.4239728 1.0416667-.9469697v-8.4280303h8.4280303c.5229969 0 .9469697-.4663701.9469697-1.0416667 0-.5752966-.4239728-1.0416667-.9469697-1.0416667h-8.4280303V3.03030303c0-.52299692-.4663701-.9469697-1.0416667-.9469697-.5752966 0-1.0416667.42397278-1.0416667.9469697v8.42803027H3.03030303c-.52299692 0-.9469697.4663701-.9469697 1.0416667 0 .5752966.42397278 1.0416667.9469697 1.0416667h8.42803027z',
	        id: 'addIconA'
	      })
	    ),
	    _react2.default.createElement(
	      'g',
	      { transform: 'translate(-2 -2)', fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { d: 'M0 0h25v25H0z' }),
	      _react2.default.createElement(
	        'mask',
	        { id: 'addIconB', fill: '#fff' },
	        _react2.default.createElement('use', { xlinkHref: '#addIconA' })
	      ),
	      _react2.default.createElement('path', {
	        d: 'M0 0h25v25H0z',
	        mask: 'url(#addIconB)',
	        fill: '#C78C2F',
	        id: 'plus-icon'
	      })
	    )
	  );
	};
	
	exports.default = Add;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pangea = function Pangea(props) {
	  return _react2.default.createElement(
	    'svg',
	    Object.assign({
	      width: '449',
	      height: '450',
	      viewBox: '0 0 449 450',
	      xmlns: 'http://www.w3.org/2000/svg'
	    }, props),
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', {
	        d: 'M224.442 9.783C106.066 9.783 9.762 106.328 9.762 225c0 118.672 96.304 215.217 214.68 215.217 118.374 0 214.68-96.545 214.68-215.217 0-118.672-96.306-215.217-214.68-215.217m0 440.217C100.687 450 .002 349.064.002 225S100.687 0 224.442 0C348.198 0 448.88 100.936 448.88 225S348.198 450 224.442 450',
	        fill: '#C78C2F'
	      }),
	      _react2.default.createElement('path', {
	        d: 'M70.815 325.446l-4.472 3.02c.787 1.13 1.59 1.857 2.416 2.182.828.325 1.61.24 2.343-.263.64-.43.968-1.055.987-1.853.01-.812-.29-1.677-.908-2.594-.13-.196-.255-.362-.367-.492zm-6.263 4.237l-5.172 3.492.114.168c1.198 1.78 2.3 2.808 3.312 3.075 1.002.263 1.803.196 2.397-.21.783-.52 1.162-1.314 1.138-2.36-.025-1.04-.464-2.202-1.317-3.467l-.47-.697zm6.713-7.518l1.618 2.403c1.06 1.576 1.587 3.095 1.572 4.557-.01 1.46-.535 2.54-1.582 3.248-1.27.864-2.828.84-4.674-.06.776 2.802.226 4.83-1.65 6.102-1.304.88-2.753 1.007-4.345.373-1.59-.645-3.052-1.95-4.38-3.927l-1.67-2.478 15.11-10.217zM82.527 338.138l1.8 2.092-2.64 8.202 8.454-1.438 1.804 2.097-11.384 1.92-6.33 5.47-1.626-1.896 6.31-5.45M109.374 365.513l1.983 1.514-4.246 5.594 6.94 5.293 4.24-5.598 1.96 1.49-11.04 14.545-1.956-1.49 5.303-6.99-6.938-5.29-5.3 6.988-1.98-1.51M124.33 384.228l2.25 1.32-.537 7.617 6.283-4.237 2.262 1.328-11.322 7.58M147.45 391.914l-2.19 4.944c1.263.54 2.33.726 3.2.558.872-.162 1.487-.654 1.85-1.46.31-.713.263-1.41-.15-2.107-.414-.69-1.128-1.262-2.137-1.71-.22-.103-.412-.173-.573-.226zm-3.068 6.92l-2.533 5.72.182.085c1.962.868 3.44 1.15 4.43.84.997-.316 1.638-.8 1.928-1.452.384-.865.288-1.734-.283-2.61-.577-.868-1.56-1.618-2.955-2.24l-.77-.343zm1.712-9.94l2.64 1.176c1.733.774 2.984 1.782 3.75 3.028.762 1.242.887 2.436.38 3.597-.624 1.405-1.955 2.216-3.997 2.437 2.14 1.957 2.75 3.973 1.833 6.042-.64 1.447-1.804 2.32-3.488 2.63-1.685.303-3.615-.022-5.785-.992l-2.735-1.218 7.402-16.7zM179.466 400.96l2.39.593-4.378 17.745-2.393-.596M191.898 403.115l11.468 15.6 1.79-13.03 2.466.34-2.603 18.938-11.474-15.534-1.763 12.854-2.465-.34M216.217 406.678l2.628-.004 5.735 12.94 5.757-12.945h2.65l-8.44 18.867M241.473 405.91l10.032-1.2.295 2.475-7.586.912.54 4.528 7.59-.908.29 2.446-7.587.913.743 6.238 7.587-.908.296 2.45-10.032 1.2M272.117 402.48l-1.59 2.048c-.646-.42-1.212-.715-1.694-.883-.484-.162-1.126-.153-1.922.04-.87.203-1.53.567-1.978 1.088-.452.525-.6 1.093-.455 1.72.124.534.472.955 1.046 1.255.57.306 1.48.564 2.735.783 1.256.226 2.25.475 2.985.747.734.272 1.365.615 1.892 1.032.53.42.96.887 1.294 1.407.33.517.57 1.1.718 1.725.347 1.48.11 2.87-.722 4.16-.826 1.3-2 2.126-3.526 2.484-1.484.35-2.894.25-4.222-.296-1.33-.544-2.487-1.557-3.482-3.042l2.262-1.252c1.35 1.787 2.938 2.47 4.756 2.04.883-.21 1.555-.645 2.016-1.314.462-.664.595-1.404.407-2.21-.115-.484-.382-.934-.802-1.35-.422-.414-.897-.724-1.428-.93-.53-.21-1.34-.4-2.426-.578-1.088-.167-1.942-.363-2.554-.573-.617-.22-1.18-.515-1.68-.888-.503-.382-.896-.778-1.186-1.204-.29-.415-.5-.893-.624-1.423-.3-1.275-.044-2.48.766-3.626.813-1.132 1.944-1.877 3.405-2.217.962-.234 1.994-.253 3.085-.072 1.088.188 2.066.632 2.925 1.33M280.103 397.994l10.497-3.76.838 2.352-4.097 1.46 5.297 14.866-2.317.83-5.295-14.86-4.082 1.467M312.11 383.22l13.146 14.612-2.168 1.122-8.004-8.94 1.03 13.345-10.323-8.653 2.654 11.833-2.156 1.113-4.286-19.203 11.307 9.473M324.08 376.78l8.284-5.793 1.426 2.05-6.267 4.38 2.603 3.74 6.266-4.38 1.41 2.02-6.268 4.384 3.586 5.156 6.265-4.385 1.41 2.026-8.286 5.795M339.973 364.195l19.293 1.194-8.823-9.74 1.84-1.677 12.824 14.148-19.247-1.146 8.705 9.61-1.844 1.678M358.846 346.975l7.226-8.503 1.896 1.614-2.823 3.32 11.98 10.237-1.596 1.877-11.98-10.236-2.81 3.31M379.878 322.5l.216 2.578c-.754.135-1.364.306-1.83.516-.468.21-.93.655-1.388 1.333-.493.75-.732 1.466-.705 2.155.025.692.303 1.208.83 1.566.462.31 1 .382 1.624.21.62-.166 1.468-.597 2.54-1.294 1.068-.693 1.964-1.195 2.69-1.495.722-.298 1.418-.48 2.085-.536.67-.053 1.3-.005 1.897.144.6.162 1.167.42 1.702.772 1.26.85 2.026 2.03 2.297 3.545.274 1.51-.024 2.92-.898 4.222-.846 1.272-1.945 2.16-3.29 2.67-1.342.507-2.882.56-4.618.144l.803-2.46c2.208.392 3.83-.195 4.874-1.748.504-.76.697-1.537.58-2.335-.114-.807-.52-1.438-1.202-1.897-.41-.276-.91-.43-1.5-.444-.594-.014-1.152.082-1.682.292-.528.21-1.252.62-2.165 1.237-.916.616-1.67 1.056-2.266 1.324-.6.26-1.206.423-1.83.495-.625.062-1.187.043-1.685-.067-.5-.114-.977-.32-1.427-.626-1.087-.73-1.72-1.78-1.9-3.176-.18-1.385.148-2.7.985-3.95.55-.827 1.288-1.54 2.21-2.154.93-.612 1.944-.952 3.05-1.023M125.236 56.334l2.798 4.867 1.59-.916c.682-.392 1.13-.983 1.33-1.757.203-.77.11-1.495-.277-2.17-.443-.773-1.065-1.213-1.858-1.327-.792-.106-1.694.14-2.708.717l-.876.587zm-5.966-1.104l6.485-3.745c1.742-1.012 3.443-1.318 5.1-.917 1.652.4 2.958 1.434 3.913 3.095.627 1.09.96 2.284 1 3.554.036 1.29-.336 2.48-1.117 3.573-.78 1.1-1.542 1.872-2.284 2.322l-2.332 1.432 4.23 7.357-4.06 2.346L119.27 55.23zM154.782 45.543l-.06 6.964 4.852-1.89-4.792-5.074zm-4.298-6.038l3.407-1.327 16.245 17.22-4.427 1.724-3.193-3.382-7.83 3.048-.045 4.643-4.4 1.72.244-23.645zM192.14 27.84l4.54-.858 4.068 21.57-4.52.85-12.47-12.093 2.63 13.96-4.634.874-4.065-21.56 4.585-.875 12.48 11.993M258.192 35.464l-3.666 5.924 5.124.916-1.458-6.84zm-.538-7.394l3.6.644 4.934 23.182-4.675-.836-.97-4.55-8.27-1.483-2.45 3.94-4.648-.835 12.48-20.062zM285.237 34.695l11.622 4.113-1.445 4.1-7.17-2.538-1.47 4.18 7.177 2.532-1.425 4.03-7.17-2.526-1.51 4.29 7.174 2.536-1.442 4.088-11.624-4.098M316.95 56.234l-5.364 4.423 4.56 2.512.805-6.936zm1.855-7.185l3.206 1.767-2.738 23.55-4.164-2.293.543-4.634-7.36-4.06-3.584 2.952-4.135-2.284 18.235-15zM233.642 30.005l-3.127 2.947c-.658-1.137-1.47-1.977-2.442-2.54-.965-.56-1.98-.84-3.038-.837-1.71.005-3.195.664-4.455 1.968-1.256 1.31-1.882 2.852-1.878 4.625.005 1.88.64 3.476 1.904 4.78 1.268 1.305 2.79 1.958 4.567 1.95.967 0 1.9-.245 2.792-.74.893-.494 1.613-1.415 2.15-2.767l-5.188.015-.01-4.28 10.11-.023.007 2.842c.002 1.457-.493 3.028-1.486 4.705-1 1.68-2.312 2.912-3.946 3.686-1.63.783-3.28 1.176-4.95 1.18-3.022.005-5.578-1.084-7.662-3.272-2.085-2.193-3.13-4.9-3.143-8.135-.007-3.062 1.058-5.684 3.19-7.862 2.135-2.184 4.705-3.278 7.72-3.282 3.844-.02 6.808 1.666 8.885 5.04M216.14 158.176v-5.402c0-.786-.638-1.427-1.423-1.427h-8.715v-2.814h8.715c.785 0 1.423-.64 1.423-1.426 0-.786-.638-1.425-1.423-1.425H204.58c-.784 0-1.422.64-1.422 1.425v5.667c0 .785.638 1.425 1.42 1.425h8.718v2.55h-8.717c-.784 0-1.422.64-1.422 1.426v12.044c0 .786.638 1.427 1.42 1.427.785 0 1.424-.64 1.424-1.427v-10.617h8.715c.785 0 1.423-.64 1.423-1.427M244.303 154.2c.783 0 1.422-.64 1.422-1.426v-5.667c0-.785-.64-1.425-1.422-1.425h-10.14c-.786 0-1.424.64-1.424 1.425s.637 1.426 1.422 1.426h8.718v2.814h-8.718c-.785 0-1.423.64-1.423 1.427v5.402c0 .786.637 1.427 1.422 1.427h8.718v10.617c0 .786.64 1.427 1.423 1.427s1.422-.64 1.422-1.427v-12.044c0-.785-.64-1.425-1.422-1.425h-8.72v-2.55h8.72zM205.96 297.337c0 4.08 3.31 7.398 7.38 7.398 2.3 0 4.42-1.102 5.812-2.915.098-.08.21-.14.287-.247l3.33-4.648c.46-.64.316-1.53-.324-1.988-.637-.46-1.524-.32-1.983.324l-3.17 4.42c-.062.065-.136.113-.186.19-.846 1.262-2.257 2.013-3.767 2.013-2.503 0-4.536-2.04-4.536-4.546 0-2.51 2.033-4.548 4.536-4.548.896 0 1.624.73 1.624 1.63 0 .9-.728 1.63-1.624 1.63-.785 0-1.423.64-1.423 1.425 0 .786.638 1.427 1.423 1.427 2.464 0 4.47-2.01 4.47-4.482 0-2.472-2.006-4.482-4.47-4.482-4.07 0-7.38 3.32-7.38 7.4',
	        fill: '#C78C2F'
	      }),
	      _react2.default.createElement('path', {
	        d: 'M246.564 383.935c30.554-9.46 56.434-38.12 71.75-77.1h43.78c-24.354 41.015-66.407 70.26-115.53 77.1zm-159.78-77.1h17.23c-.038.02-.08.03-.116.05-1.845.96-2.176 2.23-2.21 2.9-.033.663.165 1.934 1.854 3.036 2.558 1.664 5.543 2.25 8.85 1.697.665-.105 1.328-.234 1.993-.363.84-.167 1.68-.33 2.527-.44 1.39-.185 2.163.316 2.657 1.73.668 1.926.706 2.44-.478 3.08-1.52.827-2.385 1.797-2.647 2.968-.25 1.117.074 2.268.99 3.52 2.578 3.54 3.47 7.26 2.724 11.368-.47 2.57-.094 4.413 1.145 5.636 1.387 1.367 3.685 1.697 7.045 1.027 3.138-.635 3.92-.162 5.12 1.92 2.604 4.52 4.12 5.15 10.115 4.156 2.66-.42 3.745-.192 4.48.993 1.583 2.58 4.473 1.982 5.412 1.79 1.216-.247 2.33-.24 3.197-.072 7.35 8.76 15.466 16.133 24.184 21.846.01.038.017.076.026.115l1.09 4.61c.128.552.374.984.55 1.485-40.538-11.038-74.726-37.662-95.74-73.05zm-.4-162.97h43.91c-.613 1.578-1.222 3.156-1.8 4.765-.592.17-1.187.31-1.77.553-3.44 1.428-6.066 3.912-7.21 6.816l-.2.515c-1.01 2.618-1.68 4.356-5.4 4.356h-.11c-3.654.058-7.305.732-10.863 1.472-1.03.215-2.057.43-3.08.62-1.236.235-2.322.914-3.277 1.51l-.64.393c-.516.3-1.002.658-1.488 1.017-.65.482-1.264.94-1.88 1.16-3.337 1.195-6.796 2.608-9.226 5.565l-1.27 1.567c-1.295 1.614-2.52 3.143-3.937 4.547-2.14 2.122-2.95 4.468-2.546 7.38.057.422-.027.928-.205 1.23-.945 1.585-1.914 3.62-.998 5.315.95 1.768 3.37 2.102 5.615 2.193 2.83.11 5.655.31 8.475.51 1.973.14 3.943.278 5.918.388 1.018.057 1.032.253 1.07.774.088 1.193.227 2.384.365 3.577.255 2.197.495 4.275.433 6.372-.15 5.044-.57 9.12-1.33 12.82-.433 2.12-.918 4.252-1.377 6.382h-29.21c0-.22-.015-.44-.015-.66 0-29.588 8.06-57.31 22.047-81.137zm61.91-60.018c-1.483 2.367-2.577 4.674-3.625 6.922-1.86 4.002-3.617 7.78-7.536 11.167-3.304 2.856-6.227 6.095-5.744 10.513-.69.157-1.34.31-1.98.473l-.756.177c-.95.224-1.898.453-2.81.78-1.94.686-3.18 1.828-3.49 3.204-.148.653-.203 1.944 1.105 3.267 1.104 1.113 1.405 2.212-.513 4.242-3.82 4.032-1.23 7.433.16 9.258 1.836 2.407 5.076 4.48 10.09.687.498-.378.958-.656 1.446-1.008-1.437 3.132-2.79 6.353-4.08 9.64H86.784c14.782-24.894 36.063-45.472 61.51-59.323zm204.166 44.888c-1.374.808-3.146 1.862-3.8 2.856-2.31 3.497-4.487 7.122-6.593 10.624l-.576.955h-23.175c-15.317-38.98-41.197-67.64-71.75-77.1 43.148 6.01 80.858 29.288 105.895 62.665zm-7.54 14.434c1.988-3.304 4.027-6.695 6.184-9.965.413-.63 1.835-1.628 2.907-2.318 2.874 3.964 5.575 8.057 8.084 12.282H344.92zm27.468 140.1c-.4-.298-.742-.546-.84-.628-2.734-2.278-5.493-3.104-8.924-2.636-2.315.31-4.65.258-7.35.18-.552-.013-1.112-.022-1.684-.037.437-1.114.787-1.992 1.337-2.647.81-.956 1.78-1.835 2.807-2.765 1.022-.927 2.077-1.888 2.996-2.958.31-.363 3.003-3.6 1.75-5.66-1.028-1.676-3.65-2.66-5.595-2.737-2.134-.11-4.466.874-6.036 1.687-4.223 2.206-8.733 2.607-13.767 1.265-5.177-1.376-6.59-3.32-5.6-7.696.837-3.698 2.357-7.442 3.828-11.068l.156-.376c1.243-3.067.852-5.6-1.192-7.74-.69-.724-1.135-1.532-1.395-2.423.08-1.66.162-3.32.21-4.995.017-.132.002-.263.006-.402.048-1.753.08-3.51.09-5.277h51.322c-.17 20.316-4.138 39.73-11.203 57.594-.303-.23-.62-.466-.917-.685zm-42.606-17.772c1.302 1.638 3.44 2.846 6.548 3.674 5.78 1.538 10.968 1.05 15.867-1.495 1.775-.922 3.43-1.332 4.574-1.36 1.32.052 2.87.778 3.117 1.073.002.345-.545 1.51-1.377 2.48-.798.93-1.742 1.78-2.74 2.69-1.053.955-2.14 1.938-3.077 3.05-.87 1.028-1.343 2.232-1.842 3.503-.228.583-.47 1.204-.78 1.867l-.958 2.087 2.29-.004c1.278-.062 2.58.03 3.8.062 2.703.057 5.26.134 7.806-.206 2.63-.36 4.563.22 6.663 1.977.11.09.51.388.986.736.59.437 1.26.925 1.536 1.148-2.797 6.7-6.056 13.154-9.697 19.36h-43.91c4.89-12.59 8.707-26.218 11.197-40.642zm-58.58 40.64c4.54-23.52 7.173-50.743 7.253-79.78h2.746c1.26 2.133 2.96 2.892 4.43 3.077.355.044.5.182.598.31.198.264.62 1.138.242 3.53l-.044 1.964 1.537-.077c8.636-.435 13.506-1.768 15.337-2.27l.546-.148c4.17-1.017 6.395-1.61 8.543-2.183 2.313-.615 4.536-1.203 9.02-2.288 1.402-.338 8.013 2.274 8.797 3.273.013.124-.078.487-.138.725l-.128.536c-.68 3.354.024 6.178 2.03 8.425-.196 2.946-.448 5.868-.75 8.766-1.02 2.623-1.98 5.28-2.595 7.99-.617 2.73-.41 4.908.59 6.664-2.496 14.74-6.365 28.662-11.365 41.485h-46.65zm-38.22 79.132c16.235-7.783 30.073-37.377 38.087-78.434h46.514c-16.05 40.69-43.658 70.005-76.036 77.74-2.836.303-5.69.54-8.567.694zm-96.55-233.604c2.15.946 5.004 2.112 8.006 2.76 3.373.74 6.766.026 10.09-2.086 4.65-2.952 9.772-3.435 16.12-1.56.705.21 1.376.486 2.048.758.67.272 1.34.544 2.03.764.458.148.92.196 1.384.268-3.638 21.82-5.7 46.41-5.7 72.433 0 .22.007.438.007.66H116.37c0-.222-.01-.44-.01-.66 0-26.34 4.262-51.204 11.767-73.196 2.847-1.11 5.93-1.17 8.304-.14zm41.243-7.8c-.37 1.922-.732 3.866-1.076 5.837-.33-.048-.658-.09-.98-.196-.622-.195-1.224-.444-1.823-.687-.76-.31-1.52-.617-2.316-.855-7.123-2.116-13.184-1.496-18.518 1.896-2.654 1.693-5.308 2.25-7.91 1.702-2.727-.593-5.296-1.64-7.45-2.585-2.47-1.082-5.393-1.264-8.3-.6.553-1.525 1.14-3.015 1.724-4.512h46.65zm-35.08-15.247c5.343-2.59 10.39-2.986 14.97-1.157.907.36 1.808 1.074 2.05 1.633 1.765 4.08 3.22 4.945 8.225 4.864 1.863.004 3.795.004 5.04.597 2.367 1.123 4.276 2.662 5.74 4.583-.277 1.33-.546 2.673-.81 4.03h-46.516c1.407-3.568 2.902-7.043 4.482-10.43 2.347-1.622 4.623-3.05 6.82-4.12zm128.474 14.55c-8.015-41.058-21.853-70.65-38.09-78.435 2.878.152 5.732.39 8.568.694 32.378 7.735 59.987 37.05 76.036 77.74H271.07zm-39.953 82.492l.006-55.586c0-2.68 2.19-4.86 4.884-4.86.995 0 1.804.8 1.804 1.788 0 .987-.808 1.79-1.803 1.79-.783 0-1.423.64-1.423 1.426 0 .786.64 1.426 1.423 1.426 2.563 0 4.65-2.08 4.65-4.642 0-2.558-2.087-4.64-4.65-4.64-4.26 0-7.73 3.458-7.73 8.027l-.004 55.272h-2.403l-.007-78.555c0-.652-.482-1.114-1.08-1.284v-1.958h3.485v8.908c0 .785.64 1.427 1.423 1.427.784 0 1.423-.642 1.423-1.427v-8.908h39.425c4.593 23.866 7.237 51.575 7.237 81.138 0 .22-.005.438-.005.66h-46.653zm14.166 80.477c1.995-2.32 3.227-5.313 3.227-8.62 0-7.37-5.98-13.366-13.334-13.366-.783 0-1.423.64-1.423 1.427 0 .786.64 1.426 1.423 1.426 5.785 0 10.49 4.717 10.49 10.515 0 3.57-1.79 6.72-4.51 8.62h-11.983c-1.028-1.383-2.57-2.313-4.39-2.42v-8.674l4.658 6.525c.08.112.193.172.293.252 1.396 1.813 3.517 2.913 5.814 2.913 4.067 0 7.377-3.32 7.377-7.398 0-4.08-3.31-7.4-7.377-7.4-2.466 0-4.47 2.01-4.47 4.483 0 2.47 2.004 4.482 4.47 4.482.783 0 1.423-.64 1.423-1.427 0-.785-.64-1.425-1.423-1.425-.898 0-1.626-.73-1.626-1.63 0-.9.73-1.63 1.627-1.63 2.5 0 4.532 2.038 4.532 4.547 0 2.507-2.034 4.546-4.533 4.546-1.512 0-2.922-.752-3.77-2.014-.05-.075-.122-.12-.18-.18l-6.813-9.543v-11.8c.976.063 1.943.35 2.76.948.252.182.546.272.835.272.438 0 .87-.203 1.15-.587.46-.638.322-1.53-.314-1.992-1.002-.73-2.152-1.186-3.34-1.392l-.006-49.237h2.403l-.005 46.007c0 .717.53 1.32 1.24 1.413.028.003 2.475.34 4.564 2.366l-7.732 10.828c-.456.64-.308 1.532.33 1.99.25.18.54.265.827.265.44 0 .88-.208 1.157-.597l8.4-11.766c.37-.52.353-1.225-.052-1.726-1.952-2.424-4.427-3.472-5.89-3.905l.005-44.876h46.648c-.08 29.05-2.705 56.28-7.227 79.78h-25.255zm-20.5 79.355V321.58c6.086-.174 11.017-4.85 11.67-10.822 3.194-.312 6.042-1.767 8.18-3.922h25.772c-8.22 42.235-22.59 72.186-39.355 78.5-2.08.084-4.165.154-6.266.16zm-20.534-78.66c2.14 2.157 4.987 3.613 8.182 3.923.654 5.97 5.58 10.645 11.662 10.823v63.915c-2.1-.005-4.185-.075-6.267-.16-16.764-6.313-31.135-36.264-39.355-78.5h25.777zm23.35 2.826c0 1.626-1.243 2.918-2.816 3.097v-5.92h1.014c1.056.51 1.8 1.572 1.8 2.824zm-2.816 5.95c3.14-.19 5.66-2.754 5.66-5.95 0-1.038-.335-1.97-.8-2.824h10.286c-1.416.73-2.995 1.183-4.69 1.192-.027 0-.05-.014-.076-.014-.783 0-1.422.64-1.422 1.426 0 5.023-3.99 9.102-8.958 9.286v-3.117zm-.69-.003v3.12c-4.963-.19-8.95-4.267-8.95-9.287 0-.787-.638-1.426-1.423-1.426-.026 0-.048.013-.075.015-1.697-.01-3.277-.465-4.694-1.194h10.295c-.465.854-.8 1.786-.8 2.825 0 3.194 2.512 5.756 5.65 5.947zm0-8.77v5.918c-1.568-.182-2.805-1.473-2.805-3.094 0-1.25.742-2.313 1.798-2.824h1.006zm-3.502-34.47l.005-46.008h2.428l.005 49.232c-1.194.207-2.347.666-3.344 1.398-.637.466-.772 1.36-.31 1.992.463.638 1.36.777 1.987.31.804-.59 1.76-.875 2.73-.942v10.828l-9.3-13.032c2.073-1.998 4.537-2.363 4.56-2.366.71-.093 1.24-.696 1.24-1.413zm-39.627-128.502c.208.633.468 1.22.614 1.902.302 1.4-.346 2.336-.94 2.88-.86.784-2.096 1.164-3.387 1.125.348-1.995.712-3.96 1.086-5.907h2.625zm-.225-.696h-2.268c.21-1.078.42-2.15.637-3.21.65.98 1.196 2.048 1.63 3.21zm43.354-78.66v67.174c-3.515.19-6.325 3.09-6.322 6.603l-.01 4.882h-33.965c-.846-2.656-2.146-4.973-3.904-6.91 8.398-38.578 22.1-65.628 37.934-71.59 2.082-.086 4.166-.155 6.267-.16zm.69 67.172V64.51c2.1.005 4.186.074 6.266.16 16.765 6.312 31.135 36.264 39.355 78.5h-39.292v-4.575c.012-.08.02-.164.02-.248 0-3.578-2.822-6.488-6.35-6.665zm0 2.88c1.824.165 3.3 1.565 3.488 3.387-.004.017-.004.038-.004.058v5.16h-3.484v-8.606zm-4.195 4.335l.024-.55c0-1.994 1.54-3.584 3.48-3.774v8.596h-3.504v-4.273zm-49.49 86.106c0-25.986 2.048-50.535 5.658-72.31 2.184.175 4.308-.476 5.848-1.872 1.625-1.475 2.295-3.544 1.837-5.673-.098-.457-.296-.843-.418-1.282h33.737l-.014 8.908c0 .785.638 1.427 1.42 1.427.786 0 1.424-.642 1.424-1.427l-.002-8.908h3.504v1.96c-.595.172-1.075.632-1.075 1.282l.005 78.555h-2.428l.004-55.586c0-4.254-3.463-7.712-7.724-7.712-2.564 0-4.65 2.082-4.65 4.64 0 2.56 2.086 4.642 4.65 4.642.783 0 1.423-.64 1.423-1.426 0-.786-.64-1.426-1.424-1.426-.996 0-1.804-.803-1.804-1.79s.808-1.788 1.804-1.788c2.69 0 4.882 2.18 4.882 5.175l-.006 55.272h-46.645c0-.22-.006-.44-.006-.66zm6.575 81.136h-46.65c-9.162-23.5-14.48-50.73-14.643-79.78h54.04c.08 29.035 2.714 56.257 7.253 79.78zm-6.56-79.78h46.637l-.004 44.875c-1.463.433-3.935 1.48-5.887 3.906-.403.502-.42 1.208-.05 1.727l12.284 17.212v9.64c-1.817.11-3.354 1.04-4.38 2.42H207.73c-2.722-1.9-4.512-5.05-4.512-8.62 0-5.797 4.705-10.514 10.49-10.514.784 0 1.422-.64 1.422-1.425 0-.786-.638-1.426-1.423-1.426-7.35 0-13.333 5.997-13.333 13.367 0 3.305 1.233 6.3 3.228 8.62h-25.26c-4.523-23.5-7.148-50.73-7.226-79.78zm117.453 1.618c-.617-.82-1.508-1.323-2.575-1.457-.14-.015-.37-.065-.638-.16h31.558c-2.16.543-3.727.957-5.274 1.365-2.136.568-4.347 1.157-8.487 2.174l-.624.16c-1.623.445-5.747 1.572-12.988 2.07.064-1.276-.06-2.933-.974-4.152zm43.868 1.87c-1.138-1.257-3.79-2.596-6.39-3.49h6.45c-.007 1.17-.037 2.328-.06 3.49zm.167 12.24c.765 1.114.83 2.32.152 3.998l-.155.383c-.163.398-.312.812-.475 1.214.175-1.86.346-3.72.478-5.597zm-.096-16.426h-8.828c-1.232-.28-2.297-.394-2.952-.244-.375.09-.65.16-.994.244h-35.37c-.443-.437-.895-1.05-1.267-2.135-3.32-9.716 4.03-35.128 5.854-37.08 1.855-.642 3.08-1.435 4.263-2.2 1.1-.71 2.14-1.383 3.698-1.92l3.124-1.098c3.15-1.11 6.404-2.26 9.65-3.134 2.047-.554 4.206-.95 6.296-1.333 2.22-.41 4.517-.832 6.75-1.447 1.586-.435 2.78-.702 3.883-.946l.422-.095c3.538 15.965 5.483 33.01 5.483 50.728 0 .22-.01.438-.01.66zm-6.122-54.253c-.136.03-.268.064-.406.093-1.145.253-2.38.53-4.023.985-2.113.578-4.345.99-6.503 1.385-2.147.397-4.368.807-6.53 1.386-3.352.905-6.662 2.072-9.862 3.204l-3.104 1.09c-1.893.653-3.132 1.45-4.33 2.225-1.087.7-2.115 1.365-3.634 1.895-3.46 1.194-9.664 25.58-8.486 36.823.233 2.232.726 3.883 1.347 5.164h-2.394c0-.22.006-.44.006-.66 0-29.544-2.654-57.247-7.264-81.137h46.65c3.393 8.703 6.262 17.912 8.533 27.544zm14.372-25.184c.834 3.726-1.144 7.08-3.24 10.638l-.752 1.29c-.445.768-.91 1.532-1.373 2.302-.923 1.514-1.84 3.024-2.61 4.59-.48.98-.51 1.997-.538 2.89-.01.258-.017.515-.038.77-.124.147-.29.323-.452.5-.325.36-.603.664-.813.96-1.56.532-2.722.82-3.886 1.088-2.26-9.573-5.105-18.727-8.47-27.39h22.54c-.376.74-.537 1.615-.367 2.362zM207.33 65.43c2.835-.303 5.69-.543 8.566-.695-15.236 7.304-28.362 33.812-36.544 70.98-1.494-1.507-3.178-2.844-5.22-3.814-1.81-.855-4.134-.907-6.332-.874-4.033.058-4.27-.252-5.5-3.095-.676-1.56-2.396-2.698-3.658-3.194-5.377-2.14-11.21-1.725-17.323 1.246-1.027.498-2.08 1.138-3.125 1.743 16.48-32.59 41.013-55.577 69.134-62.296zm-81.794 52.852c-.253-.258-.348-.463-.33-.55.037-.152.397-.654 1.617-1.088.81-.287 1.657-.487 2.5-.688l.79-.186c.724-.18 1.453-.35 2.24-.53l2.546-.593-.4-1.466c-.93-3.438 1.05-6 4.544-9.018 4.395-3.8 6.283-7.857 8.28-12.15 1.333-2.87 4.055-7.74 6.464-10.99 15.007-7.43 31.333-12.556 48.525-14.95-26.533 8.213-49.554 30.894-65.185 62.248-1.847 1.126-3.728 2.382-5.7 3.877-3.27 2.48-4.815 1.408-5.994-.134-1.818-2.384-2.147-3.568-.363-5.455 3.52-3.726 2.196-6.587.466-8.326zm-26.79 81.467c-.133-1.153-.266-2.304-.353-3.46-.114-1.5-.87-3.32-3.828-3.487-1.96-.11-3.916-.243-5.875-.38-2.852-.203-5.703-.403-8.564-.518-2.836-.12-3.154-.65-3.157-.655-.003-.004-.208-.5.935-2.416.522-.88.74-2.054.59-3.14-.273-1.97.24-3.433 1.706-4.885 1.54-1.525 2.873-3.187 4.164-4.797l1.243-1.543c1.957-2.378 4.88-3.563 7.955-4.667 1.023-.363 1.842-.974 2.633-1.562.403-.295.802-.595 1.234-.85l.7-.428c.774-.483 1.576-.985 2.272-1.113 1.04-.198 2.087-.417 3.135-.637 3.333-.693 6.78-1.41 10.03-1.41h.344c5.727 0 7.062-3.447 8.133-6.227l.196-.497c.788-2.012 2.622-3.75 5.032-4.89-7.406 21.915-11.604 46.64-11.604 72.813 0 .22.012.438.012.66H96.558c.416-1.933.857-3.865 1.252-5.79.79-3.875 1.232-8.112 1.387-13.327.068-2.312-.196-4.59-.45-6.797zm26.225 98.32c1.41-1.967.476-4.943-.858-6.662-2.845-5.455-9.503-8.364-16.536-7.213-1.707.263-3.04-.038-3.777-.864-.644-.716-.8-1.824-.443-3.12 2.234-8.134-.136-15.103-6.505-19.115-1.336-.84-2.566-1.73-3.65-2.63-2.334-1.956-3.144-4.072-2.542-6.675l1.08-4.666c1.575-6.81 3.16-13.792 4.667-20.765h19.284c.162 29.035 5.465 56.257 14.604 79.78h-15.27c4.08-1.84 7.426-4.53 9.947-8.07zm-60.598-71.71h29.04c-1.465 6.748-2.996 13.504-4.524 20.1l-1.082 4.67c-.852 3.698.33 6.922 3.524 9.588 1.184.99 2.518 1.95 3.965 2.86 7.116 4.486 6.337 11.856 5.24 15.85-.62 2.26-.228 4.394 1.082 5.86 1.432 1.596 3.702 2.25 6.424 1.802 5.83-.922 11.222 1.347 13.61 5.884 1.02 1.348 1.316 2.867.94 3.387-3.07 4.31-7.33 7.128-13.356 8.7-1.17.304-2.347.66-3.502 1.08H86.385c-13.772-23.46-21.77-50.704-22.013-79.78zm55.425 96.923c-.363-.498-.546-.923-.495-1.147.02-.105.176-.482 1.184-1.03 3.494-1.894 2.423-4.975 1.846-6.637-.953-2.728-2.996-4.022-5.802-3.67-.904.12-1.808.297-2.708.474-.63.124-1.26.243-1.894.35-2.57.4-4.86-.01-6.792-1.262-.338-.225-.467-.393-.512-.406.05-.072.207-.25.62-.464 1.386-.722 3.082-1.165 5.067-1.68 1-.26 1.903-.634 2.832-.976h17.42c6.26 15.928 14.28 30.126 23.667 42-.513.055-.985.123-1.337.192-1.83.374-2.122-.104-2.337-.453-1.994-3.24-5.534-2.665-7.444-2.35-5.066.826-5.21.56-7.107-2.733-1.907-3.3-4.05-4.18-8.234-3.324-3.01.612-4.054.11-4.414-.25-.607-.595-.507-1.966-.32-3.013.902-4.943-.16-9.4-3.24-13.622zm60.838 49.416c-8.195-5.458-15.85-12.39-22.823-20.58 3.817 1.244 7.617 2.682 11.294 4.088l.374.143c5.57 2.136 8.8 5.633 9.867 10.7.4 1.886.844 3.77 1.288 5.65zm3.53 2.237l-.432-1.825c-.53-2.22-1.05-4.44-1.522-6.668-1.27-6.037-5.203-10.35-11.687-12.835l-.372-.144c-3.922-1.5-7.982-3.057-12.094-4.366-.987-.32-2.056-.377-3.02-.332-9.42-11.827-17.462-26.008-23.742-41.932h46.515c8.012 41.057 21.85 70.65 38.086 78.434-2.877-.153-5.73-.39-8.567-.695-8.055-1.924-15.806-5.2-23.165-9.638zm1.983 5.893c-.582-.888-1.04-1.872-1.32-3.088l-.444-1.877c5.756 3.416 11.74 6.154 17.93 8.07-5.482-.764-10.876-1.8-16.166-3.105zm198.378-155.168h-51.328c0-.22.01-.44.01-.66 0-17.77-1.95-34.863-5.502-50.88 1.39-.317 2.788-.683 4.805-1.396l2.643-.94-.02-.91c.114-.977.066-1.16-.01-1.917.025-.307.038-.618.047-.928.022-.66.04-1.28.24-1.69.73-1.487 1.607-2.92 2.48-4.363.477-.784.956-1.573 1.41-2.36l.74-1.267c2.29-3.892 4.66-7.914 3.57-12.767-.012-.08.022-.292.105-.43l.775-1.29h18.005c13.987 23.826 22.048 51.548 22.048 81.137 0 .22-.017.438-.017.66zM224.44 61.57c-89.896 0-163.03 73.317-163.03 163.433 0 90.117 73.134 163.433 163.03 163.433 89.894 0 163.028-73.316 163.028-163.433 0-90.116-73.134-163.434-163.03-163.434z',
	        fill: '#C78C2F'
	      }),
	      _react2.default.createElement('path', { d: 'M224.442 9.783C106.066 9.783 9.762 106.328 9.762 225c0 118.672 96.304 215.217 214.68 215.217 118.374 0 214.68-96.545 214.68-215.217 0-118.672-96.306-215.217-214.68-215.217m0 440.217C100.687 450 .002 349.064.002 225S100.687 0 224.442 0C348.198 0 448.88 100.936 448.88 225S348.198 450 224.442 450' })
	    )
	  );
	};
	
	exports.default = Pangea;

/***/ },
/* 132 */
14,
/* 133 */
12,
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CHANNEL = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isFunction = __webpack_require__(688);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isPlainObject = __webpack_require__(286);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _createBroadcast = __webpack_require__(536);
	
	var _createBroadcast2 = _interopRequireDefault(_createBroadcast);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* globals React$Element */
	
	
	// NOTE: DO NOT CHANGE, changing this is a semver major change!
	var babelPluginFlowReactPropTypes_proptype_Broadcast = __webpack_require__(536).babelPluginFlowReactPropTypes_proptype_Broadcast || __webpack_require__(8).any;
	
	var CHANNEL = exports.CHANNEL = '__styled-components__';
	
	if (true) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Theme', {
	  value: __webpack_require__(8).shape({})
	});
	
	/**
	 * Provide a theme to an entire react component tree via context and event listeners (have to do
	 * both context and event emitter as pure components block context updates)
	 */
	var ThemeProvider = function (_Component) {
	  _inherits(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    _classCallCheck(this, ThemeProvider);
	
	    var _this = _possibleConstructorReturn(this, (ThemeProvider.__proto__ || Object.getPrototypeOf(ThemeProvider)).call(this));
	
	    _this.getTheme = _this.getTheme.bind(_this);
	    return _this;
	  }
	
	  _createClass(ThemeProvider, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
	      // with the outer theme
	      if (this.context[CHANNEL]) {
	        var subscribe = this.context[CHANNEL];
	        this.unsubscribeToOuter = subscribe(function (theme) {
	          _this2.outerTheme = theme;
	        });
	      }
	      this.broadcast = (0, _createBroadcast2.default)(this.getTheme());
	    }
	  }, {
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return _extends({}, this.context, _defineProperty({}, CHANNEL, this.broadcast.subscribe));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.theme !== nextProps.theme) this.broadcast.publish(this.getTheme(nextProps.theme));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.context[CHANNEL]) {
	        this.unsubscribeToOuter();
	      }
	    }
	
	    // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
	
	  }, {
	    key: 'getTheme',
	    value: function getTheme(passedTheme) {
	      var theme = passedTheme || this.props.theme;
	      if ((0, _isFunction2.default)(theme)) {
	        var mergedTheme = theme(this.outerTheme);
	        if (!(0, _isPlainObject2.default)(mergedTheme)) {
	          throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
	        }
	        return mergedTheme;
	      }
	      if (!(0, _isPlainObject2.default)(theme)) {
	        throw new Error('[ThemeProvider] Please make your theme prop a plain object');
	      }
	      return _extends({}, this.outerTheme, theme);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.children) {
	        return null;
	      }
	      return _react2.default.Children.only(this.props.children);
	    }
	  }]);
	
	  return ThemeProvider;
	}(_react.Component);
	
	ThemeProvider.propTypes = {
	  children: __webpack_require__(8).any,
	  theme: __webpack_require__(8).oneOfType([__webpack_require__(8).shape({}), __webpack_require__(8).func]).isRequired
	};
	
	
	ThemeProvider.childContextTypes = _defineProperty({}, CHANNEL, _propTypes2.default.func.isRequired);
	ThemeProvider.contextTypes = _defineProperty({}, CHANNEL, _propTypes2.default.func);
	
	exports.default = ThemeProvider;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(187);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 136 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 137 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(135);
	var IE8_DOM_DEFINE = __webpack_require__(589);
	var toPrimitive = __webpack_require__(604);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(105) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 139 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 140 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 141 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// returns a style object with a single concated prefixed value string
	
	exports.default = function (property, value) {
	  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
	    return prefix + value;
	  } : arguments[2];
	  return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
	    return replacer(prefix, value);
	  }));
	};
	
	module.exports = exports['default'];

/***/ },
/* 142 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.get_phone_code = get_phone_code;
	exports.get_national_number_pattern = get_national_number_pattern;
	exports.get_formats = get_formats;
	exports.get_national_prefix = get_national_prefix;
	exports.get_national_prefix_formatting_rule = get_national_prefix_formatting_rule;
	exports.get_national_prefix_for_parsing = get_national_prefix_for_parsing;
	exports.get_national_prefix_transform_rule = get_national_prefix_transform_rule;
	exports.get_national_prefix_is_optional_when_formatting = get_national_prefix_is_optional_when_formatting;
	exports.get_leading_digits = get_leading_digits;
	exports.get_format_pattern = get_format_pattern;
	exports.get_format_format = get_format_format;
	exports.get_format_leading_digits_patterns = get_format_leading_digits_patterns;
	exports.get_format_national_prefix_formatting_rule = get_format_national_prefix_formatting_rule;
	exports.get_format_national_prefix_is_optional_when_formatting = get_format_national_prefix_is_optional_when_formatting;
	exports.get_format_national_prefix_is_mandatory_when_formatting = get_format_national_prefix_is_mandatory_when_formatting;
	exports.get_format_international_format = get_format_international_format;
	exports.get_metadata_by_country_phone_code = get_metadata_by_country_phone_code;
	exports.get_types = get_types;
	exports.get_type_fixed_line = get_type_fixed_line;
	exports.get_type_mobile = get_type_mobile;
	exports.get_type_toll_free = get_type_toll_free;
	exports.get_type_premium_rate = get_type_premium_rate;
	exports.get_type_personal_number = get_type_personal_number;
	exports.get_type_voice_mail = get_type_voice_mail;
	exports.get_type_uan = get_type_uan;
	exports.get_type_pager = get_type_pager;
	exports.get_type_voip = get_type_voip;
	exports.get_type_shared_cost = get_type_shared_cost;
	function get_phone_code(country_metadata) {
		return country_metadata[0];
	}
	
	function get_national_number_pattern(country_metadata) {
		return country_metadata[1];
	}
	
	function get_formats(country_metadata) {
		return country_metadata[2] || [];
	}
	
	function get_national_prefix(country_metadata) {
		return country_metadata[3];
	}
	
	function get_national_prefix_formatting_rule(country_metadata) {
		return country_metadata[4];
	}
	
	function get_national_prefix_for_parsing(country_metadata) {
		var national_prefix_for_parsing = country_metadata[5];
	
		// If `national_prefix_for_parsing` is not set explicitly,
		// then infer it from `national_prefix` (if any)
		if (!national_prefix_for_parsing) {
			national_prefix_for_parsing = get_national_prefix(country_metadata);
		}
	
		return national_prefix_for_parsing;
	}
	
	function get_national_prefix_transform_rule(country_metadata) {
		return country_metadata[6];
	}
	
	function get_national_prefix_is_optional_when_formatting(country_metadata) {
		return country_metadata[7];
	}
	
	function get_leading_digits(country_metadata) {
		return country_metadata[8];
	}
	
	function get_format_pattern(format_array) {
		return format_array[0];
	}
	
	function get_format_format(format_array) {
		return format_array[1];
	}
	
	function get_format_leading_digits_patterns(format_array) {
		return format_array[2] || [];
	}
	
	function get_format_national_prefix_formatting_rule(format_array, country_metadata) {
		return format_array[3] || get_national_prefix_formatting_rule(country_metadata);
	}
	
	function get_format_national_prefix_is_optional_when_formatting(format_array, country_metadata) {
		return format_array[4] || get_national_prefix_is_optional_when_formatting(country_metadata);
	}
	
	function get_format_national_prefix_is_mandatory_when_formatting(format_array, country_metadata) {
		var national_prefix_formatting_rule = get_format_national_prefix_formatting_rule(format_array, country_metadata);
	
		// National prefix is omitted if there's no national prefix formatting rule
		// set for this country, or when the national prefix formatting rule
		// contains no national prefix itself, or when this rule is set but
		// national prefix is optional for this phone number format
		// (and it is not enforced explicitly)
		return national_prefix_formatting_rule &&
		// Check that national prefix formatting rule is not a dummy one
		national_prefix_formatting_rule !== '$1' &&
		// Check that national prefix formatting rule actually has national prefix digit(s)
		/\d/.test(national_prefix_formatting_rule.replace('$1', '')) &&
		// Or maybe national prefix is optional for this format
		!get_format_national_prefix_is_optional_when_formatting(format_array, country_metadata);
	}
	
	function get_format_international_format(format_array) {
		return format_array[5] || get_format_format(format_array);
	}
	
	// Formatting information for regions which share
	// a country calling code is contained by only one region
	// for performance reasons. For example, for NANPA region
	// ("North American Numbering Plan Administration",
	//  which includes USA, Canada, Cayman Islands, Bahamas, etc)
	// it will be contained in the metadata for `US`.
	function get_metadata_by_country_phone_code(country_phone_code, metadata) {
		var country_code = metadata.country_phone_code_to_countries[country_phone_code][0];
		return metadata.countries[country_code];
	}
	
	function get_types(country_metadata) {
		return country_metadata[9];
	}
	
	function get_type(country_metadata, index) {
		return get_types(country_metadata) ? get_types(country_metadata)[index] : undefined;
	}
	
	function get_type_fixed_line(country_metadata) {
		return get_type(country_metadata, 0);
	}
	
	function get_type_mobile(country_metadata) {
		return get_type(country_metadata, 1);
	}
	
	function get_type_toll_free(country_metadata) {
		return get_type(country_metadata, 2);
	}
	
	function get_type_premium_rate(country_metadata) {
		return get_type(country_metadata, 3);
	}
	
	function get_type_personal_number(country_metadata) {
		return get_type(country_metadata, 4);
	}
	
	function get_type_voice_mail(country_metadata) {
		return get_type(country_metadata, 5);
	}
	
	function get_type_uan(country_metadata) {
		return get_type(country_metadata, 6);
	}
	
	function get_type_pager(country_metadata) {
		return get_type(country_metadata, 7);
	}
	
	function get_type_voip(country_metadata) {
		return get_type(country_metadata, 8);
	}
	
	function get_type_shared_cost(country_metadata) {
		return get_type(country_metadata, 9);
	}
	//# sourceMappingURL=metadata.js.map

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Adds two values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Number}
	 * @see R.subtract
	 * @example
	 *
	 *      R.add(2, 3);       //=>  5
	 *      R.add(7)(10);      //=> 17
	 */
	module.exports = _curry2(function add(a, b) {
	  return Number(a) + Number(b);
	});


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the specified
	 * property with the given value. Note that this copies and flattens prototype
	 * properties onto the new object as well. All non-primitive properties are
	 * copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig String -> a -> {k: v} -> {k: v}
	 * @param {String} prop The property name to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except for the changed property.
	 * @see R.dissoc
	 * @example
	 *
	 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry3(function assoc(prop, val, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  result[prop] = val;
	  return result;
	});


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var curryN = __webpack_require__(35);
	
	
	/**
	 * Returns a curried equivalent of the provided function. The curried function
	 * has two unusual capabilities. First, its arguments needn't be provided one
	 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value `R.__` may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is `R.__`, the
	 * following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> a) -> (* -> a)
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curryN
	 * @example
	 *
	 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
	 *
	 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	module.exports = _curry1(function curry(fn) {
	  return curryN(fn.length, fn);
	});


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var curry = __webpack_require__(145);
	
	
	/**
	 * Returns a new function much like the supplied one, except that the first two
	 * arguments' order is reversed.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a -> b -> c -> ... -> z) -> (b -> a -> c -> ... -> z)
	 * @param {Function} fn The function to invoke with its first two parameters reversed.
	 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
	 * @example
	 *
	 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
	 *
	 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
	 * @symb R.flip(f)(a, b, c) = f(b, a, c)
	 */
	module.exports = _curry1(function flip(fn) {
	  return curry(function(a, b) {
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = b;
	    args[1] = a;
	    return fn.apply(this, args);
	  });
	});


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(55);
	var _isPlaceholder = __webpack_require__(149);
	
	
	/**
	 * Internal curryN function.
	 *
	 * @private
	 * @category Function
	 * @param {Number} length The arity of the curried function.
	 * @param {Array} received An array of arguments received thus far.
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curryN(length, received, fn) {
	  return function() {
	    var combined = [];
	    var argsIdx = 0;
	    var left = length;
	    var combinedIdx = 0;
	    while (combinedIdx < received.length || argsIdx < arguments.length) {
	      var result;
	      if (combinedIdx < received.length &&
	          (!_isPlaceholder(received[combinedIdx]) ||
	           argsIdx >= arguments.length)) {
	        result = received[combinedIdx];
	      } else {
	        result = arguments[argsIdx];
	        argsIdx += 1;
	      }
	      combined[combinedIdx] = result;
	      if (!_isPlaceholder(result)) {
	        left -= 1;
	      }
	      combinedIdx += 1;
	    }
	    return left <= 0 ? fn.apply(this, combined)
	                     : _arity(left, _curryN(length, combined, fn));
	  };
	};


/***/ },
/* 148 */
/***/ function(module, exports) {

	module.exports = function _isFunction(x) {
	  return Object.prototype.toString.call(x) === '[object Function]';
	};


/***/ },
/* 149 */
/***/ function(module, exports) {

	module.exports = function _isPlaceholder(a) {
	  return a != null &&
	         typeof a === 'object' &&
	         a['@@functional/placeholder'] === true;
	};


/***/ },
/* 150 */
/***/ function(module, exports) {

	module.exports = function _isString(x) {
	  return Object.prototype.toString.call(x) === '[object String]';
	};


/***/ },
/* 151 */
/***/ function(module, exports) {

	module.exports = function _map(fn, functor) {
	  var idx = 0;
	  var len = functor.length;
	  var result = Array(len);
	  while (idx < len) {
	    result[idx] = fn(functor[idx]);
	    idx += 1;
	  }
	  return result;
	};


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var map = __webpack_require__(43);
	
	
	/**
	 * Returns a lens for the given getter and setter functions. The getter "gets"
	 * the value of the focus; the setter "sets" the value of the focus. The setter
	 * should not mutate the data structure.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
	 * @param {Function} getter
	 * @param {Function} setter
	 * @return {Lens}
	 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lens(R.prop('x'), R.assoc('x'));
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	module.exports = _curry2(function lens(getter, setter) {
	  return function(toFunctorFn) {
	    return function(target) {
	      return map(
	        function(focus) {
	          return setter(focus, target);
	        },
	        toFunctorFn(getter(target))
	      );
	    };
	  };
	});


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var liftN = __webpack_require__(444);
	
	
	/**
	 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
	 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.liftN
	 * @example
	 *
	 *      var madd3 = R.lift((a, b, c) => a + b + c);
	 *
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 *
	 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
	 *
	 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
	 */
	module.exports = _curry1(function lift(fn) {
	  return liftN(fn.length, fn);
	});


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly `n` parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} n The desired arity of the new function.
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity `n`.
	 * @example
	 *
	 *      var takesTwoArgs = (a, b) => [a, b];
	 *
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      var takesOneArg = R.nAry(1, takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only `n` arguments are passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.nAry(0, f)(a, b) = f()
	 * @symb R.nAry(1, f)(a, b) = f(a)
	 * @symb R.nAry(2, f)(a, b) = f(a, b)
	 */
	module.exports = _curry2(function nAry(n, fn) {
	  switch (n) {
	    case 0: return function() {return fn.call(this);};
	    case 1: return function(a0) {return fn.call(this, a0);};
	    case 2: return function(a0, a1) {return fn.call(this, a0, a1);};
	    case 3: return function(a0, a1, a2) {return fn.call(this, a0, a1, a2);};
	    case 4: return function(a0, a1, a2, a3) {return fn.call(this, a0, a1, a2, a3);};
	    case 5: return function(a0, a1, a2, a3, a4) {return fn.call(this, a0, a1, a2, a3, a4);};
	    case 6: return function(a0, a1, a2, a3, a4, a5) {return fn.call(this, a0, a1, a2, a3, a4, a5);};
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6);};
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);};
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);};
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);};
	    default: throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
	  }
	});


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(147);
	var _dispatchable = __webpack_require__(24);
	var _has = __webpack_require__(39);
	var _reduce = __webpack_require__(49);
	var _xreduceBy = __webpack_require__(795);
	
	
	/**
	 * Groups the elements of the list according to the result of calling
	 * the String-returning function `keyFn` on each element and reduces the elements
	 * of each group to a single value via the reducer function `valueFn`.
	 *
	 * This function is basically a more general `groupBy` function.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
	 * @param {Function} valueFn The function that reduces the elements of each group to a single
	 *        value. Receives two values, accumulator for a particular group and the current element.
	 * @param {*} acc The (initial) accumulator value for each group.
	 * @param {Function} keyFn The function that maps the list's element into a key.
	 * @param {Array} list The array to group.
	 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
	 *         `valueFn` for elements which produced that key when passed to `keyFn`.
	 * @see R.groupBy, R.reduce
	 * @example
	 *
	 *      var reduceToNamesBy = R.reduceBy((acc, student) => acc.concat(student.name), []);
	 *      var namesByGrade = reduceToNamesBy(function(student) {
	 *        var score = student.score;
	 *        return score < 65 ? 'F' :
	 *               score < 70 ? 'D' :
	 *               score < 80 ? 'C' :
	 *               score < 90 ? 'B' : 'A';
	 *      });
	 *      var students = [{name: 'Lucy', score: 92},
	 *                      {name: 'Drew', score: 85},
	 *                      // ...
	 *                      {name: 'Bart', score: 62}];
	 *      namesByGrade(students);
	 *      // {
	 *      //   'A': ['Lucy'],
	 *      //   'B': ['Drew']
	 *      //   // ...,
	 *      //   'F': ['Bart']
	 *      // }
	 */
	module.exports = _curryN(4, [], _dispatchable([], _xreduceBy,
	  function reduceBy(valueFn, valueAcc, keyFn, list) {
	    return _reduce(function(acc, elt) {
	      var key = keyFn(elt);
	      acc[key] = valueFn(_has(key, acc) ? acc[key] : valueAcc, elt);
	      return acc;
	    }, {}, list);
	  }));


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var _complement = __webpack_require__(428);
	var _curry2 = __webpack_require__(2);
	var filter = __webpack_require__(204);
	
	
	/**
	 * The complement of `filter`.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.filter, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isOdd = (n) => n % 2 === 1;
	 *
	 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(function reject(pred, filterable) {
	  return filter(_complement(pred), filterable);
	});


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var _isString = __webpack_require__(150);
	
	
	/**
	 * Returns a new list or string with the elements or characters in reverse
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {Array|String}
	 * @example
	 *
	 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
	 *      R.reverse([1, 2]);     //=> [2, 1]
	 *      R.reverse([1]);        //=> [1]
	 *      R.reverse([]);         //=> []
	 *
	 *      R.reverse('abc');      //=> 'cba'
	 *      R.reverse('ab');       //=> 'ba'
	 *      R.reverse('a');        //=> 'a'
	 *      R.reverse('');         //=> ''
	 */
	module.exports = _curry1(function reverse(list) {
	  return _isString(list) ? list.split('').reverse().join('') :
	                           Array.prototype.slice.call(list, 0).reverse();
	});


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactNotifyResize = __webpack_require__(1016);
	
	var _join = __webpack_require__(32);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _toMoment = __webpack_require__(33);
	
	var _toMoment2 = _interopRequireDefault(_toMoment);
	
	var _reactStyleNormalizer = __webpack_require__(525);
	
	var _reactStyleNormalizer2 = _interopRequireDefault(_reactStyleNormalizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MINUTES = Array.apply(null, new Array(60)).map(function (_, index) {
	  return index;
	});
	
	var toUpperFirst = function toUpperFirst(str) {
	  return str ? str.charAt(0).toUpperCase() + str.substr(1) : '';
	};
	
	var transformStyle = (0, _reactStyleNormalizer2.default)({ transform: '' });
	
	var rotateTickStyle = function rotateTickStyle(tick, _ref, totalSize, offset) {
	  var width = _ref.width;
	  var height = _ref.height;
	
	  var result = (0, _objectAssign2.default)({}, transformStyle);
	  var deg = tick * 6;
	
	  var transform = 'translate3d(' + -width / 2 + 'px, ' + -height / 2 + 'px, 0px) ' + ('rotate(' + deg + 'deg) translate3d(0px, -' + offset + 'px, 0px)');
	
	  Object.keys(result).forEach(function (name) {
	    result[name] = transform;
	  });
	
	  return result;
	};
	
	var Clock = function (_Component) {
	  _inherits(Clock, _Component);
	
	  function Clock(props) {
	    _classCallCheck(this, Clock);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Clock).call(this, props));
	
	    var time = void 0;
	    var seconds = void 0;
	
	    if (props.defaultSeconds) {
	      seconds = props.defaultSeconds == true ? Date.now() / 1000 : +props.defaultSeconds;
	    }
	
	    if (props.defaultTime) {
	      time = props.defaultTime == true ? Date.now() : +props.defaultTime;
	    }
	
	    // if (time === undefined) {
	    //   seconds = 0
	    // }
	
	    _this.state = {};
	
	    if (seconds !== undefined) {
	      _this.state.seconds = seconds;
	      _this.state.defaultSeconds = seconds;
	    }
	
	    if (time !== undefined) {
	      _this.state.time = time;
	      _this.state.defaultTime = time;
	    }
	    return _this;
	  }
	
	  _createClass(Clock, [{
	    key: 'shouldRun',
	    value: function shouldRun(props) {
	      props = props || this.props;
	
	      if (props.run === false) {
	        return false;
	      }
	
	      return !!(props.defaultSeconds || props.defaultTime);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.shouldRun(this.props)) {
	        this.start();
	      }
	
	      if (this.props.size == 'auto') {
	        this.setState({
	          rendered: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var currentRun = this.shouldRun(this.props);
	      var nextRun = this.shouldRun(nextProps);
	
	      if (!currentRun && nextRun) {
	        this.start();
	      } else if (currentRun && !nextRun) {
	        this.stop();
	      }
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      this.startTime = Date.now ? Date.now() : +new Date();
	
	      this.run();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (this.timeoutId) {
	        clearTimeout(this.timeoutId);
	      }
	    }
	  }, {
	    key: 'run',
	    value: function run() {
	      var _this2 = this;
	
	      this.timeoutId = setTimeout(function () {
	        _this2.update();
	        _this2.run();
	      }, this.props.updateInterval || 1000);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var now = Date.now ? Date.now() : +new Date();
	      var diff = now - this.startTime;
	
	      var seconds = this.getPropsSeconds();
	
	      if (seconds !== undefined) {
	        this.setSeconds(seconds + diff / 1000);
	        return;
	      }
	
	      var time = this.getPropsTime();
	
	      this.setTime(time + diff);
	    }
	  }, {
	    key: 'setSeconds',
	    value: function setSeconds(seconds) {
	      this.setState({
	        seconds: seconds
	      });
	
	      if (this.props.onSecondsChange) {
	        this.props.onSecondsChange(seconds);
	      }
	    }
	  }, {
	    key: 'setTime',
	    value: function setTime(time) {
	      this.setState({
	        time: time
	      });
	
	      if (this.props.onTimeChange) {
	        this.props.onTimeChange(time);
	      }
	    }
	  }, {
	    key: 'getPropsTime',
	    value: function getPropsTime() {
	      return this.props.time || this.state.defaultTime || 0;
	    }
	  }, {
	    key: 'getPropsSeconds',
	    value: function getPropsSeconds() {
	      return this.props.seconds || this.state.defaultSeconds;
	    }
	  }, {
	    key: 'getSeconds',
	    value: function getSeconds() {
	      return this.state.seconds || this.getPropsSeconds();
	    }
	  }, {
	    key: 'getTime',
	    value: function getTime() {
	      return this.state.time || this.getPropsTime();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = this.p = (0, _objectAssign2.default)({}, this.props);
	      var size = props.size;
	
	      if (size == 'auto') {
	        this.ignoreRender = false;
	        if (!this.state.rendered) {
	          this.ignoreRender = true;
	        }
	
	        size = props.size = this.state.size;
	      }
	
	      var valueSeconds = this.getSeconds();
	      var valueTime = this.getTime();
	
	      var width = size;
	      var height = size;
	
	      var className = (0, _join2.default)(props.className, 'react-date-picker__clock', 'react-date-picker__clock--theme-' + props.theme);
	
	      var seconds = void 0;
	      var minutes = void 0;
	      var hours = void 0;
	
	      if (valueSeconds != undefined) {
	        seconds = Math.floor(valueSeconds % 60);
	        minutes = valueSeconds / 60 % 60;
	        hours = valueSeconds / 3600 % 24;
	      } else {
	        var mom = (0, _toMoment2.default)(valueTime);
	
	        seconds = mom.seconds();
	        minutes = mom.minutes() + seconds / 60;
	        hours = mom.hours() + minutes / 60;
	      }
	
	      hours *= 5;
	
	      var defaultStyle = {};
	
	      if (props.color) {
	        defaultStyle.borderColor = props.color;
	      }
	
	      var style = (0, _objectAssign2.default)(defaultStyle, props.style, {
	        width: width, height: height, borderWidth: props.borderWidth
	      });
	
	      var divProps = (0, _objectAssign2.default)({}, props);
	
	      delete divProps.bigTickHeight;
	      delete divProps.bigTickOffset;
	      delete divProps.bigTickWidth;
	      delete divProps.borderColor;
	      delete divProps.borderWidth;
	      delete divProps.centerOverlaySize;
	      delete divProps.centerSize;
	      delete divProps.cleanup;
	      delete divProps.defaultSeconds;
	      delete divProps.defaultTime;
	      delete divProps.handHeight;
	      delete divProps.handOffset;
	      delete divProps.handWidth;
	      delete divProps.hourHandDiff;
	      delete divProps.isDatePickerClock;
	      delete divProps.minuteHandDiff;
	      delete divProps.seconds;
	      delete divProps.secondHandDiff;
	      delete divProps.secondHandWidth;
	      delete divProps.showHoursHand;
	      delete divProps.showMinutesHand;
	      delete divProps.showSecondsHand;
	      delete divProps.showSmallTicks;
	      delete divProps.smallTickHeight;
	      delete divProps.smallTickOffset;
	      delete divProps.smallTickWidth;
	      delete divProps.theme;
	      delete divProps.time;
	      delete divProps.tickHeight;
	      delete divProps.tickOffset;
	      delete divProps.tickWidth;
	
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(divProps);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, divProps, {
	          className: className,
	          style: style
	        }),
	        this.renderCenter(),
	        this.renderHourHand(hours),
	        this.renderMinuteHand(minutes),
	        this.renderSecondHand(seconds),
	        this.renderCenterOverlay(),
	        MINUTES.map(this.renderTick),
	        this.props.size == 'auto' && _react2.default.createElement(_reactNotifyResize.NotifyResize, { notifyOnMount: true, onResize: this.onResize })
	      );
	    }
	  }, {
	    key: 'renderCenter',
	    value: function renderCenter() {
	      var props = this.props;
	      var centerSize = props.centerSize || (props.bigTickHeight || props.tickHeight) * 3;
	
	      return _react2.default.createElement('div', {
	        className: 'react-date-picker__clock-center',
	        style: { width: centerSize, height: centerSize }
	      });
	    }
	  }, {
	    key: 'renderCenterOverlay',
	    value: function renderCenterOverlay() {
	      var props = this.props;
	      var centerOverlaySize = props.centerOverlaySize || props.handWidth * 4;
	
	      return _react2.default.createElement('div', {
	        className: 'react-date-picker__clock-overlay',
	        style: {
	          width: centerOverlaySize,
	          height: centerOverlaySize,
	          borderWidth: props.handWidth
	        }
	      });
	    }
	  }, {
	    key: 'onResize',
	    value: function onResize(_ref2) {
	      var width = _ref2.width;
	      var height = _ref2.height;
	
	      if (width != height) {
	        console.warn('Clock width != height. Please make sure it\'s a square.');
	      }
	
	      this.setState({
	        size: width
	      });
	    }
	  }, {
	    key: 'renderSecondHand',
	    value: function renderSecondHand(value) {
	      return this.props.showSecondsHand && this.renderHand('second', value);
	    }
	  }, {
	    key: 'renderMinuteHand',
	    value: function renderMinuteHand(value) {
	      return this.props.showMinutesHand && this.renderHand('minute', value);
	    }
	  }, {
	    key: 'renderHourHand',
	    value: function renderHourHand(value) {
	      return this.props.showHoursHand && this.renderHand('hour', value);
	    }
	  }, {
	    key: 'renderHand',
	    value: function renderHand(name, value) {
	      if (this.ignoreRender) {
	        return null;
	      }
	
	      var props = this.p;
	      var size = props.size;
	      var borderWidth = props.borderWidth;
	
	
	      var height = props[name + 'HandHeight'] || props.handHeight || size / 2 - props[name + 'HandDiff'];
	
	      var width = props[name + 'HandWidth'] || props.handWidth || props.tickWidth;
	      var offset = props[name + 'HandOffset'] || props.handOffset;
	
	      if (!offset && offset != 0) {
	        offset = 5;
	      }
	
	      var style = rotateTickStyle(value, { width: width, height: height }, size - borderWidth, height / 2 - offset);
	      style.width = width;
	      style.height = height;
	
	      if (props.color) {
	        style.background = props.color;
	      }
	
	      var className = (0, _join2.default)('react-date-picker__clock-hand', 'react-date-picker__clock-hand-' + name);
	
	      var renderName = 'render' + toUpperFirst(name) + 'Hand';
	
	      if (props[renderName]) {
	        return props[renderName]({
	          key: name,
	          className: className,
	          style: style
	        });
	      }
	
	      return _react2.default.createElement('div', { key: name, className: className, style: style });
	    }
	  }, {
	    key: 'renderTick',
	    value: function renderTick(tick) {
	      if (this.ignoreRender) {
	        return null;
	      }
	
	      var _p = this.p;
	      var size = _p.size;
	      var borderWidth = _p.borderWidth;
	      var tickWidth = _p.tickWidth;
	      var smallTickWidth = _p.smallTickWidth;
	      var bigTickWidth = _p.bigTickWidth;
	      var tickHeight = _p.tickHeight;
	      var smallTickHeight = _p.smallTickHeight;
	      var bigTickHeight = _p.bigTickHeight;
	      var tickOffset = _p.tickOffset;
	      var smallTickOffset = _p.smallTickOffset;
	      var bigTickOffset = _p.bigTickOffset;
	
	
	      var small = !!(tick % 5);
	      var sizeName = small ? 'small' : 'big';
	
	      if (small && !this.props.showSmallTicks) {
	        return false;
	      }
	
	      var className = (0, _join2.default)('react-date-picker__clock-tick', 'react-date-picker__clock-tick--' + sizeName);
	
	      var offset = small ? smallTickOffset || tickOffset : bigTickOffset || tickOffset;
	
	      var tWidth = small ? smallTickWidth || tickWidth : bigTickWidth || tickWidth;
	
	      var tHeight = small ? smallTickHeight || tickHeight : bigTickHeight || tickHeight;
	
	      var totalSize = size - borderWidth;
	      var style = rotateTickStyle(tick, {
	        width: tWidth,
	        height: tHeight
	      }, totalSize, totalSize / 2 - (tHeight / 2 + offset));
	
	      style.height = tHeight;
	      style.width = tWidth;
	
	      if (this.props.color) {
	        style.background = this.props.color;
	      }
	
	      if (this.props.renderTick) {
	        return this.props.renderTick({
	          tick: tick,
	          className: className,
	          style: style
	        });
	      }
	
	      return _react2.default.createElement('div', { key: tick, className: className, style: style });
	    }
	  }]);
	
	  return Clock;
	}(_reactClass2.default);
	
	exports.default = Clock;
	
	
	Clock.defaultProps = {
	
	  centerSize: null,
	  centerOverlaySize: null,
	
	  size: 150,
	  theme: 'default',
	
	  showSecondsHand: true,
	  showHoursHand: true,
	  showMinutesHand: true,
	
	  handWidth: 2,
	  secondHandWidth: 1,
	  handOffset: 10,
	
	  hourHandDiff: 35,
	  minuteHandDiff: 25,
	  secondHandDiff: 10,
	
	  tickWidth: 1,
	  bigTickWidth: 2,
	  tickOffset: 2,
	
	  smallTickHeight: 6,
	  bigTickHeight: 10,
	
	  color: '',
	  borderWidth: 0,
	  showSmallTicks: true,
	  isDatePickerClock: true
	};

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderFooter = exports.NAV_KEYS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(58);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _clampRange = __webpack_require__(475);
	
	var _clampRange2 = _interopRequireDefault(_clampRange);
	
	var _toMoment = __webpack_require__(33);
	
	var _toMoment2 = _interopRequireDefault(_toMoment);
	
	var _join = __webpack_require__(32);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _isInRange = __webpack_require__(477);
	
	var _isInRange2 = _interopRequireDefault(_isInRange);
	
	var _NavBar = __webpack_require__(160);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _Footer = __webpack_require__(217);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bemFactory = __webpack_require__(84);
	
	var _bemFactory2 = _interopRequireDefault(_bemFactory);
	
	var _joinFunctions = __webpack_require__(117);
	
	var _joinFunctions2 = _interopRequireDefault(_joinFunctions);
	
	var _assignDefined = __webpack_require__(83);
	
	var _assignDefined2 = _interopRequireDefault(_assignDefined);
	
	var _BasicMonthView = __webpack_require__(466);
	
	var _BasicMonthView2 = _interopRequireDefault(_BasicMonthView);
	
	var _onKeyDown = __webpack_require__(472);
	
	var _onKeyDown2 = _interopRequireDefault(_onKeyDown);
	
	var _navKeys = __webpack_require__(471);
	
	var _navKeys2 = _interopRequireDefault(_navKeys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TODAY = void 0;
	
	var RENDER_DAY = function RENDER_DAY(props) {
	  var divProps = (0, _objectAssign2.default)({}, props);
	
	  delete divProps.date;
	  delete divProps.dateMoment;
	  delete divProps.day;
	  delete divProps.isAfterMaxDate;
	  delete divProps.isBeforeMinDate;
	  delete divProps.inRange;
	  delete divProps.timestamp;
	
	  return _react2.default.createElement('div', divProps);
	};
	
	var isDateInMinMax = function isDateInMinMax(timestamp, props) {
	  if (props.minDate && timestamp < props.minDate) {
	    return false;
	  }
	
	  if (props.maxDate && timestamp > props.maxDate) {
	    return false;
	  }
	
	  return true;
	};
	
	var _isValidActiveDate = function _isValidActiveDate(timestamp, props) {
	  if (!props) {
	    throw new Error('props is mandatory in isValidActiveDate');
	  }
	
	  var dayProps = props.dayPropsMap[timestamp];
	
	  if (dayProps && dayProps.disabled) {
	    return false;
	  }
	
	  return isDateInMinMax(timestamp, props);
	};
	
	var _isInView = function _isInView(mom, props) {
	  if (!props) {
	    throw new Error('props is mandatory in isInView');
	  }
	
	  var daysInView = props.daysInView;
	
	  return (0, _isInRange2.default)(mom, { range: daysInView, inclusive: true });
	};
	
	var prepareViewDate = function prepareViewDate(props, state) {
	  var viewDate = props.viewDate === undefined ? state.viewDate : props.viewDate;
	
	  if (!viewDate && props.moment) {
	    return (0, _toMoment2.default)(props.moment);
	  }
	
	  return viewDate;
	};
	
	var prepareDate = function prepareDate(props, state) {
	  if (props.range) {
	    return null;
	  }
	
	  return props.date === undefined ? state.date : props.date;
	};
	
	var prepareRange = function prepareRange(props, state) {
	  if (props.moment) {
	    return null;
	  }
	
	  return props.partialRange ? props.range || state.range : state.range || props.range;
	};
	
	var prepareActiveDate = function prepareActiveDate(props, state) {
	  var fallbackDate = prepareDate(props, state) || (prepareRange(props, state) || [])[0];
	
	  var activeDate = props.activeDate === undefined ?
	  // only fallback to date if activeDate not specified
	  state.activeDate || fallbackDate : props.activeDate;
	
	  var daysInView = props.daysInView;
	
	  if (activeDate && daysInView && props.constrainActiveInView) {
	    var activeMoment = this.toMoment(activeDate);
	
	    if (!_isInView(activeMoment, props)) {
	      var date = fallbackDate;
	      var dateMoment = this.toMoment(date);
	
	      if (date && _isInView(dateMoment, props) && _isValidActiveDate(+dateMoment, props)) {
	        return date;
	      }
	
	      return null;
	    }
	  }
	
	  return _isValidActiveDate(+activeDate, props) ? activeDate : null;
	};
	
	var _renderFooter = function renderFooter(props, buttonHandlers) {
	  if (!props.footer) {
	    return null;
	  }
	
	  buttonHandlers = buttonHandlers || props;
	
	  var renderFooter = props.renderFooter;
	
	  var footerFnProps = {
	    onTodayClick: buttonHandlers.onFooterTodayClick,
	    onClearClick: buttonHandlers.onFooterClearClick,
	    onOkClick: buttonHandlers.onFooterOkClick,
	    onCancelClick: buttonHandlers.onFooterCancelClick
	  };
	
	  var childFooter = _react2.default.Children.toArray(props.children).filter(function (c) {
	    return c && c.props && c.props.isDatePickerFooter;
	  })[0];
	
	  var childFooterProps = childFooter ? childFooter.props : null;
	
	  if (childFooterProps) {
	    // also take into account the props on childFooter
	    // so we merge those with the other props already built
	    Object.keys(footerFnProps).forEach(function (key) {
	      if (childFooter.props[key]) {
	        footerFnProps[key] = (0, _joinFunctions2.default)(footerFnProps[key], childFooter.props[key]);
	      }
	    });
	  }
	
	  var footerProps = (0, _assignDefined2.default)({}, footerFnProps, {
	    todayButton: props.todayButton,
	    todayButtonText: props.todayButtonText,
	    clearButton: props.clearButton,
	    clearButtonText: props.clearButtonText,
	
	    okButton: props.okButton === undefined && !props.insideField ? false : props.okButton,
	
	    okButtonText: props.okButtonText,
	
	    cancelButton: props.cancelButton === undefined && !props.insideField ? false : props.cancelButton,
	
	    cancelButtonText: props.cancelButtonText,
	
	    clearDate: props.clearDate || props.footerClearDate,
	
	    selectDate: props.selectDate
	  });
	
	  if (childFooter) {
	    if (renderFooter) {
	      return renderFooter((0, _objectAssign2.default)({}, childFooter.props, footerProps));
	    }
	
	    return _react2.default.cloneElement(childFooter, footerProps);
	  }
	
	  if (renderFooter) {
	    return renderFooter(footerProps);
	  }
	
	  return _react2.default.createElement(_Footer2.default, footerProps);
	};
	
	var MonthView = function (_Component) {
	  _inherits(MonthView, _Component);
	
	  _createClass(MonthView, [{
	    key: 'isInView',
	    value: function isInView(mom, props) {
	      return _isInView(mom, props || this.p);
	    }
	  }]);
	
	  function MonthView(props) {
	    _classCallCheck(this, MonthView);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(MonthView).call(this, props));
	
	    _this.state = {
	      range: props.defaultRange,
	      date: props.defaultDate,
	      hoverRange: props.defaultHoverRange,
	      activeDate: props.defaultActiveDate,
	      viewDate: props.defaultViewDate
	    };
	    return _this;
	  }
	
	  _createClass(MonthView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateBem(this.props);
	      this.updateToMoment(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.defaultClassName != this.props.defaultClassName) {
	        this.updateBem(nextProps);
	      }
	
	      this.updateToMoment(nextProps);
	    }
	  }, {
	    key: 'updateBem',
	    value: function updateBem(props) {
	      this.bem = (0, _bemFactory2.default)(props.defaultClassName);
	    }
	  }, {
	    key: 'updateToMoment',
	    value: function updateToMoment(props) {
	      this.toMoment = function (value, dateFormat) {
	        return (0, _toMoment2.default)(value, {
	          locale: props.locale,
	          dateFormat: dateFormat || props.dateFormat
	        });
	      };
	
	      TODAY = +this.toMoment().startOf('day');
	    }
	  }, {
	    key: 'prepareClassName',
	    value: function prepareClassName(props) {
	      return (0, _join2.default)(props.className, this.bem(), this.bem(null, 'theme-' + props.theme));
	    }
	  }, {
	    key: 'prepareProps',
	    value: function prepareProps(thisProps, state) {
	      var _this2 = this;
	
	      var props = this.p = (0, _objectAssign2.default)({}, thisProps);
	
	      state = state || this.state;
	
	      props.hoverRange = props.hoverRange === undefined ? this.state.hoverRange : props.hoverRange;
	
	      props.dayPropsMap = {};
	      props.className = this.prepareClassName && this.prepareClassName(props);
	
	      var minDate = props.minDate;
	      var maxDate = props.maxDate;
	
	
	      if (minDate) {
	        props.minDateMoment = this.toMoment(props.minDate).startOf('day');
	        props.minDate = +props.minDateMoment;
	      }
	
	      if (maxDate) {
	        props.maxDateMoment = this.toMoment(props.maxDate);
	        props.maxDate = +props.maxDateMoment;
	      }
	
	      var date = prepareDate(props, state);
	
	      if (date) {
	        props.moment = props.moment || (props.range ? null : this.toMoment(date).startOf('day'));
	        props.timestamp = props.moment ? +props.moment : null;
	      }
	
	      props.viewMoment = props.viewMoment || this.toMoment(prepareViewDate(props, state));
	
	      if (props.constrainViewDate && props.minDate && props.viewMoment.isBefore(props.minDate)) {
	        props.minConstrained = true;
	        props.viewMoment = this.toMoment(props.minDate);
	      }
	
	      if (props.constrainViewDate && props.maxDate && props.viewMoment.isAfter(props.maxDate)) {
	        props.maxConstrained = true;
	        props.viewMoment = this.toMoment(props.maxDate);
	      }
	
	      props.viewMonthStart = this.toMoment(props.viewMoment).startOf('month');
	      props.viewMonthEnd = this.toMoment(props.viewMoment).endOf('month');
	
	      var range = prepareRange(props, state);
	
	      if (range) {
	        props.range = range.map(function (d) {
	          return _this2.toMoment(d).startOf('day');
	        });
	        props.rangeStart = state.rangeStart || (props.range.length == 1 ? props.range[0] : null);
	      }
	
	      props.daysInView = (0, _BasicMonthView.getDaysInMonthView)(props.viewMoment, props);
	
	      var activeDate = prepareActiveDate.call(this, props, state);
	
	      if (activeDate) {
	        props.activeDate = +this.toMoment(activeDate).startOf('day');
	      }
	
	      return props;
	    }
	  }, {
	    key: 'getViewMoment',
	    value: function getViewMoment() {
	      return this.p.viewMoment;
	    }
	  }, {
	    key: 'getViewSize',
	    value: function getViewSize() {
	      return 1;
	    }
	
	    // handleViewMouseLeave(){
	    //   this.state.range && this.setState({ range: null })
	    // }
	
	  }, {
	    key: 'preparePrevNextClassName',
	    value: function preparePrevNextClassName(timestamp, props) {
	      var viewMonthStart = props.viewMonthStart;
	      var viewMonthEnd = props.viewMonthEnd;
	
	
	      var before = timestamp < viewMonthStart;
	      var after = timestamp > viewMonthEnd;
	
	      var thisMonth = !before && !after;
	
	      return (0, _join2.default)(timestamp == TODAY && this.bem('day--today'), props.highlightToday && timestamp == TODAY && this.bem('day--today-highlight'), before && this.bem('day--prev-month'), before && !props.showDaysBeforeMonth && this.bem('day--hidden'), after && this.bem('day--next-month'), after && !props.showDaysAfterMonth && this.bem('day--hidden'), thisMonth && this.bem('day--this-month'));
	    }
	  }, {
	    key: 'prepareMinMaxProps',
	    value: function prepareMinMaxProps(timestamp, props) {
	      var classes = [];
	
	      var isBeforeMinDate = false;
	      var isAfterMaxDate = false;
	
	      var minDate = props.minDate;
	      var maxDate = props.maxDate;
	
	
	      if (minDate && timestamp < minDate) {
	        classes.push(this.bem('day--disabled-min'));
	        isBeforeMinDate = true;
	      }
	
	      if (maxDate && timestamp > maxDate) {
	        classes.push(this.bem('day--disabled-max'));
	        isAfterMaxDate = true;
	      }
	
	      return {
	        className: (0, _join2.default)(classes),
	        isBeforeMinDate: isBeforeMinDate,
	        isAfterMaxDate: isAfterMaxDate,
	        disabled: isBeforeMinDate || isAfterMaxDate
	      };
	    }
	  }, {
	    key: 'prepareWeekendClassName',
	    value: function prepareWeekendClassName(dateMoment, _ref) {
	      var highlightWeekends = _ref.highlightWeekends;
	
	      // const props = this.p
	      var weekDay = dateMoment.day();
	
	      // const weekendStartDay = getWeekendStartDay(props)
	
	      if (weekDay === 0 /* Sunday */ || weekDay === 6 /* Saturday */) {
	          // if (weekDay === weekendStartDay || weekDay === weekendStartDay + 1) {
	          return (0, _join2.default)(this.bem('day--weekend'), highlightWeekends && this.bem('day--weekend-highlight'));
	        }
	
	      return '';
	    }
	  }, {
	    key: 'prepareRangeProps',
	    value: function prepareRangeProps(dateMoment, props) {
	      var inRange = false;
	
	      var className = [];
	
	      var hoverRange = props.hoverRange;
	      var range = props.range;
	
	
	      if (range) {
	        var _range = _slicedToArray(range, 2);
	
	        var rangeStart = _range[0];
	        var rangeEnd = _range[1];
	
	
	        if (!range.length) {
	          rangeStart = props.rangeStart;
	        }
	
	        // const rangeName = !props.partialRange ? 'hover-range' : 'range'
	        var rangeName = 'range'; //hoverRange ? 'range' : 'hover-range'
	
	        if (rangeStart && dateMoment.isSame(rangeStart)) {
	          className.push(this.bem('day--' + rangeName + '-start'));
	          className.push(this.bem('day--in-' + rangeName));
	
	          if (!rangeEnd) {
	            className.push(this.bem('day--' + rangeName + '-end'));
	          }
	
	          inRange = true;
	        }
	
	        if (rangeEnd && dateMoment.isSame(rangeEnd)) {
	          className.push(this.bem('day--' + rangeName + '-end'));
	          className.push(this.bem('day--in-' + rangeName));
	
	          inRange = true;
	        }
	
	        if (!inRange && (0, _isInRange2.default)(dateMoment, range)) {
	          className.push(this.bem('day--in-' + rangeName));
	
	          inRange = true;
	        }
	      }
	
	      if (range && range.length < 2 && hoverRange && (0, _isInRange2.default)(dateMoment, hoverRange)) {
	        className.push(this.bem('day--in-hover-range'));
	
	        if (dateMoment.isSame(hoverRange[0])) {
	          className.push(this.bem('day--hover-range-start'));
	        }
	
	        if (dateMoment.isSame(hoverRange[1])) {
	          className.push(this.bem('day--hover-range-end'));
	        }
	      }
	
	      return {
	        inRange: inRange,
	        className: (0, _join2.default)(className)
	      };
	    }
	  }, {
	    key: 'prepareDayProps',
	    value: function prepareDayProps(renderDayProps, props) {
	      var timestamp = renderDayProps.timestamp;
	      var dateMoment = renderDayProps.dateMoment;
	      var className = renderDayProps.className;
	
	
	      props = props || this.p;
	      var result = {};
	
	      var minMaxProps = this.prepareMinMaxProps(timestamp, props);
	      var rangeProps = this.prepareRangeProps(dateMoment, props);
	
	      var weekendClassName = this.prepareWeekendClassName(dateMoment, props);
	      var prevNextClassName = this.preparePrevNextClassName(timestamp, props);
	
	      var currentTimestamp = props.timestamp;
	
	      (0, _objectAssign2.default)(result, minMaxProps, rangeProps, {
	        children: _react2.default.createElement(
	          'div',
	          { className: this.bem('day-text') },
	          renderDayProps.day
	        ),
	        className: (0, _join2.default)([minMaxProps.className, rangeProps.className, prevNextClassName, weekendClassName, timestamp == currentTimestamp ? this.bem('day--value') : null, timestamp == props.activeDate ? this.bem('day--active') : null, className])
	      });
	
	      if (!result.disabled && props.isDisabledDay) {
	        result.disabled = props.isDisabledDay(renderDayProps, props);
	      }
	
	      return result;
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      var domNode = (0, _reactDom.findDOMNode)(this);
	
	      if (domNode) {
	        domNode.focus();
	      }
	    }
	  }, {
	    key: 'onDayTextMouseEnter',
	    value: function onDayTextMouseEnter(_ref2) {
	      var dateMoment = _ref2.dateMoment;
	      var timestamp = _ref2.timestamp;
	
	      if (!this.state.focused) {
	        this.focus();
	      }
	
	      this.onActiveDateChange({ dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }, {
	    key: 'renderDay',
	    value: function renderDay(renderProps) {
	      var _this3 = this;
	
	      var props = this.p;
	
	      var _renderProps = renderProps;
	      var dateMoment = _renderProps.dateMoment;
	      var timestamp = _renderProps.timestamp;
	
	
	      (0, _objectAssign2.default)(renderProps, this.prepareDayProps(renderProps, props));
	
	      if (props.range && props.highlightRangeOnMouseMove) {
	        renderProps.onMouseEnter = this.handleDayMouseEnter.bind(this, renderProps);
	      }
	
	      if (typeof props.onRenderDay === 'function') {
	        renderProps = props.onRenderDay(renderProps);
	      }
	
	      if (renderProps.disabled) {
	        renderProps.className = (0, _join2.default)(this.bem('day--disabled'), renderProps.className);
	      } else {
	        (function () {
	          var eventParam = { dateMoment: dateMoment, timestamp: timestamp };
	
	          var onClick = _this3.handleClick.bind(_this3, eventParam);
	          var prevOnClick = renderProps.onClick;
	
	          renderProps.onClick = prevOnClick ? function () {
	            prevOnClick.apply(undefined, arguments);
	            onClick.apply(undefined, arguments);
	          } : onClick;
	
	          if (props.activateOnHover && _this3.props.activeDate !== null) {
	            (function () {
	              var onMouseEnter = _this3.onDayTextMouseEnter.bind(_this3, eventParam);
	              var prevOnMouseEnter = renderProps.onMouseEnter;
	
	              renderProps.onMouseEnter = prevOnMouseEnter ? function () {
	                prevOnMouseEnter.apply(undefined, arguments);
	                onMouseEnter.apply(undefined, arguments);
	              } : onMouseEnter;
	            })();
	          }
	        })();
	      }
	
	      props.dayPropsMap[timestamp] = renderProps;
	
	      var renderFunction = props.renderDay || RENDER_DAY;
	
	      var result = renderFunction(renderProps);
	
	      if (result === undefined) {
	        result = RENDER_DAY(renderProps);
	      }
	
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = this.p = this.prepareProps(this.props);
	
	      var basicViewProps = (0, _objectAssign2.default)({}, props);
	
	      delete basicViewProps.activeDate;
	      delete basicViewProps.activateOnHover;
	      delete basicViewProps.arrows;
	
	      delete basicViewProps.cleanup;
	      delete basicViewProps.clockTabIndex;
	      delete basicViewProps.constrainViewDate;
	      delete basicViewProps.constrainActiveInView;
	      delete basicViewProps.dayPropsMap;
	      delete basicViewProps.date;
	      delete basicViewProps.defaultActiveDate;
	      delete basicViewProps.defaultDate;
	      delete basicViewProps.defaultRange;
	      delete basicViewProps.defaultViewDate;
	
	      delete basicViewProps.enableHistoryView;
	
	      delete basicViewProps.focusOnFooterMouseDown;
	      delete basicViewProps.focusOnNavMouseDown;
	      delete basicViewProps.footer;
	      delete basicViewProps.footerClearDate;
	
	      delete basicViewProps.getTransitionTime;
	
	      delete basicViewProps.highlightRangeOnMouseMove;
	      delete basicViewProps.highlightToday;
	      delete basicViewProps.highlightWeekends;
	      delete basicViewProps.hoverRange;
	
	      delete basicViewProps.index;
	      delete basicViewProps.insideField;
	      delete basicViewProps.insideMultiView;
	      delete basicViewProps.isDatePicker;
	      delete basicViewProps.isDisabledDay;
	
	      delete basicViewProps.maxConstrained;
	      delete basicViewProps.maxDate;
	      delete basicViewProps.maxDateMoment;
	      delete basicViewProps.minConstrained;
	      delete basicViewProps.minDate;
	      delete basicViewProps.minDateMoment;
	
	      delete basicViewProps.navBarArrows;
	      delete basicViewProps.navNext;
	      delete basicViewProps.navigation;
	      delete basicViewProps.navigate;
	      delete basicViewProps.navOnDateClick;
	      delete basicViewProps.navPrev;
	      delete basicViewProps.onActiveDateChange;
	      delete basicViewProps.onChange;
	      delete basicViewProps.onHoverRangeChange;
	      delete basicViewProps.onRangeChange;
	      delete basicViewProps.onViewDateChange;
	      delete basicViewProps.onTransitionStart;
	
	      delete basicViewProps.partialRange;
	      delete basicViewProps.range;
	      delete basicViewProps.rangeStart;
	      delete basicViewProps.renderNavBar;
	
	      delete basicViewProps.select;
	      delete basicViewProps.showDaysAfterMonth;
	      delete basicViewProps.showDaysBeforeMonth;
	
	      delete basicViewProps.theme;
	
	      delete basicViewProps.viewDate;
	      delete basicViewProps.viewMonthEnd;
	      delete basicViewProps.viewMonthStart;
	
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(basicViewProps);
	      }
	
	      return _react2.default.createElement(_BasicMonthView2.default, _extends({
	        tabIndex: 0
	      }, basicViewProps, {
	
	        renderChildren: this.renderChildren,
	
	        onKeyDown: this.onViewKeyDown,
	        onFocus: this.onFocus,
	        onBlur: this.onBlur,
	
	        renderDay: this.renderDay,
	        viewMoment: props.viewMoment,
	        onMouseLeave: props.highlightRangeOnMouseMove && this.handleViewMouseLeave
	      }));
	    }
	  }, {
	    key: 'handleViewMouseLeave',
	    value: function handleViewMouseLeave(event) {
	      if (this.props.onMouseLeave) {
	        this.props.onMouseLeave(event);
	      }
	
	      if (this.state.hoverRange) {
	        this.setHoverRange(null);
	      }
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren(children) {
	      var props = this.p;
	      var navBar = this.renderNavBar(props);
	      var footer = this.renderFooter(props);
	
	      var result = [navBar, children, footer];
	
	      if (props.renderChildren) {
	        return props.renderChildren(result);
	      }
	
	      return result;
	    }
	  }, {
	    key: 'focusFromFooter',
	    value: function focusFromFooter() {
	      if (!this.isFocused() && this.props.focusOnFooterMouseDown) {
	        this.focus();
	      }
	    }
	  }, {
	    key: 'onFooterTodayClick',
	    value: function onFooterTodayClick() {
	      this.focusFromFooter();
	
	      if (this.props.onFooterTodayClick) {
	        if (this.props.onFooterTodayClick() === false) {
	          return;
	        }
	      }
	
	      this.select({ dateMoment: this.toMoment(Date.now()) });
	    }
	  }, {
	    key: 'onFooterClearClick',
	    value: function onFooterClearClick() {
	      this.focusFromFooter();
	
	      if (this.props.onFooterClearClick) {
	        if (this.props.onFooterClearClick() === false) {
	          return;
	        }
	      }
	
	      this.select({ dateMoment: null });
	    }
	  }, {
	    key: 'onFooterOkClick',
	    value: function onFooterOkClick() {
	      this.focusFromFooter();
	
	      if (this.props.onFooterOkClick) {
	        this.props.onFooterOkClick();
	      }
	    }
	  }, {
	    key: 'onFooterCancelClick',
	    value: function onFooterCancelClick() {
	      if (this.props.onFooterCancelClick) {
	        this.props.onFooterCancelClick();
	      }
	    }
	  }, {
	    key: 'renderFooter',
	    value: function renderFooter(props) {
	      return _renderFooter((0, _objectAssign2.default)({}, props, {
	        selectDate: this.select,
	        owner: this
	      }), this);
	    }
	  }, {
	    key: 'renderNavBar',
	    value: function renderNavBar(props) {
	      var _this4 = this;
	
	      var theme = props.theme;
	
	      var childNavBar = _react2.default.Children.toArray(props.children).filter(function (c) {
	        return c && c.props && c.props.isDatePickerNavBar;
	      })[0];
	
	      var ref = function ref(navBar) {
	        _this4.navBar = navBar;
	      };
	
	      if (!childNavBar) {
	        if (props.navigation || props.renderNavBar) {
	          return this.renderNavBarComponent((0, _assignDefined2.default)({
	            // prevDisabled,
	            // nextDisabled,
	            minDate: props.minDate,
	            maxDate: props.maxDate,
	            theme: theme,
	            secondary: true,
	            date: props.moment,
	            viewMoment: props.viewMoment,
	            onViewDateChange: this.onNavViewDateChange,
	            onMouseDown: this.onNavMouseDown,
	            arrows: props.navBarArrows,
	            ref: ref
	          }, {
	            enableHistoryView: props.enableHistoryView
	          }));
	        }
	
	        return null;
	      }
	
	      var navBarProps = (0, _objectAssign2.default)({}, childNavBar.props, (0, _assignDefined2.default)({
	        viewMoment: props.viewMoment,
	        date: props.moment,
	        theme: theme,
	        ref: ref,
	        minDate: props.minDate,
	        maxDate: props.maxDate
	      }, {
	        enableHistoryView: props.enableHistoryView
	      }));
	
	      var prevOnViewDateChange = navBarProps.onViewDateChange;
	      var onViewDateChange = this.onViewDateChange;
	
	      if (prevOnViewDateChange) {
	        onViewDateChange = function onViewDateChange() {
	          prevOnViewDateChange.apply(undefined, arguments);
	          _this4.onNavViewDateChange.apply(_this4, arguments);
	        };
	      }
	
	      navBarProps.onViewDateChange = onViewDateChange;
	
	      var prevOnMouseDown = navBarProps.onMouseDown;
	      var onMouseDown = this.onNavMouseDown;
	
	      if (prevOnMouseDown) {
	        onMouseDown = function onMouseDown() {
	          prevOnMouseDown.apply(undefined, arguments);
	          _this4.onNavMouseDown.apply(_this4, arguments);
	        };
	      }
	
	      navBarProps.onMouseDown = onMouseDown;
	
	      if (navBarProps) {
	        return this.renderNavBarComponent(navBarProps);
	      }
	
	      return null;
	    }
	  }, {
	    key: 'onNavMouseDown',
	    value: function onNavMouseDown(event) {
	      if (this.props.focusOnNavMouseDown && !this.isFocused()) {
	        this.focus();
	      }
	    }
	  }, {
	    key: 'renderNavBarComponent',
	    value: function renderNavBarComponent(navBarProps) {
	      if (this.props.renderNavBar) {
	        return this.props.renderNavBar(navBarProps);
	      }
	
	      return _react2.default.createElement(_NavBar2.default, navBarProps);
	    }
	  }, {
	    key: 'isFocused',
	    value: function isFocused() {
	      return this.state.focused;
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(event) {
	      this.setState({
	        focused: true
	      });
	
	      this.props.onFocus(event);
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(event) {
	      this.setState({
	        focused: false
	      });
	
	      this.hideHistoryView();
	
	      this.props.onBlur(event);
	    }
	  }, {
	    key: 'showHistoryView',
	    value: function showHistoryView() {
	      if (this.navBar) {
	        this.navBar.showHistoryView();
	      }
	    }
	  }, {
	    key: 'hideHistoryView',
	    value: function hideHistoryView() {
	      if (this.navBar) {
	        this.navBar.hideHistoryView();
	      }
	    }
	  }, {
	    key: 'isHistoryViewVisible',
	    value: function isHistoryViewVisible() {
	      if (this.navBar) {
	        return this.navBar.isHistoryViewVisible();
	      }
	
	      return false;
	    }
	  }, {
	    key: 'tryNavBarKeyDown',
	    value: function tryNavBarKeyDown(event) {
	      if (this.navBar && this.navBar.getHistoryView) {
	        var historyView = this.navBar.getHistoryView();
	
	        if (historyView && historyView.onKeyDown) {
	          historyView.onKeyDown(event);
	          return true;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'onViewKeyDown',
	    value: function onViewKeyDown(event) {
	      if (this.tryNavBarKeyDown(event)) {
	        return;
	      }
	
	      return _onKeyDown2.default.call(this, event);
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm(date, event) {
	      event.preventDefault();
	
	      if (this.props.confirm) {
	        return this.props.confirm(date, event);
	      }
	
	      var dateMoment = this.toMoment(date);
	
	      this.select({ dateMoment: dateMoment, timestamp: +dateMoment }, event);
	
	      return undefined;
	    }
	  }, {
	    key: 'navigate',
	    value: function navigate(dir, event) {
	      var _this5 = this;
	
	      var props = this.p;
	
	      var getNavigationDate = function getNavigationDate(dir, date, dateFormat) {
	        var mom = _moment2.default.isMoment(date) ? date : _this5.toMoment(date, dateFormat);
	
	        return typeof dir == 'function' ? dir(mom) : mom.add(dir, 'day');
	      };
	
	      if (props.navigate) {
	        return props.navigate(dir, event, getNavigationDate);
	      }
	
	      event.preventDefault();
	
	      if (props.activeDate) {
	        var nextMoment = getNavigationDate(dir, props.activeDate);
	
	        this.gotoViewDate({ dateMoment: nextMoment });
	      }
	
	      return undefined;
	    }
	  }, {
	    key: 'handleDayMouseEnter',
	    value: function handleDayMouseEnter(dayProps) {
	      var props = this.p;
	
	      var rangeStart = props.rangeStart;
	      var range = props.range;
	
	
	      var partial = !!(rangeStart && range.length < 2);
	
	      if (partial) {
	        this.setHoverRange((0, _clampRange2.default)([rangeStart, dayProps.dateMoment]));
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(_ref3, event) {
	      var timestamp = _ref3.timestamp;
	      var dateMoment = _ref3.dateMoment;
	
	      var props = this.p;
	
	      if (props.minDate && timestamp < props.minDate) {
	        return;
	      }
	
	      if (props.maxDate && timestamp > props.maxDate) {
	        return;
	      }
	
	      event.target.value = timestamp;
	
	      this.select({ dateMoment: dateMoment, timestamp: timestamp }, event);
	    }
	  }, {
	    key: 'select',
	    value: function select(_ref4, event) {
	      var dateMoment = _ref4.dateMoment;
	      var timestamp = _ref4.timestamp;
	
	      if (dateMoment && timestamp === undefined) {
	        timestamp = +dateMoment;
	      }
	
	      if (this.props.select) {
	        return this.props.select({ dateMoment: dateMoment, timestamp: timestamp }, event);
	      }
	
	      if (!timestamp) {
	        timestamp = +dateMoment;
	      }
	
	      this.gotoViewDate({ dateMoment: dateMoment, timestamp: timestamp });
	
	      var props = this.p;
	      var range = props.range;
	
	      if (range) {
	        this.selectRange({ dateMoment: dateMoment, timestamp: timestamp }, event);
	      } else {
	        this.onChange({ dateMoment: dateMoment, timestamp: timestamp }, event);
	      }
	
	      return undefined;
	    }
	  }, {
	    key: 'selectRange',
	    value: function selectRange(_ref5, event) {
	      var dateMoment = _ref5.dateMoment;
	      var timestamp = _ref5.timestamp;
	
	      var props = this.p;
	      var range = props.range;
	      var rangeStart = props.rangeStart;
	
	      if (dateMoment == null) {
	        this.setState({
	          rangeStart: null
	        });
	        this.onRangeChange([], event);
	        return;
	      }
	
	      if (!rangeStart) {
	        this.setState({
	          rangeStart: dateMoment
	        });
	
	        if (range.length == 2) {
	          this.onRangeChange([], event);
	        }
	      } else {
	        this.setState({
	          rangeStart: null
	        });
	
	        this.onRangeChange((0, _clampRange2.default)([rangeStart, dateMoment]), event);
	      }
	    }
	  }, {
	    key: 'format',
	    value: function format(mom) {
	      return mom == null ? '' : mom.format(this.props.dateFormat);
	    }
	  }, {
	    key: 'setHoverRange',
	    value: function setHoverRange(hoverRange) {
	      if (this.props.hoverRange === undefined) {
	        this.setState({
	          hoverRange: hoverRange
	        });
	      }
	
	      if (this.props.onHoverRangeChange) {
	        this.props.onHoverRangeChange(hoverRange);
	      }
	    }
	  }, {
	    key: 'onRangeChange',
	    value: function onRangeChange(range, event) {
	      var _this6 = this;
	
	      this.setState({
	        range: this.props.range === undefined ? range : null
	      });
	
	      this.setHoverRange(null);
	
	      if (this.props.onRangeChange) {
	        var newRange = range.map(function (m) {
	          var dateMoment = _this6.toMoment(m);
	
	          return {
	            dateString: dateMoment.format(_this6.props.dateFormat),
	            dateMoment: dateMoment,
	            timestamp: +dateMoment
	          };
	        });
	
	        var formatted = newRange.map(function (o) {
	          return o.dateString;
	        });
	
	        this.props.onRangeChange(formatted, newRange, event);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(_ref6, event) {
	      var dateMoment = _ref6.dateMoment;
	      var timestamp = _ref6.timestamp;
	
	      if (this.props.date === undefined) {
	        this.setState({
	          date: timestamp
	        });
	      }
	
	      if (this.props.onChange) {
	        var dateString = this.format(dateMoment);
	        this.props.onChange(dateString, { dateMoment: dateMoment, timestamp: timestamp, dateString: dateString }, event);
	      }
	    }
	  }, {
	    key: 'onNavViewDateChange',
	    value: function onNavViewDateChange(dateString, _ref7) {
	      var dateMoment = _ref7.dateMoment;
	      var timestamp = _ref7.timestamp;
	
	      this.onViewDateChange({ dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }, {
	    key: 'onViewDateChange',
	    value: function onViewDateChange(_ref8) {
	      var dateMoment = _ref8.dateMoment;
	      var timestamp = _ref8.timestamp;
	
	      var minDate = void 0;
	      var maxDate = void 0;
	
	      if (this.p.minDateMoment) {
	        minDate = +this.toMoment(this.p.minDateMoment).startOf('month');
	      }
	      if (this.p.maxDateMoment) {
	        maxDate = +this.toMoment(this.p.maxDateMoment).endOf('month');
	      }
	      if (this.props.constrainViewDate && !isDateInMinMax(timestamp, {
	        minDate: minDate,
	        maxDate: maxDate
	      })) {
	        return;
	      }
	
	      if (this.props.viewDate === undefined && this.props.navOnDateClick) {
	        this.setState({
	          viewDate: timestamp
	        });
	      }
	
	      if (this.props.onViewDateChange) {
	        var dateString = this.format(dateMoment);
	
	        this.props.onViewDateChange(dateString, { dateMoment: dateMoment, dateString: dateString, timestamp: timestamp });
	      }
	    }
	  }, {
	    key: 'isValidActiveDate',
	    value: function isValidActiveDate(date, props) {
	      return _isValidActiveDate(date, props || this.p);
	    }
	  }, {
	    key: 'onActiveDateChange',
	    value: function onActiveDateChange(_ref9) {
	      var dateMoment = _ref9.dateMoment;
	      var timestamp = _ref9.timestamp;
	
	      if (!_isValidActiveDate(timestamp, this.p)) {
	        return;
	      }
	
	      var props = this.p;
	      var range = props.range;
	
	      if (range && props.rangeStart) {
	        var newRange = (0, _clampRange2.default)([props.rangeStart, dateMoment]);
	
	        if (props.partialRange) {
	          this.onRangeChange(newRange);
	        }
	
	        this.setState({
	          rangeStart: props.rangeStart,
	          range: newRange
	        });
	      }
	
	      if (this.props.activeDate === undefined) {
	        this.setState({
	          activeDate: timestamp
	        });
	      }
	
	      if (this.props.onActiveDateChange) {
	        var dateString = this.format(dateMoment);
	        this.props.onActiveDateChange(dateString, { dateMoment: dateMoment, timestamp: timestamp, dateString: dateString });
	      }
	    }
	  }, {
	    key: 'gotoViewDate',
	    value: function gotoViewDate(_ref10) {
	      var dateMoment = _ref10.dateMoment;
	      var timestamp = _ref10.timestamp;
	
	      if (!timestamp) {
	        timestamp = dateMoment == null ? null : +dateMoment;
	      }
	
	      this.onViewDateChange({ dateMoment: dateMoment, timestamp: timestamp });
	      this.onActiveDateChange({ dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }]);
	
	  return MonthView;
	}(_reactClass2.default);
	
	exports.default = MonthView;
	
	
	MonthView.defaultProps = {
	  defaultClassName: 'react-date-picker__month-view',
	  dateFormat: 'YYYY-MM-DD',
	
	  theme: 'default',
	
	  onBlur: function onBlur() {},
	  onFocus: function onFocus() {},
	
	  footerClearDate: null,
	
	  partialRange: true,
	
	  activateOnHover: false,
	  constrainActiveInView: false,
	
	  showDaysBeforeMonth: true,
	  showDaysAfterMonth: true,
	
	  highlightWeekends: true,
	  highlightToday: true,
	
	  navOnDateClick: true,
	  navigation: true,
	
	  constrainViewDate: true,
	  highlightRangeOnMouseMove: false,
	
	  isDatePicker: true,
	
	  enableHistoryView: true,
	  focusOnNavMouseDown: true,
	  focusOnFooterMouseDown: true
	};
	
	MonthView.propTypes = {
	  navOnDateClick: _react.PropTypes.bool,
	  isDisabledDay: _react.PropTypes.func,
	
	  onChange: _react.PropTypes.func,
	  onViewDateChange: _react.PropTypes.func,
	  onActiveDateChange: _react.PropTypes.func
	};
	
	exports.NAV_KEYS = _navKeys2.default;
	exports.renderFooter = _renderFooter;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _reactFlex = __webpack_require__(41);
	
	var _reactInlineBlock = __webpack_require__(122);
	
	var _reactInlineBlock2 = _interopRequireDefault(_reactInlineBlock);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _assignDefined = __webpack_require__(83);
	
	var _assignDefined2 = _interopRequireDefault(_assignDefined);
	
	var _toMoment2 = __webpack_require__(33);
	
	var _toMoment3 = _interopRequireDefault(_toMoment2);
	
	var _join = __webpack_require__(32);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _bemFactory = __webpack_require__(84);
	
	var _bemFactory2 = _interopRequireDefault(_bemFactory);
	
	var _HistoryView = __webpack_require__(470);
	
	var _HistoryView2 = _interopRequireDefault(_HistoryView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ARROWS = {
	  prev: _react2.default.createElement(
	    'svg',
	    { height: '24', viewBox: '0 0 24 24', width: '24' },
	    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' }),
	    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
	  ),
	
	  next: _react2.default.createElement(
	    'svg',
	    { height: '24', viewBox: '0 0 24 24', width: '24' },
	    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' }),
	    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
	  )
	};
	
	var bem = (0, _bemFactory2.default)('react-date-picker__nav-bar');
	
	var NavBar = function (_Component) {
	  _inherits(NavBar, _Component);
	
	  function NavBar(props) {
	    _classCallCheck(this, NavBar);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(NavBar).call(this, props));
	
	    _this.state = {
	      viewDate: props.defaultViewDate
	    };
	    return _this;
	  }
	
	  _createClass(NavBar, [{
	    key: 'prepareViewDate',
	    value: function prepareViewDate(props) {
	      return props.viewDate === undefined ? this.state.viewDate : props.viewDate;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = this.p = (0, _objectAssign2.default)({}, this.props);
	
	      var viewMoment = props.viewMoment = props.viewMoment || this.toMoment(this.prepareViewDate(props));
	
	      props.historyViewEnabled = props.expandedHistoryView || props.enableHistoryView;
	
	      var secondary = props.secondary;
	
	      var className = (0, _join2.default)(props.className, bem(), bem(null, 'theme-' + props.theme), props.historyViewEnabled && bem(null, 'with-history-view'));
	
	      var historyView = props.historyViewEnabled ? this.renderHistoryView() : null;
	
	      var flexProps = (0, _objectAssign2.default)({}, props);
	
	      delete flexProps.arrows;
	      delete flexProps.date;
	      delete flexProps.enableHistoryView;
	      delete flexProps.historyViewEnabled;
	      delete flexProps.isDatePickerNavBar;
	      delete flexProps.minDate;
	      delete flexProps.maxDate;
	      delete flexProps.mainNavBar;
	      delete flexProps.multiView;
	      delete flexProps.navDateFormat;
	      delete flexProps.onNavClick;
	      delete flexProps.onUpdate;
	      delete flexProps.onViewDateChange;
	      delete flexProps.renderNavNext;
	      delete flexProps.renderNavPrev;
	      delete flexProps.secondary;
	      delete flexProps.theme;
	      delete flexProps.viewDate;
	      delete flexProps.viewMoment;
	
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(flexProps);
	      }
	
	      return _react2.default.createElement(
	        _reactFlex.Flex,
	        _extends({ inline: true, row: true }, flexProps, { className: className }),
	        secondary && this.renderNav(-2, viewMoment),
	        this.renderNav(-1, viewMoment),
	        _react2.default.createElement(
	          _reactFlex.Item,
	          {
	            className: bem('date'),
	            style: { textAlign: 'center' },
	            onMouseDown: props.historyViewEnabled ? this.toggleHistoryView : null
	          },
	          this.renderNavDate(viewMoment)
	        ),
	        this.renderNav(1, viewMoment),
	        secondary && this.renderNav(2, viewMoment),
	        historyView
	      );
	    }
	  }, {
	    key: 'renderHistoryView',
	    value: function renderHistoryView() {
	      var _this2 = this;
	
	      if (!this.state.historyView) {
	        return null;
	      }
	
	      var className = bem('history-view');
	      var _p = this.p;
	      var viewMoment = _p.viewMoment;
	      var theme = _p.theme;
	      var minDate = _p.minDate;
	      var maxDate = _p.maxDate;
	
	
	      var historyViewProps = (0, _assignDefined2.default)({
	        defaultViewDate: viewMoment,
	        defaultDate: viewMoment,
	
	        ref: function ref(view) {
	          _this2.historyView = view;
	        },
	        focusDecadeView: false,
	
	        className: className,
	        theme: theme,
	
	        onOkClick: this.onHistoryViewOk,
	        onCancelClick: this.onHistoryViewCancel
	      }, {
	        minDate: minDate,
	        maxDate: maxDate
	      });
	
	      if (this.props.renderHistoryView) {
	        return this.props.renderHistoryView(historyViewProps);
	      }
	
	      return _react2.default.createElement(_HistoryView2.default, historyViewProps);
	    }
	  }, {
	    key: 'toggleHistoryView',
	    value: function toggleHistoryView(event) {
	      if (this.isHistoryViewVisible()) {
	        this.hideHistoryView(event);
	      } else {
	        this.showHistoryView(event);
	      }
	    }
	  }, {
	    key: 'getHistoryView',
	    value: function getHistoryView() {
	      return this.historyView;
	    }
	  }, {
	    key: 'isHistoryViewVisible',
	    value: function isHistoryViewVisible() {
	      return !!this.historyView;
	    }
	  }, {
	    key: 'onHistoryViewOk',
	    value: function onHistoryViewOk(dateString, _ref) {
	      var dateMoment = _ref.dateMoment;
	      var timestamp = _ref.timestamp;
	
	      this.hideHistoryView();
	      this.onViewDateChange({ dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }, {
	    key: 'onHistoryViewCancel',
	    value: function onHistoryViewCancel() {
	      this.hideHistoryView();
	    }
	  }, {
	    key: 'showHistoryView',
	    value: function showHistoryView(event) {
	      event.preventDefault();
	
	      this.setState({
	        historyView: true
	      });
	
	      if (this.props.onShowHistoryView) {
	        this.props.onShowHistoryView();
	      }
	    }
	  }, {
	    key: 'hideHistoryView',
	    value: function hideHistoryView(event) {
	      if (event && event.preventDefault) {
	        event.preventDefault();
	      }
	
	      this.setState({
	        historyView: false
	      });
	
	      if (this.props.onHideHistoryView) {
	        this.props.onHideHistoryView();
	      }
	    }
	  }, {
	    key: 'toMoment',
	    value: function toMoment(value, props) {
	      props = props || this.props;
	
	      return (0, _toMoment3.default)(value, {
	        locale: props.locale,
	        dateFormat: props.dateFormat
	      });
	    }
	  }, {
	    key: 'renderNav',
	    value: function renderNav(dir, viewMoment) {
	      var props = this.p;
	
	      var name = dir < 0 ? 'prev' : 'next';
	      var disabled = dir < 0 ? props.prevDisabled : props.nextDisabled;
	      var secondary = Math.abs(dir) == 2;
	
	      if (dir < 0 && props.minDate) {
	        var gotoMoment = this.getGotoMoment(dir, viewMoment).endOf('month');
	
	        if (gotoMoment.isBefore(this.toMoment(props.minDate))) {
	          disabled = true;
	        }
	      }
	
	      if (dir > 0 && props.maxDate) {
	        var _gotoMoment = this.getGotoMoment(dir, viewMoment).startOf('month');
	
	        if (_gotoMoment.isAfter(this.toMoment(props.maxDate))) {
	          disabled = true;
	        }
	      }
	
	      if (this.state.historyView) {
	        disabled = true;
	      }
	
	      var className = [bem('arrow'), bem('arrow--' + name), secondary && bem('secondary-arrow'), disabled && bem('arrow--disabled')];
	
	      var arrow = props.arrows[dir] || props.arrows[name] || ARROWS[name];
	
	      var children = void 0;
	
	      if (secondary) {
	        var dirArrow = props.arrows[dir];
	
	        if (dirArrow) {
	          children = dirArrow;
	        } else {
	          var secondArrow = _react2.default.createElement(
	            _reactInlineBlock2.default,
	            { style: _defineProperty({ position: 'absolute' }, dir < 0 ? 'left' : 'left', 7) },
	            arrow
	          );
	          children = dir < 0 ? [secondArrow, arrow] : [secondArrow, arrow];
	        }
	      } else {
	        children = arrow;
	      }
	
	      var navProps = {
	        dir: dir,
	        name: name,
	        disabled: disabled,
	        className: (0, _join2.default)(className),
	        onClick: !disabled && this.onNavClick.bind(this, dir, viewMoment),
	        children: children
	      };
	
	      if (props.renderNav) {
	        return props.renderNav(navProps);
	      }
	
	      if (dir < 0 && props.renderNavPrev) {
	        return props.renderNavPrev(navProps);
	      }
	
	      if (dir > 0 && props.renderNavNext) {
	        return props.renderNavNext(navProps);
	      }
	
	      return _react2.default.createElement(_reactInlineBlock2.default, _extends({}, navProps, {
	        disabled: null,
	        name: null
	      }));
	    }
	  }, {
	    key: 'getGotoMoment',
	    value: function getGotoMoment(dir, viewMoment) {
	      viewMoment = viewMoment || this.p.viewMoment;
	
	      var sign = dir < 0 ? -1 : 1;
	      var abs = Math.abs(dir);
	
	      var mom = this.toMoment(viewMoment);
	
	      mom.add(sign, abs == 1 ? 'month' : 'year');
	
	      return mom;
	    }
	  }, {
	    key: 'onNavClick',
	    value: function onNavClick(dir, viewMoment, event) {
	      var props = this.props;
	
	      var dateMoment = this.toMoment(viewMoment);
	
	      if (props.onUpdate) {
	        dateMoment = props.onUpdate(dateMoment, dir);
	      } else {
	        var sign = dir < 0 ? -1 : 1;
	        var abs = Math.abs(dir);
	
	        dateMoment.add(sign, abs == 1 ? 'month' : 'year');
	      }
	
	      var timestamp = +dateMoment;
	
	      props.onNavClick(dir, viewMoment, event);
	
	      var disabled = dir < 0 ? props.prevDisabled : props.nextDisabled;
	
	      if (disabled) {
	        return;
	      }
	
	      this.onViewDateChange({
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: 'renderNavDate',
	    value: function renderNavDate(viewMoment) {
	      var props = this.props;
	      var text = viewMoment.format(props.navDateFormat);
	
	      if (props.renderNavDate) {
	        return props.renderNavDate(viewMoment, text);
	      }
	
	      return text;
	    }
	  }, {
	    key: 'onViewDateChange',
	    value: function onViewDateChange(_ref3) {
	      var dateMoment = _ref3.dateMoment;
	      var timestamp = _ref3.timestamp;
	
	      if (this.props.viewDate === undefined) {
	        this.setState({
	          viewDate: timestamp
	        });
	      }
	
	      if (this.props.onViewDateChange) {
	        var dateString = dateMoment.format(this.props.dateFormat);
	        this.props.onViewDateChange(dateString, { dateString: dateString, dateMoment: dateMoment, timestamp: timestamp });
	      }
	    }
	  }]);
	
	  return NavBar;
	}(_reactClass2.default);
	
	exports.default = NavBar;
	
	
	NavBar.defaultProps = {
	  arrows: {},
	
	  theme: 'default',
	
	  isDatePickerNavBar: true,
	
	  navDateFormat: 'MMM YYYY',
	  enableHistoryView: true,
	  onNavClick: function onNavClick(dir, viewMoment) {},
	
	  onViewDateChange: function onViewDateChange() {}
	};
	
	NavBar.propTypes = {
	  secondary: _react.PropTypes.bool,
	
	  renderNav: _react.PropTypes.func,
	  renderNavPrev: _react.PropTypes.func,
	  renderNavNext: _react.PropTypes.func,
	
	  arrows: _react.PropTypes.object,
	  navDateFormat: _react.PropTypes.string,
	
	  onUpdate: _react.PropTypes.func,
	  onNavClick: _react.PropTypes.func,
	  onViewDateChange: _react.PropTypes.func
	};

/***/ },
/* 161 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (from, to) {
	  if (from) {
	    ['hour', 'minute', 'second', 'millisecond'].forEach(function (part) {
	      to.set(part, from.get ? from.get(part) : from[part]);
	    });
	  }
	
	  return to;
	};

/***/ },
/* 162 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var times = function times(count) {
	  return (count >= 0 ? [].concat(_toConsumableArray(new Array(count))) : []).map(function (v, i) {
	    return i;
	  });
	};
	exports.default = times;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var EventPluginRegistry = __webpack_require__(222);
	var ReactEventEmitterMixin = __webpack_require__(944);
	var ViewportMetrics = __webpack_require__(489);
	
	var getVendorPrefixedEventName = __webpack_require__(976);
	var isEventSupported = __webpack_require__(233);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(121);
	var ViewportMetrics = __webpack_require__(489);
	
	var getEventModifierState = __webpack_require__(231);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(12);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 166 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(40);
	var DOMNamespaces = __webpack_require__(221);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(229);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _captialize = __webpack_require__(1009);
	
	Object.defineProperty(exports, 'captialize', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_captialize).default;
	  }
	});
	
	var _clamp = __webpack_require__(1010);
	
	Object.defineProperty(exports, 'clamp', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_clamp).default;
	  }
	});
	
	var _distanceTo = __webpack_require__(1011);
	
	Object.defineProperty(exports, 'distanceTo', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_distanceTo).default;
	  }
	});
	
	var _isDefined = __webpack_require__(1012);
	
	Object.defineProperty(exports, 'isDefined', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isDefined).default;
	  }
	});
	
	var _isNumber = __webpack_require__(1013);
	
	Object.defineProperty(exports, 'isNumber', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isNumber).default;
	  }
	});
	
	var _isObject = __webpack_require__(1014);
	
	Object.defineProperty(exports, 'isObject', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isObject).default;
	  }
	});
	
	var _length = __webpack_require__(1015);
	
	Object.defineProperty(exports, 'length', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_length).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(73);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(240);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(99);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1021);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(506);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1017);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1032);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1018);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1019);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(508);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1020);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(241);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(1030);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(513);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1023);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1024);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1028);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(510);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _alt = __webpack_require__(551);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alt = new _alt2.default();
	
	_alt2.default.debug('alt', alt);
	window.alt = alt;
	
	module.exports = alt;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n  cursor: pointer;\n'], ['\n  display: inline-block;\n  vertical-align: middle;\n  cursor: pointer;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: inline-block;\n  span {\n    padding-left: ', ';\n  }\n'], ['\n  display: inline-block;\n  span {\n    padding-left: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _CheckboxOn = __webpack_require__(1113);
	
	var _CheckboxOn2 = _interopRequireDefault(_CheckboxOn);
	
	var _CheckboxOff = __webpack_require__(1112);
	
	var _CheckboxOff2 = _interopRequireDefault(_CheckboxOff);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  handleChange: _react.PropTypes.func,
	  checked: _react.PropTypes.bool,
	  id: _react.PropTypes.string
	};
	
	var Icon = _styledComponents2.default.div(_templateObject);
	var CheckboxContainer = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.margins.small);
	
	var Checkbox = function Checkbox(props) {
	  var handleChange = props.handleChange;
	  var id = props.id;
	  var checked = props.checked;
	
	  return _react2.default.createElement(
	    CheckboxContainer,
	    props,
	    _react2.default.createElement(
	      Icon,
	      { onClick: handleChange },
	      checked ? _react2.default.createElement(_CheckboxOn2.default, { id: id }) : _react2.default.createElement(_CheckboxOff2.default, { id: id })
	    )
	  );
	};
	
	Checkbox.propTypes = propTypes;
	
	exports.default = Checkbox;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  max-width: 100vw;\n  overflow-x: scroll;\n\n  .noElements{\n    position: absolute;\n    top: 80px;\n    width: 170px\n    left: calc((100% - 170px)/2 + ', 'px);\n    span {\n      ', ';\n      margin-top: 0;\n    }\n  }\n'], ['\n  position: relative;\n  max-width: 100vw;\n  overflow-x: scroll;\n\n  .noElements{\n    position: absolute;\n    top: 80px;\n    width: 170px\n    left: calc((100% - 170px)/2 + ', 'px);\n    span {\n      ', ';\n      margin-top: 0;\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: block;\n  width: ', ';\n  min-height: calc(\n    100vh - (', ' +\n          ', ')\n  );\n  height: ', ';\n  border-spacing: 0;\n'], ['\n  display: block;\n  width: ', ';\n  min-height: calc(\n    100vh - (', ' +\n          ', ')\n  );\n  height: ', ';\n  border-spacing: 0;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['width: auto;'], ['width: auto;']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  background: ', ';\n  ', ';\n  height: calc(100% - 60px);\n  overflow: hidden;\n  overflow-y: scroll;\n  display: block;\n'], ['\n  background: ', ';\n  ', ';\n  height: calc(100% - 60px);\n  overflow: hidden;\n  overflow-y: scroll;\n  display: block;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  ', ';\n  background: black;\n  height: 60px;\n  padding: 24px ', ';\n  display: block;\n  text-align: left;\n'], ['\n  ', ';\n  background: black;\n  height: 60px;\n  padding: 24px ', ';\n  display: block;\n  text-align: left;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n  position: relative;\n  cursor: pointer;\n  ', ';\n  svg {\n    fill: ', ';\n    position: absolute;\n    top: -5px;\n    margin-left: ', ';\n    &.desc {\n      transform: rotate(180deg);\n    }\n  }\n'], ['\n  ', ';\n  color: ', ';\n  position: relative;\n  cursor: pointer;\n  ', ';\n  svg {\n    fill: ', ';\n    position: absolute;\n    top: -5px;\n    margin-left: ', ';\n    &.desc {\n      transform: rotate(180deg);\n    }\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  padding-left: ', ';\n  padding-right: ', ';\n  display: table-row;\n  height: 60px;\n  cursor: pointer;\n  &:hover {\n    background: ', ';\n  }\n'], ['\n  padding-left: ', ';\n  padding-right: ', ';\n  display: table-row;\n  height: 60px;\n  cursor: pointer;\n  &:hover {\n    background: ', ';\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  vertical-align: middle;\n  height: 60px;\n  border-bottom: solid 1px rgba(72, 72, 72, 0.14);\n  ', ';\n  ', ';\n  svg {\n    height: 50px;\n    &.notFavorite {\n      path {\n        fill: ', ';\n      }\n    }\n  }\n\n  &.title {\n    color: ', ';\n  }\n'], ['\n  vertical-align: middle;\n  height: 60px;\n  border-bottom: solid 1px rgba(72, 72, 72, 0.14);\n  ', ';\n  ', ';\n  svg {\n    height: 50px;\n    &.notFavorite {\n      path {\n        fill: ', ';\n      }\n    }\n  }\n\n  &.title {\n    color: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _immutable = __webpack_require__(29);
	
	var _Themes = __webpack_require__(5);
	
	var _Arrow = __webpack_require__(101);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	var _Loader = __webpack_require__(45);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var rowMargins = 60;
	
	var Container = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.left;
	}, _Themes.Fonts.style.Text);
	
	var TableContainer = _styledComponents2.default.table(_templateObject2, function (props) {
	  return props.width ? props.width + 'px' : '100%';
	}, _Themes.Metrics.components.searchbar, _Themes.Metrics.components.navbarDefault, function (props) {
	  return props.height ? props.height + 'px' : '100%';
	});
	
	var Wrapper = _styledComponents2.default.div(_templateObject3);
	
	var TableBody = _styledComponents2.default.tbody(_templateObject4, _Themes.Colors.white, function (props) {
	  return props.width && 'width: ' + props.width + 'px';
	});
	
	var TableHeader = _styledComponents2.default.thead(_templateObject5, function (props) {
	  return props.width && 'width: ' + props.width + 'px';
	}, _Themes.Metrics.margins.larger);
	
	var HeaderCell = _styledComponents2.default.th(_templateObject6, _Themes.Fonts.style.Input, _Themes.Colors.white, function (props) {
	  return props.width && 'width: ' + props.width + 'px';
	}, _Themes.Colors.primary, _Themes.Metrics.margins.small);
	
	var Row = _styledComponents2.default.tr(_templateObject7, _Themes.Metrics.margins.larger, _Themes.Metrics.margins.larger, _Themes.Colors.lightGrey);
	
	var Cell = _styledComponents2.default.td(_templateObject8, _Themes.Fonts.style.Text, function (props) {
	  return props.width && 'width: ' + props.width + 'px';
	}, _Themes.Colors.black, _Themes.Colors.primary);
	
	var Table = function (_Component) {
	  _inherits(Table, _Component);
	
	  function Table(props) {
	    _classCallCheck(this, Table);
	
	    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));
	
	    _this.state = {
	      leftScroll: 0
	    };
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    _this.handleScrollLeft = _this.handleScrollLeft.bind(_this);
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _props = this.props;
	      var data = _props.data;
	      var canLoadMore = _props.canLoadMore;
	      var isFetching = _props.isFetching;
	      var height = _props.height;
	      var width = _props.width;
	      var selectedElements = _props.selectedElements;
	      var keys = _props.keys;
	
	      if (nextProps.canLoadMore !== canLoadMore || nextProps.isFetching !== isFetching || nextProps.height !== height || nextProps.width !== width || !(0, _immutable.fromJS)(nextProps.data).equals((0, _immutable.fromJS)(data)) || !(0, _immutable.fromJS)(nextProps.keys).equals((0, _immutable.fromJS)(keys)) || selectedElements && !(0, _immutable.fromJS)(nextProps.selectedElements).equals((0, _immutable.fromJS)(selectedElements))) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'handleScrollLeft',
	    value: function handleScrollLeft(event) {
	      var position = document.getElementById('tableContainer').scrollLeft;
	      this.setState({ leftScroll: position });
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll(event) {
	      var _props2 = this.props;
	      var loadMore = _props2.loadMore;
	      var canLoadMore = _props2.canLoadMore;
	      var isFetching = _props2.isFetching;
	
	      var element = document.getElementById('table-body');
	      var hiddenPixels = element.scrollTop;
	      var difference = element.scrollHeight - element.clientHeight;
	      var scrollPrecentage = hiddenPixels / difference * 100;
	
	      if (loadMore && canLoadMore && !isFetching && scrollPrecentage > 90) {
	        loadMore();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var keys = _props3.keys;
	      var height = _props3.height;
	      var data = _props3.data;
	      var rowClick = _props3.rowClick;
	      var handleSort = _props3.handleSort;
	      var isFetching = _props3.isFetching;
	
	      var totalWidth = 0;
	      var headers = keys.length > 0 && keys.map(function (el, index) {
	        totalWidth += el.width;
	        return _react2.default.createElement(
	          HeaderCell,
	          {
	            onClick: function onClick() {
	              return el.onClick ? el.onClick() : handleSort(el);
	            },
	            width: el.width,
	            key: 'key-' + el.key },
	          el.title,
	          el.unit && ' (' + el.unit + ')',
	          el.sort && _react2.default.createElement(_Arrow2.default, { className: '' + (el.sort === 1 && 'desc') })
	        );
	      });
	      totalWidth += rowMargins; // due to the margins
	      totalWidth = totalWidth < window.screen.availWidth ? window.screen.availWidth : totalWidth;
	      var rows = data.length > 0 && keys.length > 0 && data.map(function (el, index) {
	        return _react2.default.createElement(
	          Row,
	          { key: 'row-' + index },
	          keys.map(function (keyObj) {
	            return _react2.default.createElement(
	              Cell,
	              {
	                onClick: function onClick() {
	                  return rowClick(el.id);
	                },
	                key: 'row-' + keyObj.key + '-' + index,
	                className: keyObj.key,
	                width: keyObj.width },
	              keyObj.accessor ? keyObj.accessor(el) : el[keyObj.key]
	            );
	          })
	        );
	      });
	
	      var noElements = data.length === 0 && _react2.default.createElement(
	        'div',
	        { id: 'noElements', className: 'noElements' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'There are no elements'
	        )
	      );
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Loader2.default, { visible: isFetching, width: 100, height: 100 }),
	        _react2.default.createElement(
	          Container,
	          {
	            id: 'tableContainer',
	            onScroll: this.handleScrollLeft,
	            left: this.state.leftScroll },
	          _react2.default.createElement(
	            Wrapper,
	            null,
	            _react2.default.createElement(
	              TableContainer,
	              { height: height, width: totalWidth },
	              _react2.default.createElement(
	                TableHeader,
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  headers
	                )
	              ),
	              _react2.default.createElement(
	                TableBody,
	                { id: 'table-body', onScroll: this.handleScroll },
	                rows
	              )
	            )
	          ),
	          noElements
	        )
	      );
	    }
	  }]);
	
	  return Table;
	}(_react.Component);
	
	Table.propTypes = {
	  keys: _react.PropTypes.array.isRequired,
	  data: _react.PropTypes.array.isRequired,
	  canLoadMore: _react.PropTypes.bool,
	  isFetching: _react.PropTypes.bool,
	  rowClick: _react.PropTypes.func,
	  loadMore: _react.PropTypes.func,
	  height: _react.PropTypes.number,
	  width: _react.PropTypes.number,
	  handleSort: _react.PropTypes.func,
	  selectedElements: _react.PropTypes.array
	};
	
	exports.default = Table;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MobileActions = __webpack_require__(514);
	
	var _MobileActions2 = _interopRequireDefault(_MobileActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var showBackButton = function showBackButton(WrappedComponent) {
	  return function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        _MobileActions2.default.showBackButton();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        _MobileActions2.default.hideBackButton();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	    }]);
	
	    return _class;
	  }(_react.Component);
	};
	
	exports.default = showBackButton;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 395px;\n  background: url(', ')\n    no-repeat center;\n  background-size: cover;\n  display: table;\n  position: relative;\n'], ['\n  width: 100%;\n  height: 395px;\n  background: url(', ')\n    no-repeat center;\n  background-size: cover;\n  display: table;\n  position: relative;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  right: ', ';\n  top: ', ';\n  cursor: pointer;\n  ', ';\n  color: ', ';\n'], ['\n  position: absolute;\n  right: ', ';\n  top: ', ';\n  cursor: pointer;\n  ', ';\n  color: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  background: rgba(255, 255, 255, 0.6);\n  display: table-cell;\n  vertical-align: middle;\n\n  h1 {\n    ', ';\n  }\n\n  p {\n    margin-top: ', ';\n    ', ';\n  }\n'], ['\n  background: rgba(255, 255, 255, 0.6);\n  display: table-cell;\n  vertical-align: middle;\n\n  h1 {\n    ', ';\n  }\n\n  p {\n    margin-top: ', ';\n    ', ';\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  background: rgba(0, 0, 0, 0.3);\n  ', ';\n  text-align: center;\n  color: ', ';\n  text-transform: capitalize;\n  word-break: break-all;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  display: table;\n  cursor: pointer;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.7);\n    color: ', ';\n  }\n'], ['\n  background: rgba(0, 0, 0, 0.3);\n  ', ';\n  text-align: center;\n  color: ', ';\n  text-transform: capitalize;\n  word-break: break-all;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  display: table;\n  cursor: pointer;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.7);\n    color: ', ';\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  display: table-cell;\n  vertical-align: middle;\n'], ['\n  display: table-cell;\n  vertical-align: middle;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  padding-left: 0;\n  padding-right: ', ';\n  overflow: hidden;\n\n  @media screen and (max-width: ', ') {\n    padding-right: 0;\n    display: block;\n    width: 100%;\n  }\n'], ['\n  padding-left: 0;\n  padding-right: ', ';\n  overflow: hidden;\n\n  @media screen and (max-width: ', ') {\n    padding-right: 0;\n    display: block;\n    width: 100%;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  height: 250px;\n  width: 100%;\n  margin-bottom: ', ';\n  display: block;\n  position: relative;\n  overflow: hidden;\n\n  img {\n    transition: 0.3s ease transform;\n    height: 250px;\n    width: 100%;\n    cursor: pointer;\n    background: url(', ')\n      no-repeat center;\n    background-size: cover;\n    margin-bottom: ', ';\n    display: table;\n    position: relative;\n  }\n\n  &:hover {\n    img {\n      transform: scale(1.1);\n      transition: 0.3s ease transform;\n    }\n  }\n'], ['\n  height: 250px;\n  width: 100%;\n  margin-bottom: ', ';\n  display: block;\n  position: relative;\n  overflow: hidden;\n\n  img {\n    transition: 0.3s ease transform;\n    height: 250px;\n    width: 100%;\n    cursor: pointer;\n    background: url(', ')\n      no-repeat center;\n    background-size: cover;\n    margin-bottom: ', ';\n    display: table;\n    position: relative;\n  }\n\n  &:hover {\n    img {\n      transform: scale(1.1);\n      transition: 0.3s ease transform;\n    }\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  text-align: left;\n  position: relative;\n  margin-top: ', ';\n  height: ', ';\n'], ['\n  text-align: left;\n  position: relative;\n  margin-top: ', ';\n  height: ', ';\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  margin-top: 70px;\n  margin-bottom: ', ';\n  ', ';\n  text-align: center;\n'], ['\n  margin-top: 70px;\n  margin-bottom: ', ';\n  ', ';\n  text-align: center;\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  text-align: center;\n  height: calc(100vh - ', ');\n  overflow: scroll;\n  position: relative;\n\n  .loader {\n    position: fixed;\n    background: none;\n    width: 50px;\n    height: 50px;\n    bottom: 50px;\n    left: 20px;\n    top: inherit;\n  }\n  .resultBody {\n    .hidden {\n      display: none !important;\n    }\n\n    .table {\n      text-align: left;\n      margin-top: 70px;\n      height: 500px;\n      tbody {\n        tr {\n          td {\n            svg {\n              height: 50px;\n\n              &.notFavorite {\n                path {\n                  fill: ', ';\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: ', ') {\n    height: calc(100vh - ', ');\n  }\n'], ['\n  text-align: center;\n  height: calc(100vh - ', ');\n  overflow: scroll;\n  position: relative;\n\n  .loader {\n    position: fixed;\n    background: none;\n    width: 50px;\n    height: 50px;\n    bottom: 50px;\n    left: 20px;\n    top: inherit;\n  }\n  .resultBody {\n    .hidden {\n      display: none !important;\n    }\n\n    .table {\n      text-align: left;\n      margin-top: 70px;\n      height: 500px;\n      tbody {\n        tr {\n          td {\n            svg {\n              height: 50px;\n\n              &.notFavorite {\n                path {\n                  fill: ', ';\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: ', ') {\n    height: calc(100vh - ', ');\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _Themes = __webpack_require__(5);
	
	var _Table = __webpack_require__(172);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _america = __webpack_require__(1128);
	
	var _america2 = _interopRequireDefault(_america);
	
	var _default_city = __webpack_require__(524);
	
	var _default_city2 = _interopRequireDefault(_default_city);
	
	var _default_country = __webpack_require__(1122);
	
	var _default_country2 = _interopRequireDefault(_default_country);
	
	var _default_continent = __webpack_require__(1121);
	
	var _default_continent2 = _interopRequireDefault(_default_continent);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _Loader = __webpack_require__(45);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Image = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.image ? props.image : _america2.default;
	});
	
	var Path = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.margins.larger, _Themes.Metrics.margins.larger, _Themes.Fonts.style.Input, _Themes.Colors.black);
	
	var Title = _styledComponents2.default.div(_templateObject3, _Themes.Fonts.style.Title, _Themes.Metrics.margins.large, _Themes.Fonts.style.Header);
	
	var ResultTitleContainer = _styledComponents2.default.div(_templateObject4, _Themes.Fonts.style.Title, _Themes.Colors.white, _Themes.Colors.primary);
	
	var ResultTitle = _styledComponents2.default.div(_templateObject5);
	
	var Result = (0, _styledComponents2.default)(_gridStyled.Third)(_templateObject6, _Themes.Metrics.margins.small, _Themes.Metrics.breakpoints.mobile);
	
	var ResultContainer = _styledComponents2.default.div(_templateObject7, _Themes.Metrics.margins.small, function (props) {
	  switch (props.type) {
	    case 'continent':
	      return _default_continent2.default;
	    case 'country':
	      return _default_country2.default;
	    default:
	      return _default_city2.default;
	  }
	}, _Themes.Metrics.margins.small);
	
	var ResultsContainer = _styledComponents2.default.div(_templateObject8, function (props) {
	  return props.noMarginTop ? 0 : _Themes.Metrics.margins.base;
	}, function (props) {
	  return props.isTable ? 'calc(' + window.innerHeight + 'px - ' + _Themes.Metrics.components.navbarDefault + ')' : 'auto';
	});
	
	var Description = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject9, _Themes.Metrics.margins.big, _Themes.Fonts.style.Text);
	
	var Container = _styledComponents2.default.section(_templateObject10, _Themes.Metrics.components.navbarDefault, _Themes.Colors.darkGrey, _Themes.Metrics.breakpoints.mobile, _Themes.Metrics.components.navbarDefault);
	
	var SearchResult = function (_Component) {
	  _inherits(SearchResult, _Component);
	
	  function SearchResult(props) {
	    _classCallCheck(this, SearchResult);
	
	    var _this = _possibleConstructorReturn(this, (SearchResult.__proto__ || Object.getPrototypeOf(SearchResult)).call(this, props));
	
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(SearchResult, [{
	    key: 'handleScroll',
	    value: function handleScroll() {
	      var _props = this.props;
	      var isFetching = _props.isFetching;
	      var canLoadMore = _props.canLoadMore;
	      var loadMore = _props.loadMore;
	
	      var element = document.getElementById('results-page');
	      var hiddenPixels = element.scrollTop;
	      var difference = element.scrollHeight - element.clientHeight;
	      var scrollPrecentage = hiddenPixels / difference * 100;
	      if (loadMore && canLoadMore && !isFetching && parseInt(scrollPrecentage, 10) > 90) {
	        loadMore();
	      }
	    }
	  }, {
	    key: 'table',
	    value: function table() {
	      var _props2 = this.props;
	      var results = _props2.results;
	      var tableKeys = _props2.tableKeys;
	      var isFetching = _props2.isFetching;
	      var handleClick = _props2.handleClick;
	      var loadMore = _props2.loadMore;
	      var handleSort = _props2.handleSort;
	      var canLoadMore = _props2.canLoadMore;
	      var parent = _props2.parent;
	
	      var width = window.screen.availWidth;
	      var height = window.innerHeight - 60;
	      return _react2.default.createElement(
	        ResultsContainer,
	        {
	          id: 'propertyList',
	          isTable: true,
	          noMarginTop: !parent.description },
	        _react2.default.createElement(_Table2.default, {
	          keys: tableKeys,
	          data: results,
	          isFetching: isFetching,
	          rowClick: handleClick,
	          loadMore: loadMore,
	          width: width,
	          height: height,
	          handleSort: handleSort,
	          canLoadMore: canLoadMore
	        })
	      );
	    }
	  }, {
	    key: 'cards',
	    value: function cards() {
	      var _props3 = this.props;
	      var results = _props3.results;
	      var handleClick = _props3.handleClick;
	      var type = _props3.type;
	
	      return _react2.default.createElement(
	        _ThemeContainer2.default,
	        null,
	        _react2.default.createElement(
	          ResultsContainer,
	          { id: 'results-body' },
	          results.map(function (el, index) {
	            return _react2.default.createElement(
	              Result,
	              {
	                type: type,
	                key: 'result-' + (el.city || el.name) + '-' + index,
	                xs: 1,
	                md: 1 / 2,
	                lg: 1 / 3 },
	              _react2.default.createElement(
	                ResultContainer,
	                { onClick: function onClick() {
	                    return handleClick(el);
	                  } },
	                _react2.default.createElement('img', {
	                  src: el.picture || _default_city2.default,
	                  role: 'presentation'
	                }),
	                _react2.default.createElement(
	                  ResultTitleContainer,
	                  null,
	                  _react2.default.createElement(
	                    ResultTitle,
	                    null,
	                    el.city || el.name
	                  )
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props;
	      var results = _props4.results;
	      var title = _props4.title;
	      var tableKeys = _props4.tableKeys;
	      var path = _props4.path;
	      var router = _props4.router;
	      var isFetching = _props4.isFetching;
	      var parent = _props4.parent;
	
	      var resultpath = path && _react2.default.createElement(
	        Path,
	        null,
	        _react2.default.createElement(
	          'span',
	          {
	            onClick: function onClick() {
	              router.push('/search/region');
	            } },
	          'Home'
	        ),
	        path.continent && _react2.default.createElement(
	          'span',
	          {
	            onClick: function onClick() {
	              router.push('/search/region/' + path.continent);
	            } },
	          ' > ' + path.continent
	        ),
	        path.country && _react2.default.createElement(
	          'span',
	          {
	            onClick: function onClick() {
	              router.push('/search/region/' + path.continent + '/' + path.country);
	            } },
	          ' > ' + path.country
	        ),
	        path.city && _react2.default.createElement(
	          'span',
	          {
	            onClick: function onClick() {
	              router.push('/search/region/' + path.continent + '/' + path.country + '/' + path.city);
	            } },
	          ' > ' + path.city
	        )
	      );
	
	      return _react2.default.createElement(
	        Container,
	        { onScroll: this.handleScroll, id: 'results-page' },
	        _react2.default.createElement(_Loader2.default, { visible: isFetching && !tableKeys, className: 'loader' }),
	        _react2.default.createElement(
	          Image,
	          { image: parent && parent.picture },
	          _react2.default.createElement(
	            Title,
	            null,
	            _react2.default.createElement(
	              'h1',
	              null,
	              title
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              results && results.length,
	              ' Results'
	            )
	          ),
	          resultpath
	        ),
	        parent && parent.description && _react2.default.createElement(
	          Description,
	          null,
	          parent.description
	        ),
	        tableKeys ? this.table() : this.cards()
	      );
	    }
	  }]);
	
	  return SearchResult;
	}(_react.Component);
	
	SearchResult.propTypes = {
	  handleClick: _react.PropTypes.func.isRequired,
	  results: _react.PropTypes.array,
	  title: _react.PropTypes.string,
	  loadMore: _react.PropTypes.func,
	  isFetching: _react.PropTypes.bool,
	  tableKeys: _react.PropTypes.array,
	  handleSort: _react.PropTypes.func,
	  path: _react.PropTypes.object,
	  router: _react.PropTypes.object,
	  canLoadMore: _react.PropTypes.bool,
	  type: _react.PropTypes.string,
	  parent: _react.PropTypes.object
	};
	
	exports.default = SearchResult;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Edit = function Edit(props) {
	  return _react2.default.createElement(
	    'svg',
	    Object.assign({ width: '24', height: '24', viewBox: '0 0 24 24' }, props),
	    _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement('path', {
	        d: 'M8.9524059 20.8334302L21.2074343 8.57840182c1.0567543-1.05675427 1.0567543-2.76986488 0-3.82661915l-1.959217-1.95921697c-1.0567542-1.05675427-2.7698648-1.05675427-3.8266191 0L3.16656977 15.0475941c-.13293927.1329393-.22101863.3040942-.25192638.4895407l-.9020336 5.4122015c-.1017526.6105156.4275383 1.1398065 1.03805383 1.0380539l5.41220156-.9020336c.18544653-.0309077.3566014-.1189871.48954067-.2519264zm-6.19832906-.6255609l1.03805386 1.0380539.9020336-5.4122016-.2519264.4895407L16.6972663 4.06823384c.3522222-.3522222.9230607-.3522222 1.2752829 0l1.959217 1.95921697c.3522222.35222225.3522222.9230607 0 1.2752829L7.67673774 19.5577621l.48954067-.2519264-5.41220153.9020336zm15.29604726-9.7478254c.352266.352266.9234021.352266 1.2756681 0 .3522661-.352266.3522661-.92340212 0-1.27566815l-4.510168-4.51016797c-.352266-.35226603-.9234021-.35226603-1.2756681 0-.352266.35226603-.352266.9234021 0 1.27566814l4.510168 4.51016798zM7.67673774 20.8334302c.35226603.3522661.92340212.3522661 1.27566815 0 .352266-.352266.352266-.9234021 0-1.2756681l-4.510168-4.510168c-.35226605-.352266-.9234021-.352266-1.27566816 0-.35226603.352266-.35226603.9234021 0 1.2756682l4.51016797 4.5101679z',
	        id: 'edit-a'
	      })
	    ),
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { d: 'M0 0h24v24H0z' }),
	      _react2.default.createElement(
	        'mask',
	        { id: 'edit-b', fill: '#fff' },
	        _react2.default.createElement('use', { xlinkHref: '#edit-a' })
	      ),
	      _react2.default.createElement('path', {
	        d: 'M0 0h100v40H0z',
	        mask: 'url(#edit-b)',
	        fill: '#526173',
	        id: 'icon-outline'
	      })
	    )
	  );
	};
	
	exports.default = Edit;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Key = function Key(props) {
	  return _react2.default.createElement(
	    'svg',
	    Object.assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 450 450' }, props),
	    _react2.default.createElement('path', {
	      fill: '#C78C2F',
	      d: 'M216.5 99.9V90c0-1.4-1.2-2.6-2.6-2.6h-16v-5.1h16c1.4 0 2.6-1.2 2.6-2.6s-1.2-2.6-2.6-2.6h-18.6c-1.4 0-2.6 1.2-2.6 2.6V90c0 1.4 1.2 2.6 2.6 2.6h16v4.7h-16c-1.4 0-2.6 1.2-2.6 2.6v22c0 1.4 1.2 2.6 2.6 2.6s2.6-1.2 2.6-2.6v-19.4h16c1.4 0 2.6-1.2 2.6-2.6zm51.6-7.3c1.4 0 2.6-1.2 2.6-2.6V79.6c0-1.4-1.2-2.6-2.6-2.6h-18.6c-1.4 0-2.6 1.2-2.6 2.6s1.2 2.6 2.6 2.6h16v5.1h-16c-1.4 0-2.6 1.2-2.6 2.6v9.9c0 1.4 1.2 2.6 2.6 2.6h16v19.4c0 1.4 1.2 2.6 2.6 2.6 1.4 0 2.6-1.2 2.6-2.6v-22c0-1.4-1.2-2.6-2.6-2.6h-16v-4.7h16zM238.7 63v27c0 1.4 1.2 2.6 2.6 2.6 1.4 0 2.6-1.2 2.6-2.6V63.6c0-6.8-5.5-12.2-12.2-12.2s-12.2 5.5-12.2 12.1V90c0 1.4 1.2 2.6 2.6 2.6 1.4 0 2.6-1.2 2.6-2.6V63.6c0-3.9 3.2-7 7-7 3.6 0 6.6 2.8 7 6.3v.1zm-7 324.8c6.1 0 11-4.9 11-11s-4.9-11-11-11-11 4.9-11 11c0 6 5 11 11 11zm0-16.8c3.2 0 5.8 2.6 5.8 5.8 0 3.2-2.6 5.8-5.8 5.8s-5.8-2.6-5.8-5.8c0-3.2 2.6-5.8 5.8-5.8zm-20.3-19.1c-1.4 0-2.6 1.2-2.6 2.6s1.2 2.6 2.6 2.6c4.5 0 8.2-3.7 8.2-8.2 0-4.5-3.7-8.2-8.2-8.2-7.5 0-13.5 6.1-13.5 13.5s6.1 13.5 13.5 13.5c4.2 0 8.1-2 10.7-5.3.2-.1.4-.3.5-.4l6.1-8.5c.8-1.2.6-2.8-.6-3.6-1.2-.8-2.8-.6-3.6.6l-5.8 8.1c-.1.1-.3.2-.3.3-1.5 2.3-4.1 3.7-6.9 3.7-4.6 0-8.3-3.7-8.3-8.3s3.7-8.3 8.3-8.3c1.6 0 3 1.3 3 3-.1 1.6-1.5 2.9-3.1 2.9z'
	    }),
	    _react2.default.createElement('path', {
	      fill: '#C78C2F',
	      d: 'M275.8 354.6c0-13.5-11-24.4-24.4-24.4-1.4 0-2.6 1.2-2.6 2.6 0 1.4 1.2 2.6 2.6 2.6 10.6 0 19.2 8.6 19.2 19.2s-8.6 19.1-19.1 19.2h-.1c-1.4 0-2.6 1.2-2.6 2.6 0 9.4-7.6 17-17 17s-17-7.6-17-17c0-1.4-1.2-2.6-2.6-2.6h-.1c-10.5-.1-19.1-8.6-19.1-19.2s8.6-19.2 19.2-19.2c1.4 0 2.6-1.2 2.6-2.6 0-1.4-1.2-2.6-2.6-2.6-13.5 0-24.4 11-24.4 24.4 0 12.7 9.7 23 22.1 24.2 1.2 11.1 10.6 19.8 22 19.8s20.8-8.7 22-19.8c12.2-1.2 21.9-11.5 21.9-24.2z'
	    }),
	    _react2.default.createElement('path', {
	      fill: '#C78C2F',
	      d: 'M252.1 340.7c-4.5 0-8.2 3.7-8.2 8.2s3.7 8.2 8.2 8.2c1.4 0 2.6-1.2 2.6-2.6 0-1.4-1.2-2.6-2.6-2.6-1.6 0-3-1.3-3-3s1.3-3 3-3c4.6 0 8.3 3.7 8.3 8.3 0 4.6-3.7 8.3-8.3 8.3-2.8 0-5.4-1.4-6.9-3.7l-.3-.3-30.8-43c3.8-3.7 8.3-4.3 8.4-4.3 1.3-.2 2.3-1.3 2.3-2.6v-187c0-7.8-6.3-14.1-14.2-14.1-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5c1.4 0 2.6-1.2 2.6-2.6 0-1.4-1.2-2.6-2.6-2.6-1.8 0-3.3-1.5-3.3-3.3 0-1.8 1.5-3.3 3.3-3.3 4.9 0 8.9 4 8.9 9.5v184.3c-2.7.8-7.2 2.7-10.8 7.1-.7.9-.8 2.2-.1 3.2l32.3 45.2c.1.2.4.3.5.5 2.6 3.3 6.4 5.3 10.7 5.3 7.5 0 13.5-6.1 13.5-13.5 0-7.5-6.1-13.6-13.5-13.6z'
	    }),
	    _react2.default.createElement('path', {
	      fill: '#C78C2F',
	      d: 'M229.1 314.5c-2.2.4-4.3 1.2-6.1 2.6-1.2.8-1.4 2.5-.6 3.6.8 1.2 2.5 1.4 3.6.6 3.3-2.4 8-2.4 11.3 0 .5.3 1 .5 1.5.5.8 0 1.6-.4 2.1-1.1.8-1.2.6-2.8-.6-3.6-1.8-1.3-3.9-2.2-6.1-2.5V79.7c0-1.4-1.2-2.6-2.6-2.6-1.4 0-2.6 1.2-2.6 2.6l.1 234.8z'
	    }),
	    _react2.default.createElement('path', {
	      fill: '#C78C2F',
	      d: 'M241 311.2c.1 0 4.5.6 8.4 4.3l-14.2 19.8c-.8 1.2-.6 2.8.6 3.6.5.3 1 .5 1.5.5.8 0 1.6-.4 2.1-1.1l15.4-21.5c.7-.9.6-2.2-.1-3.2-3.6-4.4-8.1-6.3-10.8-7.1V121.6c0-4.9 4-8.9 9-8.9 1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3-1.4 0-2.6 1.2-2.6 2.6 0 1.4 1.2 2.6 2.6 2.6 4.7 0 8.5-3.8 8.5-8.5s-3.8-8.5-8.5-8.5c-7.8 0-14.2 6.3-14.2 14.7v186.4c0 1.3 1 2.4 2.3 2.6z'
	    })
	  );
	};
	
	exports.default = Key;

/***/ },
/* 177 */
[1179, 532],
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _interleave = __webpack_require__(1163);
	
	var _interleave2 = _interopRequireDefault(_interleave);
	
	var _flatten = __webpack_require__(250);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_RuleSet = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_RuleSet || __webpack_require__(8).any;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(8).any;
	
	exports.default = function (strings) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  return (0, _flatten2.default)((0, _interleave2.default)(strings, interpolations));
	};
	
	module.exports = exports['default'];

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parse = __webpack_require__(543);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	var _root = __webpack_require__(255);
	
	var _root2 = _interopRequireDefault(_root);
	
	var _rule = __webpack_require__(256);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _atRule = __webpack_require__(251);
	
	var _atRule2 = _interopRequireDefault(_atRule);
	
	var _declaration = __webpack_require__(541);
	
	var _declaration2 = _interopRequireDefault(_declaration);
	
	var _warnOnce = __webpack_require__(67);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	var _comment = __webpack_require__(252);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _node = __webpack_require__(254);
	
	var _node2 = _interopRequireDefault(_node);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function cleanSource(nodes) {
	    return nodes.map(function (i) {
	        if (i.nodes) i.nodes = cleanSource(i.nodes);
	        delete i.source;
	        return i;
	    });
	}
	
	/**
	 * @callback childCondition
	 * @param {Node} node    - container child
	 * @param {number} index - child index
	 * @param {Node[]} nodes - all container children
	 * @return {boolean}
	 */
	
	/**
	 * @callback childIterator
	 * @param {Node} node    - container child
	 * @param {number} index - child index
	 * @return {false|undefined} returning `false` will break iteration
	 */
	
	/**
	 * The {@link Root}, {@link AtRule}, and {@link Rule} container nodes
	 * inherit some common methods to help work with their children.
	 *
	 * Note that all containers can store any content. If you write a rule inside
	 * a rule, PostCSS will parse it.
	 *
	 * @extends Node
	 * @abstract
	 */
	
	var Container = function (_Node) {
	    _inherits(Container, _Node);
	
	    function Container() {
	        _classCallCheck(this, Container);
	
	        return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
	    }
	
	    _createClass(Container, [{
	        key: 'push',
	        value: function push(child) {
	            child.parent = this;
	            this.nodes.push(child);
	            return this;
	        }
	
	        /**
	         * Iterates through the container’s immediate children,
	         * calling `callback` for each child.
	         *
	         * Returning `false` in the callback will break iteration.
	         *
	         * This method only iterates through the container’s immediate children.
	         * If you need to recursively iterate through all the container’s descendant
	         * nodes, use {@link Container#walk}.
	         *
	         * Unlike the for `{}`-cycle or `Array#forEach` this iterator is safe
	         * if you are mutating the array of child nodes during iteration.
	         * PostCSS will adjust the current index to match the mutations.
	         *
	         * @param {childIterator} callback - iterator receives each node and index
	         *
	         * @return {false|undefined} returns `false` if iteration was broke
	         *
	         * @example
	         * const root = postcss.parse('a { color: black; z-index: 1 }');
	         * const rule = root.first;
	         *
	         * for ( let decl of rule.nodes ) {
	         *     decl.cloneBefore({ prop: '-webkit-' + decl.prop });
	         *     // Cycle will be infinite, because cloneBefore moves the current node
	         *     // to the next index
	         * }
	         *
	         * rule.each(decl => {
	         *     decl.cloneBefore({ prop: '-webkit-' + decl.prop });
	         *     // Will be executed only for color and z-index
	         * });
	         */
	
	    }, {
	        key: 'each',
	        value: function each(callback) {
	            if (!this.lastEach) this.lastEach = 0;
	            if (!this.indexes) this.indexes = {};
	
	            this.lastEach += 1;
	            var id = this.lastEach;
	            this.indexes[id] = 0;
	
	            if (!this.nodes) return undefined;
	
	            var index = void 0,
	                result = void 0;
	            while (this.indexes[id] < this.nodes.length) {
	                index = this.indexes[id];
	                result = callback(this.nodes[index], index);
	                if (result === false) break;
	
	                this.indexes[id] += 1;
	            }
	
	            delete this.indexes[id];
	
	            return result;
	        }
	
	        /**
	         * Traverses the container’s descendant nodes, calling callback
	         * for each node.
	         *
	         * Like container.each(), this method is safe to use
	         * if you are mutating arrays during iteration.
	         *
	         * If you only need to iterate through the container’s immediate children,
	         * use {@link Container#each}.
	         *
	         * @param {childIterator} callback - iterator receives each node and index
	         *
	         * @return {false|undefined} returns `false` if iteration was broke
	         *
	         * @example
	         * root.walk(node => {
	         *   // Traverses all descendant nodes.
	         * });
	         */
	
	    }, {
	        key: 'walk',
	        value: function walk(callback) {
	            return this.each(function (child, i) {
	                var result = callback(child, i);
	                if (result !== false && child.walk) {
	                    result = child.walk(callback);
	                }
	                return result;
	            });
	        }
	
	        /**
	         * Traverses the container’s descendant nodes, calling callback
	         * for each declaration node.
	         *
	         * If you pass a filter, iteration will only happen over declarations
	         * with matching properties.
	         *
	         * Like {@link Container#each}, this method is safe
	         * to use if you are mutating arrays during iteration.
	         *
	         * @param {string|RegExp} [prop]   - string or regular expression
	         *                                   to filter declarations by property name
	         * @param {childIterator} callback - iterator receives each node and index
	         *
	         * @return {false|undefined} returns `false` if iteration was broke
	         *
	         * @example
	         * root.walkDecls(decl => {
	         *   checkPropertySupport(decl.prop);
	         * });
	         *
	         * root.walkDecls('border-radius', decl => {
	         *   decl.remove();
	         * });
	         *
	         * root.walkDecls(/^background/, decl => {
	         *   decl.value = takeFirstColorFromGradient(decl.value);
	         * });
	         */
	
	    }, {
	        key: 'walkDecls',
	        value: function walkDecls(prop, callback) {
	            if (!callback) {
	                callback = prop;
	                return this.walk(function (child, i) {
	                    if (child.type === 'decl') {
	                        return callback(child, i);
	                    }
	                });
	            } else if (prop instanceof RegExp) {
	                return this.walk(function (child, i) {
	                    if (child.type === 'decl' && prop.test(child.prop)) {
	                        return callback(child, i);
	                    }
	                });
	            } else {
	                return this.walk(function (child, i) {
	                    if (child.type === 'decl' && child.prop === prop) {
	                        return callback(child, i);
	                    }
	                });
	            }
	        }
	
	        /**
	         * Traverses the container’s descendant nodes, calling callback
	         * for each rule node.
	         *
	         * If you pass a filter, iteration will only happen over rules
	         * with matching selectors.
	         *
	         * Like {@link Container#each}, this method is safe
	         * to use if you are mutating arrays during iteration.
	         *
	         * @param {string|RegExp} [selector] - string or regular expression
	         *                                     to filter rules by selector
	         * @param {childIterator} callback   - iterator receives each node and index
	         *
	         * @return {false|undefined} returns `false` if iteration was broke
	         *
	         * @example
	         * const selectors = [];
	         * root.walkRules(rule => {
	         *   selectors.push(rule.selector);
	         * });
	         * console.log(`Your CSS uses ${selectors.length} selectors`);
	         */
	
	    }, {
	        key: 'walkRules',
	        value: function walkRules(selector, callback) {
	            if (!callback) {
	                callback = selector;
	
	                return this.walk(function (child, i) {
	                    if (child.type === 'rule') {
	                        return callback(child, i);
	                    }
	                });
	            } else if (selector instanceof RegExp) {
	                return this.walk(function (child, i) {
	                    if (child.type === 'rule' && selector.test(child.selector)) {
	                        return callback(child, i);
	                    }
	                });
	            } else {
	                return this.walk(function (child, i) {
	                    if (child.type === 'rule' && child.selector === selector) {
	                        return callback(child, i);
	                    }
	                });
	            }
	        }
	
	        /**
	         * Traverses the container’s descendant nodes, calling callback
	         * for each at-rule node.
	         *
	         * If you pass a filter, iteration will only happen over at-rules
	         * that have matching names.
	         *
	         * Like {@link Container#each}, this method is safe
	         * to use if you are mutating arrays during iteration.
	         *
	         * @param {string|RegExp} [name]   - string or regular expression
	         *                                   to filter at-rules by name
	         * @param {childIterator} callback - iterator receives each node and index
	         *
	         * @return {false|undefined} returns `false` if iteration was broke
	         *
	         * @example
	         * root.walkAtRules(rule => {
	         *   if ( isOld(rule.name) ) rule.remove();
	         * });
	         *
	         * let first = false;
	         * root.walkAtRules('charset', rule => {
	         *   if ( !first ) {
	         *     first = true;
	         *   } else {
	         *     rule.remove();
	         *   }
	         * });
	         */
	
	    }, {
	        key: 'walkAtRules',
	        value: function walkAtRules(name, callback) {
	            if (!callback) {
	                callback = name;
	                return this.walk(function (child, i) {
	                    if (child.type === 'atrule') {
	                        return callback(child, i);
	                    }
	                });
	            } else if (name instanceof RegExp) {
	                return this.walk(function (child, i) {
	                    if (child.type === 'atrule' && name.test(child.name)) {
	                        return callback(child, i);
	                    }
	                });
	            } else {
	                return this.walk(function (child, i) {
	                    if (child.type === 'atrule' && child.name === name) {
	                        return callback(child, i);
	                    }
	                });
	            }
	        }
	
	        /**
	         * Traverses the container’s descendant nodes, calling callback
	         * for each comment node.
	         *
	         * Like {@link Container#each}, this method is safe
	         * to use if you are mutating arrays during iteration.
	         *
	         * @param {childIterator} callback - iterator receives each node and index
	         *
	         * @return {false|undefined} returns `false` if iteration was broke
	         *
	         * @example
	         * root.walkComments(comment => {
	         *   comment.remove();
	         * });
	         */
	
	    }, {
	        key: 'walkComments',
	        value: function walkComments(callback) {
	            return this.walk(function (child, i) {
	                if (child.type === 'comment') {
	                    return callback(child, i);
	                }
	            });
	        }
	
	        /**
	         * Inserts new nodes to the start of the container.
	         *
	         * @param {...(Node|object|string|Node[])} children - new nodes
	         *
	         * @return {Node} this node for methods chain
	         *
	         * @example
	         * const decl1 = postcss.decl({ prop: 'color', value: 'black' });
	         * const decl2 = postcss.decl({ prop: 'background-color', value: 'white' });
	         * rule.append(decl1, decl2);
	         *
	         * root.append({ name: 'charset', params: '"UTF-8"' });  // at-rule
	         * root.append({ selector: 'a' });                       // rule
	         * rule.append({ prop: 'color', value: 'black' });       // declaration
	         * rule.append({ text: 'Comment' })                      // comment
	         *
	         * root.append('a {}');
	         * root.first.append('color: black; z-index: 1');
	         */
	
	    }, {
	        key: 'append',
	        value: function append() {
	            var _this2 = this;
	
	            for (var _len = arguments.length, children = Array(_len), _key = 0; _key < _len; _key++) {
	                children[_key] = arguments[_key];
	            }
	
	            children.forEach(function (child) {
	                var nodes = _this2.normalize(child, _this2.last);
	                nodes.forEach(function (node) {
	                    return _this2.nodes.push(node);
	                });
	            });
	            return this;
	        }
	
	        /**
	         * Inserts new nodes to the end of the container.
	         *
	         * @param {...(Node|object|string|Node[])} children - new nodes
	         *
	         * @return {Node} this node for methods chain
	         *
	         * @example
	         * const decl1 = postcss.decl({ prop: 'color', value: 'black' });
	         * const decl2 = postcss.decl({ prop: 'background-color', value: 'white' });
	         * rule.prepend(decl1, decl2);
	         *
	         * root.append({ name: 'charset', params: '"UTF-8"' });  // at-rule
	         * root.append({ selector: 'a' });                       // rule
	         * rule.append({ prop: 'color', value: 'black' });       // declaration
	         * rule.append({ text: 'Comment' })                      // comment
	         *
	         * root.append('a {}');
	         * root.first.append('color: black; z-index: 1');
	         */
	
	    }, {
	        key: 'prepend',
	        value: function prepend() {
	            var _this3 = this;
	
	            for (var _len2 = arguments.length, children = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	                children[_key2] = arguments[_key2];
	            }
	
	            children = children.reverse();
	            children.forEach(function (child) {
	                var nodes = _this3.normalize(child, _this3.first, 'prepend').reverse();
	                nodes.forEach(function (node) {
	                    return _this3.nodes.unshift(node);
	                });
	                for (var id in _this3.indexes) {
	                    _this3.indexes[id] = _this3.indexes[id] + nodes.length;
	                }
	            });
	            return this;
	        }
	    }, {
	        key: 'cleanRaws',
	        value: function cleanRaws(keepBetween) {
	            _get(Container.prototype.__proto__ || Object.getPrototypeOf(Container.prototype), 'cleanRaws', this).call(this, keepBetween);
	            if (this.nodes) {
	                this.nodes.forEach(function (node) {
	                    return node.cleanRaws(keepBetween);
	                });
	            }
	        }
	
	        /**
	         * Insert new node before old node within the container.
	         *
	         * @param {Node|number} exist             - child or child’s index.
	         * @param {Node|object|string|Node[]} add - new node
	         *
	         * @return {Node} this node for methods chain
	         *
	         * @example
	         * rule.insertBefore(decl, decl.clone({ prop: '-webkit-' + decl.prop }));
	         */
	
	    }, {
	        key: 'insertBefore',
	        value: function insertBefore(exist, add) {
	            var _this4 = this;
	
	            exist = this.index(exist);
	
	            var type = exist === 0 ? 'prepend' : false;
	            var nodes = this.normalize(add, this.nodes[exist], type).reverse();
	            nodes.forEach(function (node) {
	                return _this4.nodes.splice(exist, 0, node);
	            });
	
	            var index = void 0;
	            for (var id in this.indexes) {
	                index = this.indexes[id];
	                if (exist <= index) {
	                    this.indexes[id] = index + nodes.length;
	                }
	            }
	
	            return this;
	        }
	
	        /**
	         * Insert new node after old node within the container.
	         *
	         * @param {Node|number} exist             - child or child’s index
	         * @param {Node|object|string|Node[]} add - new node
	         *
	         * @return {Node} this node for methods chain
	         */
	
	    }, {
	        key: 'insertAfter',
	        value: function insertAfter(exist, add) {
	            var _this5 = this;
	
	            exist = this.index(exist);
	
	            var nodes = this.normalize(add, this.nodes[exist]).reverse();
	            nodes.forEach(function (node) {
	                return _this5.nodes.splice(exist + 1, 0, node);
	            });
	
	            var index = void 0;
	            for (var id in this.indexes) {
	                index = this.indexes[id];
	                if (exist < index) {
	                    this.indexes[id] = index + nodes.length;
	                }
	            }
	
	            return this;
	        }
	    }, {
	        key: 'remove',
	        value: function remove(child) {
	            if (typeof child !== 'undefined') {
	                (0, _warnOnce2.default)('Container#remove is deprecated. ' + 'Use Container#removeChild');
	                this.removeChild(child);
	            } else {
	                _get(Container.prototype.__proto__ || Object.getPrototypeOf(Container.prototype), 'remove', this).call(this);
	            }
	            return this;
	        }
	
	        /**
	         * Removes node from the container and cleans the parent properties
	         * from the node and its children.
	         *
	         * @param {Node|number} child - child or child’s index
	         *
	         * @return {Node} this node for methods chain
	         *
	         * @example
	         * rule.nodes.length  //=> 5
	         * rule.removeChild(decl);
	         * rule.nodes.length  //=> 4
	         * decl.parent        //=> undefined
	         */
	
	    }, {
	        key: 'removeChild',
	        value: function removeChild(child) {
	            child = this.index(child);
	            this.nodes[child].parent = undefined;
	            this.nodes.splice(child, 1);
	
	            var index = void 0;
	            for (var id in this.indexes) {
	                index = this.indexes[id];
	                if (index >= child) {
	                    this.indexes[id] = index - 1;
	                }
	            }
	
	            return this;
	        }
	
	        /**
	         * Removes all children from the container
	         * and cleans their parent properties.
	         *
	         * @return {Node} this node for methods chain
	         *
	         * @example
	         * rule.removeAll();
	         * rule.nodes.length //=> 0
	         */
	
	    }, {
	        key: 'removeAll',
	        value: function removeAll() {
	            this.nodes.forEach(function (node) {
	                return node.parent = undefined;
	            });
	            this.nodes = [];
	            return this;
	        }
	
	        /**
	         * Passes all declaration values within the container that match pattern
	         * through callback, replacing those values with the returned result
	         * of callback.
	         *
	         * This method is useful if you are using a custom unit or function
	         * and need to iterate through all values.
	         *
	         * @param {string|RegExp} pattern      - replace pattern
	         * @param {object} opts                - options to speed up the search
	         * @param {string|string[]} opts.props - an array of property names
	         * @param {string} opts.fast           - string that’s used
	         *                                       to narrow down values and speed up
	                                                 the regexp search
	         * @param {function|string} callback   - string to replace pattern
	         *                                       or callback that returns a new
	         *                                       value.
	         *                                       The callback will receive
	         *                                       the same arguments as those
	         *                                       passed to a function parameter
	         *                                       of `String#replace`.
	         *
	         * @return {Node} this node for methods chain
	         *
	         * @example
	         * root.replaceValues(/\d+rem/, { fast: 'rem' }, string => {
	         *   return 15 * parseInt(string) + 'px';
	         * });
	         */
	
	    }, {
	        key: 'replaceValues',
	        value: function replaceValues(pattern, opts, callback) {
	            if (!callback) {
	                callback = opts;
	                opts = {};
	            }
	
	            this.walkDecls(function (decl) {
	                if (opts.props && opts.props.indexOf(decl.prop) === -1) return;
	                if (opts.fast && decl.value.indexOf(opts.fast) === -1) return;
	
	                decl.value = decl.value.replace(pattern, callback);
	            });
	
	            return this;
	        }
	
	        /**
	         * Returns `true` if callback returns `true`
	         * for all of the container’s children.
	         *
	         * @param {childCondition} condition - iterator returns true or false.
	         *
	         * @return {boolean} is every child pass condition
	         *
	         * @example
	         * const noPrefixes = rule.every(i => i.prop[0] !== '-');
	         */
	
	    }, {
	        key: 'every',
	        value: function every(condition) {
	            return this.nodes.every(condition);
	        }
	
	        /**
	         * Returns `true` if callback returns `true` for (at least) one
	         * of the container’s children.
	         *
	         * @param {childCondition} condition - iterator returns true or false.
	         *
	         * @return {boolean} is some child pass condition
	         *
	         * @example
	         * const hasPrefix = rule.some(i => i.prop[0] === '-');
	         */
	
	    }, {
	        key: 'some',
	        value: function some(condition) {
	            return this.nodes.some(condition);
	        }
	
	        /**
	         * Returns a `child`’s index within the {@link Container#nodes} array.
	         *
	         * @param {Node} child - child of the current container.
	         *
	         * @return {number} child index
	         *
	         * @example
	         * rule.index( rule.nodes[2] ) //=> 2
	         */
	
	    }, {
	        key: 'index',
	        value: function index(child) {
	            if (typeof child === 'number') {
	                return child;
	            } else {
	                return this.nodes.indexOf(child);
	            }
	        }
	
	        /**
	         * The container’s first child.
	         *
	         * @type {Node}
	         *
	         * @example
	         * rule.first == rules.nodes[0];
	         */
	
	    }, {
	        key: 'normalize',
	        value: function normalize(nodes, sample) {
	            var _this6 = this;
	
	            if (typeof nodes === 'string') {
	                nodes = cleanSource((0, _parse2.default)(nodes).nodes);
	            } else if (!Array.isArray(nodes)) {
	                if (nodes.type === 'root') {
	                    nodes = nodes.nodes;
	                } else if (nodes.type) {
	                    nodes = [nodes];
	                } else if (nodes.prop) {
	                    if (typeof nodes.value === 'undefined') {
	                        throw new Error('Value field is missed in node creation');
	                    } else if (typeof nodes.value !== 'string') {
	                        nodes.value = String(nodes.value);
	                    }
	                    nodes = [new _declaration2.default(nodes)];
	                } else if (nodes.selector) {
	                    nodes = [new _rule2.default(nodes)];
	                } else if (nodes.name) {
	                    nodes = [new _atRule2.default(nodes)];
	                } else if (nodes.text) {
	                    nodes = [new _comment2.default(nodes)];
	                } else {
	                    throw new Error('Unknown node type in node creation');
	                }
	            }
	
	            var processed = nodes.map(function (i) {
	                if (typeof i.raws === 'undefined') i = _this6.rebuild(i);
	
	                if (i.parent) i = i.clone();
	                if (typeof i.raws.before === 'undefined') {
	                    if (sample && typeof sample.raws.before !== 'undefined') {
	                        i.raws.before = sample.raws.before.replace(/[^\s]/g, '');
	                    }
	                }
	                i.parent = _this6;
	                return i;
	            });
	
	            return processed;
	        }
	    }, {
	        key: 'rebuild',
	        value: function rebuild(node, parent) {
	            var _this7 = this;
	
	            var fix = void 0;
	            if (node.type === 'root') {
	                fix = new _root2.default();
	            } else if (node.type === 'atrule') {
	                fix = new _atRule2.default();
	            } else if (node.type === 'rule') {
	                fix = new _rule2.default();
	            } else if (node.type === 'decl') {
	                fix = new _declaration2.default();
	            } else if (node.type === 'comment') {
	                fix = new _comment2.default();
	            }
	
	            for (var i in node) {
	                if (i === 'nodes') {
	                    fix.nodes = node.nodes.map(function (j) {
	                        return _this7.rebuild(j, fix);
	                    });
	                } else if (i === 'parent' && parent) {
	                    fix.parent = parent;
	                } else if (node.hasOwnProperty(i)) {
	                    fix[i] = node[i];
	                }
	            }
	
	            return fix;
	        }
	    }, {
	        key: 'eachInside',
	        value: function eachInside(callback) {
	            (0, _warnOnce2.default)('Container#eachInside is deprecated. ' + 'Use Container#walk instead.');
	            return this.walk(callback);
	        }
	    }, {
	        key: 'eachDecl',
	        value: function eachDecl(prop, callback) {
	            (0, _warnOnce2.default)('Container#eachDecl is deprecated. ' + 'Use Container#walkDecls instead.');
	            return this.walkDecls(prop, callback);
	        }
	    }, {
	        key: 'eachRule',
	        value: function eachRule(selector, callback) {
	            (0, _warnOnce2.default)('Container#eachRule is deprecated. ' + 'Use Container#walkRules instead.');
	            return this.walkRules(selector, callback);
	        }
	    }, {
	        key: 'eachAtRule',
	        value: function eachAtRule(name, callback) {
	            (0, _warnOnce2.default)('Container#eachAtRule is deprecated. ' + 'Use Container#walkAtRules instead.');
	            return this.walkAtRules(name, callback);
	        }
	    }, {
	        key: 'eachComment',
	        value: function eachComment(callback) {
	            (0, _warnOnce2.default)('Container#eachComment is deprecated. ' + 'Use Container#walkComments instead.');
	            return this.walkComments(callback);
	        }
	    }, {
	        key: 'first',
	        get: function get() {
	            if (!this.nodes) return undefined;
	            return this.nodes[0];
	        }
	
	        /**
	         * The container’s last child.
	         *
	         * @type {Node}
	         *
	         * @example
	         * rule.last == rule.nodes[rule.nodes.length - 1];
	         */
	
	    }, {
	        key: 'last',
	        get: function get() {
	            if (!this.nodes) return undefined;
	            return this.nodes[this.nodes.length - 1];
	        }
	    }, {
	        key: 'semicolon',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#semicolon is deprecated. Use Node#raws.semicolon');
	            return this.raws.semicolon;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#semicolon is deprecated. Use Node#raws.semicolon');
	            this.raws.semicolon = val;
	        }
	    }, {
	        key: 'after',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#after is deprecated. Use Node#raws.after');
	            return this.raws.after;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#after is deprecated. Use Node#raws.after');
	            this.raws.after = val;
	        }
	
	        /**
	         * @memberof Container#
	         * @member {Node[]} nodes - an array containing the container’s children
	         *
	         * @example
	         * const root = postcss.parse('a { color: black }');
	         * root.nodes.length           //=> 1
	         * root.nodes[0].selector      //=> 'a'
	         * root.nodes[0].nodes[0].prop //=> 'color'
	         */
	
	    }]);
	
	    return Container;
	}(_node2.default);
	
	exports.default = Container;
	module.exports = exports['default'];

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getInternalMethods = getInternalMethods;
	exports.getPrototypeChain = getPrototypeChain;
	exports.warn = warn;
	exports.uid = uid;
	exports.formatAsConstant = formatAsConstant;
	exports.dispatchIdentity = dispatchIdentity;
	exports.fsa = fsa;
	exports.dispatch = dispatch;
	
	var _functions = __webpack_require__(79);
	
	var fn = _interopRequireWildcard(_functions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/*eslint-disable*/
	var builtIns = Object.getOwnPropertyNames(NoopClass);
	var builtInProto = Object.getOwnPropertyNames(NoopClass.prototype);
	/*eslint-enable*/
	
	function getInternalMethods(Obj, isProto) {
	  var excluded = isProto ? builtInProto : builtIns;
	  var obj = isProto ? Obj.prototype : Obj;
	  return Object.getOwnPropertyNames(obj).reduce(function (value, m) {
	    if (excluded.indexOf(m) !== -1) {
	      return value;
	    }
	
	    value[m] = obj[m];
	    return value;
	  }, {});
	}
	
	function getPrototypeChain(Obj) {
	  var methods = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  return Obj === Function.prototype ? methods : getPrototypeChain(Object.getPrototypeOf(Obj), fn.assign(getInternalMethods(Obj, true), methods));
	}
	
	function warn(msg) {
	  /* istanbul ignore else */
	  /*eslint-disable*/
	  if (typeof console !== 'undefined') {
	    console.warn(new ReferenceError(msg));
	  }
	  /*eslint-enable*/
	}
	
	function uid(container, name) {
	  var count = 0;
	  var key = name;
	  while (Object.hasOwnProperty.call(container, key)) {
	    key = name + String(++count);
	  }
	  return key;
	}
	
	function formatAsConstant(name) {
	  return name.replace(/[a-z]([A-Z])/g, function (i) {
	    return String(i[0]) + '_' + String(i[1].toLowerCase());
	  }).toUpperCase();
	}
	
	function dispatchIdentity(x) {
	  if (x === undefined) return null;
	
	  for (var _len = arguments.length, a = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    a[_key - 1] = arguments[_key];
	  }
	
	  return a.length ? [x].concat(a) : x;
	}
	
	function fsa(id, type, payload, details) {
	  return {
	    type: type,
	    payload: payload,
	    meta: _extends({
	      dispatchId: id
	    }, details),
	
	    id: id,
	    action: type,
	    data: payload,
	    details: details
	  };
	}
	
	function dispatch(id, actionObj, payload, alt) {
	  var data = actionObj.dispatch(payload);
	  if (data === undefined) return null;
	
	  var type = actionObj.id;
	  var namespace = type;
	  var name = type;
	  var details = { id: type, namespace: namespace, name: name };
	
	  var dispatchLater = function dispatchLater(x) {
	    return alt.dispatch(type, x, details);
	  };
	
	  if (fn.isFunction(data)) return data(dispatchLater, alt);
	
	  // XXX standardize this
	  return alt.dispatcher.dispatch(fsa(id, type, data, details));
	}
	
	/* istanbul ignore next */
	function NoopClass() {}

/***/ },
/* 181 */
/***/ function(module, exports) {

	/**
	 * @copyright 2015, Andrey Popp <8mayday@gmail.com>
	 *
	 * The decorator may be used on classes or methods
	 * ```
	 * @autobind
	 * class FullBound {}
	 *
	 * class PartBound {
	 *   @autobind
	 *   method () {}
	 * }
	 * ```
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = autobind;
	
	function autobind() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (args.length === 1) {
	    return boundClass.apply(undefined, args);
	  } else {
	    return boundMethod.apply(undefined, args);
	  }
	}
	
	/**
	 * Use boundMethod to bind all methods on the target.prototype
	 */
	function boundClass(target) {
	  // (Using reflect to get all keys including symbols)
	  var keys = undefined;
	  // Use Reflect if exists
	  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
	    keys = Reflect.ownKeys(target.prototype);
	  } else {
	    keys = Object.getOwnPropertyNames(target.prototype);
	    // use symbols if support is provided
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
	    }
	  }
	
	  keys.forEach(function (key) {
	    // Ignore special case target method
	    if (key === 'constructor') {
	      return;
	    }
	
	    var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key);
	
	    // Only methods need binding
	    if (typeof descriptor.value === 'function') {
	      Object.defineProperty(target.prototype, key, boundMethod(target, key, descriptor));
	    }
	  });
	  return target;
	}
	
	/**
	 * Return a descriptor removing the value and returning a getter
	 * The getter will return a .bind version of the function
	 * and memoize the result against a symbol on the instance
	 */
	function boundMethod(target, key, descriptor) {
	  var fn = descriptor.value;
	
	  if (typeof fn !== 'function') {
	    throw new Error('@autobind decorator can only be applied to methods not: ' + typeof fn);
	  }
	
	  // In IE11 calling Object.defineProperty has a side-effect of evaluating the
	  // getter for the property which is being replaced. This causes infinite
	  // recursion and an "Out of stack space" error.
	  var definingProperty = false;
	
	  return {
	    configurable: true,
	    get: function get() {
	      if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
	        return fn;
	      }
	
	      var boundFn = fn.bind(this);
	      definingProperty = true;
	      Object.defineProperty(this, key, {
	        value: boundFn,
	        configurable: true,
	        writable: true
	      });
	      definingProperty = false;
	      return boundFn;
	    }
	  };
	}
	module.exports = exports['default'];


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(47);
	var normalizeHeaderName = __webpack_require__(572);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(259);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(259);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(580), __esModule: true };

/***/ },
/* 184 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(90);
	var core = __webpack_require__(104);
	var ctx = __webpack_require__(587);
	var hide = __webpack_require__(106);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 186 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 187 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(272)('keys');
	var uid = __webpack_require__(274);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 189 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(267);
	var defined = __webpack_require__(184);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(93);
	
	var _DOMUtils = __webpack_require__(140);
	
	var _DOMStateStorage = __webpack_require__(278);
	
	var _PathUtils = __webpack_require__(69);
	
	var _ExecutionEnvironment = __webpack_require__(192);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 192 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(653);
	
	var _PathUtils = __webpack_require__(69);
	
	var _runTransitionHook = __webpack_require__(194);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(139);
	
	var _LocationUtils = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 195 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  if (Array.isArray(value)) value = value.join(',');
	
	  return value.match(/-webkit-|-moz-|-ms-/) !== null;
	};
	
	module.exports = exports['default'];

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var base64_url_decode = __webpack_require__(692);
	
	function InvalidTokenError(message) {
	  this.message = message;
	}
	
	InvalidTokenError.prototype = new Error();
	InvalidTokenError.prototype.name = 'InvalidTokenError';
	
	module.exports = function (token,options) {
	  if (typeof token !== 'string') {
	    throw new InvalidTokenError('Invalid token specified');
	  }
	
	  options = options || {};
	  var pos = options.header === true ? 0 : 1;
	  try {
	    return JSON.parse(base64_url_decode(token.split('.')[pos]));
	  } catch (e) {
	    throw new InvalidTokenError('Invalid token specified: ' + e.message);
	  }
	};
	
	module.exports.InvalidTokenError = InvalidTokenError;


/***/ },
/* 197 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.matches_entirely = matches_entirely;
	// Checks whether the entire input sequence can be matched
	// against the regular expression.
	function matches_entirely() {
		var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var regular_expression = arguments[1];
	
		if (typeof regular_expression === 'string') {
			regular_expression = '^(?:' + regular_expression + ')$';
		}
	
		var matched_groups = text.match(regular_expression);
		return matched_groups && matched_groups[0].length === text.length;
	}
	//# sourceMappingURL=common.js.map

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.FIRST_GROUP_PATTERN = undefined;
	
	var _getIterator2 = __webpack_require__(183);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = format;
	exports.format_national_number_using_format = format_national_number_using_format;
	exports.format_national_number = format_national_number;
	exports.choose_format_for_number = choose_format_for_number;
	exports.local_to_international_style = local_to_international_style;
	
	var _common = __webpack_require__(197);
	
	var _parse = __webpack_require__(109);
	
	var _metadata = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Formats a phone number
	//
	// Example use cases:
	//
	// ```js
	// format('8005553535', 'RU', 'International')
	// format('8005553535', 'RU', 'International', metadata)
	// format({ phone: '8005553535', country: 'RU' }, 'International')
	// format({ phone: '8005553535', country: 'RU' }, 'International', metadata)
	// format('+78005553535', 'National')
	// format('+78005553535', 'National', metadata)
	// ```
	//
	function format(first_argument, second_argument, third_argument, fourth_argument) {
		var _sort_out_arguments = sort_out_arguments(first_argument, second_argument, third_argument, fourth_argument),
		    input = _sort_out_arguments.input,
		    format_type = _sort_out_arguments.format_type,
		    metadata = _sort_out_arguments.metadata;
	
		var country_metadata = void 0;
	
		if (input.country) {
			country_metadata = metadata.countries[input.country];
		}
	
		var _parse_phone_number_a = (0, _parse.parse_phone_number_and_country_phone_code)(input.phone, metadata),
		    country_phone_code = _parse_phone_number_a.country_phone_code,
		    number = _parse_phone_number_a.number;
	
		if (country_phone_code) {
			// Check country restriction
			if (input.country && country_metadata && country_phone_code !== (0, _metadata.get_phone_code)(country_metadata)) {
				return input.phone;
			}
	
			country_metadata = (0, _metadata.get_metadata_by_country_phone_code)(country_phone_code, metadata);
		}
	
		if (!country_metadata) {
			return input.phone;
		}
	
		switch (format_type) {
			case 'International':
				if (!number) {
					return '+' + (0, _metadata.get_phone_code)(country_metadata);
				}
				var national_number = format_national_number(number, 'International', false, country_metadata);
				return '+' + (0, _metadata.get_phone_code)(country_metadata) + ' ' + national_number;
	
			case 'International_plaintext':
				return '+' + (0, _metadata.get_phone_code)(country_metadata) + input.phone;
	
			case 'National':
				if (!number) {
					return '';
				}
				return format_national_number(number, 'National', false, country_metadata);
		}
	}
	
	// This was originally set to $1 but there are some countries for which the
	// first group is not used in the national pattern (e.g. Argentina) so the $1
	// group does not match correctly.  Therefore, we use \d, so that the first
	// group actually used in the pattern will be matched.
	// This is a port of Google Android `libphonenumber`'s
	// `phonenumberutil.js` of 17th November, 2016.
	//
	// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
	
	var FIRST_GROUP_PATTERN = exports.FIRST_GROUP_PATTERN = /(\$\d)/;
	
	function format_national_number_using_format(number, format, international, enforce_national_prefix, country_metadata) {
		var format_pattern_matcher = new RegExp((0, _metadata.get_format_pattern)(format));
	
		var national_prefix_formatting_rule = (0, _metadata.get_format_national_prefix_formatting_rule)(format, country_metadata);
	
		// National prefix is omitted if there's no national prefix formatting rule
		// set for this country, or when this rule is set but
		// national prefix is optional for this phone number format
		// (and it is not enforced explicitly)
		var national_prefix_may_be_omitted = !national_prefix_formatting_rule || national_prefix_formatting_rule && (0, _metadata.get_format_national_prefix_is_optional_when_formatting)(format, country_metadata) && !enforce_national_prefix;
	
		if (!international && !national_prefix_may_be_omitted) {
			return number.replace(format_pattern_matcher, (0, _metadata.get_format_format)(format).replace(FIRST_GROUP_PATTERN, national_prefix_formatting_rule));
		}
	
		var formatted_number = number.replace(format_pattern_matcher, international ? (0, _metadata.get_format_international_format)(format) : (0, _metadata.get_format_format)(format));
	
		if (international) {
			return local_to_international_style(formatted_number);
		}
	
		return formatted_number;
	}
	
	function format_national_number(number, format_as, enforce_national_prefix, country_metadata) {
		var format = choose_format_for_number((0, _metadata.get_formats)(country_metadata), number);
	
		if (!format) {
			return number;
		}
	
		return format_national_number_using_format(number, format, format_as === 'International', enforce_national_prefix, country_metadata);
	}
	
	function choose_format_for_number(available_formats, national_number) {
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;
	
		try {
			for (var _iterator = (0, _getIterator3.default)(available_formats), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var _format = _step.value;
	
				// Validate leading digits
				if ((0, _metadata.get_format_leading_digits_patterns)(_format).length > 0) {
					// The last leading_digits_pattern is used here, as it is the most detailed
					var last_leading_digits_pattern = (0, _metadata.get_format_leading_digits_patterns)(_format)[(0, _metadata.get_format_leading_digits_patterns)(_format).length - 1];
	
					// If leading digits don't match then move on to the next phone number format
					if (national_number.search(last_leading_digits_pattern) !== 0) {
						continue;
					}
				}
	
				// Check that the national number matches the phone number format regular expression
				if ((0, _common.matches_entirely)(national_number, new RegExp((0, _metadata.get_format_pattern)(_format)))) {
					return _format;
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	}
	
	// Removes brackets and replaces dashes with spaces.
	//
	// E.g. "(999) 111-22-33" -> "999 111 22 33"
	//
	function local_to_international_style(local) {
		return local
		// Remove brackets
		.replace(/[\(\)]/g, '')
		// Replace dashes with spaces
		.replace(/\-/g, ' ').trim();
	}
	
	// Sort out arguments
	function sort_out_arguments() {
		var first_argument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var second_argument = arguments[1];
		var third_argument = arguments[2];
		var fourth_argument = arguments[3];
	
		var input = void 0;
		var format_type = void 0;
		var metadata = void 0;
	
		// Sort out arguments
		if (typeof first_argument === 'string') {
			// If country code is supplied
			if (typeof third_argument === 'string') {
				// Will be `parse()`d later in code
				input = {
					phone: first_argument,
					country: second_argument
				};
	
				format_type = third_argument;
				metadata = fourth_argument;
			}
			// Just an international phone number is supplied
			else {
					// Will be `parse()`d later in code
					input = {
						phone: first_argument
					};
	
					if (typeof second_argument !== 'string') {
						throw new Error('Format type argument not passed for `format()`');
					}
	
					format_type = second_argument;
					metadata = third_argument;
				}
		} else {
			input = first_argument;
			format_type = second_argument;
			metadata = third_argument;
		}
	
		// Sanity check
		if (!metadata) {
			throw new Error('Metadata not passed');
		}
	
		switch (format_type) {
			case 'International':
			case 'International_plaintext':
			case 'National':
				break;
			default:
				throw new Error('Unknown format type argument passed to "format()": "' + format_type + '"');
		}
	
		return { input: input, format_type: format_type, metadata: metadata };
	}
	//# sourceMappingURL=format.js.map

/***/ },
/* 199 */
63,
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(50);
	var _curry2 = __webpack_require__(2);
	var _reduce = __webpack_require__(49);
	var map = __webpack_require__(43);
	
	
	/**
	 * ap applies a list of functions to a list of values.
	 *
	 * Dispatches to the `ap` method of the second argument, if present. Also
	 * treats curried functions as applicatives.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig [a -> b] -> [a] -> [b]
	 * @sig Apply f => f (a -> b) -> f a -> f b
	 * @param {Array} fns An array of functions
	 * @param {Array} vs An array of values
	 * @return {Array} An array of results of applying each of `fns` to all of `vs` in turn.
	 * @example
	 *
	 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
	 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
	 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
	 */
	module.exports = _curry2(function ap(applicative, fn) {
	  return (
	    typeof applicative.ap === 'function' ?
	      applicative.ap(fn) :
	    typeof applicative === 'function' ?
	      function(x) { return applicative(x)(fn(x)); } :
	    // else
	      _reduce(function(acc, f) { return _concat(acc, map(f, fn)); }, [], applicative)
	  );
	});


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _makeFlat = __webpack_require__(436);
	var _xchain = __webpack_require__(784);
	var map = __webpack_require__(43);
	
	
	/**
	 * `chain` maps a function over a list and concatenates the results. `chain`
	 * is also known as `flatMap` in some libraries
	 *
	 * Dispatches to the `chain` method of the second argument, if present,
	 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain m => (a -> m b) -> m a -> m b
	 * @param {Function} fn The function to map with
	 * @param {Array} list The list to map over
	 * @return {Array} The result of flat-mapping `list` with `fn`
	 * @example
	 *
	 *      var duplicate = n => [n, n];
	 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
	 *
	 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
	 */
	module.exports = _curry2(_dispatchable(['chain'], _xchain, function chain(fn, monad) {
	  if (typeof monad === 'function') {
	    return function(x) { return fn(monad(x))(x); };
	  }
	  return _makeFlat(false)(map(fn, monad));
	}));


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	var pipe = __webpack_require__(453);
	var reverse = __webpack_require__(157);
	
	
	/**
	 * Performs right-to-left function composition. The rightmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * **Note:** The result of compose is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipe
	 * @example
	 *
	 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
	 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
	 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
	 *
	 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
	 *
	 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
	 */
	module.exports = function compose() {
	  if (arguments.length === 0) {
	    throw new Error('compose requires at least one argument');
	  }
	  return pipe.apply(this, reverse(arguments));
	};


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _isArray = __webpack_require__(71);
	var _isFunction = __webpack_require__(148);
	var toString = __webpack_require__(116);
	
	
	/**
	 * Returns the result of concatenating the given lists or strings.
	 *
	 * Note: `R.concat` expects both arguments to be of the same type,
	 * unlike the native `Array.prototype.concat` method. It will throw
	 * an error if you `concat` an Array with a non-Array value.
	 *
	 * Dispatches to the `concat` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @sig String -> String -> String
	 * @param {Array|String} firstList The first list
	 * @param {Array|String} secondList The second list
	 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
	 * `secondList`.
	 *
	 * @example
	 *
	 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
	 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 *      R.concat([], []); //=> []
	 */
	module.exports = _curry2(function concat(a, b) {
	  if (a == null || !_isFunction(a.concat)) {
	    throw new TypeError(toString(a) + ' does not have a method named "concat"');
	  }
	  if (_isArray(a) && !_isArray(b)) {
	    throw new TypeError(toString(b) + ' is not an array');
	  }
	  return a.concat(b);
	});


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _filter = __webpack_require__(430);
	var _isObject = __webpack_require__(435);
	var _reduce = __webpack_require__(49);
	var _xfilter = __webpack_require__(789);
	var keys = __webpack_require__(56);
	
	
	/**
	 * Takes a predicate and a "filterable", and returns a new filterable of the
	 * same type containing the members of the given filterable which satisfy the
	 * given predicate.
	 *
	 * Dispatches to the `filter` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.reject, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(_dispatchable(['filter'], _xfilter, function(pred, filterable) {
	  return (
	    _isObject(filterable) ?
	      _reduce(function(acc, key) {
	        if (pred(filterable[key])) {
	          acc[key] = filterable[key];
	        }
	        return acc;
	      }, {}, keys(filterable)) :
	    // else
	      _filter(pred, filterable)
	  );
	}));


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var _identity = __webpack_require__(208);
	
	
	/**
	 * A function that does nothing but return the parameter supplied to it. Good
	 * as a default or placeholder function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x The value to return.
	 * @return {*} The input value, `x`.
	 * @example
	 *
	 *      R.identity(1); //=> 1
	 *
	 *      var obj = {};
	 *      R.identity(obj) === obj; //=> true
	 * @symb R.identity(a) = a
	 */
	module.exports = _curry1(_identity);


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var _objectAssign = __webpack_require__(774);
	
	module.exports =
	  typeof Object.assign === 'function' ? Object.assign : _objectAssign;


/***/ },
/* 207 */
/***/ function(module, exports) {

	module.exports = function _containsWith(pred, x, list) {
	  var idx = 0;
	  var len = list.length;
	
	  while (idx < len) {
	    if (pred(x, list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	};


/***/ },
/* 208 */
/***/ function(module, exports) {

	module.exports = function _identity(x) { return x; };


/***/ },
/* 209 */
/***/ function(module, exports) {

	module.exports = function _isTransformer(obj) {
	  return typeof obj['@@transducer/step'] === 'function';
	};


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns a function that when supplied an object returns the indicated
	 * property of that object, if it exists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig s -> {s: a} -> a | Undefined
	 * @param {String} p The property name
	 * @param {Object} obj The object to query
	 * @return {*} The value at `obj.p`.
	 * @see R.path
	 * @example
	 *
	 *      R.prop('x', {x: 100}); //=> 100
	 *      R.prop('x', {}); //=> undefined
	 */
	module.exports = _curry2(function prop(p, obj) { return obj[p]; });


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(110);
	var _curry1 = __webpack_require__(6);
	var slice = __webpack_require__(82);
	
	
	/**
	 * Returns all but the first element of the given list or string (or object
	 * with a `tail` method).
	 *
	 * Dispatches to the `slice` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.head, R.init, R.last
	 * @example
	 *
	 *      R.tail([1, 2, 3]);  //=> [2, 3]
	 *      R.tail([1, 2]);     //=> [2]
	 *      R.tail([1]);        //=> []
	 *      R.tail([]);         //=> []
	 *
	 *      R.tail('abc');  //=> 'bc'
	 *      R.tail('ab');   //=> 'b'
	 *      R.tail('a');    //=> ''
	 *      R.tail('');     //=> ''
	 */
	module.exports = _curry1(_checkForMethod('tail', slice(1, Infinity)));


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	
	
	/**
	 * Gives a single-word string description of the (native) type of a value,
	 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
	 * attempt to distinguish user Object types any further, reporting them all as
	 * 'Object'.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Type
	 * @sig (* -> {*}) -> String
	 * @param {*} val The value to test
	 * @return {String}
	 * @example
	 *
	 *      R.type({}); //=> "Object"
	 *      R.type(1); //=> "Number"
	 *      R.type(false); //=> "Boolean"
	 *      R.type('s'); //=> "String"
	 *      R.type(null); //=> "Null"
	 *      R.type([]); //=> "Array"
	 *      R.type(/[A-z]/); //=> "RegExp"
	 */
	module.exports = _curry1(function type(val) {
	  return val === null      ? 'Null'      :
	         val === undefined ? 'Undefined' :
	         Object.prototype.toString.call(val).slice(8, -1);
	});


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(205);
	var uniqBy = __webpack_require__(461);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list. `R.equals` is used to determine equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
	 *      R.uniq([1, '1']);     //=> [1, '1']
	 *      R.uniq([[42], [42]]); //=> [[42]]
	 */
	module.exports = uniqBy(identity);


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(207);
	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied predicate to
	 * two list elements. Prefers the first item if two items compare equal based
	 * on the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category List
	 * @sig (a, a -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      var strEq = R.eqBy(String);
	 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
	 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
	 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
	 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
	 */
	module.exports = _curry2(function uniqWith(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var item;
	  while (idx < len) {
	    item = list[idx];
	    if (!_containsWith(pred, item, result)) {
	      result[result.length] = item;
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(58);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _lodash = __webpack_require__(288);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _TimeInput = __webpack_require__(218);
	
	var _toMoment2 = __webpack_require__(33);
	
	var _toMoment3 = _interopRequireDefault(_toMoment2);
	
	var _parseFormat2 = __webpack_require__(904);
	
	var _parseFormat3 = _interopRequireDefault(_parseFormat2);
	
	var _forwardTime = __webpack_require__(161);
	
	var _forwardTime2 = _interopRequireDefault(_forwardTime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var emptyFn = function emptyFn() {};
	
	var BACKWARDS = {
	  Backspace: 1,
	  ArrowUp: 1,
	  ArrowDown: 1,
	  PageUp: 1,
	  PageDown: 1
	};
	
	var DateFormatInput = function (_Component) {
	  _inherits(DateFormatInput, _Component);
	
	  function DateFormatInput(props) {
	    _classCallCheck(this, DateFormatInput);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DateFormatInput).call(this, props));
	
	    var _parseFormat = (0, _parseFormat3.default)(props.dateFormat);
	
	    var positions = _parseFormat.positions;
	    var matches = _parseFormat.matches;
	
	    var defaultValue = props.defaultValue || Date.now();
	
	    var delay = props.changeDelay;
	    _this.throttleSetValue = delay == -1 ? _this.setValue : (0, _lodash2.default)(_this.setValue, delay);
	
	    var _this$getMinMax = _this.getMinMax(props);
	
	    var minDate = _this$getMinMax.minDate;
	    var maxDate = _this$getMinMax.maxDate;
	
	
	    _this.state = {
	      positions: positions,
	      matches: matches,
	      propsValue: props.value !== undefined,
	      value: defaultValue,
	      minDate: minDate,
	      maxDate: maxDate
	    };
	    return _this;
	  }
	
	  _createClass(DateFormatInput, [{
	    key: 'getMinMax',
	    value: function getMinMax(props) {
	      props = props || this.props;
	
	      var minDate = null;
	
	      if (props.minDate) {
	        minDate = this.toMoment(props.minDate, props);
	      }
	
	      var maxDate = null;
	
	      if (props.maxDate) {
	        maxDate = this.toMoment(props.maxDate, props);
	      }
	
	      return {
	        minDate: minDate, maxDate: maxDate
	      };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _getMinMax = this.getMinMax(nextProps);
	
	      var minDate = _getMinMax.minDate;
	      var maxDate = _getMinMax.maxDate;
	
	
	      this.setState({
	        minDate: minDate, maxDate: maxDate
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.value !== undefined && this.caretPos && this.isFocused()) {
	        this.setCaretPosition(this.caretPos);
	      }
	    }
	  }, {
	    key: 'toMoment',
	    value: function toMoment(value, props) {
	      props = props || this.props;
	
	      return (0, _toMoment3.default)(value, {
	        locale: props.locale,
	        dateFormat: props.dateFormat || this.props.dateFormat
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	
	
	      var value = this.state.propsValue ? props.value : this.state.value;
	
	      var displayValue = this.displayValue = this.toMoment(value).format(props.dateFormat);
	
	      var inputProps = (0, _objectAssign2.default)({}, props);
	
	      delete inputProps.changeDelay;
	      delete inputProps.date;
	      delete inputProps.dateFormat;
	      delete inputProps.isDateInput;
	      delete inputProps.maxDate;
	      delete inputProps.minDate;
	      delete inputProps.stopPropagation;
	      delete inputProps.updateOnWheel;
	
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(inputProps);
	      }
	
	      return _react2.default.createElement('input', _extends({}, inputProps, {
	        defaultValue: undefined,
	        onFocus: this.onFocus,
	        onBlur: this.onBlur,
	        value: displayValue,
	        onKeyDown: this.onKeyDown,
	        onWheel: this.onWheel,
	        onChange: this.onChange
	      }));
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      (0, _reactDom.findDOMNode)(this).focus();
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(event) {
	      if (this.props.onFocus) {
	        this.props.onFocus(event);
	      }
	
	      this.setState({
	        focused: true
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(event) {
	      if (this.props.onBlur) {
	        this.props.onBlur(event);
	      }
	
	      this.setState({
	        focused: false
	      });
	    }
	  }, {
	    key: 'isFocused',
	    value: function isFocused() {
	      return this.state.focused;
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      event.stopPropagation();
	    }
	  }, {
	    key: 'onDirection',
	    value: function onDirection(dir) {
	      var event = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      this.onKeyDown({
	        key: dir > 0 ? 'ArrowUp' : 'ArrowDown',
	        type: event.type || 'unknown',
	        stopPropagation: typeof event.stopPropagation == 'function' ? function () {
	          return event.stopPropagation();
	        } : emptyFn,
	        preventDefault: typeof event.preventDefault == 'function' ? function () {
	          return event.preventDefault();
	        } : emptyFn
	      });
	    }
	  }, {
	    key: 'onWheel',
	    value: function onWheel(event) {
	      if (this.props.updateOnWheel && this.isFocused()) {
	        this.onDirection(-event.deltaY, event);
	        // this.onKeyDown({
	        //   key: event.deltaY < 0 ? 'ArrowUp' : 'ArrowDown',
	        //   type: event.type,
	        //   stopPropagation: () => event.stopPropagation(),
	        //   preventDefault: () => event.preventDefault()
	        // })
	      }
	
	      if (this.props.onWheel) {
	        this.props.onWheel(event);
	      }
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(event) {
	      var _this2 = this;
	
	      var props = this.props;
	      var key = event.key;
	      var type = event.type;
	      var which = event.which;
	
	
	      if (key !== 'Unidentified' && which && which >= 65 && which <= 90) {
	        key = ' ';
	      }
	
	      if (key != ' ' && key * 1 == key) {
	        key = 'Unidentified';
	      }
	
	      if (props.stopPropagation) {
	        event.stopPropagation();
	      }
	
	      var range = this.getSelectedRange();
	      var selectedValue = this.getSelectedValue(range);
	      var value = this.displayValue;
	
	      var _state = this.state;
	      var positions = _state.positions;
	      var matches = _state.matches;
	
	      var valueStr = '' + value;
	
	      var currentPosition = positions[range.start];
	
	      if (typeof currentPosition == 'string') {
	        currentPosition = positions[range.start + (key in BACKWARDS ? -1 : 1)];
	      }
	
	      if (!currentPosition) {
	        currentPosition = positions[range.start - 1];
	      }
	
	      if (props.onKeyDown && type == 'keydown') {
	        if (props.onKeyDown(event, currentPosition) === false) {
	          this.caretPos = range;
	          return;
	        }
	      }
	
	      var keyName = key;
	
	      if (key == 'ArrowUp' || key == 'ArrowDown') {
	        keyName = 'Arrow';
	      }
	
	      var handlerName = 'handle' + keyName;
	
	      var preventDefault = void 0;
	      var newValue = void 0;
	      var newCaretPos = void 0;
	
	      if (currentPosition && currentPosition[handlerName]) {
	        var returnValue = currentPosition[handlerName](currentPosition, {
	          range: range,
	          selectedValue: selectedValue,
	          value: value,
	          positions: positions,
	          currentValue: valueStr.substring(currentPosition.start, currentPosition.end + 1),
	          matches: matches,
	          event: event,
	          key: key,
	          input: this.getInput(),
	          setCaretPosition: function setCaretPosition() {
	            return _this2.setCaretPosition.apply(_this2, arguments);
	          }
	        });
	
	        this.caretPos = range;
	
	        if (returnValue && returnValue.value !== undefined) {
	          newValue = valueStr.substring(0, currentPosition.start) + returnValue.value + valueStr.substring(currentPosition.end + 1);
	
	          newCaretPos = returnValue.caretPos || range;
	          if (newCaretPos === true) {
	            newCaretPos = { start: currentPosition.start, end: currentPosition.end + 1 };
	          }
	          preventDefault = returnValue.preventDefault !== false;
	        }
	      }
	
	      if (preventDefault || key == 'Backspace' || key == 'Delete' || key == ' ') {
	        if (!preventDefault) {
	          this.setCaretPosition(this.caretPos = {
	            start: range.start + (key == 'Backspace' ? -1 : 1)
	          });
	        }
	        preventDefault = true;
	      }
	
	      var config = {
	        currentPosition: currentPosition,
	        preventDefault: preventDefault,
	        event: event,
	        value: newValue,
	        stop: false
	      };
	
	      if (this.props.afterKeyDown && type == 'keydown') {
	        this.props.afterKeyDown(config);
	      }
	
	      if (!config.stop && newCaretPos !== undefined) {
	        var updateCaretPos = function updateCaretPos() {
	          return _this2.setCaretPosition(newCaretPos);
	        };
	        this.caretPos = newCaretPos;
	        this.setStateValue(newValue, updateCaretPos, { key: key, oldValue: valueStr, currentPosition: currentPosition });
	      }
	
	      if (config.preventDefault) {
	        event.preventDefault();
	      }
	    }
	  }, {
	    key: 'getInput',
	    value: function getInput() {
	      return (0, _reactDom.findDOMNode)(this);
	    }
	  }, {
	    key: 'setCaretPosition',
	    value: function setCaretPosition(pos) {
	      var dom = this.getInput();
	      if (dom) {
	        (0, _TimeInput.setCaretPosition)(dom, pos);
	      }
	    }
	  }, {
	    key: 'format',
	    value: function format(mom, _format) {
	      return mom.format(_format || this.props.dateFormat);
	    }
	  }, {
	    key: 'setStateValue',
	    value: function setStateValue(value, callback, _ref) {
	      var key = _ref.key;
	      var oldValue = _ref.oldValue;
	      var currentPosition = _ref.currentPosition;
	
	      var dateMoment = this.toMoment(value);
	
	      if (!dateMoment.isValid()) {
	        var dir = key == 'ArrowUp' || key == 'PageUp' ? 1 : -1;
	
	        if (currentPosition.format == 'MM') {
	          // updating the month
	          dateMoment = this.toMoment(oldValue).add(dir, 'month');
	        } else {
	          // updating the day
	          dateMoment = dir > 0 ?
	          // we've gone with +1 beyond max, so reset to 1
	          this.toMoment(oldValue).date(1) :
	
	          // we've gone with -1 beyond max, so reset to max of month
	          this.toMoment(oldValue).endOf('month');
	        }
	
	        if (!dateMoment.isValid()) {
	          return;
	        }
	
	        value = this.format(dateMoment);
	      }
	
	      var _state2 = this.state;
	      var minDate = _state2.minDate;
	      var maxDate = _state2.maxDate;
	
	
	      if (minDate && dateMoment.isBefore(minDate)) {
	        var clone = this.toMoment(dateMoment);
	
	        // try with time
	        dateMoment = (0, _forwardTime2.default)(clone, this.toMoment(minDate));
	
	        if (dateMoment.isBefore(minDate)) {
	          // try without time
	          dateMoment = this.toMoment(minDate);
	        }
	
	        value = this.format(dateMoment);
	      }
	
	      if (maxDate && dateMoment.isAfter(maxDate)) {
	        var _clone = this.toMoment(dateMoment);
	        dateMoment = (0, _forwardTime2.default)(_clone, this.toMoment(maxDate));
	
	        if (dateMoment.isAfter(maxDate)) {
	          dateMoment = this.toMoment(maxDate);
	        }
	
	        value = this.format(dateMoment);
	      }
	
	      this.setState({
	        value: value,
	        propsValue: false
	      }, typeof callback == 'function' && callback);
	
	      // if (this.props.value !== undefined) {
	      if (this.props.onChange) {
	        this.throttleSetValue(value, dateMoment);
	      }
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value, dateMoment) {
	      if (this.props.value === undefined) {
	        this.setState({
	          value: value,
	          propsValue: false
	        });
	      } else {
	        this.setState({
	          propsValue: true,
	          value: undefined
	        });
	      }
	
	      if (this.props.onChange) {
	        this.props.onChange(value, { dateMoment: dateMoment || this.toMoment(value) });
	      }
	    }
	  }, {
	    key: 'getSelectedRange',
	    value: function getSelectedRange() {
	      var dom = this.getInput();
	
	      return {
	        start: (0, _TimeInput.getSelectionStart)(dom),
	        end: (0, _TimeInput.getSelectionEnd)(dom)
	      };
	    }
	  }, {
	    key: 'getSelectedValue',
	    value: function getSelectedValue(range) {
	      range = range || this.getSelectedRange();
	      var value = this.displayValue;
	
	      return value.substring(range.start, range.end);
	    }
	  }]);
	
	  return DateFormatInput;
	}(_reactClass2.default);
	
	exports.default = DateFormatInput;
	
	
	DateFormatInput.defaultProps = {
	  isDateInput: true,
	  stopPropagation: true,
	  updateOnWheel: true,
	  changeDelay: 100
	};
	
	DateFormatInput.propTypes = {
	  dateFormat: _react.PropTypes.string.isRequired,
	  value: function value(props, propName) {
	    if (props[propName] !== undefined) {
	      // console.warn('Due to performance considerations, TimeInput will only be uncontrolled.')
	    }
	  }
	};

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getInitialState = exports.isValidActiveDate = exports.isDateInMinMax = exports.prepareDate = exports.prepareDateProps = exports.prepareMinMax = exports.prepareViewDate = exports.prepareActiveDate = exports.onKeyDown = exports.navigate = exports.gotoViewDate = exports.confirm = exports.select = exports.onActiveDateChange = exports.onViewDateChange = exports.onChange = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(58);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactFlex = __webpack_require__(41);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _times = __webpack_require__(162);
	
	var _times2 = _interopRequireDefault(_times);
	
	var _toMoment2 = __webpack_require__(33);
	
	var _toMoment3 = _interopRequireDefault(_toMoment2);
	
	var _join = __webpack_require__(32);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _bemFactory = __webpack_require__(84);
	
	var _bemFactory2 = _interopRequireDefault(_bemFactory);
	
	var _onKeyDown = __webpack_require__(472);
	
	var _onKeyDown2 = _interopRequireDefault(_onKeyDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var bem = (0, _bemFactory2.default)('react-date-picker__decade-view');
	
	var ARROWS = {
	  prev: _react2.default.createElement(
	    'svg',
	    { height: '24', viewBox: '0 0 24 24', width: '24' },
	    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' }),
	    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
	  ),
	
	  next: _react2.default.createElement(
	    'svg',
	    { height: '24', viewBox: '0 0 24 24', width: '24' },
	    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' }),
	    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
	  )
	};
	
	var getDecadeStartYear = function getDecadeStartYear(mom) {
	  var year = mom.get('year');
	
	  return year - year % 10;
	};
	
	var getDecadeEndYear = function getDecadeEndYear(mom) {
	  return getDecadeStartYear(mom) + 9;
	};
	
	var NAV_KEYS = {
	  ArrowUp: function ArrowUp(mom) {
	    return mom.add(-5, 'year');
	  },
	  ArrowDown: function ArrowDown(mom) {
	    return mom.add(5, 'year');
	  },
	  ArrowLeft: function ArrowLeft(mom) {
	    return mom.add(-1, 'year');
	  },
	  ArrowRight: function ArrowRight(mom) {
	    return mom.add(1, 'year');
	  },
	  Home: function Home(mom) {
	    return mom.set('year', getDecadeStartYear(mom));
	  },
	  End: function End(mom) {
	    return mom.set('year', getDecadeEndYear(mom));
	  },
	  PageUp: function PageUp(mom) {
	    return mom.add(-10, 'year');
	  },
	  PageDown: function PageDown(mom) {
	    return mom.add(10, 'year');
	  }
	};
	
	var isDateInMinMax = function isDateInMinMax(timestamp, props) {
	  if (props.minDate && timestamp < props.minDate) {
	    return false;
	  }
	
	  if (props.maxDate && timestamp > props.maxDate) {
	    return false;
	  }
	
	  return true;
	};
	
	var isValidActiveDate = function isValidActiveDate(timestamp, props) {
	  if (!props) {
	    throw new Error('props is mandatory in isValidActiveDate');
	  }
	
	  return isDateInMinMax(timestamp, props);
	};
	
	var _select = function _select(_ref, event) {
	  var dateMoment = _ref.dateMoment;
	  var timestamp = _ref.timestamp;
	
	  if (this.props.select) {
	    return this.props.select({ dateMoment: dateMoment, timestamp: timestamp }, event);
	  }
	
	  if (!timestamp) {
	    timestamp = +dateMoment;
	  }
	
	  this.gotoViewDate({ dateMoment: dateMoment, timestamp: timestamp });
	  this.onChange({ dateMoment: dateMoment, timestamp: timestamp }, event);
	
	  return undefined;
	};
	
	var _confirm = function _confirm(date, event) {
	  event.preventDefault();
	
	  if (this.props.confirm) {
	    return this.props.confirm(date, event);
	  }
	
	  var dateMoment = this.toMoment(date);
	  var timestamp = +dateMoment;
	
	  this.select({ dateMoment: dateMoment, timestamp: timestamp }, event);
	
	  if (this.props.onConfirm) {
	    this.props.onConfirm({ dateMoment: dateMoment, timestamp: timestamp });
	  }
	
	  return undefined;
	};
	
	var _onActiveDateChange = function _onActiveDateChange(_ref2) {
	  var dateMoment = _ref2.dateMoment;
	  var timestamp = _ref2.timestamp;
	
	  if (!isValidActiveDate(timestamp, this.p)) {
	    return;
	  }
	
	  if (this.props.activeDate === undefined) {
	    this.setState({
	      activeDate: timestamp
	    });
	  }
	
	  if (this.props.onActiveDateChange) {
	    var dateString = this.format(dateMoment);
	    this.props.onActiveDateChange(dateString, { dateMoment: dateMoment, timestamp: timestamp, dateString: dateString });
	  }
	};
	
	var _onViewDateChange = function _onViewDateChange(_ref3) {
	  var dateMoment = _ref3.dateMoment;
	  var timestamp = _ref3.timestamp;
	
	  if (dateMoment && timestamp === undefined) {
	    timestamp = +dateMoment;
	  }
	
	  if (this.props.constrainViewDate && !isDateInMinMax(timestamp, this.p)) {
	    return;
	  }
	
	  if (this.props.viewDate === undefined) {
	    this.setState({
	      viewDate: timestamp
	    });
	  }
	
	  if (this.props.onViewDateChange) {
	    var dateString = this.format(dateMoment);
	    this.props.onViewDateChange(dateString, { dateMoment: dateMoment, dateString: dateString, timestamp: timestamp });
	  }
	};
	
	var _onChange = function _onChange(_ref4, event) {
	  var dateMoment = _ref4.dateMoment;
	  var timestamp = _ref4.timestamp;
	
	  if (this.props.date === undefined) {
	    this.setState({
	      date: timestamp
	    });
	  }
	
	  if (this.props.onChange) {
	    var dateString = this.format(dateMoment);
	    this.props.onChange(dateString, { dateMoment: dateMoment, timestamp: timestamp, dateString: dateString }, event);
	  }
	};
	
	var _navigate = function _navigate(direction, event) {
	  var _this = this;
	
	  var props = this.p;
	
	  var getNavigationDate = function getNavigationDate(dir, date, dateFormat) {
	    var mom = _moment2.default.isMoment(date) ? date : _this.toMoment(date, dateFormat);
	
	    if (typeof dir == 'function') {
	      return dir(mom);
	    }
	
	    return mom;
	  };
	
	  if (props.navigate) {
	    return props.navigate(direction, event, getNavigationDate);
	  }
	
	  event.preventDefault();
	
	  if (props.activeDate) {
	    var nextMoment = getNavigationDate(direction, props.activeDate);
	
	    this.gotoViewDate({ dateMoment: nextMoment });
	  }
	
	  return undefined;
	};
	
	var _gotoViewDate = function _gotoViewDate(_ref5) {
	  var dateMoment = _ref5.dateMoment;
	  var timestamp = _ref5.timestamp;
	
	  if (!timestamp) {
	    timestamp = dateMoment == null ? null : +dateMoment;
	  }
	
	  this.onViewDateChange({ dateMoment: dateMoment, timestamp: timestamp });
	  this.onActiveDateChange({ dateMoment: dateMoment, timestamp: timestamp });
	};
	
	var prepareDate = function prepareDate(props, state) {
	  return props.date === undefined ? state.date : props.date;
	};
	
	var prepareViewDate = function prepareViewDate(props, state) {
	  var viewDate = props.viewDate === undefined ? state.viewDate : props.viewDate;
	
	  if (!viewDate && props.date) {
	    return props.date;
	  }
	
	  return viewDate;
	};
	
	var prepareActiveDate = function prepareActiveDate(props, state) {
	  var activeDate = props.activeDate === undefined ? state.activeDate || prepareDate(props, state) : props.activeDate;
	
	  return activeDate;
	};
	
	var prepareMinMax = function prepareMinMax(props) {
	  var minDate = props.minDate;
	  var maxDate = props.maxDate;
	
	
	  var result = {};
	
	  if (minDate != null) {
	    result.minDateMoment = (0, _toMoment3.default)(props.minDate, props).startOf(props.adjustMinDateStartOf);
	
	    result.minDate = +result.minDateMoment;
	  }
	
	  if (maxDate != null) {
	    result.maxDateMoment = (0, _toMoment3.default)(props.maxDate, props).endOf(props.adjustMaxDateStartOf);
	
	    result.maxDate = +result.maxDateMoment;
	  }
	
	  return result;
	};
	
	var prepareDateProps = function prepareDateProps(props, state) {
	  var result = {};
	
	  (0, _objectAssign2.default)(result, prepareMinMax(props));
	
	  result.date = prepareDate(props, state);
	  result.viewDate = prepareViewDate(props, state);
	
	  var activeDate = prepareActiveDate(props, state);
	
	  if (result.date != null) {
	    result.moment = (0, _toMoment3.default)(result.date, props);
	    if (props.adjustDateStartOf) {
	      result.moment.startOf(props.adjustDateStartOf);
	    }
	    result.timestamp = +result.moment;
	  }
	
	  if (activeDate) {
	    result.activeMoment = (0, _toMoment3.default)(activeDate, props);
	    if (props.adjustDateStartOf) {
	      result.activeMoment.startOf(props.adjustDateStartOf);
	    }
	    result.activeDate = +result.activeMoment;
	  }
	
	  var viewMoment = (0, _toMoment3.default)(result.viewDate, props);
	
	  if (props.constrainViewDate && result.minDate != null && viewMoment.isBefore(result.minDate)) {
	    result.minConstrained = true;
	    viewMoment = (0, _toMoment3.default)(result.minDate, props);
	  }
	
	  if (props.constrainViewDate && result.maxDate != null && viewMoment.isAfter(result.maxDate)) {
	    result.maxConstrained = true;
	    viewMoment = (0, _toMoment3.default)(result.maxDate, props);
	  }
	
	  if (props.adjustDateStartOf) {
	    viewMoment.startOf(props.adjustDateStartOf);
	  }
	
	  result.viewMoment = viewMoment;
	
	  return result;
	};
	
	var getInitialState = function getInitialState(props) {
	  return {
	    date: props.defaultDate,
	    activeDate: props.defaultActiveDate,
	    viewDate: props.defaultViewDate
	  };
	};
	
	var DecadeView = function (_Component) {
	  _inherits(DecadeView, _Component);
	
	  function DecadeView(props) {
	    _classCallCheck(this, DecadeView);
	
	    var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(DecadeView).call(this, props));
	
	    _this2.state = getInitialState(props);
	    return _this2;
	  }
	
	  _createClass(DecadeView, [{
	    key: 'getYearsInDecade',
	    value: function getYearsInDecade(value) {
	      var _this3 = this;
	
	      var year = getDecadeStartYear(this.toMoment(value));
	
	      var start = this.toMoment('' + year, 'YYYY').startOf('year');
	
	      return (0, _times2.default)(10).map(function (i) {
	        return _this3.toMoment(start).add(i, 'year');
	      });
	    }
	  }, {
	    key: 'toMoment',
	    value: function toMoment(date, format) {
	      return (0, _toMoment3.default)(date, format, this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = this.p = (0, _objectAssign2.default)({}, this.props);
	
	      if (props.onlyCompareYear) {
	        // props.adjustDateStartOf = null
	      }
	
	      var dateProps = prepareDateProps(props, this.state);
	
	      (0, _objectAssign2.default)(props, dateProps);
	
	      var yearsInView = this.getYearsInDecade(props.viewMoment);
	
	      var className = (0, _join2.default)(props.className, bem(), props.theme && bem(null, 'theme-' + props.theme));
	
	      var children = this.renderYears(props, yearsInView);
	      var align = 'stretch';
	      var column = true;
	
	      if (props.navigation) {
	        column = false;
	        align = 'center';
	
	        children = [this.renderNav(-1), _react2.default.createElement(_reactFlex.Flex, { inline: true, flex: true, column: true, alignItems: 'stretch', children: children }), this.renderNav(1)];
	      }
	
	      var flexProps = (0, _objectAssign2.default)({}, this.props);
	
	      delete flexProps.activeDate;
	      delete flexProps.adjustDateStartOf;
	      delete flexProps.adjustMaxDateStartOf;
	      delete flexProps.adjustMinDateStartOf;
	      delete flexProps.arrows;
	      delete flexProps.cleanup;
	      delete flexProps.constrainViewDate;
	      delete flexProps.date;
	      delete flexProps.dateFormat;
	      delete flexProps.isDecadeView;
	      delete flexProps.maxDate;
	      delete flexProps.minDate;
	      delete flexProps.navigation;
	      delete flexProps.navKeys;
	      delete flexProps.onActiveDateChange;
	      delete flexProps.onConfirm;
	      delete flexProps.onlyCompareYear;
	      delete flexProps.onViewDateChange;
	      delete flexProps.perRow;
	      delete flexProps.theme;
	      delete flexProps.viewDate;
	      delete flexProps.yearFormat;
	
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(flexProps);
	      }
	
	      return _react2.default.createElement(_reactFlex.Flex, _extends({
	        inline: true,
	        column: column,
	        alignItems: align,
	        tabIndex: 0
	      }, flexProps, {
	        onKeyDown: this.onKeyDown,
	        className: className,
	        children: children
	      }));
	    }
	  }, {
	    key: 'renderNav',
	    value: function renderNav(dir) {
	      var _this4 = this;
	
	      var props = this.p;
	
	      var name = dir == -1 ? 'prev' : 'next';
	      var navMoment = this.toMoment(props.viewMoment).add(dir * 10, 'year');
	
	      var disabled = dir == -1 ? props.minDateMoment && getDecadeEndYear(navMoment) < getDecadeEndYear(props.minDateMoment) : props.maxDateMoment && getDecadeEndYear(navMoment) > getDecadeEndYear(props.maxDateMoment);
	
	      var className = (0, _join2.default)(bem('arrow'), bem('arrow--' + name), disabled && bem('arrow--disabled'));
	
	      var arrow = props.arrows[name] || ARROWS[name];
	
	      var arrowProps = {
	        className: className,
	        onClick: !disabled ? function () {
	          return _this4.onViewDateChange({ dateMoment: navMoment });
	        } : null,
	        children: arrow,
	        disabled: disabled
	      };
	
	      if (props.renderNavigation) {
	        return props.renderNavigation(arrowProps, props);
	      }
	
	      return _react2.default.createElement('div', arrowProps);
	    }
	  }, {
	    key: 'renderYears',
	    value: function renderYears(props, years) {
	      var nodes = years.map(this.renderYear);
	
	      var perRow = props.perRow;
	      var buckets = (0, _times2.default)(Math.ceil(nodes.length / perRow)).map(function (i) {
	        return nodes.slice(i * perRow, (i + 1) * perRow);
	      });
	
	      return buckets.map(function (bucket, i) {
	        return _react2.default.createElement(
	          _reactFlex.Flex,
	          {
	            alignItems: 'center',
	            flex: true,
	            row: true,
	            inline: true,
	            key: 'row_' + i,
	            className: 'dp-row'
	          },
	          bucket
	        );
	      });
	    }
	  }, {
	    key: 'renderYear',
	    value: function renderYear(dateMoment) {
	      var props = this.p;
	      var yearText = this.format(dateMoment);
	
	      var timestamp = +dateMoment;
	
	      var isActiveDate = props.onlyCompareYear && props.activeMoment ? dateMoment.get('year') == props.activeMoment.get('year') : timestamp === props.activeDate;
	
	      var isValue = props.onlyCompareYear && props.moment ? dateMoment.get('year') == props.moment.get('year') : timestamp === props.timestamp;
	
	      var className = (0, _join2.default)(bem('year'), isActiveDate && bem('year', 'active'), isValue && bem('year', 'value'), props.minDate != null && timestamp < props.minDate && bem('year', 'disabled'), props.maxDate != null && timestamp > props.maxDate && bem('year', 'disabled'));
	
	      var onClick = this.handleClick.bind(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	
	      return _react2.default.createElement(
	        _reactFlex.Item,
	        {
	          key: yearText,
	          className: className,
	          onClick: onClick
	        },
	        yearText
	      );
	    }
	  }, {
	    key: 'format',
	    value: function format(mom, _format) {
	      _format = _format || this.props.yearFormat;
	
	      return mom.format(_format);
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(_ref6, event) {
	      var timestamp = _ref6.timestamp;
	      var dateMoment = _ref6.dateMoment;
	
	      event.target.value = timestamp;
	
	      var props = this.p;
	      if (props.minDate && timestamp < props.minDate) {
	        return;
	      }
	
	      if (props.maxDate && timestamp > props.maxDate) {
	        return;
	      }
	
	      this.select({ dateMoment: dateMoment, timestamp: timestamp }, event);
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(event) {
	      return _onKeyDown2.default.call(this, event);
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm(date, event) {
	      return _confirm.call(this, date, event);
	    }
	  }, {
	    key: 'navigate',
	    value: function navigate(direction, event) {
	      return _navigate.call(this, direction, event);
	    }
	  }, {
	    key: 'select',
	    value: function select(_ref7, event) {
	      var dateMoment = _ref7.dateMoment;
	      var timestamp = _ref7.timestamp;
	
	      return _select.call(this, { dateMoment: dateMoment, timestamp: timestamp }, event);
	    }
	  }, {
	    key: 'onViewDateChange',
	    value: function onViewDateChange(_ref8) {
	      var dateMoment = _ref8.dateMoment;
	      var timestamp = _ref8.timestamp;
	
	      return _onViewDateChange.call(this, { dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }, {
	    key: 'gotoViewDate',
	    value: function gotoViewDate(_ref9) {
	      var dateMoment = _ref9.dateMoment;
	      var timestamp = _ref9.timestamp;
	
	      return _gotoViewDate.call(this, { dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }, {
	    key: 'onActiveDateChange',
	    value: function onActiveDateChange(_ref10) {
	      var dateMoment = _ref10.dateMoment;
	      var timestamp = _ref10.timestamp;
	
	      return _onActiveDateChange.call(this, { dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(_ref11, event) {
	      var dateMoment = _ref11.dateMoment;
	      var timestamp = _ref11.timestamp;
	
	      return _onChange.call(this, { dateMoment: dateMoment, timestamp: timestamp }, event);
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      (0, _reactDom.findDOMNode)(this).focus();
	    }
	  }]);
	
	  return DecadeView;
	}(_reactClass2.default);
	
	exports.default = DecadeView;
	
	
	DecadeView.defaultProps = {
	  isDecadeView: true,
	  arrows: {},
	  navigation: true,
	  constrainViewDate: true,
	  navKeys: NAV_KEYS,
	  theme: 'default',
	  yearFormat: 'YYYY',
	  dateFormat: 'YYYY-MM-DD',
	  perRow: 5,
	
	  onlyCompareYear: true,
	
	  adjustDateStartOf: 'year',
	  adjustMinDateStartOf: 'year',
	  adjustMaxDateStartOf: 'year'
	};
	
	exports.onChange = _onChange;
	exports.onViewDateChange = _onViewDateChange;
	exports.onActiveDateChange = _onActiveDateChange;
	exports.select = _select;
	exports.confirm = _confirm;
	exports.gotoViewDate = _gotoViewDate;
	exports.navigate = _navigate;
	exports.onKeyDown = _onKeyDown2.default;
	exports.prepareActiveDate = prepareActiveDate;
	exports.prepareViewDate = prepareViewDate;
	exports.prepareMinMax = prepareMinMax;
	exports.prepareDateProps = prepareDateProps;
	exports.prepareDate = prepareDate;
	exports.isDateInMinMax = isDateInMinMax;
	exports.isValidActiveDate = isValidActiveDate;
	exports.getInitialState = getInitialState;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Button = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _reactFlex = __webpack_require__(41);
	
	var _reactInlineBlock = __webpack_require__(122);
	
	var _reactInlineBlock2 = _interopRequireDefault(_reactInlineBlock);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _joinFunctions = __webpack_require__(117);
	
	var _joinFunctions2 = _interopRequireDefault(_joinFunctions);
	
	var _join = __webpack_require__(32);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _bemFactory = __webpack_require__(84);
	
	var _bemFactory2 = _interopRequireDefault(_bemFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var bem = (0, _bemFactory2.default)('react-date-picker__footer');
	
	var SPACER = _react2.default.createElement(_reactFlex.Item, null);
	
	var buttonClassName = 'react-date-picker__footer-button';
	
	var preventDefault = function preventDefault(e) {
	  return e.preventDefault();
	};
	
	var Button = exports.Button = function Button(props) {
	  var disabledClassName = props.disabled ? buttonClassName + '--disabled' : '';
	
	  var className = (props.className || '') + ' ' + buttonClassName + ' ' + disabledClassName;
	  return _react2.default.createElement('button', _extends({
	    tabIndex: -1
	  }, props, {
	    className: className
	  }));
	};
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Footer).apply(this, arguments));
	  }
	
	  _createClass(Footer, [{
	    key: 'render',
	    value: function render() {
	      var props = this.p = (0, _objectAssign2.default)({}, this.props);
	
	      var className = (0, _join2.default)(props.className, bem(), bem(null, 'theme-' + props.theme));
	
	      var todayButton = this.renderTodayButton();
	      var clearButton = this.renderClearButton();
	
	      var okButton = this.renderOkButton();
	      var cancelButton = this.renderCancelButton();
	
	      if (!todayButton && !clearButton && !okButton && !cancelButton) {
	        return null;
	      }
	
	      var middleSpacer = okButton || cancelButton ? SPACER : null;
	
	      var spacer = !props.centerButtons ? middleSpacer : null;
	
	      var children = [props.centerButtons && SPACER, todayButton, clearButton, spacer, okButton, cancelButton, props.centerButtons && SPACER];
	
	      if (props.renderChildren) {
	        children = props.renderChildren(children, props);
	      }
	
	      var flexProps = (0, _objectAssign2.default)({}, props);
	
	      delete flexProps.actionEvent;
	      delete flexProps.buttonFactory;
	      delete flexProps.cancelButton;
	      delete flexProps.cancelButtonText;
	      delete flexProps.centerButtons;
	      delete flexProps.clearDate;
	      delete flexProps.cleanup;
	      delete flexProps.clearButton;
	      delete flexProps.clearButtonText;
	      delete flexProps.isDatePickerFooter;
	      delete flexProps.onCancelClick;
	      delete flexProps.onClearClick;
	      delete flexProps.onOkClick;
	      delete flexProps.onTodayClick;
	      delete flexProps.okButton;
	      delete flexProps.okButtonText;
	      delete flexProps.selectDate;
	      delete flexProps.theme;
	      delete flexProps.todayButton;
	      delete flexProps.todayButtonText;
	
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(flexProps);
	      }
	
	      return _react2.default.createElement(_reactFlex.Flex, _extends({
	        inline: true,
	        row: true
	      }, flexProps, {
	        justifyContent: 'center',
	        className: className,
	        children: children
	      }));
	    }
	  }, {
	    key: 'renderTodayButton',
	    value: function renderTodayButton() {
	      if (!this.props.todayButton) {
	        return null;
	      }
	      return this.renderButton(this.props.todayButtonText, this.props.onTodayClick);
	    }
	  }, {
	    key: 'renderClearButton',
	    value: function renderClearButton() {
	      if (!this.props.clearButton) {
	        return null;
	      }
	
	      return this.renderButton({
	        children: this.props.clearButtonText,
	        disabled: this.props.clearDate === undefined
	      }, this.props.onClearClick);
	    }
	  }, {
	    key: 'renderOkButton',
	    value: function renderOkButton() {
	      if (!this.props.okButton) {
	        return null;
	      }
	      return this.renderButton(this.props.okButtonText, this.props.onOkClick);
	    }
	  }, {
	    key: 'renderCancelButton',
	    value: function renderCancelButton() {
	      if (!this.props.cancelButton) {
	        return null;
	      }
	      return this.renderButton(this.props.cancelButtonText, this.props.onCancelClick);
	    }
	  }, {
	    key: 'renderButton',
	    value: function renderButton(props, fn) {
	      var text = props.children;
	      var p = props;
	
	      if (typeof props == 'string') {
	        p = {};
	        text = props;
	      }
	
	      if (typeof fn == 'function' && !p.onClick && !p.disabled) {
	        p.onClick = fn;
	      }
	
	      var Factory = this.props.buttonFactory;
	
	      var onMouseDown = p.onMouseDown ? (0, _joinFunctions2.default)(p.onMouseDown, preventDefault) : preventDefault;
	
	      return _react2.default.createElement(
	        Factory,
	        _extends({ tabIndex: 0 }, p, { onMouseDown: onMouseDown }),
	        text
	      );
	    }
	  }]);
	
	  return Footer;
	}(_reactClass2.default);
	
	exports.default = Footer;
	
	
	Footer.defaultProps = {
	  actionEvent: 'onClick',
	  theme: 'default',
	
	  buttonFactory: Button,
	
	  todayButton: true,
	  clearButton: true,
	  okButton: true,
	  cancelButton: true,
	
	  todayButtonText: 'Today',
	  clearButtonText: 'Clear',
	  okButtonText: 'OK',
	  cancelButtonText: 'Cancel',
	
	  isDatePickerFooter: true
	};
	
	Footer.propTypes = {
	  theme: _react.PropTypes.string,
	  centerButtons: _react.PropTypes.bool,
	
	  cokButtonText: _react.PropTypes.node,
	  clearButtonText: _react.PropTypes.node,
	  cancelButtonText: _react.PropTypes.node,
	  todayButtonText: _react.PropTypes.node,
	
	  onTodayClick: _react.PropTypes.func,
	  onClearClick: _react.PropTypes.func,
	  onOkClick: _react.PropTypes.func,
	  onCancelClick: _react.PropTypes.func
	};

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toTimeValue = exports.setCaretPosition = exports.getNewValue = exports.getSelectionEnd = exports.getSelectionStart = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(58);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _raf = __webpack_require__(706);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _toMoment = __webpack_require__(33);
	
	var _toMoment2 = _interopRequireDefault(_toMoment);
	
	var _join = __webpack_require__(32);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _Clock = __webpack_require__(158);
	
	var _Clock2 = _interopRequireDefault(_Clock);
	
	var _reactFlex = __webpack_require__(41);
	
	var _getSelectionStart = __webpack_require__(908);
	
	var _getSelectionStart2 = _interopRequireDefault(_getSelectionStart);
	
	var _getSelectionEnd = __webpack_require__(907);
	
	var _getSelectionEnd2 = _interopRequireDefault(_getSelectionEnd);
	
	var _setCaretPosition2 = __webpack_require__(909);
	
	var _setCaretPosition3 = _interopRequireDefault(_setCaretPosition2);
	
	var _getNewValue2 = __webpack_require__(906);
	
	var _getNewValue3 = _interopRequireDefault(_getNewValue2);
	
	var _toTimeValue = __webpack_require__(473);
	
	var _toTimeValue2 = _interopRequireDefault(_toTimeValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.getSelectionStart = _getSelectionStart2.default;
	exports.getSelectionEnd = _getSelectionEnd2.default;
	exports.getNewValue = _getNewValue3.default;
	exports.setCaretPosition = _setCaretPosition3.default;
	exports.toTimeValue = _toTimeValue2.default;
	
	var TimeInput = function (_Component) {
	  _inherits(TimeInput, _Component);
	
	  function TimeInput(props) {
	    _classCallCheck(this, TimeInput);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TimeInput).call(this, props));
	
	    var format = props.format || props.timeFormat;
	
	    if (format.indexOf('hh') != 0 && format.indexOf('HH') != 0) {
	      console.warn('Please start your time format with 2 digit hours.');
	    }
	
	    var hours24 = true;
	    var meridiem = format.indexOf('a') != -1 || format.indexOf('A') != -1;
	
	    if (format.indexOf('hh') == 0) {
	      hours24 = false;
	    }
	
	    var separator = props.separator || format && format.length > 2 ? format.charAt(2) : ':';
	    var hasSeconds = format.indexOf('ss') != -1;
	
	    if (hasSeconds && format.charAt(5) != separator) {
	      console.warn('Expected minutes-seconds separator to be same as hours-minutes separator. (at position 5)');
	    }
	
	    var defaultValue = '00' + separator + '00';
	
	    if (hasSeconds) {
	      defaultValue += separator + '00';
	    }
	    if (meridiem) {
	      defaultValue += ' am';
	    }
	
	    _this.state = {
	      valueRange: props.valueRange || 0,
	      separator: separator,
	      hours24: hours24,
	      meridiem: meridiem,
	      value: props.defaultValue || defaultValue
	    };
	    return _this;
	  }
	
	  _createClass(TimeInput, [{
	    key: 'render',
	    value: function render() {
	
	      var props = this.p = (0, _objectAssign2.default)({}, this.props);
	
	      props.value = this.state.value; //props.value !== undefined?
	      // props.value:
	      // this.state.value
	
	      return _react2.default.createElement('input', _extends({}, props, {
	        defaultValue: undefined,
	        value: props.value,
	        onKeyDown: this.onKeyDown,
	        onChange: this.onChange
	      }));
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      event.stopPropagation();
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(event) {
	      var _this2 = this;
	
	      var value = this.p.value;
	
	      var valueRange = this.state.valueRange;
	
	      if (this.props.onKeyDown) {
	        this.props.onKeyDown(event);
	      }
	
	      var range = this.getSelectedRange();
	      var separator = this.props.separator || this.state.separator || ':';
	
	      var _getNewValue = (0, _getNewValue3.default)({
	        range: range,
	        event: event,
	
	        circular: this.props.circular,
	        propagate: this.props.propagate,
	
	        oldValue: value,
	        separator: separator,
	        meridiem: this.state.meridiem,
	        hours24: this.state.hours24,
	        incrementNext: this.props.incrementNext
	
	      });
	
	      var newValue = _getNewValue.value;
	      var update = _getNewValue.update;
	      var caretPos = _getNewValue.caretPos;
	
	
	      var updateCaretPos = function updateCaretPos() {
	        if (caretPos != undefined) {
	          _this2.setCaretPosition(caretPos);
	        }
	      };
	
	      if (update || caretPos) {
	        event.preventDefault();
	      }
	
	      if (update) {
	        this.setValue(newValue, updateCaretPos);
	      } else {
	        (0, _raf2.default)(updateCaretPos);
	      }
	    }
	  }, {
	    key: 'getInput',
	    value: function getInput() {
	      return (0, _reactDom.findDOMNode)(this);
	    }
	  }, {
	    key: 'setCaretPosition',
	    value: function setCaretPosition(pos) {
	      var dom = this.getInput();
	      dom && (0, _setCaretPosition3.default)(dom, pos);
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value, callback) {
	      // if (this.props.value === undefined){
	      this.setState({
	        now: Date.now(),
	        value: value
	      }, typeof callback == 'function' && callback);
	      // } else {
	      //   this.updateCallback = callback
	      // }
	
	      if (this.props.onChange) {
	        this.props.onChange(value);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.updateCallback) {
	        this.updateCallback();
	        this.updateCallback = null;
	      }
	    }
	  }, {
	    key: 'getSelectedRange',
	    value: function getSelectedRange() {
	      var dom = this.getInput();
	
	      return {
	        start: (0, _getSelectionStart2.default)(dom),
	        end: (0, _getSelectionEnd2.default)(dom)
	      };
	    }
	  }, {
	    key: 'getSelectedValue',
	    value: function getSelectedValue() {
	      var range = this.getSelectedRange();
	      var value = this.p.value;
	
	      return value.substring(range.start, range.end);
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      var value = event.target.value;
	    }
	  }, {
	    key: 'onTimeChange',
	    value: function onTimeChange(value) {
	      var time = value.split(':');
	
	      this.setState({
	        minutes: time[0] * 60 + time[1]
	      });
	    }
	  }, {
	    key: 'renderClock',
	    value: function renderClock() {
	
	      var props = this.p;
	      var clock = props.children.filter(function (child) {
	        return child && child.props && child.props.isTimePickerClock;
	      })[0];
	
	      var clockProps = {
	        time: this.state.minutes || props.date,
	        showSecondsHand: true
	      };
	
	      if (clock) {
	        return _react2.default.cloneElement(clock, clockProps);
	      }
	
	      return _react2.default.createElement(_Clock2.default, clockProps);
	    }
	  }]);
	
	  return TimeInput;
	}(_reactClass2.default);
	
	exports.default = TimeInput;
	
	
	TimeInput.defaultProps = {
	  theme: 'default',
	
	  circular: true,
	  propagate: true,
	  incrementNext: true
	};
	
	TimeInput.propTypes = {
	  format: _react.PropTypes.string,
	  value: function value(props, propName) {
	    if (props[propName] !== undefined) {
	      console.warn('Due to performance considerations, TimeInput will only be uncontrolled.');
	    }
	  }
	};

/***/ },
/* 219 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (str) {
	
	  if (typeof str == 'string' && str.length < 2) {
	    return str.length ? '0' + str : '00';
	  }
	
	  if (typeof str == 'number') {
	    return str < 10 ? '0' + str : str + '';
	  }
	
	  return str;
	};

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(96);
	var Danger = __webpack_require__(921);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactInstrumentation = __webpack_require__(51);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(229);
	var setInnerHTML = __webpack_require__(167);
	var setTextContent = __webpack_require__(497);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 221 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactErrorUtils = __webpack_require__(227);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(19);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 224 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactPropTypesSecret = __webpack_require__(950);
	var propTypesFactory = __webpack_require__(404);
	
	var React = __webpack_require__(102);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(19);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(12);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactCurrentOwner = __webpack_require__(66);
	var ReactInstanceMap = __webpack_require__(120);
	var ReactInstrumentation = __webpack_require__(51);
	var ReactUpdates = __webpack_require__(59);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(19);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 229 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 230 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 231 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 232 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(40);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 234 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var emptyFunction = __webpack_require__(63);
	var warning = __webpack_require__(19);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 236 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 237 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var notEmpty = function notEmpty(v) {
	  return !!v;
	};
	
	exports.default = function () {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return args.filter(notEmpty).join(' ');
	};

/***/ },
/* 238 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(8);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(61);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(8);
	
	var _getRouteParams = __webpack_require__(1027);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(239);
	
	var _RouteUtils = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 242 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var colors = {
	  primary: '#c78c2f',
	  lightGrey: '#ededed',
	  darkGrey: '#d8d8d8',
	  black: '#303030',
	  red: '#d61600',
	  greenBlue: '#2ad587',
	  white: '#ffffff',
	  overlay: 'rgba(56, 56, 56, 0.78)',
	  whiteOverlay: 'rgba(255, 255, 255, 0.25)'
	};
	
	exports.default = colors;

/***/ },
/* 243 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var errorMessages = exports.errorMessages = {
	  diferentPasswords: 'Passwords don\'t match',
	  emailAlreadyExists: 'The email already exists',
	  emailOrPassWrong: 'The email or password are wrong',
	  general: 'An error occurred',
	  linkedinAuthentication: 'An error occurred when authenticating with Linkedin'
	};

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  .GMap {\n    height: 100%;\n    position: absolute;\n    width: 100%;\n    top: 0;\n    left: 0;\n    margin-top: -20px;\n    z-index: 0;\n    .GMap-canvas {\n      top: 20px;\n      display: block;\n      width: 100%;\n      height: 100%;\n      overflow: hidden;\n    }\n  }\n'], ['\n  .GMap {\n    height: 100%;\n    position: absolute;\n    width: 100%;\n    top: 0;\n    left: 0;\n    margin-top: -20px;\n    z-index: 0;\n    .GMap-canvas {\n      top: 20px;\n      display: block;\n      width: 100%;\n      height: 100%;\n      overflow: hidden;\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  display: block;\n  overflow: hidden;\n'], ['\n  width: 100%;\n  height: 100%;\n  display: block;\n  overflow: hidden;\n']);
	
	var _immutable = __webpack_require__(29);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _MapUtils = __webpack_require__(1042);
	
	var _MapUtils2 = _interopRequireDefault(_MapUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* globals google */
	
	
	var MapContainer = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var Map = function (_Component) {
	  _inherits(Map, _Component);
	
	  function Map(props) {
	    _classCallCheck(this, Map);
	
	    var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));
	
	    _this.state = {
	      zoom: props.zoom,
	      mapSettings: {
	        zoom: props.zoom,
	        scrollwheel: props.scrollable,
	        draggable: props.draggable,
	        center: new google.maps.LatLng(_this.props.initialCenter.lat, _this.props.initialCenter.lng),
	        disableDefaultUI: props.disableUI
	      }
	    };
	    _this.map = null;
	    _this.markers = [];
	    _this.markerClusters = null;
	    _this.setMarkers = _this.setMarkers.bind(_this);
	    _this.clearMarkers = _this.clearMarkers.bind(_this);
	    return _this;
	  }
	
	  _createClass(Map, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var places = this.props.places;
	
	      if (!(0, _immutable.fromJS)(places).equals((0, _immutable.fromJS)(nextProps.places))) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.map = _MapUtils2.default.createMap(this.state.mapSettings, this.refs.mapCanvas);
	      this.setMarkers(this.props.places);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var initialCenter = this.props.initialCenter;
	
	      if (nextProps.places) {
	        this.clearMarkers();
	        this.setMarkers(nextProps.places);
	      }
	      if (initialCenter.lat !== nextProps.initialCenter.lat && initialCenter.lng !== nextProps.initialCenter.lng) {
	        this.map.setCenter(nextProps.initialCenter);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.markers.forEach(function (marker) {
	        return google.maps.event.clearListeners(marker, 'click');
	      });
	    }
	  }, {
	    key: 'setMarkers',
	    value: function setMarkers(places) {
	      this.markers = _MapUtils2.default.createMarkers(this.map, places, this.props.handleSelect);
	      this.markerClusters = _MapUtils2.default.createMarkerCluster({
	        map: this.map,
	        markers: this.markers
	      });
	    }
	  }, {
	    key: 'clearMarkers',
	    value: function clearMarkers() {
	      this.markers.forEach(function (marker) {
	        marker.setMap(null);
	      });
	      this.markerClusters.clearMarkers();
	      this.markerClusters = [];
	      this.markers = [];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(
	          MapContainer,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'GMap' },
	            _react2.default.createElement('div', { className: 'GMap-canvas', ref: 'mapCanvas' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Map;
	}(_react.Component);
	
	Map.propTypes = {
	  initialCenter: _react.PropTypes.object.isRequired,
	  places: _react.PropTypes.array.isRequired,
	  handleSelect: _react.PropTypes.func,
	  zoom: _react.PropTypes.number,
	  scrollable: _react.PropTypes.bool,
	  draggable: _react.PropTypes.bool,
	  disableUI: _react.PropTypes.bool
	};
	
	Map.defaultProps = {
	  scrollable: true,
	  draggable: true,
	  disableUI: false,
	  zoom: 2
	};
	
	exports.default = Map;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: ', ';\n  background-color: ', ';\n  border: ', ';\n  position: absolute;\n  top: calc(', ' - 1px);\n  z-index: 2;\n\n  @media screen and (max-width: ', ') {\n    display: ', ';\n  }\n'], ['\n  width: 100%;\n  height: ', ';\n  background-color: ', ';\n  border: ', ';\n  position: absolute;\n  top: calc(', ' - 1px);\n  z-index: 2;\n\n  @media screen and (max-width: ', ') {\n    display: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral([''], ['']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  display: inline-block;\n  position: absolute;\n  top: ', ';\n'], ['\n  display: inline-block;\n  position: absolute;\n  top: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  margin-left: ', ';\n  padding: 8px ', ';\n'], ['\n  margin-left: ', ';\n  padding: 8px ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  ', ';\n  margin-bottom: ', ';\n'], ['\n  ', ';\n  margin-bottom: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteral(['margin-bottom: ', ';'], ['margin-bottom: ', ';']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  .arrow {\n    display: none;\n  }\n\n  .dropdown-component {\n    border: none;\n  }\n\n  .dropdown-list {\n    border: none;\n    position: static;\n    display: block;\n\n    .list {\n      display: block;\n    }\n  }\n'], ['\n  .arrow {\n    display: none;\n  }\n\n  .dropdown-component {\n    border: none;\n  }\n\n  .dropdown-list {\n    border: none;\n    position: static;\n    display: block;\n\n    .list {\n      display: block;\n    }\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  border: none;\n  .arrow {\n    display: none;\n  }\n\n  .dropdown-list {\n    border: none;\n    position: static;\n    display: block;\n    padding: ', ';\n\n    .list {\n      display: block;\n    }\n  }\n'], ['\n  border: none;\n  .arrow {\n    display: none;\n  }\n\n  .dropdown-list {\n    border: none;\n    position: static;\n    display: block;\n    padding: ', ';\n\n    .list {\n      display: block;\n    }\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  .dropdown-list {\n    position: static;\n    margin-top: -10px;\n  }\n\n  input {\n    padding: 0;\n  }\n'], ['\n  .dropdown-list {\n    position: static;\n    margin-top: -10px;\n  }\n\n  input {\n    padding: 0;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  .picker {\n    margin-left: 5px;\n  }\n'], ['\n  .picker {\n    margin-left: 5px;\n  }\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  float: right;\n  ', ';\n  padding-top: ', ';\n'], ['\n  float: right;\n  ', ';\n  padding-top: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _bluebird = __webpack_require__(80);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	var _SearchDropdown = __webpack_require__(1048);
	
	var _SearchDropdown2 = _interopRequireDefault(_SearchDropdown);
	
	var _MoreFilters = __webpack_require__(1047);
	
	var _MoreFilters2 = _interopRequireDefault(_MoreFilters);
	
	var _RangePicker = __webpack_require__(126);
	
	var _RangePicker2 = _interopRequireDefault(_RangePicker);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SearchableDropdown = __webpack_require__(64);
	
	var _SearchableDropdown2 = _interopRequireDefault(_SearchableDropdown);
	
	var _MultiSelectDropdown = __webpack_require__(516);
	
	var _MultiSelectDropdown2 = _interopRequireDefault(_MultiSelectDropdown);
	
	var _SearchSource = __webpack_require__(18);
	
	var _Utils = __webpack_require__(22);
	
	var _MobileSearchbar = __webpack_require__(1046);
	
	var _MobileSearchbar2 = _interopRequireDefault(_MobileSearchbar);
	
	var _Constants = __webpack_require__(52);
	
	var _Dropdown = __webpack_require__(60);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Defaults = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var SearchBarContainer = _styledComponents2.default.div(_templateObject, _Themes.Metrics.components.searchbar, _Themes.Colors.white, _Themes.Metrics.borders.default, _Themes.Metrics.components.navbarDefault, _Themes.Metrics.breakpoints.tablet, function (props) {
	  return props.isAdmin ? 'block' : 'none';
	});
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var ActionsContainer = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.medium);
	
	var ExportInfo = (0, _styledComponents2.default)(_Button2.default)(_templateObject4, _Themes.Metrics.margins.small, _Themes.Metrics.margins.small);
	
	var Title = _styledComponents2.default.div(_templateObject5, _Themes.Fonts.style.Label, _Themes.Metrics.margins.small);
	
	var Form = _styledComponents2.default.div(_templateObject6, _Themes.Metrics.margins.base);
	
	var CustomMultiSelect = (0, _styledComponents2.default)(_MultiSelectDropdown2.default)(_templateObject7);
	
	var CustomDropdown = (0, _styledComponents2.default)(_Dropdown2.default)(_templateObject8, _Themes.Metrics.margins.small);
	
	var CustomSearchableDropdown = (0, _styledComponents2.default)(_SearchableDropdown2.default)(_templateObject9);
	
	var CustomRangePicker = (0, _styledComponents2.default)(_RangePicker2.default)(_templateObject10);
	
	var ButtonContainer = _styledComponents2.default.div(_templateObject11, function (props) {
	  return props.noPadding ? 0 : 'padding: ' + _Themes.Metrics.margins.small;
	}, _Themes.Metrics.margins.small);
	
	var SearchBar = function (_Component) {
	  _inherits(SearchBar, _Component);
	
	  function SearchBar(props) {
	    _classCallCheck(this, SearchBar);
	
	    var _this = _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props));
	
	    _this.state = {
	      active: '',
	      settings: props.settings,
	      searchCountry: '',
	      searchContinent: '',
	      searchCity: '',
	      countries: [],
	      categories: [],
	      continents: [],
	      cities: [],
	      portfolio: null,
	      favorites: null,
	      openModal: false,
	      selectedRequest: null,
	      searchRequests: props.searchRequests || null
	    };
	    _this.handleDropdownClick = _this.handleDropdownClick.bind(_this);
	    _this.handleOnBlur = _this.handleOnBlur.bind(_this);
	    _this.handleOnFocus = _this.handleOnFocus.bind(_this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.handleRange = _this.handleRange.bind(_this);
	    _this.handleDropdownSelect = _this.handleDropdownSelect.bind(_this);
	    _this.handleSelectSearchRequest = _this.handleSelectSearchRequest.bind(_this);
	    _this.apply = _this.apply.bind(_this);
	    _this.handleSearch = _this.handleSearch.bind(_this);
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    _this.clearFilters = _this.clearFilters.bind(_this);
	    return _this;
	  }
	
	  _createClass(SearchBar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var searchRequests = this.state.searchRequests;
	
	      var citiesIds = [];
	      var countriesIds = [];
	      var continentIds = [];
	
	      searchRequests && searchRequests.forEach(function (searchRequest) {
	        citiesIds = _ramda2.default.union(citiesIds, searchRequest.city ? [searchRequest.city] : []);
	        countriesIds = _ramda2.default.union(countriesIds, searchRequest.country ? [searchRequest.country] : []);
	        continentIds = _ramda2.default.union(continentIds, searchRequest.continent ? [searchRequest.continent] : []);
	      });
	
	      _bluebird2.default.all([(0, _SearchSource.searchCategories)(), continentIds.length > 0 ? (0, _SearchSource.searchContinents)({ where: { id: continentIds } }) : [], countriesIds.length > 0 ? (0, _SearchSource.searchCountries)({ where: { id: countriesIds } }) : [], citiesIds.length > 0 ? (0, _SearchSource.searchCities)({ where: { id: citiesIds } }) : []]).spread(function (categoriesResponse, continentsResponse, countriesResponse, citiesResponse) {
	        var categories = categoriesResponse.data;
	
	        if (searchRequests) {
	          var categoriesHash = {};
	          var continentsHash = {};
	          var countriesHash = {};
	          var citiesHash = {};
	
	          categories && categories.forEach(function (category) {
	            categoriesHash[category.id] = category;
	          });
	
	          continentsResponse.data && continentsResponse.data.forEach(function (continent) {
	            continentsHash[continent.id] = continent;
	          });
	
	          countriesResponse.data && countriesResponse.data.forEach(function (country) {
	            countriesHash[country.id] = country;
	          });
	
	          citiesResponse.data && citiesResponse.data.forEach(function (city) {
	            citiesHash[city.id] = city;
	          });
	
	          searchRequests.forEach(function (search) {
	            search.city = search.city && citiesHash[search.city];
	            search.country = search.country && countriesHash[search.country];
	            search.continent = search.continent && continentsHash[search.continent];
	            search.category = categoriesHash[search.category];
	          });
	        }
	        _this2.setState({ searchRequests: searchRequests, categories: categories });
	      }).catch(console.error);
	    }
	  }, {
	    key: 'handleSearch',
	    value: function handleSearch(key, search) {
	      var _this3 = this;
	
	      switch (key) {
	        case 'country':
	          (0, _SearchSource.searchCountries)({ where: { name: { startsWith: search } } }).then(function (response) {
	            _this3.setState({ searchCountry: search, countries: response.data });
	          }).catch(console.error);
	          break;
	        case 'continent':
	          (0, _SearchSource.searchContinents)({ where: { name: { startsWith: search } } }).then(function (response) {
	            _this3.setState({
	              searchContinent: search,
	              continents: response.data
	            });
	          }).catch(console.error);
	          break;
	        case 'city':
	          (0, _SearchSource.searchCities)({ where: { city: { startsWith: search } } }).then(function (response) {
	            _this3.setState({ searchCity: search, cities: response.data });
	          }).catch(console.error);
	          break;
	        default:
	      }
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(key, value) {
	      var settings = this.state.settings;
	
	      settings[key] = (0, _Utils.addOrRemoveObjectFromList)(settings[key], value);
	      this.setState({
	        settings: settings,
	        searchCountry: '',
	        searchCategory: '',
	        searchContinent: '',
	        searchCity: ''
	      });
	    }
	  }, {
	    key: 'handleRange',
	    value: function handleRange(minKey, maxKey, value) {
	      var settings = this.state.settings;
	
	      settings[minKey] = value.min;
	      settings[maxKey] = value.max;
	      this.setState({ settings: settings });
	    }
	  }, {
	    key: 'handleDropdownClick',
	    value: function handleDropdownClick(id) {
	      if (this.state.active === id) {
	        return this.setState({ active: '' });
	      }
	      this.setState({ active: id });
	    }
	  }, {
	    key: 'handleDropdownSelect',
	    value: function handleDropdownSelect(key, el) {
	      var settings = this.state.settings;
	
	      settings[key] = el;
	      this.setState({ settings: settings });
	    }
	  }, {
	    key: 'handleSelectSearchRequest',
	    value: function handleSelectSearchRequest(searchRequest) {
	      var _this4 = this;
	
	      var settings = {
	        minInvestment: searchRequest.minPrice,
	        maxInvestment: searchRequest.maxPrice || _Constants.maxPrice,
	        minNoRooms: searchRequest.minNoRooms,
	        maxNoRooms: searchRequest.maxNoRooms || _Constants.maxRooms,
	        minYield: searchRequest.minYield,
	        maxYield: searchRequest.maxYield || _Constants.maxYield,
	        preferredCategories: searchRequest.category ? [searchRequest.category] : [],
	        preferredCities: searchRequest.city ? [searchRequest.city] : [],
	        preferredCountries: searchRequest.country ? [searchRequest.country] : [],
	        preferredRegions: searchRequest.continent ? [searchRequest.continent] : []
	      };
	      this.setState({ settings: settings, selectedRequest: searchRequest }, function () {
	        return _this4.apply();
	      });
	    }
	  }, {
	    key: 'handleOnBlur',
	    value: function handleOnBlur() {
	      var _this5 = this;
	
	      this.timer = setTimeout(function () {
	        _this5.setState({
	          active: '',
	          searchCountry: '',
	          searchCategory: '',
	          searchContinent: '',
	          searchCity: ''
	        });
	      }, 0);
	    }
	  }, {
	    key: 'handleOnFocus',
	    value: function handleOnFocus() {
	      clearTimeout(this.timer);
	    }
	  }, {
	    key: 'clearFilters',
	    value: function clearFilters() {
	      var _this6 = this;
	
	      this.setState({
	        settings: _ramda2.default.clone(_Defaults.searchQueryDefault),
	        favorites: null,
	        portfolio: null,
	        searchCountry: '',
	        active: '',
	        searchCategory: '',
	        searchContinent: '',
	        searchCity: '',
	        selectedRequest: null,
	        openModal: false
	      }, function () {
	        return _this6.props.updateSettings(_Defaults.searchQueryDefault);
	      });
	    }
	  }, {
	    key: 'apply',
	    value: function apply() {
	      var _this7 = this;
	
	      var updateSettings = this.props.updateSettings;
	
	      if (updateSettings) {
	        this.setState({
	          active: '',
	          searchCountry: '',
	          searchCategory: '',
	          searchContinent: '',
	          searchCity: '',
	          openModal: false
	        }, function () {
	          return updateSettings(_this7.state.settings);
	        });
	      }
	    }
	  }, {
	    key: 'toggleModal',
	    value: function toggleModal() {
	      this.setState({ openModal: !this.state.openModal });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _state = this.state;
	      var active = _state.active;
	      var settings = _state.settings;
	      var categories = _state.categories;
	      var continents = _state.continents;
	      var countries = _state.countries;
	      var cities = _state.cities;
	      var searchCategory = _state.searchCategory;
	      var searchContinent = _state.searchContinent;
	      var searchCountry = _state.searchCountry;
	      var searchCity = _state.searchCity;
	      var selectedRequest = _state.selectedRequest;
	      var openModal = _state.openModal;
	      var searchRequests = _state.searchRequests;
	      var _props = this.props;
	      var isAdminPage = _props.isAdminPage;
	      var exportAction = _props.exportAction;
	      var t = _props.t;
	      var isAdmin = _props.isAdmin;
	
	      return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(
	          _MobileSearchbar2.default,
	          {
	            openModal: openModal,
	            toggleModal: this.toggleModal,
	            apply: this.apply,
	            clearFilters: this.clearFilters,
	            isAdmin: isAdmin },
	          searchRequests && _react2.default.createElement(
	            Form,
	            null,
	            _react2.default.createElement(
	              Title,
	              null,
	              t('Search Requests')
	            ),
	            _react2.default.createElement(_Dropdown2.default, {
	              id: 'mobile',
	              options: searchRequests,
	              accessor: function accessor(d) {
	                return d.name;
	              },
	              selectedOption: selectedRequest,
	              handleSelect: this.handleSelectSearchRequest,
	              placeholder: 'Select Search Request'
	            })
	          ),
	          _react2.default.createElement(
	            Form,
	            null,
	            _react2.default.createElement(
	              Title,
	              null,
	              t('Type of Asset')
	            ),
	            _react2.default.createElement(_MultiSelectDropdown2.default, {
	              options: categories,
	              showTags: true,
	              selectedOptions: settings.preferredCategories,
	              value: searchCategory,
	              handleSelect: function handleSelect(value) {
	                _this8.handleSelect('preferredCategories', value);
	              },
	              placeholder: 'Filter By Type of Asset',
	              accessor: function accessor(d) {
	                return d.name;
	              },
	              tagsAccessor: function tagsAccessor(d) {
	                return d.name;
	              }
	            })
	          ),
	          _react2.default.createElement(
	            Form,
	            null,
	            _react2.default.createElement(
	              Title,
	              null,
	              t('Continent')
	            ),
	            _react2.default.createElement(_SearchableDropdown2.default, {
	              showTags: true,
	              selectedOptions: settings.preferredRegions,
	              options: continents,
	              value: searchContinent,
	              handleSearch: function handleSearch(event) {
	                _this8.handleSearch('continent', event.target.value);
	              },
	              handleSelect: function handleSelect(value) {
	                _this8.handleSelect('preferredRegions', value);
	              },
	              placeholder: 'Filter By Continent',
	              accessor: function accessor(d) {
	                return d.name;
	              },
	              tagsAccessor: function tagsAccessor(d) {
	                return d.name;
	              }
	            })
	          ),
	          _react2.default.createElement(
	            Form,
	            null,
	            _react2.default.createElement(
	              Title,
	              null,
	              t('Country')
	            ),
	            _react2.default.createElement(_SearchableDropdown2.default, {
	              options: countries,
	              selectedOptions: settings.preferredCountries,
	              showTags: true,
	              value: searchCountry,
	              handleSearch: function handleSearch(event) {
	                _this8.handleSearch('country', event.target.value);
	              },
	              handleSelect: function handleSelect(value) {
	                _this8.handleSelect('preferredCountries', value);
	              },
	              placeholder: 'Filter By Country',
	              accessor: function accessor(d) {
	                return d.name;
	              },
	              tagsAccessor: function tagsAccessor(d) {
	                return d.name;
	              }
	            })
	          ),
	          _react2.default.createElement(
	            Form,
	            null,
	            _react2.default.createElement(
	              Title,
	              null,
	              t('City')
	            ),
	            _react2.default.createElement(_SearchableDropdown2.default, {
	              options: cities,
	              value: searchCity,
	              showTags: true,
	              selectedOptions: settings.preferredCities,
	              handleSearch: function handleSearch(event) {
	                _this8.handleSearch('city', event.target.value);
	              },
	              handleSelect: function handleSelect(value) {
	                _this8.handleSelect('preferredCities', value);
	              },
	              placeholder: 'Filter By Metropolitan Area',
	              accessor: function accessor(d) {
	                return d.city;
	              },
	              tagsAccessor: function tagsAccessor(d) {
	                return d.city;
	              }
	            })
	          ),
	          _react2.default.createElement(
	            Form,
	            null,
	            _react2.default.createElement(
	              Title,
	              null,
	              t('Portfolio')
	            ),
	            _react2.default.createElement(_Dropdown2.default, {
	              options: [true, false],
	              accessor: function accessor(d) {
	                return d ? 'Yes' : 'No';
	              },
	              selectedOption: settings.portfolio,
	              handleSelect: function handleSelect(el) {
	                return _this8.handleDropdownSelect('portfolio', el);
	              },
	              placeholder: 'Filter By Portfolio'
	            })
	          ),
	          _react2.default.createElement(
	            Form,
	            null,
	            _react2.default.createElement(
	              Title,
	              null,
	              t('Number of Keys')
	            ),
	            _react2.default.createElement(_RangePicker2.default, {
	              max: _Constants.maxRooms,
	              step: _Constants.defaultRoomsStep,
	              minValue: settings.minNoRooms,
	              maxValue: settings.maxNoRooms,
	              handleChange: function handleChange(value) {
	                return _this8.handleRange('minNoRooms', 'maxNoRooms', value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            Form,
	            null,
	            _react2.default.createElement(
	              Title,
	              null,
	              t('Price')
	            ),
	            _react2.default.createElement(_RangePicker2.default, {
	              max: _Constants.maxPrice,
	              step: _Constants.defaultPriceStep,
	              minValue: settings.minInvestment,
	              maxValue: settings.maxInvestment,
	              unit: '€',
	              handleChange: function handleChange(value) {
	                return _this8.handleRange('minInvestment', 'maxInvestment', value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            Form,
	            null,
	            _react2.default.createElement(
	              Title,
	              null,
	              t('Estimated Yield')
	            ),
	            _react2.default.createElement(_RangePicker2.default, {
	              max: _Constants.maxYield,
	              step: _Constants.defaultYieldStep,
	              minValue: settings.minYield,
	              maxValue: settings.maxYield,
	              unit: '%',
	              rightUnit: true,
	              handleChange: function handleChange(value) {
	                return _this8.handleRange('minYield', 'maxYield', value);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          SearchBarContainer,
	          { className: 'searchbar-container', isAdmin: isAdmin },
	          searchRequests && _react2.default.createElement(
	            _SearchDropdown2.default,
	            {
	              id: 'Search Requests',
	              dropdown: true,
	              active: active,
	              onFocus: this.handleOnFocus,
	              onBlur: this.handleOnBlur,
	              onClick: this.handleDropdownClick },
	            _react2.default.createElement(CustomDropdown, {
	              id: 'desktop',
	              options: searchRequests,
	              accessor: function accessor(d) {
	                return d.name;
	              },
	              selectedOption: selectedRequest,
	              handleSelect: this.handleSelectSearchRequest,
	              placeholder: 'Select Search Request'
	            })
	          ),
	          _react2.default.createElement(
	            _SearchDropdown2.default,
	            {
	              id: 'Type of Asset',
	              active: active,
	              dropdown: true,
	              onFocus: this.handleOnFocus,
	              onBlur: this.handleOnBlur,
	              onClick: this.handleDropdownClick },
	            _react2.default.createElement(CustomMultiSelect, {
	              options: categories,
	              showTags: true,
	              selectedOptions: settings.preferredCategories,
	              value: searchCategory,
	              handleSelect: function handleSelect(value) {
	                _this8.handleSelect('preferredCategories', value);
	              },
	              placeholder: 'Filter By Type of Asset',
	              accessor: function accessor(d) {
	                return d.name;
	              },
	              tagsAccessor: function tagsAccessor(d) {
	                return d.name;
	              }
	            }),
	            _react2.default.createElement(
	              ButtonContainer,
	              null,
	              _react2.default.createElement(_Button2.default, { onClick: this.apply, label: 'Apply' })
	            )
	          ),
	          _react2.default.createElement(
	            _SearchDropdown2.default,
	            {
	              id: 'Country',
	              active: active,
	              dropdown: true,
	              onFocus: this.handleOnFocus,
	              onBlur: this.handleOnBlur,
	              onClick: this.handleDropdownClick },
	            _react2.default.createElement(CustomSearchableDropdown, {
	              value: this.state.searchCountry,
	              handleSearch: function handleSearch(event) {
	                _this8.handleSearch('country', event.target.value);
	              },
	              placeholder: 'Type the country name',
	              options: this.state.countries,
	              showTags: true,
	              selectedOptions: settings.preferredCountries,
	              handleSelect: function handleSelect(value) {
	                return _this8.handleSelect('preferredCountries', value);
	              },
	              className: 'search',
	              accessor: function accessor(d) {
	                return d.name;
	              },
	              tagsAccessor: function tagsAccessor(d) {
	                return d.name;
	              }
	            }),
	            _react2.default.createElement(
	              ButtonContainer,
	              null,
	              _react2.default.createElement(_Button2.default, { onClick: this.apply, label: 'Apply' })
	            )
	          ),
	          _react2.default.createElement(
	            _SearchDropdown2.default,
	            {
	              id: 'Price',
	              active: active,
	              onFocus: this.handleOnFocus,
	              onBlur: this.handleOnBlur,
	              onClick: this.handleDropdownClick },
	            _react2.default.createElement(CustomRangePicker, {
	              key: 'investment',
	              max: _Constants.maxPrice,
	              step: _Constants.defaultPriceStep,
	              minValue: settings.minInvestment,
	              maxValue: settings.maxInvestment,
	              unit: '€',
	              handleChange: function handleChange(value) {
	                return _this8.handleRange('minInvestment', 'maxInvestment', value);
	              }
	            }),
	            _react2.default.createElement(
	              ButtonContainer,
	              { noPadding: true },
	              _react2.default.createElement(_Button2.default, { onClick: this.apply, label: 'Apply' })
	            )
	          ),
	          _react2.default.createElement(
	            _SearchDropdown2.default,
	            {
	              id: 'Estimated Yield',
	              active: active,
	              onFocus: this.handleOnFocus,
	              onBlur: this.handleOnBlur,
	              onClick: this.handleDropdownClick },
	            _react2.default.createElement(CustomRangePicker, {
	              key: 'Yield',
	              minValue: settings.minYield,
	              maxValue: settings.maxYield,
	              unit: '%',
	              rightUnit: true,
	              handleChange: function handleChange(value) {
	                return _this8.handleRange('minYield', 'maxYield', value);
	              },
	              max: _Constants.maxYield
	            }),
	            _react2.default.createElement(
	              ButtonContainer,
	              { noPadding: true },
	              _react2.default.createElement(_Button2.default, { onClick: this.apply, label: 'Apply' })
	            )
	          ),
	          _react2.default.createElement(
	            _SearchDropdown2.default,
	            {
	              id: 'More Filters',
	              active: active,
	              onFocus: this.handleOnFocus,
	              onBlur: this.handleOnBlur,
	              onClick: this.handleDropdownClick },
	            _react2.default.createElement(_MoreFilters2.default, {
	              t: t,
	              clearFilters: this.clearFilters,
	              handleSelect: this.handleSelect,
	              settings: settings,
	              categories: categories,
	              handleDropdownSelect: this.handleDropdownSelect,
	              handleRange: this.handleRange,
	              apply: this.apply,
	              isAdminPage: isAdminPage
	            })
	          ),
	          _react2.default.createElement(
	            ActionsContainer,
	            null,
	            exportAction && _react2.default.createElement(ExportInfo, {
	              secondary: true,
	              onClick: exportAction,
	              label: t('Export to Excel')
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SearchBar;
	}(_react.Component);
	
	SearchBar.propTypes = {
	  updateSettings: _react.PropTypes.func,
	  settings: _react.PropTypes.object,
	  isAdminPage: _react.PropTypes.bool,
	  exportAction: _react.PropTypes.func,
	  t: _react.PropTypes.func,
	  isAdmin: _react.PropTypes.bool,
	  searchRequests: _react.PropTypes.array
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'search', 'forms'], { wait: true })(SearchBar);

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendNda = exports.fetchPreferences = exports.updatePreference = exports.deleteUserPreference = exports.removePreference = exports.addPreference = exports.updateUserPicture = exports.removeFromFavorites = exports.addToFavorites = undefined;
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _axios = __webpack_require__(86);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(88);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Constants = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addToFavorites = exports.addToFavorites = function addToFavorites(userId, id, type) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user/' + userId + '/' + type + '/' + id + '/add_preferred');
	};
	
	var removeFromFavorites = exports.removeFromFavorites = function removeFromFavorites(userId, id, type) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user/' + userId + '/' + type + '/' + id + '/remove_preferred');
	};
	
	var updateUserPicture = exports.updateUserPicture = function updateUserPicture(userId, picture) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user/' + userId + '/', {
	    picture: picture
	  });
	};
	
	var addPreference = exports.addPreference = function addPreference(userId, preference) {
	  var body = _ramda2.default.clone(preference);
	  if (preference.city) {
	    body.city = preference.city.id;
	  }
	  if (preference.category) {
	    body.category = preference.category.id;
	  }
	
	  if (preference.maxYield === _Constants.maxYield) {
	    delete body.maxYield;
	  }
	
	  if (preference.maxPrice === _Constants.maxPrice) {
	    delete body.maxPrice;
	  }
	
	  if (preference.maxArea === _Constants.maxArea) {
	    delete body.maxArea;
	  }
	
	  if (preference.maxNoRooms === _Constants.maxRooms) {
	    delete body.maxNoRooms;
	  }
	
	  body.user = userId;
	  return _axios2.default.post(_config2.default.SERVER_URL + '/preference/', body);
	};
	
	var removePreference = exports.removePreference = function removePreference(preferenceId) {
	  return _axios2.default.delete(_config2.default.SERVER_URL + '/preference/' + preferenceId);
	};
	
	var deleteUserPreference = exports.deleteUserPreference = function deleteUserPreference(preferenceId, userId) {
	  return _axios2.default.delete(_config2.default.SERVER_URL + '/preference/' + preferenceId + '?user=' + userId);
	};
	
	var updatePreference = exports.updatePreference = function updatePreference(preference) {
	  return _axios2.default.put(_config2.default.SERVER_URL + '/preference/' + preference.id, preference);
	};
	
	var fetchPreferences = exports.fetchPreferences = function fetchPreferences() {
	  var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return _axios2.default.post(_config2.default.SERVER_URL + '/preference/fetch', {
	    criteria: criteria,
	    params: params
	  });
	};
	
	var sendNda = exports.sendNda = function sendNda(id) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user/send_nda', { id: id });
	};

/***/ },
/* 247 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var el
	
	module.exports = function(){
	
		if(!el && !!global.document){
		  	el = global.document.createElement('div')
		}
	
		if (!el){
			el = {style: {}}
		}
	
		return el
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toUpperFirst = __webpack_require__(249)
	var prefixes     = ["ms", "Moz", "Webkit", "O"]
	
	var el = __webpack_require__(247)
	
	var ELEMENT
	var PREFIX
	
	module.exports = function(key){
	
		if (PREFIX !== undefined){
			return PREFIX
		}
	
		ELEMENT = ELEMENT || el()
	
		var i = 0
		var len = prefixes.length
		var tmp
		var prefix
	
		for (; i < len; i++){
			prefix = prefixes[i]
			tmp = prefix + toUpperFirst(key)
	
			if (typeof ELEMENT.style[tmp] != 'undefined'){
				return PREFIX = prefix
			}
		}
	
		return PREFIX
	}

/***/ },
/* 249 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(str){
		return str?
				str.charAt(0).toUpperCase() + str.slice(1):
				''
	}

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.objToCss = undefined;
	
	var _hyphenateStyleName = __webpack_require__(547);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _isPlainObject = __webpack_require__(286);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(8).any;
	
	var objToCss = exports.objToCss = function objToCss(obj, prevKey) {
	  var css = Object.keys(obj).map(function (key) {
	    if ((0, _isPlainObject2.default)(obj[key])) return objToCss(obj[key], key);
	    return (0, _hyphenateStyleName2.default)(key) + ': ' + obj[key] + ';';
	  }).join(' ');
	  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
	};
	
	var flatten = function flatten(chunks, executionContext) {
	  return chunks.reduce(function (ruleSet, chunk) {
	    /* Remove falsey values */
	    if (chunk === undefined || chunk === null || chunk === false || chunk === '') return ruleSet;
	    /* Flatten ruleSet */
	    if (Array.isArray(chunk)) return [].concat(_toConsumableArray(ruleSet), _toConsumableArray(flatten(chunk, executionContext)));
	    /* Either execute or defer the function */
	    if (typeof chunk === 'function') {
	      return executionContext ? ruleSet.concat.apply(ruleSet, _toConsumableArray(flatten([chunk(executionContext)], executionContext))) : ruleSet.concat(chunk);
	    }
	
	    /* Handle objects */
	    // $FlowFixMe have to add %checks somehow to isPlainObject
	    return ruleSet.concat((0, _isPlainObject2.default)(chunk) ? objToCss(chunk) : chunk.toString());
	  }, []);
	};
	
	exports.default = flatten;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _container = __webpack_require__(179);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _warnOnce = __webpack_require__(67);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Represents an at-rule.
	 *
	 * If it’s followed in the CSS by a {} block, this node will have
	 * a nodes property representing its children.
	 *
	 * @extends Container
	 *
	 * @example
	 * const root = postcss.parse('@charset "UTF-8"; @media print {}');
	 *
	 * const charset = root.first;
	 * charset.type  //=> 'atrule'
	 * charset.nodes //=> undefined
	 *
	 * const media = root.last;
	 * media.nodes   //=> []
	 */
	var AtRule = function (_Container) {
	    _inherits(AtRule, _Container);
	
	    function AtRule(defaults) {
	        _classCallCheck(this, AtRule);
	
	        var _this = _possibleConstructorReturn(this, (AtRule.__proto__ || Object.getPrototypeOf(AtRule)).call(this, defaults));
	
	        _this.type = 'atrule';
	        return _this;
	    }
	
	    _createClass(AtRule, [{
	        key: 'append',
	        value: function append() {
	            var _get2;
	
	            if (!this.nodes) this.nodes = [];
	
	            for (var _len = arguments.length, children = Array(_len), _key = 0; _key < _len; _key++) {
	                children[_key] = arguments[_key];
	            }
	
	            return (_get2 = _get(AtRule.prototype.__proto__ || Object.getPrototypeOf(AtRule.prototype), 'append', this)).call.apply(_get2, [this].concat(children));
	        }
	    }, {
	        key: 'prepend',
	        value: function prepend() {
	            var _get3;
	
	            if (!this.nodes) this.nodes = [];
	
	            for (var _len2 = arguments.length, children = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	                children[_key2] = arguments[_key2];
	            }
	
	            return (_get3 = _get(AtRule.prototype.__proto__ || Object.getPrototypeOf(AtRule.prototype), 'prepend', this)).call.apply(_get3, [this].concat(children));
	        }
	    }, {
	        key: 'afterName',
	        get: function get() {
	            (0, _warnOnce2.default)('AtRule#afterName was deprecated. Use AtRule#raws.afterName');
	            return this.raws.afterName;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('AtRule#afterName was deprecated. Use AtRule#raws.afterName');
	            this.raws.afterName = val;
	        }
	    }, {
	        key: '_params',
	        get: function get() {
	            (0, _warnOnce2.default)('AtRule#_params was deprecated. Use AtRule#raws.params');
	            return this.raws.params;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('AtRule#_params was deprecated. Use AtRule#raws.params');
	            this.raws.params = val;
	        }
	
	        /**
	         * @memberof AtRule#
	         * @member {string} name - the at-rule’s name immediately follows the `@`
	         *
	         * @example
	         * const root  = postcss.parse('@media print {}');
	         * media.name //=> 'media'
	         * const media = root.first;
	         */
	
	        /**
	         * @memberof AtRule#
	         * @member {string} params - the at-rule’s parameters, the values
	         *                           that follow the at-rule’s name but precede
	         *                           any {} block
	         *
	         * @example
	         * const root  = postcss.parse('@media print, screen {}');
	         * const media = root.first;
	         * media.params //=> 'print, screen'
	         */
	
	        /**
	         * @memberof AtRule#
	         * @member {object} raws - Information to generate byte-to-byte equal
	         *                         node string as it was in the origin input.
	         *
	         * Every parser saves its own properties,
	         * but the default CSS parser uses:
	         *
	         * * `before`: the space symbols before the node. It also stores `*`
	         *   and `_` symbols before the declaration (IE hack).
	         * * `after`: the space symbols after the last child of the node
	         *   to the end of the node.
	         * * `between`: the symbols between the property and value
	         *   for declarations, selector and `{` for rules, or last parameter
	         *   and `{` for at-rules.
	         * * `semicolon`: contains true if the last child has
	         *   an (optional) semicolon.
	         * * `afterName`: the space between the at-rule name and its parameters.
	         *
	         * PostCSS cleans at-rule parameters from comments and extra spaces,
	         * but it stores origin content in raws properties.
	         * As such, if you don’t change a declaration’s value,
	         * PostCSS will use the raw value with comments.
	         *
	         * @example
	         * const root = postcss.parse('  @media\nprint {\n}')
	         * root.first.first.raws //=> { before: '  ',
	         *                       //     between: ' ',
	         *                       //     afterName: '\n',
	         *                       //     after: '\n' }
	         */
	
	    }]);
	
	    return AtRule;
	}(_container2.default);
	
	exports.default = AtRule;
	module.exports = exports['default'];

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warnOnce = __webpack_require__(67);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	var _node = __webpack_require__(254);
	
	var _node2 = _interopRequireDefault(_node);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Represents a comment between declarations or statements (rule and at-rules).
	 *
	 * Comments inside selectors, at-rule parameters, or declaration values
	 * will be stored in the `raws` properties explained above.
	 *
	 * @extends Node
	 */
	var Comment = function (_Node) {
	    _inherits(Comment, _Node);
	
	    function Comment(defaults) {
	        _classCallCheck(this, Comment);
	
	        var _this = _possibleConstructorReturn(this, (Comment.__proto__ || Object.getPrototypeOf(Comment)).call(this, defaults));
	
	        _this.type = 'comment';
	        return _this;
	    }
	
	    _createClass(Comment, [{
	        key: 'left',
	        get: function get() {
	            (0, _warnOnce2.default)('Comment#left was deprecated. Use Comment#raws.left');
	            return this.raws.left;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Comment#left was deprecated. Use Comment#raws.left');
	            this.raws.left = val;
	        }
	    }, {
	        key: 'right',
	        get: function get() {
	            (0, _warnOnce2.default)('Comment#right was deprecated. Use Comment#raws.right');
	            return this.raws.right;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Comment#right was deprecated. Use Comment#raws.right');
	            this.raws.right = val;
	        }
	
	        /**
	         * @memberof Comment#
	         * @member {string} text - the comment’s text
	         */
	
	        /**
	         * @memberof Comment#
	         * @member {object} raws - Information to generate byte-to-byte equal
	         *                         node string as it was in the origin input.
	         *
	         * Every parser saves its own properties,
	         * but the default CSS parser uses:
	         *
	         * * `before`: the space symbols before the node.
	         * * `left`: the space symbols between `/*` and the comment’s text.
	         * * `right`: the space symbols between the comment’s text.
	         */
	
	    }]);
	
	    return Comment;
	}(_node2.default);
	
	exports.default = Comment;
	module.exports = exports['default'];

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // break cyclical dependency deadlock – #87
	
	__webpack_require__(255);
	
	var _cssSyntaxError = __webpack_require__(540);
	
	var _cssSyntaxError2 = _interopRequireDefault(_cssSyntaxError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// import PreviousMap    from './previous-map';
	
	var sequence = 0;
	
	/**
	 * @typedef  {object} filePosition
	 * @property {string} file   - path to file
	 * @property {number} line   - source line in file
	 * @property {number} column - source column in file
	 */
	
	/**
	 * Represents the source CSS.
	 *
	 * @example
	 * const root  = postcss.parse(css, { from: file });
	 * const input = root.source.input;
	 */
	
	var Input = function () {
	
	    /**
	     * @param {string} css    - input CSS source
	     * @param {object} [opts] - {@link Processor#process} options
	     */
	    function Input(css) {
	        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        _classCallCheck(this, Input);
	
	        /**
	         * @member {string} - input CSS source
	         *
	         * @example
	         * const input = postcss.parse('a{}', { from: file }).input;
	         * input.css //=> "a{}";
	         */
	        this.css = css.toString();
	
	        if (this.css[0] === '\uFEFF' || this.css[0] === '\uFFFE') {
	            this.css = this.css.slice(1);
	        }
	
	        if (opts.from) {
	            if (/^\w+:\/\//.test(opts.from)) {
	                /**
	                 * @member {string} - The absolute path to the CSS source file
	                 *                    defined with the `from` option.
	                 *
	                 * @example
	                 * const root = postcss.parse(css, { from: 'a.css' });
	                 * root.source.input.file //=> '/home/ai/a.css'
	                 */
	                this.file = opts.from;
	            } else {
	                this.file = path.resolve(opts.from);
	            }
	        }
	
	        /*
	                let map = new PreviousMap(this.css, opts);
	                if ( map.text ) {
	                    /!**
	                     * @member {PreviousMap} - The input source map passed from
	                     *                         a compilation step before PostCSS
	                     *                         (for example, from Sass compiler).
	                     *
	                     * @example
	                     * root.source.input.map.consumer().sources //=> ['a.sass']
	                     *!/
	                    this.map = map;
	                    let file = map.consumer().file;
	                    if ( !this.file && file ) this.file = this.mapResolve(file);
	                }
	        */
	
	        if (!this.file) {
	            sequence += 1;
	            /**
	             * @member {string} - The unique ID of the CSS source. It will be
	             *                    created if `from` option is not provided
	             *                    (because PostCSS does not know the file path).
	             *
	             * @example
	             * const root = postcss.parse(css);
	             * root.source.input.file //=> undefined
	             * root.source.input.id   //=> "<input css 1>"
	             */
	            this.id = '<input css ' + sequence + '>';
	        }
	        if (this.map) this.map.file = this.from;
	    }
	
	    _createClass(Input, [{
	        key: 'error',
	        value: function error(message, line, column) {
	            var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	            var result = void 0;
	            var origin = this.origin(line, column);
	            if (origin) {
	                result = new _cssSyntaxError2.default(message, origin.line, origin.column, origin.source, origin.file, opts.plugin);
	            } else {
	                result = new _cssSyntaxError2.default(message, line, column, this.css, this.file, opts.plugin);
	            }
	
	            result.input = { line: line, column: column, source: this.css };
	            if (this.file) result.input.file = this.file;
	
	            return result;
	        }
	
	        /**
	         * Reads the input source map and returns a symbol position
	         * in the input source (e.g., in a Sass file that was compiled
	         * to CSS before being passed to PostCSS).
	         *
	         * @param {number} line   - line in input CSS
	         * @param {number} column - column in input CSS
	         *
	         * @return {filePosition} position in input source
	         *
	         * @example
	         * root.source.input.origin(1, 1) //=> { file: 'a.css', line: 3, column: 1 }
	         */
	
	    }, {
	        key: 'origin',
	        value: function origin(line, column) {
	            if (!this.map) return false;
	            var consumer = this.map.consumer();
	
	            var from = consumer.originalPositionFor({ line: line, column: column });
	            if (!from.source) return false;
	
	            var result = {
	                file: this.mapResolve(from.source),
	                line: from.line,
	                column: from.column
	            };
	
	            var source = consumer.sourceContentFor(from.source);
	            if (source) result.source = source;
	
	            return result;
	        }
	    }, {
	        key: 'mapResolve',
	        value: function mapResolve(file) {
	            if (/^\w+:\/\//.test(file)) {
	                return file;
	            } else {
	                return path.resolve(this.map.consumer().sourceRoot || '.', file);
	            }
	        }
	
	        /**
	         * The CSS source identifier. Contains {@link Input#file} if the user
	         * set the `from` option, or {@link Input#id} if they did not.
	         * @type {string}
	         *
	         * @example
	         * const root = postcss.parse(css, { from: 'a.css' });
	         * root.source.input.from //=> "/home/ai/a.css"
	         *
	         * const root = postcss.parse(css);
	         * root.source.input.from //=> "<input css 1>"
	         */
	
	    }, {
	        key: 'from',
	        get: function get() {
	            return this.file || this.id;
	        }
	    }]);
	
	    return Input;
	}();
	
	exports.default = Input;
	module.exports = exports['default'];

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _cssSyntaxError = __webpack_require__(540);
	
	var _cssSyntaxError2 = _interopRequireDefault(_cssSyntaxError);
	
	var _stringifier = __webpack_require__(545);
	
	var _stringifier2 = _interopRequireDefault(_stringifier);
	
	var _stringify = __webpack_require__(546);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _warnOnce = __webpack_require__(67);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @typedef {object} position
	 * @property {number} line   - source line in file
	 * @property {number} column - source column in file
	 */
	
	/**
	 * @typedef {object} source
	 * @property {Input} input    - {@link Input} with input file
	 * @property {position} start - The starting position of the node’s source
	 * @property {position} end   - The ending position of the node’s source
	 */
	
	var cloneNode = function cloneNode(obj, parent) {
	    var cloned = new obj.constructor();
	
	    for (var i in obj) {
	        if (!obj.hasOwnProperty(i)) continue;
	        var value = obj[i];
	        var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	
	        if (i === 'parent' && type === 'object') {
	            if (parent) cloned[i] = parent;
	        } else if (i === 'source') {
	            cloned[i] = value;
	        } else if (value instanceof Array) {
	            cloned[i] = value.map(function (j) {
	                return cloneNode(j, cloned);
	            });
	        } else if (i !== 'before' && i !== 'after' && i !== 'between' && i !== 'semicolon') {
	            if (type === 'object' && value !== null) value = cloneNode(value);
	            cloned[i] = value;
	        }
	    }
	
	    return cloned;
	};
	
	/**
	 * All node classes inherit the following common methods.
	 *
	 * @abstract
	 */
	
	var Node = function () {
	
	    /**
	     * @param {object} [defaults] - value for node properties
	     */
	    function Node() {
	        var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _classCallCheck(this, Node);
	
	        this.raws = {};
	        for (var name in defaults) {
	            this[name] = defaults[name];
	        }
	    }
	
	    /**
	     * Returns a CssSyntaxError instance containing the original position
	     * of the node in the source, showing line and column numbers and also
	     * a small excerpt to facilitate debugging.
	     *
	     * If present, an input source map will be used to get the original position
	     * of the source, even from a previous compilation step
	     * (e.g., from Sass compilation).
	     *
	     * This method produces very useful error messages.
	     *
	     * @param {string} message     - error description
	     * @param {object} [opts]      - options
	     * @param {string} opts.plugin - plugin name that created this error.
	     *                               PostCSS will set it automatically.
	     * @param {string} opts.word   - a word inside a node’s string that should
	     *                               be highlighted as the source of the error
	     * @param {number} opts.index  - an index inside a node’s string that should
	     *                               be highlighted as the source of the error
	     *
	     * @return {CssSyntaxError} error object to throw it
	     *
	     * @example
	     * if ( !variables[name] ) {
	     *   throw decl.error('Unknown variable ' + name, { word: name });
	     *   // CssSyntaxError: postcss-vars:a.sass:4:3: Unknown variable $black
	     *   //   color: $black
	     *   // a
	     *   //          ^
	     *   //   background: white
	     * }
	     */
	
	
	    _createClass(Node, [{
	        key: 'error',
	        value: function error(message) {
	            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            if (this.source) {
	                var pos = this.positionBy(opts);
	                return this.source.input.error(message, pos.line, pos.column, opts);
	            } else {
	                return new _cssSyntaxError2.default(message);
	            }
	        }
	
	        /**
	         * This method is provided as a convenience wrapper for {@link Result#warn}.
	         *
	         * @param {Result} result      - the {@link Result} instance
	         *                               that will receive the warning
	         * @param {string} text        - warning message
	         * @param {object} [opts]      - options
	         * @param {string} opts.plugin - plugin name that created this warning.
	         *                               PostCSS will set it automatically.
	         * @param {string} opts.word   - a word inside a node’s string that should
	         *                               be highlighted as the source of the warning
	         * @param {number} opts.index  - an index inside a node’s string that should
	         *                               be highlighted as the source of the warning
	         *
	         * @return {Warning} created warning object
	         *
	         * @example
	         * const plugin = postcss.plugin('postcss-deprecated', () => {
	         *   return (root, result) => {
	         *     root.walkDecls('bad', decl => {
	         *       decl.warn(result, 'Deprecated property bad');
	         *     });
	         *   };
	         * });
	         */
	
	    }, {
	        key: 'warn',
	        value: function warn(result, text, opts) {
	            var data = { node: this };
	            for (var i in opts) {
	                data[i] = opts[i];
	            }return result.warn(text, data);
	        }
	
	        /**
	         * Removes the node from its parent and cleans the parent properties
	         * from the node and its children.
	         *
	         * @example
	         * if ( decl.prop.match(/^-webkit-/) ) {
	         *   decl.remove();
	         * }
	         *
	         * @return {Node} node to make calls chain
	         */
	
	    }, {
	        key: 'remove',
	        value: function remove() {
	            if (this.parent) {
	                this.parent.removeChild(this);
	            }
	            this.parent = undefined;
	            return this;
	        }
	
	        /**
	         * Returns a CSS string representing the node.
	         *
	         * @param {stringifier|syntax} [stringifier] - a syntax to use
	         *                                             in string generation
	         *
	         * @return {string} CSS string of this node
	         *
	         * @example
	         * postcss.rule({ selector: 'a' }).toString() //=> "a {}"
	         */
	
	    }, {
	        key: 'toString',
	        value: function toString() {
	            var stringifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _stringify2.default;
	
	            if (stringifier.stringify) stringifier = stringifier.stringify;
	            var result = '';
	            stringifier(this, function (i) {
	                result += i;
	            });
	            return result;
	        }
	
	        /**
	         * Returns a clone of the node.
	         *
	         * The resulting cloned node and its (cloned) children will have
	         * a clean parent and code style properties.
	         *
	         * @param {object} [overrides] - new properties to override in the clone.
	         *
	         * @example
	         * const cloned = decl.clone({ prop: '-moz-' + decl.prop });
	         * cloned.raws.before  //=> undefined
	         * cloned.parent       //=> undefined
	         * cloned.toString()   //=> -moz-transform: scale(0)
	         *
	         * @return {Node} clone of the node
	         */
	
	    }, {
	        key: 'clone',
	        value: function clone() {
	            var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            var cloned = cloneNode(this);
	            for (var name in overrides) {
	                cloned[name] = overrides[name];
	            }
	            return cloned;
	        }
	
	        /**
	         * Shortcut to clone the node and insert the resulting cloned node
	         * before the current node.
	         *
	         * @param {object} [overrides] - new properties to override in the clone.
	         *
	         * @example
	         * decl.cloneBefore({ prop: '-moz-' + decl.prop });
	         *
	         * @return {Node} - new node
	         */
	
	    }, {
	        key: 'cloneBefore',
	        value: function cloneBefore() {
	            var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            var cloned = this.clone(overrides);
	            this.parent.insertBefore(this, cloned);
	            return cloned;
	        }
	
	        /**
	         * Shortcut to clone the node and insert the resulting cloned node
	         * after the current node.
	         *
	         * @param {object} [overrides] - new properties to override in the clone.
	         *
	         * @return {Node} - new node
	         */
	
	    }, {
	        key: 'cloneAfter',
	        value: function cloneAfter() {
	            var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            var cloned = this.clone(overrides);
	            this.parent.insertAfter(this, cloned);
	            return cloned;
	        }
	
	        /**
	         * Inserts node(s) before the current node and removes the current node.
	         *
	         * @param {...Node} nodes - node(s) to replace current one
	         *
	         * @example
	         * if ( atrule.name == 'mixin' ) {
	         *   atrule.replaceWith(mixinRules[atrule.params]);
	         * }
	         *
	         * @return {Node} current node to methods chain
	         */
	
	    }, {
	        key: 'replaceWith',
	        value: function replaceWith() {
	            var _this = this;
	
	            if (this.parent) {
	                for (var _len = arguments.length, nodes = Array(_len), _key = 0; _key < _len; _key++) {
	                    nodes[_key] = arguments[_key];
	                }
	
	                nodes.forEach(function (node) {
	                    _this.parent.insertBefore(_this, node);
	                });
	
	                this.remove();
	            }
	
	            return this;
	        }
	
	        /**
	         * Removes the node from its current parent and inserts it
	         * at the end of `newParent`.
	         *
	         * This will clean the `before` and `after` code {@link Node#raws} data
	         * from the node and replace them with the indentation style of `newParent`.
	         * It will also clean the `between` property
	         * if `newParent` is in another {@link Root}.
	         *
	         * @param {Container} newParent - container node where the current node
	         *                                will be moved
	         *
	         * @example
	         * atrule.moveTo(atrule.root());
	         *
	         * @return {Node} current node to methods chain
	         */
	
	    }, {
	        key: 'moveTo',
	        value: function moveTo(newParent) {
	            this.cleanRaws(this.root() === newParent.root());
	            this.remove();
	            newParent.append(this);
	            return this;
	        }
	
	        /**
	         * Removes the node from its current parent and inserts it into
	         * a new parent before `otherNode`.
	         *
	         * This will also clean the node’s code style properties just as it would
	         * in {@link Node#moveTo}.
	         *
	         * @param {Node} otherNode - node that will be before current node
	         *
	         * @return {Node} current node to methods chain
	         */
	
	    }, {
	        key: 'moveBefore',
	        value: function moveBefore(otherNode) {
	            this.cleanRaws(this.root() === otherNode.root());
	            this.remove();
	            otherNode.parent.insertBefore(otherNode, this);
	            return this;
	        }
	
	        /**
	         * Removes the node from its current parent and inserts it into
	         * a new parent after `otherNode`.
	         *
	         * This will also clean the node’s code style properties just as it would
	         * in {@link Node#moveTo}.
	         *
	         * @param {Node} otherNode - node that will be after current node
	         *
	         * @return {Node} current node to methods chain
	         */
	
	    }, {
	        key: 'moveAfter',
	        value: function moveAfter(otherNode) {
	            this.cleanRaws(this.root() === otherNode.root());
	            this.remove();
	            otherNode.parent.insertAfter(otherNode, this);
	            return this;
	        }
	
	        /**
	         * Returns the next child of the node’s parent.
	         * Returns `undefined` if the current node is the last child.
	         *
	         * @return {Node|undefined} next node
	         *
	         * @example
	         * if ( comment.text === 'delete next' ) {
	         *   const next = comment.next();
	         *   if ( next ) {
	         *     next.remove();
	         *   }
	         * }
	         */
	
	    }, {
	        key: 'next',
	        value: function next() {
	            var index = this.parent.index(this);
	            return this.parent.nodes[index + 1];
	        }
	
	        /**
	         * Returns the previous child of the node’s parent.
	         * Returns `undefined` if the current node is the first child.
	         *
	         * @return {Node|undefined} previous node
	         *
	         * @example
	         * const annotation = decl.prev();
	         * if ( annotation.type == 'comment' ) {
	         *  readAnnotation(annotation.text);
	         * }
	         */
	
	    }, {
	        key: 'prev',
	        value: function prev() {
	            var index = this.parent.index(this);
	            return this.parent.nodes[index - 1];
	        }
	    }, {
	        key: 'toJSON',
	        value: function toJSON() {
	            var fixed = {};
	
	            for (var name in this) {
	                if (!this.hasOwnProperty(name)) continue;
	                if (name === 'parent') continue;
	                var value = this[name];
	
	                if (value instanceof Array) {
	                    fixed[name] = value.map(function (i) {
	                        if ((typeof i === 'undefined' ? 'undefined' : _typeof(i)) === 'object' && i.toJSON) {
	                            return i.toJSON();
	                        } else {
	                            return i;
	                        }
	                    });
	                } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.toJSON) {
	                    fixed[name] = value.toJSON();
	                } else {
	                    fixed[name] = value;
	                }
	            }
	
	            return fixed;
	        }
	
	        /**
	         * Returns a {@link Node#raws} value. If the node is missing
	         * the code style property (because the node was manually built or cloned),
	         * PostCSS will try to autodetect the code style property by looking
	         * at other nodes in the tree.
	         *
	         * @param {string} prop          - name of code style property
	         * @param {string} [defaultType] - name of default value, it can be missed
	         *                                 if the value is the same as prop
	         *
	         * @example
	         * const root = postcss.parse('a { background: white }');
	         * root.nodes[0].append({ prop: 'color', value: 'black' });
	         * root.nodes[0].nodes[1].raws.before   //=> undefined
	         * root.nodes[0].nodes[1].raw('before') //=> ' '
	         *
	         * @return {string} code style value
	         */
	
	    }, {
	        key: 'raw',
	        value: function raw(prop, defaultType) {
	            var str = new _stringifier2.default();
	            return str.raw(this, prop, defaultType);
	        }
	
	        /**
	         * Finds the Root instance of the node’s tree.
	         *
	         * @example
	         * root.nodes[0].nodes[0].root() === root
	         *
	         * @return {Root} root parent
	         */
	
	    }, {
	        key: 'root',
	        value: function root() {
	            var result = this;
	            while (result.parent) {
	                result = result.parent;
	            }return result;
	        }
	    }, {
	        key: 'cleanRaws',
	        value: function cleanRaws(keepBetween) {
	            delete this.raws.before;
	            delete this.raws.after;
	            if (!keepBetween) delete this.raws.between;
	        }
	    }, {
	        key: 'positionInside',
	        value: function positionInside(index) {
	            var string = this.toString();
	            var column = this.source.start.column;
	            var line = this.source.start.line;
	
	            for (var i = 0; i < index; i++) {
	                if (string[i] === '\n') {
	                    column = 1;
	                    line += 1;
	                } else {
	                    column += 1;
	                }
	            }
	
	            return { line: line, column: column };
	        }
	    }, {
	        key: 'positionBy',
	        value: function positionBy(opts) {
	            var pos = this.source.start;
	            if (opts.index) {
	                pos = this.positionInside(opts.index);
	            } else if (opts.word) {
	                var index = this.toString().indexOf(opts.word);
	                if (index !== -1) pos = this.positionInside(index);
	            }
	            return pos;
	        }
	    }, {
	        key: 'removeSelf',
	        value: function removeSelf() {
	            (0, _warnOnce2.default)('Node#removeSelf is deprecated. Use Node#remove.');
	            return this.remove();
	        }
	    }, {
	        key: 'replace',
	        value: function replace(nodes) {
	            (0, _warnOnce2.default)('Node#replace is deprecated. Use Node#replaceWith');
	            return this.replaceWith(nodes);
	        }
	    }, {
	        key: 'style',
	        value: function style(own, detect) {
	            (0, _warnOnce2.default)('Node#style() is deprecated. Use Node#raw()');
	            return this.raw(own, detect);
	        }
	    }, {
	        key: 'cleanStyles',
	        value: function cleanStyles(keepBetween) {
	            (0, _warnOnce2.default)('Node#cleanStyles() is deprecated. Use Node#cleanRaws()');
	            return this.cleanRaws(keepBetween);
	        }
	    }, {
	        key: 'before',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#before is deprecated. Use Node#raws.before');
	            return this.raws.before;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#before is deprecated. Use Node#raws.before');
	            this.raws.before = val;
	        }
	    }, {
	        key: 'between',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#between is deprecated. Use Node#raws.between');
	            return this.raws.between;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#between is deprecated. Use Node#raws.between');
	            this.raws.between = val;
	        }
	
	        /**
	         * @memberof Node#
	         * @member {string} type - String representing the node’s type.
	         *                         Possible values are `root`, `atrule`, `rule`,
	         *                         `decl`, or `comment`.
	         *
	         * @example
	         * postcss.decl({ prop: 'color', value: 'black' }).type //=> 'decl'
	         */
	
	        /**
	         * @memberof Node#
	         * @member {Container} parent - the node’s parent node.
	         *
	         * @example
	         * root.nodes[0].parent == root;
	         */
	
	        /**
	         * @memberof Node#
	         * @member {source} source - the input source of the node
	         *
	         * The property is used in source map generation.
	         *
	         * If you create a node manually (e.g., with `postcss.decl()`),
	         * that node will not have a `source` property and will be absent
	         * from the source map. For this reason, the plugin developer should
	         * consider cloning nodes to create new ones (in which case the new node’s
	         * source will reference the original, cloned node) or setting
	         * the `source` property manually.
	         *
	         * ```js
	         * // Bad
	         * const prefixed = postcss.decl({
	         *   prop: '-moz-' + decl.prop,
	         *   value: decl.value
	         * });
	         *
	         * // Good
	         * const prefixed = decl.clone({ prop: '-moz-' + decl.prop });
	         * ```
	         *
	         * ```js
	         * if ( atrule.name == 'add-link' ) {
	         *   const rule = postcss.rule({ selector: 'a', source: atrule.source });
	         *   atrule.parent.insertBefore(atrule, rule);
	         * }
	         * ```
	         *
	         * @example
	         * decl.source.input.from //=> '/home/ai/a.sass'
	         * decl.source.start      //=> { line: 10, column: 2 }
	         * decl.source.end        //=> { line: 10, column: 12 }
	         */
	
	        /**
	         * @memberof Node#
	         * @member {object} raws - Information to generate byte-to-byte equal
	         *                         node string as it was in the origin input.
	         *
	         * Every parser saves its own properties,
	         * but the default CSS parser uses:
	         *
	         * * `before`: the space symbols before the node. It also stores `*`
	         *   and `_` symbols before the declaration (IE hack).
	         * * `after`: the space symbols after the last child of the node
	         *   to the end of the node.
	         * * `between`: the symbols between the property and value
	         *   for declarations, selector and `{` for rules, or last parameter
	         *   and `{` for at-rules.
	         * * `semicolon`: contains true if the last child has
	         *   an (optional) semicolon.
	         * * `afterName`: the space between the at-rule name and its parameters.
	         * * `left`: the space symbols between `/*` and the comment’s text.
	         * * `right`: the space symbols between the comment’s text
	         *   and <code>*&#47;</code>.
	         * * `important`: the content of the important statement,
	         *   if it is not just `!important`.
	         *
	         * PostCSS cleans selectors, declaration values and at-rule parameters
	         * from comments and extra spaces, but it stores origin content in raws
	         * properties. As such, if you don’t change a declaration’s value,
	         * PostCSS will use the raw value with comments.
	         *
	         * @example
	         * const root = postcss.parse('a {\n  color:black\n}')
	         * root.first.first.raws //=> { before: '\n  ', between: ':' }
	         */
	
	    }]);
	
	    return Node;
	}();
	
	exports.default = Node;
	module.exports = exports['default'];

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	__webpack_require__(256);
	
	var _container = __webpack_require__(179);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _lazyResult = __webpack_require__(542);
	
	var _lazyResult2 = _interopRequireDefault(_lazyResult);
	
	var _processor = __webpack_require__(1169);
	
	var _processor2 = _interopRequireDefault(_processor);
	
	var _warnOnce = __webpack_require__(67);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // break cyclical dependency deadlock – #87
	
	/**
	 * Represents a CSS file and contains all its parsed nodes.
	 *
	 * @extends Container
	 *
	 * @example
	 * const root = postcss.parse('a{color:black} b{z-index:2}');
	 * root.type         //=> 'root'
	 * root.nodes.length //=> 2
	 */
	var Root = function (_Container) {
	    _inherits(Root, _Container);
	
	    function Root(defaults) {
	        _classCallCheck(this, Root);
	
	        var _this = _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).call(this, defaults));
	
	        _this.type = 'root';
	        if (!_this.nodes) _this.nodes = [];
	        return _this;
	    }
	
	    _createClass(Root, [{
	        key: 'removeChild',
	        value: function removeChild(child) {
	            child = this.index(child);
	
	            if (child === 0 && this.nodes.length > 1) {
	                this.nodes[1].raws.before = this.nodes[child].raws.before;
	            }
	
	            return _get(Root.prototype.__proto__ || Object.getPrototypeOf(Root.prototype), 'removeChild', this).call(this, child);
	        }
	    }, {
	        key: 'normalize',
	        value: function normalize(child, sample, type) {
	            var nodes = _get(Root.prototype.__proto__ || Object.getPrototypeOf(Root.prototype), 'normalize', this).call(this, child);
	
	            if (sample) {
	                if (type === 'prepend') {
	                    if (this.nodes.length > 1) {
	                        sample.raws.before = this.nodes[1].raws.before;
	                    } else {
	                        delete sample.raws.before;
	                    }
	                } else if (this.first !== sample) {
	                    nodes.forEach(function (node) {
	                        node.raws.before = sample.raws.before;
	                    });
	                }
	            }
	
	            return nodes;
	        }
	
	        /**
	         * Returns a {@link Result} instance representing the root’s CSS.
	         *
	         * @param {processOptions} [opts] - options with only `to` and `map` keys
	         *
	         * @return {Result} result with current root’s CSS
	         *
	         * @example
	         * const root1 = postcss.parse(css1, { from: 'a.css' });
	         * const root2 = postcss.parse(css2, { from: 'b.css' });
	         * root1.append(root2);
	         * const result = root1.toResult({ to: 'all.css', map: true });
	         */
	
	    }, {
	        key: 'toResult',
	        value: function toResult() {
	            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            var lazy = new _lazyResult2.default(new _processor2.default(), this, opts);
	            return lazy.stringify();
	        }
	    }, {
	        key: 'remove',
	        value: function remove(child) {
	            (0, _warnOnce2.default)('Root#remove is deprecated. Use Root#removeChild');
	            this.removeChild(child);
	        }
	    }, {
	        key: 'prevMap',
	        value: function prevMap() {
	            (0, _warnOnce2.default)('Root#prevMap is deprecated. Use Root#source.input.map');
	            return this.source.input.map;
	        }
	
	        /**
	         * @memberof Root#
	         * @member {object} raws - Information to generate byte-to-byte equal
	         *                         node string as it was in the origin input.
	         *
	         * Every parser saves its own properties,
	         * but the default CSS parser uses:
	         *
	         * * `after`: the space symbols after the last child to the end of file.
	         * * `semicolon`: is the last child has an (optional) semicolon.
	         *
	         * @example
	         * postcss.parse('a {}\n').raws //=> { after: '\n' }
	         * postcss.parse('a {}').raws   //=> { after: '' }
	         */
	
	    }]);
	
	    return Root;
	}(_container2.default);
	
	exports.default = Root;
	module.exports = exports['default'];

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(251);
	
	var _container = __webpack_require__(179);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _warnOnce = __webpack_require__(67);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	var _list = __webpack_require__(1168);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // break cyclical dependency deadlock – #87
	
	/**
	 * Represents a CSS rule: a selector followed by a declaration block.
	 *
	 * @extends Container
	 *
	 * @example
	 * const root = postcss.parse('a{}');
	 * const rule = root.first;
	 * rule.type       //=> 'rule'
	 * rule.toString() //=> 'a{}'
	 */
	var Rule = function (_Container) {
	    _inherits(Rule, _Container);
	
	    function Rule(defaults) {
	        _classCallCheck(this, Rule);
	
	        var _this = _possibleConstructorReturn(this, (Rule.__proto__ || Object.getPrototypeOf(Rule)).call(this, defaults));
	
	        _this.type = 'rule';
	        if (!_this.nodes) _this.nodes = [];
	        return _this;
	    }
	
	    /**
	     * An array containing the rule’s individual selectors.
	     * Groups of selectors are split at commas.
	     *
	     * @type {string[]}
	     *
	     * @example
	     * const root = postcss.parse('a, b { }');
	     * const rule = root.first;
	     *
	     * rule.selector  //=> 'a, b'
	     * rule.selectors //=> ['a', 'b']
	     *
	     * rule.selectors = ['a', 'strong'];
	     * rule.selector //=> 'a, strong'
	     */
	
	
	    _createClass(Rule, [{
	        key: 'selectors',
	        get: function get() {
	            return _list2.default.comma(this.selector);
	        },
	        set: function set(values) {
	            var match = this.selector ? this.selector.match(/,\s*/) : null;
	            var sep = match ? match[0] : ',' + this.raw('between', 'beforeOpen');
	            this.selector = values.join(sep);
	        }
	    }, {
	        key: '_selector',
	        get: function get() {
	            (0, _warnOnce2.default)('Rule#_selector is deprecated. Use Rule#raws.selector');
	            return this.raws.selector;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Rule#_selector is deprecated. Use Rule#raws.selector');
	            this.raws.selector = val;
	        }
	
	        /**
	         * @memberof Rule#
	         * @member {string} selector - the rule’s full selector represented
	         *                             as a string
	         *
	         * @example
	         * const root = postcss.parse('a, b { }');
	         * const rule = root.first;
	         * rule.selector //=> 'a, b'
	         */
	
	        /**
	         * @memberof Rule#
	         * @member {object} raws - Information to generate byte-to-byte equal
	         *                         node string as it was in the origin input.
	         *
	         * Every parser saves its own properties,
	         * but the default CSS parser uses:
	         *
	         * * `before`: the space symbols before the node. It also stores `*`
	         *   and `_` symbols before the declaration (IE hack).
	         * * `after`: the space symbols after the last child of the node
	         *   to the end of the node.
	         * * `between`: the symbols between the property and value
	         *   for declarations, selector and `{` for rules, or last parameter
	         *   and `{` for at-rules.
	         * * `semicolon`: contains true if the last child has
	         *   an (optional) semicolon.
	         *
	         * PostCSS cleans selectors from comments and extra spaces,
	         * but it stores origin content in raws properties.
	         * As such, if you don’t change a declaration’s value,
	         * PostCSS will use the raw value with comments.
	         *
	         * @example
	         * const root = postcss.parse('a {\n  color:black\n}')
	         * root.first.first.raws //=> { before: '', between: ' ', after: '\n' }
	         */
	
	    }]);
	
	    return Rule;
	}(_container2.default);
	
	exports.default = Rule;
	module.exports = exports['default'];

/***/ },
/* 257 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = tokenize;
	var SINGLE_QUOTE = '\''.charCodeAt(0);
	var DOUBLE_QUOTE = '"'.charCodeAt(0);
	var BACKSLASH = '\\'.charCodeAt(0);
	var SLASH = '/'.charCodeAt(0);
	var NEWLINE = '\n'.charCodeAt(0);
	var SPACE = ' '.charCodeAt(0);
	var FEED = '\f'.charCodeAt(0);
	var TAB = '\t'.charCodeAt(0);
	var CR = '\r'.charCodeAt(0);
	var OPEN_SQUARE = '['.charCodeAt(0);
	var CLOSE_SQUARE = ']'.charCodeAt(0);
	var OPEN_PARENTHESES = '('.charCodeAt(0);
	var CLOSE_PARENTHESES = ')'.charCodeAt(0);
	var OPEN_CURLY = '{'.charCodeAt(0);
	var CLOSE_CURLY = '}'.charCodeAt(0);
	var SEMICOLON = ';'.charCodeAt(0);
	var ASTERISK = '*'.charCodeAt(0);
	var COLON = ':'.charCodeAt(0);
	var AT = '@'.charCodeAt(0);
	
	var RE_AT_END = /[ \n\t\r\f\{\(\)'"\\;/\[\]#]/g;
	var RE_WORD_END = /[ \n\t\r\f\(\)\{\}:;@!'"\\\]\[#]|\/(?=\*)/g;
	var RE_BAD_BRACKET = /.[\\\/\("'\n]/;
	
	function tokenize(input) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var tokens = [];
	    var css = input.css.valueOf();
	
	    var ignore = options.ignoreErrors;
	
	    var code = void 0,
	        next = void 0,
	        quote = void 0,
	        lines = void 0,
	        last = void 0,
	        content = void 0,
	        escape = void 0,
	        nextLine = void 0,
	        nextOffset = void 0,
	        escaped = void 0,
	        escapePos = void 0,
	        prev = void 0,
	        n = void 0;
	
	    var length = css.length;
	    var offset = -1;
	    var line = 1;
	    var pos = 0;
	
	    function unclosed(what) {
	        throw input.error('Unclosed ' + what, line, pos - offset);
	    }
	
	    while (pos < length) {
	        code = css.charCodeAt(pos);
	
	        if (code === NEWLINE || code === FEED || code === CR && css.charCodeAt(pos + 1) !== NEWLINE) {
	            offset = pos;
	            line += 1;
	        }
	
	        switch (code) {
	            case NEWLINE:
	            case SPACE:
	            case TAB:
	            case CR:
	            case FEED:
	                next = pos;
	                do {
	                    next += 1;
	                    code = css.charCodeAt(next);
	                    if (code === NEWLINE) {
	                        offset = next;
	                        line += 1;
	                    }
	                } while (code === SPACE || code === NEWLINE || code === TAB || code === CR || code === FEED);
	
	                tokens.push(['space', css.slice(pos, next)]);
	                pos = next - 1;
	                break;
	
	            case OPEN_SQUARE:
	                tokens.push(['[', '[', line, pos - offset]);
	                break;
	
	            case CLOSE_SQUARE:
	                tokens.push([']', ']', line, pos - offset]);
	                break;
	
	            case OPEN_CURLY:
	                tokens.push(['{', '{', line, pos - offset]);
	                break;
	
	            case CLOSE_CURLY:
	                tokens.push(['}', '}', line, pos - offset]);
	                break;
	
	            case COLON:
	                tokens.push([':', ':', line, pos - offset]);
	                break;
	
	            case SEMICOLON:
	                tokens.push([';', ';', line, pos - offset]);
	                break;
	
	            case OPEN_PARENTHESES:
	                prev = tokens.length ? tokens[tokens.length - 1][1] : '';
	                n = css.charCodeAt(pos + 1);
	                if (prev === 'url' && n !== SINGLE_QUOTE && n !== DOUBLE_QUOTE && n !== SPACE && n !== NEWLINE && n !== TAB && n !== FEED && n !== CR) {
	                    next = pos;
	                    do {
	                        escaped = false;
	                        next = css.indexOf(')', next + 1);
	                        if (next === -1) {
	                            if (ignore) {
	                                next = pos;
	                                break;
	                            } else {
	                                unclosed('bracket');
	                            }
	                        }
	                        escapePos = next;
	                        while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
	                            escapePos -= 1;
	                            escaped = !escaped;
	                        }
	                    } while (escaped);
	
	                    tokens.push(['brackets', css.slice(pos, next + 1), line, pos - offset, line, next - offset]);
	                    pos = next;
	                } else {
	                    next = css.indexOf(')', pos + 1);
	                    content = css.slice(pos, next + 1);
	
	                    if (next === -1 || RE_BAD_BRACKET.test(content)) {
	                        tokens.push(['(', '(', line, pos - offset]);
	                    } else {
	                        tokens.push(['brackets', content, line, pos - offset, line, next - offset]);
	                        pos = next;
	                    }
	                }
	
	                break;
	
	            case CLOSE_PARENTHESES:
	                tokens.push([')', ')', line, pos - offset]);
	                break;
	
	            case SINGLE_QUOTE:
	            case DOUBLE_QUOTE:
	                quote = code === SINGLE_QUOTE ? '\'' : '"';
	                next = pos;
	                do {
	                    escaped = false;
	                    next = css.indexOf(quote, next + 1);
	                    if (next === -1) {
	                        if (ignore) {
	                            next = pos + 1;
	                            break;
	                        } else {
	                            unclosed('quote');
	                        }
	                    }
	                    escapePos = next;
	                    while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
	                        escapePos -= 1;
	                        escaped = !escaped;
	                    }
	                } while (escaped);
	
	                content = css.slice(pos, next + 1);
	                lines = content.split('\n');
	                last = lines.length - 1;
	
	                if (last > 0) {
	                    nextLine = line + last;
	                    nextOffset = next - lines[last].length;
	                } else {
	                    nextLine = line;
	                    nextOffset = offset;
	                }
	
	                tokens.push(['string', css.slice(pos, next + 1), line, pos - offset, nextLine, next - nextOffset]);
	
	                offset = nextOffset;
	                line = nextLine;
	                pos = next;
	                break;
	
	            case AT:
	                RE_AT_END.lastIndex = pos + 1;
	                RE_AT_END.test(css);
	                if (RE_AT_END.lastIndex === 0) {
	                    next = css.length - 1;
	                } else {
	                    next = RE_AT_END.lastIndex - 2;
	                }
	                tokens.push(['at-word', css.slice(pos, next + 1), line, pos - offset, line, next - offset]);
	                pos = next;
	                break;
	
	            case BACKSLASH:
	                next = pos;
	                escape = true;
	                while (css.charCodeAt(next + 1) === BACKSLASH) {
	                    next += 1;
	                    escape = !escape;
	                }
	                code = css.charCodeAt(next + 1);
	                if (escape && code !== SLASH && code !== SPACE && code !== NEWLINE && code !== TAB && code !== CR && code !== FEED) {
	                    next += 1;
	                }
	                tokens.push(['word', css.slice(pos, next + 1), line, pos - offset, line, next - offset]);
	                pos = next;
	                break;
	
	            default:
	                if (code === SLASH && css.charCodeAt(pos + 1) === ASTERISK) {
	                    next = css.indexOf('*/', pos + 2) + 1;
	                    if (next === 0) {
	                        if (ignore) {
	                            next = css.length;
	                        } else {
	                            unclosed('comment');
	                        }
	                    }
	
	                    content = css.slice(pos, next + 1);
	                    lines = content.split('\n');
	                    last = lines.length - 1;
	
	                    if (last > 0) {
	                        nextLine = line + last;
	                        nextOffset = next - lines[last].length;
	                    } else {
	                        nextLine = line;
	                        nextOffset = offset;
	                    }
	
	                    tokens.push(['comment', content, line, pos - offset, nextLine, next - nextOffset]);
	
	                    offset = nextOffset;
	                    line = nextLine;
	                    pos = next;
	                } else {
	                    RE_WORD_END.lastIndex = pos + 1;
	                    RE_WORD_END.test(css);
	                    if (RE_WORD_END.lastIndex === 0) {
	                        next = css.length - 1;
	                    } else {
	                        next = RE_WORD_END.lastIndex - 2;
	                    }
	
	                    tokens.push(['word', css.slice(pos, next + 1), line, pos - offset, line, next - offset]);
	                    pos = next;
	                }
	
	                break;
	        }
	
	        pos++;
	    }
	
	    return tokens;
	}
	module.exports = exports['default'];

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * 'Higher Order Component' that controls the props of a wrapped
	 * component via stores.
	 *
	 * Expects the Component to have two static methods:
	 *   - getStores(): Should return an array of stores.
	 *   - getPropsFromStores(props): Should return the props from the stores.
	 *
	 * Example using old React.createClass() style:
	 *
	 *    const MyComponent = React.createClass({
	 *      statics: {
	 *        getStores(props) {
	 *          return [myStore]
	 *        },
	 *        getPropsFromStores(props) {
	 *          return myStore.getState()
	 *        }
	 *      },
	 *      render() {
	 *        // Use this.props like normal ...
	 *      }
	 *    })
	 *    MyComponent = connectToStores(MyComponent)
	 *
	 *
	 * Example using ES6 Class:
	 *
	 *    class MyComponent extends React.Component {
	 *      static getStores(props) {
	 *        return [myStore]
	 *      }
	 *      static getPropsFromStores(props) {
	 *        return myStore.getState()
	 *      }
	 *      render() {
	 *        // Use this.props like normal ...
	 *      }
	 *    }
	 *    MyComponent = connectToStores(MyComponent)
	 *
	 * A great explanation of the merits of higher order components can be found at
	 * http://bit.ly/1abPkrP
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _functions = __webpack_require__(549);
	
	function connectToStores(Spec) {
	  var Component = arguments.length <= 1 || arguments[1] === undefined ? Spec : arguments[1];
	  return (function () {
	    // Check for required static methods.
	    if (!(0, _functions.isFunction)(Spec.getStores)) {
	      throw new Error('connectToStores() expects the wrapped component to have a static getStores() method');
	    }
	    if (!(0, _functions.isFunction)(Spec.getPropsFromStores)) {
	      throw new Error('connectToStores() expects the wrapped component to have a static getPropsFromStores() method');
	    }
	
	    var StoreConnection = _react2['default'].createClass({
	      displayName: 'Stateful' + (Component.displayName || Component.name || 'Container'),
	
	      getInitialState: function getInitialState() {
	        return Spec.getPropsFromStores(this.props, this.context);
	      },
	
	      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this.setState(Spec.getPropsFromStores(nextProps, this.context));
	      },
	
	      componentDidMount: function componentDidMount() {
	        var _this = this;
	
	        var stores = Spec.getStores(this.props, this.context);
	        this.storeListeners = stores.map(function (store) {
	          return store.listen(_this.onChange);
	        });
	        if (Spec.componentDidConnect) {
	          Spec.componentDidConnect(this.props, this.context);
	        }
	      },
	
	      componentWillUnmount: function componentWillUnmount() {
	        this.storeListeners.forEach(function (unlisten) {
	          return unlisten();
	        });
	      },
	
	      onChange: function onChange() {
	        this.setState(Spec.getPropsFromStores(this.props, this.context));
	      },
	
	      render: function render() {
	        return _react2['default'].createElement(Component, (0, _functions.assign)({}, this.props, this.state));
	      }
	    });
	    if (Component.contextTypes) {
	      StoreConnection.contextTypes = Component.contextTypes;
	    }
	
	    return StoreConnection;
	  })();
	}
	
	exports['default'] = connectToStores;
	module.exports = exports['default'];

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(47);
	var settle = __webpack_require__(564);
	var buildURL = __webpack_require__(567);
	var parseHeaders = __webpack_require__(573);
	var isURLSameOrigin = __webpack_require__(571);
	var createError = __webpack_require__(262);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(566);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(569);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 260 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 261 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(563);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ },
/* 263 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 264 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(187);
	var document = __webpack_require__(90).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 266 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(264);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(592);
	var $export = __webpack_require__(185);
	var redefine = __webpack_require__(600);
	var hide = __webpack_require__(106);
	var has = __webpack_require__(136);
	var Iterators = __webpack_require__(137);
	var $iterCreate = __webpack_require__(590);
	var setToStringTag = __webpack_require__(271);
	var getPrototypeOf = __webpack_require__(597);
	var ITERATOR = __webpack_require__(91)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(598);
	var enumBugKeys = __webpack_require__(266);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 270 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(138).f;
	var has = __webpack_require__(136);
	var TAG = __webpack_require__(91)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(90);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(184);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 274 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(NEXT_FILTER) {
	var util = __webpack_require__(16);
	var getKeys = __webpack_require__(92).keys;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function catchFilter(instances, cb, promise) {
	    return function(e) {
	        var boundTo = promise._boundValue();
	        predicateLoop: for (var i = 0; i < instances.length; ++i) {
	            var item = instances[i];
	
	            if (item === Error ||
	                (item != null && item.prototype instanceof Error)) {
	                if (e instanceof item) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (typeof item === "function") {
	                var matchesPredicate = tryCatch(item).call(boundTo, e);
	                if (matchesPredicate === errorObj) {
	                    return matchesPredicate;
	                } else if (matchesPredicate) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (util.isObject(e)) {
	                var keys = getKeys(item);
	                for (var j = 0; j < keys.length; ++j) {
	                    var key = keys[j];
	                    if (item[key] != e[key]) {
	                        continue predicateLoop;
	                    }
	                }
	                return tryCatch(cb).call(boundTo, e);
	            }
	        }
	        return NEXT_FILTER;
	    };
	}
	
	return catchFilter;
	};


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var util = __webpack_require__(16);
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = __webpack_require__(68);
	var OperationalError = errors.OperationalError;
	var es5 = __webpack_require__(92);
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise, multiArgs) {
	    return function(err, value) {
	        if (promise === null) return;
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (!multiArgs) {
	            promise._fulfill(value);
	        } else {
	            var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	            promise._fulfill(args);
	        }
	        promise = null;
	    };
	}
	
	module.exports = nodebackForPromise;


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var emptyObject = __webpack_require__(643);
	var _invariant = __webpack_require__(644);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(194);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(705);
	
	var _runTransitionHook = __webpack_require__(194);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(93);
	
	var _PathUtils = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 281 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertAPIOptions = convertAPIOptions;
	exports.convertJSONOptions = convertJSONOptions;
	exports.convertTOptions = convertTOptions;
	exports.appendBackwardsAPI = appendBackwardsAPI;
	
	var _logger = __webpack_require__(70);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function convertInterpolation(options) {
	
	  options.interpolation = {
	    unescapeSuffix: 'HTML'
	  };
	
	  options.interpolation.prefix = options.interpolationPrefix || '__';
	  options.interpolation.suffix = options.interpolationSuffix || '__';
	  options.interpolation.escapeValue = options.escapeInterpolation || false;
	
	  options.interpolation.nestingPrefix = options.reusePrefix || '$t(';
	  options.interpolation.nestingSuffix = options.reuseSuffix || ')';
	
	  return options;
	}
	
	function convertAPIOptions(options) {
	  if (options.resStore) options.resources = options.resStore;
	
	  if (options.ns && options.ns.defaultNs) {
	    options.defaultNS = options.ns.defaultNs;
	    options.ns = options.ns.namespaces;
	  } else {
	    options.defaultNS = options.ns || 'translation';
	  }
	
	  if (options.fallbackToDefaultNS && options.defaultNS) options.fallbackNS = options.defaultNS;
	
	  options.saveMissing = options.sendMissing;
	  options.saveMissingTo = options.sendMissingTo || 'current';
	  options.returnNull = options.fallbackOnNull ? false : true;
	  options.returnEmptyString = options.fallbackOnEmpty ? false : true;
	  options.returnObjects = options.returnObjectTrees;
	  options.joinArrays = '\n';
	
	  options.returnedObjectHandler = options.objectTreeKeyHandler;
	  options.parseMissingKeyHandler = options.parseMissingKey;
	  options.appendNamespaceToMissingKey = true;
	
	  options.nsSeparator = options.nsseparator || ':';
	  options.keySeparator = options.keyseparator || '.';
	
	  if (options.shortcutFunction === 'sprintf') {
	    options.overloadTranslationOptionHandler = function (args) {
	      var values = [];
	
	      for (var i = 1; i < args.length; i++) {
	        values.push(args[i]);
	      }
	
	      return {
	        postProcess: 'sprintf',
	        sprintf: values
	      };
	    };
	  }
	
	  options.whitelist = options.lngWhitelist;
	  options.preload = options.preload;
	  if (options.load === 'current') options.load = 'currentOnly';
	  if (options.load === 'unspecific') options.load = 'languageOnly';
	
	  // backend
	  options.backend = options.backend || {};
	  options.backend.loadPath = options.resGetPath || 'locales/__lng__/__ns__.json';
	  options.backend.addPath = options.resPostPath || 'locales/add/__lng__/__ns__';
	  options.backend.allowMultiLoading = options.dynamicLoad;
	
	  // cache
	  options.cache = options.cache || {};
	  options.cache.prefix = 'res_';
	  options.cache.expirationTime = 7 * 24 * 60 * 60 * 1000;
	  options.cache.enabled = options.useLocalStorage ? true : false;
	
	  options = convertInterpolation(options);
	  if (options.defaultVariables) options.interpolation.defaultVariables = options.defaultVariables;
	
	  // TODO: deprecation
	  // if (options.getAsync === false) throw deprecation error
	
	  return options;
	}
	
	function convertJSONOptions(options) {
	  options = convertInterpolation(options);
	  options.joinArrays = '\n';
	
	  return options;
	}
	
	function convertTOptions(options) {
	  if (options.interpolationPrefix || options.interpolationSuffix || options.escapeInterpolation) {
	    options = convertInterpolation(options);
	  }
	
	  options.nsSeparator = options.nsseparator;
	  options.keySeparator = options.keyseparator;
	
	  options.returnObjects = options.returnObjectTrees;
	
	  return options;
	}
	
	function appendBackwardsAPI(i18n) {
	  i18n.lng = function () {
	    _logger2.default.deprecate('i18next.lng() can be replaced by i18next.language for detected language or i18next.languages for languages ordered by translation lookup.');
	    return i18n.services.languageUtils.toResolveHierarchy(i18n.language)[0];
	  };
	
	  i18n.preload = function (lngs, cb) {
	    _logger2.default.deprecate('i18next.preload() can be replaced with i18next.loadLanguages()');
	    i18n.loadLanguages(lngs, cb);
	  };
	
	  i18n.setLng = function (lng, options, callback) {
	    _logger2.default.deprecate('i18next.setLng() can be replaced with i18next.changeLanguage() or i18next.getFixedT() to get a translation function with fixed language or namespace.');
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    if (!options) options = {};
	
	    if (options.fixLng === true) {
	      if (callback) return callback(null, i18n.getFixedT(lng));
	    }
	
	    i18n.changeLanguage(lng, callback);
	  };
	
	  i18n.addPostProcessor = function (name, fc) {
	    _logger2.default.deprecate('i18next.addPostProcessor() can be replaced by i18next.use({ type: \'postProcessor\', name: \'name\', process: fc })');
	    i18n.use({
	      type: 'postProcessor',
	      name: name,
	      process: fc
	    });
	  };
	}

/***/ },
/* 283 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  processors: {},
	
	  addPostProcessor: function addPostProcessor(module) {
	    this.processors[module.name] = module;
	  },
	  handle: function handle(processors, value, key, options, translator) {
	    var _this = this;
	
	    processors.forEach(function (processor) {
	      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
	    });
	
	    return value;
	  }
	};

/***/ },
/* 284 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
	module.exports = exports["default"];

/***/ },
/* 285 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// helper to capitalize strings
	
	exports.default = function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	module.exports = exports["default"];

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(690);
	
	function isObjectObject(o) {
	  return isObject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	module.exports = function isPlainObject(o) {
	  var ctor,prot;
	
	  if (isObjectObject(o) === false) return false;
	
	  // If has modified constructor
	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	};


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.DIGIT_PLACEHOLDER = undefined;
	
	var _getIterator2 = __webpack_require__(183);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(577);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(578);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.close_dangling_braces = close_dangling_braces;
	exports.count_occurences = count_occurences;
	exports.repeat = repeat;
	
	var _metadata = __webpack_require__(142);
	
	var _parse = __webpack_require__(109);
	
	var _format = __webpack_require__(198);
	
	var _common = __webpack_require__(197);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Used in phone number format template creation.
	// Could be any digit, I guess.
	// This is an enhanced port of Google Android `libphonenumber`'s
	// `asyoutypeformatter.js` of 17th November, 2016.
	//
	// https://github.com/googlei18n/libphonenumber/blob/8d21a365061de2ba0675c878a710a7b24f74d2ae/javascript/i18n/phonenumbers/asyoutypeformatter.js
	
	var DUMMY_DIGIT = '9';
	var DUMMY_DIGIT_MATCHER = new RegExp(DUMMY_DIGIT, 'g');
	// I don't know why is it exactly `15`
	var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15;
	// Create a phone number consisting only of the digit 9 that matches the
	// `number_pattern` by applying the pattern to the "longest phone number" string.
	var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH);
	
	// The digits that have not been entered yet will be represented by a \u2008,
	// the punctuation space.
	var DIGIT_PLACEHOLDER = exports.DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)
	var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER);
	var DIGIT_PLACEHOLDER_MATCHER_GLOBAL = new RegExp(DIGIT_PLACEHOLDER, 'g');
	
	// A pattern that is used to match character classes in regular expressions.
	// An example of a character class is "[1-4]".
	var CHARACTER_CLASS_PATTERN = /\[([^\[\]])*\]/g;
	
	// Any digit in a regular expression that actually denotes a digit. For
	// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
	// (8 and 0) are standalone digits, but the rest are not.
	// Two look-aheads are needed because the number following \\d could be a
	// two-digit number, since the phone number can be as long as 15 digits.
	var STANDALONE_DIGIT_PATTERN = /\d(?=[^,}][^,}])/g;
	
	// A pattern that is used to determine if a `format` is eligible
	// to be used by the "as you type formatter".
	// It is eligible when the `format` contains groups of the dollar sign
	// followed by a single digit, separated by valid phone number punctuation.
	// This prevents invalid punctuation (such as the star sign in Israeli star numbers)
	// getting into the output of the "as you type formatter".
	var ELIGIBLE_FORMAT_PATTERN = new RegExp('^' + '[' + _parse.VALID_PUNCTUATION + ']*' + '(\\$\\d[' + _parse.VALID_PUNCTUATION + ']*)+' + '$');
	
	// This is the minimum length of the leading digits of a phone number
	// to guarantee the first "leading digits pattern" for a phone number format
	// to be preemptive.
	var MIN_LEADING_DIGITS_LENGTH = 3;
	
	var VALID_INCOMPLETE_PHONE_NUMBER = '[' + _parse.PLUS_CHARS + ']{0,1}' + '[' + _parse.VALID_PUNCTUATION + _parse.VALID_DIGITS + ']*';
	
	var VALID_INCOMPLETE_PHONE_NUMBER_PATTERN = new RegExp('^' + VALID_INCOMPLETE_PHONE_NUMBER + '$', 'i');
	
	var as_you_type = function () {
		function as_you_type(country_code, metadata) {
			(0, _classCallCheck3.default)(this, as_you_type);
	
			// Sanity check
			if (!metadata) {
				throw new Error('Metadata not passed');
			}
	
			if (country_code && metadata.countries[country_code]) {
				this.default_country = country_code;
			}
	
			this.metadata = metadata;
	
			this.reset();
		}
	
		(0, _createClass3.default)(as_you_type, [{
			key: 'input',
			value: function input(text) {
				// Parse input
	
				var extracted_number = (0, _parse.extract_formatted_phone_number)(text);
	
				// Special case for a lone '+' sign
				// since it's not considered a possible phone number.
				if (!extracted_number) {
					if (text && text.indexOf('+') >= 0) {
						extracted_number = '+';
					}
				}
	
				// Validate possible first part of a phone number
				if (!(0, _common.matches_entirely)(extracted_number, VALID_INCOMPLETE_PHONE_NUMBER_PATTERN)) {
					return this.current_output;
				}
	
				return this.process_input((0, _parse.parse_phone_number)(extracted_number));
			}
		}, {
			key: 'process_input',
			value: function process_input(input) {
				// If an out of position '+' sign detected
				// (or a second '+' sign),
				// then just drop it from the input.
				if (input[0] === '+') {
					if (!this.parsed_input) {
						this.parsed_input += '+';
	
						// If a default country was set
						// then reset it because an explicitly international
						// phone number is being entered
						this.reset_countriness();
					}
	
					input = input.slice(1);
				}
	
				// Raw phone number
				this.parsed_input += input;
	
				// Reset phone number validation state
				this.valid = false;
	
				// Add digits to the national number
				this.national_number += input;
	
				// Try to format the parsed input
	
				if (this.is_international()) {
					if (!this.country_phone_code) {
						// If one looks at country phone codes
						// then he can notice that no one country phone code
						// is ever a (leftmost) substring of another country phone code.
						// So if a valid country code is extracted so far
						// then it means that this is the country code.
	
						// If no country phone code could be extracted so far,
						// then just return the raw phone number,
						// because it has no way of knowing
						// how to format the phone number so far.
						if (!this.extract_country_phone_code()) {
							// Return raw phone number
							return this.parsed_input;
						}
	
						// Initialize country-specific data
						this.initialize_phone_number_formats_for_this_country_phone_code();
						this.reset_format();
						this.determine_the_country();
					}
					// `this.country` could be `undefined`,
					// for instance, when there is ambiguity
					// in a form of several different countries
					// each corresponding to the same country phone code
					// (e.g. NANPA: USA, Canada, etc),
					// and there's not enough digits entered
					// to reliably determine the country
					// the phone number belongs to.
					// Therefore, in cases of such ambiguity,
					// each time something is input,
					// try to determine the country
					// (if it's not determined yet).
					else if (!this.country) {
							this.determine_the_country();
						}
				} else {
					// Some national prefixes are substrings of other national prefixes
					// (for the same country), therefore try to extract national prefix each time
					// because a longer national prefix might be available at some point in time.
	
					var previous_national_prefix = this.national_prefix;
					this.national_number = this.national_prefix + this.national_number;
	
					// Possibly extract a national prefix
					this.extract_national_prefix();
	
					if (this.national_prefix !== previous_national_prefix) {
						// National number has changed
						// (due to another national prefix been extracted)
						// therefore national number has changed
						// therefore reset all previous formatting data.
						// (and leading digits matching state)
						this.matching_formats = this.available_formats;
						this.reset_format();
					}
				}
	
				// Check the available phone number formats
				// based on the currently available leading digits.
				this.match_formats_by_leading_digits();
	
				// Format the phone number (given the next digits)
				var formatted_national_phone_number = this.format_national_phone_number(input);
	
				// If the phone number could be formatted,
				// then return it, possibly prepending with country phone code
				// (for international phone numbers only)
				if (formatted_national_phone_number) {
					return this.full_phone_number(formatted_national_phone_number);
				}
	
				// If the phone number couldn't be formatted,
				// then just fall back to the raw phone number.
				return this.parsed_input;
			}
		}, {
			key: 'format_national_phone_number',
			value: function format_national_phone_number(next_digits) {
				// Format the next phone number digits
				// using the previously chosen phone number format.
				//
				// This is done here because if `attempt_to_format_complete_phone_number`
				// was placed before this call then the `template`
				// wouldn't reflect the situation correctly (and would therefore be inconsistent)
				//
				var national_number_formatted_with_previous_format = void 0;
				if (this.chosen_format) {
					national_number_formatted_with_previous_format = this.format_next_national_number_digits(next_digits);
				}
	
				// See if the input digits can be formatted properly already. If not,
				// use the results from format_next_national_number_digits(), which does formatting
				// based on the formatting pattern chosen.
	
				var formatted_number = this.attempt_to_format_complete_phone_number();
	
				if (formatted_number) {
					if (this.country) {
						this.valid = true;
					}
	
					return formatted_number;
				}
	
				// If the previously chosen phone number format
				// didn't match the next (current) digit being input
				// (leading digits pattern didn't match).
				if (this.choose_another_format()) {
					// And a more appropriate phone number format
					// has been chosen for these `leading digits`,
					// then format the national phone number (so far)
					// using the newly selected phone number pattern.
	
					// Will return `undefined` if it couldn't format
					// the supplied national number
					// using the selected phone number pattern.
	
					return this.reformat_national_number();
				}
	
				// If could format the next (current) digit
				// using the previously chosen phone number format
				// then return the formatted number so far.
	
				// If no new phone number format could be chosen,
				// and couldn't format the supplied national number
				// using the selected phone number pattern,
				// then it will return `undefined`.
	
				return national_number_formatted_with_previous_format;
			}
		}, {
			key: 'reset',
			value: function reset() {
				// Input stripped of non-phone-number characters.
				// Can only contain a possible leading '+' sign and digits.
				this.parsed_input = '';
	
				this.current_output = '';
	
				// This contains the national prefix that has been extracted. It contains only
				// digits without formatting.
				this.national_prefix = '';
	
				this.national_number = '';
	
				this.reset_countriness();
	
				this.reset_format();
	
				this.valid = false;
	
				return this;
			}
		}, {
			key: 'reset_country',
			value: function reset_country() {
				if (this.default_country && !this.is_international()) {
					this.country = this.default_country;
				} else {
					this.country = undefined;
				}
			}
		}, {
			key: 'reset_countriness',
			value: function reset_countriness() {
				this.reset_country();
	
				if (this.default_country && !this.is_international()) {
					this.country_metadata = this.metadata.countries[this.default_country];
					this.country_phone_code = this.country_metadata.phone_code;
	
					this.initialize_phone_number_formats_for_this_country_phone_code();
				} else {
					this.country_metadata = undefined;
					this.country_phone_code = undefined;
	
					this.available_formats = [];
					this.matching_formats = this.available_formats;
				}
			}
		}, {
			key: 'reset_format',
			value: function reset_format() {
				this.chosen_format = undefined;
				this.template = undefined;
				this.partially_populated_template = undefined;
				this.last_match_position = -1;
			}
	
			// Format each digit of national phone number (so far)
			// using the newly selected phone number pattern.
	
		}, {
			key: 'reformat_national_number',
			value: function reformat_national_number() {
				// Format each digit of national phone number (so far)
				// using the selected phone number pattern.
				return this.format_next_national_number_digits(this.national_number);
			}
		}, {
			key: 'initialize_phone_number_formats_for_this_country_phone_code',
			value: function initialize_phone_number_formats_for_this_country_phone_code() {
				// Get all "eligible" phone number formats for this country
				this.available_formats = (0, _metadata.get_formats)(this.country_metadata).filter(function (format) {
					return ELIGIBLE_FORMAT_PATTERN.test((0, _metadata.get_format_international_format)(format));
				});
	
				this.matching_formats = this.available_formats;
			}
		}, {
			key: 'match_formats_by_leading_digits',
			value: function match_formats_by_leading_digits() {
				var leading_digits = this.national_number;
	
				// "leading digits" patterns start with a maximum 3 digits,
				// and then with each additional digit
				// a more precise "leading digits" pattern is specified.
				// They could make "leading digits" patterns start
				// with a maximum of a single digit, but they didn't,
				// so it's possible that some phone number formats
				// will be falsely rejected until there are at least
				// 3 digits in the national (significant) number being input.
	
				var index_of_leading_digits_pattern = leading_digits.length - MIN_LEADING_DIGITS_LENGTH;
	
				if (index_of_leading_digits_pattern < 0) {
					index_of_leading_digits_pattern = 0;
				}
	
				this.matching_formats = this.get_relevant_phone_number_formats().filter(function (format) {
					var leading_digits_pattern_count = (0, _metadata.get_format_leading_digits_patterns)(format).length;
	
					// Keep everything that isn't restricted by leading digits.
					if (leading_digits_pattern_count === 0) {
						return true;
					}
	
					var leading_digits_pattern_index = Math.min(index_of_leading_digits_pattern, leading_digits_pattern_count - 1);
					var leading_digits_pattern = (0, _metadata.get_format_leading_digits_patterns)(format)[leading_digits_pattern_index];
	
					// Brackets are required for `^` to be applied to
					// all or-ed (`|`) parts, not just the first one.
					return new RegExp('^(' + leading_digits_pattern + ')').test(leading_digits);
				});
	
				// If there was a phone number format chosen
				// and it no longer holds given the new leading digits then reset it
				if (this.chosen_format && this.matching_formats.indexOf(this.chosen_format) === -1) {
					this.reset_format();
				}
			}
		}, {
			key: 'get_relevant_phone_number_formats',
			value: function get_relevant_phone_number_formats() {
				var leading_digits = this.national_number;
	
				// "leading digits" patterns start with a maximum 3 digits,
				// and then with each additional digit
				// a more precise "leading digits" pattern is specified.
				// They could make "leading digits" patterns start
				// with a maximum of a single digit, but they didn't,
				// so it's possible that some phone number formats
				// will be falsely rejected until there are at least
				// 3 digits in the national (significant) number being input.
	
				if (leading_digits.length <= MIN_LEADING_DIGITS_LENGTH) {
					return this.available_formats;
				}
	
				return this.matching_formats;
			}
	
			// Check to see if there is an exact pattern match for these digits. If so, we
			// should use this instead of any other formatting template whose
			// leadingDigitsPattern also matches the input.
	
		}, {
			key: 'attempt_to_format_complete_phone_number',
			value: function attempt_to_format_complete_phone_number() {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = (0, _getIterator3.default)(this.get_relevant_phone_number_formats()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var format = _step.value;
	
						var matcher = new RegExp('^(?:' + (0, _metadata.get_format_pattern)(format) + ')$');
	
						if (!matcher.test(this.national_number)) {
							// If the national prefix is optional
							// then also try to format the phone number
							// without the national prefix being extracted.
							if (this.national_prefix && (0, _metadata.get_format_national_prefix_is_optional_when_formatting)(format, this.country_metadata)) {
								if (!matcher.test(this.national_prefix + this.national_number)) {
									continue;
								}
	
								this.national_number = this.national_prefix + this.national_number;
								this.national_prefix = '';
							}
	
							continue;
						}
	
						if (!this.validate_format(format)) {
							continue;
						}
	
						// To leave the formatter in a consistent state
						this.reset_format();
						this.chosen_format = format;
	
						var formatted_number = (0, _format.format_national_number_using_format)(this.national_number, format, this.is_international(), this.national_prefix.length > 0, this.country_metadata);
	
						// Set `this.template` and `this.partially_populated_template`
						//
						// `else` case doesn't ever happen
						// with the current metadata,
						// but just in case.
						//
						/* istanbul ignore else */
						if (this.create_formatting_template(format)) {
							// Populate `this.partially_populated_template`
							this.reformat_national_number();
						} else {
							var full_number = this.full_phone_number(formatted_number);
	
							this.template = full_number.replace(/[\d\+]/g, DIGIT_PLACEHOLDER);
							this.partially_populated_template = full_number;
						}
	
						return formatted_number;
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			}
	
			// Combines the national number with the appropriate prefix
	
		}, {
			key: 'full_phone_number',
			value: function full_phone_number(formatted_national_number) {
				if (this.is_international()) {
					return '+' + this.country_phone_code + ' ' + formatted_national_number;
				}
	
				return formatted_national_number;
			}
	
			// Extracts the country calling code from the beginning
			// of the entered `national_number` (so far),
			// and places the remaining input into the `national_number`.
	
		}, {
			key: 'extract_country_phone_code',
			value: function extract_country_phone_code() {
				if (!this.national_number) {
					return;
				}
	
				var _parse_phone_number_a = (0, _parse.parse_phone_number_and_country_phone_code)(this.parsed_input, this.metadata),
				    country_phone_code = _parse_phone_number_a.country_phone_code,
				    number = _parse_phone_number_a.number;
	
				if (!country_phone_code) {
					return;
				}
	
				this.country_phone_code = country_phone_code;
				this.national_number = number;
	
				return this.country_metadata = (0, _metadata.get_metadata_by_country_phone_code)(country_phone_code, this.metadata);
			}
		}, {
			key: 'extract_national_prefix',
			value: function extract_national_prefix() {
				this.national_prefix = '';
	
				if (!this.country_metadata) {
					return;
				}
	
				var national_prefix_for_parsing = (0, _metadata.get_national_prefix_for_parsing)(this.country_metadata);
	
				if (!national_prefix_for_parsing) {
					return;
				}
	
				var matches = this.national_number.match(new RegExp('^(?:' + national_prefix_for_parsing + ')'));
	
				// Since some national prefix patterns are entirely optional, check that a
				// national prefix could actually be extracted.
				if (!matches || !matches[0]) {
					return;
				}
	
				var national_number_starts_at = matches[0].length;
	
				this.national_prefix = this.national_number.slice(0, national_number_starts_at);
				this.national_number = this.national_number.slice(national_number_starts_at);
	
				return this.national_prefix;
			}
		}, {
			key: 'choose_another_format',
			value: function choose_another_format() {
				// When there are multiple available formats, the formatter uses the first
				// format where a formatting template could be created.
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = (0, _getIterator3.default)(this.get_relevant_phone_number_formats()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var format = _step2.value;
	
						// If this format is currently being used
						// and is still possible, then stick to it.
						if (this.chosen_format === format) {
							return;
						}
	
						// If this `format` is suitable for "as you type",
						// then extract the template from this format
						// and use it to format the phone number being input.
	
						if (!this.validate_format(format)) {
							continue;
						}
	
						if (!this.create_formatting_template(format)) {
							continue;
						}
	
						this.chosen_format = format;
	
						// With a new formatting template, the matched position
						// using the old template needs to be reset.
						this.last_match_position = -1;
	
						return true;
					}
	
					// No format matches the phone number,
					// therefore set `country` to `undefined`
					// (or to the default country).
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
	
				this.reset_country();
	
				// No format matches the national phone number entered
				this.reset_format();
			}
		}, {
			key: 'validate_format',
			value: function validate_format(format) {
				// If national prefix is mandatory for this phone number format
				// and the user didn't input the national prefix,
				// then this phone number format isn't suitable.
				if (!this.is_international() && !this.national_prefix && (0, _metadata.get_format_national_prefix_is_mandatory_when_formatting)(format, this.country_metadata)) {
					return;
				}
	
				return true;
			}
		}, {
			key: 'create_formatting_template',
			value: function create_formatting_template(format) {
				// The formatter doesn't format numbers when numberPattern contains '|', e.g.
				// (20|3)\d{4}. In those cases we quickly return.
				// (Though there's no such format in current metadata)
				/* istanbul ignore if */
				if ((0, _metadata.get_format_pattern)(format).indexOf('|') >= 0) {
					return;
				}
	
				var national_prefix_formatting_rule = (0, _metadata.get_format_national_prefix_formatting_rule)(format, this.country_metadata);
	
				// A very smart trick by the guys at Google
				var number_pattern = (0, _metadata.get_format_pattern)(format)
				// Replace anything in the form of [..] with \d
				.replace(CHARACTER_CLASS_PATTERN, '\\d')
				// Replace any standalone digit (not the one in `{}`) with \d
				.replace(STANDALONE_DIGIT_PATTERN, '\\d');
	
				// This match will always succeed,
				// because the "longest dummy phone number"
				// has enough length to accomodate any possible
				// national phone number format pattern.
				var dummy_phone_number_matching_format_pattern = LONGEST_DUMMY_PHONE_NUMBER.match(number_pattern)[0];
	
				// If the national number entered is too long
				// for any phone number format, then abort.
				if (this.national_number.length > dummy_phone_number_matching_format_pattern.length) {
					return;
				}
	
				// Now prepare phone number format
				var number_format = this.get_format_format(format);
	
				// If the user did input the national prefix
				// then maybe make it a part of the phone number template
				if (this.national_prefix) {
					var _national_prefix_formatting_rule = (0, _metadata.get_format_national_prefix_formatting_rule)(format, this.country_metadata);
	
					// If national prefix formatting rule is set
					// for this phone number format
					if (_national_prefix_formatting_rule) {
						// Make the national prefix a part of the phone number template
						number_format = number_format.replace(_format.FIRST_GROUP_PATTERN, _national_prefix_formatting_rule);
					}
				}
	
				// Get a formatting template which can be used to efficiently format
				// a partial number where digits are added one by one.
	
				// Create formatting template for this phone number format
				var template = dummy_phone_number_matching_format_pattern
				// Format the dummy phone number according to the format
				.replace(new RegExp(number_pattern, 'g'), number_format)
				// Replace each dummy digit with a DIGIT_PLACEHOLDER
				.replace(DUMMY_DIGIT_MATCHER, DIGIT_PLACEHOLDER);
	
				// This one is for national number only
				this.partially_populated_template = template;
	
				// For convenience, the public `.template` property
				// is gonna contain the whole international number
				// if the phone number being input is international.
				if (this.is_international()) {
					template = DIGIT_PLACEHOLDER + repeat(DIGIT_PLACEHOLDER, this.country_phone_code.length) + ' ' + template;
				}
				// For local numbers, replace national prefix
				// with a digit placeholder.
				else {
						template = template.replace(/\d/g, DIGIT_PLACEHOLDER);
					}
	
				// This one is for the full phone number
				return this.template = template;
			}
		}, {
			key: 'format_next_national_number_digits',
			value: function format_next_national_number_digits(digits) {
				var _iteratorNormalCompletion3 = true;
				var _didIteratorError3 = false;
				var _iteratorError3 = undefined;
	
				try {
					for (var _iterator3 = (0, _getIterator3.default)(digits), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
						var digit = _step3.value;
	
						// If there is room for more digits in current `template`,
						// then set the next digit in the `template`,
						// and return the formatted digits so far.
	
						// If more digits are entered than the current format could handle
						if (this.partially_populated_template.slice(this.last_match_position + 1).search(DIGIT_PLACEHOLDER_MATCHER) === -1) {
							// Reset the current format,
							// so that the new format will be chosen
							// in a subsequent `this.choose_another_format()` call
							// later in code.
							this.chosen_format = undefined;
							this.template = undefined;
							this.partially_populated_template = undefined;
							return;
						}
	
						this.last_match_position = this.partially_populated_template.search(DIGIT_PLACEHOLDER_MATCHER);
						this.partially_populated_template = this.partially_populated_template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
					}
	
					// Return the formatted phone number so far
				} catch (err) {
					_didIteratorError3 = true;
					_iteratorError3 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion3 && _iterator3.return) {
							_iterator3.return();
						}
					} finally {
						if (_didIteratorError3) {
							throw _iteratorError3;
						}
					}
				}
	
				return close_dangling_braces(this.partially_populated_template, this.last_match_position + 1).replace(DIGIT_PLACEHOLDER_MATCHER_GLOBAL, ' ');
			}
		}, {
			key: 'is_international',
			value: function is_international() {
				return this.parsed_input && this.parsed_input[0] === '+';
			}
		}, {
			key: 'get_format_format',
			value: function get_format_format(format) {
				if (this.is_international()) {
					return (0, _format.local_to_international_style)((0, _metadata.get_format_international_format)(format));
				}
	
				return (0, _metadata.get_format_format)(format);
			}
	
			// Determines the country of the phone number
			// entered so far based on the country phone code
			// and the national phone number.
	
		}, {
			key: 'determine_the_country',
			value: function determine_the_country() {
				this.country = (0, _parse.find_country_code)(this.country_phone_code, this.national_number, this.metadata);
			}
		}]);
		return as_you_type;
	}();
	
	exports.default = as_you_type;
	function close_dangling_braces(template, cut_before) {
		var retained_template = template.slice(0, cut_before);
	
		var opening_braces = count_occurences('(', retained_template);
		var closing_braces = count_occurences(')', retained_template);
	
		var dangling_braces = opening_braces - closing_braces;
	
		while (dangling_braces > 0 && cut_before < template.length) {
			if (template[cut_before] === ')') {
				dangling_braces--;
			}
			cut_before++;
		}
	
		return template.slice(0, cut_before);
	}
	
	// Counts all occurences of a symbol in a string
	function count_occurences(symbol, string) {
		var count = 0;
	
		var _iteratorNormalCompletion4 = true;
		var _didIteratorError4 = false;
		var _iteratorError4 = undefined;
	
		try {
			for (var _iterator4 = (0, _getIterator3.default)(string), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
				var character = _step4.value;
	
				if (character === symbol) {
					count++;
				}
			}
		} catch (err) {
			_didIteratorError4 = true;
			_iteratorError4 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion4 && _iterator4.return) {
					_iterator4.return();
				}
			} finally {
				if (_didIteratorError4) {
					throw _iteratorError4;
				}
			}
		}
	
		return count;
	}
	
	// Repeats a string (or a symbol) N times.
	// http://stackoverflow.com/questions/202605/repeat-string-javascript
	function repeat(string, times) {
		if (times < 1) {
			return '';
		}
	
		var result = '';
	
		while (times > 1) {
			if (times & 1) {
				result += string;
			}
	
			times >>= 1;
			string += string;
		}
	
		return result + string;
	}
	//# sourceMappingURL=as you type.js.map

/***/ },
/* 288 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : '[el] D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(700);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 405 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 406 */
12,
/* 407 */
/***/ function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	module.exports = {
	    'default': 'RFC3986',
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return value;
	        }
	    },
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};


/***/ },
/* 408 */
/***/ function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	exports.arrayToObject = function (source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	exports.merge = function (target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        } else if (typeof target === 'object') {
	            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (Array.isArray(target) && !Array.isArray(source)) {
	        mergeTarget = exports.arrayToObject(target, options);
	    }
	
	    if (Array.isArray(target) && Array.isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                if (target[i] && typeof target[i] === 'object') {
	                    target[i] = exports.merge(target[i], item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = exports.merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	exports.assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	exports.decode = function (str) {
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	exports.encode = function (str) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = typeof str === 'string' ? str : String(str);
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D    // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	exports.compact = function (obj, references) {
	    if (typeof obj !== 'object' || obj === null) {
	        return obj;
	    }
	
	    var refs = references || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0; i < obj.length; ++i) {
	            if (obj[i] && typeof obj[i] === 'object') {
	                compacted.push(exports.compact(obj[i], refs));
	            } else if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    keys.forEach(function (key) {
	        obj[key] = exports.compact(obj[key], refs);
	    });
	
	    return obj;
	};
	
	exports.isRegExp = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	exports.isBuffer = function (obj) {
	    if (obj === null || typeof obj === 'undefined') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(50);
	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Applies a function to the value at the given index of an array, returning a
	 * new copy of the array with the element at the given index replaced with the
	 * result of the function application.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig (a -> a) -> Number -> [a] -> [a]
	 * @param {Function} fn The function to apply.
	 * @param {Number} idx The index.
	 * @param {Array|Arguments} list An array-like object whose value
	 *        at the supplied index will be replaced.
	 * @return {Array} A copy of the supplied array-like object with
	 *         the element at index `idx` replaced with the value
	 *         returned by applying `fn` to the existing element.
	 * @see R.update
	 * @example
	 *
	 *      R.adjust(R.add(10), 1, [1, 2, 3]);     //=> [1, 12, 3]
	 *      R.adjust(R.add(10))(1)([1, 2, 3]);     //=> [1, 12, 3]
	 * @symb R.adjust(f, -1, [a, b]) = [a, f(b)]
	 * @symb R.adjust(f, 0, [a, b]) = [f(a), b]
	 */
	module.exports = _curry3(function adjust(fn, idx, list) {
	  if (idx >= list.length || idx < -list.length) {
	    return list;
	  }
	  var start = idx < 0 ? list.length : 0;
	  var _idx = start + idx;
	  var _list = _concat(list);
	  _list[_idx] = fn(list[_idx]);
	  return _list;
	});


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns `true` if both arguments are `true`; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if it is falsy, otherwise the second argument.
	 * @see R.both
	 * @example
	 *
	 *      R.and(true, true); //=> true
	 *      R.and(true, false); //=> false
	 *      R.and(false, true); //=> false
	 *      R.and(false, false); //=> false
	 */
	module.exports = _curry2(function and(a, b) {
	  return a && b;
	});


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _xany = __webpack_require__(437);
	
	
	/**
	 * Returns `true` if at least one of elements of the list match the predicate,
	 * `false` otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
	 *         otherwise.
	 * @see R.all, R.none, R.transduce
	 * @example
	 *
	 *      var lessThan0 = R.flip(R.lt)(0);
	 *      var lessThan2 = R.flip(R.lt)(2);
	 *      R.any(lessThan0)([1, 2]); //=> false
	 *      R.any(lessThan2)([1, 2]); //=> true
	 */
	module.exports = _curry2(_dispatchable(['any'], _xany, function any(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (fn(list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	}));


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Applies function `fn` to the argument list `args`. This is useful for
	 * creating a fixed-arity function from a variadic function. `fn` should be a
	 * bound function if context is significant.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> a) -> [*] -> a
	 * @param {Function} fn The function which will be called with `args`
	 * @param {Array} args The arguments to call `fn` with
	 * @return {*} result The result, equivalent to `fn(...args)`
	 * @see R.call, R.unapply
	 * @example
	 *
	 *      var nums = [1, 2, 3, -99, 42, 6, 7];
	 *      R.apply(Math.max, nums); //=> 42
	 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
	 */
	module.exports = _curry2(function apply(fn, args) {
	  return fn.apply(this, args);
	});


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	var _has = __webpack_require__(39);
	var _isArray = __webpack_require__(71);
	var _isInteger = __webpack_require__(433);
	var assoc = __webpack_require__(144);
	
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the nodes required
	 * to create the given path, and placing the specific value at the tail end of
	 * that path. Note that this copies and flattens prototype properties onto the
	 * new object as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> {a}
	 * @param {Array} path the path to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except along the specified path.
	 * @see R.dissocPath
	 * @example
	 *
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
	 *
	 *      // Any missing or non-object keys in path will be overridden
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
	 */
	module.exports = _curry3(function assocPath(path, val, obj) {
	  if (path.length === 0) {
	    return val;
	  }
	  var idx = path[0];
	  if (path.length > 1) {
	    var nextObj = _has(idx, obj) ? obj[idx] : _isInteger(path[1]) ? [] : {};
	    val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
	  }
	  if (_isInteger(idx) && _isArray(obj)) {
	    var arr = [].concat(obj);
	    arr[idx] = val;
	    return arr;
	  } else {
	    return assoc(idx, val, obj);
	  }
	});


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(55);
	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Creates a function that is bound to a context.
	 * Note: `R.bind` does not provide the additional argument-binding capabilities of
	 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @category Object
	 * @sig (* -> *) -> {*} -> (* -> *)
	 * @param {Function} fn The function to bind to context
	 * @param {Object} thisObj The context to bind `fn` to
	 * @return {Function} A function that will execute in the context of `thisObj`.
	 * @see R.partial
	 * @example
	 *
	 *      var log = R.bind(console.log, console);
	 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
	 *      // logs {a: 2}
	 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
	 */
	module.exports = _curry2(function bind(fn, thisObj) {
	  return _arity(fn.length, function() {
	    return fn.apply(thisObj, arguments);
	  });
	});


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var chain = __webpack_require__(201);
	var compose = __webpack_require__(202);
	var map = __webpack_require__(43);
	
	
	/**
	 * Returns the right-to-left Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.composeK(h, g, f)` is equivalent to `R.compose(R.chain(h), R.chain(g), R.chain(f))`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((y -> m z), (x -> m y), ..., (a -> m b)) -> (a -> m z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipeK
	 * @example
	 *
	 *       //  get :: String -> Object -> Maybe *
	 *       var get = R.curry((propName, obj) => Maybe(obj[propName]))
	 *
	 *       //  getStateCode :: Maybe String -> Maybe String
	 *       var getStateCode = R.composeK(
	 *         R.compose(Maybe.of, R.toUpper),
	 *         get('state'),
	 *         get('address'),
	 *         get('user'),
	 *       );
	 *       getStateCode({"user":{"address":{"state":"ny"}}}); //=> Maybe.Just("NY")
	 *       getStateCode({}); //=> Maybe.Nothing()
	 * @symb R.composeK(f, g, h)(a) = R.chain(f, R.chain(g, h(a)))
	 */
	module.exports = function composeK() {
	  if (arguments.length === 0) {
	    throw new Error('composeK requires at least one argument');
	  }
	  var init = Array.prototype.slice.call(arguments);
	  var last = init.pop();
	  return compose(compose.apply(this, map(chain, init)), last);
	};


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var curry = __webpack_require__(145);
	var nAry = __webpack_require__(154);
	
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type. The arity of the function
	 * returned is specified to allow using variadic constructor functions.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Function
	 * @sig Number -> (* -> {*}) -> (* -> {*})
	 * @param {Number} n The arity of the constructor function.
	 * @param {Function} Fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @example
	 *
	 *      // Variadic Constructor function
	 *      function Salad() {
	 *        this.ingredients = arguments;
	 *      };
	 *      Salad.prototype.recipe = function() {
	 *        var instructions = R.map((ingredient) => (
	 *          'Add a whollop of ' + ingredient, this.ingredients)
	 *        )
	 *        return R.join('\n', instructions)
	 *      }
	 *
	 *      var ThreeLayerSalad = R.constructN(3, Salad)
	 *
	 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
	 *      var salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup')
	 *      console.log(salad.recipe());
	 *      // Add a whollop of Mayonnaise
	 *      // Add a whollop of Potato Chips
	 *      // Add a whollop of Potato Ketchup
	 */
	module.exports = _curry2(function constructN(n, Fn) {
	  if (n > 10) {
	    throw new Error('Constructor with greater than ten arguments');
	  }
	  if (n === 0) {
	    return function() { return new Fn(); };
	  }
	  return curry(nAry(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
	    switch (arguments.length) {
	      case  1: return new Fn($0);
	      case  2: return new Fn($0, $1);
	      case  3: return new Fn($0, $1, $2);
	      case  4: return new Fn($0, $1, $2, $3);
	      case  5: return new Fn($0, $1, $2, $3, $4);
	      case  6: return new Fn($0, $1, $2, $3, $4, $5);
	      case  7: return new Fn($0, $1, $2, $3, $4, $5, $6);
	      case  8: return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
	      case  9: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
	      case 10: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
	    }
	  }));
	});


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _map = __webpack_require__(151);
	var curryN = __webpack_require__(35);
	var max = __webpack_require__(95);
	var pluck = __webpack_require__(115);
	var reduce = __webpack_require__(57);
	
	
	/**
	 * Accepts a converging function and a list of branching functions and returns
	 * a new function. When invoked, this new function is applied to some
	 * arguments, each branching function is applied to those same arguments. The
	 * results of each branching function are passed as arguments to the converging
	 * function to produce the return value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.2
	 * @category Function
	 * @sig (x1 -> x2 -> ... -> z) -> [(a -> b -> ... -> x1), (a -> b -> ... -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} after A function. `after` will be invoked with the return values of
	 *        `fn1` and `fn2` as its arguments.
	 * @param {Array} functions A list of functions.
	 * @return {Function} A new function.
	 * @see R.useWith
	 * @example
	 *
	 *      var average = R.converge(R.divide, [R.sum, R.length])
	 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
	 *
	 *      var strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
	 *      strangeConcat("Yodel") //=> "YODELyodel"
	 *
	 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
	 */
	module.exports = _curry2(function converge(after, fns) {
	  return curryN(reduce(max, 0, pluck('length', fns)), function() {
	    var args = arguments;
	    var context = this;
	    return after.apply(context, _map(function(fn) {
	      return fn.apply(context, args);
	    }, fns));
	  });
	});


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns the second argument if it is not `null`, `undefined` or `NaN`
	 * otherwise the first argument is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {a} default The default value.
	 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
	 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
	 * @example
	 *
	 *      var defaultTo42 = R.defaultTo(42);
	 *
	 *      defaultTo42(null);  //=> 42
	 *      defaultTo42(undefined);  //=> 42
	 *      defaultTo42('Ramda');  //=> 'Ramda'
	 *      // parseInt('string') results in NaN
	 *      defaultTo42(parseInt('string')); //=> 42
	 */
	module.exports = _curry2(function defaultTo(d, v) {
	  return v == null || v !== v ? d : v;
	});


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(81);
	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Objects and Arrays are compared are compared
	 * in terms of value equality, not reference equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith
	 * @example
	 *
	 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
	 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
	 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
	 */
	module.exports = _curry2(function difference(first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  while (idx < firstLen) {
	    if (!_contains(first[idx], second) && !_contains(first[idx], out)) {
	      out[out.length] = first[idx];
	    }
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(207);
	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Duplication is determined according to the
	 * value returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
	 * @example
	 *
	 *      var cmp = (x, y) => x.a === y.a;
	 *      var l1 = [{a: 1}, {a: 2}, {a: 3}];
	 *      var l2 = [{a: 3}, {a: 4}];
	 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
	 */
	module.exports = _curry3(function differenceWith(pred, first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  while (idx < firstLen) {
	    if (!_containsWith(pred, first[idx], second) &&
	        !_containsWith(pred, first[idx], out)) {
	      out.push(first[idx]);
	    }
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns a new object that does not contain a `prop` property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Object
	 * @sig String -> {k: v} -> {k: v}
	 * @param {String} prop The name of the property to dissociate
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original but without the specified property
	 * @see R.assoc
	 * @example
	 *
	 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
	 */
	module.exports = _curry2(function dissoc(prop, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  delete result[prop];
	  return result;
	});


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _xdrop = __webpack_require__(785);
	var slice = __webpack_require__(82);
	
	
	/**
	 * Returns all but the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `drop` method).
	 *
	 * Dispatches to the `drop` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {[a]} list
	 * @return {[a]} A copy of list without the first `n` elements
	 * @see R.take, R.transduce, R.dropLast, R.dropWhile
	 * @example
	 *
	 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(3, 'ramda');               //=> 'da'
	 */
	module.exports = _curry2(_dispatchable(['drop'], _xdrop, function drop(n, xs) {
	  return slice(Math.max(0, n), Infinity, xs);
	}));


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _xdropRepeatsWith = __webpack_require__(438);
	var last = __webpack_require__(442);
	
	
	/**
	 * Returns a new list without any consecutively repeating elements. Equality is
	 * determined by applying the supplied predicate to each pair of consecutive elements. The
	 * first element in a series of equal elements will be preserved.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig (a, a -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
	 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
	 */
	module.exports = _curry2(_dispatchable([], _xdropRepeatsWith, function dropRepeatsWith(pred, list) {
	  var result = [];
	  var idx = 1;
	  var len = list.length;
	  if (len !== 0) {
	    result[0] = list[0];
	    while (idx < len) {
	      if (!pred(last(result), list[idx])) {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	  }
	  return result;
	}));
	


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var _isArguments = __webpack_require__(432);
	var _isArray = __webpack_require__(71);
	var _isObject = __webpack_require__(435);
	var _isString = __webpack_require__(150);
	
	
	/**
	 * Returns the empty value of its argument's type. Ramda defines the empty
	 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
	 * types are supported if they define `<Type>.empty` and/or
	 * `<Type>.prototype.empty`.
	 *
	 * Dispatches to the `empty` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x
	 * @return {*}
	 * @example
	 *
	 *      R.empty(Just(42));      //=> Nothing()
	 *      R.empty([1, 2, 3]);     //=> []
	 *      R.empty('unicorns');    //=> ''
	 *      R.empty({x: 1, y: 2});  //=> {}
	 */
	module.exports = _curry1(function empty(x) {
	  return (
	    (x != null && typeof x.empty === 'function') ?
	      x.empty() :
	    (x != null && x.constructor != null && typeof x.constructor.empty === 'function') ?
	      x.constructor.empty() :
	    _isArray(x) ?
	      [] :
	    _isString(x) ?
	      '' :
	    _isObject(x) ?
	      {} :
	    _isArguments(x) ?
	      (function() { return arguments; }()) :
	    // else
	      void 0
	  );
	});


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns true if its arguments are identical, false otherwise. Values are
	 * identical if they reference the same memory. `NaN` is identical to `NaN`;
	 * `0` and `-0` are not identical.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      var o = {};
	 *      R.identical(o, o); //=> true
	 *      R.identical(1, 1); //=> true
	 *      R.identical(1, '1'); //=> false
	 *      R.identical([], []); //=> false
	 *      R.identical(0, -0); //=> false
	 *      R.identical(NaN, NaN); //=> true
	 */
	module.exports = _curry2(function identical(a, b) {
	  // SameValue algorithm
	  if (a === b) { // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return a !== 0 || 1 / a === 1 / b;
	  } else {
	    // Step 6.a: NaN == NaN
	    return a !== a && b !== b;
	  }
	});


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	var _cloneRegExp = __webpack_require__(427);
	var type = __webpack_require__(212);
	
	
	/**
	 * Copies an object.
	 *
	 * @private
	 * @param {*} value The value to be copied
	 * @param {Array} refFrom Array containing the source references
	 * @param {Array} refTo Array containing the copied source references
	 * @param {Boolean} deep Whether or not to perform deep cloning.
	 * @return {*} The copied value.
	 */
	module.exports = function _clone(value, refFrom, refTo, deep) {
	  var copy = function copy(copiedValue) {
	    var len = refFrom.length;
	    var idx = 0;
	    while (idx < len) {
	      if (value === refFrom[idx]) {
	        return refTo[idx];
	      }
	      idx += 1;
	    }
	    refFrom[idx + 1] = value;
	    refTo[idx + 1] = copiedValue;
	    for (var key in value) {
	      copiedValue[key] = deep ?
	        _clone(value[key], refFrom, refTo, true) : value[key];
	    }
	    return copiedValue;
	  };
	  switch (type(value)) {
	    case 'Object':  return copy({});
	    case 'Array':   return copy([]);
	    case 'Date':    return new Date(value.valueOf());
	    case 'RegExp':  return _cloneRegExp(value);
	    default:        return value;
	  }
	};


/***/ },
/* 427 */
/***/ function(module, exports) {

	module.exports = function _cloneRegExp(pattern) {
	  return new RegExp(pattern.source, (pattern.global     ? 'g' : '') +
	                                    (pattern.ignoreCase ? 'i' : '') +
	                                    (pattern.multiline  ? 'm' : '') +
	                                    (pattern.sticky     ? 'y' : '') +
	                                    (pattern.unicode    ? 'u' : ''));
	};


/***/ },
/* 428 */
/***/ function(module, exports) {

	module.exports = function _complement(f) {
	  return function() {
	    return !f.apply(this, arguments);
	  };
	};


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(55);
	var _curry2 = __webpack_require__(2);
	
	
	module.exports = function _createPartialApplicator(concat) {
	  return _curry2(function(fn, args) {
	    return _arity(Math.max(0, fn.length - args.length), function() {
	      return fn.apply(this, concat(args, arguments));
	    });
	  });
	};


/***/ },
/* 430 */
/***/ function(module, exports) {

	module.exports = function _filter(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	
	  while (idx < len) {
	    if (fn(list[idx])) {
	      result[result.length] = list[idx];
	    }
	    idx += 1;
	  }
	  return result;
	};


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	var equals = __webpack_require__(54);
	
	
	module.exports = function _indexOf(list, a, idx) {
	  var inf, item;
	  // Array.prototype.indexOf doesn't exist below IE9
	  if (typeof list.indexOf === 'function') {
	    switch (typeof a) {
	      case 'number':
	        if (a === 0) {
	          // manually crawl the list to distinguish between +0 and -0
	          inf = 1 / a;
	          while (idx < list.length) {
	            item = list[idx];
	            if (item === 0 && 1 / item === inf) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        } else if (a !== a) {
	          // NaN
	          while (idx < list.length) {
	            item = list[idx];
	            if (typeof item === 'number' && item !== item) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        }
	        // non-zero numbers can utilise Set
	        return list.indexOf(a, idx);
	
	      // all these types can utilise Set
	      case 'string':
	      case 'boolean':
	      case 'function':
	      case 'undefined':
	        return list.indexOf(a, idx);
	
	      case 'object':
	        if (a === null) {
	          // null can utilise Set
	          return list.indexOf(a, idx);
	        }
	    }
	  }
	  // anything else not covered above, defer to R.equals
	  while (idx < list.length) {
	    if (equals(list[idx], a)) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	};


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	var _has = __webpack_require__(39);
	
	
	module.exports = (function() {
	  var toString = Object.prototype.toString;
	  return toString.call(arguments) === '[object Arguments]' ?
	    function _isArguments(x) { return toString.call(x) === '[object Arguments]'; } :
	    function _isArguments(x) { return _has('callee', x); };
	}());


/***/ },
/* 433 */
/***/ function(module, exports) {

	/**
	 * Determine if the passed argument is an integer.
	 *
	 * @private
	 * @param {*} n
	 * @category Type
	 * @return {Boolean}
	 */
	module.exports = Number.isInteger || function _isInteger(n) {
	  return (n << 0) === n;
	};


/***/ },
/* 434 */
/***/ function(module, exports) {

	module.exports = function _isNumber(x) {
	  return Object.prototype.toString.call(x) === '[object Number]';
	};


/***/ },
/* 435 */
/***/ function(module, exports) {

	module.exports = function _isObject(x) {
	  return Object.prototype.toString.call(x) === '[object Object]';
	};


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(112);
	
	
	/**
	 * `_makeFlat` is a helper function that returns a one-level or fully recursive
	 * function based on the flag passed in.
	 *
	 * @private
	 */
	module.exports = function _makeFlat(recursive) {
	  return function flatt(list) {
	    var value, jlen, j;
	    var result = [];
	    var idx = 0;
	    var ilen = list.length;
	
	    while (idx < ilen) {
	      if (isArrayLike(list[idx])) {
	        value = recursive ? flatt(list[idx]) : list[idx];
	        j = 0;
	        jlen = value.length;
	        while (j < jlen) {
	          result[result.length] = value[j];
	          j += 1;
	        }
	      } else {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	    return result;
	  };
	};


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _reduced = __webpack_require__(72);
	var _xfBase = __webpack_require__(27);
	
	
	module.exports = (function() {
	  function XAny(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.any = false;
	  }
	  XAny.prototype['@@transducer/init'] = _xfBase.init;
	  XAny.prototype['@@transducer/result'] = function(result) {
	    if (!this.any) {
	      result = this.xf['@@transducer/step'](result, false);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAny.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.any = true;
	      result = _reduced(this.xf['@@transducer/step'](result, true));
	    }
	    return result;
	  };
	
	  return _curry2(function _xany(f, xf) { return new XAny(f, xf); });
	}());


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _xfBase = __webpack_require__(27);
	
	
	module.exports = (function() {
	  function XDropRepeatsWith(pred, xf) {
	    this.xf = xf;
	    this.pred = pred;
	    this.lastValue = undefined;
	    this.seenFirstValue = false;
	  }
	
	  XDropRepeatsWith.prototype['@@transducer/init'] = _xfBase.init;
	  XDropRepeatsWith.prototype['@@transducer/result'] = _xfBase.result;
	  XDropRepeatsWith.prototype['@@transducer/step'] = function(result, input) {
	    var sameAsLast = false;
	    if (!this.seenFirstValue) {
	      this.seenFirstValue = true;
	    } else if (this.pred(this.lastValue, input)) {
	      sameAsLast = true;
	    }
	    this.lastValue = input;
	    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdropRepeatsWith(pred, xf) { return new XDropRepeatsWith(pred, xf); });
	}());


/***/ },
/* 439 */
/***/ function(module, exports) {

	module.exports = (function() {
	  function XWrap(fn) {
	    this.f = fn;
	  }
	  XWrap.prototype['@@transducer/init'] = function() {
	    throw new Error('init not implemented on XWrap');
	  };
	  XWrap.prototype['@@transducer/result'] = function(acc) { return acc; };
	  XWrap.prototype['@@transducer/step'] = function(acc, x) {
	    return this.f(acc, x);
	  };
	
	  return function _xwrap(fn) { return new XWrap(fn); };
	}());


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * See if an object (`val`) is an instance of the supplied constructor. This
	 * function will check up the inheritance chain, if any.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Type
	 * @sig (* -> {*}) -> a -> Boolean
	 * @param {Object} ctor A constructor
	 * @param {*} val The value to test
	 * @return {Boolean}
	 * @example
	 *
	 *      R.is(Object, {}); //=> true
	 *      R.is(Number, 1); //=> true
	 *      R.is(Object, 1); //=> false
	 *      R.is(String, 's'); //=> true
	 *      R.is(String, new String('')); //=> true
	 *      R.is(Object, new String('')); //=> true
	 *      R.is(Object, 's'); //=> false
	 *      R.is(Number, {}); //=> false
	 */
	module.exports = _curry2(function is(Ctor, val) {
	  return val != null && val.constructor === Ctor || val instanceof Ctor;
	});


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var converge = __webpack_require__(417);
	
	
	/**
	 * juxt applies a list of functions to a list of values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Function
	 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
	 * @param {Array} fns An array of functions
	 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
	 * @see R.applySpec
	 * @example
	 *
	 *      var getRange = R.juxt([Math.min, Math.max]);
	 *      getRange(3, 4, 9, -3); //=> [-3, 9]
	 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
	 */
	module.exports = _curry1(function juxt(fns) {
	  return converge(function() { return Array.prototype.slice.call(arguments, 0); }, fns);
	});


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var nth = __webpack_require__(113);
	
	
	/**
	 * Returns the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.init, R.head, R.tail
	 * @example
	 *
	 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
	 *      R.last([]); //=> undefined
	 *
	 *      R.last('abc'); //=> 'c'
	 *      R.last(''); //=> ''
	 */
	module.exports = nth(-1);


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var _isNumber = __webpack_require__(434);
	
	
	/**
	 * Returns the number of elements in the array by returning `list.length`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [a] -> Number
	 * @param {Array} list The array to inspect.
	 * @return {Number} The length of the array.
	 * @example
	 *
	 *      R.length([]); //=> 0
	 *      R.length([1, 2, 3]); //=> 3
	 */
	module.exports = _curry1(function length(list) {
	  return list != null && _isNumber(list.length) ? list.length : NaN;
	});


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _reduce = __webpack_require__(49);
	var ap = __webpack_require__(200);
	var curryN = __webpack_require__(35);
	var map = __webpack_require__(43);
	
	
	/**
	 * "lifts" a function to be the specified arity, so that it may "map over" that
	 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig Number -> (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.lift, R.ap
	 * @example
	 *
	 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 */
	module.exports = _curry2(function liftN(arity, fn) {
	  var lifted = curryN(arity, fn);
	  return curryN(arity, function() {
	    return _reduce(ap, map(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
	  });
	});


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var sum = __webpack_require__(458);
	
	
	/**
	 * Returns the mean of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @example
	 *
	 *      R.mean([2, 7, 9]); //=> 6
	 *      R.mean([]); //=> NaN
	 */
	module.exports = _curry1(function mean(list) {
	  return sum(list) / list.length;
	});


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	var _has = __webpack_require__(39);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the key
	 * and the values associated with the key in each object, with the result being
	 * used as the value associated with the key in the returned object. The key
	 * will be excluded from the returned object if the resulting value is
	 * `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig (String -> a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.merge, R.mergeWith
	 * @example
	 *
	 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
	 *      R.mergeWithKey(concatValues,
	 *                     { a: true, thing: 'foo', values: [10, 20] },
	 *                     { b: true, thing: 'bar', values: [15, 35] });
	 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
	 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
	 */
	module.exports = _curry3(function mergeWithKey(fn, l, r) {
	  var result = {};
	  var k;
	
	  for (k in l) {
	    if (_has(k, l)) {
	      result[k] = _has(k, r) ? fn(k, l[k], r[k]) : l[k];
	    }
	  }
	
	  for (k in r) {
	    if (_has(k, r) && !(_has(k, result))) {
	      result[k] = r[k];
	    }
	  }
	
	  return result;
	});


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Multiplies two numbers. Equivalent to `a * b` but curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a * b`.
	 * @see R.divide
	 * @example
	 *
	 *      var double = R.multiply(2);
	 *      var triple = R.multiply(3);
	 *      double(3);       //=>  6
	 *      triple(4);       //=> 12
	 *      R.multiply(2, 5);  //=> 10
	 */
	module.exports = _curry2(function multiply(a, b) { return a * b; });


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	
	
	/**
	 * A function that returns the `!` of its argument. It will return `true` when
	 * passed false-y value, and `false` when passed a truth-y one.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig * -> Boolean
	 * @param {*} a any value
	 * @return {Boolean} the logical inverse of passed argument.
	 * @see R.complement
	 * @example
	 *
	 *      R.not(true); //=> false
	 *      R.not(false); //=> true
	 *      R.not(0); //=> true
	 *      R.not(1); //=> false
	 */
	module.exports = _curry1(function not(a) {
	  return !a;
	});


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Creates an object containing a single key:value pair.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @sig String -> a -> {String:a}
	 * @param {String} key
	 * @param {*} val
	 * @return {Object}
	 * @see R.pair
	 * @example
	 *
	 *      var matchPhrases = R.compose(
	 *        R.objOf('must'),
	 *        R.map(R.objOf('match_phrase'))
	 *      );
	 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
	 */
	module.exports = _curry2(function objOf(key, val) {
	  var obj = {};
	  obj[key] = val;
	  return obj;
	});


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns `true` if one or both of its arguments are `true`. Returns `false`
	 * if both arguments are `false`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if truthy, otherwise the second argument.
	 * @see R.either
	 * @example
	 *
	 *      R.or(true, true); //=> true
	 *      R.or(true, false); //=> true
	 *      R.or(false, true); //=> true
	 *      R.or(false, false); //=> false
	 */
	module.exports = _curry2(function or(a, b) {
	  return a || b;
	});


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the result of applying the given function to
	 * the focused value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> (a -> a) -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var headLens = R.lensIndex(0);
	 *
	 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
	 */
	module.exports = (function() {
	  // `Identity` is a functor that holds a single value, where `map` simply
	  // transforms the held value with the provided function.
	  var Identity = function(x) {
	    return {value: x, map: function(f) { return Identity(f(x)); }};
	  };
	
	  return _curry3(function over(lens, f, x) {
	    // The value returned by the getter function is first transformed with `f`,
	    // then set as the value of an `Identity`. This is then mapped over with the
	    // setter function of the lens.
	    return lens(function(y) { return Identity(f(y)); })(x).value;
	  });
	}());


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Similar to `pick` except that this one includes a `key: undefined` pair for
	 * properties that don't exist.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
	 */
	module.exports = _curry2(function pickAll(names, obj) {
	  var result = {};
	  var idx = 0;
	  var len = names.length;
	  while (idx < len) {
	    var name = names[idx];
	    result[name] = obj[name];
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(55);
	var _pipe = __webpack_require__(776);
	var reduce = __webpack_require__(57);
	var tail = __webpack_require__(211);
	
	
	/**
	 * Performs left-to-right function composition. The leftmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * In some libraries this function is named `sequence`.
	 *
	 * **Note:** The result of pipe is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.compose
	 * @example
	 *
	 *      var f = R.pipe(Math.pow, R.negate, R.inc);
	 *
	 *      f(3, 4); // -(3^4) + 1
	 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
	 */
	module.exports = function pipe() {
	  if (arguments.length === 0) {
	    throw new Error('pipe requires at least one argument');
	  }
	  return _arity(arguments[0].length,
	                reduce(_pipe, arguments[0], tail(arguments)));
	};


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(55);
	var _pipeP = __webpack_require__(777);
	var reduce = __webpack_require__(57);
	var tail = __webpack_require__(211);
	
	
	/**
	 * Performs left-to-right composition of one or more Promise-returning
	 * functions. The leftmost function may have any arity; the remaining functions
	 * must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a -> Promise b), (b -> Promise c), ..., (y -> Promise z)) -> (a -> Promise z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.composeP
	 * @example
	 *
	 *      //  followersForUser :: String -> Promise [User]
	 *      var followersForUser = R.pipeP(db.getUserById, db.getFollowers);
	 */
	module.exports = function pipeP() {
	  if (arguments.length === 0) {
	    throw new Error('pipeP requires at least one argument');
	  }
	  return _arity(arguments[0].length,
	                reduce(_pipeP, arguments[0], tail(arguments)));
	};


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(50);
	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns a new list with the given element at the front, followed by the
	 * contents of the list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The item to add to the head of the output list.
	 * @param {Array} list The array to add to the tail of the output list.
	 * @return {Array} A new array.
	 * @see R.append
	 * @example
	 *
	 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
	 */
	module.exports = _curry2(function prepend(el, list) {
	  return _concat([el], list);
	});


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * Similar to `reduce`, except moves through the input list from the right to
	 * the left.
	 *
	 * The iterator function receives two values: *(value, acc)*, while the arguments'
	 * order of `reduce`'s iterator function is *(acc, value)*.
	 *
	 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a, b -> b) -> b -> [a] -> b
	 * @param {Function} fn The iterator function. Receives two values, the current element from the array
	 *        and the accumulator.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.addIndex
	 * @example
	 *
	 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
	 *          -               -2
	 *         / \              / \
	 *        1   -            1   3
	 *           / \              / \
	 *          2   -     ==>    2  -1
	 *             / \              / \
	 *            3   -            3   4
	 *               / \              / \
	 *              4   0            4   0
	 *
	 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
	 */
	module.exports = _curry3(function reduceRight(fn, acc, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    acc = fn(list[idx], acc);
	    idx -= 1;
	  }
	  return acc;
	});


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var ap = __webpack_require__(200);
	var map = __webpack_require__(43);
	var prepend = __webpack_require__(455);
	var reduceRight = __webpack_require__(456);
	
	
	/**
	 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
	 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
	 * Applicative of Traversable.
	 *
	 * Dispatches to the `sequence` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
	 * @param {Function} of
	 * @param {*} traversable
	 * @return {*}
	 * @see R.traverse
	 * @example
	 *
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
	 *
	 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
	 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
	 */
	module.exports = _curry2(function sequence(of, traversable) {
	  return typeof traversable.sequence === 'function' ?
	    traversable.sequence(of) :
	    reduceRight(function(x, acc) { return ap(map(prepend, x), acc); },
	                of([]),
	                traversable);
	});


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	var add = __webpack_require__(143);
	var reduce = __webpack_require__(57);
	
	
	/**
	 * Adds together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The sum of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.sum([2,4,6,8,100,1]); //=> 121
	 */
	module.exports = reduce(add, 0);


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _xtake = __webpack_require__(796);
	var slice = __webpack_require__(82);
	
	
	/**
	 * Returns the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `take` method).
	 *
	 * Dispatches to the `take` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {*} list
	 * @return {*}
	 * @see R.drop
	 * @example
	 *
	 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(3, 'ramda');               //=> 'ram'
	 *
	 *      var personnel = [
	 *        'Dave Brubeck',
	 *        'Paul Desmond',
	 *        'Eugene Wright',
	 *        'Joe Morello',
	 *        'Gerry Mulligan',
	 *        'Bob Bates',
	 *        'Joe Dodge',
	 *        'Ron Crotty'
	 *      ];
	 *
	 *      var takeFive = R.take(5);
	 *      takeFive(personnel);
	 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
	 * @symb R.take(-1, [a, b]) = [a, b]
	 * @symb R.take(0, [a, b]) = []
	 * @symb R.take(1, [a, b]) = [a]
	 * @symb R.take(2, [a, b]) = [a, b]
	 */
	module.exports = _curry2(_dispatchable(['take'], _xtake, function take(n, xs) {
	  return slice(0, n < 0 ? Infinity : n, xs);
	}));


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Calls an input function `n` times, returning an array containing the results
	 * of those function calls.
	 *
	 * `fn` is passed one argument: The current value of `n`, which begins at `0`
	 * and is gradually incremented to `n - 1`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.3
	 * @category List
	 * @sig (Number -> a) -> Number -> [a]
	 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
	 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
	 * @return {Array} An array containing the return values of all calls to `fn`.
	 * @example
	 *
	 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
	 * @symb R.times(f, 0) = []
	 * @symb R.times(f, 1) = [f(0)]
	 * @symb R.times(f, 2) = [f(0), f(1)]
	 */
	module.exports = _curry2(function times(fn, n) {
	  var len = Number(n);
	  var idx = 0;
	  var list;
	
	  if (len < 0 || isNaN(len)) {
	    throw new RangeError('n must be a non-negative number');
	  }
	  list = new Array(len);
	  while (idx < len) {
	    list[idx] = fn(idx);
	    idx += 1;
	  }
	  return list;
	});


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	var _Set = __webpack_require__(764);
	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied function to
	 * each list element. Prefers the first item if the supplied function produces
	 * the same value on two items. `R.equals` is used for comparison.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> b) -> [a] -> [a]
	 * @param {Function} fn A function used to produce a value to use during comparisons.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
	 */
	module.exports = _curry2(function uniqBy(fn, list) {
	  var set = new _Set();
	  var result = [];
	  var idx = 0;
	  var appliedItem, item;
	
	  while (idx < list.length) {
	    item = list[idx];
	    appliedItem = fn(item);
	    if (set.add(appliedItem)) {
	      result.push(item);
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	var adjust = __webpack_require__(409);
	var always = __webpack_require__(94);
	
	
	/**
	 * Returns a new copy of the array with the element at the provided index
	 * replaced with the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} idx The index to update.
	 * @param {*} x The value to exist at the given index of the returned array.
	 * @param {Array|Arguments} list The source array-like object to be updated.
	 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
	 * @see R.adjust
	 * @example
	 *
	 *      R.update(1, 11, [0, 1, 2]);     //=> [0, 11, 2]
	 *      R.update(1)(11)([0, 1, 2]);     //=> [0, 11, 2]
	 * @symb R.update(-1, a, [b, c]) = [b, a]
	 * @symb R.update(0, a, [b, c]) = [a, c]
	 * @symb R.update(1, a, [b, c]) = [b, a]
	 */
	module.exports = _curry3(function update(idx, x, list) {
	  return adjust(always(x), idx, list);
	});


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var curryN = __webpack_require__(35);
	
	
	/**
	 * Accepts a function `fn` and a list of transformer functions and returns a
	 * new curried function. When the new function is invoked, it calls the
	 * function `fn` with parameters consisting of the result of calling each
	 * supplied handler on successive arguments to the new function.
	 *
	 * If more arguments are passed to the returned function than transformer
	 * functions, those arguments are passed directly to `fn` as additional
	 * parameters. If you expect additional arguments that don't need to be
	 * transformed, although you can ignore them, it's best to pass an identity
	 * function so that the new function reports the correct arity.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (x1 -> x2 -> ... -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} fn The function to wrap.
	 * @param {Array} transformers A list of transformer functions
	 * @return {Function} The wrapped function.
	 * @see R.converge
	 * @example
	 *
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
	 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
	 */
	module.exports = _curry2(function useWith(fn, transformers) {
	  return curryN(transformers.length, function() {
	    var args = [];
	    var idx = 0;
	    while (idx < transformers.length) {
	      args.push(transformers[idx].call(this, arguments[idx]));
	      idx += 1;
	    }
	    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
	  });
	});


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var keys = __webpack_require__(56);
	
	
	/**
	 * Returns a list of all the enumerable own properties of the supplied object.
	 * Note that the order of the output array is not guaranteed across different
	 * JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own properties.
	 * @example
	 *
	 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
	 */
	module.exports = _curry1(function values(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var vals = [];
	  var idx = 0;
	  while (idx < len) {
	    vals[idx] = obj[props[idx]];
	    idx += 1;
	  }
	  return vals;
	});


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _has = __webpack_require__(39);
	
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec. Each of the spec's own properties must be a predicate function.
	 * Each predicate is applied to the value of the corresponding property of the
	 * test object. `where` returns true if all the predicates return true, false
	 * otherwise.
	 *
	 * `where` is well suited to declaratively expressing constraints for other
	 * functions such as `filter` and `find`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Object
	 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      var pred = R.where({
	 *        a: R.equals('foo'),
	 *        b: R.complement(R.equals('bar')),
	 *        x: R.gt(__, 10),
	 *        y: R.lt(__, 20)
	 *      });
	 *
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
	 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
	 */
	module.exports = _curry2(function where(spec, testObj) {
	  for (var prop in spec) {
	    if (_has(prop, spec) && !spec[prop](testObj[prop])) {
	      return false;
	    }
	  }
	  return true;
	});


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDaysInMonthView = exports.getWeekendStartDay = exports.getWeekStartMoment = exports.getWeekStartDay = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactFlex = __webpack_require__(41);
	
	var _format = __webpack_require__(914);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _toMoment = __webpack_require__(33);
	
	var _toMoment2 = _interopRequireDefault(_toMoment);
	
	var _getWeekDayNames = __webpack_require__(915);
	
	var _getWeekDayNames2 = _interopRequireDefault(_getWeekDayNames);
	
	var _join = __webpack_require__(32);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _bemFactory = __webpack_require__(84);
	
	var _bemFactory2 = _interopRequireDefault(_bemFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var CLASS_NAME = 'react-date-picker__basic-month-view';
	
	var RENDER_DAY = function RENDER_DAY(props) {
	  var divProps = (0, _objectAssign2.default)({}, props);
	
	  delete divProps.date;
	  delete divProps.dateMoment;
	  delete divProps.day;
	  delete divProps.timestamp;
	
	  return _react2.default.createElement('div', divProps);
	};
	
	var getWeekStartDay = function getWeekStartDay(props) {
	  var locale = props.locale;
	  var weekStartDay = props.weekStartDay;
	
	  if (weekStartDay == null) {
	    var localeData = props.localeData || _moment2.default.localeData(locale);
	    weekStartDay = localeData._week ? localeData._week.dow : null;
	  }
	
	  return weekStartDay;
	};
	
	/**
	 * Gets the number for the first day of the weekend
	 *
	 * @param  {Object} props
	 * @param  {Number/String} props.weekStartDay
	 *
	 * @return {Number}
	 */
	var getWeekendStartDay = function getWeekendStartDay(props) {
	  var weekendStartDay = props.weekendStartDay;
	
	
	  if (weekendStartDay == null) {
	    return getWeekStartDay(props) + 5 % 7;
	  }
	
	  return weekendStartDay;
	};
	
	/**
	 * Gets a moment that points to the first day of the week
	 *
	 * @param  {Moment/Date/String} value]
	 * @param  {Object} props
	 * @param  {String} props.dateFormat
	 * @param  {String} props.locale
	 * @param  {Number/String} props.weekStartDay
	 *
	 * @return {Moment}
	 */
	var getWeekStartMoment = function getWeekStartMoment(value, props) {
	  var locale = props.locale;
	  var dateFormat = props.dateFormat;
	
	  var weekStartDay = getWeekStartDay(props);
	
	  return (0, _toMoment2.default)(value, {
	    locale: locale,
	    dateFormat: dateFormat
	  }).day(weekStartDay);
	};
	
	/**
	 * Returns an array of moments with the days in the month of the value
	 *
	 * @param  {Moment/Date/String} value
	 *
	 * @param  {Object} props
	 * @param  {String} props.locale
	 * @param  {String} props.dateFormat
	 * @param  {String} props.weekStartDay
	 * @param  {Boolean} props.alwaysShowPrevWeek
	 *
	 * @return {Moment[]}
	 */
	var getDaysInMonthView = function getDaysInMonthView(value, props) {
	  var locale = props.locale;
	  var dateFormat = props.dateFormat;
	
	  var toMomentParam = { locale: locale, dateFormat: dateFormat };
	
	  var first = (0, _toMoment2.default)(value, toMomentParam).startOf('month');
	  var beforeFirst = (0, _toMoment2.default)(value, toMomentParam).startOf('month').add(-1, 'days');
	
	  var start = getWeekStartMoment(first, props);
	
	  var result = [];
	
	  var i = 0;
	
	  if (beforeFirst.isBefore(start)
	  // and it doesn't start with a full week before and the
	  // week has at least 1 day from current month (default)
	   && (props.alwaysShowPrevWeek || !start.isSame(first))) {
	    start.add(-1, 'weeks');
	  }
	
	  for (; i < 42; i++) {
	    result.push((0, _toMoment2.default)(start, toMomentParam));
	    start.add(1, 'days');
	  }
	
	  return result;
	};
	
	/**
	 * @param  {Object} props
	 * @param  {String} props.locale
	 * @param  {Number} props.weekStartDay
	 * @param  {Array/Function} props.weekDayNames
	 *
	 * @return {String[]}
	 */
	var getWeekDayNames = function getWeekDayNames(props) {
	  var weekStartDay = props.weekStartDay;
	  var weekDayNames = props.weekDayNames;
	  var locale = props.locale;
	
	
	  var names = weekDayNames;
	
	  if (typeof names == 'function') {
	    names = names(weekStartDay, locale);
	  } else if (Array.isArray(names)) {
	    names = [].concat(_toConsumableArray(names));
	
	    var index = weekStartDay;
	
	    while (index > 0) {
	      names.push(names.shift());
	      index--;
	    }
	  }
	
	  return names;
	};
	
	var BasicMonthView = function (_Component) {
	  _inherits(BasicMonthView, _Component);
	
	  function BasicMonthView() {
	    _classCallCheck(this, BasicMonthView);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(BasicMonthView).apply(this, arguments));
	  }
	
	  _createClass(BasicMonthView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateBem(this.props);
	      this.updateToMoment(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.defaultClassName != this.props.defaultClassName) {
	        this.updateBem(nextProps);
	      }
	
	      this.updateToMoment(nextProps);
	    }
	  }, {
	    key: 'updateBem',
	    value: function updateBem(props) {
	      this.bem = (0, _bemFactory2.default)(props.defaultClassName);
	    }
	  }, {
	    key: 'updateToMoment',
	    value: function updateToMoment(props) {
	      this.toMoment = function (value, dateFormat) {
	        return (0, _toMoment2.default)(value, {
	          locale: props.locale,
	          dateFormat: dateFormat || props.dateFormat
	        });
	      };
	    }
	  }, {
	    key: 'prepareProps',
	    value: function prepareProps(thisProps) {
	      var props = (0, _objectAssign2.default)({}, thisProps);
	
	      props.viewMoment = props.viewMoment || this.toMoment(props.viewDate);
	
	      props.weekStartDay = getWeekStartDay(props);
	
	      props.className = this.prepareClassName(props);
	
	      return props;
	    }
	  }, {
	    key: 'prepareClassName',
	    value: function prepareClassName(props) {
	      return (0, _join2.default)(props.className, CLASS_NAME + ' dp-month-view');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = this.p = this.prepareProps(this.props);
	
	      var viewMoment = props.viewMoment;
	
	
	      var daysInView = props.daysInView || getDaysInMonthView(viewMoment, props);
	
	      var children = [this.renderWeekDayNames(), this.renderDays(props, daysInView)];
	
	      if (props.renderChildren) {
	        children = props.renderChildren(children, props);
	      }
	
	      var flexProps = (0, _objectAssign2.default)({}, props);
	
	      delete flexProps.alwaysShowPrevWeek;
	      delete flexProps.cleanup;
	      delete flexProps.dateFormat;
	      delete flexProps.daysInView;
	      delete flexProps.defaultClassName;
	      delete flexProps.defaultDate;
	      delete flexProps.defaultValue;
	      delete flexProps.forceValidDate;
	      delete flexProps.locale;
	      delete flexProps.moment;
	      delete flexProps.onClockEnterKey;
	      delete flexProps.onClockEscapeKey;
	      delete flexProps.onClockInputBlur;
	      delete flexProps.onClockInputFocus;
	      delete flexProps.onClockInputMouseDown;
	      delete flexProps.onFooterCancelClick;
	      delete flexProps.onFooterClearClick;
	      delete flexProps.onFooterOkClick;
	      delete flexProps.onFooterTodayClick;
	      delete flexProps.onRenderDay;
	      delete flexProps.renderChildren;
	      delete flexProps.renderDay;
	      delete flexProps.timestamp;
	      delete flexProps.value;
	      delete flexProps.viewDate;
	      delete flexProps.viewMoment;
	      delete flexProps.weekDayNames;
	      delete flexProps.weekNumbers;
	      delete flexProps.weekNumberName;
	      delete flexProps.weekStartDay;
	
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(flexProps);
	      }
	
	      return _react2.default.createElement(_reactFlex.Flex, _extends({
	        column: true,
	        wrap: false,
	        inline: true,
	        alignItems: 'stretch'
	      }, flexProps, {
	
	        children: children
	      }));
	    }
	
	    /**
	     * Render the week number cell
	     * @param  {Moment[]} days The days in a week
	     * @return {React.DOM}
	     */
	
	  }, {
	    key: 'renderWeekNumber',
	    value: function renderWeekNumber(props, days) {
	      var firstDayOfWeek = days[0];
	      var week = firstDayOfWeek.weeks();
	
	      var weekNumberProps = {
	        key: 'week',
	
	        className: this.bem('cell') + ' ' + this.bem('week-number') + ' dp-cell dp-weeknumber',
	
	        // week number
	        week: week,
	
	        // the days in this week
	        days: days,
	
	        date: firstDayOfWeek,
	
	        children: week
	      };
	
	      var renderWeekNumber = props.renderWeekNumber;
	
	      var result = void 0;
	
	      if (renderWeekNumber) {
	        result = renderWeekNumber(weekNumberProps);
	      }
	
	      if (result === undefined) {
	        var divProps = (0, _objectAssign2.default)({}, weekNumberProps);
	
	        delete divProps.date;
	        delete divProps.days;
	        delete divProps.week;
	
	        result = _react2.default.createElement('div', divProps);
	      }
	
	      return result;
	    }
	
	    /**
	     * Render the given array of days
	     * @param  {Moment[]} days
	     *
	     * @return {React.DOM}
	     */
	
	  }, {
	    key: 'renderDays',
	    value: function renderDays(props, days) {
	      var _this2 = this;
	
	      var nodes = days.map(function (date) {
	        return _this2.renderDay(props, date);
	      });
	
	      var len = days.length;
	      var buckets = [];
	      var bucketsLen = Math.ceil(len / 7);
	
	      var i = 0;
	      var weekStart = void 0;
	      var weekEnd = void 0;
	
	      for (; i < bucketsLen; i++) {
	        weekStart = i * 7;
	        weekEnd = (i + 1) * 7;
	
	        buckets.push([props.weekNumbers && this.renderWeekNumber(props, days.slice(weekStart, weekEnd))].concat(nodes.slice(weekStart, weekEnd)));
	      }
	
	      return buckets.map(function (bucket, index) {
	        return _react2.default.createElement('div', {
	          key: 'row_' + index,
	          className: _this2.bem('row') + ' dp-week dp-row',
	          children: bucket
	        });
	      });
	    }
	  }, {
	    key: 'renderDay',
	    value: function renderDay(props, dateMoment) {
	      var dayText = _format2.default.day(dateMoment, props.dayFormat);
	
	      var classes = [this.bem('cell'), this.bem('day'), 'dp-cell dp-day'];
	
	      var renderDayProps = {
	        day: dayText,
	        dateMoment: dateMoment,
	        timestamp: +dateMoment,
	
	        key: dayText,
	        className: classes.join(' '),
	        children: dayText
	      };
	
	      if (typeof props.onRenderDay === 'function') {
	        renderDayProps = props.onRenderDay(renderDayProps);
	      }
	
	      var renderFunction = props.renderDay || RENDER_DAY;
	
	      var result = renderFunction(renderDayProps);
	
	      if (result === undefined) {
	        result = RENDER_DAY(renderDayProps);
	      }
	
	      return result;
	    }
	  }, {
	    key: 'renderWeekDayNames',
	    value: function renderWeekDayNames() {
	      var _this3 = this;
	
	      var props = this.p;
	      var weekNumbers = props.weekNumbers;
	      var weekNumberName = props.weekNumberName;
	      var weekDayNames = props.weekDayNames;
	      var renderWeekDayNames = props.renderWeekDayNames;
	      var renderWeekDayName = props.renderWeekDayName;
	      var weekStartDay = props.weekStartDay;
	
	
	      if (weekDayNames === false) {
	        return null;
	      }
	
	      var names = weekNumbers ? [weekNumberName].concat(getWeekDayNames(props)) : getWeekDayNames(props);
	
	      var className = this.bem('row') + ' ' + this.bem('week-day-names') + ' dp-row dp-week-day-names';
	
	      var renderProps = {
	        className: className,
	        names: names
	      };
	
	      if (renderWeekDayNames) {
	        return renderWeekDayNames(renderProps);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        names.map(function (name, index) {
	          var props = {
	            weekStartDay: weekStartDay,
	            index: index,
	            name: name,
	
	            key: index,
	            className: _this3.bem('cell') + ' ' + _this3.bem('week-day-name') + ' dp-week-day-name',
	            children: name
	          };
	
	          if (renderWeekDayName) {
	            return renderWeekDayName(props);
	          }
	
	          var divProps = (0, _objectAssign2.default)({}, props);
	
	          delete divProps.index;
	          delete divProps.weekStartDay;
	          delete divProps.name;
	
	          return _react2.default.createElement('div', divProps);
	        })
	      );
	    }
	  }]);
	
	  return BasicMonthView;
	}(_reactClass2.default);
	
	BasicMonthView.propTypes = {
	  viewDate: _react.PropTypes.any,
	  viewMoment: _react.PropTypes.any,
	
	  locale: _react.PropTypes.string,
	  weekStartDay: _react.PropTypes.number, // 0 is Sunday in the English locale
	
	  // boolean prop to show/hide week numbers
	  weekNumbers: _react.PropTypes.bool,
	
	  // the name to give to the week number column
	  weekNumberName: _react.PropTypes.string,
	
	  weekDayNames: function weekDayNames(props, propName) {
	    var value = props[propName];
	
	    if (typeof value != 'function' && value !== false && !Array.isArray(value)) {
	      return new Error('"weekDayNames" should be a function, an array or the boolean "false"');
	    }
	
	    return undefined;
	  },
	
	
	  renderWeekDayNames: _react.PropTypes.func,
	  renderWeekDayName: _react.PropTypes.func,
	
	  renderWeekNumber: _react.PropTypes.func,
	  renderDay: _react.PropTypes.func,
	  onRenderDay: _react.PropTypes.func,
	
	  alwaysShowPrevWeek: _react.PropTypes.bool
	};
	
	BasicMonthView.defaultProps = {
	
	  defaultClassName: CLASS_NAME,
	
	  dateFormat: 'YYYY-MM-DD',
	  alwaysShowPrevWeek: false,
	  weekNumbers: true,
	  weekNumberName: null,
	
	  weekDayNames: _getWeekDayNames2.default
	};
	
	exports.default = BasicMonthView;
	exports.getWeekStartDay = getWeekStartDay;
	exports.getWeekStartMoment = getWeekStartMoment;
	exports.getWeekendStartDay = getWeekendStartDay;
	exports.getDaysInMonthView = getDaysInMonthView;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NAV_KEYS = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _assignDefined = __webpack_require__(83);
	
	var _assignDefined2 = _interopRequireDefault(_assignDefined);
	
	var _MonthView = __webpack_require__(159);
	
	var _MonthView2 = _interopRequireDefault(_MonthView);
	
	var _toMoment = __webpack_require__(33);
	
	var _toMoment2 = _interopRequireDefault(_toMoment);
	
	var _join = __webpack_require__(32);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _ClockInput = __webpack_require__(468);
	
	var _ClockInput2 = _interopRequireDefault(_ClockInput);
	
	var _forwardTime = __webpack_require__(161);
	
	var _forwardTime2 = _interopRequireDefault(_forwardTime);
	
	var _reactFlex = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Calendar = function (_Component) {
	  _inherits(Calendar, _Component);
	
	  function Calendar(props) {
	    _classCallCheck(this, Calendar);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Calendar).call(this, props));
	
	    _this.state = {
	      timeFocused: false
	    };
	    return _this;
	  }
	
	  _createClass(Calendar, [{
	    key: 'prepareDate',
	    value: function prepareDate(props) {
	      return (0, _toMoment2.default)(props.date, props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var props = this.p = (0, _objectAssign2.default)({}, this.props);
	      var dateFormat = props.dateFormat.toLowerCase();
	
	      props.date = this.prepareDate(props);
	      if (props.showClock === undefined) {
	        props.showClock = dateFormat.indexOf('k') != -1 || dateFormat.indexOf('h') != -1;
	      }
	
	      var timeFormat = dateFormat.substring(dateFormat.toLowerCase().indexOf('hh'));
	
	      props.timeFormat = timeFormat;
	
	      var className = (0, _join2.default)(props.className, 'react-date-picker__calendar', props.theme && 'react-date-picker__calendar--theme-' + props.theme);
	
	      var monthViewProps = (0, _objectAssign2.default)({}, this.props);
	
	      delete monthViewProps.onTimeChange;
	      delete monthViewProps.showClock;
	      delete monthViewProps.updateOnWheel;
	      delete monthViewProps.wrapTime;
	
	      if (typeof this.props.cleanup == 'function') {
	        this.props.cleanup(monthViewProps);
	      }
	
	      var monthView = _react2.default.createElement(_MonthView2.default, _extends({}, monthViewProps, {
	        onChange: this.onChange,
	        className: null,
	        style: null,
	        ref: function ref(view) {
	          _this2.view = view;
	        },
	        renderChildren: this.renderChildren
	      }));
	
	      return _react2.default.createElement(
	        _reactFlex.Flex,
	        { inline: true, row: true, wrap: false, className: className, style: props.style },
	        monthView
	      );
	    }
	  }, {
	    key: 'isHistoryViewVisible',
	    value: function isHistoryViewVisible() {
	      if (this.view && this.view.isHistoryViewVisible) {
	        return this.view.isHistoryViewVisible();
	      }
	
	      return false;
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren(_ref) {
	      var _ref2 = _slicedToArray(_ref, 3);
	
	      var navBar = _ref2[0];
	      var inner = _ref2[1];
	      var footer = _ref2[2];
	
	      var props = this.p;
	      var clockInput = props.showClock && this.renderClockInput();
	
	      var children = [navBar, _react2.default.createElement(
	        _reactFlex.Flex,
	        { justifyContent: 'center', wrap: this.props.wrap || this.props.wrapTime },
	        _react2.default.createElement(_reactFlex.Flex, {
	          flexGrow: '1',
	          flexShrink: '0',
	          flexBasis: 'auto',
	          column: true,
	          wrap: false,
	          alignItems: 'stretch',
	          children: inner
	        }),
	        clockInput
	      ), footer];
	
	      return _react2.default.createElement(_reactFlex.Flex, {
	        column: true,
	        wrap: false,
	        alignItems: 'stretch',
	        children: children
	      });
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.view) {
	        this.view.focus();
	      }
	    }
	  }, {
	    key: 'isFocused',
	    value: function isFocused() {
	      if (this.view) {
	        return this.view.isFocused();
	      }
	
	      return false;
	    }
	  }, {
	    key: 'onViewKeyDown',
	    value: function onViewKeyDown() {
	      if (this.view) {
	        var _view;
	
	        (_view = this.view).onViewKeyDown.apply(_view, arguments);
	      }
	    }
	  }, {
	    key: 'isTimeInputFocused',
	    value: function isTimeInputFocused() {
	      return this.state.timeFocused;
	    }
	  }, {
	    key: 'renderClockInput',
	    value: function renderClockInput() {
	      var _this3 = this,
	          _clockInputProps;
	
	      var clockInput = null;
	
	      var readOnly = this.props.readOnly;
	
	      var clockInputProps = (_clockInputProps = {
	        ref: function ref(clkInput) {
	          _this3.clockInput = clkInput;
	        },
	        viewIndex: this.props.viewIndex,
	        dateFormat: this.p.dateFormat
	      }, _defineProperty(_clockInputProps, readOnly ? 'value' : 'defaultValue', this.p.date), _defineProperty(_clockInputProps, 'onFocus', this.onClockInputFocus), _defineProperty(_clockInputProps, 'onBlur', this.onClockInputBlur), _defineProperty(_clockInputProps, 'onChange', this.onTimeChange), _defineProperty(_clockInputProps, 'onMouseDown', this.onClockInputMouseDown), _clockInputProps);
	
	      (0, _assignDefined2.default)(clockInputProps, {
	        onEnterKey: this.props.onClockEnterKey,
	        onEscapeKey: this.props.onClockEscapeKey,
	        readOnly: readOnly,
	        tabIndex: readOnly ? null : this.props.clockTabIndex,
	        theme: this.props.theme,
	        updateOnWheel: this.props.updateOnWheel
	      });
	
	      if (clockInput) {
	        return _react2.default.cloneElement(clockInput, clockInputProps);
	      }
	
	      return _react2.default.createElement(_ClockInput2.default, clockInputProps);
	    }
	  }, {
	    key: 'onClockInputFocus',
	    value: function onClockInputFocus() {
	      this.setState({
	        timeFocused: true
	      });
	
	      this.props.onClockInputFocus();
	    }
	  }, {
	    key: 'onClockInputBlur',
	    value: function onClockInputBlur() {
	      this.setState({
	        timeFocused: false
	      });
	
	      this.props.onClockInputBlur();
	    }
	  }, {
	    key: 'onClockInputMouseDown',
	    value: function onClockInputMouseDown(event) {
	      event.stopPropagation();
	      if (event.target && event.target.type != 'text') {
	        // in order not to blur - in case we're in a date field
	        event.preventDefault();
	      }
	
	      this.clockInput.focus();
	    }
	  }, {
	    key: 'onTimeChange',
	    value: function onTimeChange(value, timeFormat) {
	      this.time = value;
	      this.props.onTimeChange(value, timeFormat);
	
	      var view = this.view;
	      var moment = view.p.moment;
	
	      if (moment == null) {
	        return;
	      }
	
	      view.onChange({
	        dateMoment: moment,
	        timestamp: +moment
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(dateString, _ref3, event) {
	      var dateMoment = _ref3.dateMoment;
	      var timestamp = _ref3.timestamp;
	
	      var props = this.p;
	
	      if (props.showClock) {
	        var time = (0, _toMoment2.default)(this.time || this.clockInput.getValue(), {
	          dateFormat: props.timeFormat,
	          locale: props.locale
	        });
	
	        (0, _forwardTime2.default)(time, dateMoment);
	        timestamp = +dateMoment;
	        dateString = this.view.format(dateMoment);
	      }
	
	      if (this.props.onChange) {
	        this.props.onChange(dateString, { dateMoment: dateMoment, timestamp: timestamp, dateString: dateString }, event);
	      }
	    }
	  }]);
	
	  return Calendar;
	}(_reactClass2.default);
	
	exports.default = Calendar;
	
	
	Calendar.defaultProps = {
	  dateFormat: 'YYYY-MM-DD',
	
	  theme: 'default',
	
	  isDatePicker: true,
	  wrapTime: false,
	
	  onTimeChange: function onTimeChange() {},
	
	  onClockEnterKey: function onClockEnterKey() {},
	  onClockInputBlur: function onClockInputBlur() {},
	  onClockInputFocus: function onClockInputFocus() {},
	
	  onFooterTodayClick: function onFooterTodayClick() {},
	  onFooterCancelClick: function onFooterCancelClick() {},
	  onFooterClearClick: function onFooterClearClick() {},
	  onFooterOkClick: function onFooterOkClick() {}
	};
	
	Calendar.propTypes = {};
	
	exports.NAV_KEYS = _MonthView.NAV_KEYS;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _lodash = __webpack_require__(288);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactFlex = __webpack_require__(41);
	
	var _join = __webpack_require__(32);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _toMoment = __webpack_require__(33);
	
	var _toMoment2 = _interopRequireDefault(_toMoment);
	
	var _Clock = __webpack_require__(158);
	
	var _Clock2 = _interopRequireDefault(_Clock);
	
	var _DateFormatSpinnerInput = __webpack_require__(469);
	
	var _DateFormatSpinnerInput2 = _interopRequireDefault(_DateFormatSpinnerInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClockInput = function (_Component) {
	  _inherits(ClockInput, _Component);
	
	  function ClockInput(props) {
	    _classCallCheck(this, ClockInput);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ClockInput).call(this, props));
	
	    var delay = props.changeDelay;
	    _this.throttleSetValue = delay == -1 ? _this.setValue : (0, _lodash2.default)(_this.setValue, delay);
	
	    _this.state = {
	      value: props.defaultValue || Date.now()
	    };
	    return _this;
	  }
	
	  _createClass(ClockInput, [{
	    key: 'getValue',
	    value: function getValue() {
	      return this.value;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	      var format = props.dateFormat || props.format;
	
	      var dateFormat = format.substring(format.toLowerCase().indexOf('hh'));
	
	      this.dateFormat = dateFormat;
	
	      this.value = props.value !== undefined ? props.value : this.state.value;
	
	      var className = (0, _join2.default)(props.className, 'react-date-picker__clock-input', props.theme && 'react-date-picker__clock-input--theme-' + props.theme);
	
	      var flexProps = (0, _objectAssign2.default)({}, this.props);
	
	      delete flexProps.changeDelay;
	      delete flexProps.cleanup;
	      delete flexProps.dateFormat;
	      delete flexProps.isClockInput;
	      delete flexProps.onEnterKey;
	      delete flexProps.onEscapeKey;
	      delete flexProps.onTimeChange;
	      delete flexProps.updateOnWheel;
	      delete flexProps.theme;
	      delete flexProps.viewIndex;
	      delete flexProps.wrapTime;
	
	      if (typeof this.props.cleanup == 'function') {
	        this.props.cleanup(flexProps);
	      }
	
	      return _react2.default.createElement(
	        _reactFlex.Flex,
	        _extends({
	          column: true
	        }, flexProps, {
	          value: null,
	          defaultValue: null,
	          className: className
	        }),
	        this.renderClock(),
	        this.renderTimeInput()
	      );
	    }
	  }, {
	    key: 'renderTimeInput',
	    value: function renderTimeInput() {
	      var _this2 = this;
	
	      var props = this.props;
	      var dateInput = _react2.default.Children.toArray(props.children).filter(function (child) {
	        return child && child.props && child.props.isDateInput;
	      })[0];
	
	      var dateInputProps = (0, _objectAssign2.default)({}, this.props, {
	        ref: function ref(field) {
	          _this2.field = field;
	        },
	        tabIndex: props.readOnly ? -1 : props.tabIndex || 0,
	        readOnly: props.readOnly,
	        value: this.value,
	        dateFormat: this.dateFormat,
	        onChange: this.onChange,
	        onKeyDown: this.onKeyDown,
	        size: props.size || this.dateFormat.length + 2
	      });
	
	      if (dateInput) {
	        return _react2.default.cloneElement(dateInput, dateInputProps);
	      }
	
	      return _react2.default.createElement(_DateFormatSpinnerInput2.default, _extends({}, dateInputProps, { style: null }));
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.field) {
	        this.field.focus();
	      }
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(event) {
	      if (this.props.onEnterKey && event.key == 'Enter') {
	        this.props.onEnterKey(event);
	      }
	
	      if (this.props.onEscapeKey && event.key == 'Escape') {
	        this.props.onEscapeKey(event);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(value) {
	      if (this.props.value === undefined) {
	        this.setState({
	          value: value
	        });
	      }
	
	      if (this.props.onChange) {
	        this.throttleSetValue(value);
	      }
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      if (this.props.value === undefined) {
	        this.setState({
	          value: value
	        });
	      }
	
	      if (this.props.onChange) {
	        this.props.onChange(value, this.dateFormat);
	      }
	    }
	  }, {
	    key: 'renderClock',
	    value: function renderClock() {
	      var props = this.props;
	      var clock = _react2.default.Children.toArray(props.children).filter(function (child) {
	        return child && child.props && child.props.isDatePickerClock;
	      })[0];
	
	      var dateFormat = this.dateFormat;
	      var time = (0, _toMoment2.default)(this.value, { dateFormat: dateFormat });
	
	      var clockProps = {
	        time: time,
	        theme: props.theme,
	        showMinutesHand: dateFormat.indexOf('mm') != -1,
	        showSecondsHand: dateFormat.indexOf('ss') != -1
	      };
	
	      if (clock) {
	        return _react2.default.cloneElement(clock, clockProps);
	      }
	
	      return _react2.default.createElement(_Clock2.default, clockProps);
	    }
	  }]);
	
	  return ClockInput;
	}(_reactClass2.default);
	
	exports.default = ClockInput;
	
	
	ClockInput.defaultProps = {
	  changeDelay: 50,
	
	  dateFormat: 'YYYY-MM-DD',
	  updateOnWheel: true,
	
	  theme: 'default',
	
	  wrapTime: false,
	  isClockInput: true,
	
	  onTimeChange: function onTimeChange() {}
	};
	
	ClockInput.propTypes = {};

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _reactFlex = __webpack_require__(41);
	
	var _DateFormatInput = __webpack_require__(215);
	
	var _DateFormatInput2 = _interopRequireDefault(_DateFormatInput);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _joinFunctions = __webpack_require__(117);
	
	var _joinFunctions2 = _interopRequireDefault(_joinFunctions);
	
	var _assignDefined = __webpack_require__(83);
	
	var _assignDefined2 = _interopRequireDefault(_assignDefined);
	
	var _join = __webpack_require__(32);
	
	var _join2 = _interopRequireDefault(_join);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateFormatSpinnerInput = function (_Component) {
	  _inherits(DateFormatSpinnerInput, _Component);
	
	  function DateFormatSpinnerInput(props) {
	    _classCallCheck(this, DateFormatSpinnerInput);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DateFormatSpinnerInput).call(this, props));
	
	    _this.state = {
	      focused: false
	    };
	    return _this;
	  }
	
	  _createClass(DateFormatSpinnerInput, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.started = false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var props = this.props;
	      var children = _react2.default.Children.toArray(props.children);
	
	      var input = this.inputChild = children.filter(function (c) {
	        return c && c.type == 'input';
	      })[0];
	      var inputProps = input ? (0, _objectAssign2.default)({}, input.props) : {};
	
	      var onKeyDown = (0, _joinFunctions2.default)(props.onKeyDown, inputProps.onKeyDown);
	      var onChange = (0, _joinFunctions2.default)(props.onChange, inputProps.onChange);
	      var disabled = props.disabled || inputProps.disabled;
	
	      (0, _assignDefined2.default)(inputProps, {
	        size: props.size || inputProps.size,
	        minDate: props.minDate || inputProps.minDate,
	        maxDate: props.maxDate || inputProps.maxDate,
	
	        changeDelay: props.changeDelay === undefined ? inputProps.changeDelay : props.changeDelay,
	
	        tabIndex: props.tabIndex,
	
	        onKeyDown: onKeyDown,
	        onChange: onChange,
	        disabled: disabled,
	
	        dateFormat: props.dateFormat === undefined ? inputProps.dateFormat : props.dateFormat,
	        stopPropagation: props.stopPropagation,
	        updateOnWheel: props.updateOnWheel,
	
	        onBlur: this.onBlur,
	        onFocus: this.onFocus
	      });
	
	      this.inputProps = inputProps;
	
	      var arrowSize = this.props.arrowSize;
	
	      this.arrows = {
	        1: _react2.default.createElement(
	          'svg',
	          { height: arrowSize, viewBox: '0 0 24 24', width: arrowSize },
	          _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
	        ),
	
	        '-1': _react2.default.createElement(
	          'svg',
	          { height: arrowSize, viewBox: '0 0 24 24', width: arrowSize },
	          _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
	        )
	      };
	
	      var className = (0, _join2.default)(props.className, 'react-date-picker__date-format-spinner', disabled && 'react-date-picker__date-format-spinner--disabled', this.isFocused() && 'react-date-picker__date-format-spinner--focused', 'react-date-picker__date-format-spinner--theme-' + props.theme);
	
	      return _react2.default.createElement(
	        _reactFlex.Flex,
	        {
	          inline: true,
	          row: true,
	          className: className,
	          disabled: props.disabled
	        },
	        _react2.default.createElement(_DateFormatInput2.default, _extends({
	          ref: function ref(inputDOM) {
	            _this2.input = inputDOM;
	          },
	          value: props.value
	        }, inputProps)),
	        this.renderArrows()
	      );
	    }
	  }, {
	    key: 'renderArrows',
	    value: function renderArrows() {
	      if (this.props.renderArrows) {
	        return this.props.renderArrows(this.props);
	      }
	
	      return _react2.default.createElement(
	        _reactFlex.Flex,
	        {
	          column: true,
	          inline: true
	        },
	        this.renderArrow(1),
	        this.renderArrow(-1)
	      );
	    }
	  }, {
	    key: 'renderArrow',
	    value: function renderArrow(dir) {
	      return _react2.default.createElement(
	        _reactFlex.Item,
	        {
	          flexShrink: 1,
	          className: 'react-date-picker__date-format-spinner-arrow',
	          style: { overflow: 'hidden', height: this.props.arrowSize },
	          onMouseDown: this.onMouseDown.bind(this, dir),
	          onMouseUp: this.stop,
	          onMouseLeave: this.stop
	        },
	        this.arrows[dir]
	      );
	    }
	  }, {
	    key: 'onMouseDown',
	    value: function onMouseDown(dir, event) {
	      var _this3 = this;
	
	      if (this.props.disabled) {
	        event.preventDefault();
	        return;
	      }
	
	      event.preventDefault();
	      if (this.isFocused()) {
	        this.start(dir);
	      } else {
	        this.focus();
	
	        setTimeout(function () {
	          _this3.increment(dir);
	        }, 1);
	      }
	    }
	  }, {
	    key: 'start',
	    value: function start(dir) {
	      var _this4 = this;
	
	      this.started = true;
	      this.startTime = Date.now();
	
	      this.step(dir);
	
	      this.timeoutId = setTimeout(function () {
	        _this4.step(dir);
	
	        _this4.timeoutId = setTimeout(function () {
	          var lazyStep = function lazyStep() {
	            var delay = _this4.props.stepDelay - (Date.now() - _this4.startTime) / 500;
	            _this4.step(dir, lazyStep, delay);
	          };
	
	          lazyStep();
	        }, _this4.props.secondStepDelay);
	      }, this.props.firstStepDelay);
	    }
	  }, {
	    key: 'isStarted',
	    value: function isStarted() {
	      return !!(this.started && this.input);
	    }
	  }, {
	    key: 'increment',
	    value: function increment(dir) {
	      this.input.onDirection(dir);
	    }
	  }, {
	    key: 'step',
	    value: function step(dir, callback, delay) {
	      var _this5 = this;
	
	      if (this.isStarted()) {
	        this.increment(dir);
	
	        if (typeof callback == 'function') {
	          this.timeoutId = setTimeout(function () {
	            if (_this5.isStarted()) {
	              callback();
	            }
	          }, delay === undefined ? this.props.stepDelay : delay);
	        }
	      }
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.started = false;
	      if (this.timeoutId) {
	        global.clearTimeout(this.timeoutId);
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.input) {
	        this.input.focus();
	      }
	    }
	  }, {
	    key: 'isFocused',
	    value: function isFocused() {
	      return this.state.focused;
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(event) {
	      var props = this.props;
	
	      var onBlur = (0, _joinFunctions2.default)(props.onBlur, this.inputChild && this.inputChild.props && this.inputChild.props.onBlur);
	
	      if (onBlur) {
	        onBlur(event);
	      }
	
	      this.setState({
	        focused: false
	      });
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(event) {
	      var props = this.props;
	
	      var onFocus = (0, _joinFunctions2.default)(props.onFocus, this.inputChild && this.inputChild.props && this.inputChild.props.onFocus);
	
	      if (onFocus) {
	        onFocus(event);
	      }
	
	      this.setState({
	        focused: true
	      });
	    }
	  }]);
	
	  return DateFormatSpinnerInput;
	}(_reactClass2.default);
	
	exports.default = DateFormatSpinnerInput;
	
	
	DateFormatSpinnerInput.defaultProps = {
	  firstStepDelay: 150,
	  secondStepDelay: 100,
	  stepDelay: 50,
	
	  changeDelay: undefined,
	
	  theme: 'default',
	
	  disabled: false,
	  arrowSize: 15,
	  isDateInput: true,
	  stopPropagation: true,
	  updateOnWheel: true
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactFlex = __webpack_require__(41);
	
	var _toMoment2 = __webpack_require__(33);
	
	var _toMoment3 = _interopRequireDefault(_toMoment2);
	
	var _join = __webpack_require__(32);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _joinFunctions = __webpack_require__(117);
	
	var _joinFunctions2 = _interopRequireDefault(_joinFunctions);
	
	var _bemFactory = __webpack_require__(84);
	
	var _bemFactory2 = _interopRequireDefault(_bemFactory);
	
	var _Footer = __webpack_require__(217);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _YearView = __webpack_require__(474);
	
	var _YearView2 = _interopRequireDefault(_YearView);
	
	var _assignDefined = __webpack_require__(83);
	
	var _assignDefined2 = _interopRequireDefault(_assignDefined);
	
	var _DecadeView = __webpack_require__(216);
	
	var _DecadeView2 = _interopRequireDefault(_DecadeView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var bem = (0, _bemFactory2.default)('react-date-picker__history-view');
	
	var preventDefault = function preventDefault(e) {
	  e.preventDefault();
	};
	
	var HistoryView = function (_Component) {
	  _inherits(HistoryView, _Component);
	
	  function HistoryView(props) {
	    _classCallCheck(this, HistoryView);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(HistoryView).call(this, props));
	
	    _this.state = (0, _DecadeView.getInitialState)(props);
	    return _this;
	  }
	
	  _createClass(HistoryView, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unmounted = true;
	    }
	  }, {
	    key: 'toMoment',
	    value: function toMoment(date, format) {
	      return (0, _toMoment3.default)(date, format, this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var dateProps = (0, _DecadeView.prepareDateProps)(this.props, this.state);
	
	      var props = this.p = (0, _objectAssign2.default)({}, this.props, dateProps);
	
	      props.children = _react2.default.Children.toArray(props.children);
	
	      var className = (0, _join2.default)(props.className, bem(), props.theme && bem(null, 'theme-' + props.theme));
	
	      var commonProps = (0, _assignDefined2.default)({}, {
	        locale: props.locale,
	        theme: props.theme,
	        minDate: props.minDate,
	        maxDate: props.maxDate,
	
	        viewDate: props.viewMoment,
	        activeDate: props.activeDate,
	        date: props.date,
	
	        dateFormat: props.dateFormat
	      });
	
	      var yearViewProps = (0, _objectAssign2.default)({}, commonProps);
	
	      var decadeViewProps = (0, _objectAssign2.default)({}, commonProps, {
	        ref: function ref(view) {
	          _this2.decadeView = view;
	        }
	      });
	
	      var flexProps = (0, _objectAssign2.default)({}, this.props);
	
	      delete flexProps.activeDate;
	      delete flexProps.adjustDateStartOf;
	      delete flexProps.adjustMaxDateStartOf;
	      delete flexProps.adjustMinDateStartOf;
	
	      delete flexProps.cleanup;
	
	      delete flexProps.date;
	      delete flexProps.dateFormat;
	      delete flexProps.defaultDate;
	      delete flexProps.defaultViewDate;
	
	      delete flexProps.focusDecadeView;
	      delete flexProps.focusYearView;
	      delete flexProps.footer;
	
	      delete flexProps.locale;
	
	      delete flexProps.maxDate;
	      delete flexProps.minDate;
	
	      delete flexProps.onOkClick;
	      delete flexProps.onCancelClick;
	      delete flexProps.okOnEnter;
	
	      delete flexProps.navigation;
	
	      delete flexProps.theme;
	
	      delete flexProps.viewMoment;
	
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(flexProps);
	      }
	
	      return _react2.default.createElement(
	        _reactFlex.Flex,
	        _extends({
	          inline: true,
	          column: true,
	          alignItems: 'stretch'
	        }, flexProps, {
	          className: className
	        }),
	        this.renderYearView(yearViewProps),
	        this.renderDecadeView(decadeViewProps),
	        this.renderFooter()
	      );
	    }
	  }, {
	    key: 'renderFooter',
	    value: function renderFooter() {
	      var props = this.p;
	      var children = props.children;
	
	      if (!props.footer) {
	        return null;
	      }
	
	      var footerChild = children.filter(function (c) {
	        return c && c.props && c.props.isDatePickerFooter;
	      })[0];
	
	      if (footerChild) {
	        var newFooterProps = {
	          onOkClick: (0, _joinFunctions2.default)(this.onOkClick, footerChild.props.onOkClick),
	          onCancelClick: (0, _joinFunctions2.default)(this.onCancelClick, footerChild.props.onCancelClick)
	        };
	
	        if (footerChild.props.centerButtons === undefined) {
	          newFooterProps.centerButtons = true;
	        }
	        if (footerChild.props.todayButton === undefined) {
	          newFooterProps.todayButton = false;
	        }
	        if (footerChild.props.clearButton === undefined) {
	          newFooterProps.clearButton = false;
	        }
	
	        return _react2.default.cloneElement(footerChild, newFooterProps);
	      }
	
	      return _react2.default.createElement(_Footer2.default, {
	        todayButton: false,
	        clearButton: false,
	        onOkClick: this.onOkClick,
	        onCancelClick: this.onCancelClick,
	        centerButtons: true
	      });
	    }
	  }, {
	    key: 'onOkClick',
	    value: function onOkClick() {
	      if (this.props.onOkClick) {
	        var dateMoment = this.p.activeMoment;
	        var dateString = this.format(dateMoment);
	        var timestamp = +dateMoment;
	
	        this.props.onOkClick(dateString, { dateMoment: dateMoment, timestamp: timestamp });
	      }
	    }
	  }, {
	    key: 'onCancelClick',
	    value: function onCancelClick() {
	      if (this.props.onCancelClick) {
	        this.props.onCancelClick();
	      }
	    }
	  }, {
	    key: 'renderYearView',
	    value: function renderYearView(yearViewProps) {
	      var props = this.p;
	      var children = props.children;
	
	      var yearViewChild = children.filter(function (c) {
	        return c && c.props && c.props.isYearView;
	      })[0];
	      var yearViewChildProps = yearViewChild ? yearViewChild.props : {};
	
	      var tabIndex = yearViewChildProps.tabIndex == null ? null : yearViewChildProps.tabIndex;
	
	      yearViewProps.tabIndex = tabIndex;
	
	      if (props.focusYearView === false || tabIndex == null) {
	        yearViewProps.tabIndex = null;
	        yearViewProps.onFocus = this.onYearViewFocus;
	        yearViewProps.onMouseDown = this.onYearViewMouseDown;
	      }
	
	      (0, _objectAssign2.default)(yearViewProps, {
	        // viewDate: props.moment || props.viewDate,
	        onViewDateChange: (0, _joinFunctions2.default)(this.onViewDateChange, yearViewChildProps.onViewDateChange),
	        onActiveDateChange: (0, _joinFunctions2.default)(this.onActiveDateChange, yearViewChildProps.onActiveDateChange),
	        onChange: (0, _joinFunctions2.default)(this.handleYearViewOnChange, yearViewChildProps.onChange)
	      });
	
	      if (yearViewChild) {
	        return _react2.default.cloneElement(yearViewChild, yearViewProps);
	      }
	
	      return _react2.default.createElement(_YearView2.default, yearViewProps);
	    }
	  }, {
	    key: 'renderDecadeView',
	    value: function renderDecadeView(decadeViewProps) {
	      var props = this.p;
	      var children = props.children;
	      var decadeViewChild = children.filter(function (c) {
	        return c && c.props && c.props.isDecadeView;
	      })[0];
	
	      var decadeViewChildProps = decadeViewChild ? decadeViewChild.props : {};
	
	      var tabIndex = decadeViewChildProps.tabIndex == null ? null : decadeViewChildProps.tabIndex;
	
	      decadeViewProps.tabIndex = tabIndex;
	
	      if (props.focusDecadeView === false || tabIndex == null) {
	        decadeViewProps.tabIndex = null;
	        decadeViewProps.onMouseDown = this.onDecadeViewMouseDown;
	      }
	
	      (0, _objectAssign2.default)(decadeViewProps, {
	        onConfirm: (0, _joinFunctions2.default)(this.handleDecadeViewOnConfirm, decadeViewChildProps.onConfirm),
	        onViewDateChange: (0, _joinFunctions2.default)(this.handleDecadeOnViewDateChange, decadeViewChildProps.onViewDateChange),
	        onActiveDateChange: (0, _joinFunctions2.default)(this.handleDecadeOnActiveDateChange, decadeViewChildProps.onActiveDateChange),
	        onChange: (0, _joinFunctions2.default)(this.handleDecadeOnChange, decadeViewChildProps.onChange)
	      });
	
	      if (decadeViewChild) {
	        return _react2.default.cloneElement(decadeViewChild, decadeViewProps);
	      }
	
	      return _react2.default.createElement(_DecadeView2.default, decadeViewProps);
	    }
	  }, {
	    key: 'onYearViewFocus',
	    value: function onYearViewFocus() {
	      if (this.props.focusYearView === false) {
	        this.focus();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.decadeView && this.props.focusDecadeView) {
	        this.decadeView.focus();
	      }
	    }
	  }, {
	    key: 'onYearViewMouseDown',
	    value: function onYearViewMouseDown(e) {
	      preventDefault(e);
	
	      this.focus();
	    }
	  }, {
	    key: 'onDecadeViewMouseDown',
	    value: function onDecadeViewMouseDown(e) {
	      preventDefault(e);
	    }
	  }, {
	    key: 'format',
	    value: function format(mom, _format) {
	      _format = _format || this.props.dateFormat;
	
	      return mom.format(_format);
	    }
	  }, {
	    key: 'handleDecadeViewOnConfirm',
	    value: function handleDecadeViewOnConfirm() {
	      if (this.props.okOnEnter) {
	        this.onOkClick();
	      }
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(event) {
	      if (event.key == 'Escape') {
	        return this.onCancelClick();
	      }
	
	      if (this.decadeView) {
	        this.decadeView.onKeyDown(event);
	      }
	
	      return undefined;
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm(date, event) {
	      return _DecadeView.confirm.call(this, date, event);
	    }
	  }, {
	    key: 'navigate',
	    value: function navigate(direction, event) {
	      return _DecadeView.navigate.call(this, direction, event);
	    }
	  }, {
	    key: 'select',
	    value: function select(_ref, event) {
	      var dateMoment = _ref.dateMoment;
	      var timestamp = _ref.timestamp;
	
	      return _DecadeView.select.call(this, { dateMoment: dateMoment, timestamp: timestamp }, event);
	    }
	  }, {
	    key: 'handleDecadeOnViewDateChange',
	    value: function handleDecadeOnViewDateChange(dateString, _ref2) {
	      var dateMoment = _ref2.dateMoment;
	      var timestamp = _ref2.timestamp;
	
	      var props = this.p;
	      var currentViewMoment = props.viewMoment;
	
	      if (currentViewMoment) {
	        dateMoment.set('month', currentViewMoment.get('month'));
	        dateString = this.format(dateMoment);
	        timestamp = +dateMoment;
	      }
	
	      this.onViewDateChange(dateString, { dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }, {
	    key: 'handleDecadeOnActiveDateChange',
	    value: function handleDecadeOnActiveDateChange(dateString, _ref3) {
	      var dateMoment = _ref3.dateMoment;
	      var timestamp = _ref3.timestamp;
	
	      var props = this.p;
	      var currentViewMoment = props.viewMoment;
	
	      if (currentViewMoment) {
	        dateMoment.set('month', currentViewMoment.get('month'));
	        dateString = this.format(dateMoment);
	        timestamp = +dateMoment;
	      }
	
	      this.onActiveDateChange(dateString, { dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }, {
	    key: 'handleDecadeOnChange',
	    value: function handleDecadeOnChange(dateString, _ref4, event) {
	      var dateMoment = _ref4.dateMoment;
	      var timestamp = _ref4.timestamp;
	
	      var props = this.p;
	      var currentViewMoment = props.viewMoment;
	
	      if (currentViewMoment) {
	        dateMoment.set('month', currentViewMoment.get('month'));
	        dateString = this.format(dateMoment);
	        timestamp = +dateMoment;
	      }
	
	      this.onChange(dateString, { dateMoment: dateMoment, timestamp: timestamp }, event);
	    }
	  }, {
	    key: 'handleYearViewOnChange',
	    value: function handleYearViewOnChange(dateString, _ref5, event) {
	      var dateMoment = _ref5.dateMoment;
	      var timestamp = _ref5.timestamp;
	
	      var props = this.p;
	      var currentMoment = props.moment;
	
	      if (currentMoment) {
	        dateMoment.set('year', currentMoment.get('year'));
	        dateString = this.format(dateMoment);
	        timestamp = +dateMoment;
	      }
	
	      this.onChange(dateString, { dateMoment: dateMoment, timestamp: timestamp }, event);
	    }
	  }, {
	    key: 'onViewDateChange',
	    value: function onViewDateChange(dateString, _ref6) {
	      var dateMoment = _ref6.dateMoment;
	      var timestamp = _ref6.timestamp;
	
	      return _DecadeView.onViewDateChange.call(this, { dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }, {
	    key: 'gotoViewDate',
	    value: function gotoViewDate(_ref7) {
	      var dateMoment = _ref7.dateMoment;
	      var timestamp = _ref7.timestamp;
	
	      return _DecadeView.gotoViewDate.call(this, { dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }, {
	    key: 'onActiveDateChange',
	    value: function onActiveDateChange(dateString, _ref8) {
	      var dateMoment = _ref8.dateMoment;
	      var timestamp = _ref8.timestamp;
	
	      return _DecadeView.onActiveDateChange.call(this, { dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(dateString, _ref9, event) {
	      var dateMoment = _ref9.dateMoment;
	      var timestamp = _ref9.timestamp;
	
	      return _DecadeView.onChange.call(this, { dateMoment: dateMoment, timestamp: timestamp }, event);
	    }
	  }]);
	
	  return HistoryView;
	}(_reactClass2.default);
	
	exports.default = HistoryView;
	
	
	HistoryView.defaultProps = {
	  okOnEnter: true,
	
	  footer: true,
	  theme: 'default',
	  navigation: true,
	
	  focusYearView: false,
	  focusDecadeView: true,
	
	  dateFormat: 'YYYY-MM-DD',
	
	  adjustDateStartOf: 'month',
	  adjustMinDateStartOf: 'month',
	  adjustMaxDateStartOf: 'month'
	};

/***/ },
/* 471 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  ArrowUp: -7,
	  ArrowDown: 7,
	  ArrowLeft: -1,
	  ArrowRight: 1,
	
	  PageUp: function PageUp(mom) {
	    return mom.add(-1, 'month');
	  },
	  PageDown: function PageDown(mom) {
	    return mom.add(1, 'month');
	  },
	  Home: function Home(mom) {
	    return mom.startOf('month');
	  },
	  End: function End(mom) {
	    return mom.endOf('month');
	  }
	};

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (event) {
	  var key = event.key;
	
	  if (this.props.onKeyDown) {
	    if (this.props.onKeyDown(event) === false) {
	      return;
	    }
	  }
	
	  if (key == 'Enter' && this.p.activeDate) {
	    this.confirm(this.p.activeDate, event);
	  }
	
	  var navKeys = this.p.navKeys || _navKeys2.default;
	  var dir = navKeys[key];
	
	  if (!dir) {
	    return;
	  }
	
	  event.preventDefault();
	  this.navigate(dir, event);
	};
	
	var _navKeys = __webpack_require__(471);
	
	var _navKeys2 = _interopRequireDefault(_navKeys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _leftPad = __webpack_require__(219);
	
	var _leftPad2 = _interopRequireDefault(_leftPad);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var value = _ref.value;
	  var _ref$separator = _ref.separator;
	  var separator = _ref$separator === undefined ? ':' : _ref$separator;
	  var meridiem = _ref.meridiem;
	
	  var parts = value.split(separator);
	
	  var hours = parts[0];
	  var minutes = parts[1];
	  var seconds = parts[2];
	
	  var result = { hours: hours, minutes: minutes };
	
	  if (typeof seconds == 'string' && seconds.length) {
	    result.seconds = seconds;
	  }
	
	  if (meridiem && seconds !== undefined && seconds * 1 != seconds) {
	    result.seconds = (0, _leftPad2.default)(parseInt(seconds, 10));
	  }
	
	  if (meridiem && seconds === undefined && minutes * 1 != minutes) {
	    result.minutes = (0, _leftPad2.default)(parseInt(minutes, 10));
	  }
	
	  if (meridiem) {
	    (function () {
	      var meridiems = ['am', 'AM', 'pm', 'PM'];
	      var indexes = meridiems.map(function (m) {
	        return (seconds || minutes).indexOf(m);
	      });
	
	      indexes.forEach(function (indexOf, i) {
	        if (indexOf != -1) {
	          result.meridiem = meridiems[i];
	        }
	      });
	    })();
	  }
	
	  return result;
	};

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(58);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _times = __webpack_require__(162);
	
	var _times2 = _interopRequireDefault(_times);
	
	var _join = __webpack_require__(32);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _toMoment2 = __webpack_require__(33);
	
	var _toMoment3 = _interopRequireDefault(_toMoment2);
	
	var _reactFlex = __webpack_require__(41);
	
	var _bemFactory = __webpack_require__(84);
	
	var _bemFactory2 = _interopRequireDefault(_bemFactory);
	
	var _DecadeView = __webpack_require__(216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var bem = (0, _bemFactory2.default)('react-date-picker__year-view');
	
	var NAV_KEYS = {
	  ArrowUp: function ArrowUp(mom) {
	    if (mom.get('month') >= 4) {
	      mom.add(-4, 'month');
	    }
	
	    return mom;
	  },
	  ArrowDown: function ArrowDown(mom) {
	    if (mom.get('month') <= 7) {
	      mom.add(4, 'month');
	    }
	
	    return mom;
	  },
	  ArrowLeft: function ArrowLeft(mom) {
	    if (mom.get('month') >= 1) {
	      mom.add(-1, 'month');
	    }
	
	    return mom;
	  },
	  ArrowRight: function ArrowRight(mom) {
	    if (mom.get('month') <= 10) {
	      mom.add(1, 'month');
	    }
	
	    return mom;
	  },
	  Home: function Home(mom) {
	    return mom.startOf('year').startOf('month');
	  },
	  End: function End(mom) {
	    return mom.endOf('year').startOf('month');
	  },
	  PageUp: function PageUp(mom) {
	    var month = mom.get('month') - 4;
	    var extra4 = month - 4;
	
	    if (month >= 0) {
	      if (extra4 >= 0) {
	        return mom.set('month', extra4);
	      }
	
	      return mom.set('month', month);
	    }
	
	    return mom;
	  },
	  PageDown: function PageDown(mom) {
	    var month = mom.get('month') + 4;
	    var extra4 = month + 4;
	
	    if (month <= 11) {
	      if (extra4 <= 11) {
	        return mom.set('month', extra4);
	      }
	
	      return mom.set('month', month);
	    }
	
	    return mom;
	  }
	};
	
	var YearView = function (_Component) {
	  _inherits(YearView, _Component);
	
	  function YearView(props) {
	    _classCallCheck(this, YearView);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(YearView).call(this, props));
	
	    _this.state = (0, _DecadeView.getInitialState)(props);
	    return _this;
	  }
	
	  /**
	   * Returns all the days in the specified month.
	   *
	   * @param  {Moment/Date/Number} value
	   * @return {Moment[]}
	   */
	
	
	  _createClass(YearView, [{
	    key: 'getMonthsInYear',
	    value: function getMonthsInYear(value) {
	      var _this2 = this;
	
	      var start = this.toMoment(value).startOf('year');
	
	      return (0, _times2.default)(12).map(function (i) {
	        return _this2.toMoment(start).add(i, 'month');
	      });
	    }
	  }, {
	    key: 'toMoment',
	    value: function toMoment(date) {
	      return (0, _toMoment3.default)(date, this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = this.p = (0, _objectAssign2.default)({}, this.props);
	
	      if (props.onlyCompareMonth) {
	        // props.adjustDateStartOf = null
	      }
	
	      var dateProps = (0, _DecadeView.prepareDateProps)(props, this.state);
	
	      (0, _objectAssign2.default)(props, dateProps);
	
	      var className = (0, _join2.default)(props.className, bem(), props.theme && bem(null, 'theme-' + props.theme));
	
	      var monthsInView = this.getMonthsInYear(props.viewMoment);
	
	      var flexProps = (0, _objectAssign2.default)({}, props);
	
	      delete flexProps.activeDate;
	      delete flexProps.activeMoment;
	      delete flexProps.adjustDateStartOf;
	      delete flexProps.adjustMaxDateStartOf;
	      delete flexProps.adjustMinDateStartOf;
	
	      delete flexProps.cleanup;
	      delete flexProps.constrainViewDate;
	
	      delete flexProps.date;
	      delete flexProps.dateFormat;
	
	      delete flexProps.isYearView;
	
	      delete flexProps.maxConstrained;
	      delete flexProps.maxDate;
	      delete flexProps.maxDateMoment;
	      delete flexProps.minConstrained;
	      delete flexProps.minDate;
	      delete flexProps.minDateMoment;
	      delete flexProps.moment;
	      delete flexProps.monthFormat;
	
	      delete flexProps.navKeys;
	
	      delete flexProps.onActiveDateChange;
	      delete flexProps.onViewDateChange;
	      delete flexProps.onlyCompareMonth;
	
	      delete flexProps.timestamp;
	      delete flexProps.theme;
	
	      delete flexProps.viewDate;
	      delete flexProps.viewMoment;
	
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(flexProps);
	      }
	
	      return _react2.default.createElement(
	        _reactFlex.Flex,
	        _extends({
	          inline: true,
	          column: true,
	          alignItems: 'stretch',
	          tabIndex: 0
	        }, flexProps, {
	          onKeyDown: this.onKeyDown,
	          className: className
	        }),
	        this.renderMonths(props, monthsInView)
	      );
	    }
	  }, {
	    key: 'renderMonths',
	    value: function renderMonths(props, months) {
	      var _this3 = this;
	
	      var nodes = months.map(function (monthMoment) {
	        return _this3.renderMonth(props, monthMoment);
	      });
	
	      var buckets = (0, _times2.default)(Math.ceil(nodes.length / 4)).map(function (i) {
	        return nodes.slice(i * 4, (i + 1) * 4);
	      });
	
	      var className = bem('row');
	
	      return buckets.map(function (bucket, i) {
	        return _react2.default.createElement(
	          _reactFlex.Flex,
	          {
	            alignItems: 'center',
	            flex: true,
	            row: true,
	            inline: true,
	            key: 'row_' + i,
	            className: className
	          },
	          bucket
	        );
	      });
	    }
	  }, {
	    key: 'format',
	    value: function format(mom, _format) {
	      _format = _format || this.props.monthFormat;
	
	      return mom.format(_format);
	    }
	  }, {
	    key: 'renderMonth',
	    value: function renderMonth(props, dateMoment) {
	      var index = dateMoment.get('month');
	
	      var monthText = props.monthNames ? props.monthNames[index] || this.format(dateMoment) : this.format(dateMoment);
	
	      var timestamp = +dateMoment;
	
	      var isActiveDate = props.onlyCompareMonth && props.activeMoment ? dateMoment.get('month') == props.activeMoment.get('month') : timestamp === props.activeDate;
	
	      var isValue = props.onlyCompareMonth && props.moment ? dateMoment.get('month') == props.moment.get('month') : timestamp === props.timestamp;
	
	      var disabled = props.minDate != null && timestamp < props.minDate || props.maxDate != null && timestamp > props.maxDate;
	
	      var className = (0, _join2.default)(bem('month'), !disabled && isActiveDate && bem('month', 'active'), isValue && bem('month', 'value'), disabled && bem('month', 'disabled'));
	
	      var onClick = disabled ? null : this.handleClick.bind(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	
	      return _react2.default.createElement(
	        _reactFlex.Item,
	        {
	          key: monthText,
	          className: className,
	          onClick: onClick
	        },
	        monthText
	      );
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(_ref, event) {
	      var timestamp = _ref.timestamp;
	      var dateMoment = _ref.dateMoment;
	
	      event.target.value = timestamp;
	
	      this.select({ dateMoment: dateMoment, timestamp: timestamp }, event);
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(event) {
	      return _DecadeView.onKeyDown.call(this, event);
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm(date, event) {
	      return _DecadeView.confirm.call(this, date, event);
	    }
	  }, {
	    key: 'navigate',
	    value: function navigate(direction, event) {
	      return _DecadeView.navigate.call(this, direction, event);
	    }
	  }, {
	    key: 'select',
	    value: function select(_ref2, event) {
	      var dateMoment = _ref2.dateMoment;
	      var timestamp = _ref2.timestamp;
	
	      return _DecadeView.select.call(this, { dateMoment: dateMoment, timestamp: timestamp }, event);
	    }
	  }, {
	    key: 'onViewDateChange',
	    value: function onViewDateChange(_ref3) {
	      var dateMoment = _ref3.dateMoment;
	      var timestamp = _ref3.timestamp;
	
	      return _DecadeView.onViewDateChange.call(this, { dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }, {
	    key: 'gotoViewDate',
	    value: function gotoViewDate(_ref4) {
	      var dateMoment = _ref4.dateMoment;
	      var timestamp = _ref4.timestamp;
	
	      return _DecadeView.gotoViewDate.call(this, { dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }, {
	    key: 'onActiveDateChange',
	    value: function onActiveDateChange(_ref5) {
	      var dateMoment = _ref5.dateMoment;
	      var timestamp = _ref5.timestamp;
	
	      return _DecadeView.onActiveDateChange.call(this, { dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(_ref6, event) {
	      var dateMoment = _ref6.dateMoment;
	      var timestamp = _ref6.timestamp;
	
	      return _DecadeView.onChange.call(this, { dateMoment: dateMoment, timestamp: timestamp }, event);
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      (0, _reactDom.findDOMNode)(this).focus();
	    }
	  }]);
	
	  return YearView;
	}(_reactClass2.default);
	
	exports.default = YearView;
	
	
	YearView.defaultProps = {
	  isYearView: true,
	  navKeys: NAV_KEYS,
	  constrainViewDate: true,
	  theme: 'default',
	  monthFormat: 'MMM',
	  dateFormat: 'YYYY-MM-DD',
	
	  onlyCompareMonth: true,
	
	  adjustDateStartOf: 'month',
	  adjustMinDateStartOf: 'month',
	  adjustMaxDateStartOf: 'month'
	};

/***/ },
/* 475 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (range) {
	  if (range[1] && range[0].isAfter(range[1])) {
	    range = [range[1], range[0]];
	  }
	
	  return range;
	};

/***/ },
/* 476 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var clamp = function clamp(value, _ref) {
	  var min = _ref.min;
	  var max = _ref.max;
	  var _ref$circular = _ref.circular;
	  var circular = _ref$circular === undefined ? true : _ref$circular;
	
	  return value < min ? circular ? max : min : value > max ? circular ? min : max : value;
	};
	
	var clampHour = exports.clampHour = function clampHour(value, _ref2) {
	  var max = _ref2.max;
	  var min = _ref2.min;
	  var circular = _ref2.circular;
	
	  return clamp(value, { min: min || 0, max: max || 23, circular: circular });
	};
	
	var clampMinute = exports.clampMinute = function clampMinute(value, _ref3) {
	  var circular = _ref3.circular;
	
	  return clamp(value, { min: 0, max: 59, circular: circular });
	};
	
	var clampSecond = exports.clampSecond = function clampSecond(value, _ref4) {
	  var circular = _ref4.circular;
	
	  return clamp(value, { min: 0, max: 59, circular: circular });
	};
	
	var MAP = {
	  second: clampSecond,
	  seconds: clampSecond,
	  minute: clampMinute,
	  minutes: clampMinute,
	  hour: clampHour,
	  hours: clampHour
	};
	
	var clampNamed = exports.clampNamed = function clampNamed(name, value, _ref5) {
	  var circular = _ref5.circular;
	  var max = _ref5.max;
	  var min = _ref5.min;
	
	  return MAP[name](value, { circular: circular, max: max, min: min });
	};
	
	exports.default = clamp;

/***/ },
/* 477 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = function (moment, configOrRange) {
	
	  var range = configOrRange;
	  var inclusive = true;
	
	  if (!Array.isArray(configOrRange) && (typeof configOrRange === 'undefined' ? 'undefined' : _typeof(configOrRange)) == 'object') {
	    range = configOrRange.range;
	
	    if (configOrRange.inclusive !== undefined) {
	      inclusive = !!configOrRange.inclusive;
	    }
	  }
	
	  var start = range[0];
	  var end = range.length >= 2 && range[range.length - 1];
	
	  if (!moment) {
	    return false;
	  }
	
	  if (start && end) {
	    var insideRange = start.isBefore(moment) && end.isAfter(moment);
	
	    return inclusive ? insideRange || start.isSame(moment) || end.isSame(moment) : insideRange;
	  }
	
	  return false;
	};

/***/ },
/* 478 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(85);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(97);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactInstrumentation = __webpack_require__(51);
	
	var quoteAttributeValueForBrowser = __webpack_require__(977);
	var warning = __webpack_require__(19);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 481 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var LinkedValueUtils = __webpack_require__(225);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactUpdates = __webpack_require__(59);
	
	var warning = __webpack_require__(19);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 483 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 484 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(12);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(937);
	
	var containsNode = __webpack_require__(981);
	var focusNode = __webpack_require__(501);
	var getActiveElement = __webpack_require__(502);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var DOMLazyTree = __webpack_require__(96);
	var DOMProperty = __webpack_require__(97);
	var React = __webpack_require__(102);
	var ReactBrowserEventEmitter = __webpack_require__(163);
	var ReactCurrentOwner = __webpack_require__(66);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactDOMContainerInfo = __webpack_require__(931);
	var ReactDOMFeatureFlags = __webpack_require__(933);
	var ReactFeatureFlags = __webpack_require__(484);
	var ReactInstanceMap = __webpack_require__(120);
	var ReactInstrumentation = __webpack_require__(51);
	var ReactMarkupChecksum = __webpack_require__(947);
	var ReactReconciler = __webpack_require__(98);
	var ReactUpdateQueue = __webpack_require__(228);
	var ReactUpdates = __webpack_require__(59);
	
	var emptyObject = __webpack_require__(500);
	var instantiateReactComponent = __webpack_require__(495);
	var invariant = __webpack_require__(12);
	var setInnerHTML = __webpack_require__(167);
	var shouldUpdateReactComponent = __webpack_require__(234);
	var warning = __webpack_require__(19);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var React = __webpack_require__(102);
	
	var invariant = __webpack_require__(12);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 489 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 491 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(488);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(40);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(21);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  delete inst._wrapperState.valueTracker;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(15);
	
	var ReactCompositeComponent = __webpack_require__(928);
	var ReactEmptyComponent = __webpack_require__(483);
	var ReactHostComponent = __webpack_require__(485);
	
	var getNextDebugID = __webpack_require__(1147);
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(19);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 496 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(40);
	var escapeTextContentForBrowser = __webpack_require__(166);
	var setInnerHTML = __webpack_require__(167);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactCurrentOwner = __webpack_require__(66);
	var REACT_ELEMENT_TYPE = __webpack_require__(943);
	
	var getIteratorFn = __webpack_require__(974);
	var invariant = __webpack_require__(12);
	var KeyEscapeUtils = __webpack_require__(224);
	var warning = __webpack_require__(19);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(63);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 501 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 502 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 503 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (props) {
	  delete props.display;
	  delete props.wrap;
	  delete props.row;
	  delete props.column;
	  delete props.alignItems;
	  delete props.alignSelf;
	  delete props.alignContent;
	  delete props.justifyContent;
	  delete props.flex;
	  delete props.flexGrow;
	  delete props.flexShrink;
	  delete props.flexBasis;
	  delete props.inline;
	  delete props.wrap;
	};

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _join = __webpack_require__(237);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _props2flex = __webpack_require__(995);
	
	var _props2flex2 = _interopRequireDefault(_props2flex);
	
	var _prefix = __webpack_require__(994);
	
	var _prefix2 = _interopRequireDefault(_prefix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PREFIX = _prefix2.default;
	
	exports.default = function (props) {
	
	  var column = !!props.column;
	  var row = !column && !!props.row;
	  var reverse = props.reverse ? '-reverse' : '';
	
	  var flex = (0, _props2flex2.default)(props);
	
	  var flexGrow = props.flexGrow;
	  var flexShrink = props.flexShrink;
	  var flexBasis = props.flexBasis;
	  var display = props.inline ? 'inline-flex' : props.display;
	
	  var className = (0, _join2.default)(props.className, props.alignItems ? PREFIX + '--align-items-' + props.alignItems : null, props.alignContent ? PREFIX + '--align-content-' + props.alignContent : null, props.justifyContent ? PREFIX + '--justify-content-' + props.justifyContent : null, props.wrap ? PREFIX + '--wrap' : null, props.alignSelf ? PREFIX + '--align-self-' + props.alignSelf : null, row ? PREFIX + '--row' + reverse : null, column ? PREFIX + '--column' + reverse : null,
	
	  // more like flex item related
	  flex != null ? PREFIX + '--flex-' + flex : null, flexGrow != null ? PREFIX + '--flex-grow-' + flexGrow : null, flexShrink != null ? PREFIX + '--flex-shrink-' + flexShrink : null, flexBasis != null ? PREFIX + '--flex-basis-' + flexBasis : null, display != null ? PREFIX + '--display-' + display : null);
	
	  return className;
	};

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Label;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore
	 * @param {Object} props
	 * @param {InputRangeClassNames} props.classNames
	 * @param {Function} props.formatLabel
	 * @param {string} props.type
	 */
	function Label(props) {
	  var labelValue = props.formatLabel ? props.formatLabel(props.children, props.type) : props.children;
	
	  return _react2.default.createElement(
	    'span',
	    { className: props.classNames[props.type + 'Label'] },
	    _react2.default.createElement(
	      'span',
	      { className: props.classNames.labelContainer },
	      labelValue
	    )
	  );
	}
	
	/**
	 * @type {Object}
	 * @property {Function} children
	 * @property {Function} classNames
	 * @property {Function} formatLabel
	 * @property {Function} type
	 */
	Label.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
	  formatLabel: _propTypes2.default.func,
	  type: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];
	//# sourceMappingURL=label.js.map

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(61);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(8);
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(240);
	
	var _ContextUtils = __webpack_require__(239);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 507 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(61);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(8);
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(73);
	
	var _PatternUtils = __webpack_require__(99);
	
	var _InternalPropTypes = __webpack_require__(123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 509 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(280);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(279);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(658);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(513);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(100);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1025);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1022);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(1029);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1026);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1031);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(280);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(279);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _alt = __webpack_require__(170);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MobileActions = function MobileActions() {
	  _classCallCheck(this, MobileActions);
	
	  this.generateActions('showBackButton', 'hideBackButton');
	};
	
	module.exports = _alt2.default.createActions(MobileActions);

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  top: -12px;\n  right: 10px;\n  width: 25px;\n\n  @media screen and (max-width: ', ') {\n    display: none;\n  }\n'], ['\n  position: absolute;\n  top: -12px;\n  right: 10px;\n  width: 25px;\n\n  @media screen and (max-width: ', ') {\n    display: none;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral([' \n  text-decoration: none;\n  ', ';\n  color: ', ';\n  font-weight: ', ';\n  display: ', ';\n  margin-top:', ';\n  padding: ', ' 0;\n  &.active, hover {\n    color: ', ';\n  }\n\n  &:hover {\n    color: ', ';u\n  }\n\n  @media screen and (max-width: ', ') {\n    display: block;\n  }\n'], [' \n  text-decoration: none;\n  ', ';\n  color: ', ';\n  font-weight: ', ';\n  display: ', ';\n  margin-top:', ';\n  padding: ', ' 0;\n  &.active, hover {\n    color: ', ';\n  }\n\n  &:hover {\n    color: ', ';u\n  }\n\n  @media screen and (max-width: ', ') {\n    display: block;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  cursor: pointer;\n  display: inline-block;\n  position: relative\n  margin-top: ', ';\n  margin-left: ', ';\n\n  &:hover {\n    color: ', ';\n  }\n\n  &.active {\n    color: ', ';\n  }\n'], ['\n  cursor: pointer;\n  display: inline-block;\n  position: relative\n  margin-top: ', ';\n  margin-left: ', ';\n\n  &:hover {\n    color: ', ';\n  }\n\n  &.active {\n    color: ', ';\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  position: relative;\n  display: inline-block;\n  margin-right: ', ';\n  ', ';\n  color: ', ';\n  font-weight: ', ';\n\n  @media screen and (max-width: ', ') {\n    display: block;\n    margin-right: 0;\n  }\n'], ['\n  position: relative;\n  display: inline-block;\n  margin-right: ', ';\n  ', ';\n  color: ', ';\n  font-weight: ', ';\n\n  @media screen and (max-width: ', ') {\n    display: block;\n    margin-right: 0;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  display: ', ';\n  padding: ', ' ', ';\n  z-index: 6;\n  position: absolute;\n  top: 46px;\n  right: 0;\n  min-width: 150px;\n  border: ', ';\n  color: ', ';\n  background-color: ', ';\n\n  @media screen and (max-width: ', ') {\n    display: block;\n    padding: ', ' ', ';\n    position: static;\n    border: none;\n  }\n'], ['\n  display: ', ';\n  padding: ', ' ', ';\n  z-index: 6;\n  position: absolute;\n  top: 46px;\n  right: 0;\n  min-width: 150px;\n  border: ', ';\n  color: ', ';\n  background-color: ', ';\n\n  @media screen and (max-width: ', ') {\n    display: block;\n    padding: ', ' ', ';\n    position: static;\n    border: none;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	var _MenuPointer = __webpack_require__(522);
	
	var _MenuPointer2 = _interopRequireDefault(_MenuPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomMenuPointer = (0, _styledComponents2.default)(_MenuPointer2.default)(_templateObject, _Themes.Metrics.breakpoints.tablet);
	
	var CustomLink = _styledComponents2.default.div(_templateObject2, _Themes.Fonts.style.Text, function (props) {
	  return props.active ? _Themes.Colors.primary : _Themes.Colors.black;
	}, _Themes.Fonts.weight.light, function (props) {
	  return props.mobile || props.subLink ? 'block' : 'inline-block';
	}, _Themes.Metrics.margins.tiny, _Themes.Metrics.margins.tiny, _Themes.Colors.primary, _Themes.Colors.primary, _Themes.Metrics.breakpoints.tablet);
	var LinkComponent = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.logout ? _Themes.Metrics.margins.larger : 0;
	}, function (props) {
	  return props.logout ? _Themes.Metrics.margins.larger : 0;
	}, _Themes.Colors.primary, _Themes.Colors.primary);
	
	var Container = _styledComponents2.default.div(_templateObject4, _Themes.Metrics.margins.large, _Themes.Fonts.style.Label, function (props) {
	  return props.active ? _Themes.Colors.primary : _Themes.Colors.black;
	}, _Themes.Fonts.weight.normal, _Themes.Metrics.breakpoints.tablet);
	
	var DropdownBox = _styledComponents2.default.div(_templateObject5, function (props) {
	  return props.visible ? 'block' : 'none';
	}, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.larger, _Themes.Metrics.borders.default, _Themes.Colors.black, _Themes.Colors.white, _Themes.Metrics.breakpoints.tablet, _Themes.Metrics.margins.tiny, _Themes.Metrics.margins.base);
	
	var DropdownLinkContainer = function (_Component) {
	  _inherits(DropdownLinkContainer, _Component);
	
	  function DropdownLinkContainer() {
	    _classCallCheck(this, DropdownLinkContainer);
	
	    return _possibleConstructorReturn(this, (DropdownLinkContainer.__proto__ || Object.getPrototypeOf(DropdownLinkContainer)).apply(this, arguments));
	  }
	
	  _createClass(DropdownLinkContainer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var link = _props.link;
	      var toggleDropdown = _props.toggleDropdown;
	      var open = _props.open;
	      var key = _props.key;
	      var avatar = _props.avatar;
	      var sublinks = _props.sublinks;
	
	      var location = window.location.pathname;
	      var isActive = false;
	      var linkFunction = null;
	
	      if (link) {
	        isActive = location.indexOf(link.id || link.label.toLowerCase()) !== -1;
	        linkFunction = sublinks ? function () {
	          return toggleDropdown(link.label);
	        } : link.onClick;
	      }
	
	      return _react2.default.createElement(
	        Container,
	        { key: key },
	        _react2.default.createElement(
	          LinkComponent,
	          null,
	          avatar || _react2.default.createElement(
	            CustomLink,
	            {
	              active: isActive,
	              key: 'link-' + link.label,
	              activeClassName: 'active',
	              onClick: linkFunction },
	            link.label
	          )
	        ),
	        sublinks && _react2.default.createElement(
	          DropdownBox,
	          { visible: open },
	          _react2.default.createElement(CustomMenuPointer, null),
	          sublinks.map(function (sublink, index) {
	            var isSubLinkActive = isActive && location.indexOf(sublink.id) !== -1;
	            return _react2.default.createElement(
	              CustomLink,
	              {
	                subLink: true,
	                active: isSubLinkActive,
	                key: 'sublink-' + sublink.label,
	                onClick: sublink.onClick,
	                activeClassName: 'active' },
	              sublink.label
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return DropdownLinkContainer;
	}(_react.Component);
	
	DropdownLinkContainer.propTypes = {
	  link: _react.PropTypes.object,
	  toggleDropdown: _react.PropTypes.func,
	  open: _react.PropTypes.bool,
	  key: _react.PropTypes.string,
	  avatar: _react.PropTypes.node,
	  sublinks: _react.PropTypes.array,
	  name: _react.PropTypes.string
	};
	
	exports.default = DropdownLinkContainer;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral([''], ['']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n  background: white;\n  border: ', ';\n  cursor: pointer;\n  border-radius: ', ';\n  min-height: ', ';\n  padding: calc(', ' - 1px);\n  .dropdown-header {\n    ', ';\n    color: ', ';\n    position: relative;\n    .placeholder {\n      ', ';\n      color: ', ';\n    }\n    .arrow {\n      position: absolute;\n      right: 10px;\n      right: 0;\n      top: -', ';\n      transform: rotate(180deg);\n      fill: ', ';\n      &.open {\n        transform: rotate(0deg);\n      }\n    }\n  }\n\n  .dropdown-list {\n    display: ', ';\n    position: absolute;\n    left: -1px;\n    z-index: 2;\n    width: calc(100% + 2px);\n    background: white;\n    border: ', ';\n    border-top: none;\n    border-radius: ', ';\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    ', ';\n    color: ', ';\n  }\n'], ['\n  position: relative;\n  background: white;\n  border: ', ';\n  cursor: pointer;\n  border-radius: ', ';\n  min-height: ', ';\n  padding: calc(', ' - 1px);\n  .dropdown-header {\n    ', ';\n    color: ', ';\n    position: relative;\n    .placeholder {\n      ', ';\n      color: ', ';\n    }\n    .arrow {\n      position: absolute;\n      right: 10px;\n      right: 0;\n      top: -', ';\n      transform: rotate(180deg);\n      fill: ', ';\n      &.open {\n        transform: rotate(0deg);\n      }\n    }\n  }\n\n  .dropdown-list {\n    display: ', ';\n    position: absolute;\n    left: -1px;\n    z-index: 2;\n    width: calc(100% + 2px);\n    background: white;\n    border: ', ';\n    border-top: none;\n    border-radius: ', ';\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    ', ';\n    color: ', ';\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n'], ['\n  ', ';\n  color: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n  position: relative;\n\n  .arrow {\n    position: absolute;\n    right: 10px;\n    right: 0;\n    top: -', ';\n    transform: rotate(180deg);\n    fill: ', ';\n    &.open {\n      transform: rotate(0deg);\n    }\n  }\n'], ['\n  ', ';\n  color: ', ';\n  position: relative;\n\n  .arrow {\n    position: absolute;\n    right: 10px;\n    right: 0;\n    top: -', ';\n    transform: rotate(180deg);\n    fill: ', ';\n    &.open {\n      transform: rotate(0deg);\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Themes = __webpack_require__(5);
	
	var _immutable = __webpack_require__(29);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _List = __webpack_require__(124);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(125);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Tag = __webpack_require__(127);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _Arrow = __webpack_require__(101);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	var _CloseIcon = __webpack_require__(65);
	
	var _CloseIcon2 = _interopRequireDefault(_CloseIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var DropdownContainer = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.borders.default, _Themes.Metrics.borders.defaultRadius, _Themes.Metrics.components.inputFormHeight, _Themes.Metrics.margins.small, _Themes.Fonts.style.Input, _Themes.Colors.black, _Themes.Fonts.style.Input, _Themes.Colors.darkGrey, _Themes.Metrics.margins.tiny, _Themes.Colors.primary, function (props) {
	  return props.open ? 'block' : 'none';
	}, _Themes.Metrics.borders.headerBorder, _Themes.Metrics.borders.defaultRadius, _Themes.Fonts.style.Input, _Themes.Colors.black);
	
	var Error = _styledComponents2.default.div(_templateObject3, _Themes.Fonts.style.Input, _Themes.Colors.red);
	
	var DropdownHeader = _styledComponents2.default.div(_templateObject4, _Themes.Fonts.style.Input, _Themes.Colors.darkGrey, _Themes.Metrics.margins.tiny, _Themes.Colors.primary);
	
	var MultiSelectDropdown = function (_Component) {
	  _inherits(MultiSelectDropdown, _Component);
	
	  function MultiSelectDropdown(props) {
	    _classCallCheck(this, MultiSelectDropdown);
	
	    var _this = _possibleConstructorReturn(this, (MultiSelectDropdown.__proto__ || Object.getPrototypeOf(MultiSelectDropdown)).call(this, props));
	
	    _this.state = {
	      open: false
	    };
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(MultiSelectDropdown, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var _props = this.props;
	      var options = _props.options;
	      var selectedOptions = _props.selectedOptions;
	      var error = _props.error;
	      var open = this.state.open;
	
	
	      if (!(0, _immutable.fromJS)(options).equals((0, _immutable.fromJS)(nextProps.options)) || !(0, _immutable.fromJS)(selectedOptions).equals((0, _immutable.fromJS)(nextProps.selectedOptions)) || error !== nextProps.error || open !== nextState.open) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      this.setState({ open: !this.state.open });
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        if (_this2.props.handleBlur) {
	          _this2.props.handleBlur();
	        }
	        _this2.setState({
	          open: false,
	          value: ''
	        });
	      }, 250);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props;
	      var placeholder = _props2.placeholder;
	      var handleSelect = _props2.handleSelect;
	      var selectedOptions = _props2.selectedOptions;
	      var showTags = _props2.showTags;
	      var options = _props2.options;
	      var accessor = _props2.accessor;
	      var tagsAccessor = _props2.tagsAccessor;
	      var name = _props2.name;
	      var required = _props2.required;
	      var error = _props2.error;
	      var className = _props2.className;
	
	
	      var list = options.length > 0 ? options.map(function (el, index) {
	        return _react2.default.createElement(
	          _ListItem2.default,
	          {
	            key: index,
	            value: el,
	            onClick: function onClick() {
	              handleSelect(el);
	              _this3.handleBlur();
	            } },
	          accessor ? accessor(options[index]) : '' + options[index]
	        );
	      }) : _react2.default.createElement(
	        'span',
	        null,
	        'There are no elements'
	      );
	
	      var tags = showTags && selectedOptions && selectedOptions.map(function (el, index) {
	        return _react2.default.createElement(_Tag2.default, {
	          key: 'Tag-' + index + '-index',
	          text: tagsAccessor(el),
	          icon: _react2.default.createElement(_CloseIcon2.default, { onClick: function onClick() {
	              return handleSelect(el);
	            } })
	        });
	      });
	
	      return _react2.default.createElement(
	        DropdownContainer,
	        { required: required, id: name, className: className },
	        _react2.default.createElement(
	          Container,
	          {
	            onBlur: this.handleBlur,
	            open: this.state.open,
	            tabIndex: '-1',
	            className: 'dropdown-component' },
	          _react2.default.createElement(
	            DropdownHeader,
	            {
	              className: 'dropdown-header',
	              onClick: this.handleClick },
	            _react2.default.createElement(
	              'span',
	              { className: 'placeholder' },
	              placeholder
	            ),
	            _react2.default.createElement(_Arrow2.default, { className: 'arrow ' + (this.state.open && 'open') })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'dropdown-list' },
	            _react2.default.createElement(
	              _List2.default,
	              { className: 'list', hide: !this.state.open },
	              list
	            )
	          )
	        ),
	        error && _react2.default.createElement(
	          Error,
	          null,
	          error
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tags' },
	          tags
	        )
	      );
	    }
	  }]);
	
	  return MultiSelectDropdown;
	}(_react.Component);
	
	MultiSelectDropdown.propTypes = {
	  showTags: _react.PropTypes.bool,
	  options: _react.PropTypes.array.isRequired,
	  selectedOptions: _react.PropTypes.any,
	  placeholder: _react.PropTypes.string.isRequired,
	  handleSelect: _react.PropTypes.func,
	  accessor: _react.PropTypes.func,
	  tagsAccessor: _react.PropTypes.func,
	  error: _react.PropTypes.string,
	  handleBlur: _react.PropTypes.func,
	  name: _react.PropTypes.string,
	  required: _react.PropTypes.bool,
	  className: _react.PropTypes.string
	};
	
	exports.default = MultiSelectDropdown;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin: ', ' 35px;\n  overflow: hidden;\n  img {\n    width: 130px;\n  }\n'], ['\n  margin: ', ' 35px;\n  overflow: hidden;\n  img {\n    width: 130px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  height: 100vh;\n  width: ', ';\n  background: ', '\n  display: inline-block;\n  color: white;\n  margin: 0px;\n'], ['\n  height: 100vh;\n  width: ', ';\n  background: ', '\n  display: inline-block;\n  color: white;\n  margin: 0px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n  text-decoration: none;\n  display: block;\n  padding: 20px;\n  border-left: 8px solid transparent;\n  ', ';\n  \n  &.active {\n    ', ';\n    ', ';\n    ', ';\n  }\n\n  &:hover {\n    background: ', ';\n  }\n'], ['\n  ', ';\n  color: ', ';\n  text-decoration: none;\n  display: block;\n  padding: 20px;\n  border-left: 8px solid transparent;\n  ', ';\n  \n  &.active {\n    ', ';\n    ', ';\n    ', ';\n  }\n\n  &:hover {\n    background: ', ';\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  padding: 0;\n  list-style: none;\n'], ['\n  padding: 0;\n  list-style: none;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  min-height: 54px;\n  display: block;\n  cursor: pointer;\n'], ['\n  min-height: 54px;\n  display: block;\n  cursor: pointer;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  height: 0;\n  overflow: hidden;\n  transition: height 0.5s ease;\n  padding: 0;\n  &.visible {\n    transition: height 0.5s ease;\n    height: ', ';\n  }\n'], ['\n  height: 0;\n  overflow: hidden;\n  transition: height 0.5s ease;\n  padding: 0;\n  &.visible {\n    transition: height 0.5s ease;\n    height: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(169);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  links: _react.PropTypes.array,
	  logo: _react.PropTypes.node,
	  className: _react.PropTypes.string
	};
	
	var Logo = _styledComponents2.default.div(_templateObject, _Themes.Metrics.margins.large);
	
	var SidebarContainer = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.components.sidebar, _Themes.Colors.black);
	
	var CustomLink = (0, _styledComponents2.default)(_reactRouter.Link)(_templateObject3, _Themes.Fonts.style.Text, _Themes.Colors.white, function (props) {
	  return props.isSubLink && 'padding-left:' + _Themes.Metrics.margins.big;
	}, function (props) {
	  return !props.isSubLink && 'border-left: 8px solid ' + _Themes.Colors.white;
	}, function (props) {
	  return !props.isSubLink && ' backgroundColor: ' + _Themes.Colors.whiteOverlay;
	}, function (props) {
	  return props.isSubLink && ' color: ' + _Themes.Colors.primary;
	}, _Themes.Colors.whiteOverlay);
	
	var LinksList = _styledComponents2.default.ul(_templateObject4);
	
	var LinkContainer = _styledComponents2.default.li(_templateObject5);
	
	var SubLinksContainer = _styledComponents2.default.ul(_templateObject6, function (props) {
	  return props.length ? 54 * props.length + 'px' : '100%';
	});
	
	var Sidebar = function Sidebar(props) {
	  var logo = props.logo;
	  var links = props.links;
	  var className = props.className;
	
	  var location = window.location.pathname;
	
	  var list = links.map(function (link, index) {
	    if (link.sublinks) {
	      return _react2.default.createElement(
	        LinkContainer,
	        { key: 'link-' + index },
	        _react2.default.createElement(
	          CustomLink,
	          {
	            to: link.to,
	            onClick: function onClick() {
	              return document.getElementById(link.id).classList.toggle('visible');
	            },
	            className: '' + (location.indexOf(link.label.toLowerCase()) !== -1 && 'active') },
	          link.label
	        ),
	        _react2.default.createElement(
	          SubLinksContainer,
	          { id: link.id, length: link.sublinks.length },
	          link.sublinks.map(function (sublink, idx) {
	            return _react2.default.createElement(
	              LinkContainer,
	              { key: 'sublink-' + idx },
	              _react2.default.createElement(
	                CustomLink,
	                {
	                  isSubLink: true,
	                  to: sublink.to,
	                  className: '' + (location.indexOf(sublink.label.toLowerCase()) !== -1 && 'active') },
	                sublink.label
	              )
	            );
	          })
	        )
	      );
	    } else {
	      return _react2.default.createElement(
	        LinkContainer,
	        { key: 'link-' + index },
	        _react2.default.createElement(
	          CustomLink,
	          {
	            key: 'link-' + index,
	            to: link.to,
	            className: '' + (location.indexOf(link.label.toLowerCase()) !== -1 && 'active') },
	          link.label
	        )
	      );
	    }
	  });
	
	  return _react2.default.createElement(
	    SidebarContainer,
	    { className: className },
	    _react2.default.createElement(
	      Logo,
	      null,
	      logo
	    ),
	    _react2.default.createElement(
	      LinksList,
	      null,
	      list
	    )
	  );
	};
	
	Sidebar.propTypes = propTypes;
	
	exports.default = Sidebar;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 45px;\n  height: 25px;\n  background: ', ';\n  border-radius: 25px;\n  display: block;\n  position: relative;\n  cursor: pointer;\n'], ['\n  width: 45px;\n  height: 25px;\n  background: ', ';\n  border-radius: 25px;\n  display: block;\n  position: relative;\n  cursor: pointer;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  border-radius: 18px;\n  width: 18px;\n  height: 18px;\n  display: block;\n  background: ', ';\n  position: absolute;\n  left: ', ';\n  top: 3px;\n'], ['\n  border-radius: 18px;\n  width: 18px;\n  height: 18px;\n  display: block;\n  background: ', ';\n  position: absolute;\n  left: ', ';\n  top: 3px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.active ? _Themes.Colors.greenBlue : _Themes.Colors.lightGrey;
	});
	
	var Circle = _styledComponents2.default.div(_templateObject2, _Themes.Colors.white, function (props) {
	  return props.active ? _Themes.Metrics.margins.large : '3px';
	});
	
	var Switch = function (_Component) {
	  _inherits(Switch, _Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).apply(this, arguments));
	  }
	
	  _createClass(Switch, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var active = this.props.active;
	
	      if (active !== nextProps.active) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var active = this.props.active;
	
	
	      return _react2.default.createElement(
	        Container,
	        Object.assign({ active: active }, this.props),
	        _react2.default.createElement(Circle, { active: active })
	      );
	    }
	  }]);
	
	  return Switch;
	}(_react.Component);
	
	Switch.propTypes = {
	  active: _react.PropTypes.bool.isRequired
	};
	
	exports.default = Switch;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendMultipleEmails = exports.propertyContactRequest = undefined;
	
	var _axios = __webpack_require__(86);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(88);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propertyContactRequest = exports.propertyContactRequest = function propertyContactRequest(propertyId, message) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/property/' + propertyId + '/contact_request', {
	    message: message
	  });
	};
	
	var sendMultipleEmails = exports.sendMultipleEmails = function sendMultipleEmails(users, message, subject) {
	  return _axios2.default.post(_config2.default.SERVER_URL + '/user/massive_emails', {
	    users: users,
	    subject: subject,
	    message: message
	  });
	};

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Burger = function Burger(props) {
	  return _react2.default.createElement(
	    'svg',
	    Object.assign({ width: '32', height: '32', xmlns: 'http://www.w3.org/2000/svg' }, props),
	    _react2.default.createElement('path', {
	      d: 'M0 15h32v3H0zM0 5h32v3H0zm0 20h32v3H0z',
	      fill: '#2A2A2A',
	      fillRule: 'evenodd'
	    })
	  );
	};
	
	exports.default = Burger;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HvbWhite = function HvbWhite(props) {
	  return _react2.default.createElement(
	    'svg',
	    Object.assign({
	      xmlns: 'http://www.w3.org/2000/svg',
	      xmlnsXlink: 'http://www.w3.org/1999/xlink',
	      x: '0px',
	      y: '0px',
	      viewBox: '0 0 450 450',
	      style: { enableBackground: 'new 0 0 450 450' },
	      xmlSpace: 'preserve'
	    }, props),
	    _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement(
	          'g',
	          null,
	          _react2.default.createElement('path', {
	            fill: '#C78C2F',
	            d: 'M216.5,99.9V90c0-1.4-1.2-2.6-2.6-2.6h-16v-5.1h16c1.4,0,2.6-1.2,2.6-2.6s-1.2-2.6-2.6-2.6h-18.6 c-1.4,0-2.6,1.2-2.6,2.6V90c0,1.4,1.2,2.6,2.6,2.6h16v4.7h-16c-1.4,0-2.6,1.2-2.6,2.6v22c0,1.4,1.2,2.6,2.6,2.6 c1.4,0,2.6-1.2,2.6-2.6v-19.4h16C215.3,102.5,216.5,101.3,216.5,99.9z'
	          }),
	          _react2.default.createElement('path', {
	            fill: '#C78C2F',
	            d: 'M268.1,92.6c1.4,0,2.6-1.2,2.6-2.6V79.6c0-1.4-1.2-2.6-2.6-2.6h-18.6c-1.4,0-2.6,1.2-2.6,2.6 s1.2,2.6,2.6,2.6h16v5.1h-16c-1.4,0-2.6,1.2-2.6,2.6v9.9c0,1.4,1.2,2.6,2.6,2.6h16v19.4c0,1.4,1.2,2.6,2.6,2.6s2.6-1.2,2.6-2.6 v-22c0-1.4-1.2-2.6-2.6-2.6h-16v-4.7H268.1z'
	          })
	        ),
	        _react2.default.createElement('path', {
	          fill: '#C78C2F',
	          d: 'M238.7,63v27c0,1.4,1.2,2.6,2.6,2.6c1.4,0,2.6-1.2,2.6-2.6V64.1c0-0.1,0-0.3,0-0.5c0-6.8-5.5-12.2-12.2-12.2 s-12.2,5.5-12.2,12.1l0,26.5c0,1.4,1.2,2.6,2.6,2.6s2.6-1.2,2.6-2.6l0-25.4l0-1c0-3.9,3.2-7,7-7c3.6,0,6.6,2.8,7,6.3 C238.7,62.9,238.7,63,238.7,63z'
	        }),
	        _react2.default.createElement('path', {
	          fill: '#C78C2F',
	          d: 'M234.3,151.1V79.6c0-1.4-1.2-2.6-2.6-2.6c-1.4,0-2.6,1.2-2.6,2.6v71.5H234.3z'
	        }),
	        _react2.default.createElement(
	          'g',
	          null,
	          _react2.default.createElement('path', {
	            fill: '#C78C2F',
	            d: 'M210.5,124.5c1.4,0,2.6-1.2,2.6-2.6s-1.2-2.6-2.6-2.6c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3 c4.9,0,8.9,4,8.9,9.5v28.9h5.2v-29.5c0-7.8-6.3-14.1-14.2-14.1c-4.7,0-8.5,3.8-8.5,8.5C202,120.7,205.8,124.5,210.5,124.5z'
	          }),
	          _react2.default.createElement('path', {
	            fill: '#C78C2F',
	            d: 'M244,151.1v-29.5c0-4.9,4-8.9,9-8.9c1.8,0,3.3,1.5,3.3,3.3s-1.5,3.3-3.3,3.3c-1.4,0-2.6,1.2-2.6,2.6 s1.2,2.6,2.6,2.6c4.7,0,8.5-3.8,8.5-8.5c0-4.7-3.8-8.5-8.5-8.5c-7.8,0-14.2,6.3-14.2,14.7v28.9H244z'
	          })
	        ),
	        _react2.default.createElement(
	          'g',
	          null,
	          _react2.default.createElement('path', {
	            fill: '#C78C2F',
	            d: 'M231.7,387.8c6.1,0,11-4.9,11-11s-4.9-11-11-11c-6.1,0-11,4.9-11,11S225.7,387.8,231.7,387.8z M231.7,371 c3.2,0,5.8,2.6,5.8,5.8c0,3.2-2.6,5.8-5.8,5.8c-3.2,0-5.8-2.6-5.8-5.8C225.9,373.6,228.5,371,231.7,371z'
	          }),
	          _react2.default.createElement('path', {
	            fill: '#C78C2F',
	            d: 'M211.4,351.9c-1.4,0-2.6,1.2-2.6,2.6c0,1.4,1.2,2.6,2.6,2.6c4.5,0,8.2-3.7,8.2-8.2s-3.7-8.2-8.2-8.2 c-7.5,0-13.5,6.1-13.5,13.5c0,7.5,6.1,13.5,13.5,13.5c4.2,0,8.1-2,10.7-5.3c0.2-0.1,0.4-0.3,0.5-0.4l6.1-8.5 c0.8-1.2,0.6-2.8-0.6-3.6c-1.2-0.8-2.8-0.6-3.6,0.6l-5.8,8.1c-0.1,0.1-0.3,0.2-0.3,0.3c-1.5,2.3-4.1,3.7-6.9,3.7 c-4.6,0-8.3-3.7-8.3-8.3s3.7-8.3,8.3-8.3c1.6,0,3,1.3,3,3C214.4,350.6,213,351.9,211.4,351.9z'
	          }),
	          _react2.default.createElement('path', {
	            fill: '#C78C2F',
	            d: 'M275.8,354.6c0-13.5-11-24.4-24.4-24.4c-1.4,0-2.6,1.2-2.6,2.6c0,1.4,1.2,2.6,2.6,2.6 c10.6,0,19.2,8.6,19.2,19.2c0,10.6-8.6,19.1-19.1,19.2c0,0-0.1,0-0.1,0c-1.4,0-2.6,1.2-2.6,2.6c0,9.4-7.6,17-17,17 c-9.4,0-17-7.6-17-17c0-1.4-1.2-2.6-2.6-2.6c0,0-0.1,0-0.1,0c-10.5-0.1-19.1-8.6-19.1-19.2c0-10.6,8.6-19.2,19.2-19.2 c1.4,0,2.6-1.2,2.6-2.6c0-1.4-1.2-2.6-2.6-2.6c-13.5,0-24.4,11-24.4,24.4c0,12.7,9.7,23,22.1,24.2c1.2,11.1,10.6,19.8,22,19.8 c11.4,0,20.8-8.7,22-19.8C266.1,377.6,275.8,367.3,275.8,354.6z'
	          }),
	          _react2.default.createElement('path', {
	            fill: '#C78C2F',
	            d: 'M252.1,340.7c-4.5,0-8.2,3.7-8.2,8.2s3.7,8.2,8.2,8.2c1.4,0,2.6-1.2,2.6-2.6c0-1.4-1.2-2.6-2.6-2.6 c-1.6,0-3-1.3-3-3c0-1.6,1.3-3,3-3c4.6,0,8.3,3.7,8.3,8.3s-3.7,8.3-8.3,8.3c-2.8,0-5.4-1.4-6.9-3.7c-0.1-0.1-0.2-0.2-0.3-0.3 l-30.8-43c3.8-3.7,8.3-4.3,8.4-4.3c1.3-0.2,2.3-1.3,2.3-2.6v-12h-5.2v10c-2.7,0.8-7.2,2.7-10.8,7.1c-0.7,0.9-0.8,2.2-0.1,3.2 l32.3,45.2c0.1,0.2,0.4,0.3,0.5,0.5c2.6,3.3,6.4,5.3,10.7,5.3c7.5,0,13.5-6.1,13.5-13.5C265.6,346.8,259.5,340.7,252.1,340.7z'
	          }),
	          _react2.default.createElement('path', {
	            fill: '#C78C2F',
	            d: 'M234.3,314.5v-18h-5.2v17.9c-2.2,0.4-4.3,1.2-6.1,2.6c-1.2,0.8-1.4,2.5-0.6,3.6c0.8,1.2,2.5,1.4,3.6,0.6 c3.3-2.4,8-2.4,11.3,0c0.5,0.3,1,0.5,1.5,0.5c0.8,0,1.6-0.4,2.1-1.1c0.8-1.2,0.6-2.8-0.6-3.6 C238.6,315.7,236.5,314.9,234.3,314.5z'
	          }),
	          _react2.default.createElement('path', {
	            fill: '#C78C2F',
	            d: 'M243.9,306.5v-10h-5.2v12c0,1.3,1,2.4,2.3,2.6c0.1,0,4.5,0.6,8.4,4.3l-14.2,19.8c-0.8,1.2-0.6,2.8,0.6,3.6 c0.5,0.3,1,0.5,1.5,0.5c0.8,0,1.6-0.4,2.1-1.1l15.4-21.5c0.7-0.9,0.6-2.2-0.1-3.2C251.2,309.2,246.6,307.3,243.9,306.5z'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('path', {
	          fill: '#FFFFFF',
	          d: 'M268.7,167.7h-25.9c-0.6,0-1.2,0.5-1.2,1.2v6.2c0,0.5,0.4,1,0.9,1.1c6.5,1.6,7.7,2.6,7.7,4.4 c0,1.1-0.4,2.3-0.8,3.4l-14.6,41.8l-14.6-45.4l-0.2-0.8c-0.1-0.4-0.3-0.8-0.1-1.1l8.1-2.4c0.5-0.1,0.8-0.6,0.8-1.1v-6.2 c0-0.6-0.5-1.2-1.2-1.2h-30.2c-0.6,0-1.2,0.5-1.2,1.2v6.2c0,0.5,0.4,1,0.9,1.1c5.6,1.5,5.6,1.5,6.7,5l22.5,63.4 c0.2,0.5,0.6,0.8,1.1,0.8h9.2c0.5,0,0.9-0.3,1.1-0.8l25.4-66.6c0.3-0.3,2.9-1,5.8-1.8c0.5-0.1,0.9-0.6,0.9-1.1v-6.2 C269.9,168.2,269.4,167.7,268.7,167.7z'
	        }),
	        _react2.default.createElement('path', {
	          fill: '#FFFFFF',
	          d: 'M354.5,185.8c6.2-3.1,14.1-11.7,14.1-25.7c0-17.4-12.1-27.4-33.2-27.4H294c-0.6,0-1.2,0.5-1.2,1.2v6.2 c0,0.6,0.4,1,0.9,1.1c9.9,1.9,9.9,3,9.9,8.7v78.2c0,5.8,0,6.8-9.9,8.7c-0.5,0.1-0.9,0.6-0.9,1.1v6.2c0,0.6,0.5,1.2,1.2,1.2h45.5 c24.6,0,35.6-16,35.6-31.9C375,200.7,366.3,189.2,354.5,185.8z M319.7,192.8h15.7c5,0,21.5,1.6,21.5,22.1 c0,12.8-9.8,19.9-27.5,19.9c-5.8,0-8-1.3-8.2-1.5c-1.2-0.6-1.5-2.1-1.5-4.5V192.8z M319.7,182v-38.6h8.4 c10.5,0,22.9,3.2,22.9,18.6c0,12.2-9.6,20-24.5,20H319.7z'
	        }),
	        _react2.default.createElement('path', {
	          fill: '#FFFFFF',
	          d: 'M143,228.1l0,0.9c0,5.1,0,6-9,7.8c-0.5,0.1-0.9,0.6-0.9,1.1v6.2c0,0.6,0.5,1.2,1.2,1.2h34.9 c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8l0-6.2c0-0.5-0.4-1-0.9-1.1l-8.2-1.9c-1.8-0.4-2-1.1-2-3v-85.8c0-1.9,0.2-2.6,2-3 l8.3-1.9c0.5-0.1,0.9-0.6,0.9-1.1v-6.2c0-0.6-0.5-1.2-1.1-1.2h-34.9c-0.6,0-1.2,0.5-1.2,1.2v6.2c0,0.6,0.4,1,0.9,1.1 c9.1,1.8,9.1,2.7,9,7.8l0,33h-41.9l0-35.9c0-1.9,0.2-2.6,1.9-3l8.3-1.9c0.5-0.1,0.8-0.6,0.8-1.1v-6.2c0-0.6-0.5-1.2-1.1-1.2H76.2 c-0.6,0-1.2,0.5-1.2,1.2v6.2c0,0.6,0.4,1,0.9,1.1c9.1,1.8,9.1,2.7,9,7.8l0,79.1l0,0.9c0,5.1,0,6-9,7.8c-0.5,0.1-0.9,0.6-0.9,1.1 v6.2c0,0.6,0.5,1.2,1.2,1.2H111c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8l0-6.2c0-0.5-0.4-1-0.9-1.1l-8.2-1.9 c-1.8-0.4-2-1.1-2-3l0-39.1H143L143,228.1z'
	        })
	      ),
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('path', { fill: '#FFFFFF', d: 'M124.6,263.5h2.6V283h-2.6V263.5z' }),
	        _react2.default.createElement('path', {
	          fill: '#FFFFFF',
	          d: 'M134,262.7l14.4,14.9v-14.1h2.7v20.4l-14.4-14.8V283H134V262.7z'
	        }),
	        _react2.default.createElement('path', {
	          fill: '#FFFFFF',
	          d: 'M273.5,262.7l14.4,14.9v-14.1h2.7v20.4l-14.4-14.8V283h-2.7V262.7z'
	        }),
	        _react2.default.createElement('path', {
	          fill: '#FFFFFF',
	          d: 'M179,263.5h10.8v2.7h-8.2v4.9h8.2v2.6h-8.2v6.7h8.2v2.6H179V263.5z'
	        }),
	        _react2.default.createElement('path', {
	          fill: '#FFFFFF',
	          d: 'M256,263.5h10.8v2.7h-8.2v4.9h8.2v2.6h-8.2v6.7h8.2v2.6H256V263.5z'
	        }),
	        _react2.default.createElement('path', {
	          fill: '#FFFFFF',
	          d: 'M324.9,266.1l-2,1.6c-0.5-0.6-1-1-1.5-1.2c-0.4-0.3-1.1-0.4-1.9-0.4c-0.9,0-1.6,0.2-2.2,0.6 c-0.6,0.4-0.8,0.9-0.8,1.6c0,0.6,0.2,1,0.7,1.5c0.5,0.4,1.3,0.9,2.5,1.4c1.2,0.5,2.1,1,2.7,1.4c0.7,0.4,1.2,0.9,1.6,1.4 c0.4,0.5,0.7,1.1,0.9,1.7c0.2,0.6,0.3,1.2,0.3,1.9c0,1.5-0.6,2.8-1.7,3.9c-1.1,1.1-2.5,1.6-4,1.6c-1.5,0-2.9-0.4-4.1-1.3 c-1.2-0.8-2.1-2.1-2.7-3.8l2.5-0.7c0.9,2.1,2.3,3.1,4.2,3.1c0.9,0,1.7-0.3,2.3-0.8c0.6-0.5,0.9-1.2,0.9-2.1c0-0.5-0.2-1-0.5-1.5 c-0.3-0.5-0.7-0.9-1.2-1.2c-0.5-0.3-1.2-0.7-2.3-1.1c-1-0.4-1.8-0.8-2.4-1.2c-0.6-0.3-1-0.8-1.4-1.3c-0.4-0.5-0.7-1-0.9-1.4 c-0.2-0.5-0.3-1-0.3-1.5c0-1.3,0.5-2.4,1.6-3.4c1.1-0.9,2.3-1.4,3.8-1.4c1,0,2,0.2,3,0.6C323.4,264.6,324.2,265.2,324.9,266.1z'
	        }),
	        _react2.default.createElement('path', {
	          fill: '#FFFFFF',
	          d: 'M212.5,263.5h12v2.7h-4.7V283h-2.6v-16.9h-4.7V263.5z'
	        }),
	        _react2.default.createElement('path', {
	          fill: '#FFFFFF',
	          d: 'M296.1,263.5h12v2.7h-4.7V283h-2.6v-16.9h-4.7V263.5z'
	        }),
	        _react2.default.createElement('polygon', {
	          fill: '#FFFFFF',
	          points: '165.1,277.6 158.7,263.5 155.8,263.5 165.1,283.9 174.3,263.5 171.5,263.5'
	        }),
	        _react2.default.createElement('polygon', {
	          fill: '#FFFFFF',
	          points: '245.1,262.7 239.1,277.3 232.9,262.7 227.6,283 230.2,283 233.5,270.5 238.7,283.2 239.1,283.9 239.4,283.2 244.6,270.6 247.9,283 250.5,283'
	        }),
	        _react2.default.createElement('path', {
	          fill: '#FFFFFF',
	          d: 'M207.2,266.1l-2,1.6c-0.5-0.6-1-1-1.5-1.2c-0.4-0.3-1.1-0.4-1.9-0.4c-0.9,0-1.6,0.2-2.2,0.6 c-0.6,0.4-0.8,0.9-0.8,1.6c0,0.6,0.2,1,0.7,1.5c0.5,0.4,1.3,0.9,2.5,1.4c1.2,0.5,2.1,1,2.7,1.4c0.7,0.4,1.2,0.9,1.6,1.4 s0.7,1.1,0.9,1.7c0.2,0.6,0.3,1.2,0.3,1.9c0,1.5-0.6,2.8-1.7,3.9c-1.1,1.1-2.5,1.6-4,1.6c-1.5,0-2.9-0.4-4.1-1.3s-2.1-2.1-2.7-3.8 l2.5-0.7c0.9,2.1,2.3,3.1,4.2,3.1c0.9,0,1.7-0.3,2.3-0.8c0.6-0.5,0.9-1.2,0.9-2.1c0-0.5-0.2-1-0.5-1.5c-0.3-0.5-0.7-0.9-1.2-1.2 c-0.5-0.3-1.2-0.7-2.3-1.1c-1-0.4-1.8-0.8-2.4-1.2c-0.6-0.3-1-0.8-1.4-1.3c-0.4-0.5-0.7-1-0.9-1.4c-0.2-0.5-0.3-1-0.3-1.5 c0-1.3,0.5-2.4,1.6-3.4c1.1-0.9,2.3-1.4,3.8-1.4c1,0,2,0.2,3,0.6C205.6,264.6,206.5,265.2,207.2,266.1z'
	        })
	      )
	    )
	  );
	};
	
	exports.default = HvbWhite;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  .st0 {\n    fill: #ffffff;\n    stroke: #dfdfdf;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-miterlimit: 10;\n  }\n'], ['\n  .st0 {\n    fill: #ffffff;\n    stroke: #dfdfdf;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-miterlimit: 10;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var SVG = _styledComponents2.default.svg(_templateObject);
	
	var MenuPointer = function MenuPointer(props) {
	  return _react2.default.createElement(
	    SVG,
	    Object.assign({
	      id: 'Layer_1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      viewBox: '0 0 92 48'
	    }, props),
	    _react2.default.createElement('path', { className: 'st0', d: 'M.7 46.6L46 1.4l45.3 45.2' })
	  );
	};
	
	exports.default = MenuPointer;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(556);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/default_city.8975eca2.jpg";

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasOwn      = __webpack_require__(1136)
	var getPrefixed = __webpack_require__(1134)
	
	var map      = __webpack_require__(1137)
	var plugable = __webpack_require__(1138)
	
	function plugins(key, value){
	
		var result = {
			key  : key,
			value: value
		}
	
		;(RESULT.plugins || []).forEach(function(fn){
	
			var tmp = map(function(res){
				return fn(key, value, res)
			}, result)
	
			if (tmp){
				result = tmp
			}
		})
	
		return result
	}
	
	function normalize(key, value){
	
		var result = plugins(key, value)
	
		return map(function(result){
			return {
				key  : getPrefixed(result.key, result.value),
				value: result.value
			}
		}, result)
	
		return result
	}
	
	var RESULT = function(style){
	
		var k
		var item
		var result = {}
	
		for (k in style) if (hasOwn(style, k)){
			item = normalize(k, style[k])
	
			if (!item){
				continue
			}
	
			map(function(item){
				result[item.key] = item.value
			}, item)
		}
	
		return result
	}
	
	module.exports = plugable(RESULT)

/***/ },
/* 526 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  'alignItems': 1,
	  'justifyContent': 1,
	  'flex': 1,
	  'flexFlow': 1,
	  'flexGrow': 1,
	  'flexShrink': 1,
	  'flexBasis': 1,
	  'flexDirection': 1,
	  'flexWrap': 1,
	  'alignContent': 1,
	  'alignSelf': 1,
	
	  'userSelect': 1,
	  'transform': 1,
	  'transition': 1,
	  'transformOrigin': 1,
	  'transformStyle': 1,
	  'transitionProperty': 1,
	  'transitionDuration': 1,
	  'transitionTimingFunction': 1,
	  'transitionDelay': 1,
	  'borderImage': 1,
	  'borderImageSlice': 1,
	  'boxShadow': 1,
	  'backgroundClip': 1,
	  'backfaceVisibility': 1,
	  'perspective': 1,
	  'perspectiveOrigin': 1,
	  'animation': 1,
	  'animationDuration': 1,
	  'animationName': 1,
	  'animationDelay': 1,
	  'animationDirection': 1,
	  'animationIterationCount': 1,
	  'animationTimingFunction': 1,
	  'animationPlayState': 1,
	  'animationFillMode': 1,
	  'appearance': 1
	}


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(132),
	    _assign = __webpack_require__(15);
	
	var ReactNoopUpdateQueue = __webpack_require__(530);
	
	var canDefineProperty = __webpack_require__(531);
	var emptyObject = __webpack_require__(1151);
	var invariant = __webpack_require__(133);
	var lowPriorityWarning = __webpack_require__(1148);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(132);
	
	var ReactCurrentOwner = __webpack_require__(66);
	
	var invariant = __webpack_require__(133);
	var warning = __webpack_require__(177);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 529 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(177);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 532 */
63,
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parse = __webpack_require__(539);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	var _autoprefix = __webpack_require__(535);
	
	var _autoprefix2 = _interopRequireDefault(_autoprefix);
	
	var _postcssNested = __webpack_require__(538);
	
	var _postcssNested2 = _interopRequireDefault(_postcssNested);
	
	var _flatten = __webpack_require__(250);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _StyleSheet = __webpack_require__(534);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var babelPluginFlowReactPropTypes_proptype_RuleSet = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_RuleSet || __webpack_require__(8).any;
	
	var ComponentStyle = function () {
	  function ComponentStyle(rules, selector) {
	    _classCallCheck(this, ComponentStyle);
	
	    this.rules = rules;
	    this.selector = selector;
	  }
	
	  _createClass(ComponentStyle, [{
	    key: 'generateAndInject',
	    value: function generateAndInject() {
	      if (!_StyleSheet2.default.injected) _StyleSheet2.default.inject();
	      var flatCSS = (0, _flatten2.default)(this.rules).join('');
	      if (this.selector) {
	        flatCSS = this.selector + ' {' + flatCSS + '\n}';
	      }
	      var root = (0, _parse2.default)(flatCSS);
	      (0, _postcssNested2.default)(root);
	      (0, _autoprefix2.default)(root);
	      _StyleSheet2.default.insert(root.toResult().css, { global: true });
	    }
	  }]);
	
	  return ComponentStyle;
	}();
	
	exports.default = ComponentStyle;
	module.exports = exports['default'];

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	/* Wraps glamor's stylesheet and exports a singleton for styled components
	to use. */
	
	
	var _sheet = __webpack_require__(1166);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var babelPluginFlowReactPropTypes_proptype_GlamorInsertedRule = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_GlamorInsertedRule || __webpack_require__(8).any;
	
	var babelPluginFlowReactPropTypes_proptype_GlamorRule = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_GlamorRule || __webpack_require__(8).any;
	
	var StyleSheet = function () {
	  function StyleSheet() {
	    _classCallCheck(this, StyleSheet);
	
	    /* Don't specify a maxLength for the global sheet, since these rules
	     * are defined at initialization and should remain static after that */
	    this.globalStyleSheet = new _sheet.StyleSheet({ speedy: false });
	    this.componentStyleSheet = new _sheet.StyleSheet({ speedy: false, maxLength: 40 });
	  }
	
	  _createClass(StyleSheet, [{
	    key: 'inject',
	    value: function inject() {
	      this.globalStyleSheet.inject();
	      this.componentStyleSheet.inject();
	    }
	  }, {
	    key: 'flush',
	    value: function flush() {
	      if (this.globalStyleSheet.sheet) this.globalStyleSheet.flush();
	      if (this.componentStyleSheet.sheet) this.componentStyleSheet.flush();
	    }
	  }, {
	    key: 'insert',
	    value: function insert(rule) {
	      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { global: false };
	
	      var sheet = opts.global ? this.globalStyleSheet : this.componentStyleSheet;
	      return sheet.insert(rule);
	    }
	  }, {
	    key: 'rules',
	    value: function rules() {
	      return this.globalStyleSheet.rules().concat(this.componentStyleSheet.rules());
	    }
	  }, {
	    key: 'injected',
	    get: function get() {
	      return this.globalStyleSheet.injected && this.componentStyleSheet.injected;
	    }
	  }]);
	
	  return StyleSheet;
	}();
	
	/* Export stylesheet as a singleton class */
	
	
	exports.default = new StyleSheet();
	module.exports = exports['default'];

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _camelizeStyleName = __webpack_require__(1174);
	
	var _camelizeStyleName2 = _interopRequireDefault(_camelizeStyleName);
	
	var _hyphenateStyleName = __webpack_require__(547);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _static = __webpack_require__(687);
	
	var _static2 = _interopRequireDefault(_static);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// eslint-disable-next-line
	
	
	var babelPluginFlowReactPropTypes_proptype_Container = __webpack_require__(179).babelPluginFlowReactPropTypes_proptype_Container || __webpack_require__(8).any;
	
	exports.default = function (root) {
	  root.walkDecls(function (decl) {
	    /* No point even checking custom props */
	    if (/^--/.test(decl.prop)) return;
	
	    var objStyle = _defineProperty({}, (0, _camelizeStyleName2.default)(decl.prop), decl.value);
	    var prefixed = (0, _static2.default)(objStyle);
	    Object.keys(prefixed).reverse().forEach(function (newProp) {
	      var newVals = prefixed[newProp];
	      var newValArray = Array.isArray(newVals) ? newVals : [newVals];
	      newValArray.forEach(function (newVal) {
	        decl.cloneBefore({
	          prop: (0, _hyphenateStyleName2.default)(newProp),
	          value: newVal
	        });
	      });
	    });
	    decl.remove();
	  });
	};
	
	module.exports = exports['default'];

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	if (true) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_Broadcast", {
	  value: __webpack_require__(8).shape({
	    publish: __webpack_require__(8).func.isRequired,
	    subscribe: __webpack_require__(8).func.isRequired
	  })
	});
	/**
	 * Creates a broadcast that can be listened to, i.e. simple event emitter
	 *
	 * @see https://github.com/ReactTraining/react-broadcast
	 */
	
	var createBroadcast = function createBroadcast(initialValue) {
	  var listeners = [];
	  var currentValue = initialValue;
	
	  return {
	    publish: function publish(value) {
	      currentValue = value;
	      listeners.forEach(function (listener) {
	        return listener(currentValue);
	      });
	    },
	    subscribe: function subscribe(listener) {
	      listeners.push(listener);
	
	      // Publish to this subscriber once immediately.
	      listener(currentValue);
	
	      return function () {
	        listeners = listeners.filter(function (item) {
	          return item !== listener;
	        });
	      };
	    }
	  };
	};
	
	exports.default = createBroadcast;
	module.exports = exports["default"];

/***/ },
/* 537 */
/***/ function(module, exports) {

	/**
	 * Stolen directly from glamor, thanks @threepointone!
	 */
	
	/* eslint-disable */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = doHash;
	// murmurhash2 via https://gist.github.com/raycmorgan/588423
	
	function doHash(str, seed) {
	  var m = 0x5bd1e995;
	  var r = 24;
	  var h = seed ^ str.length;
	  var length = str.length;
	  var currentIndex = 0;
	
	  while (length >= 4) {
	    var k = UInt32(str, currentIndex);
	
	    k = Umul32(k, m);
	    k ^= k >>> r;
	    k = Umul32(k, m);
	
	    h = Umul32(h, m);
	    h ^= k;
	
	    currentIndex += 4;
	    length -= 4;
	  }
	
	  switch (length) {
	    case 3:
	      h ^= UInt16(str, currentIndex);
	      h ^= str.charCodeAt(currentIndex + 2) << 16;
	      h = Umul32(h, m);
	      break;
	
	    case 2:
	      h ^= UInt16(str, currentIndex);
	      h = Umul32(h, m);
	      break;
	
	    case 1:
	      h ^= str.charCodeAt(currentIndex);
	      h = Umul32(h, m);
	      break;
	  }
	
	  h ^= h >>> 13;
	  h = Umul32(h, m);
	  h ^= h >>> 15;
	
	  return h >>> 0;
	}
	
	function UInt32(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
	}
	
	function UInt16(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
	}
	
	function Umul32(n, m) {
	  n = n | 0;
	  m = m | 0;
	  var nlo = n & 0xffff;
	  var nhi = n >>> 16;
	  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
	  return res;
	}

/***/ },
/* 538 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function selectors(parent, node) {
	  var result = [];
	  parent.selectors.forEach(function (i) {
	    node.selectors.forEach(function (j) {
	      if (j.indexOf('&') === -1) {
	        result.push(i + ' ' + j);
	      } else {
	        result.push(j.replace(/&/g, i));
	      }
	    });
	  });
	  return result;
	}
	
	function pickComment(comment, after) {
	  if (comment && comment.type === 'comment') {
	    return comment.moveAfter(after);
	  } else {
	    return after;
	  }
	}
	
	function atruleChilds(rule, atrule) {
	  var children = [];
	  atrule.each(function (child) {
	    if (child.type === 'comment') {
	      children.push(child);
	    }
	    if (child.type === 'decl') {
	      children.push(child);
	    } else if (child.type === 'rule') {
	      child.selectors = selectors(rule, child);
	    } else if (child.type === 'atrule') {
	      atruleChilds(rule, child);
	    }
	  });
	  if (children.length) {
	    var clone = rule.clone({ nodes: [] });
	    for (var i = 0; i < children.length; i++) {
	      children[i].moveTo(clone);
	    }atrule.prepend(clone);
	  }
	}
	
	function processRule(rule, bubble) {
	  var unwrapped = false;
	  var after = rule;
	  rule.each(function (child) {
	    if (child.type === 'rule') {
	      unwrapped = true;
	      child.selectors = selectors(rule, child);
	      after = pickComment(child.prev(), after);
	      after = child.moveAfter(after);
	    } else if (child.type === 'atrule') {
	      if (bubble.indexOf(child.name) !== -1) {
	        unwrapped = true;
	        atruleChilds(rule, child);
	        after = pickComment(child.prev(), after);
	        after = child.moveAfter(after);
	      }
	    }
	  });
	  if (unwrapped) {
	    rule.raws.semicolon = true;
	    if (rule.nodes.length === 0) rule.remove();
	  }
	}
	
	var bubble = ['media', 'supports', 'document'];
	
	var process = function process(node) {
	  node.each(function (child) {
	    if (child.type === 'rule') {
	      processRule(child, bubble);
	    } else if (child.type === 'atrule') {
	      process(child);
	    }
	  });
	};
	
	exports.default = process;
	module.exports = exports['default'];

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = safeParse;
	
	var _input = __webpack_require__(253);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _safeParser = __webpack_require__(1167);
	
	var _safeParser2 = _interopRequireDefault(_safeParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function safeParse(css, opts) {
	    var input = new _input2.default(css, opts);
	
	    var parser = new _safeParser2.default(input);
	    parser.tokenize();
	    parser.loop();
	
	    return parser.root;
	}
	module.exports = exports['default'];

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _supportsColor = __webpack_require__(1176);
	
	var _supportsColor2 = _interopRequireDefault(_supportsColor);
	
	var _terminalHighlight = __webpack_require__(1171);
	
	var _terminalHighlight2 = _interopRequireDefault(_terminalHighlight);
	
	var _warnOnce = __webpack_require__(67);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The CSS parser throws this error for broken CSS.
	 *
	 * Custom parsers can throw this error for broken custom syntax using
	 * the {@link Node#error} method.
	 *
	 * PostCSS will use the input source map to detect the original error location.
	 * If you wrote a Sass file, compiled it to CSS and then parsed it with PostCSS,
	 * PostCSS will show the original position in the Sass file.
	 *
	 * If you need the position in the PostCSS input
	 * (e.g., to debug the previous compiler), use `error.input.file`.
	 *
	 * @example
	 * // Catching and checking syntax error
	 * try {
	 *   postcss.parse('a{')
	 * } catch (error) {
	 *   if ( error.name === 'CssSyntaxError' ) {
	 *     error //=> CssSyntaxError
	 *   }
	 * }
	 *
	 * @example
	 * // Raising error from plugin
	 * throw node.error('Unknown variable', { plugin: 'postcss-vars' });
	 */
	var CssSyntaxError = function () {
	
	    /**
	     * @param {string} message  - error message
	     * @param {number} [line]   - source line of the error
	     * @param {number} [column] - source column of the error
	     * @param {string} [source] - source code of the broken file
	     * @param {string} [file]   - absolute path to the broken file
	     * @param {string} [plugin] - PostCSS plugin name, if error came from plugin
	     */
	    function CssSyntaxError(message, line, column, source, file, plugin) {
	        _classCallCheck(this, CssSyntaxError);
	
	        /**
	         * @member {string} - Always equal to `'CssSyntaxError'`. You should
	         *                    always check error type
	         *                    by `error.name === 'CssSyntaxError'` instead of
	         *                    `error instanceof CssSyntaxError`, because
	         *                    npm could have several PostCSS versions.
	         *
	         * @example
	         * if ( error.name === 'CssSyntaxError' ) {
	         *   error //=> CssSyntaxError
	         * }
	         */
	        this.name = 'CssSyntaxError';
	        /**
	         * @member {string} - Error message.
	         *
	         * @example
	         * error.message //=> 'Unclosed block'
	         */
	        this.reason = message;
	
	        if (file) {
	            /**
	             * @member {string} - Absolute path to the broken file.
	             *
	             * @example
	             * error.file       //=> 'a.sass'
	             * error.input.file //=> 'a.css'
	             */
	            this.file = file;
	        }
	        if (source) {
	            /**
	             * @member {string} - Source code of the broken file.
	             *
	             * @example
	             * error.source       //=> 'a { b {} }'
	             * error.input.column //=> 'a b { }'
	             */
	            this.source = source;
	        }
	        if (plugin) {
	            /**
	             * @member {string} - Plugin name, if error came from plugin.
	             *
	             * @example
	             * error.plugin //=> 'postcss-vars'
	             */
	            this.plugin = plugin;
	        }
	        if (typeof line !== 'undefined' && typeof column !== 'undefined') {
	            /**
	             * @member {number} - Source line of the error.
	             *
	             * @example
	             * error.line       //=> 2
	             * error.input.line //=> 4
	             */
	            this.line = line;
	            /**
	             * @member {number} - Source column of the error.
	             *
	             * @example
	             * error.column       //=> 1
	             * error.input.column //=> 4
	             */
	            this.column = column;
	        }
	
	        this.setMessage();
	
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, CssSyntaxError);
	        }
	    }
	
	    _createClass(CssSyntaxError, [{
	        key: 'setMessage',
	        value: function setMessage() {
	            /**
	             * @member {string} - Full error text in the GNU error format
	             *                    with plugin, file, line and column.
	             *
	             * @example
	             * error.message //=> 'a.css:1:1: Unclosed block'
	             */
	            this.message = this.plugin ? this.plugin + ': ' : '';
	            this.message += this.file ? this.file : '<css input>';
	            if (typeof this.line !== 'undefined') {
	                this.message += ':' + this.line + ':' + this.column;
	            }
	            this.message += ': ' + this.reason;
	        }
	
	        /**
	         * Returns a few lines of CSS source that caused the error.
	         *
	         * If the CSS has an input source map without `sourceContent`,
	         * this method will return an empty string.
	         *
	         * @param {boolean} [color] whether arrow will be colored red by terminal
	         *                          color codes. By default, PostCSS will detect
	         *                          color support by `process.stdout.isTTY`
	         *                          and `process.env.NODE_DISABLE_COLORS`.
	         *
	         * @example
	         * error.showSourceCode() //=> "  4 | }
	         *                        //      5 | a {
	         *                        //    > 6 |   bad
	         *                        //        |   ^
	         *                        //      7 | }
	         *                        //      8 | b {"
	         *
	         * @return {string} few lines of CSS source that caused the error
	         */
	
	    }, {
	        key: 'showSourceCode',
	        value: function showSourceCode(color) {
	            var _this = this;
	
	            if (!this.source) return '';
	
	            var css = this.source;
	            if (typeof color === 'undefined') color = _supportsColor2.default;
	            if (color) css = (0, _terminalHighlight2.default)(css);
	
	            var lines = css.split(/\r?\n/);
	            var start = Math.max(this.line - 3, 0);
	            var end = Math.min(this.line + 2, lines.length);
	
	            var maxWidth = String(end).length;
	
	            return lines.slice(start, end).map(function (line, index) {
	                var number = start + 1 + index;
	                var padded = (' ' + number).slice(-maxWidth);
	                var gutter = ' ' + padded + ' | ';
	                if (number === _this.line) {
	                    var spacing = gutter.replace(/\d/g, ' ') + line.slice(0, _this.column - 1).replace(/[^\t]/g, ' ');
	                    return '>' + gutter + line + '\n ' + spacing + '^';
	                } else {
	                    return ' ' + gutter + line;
	                }
	            }).join('\n');
	        }
	
	        /**
	         * Returns error position, message and source code of the broken part.
	         *
	         * @example
	         * error.toString() //=> "CssSyntaxError: app.css:1:1: Unclosed block
	         *                  //    > 1 | a {
	         *                  //        | ^"
	         *
	         * @return {string} error position, message and source code
	         */
	
	    }, {
	        key: 'toString',
	        value: function toString() {
	            var code = this.showSourceCode();
	            if (code) {
	                code = '\n\n' + code + '\n';
	            }
	            return this.name + ': ' + this.message + code;
	        }
	    }, {
	        key: 'generated',
	        get: function get() {
	            (0, _warnOnce2.default)('CssSyntaxError#generated is depreacted. Use input instead.');
	            return this.input;
	        }
	
	        /**
	         * @memberof CssSyntaxError#
	         * @member {Input} input - Input object with PostCSS internal information
	         *                         about input file. If input has source map
	         *                         from previous tool, PostCSS will use origin
	         *                         (for example, Sass) source. You can use this
	         *                         object to get PostCSS input source.
	         *
	         * @example
	         * error.input.file //=> 'a.css'
	         * error.file       //=> 'a.sass'
	         */
	
	    }]);
	
	    return CssSyntaxError;
	}();
	
	exports.default = CssSyntaxError;
	module.exports = exports['default'];

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warnOnce = __webpack_require__(67);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	var _node = __webpack_require__(254);
	
	var _node2 = _interopRequireDefault(_node);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Represents a CSS declaration.
	 *
	 * @extends Node
	 *
	 * @example
	 * const root = postcss.parse('a { color: black }');
	 * const decl = root.first.first;
	 * decl.type       //=> 'decl'
	 * decl.toString() //=> ' color: black'
	 */
	var Declaration = function (_Node) {
	    _inherits(Declaration, _Node);
	
	    function Declaration(defaults) {
	        _classCallCheck(this, Declaration);
	
	        var _this = _possibleConstructorReturn(this, (Declaration.__proto__ || Object.getPrototypeOf(Declaration)).call(this, defaults));
	
	        _this.type = 'decl';
	        return _this;
	    }
	
	    _createClass(Declaration, [{
	        key: '_value',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#_value was deprecated. Use Node#raws.value');
	            return this.raws.value;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#_value was deprecated. Use Node#raws.value');
	            this.raws.value = val;
	        }
	    }, {
	        key: '_important',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#_important was deprecated. Use Node#raws.important');
	            return this.raws.important;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#_important was deprecated. Use Node#raws.important');
	            this.raws.important = val;
	        }
	
	        /**
	         * @memberof Declaration#
	         * @member {string} prop - the declaration’s property name
	         *
	         * @example
	         * const root = postcss.parse('a { color: black }');
	         * const decl = root.first.first;
	         * decl.prop //=> 'color'
	         */
	
	        /**
	         * @memberof Declaration#
	         * @member {string} value - the declaration’s value
	         *
	         * @example
	         * const root = postcss.parse('a { color: black }');
	         * const decl = root.first.first;
	         * decl.value //=> 'black'
	         */
	
	        /**
	         * @memberof Declaration#
	         * @member {boolean} important - `true` if the declaration
	         *                               has an !important annotation.
	         *
	         * @example
	         * const root = postcss.parse('a { color: black !important; color: red }');
	         * root.first.first.important //=> true
	         * root.first.last.important  //=> undefined
	         */
	
	        /**
	         * @memberof Declaration#
	         * @member {object} raws - Information to generate byte-to-byte equal
	         *                         node string as it was in the origin input.
	         *
	         * Every parser saves its own properties,
	         * but the default CSS parser uses:
	         *
	         * * `before`: the space symbols before the node. It also stores `*`
	         *   and `_` symbols before the declaration (IE hack).
	         * * `between`: the symbols between the property and value
	         *   for declarations, selector and `{` for rules, or last parameter
	         *   and `{` for at-rules.
	         * * `important`: the content of the important statement,
	         *   if it is not just `!important`.
	         *
	         * PostCSS cleans declaration from comments and extra spaces,
	         * but it stores origin content in raws properties.
	         * As such, if you don’t change a declaration’s value,
	         * PostCSS will use the raw value with comments.
	         *
	         * @example
	         * const root = postcss.parse('a {\n  color:black\n}')
	         * root.first.first.raws //=> { before: '\n  ', between: ':' }
	         */
	
	    }]);
	
	    return Declaration;
	}(_node2.default);
	
	exports.default = Declaration;
	module.exports = exports['default'];

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _stringify2 = __webpack_require__(546);
	
	var _stringify3 = _interopRequireDefault(_stringify2);
	
	var _warnOnce = __webpack_require__(67);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	var _result = __webpack_require__(1170);
	
	var _result2 = _interopRequireDefault(_result);
	
	var _parse = __webpack_require__(543);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function isPromise(obj) {
	    return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && typeof obj.then === 'function';
	}
	
	/**
	 * @callback onFulfilled
	 * @param {Result} result
	 */
	
	/**
	 * @callback onRejected
	 * @param {Error} error
	 */
	
	/**
	 * A Promise proxy for the result of PostCSS transformations.
	 *
	 * A `LazyResult` instance is returned by {@link Processor#process}.
	 *
	 * @example
	 * const lazy = postcss([cssnext]).process(css);
	 */
	
	var LazyResult = function () {
	    function LazyResult(processor, css, opts) {
	        _classCallCheck(this, LazyResult);
	
	        this.stringified = false;
	        this.processed = false;
	
	        var root = void 0;
	        if ((typeof css === 'undefined' ? 'undefined' : _typeof(css)) === 'object' && css.type === 'root') {
	            root = css;
	        } else if (css instanceof LazyResult || css instanceof _result2.default) {
	            root = css.root;
	            if (css.map) {
	                if (typeof opts.map === 'undefined') opts.map = {};
	                if (!opts.map.inline) opts.map.inline = false;
	                opts.map.prev = css.map;
	            }
	        } else {
	            var parser = _parse2.default;
	            if (opts.syntax) parser = opts.syntax.parse;
	            if (opts.parser) parser = opts.parser;
	            if (parser.parse) parser = parser.parse;
	
	            try {
	                root = parser(css, opts);
	            } catch (error) {
	                this.error = error;
	            }
	        }
	
	        this.result = new _result2.default(processor, root, opts);
	    }
	
	    /**
	     * Returns a {@link Processor} instance, which will be used
	     * for CSS transformations.
	     * @type {Processor}
	     */
	
	
	    _createClass(LazyResult, [{
	        key: 'warnings',
	
	
	        /**
	         * Processes input CSS through synchronous plugins
	         * and calls {@link Result#warnings()}.
	         *
	         * @return {Warning[]} warnings from plugins
	         */
	        value: function warnings() {
	            return this.sync().warnings();
	        }
	
	        /**
	         * Alias for the {@link LazyResult#css} property.
	         *
	         * @example
	         * lazy + '' === lazy.css;
	         *
	         * @return {string} output CSS
	         */
	
	    }, {
	        key: 'toString',
	        value: function toString() {
	            return this.css;
	        }
	
	        /**
	         * Processes input CSS through synchronous and asynchronous plugins
	         * and calls `onFulfilled` with a Result instance. If a plugin throws
	         * an error, the `onRejected` callback will be executed.
	         *
	         * It implements standard Promise API.
	         *
	         * @param {onFulfilled} onFulfilled - callback will be executed
	         *                                    when all plugins will finish work
	         * @param {onRejected}  onRejected  - callback will be execited on any error
	         *
	         * @return {Promise} Promise API to make queue
	         *
	         * @example
	         * postcss([cssnext]).process(css).then(result => {
	         *   console.log(result.css);
	         * });
	         */
	
	    }, {
	        key: 'then',
	        value: function then(onFulfilled, onRejected) {
	            return this.async().then(onFulfilled, onRejected);
	        }
	
	        /**
	         * Processes input CSS through synchronous and asynchronous plugins
	         * and calls onRejected for each error thrown in any plugin.
	         *
	         * It implements standard Promise API.
	         *
	         * @param {onRejected} onRejected - callback will be execited on any error
	         *
	         * @return {Promise} Promise API to make queue
	         *
	         * @example
	         * postcss([cssnext]).process(css).then(result => {
	         *   console.log(result.css);
	         * }).catch(error => {
	         *   console.error(error);
	         * });
	         */
	
	    }, {
	        key: 'catch',
	        value: function _catch(onRejected) {
	            return this.async().catch(onRejected);
	        }
	    }, {
	        key: 'handleError',
	        value: function handleError(error, plugin) {
	            try {
	                this.error = error;
	                if (error.name === 'CssSyntaxError' && !error.plugin) {
	                    error.plugin = plugin.postcssPlugin;
	                    error.setMessage();
	                } else if (plugin.postcssVersion) {
	                    var pluginName = plugin.postcssPlugin;
	                    var pluginVer = plugin.postcssVersion;
	                    var runtimeVer = this.result.processor.version;
	                    var a = pluginVer.split('.');
	                    var b = runtimeVer.split('.');
	
	                    if (a[0] !== b[0] || parseInt(a[1]) > parseInt(b[1])) {
	                        (0, _warnOnce2.default)('Your current PostCSS version ' + 'is ' + runtimeVer + ', but ' + pluginName + ' ' + 'uses ' + pluginVer + '. Perhaps this is ' + 'the source of the error below.');
	                    }
	                }
	            } catch (err) {
	                if (console && console.error) console.error(err);
	            }
	        }
	    }, {
	        key: 'asyncTick',
	        value: function asyncTick(resolve, reject) {
	            var _this = this;
	
	            if (this.plugin >= this.processor.plugins.length) {
	                this.processed = true;
	                return resolve();
	            }
	
	            try {
	                var plugin = this.processor.plugins[this.plugin];
	                var promise = this.run(plugin);
	                this.plugin += 1;
	
	                if (isPromise(promise)) {
	                    promise.then(function () {
	                        _this.asyncTick(resolve, reject);
	                    }).catch(function (error) {
	                        _this.handleError(error, plugin);
	                        _this.processed = true;
	                        reject(error);
	                    });
	                } else {
	                    this.asyncTick(resolve, reject);
	                }
	            } catch (error) {
	                this.processed = true;
	                reject(error);
	            }
	        }
	    }, {
	        key: 'async',
	        value: function async() {
	            var _this2 = this;
	
	            if (this.processed) {
	                return new Promise(function (resolve, reject) {
	                    if (_this2.error) {
	                        reject(_this2.error);
	                    } else {
	                        resolve(_this2.stringify());
	                    }
	                });
	            }
	            if (this.processing) {
	                return this.processing;
	            }
	
	            this.processing = new Promise(function (resolve, reject) {
	                if (_this2.error) return reject(_this2.error);
	                _this2.plugin = 0;
	                _this2.asyncTick(resolve, reject);
	            }).then(function () {
	                _this2.processed = true;
	                return _this2.stringify();
	            });
	
	            return this.processing;
	        }
	    }, {
	        key: 'sync',
	        value: function sync() {
	            var _this3 = this;
	
	            if (this.processed) return this.result;
	            this.processed = true;
	
	            if (this.processing) {
	                throw new Error('Use process(css).then(cb) to work with async plugins');
	            }
	
	            if (this.error) throw this.error;
	
	            this.result.processor.plugins.forEach(function (plugin) {
	                var promise = _this3.run(plugin);
	                if (isPromise(promise)) {
	                    throw new Error('Use process(css).then(cb) to work with async plugins');
	                }
	            });
	
	            return this.result;
	        }
	    }, {
	        key: 'run',
	        value: function run(plugin) {
	            this.result.lastPlugin = plugin;
	
	            try {
	                return plugin(this.result.root, this.result);
	            } catch (error) {
	                this.handleError(error, plugin);
	                throw error;
	            }
	        }
	    }, {
	        key: 'stringify',
	        value: function stringify() {
	            if (this.stringified) return this.result;
	            this.stringified = true;
	
	            this.sync();
	
	            var opts = this.result.opts;
	            var str = _stringify3.default;
	            if (opts.syntax) str = opts.syntax.stringify;
	            if (opts.stringifier) str = opts.stringifier;
	            if (str.stringify) str = str.stringify;
	
	            var result = '';
	            str(this.root, function (i) {
	                result += i;
	            });
	            this.result.css = result;
	
	            return this.result;
	        }
	    }, {
	        key: 'processor',
	        get: function get() {
	            return this.result.processor;
	        }
	
	        /**
	         * Options from the {@link Processor#process} call.
	         * @type {processOptions}
	         */
	
	    }, {
	        key: 'opts',
	        get: function get() {
	            return this.result.opts;
	        }
	
	        /**
	         * Processes input CSS through synchronous plugins, converts `Root`
	         * to a CSS string and returns {@link Result#css}.
	         *
	         * This property will only work with synchronous plugins.
	         * If the processor contains any asynchronous plugins
	         * it will throw an error. This is why this method is only
	         * for debug purpose, you should always use {@link LazyResult#then}.
	         *
	         * @type {string}
	         * @see Result#css
	         */
	
	    }, {
	        key: 'css',
	        get: function get() {
	            return this.stringify().css;
	        }
	
	        /**
	         * An alias for the `css` property. Use it with syntaxes
	         * that generate non-CSS output.
	         *
	         * This property will only work with synchronous plugins.
	         * If the processor contains any asynchronous plugins
	         * it will throw an error. This is why this method is only
	         * for debug purpose, you should always use {@link LazyResult#then}.
	         *
	         * @type {string}
	         * @see Result#content
	         */
	
	    }, {
	        key: 'content',
	        get: function get() {
	            return this.stringify().content;
	        }
	
	        /**
	         * Processes input CSS through synchronous plugins
	         * and returns {@link Result#map}.
	         *
	         * This property will only work with synchronous plugins.
	         * If the processor contains any asynchronous plugins
	         * it will throw an error. This is why this method is only
	         * for debug purpose, you should always use {@link LazyResult#then}.
	         *
	         * @type {SourceMapGenerator}
	         * @see Result#map
	         */
	
	    }, {
	        key: 'map',
	        get: function get() {
	            return this.stringify().map;
	        }
	
	        /**
	         * Processes input CSS through synchronous plugins
	         * and returns {@link Result#root}.
	         *
	         * This property will only work with synchronous plugins. If the processor
	         * contains any asynchronous plugins it will throw an error.
	         *
	         * This is why this method is only for debug purpose,
	         * you should always use {@link LazyResult#then}.
	         *
	         * @type {Root}
	         * @see Result#root
	         */
	
	    }, {
	        key: 'root',
	        get: function get() {
	            return this.sync().root;
	        }
	
	        /**
	         * Processes input CSS through synchronous plugins
	         * and returns {@link Result#messages}.
	         *
	         * This property will only work with synchronous plugins. If the processor
	         * contains any asynchronous plugins it will throw an error.
	         *
	         * This is why this method is only for debug purpose,
	         * you should always use {@link LazyResult#then}.
	         *
	         * @type {Message[]}
	         * @see Result#messages
	         */
	
	    }, {
	        key: 'messages',
	        get: function get() {
	            return this.sync().messages;
	        }
	    }]);
	
	    return LazyResult;
	}();
	
	exports.default = LazyResult;
	module.exports = exports['default'];

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = parse;
	
	var _parser = __webpack_require__(544);
	
	var _parser2 = _interopRequireDefault(_parser);
	
	var _input = __webpack_require__(253);
	
	var _input2 = _interopRequireDefault(_input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parse(css, opts) {
	    if (opts && opts.safe) {
	        throw new Error('Option safe was removed. ' + 'Use parser: require("postcss-safe-parser")');
	    }
	
	    var input = new _input2.default(css, opts);
	
	    var parser = new _parser2.default(input);
	    try {
	        parser.tokenize();
	        parser.loop();
	    } catch (e) {
	        if (e.name === 'CssSyntaxError' && opts && opts.from) {
	            if (/\.scss$/i.test(opts.from)) {
	                e.message += '\nYou tried to parse SCSS with ' + 'the standard CSS parser; ' + 'try again with the postcss-scss parser';
	            } else if (/\.less$/i.test(opts.from)) {
	                e.message += '\nYou tried to parse Less with ' + 'the standard CSS parser; ' + 'try again with the postcss-less parser';
	            }
	        }
	        throw e;
	    }
	
	    return parser.root;
	}
	module.exports = exports['default'];

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _declaration = __webpack_require__(541);
	
	var _declaration2 = _interopRequireDefault(_declaration);
	
	var _tokenize = __webpack_require__(257);
	
	var _tokenize2 = _interopRequireDefault(_tokenize);
	
	var _comment = __webpack_require__(252);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _atRule = __webpack_require__(251);
	
	var _atRule2 = _interopRequireDefault(_atRule);
	
	var _root = __webpack_require__(255);
	
	var _root2 = _interopRequireDefault(_root);
	
	var _rule = __webpack_require__(256);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Parser = function () {
	    function Parser(input) {
	        _classCallCheck(this, Parser);
	
	        this.input = input;
	
	        this.pos = 0;
	        this.root = new _root2.default();
	        this.current = this.root;
	        this.spaces = '';
	        this.semicolon = false;
	
	        this.root.source = { input: input, start: { line: 1, column: 1 } };
	    }
	
	    _createClass(Parser, [{
	        key: 'tokenize',
	        value: function tokenize() {
	            this.tokens = (0, _tokenize2.default)(this.input);
	        }
	    }, {
	        key: 'loop',
	        value: function loop() {
	            var token = void 0;
	            while (this.pos < this.tokens.length) {
	                token = this.tokens[this.pos];
	
	                switch (token[0]) {
	
	                    case 'space':
	                    case ';':
	                        this.spaces += token[1];
	                        break;
	
	                    case '}':
	                        this.end(token);
	                        break;
	
	                    case 'comment':
	                        this.comment(token);
	                        break;
	
	                    case 'at-word':
	                        this.atrule(token);
	                        break;
	
	                    case '{':
	                        this.emptyRule(token);
	                        break;
	
	                    default:
	                        this.other();
	                        break;
	                }
	
	                this.pos += 1;
	            }
	            this.endFile();
	        }
	    }, {
	        key: 'comment',
	        value: function comment(token) {
	            var node = new _comment2.default();
	            this.init(node, token[2], token[3]);
	            node.source.end = { line: token[4], column: token[5] };
	
	            var text = token[1].slice(2, -2);
	            if (/^\s*$/.test(text)) {
	                node.text = '';
	                node.raws.left = text;
	                node.raws.right = '';
	            } else {
	                var match = text.match(/^(\s*)([^]*[^\s])(\s*)$/);
	                node.text = match[2];
	                node.raws.left = match[1];
	                node.raws.right = match[3];
	            }
	        }
	    }, {
	        key: 'emptyRule',
	        value: function emptyRule(token) {
	            var node = new _rule2.default();
	            this.init(node, token[2], token[3]);
	            node.selector = '';
	            node.raws.between = '';
	            this.current = node;
	        }
	    }, {
	        key: 'other',
	        value: function other() {
	            var token = void 0;
	            var end = false;
	            var type = null;
	            var colon = false;
	            var bracket = null;
	            var brackets = [];
	
	            var start = this.pos;
	            while (this.pos < this.tokens.length) {
	                token = this.tokens[this.pos];
	                type = token[0];
	
	                if (type === '(' || type === '[') {
	                    if (!bracket) bracket = token;
	                    brackets.push(type === '(' ? ')' : ']');
	                } else if (brackets.length === 0) {
	                    if (type === ';') {
	                        if (colon) {
	                            this.decl(this.tokens.slice(start, this.pos + 1));
	                            return;
	                        } else {
	                            break;
	                        }
	                    } else if (type === '{') {
	                        this.rule(this.tokens.slice(start, this.pos + 1));
	                        return;
	                    } else if (type === '}') {
	                        this.pos -= 1;
	                        end = true;
	                        break;
	                    } else if (type === ':') {
	                        colon = true;
	                    }
	                } else if (type === brackets[brackets.length - 1]) {
	                    brackets.pop();
	                    if (brackets.length === 0) bracket = null;
	                }
	
	                this.pos += 1;
	            }
	            if (this.pos === this.tokens.length) {
	                this.pos -= 1;
	                end = true;
	            }
	
	            if (brackets.length > 0) this.unclosedBracket(bracket);
	
	            if (end && colon) {
	                while (this.pos > start) {
	                    token = this.tokens[this.pos][0];
	                    if (token !== 'space' && token !== 'comment') break;
	                    this.pos -= 1;
	                }
	                this.decl(this.tokens.slice(start, this.pos + 1));
	                return;
	            }
	
	            this.unknownWord(start);
	        }
	    }, {
	        key: 'rule',
	        value: function rule(tokens) {
	            tokens.pop();
	
	            var node = new _rule2.default();
	            this.init(node, tokens[0][2], tokens[0][3]);
	
	            node.raws.between = this.spacesFromEnd(tokens);
	            this.raw(node, 'selector', tokens);
	            this.current = node;
	        }
	    }, {
	        key: 'decl',
	        value: function decl(tokens) {
	            var node = new _declaration2.default();
	            this.init(node);
	
	            var last = tokens[tokens.length - 1];
	            if (last[0] === ';') {
	                this.semicolon = true;
	                tokens.pop();
	            }
	            if (last[4]) {
	                node.source.end = { line: last[4], column: last[5] };
	            } else {
	                node.source.end = { line: last[2], column: last[3] };
	            }
	
	            while (tokens[0][0] !== 'word') {
	                node.raws.before += tokens.shift()[1];
	            }
	            node.source.start = { line: tokens[0][2], column: tokens[0][3] };
	
	            node.prop = '';
	            while (tokens.length) {
	                var type = tokens[0][0];
	                if (type === ':' || type === 'space' || type === 'comment') {
	                    break;
	                }
	                node.prop += tokens.shift()[1];
	            }
	
	            node.raws.between = '';
	
	            var token = void 0;
	            while (tokens.length) {
	                token = tokens.shift();
	
	                if (token[0] === ':') {
	                    node.raws.between += token[1];
	                    break;
	                } else {
	                    node.raws.between += token[1];
	                }
	            }
	
	            if (node.prop[0] === '_' || node.prop[0] === '*') {
	                node.raws.before += node.prop[0];
	                node.prop = node.prop.slice(1);
	            }
	            node.raws.between += this.spacesFromStart(tokens);
	            this.precheckMissedSemicolon(tokens);
	
	            for (var i = tokens.length - 1; i > 0; i--) {
	                token = tokens[i];
	                if (token[1] === '!important') {
	                    node.important = true;
	                    var string = this.stringFrom(tokens, i);
	                    string = this.spacesFromEnd(tokens) + string;
	                    if (string !== ' !important') node.raws.important = string;
	                    break;
	                } else if (token[1] === 'important') {
	                    var cache = tokens.slice(0);
	                    var str = '';
	                    for (var j = i; j > 0; j--) {
	                        var _type = cache[j][0];
	                        if (str.trim().indexOf('!') === 0 && _type !== 'space') {
	                            break;
	                        }
	                        str = cache.pop()[1] + str;
	                    }
	                    if (str.trim().indexOf('!') === 0) {
	                        node.important = true;
	                        node.raws.important = str;
	                        tokens = cache;
	                    }
	                }
	
	                if (token[0] !== 'space' && token[0] !== 'comment') {
	                    break;
	                }
	            }
	
	            this.raw(node, 'value', tokens);
	
	            if (node.value.indexOf(':') !== -1) this.checkMissedSemicolon(tokens);
	        }
	    }, {
	        key: 'atrule',
	        value: function atrule(token) {
	            var node = new _atRule2.default();
	            node.name = token[1].slice(1);
	            if (node.name === '') {
	                this.unnamedAtrule(node, token);
	            }
	            this.init(node, token[2], token[3]);
	
	            var last = false;
	            var open = false;
	            var params = [];
	
	            this.pos += 1;
	            while (this.pos < this.tokens.length) {
	                token = this.tokens[this.pos];
	
	                if (token[0] === ';') {
	                    node.source.end = { line: token[2], column: token[3] };
	                    this.semicolon = true;
	                    break;
	                } else if (token[0] === '{') {
	                    open = true;
	                    break;
	                } else if (token[0] === '}') {
	                    this.end(token);
	                    break;
	                } else {
	                    params.push(token);
	                }
	
	                this.pos += 1;
	            }
	            if (this.pos === this.tokens.length) {
	                last = true;
	            }
	
	            node.raws.between = this.spacesFromEnd(params);
	            if (params.length) {
	                node.raws.afterName = this.spacesFromStart(params);
	                this.raw(node, 'params', params);
	                if (last) {
	                    token = params[params.length - 1];
	                    node.source.end = { line: token[4], column: token[5] };
	                    this.spaces = node.raws.between;
	                    node.raws.between = '';
	                }
	            } else {
	                node.raws.afterName = '';
	                node.params = '';
	            }
	
	            if (open) {
	                node.nodes = [];
	                this.current = node;
	            }
	        }
	    }, {
	        key: 'end',
	        value: function end(token) {
	            if (this.current.nodes && this.current.nodes.length) {
	                this.current.raws.semicolon = this.semicolon;
	            }
	            this.semicolon = false;
	
	            this.current.raws.after = (this.current.raws.after || '') + this.spaces;
	            this.spaces = '';
	
	            if (this.current.parent) {
	                this.current.source.end = { line: token[2], column: token[3] };
	                this.current = this.current.parent;
	            } else {
	                this.unexpectedClose(token);
	            }
	        }
	    }, {
	        key: 'endFile',
	        value: function endFile() {
	            if (this.current.parent) this.unclosedBlock();
	            if (this.current.nodes && this.current.nodes.length) {
	                this.current.raws.semicolon = this.semicolon;
	            }
	            this.current.raws.after = (this.current.raws.after || '') + this.spaces;
	        }
	
	        // Helpers
	
	    }, {
	        key: 'init',
	        value: function init(node, line, column) {
	            this.current.push(node);
	
	            node.source = { start: { line: line, column: column }, input: this.input };
	            node.raws.before = this.spaces;
	            this.spaces = '';
	            if (node.type !== 'comment') this.semicolon = false;
	        }
	    }, {
	        key: 'raw',
	        value: function raw(node, prop, tokens) {
	            var token = void 0,
	                type = void 0;
	            var length = tokens.length;
	            var value = '';
	            var clean = true;
	            for (var i = 0; i < length; i += 1) {
	                token = tokens[i];
	                type = token[0];
	                if (type === 'comment' || type === 'space' && i === length - 1) {
	                    clean = false;
	                } else {
	                    value += token[1];
	                }
	            }
	            if (!clean) {
	                var raw = tokens.reduce(function (all, i) {
	                    return all + i[1];
	                }, '');
	                node.raws[prop] = { value: value, raw: raw };
	            }
	            node[prop] = value;
	        }
	    }, {
	        key: 'spacesFromEnd',
	        value: function spacesFromEnd(tokens) {
	            var lastTokenType = void 0;
	            var spaces = '';
	            while (tokens.length) {
	                lastTokenType = tokens[tokens.length - 1][0];
	                if (lastTokenType !== 'space' && lastTokenType !== 'comment') break;
	                spaces = tokens.pop()[1] + spaces;
	            }
	            return spaces;
	        }
	    }, {
	        key: 'spacesFromStart',
	        value: function spacesFromStart(tokens) {
	            var next = void 0;
	            var spaces = '';
	            while (tokens.length) {
	                next = tokens[0][0];
	                if (next !== 'space' && next !== 'comment') break;
	                spaces += tokens.shift()[1];
	            }
	            return spaces;
	        }
	    }, {
	        key: 'stringFrom',
	        value: function stringFrom(tokens, from) {
	            var result = '';
	            for (var i = from; i < tokens.length; i++) {
	                result += tokens[i][1];
	            }
	            tokens.splice(from, tokens.length - from);
	            return result;
	        }
	    }, {
	        key: 'colon',
	        value: function colon(tokens) {
	            var brackets = 0;
	            var token = void 0,
	                type = void 0,
	                prev = void 0;
	            for (var i = 0; i < tokens.length; i++) {
	                token = tokens[i];
	                type = token[0];
	
	                if (type === '(') {
	                    brackets += 1;
	                } else if (type === ')') {
	                    brackets -= 1;
	                } else if (brackets === 0 && type === ':') {
	                    if (!prev) {
	                        this.doubleColon(token);
	                    } else if (prev[0] === 'word' && prev[1] === 'progid') {
	                        continue;
	                    } else {
	                        return i;
	                    }
	                }
	
	                prev = token;
	            }
	            return false;
	        }
	
	        // Errors
	
	    }, {
	        key: 'unclosedBracket',
	        value: function unclosedBracket(bracket) {
	            throw this.input.error('Unclosed bracket', bracket[2], bracket[3]);
	        }
	    }, {
	        key: 'unknownWord',
	        value: function unknownWord(start) {
	            var token = this.tokens[start];
	            throw this.input.error('Unknown word', token[2], token[3]);
	        }
	    }, {
	        key: 'unexpectedClose',
	        value: function unexpectedClose(token) {
	            throw this.input.error('Unexpected }', token[2], token[3]);
	        }
	    }, {
	        key: 'unclosedBlock',
	        value: function unclosedBlock() {
	            var pos = this.current.source.start;
	            throw this.input.error('Unclosed block', pos.line, pos.column);
	        }
	    }, {
	        key: 'doubleColon',
	        value: function doubleColon(token) {
	            throw this.input.error('Double colon', token[2], token[3]);
	        }
	    }, {
	        key: 'unnamedAtrule',
	        value: function unnamedAtrule(node, token) {
	            throw this.input.error('At-rule without name', token[2], token[3]);
	        }
	    }, {
	        key: 'precheckMissedSemicolon',
	        value: function precheckMissedSemicolon(tokens) {
	            // Hook for Safe Parser
	            tokens;
	        }
	    }, {
	        key: 'checkMissedSemicolon',
	        value: function checkMissedSemicolon(tokens) {
	            var colon = this.colon(tokens);
	            if (colon === false) return;
	
	            var founded = 0;
	            var token = void 0;
	            for (var j = colon - 1; j >= 0; j--) {
	                token = tokens[j];
	                if (token[0] !== 'space') {
	                    founded += 1;
	                    if (founded === 2) break;
	                }
	            }
	            throw this.input.error('Missed semicolon', token[2], token[3]);
	        }
	    }]);
	
	    return Parser;
	}();
	
	exports.default = Parser;
	module.exports = exports['default'];

/***/ },
/* 545 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable valid-jsdoc */
	
	var defaultRaw = {
	    colon: ': ',
	    indent: '    ',
	    beforeDecl: '\n',
	    beforeRule: '\n',
	    beforeOpen: ' ',
	    beforeClose: '\n',
	    beforeComment: '\n',
	    after: '\n',
	    emptyBody: '',
	    commentLeft: ' ',
	    commentRight: ' '
	};
	
	function capitalize(str) {
	    return str[0].toUpperCase() + str.slice(1);
	}
	
	var Stringifier = function () {
	    function Stringifier(builder) {
	        _classCallCheck(this, Stringifier);
	
	        this.builder = builder;
	    }
	
	    _createClass(Stringifier, [{
	        key: 'stringify',
	        value: function stringify(node, semicolon) {
	            this[node.type](node, semicolon);
	        }
	    }, {
	        key: 'root',
	        value: function root(node) {
	            this.body(node);
	            if (node.raws.after) this.builder(node.raws.after);
	        }
	    }, {
	        key: 'comment',
	        value: function comment(node) {
	            var left = this.raw(node, 'left', 'commentLeft');
	            var right = this.raw(node, 'right', 'commentRight');
	            this.builder('/*' + left + node.text + right + '*/', node);
	        }
	    }, {
	        key: 'decl',
	        value: function decl(node, semicolon) {
	            var between = this.raw(node, 'between', 'colon');
	            var string = node.prop + between + this.rawValue(node, 'value');
	
	            if (node.important) {
	                string += node.raws.important || ' !important';
	            }
	
	            if (semicolon) string += ';';
	            this.builder(string, node);
	        }
	    }, {
	        key: 'rule',
	        value: function rule(node) {
	            this.block(node, this.rawValue(node, 'selector'));
	        }
	    }, {
	        key: 'atrule',
	        value: function atrule(node, semicolon) {
	            var name = '@' + node.name;
	            var params = node.params ? this.rawValue(node, 'params') : '';
	
	            if (typeof node.raws.afterName !== 'undefined') {
	                name += node.raws.afterName;
	            } else if (params) {
	                name += ' ';
	            }
	
	            if (node.nodes) {
	                this.block(node, name + params);
	            } else {
	                var end = (node.raws.between || '') + (semicolon ? ';' : '');
	                this.builder(name + params + end, node);
	            }
	        }
	    }, {
	        key: 'body',
	        value: function body(node) {
	            var last = node.nodes.length - 1;
	            while (last > 0) {
	                if (node.nodes[last].type !== 'comment') break;
	                last -= 1;
	            }
	
	            var semicolon = this.raw(node, 'semicolon');
	            for (var i = 0; i < node.nodes.length; i++) {
	                var child = node.nodes[i];
	                var before = this.raw(child, 'before');
	                if (before) this.builder(before);
	                this.stringify(child, last !== i || semicolon);
	            }
	        }
	    }, {
	        key: 'block',
	        value: function block(node, start) {
	            var between = this.raw(node, 'between', 'beforeOpen');
	            this.builder(start + between + '{', node, 'start');
	
	            var after = void 0;
	            if (node.nodes && node.nodes.length) {
	                this.body(node);
	                after = this.raw(node, 'after');
	            } else {
	                after = this.raw(node, 'after', 'emptyBody');
	            }
	
	            if (after) this.builder(after);
	            this.builder('}', node, 'end');
	        }
	    }, {
	        key: 'raw',
	        value: function raw(node, own, detect) {
	            var value = void 0;
	            if (!detect) detect = own;
	
	            // Already had
	            if (own) {
	                value = node.raws[own];
	                if (typeof value !== 'undefined') return value;
	            }
	
	            var parent = node.parent;
	
	            // Hack for first rule in CSS
	            if (detect === 'before') {
	                if (!parent || parent.type === 'root' && parent.first === node) {
	                    return '';
	                }
	            }
	
	            // Floating child without parent
	            if (!parent) return defaultRaw[detect];
	
	            // Detect style by other nodes
	            var root = node.root();
	            if (!root.rawCache) root.rawCache = {};
	            if (typeof root.rawCache[detect] !== 'undefined') {
	                return root.rawCache[detect];
	            }
	
	            if (detect === 'before' || detect === 'after') {
	                return this.beforeAfter(node, detect);
	            } else {
	                var method = 'raw' + capitalize(detect);
	                if (this[method]) {
	                    value = this[method](root, node);
	                } else {
	                    root.walk(function (i) {
	                        value = i.raws[own];
	                        if (typeof value !== 'undefined') return false;
	                    });
	                }
	            }
	
	            if (typeof value === 'undefined') value = defaultRaw[detect];
	
	            root.rawCache[detect] = value;
	            return value;
	        }
	    }, {
	        key: 'rawSemicolon',
	        value: function rawSemicolon(root) {
	            var value = void 0;
	            root.walk(function (i) {
	                if (i.nodes && i.nodes.length && i.last.type === 'decl') {
	                    value = i.raws.semicolon;
	                    if (typeof value !== 'undefined') return false;
	                }
	            });
	            return value;
	        }
	    }, {
	        key: 'rawEmptyBody',
	        value: function rawEmptyBody(root) {
	            var value = void 0;
	            root.walk(function (i) {
	                if (i.nodes && i.nodes.length === 0) {
	                    value = i.raws.after;
	                    if (typeof value !== 'undefined') return false;
	                }
	            });
	            return value;
	        }
	    }, {
	        key: 'rawIndent',
	        value: function rawIndent(root) {
	            if (root.raws.indent) return root.raws.indent;
	            var value = void 0;
	            root.walk(function (i) {
	                var p = i.parent;
	                if (p && p !== root && p.parent && p.parent === root) {
	                    if (typeof i.raws.before !== 'undefined') {
	                        var parts = i.raws.before.split('\n');
	                        value = parts[parts.length - 1];
	                        value = value.replace(/[^\s]/g, '');
	                        return false;
	                    }
	                }
	            });
	            return value;
	        }
	    }, {
	        key: 'rawBeforeComment',
	        value: function rawBeforeComment(root, node) {
	            var value = void 0;
	            root.walkComments(function (i) {
	                if (typeof i.raws.before !== 'undefined') {
	                    value = i.raws.before;
	                    if (value.indexOf('\n') !== -1) {
	                        value = value.replace(/[^\n]+$/, '');
	                    }
	                    return false;
	                }
	            });
	            if (typeof value === 'undefined') {
	                value = this.raw(node, null, 'beforeDecl');
	            }
	            return value;
	        }
	    }, {
	        key: 'rawBeforeDecl',
	        value: function rawBeforeDecl(root, node) {
	            var value = void 0;
	            root.walkDecls(function (i) {
	                if (typeof i.raws.before !== 'undefined') {
	                    value = i.raws.before;
	                    if (value.indexOf('\n') !== -1) {
	                        value = value.replace(/[^\n]+$/, '');
	                    }
	                    return false;
	                }
	            });
	            if (typeof value === 'undefined') {
	                value = this.raw(node, null, 'beforeRule');
	            }
	            return value;
	        }
	    }, {
	        key: 'rawBeforeRule',
	        value: function rawBeforeRule(root) {
	            var value = void 0;
	            root.walk(function (i) {
	                if (i.nodes && (i.parent !== root || root.first !== i)) {
	                    if (typeof i.raws.before !== 'undefined') {
	                        value = i.raws.before;
	                        if (value.indexOf('\n') !== -1) {
	                            value = value.replace(/[^\n]+$/, '');
	                        }
	                        return false;
	                    }
	                }
	            });
	            return value;
	        }
	    }, {
	        key: 'rawBeforeClose',
	        value: function rawBeforeClose(root) {
	            var value = void 0;
	            root.walk(function (i) {
	                if (i.nodes && i.nodes.length > 0) {
	                    if (typeof i.raws.after !== 'undefined') {
	                        value = i.raws.after;
	                        if (value.indexOf('\n') !== -1) {
	                            value = value.replace(/[^\n]+$/, '');
	                        }
	                        return false;
	                    }
	                }
	            });
	            return value;
	        }
	    }, {
	        key: 'rawBeforeOpen',
	        value: function rawBeforeOpen(root) {
	            var value = void 0;
	            root.walk(function (i) {
	                if (i.type !== 'decl') {
	                    value = i.raws.between;
	                    if (typeof value !== 'undefined') return false;
	                }
	            });
	            return value;
	        }
	    }, {
	        key: 'rawColon',
	        value: function rawColon(root) {
	            var value = void 0;
	            root.walkDecls(function (i) {
	                if (typeof i.raws.between !== 'undefined') {
	                    value = i.raws.between.replace(/[^\s:]/g, '');
	                    return false;
	                }
	            });
	            return value;
	        }
	    }, {
	        key: 'beforeAfter',
	        value: function beforeAfter(node, detect) {
	            var value = void 0;
	            if (node.type === 'decl') {
	                value = this.raw(node, null, 'beforeDecl');
	            } else if (node.type === 'comment') {
	                value = this.raw(node, null, 'beforeComment');
	            } else if (detect === 'before') {
	                value = this.raw(node, null, 'beforeRule');
	            } else {
	                value = this.raw(node, null, 'beforeClose');
	            }
	
	            var buf = node.parent;
	            var depth = 0;
	            while (buf && buf.type !== 'root') {
	                depth += 1;
	                buf = buf.parent;
	            }
	
	            if (value.indexOf('\n') !== -1) {
	                var indent = this.raw(node, null, 'indent');
	                if (indent.length) {
	                    for (var step = 0; step < depth; step++) {
	                        value += indent;
	                    }
	                }
	            }
	
	            return value;
	        }
	    }, {
	        key: 'rawValue',
	        value: function rawValue(node, prop) {
	            var value = node[prop];
	            var raw = node.raws[prop];
	            if (raw && raw.value === value) {
	                return raw.raw;
	            } else {
	                return value;
	            }
	        }
	    }]);
	
	    return Stringifier;
	}();
	
	exports.default = Stringifier;
	module.exports = exports['default'];

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = stringify;
	
	var _stringifier = __webpack_require__(545);
	
	var _stringifier2 = _interopRequireDefault(_stringifier);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stringify(node, builder) {
	    var str = new _stringifier2.default(builder);
	    str.stringify(node);
	}
	module.exports = exports['default'];

/***/ },
/* 547 */
[1182, 1175],
/* 548 */
/***/ function(module, exports) {

	"use strict";
	
	function transmitter() {
	  var subscriptions = [];
	  var nowDispatching = false;
	  var toUnsubscribe = {};
	
	  var unsubscribe = function unsubscribe(onChange) {
	    var id = subscriptions.indexOf(onChange);
	    if (id < 0) return;
	    if (nowDispatching) {
	      toUnsubscribe[id] = onChange;
	      return;
	    }
	    subscriptions.splice(id, 1);
	  };
	
	  var subscribe = function subscribe(onChange) {
	    var id = subscriptions.push(onChange);
	    var dispose = function dispose() {
	      return unsubscribe(onChange);
	    };
	    return { dispose: dispose };
	  };
	
	  var publish = function publish() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    nowDispatching = true;
	    try {
	      subscriptions.forEach(function (subscription, id) {
	        return toUnsubscribe[id] || subscription.apply(undefined, args);
	      });
	    } finally {
	      nowDispatching = false;
	      Object.keys(toUnsubscribe).forEach(function (id) {
	        return unsubscribe(toUnsubscribe[id]);
	      });
	      toUnsubscribe = {};
	    }
	  };
	
	  return {
	    publish: publish,
	    subscribe: subscribe,
	    $subscriptions: subscriptions
	  };
	}
	
	module.exports = transmitter;

/***/ },
/* 549 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.isPojo = isPojo;
	exports.isPromise = isPromise;
	exports.eachObject = eachObject;
	exports.assign = assign;
	var isFunction = function isFunction(x) {
	  return typeof x === 'function';
	};
	
	exports.isFunction = isFunction;
	
	function isPojo(target) {
	  var Ctor = target.constructor;
	
	  return !!target && typeof target === 'object' && Object.prototype.toString.call(target) === '[object Object]' && isFunction(Ctor) && (Ctor instanceof Ctor || target.type === 'AltStore');
	}
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}
	
	function eachObject(f, o) {
	  o.forEach(function (from) {
	    Object.keys(Object(from)).forEach(function (key) {
	      f(key, from[key]);
	    });
	  });
	}
	
	function assign(target) {
	  for (var _len = arguments.length, source = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    source[_key - 1] = arguments[_key];
	  }
	
	  eachObject(function (key, value) {
	    return target[key] = value;
	  }, source);
	  return target;
	}

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = makeAction;
	
	var _functions = __webpack_require__(79);
	
	var fn = _interopRequireWildcard(_functions);
	
	var _AltUtils = __webpack_require__(180);
	
	var utils = _interopRequireWildcard(_AltUtils);
	
	var _isPromise = __webpack_require__(689);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function makeAction(alt, namespace, name, implementation, obj) {
	  var id = utils.uid(alt._actionsRegistry, String(namespace) + '.' + String(name));
	  alt._actionsRegistry[id] = 1;
	
	  var data = { id: id, namespace: namespace, name: name };
	
	  var dispatch = function dispatch(payload) {
	    return alt.dispatch(id, payload, data);
	  };
	
	  // the action itself
	  var action = function action() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var invocationResult = implementation.apply(obj, args);
	    var actionResult = invocationResult;
	
	    // async functions that return promises should not be dispatched
	    if (invocationResult !== undefined && !(0, _isPromise2['default'])(invocationResult)) {
	      if (fn.isFunction(invocationResult)) {
	        // inner function result should be returned as an action result
	        actionResult = invocationResult(dispatch, alt);
	      } else {
	        dispatch(invocationResult);
	      }
	    }
	
	    if (invocationResult === undefined) {
	      utils.warn('An action was called but nothing was dispatched');
	    }
	
	    return actionResult;
	  };
	  action.defer = function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return setTimeout(function () {
	      return action.apply(null, args);
	    });
	  };
	  action.id = id;
	  action.data = data;
	
	  // ensure each reference is unique in the namespace
	  var container = alt.actions[namespace];
	  var namespaceId = utils.uid(container, name);
	  container[namespaceId] = action;
	
	  // generate a constant
	  var constant = utils.formatAsConstant(namespaceId);
	  container[constant] = id;
	
	  return action;
	}
	module.exports = exports['default'];

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _flux = __webpack_require__(651);
	
	var _StateFunctions = __webpack_require__(555);
	
	var StateFunctions = _interopRequireWildcard(_StateFunctions);
	
	var _functions = __webpack_require__(79);
	
	var fn = _interopRequireWildcard(_functions);
	
	var _store = __webpack_require__(554);
	
	var store = _interopRequireWildcard(_store);
	
	var _AltUtils = __webpack_require__(180);
	
	var utils = _interopRequireWildcard(_AltUtils);
	
	var _actions = __webpack_require__(550);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* global window */
	
	
	var Alt = function () {
	  function Alt() {
	    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, Alt);
	
	    this.config = config;
	    this.serialize = config.serialize || JSON.stringify;
	    this.deserialize = config.deserialize || JSON.parse;
	    this.dispatcher = config.dispatcher || new _flux.Dispatcher();
	    this.batchingFunction = config.batchingFunction || function (callback) {
	      return callback();
	    };
	    this.actions = { global: {} };
	    this.stores = {};
	    this.storeTransforms = config.storeTransforms || [];
	    this.trapAsync = false;
	    this._actionsRegistry = {};
	    this._initSnapshot = {};
	    this._lastSnapshot = {};
	  }
	
	  Alt.prototype.dispatch = function () {
	    function dispatch(action, data, details) {
	      var _this = this;
	
	      this.batchingFunction(function () {
	        var id = Math.random().toString(18).substr(2, 16);
	
	        // support straight dispatching of FSA-style actions
	        if (action.hasOwnProperty('type') && action.hasOwnProperty('payload')) {
	          var fsaDetails = {
	            id: action.type,
	            namespace: action.type,
	            name: action.type
	          };
	          return _this.dispatcher.dispatch(utils.fsa(id, action.type, action.payload, fsaDetails));
	        }
	
	        if (action.id && action.dispatch) {
	          return utils.dispatch(id, action, data, _this);
	        }
	
	        return _this.dispatcher.dispatch(utils.fsa(id, action, data, details));
	      });
	    }
	
	    return dispatch;
	  }();
	
	  Alt.prototype.createUnsavedStore = function () {
	    function createUnsavedStore(StoreModel) {
	      var key = StoreModel.displayName || '';
	      store.createStoreConfig(this.config, StoreModel);
	      var Store = store.transformStore(this.storeTransforms, StoreModel);
	
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return fn.isFunction(Store) ? store.createStoreFromClass.apply(store, [this, Store, key].concat(args)) : store.createStoreFromObject(this, Store, key);
	    }
	
	    return createUnsavedStore;
	  }();
	
	  Alt.prototype.createStore = function () {
	    function createStore(StoreModel, iden) {
	      var key = iden || StoreModel.displayName || StoreModel.name || '';
	      store.createStoreConfig(this.config, StoreModel);
	      var Store = store.transformStore(this.storeTransforms, StoreModel);
	
	      /* istanbul ignore next */
	      if (false) delete this.stores[key];
	
	      if (this.stores[key] || !key) {
	        if (this.stores[key]) {
	          utils.warn('A store named ' + String(key) + ' already exists, double check your store ' + 'names or pass in your own custom identifier for each store');
	        } else {
	          utils.warn('Store name was not specified');
	        }
	
	        key = utils.uid(this.stores, key);
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      var storeInstance = fn.isFunction(Store) ? store.createStoreFromClass.apply(store, [this, Store, key].concat(args)) : store.createStoreFromObject(this, Store, key);
	
	      this.stores[key] = storeInstance;
	      StateFunctions.saveInitialSnapshot(this, key);
	
	      return storeInstance;
	    }
	
	    return createStore;
	  }();
	
	  Alt.prototype.generateActions = function () {
	    function generateActions() {
	      var actions = { name: 'global' };
	
	      for (var _len3 = arguments.length, actionNames = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        actionNames[_key3] = arguments[_key3];
	      }
	
	      return this.createActions(actionNames.reduce(function (obj, action) {
	        obj[action] = utils.dispatchIdentity;
	        return obj;
	      }, actions));
	    }
	
	    return generateActions;
	  }();
	
	  Alt.prototype.createAction = function () {
	    function createAction(name, implementation, obj) {
	      return (0, _actions2['default'])(this, 'global', name, implementation, obj);
	    }
	
	    return createAction;
	  }();
	
	  Alt.prototype.createActions = function () {
	    function createActions(ActionsClass) {
	      var _this3 = this;
	
	      var exportObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      var actions = {};
	      var key = utils.uid(this._actionsRegistry, ActionsClass.displayName || ActionsClass.name || 'Unknown');
	
	      if (fn.isFunction(ActionsClass)) {
	        fn.assign(actions, utils.getPrototypeChain(ActionsClass));
	
	        var ActionsGenerator = function (_ActionsClass) {
	          _inherits(ActionsGenerator, _ActionsClass);
	
	          function ActionsGenerator() {
	            _classCallCheck(this, ActionsGenerator);
	
	            for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	              args[_key5] = arguments[_key5];
	            }
	
	            return _possibleConstructorReturn(this, _ActionsClass.call.apply(_ActionsClass, [this].concat(args)));
	          }
	
	          ActionsGenerator.prototype.generateActions = function () {
	            function generateActions() {
	              for (var _len6 = arguments.length, actionNames = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	                actionNames[_key6] = arguments[_key6];
	              }
	
	              actionNames.forEach(function (actionName) {
	                actions[actionName] = utils.dispatchIdentity;
	              });
	            }
	
	            return generateActions;
	          }();
	
	          return ActionsGenerator;
	        }(ActionsClass);
	
	        for (var _len4 = arguments.length, argsForConstructor = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
	          argsForConstructor[_key4 - 2] = arguments[_key4];
	        }
	
	        fn.assign(actions, new (Function.prototype.bind.apply(ActionsGenerator, [null].concat(argsForConstructor)))());
	      } else {
	        fn.assign(actions, ActionsClass);
	      }
	
	      this.actions[key] = this.actions[key] || {};
	
	      fn.eachObject(function (actionName, action) {
	        if (!fn.isFunction(action)) {
	          exportObj[actionName] = action;
	          return;
	        }
	
	        // create the action
	        exportObj[actionName] = (0, _actions2['default'])(_this3, key, actionName, action, exportObj);
	
	        // generate a constant
	        var constant = utils.formatAsConstant(actionName);
	        exportObj[constant] = exportObj[actionName].id;
	      }, [actions]);
	
	      return exportObj;
	    }
	
	    return createActions;
	  }();
	
	  Alt.prototype.takeSnapshot = function () {
	    function takeSnapshot() {
	      for (var _len7 = arguments.length, storeNames = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        storeNames[_key7] = arguments[_key7];
	      }
	
	      var state = StateFunctions.snapshot(this, storeNames);
	      fn.assign(this._lastSnapshot, state);
	      return this.serialize(state);
	    }
	
	    return takeSnapshot;
	  }();
	
	  Alt.prototype.rollback = function () {
	    function rollback() {
	      StateFunctions.setAppState(this, this.serialize(this._lastSnapshot), function (storeInst) {
	        storeInst.lifecycle('rollback');
	        storeInst.emitChange();
	      });
	    }
	
	    return rollback;
	  }();
	
	  Alt.prototype.recycle = function () {
	    function recycle() {
	      for (var _len8 = arguments.length, storeNames = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	        storeNames[_key8] = arguments[_key8];
	      }
	
	      var initialSnapshot = storeNames.length ? StateFunctions.filterSnapshots(this, this._initSnapshot, storeNames) : this._initSnapshot;
	
	      StateFunctions.setAppState(this, this.serialize(initialSnapshot), function (storeInst) {
	        storeInst.lifecycle('init');
	        storeInst.emitChange();
	      });
	    }
	
	    return recycle;
	  }();
	
	  Alt.prototype.flush = function () {
	    function flush() {
	      var state = this.serialize(StateFunctions.snapshot(this));
	      this.recycle();
	      return state;
	    }
	
	    return flush;
	  }();
	
	  Alt.prototype.bootstrap = function () {
	    function bootstrap(data) {
	      StateFunctions.setAppState(this, data, function (storeInst, state) {
	        storeInst.lifecycle('bootstrap', state);
	        storeInst.emitChange();
	      });
	    }
	
	    return bootstrap;
	  }();
	
	  Alt.prototype.prepare = function () {
	    function prepare(storeInst, payload) {
	      var data = {};
	      if (!storeInst.displayName) {
	        throw new ReferenceError('Store provided does not have a name');
	      }
	      data[storeInst.displayName] = payload;
	      return this.serialize(data);
	    }
	
	    return prepare;
	  }();
	
	  // Instance type methods for injecting alt into your application as context
	
	  Alt.prototype.addActions = function () {
	    function addActions(name, ActionsClass) {
	      for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
	        args[_key9 - 2] = arguments[_key9];
	      }
	
	      this.actions[name] = Array.isArray(ActionsClass) ? this.generateActions.apply(this, ActionsClass) : this.createActions.apply(this, [ActionsClass].concat(args));
	    }
	
	    return addActions;
	  }();
	
	  Alt.prototype.addStore = function () {
	    function addStore(name, StoreModel) {
	      for (var _len10 = arguments.length, args = Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
	        args[_key10 - 2] = arguments[_key10];
	      }
	
	      this.createStore.apply(this, [StoreModel, name].concat(args));
	    }
	
	    return addStore;
	  }();
	
	  Alt.prototype.getActions = function () {
	    function getActions(name) {
	      return this.actions[name];
	    }
	
	    return getActions;
	  }();
	
	  Alt.prototype.getStore = function () {
	    function getStore(name) {
	      return this.stores[name];
	    }
	
	    return getStore;
	  }();
	
	  Alt.debug = function () {
	    function debug(name, alt, win) {
	      var key = 'alt.js.org';
	      var context = win;
	      if (!context && typeof window !== 'undefined') {
	        context = window;
	      }
	      if (typeof context !== 'undefined') {
	        context[key] = context[key] || [];
	        context[key].push({ name: name, alt: alt });
	      }
	      return alt;
	    }
	
	    return debug;
	  }();
	
	  return Alt;
	}();
	
	exports['default'] = Alt;
	module.exports = exports['default'];

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _functions = __webpack_require__(79);
	
	var fn = _interopRequireWildcard(_functions);
	
	var _transmitter = __webpack_require__(548);
	
	var _transmitter2 = _interopRequireDefault(_transmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AltStore = function () {
	  function AltStore(alt, model, state, StoreModel) {
	    var _this = this;
	
	    _classCallCheck(this, AltStore);
	
	    var lifecycleEvents = model.lifecycleEvents;
	    this.transmitter = (0, _transmitter2['default'])();
	    this.lifecycle = function (event, x) {
	      if (lifecycleEvents[event]) lifecycleEvents[event].publish(x);
	    };
	    this.state = state;
	
	    this.alt = alt;
	    this.preventDefault = false;
	    this.displayName = model.displayName;
	    this.boundListeners = model.boundListeners;
	    this.StoreModel = StoreModel;
	    this.reduce = model.reduce || function (x) {
	      return x;
	    };
	    this.subscriptions = [];
	
	    var output = model.output || function (x) {
	      return x;
	    };
	
	    this.emitChange = function () {
	      return _this.transmitter.publish(output(_this.state));
	    };
	
	    var handleDispatch = function handleDispatch(f, payload) {
	      try {
	        return f();
	      } catch (e) {
	        if (model.handlesOwnErrors) {
	          _this.lifecycle('error', {
	            error: e,
	            payload: payload,
	            state: _this.state
	          });
	          return false;
	        }
	
	        throw e;
	      }
	    };
	
	    fn.assign(this, model.publicMethods);
	
	    // Register dispatcher
	    this.dispatchToken = alt.dispatcher.register(function (payload) {
	      _this.preventDefault = false;
	
	      _this.lifecycle('beforeEach', {
	        payload: payload,
	        state: _this.state
	      });
	
	      var actionHandlers = model.actionListeners[payload.action];
	
	      if (actionHandlers || model.otherwise) {
	        var result = void 0;
	
	        if (actionHandlers) {
	          result = handleDispatch(function () {
	            return actionHandlers.filter(Boolean).every(function (handler) {
	              return handler.call(model, payload.data, payload.action) !== false;
	            });
	          }, payload);
	        } else {
	          result = handleDispatch(function () {
	            return model.otherwise(payload.data, payload.action);
	          }, payload);
	        }
	
	        if (result !== false && !_this.preventDefault) _this.emitChange();
	      }
	
	      if (model.reduce) {
	        handleDispatch(function () {
	          var value = model.reduce(_this.state, payload);
	          if (value !== undefined) _this.state = value;
	        }, payload);
	        if (!_this.preventDefault) _this.emitChange();
	      }
	
	      _this.lifecycle('afterEach', {
	        payload: payload,
	        state: _this.state
	      });
	    });
	
	    this.lifecycle('init');
	  }
	
	  AltStore.prototype.listen = function () {
	    function listen(cb) {
	      var _this2 = this;
	
	      if (!fn.isFunction(cb)) throw new TypeError('listen expects a function');
	
	      var _transmitter$subscrib = this.transmitter.subscribe(cb);
	
	      var dispose = _transmitter$subscrib.dispose;
	
	      this.subscriptions.push({ cb: cb, dispose: dispose });
	      return function () {
	        _this2.lifecycle('unlisten');
	        dispose();
	      };
	    }
	
	    return listen;
	  }();
	
	  AltStore.prototype.unlisten = function () {
	    function unlisten(cb) {
	      this.lifecycle('unlisten');
	      this.subscriptions.filter(function (subscription) {
	        return subscription.cb === cb;
	      }).forEach(function (subscription) {
	        return subscription.dispose();
	      });
	    }
	
	    return unlisten;
	  }();
	
	  AltStore.prototype.getState = function () {
	    function getState() {
	      return this.StoreModel.config.getState.call(this, this.state);
	    }
	
	    return getState;
	  }();
	
	  return AltStore;
	}();
	
	exports['default'] = AltStore;
	module.exports = exports['default'];

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _transmitter = __webpack_require__(548);
	
	var _transmitter2 = _interopRequireDefault(_transmitter);
	
	var _functions = __webpack_require__(79);
	
	var fn = _interopRequireWildcard(_functions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var StoreMixin = {
	  waitFor: function () {
	    function waitFor() {
	      for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
	        sources[_key] = arguments[_key];
	      }
	
	      if (!sources.length) {
	        throw new ReferenceError('Dispatch tokens not provided');
	      }
	
	      var sourcesArray = sources;
	      if (sources.length === 1) {
	        sourcesArray = Array.isArray(sources[0]) ? sources[0] : sources;
	      }
	
	      var tokens = sourcesArray.map(function (source) {
	        return source.dispatchToken || source;
	      });
	
	      this.dispatcher.waitFor(tokens);
	    }
	
	    return waitFor;
	  }(),
	  exportAsync: function () {
	    function exportAsync(asyncMethods) {
	      this.registerAsync(asyncMethods);
	    }
	
	    return exportAsync;
	  }(),
	  registerAsync: function () {
	    function registerAsync(asyncDef) {
	      var _this = this;
	
	      var loadCounter = 0;
	
	      var asyncMethods = fn.isFunction(asyncDef) ? asyncDef(this.alt) : asyncDef;
	
	      var toExport = Object.keys(asyncMethods).reduce(function (publicMethods, methodName) {
	        var desc = asyncMethods[methodName];
	        var spec = fn.isFunction(desc) ? desc(_this) : desc;
	
	        var validHandlers = ['success', 'error', 'loading'];
	        validHandlers.forEach(function (handler) {
	          if (spec[handler] && !spec[handler].id) {
	            throw new Error(String(handler) + ' handler must be an action function');
	          }
	        });
	
	        publicMethods[methodName] = function () {
	          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	          }
	
	          var state = _this.getInstance().getState();
	          var value = spec.local && spec.local.apply(spec, [state].concat(args));
	          var shouldFetch = spec.shouldFetch ? spec.shouldFetch.apply(spec, [state].concat(args))
	          /*eslint-disable*/
	          : value == null;
	          /*eslint-enable*/
	          var intercept = spec.interceptResponse || function (x) {
	            return x;
	          };
	
	          var makeActionHandler = function () {
	            function makeActionHandler(action, isError) {
	              return function (x) {
	                var fire = function () {
	                  function fire() {
	                    loadCounter -= 1;
	                    action(intercept(x, action, args));
	                    if (isError) throw x;
	                    return x;
	                  }
	
	                  return fire;
	                }();
	                return _this.alt.trapAsync ? function () {
	                  return fire();
	                } : fire();
	              };
	            }
	
	            return makeActionHandler;
	          }();
	
	          // if we don't have it in cache then fetch it
	          if (shouldFetch) {
	            loadCounter += 1;
	            /* istanbul ignore else */
	            if (spec.loading) spec.loading(intercept(null, spec.loading, args));
	            return spec.remote.apply(spec, [state].concat(args)).then(makeActionHandler(spec.success), makeActionHandler(spec.error, 1));
	          }
	
	          // otherwise emit the change now
	          _this.emitChange();
	          return value;
	        };
	
	        return publicMethods;
	      }, {});
	
	      this.exportPublicMethods(toExport);
	      this.exportPublicMethods({
	        isLoading: function () {
	          function isLoading() {
	            return loadCounter > 0;
	          }
	
	          return isLoading;
	        }()
	      });
	    }
	
	    return registerAsync;
	  }(),
	  exportPublicMethods: function () {
	    function exportPublicMethods(methods) {
	      var _this2 = this;
	
	      fn.eachObject(function (methodName, value) {
	        if (!fn.isFunction(value)) {
	          throw new TypeError('exportPublicMethods expects a function');
	        }
	
	        _this2.publicMethods[methodName] = value;
	      }, [methods]);
	    }
	
	    return exportPublicMethods;
	  }(),
	  emitChange: function () {
	    function emitChange() {
	      this.getInstance().emitChange();
	    }
	
	    return emitChange;
	  }(),
	  on: function () {
	    function on(lifecycleEvent, handler) {
	      if (lifecycleEvent === 'error') this.handlesOwnErrors = true;
	      var bus = this.lifecycleEvents[lifecycleEvent] || (0, _transmitter2['default'])();
	      this.lifecycleEvents[lifecycleEvent] = bus;
	      return bus.subscribe(handler.bind(this));
	    }
	
	    return on;
	  }(),
	  bindAction: function () {
	    function bindAction(symbol, handler) {
	      if (!symbol) {
	        throw new ReferenceError('Invalid action reference passed in');
	      }
	      if (!fn.isFunction(handler)) {
	        throw new TypeError('bindAction expects a function');
	      }
	
	      // You can pass in the constant or the function itself
	      var key = symbol.id ? symbol.id : symbol;
	      this.actionListeners[key] = this.actionListeners[key] || [];
	      this.actionListeners[key].push(handler.bind(this));
	      this.boundListeners.push(key);
	    }
	
	    return bindAction;
	  }(),
	  bindActions: function () {
	    function bindActions(actions) {
	      var _this3 = this;
	
	      fn.eachObject(function (action, symbol) {
	        var matchFirstCharacter = /./;
	        var assumedEventHandler = action.replace(matchFirstCharacter, function (x) {
	          return 'on' + String(x[0].toUpperCase());
	        });
	
	        if (_this3[action] && _this3[assumedEventHandler]) {
	          // If you have both action and onAction
	          throw new ReferenceError('You have multiple action handlers bound to an action: ' + (String(action) + ' and ' + String(assumedEventHandler)));
	        }
	
	        var handler = _this3[action] || _this3[assumedEventHandler];
	        if (handler) {
	          _this3.bindAction(symbol, handler);
	        }
	      }, [actions]);
	    }
	
	    return bindActions;
	  }(),
	  bindListeners: function () {
	    function bindListeners(obj) {
	      var _this4 = this;
	
	      fn.eachObject(function (methodName, symbol) {
	        var listener = _this4[methodName];
	
	        if (!listener) {
	          throw new ReferenceError(String(methodName) + ' defined but does not exist in ' + String(_this4.displayName));
	        }
	
	        if (Array.isArray(symbol)) {
	          symbol.forEach(function (action) {
	            _this4.bindAction(action, listener);
	          });
	        } else {
	          _this4.bindAction(symbol, listener);
	        }
	      }, [obj]);
	    }
	
	    return bindListeners;
	  }()
	};
	
	exports['default'] = StoreMixin;
	module.exports = exports['default'];

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createStoreConfig = createStoreConfig;
	exports.transformStore = transformStore;
	exports.createStoreFromObject = createStoreFromObject;
	exports.createStoreFromClass = createStoreFromClass;
	
	var _AltUtils = __webpack_require__(180);
	
	var utils = _interopRequireWildcard(_AltUtils);
	
	var _functions = __webpack_require__(79);
	
	var fn = _interopRequireWildcard(_functions);
	
	var _AltStore = __webpack_require__(552);
	
	var _AltStore2 = _interopRequireDefault(_AltStore);
	
	var _StoreMixin = __webpack_require__(553);
	
	var _StoreMixin2 = _interopRequireDefault(_StoreMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function doSetState(store, storeInstance, state) {
	  if (!state) {
	    return;
	  }
	
	  var config = storeInstance.StoreModel.config;
	
	
	  var nextState = fn.isFunction(state) ? state(storeInstance.state) : state;
	
	  storeInstance.state = config.setState.call(store, storeInstance.state, nextState);
	
	  if (!store.alt.dispatcher.isDispatching()) {
	    store.emitChange();
	  }
	}
	
	function createPrototype(proto, alt, key, extras) {
	  return fn.assign(proto, _StoreMixin2['default'], {
	    displayName: key,
	    alt: alt,
	    dispatcher: alt.dispatcher,
	    preventDefault: function () {
	      function preventDefault() {
	        this.getInstance().preventDefault = true;
	      }
	
	      return preventDefault;
	    }(),
	
	    boundListeners: [],
	    lifecycleEvents: {},
	    actionListeners: {},
	    publicMethods: {},
	    handlesOwnErrors: false
	  }, extras);
	}
	
	function createStoreConfig(globalConfig, StoreModel) {
	  StoreModel.config = fn.assign({
	    getState: function () {
	      function getState(state) {
	        if (Array.isArray(state)) {
	          return state.slice();
	        } else if (fn.isMutableObject(state)) {
	          return fn.assign({}, state);
	        }
	
	        return state;
	      }
	
	      return getState;
	    }(),
	    setState: function () {
	      function setState(currentState, nextState) {
	        if (fn.isMutableObject(nextState)) {
	          return fn.assign(currentState, nextState);
	        }
	        return nextState;
	      }
	
	      return setState;
	    }()
	  }, globalConfig, StoreModel.config);
	}
	
	function transformStore(transforms, StoreModel) {
	  return transforms.reduce(function (Store, transform) {
	    return transform(Store);
	  }, StoreModel);
	}
	
	function createStoreFromObject(alt, StoreModel, key) {
	  var storeInstance = void 0;
	
	  var StoreProto = createPrototype({}, alt, key, fn.assign({
	    getInstance: function () {
	      function getInstance() {
	        return storeInstance;
	      }
	
	      return getInstance;
	    }(),
	    setState: function () {
	      function setState(nextState) {
	        doSetState(this, storeInstance, nextState);
	      }
	
	      return setState;
	    }()
	  }, StoreModel));
	
	  // bind the store listeners
	  /* istanbul ignore else */
	  if (StoreProto.bindListeners) {
	    _StoreMixin2['default'].bindListeners.call(StoreProto, StoreProto.bindListeners);
	  }
	  /* istanbul ignore else */
	  if (StoreProto.observe) {
	    _StoreMixin2['default'].bindListeners.call(StoreProto, StoreProto.observe(alt));
	  }
	
	  // bind the lifecycle events
	  /* istanbul ignore else */
	  if (StoreProto.lifecycle) {
	    fn.eachObject(function (eventName, event) {
	      _StoreMixin2['default'].on.call(StoreProto, eventName, event);
	    }, [StoreProto.lifecycle]);
	  }
	
	  // create the instance and fn.assign the public methods to the instance
	  storeInstance = fn.assign(new _AltStore2['default'](alt, StoreProto, StoreProto.state !== undefined ? StoreProto.state : {}, StoreModel), StoreProto.publicMethods, {
	    displayName: key,
	    config: StoreModel.config
	  });
	
	  return storeInstance;
	}
	
	function createStoreFromClass(alt, StoreModel, key) {
	  var storeInstance = void 0;
	  var config = StoreModel.config;
	
	  // Creating a class here so we don't overload the provided store's
	  // prototype with the mixin behaviour and I'm extending from StoreModel
	  // so we can inherit any extensions from the provided store.
	
	  var Store = function (_StoreModel) {
	    _inherits(Store, _StoreModel);
	
	    function Store() {
	      _classCallCheck(this, Store);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _possibleConstructorReturn(this, _StoreModel.call.apply(_StoreModel, [this].concat(args)));
	    }
	
	    return Store;
	  }(StoreModel);
	
	  createPrototype(Store.prototype, alt, key, {
	    type: 'AltStore',
	    getInstance: function () {
	      function getInstance() {
	        return storeInstance;
	      }
	
	      return getInstance;
	    }(),
	    setState: function () {
	      function setState(nextState) {
	        doSetState(this, storeInstance, nextState);
	      }
	
	      return setState;
	    }()
	  });
	
	  for (var _len = arguments.length, argsForClass = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    argsForClass[_key - 3] = arguments[_key];
	  }
	
	  var store = new (Function.prototype.bind.apply(Store, [null].concat(argsForClass)))();
	
	  /* istanbul ignore next */
	  if (config.bindListeners) store.bindListeners(config.bindListeners);
	  /* istanbul ignore next */
	  if (config.datasource) store.registerAsync(config.datasource);
	
	  storeInstance = fn.assign(new _AltStore2['default'](alt, store, store.state !== undefined ? store.state : store, StoreModel), utils.getInternalMethods(StoreModel), config.publicMethods, { displayName: key });
	
	  return storeInstance;
	}

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setAppState = setAppState;
	exports.snapshot = snapshot;
	exports.saveInitialSnapshot = saveInitialSnapshot;
	exports.filterSnapshots = filterSnapshots;
	
	var _functions = __webpack_require__(79);
	
	var fn = _interopRequireWildcard(_functions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function setAppState(instance, data, onStore) {
	  var obj = instance.deserialize(data);
	  fn.eachObject(function (key, value) {
	    var store = instance.stores[key];
	    if (store) {
	      (function () {
	        var config = store.StoreModel.config;
	
	        var state = store.state;
	        if (config.onDeserialize) obj[key] = config.onDeserialize(value) || value;
	        if (fn.isMutableObject(state)) {
	          fn.eachObject(function (k) {
	            return delete state[k];
	          }, [state]);
	          fn.assign(state, obj[key]);
	        } else {
	          store.state = obj[key];
	        }
	        onStore(store, store.state);
	      })();
	    }
	  }, [obj]);
	}
	
	function snapshot(instance) {
	  var storeNames = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	
	  var stores = storeNames.length ? storeNames : Object.keys(instance.stores);
	  return stores.reduce(function (obj, storeHandle) {
	    var storeName = storeHandle.displayName || storeHandle;
	    var store = instance.stores[storeName];
	    var config = store.StoreModel.config;
	
	    store.lifecycle('snapshot');
	    var customSnapshot = config.onSerialize && config.onSerialize(store.state);
	    obj[storeName] = customSnapshot ? customSnapshot : store.getState();
	    return obj;
	  }, {});
	}
	
	function saveInitialSnapshot(instance, key) {
	  var state = instance.deserialize(instance.serialize(instance.stores[key].state));
	  instance._initSnapshot[key] = state;
	  instance._lastSnapshot[key] = state;
	}
	
	function filterSnapshots(instance, state, stores) {
	  return stores.reduce(function (obj, store) {
	    var storeName = store.displayName || store;
	    if (!state[storeName]) {
	      throw new ReferenceError(String(storeName) + ' is not a valid store');
	    }
	    obj[storeName] = state[storeName];
	    return obj;
	  }, {});
	}

/***/ },
/* 556 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(558);

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(47);
	var bind = __webpack_require__(263);
	var Axios = __webpack_require__(560);
	var defaults = __webpack_require__(182);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(260);
	axios.CancelToken = __webpack_require__(559);
	axios.isCancel = __webpack_require__(261);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(574);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(260);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(182);
	var utils = __webpack_require__(47);
	var InterceptorManager = __webpack_require__(561);
	var dispatchRequest = __webpack_require__(562);
	var isAbsoluteURL = __webpack_require__(570);
	var combineURLs = __webpack_require__(568);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(47);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(47);
	var transformData = __webpack_require__(565);
	var isCancel = __webpack_require__(261);
	var defaults = __webpack_require__(182);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 563 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(262);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(47);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 566 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(47);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 568 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(47);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 570 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(47);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(47);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(47);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 574 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(581), __esModule: true };

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(582), __esModule: true };

/***/ },
/* 577 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(576);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(575);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(611);
	__webpack_require__(610);
	module.exports = __webpack_require__(606);


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(608);
	module.exports = __webpack_require__(104).Object.assign;


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(609);
	var $Object = __webpack_require__(104).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 583 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 584 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(190);
	var toLength = __webpack_require__(603);
	var toAbsoluteIndex = __webpack_require__(602);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(264);
	var TAG = __webpack_require__(91)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(583);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(90).document;
	module.exports = document && document.documentElement;


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(105) && !__webpack_require__(186)(function () {
	  return Object.defineProperty(__webpack_require__(265)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(594);
	var descriptor = __webpack_require__(270);
	var setToStringTag = __webpack_require__(271);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(106)(IteratorPrototype, __webpack_require__(91)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 591 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 592 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(269);
	var gOPS = __webpack_require__(596);
	var pIE = __webpack_require__(599);
	var toObject = __webpack_require__(273);
	var IObject = __webpack_require__(267);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(186)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(135);
	var dPs = __webpack_require__(595);
	var enumBugKeys = __webpack_require__(266);
	var IE_PROTO = __webpack_require__(188)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(265)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(588).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(138);
	var anObject = __webpack_require__(135);
	var getKeys = __webpack_require__(269);
	
	module.exports = __webpack_require__(105) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 596 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(136);
	var toObject = __webpack_require__(273);
	var IE_PROTO = __webpack_require__(188)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(136);
	var toIObject = __webpack_require__(190);
	var arrayIndexOf = __webpack_require__(585)(false);
	var IE_PROTO = __webpack_require__(188)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 599 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(106);


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(189);
	var defined = __webpack_require__(184);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(189);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(189);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(187);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(586);
	var ITERATOR = __webpack_require__(91)('iterator');
	var Iterators = __webpack_require__(137);
	module.exports = __webpack_require__(104).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(135);
	var get = __webpack_require__(605);
	module.exports = __webpack_require__(104).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(584);
	var step = __webpack_require__(591);
	var Iterators = __webpack_require__(137);
	var toIObject = __webpack_require__(190);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(268)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(185);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(593) });


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(185);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(105), 'Object', { defineProperty: __webpack_require__(138).f });


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(601)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(268)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(607);
	var global = __webpack_require__(90);
	var hide = __webpack_require__(106);
	var Iterators = __webpack_require__(137);
	var TO_STRING_TAG = __webpack_require__(91)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 612 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var SomePromiseArray = Promise._SomePromiseArray;
	function any(promises) {
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(1);
	    ret.setUnwrap();
	    ret.init();
	    return promise;
	}
	
	Promise.any = function (promises) {
	    return any(promises);
	};
	
	Promise.prototype.any = function () {
	    return any(this);
	};
	
	};


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = __webpack_require__(635);
	var Queue = __webpack_require__(632);
	var util = __webpack_require__(16);
	
	function Async() {
	    this._customScheduler = false;
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._haveDrainedQueues = false;
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule = schedule;
	}
	
	Async.prototype.setScheduler = function(fn) {
	    var prev = this._schedule;
	    this._schedule = fn;
	    this._customScheduler = true;
	    return prev;
	};
	
	Async.prototype.hasCustomScheduler = function() {
	    return this._customScheduler;
	};
	
	Async.prototype.enableTrampoline = function() {
	    this._trampolineEnabled = true;
	};
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._isTickUsed || this._haveDrainedQueues;
	};
	
	
	Async.prototype.fatalError = function(e, isNode) {
	    if (isNode) {
	        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
	            "\n");
	        process.exit(2);
	    } else {
	        this.throwLater(e);
	    }
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	Async.prototype._drainQueue = function(queue) {
	    while (queue.length() > 0) {
	        var fn = queue.shift();
	        if (typeof fn !== "function") {
	            fn._settlePromises();
	            continue;
	        }
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	};
	
	Async.prototype._drainQueues = function () {
	    this._drainQueue(this._normalQueue);
	    this._reset();
	    this._haveDrainedQueues = true;
	    this._drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = Async;
	module.exports.firstLineError = firstLineError;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ },
/* 614 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
	var calledBind = false;
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (((this._bitField & 50397184) === 0)) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    if (!calledBind) {
	        calledBind = true;
	        Promise.prototype._propagateFrom = debug.propagateFromFunction();
	        Promise.prototype._boundValue = debug.boundValueFunction();
	    }
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, undefined, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, undefined, ret, context);
	        ret._setOnCancel(maybePromise);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 2097152;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~2097152);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 2097152) === 2097152;
	};
	
	Promise.bind = function (thisArg, value) {
	    return Promise.resolve(value).bind(thisArg);
	};
	};


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var cr = Object.create;
	if (cr) {
	    var callerCache = cr(null);
	    var getterCache = cr(null);
	    callerCache[" size"] = getterCache[" size"] = 0;
	}
	
	module.exports = function(Promise) {
	var util = __webpack_require__(16);
	var canEvaluate = util.canEvaluate;
	var isIdentifier = util.isIdentifier;
	
	var getMethodCaller;
	var getGetter;
	if (true) {
	var makeMethodCaller = function (methodName) {
	    return new Function("ensureMethod", "                                    \n\
	        return function(obj) {                                               \n\
	            'use strict'                                                     \n\
	            var len = this.length;                                           \n\
	            ensureMethod(obj, 'methodName');                                 \n\
	            switch(len) {                                                    \n\
	                case 1: return obj.methodName(this[0]);                      \n\
	                case 2: return obj.methodName(this[0], this[1]);             \n\
	                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
	                case 0: return obj.methodName();                             \n\
	                default:                                                     \n\
	                    return obj.methodName.apply(obj, this);                  \n\
	            }                                                                \n\
	        };                                                                   \n\
	        ".replace(/methodName/g, methodName))(ensureMethod);
	};
	
	var makeGetter = function (propertyName) {
	    return new Function("obj", "                                             \n\
	        'use strict';                                                        \n\
	        return obj.propertyName;                                             \n\
	        ".replace("propertyName", propertyName));
	};
	
	var getCompiled = function(name, compiler, cache) {
	    var ret = cache[name];
	    if (typeof ret !== "function") {
	        if (!isIdentifier(name)) {
	            return null;
	        }
	        ret = compiler(name);
	        cache[name] = ret;
	        cache[" size"]++;
	        if (cache[" size"] > 512) {
	            var keys = Object.keys(cache);
	            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
	            cache[" size"] = keys.length - 256;
	        }
	    }
	    return ret;
	};
	
	getMethodCaller = function(name) {
	    return getCompiled(name, makeMethodCaller, callerCache);
	};
	
	getGetter = function(name) {
	    return getCompiled(name, makeGetter, getterCache);
	};
	}
	
	function ensureMethod(obj, methodName) {
	    var fn;
	    if (obj != null) fn = obj[methodName];
	    if (typeof fn !== "function") {
	        var message = "Object " + util.classString(obj) + " has no method '" +
	            util.toString(methodName) + "'";
	        throw new Promise.TypeError(message);
	    }
	    return fn;
	}
	
	function caller(obj) {
	    var methodName = this.pop();
	    var fn = ensureMethod(obj, methodName);
	    return fn.apply(obj, this);
	}
	Promise.prototype.call = function (methodName) {
	    var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	    if (true) {
	        if (canEvaluate) {
	            var maybeCaller = getMethodCaller(methodName);
	            if (maybeCaller !== null) {
	                return this._then(
	                    maybeCaller, undefined, undefined, args, undefined);
	            }
	        }
	    }
	    args.push(methodName);
	    return this._then(caller, undefined, undefined, args, undefined);
	};
	
	function namedGetter(obj) {
	    return obj[this];
	}
	function indexedGetter(obj) {
	    var index = +this;
	    if (index < 0) index = Math.max(0, index + obj.length);
	    return obj[index];
	}
	Promise.prototype.get = function (propertyName) {
	    var isIndex = (typeof propertyName === "number");
	    var getter;
	    if (!isIndex) {
	        if (canEvaluate) {
	            var maybeGetter = getGetter(propertyName);
	            getter = maybeGetter !== null ? maybeGetter : namedGetter;
	        } else {
	            getter = namedGetter;
	        }
	    } else {
	        getter = indexedGetter;
	    }
	    return this._then(getter, undefined, undefined, propertyName, undefined);
	};
	};


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, PromiseArray, apiRejection, debug) {
	var util = __webpack_require__(16);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	Promise.prototype["break"] = Promise.prototype.cancel = function() {
	    if (!debug.cancellation()) return this._warn("cancellation is disabled");
	
	    var promise = this;
	    var child = promise;
	    while (promise._isCancellable()) {
	        if (!promise._cancelBy(child)) {
	            if (child._isFollowing()) {
	                child._followee().cancel();
	            } else {
	                child._cancelBranched();
	            }
	            break;
	        }
	
	        var parent = promise._cancellationParent;
	        if (parent == null || !parent._isCancellable()) {
	            if (promise._isFollowing()) {
	                promise._followee().cancel();
	            } else {
	                promise._cancelBranched();
	            }
	            break;
	        } else {
	            if (promise._isFollowing()) promise._followee().cancel();
	            promise._setWillBeCancelled();
	            child = promise;
	            promise = parent;
	        }
	    }
	};
	
	Promise.prototype._branchHasCancelled = function() {
	    this._branchesRemainingToCancel--;
	};
	
	Promise.prototype._enoughBranchesHaveCancelled = function() {
	    return this._branchesRemainingToCancel === undefined ||
	           this._branchesRemainingToCancel <= 0;
	};
	
	Promise.prototype._cancelBy = function(canceller) {
	    if (canceller === this) {
	        this._branchesRemainingToCancel = 0;
	        this._invokeOnCancel();
	        return true;
	    } else {
	        this._branchHasCancelled();
	        if (this._enoughBranchesHaveCancelled()) {
	            this._invokeOnCancel();
	            return true;
	        }
	    }
	    return false;
	};
	
	Promise.prototype._cancelBranched = function() {
	    if (this._enoughBranchesHaveCancelled()) {
	        this._cancel();
	    }
	};
	
	Promise.prototype._cancel = function() {
	    if (!this._isCancellable()) return;
	    this._setCancelled();
	    async.invoke(this._cancelPromises, this, undefined);
	};
	
	Promise.prototype._cancelPromises = function() {
	    if (this._length() > 0) this._settlePromises();
	};
	
	Promise.prototype._unsetOnCancel = function() {
	    this._onCancelField = undefined;
	};
	
	Promise.prototype._isCancellable = function() {
	    return this.isPending() && !this._isCancelled();
	};
	
	Promise.prototype.isCancellable = function() {
	    return this.isPending() && !this.isCancelled();
	};
	
	Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
	    if (util.isArray(onCancelCallback)) {
	        for (var i = 0; i < onCancelCallback.length; ++i) {
	            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
	        }
	    } else if (onCancelCallback !== undefined) {
	        if (typeof onCancelCallback === "function") {
	            if (!internalOnly) {
	                var e = tryCatch(onCancelCallback).call(this._boundValue());
	                if (e === errorObj) {
	                    this._attachExtraTrace(e.e);
	                    async.throwLater(e.e);
	                }
	            }
	        } else {
	            onCancelCallback._resultCancelled(this);
	        }
	    }
	};
	
	Promise.prototype._invokeOnCancel = function() {
	    var onCancelCallback = this._onCancel();
	    this._unsetOnCancel();
	    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
	};
	
	Promise.prototype._invokeInternalOnCancel = function() {
	    if (this._isCancellable()) {
	        this._doInvokeOnCancel(this._onCancel(), true);
	        this._unsetOnCancel();
	    }
	};
	
	Promise.prototype._resultCancelled = function() {
	    this.cancel();
	};
	
	};


/***/ },
/* 617 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var longStackTraces = false;
	var contextStack = [];
	
	Promise.prototype._promiseCreated = function() {};
	Promise.prototype._pushContext = function() {};
	Promise.prototype._popContext = function() {return null;};
	Promise._peekContext = Promise.prototype._peekContext = function() {};
	
	function Context() {
	    this._trace = new Context.CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (this._trace !== undefined) {
	        this._trace._promiseCreated = null;
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (this._trace !== undefined) {
	        var trace = contextStack.pop();
	        var ret = trace._promiseCreated;
	        trace._promiseCreated = null;
	        return ret;
	    }
	    return null;
	};
	
	function createContext() {
	    if (longStackTraces) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	Context.CapturedTrace = null;
	Context.create = createContext;
	Context.deactivateLongStackTraces = function() {};
	Context.activateLongStackTraces = function() {
	    var Promise_pushContext = Promise.prototype._pushContext;
	    var Promise_popContext = Promise.prototype._popContext;
	    var Promise_PeekContext = Promise._peekContext;
	    var Promise_peekContext = Promise.prototype._peekContext;
	    var Promise_promiseCreated = Promise.prototype._promiseCreated;
	    Context.deactivateLongStackTraces = function() {
	        Promise.prototype._pushContext = Promise_pushContext;
	        Promise.prototype._popContext = Promise_popContext;
	        Promise._peekContext = Promise_PeekContext;
	        Promise.prototype._peekContext = Promise_peekContext;
	        Promise.prototype._promiseCreated = Promise_promiseCreated;
	        longStackTraces = false;
	    };
	    longStackTraces = true;
	    Promise.prototype._pushContext = Context.prototype._pushContext;
	    Promise.prototype._popContext = Context.prototype._popContext;
	    Promise._peekContext = Promise.prototype._peekContext = peekContext;
	    Promise.prototype._promiseCreated = function() {
	        var ctx = this._peekContext();
	        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
	    };
	};
	return Context;
	};


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function(Promise, Context) {
	var getDomain = Promise._getDomain;
	var async = Promise._async;
	var Warning = __webpack_require__(68).Warning;
	var util = __webpack_require__(16);
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
	var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
	var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var printWarning;
	var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
	                        (false ||
	                         util.env("BLUEBIRD_DEBUG") ||
	                         util.env("NODE_ENV") === "development"));
	
	var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
	    (debugging || util.env("BLUEBIRD_WARNINGS")));
	
	var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
	    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
	
	var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
	    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
	
	Promise.prototype.suppressUnhandledRejections = function() {
	    var target = this._target();
	    target._bitField = ((target._bitField & (~1048576)) |
	                      524288);
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 524288) !== 0) return;
	    this._setRejectionIsUnhandled();
	    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._setReturnedNonUndefined = function() {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._returnedNonUndefined = function() {
	    return (this._bitField & 268435456) !== 0;
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._settledValue();
	        this._setUnhandledRejectionIsNotified();
	        fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 262144;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~262144);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 262144) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 1048576;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~1048576);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
	    return warn(message, shouldUseOwnTrace, promise || this);
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	var disableLongStackTraces = function() {};
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() && !config.longStackTraces) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (!config.longStackTraces && longStackTracesIsSupported()) {
	        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
	        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
	        config.longStackTraces = true;
	        disableLongStackTraces = function() {
	            if (async.haveItemsQueued() && !config.longStackTraces) {
	                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	            }
	            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
	            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
	            Context.deactivateLongStackTraces();
	            async.enableTrampoline();
	            config.longStackTraces = false;
	        };
	        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
	        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
	        Context.activateLongStackTraces();
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return config.longStackTraces && longStackTracesIsSupported();
	};
	
	var fireDomEvent = (function() {
	    try {
	        if (typeof CustomEvent === "function") {
	            var event = new CustomEvent("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = new CustomEvent(name.toLowerCase(), {
	                    detail: event,
	                    cancelable: true
	                });
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else if (typeof Event === "function") {
	            var event = new Event("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = new Event(name.toLowerCase(), {
	                    cancelable: true
	                });
	                domEvent.detail = event;
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else {
	            var event = document.createEvent("CustomEvent");
	            event.initCustomEvent("testingtheevent", false, true, {});
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = document.createEvent("CustomEvent");
	                domEvent.initCustomEvent(name.toLowerCase(), false, true,
	                    event);
	                return !util.global.dispatchEvent(domEvent);
	            };
	        }
	    } catch (e) {}
	    return function() {
	        return false;
	    };
	})();
	
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function() {
	            return process.emit.apply(process, arguments);
	        };
	    } else {
	        if (!util.global) {
	            return function() {
	                return false;
	            };
	        }
	        return function(name) {
	            var methodName = "on" + name.toLowerCase();
	            var method = util.global[methodName];
	            if (!method) return false;
	            method.apply(util.global, [].slice.call(arguments, 1));
	            return true;
	        };
	    }
	})();
	
	function generatePromiseLifecycleEventObject(name, promise) {
	    return {promise: promise};
	}
	
	var eventToObjectGenerator = {
	    promiseCreated: generatePromiseLifecycleEventObject,
	    promiseFulfilled: generatePromiseLifecycleEventObject,
	    promiseRejected: generatePromiseLifecycleEventObject,
	    promiseResolved: generatePromiseLifecycleEventObject,
	    promiseCancelled: generatePromiseLifecycleEventObject,
	    promiseChained: function(name, promise, child) {
	        return {promise: promise, child: child};
	    },
	    warning: function(name, warning) {
	        return {warning: warning};
	    },
	    unhandledRejection: function (name, reason, promise) {
	        return {reason: reason, promise: promise};
	    },
	    rejectionHandled: generatePromiseLifecycleEventObject
	};
	
	var activeFireEvent = function (name) {
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent.apply(null, arguments);
	    } catch (e) {
	        async.throwLater(e);
	        globalEventFired = true;
	    }
	
	    var domEventFired = false;
	    try {
	        domEventFired = fireDomEvent(name,
	                    eventToObjectGenerator[name].apply(null, arguments));
	    } catch (e) {
	        async.throwLater(e);
	        domEventFired = true;
	    }
	
	    return domEventFired || globalEventFired;
	};
	
	Promise.config = function(opts) {
	    opts = Object(opts);
	    if ("longStackTraces" in opts) {
	        if (opts.longStackTraces) {
	            Promise.longStackTraces();
	        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
	            disableLongStackTraces();
	        }
	    }
	    if ("warnings" in opts) {
	        var warningsOption = opts.warnings;
	        config.warnings = !!warningsOption;
	        wForgottenReturn = config.warnings;
	
	        if (util.isObject(warningsOption)) {
	            if ("wForgottenReturn" in warningsOption) {
	                wForgottenReturn = !!warningsOption.wForgottenReturn;
	            }
	        }
	    }
	    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
	        if (async.haveItemsQueued()) {
	            throw new Error(
	                "cannot enable cancellation after promises are in use");
	        }
	        Promise.prototype._clearCancellationData =
	            cancellationClearCancellationData;
	        Promise.prototype._propagateFrom = cancellationPropagateFrom;
	        Promise.prototype._onCancel = cancellationOnCancel;
	        Promise.prototype._setOnCancel = cancellationSetOnCancel;
	        Promise.prototype._attachCancellationCallback =
	            cancellationAttachCancellationCallback;
	        Promise.prototype._execute = cancellationExecute;
	        propagateFromFunction = cancellationPropagateFrom;
	        config.cancellation = true;
	    }
	    if ("monitoring" in opts) {
	        if (opts.monitoring && !config.monitoring) {
	            config.monitoring = true;
	            Promise.prototype._fireEvent = activeFireEvent;
	        } else if (!opts.monitoring && config.monitoring) {
	            config.monitoring = false;
	            Promise.prototype._fireEvent = defaultFireEvent;
	        }
	    }
	    return Promise;
	};
	
	function defaultFireEvent() { return false; }
	
	Promise.prototype._fireEvent = defaultFireEvent;
	Promise.prototype._execute = function(executor, resolve, reject) {
	    try {
	        executor(resolve, reject);
	    } catch (e) {
	        return e;
	    }
	};
	Promise.prototype._onCancel = function () {};
	Promise.prototype._setOnCancel = function (handler) { ; };
	Promise.prototype._attachCancellationCallback = function(onCancel) {
	    ;
	};
	Promise.prototype._captureStackTrace = function () {};
	Promise.prototype._attachExtraTrace = function () {};
	Promise.prototype._clearCancellationData = function() {};
	Promise.prototype._propagateFrom = function (parent, flags) {
	    ;
	    ;
	};
	
	function cancellationExecute(executor, resolve, reject) {
	    var promise = this;
	    try {
	        executor(resolve, reject, function(onCancel) {
	            if (typeof onCancel !== "function") {
	                throw new TypeError("onCancel must be a function, got: " +
	                                    util.toString(onCancel));
	            }
	            promise._attachCancellationCallback(onCancel);
	        });
	    } catch (e) {
	        return e;
	    }
	}
	
	function cancellationAttachCancellationCallback(onCancel) {
	    if (!this._isCancellable()) return this;
	
	    var previousOnCancel = this._onCancel();
	    if (previousOnCancel !== undefined) {
	        if (util.isArray(previousOnCancel)) {
	            previousOnCancel.push(onCancel);
	        } else {
	            this._setOnCancel([previousOnCancel, onCancel]);
	        }
	    } else {
	        this._setOnCancel(onCancel);
	    }
	}
	
	function cancellationOnCancel() {
	    return this._onCancelField;
	}
	
	function cancellationSetOnCancel(onCancel) {
	    this._onCancelField = onCancel;
	}
	
	function cancellationClearCancellationData() {
	    this._cancellationParent = undefined;
	    this._onCancelField = undefined;
	}
	
	function cancellationPropagateFrom(parent, flags) {
	    if ((flags & 1) !== 0) {
	        this._cancellationParent = parent;
	        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
	        if (branchesRemainingToCancel === undefined) {
	            branchesRemainingToCancel = 0;
	        }
	        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
	    }
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	
	function bindingPropagateFrom(parent, flags) {
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	var propagateFromFunction = bindingPropagateFrom;
	
	function boundValueFunction() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	}
	
	function longStackTracesCaptureStackTrace() {
	    this._trace = new CapturedTrace(this._peekContext());
	}
	
	function longStackTracesAttachExtraTrace(error, ignoreSelf) {
	    if (canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	}
	
	function checkForgottenReturns(returnValue, promiseCreated, name, promise,
	                               parent) {
	    if (returnValue === undefined && promiseCreated !== null &&
	        wForgottenReturn) {
	        if (parent !== undefined && parent._returnedNonUndefined()) return;
	        if ((promise._bitField & 65535) === 0) return;
	
	        if (name) name = name + " ";
	        var handlerLine = "";
	        var creatorLine = "";
	        if (promiseCreated._trace) {
	            var traceLines = promiseCreated._trace.stack.split("\n");
	            var stack = cleanStack(traceLines);
	            for (var i = stack.length - 1; i >= 0; --i) {
	                var line = stack[i];
	                if (!nodeFramePattern.test(line)) {
	                    var lineMatches = line.match(parseLinePattern);
	                    if (lineMatches) {
	                        handlerLine  = "at " + lineMatches[1] +
	                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
	                    }
	                    break;
	                }
	            }
	
	            if (stack.length > 0) {
	                var firstUserLine = stack[0];
	                for (var i = 0; i < traceLines.length; ++i) {
	
	                    if (traceLines[i] === firstUserLine) {
	                        if (i > 0) {
	                            creatorLine = "\n" + traceLines[i - 1];
	                        }
	                        break;
	                    }
	                }
	
	            }
	        }
	        var msg = "a promise was created in a " + name +
	            "handler " + handlerLine + "but was not returned from it, " +
	            "see http://goo.gl/rRqMUw" +
	            creatorLine;
	        promise._warn(msg, true, promiseCreated);
	    }
	}
	
	function deprecated(name, replacement) {
	    var message = name +
	        " is deprecated and will be removed in a future version.";
	    if (replacement) message += " Use " + replacement + " instead.";
	    return warn(message);
	}
	
	function warn(message, shouldUseOwnTrace, promise) {
	    if (!config.warnings) return;
	    var warning = new Warning(message);
	    var ctx;
	    if (shouldUseOwnTrace) {
	        promise._attachExtraTrace(warning);
	    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	
	    if (!activeFireEvent("warning", warning)) {
	        formatAndLogError(warning, "", true);
	    }
	}
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = "    (No stack trace)" === line ||
	            stackFramePattern.test(line);
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0 && error.name != "SyntaxError") {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	function parseStackAndMessage(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
	    };
	}
	
	function formatAndLogError(error, title, isSoft) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (util.isObject(error)) {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof printWarning === "function") {
	            printWarning(message, isSoft);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	}
	
	function fireRejectionEvent(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    if (name === "unhandledRejection") {
	        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
	            formatAndLogError(reason, "Unhandled rejection ");
	        }
	    } else {
	        activeFireEvent(name, promise);
	    }
	}
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj && typeof obj.toString === "function"
	            ? obj.toString() : util.toString(obj);
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	function longStackTracesIsSupported() {
	    return typeof captureStackTrace === "function";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	
	function setBounds(firstLineError, lastLineError) {
	    if (!longStackTracesIsSupported()) return;
	    var firstStackLines = firstLineError.stack.split("\n");
	    var lastStackLines = lastLineError.stack.split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	}
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    this._promisesCreated = 0;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	Context.CapturedTrace = CapturedTrace;
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit += 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit += 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit -= 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit += 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit -= 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    printWarning = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        printWarning = function(message, isSoft) {
	            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
	            console.warn(color + message + "\u001b[0m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        printWarning = function(message, isSoft) {
	            console.warn("%c" + message,
	                        isSoft ? "color: darkorange" : "color: red");
	        };
	    }
	}
	
	var config = {
	    warnings: warnings,
	    longStackTraces: false,
	    cancellation: false,
	    monitoring: false
	};
	
	if (longStackTraces) Promise.longStackTraces();
	
	return {
	    longStackTraces: function() {
	        return config.longStackTraces;
	    },
	    warnings: function() {
	        return config.warnings;
	    },
	    cancellation: function() {
	        return config.cancellation;
	    },
	    monitoring: function() {
	        return config.monitoring;
	    },
	    propagateFromFunction: function() {
	        return propagateFromFunction;
	    },
	    boundValueFunction: function() {
	        return boundValueFunction;
	    },
	    checkForgottenReturns: checkForgottenReturns,
	    setBounds: setBounds,
	    warn: warn,
	    deprecated: deprecated,
	    CapturedTrace: CapturedTrace,
	    fireDomEvent: fireDomEvent,
	    fireGlobalEvent: fireGlobalEvent
	};
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ },
/* 619 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function returner() {
	    return this.value;
	}
	function thrower() {
	    throw this.reason;
	}
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value instanceof Promise) value.suppressUnhandledRejections();
	    return this._then(
	        returner, undefined, undefined, {value: value}, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    return this._then(
	        thrower, undefined, undefined, {reason: reason}, undefined);
	};
	
	Promise.prototype.catchThrow = function (reason) {
	    if (arguments.length <= 1) {
	        return this._then(
	            undefined, thrower, undefined, {reason: reason}, undefined);
	    } else {
	        var _reason = arguments[1];
	        var handler = function() {throw _reason;};
	        return this.caught(reason, handler);
	    }
	};
	
	Promise.prototype.catchReturn = function (value) {
	    if (arguments.length <= 1) {
	        if (value instanceof Promise) value.suppressUnhandledRejections();
	        return this._then(
	            undefined, returner, undefined, {value: value}, undefined);
	    } else {
	        var _value = arguments[1];
	        if (_value instanceof Promise) _value.suppressUnhandledRejections();
	        var handler = function() {return _value;};
	        return this.caught(value, handler);
	    }
	};
	};


/***/ },
/* 620 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseReduce = Promise.reduce;
	var PromiseAll = Promise.all;
	
	function promiseAllThis() {
	    return PromiseAll(this);
	}
	
	function PromiseMapSeries(promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
	}
	
	Promise.prototype.each = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, this, undefined);
	};
	
	Promise.prototype.mapSeries = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
	};
	
	Promise.each = function (promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, promises, undefined);
	};
	
	Promise.mapSeries = PromiseMapSeries;
	};
	


/***/ },
/* 621 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseMap = Promise.map;
	
	Promise.prototype.filter = function (fn, options) {
	    return PromiseMap(this, fn, options, INTERNAL);
	};
	
	Promise.filter = function (promises, fn, options) {
	    return PromiseMap(promises, fn, options, INTERNAL);
	};
	};


/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
	var util = __webpack_require__(16);
	var CancellationError = Promise.CancellationError;
	var errorObj = util.errorObj;
	var catchFilter = __webpack_require__(275)(NEXT_FILTER);
	
	function PassThroughHandlerContext(promise, type, handler) {
	    this.promise = promise;
	    this.type = type;
	    this.handler = handler;
	    this.called = false;
	    this.cancelPromise = null;
	}
	
	PassThroughHandlerContext.prototype.isFinallyHandler = function() {
	    return this.type === 0;
	};
	
	function FinallyHandlerCancelReaction(finallyHandler) {
	    this.finallyHandler = finallyHandler;
	}
	
	FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
	    checkCancel(this.finallyHandler);
	};
	
	function checkCancel(ctx, reason) {
	    if (ctx.cancelPromise != null) {
	        if (arguments.length > 1) {
	            ctx.cancelPromise._reject(reason);
	        } else {
	            ctx.cancelPromise._cancel();
	        }
	        ctx.cancelPromise = null;
	        return true;
	    }
	    return false;
	}
	
	function succeed() {
	    return finallyHandler.call(this, this.promise._target()._settledValue());
	}
	function fail(reason) {
	    if (checkCancel(this, reason)) return;
	    errorObj.e = reason;
	    return errorObj;
	}
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    if (!this.called) {
	        this.called = true;
	        var ret = this.isFinallyHandler()
	            ? handler.call(promise._boundValue())
	            : handler.call(promise._boundValue(), reasonOrValue);
	        if (ret === NEXT_FILTER) {
	            return ret;
	        } else if (ret !== undefined) {
	            promise._setReturnedNonUndefined();
	            var maybePromise = tryConvertToPromise(ret, promise);
	            if (maybePromise instanceof Promise) {
	                if (this.cancelPromise != null) {
	                    if (maybePromise._isCancelled()) {
	                        var reason =
	                            new CancellationError("late cancellation observer");
	                        promise._attachExtraTrace(reason);
	                        errorObj.e = reason;
	                        return errorObj;
	                    } else if (maybePromise.isPending()) {
	                        maybePromise._attachCancellationCallback(
	                            new FinallyHandlerCancelReaction(this));
	                    }
	                }
	                return maybePromise._then(
	                    succeed, fail, undefined, this, undefined);
	            }
	        }
	    }
	
	    if (promise.isRejected()) {
	        checkCancel(this);
	        errorObj.e = reasonOrValue;
	        return errorObj;
	    } else {
	        checkCancel(this);
	        return reasonOrValue;
	    }
	}
	
	Promise.prototype._passThrough = function(handler, type, success, fail) {
	    if (typeof handler !== "function") return this.then();
	    return this._then(success,
	                      fail,
	                      undefined,
	                      new PassThroughHandlerContext(this, type, handler),
	                      undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThrough(handler,
	                             0,
	                             finallyHandler,
	                             finallyHandler);
	};
	
	
	Promise.prototype.tap = function (handler) {
	    return this._passThrough(handler, 1, finallyHandler);
	};
	
	Promise.prototype.tapCatch = function (handlerOrPredicate) {
	    var len = arguments.length;
	    if(len === 1) {
	        return this._passThrough(handlerOrPredicate,
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    } else {
	         var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return Promise.reject(new TypeError(
	                    "tapCatch statement predicate: "
	                    + "expecting an object but got " + util.classString(item)
	                ));
	            }
	        }
	        catchInstances.length = j;
	        var handler = arguments[i];
	        return this._passThrough(catchFilter(catchInstances, handler, this),
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    }
	
	};
	
	return PassThroughHandlerContext;
	};


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          apiRejection,
	                          INTERNAL,
	                          tryConvertToPromise,
	                          Proxyable,
	                          debug) {
	var errors = __webpack_require__(68);
	var TypeError = errors.TypeError;
	var util = __webpack_require__(16);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	var yieldHandlers = [];
	
	function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
	    for (var i = 0; i < yieldHandlers.length; ++i) {
	        traceParent._pushContext();
	        var result = tryCatch(yieldHandlers[i])(value);
	        traceParent._popContext();
	        if (result === errorObj) {
	            traceParent._pushContext();
	            var ret = Promise.reject(errorObj.e);
	            traceParent._popContext();
	            return ret;
	        }
	        var maybePromise = tryConvertToPromise(result, traceParent);
	        if (maybePromise instanceof Promise) return maybePromise;
	    }
	    return null;
	}
	
	function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
	    if (debug.cancellation()) {
	        var internal = new Promise(INTERNAL);
	        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
	        this._promise = internal.lastly(function() {
	            return _finallyPromise;
	        });
	        internal._captureStackTrace();
	        internal._setOnCancel(this);
	    } else {
	        var promise = this._promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	    }
	    this._stack = stack;
	    this._generatorFunction = generatorFunction;
	    this._receiver = receiver;
	    this._generator = undefined;
	    this._yieldHandlers = typeof yieldHandler === "function"
	        ? [yieldHandler].concat(yieldHandlers)
	        : yieldHandlers;
	    this._yieldedPromise = null;
	    this._cancellationPhase = false;
	}
	util.inherits(PromiseSpawn, Proxyable);
	
	PromiseSpawn.prototype._isResolved = function() {
	    return this._promise === null;
	};
	
	PromiseSpawn.prototype._cleanup = function() {
	    this._promise = this._generator = null;
	    if (debug.cancellation() && this._finallyPromise !== null) {
	        this._finallyPromise._fulfill();
	        this._finallyPromise = null;
	    }
	};
	
	PromiseSpawn.prototype._promiseCancelled = function() {
	    if (this._isResolved()) return;
	    var implementsReturn = typeof this._generator["return"] !== "undefined";
	
	    var result;
	    if (!implementsReturn) {
	        var reason = new Promise.CancellationError(
	            "generator .return() sentinel");
	        Promise.coroutine.returnSentinel = reason;
	        this._promise._attachExtraTrace(reason);
	        this._promise._pushContext();
	        result = tryCatch(this._generator["throw"]).call(this._generator,
	                                                         reason);
	        this._promise._popContext();
	    } else {
	        this._promise._pushContext();
	        result = tryCatch(this._generator["return"]).call(this._generator,
	                                                          undefined);
	        this._promise._popContext();
	    }
	    this._cancellationPhase = true;
	    this._yieldedPromise = null;
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseFulfilled = function(value) {
	    this._yieldedPromise = null;
	    this._promise._pushContext();
	    var result = tryCatch(this._generator.next).call(this._generator, value);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseRejected = function(reason) {
	    this._yieldedPromise = null;
	    this._promise._attachExtraTrace(reason);
	    this._promise._pushContext();
	    var result = tryCatch(this._generator["throw"])
	        .call(this._generator, reason);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._resultCancelled = function() {
	    if (this._yieldedPromise instanceof Promise) {
	        var promise = this._yieldedPromise;
	        this._yieldedPromise = null;
	        promise.cancel();
	    }
	};
	
	PromiseSpawn.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseSpawn.prototype._run = function () {
	    this._generator = this._generatorFunction.call(this._receiver);
	    this._receiver =
	        this._generatorFunction = undefined;
	    this._promiseFulfilled(undefined);
	};
	
	PromiseSpawn.prototype._continue = function (result) {
	    var promise = this._promise;
	    if (result === errorObj) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._rejectCallback(result.e, false);
	        }
	    }
	
	    var value = result.value;
	    if (result.done === true) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._resolveCallback(value);
	        }
	    } else {
	        var maybePromise = tryConvertToPromise(value, this._promise);
	        if (!(maybePromise instanceof Promise)) {
	            maybePromise =
	                promiseFromYieldHandler(maybePromise,
	                                        this._yieldHandlers,
	                                        this._promise);
	            if (maybePromise === null) {
	                this._promiseRejected(
	                    new TypeError(
	                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
	                        "From coroutine:\u000a" +
	                        this._stack.split("\n").slice(1, -7).join("\n")
	                    )
	                );
	                return;
	            }
	        }
	        maybePromise = maybePromise._target();
	        var bitField = maybePromise._bitField;
	        ;
	        if (((bitField & 50397184) === 0)) {
	            this._yieldedPromise = maybePromise;
	            maybePromise._proxy(this, null);
	        } else if (((bitField & 33554432) !== 0)) {
	            Promise._async.invoke(
	                this._promiseFulfilled, this, maybePromise._value()
	            );
	        } else if (((bitField & 16777216) !== 0)) {
	            Promise._async.invoke(
	                this._promiseRejected, this, maybePromise._reason()
	            );
	        } else {
	            this._promiseCancelled();
	        }
	    }
	};
	
	Promise.coroutine = function (generatorFunction, options) {
	    if (typeof generatorFunction !== "function") {
	        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var yieldHandler = Object(options).yieldHandler;
	    var PromiseSpawn$ = PromiseSpawn;
	    var stack = new Error().stack;
	    return function () {
	        var generator = generatorFunction.apply(this, arguments);
	        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
	                                      stack);
	        var ret = spawn.promise();
	        spawn._generator = generator;
	        spawn._promiseFulfilled(undefined);
	        return ret;
	    };
	};
	
	Promise.coroutine.addYieldHandler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    yieldHandlers.push(fn);
	};
	
	Promise.spawn = function (generatorFunction) {
	    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
	    if (typeof generatorFunction !== "function") {
	        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var spawn = new PromiseSpawn(generatorFunction, this);
	    var ret = spawn.promise();
	    spawn._run(Promise.spawn);
	    return ret;
	};
	};


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
	         getDomain) {
	var util = __webpack_require__(16);
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (true) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var promiseSetter = function(i) {
	        return new Function("promise", "holder", "                           \n\
	            'use strict';                                                    \n\
	            holder.pIndex = promise;                                         \n\
	            ".replace(/Index/g, i));
	    };
	
	    var generateHolderClass = function(total) {
	        var props = new Array(total);
	        for (var i = 0; i < props.length; ++i) {
	            props[i] = "this.p" + (i+1);
	        }
	        var assignment = props.join(" = ") + " = null;";
	        var cancellationCode= "var promise;\n" + props.map(function(prop) {
	            return "                                                         \n\
	                promise = " + prop + ";                                      \n\
	                if (promise instanceof Promise) {                            \n\
	                    promise.cancel();                                        \n\
	                }                                                            \n\
	            ";
	        }).join("\n");
	        var passedArguments = props.join(", ");
	        var name = "Holder$" + total;
	
	
	        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
	            'use strict';                                                    \n\
	            function [TheName](fn) {                                         \n\
	                [TheProperties]                                              \n\
	                this.fn = fn;                                                \n\
	                this.asyncNeeded = true;                                     \n\
	                this.now = 0;                                                \n\
	            }                                                                \n\
	                                                                             \n\
	            [TheName].prototype._callFunction = function(promise) {          \n\
	                promise._pushContext();                                      \n\
	                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
	                promise._popContext();                                       \n\
	                if (ret === errorObj) {                                      \n\
	                    promise._rejectCallback(ret.e, false);                   \n\
	                } else {                                                     \n\
	                    promise._resolveCallback(ret);                           \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype.checkFulfillment = function(promise) {       \n\
	                var now = ++this.now;                                        \n\
	                if (now === [TheTotal]) {                                    \n\
	                    if (this.asyncNeeded) {                                  \n\
	                        async.invoke(this._callFunction, this, promise);     \n\
	                    } else {                                                 \n\
	                        this._callFunction(promise);                         \n\
	                    }                                                        \n\
	                                                                             \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype._resultCancelled = function() {              \n\
	                [CancellationCode]                                           \n\
	            };                                                               \n\
	                                                                             \n\
	            return [TheName];                                                \n\
	        }(tryCatch, errorObj, Promise, async);                               \n\
	        ";
	
	        code = code.replace(/\[TheName\]/g, name)
	            .replace(/\[TheTotal\]/g, total)
	            .replace(/\[ThePassedArguments\]/g, passedArguments)
	            .replace(/\[TheProperties\]/g, assignment)
	            .replace(/\[CancellationCode\]/g, cancellationCode);
	
	        return new Function("tryCatch", "errorObj", "Promise", "async", code)
	                           (tryCatch, errorObj, Promise, async);
	    };
	
	    var holderClasses = [];
	    var thenCallbacks = [];
	    var promiseSetters = [];
	
	    for (var i = 0; i < 8; ++i) {
	        holderClasses.push(generateHolderClass(i + 1));
	        thenCallbacks.push(thenCallback(i + 1));
	        promiseSetters.push(promiseSetter(i + 1));
	    }
	
	    reject = function (reason) {
	        this._reject(reason);
	    };
	}}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (true) {
	            if (last <= 8 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var HolderClass = holderClasses[last - 1];
	                var holder = new HolderClass(fn);
	                var callbacks = thenCallbacks;
	
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        var bitField = maybePromise._bitField;
	                        ;
	                        if (((bitField & 50397184) === 0)) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                            promiseSetters[i](maybePromise, holder);
	                            holder.asyncNeeded = false;
	                        } else if (((bitField & 33554432) !== 0)) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else if (((bitField & 16777216) !== 0)) {
	                            ret._reject(maybePromise._reason());
	                        } else {
	                            ret._cancel();
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	
	                if (!ret._isFateSealed()) {
	                    if (holder.asyncNeeded) {
	                        var domain = getDomain();
	                        if (domain !== null) {
	                            holder.fn = util.domainBind(domain, holder.fn);
	                        }
	                    }
	                    ret._setAsyncGuaranteed();
	                    ret._setOnCancel(holder);
	                }
	                return ret;
	            }
	        }
	    }
	    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];};
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(16);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	function MappingPromiseArray(promises, fn, limit, _filter) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    var domain = getDomain();
	    this._callback = domain === null ? fn : util.domainBind(domain, fn);
	    this._preservedValues = _filter === INTERNAL
	        ? new Array(this.length())
	        : null;
	    this._limit = limit;
	    this._inFlight = 0;
	    this._queue = [];
	    async.invoke(this._asyncInit, this, undefined);
	}
	util.inherits(MappingPromiseArray, PromiseArray);
	
	MappingPromiseArray.prototype._asyncInit = function() {
	    this._init$(undefined, -2);
	};
	
	MappingPromiseArray.prototype._init = function () {};
	
	MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var limit = this._limit;
	
	    if (index < 0) {
	        index = (index * -1) - 1;
	        values[index] = value;
	        if (limit >= 1) {
	            this._inFlight--;
	            this._drainQueue();
	            if (this._isResolved()) return true;
	        }
	    } else {
	        if (limit >= 1 && this._inFlight >= limit) {
	            values[index] = value;
	            this._queue.push(index);
	            return false;
	        }
	        if (preservedValues !== null) preservedValues[index] = value;
	
	        var promise = this._promise;
	        var callback = this._callback;
	        var receiver = promise._boundValue();
	        promise._pushContext();
	        var ret = tryCatch(callback).call(receiver, value, index, length);
	        var promiseCreated = promise._popContext();
	        debug.checkForgottenReturns(
	            ret,
	            promiseCreated,
	            preservedValues !== null ? "Promise.filter" : "Promise.map",
	            promise
	        );
	        if (ret === errorObj) {
	            this._reject(ret.e);
	            return true;
	        }
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            var bitField = maybePromise._bitField;
	            ;
	            if (((bitField & 50397184) === 0)) {
	                if (limit >= 1) this._inFlight++;
	                values[index] = maybePromise;
	                maybePromise._proxy(this, (index + 1) * -1);
	                return false;
	            } else if (((bitField & 33554432) !== 0)) {
	                ret = maybePromise._value();
	            } else if (((bitField & 16777216) !== 0)) {
	                this._reject(maybePromise._reason());
	                return true;
	            } else {
	                this._cancel();
	                return true;
	            }
	        }
	        values[index] = ret;
	    }
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= length) {
	        if (preservedValues !== null) {
	            this._filter(values, preservedValues);
	        } else {
	            this._resolve(values);
	        }
	        return true;
	    }
	    return false;
	};
	
	MappingPromiseArray.prototype._drainQueue = function () {
	    var queue = this._queue;
	    var limit = this._limit;
	    var values = this._values;
	    while (queue.length > 0 && this._inFlight < limit) {
	        if (this._isResolved()) return;
	        var index = queue.pop();
	        this._promiseFulfilled(values[index], index);
	    }
	};
	
	MappingPromiseArray.prototype._filter = function (booleans, values) {
	    var len = values.length;
	    var ret = new Array(len);
	    var j = 0;
	    for (var i = 0; i < len; ++i) {
	        if (booleans[i]) ret[j++] = values[i];
	    }
	    ret.length = j;
	    this._resolve(ret);
	};
	
	MappingPromiseArray.prototype.preservedValues = function () {
	    return this._preservedValues;
	};
	
	function map(promises, fn, options, _filter) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	
	    var limit = 0;
	    if (options !== undefined) {
	        if (typeof options === "object" && options !== null) {
	            if (typeof options.concurrency !== "number") {
	                return Promise.reject(
	                    new TypeError("'concurrency' must be a number but it is " +
	                                    util.classString(options.concurrency)));
	            }
	            limit = options.concurrency;
	        } else {
	            return Promise.reject(new TypeError(
	                            "options argument must be an object but it is " +
	                             util.classString(options)));
	        }
	    }
	    limit = typeof limit === "number" &&
	        isFinite(limit) && limit >= 1 ? limit : 0;
	    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
	}
	
	Promise.prototype.map = function (fn, options) {
	    return map(this, fn, options, null);
	};
	
	Promise.map = function (promises, fn, options, _filter) {
	    return map(promises, fn, options, _filter);
	};
	
	
	};


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
	var util = __webpack_require__(16);
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        var promiseCreated = ret._popContext();
	        debug.checkForgottenReturns(
	            value, promiseCreated, "Promise.method", ret);
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value;
	    if (arguments.length > 1) {
	        debug.deprecated("calling Promise.try with more than 1 argument");
	        var arg = arguments[1];
	        var ctx = arguments[2];
	        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
	                                  : tryCatch(fn).call(ctx, arg);
	    } else {
	        value = tryCatch(fn)();
	    }
	    var promiseCreated = ret._popContext();
	    debug.checkForgottenReturns(
	        value, promiseCreated, "Promise.try", ret);
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise) {
	var util = __webpack_require__(16);
	var async = Promise._async;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function spreadAdapter(val, nodeback) {
	    var promise = this;
	    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
	    var ret =
	        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	function successAdapter(val, nodeback) {
	    var promise = this;
	    var receiver = promise._boundValue();
	    var ret = val === undefined
	        ? tryCatch(nodeback).call(receiver, null)
	        : tryCatch(nodeback).call(receiver, null, val);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	function errorAdapter(reason, nodeback) {
	    var promise = this;
	    if (!reason) {
	        var newReason = new Error(reason + "");
	        newReason.cause = reason;
	        reason = newReason;
	    }
	    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
	                                                                     options) {
	    if (typeof nodeback == "function") {
	        var adapter = successAdapter;
	        if (options !== undefined && Object(options).spread) {
	            adapter = spreadAdapter;
	        }
	        this._then(
	            adapter,
	            errorAdapter,
	            undefined,
	            this,
	            nodeback
	        );
	    }
	    return this;
	};
	};


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var reflectHandler = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	function Proxyable() {}
	var UNDEFINED_BINDING = {};
	var util = __webpack_require__(16);
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var es5 = __webpack_require__(92);
	var Async = __webpack_require__(613);
	var async = new Async();
	es5.defineProperty(Promise, "_async", {value: async});
	var errors = __webpack_require__(68);
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	var CancellationError = Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {};
	var tryConvertToPromise = __webpack_require__(639)(Promise, INTERNAL);
	var PromiseArray =
	    __webpack_require__(629)(Promise, INTERNAL,
	                               tryConvertToPromise, apiRejection, Proxyable);
	var Context = __webpack_require__(617)(Promise);
	 /*jshint unused:false*/
	var createContext = Context.create;
	var debug = __webpack_require__(618)(Promise, Context);
	var CapturedTrace = debug.CapturedTrace;
	var PassThroughHandlerContext =
	    __webpack_require__(622)(Promise, tryConvertToPromise, NEXT_FILTER);
	var catchFilter = __webpack_require__(275)(NEXT_FILTER);
	var nodebackForPromise = __webpack_require__(276);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	function check(self, executor) {
	    if (self == null || self.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (typeof executor !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(executor));
	    }
	
	}
	
	function Promise(executor) {
	    if (executor !== INTERNAL) {
	        check(this, executor);
	    }
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._resolveFromExecutor(executor);
	    this._promiseCreated();
	    this._fireEvent("promiseCreated", this);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return apiRejection("Catch statement predicate: " +
	                    "expecting an object but got " + util.classString(item));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	        return this.then(undefined, catchFilter(catchInstances, fn, this));
	    }
	    return this.then(undefined, fn);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflectHandler,
	        reflectHandler, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject) {
	    if (debug.warnings() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, undefined, undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject) {
	    var promise =
	        this._then(didFulfill, didReject, undefined, undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    if (arguments.length > 0) {
	        this._warn(".all() was passed arguments but it does not take any");
	    }
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.getNewLibraryCopy = module.exports;
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = Promise.fromCallback = function(fn) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
	                                         : false;
	    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true);
	    }
	    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._setFulfilled();
	        ret._rejectionHandler0 = obj;
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return async.setScheduler(fn);
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    _,    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
	    var target = this._target();
	    var bitField = target._bitField;
	
	    if (!haveInternalData) {
	        promise._propagateFrom(this, 3);
	        promise._captureStackTrace();
	        if (receiver === undefined &&
	            ((this._bitField & 2097152) !== 0)) {
	            if (!((bitField & 50397184) === 0)) {
	                receiver = this._boundValue();
	            } else {
	                receiver = target === this ? undefined : this._boundTo;
	            }
	        }
	        this._fireEvent("promiseChained", this, promise);
	    }
	
	    var domain = getDomain();
	    if (!((bitField & 50397184) === 0)) {
	        var handler, value, settler = target._settlePromiseCtx;
	        if (((bitField & 33554432) !== 0)) {
	            value = target._rejectionHandler0;
	            handler = didFulfill;
	        } else if (((bitField & 16777216) !== 0)) {
	            value = target._fulfillmentHandler0;
	            handler = didReject;
	            target._unsetRejectionIsUnhandled();
	        } else {
	            settler = target._settlePromiseLateCancellationObserver;
	            value = new CancellationError("late cancellation observer");
	            target._attachExtraTrace(value);
	            handler = didReject;
	        }
	
	        async.invoke(settler, target, {
	            handler: domain === null ? handler
	                : (typeof handler === "function" &&
	                    util.domainBind(domain, handler)),
	            promise: promise,
	            receiver: receiver,
	            value: value
	        });
	    } else {
	        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
	    }
	
	    return promise;
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 65535;
	};
	
	Promise.prototype._isFateSealed = function () {
	    return (this._bitField & 117506048) !== 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 67108864) === 67108864;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -65536) |
	        (len & 65535);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 33554432;
	    this._fireEvent("promiseFulfilled", this);
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 16777216;
	    this._fireEvent("promiseRejected", this);
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 67108864;
	    this._fireEvent("promiseResolved", this);
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._unsetCancelled = function() {
	    this._bitField = this._bitField & (~65536);
	};
	
	Promise.prototype._setCancelled = function() {
	    this._bitField = this._bitField | 65536;
	    this._fireEvent("promiseCancelled", this);
	};
	
	Promise.prototype._setWillBeCancelled = function() {
	    this._bitField = this._bitField | 8388608;
	};
	
	Promise.prototype._setAsyncGuaranteed = function() {
	    if (async.hasCustomScheduler()) return;
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0 ? this._receiver0 : this[
	            index * 4 - 4 + 3];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return this[
	            index * 4 - 4 + 2];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 1];
	};
	
	Promise.prototype._boundValue = function() {};
	
	Promise.prototype._migrateCallback0 = function (follower) {
	    var bitField = follower._bitField;
	    var fulfill = follower._fulfillmentHandler0;
	    var reject = follower._rejectionHandler0;
	    var promise = follower._promise0;
	    var receiver = follower._receiverAt(0);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._migrateCallbackAt = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 65535 - 4) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        this._receiver0 = receiver;
	        if (typeof fulfill === "function") {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    } else {
	        var base = index * 4 - 4;
	        this[base + 2] = promise;
	        this[base + 3] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._proxy = function (proxyable, arg) {
	    this._addCallbacks(undefined, undefined, arg, proxyable, null);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (((this._bitField & 117506048) !== 0)) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    if (shouldBind) this._propagateFrom(maybePromise, 2);
	
	    var promise = maybePromise._target();
	
	    if (promise === this) {
	        this._reject(makeSelfResolutionError());
	        return;
	    }
	
	    var bitField = promise._bitField;
	    if (((bitField & 50397184) === 0)) {
	        var len = this._length();
	        if (len > 0) promise._migrateCallback0(this);
	        for (var i = 1; i < len; ++i) {
	            promise._migrateCallbackAt(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (((bitField & 33554432) !== 0)) {
	        this._fulfill(promise._value());
	    } else if (((bitField & 16777216) !== 0)) {
	        this._reject(promise._reason());
	    } else {
	        var reason = new CancellationError("late cancellation observer");
	        promise._attachExtraTrace(reason);
	        this._reject(reason);
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, ignoreNonErrorWarnings) {
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
	        var message = "a promise was rejected with a non-error: " +
	            util.classString(reason);
	        this._warn(message, true);
	    }
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason);
	};
	
	Promise.prototype._resolveFromExecutor = function (executor) {
	    if (executor === INTERNAL) return;
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = this._execute(executor, function(value) {
	        promise._resolveCallback(value);
	    }, function (reason) {
	        promise._rejectCallback(reason, synchronous);
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined) {
	        promise._rejectCallback(r, true);
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    var bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY) {
	        if (!value || typeof value.length !== "number") {
	            x = errorObj;
	            x.e = new TypeError("cannot .spread() a non-array: " +
	                                    util.classString(value));
	        } else {
	            x = tryCatch(handler).apply(this._boundValue(), value);
	        }
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    var promiseCreated = promise._popContext();
	    bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	
	    if (x === NEXT_FILTER) {
	        promise._reject(value);
	    } else if (x === errorObj) {
	        promise._rejectCallback(x.e, false);
	    } else {
	        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
	    var isPromise = promise instanceof Promise;
	    var bitField = this._bitField;
	    var asyncGuaranteed = ((bitField & 134217728) !== 0);
	    if (((bitField & 65536) !== 0)) {
	        if (isPromise) promise._invokeInternalOnCancel();
	
	        if (receiver instanceof PassThroughHandlerContext &&
	            receiver.isFinallyHandler()) {
	            receiver.cancelPromise = promise;
	            if (tryCatch(handler).call(receiver, value) === errorObj) {
	                promise._reject(errorObj.e);
	            }
	        } else if (handler === reflectHandler) {
	            promise._fulfill(reflectHandler.call(receiver));
	        } else if (receiver instanceof Proxyable) {
	            receiver._promiseCancelled(promise);
	        } else if (isPromise || promise instanceof PromiseArray) {
	            promise._cancel();
	        } else {
	            receiver.cancel();
	        }
	    } else if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            if (asyncGuaranteed) promise._setAsyncGuaranteed();
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof Proxyable) {
	        if (!receiver._isResolved()) {
	            if (((bitField & 33554432) !== 0)) {
	                receiver._promiseFulfilled(value, promise);
	            } else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (asyncGuaranteed) promise._setAsyncGuaranteed();
	        if (((bitField & 33554432) !== 0)) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value);
	        }
	    }
	};
	
	Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
	    var handler = ctx.handler;
	    var promise = ctx.promise;
	    var receiver = ctx.receiver;
	    var value = ctx.value;
	    if (typeof handler === "function") {
	        if (!(promise instanceof Promise)) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (promise instanceof Promise) {
	        promise._reject(value);
	    }
	};
	
	Promise.prototype._settlePromiseCtx = function(ctx) {
	    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
	};
	
	Promise.prototype._settlePromise0 = function(handler, value, bitField) {
	    var promise = this._promise0;
	    var receiver = this._receiverAt(0);
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settlePromise(promise, handler, receiver, value);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    var base = index * 4 - 4;
	    this[base + 2] =
	    this[base + 3] =
	    this[base + 0] =
	    this[base + 1] = undefined;
	};
	
	Promise.prototype._fulfill = function (value) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._reject(err);
	    }
	    this._setFulfilled();
	    this._rejectionHandler0 = value;
	
	    if ((bitField & 65535) > 0) {
	        if (((bitField & 134217728) !== 0)) {
	            this._settlePromises();
	        } else {
	            async.settlePromises(this);
	        }
	    }
	};
	
	Promise.prototype._reject = function (reason) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    this._setRejected();
	    this._fulfillmentHandler0 = reason;
	
	    if (this._isFinal()) {
	        return async.fatalError(reason, util.isNode);
	    }
	
	    if ((bitField & 65535) > 0) {
	        async.settlePromises(this);
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._fulfillPromises = function (len, value) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._fulfillmentHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, value);
	    }
	};
	
	Promise.prototype._rejectPromises = function (len, reason) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._rejectionHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, reason);
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    var bitField = this._bitField;
	    var len = (bitField & 65535);
	
	    if (len > 0) {
	        if (((bitField & 16842752) !== 0)) {
	            var reason = this._fulfillmentHandler0;
	            this._settlePromise0(this._rejectionHandler0, reason, bitField);
	            this._rejectPromises(len, reason);
	        } else {
	            var value = this._rejectionHandler0;
	            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
	            this._fulfillPromises(len, value);
	        }
	        this._setLength(0);
	    }
	    this._clearCancellationData();
	};
	
	Promise.prototype._settledValue = function() {
	    var bitField = this._bitField;
	    if (((bitField & 33554432) !== 0)) {
	        return this._rejectionHandler0;
	    } else if (((bitField & 16777216) !== 0)) {
	        return this._fulfillmentHandler0;
	    }
	};
	
	function deferResolve(v) {this.promise._resolveCallback(v);}
	function deferReject(v) {this.promise._rejectCallback(v, false);}
	
	Promise.defer = Promise.pending = function() {
	    debug.deprecated("Promise.defer", "new Promise");
	    var promise = new Promise(INTERNAL);
	    return {
	        promise: promise,
	        resolve: deferResolve,
	        reject: deferReject
	    };
	};
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	__webpack_require__(626)(Promise, INTERNAL, tryConvertToPromise, apiRejection,
	    debug);
	__webpack_require__(614)(Promise, INTERNAL, tryConvertToPromise, debug);
	__webpack_require__(616)(Promise, PromiseArray, apiRejection, debug);
	__webpack_require__(619)(Promise);
	__webpack_require__(638)(Promise);
	__webpack_require__(624)(
	    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
	Promise.Promise = Promise;
	Promise.version = "3.5.0";
	__webpack_require__(625)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(615)(Promise);
	__webpack_require__(641)(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
	__webpack_require__(640)(Promise, INTERNAL, debug);
	__webpack_require__(623)(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
	__webpack_require__(627)(Promise);
	__webpack_require__(630)(Promise, INTERNAL);
	__webpack_require__(631)(Promise, PromiseArray, tryConvertToPromise, apiRejection);
	__webpack_require__(633)(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	__webpack_require__(634)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(636)(Promise, PromiseArray, debug);
	__webpack_require__(637)(Promise, PromiseArray, apiRejection);
	__webpack_require__(621)(Promise, INTERNAL);
	__webpack_require__(620)(Promise, INTERNAL);
	__webpack_require__(612)(Promise);
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    debug.setBounds(Async.firstLineError, util.lastLineError);               
	    return Promise;                                                          
	
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection, Proxyable) {
	var util = __webpack_require__(16);
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    case -6: return new Map();
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    if (values instanceof Promise) {
	        promise._propagateFrom(values, 3);
	    }
	    promise._setOnCancel(this);
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	util.inherits(PromiseArray, Proxyable);
	
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        var bitField = values._bitField;
	        ;
	        this._values = values;
	
	        if (((bitField & 50397184) === 0)) {
	            this._promise._setAsyncGuaranteed();
	            return values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	        } else if (((bitField & 33554432) !== 0)) {
	            values = values._value();
	        } else if (((bitField & 16777216) !== 0)) {
	            return this._reject(values._reason());
	        } else {
	            return this._cancel();
	        }
	    }
	    values = util.asArray(values);
	    if (values === null) {
	        var err = apiRejection(
	            "expecting an array or an iterable object but got " + util.classString(values)).reason();
	        this._promise._rejectCallback(err, false);
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    this._iterate(values);
	};
	
	PromiseArray.prototype._iterate = function(values) {
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var result = this._promise;
	    var isResolved = false;
	    var bitField = null;
	    for (var i = 0; i < len; ++i) {
	        var maybePromise = tryConvertToPromise(values[i], result);
	
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            bitField = maybePromise._bitField;
	        } else {
	            bitField = null;
	        }
	
	        if (isResolved) {
	            if (bitField !== null) {
	                maybePromise.suppressUnhandledRejections();
	            }
	        } else if (bitField !== null) {
	            if (((bitField & 50397184) === 0)) {
	                maybePromise._proxy(this, i);
	                this._values[i] = maybePromise;
	            } else if (((bitField & 33554432) !== 0)) {
	                isResolved = this._promiseFulfilled(maybePromise._value(), i);
	            } else if (((bitField & 16777216) !== 0)) {
	                isResolved = this._promiseRejected(maybePromise._reason(), i);
	            } else {
	                isResolved = this._promiseCancelled(i);
	            }
	        } else {
	            isResolved = this._promiseFulfilled(maybePromise, i);
	        }
	    }
	    if (!isResolved) result._setAsyncGuaranteed();
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype._cancel = function() {
	    if (this._isResolved() || !this._promise._isCancellable()) return;
	    this._values = null;
	    this._promise._cancel();
	};
	
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false);
	};
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	PromiseArray.prototype._promiseCancelled = function() {
	    this._cancel();
	    return true;
	};
	
	PromiseArray.prototype._promiseRejected = function (reason) {
	    this._totalResolved++;
	    this._reject(reason);
	    return true;
	};
	
	PromiseArray.prototype._resultCancelled = function() {
	    if (this._isResolved()) return;
	    var values = this._values;
	    this._cancel();
	    if (values instanceof Promise) {
	        values.cancel();
	    } else {
	        for (var i = 0; i < values.length; ++i) {
	            if (values[i] instanceof Promise) {
	                values[i].cancel();
	            }
	        }
	    }
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var THIS = {};
	var util = __webpack_require__(16);
	var nodebackForPromise = __webpack_require__(276);
	var withAppended = util.withAppended;
	var maybeWrapAsError = util.maybeWrapAsError;
	var canEvaluate = util.canEvaluate;
	var TypeError = __webpack_require__(68).TypeError;
	var defaultSuffix = "Async";
	var defaultPromisified = {__isPromisified__: true};
	var noCopyProps = [
	    "arity",    "length",
	    "name",
	    "arguments",
	    "caller",
	    "callee",
	    "prototype",
	    "__isPromisified__"
	];
	var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
	
	var defaultFilter = function(name) {
	    return util.isIdentifier(name) &&
	        name.charAt(0) !== "_" &&
	        name !== "constructor";
	};
	
	function propsFilter(key) {
	    return !noCopyPropsPattern.test(key);
	}
	
	function isPromisified(fn) {
	    try {
	        return fn.__isPromisified__ === true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	
	function hasPromisified(obj, key, suffix) {
	    var val = util.getDataPropertyOrDefault(obj, key + suffix,
	                                            defaultPromisified);
	    return val ? isPromisified(val) : false;
	}
	function checkValid(ret, suffix, suffixRegexp) {
	    for (var i = 0; i < ret.length; i += 2) {
	        var key = ret[i];
	        if (suffixRegexp.test(key)) {
	            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
	            for (var j = 0; j < ret.length; j += 2) {
	                if (ret[j] === keyWithoutAsyncSuffix) {
	                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
	                        .replace("%s", suffix));
	                }
	            }
	        }
	    }
	}
	
	function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
	    var keys = util.inheritedDataKeys(obj);
	    var ret = [];
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var value = obj[key];
	        var passesDefaultFilter = filter === defaultFilter
	            ? true : defaultFilter(key, value, obj);
	        if (typeof value === "function" &&
	            !isPromisified(value) &&
	            !hasPromisified(obj, key, suffix) &&
	            filter(key, value, obj, passesDefaultFilter)) {
	            ret.push(key, value);
	        }
	    }
	    checkValid(ret, suffix, suffixRegexp);
	    return ret;
	}
	
	var escapeIdentRegex = function(str) {
	    return str.replace(/([$])/, "\\$");
	};
	
	var makeNodePromisifiedEval;
	if (true) {
	var switchCaseArgumentOrder = function(likelyArgumentCount) {
	    var ret = [likelyArgumentCount];
	    var min = Math.max(0, likelyArgumentCount - 1 - 3);
	    for(var i = likelyArgumentCount - 1; i >= min; --i) {
	        ret.push(i);
	    }
	    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
	        ret.push(i);
	    }
	    return ret;
	};
	
	var argumentSequence = function(argumentCount) {
	    return util.filledRange(argumentCount, "_arg", "");
	};
	
	var parameterDeclaration = function(parameterCount) {
	    return util.filledRange(
	        Math.max(parameterCount, 3), "_arg", "");
	};
	
	var parameterCount = function(fn) {
	    if (typeof fn.length === "number") {
	        return Math.max(Math.min(fn.length, 1023 + 1), 0);
	    }
	    return 0;
	};
	
	makeNodePromisifiedEval =
	function(callback, receiver, originalName, fn, _, multiArgs) {
	    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
	    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
	    var shouldProxyThis = typeof callback === "string" || receiver === THIS;
	
	    function generateCallForArgumentCount(count) {
	        var args = argumentSequence(count).join(", ");
	        var comma = count > 0 ? ", " : "";
	        var ret;
	        if (shouldProxyThis) {
	            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
	        } else {
	            ret = receiver === undefined
	                ? "ret = callback({{args}}, nodeback); break;\n"
	                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
	        }
	        return ret.replace("{{args}}", args).replace(", ", comma);
	    }
	
	    function generateArgumentSwitchCase() {
	        var ret = "";
	        for (var i = 0; i < argumentOrder.length; ++i) {
	            ret += "case " + argumentOrder[i] +":" +
	                generateCallForArgumentCount(argumentOrder[i]);
	        }
	
	        ret += "                                                             \n\
	        default:                                                             \n\
	            var args = new Array(len + 1);                                   \n\
	            var i = 0;                                                       \n\
	            for (var i = 0; i < len; ++i) {                                  \n\
	               args[i] = arguments[i];                                       \n\
	            }                                                                \n\
	            args[i] = nodeback;                                              \n\
	            [CodeForCall]                                                    \n\
	            break;                                                           \n\
	        ".replace("[CodeForCall]", (shouldProxyThis
	                                ? "ret = callback.apply(this, args);\n"
	                                : "ret = callback.apply(receiver, args);\n"));
	        return ret;
	    }
	
	    var getFunctionCode = typeof callback === "string"
	                                ? ("this != null ? this['"+callback+"'] : fn")
	                                : "fn";
	    var body = "'use strict';                                                \n\
	        var ret = function (Parameters) {                                    \n\
	            'use strict';                                                    \n\
	            var len = arguments.length;                                      \n\
	            var promise = new Promise(INTERNAL);                             \n\
	            promise._captureStackTrace();                                    \n\
	            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
	            var ret;                                                         \n\
	            var callback = tryCatch([GetFunctionCode]);                      \n\
	            switch(len) {                                                    \n\
	                [CodeForSwitchCase]                                          \n\
	            }                                                                \n\
	            if (ret === errorObj) {                                          \n\
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
	            }                                                                \n\
	            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
	            return promise;                                                  \n\
	        };                                                                   \n\
	        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
	        return ret;                                                          \n\
	    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
	        .replace("[GetFunctionCode]", getFunctionCode);
	    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
	    return new Function("Promise",
	                        "fn",
	                        "receiver",
	                        "withAppended",
	                        "maybeWrapAsError",
	                        "nodebackForPromise",
	                        "tryCatch",
	                        "errorObj",
	                        "notEnumerableProp",
	                        "INTERNAL",
	                        body)(
	                    Promise,
	                    fn,
	                    receiver,
	                    withAppended,
	                    maybeWrapAsError,
	                    nodebackForPromise,
	                    util.tryCatch,
	                    util.errorObj,
	                    util.notEnumerableProp,
	                    INTERNAL);
	};
	}
	
	function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
	    var defaultThis = (function() {return this;})();
	    var method = callback;
	    if (typeof method === "string") {
	        callback = fn;
	    }
	    function promisified() {
	        var _receiver = receiver;
	        if (receiver === THIS) _receiver = this;
	        var promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	        var cb = typeof method === "string" && this !== defaultThis
	            ? this[method] : callback;
	        var fn = nodebackForPromise(promise, multiArgs);
	        try {
	            cb.apply(_receiver, withAppended(arguments, fn));
	        } catch(e) {
	            promise._rejectCallback(maybeWrapAsError(e), true, true);
	        }
	        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
	        return promise;
	    }
	    util.notEnumerableProp(promisified, "__isPromisified__", true);
	    return promisified;
	}
	
	var makeNodePromisified = canEvaluate
	    ? makeNodePromisifiedEval
	    : makeNodePromisifiedClosure;
	
	function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
	    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
	    var methods =
	        promisifiableMethods(obj, suffix, suffixRegexp, filter);
	
	    for (var i = 0, len = methods.length; i < len; i+= 2) {
	        var key = methods[i];
	        var fn = methods[i+1];
	        var promisifiedKey = key + suffix;
	        if (promisifier === makeNodePromisified) {
	            obj[promisifiedKey] =
	                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
	        } else {
	            var promisified = promisifier(fn, function() {
	                return makeNodePromisified(key, THIS, key,
	                                           fn, suffix, multiArgs);
	            });
	            util.notEnumerableProp(promisified, "__isPromisified__", true);
	            obj[promisifiedKey] = promisified;
	        }
	    }
	    util.toFastProperties(obj);
	    return obj;
	}
	
	function promisify(callback, receiver, multiArgs) {
	    return makeNodePromisified(callback, receiver, undefined,
	                                callback, null, multiArgs);
	}
	
	Promise.promisify = function (fn, options) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    if (isPromisified(fn)) {
	        return fn;
	    }
	    options = Object(options);
	    var receiver = options.context === undefined ? THIS : options.context;
	    var multiArgs = !!options.multiArgs;
	    var ret = promisify(fn, receiver, multiArgs);
	    util.copyDescriptors(fn, ret, propsFilter);
	    return ret;
	};
	
	Promise.promisifyAll = function (target, options) {
	    if (typeof target !== "function" && typeof target !== "object") {
	        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    options = Object(options);
	    var multiArgs = !!options.multiArgs;
	    var suffix = options.suffix;
	    if (typeof suffix !== "string") suffix = defaultSuffix;
	    var filter = options.filter;
	    if (typeof filter !== "function") filter = defaultFilter;
	    var promisifier = options.promisifier;
	    if (typeof promisifier !== "function") promisifier = makeNodePromisified;
	
	    if (!util.isIdentifier(suffix)) {
	        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	
	    var keys = util.inheritedDataKeys(target);
	    for (var i = 0; i < keys.length; ++i) {
	        var value = target[keys[i]];
	        if (keys[i] !== "constructor" &&
	            util.isClass(value)) {
	            promisifyAll(value.prototype, suffix, filter, promisifier,
	                multiArgs);
	            promisifyAll(value, suffix, filter, promisifier, multiArgs);
	        }
	    }
	
	    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
	};
	};
	


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(16);
	var isObject = util.isObject;
	var es5 = __webpack_require__(92);
	var Es6Map;
	if (typeof Map === "function") Es6Map = Map;
	
	var mapToEntries = (function() {
	    var index = 0;
	    var size = 0;
	
	    function extractEntry(value, key) {
	        this[index] = value;
	        this[index + size] = key;
	        index++;
	    }
	
	    return function mapToEntries(map) {
	        size = map.size;
	        index = 0;
	        var ret = new Array(map.size * 2);
	        map.forEach(extractEntry, ret);
	        return ret;
	    };
	})();
	
	var entriesToMap = function(entries) {
	    var ret = new Es6Map();
	    var length = entries.length / 2 | 0;
	    for (var i = 0; i < length; ++i) {
	        var key = entries[length + i];
	        var value = entries[i];
	        ret.set(key, value);
	    }
	    return ret;
	};
	
	function PropertiesPromiseArray(obj) {
	    var isMap = false;
	    var entries;
	    if (Es6Map !== undefined && obj instanceof Es6Map) {
	        entries = mapToEntries(obj);
	        isMap = true;
	    } else {
	        var keys = es5.keys(obj);
	        var len = keys.length;
	        entries = new Array(len * 2);
	        for (var i = 0; i < len; ++i) {
	            var key = keys[i];
	            entries[i] = obj[key];
	            entries[i + len] = key;
	        }
	    }
	    this.constructor$(entries);
	    this._isMap = isMap;
	    this._init$(undefined, isMap ? -6 : -3);
	}
	util.inherits(PropertiesPromiseArray, PromiseArray);
	
	PropertiesPromiseArray.prototype._init = function () {};
	
	PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        var val;
	        if (this._isMap) {
	            val = entriesToMap(this._values);
	        } else {
	            val = {};
	            var keyOffset = this.length();
	            for (var i = 0, len = this.length(); i < len; ++i) {
	                val[this._values[i + keyOffset]] = this._values[i];
	            }
	        }
	        this._resolve(val);
	        return true;
	    }
	    return false;
	};
	
	PropertiesPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	PropertiesPromiseArray.prototype.getActualLength = function (len) {
	    return len >> 1;
	};
	
	function props(promises) {
	    var ret;
	    var castValue = tryConvertToPromise(promises);
	
	    if (!isObject(castValue)) {
	        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    } else if (castValue instanceof Promise) {
	        ret = castValue._then(
	            Promise.props, undefined, undefined, undefined, undefined);
	    } else {
	        ret = new PropertiesPromiseArray(castValue).promise();
	    }
	
	    if (castValue instanceof Promise) {
	        ret._propagateFrom(castValue, 2);
	    }
	    return ret;
	}
	
	Promise.prototype.props = function () {
	    return props(this);
	};
	
	Promise.props = function (promises) {
	    return props(promises);
	};
	};


/***/ },
/* 632 */
/***/ function(module, exports) {

	"use strict";
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(16);
	
	var raceLater = function (promise) {
	    return promise.then(function(array) {
	        return race(array, promise);
	    });
	};
	
	function race(promises, parent) {
	    var maybePromise = tryConvertToPromise(promises);
	
	    if (maybePromise instanceof Promise) {
	        return raceLater(maybePromise);
	    } else {
	        promises = util.asArray(promises);
	        if (promises === null)
	            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
	    }
	
	    var ret = new Promise(INTERNAL);
	    if (parent !== undefined) {
	        ret._propagateFrom(parent, 3);
	    }
	    var fulfill = ret._fulfill;
	    var reject = ret._reject;
	    for (var i = 0, len = promises.length; i < len; ++i) {
	        var val = promises[i];
	
	        if (val === undefined && !(i in promises)) {
	            continue;
	        }
	
	        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
	    }
	    return ret;
	}
	
	Promise.race = function (promises) {
	    return race(promises, undefined);
	};
	
	Promise.prototype.race = function () {
	    return race(this, undefined);
	};
	
	};


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(16);
	var tryCatch = util.tryCatch;
	
	function ReductionPromiseArray(promises, fn, initialValue, _each) {
	    this.constructor$(promises);
	    var domain = getDomain();
	    this._fn = domain === null ? fn : util.domainBind(domain, fn);
	    if (initialValue !== undefined) {
	        initialValue = Promise.resolve(initialValue);
	        initialValue._attachCancellationCallback(this);
	    }
	    this._initialValue = initialValue;
	    this._currentCancellable = null;
	    if(_each === INTERNAL) {
	        this._eachValues = Array(this._length);
	    } else if (_each === 0) {
	        this._eachValues = null;
	    } else {
	        this._eachValues = undefined;
	    }
	    this._promise._captureStackTrace();
	    this._init$(undefined, -5);
	}
	util.inherits(ReductionPromiseArray, PromiseArray);
	
	ReductionPromiseArray.prototype._gotAccum = function(accum) {
	    if (this._eachValues !== undefined && 
	        this._eachValues !== null && 
	        accum !== INTERNAL) {
	        this._eachValues.push(accum);
	    }
	};
	
	ReductionPromiseArray.prototype._eachComplete = function(value) {
	    if (this._eachValues !== null) {
	        this._eachValues.push(value);
	    }
	    return this._eachValues;
	};
	
	ReductionPromiseArray.prototype._init = function() {};
	
	ReductionPromiseArray.prototype._resolveEmptyArray = function() {
	    this._resolve(this._eachValues !== undefined ? this._eachValues
	                                                 : this._initialValue);
	};
	
	ReductionPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	ReductionPromiseArray.prototype._resolve = function(value) {
	    this._promise._resolveCallback(value);
	    this._values = null;
	};
	
	ReductionPromiseArray.prototype._resultCancelled = function(sender) {
	    if (sender === this._initialValue) return this._cancel();
	    if (this._isResolved()) return;
	    this._resultCancelled$();
	    if (this._currentCancellable instanceof Promise) {
	        this._currentCancellable.cancel();
	    }
	    if (this._initialValue instanceof Promise) {
	        this._initialValue.cancel();
	    }
	};
	
	ReductionPromiseArray.prototype._iterate = function (values) {
	    this._values = values;
	    var value;
	    var i;
	    var length = values.length;
	    if (this._initialValue !== undefined) {
	        value = this._initialValue;
	        i = 0;
	    } else {
	        value = Promise.resolve(values[0]);
	        i = 1;
	    }
	
	    this._currentCancellable = value;
	
	    if (!value.isRejected()) {
	        for (; i < length; ++i) {
	            var ctx = {
	                accum: null,
	                value: values[i],
	                index: i,
	                length: length,
	                array: this
	            };
	            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
	        }
	    }
	
	    if (this._eachValues !== undefined) {
	        value = value
	            ._then(this._eachComplete, undefined, undefined, this, undefined);
	    }
	    value._then(completed, completed, undefined, value, this);
	};
	
	Promise.prototype.reduce = function (fn, initialValue) {
	    return reduce(this, fn, initialValue, null);
	};
	
	Promise.reduce = function (promises, fn, initialValue, _each) {
	    return reduce(promises, fn, initialValue, _each);
	};
	
	function completed(valueOrReason, array) {
	    if (this.isFulfilled()) {
	        array._resolve(valueOrReason);
	    } else {
	        array._reject(valueOrReason);
	    }
	}
	
	function reduce(promises, fn, initialValue, _each) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
	    return array.promise();
	}
	
	function gotAccum(accum) {
	    this.accum = accum;
	    this.array._gotAccum(accum);
	    var value = tryConvertToPromise(this.value, this.array._promise);
	    if (value instanceof Promise) {
	        this.array._currentCancellable = value;
	        return value._then(gotValue, undefined, undefined, this, undefined);
	    } else {
	        return gotValue.call(this, value);
	    }
	}
	
	function gotValue(value) {
	    var array = this.array;
	    var promise = array._promise;
	    var fn = tryCatch(array._fn);
	    promise._pushContext();
	    var ret;
	    if (array._eachValues !== undefined) {
	        ret = fn.call(promise._boundValue(), value, this.index, this.length);
	    } else {
	        ret = fn.call(promise._boundValue(),
	                              this.accum, value, this.index, this.length);
	    }
	    if (ret instanceof Promise) {
	        array._currentCancellable = ret;
	    }
	    var promiseCreated = promise._popContext();
	    debug.checkForgottenReturns(
	        ret,
	        promiseCreated,
	        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
	        promise
	    );
	    return ret;
	}
	};


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, setImmediate) {"use strict";
	var util = __webpack_require__(16);
	var schedule;
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var NativePromise = util.getNativePromise();
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if (typeof NativePromise === "function" &&
	           typeof NativePromise.resolve === "function") {
	    var nativePromise = NativePromise.resolve();
	    schedule = function(fn) {
	        nativePromise.then(fn);
	    };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            (window.navigator.standalone || window.cordova))) {
	    schedule = (function() {
	        var div = document.createElement("div");
	        var opts = {attributes: true};
	        var toggleScheduled = false;
	        var div2 = document.createElement("div");
	        var o2 = new MutationObserver(function() {
	            div.classList.toggle("foo");
	            toggleScheduled = false;
	        });
	        o2.observe(div2, opts);
	
	        var scheduleToggle = function() {
	            if (toggleScheduled) return;
	            toggleScheduled = true;
	            div2.classList.toggle("foo");
	        };
	
	        return function schedule(fn) {
	            var o = new MutationObserver(function() {
	                o.disconnect();
	                fn();
	            });
	            o.observe(div, opts);
	            scheduleToggle();
	        };
	    })();
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(48), __webpack_require__(1177).setImmediate))

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	    function(Promise, PromiseArray, debug) {
	var PromiseInspection = Promise.PromiseInspection;
	var util = __webpack_require__(16);
	
	function SettledPromiseArray(values) {
	    this.constructor$(values);
	}
	util.inherits(SettledPromiseArray, PromiseArray);
	
	SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
	    this._values[index] = inspection;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 33554432;
	    ret._settledValueField = value;
	    return this._promiseResolved(index, ret);
	};
	SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 16777216;
	    ret._settledValueField = reason;
	    return this._promiseResolved(index, ret);
	};
	
	Promise.settle = function (promises) {
	    debug.deprecated(".settle()", ".reflect()");
	    return new SettledPromiseArray(promises).promise();
	};
	
	Promise.prototype.settle = function () {
	    return Promise.settle(this);
	};
	};


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, apiRejection) {
	var util = __webpack_require__(16);
	var RangeError = __webpack_require__(68).RangeError;
	var AggregateError = __webpack_require__(68).AggregateError;
	var isArray = util.isArray;
	var CANCELLATION = {};
	
	
	function SomePromiseArray(values) {
	    this.constructor$(values);
	    this._howMany = 0;
	    this._unwrap = false;
	    this._initialized = false;
	}
	util.inherits(SomePromiseArray, PromiseArray);
	
	SomePromiseArray.prototype._init = function () {
	    if (!this._initialized) {
	        return;
	    }
	    if (this._howMany === 0) {
	        this._resolve([]);
	        return;
	    }
	    this._init$(undefined, -5);
	    var isArrayResolved = isArray(this._values);
	    if (!this._isResolved() &&
	        isArrayResolved &&
	        this._howMany > this._canPossiblyFulfill()) {
	        this._reject(this._getRangeError(this.length()));
	    }
	};
	
	SomePromiseArray.prototype.init = function () {
	    this._initialized = true;
	    this._init();
	};
	
	SomePromiseArray.prototype.setUnwrap = function () {
	    this._unwrap = true;
	};
	
	SomePromiseArray.prototype.howMany = function () {
	    return this._howMany;
	};
	
	SomePromiseArray.prototype.setHowMany = function (count) {
	    this._howMany = count;
	};
	
	SomePromiseArray.prototype._promiseFulfilled = function (value) {
	    this._addFulfilled(value);
	    if (this._fulfilled() === this.howMany()) {
	        this._values.length = this.howMany();
	        if (this.howMany() === 1 && this._unwrap) {
	            this._resolve(this._values[0]);
	        } else {
	            this._resolve(this._values);
	        }
	        return true;
	    }
	    return false;
	
	};
	SomePromiseArray.prototype._promiseRejected = function (reason) {
	    this._addRejected(reason);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._promiseCancelled = function () {
	    if (this._values instanceof Promise || this._values == null) {
	        return this._cancel();
	    }
	    this._addRejected(CANCELLATION);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._checkOutcome = function() {
	    if (this.howMany() > this._canPossiblyFulfill()) {
	        var e = new AggregateError();
	        for (var i = this.length(); i < this._values.length; ++i) {
	            if (this._values[i] !== CANCELLATION) {
	                e.push(this._values[i]);
	            }
	        }
	        if (e.length > 0) {
	            this._reject(e);
	        } else {
	            this._cancel();
	        }
	        return true;
	    }
	    return false;
	};
	
	SomePromiseArray.prototype._fulfilled = function () {
	    return this._totalResolved;
	};
	
	SomePromiseArray.prototype._rejected = function () {
	    return this._values.length - this.length();
	};
	
	SomePromiseArray.prototype._addRejected = function (reason) {
	    this._values.push(reason);
	};
	
	SomePromiseArray.prototype._addFulfilled = function (value) {
	    this._values[this._totalResolved++] = value;
	};
	
	SomePromiseArray.prototype._canPossiblyFulfill = function () {
	    return this.length() - this._rejected();
	};
	
	SomePromiseArray.prototype._getRangeError = function (count) {
	    var message = "Input array must contain at least " +
	            this._howMany + " items but contains only " + count + " items";
	    return new RangeError(message);
	};
	
	SomePromiseArray.prototype._resolveEmptyArray = function () {
	    this._reject(this._getRangeError(0));
	};
	
	function some(promises, howMany) {
	    if ((howMany | 0) !== howMany || howMany < 0) {
	        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(howMany);
	    ret.init();
	    return promise;
	}
	
	Promise.some = function (promises, howMany) {
	    return some(promises, howMany);
	};
	
	Promise.prototype.some = function (howMany) {
	    return some(this, howMany);
	};
	
	Promise._SomePromiseArray = SomePromiseArray;
	};


/***/ },
/* 638 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValueField = promise._isFateSealed()
	            ? promise._settledValue() : undefined;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValueField = undefined;
	    }
	}
	
	PromiseInspection.prototype._settledValue = function() {
	    return this._settledValueField;
	};
	
	var value = PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var reason = PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
	    return (this._bitField & 33554432) !== 0;
	};
	
	var isRejected = PromiseInspection.prototype.isRejected = function () {
	    return (this._bitField & 16777216) !== 0;
	};
	
	var isPending = PromiseInspection.prototype.isPending = function () {
	    return (this._bitField & 50397184) === 0;
	};
	
	var isResolved = PromiseInspection.prototype.isResolved = function () {
	    return (this._bitField & 50331648) !== 0;
	};
	
	PromiseInspection.prototype.isCancelled = function() {
	    return (this._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.__isCancelled = function() {
	    return (this._bitField & 65536) === 65536;
	};
	
	Promise.prototype._isCancelled = function() {
	    return this._target().__isCancelled();
	};
	
	Promise.prototype.isCancelled = function() {
	    return (this._target()._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.isPending = function() {
	    return isPending.call(this._target());
	};
	
	Promise.prototype.isRejected = function() {
	    return isRejected.call(this._target());
	};
	
	Promise.prototype.isFulfilled = function() {
	    return isFulfilled.call(this._target());
	};
	
	Promise.prototype.isResolved = function() {
	    return isResolved.call(this._target());
	};
	
	Promise.prototype.value = function() {
	    return value.call(this._target());
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    target._unsetRejectionIsUnhandled();
	    return reason.call(target);
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue();
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue();
	};
	
	Promise.PromiseInspection = PromiseInspection;
	};


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = __webpack_require__(16);
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) return obj;
	        var then = getThen(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            if (isAnyBluebirdPromise(obj)) {
	                var ret = new Promise(INTERNAL);
	                obj._then(
	                    ret._fulfill,
	                    ret._reject,
	                    undefined,
	                    ret,
	                    null
	                );
	                return ret;
	            }
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function doGetThen(obj) {
	    return obj.then;
	}
	
	function getThen(obj) {
	    try {
	        return doGetThen(obj);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    try {
	        return hasProp.call(obj, "_promise0");
	    } catch (e) {
	        return false;
	    }
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x, resolve, reject);
	    synchronous = false;
	
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolve(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function reject(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, debug) {
	var util = __webpack_require__(16);
	var TimeoutError = Promise.TimeoutError;
	
	function HandleWrapper(handle)  {
	    this.handle = handle;
	}
	
	HandleWrapper.prototype._resultCancelled = function() {
	    clearTimeout(this.handle);
	};
	
	var afterValue = function(value) { return delay(+this).thenReturn(value); };
	var delay = Promise.delay = function (ms, value) {
	    var ret;
	    var handle;
	    if (value !== undefined) {
	        ret = Promise.resolve(value)
	                ._then(afterValue, null, null, ms, undefined);
	        if (debug.cancellation() && value instanceof Promise) {
	            ret._setOnCancel(value);
	        }
	    } else {
	        ret = new Promise(INTERNAL);
	        handle = setTimeout(function() { ret._fulfill(); }, +ms);
	        if (debug.cancellation()) {
	            ret._setOnCancel(new HandleWrapper(handle));
	        }
	        ret._captureStackTrace();
	    }
	    ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.prototype.delay = function (ms) {
	    return delay(ms, this);
	};
	
	var afterTimeout = function (promise, message, parent) {
	    var err;
	    if (typeof message !== "string") {
	        if (message instanceof Error) {
	            err = message;
	        } else {
	            err = new TimeoutError("operation timed out");
	        }
	    } else {
	        err = new TimeoutError(message);
	    }
	    util.markAsOriginatingFromRejection(err);
	    promise._attachExtraTrace(err);
	    promise._reject(err);
	
	    if (parent != null) {
	        parent.cancel();
	    }
	};
	
	function successClear(value) {
	    clearTimeout(this.handle);
	    return value;
	}
	
	function failureClear(reason) {
	    clearTimeout(this.handle);
	    throw reason;
	}
	
	Promise.prototype.timeout = function (ms, message) {
	    ms = +ms;
	    var ret, parent;
	
	    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
	        if (ret.isPending()) {
	            afterTimeout(ret, message, parent);
	        }
	    }, ms));
	
	    if (debug.cancellation()) {
	        parent = this.then();
	        ret = parent._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	        ret._setOnCancel(handleWrapper);
	    } else {
	        ret = this._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	    }
	
	    return ret;
	};
	
	};


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function (Promise, apiRejection, tryConvertToPromise,
	    createContext, INTERNAL, debug) {
	    var util = __webpack_require__(16);
	    var TypeError = __webpack_require__(68).TypeError;
	    var inherits = __webpack_require__(16).inherits;
	    var errorObj = util.errorObj;
	    var tryCatch = util.tryCatch;
	    var NULL = {};
	
	    function thrower(e) {
	        setTimeout(function(){throw e;}, 0);
	    }
	
	    function castPreservingDisposable(thenable) {
	        var maybePromise = tryConvertToPromise(thenable);
	        if (maybePromise !== thenable &&
	            typeof thenable._isDisposable === "function" &&
	            typeof thenable._getDisposer === "function" &&
	            thenable._isDisposable()) {
	            maybePromise._setDisposable(thenable._getDisposer());
	        }
	        return maybePromise;
	    }
	    function dispose(resources, inspection) {
	        var i = 0;
	        var len = resources.length;
	        var ret = new Promise(INTERNAL);
	        function iterator() {
	            if (i >= len) return ret._fulfill();
	            var maybePromise = castPreservingDisposable(resources[i++]);
	            if (maybePromise instanceof Promise &&
	                maybePromise._isDisposable()) {
	                try {
	                    maybePromise = tryConvertToPromise(
	                        maybePromise._getDisposer().tryDispose(inspection),
	                        resources.promise);
	                } catch (e) {
	                    return thrower(e);
	                }
	                if (maybePromise instanceof Promise) {
	                    return maybePromise._then(iterator, thrower,
	                                              null, null, null);
	                }
	            }
	            iterator();
	        }
	        iterator();
	        return ret;
	    }
	
	    function Disposer(data, promise, context) {
	        this._data = data;
	        this._promise = promise;
	        this._context = context;
	    }
	
	    Disposer.prototype.data = function () {
	        return this._data;
	    };
	
	    Disposer.prototype.promise = function () {
	        return this._promise;
	    };
	
	    Disposer.prototype.resource = function () {
	        if (this.promise().isFulfilled()) {
	            return this.promise().value();
	        }
	        return NULL;
	    };
	
	    Disposer.prototype.tryDispose = function(inspection) {
	        var resource = this.resource();
	        var context = this._context;
	        if (context !== undefined) context._pushContext();
	        var ret = resource !== NULL
	            ? this.doDispose(resource, inspection) : null;
	        if (context !== undefined) context._popContext();
	        this._promise._unsetDisposable();
	        this._data = null;
	        return ret;
	    };
	
	    Disposer.isDisposer = function (d) {
	        return (d != null &&
	                typeof d.resource === "function" &&
	                typeof d.tryDispose === "function");
	    };
	
	    function FunctionDisposer(fn, promise, context) {
	        this.constructor$(fn, promise, context);
	    }
	    inherits(FunctionDisposer, Disposer);
	
	    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
	        var fn = this.data();
	        return fn.call(resource, resource, inspection);
	    };
	
	    function maybeUnwrapDisposer(value) {
	        if (Disposer.isDisposer(value)) {
	            this.resources[this.index]._setDisposable(value);
	            return value.promise();
	        }
	        return value;
	    }
	
	    function ResourceList(length) {
	        this.length = length;
	        this.promise = null;
	        this[length-1] = null;
	    }
	
	    ResourceList.prototype._resultCancelled = function() {
	        var len = this.length;
	        for (var i = 0; i < len; ++i) {
	            var item = this[i];
	            if (item instanceof Promise) {
	                item.cancel();
	            }
	        }
	    };
	
	    Promise.using = function () {
	        var len = arguments.length;
	        if (len < 2) return apiRejection(
	                        "you must pass at least 2 arguments to Promise.using");
	        var fn = arguments[len - 1];
	        if (typeof fn !== "function") {
	            return apiRejection("expecting a function but got " + util.classString(fn));
	        }
	        var input;
	        var spreadArgs = true;
	        if (len === 2 && Array.isArray(arguments[0])) {
	            input = arguments[0];
	            len = input.length;
	            spreadArgs = false;
	        } else {
	            input = arguments;
	            len--;
	        }
	        var resources = new ResourceList(len);
	        for (var i = 0; i < len; ++i) {
	            var resource = input[i];
	            if (Disposer.isDisposer(resource)) {
	                var disposer = resource;
	                resource = resource.promise();
	                resource._setDisposable(disposer);
	            } else {
	                var maybePromise = tryConvertToPromise(resource);
	                if (maybePromise instanceof Promise) {
	                    resource =
	                        maybePromise._then(maybeUnwrapDisposer, null, null, {
	                            resources: resources,
	                            index: i
	                    }, undefined);
	                }
	            }
	            resources[i] = resource;
	        }
	
	        var reflectedResources = new Array(resources.length);
	        for (var i = 0; i < reflectedResources.length; ++i) {
	            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
	        }
	
	        var resultPromise = Promise.all(reflectedResources)
	            .then(function(inspections) {
	                for (var i = 0; i < inspections.length; ++i) {
	                    var inspection = inspections[i];
	                    if (inspection.isRejected()) {
	                        errorObj.e = inspection.error();
	                        return errorObj;
	                    } else if (!inspection.isFulfilled()) {
	                        resultPromise.cancel();
	                        return;
	                    }
	                    inspections[i] = inspection.value();
	                }
	                promise._pushContext();
	
	                fn = tryCatch(fn);
	                var ret = spreadArgs
	                    ? fn.apply(undefined, inspections) : fn(inspections);
	                var promiseCreated = promise._popContext();
	                debug.checkForgottenReturns(
	                    ret, promiseCreated, "Promise.using", promise);
	                return ret;
	            });
	
	        var promise = resultPromise.lastly(function() {
	            var inspection = new Promise.PromiseInspection(resultPromise);
	            return dispose(resources, inspection);
	        });
	        resources.promise = promise;
	        promise._setOnCancel(resources);
	        return promise;
	    };
	
	    Promise.prototype._setDisposable = function (disposer) {
	        this._bitField = this._bitField | 131072;
	        this._disposer = disposer;
	    };
	
	    Promise.prototype._isDisposable = function () {
	        return (this._bitField & 131072) > 0;
	    };
	
	    Promise.prototype._getDisposer = function () {
	        return this._disposer;
	    };
	
	    Promise.prototype._unsetDisposable = function () {
	        this._bitField = this._bitField & (~131072);
	        this._disposer = undefined;
	    };
	
	    Promise.prototype.disposer = function (fn) {
	        if (typeof fn === "function") {
	            return new FunctionDisposer(fn, this, createContext());
	        }
	        throw new TypeError();
	    };
	
	};


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var window = (typeof window === "undefined") ? {} : window;
	(function(root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === "object" && module.exports) {
	        module.exports = factory();
	    } else {
	        root.bodymovin = factory();
	    }
	}(window, function() {
	    var svgNS = "http://www.w3.org/2000/svg";
	var subframeEnabled = true;
	var expressionsPlugin;
	var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	var cachedColors = {};
	var bm_rounder = Math.round;
	var bm_rnd;
	var bm_pow = Math.pow;
	var bm_sqrt = Math.sqrt;
	var bm_abs = Math.abs;
	var bm_floor = Math.floor;
	var bm_max = Math.max;
	var bm_min = Math.min;
	var blitter = 10;
	
	var BMMath = {};
	(function(){
	    var propertyNames = Object.getOwnPropertyNames(Math);
	    var i, len = propertyNames.length;
	    for(i=0;i<len;i+=1){
	        BMMath[propertyNames[i]] = Math[propertyNames[i]];
	    }
	}());
	
	function ProjectInterface(){return {}};
	
	BMMath.random = Math.random;
	BMMath.abs = function(val){
	    var tOfVal = typeof val;
	    if(tOfVal === 'object' && val.length){
	        var absArr = Array.apply(null,{length:val.length});
	        var i, len = val.length;
	        for(i=0;i<len;i+=1){
	            absArr[i] = Math.abs(val[i]);
	        }
	        return absArr;
	    }
	    return Math.abs(val);
	
	}
	var defaultCurveSegments = 150;
	var degToRads = Math.PI/180;
	var roundCorner = 0.5519;
	
	function roundValues(flag){
	    if(flag){
	        bm_rnd = Math.round;
	    }else{
	        bm_rnd = function(val){
	            return val;
	        };
	    }
	}
	roundValues(false);
	
	function roundTo2Decimals(val){
	    return Math.round(val*10000)/10000;
	}
	
	function roundTo3Decimals(val){
	    return Math.round(val*100)/100;
	}
	
	function styleDiv(element){
	    element.style.position = 'absolute';
	    element.style.top = 0;
	    element.style.left = 0;
	    element.style.display = 'block';
	    element.style.transformOrigin = element.style.webkitTransformOrigin = '0 0';
	    element.style.backfaceVisibility  = element.style.webkitBackfaceVisibility = 'visible';
	    element.style.transformStyle = element.style.webkitTransformStyle = element.style.mozTransformStyle = "preserve-3d";
	}
	
	function styleUnselectableDiv(element){
	    element.style.userSelect = 'none';
	    element.style.MozUserSelect = 'none';
	    element.style.webkitUserSelect = 'none';
	    element.style.oUserSelect = 'none';
	
	}
	
	function BMEnterFrameEvent(n,c,t,d){
	    this.type = n;
	    this.currentTime = c;
	    this.totalTime = t;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMCompleteEvent(n,d){
	    this.type = n;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMCompleteLoopEvent(n,c,t,d){
	    this.type = n;
	    this.currentLoop = c;
	    this.totalLoops = t;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMSegmentStartEvent(n,f,t){
	    this.type = n;
	    this.firstFrame = f;
	    this.totalFrames = t;
	}
	
	function BMDestroyEvent(n,t){
	    this.type = n;
	    this.target = t;
	}
	
	function _addEventListener(eventName, callback){
	
	    if (!this._cbs[eventName]){
	        this._cbs[eventName] = [];
	    }
	    this._cbs[eventName].push(callback);
	
		return function() {
			this.removeEventListener(eventName, callback);
		}.bind(this);
	}
	
	function _removeEventListener(eventName,callback){
	
	    if (!callback){
	        this._cbs[eventName] = null;
	    }else if(this._cbs[eventName]){
	        var i = 0, len = this._cbs[eventName].length;
	        while(i<len){
	            if(this._cbs[eventName][i] === callback){
	                this._cbs[eventName].splice(i,1);
	                i -=1;
	                len -= 1;
	            }
	            i += 1;
	        }
	        if(!this._cbs[eventName].length){
	            this._cbs[eventName] = null;
	        }
	    }
	
	}
	
	function _triggerEvent(eventName, args){
	    if (this._cbs[eventName]) {
	        var len = this._cbs[eventName].length;
	        for (var i = 0; i < len; i++){
	            this._cbs[eventName][i](args);
	        }
	    }
	}
	
	function randomString(length, chars){
	    if(chars === undefined){
	        chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
	    }
	    var i;
	    var result = '';
	    for (i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
	    return result;
	}
	
	function HSVtoRGB(h, s, v) {
	    var r, g, b, i, f, p, q, t;
	    if (arguments.length === 1) {
	        s = h.s, v = h.v, h = h.h;
	    }
	    i = Math.floor(h * 6);
	    f = h * 6 - i;
	    p = v * (1 - s);
	    q = v * (1 - f * s);
	    t = v * (1 - (1 - f) * s);
	    switch (i % 6) {
	        case 0: r = v, g = t, b = p; break;
	        case 1: r = q, g = v, b = p; break;
	        case 2: r = p, g = v, b = t; break;
	        case 3: r = p, g = q, b = v; break;
	        case 4: r = t, g = p, b = v; break;
	        case 5: r = v, g = p, b = q; break;
	    }
	    return [ r,
	        g,
	         b ];
	}
	
	function RGBtoHSV(r, g, b) {
	    if (arguments.length === 1) {
	        g = r.g, b = r.b, r = r.r;
	    }
	    var max = Math.max(r, g, b), min = Math.min(r, g, b),
	        d = max - min,
	        h,
	        s = (max === 0 ? 0 : d / max),
	        v = max / 255;
	
	    switch (max) {
	        case min: h = 0; break;
	        case r: h = (g - b) + d * (g < b ? 6: 0); h /= 6 * d; break;
	        case g: h = (b - r) + d * 2; h /= 6 * d; break;
	        case b: h = (r - g) + d * 4; h /= 6 * d; break;
	    }
	
	    return [
	         h,
	         s,
	         v
	    ];
	}
	
	function addSaturationToRGB(color,offset){
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[1] += offset;
	    if (hsv[1] > 1) {
	        hsv[1] = 1;
	    }
	    else if (hsv[1] <= 0) {
	        hsv[1] = 0;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	function addBrightnessToRGB(color,offset){
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[2] += offset;
	    if (hsv[2] > 1) {
	        hsv[2] = 1;
	    }
	    else if (hsv[2] < 0) {
	        hsv[2] = 0;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	function addHueToRGB(color,offset) {
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[0] += offset/360;
	    if (hsv[0] > 1) {
	        hsv[0] -= 1;
	    }
	    else if (hsv[0] < 0) {
	        hsv[0] += 1;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	function componentToHex(c) {
	    var hex = c.toString(16);
	    return hex.length == 1 ? '0' + hex : hex;
	}
	
	var rgbToHex = (function(){
	    var colorMap = [];
	    var i;
	    var hex;
	    for(i=0;i<256;i+=1){
	        hex = i.toString(16);
	        colorMap[i] = hex.length == 1 ? '0' + hex : hex;
	    }
	
	    return function(r, g, b) {
	        if(r<0){
	            r = 0;
	        }
	        if(g<0){
	            g = 0;
	        }
	        if(b<0){
	            b = 0;
	        }
	        return '#' + colorMap[r] + colorMap[g] + colorMap[b];
	    };
	}());
	
	function fillToRgba(hex,alpha){
	    if(!cachedColors[hex]){
	        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	        cachedColors[hex] = parseInt(result[1], 16)+','+parseInt(result[2], 16)+','+parseInt(result[3], 16);
	    }
	    return 'rgba('+cachedColors[hex]+','+alpha+')';
	}
	
	var fillColorToString = (function(){
	
	    var colorMap = [];
	    return function(colorArr,alpha){
	        if(alpha !== undefined){
	            colorArr[3] = alpha;
	        }
	        if(!colorMap[colorArr[0]]){
	            colorMap[colorArr[0]] = {};
	        }
	        if(!colorMap[colorArr[0]][colorArr[1]]){
	            colorMap[colorArr[0]][colorArr[1]] = {};
	        }
	        if(!colorMap[colorArr[0]][colorArr[1]][colorArr[2]]){
	            colorMap[colorArr[0]][colorArr[1]][colorArr[2]] = {};
	        }
	        if(!colorMap[colorArr[0]][colorArr[1]][colorArr[2]][colorArr[3]]){
	            colorMap[colorArr[0]][colorArr[1]][colorArr[2]][colorArr[3]] = 'rgba(' + colorArr.join(',')+')';
	        }
	        return colorMap[colorArr[0]][colorArr[1]][colorArr[2]][colorArr[3]];
	    };
	}());
	
	function RenderedFrame(tr,o) {
	    this.tr = tr;
	    this.o = o;
	}
	
	function LetterProps(o,sw,sc,fc,m,p){
	    this.o = o;
	    this.sw = sw;
	    this.sc = sc;
	    this.fc = fc;
	    this.m = m;
	    this.props = p;
	}
	
	function iterateDynamicProperties(num){
	    var i, len = this.dynamicProperties;
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue(num);
	    }
	}
	
	function reversePath(paths){
	    var newI = [], newO = [], newV = [];
	    var i, len, newPaths = {};
	    var init = 0;
	    if (paths.c) {
	        newI[0] = paths.o[0];
	        newO[0] = paths.i[0];
	        newV[0] = paths.v[0];
	        init = 1;
	    }
	    len = paths.i.length;
	    var cnt = len - 1;
	
	    for (i = init; i < len; i += 1) {
	        newI.push(paths.o[cnt]);
	        newO.push(paths.i[cnt]);
	        newV.push(paths.v[cnt]);
	        cnt -= 1;
	    }
	
	    newPaths.i = newI;
	    newPaths.o = newO;
	    newPaths.v = newV;
	
	    return newPaths;
	}
	/*!
	 Transformation Matrix v2.0
	 (c) Epistemex 2014-2015
	 www.epistemex.com
	 By Ken Fyrstenberg
	 Contributions by leeoniya.
	 License: MIT, header required.
	 */
	
	/**
	 * 2D transformation matrix object initialized with identity matrix.
	 *
	 * The matrix can synchronize a canvas context by supplying the context
	 * as an argument, or later apply current absolute transform to an
	 * existing context.
	 *
	 * All values are handled as floating point values.
	 *
	 * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
	 * @prop {number} a - scale x
	 * @prop {number} b - shear y
	 * @prop {number} c - shear x
	 * @prop {number} d - scale y
	 * @prop {number} e - translate x
	 * @prop {number} f - translate y
	 * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
	 * @constructor
	 */
	
	var Matrix = (function(){
	
	    function reset(){
	        this.props[0] = 1;
	        this.props[1] = 0;
	        this.props[2] = 0;
	        this.props[3] = 0;
	        this.props[4] = 0;
	        this.props[5] = 1;
	        this.props[6] = 0;
	        this.props[7] = 0;
	        this.props[8] = 0;
	        this.props[9] = 0;
	        this.props[10] = 1;
	        this.props[11] = 0;
	        this.props[12] = 0;
	        this.props[13] = 0;
	        this.props[14] = 0;
	        this.props[15] = 1;
	        return this;
	    }
	
	    function rotate(angle) {
	        if(angle === 0){
	            return this;
	        }
	        var mCos = Math.cos(angle);
	        var mSin = Math.sin(angle);
	        return this._t(mCos, -mSin,  0, 0
	            , mSin,  mCos, 0, 0
	            , 0,  0,  1, 0
	            , 0, 0, 0, 1);
	    }
	
	    function rotateX(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = Math.cos(angle);
	        var mSin = Math.sin(angle);
	        return this._t(1, 0, 0, 0
	            , 0, mCos, -mSin, 0
	            , 0, mSin,  mCos, 0
	            , 0, 0, 0, 1);
	    }
	
	    function rotateY(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = Math.cos(angle);
	        var mSin = Math.sin(angle);
	        return this._t(mCos,  0,  mSin, 0
	            , 0, 1, 0, 0
	            , -mSin,  0,  mCos, 0
	            , 0, 0, 0, 1);
	    }
	
	    function rotateZ(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = Math.cos(angle);
	        var mSin = Math.sin(angle);
	        return this._t(mCos, -mSin,  0, 0
	            , mSin,  mCos, 0, 0
	            , 0,  0,  1, 0
	            , 0, 0, 0, 1);
	    }
	
	    function shear(sx,sy){
	        return this._t(1, sy, sx, 1, 0, 0);
	    }
	
	    function skew(ax, ay){
	        return this.shear(Math.tan(ax), Math.tan(ay));
	    }
	
	    function skewFromAxis(ax, angle){
	        var mCos = Math.cos(angle);
	        var mSin = Math.sin(angle);
	        return this._t(mCos, mSin,  0, 0
	            , -mSin,  mCos, 0, 0
	            , 0,  0,  1, 0
	            , 0, 0, 0, 1)
	            ._t(1, 0,  0, 0
	            , Math.tan(ax),  1, 0, 0
	            , 0,  0,  1, 0
	            , 0, 0, 0, 1)
	            ._t(mCos, -mSin,  0, 0
	            , mSin,  mCos, 0, 0
	            , 0,  0,  1, 0
	            , 0, 0, 0, 1);
	        //return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, Math.tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
	    }
	
	    function scale(sx, sy, sz) {
	        sz = isNaN(sz) ? 1 : sz;
	        if(sx == 1 && sy == 1 && sz == 1){
	            return this;
	        }
	        return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
	    }
	
	    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
	        this.props[0] = a;
	        this.props[1] = b;
	        this.props[2] = c;
	        this.props[3] = d;
	        this.props[4] = e;
	        this.props[5] = f;
	        this.props[6] = g;
	        this.props[7] = h;
	        this.props[8] = i;
	        this.props[9] = j;
	        this.props[10] = k;
	        this.props[11] = l;
	        this.props[12] = m;
	        this.props[13] = n;
	        this.props[14] = o;
	        this.props[15] = p;
	        return this;
	    }
	
	    function translate(tx, ty, tz) {
	        tz = tz || 0;
	        if(tx !== 0 || ty !== 0 || tz !== 0){
	            return this._t(1,0,0,0,0,1,0,0,0,0,1,0,tx,ty,tz,1);
	        }
	        return this;
	    }
	
	    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
	
	        if(a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0){
	            if(m2 !== 0 || n2 !== 0 || o2 !== 0){
	
	                this.props[12] = this.props[12] * a2 + this.props[13] * e2 + this.props[14] * i2 + this.props[15] * m2 ;
	                this.props[13] = this.props[12] * b2 + this.props[13] * f2 + this.props[14] * j2 + this.props[15] * n2 ;
	                this.props[14] = this.props[12] * c2 + this.props[13] * g2 + this.props[14] * k2 + this.props[15] * o2 ;
	                this.props[15] = this.props[12] * d2 + this.props[13] * h2 + this.props[14] * l2 + this.props[15] * p2 ;
	            }
	            this._identityCalculated = false;
	            return this;
	        }
	
	        var a1 = this.props[0];
	        var b1 = this.props[1];
	        var c1 = this.props[2];
	        var d1 = this.props[3];
	        var e1 = this.props[4];
	        var f1 = this.props[5];
	        var g1 = this.props[6];
	        var h1 = this.props[7];
	        var i1 = this.props[8];
	        var j1 = this.props[9];
	        var k1 = this.props[10];
	        var l1 = this.props[11];
	        var m1 = this.props[12];
	        var n1 = this.props[13];
	        var o1 = this.props[14];
	        var p1 = this.props[15];
	
	        /* matrix order (canvas compatible):
	         * ace
	         * bdf
	         * 001
	         */
	        this.props[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
	        this.props[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2 ;
	        this.props[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2 ;
	        this.props[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2 ;
	
	        this.props[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2 ;
	        this.props[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2 ;
	        this.props[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2 ;
	        this.props[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2 ;
	
	        this.props[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2 ;
	        this.props[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2 ;
	        this.props[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2 ;
	        this.props[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2 ;
	
	        this.props[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2 ;
	        this.props[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2 ;
	        this.props[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2 ;
	        this.props[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2 ;
	
	        this._identityCalculated = false;
	        return this;
	    }
	
	    function isIdentity() {
	        if(!this._identityCalculated){
	            this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0
	                || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0
	                || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0
	                || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
	            this._identityCalculated = true;
	        }
	        return this._identity;
	    }
	
	    function clone(matr){
	        var i;
	        for(i=0;i<16;i+=1){
	            matr.props[i] = this.props[i];
	        }
	    }
	
	    function cloneFromProps(props){
	        var i;
	        for(i=0;i<16;i+=1){
	            this.props[i] = props[i];
	        }
	    }
	
	    function applyToPoint(x, y, z) {
	
	        return {
	            x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
	            y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
	            z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
	        };
	        /*return {
	         x: x * me.a + y * me.c + me.e,
	         y: x * me.b + y * me.d + me.f
	         };*/
	    }
	    function applyToX(x, y, z) {
	        return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
	    }
	    function applyToY(x, y, z) {
	        return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
	    }
	    function applyToZ(x, y, z) {
	        return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
	    }
	
	    function inversePoint(pt) {
	        var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
	        var a = this.props[5]/determinant;
	        var b = - this.props[1]/determinant;
	        var c = - this.props[4]/determinant;
	        var d = this.props[0]/determinant;
	        var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12])/determinant;
	        var f = - (this.props[0] * this.props[13] - this.props[1] * this.props[12])/determinant;
	        return [pt[0] * a + pt[1] * c + e, pt[0] * b + pt[1] * d + f, 0];
	    }
	
	    function inversePoints(pts){
	        var i, len = pts.length, retPts = [];
	        for(i=0;i<len;i+=1){
	            retPts[i] = inversePoint(pts[i]);
	        }
	        return retPts;
	    }
	
	    function applyToPointArray(x,y,z,dimensions){
	        if(dimensions && dimensions === 2) {
	            var arr = point_pool.newPoint();
	            arr[0] = x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12]; 
	            arr[1] = x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13]; 
	            return arr;    
	        }
	        return [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
	    }
	    function applyToPointStringified(x, y) {
	        if(this.isIdentity()) {
	            return x + ',' + y;
	        }
	        return (bm_rnd(x * this.props[0] + y * this.props[4] + this.props[12]))+','+(bm_rnd(x * this.props[1] + y * this.props[5] + this.props[13]));
	    }
	
	    function toArray() {
	        return [this.props[0],this.props[1],this.props[2],this.props[3],this.props[4],this.props[5],this.props[6],this.props[7],this.props[8],this.props[9],this.props[10],this.props[11],this.props[12],this.props[13],this.props[14],this.props[15]];
	    }
	
	    function toCSS() {
	        if(isSafari){
	            return "matrix3d(" + roundTo2Decimals(this.props[0]) + ',' + roundTo2Decimals(this.props[1]) + ',' + roundTo2Decimals(this.props[2]) + ',' + roundTo2Decimals(this.props[3]) + ',' + roundTo2Decimals(this.props[4]) + ',' + roundTo2Decimals(this.props[5]) + ',' + roundTo2Decimals(this.props[6]) + ',' + roundTo2Decimals(this.props[7]) + ',' + roundTo2Decimals(this.props[8]) + ',' + roundTo2Decimals(this.props[9]) + ',' + roundTo2Decimals(this.props[10]) + ',' + roundTo2Decimals(this.props[11]) + ',' + roundTo2Decimals(this.props[12]) + ',' + roundTo2Decimals(this.props[13]) + ',' + roundTo2Decimals(this.props[14]) + ',' + roundTo2Decimals(this.props[15]) + ')';
	        } else {
	            this.cssParts[1] = this.props.join(',');
	            return this.cssParts.join('');
	        }
	    }
	
	    function to2dCSS() {
	        return "matrix(" + this.props[0] + ',' + this.props[1] + ',' + this.props[4] + ',' + this.props[5] + ',' + this.props[12] + ',' + this.props[13] + ")";
	    }
	
	    function toString() {
	        return "" + this.toArray();
	    }
	
	    return function(){
	        this.reset = reset;
	        this.rotate = rotate;
	        this.rotateX = rotateX;
	        this.rotateY = rotateY;
	        this.rotateZ = rotateZ;
	        this.skew = skew;
	        this.skewFromAxis = skewFromAxis;
	        this.shear = shear;
	        this.scale = scale;
	        this.setTransform = setTransform;
	        this.translate = translate;
	        this.transform = transform;
	        this.applyToPoint = applyToPoint;
	        this.applyToX = applyToX;
	        this.applyToY = applyToY;
	        this.applyToZ = applyToZ;
	        this.applyToPointArray = applyToPointArray;
	        this.applyToPointStringified = applyToPointStringified;
	        this.toArray = toArray;
	        this.toCSS = toCSS;
	        this.to2dCSS = to2dCSS;
	        this.toString = toString;
	        this.clone = clone;
	        this.cloneFromProps = cloneFromProps;
	        this.inversePoints = inversePoints;
	        this.inversePoint = inversePoint;
	        this._t = this.transform;
	        this.isIdentity = isIdentity;
	        this._identity = true;
	        this._identityCalculated = false;
	
	        this.props = [1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1];
	
	        this.cssParts = ['matrix3d(','',')'];
	    }
	}());
	
	function Matrix() {
	
	
	}
	
	/*
	 Copyright 2014 David Bau.
	
	 Permission is hereby granted, free of charge, to any person obtaining
	 a copy of this software and associated documentation files (the
	 "Software"), to deal in the Software without restriction, including
	 without limitation the rights to use, copy, modify, merge, publish,
	 distribute, sublicense, and/or sell copies of the Software, and to
	 permit persons to whom the Software is furnished to do so, subject to
	 the following conditions:
	
	 The above copyright notice and this permission notice shall be
	 included in all copies or substantial portions of the Software.
	
	 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	 */
	
	(function (pool, math) {
	//
	// The following constants are related to IEEE 754 limits.
	//
	    var global = this,
	        width = 256,        // each RC4 output is 0 <= x < 256
	        chunks = 6,         // at least six RC4 outputs for each double
	        digits = 52,        // there are 52 significant digits in a double
	        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
	        startdenom = math.pow(width, chunks),
	        significance = math.pow(2, digits),
	        overflow = significance * 2,
	        mask = width - 1,
	        nodecrypto;         // node.js crypto module, initialized at the bottom.
	
	//
	// seedrandom()
	// This is the seedrandom function described above.
	//
	    function seedrandom(seed, options, callback) {
	        var key = [];
	        options = (options == true) ? { entropy: true } : (options || {});
	
	        // Flatten the seed string or build one from local entropy if needed.
	        var shortseed = mixkey(flatten(
	            options.entropy ? [seed, tostring(pool)] :
	                (seed == null) ? autoseed() : seed, 3), key);
	
	        // Use the seed to initialize an ARC4 generator.
	        var arc4 = new ARC4(key);
	
	        // This function returns a random double in [0, 1) that contains
	        // randomness in every bit of the mantissa of the IEEE 754 value.
	        var prng = function() {
	            var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
	                d = startdenom,                 //   and denominator d = 2 ^ 48.
	                x = 0;                          //   and no 'extra last byte'.
	            while (n < significance) {          // Fill up all significant digits by
	                n = (n + x) * width;              //   shifting numerator and
	                d *= width;                       //   denominator and generating a
	                x = arc4.g(1);                    //   new least-significant-byte.
	            }
	            while (n >= overflow) {             // To avoid rounding up, before adding
	                n /= 2;                           //   last byte, shift everything
	                d /= 2;                           //   right using integer math until
	                x >>>= 1;                         //   we have exactly the desired bits.
	            }
	            return (n + x) / d;                 // Form the number within [0, 1).
	        };
	
	        prng.int32 = function() { return arc4.g(4) | 0; }
	        prng.quick = function() { return arc4.g(4) / 0x100000000; }
	        prng.double = prng;
	
	        // Mix the randomness into accumulated entropy.
	        mixkey(tostring(arc4.S), pool);
	
	        // Calling convention: what to return as a function of prng, seed, is_math.
	        return (options.pass || callback ||
	        function(prng, seed, is_math_call, state) {
	            if (state) {
	                // Load the arc4 state from the given state if it has an S array.
	                if (state.S) { copy(state, arc4); }
	                // Only provide the .state method if requested via options.state.
	                prng.state = function() { return copy(arc4, {}); }
	            }
	
	            // If called as a method of Math (Math.seedrandom()), mutate
	            // Math.random because that is how seedrandom.js has worked since v1.0.
	            if (is_math_call) { math[rngname] = prng; return seed; }
	
	            // Otherwise, it is a newer calling convention, so return the
	            // prng directly.
	            else return prng;
	        })(
	            prng,
	            shortseed,
	            'global' in options ? options.global : (this == math),
	            options.state);
	    }
	    math['seed' + rngname] = seedrandom;
	
	//
	// ARC4
	//
	// An ARC4 implementation.  The constructor takes a key in the form of
	// an array of at most (width) integers that should be 0 <= x < (width).
	//
	// The g(count) method returns a pseudorandom integer that concatenates
	// the next (count) outputs from ARC4.  Its return value is a number x
	// that is in the range 0 <= x < (width ^ count).
	//
	    function ARC4(key) {
	        var t, keylen = key.length,
	            me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
	
	        // The empty key [] is treated as [0].
	        if (!keylen) { key = [keylen++]; }
	
	        // Set up S using the standard key scheduling algorithm.
	        while (i < width) {
	            s[i] = i++;
	        }
	        for (i = 0; i < width; i++) {
	            s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
	            s[j] = t;
	        }
	
	        // The "g" method returns the next (count) outputs as one number.
	        (me.g = function(count) {
	            // Using instance members instead of closure state nearly doubles speed.
	            var t, r = 0,
	                i = me.i, j = me.j, s = me.S;
	            while (count--) {
	                t = s[i = mask & (i + 1)];
	                r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
	            }
	            me.i = i; me.j = j;
	            return r;
	            // For robust unpredictability, the function call below automatically
	            // discards an initial batch of values.  This is called RC4-drop[256].
	            // See http://google.com/search?q=rsa+fluhrer+response&btnI
	        })(width);
	    }
	
	//
	// copy()
	// Copies internal state of ARC4 to or from a plain object.
	//
	    function copy(f, t) {
	        t.i = f.i;
	        t.j = f.j;
	        t.S = f.S.slice();
	        return t;
	    };
	
	//
	// flatten()
	// Converts an object tree to nested arrays of strings.
	//
	    function flatten(obj, depth) {
	        var result = [], typ = (typeof obj), prop;
	        if (depth && typ == 'object') {
	            for (prop in obj) {
	                try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
	            }
	        }
	        return (result.length ? result : typ == 'string' ? obj : obj + '\0');
	    }
	
	//
	// mixkey()
	// Mixes a string seed into a key that is an array of integers, and
	// returns a shortened string seed that is equivalent to the result key.
	//
	    function mixkey(seed, key) {
	        var stringseed = seed + '', smear, j = 0;
	        while (j < stringseed.length) {
	            key[mask & j] =
	                mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
	        }
	        return tostring(key);
	    }
	
	//
	// autoseed()
	// Returns an object for autoseeding, using window.crypto and Node crypto
	// module if available.
	//
	    function autoseed() {
	        try {
	            if (nodecrypto) { return tostring(nodecrypto.randomBytes(width)); }
	            var out = new Uint8Array(width);
	            (global.crypto || global.msCrypto).getRandomValues(out);
	            return tostring(out);
	        } catch (e) {
	            var browser = global.navigator,
	                plugins = browser && browser.plugins;
	            return [+new Date, global, plugins, global.screen, tostring(pool)];
	        }
	    }
	
	//
	// tostring()
	// Converts an array of charcodes to a string
	//
	    function tostring(a) {
	        return String.fromCharCode.apply(0, a);
	    }
	
	//
	// When seedrandom.js is loaded, we immediately mix a few bits
	// from the built-in RNG into the entropy pool.  Because we do
	// not want to interfere with deterministic PRNG state later,
	// seedrandom will not call math.random on its own again after
	// initialization.
	//
	    mixkey(math.random(), pool);
	
	//
	// Nodejs and AMD support: export the implementation as a module using
	// either convention.
	//
	
	// End anonymous scope, and pass initial values.
	})(
	    [],     // pool: entropy pool starts empty
	    BMMath    // math: package containing random, pow, and seedrandom
	);
	var BezierFactory = (function(){
	    /**
	     * BezierEasing - use bezier curve for transition easing function
	     * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	     *
	     * Credits: is based on Firefox's nsSMILKeySpline.cpp
	     * Usage:
	     * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
	     * spline.get(x) => returns the easing value | x must be in [0, 1] range
	     *
	     */
	
	        var ob = {};
	    ob.getBezierEasing = getBezierEasing;
	    var beziers = {};
	
	    function getBezierEasing(a,b,c,d,nm){
	        var str = nm || ('bez_' + a+'_'+b+'_'+c+'_'+d).replace(/\./g, 'p');
	        if(beziers[str]){
	            return beziers[str];
	        }
	        var bezEasing = new BezierEasing([a,b,c,d]);
	        beziers[str] = bezEasing;
	        return bezEasing;
	    }
	
	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	    var NEWTON_ITERATIONS = 4;
	    var NEWTON_MIN_SLOPE = 0.001;
	    var SUBDIVISION_PRECISION = 0.0000001;
	    var SUBDIVISION_MAX_ITERATIONS = 10;
	
	    var kSplineTableSize = 11;
	    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	    var float32ArraySupported = typeof Float32Array === "function";
	
	    function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	    function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	    function C (aA1)      { return 3.0 * aA1; }
	
	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	    function calcBezier (aT, aA1, aA2) {
	        return ((A(aA1, aA2)*aT + B(aA1, aA2))*aT + C(aA1))*aT;
	    }
	
	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	    function getSlope (aT, aA1, aA2) {
	        return 3.0 * A(aA1, aA2)*aT*aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
	    }
	
	    function binarySubdivide (aX, aA, aB, mX1, mX2) {
	        var currentX, currentT, i = 0;
	        do {
	            currentT = aA + (aB - aA) / 2.0;
	            currentX = calcBezier(currentT, mX1, mX2) - aX;
	            if (currentX > 0.0) {
	                aB = currentT;
	            } else {
	                aA = currentT;
	            }
	        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	        return currentT;
	    }
	
	    function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
	        for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	            var currentSlope = getSlope(aGuessT, mX1, mX2);
	            if (currentSlope === 0.0) return aGuessT;
	            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	            aGuessT -= currentX / currentSlope;
	        }
	        return aGuessT;
	    }
	
	    /**
	     * points is an array of [ mX1, mY1, mX2, mY2 ]
	     */
	    function BezierEasing (points) {
	        this._p = points;
	        this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	        this._precomputed = false;
	
	        this.get = this.get.bind(this);
	    }
	
	    BezierEasing.prototype = {
	
	        get: function (x) {
	            var mX1 = this._p[0],
	                mY1 = this._p[1],
	                mX2 = this._p[2],
	                mY2 = this._p[3];
	            if (!this._precomputed) this._precompute();
	            if (mX1 === mY1 && mX2 === mY2) return x; // linear
	            // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	            if (x === 0) return 0;
	            if (x === 1) return 1;
	            return calcBezier(this._getTForX(x), mY1, mY2);
	        },
	
	        // Private part
	
	        _precompute: function () {
	            var mX1 = this._p[0],
	                mY1 = this._p[1],
	                mX2 = this._p[2],
	                mY2 = this._p[3];
	            this._precomputed = true;
	            if (mX1 !== mY1 || mX2 !== mY2)
	                this._calcSampleValues();
	        },
	
	        _calcSampleValues: function () {
	            var mX1 = this._p[0],
	                mX2 = this._p[2];
	            for (var i = 0; i < kSplineTableSize; ++i) {
	                this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	            }
	        },
	
	        /**
	         * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
	         */
	        _getTForX: function (aX) {
	            var mX1 = this._p[0],
	                mX2 = this._p[2],
	                mSampleValues = this._mSampleValues;
	
	            var intervalStart = 0.0;
	            var currentSample = 1;
	            var lastSample = kSplineTableSize - 1;
	
	            for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
	                intervalStart += kSampleStepSize;
	            }
	            --currentSample;
	
	            // Interpolate to provide an initial guess for t
	            var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample+1] - mSampleValues[currentSample]);
	            var guessForT = intervalStart + dist * kSampleStepSize;
	
	            var initialSlope = getSlope(guessForT, mX1, mX2);
	            if (initialSlope >= NEWTON_MIN_SLOPE) {
	                return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	            } else if (initialSlope === 0.0) {
	                return guessForT;
	            } else {
	                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	            }
	        }
	    };
	
	    return ob;
	
	}())
	
	
	function matrixManagerFunction(){
	
	    var mat = new Matrix();
	
	    var returnMatrix2D = function(rX, scaleX, scaleY, tX, tY){
	        return mat.reset().translate(tX,tY).rotate(rX).scale(scaleX,scaleY).toCSS();
	    };
	
	    var getMatrix = function(animData){
	        return returnMatrix2D(animData.tr.r[2],animData.tr.s[0],animData.tr.s[1],animData.tr.p[0],animData.tr.p[1]);
	    };
	
	    return {
	        getMatrix : getMatrix
	    };
	
	}
	var MatrixManager = matrixManagerFunction;
	(function () {
	    var lastTime = 0;
	    var vendors = ['ms', 'moz', 'webkit', 'o'];
	    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	    }
	    if(!window.requestAnimationFrame)
	        window.requestAnimationFrame = function (callback, element) {
	            var currTime = new Date().getTime();
	            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	            var id = window.setTimeout(function () {
	                    callback(currTime + timeToCall);
	                },
	                timeToCall);
	            lastTime = currTime + timeToCall;
	            return id;
	        };
	    if(!window.cancelAnimationFrame)
	        window.cancelAnimationFrame = function (id) {
	            clearTimeout(id);
	        };
	}());
	function createElement(parent,child,params){
	    if(child){
	        child.prototype = Object.create(parent.prototype);
	        child.prototype.constructor = child;
	        child.prototype._parent = parent.prototype;
	    }else{
	        var instance = Object.create(parent.prototype,params);
	        var getType = {};
	        if(instance && getType.toString.call(instance.init) === '[object Function]'){
	            instance.init();
	        }
	        return instance;
	    }
	}
	
	function extendPrototype(source,destination){
	    for (var attr in source.prototype) {
	        if (source.prototype.hasOwnProperty(attr)) destination.prototype[attr] = source.prototype[attr];
	    }
	}
	function bezFunction(){
	
	    var easingFunctions = [];
	    var math = Math;
	
	    function pointOnLine2D(x1,y1, x2,y2, x3,y3){
	        var det1 = (x1*y2) + (y1*x3) + (x2*y3) - (x3*y2) - (y3*x1) - (x2*y1);
	        return det1 > -0.0001 && det1 < 0.0001;
	    }
	
	    function pointOnLine3D(x1,y1,z1, x2,y2,z2, x3,y3,z3){
	        if(z1 === 0 && z2 === 0 && z3 === 0) {
	            return pointOnLine2D(x1,y1, x2,y2, x3,y3);
	        }
	        var dist1 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2) + Math.pow(z2 - z1, 2));
	        var dist2 = Math.sqrt(Math.pow(x3 - x1, 2) + Math.pow(y3 - y1, 2) + Math.pow(z3 - z1, 2));
	        var dist3 = Math.sqrt(Math.pow(x3 - x2, 2) + Math.pow(y3 - y2, 2) + Math.pow(z3 - z2, 2));
	        var diffDist;
	        if(dist1 > dist2){
	            if(dist1 > dist3){
	                diffDist = dist1 - dist2 - dist3;
	            } else {
	                diffDist = dist3 - dist2 - dist1;
	            }
	        } else if(dist3 > dist2){
	            diffDist = dist3 - dist2 - dist1;
	        } else {
	            diffDist = dist2 - dist1 - dist3;
	        }
	        return diffDist > -0.0001 && diffDist < 0.0001;
	    }
	
	    /*function getEasingCurve(aa,bb,cc,dd,encodedFuncName) {
	        if(!encodedFuncName){
	            encodedFuncName = ('bez_' + aa+'_'+bb+'_'+cc+'_'+dd).replace(/\./g, 'p');
	        }
	        if(easingFunctions[encodedFuncName]){
	            return easingFunctions[encodedFuncName];
	        }
	        var A0, B0, C0;
	        var A1, B1, C1;
	        easingFunctions[encodedFuncName] = function(tt) {
	            var x = tt;
	            var i = 0, z;
	            while (++i < 20) {
	                C0 = 3 * aa;
	                B0 = 3 * (cc - aa) - C0;
	                A0 = 1 - C0 - B0;
	                z = (x * (C0 + x * (B0 + x * A0))) - tt;
	                if (bm_abs(z) < 1e-3) break;
	                x -= z / (C0 + x * (2 * B0 + 3 * A0 * x));
	            }
	            C1 = 3 * bb;
	            B1 = 3 * (dd - bb) - C1;
	            A1 = 1 - C1 - B1;
	            var polyB = x * (C1 + x * (B1 + x * A1));
	            //return c * polyB + b;
	            return polyB;
	        };
	        return easingFunctions[encodedFuncName];
	    }*/
	    var getBezierLength = (function(){
	
	        function Segment(l,p){
	            this.l = l;
	            this.p = p;
	        }
	
	        return function(pt1,pt2,pt3,pt4){
	            var curveSegments = defaultCurveSegments;
	            var k;
	            var i, len;
	            var ptCoord,perc,addedLength = 0;
	            var ptDistance;
	            var point = [],lastPoint = [];
	            var lengthData = {
	                addedLength: 0,
	                segments: []
	            };
	            len = pt3.length;
	            for(k=0;k<curveSegments;k+=1){
	                perc = k/(curveSegments-1);
	                ptDistance = 0;
	                for(i=0;i<len;i+=1){
	                    ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*pt3[i]+3*(1-perc)*bm_pow(perc,2)*pt4[i]+bm_pow(perc,3)*pt2[i];
	                    point[i] = ptCoord;
	                    if(lastPoint[i] !== null){
	                        ptDistance += bm_pow(point[i] - lastPoint[i],2);
	                    }
	                    lastPoint[i] = point[i];
	                }
	                if(ptDistance){
	                    ptDistance = bm_sqrt(ptDistance);
	                    addedLength += ptDistance;
	                }
	                lengthData.segments.push(new Segment(addedLength,perc));
	            }
	            lengthData.addedLength = addedLength;
	            return lengthData;
	        };
	    }());
	
	    function BezierData(length){
	        this.segmentLength = 0;
	        this.points = new Array(length);
	    }
	
	    function PointData(partial,point){
	        this.partialLength = partial;
	        this.point = point;
	    }
	
	    var buildBezierData = (function(){
	
	        var storedData = {};
	
	        return function (keyData){
	            var pt1 = keyData.s;
	            var pt2 = keyData.e;
	            var pt3 = keyData.to;
	            var pt4 = keyData.ti;
	            var bezierName = (pt1.join('_')+'_'+pt2.join('_')+'_'+pt3.join('_')+'_'+pt4.join('_')).replace(/\./g, 'p');
	            if(storedData[bezierName]){
	                keyData.bezierData = storedData[bezierName];
	                return;
	            }
	        var curveSegments = defaultCurveSegments;
	        var k, i, len;
	            var ptCoord,perc,addedLength = 0;
	            var ptDistance;
	            var point,lastPoint = null;
	            if(pt1.length === 2 && (pt1[0] != pt2[0] || pt1[1] != pt2[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt1[0]+pt3[0],pt1[1]+pt3[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt2[0]+pt4[0],pt2[1]+pt4[1])){
	                curveSegments = 2;
	            }
	            var bezierData = new BezierData(curveSegments);
	            len = pt3.length;
	            for(k=0;k<curveSegments;k+=1){
	            point = new Array(len);
	                perc = k/(curveSegments-1);
	                ptDistance = 0;
	                for(i=0;i<len;i+=1){
	                ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*(pt1[i] + pt3[i])+3*(1-perc)*bm_pow(perc,2)*(pt2[i] + pt4[i])+bm_pow(perc,3)*pt2[i];
	                point[i] = ptCoord;
	                    if(lastPoint !== null){
	                    ptDistance += bm_pow(point[i] - lastPoint[i],2);
	                    }
	                }
	            ptDistance = bm_sqrt(ptDistance);
	                addedLength += ptDistance;
	                bezierData.points[k] = new PointData(ptDistance,point);
	                lastPoint = point;
	            }
	            bezierData.segmentLength = addedLength;
	            keyData.bezierData = bezierData;
	            storedData[bezierName] = bezierData;
	
	        }
	    }());
	
	    function getDistancePerc(perc,bezierData){
	        var segments = bezierData.segments;
	        var len = segments.length;
	        var initPos = bm_floor((len-1)*perc);
	        var lengthPos = perc*bezierData.addedLength;
	        var lPerc = 0;
	        if(lengthPos == segments[initPos].l){
	            return segments[initPos].p;
	        }else{
	            var dir = segments[initPos].l > lengthPos ? -1 : 1;
	            var flag = true;
	            while(flag){
	                if(segments[initPos].l <= lengthPos && segments[initPos+1].l > lengthPos){
	                    lPerc = (lengthPos - segments[initPos].l)/(segments[initPos+1].l-segments[initPos].l);
	                    flag = false;
	                }else{
	                    initPos += dir;
	                }
	                if(initPos < 0 || initPos >= len - 1){
	                    flag = false;
	                }
	            }
	            return segments[initPos].p + (segments[initPos+1].p - segments[initPos].p)*lPerc;
	        }
	    }
	
	    function SegmentPoints(){
	        this.pt1 = new Array(2);
	        this.pt2 = new Array(2);
	        this.pt3 = new Array(2);
	        this.pt4 = new Array(2);
	    }
	
	    function getNewSegment(pt1,pt2,pt3,pt4,startPerc,endPerc, bezierData){
	
	        var pts = new SegmentPoints();
	        startPerc = startPerc < 0 ? 0 : startPerc > 1 ? 1 : startPerc;
	        var t0 = getDistancePerc(startPerc,bezierData);
	        endPerc = endPerc > 1 ? 1 : endPerc;
	        var t1 = getDistancePerc(endPerc,bezierData);
	        var i, len = pt1.length;
	        var u0 = 1 - t0;
	        var u1 = 1 - t1;
	        //Math.round(num * 100) / 100
	        for(i=0;i<len;i+=1){
	            pts.pt1[i] =  Math.round((u0*u0*u0* pt1[i] + (t0*u0*u0 + u0*t0*u0 + u0*u0*t0) * pt3[i] + (t0*t0*u0 + u0*t0*t0 + t0*u0*t0)* pt4[i] + t0*t0*t0* pt2[i])* 1000) / 1000;
	            pts.pt3[i] = Math.round((u0*u0*u1*pt1[i] + (t0*u0*u1 + u0*t0*u1 + u0*u0*t1)* pt3[i] + (t0*t0*u1 + u0*t0*t1 + t0*u0*t1)* pt4[i] + t0*t0*t1* pt2[i])* 1000) / 1000;
	            pts.pt4[i] = Math.round((u0*u1*u1* pt1[i] + (t0*u1*u1 + u0*t1*u1 + u0*u1*t1)* pt3[i] + (t0*t1*u1 + u0*t1*t1 + t0*u1*t1)* pt4[i] + t0*t1*t1* pt2[i])* 1000) / 1000;
	            pts.pt2[i] = Math.round((u1*u1*u1* pt1[i] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[i] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[i] + t1*t1*t1* pt2[i])* 1000) / 1000;
	        }
	        return pts;
	    }
	
	    return {
	        //getEasingCurve : getEasingCurve,
	        getBezierLength : getBezierLength,
	        getNewSegment : getNewSegment,
	        buildBezierData : buildBezierData,
	        pointOnLine2D : pointOnLine2D,
	        pointOnLine3D : pointOnLine3D
	    };
	}
	
	var bez = bezFunction();
	function dataFunctionManager(){
	
	    //var tCanvasHelper = document.createElement('canvas').getContext('2d');
	
	    function completeLayers(layers, comps, fontManager){
	        var layerData;
	        var animArray, lastFrame;
	        var i, len = layers.length;
	        var j, jLen, k, kLen;
	        for(i=0;i<len;i+=1){
	            layerData = layers[i];
	            if(!('ks' in layerData) || layerData.completed){
	                continue;
	            }
	            layerData.completed = true;
	            if(layerData.tt){
	                layers[i-1].td = layerData.tt;
	            }
	            animArray = [];
	            lastFrame = -1;
	            if(layerData.hasMask){
	                var maskProps = layerData.masksProperties;
	                jLen = maskProps.length;
	                for(j=0;j<jLen;j+=1){
	                    if(maskProps[j].pt.k.i){
	                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
	                    }else{
	                        kLen = maskProps[j].pt.k.length;
	                        for(k=0;k<kLen;k+=1){
	                            if(maskProps[j].pt.k[k].s){
	                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
	                            }
	                            if(maskProps[j].pt.k[k].e){
	                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
	                            }
	                        }
	                    }
	                }
	            }
	            if(layerData.ty===0){
	                layerData.layers = findCompLayers(layerData.refId, comps);
	                completeLayers(layerData.layers,comps, fontManager);
	            }else if(layerData.ty === 4){
	                completeShapes(layerData.shapes);
	            }else if(layerData.ty == 5){
	                completeText(layerData, fontManager);
	            }
	        }
	    }
	
	    function findCompLayers(id,comps){
	        var i = 0, len = comps.length;
	        while(i<len){
	            if(comps[i].id === id){
	                if(!comps[i].layers.__used) {
	                    comps[i].layers.__used = true;
	                    return comps[i].layers;
	                }
	                return JSON.parse(JSON.stringify(comps[i].layers));
	            }
	            i += 1;
	        }
	    }
	
	    function completeShapes(arr){
	        var i, len = arr.length;
	        var j, jLen;
	        var hasPaths = false;
	        for(i=len-1;i>=0;i-=1){
	            if(arr[i].ty == 'sh'){
	                if(arr[i].ks.k.i){
	                    convertPathsToAbsoluteValues(arr[i].ks.k);
	                }else{
	                    jLen = arr[i].ks.k.length;
	                    for(j=0;j<jLen;j+=1){
	                        if(arr[i].ks.k[j].s){
	                            convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
	                        }
	                        if(arr[i].ks.k[j].e){
	                            convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
	                        }
	                    }
	                }
	                hasPaths = true;
	            }else if(arr[i].ty == 'gr'){
	                completeShapes(arr[i].it);
	            }
	        }
	        /*if(hasPaths){
	            //mx: distance
	            //ss: sensitivity
	            //dc: decay
	            arr.splice(arr.length-1,0,{
	                "ty": "ms",
	                "mx":20,
	                "ss":10,
	                 "dc":0.001,
	                "maxDist":200
	            });
	        }*/
	    }
	
	    function convertPathsToAbsoluteValues(path){
	        var i, len = path.i.length;
	        for(i=0;i<len;i+=1){
	            path.i[i][0] += path.v[i][0];
	            path.i[i][1] += path.v[i][1];
	            path.o[i][0] += path.v[i][0];
	            path.o[i][1] += path.v[i][1];
	        }
	    }
	
	    function checkVersion(minimum,animVersionString){
	        var animVersion = animVersionString ? animVersionString.split('.') : [100,100,100];
	        if(minimum[0]>animVersion[0]){
	            return true;
	        } else if(animVersion[0] > minimum[0]){
	            return false;
	        }
	        if(minimum[1]>animVersion[1]){
	            return true;
	        } else if(animVersion[1] > minimum[1]){
	            return false;
	        }
	        if(minimum[2]>animVersion[2]){
	            return true;
	        } else if(animVersion[2] > minimum[2]){
	            return false;
	        }
	    }
	
	    var checkText = (function(){
	        var minimumVersion = [4,4,14];
	
	        function updateTextLayer(textLayer){
	            var documentData = textLayer.t.d;
	            textLayer.t.d = {
	                k: [
	                    {
	                        s:documentData,
	                        t:0
	                    }
	                ]
	            }
	        }
	
	        function iterateLayers(layers){
	            var i, len = layers.length;
	            for(i=0;i<len;i+=1){
	                if(layers[i].ty === 5){
	                    updateTextLayer(layers[i]);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        }
	    }())
	
	    var checkChars = (function() {
	        var minimumVersion = [4,7,99];
	        return function (animationData){
	            if(animationData.chars && !checkVersion(minimumVersion,animationData.v)){
	                var i, len = animationData.chars.length, j, jLen, k, kLen;
	                var pathData, paths;
	                for(i = 0; i < len; i += 1) {
	                    if(animationData.chars[i].data && animationData.chars[i].data.shapes) {
	                        paths = animationData.chars[i].data.shapes[0].it;
	                        jLen = paths.length;
	
	                        for(j = 0; j < jLen; j += 1) {
	                            pathData = paths[j].ks.k;
	                            convertPathsToAbsoluteValues(paths[j].ks.k);
	                        }
	                    }
	                }
	            }
	        }
	
	    }())
	
	    var checkColors = (function(){
	        var minimumVersion = [4,1,9];
	
	        function iterateShapes(shapes){
	            var i, len = shapes.length;
	            var j, jLen;
	            for(i=0;i<len;i+=1){
	                if(shapes[i].ty === 'gr'){
	                    iterateShapes(shapes[i].it);
	                }else if(shapes[i].ty === 'fl' || shapes[i].ty === 'st'){
	                    if(shapes[i].c.k && shapes[i].c.k[0].i){
	                        jLen = shapes[i].c.k.length;
	                        for(j=0;j<jLen;j+=1){
	                            if(shapes[i].c.k[j].s){
	                                shapes[i].c.k[j].s[0] /= 255;
	                                shapes[i].c.k[j].s[1] /= 255;
	                                shapes[i].c.k[j].s[2] /= 255;
	                                shapes[i].c.k[j].s[3] /= 255;
	                            }
	                            if(shapes[i].c.k[j].e){
	                                shapes[i].c.k[j].e[0] /= 255;
	                                shapes[i].c.k[j].e[1] /= 255;
	                                shapes[i].c.k[j].e[2] /= 255;
	                                shapes[i].c.k[j].e[3] /= 255;
	                            }
	                        }
	                    } else {
	                        shapes[i].c.k[0] /= 255;
	                        shapes[i].c.k[1] /= 255;
	                        shapes[i].c.k[2] /= 255;
	                        shapes[i].c.k[3] /= 255;
	                    }
	                }
	            }
	        }
	
	        function iterateLayers(layers){
	            var i, len = layers.length;
	            for(i=0;i<len;i+=1){
	                if(layers[i].ty === 4){
	                    iterateShapes(layers[i].shapes);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        }
	    }());
	
	    var checkShapes = (function(){
	        var minimumVersion = [4,4,18];
	
	
	
	        function completeShapes(arr){
	            var i, len = arr.length;
	            var j, jLen;
	            var hasPaths = false;
	            for(i=len-1;i>=0;i-=1){
	                if(arr[i].ty == 'sh'){
	                    if(arr[i].ks.k.i){
	                        arr[i].ks.k.c = arr[i].closed;
	                    }else{
	                        jLen = arr[i].ks.k.length;
	                        for(j=0;j<jLen;j+=1){
	                            if(arr[i].ks.k[j].s){
	                                arr[i].ks.k[j].s[0].c = arr[i].closed;
	                            }
	                            if(arr[i].ks.k[j].e){
	                                arr[i].ks.k[j].e[0].c = arr[i].closed;
	                            }
	                        }
	                    }
	                    hasPaths = true;
	                }else if(arr[i].ty == 'gr'){
	                    completeShapes(arr[i].it);
	                }
	            }
	        }
	
	        function iterateLayers(layers){
	            var layerData;
	            var i, len = layers.length;
	            var j, jLen, k, kLen;
	            for(i=0;i<len;i+=1){
	                layerData = layers[i];
	                if(layerData.hasMask){
	                    var maskProps = layerData.masksProperties;
	                    jLen = maskProps.length;
	                    for(j=0;j<jLen;j+=1){
	                        if(maskProps[j].pt.k.i){
	                            maskProps[j].pt.k.c = maskProps[j].cl;
	                        }else{
	                            kLen = maskProps[j].pt.k.length;
	                            for(k=0;k<kLen;k+=1){
	                                if(maskProps[j].pt.k[k].s){
	                                    maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
	                                }
	                                if(maskProps[j].pt.k[k].e){
	                                    maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
	                                }
	                            }
	                        }
	                    }
	                }
	                if(layerData.ty === 4){
	                    completeShapes(layerData.shapes);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        }
	    }());
	
	    /*function blitPaths(path){
	        var i, len = path.i.length;
	        for(i=0;i<len;i+=1){
	            path.i[i][0] /= blitter;
	            path.i[i][1] /= blitter;
	            path.o[i][0] /= blitter;
	            path.o[i][1] /= blitter;
	            path.v[i][0] /= blitter;
	            path.v[i][1] /= blitter;
	        }
	    }
	
	    function blitShapes(arr){
	        var i, len = arr.length;
	        var j, jLen;
	        var hasPaths = false;
	        for(i=len-1;i>=0;i-=1){
	            if(arr[i].ty == 'sh'){
	                if(arr[i].ks.k.i){
	                    blitPaths(arr[i].ks.k);
	                }else{
	                    jLen = arr[i].ks.k.length;
	                    for(j=0;j<jLen;j+=1){
	                        if(arr[i].ks.k[j].s){
	                            blitPaths(arr[i].ks.k[j].s[0]);
	                        }
	                        if(arr[i].ks.k[j].e){
	                            blitPaths(arr[i].ks.k[j].e[0]);
	                        }
	                    }
	                }
	                hasPaths = true;
	            }else if(arr[i].ty == 'gr'){
	                blitShapes(arr[i].it);
	            }else if(arr[i].ty == 'rc'){
	                blitProperty(arr[i].p);
	                blitProperty(arr[i].s);
	            }else if(arr[i].ty == 'st'){
	                blitProperty(arr[i].w);
	            }else if(arr[i].ty == 'tr'){
	                blitProperty(arr[i].p);
	                blitProperty(arr[i].sk);
	                blitProperty(arr[i].a);
	            }else if(arr[i].ty == 'el'){
	                blitProperty(arr[i].p);
	                blitProperty(arr[i].s);
	            }else if(arr[i].ty == 'rd'){
	                blitProperty(arr[i].r);
	            }else{
	
	                //console.log(arr[i].ty );
	            }
	        }
	    }
	
	    function blitText(data, fontManager){
	
	    }
	
	    function blitValue(val){
	        if(typeof(val) === 'number'){
	            val /= blitter;
	        } else {
	            var i = val.length-1;
	            while(i>=0){
	                val[i] /= blitter;
	                i-=1;
	            }
	        }
	        return val;
	    }
	
	    function blitProperty(data){
	        if(!data.k.length){
	            data.k = blitValue(data.k);
	        }else if(typeof(data.k[0]) === 'number'){
	            data.k = blitValue(data.k);
	        } else {
	            var i, len = data.k.length;
	            for(i=0;i<len;i+=1){
	                if(data.k[i].s){
	                    //console.log('pre S: ', data.k[i].s);
	                    data.k[i].s = blitValue(data.k[i].s);
	                    //console.log('post S: ', data.k[i].s);
	                }
	                if(data.k[i].e){
	                    //console.log('pre E: ', data.k[i].e);
	                    data.k[i].e = blitValue(data.k[i].e);
	                    //console.log('post E: ', data.k[i].e);
	                }
	            }
	        }
	    }
	
	    function blitLayers(layers,comps, fontManager){
	        var layerData;
	        var animArray, lastFrame;
	        var i, len = layers.length;
	        var j, jLen, k, kLen;
	        for(i=0;i<len;i+=1){
	            layerData = layers[i];
	            if(!('ks' in layerData)){
	                continue;
	            }
	            blitProperty(layerData.ks.a);
	            blitProperty(layerData.ks.p);
	            layerData.completed = true;
	            if(layerData.tt){
	                layers[i-1].td = layerData.tt;
	            }
	            animArray = [];
	            lastFrame = -1;
	            if(layerData.hasMask){
	                var maskProps = layerData.masksProperties;
	                jLen = maskProps.length;
	                for(j=0;j<jLen;j+=1){
	                    if(maskProps[j].pt.k.i){
	                        blitPaths(maskProps[j].pt.k);
	                    }else{
	                        kLen = maskProps[j].pt.k.length;
	                        for(k=0;k<kLen;k+=1){
	                            if(maskProps[j].pt.k[k].s){
	                                blitPaths(maskProps[j].pt.k[k].s[0]);
	                            }
	                            if(maskProps[j].pt.k[k].e){
	                                blitPaths(maskProps[j].pt.k[k].e[0]);
	                            }
	                        }
	                    }
	                }
	            }
	            if(layerData.ty===0){
	                layerData.w = Math.round(layerData.w/blitter);
	                layerData.h = Math.round(layerData.h/blitter);
	                blitLayers(layerData.layers,comps, fontManager);
	            }else if(layerData.ty === 4){
	                blitShapes(layerData.shapes);
	            }else if(layerData.ty == 5){
	                blitText(layerData, fontManager);
	            }else if(layerData.ty == 1){
	                layerData.sh /= blitter;
	                layerData.sw /= blitter;
	            } else {
	            }
	        }
	    }
	
	    function blitAnimation(animationData,comps, fontManager){
	        blitLayers(animationData.layers,comps, fontManager);
	    }*/
	
	    function completeData(animationData, fontManager){
	        if(animationData.__complete){
	            return;
	        }
	        checkColors(animationData);
	        checkText(animationData);
	        checkChars(animationData);
	        checkShapes(animationData);
	        completeLayers(animationData.layers, animationData.assets, fontManager);
	        animationData.__complete = true;
	        //blitAnimation(animationData, animationData.assets, fontManager);
	    }
	
	    function completeText(data, fontManager){
	        var letters;
	        var keys = data.t.d.k;
	        var k, kLen = keys.length;
	        for(k=0;k<kLen;k+=1){
	            var documentData = data.t.d.k[k].s;
	            letters = [];
	            var i, len;
	            var newLineFlag, index = 0, val;
	            var anchorGrouping = data.t.m.g;
	            var currentSize = 0, currentPos = 0, currentLine = 0, lineWidths = [];
	            var lineWidth = 0;
	            var maxLineWidth = 0;
	            var j, jLen;
	            var fontData = fontManager.getFontByName(documentData.f);
	            var charData, cLength = 0;
	            var styles = fontData.fStyle.split(' ');
	
	            var fWeight = 'normal', fStyle = 'normal';
	            len = styles.length;
	            for(i=0;i<len;i+=1){
	                if (styles[i].toLowerCase() === 'italic') {
	                    fStyle = 'italic';
	                }else if (styles[i].toLowerCase() === 'bold') {
	                    fWeight = '700';
	                } else if (styles[i].toLowerCase() === 'black') {
	                    fWeight = '900';
	                } else if (styles[i].toLowerCase() === 'medium') {
	                    fWeight = '500';
	                } else if (styles[i].toLowerCase() === 'regular' || styles[i].toLowerCase() === 'normal') {
	                    fWeight = '400';
	                } else if (styles[i].toLowerCase() === 'light' || styles[i].toLowerCase() === 'thin') {
	                    fWeight = '200';
	                }
	            }
	            documentData.fWeight = fWeight;
	            documentData.fStyle = fStyle;
	            len = documentData.t.length;
	            if(documentData.sz){
	                var boxWidth = documentData.sz[0];
	                var lastSpaceIndex = -1;
	                for(i=0;i<len;i+=1){
	                    newLineFlag = false;
	                    if(documentData.t.charAt(i) === ' '){
	                        lastSpaceIndex = i;
	                    }else if(documentData.t.charCodeAt(i) === 13){
	                        lineWidth = 0;
	                        newLineFlag = true;
	                    }
	                    if(fontManager.chars){
	                        charData = fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, fontData.fFamily);
	                        cLength = newLineFlag ? 0 : charData.w*documentData.s/100;
	                    }else{
	                        //tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
	                        cLength = fontManager.measureText(documentData.t.charAt(i), documentData.f, documentData.s);
	                    }
	                    if(lineWidth + cLength > boxWidth){
	                        if(lastSpaceIndex === -1){
	                            //i -= 1;
	                            documentData.t = documentData.t.substr(0,i) + "\r" + documentData.t.substr(i);
	                            len += 1;
	                        } else {
	                            i = lastSpaceIndex;
	                            documentData.t = documentData.t.substr(0,i) + "\r" + documentData.t.substr(i+1);
	                        }
	                        lastSpaceIndex = -1;
	                        lineWidth = 0;
	                    }else {
	                        lineWidth += cLength;
	                    }
	                }
	                len = documentData.t.length;
	            }
	            lineWidth = 0;
	            cLength = 0;
	            for (i = 0;i < len ;i += 1) {
	                newLineFlag = false;
	                if(documentData.t.charAt(i) === ' '){
	                    val = '\u00A0';
	                }else if(documentData.t.charCodeAt(i) === 13){
	                    lineWidths.push(lineWidth);
	                    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	                    lineWidth = 0;
	                    val = '';
	                    newLineFlag = true;
	                    currentLine += 1;
	                }else{
	                    val = documentData.t.charAt(i);
	                }
	                if(fontManager.chars){
	                    charData = fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
	                    cLength = newLineFlag ? 0 : charData.w*documentData.s/100;
	                }else{
	                    //var charWidth = fontManager.measureText(val, documentData.f, documentData.s);
	                    //tCanvasHelper.font = documentData.s + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
	                    cLength = fontManager.measureText(val, documentData.f, documentData.s);
	                }
	
	                //
	                lineWidth += cLength;
	                letters.push({l:cLength,an:cLength,add:currentSize,n:newLineFlag, anIndexes:[], val: val, line: currentLine});
	                if(anchorGrouping == 2){
	                    currentSize += cLength;
	                    if(val == '' || val == '\u00A0' || i == len - 1){
	                        if(val == '' || val == '\u00A0'){
	                            currentSize -= cLength;
	                        }
	                        while(currentPos<=i){
	                            letters[currentPos].an = currentSize;
	                            letters[currentPos].ind = index;
	                            letters[currentPos].extra = cLength;
	                            currentPos += 1;
	                        }
	                        index += 1;
	                        currentSize = 0;
	                    }
	                }else if(anchorGrouping == 3){
	                    currentSize += cLength;
	                    if(val == '' || i == len - 1){
	                        if(val == ''){
	                            currentSize -= cLength;
	                        }
	                        while(currentPos<=i){
	                            letters[currentPos].an = currentSize;
	                            letters[currentPos].ind = index;
	                            letters[currentPos].extra = cLength;
	                            currentPos += 1;
	                        }
	                        currentSize = 0;
	                        index += 1;
	                    }
	                }else{
	                    letters[index].ind = index;
	                    letters[index].extra = 0;
	                    index += 1;
	                }
	            }
	            documentData.l = letters;
	            maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	            lineWidths.push(lineWidth);
	            if(documentData.sz){
	                documentData.boxWidth = documentData.sz[0];
	                documentData.justifyOffset = 0;
	            }else{
	                documentData.boxWidth = maxLineWidth;
	                switch(documentData.j){
	                    case 1:
	                        documentData.justifyOffset = - documentData.boxWidth;
	                        break;
	                    case 2:
	                        documentData.justifyOffset = - documentData.boxWidth/2;
	                        break;
	                    default:
	                        documentData.justifyOffset = 0;
	                }
	            }
	            documentData.lineWidths = lineWidths;
	
	            var animators = data.t.a;
	            jLen = animators.length;
	            var based, ind, indexes = [];
	            for(j=0;j<jLen;j+=1){
	                if(animators[j].a.sc){
	                    documentData.strokeColorAnim = true;
	                }
	                if(animators[j].a.sw){
	                    documentData.strokeWidthAnim = true;
	                }
	                if(animators[j].a.fc || animators[j].a.fh || animators[j].a.fs || animators[j].a.fb){
	                    documentData.fillColorAnim = true;
	                }
	                ind = 0;
	                based = animators[j].s.b;
	                for(i=0;i<len;i+=1){
	                    letters[i].anIndexes[j] = ind;
	                    if((based == 1 && letters[i].val != '') || (based == 2 && letters[i].val != '' && letters[i].val != '\u00A0') || (based == 3 && (letters[i].n || letters[i].val == '\u00A0' || i == len - 1)) || (based == 4 && (letters[i].n || i == len - 1))){
	                        if(animators[j].s.rn === 1){
	                            indexes.push(ind);
	                        }
	                        ind += 1;
	                    }
	                }
	                data.t.a[j].s.totalChars = ind;
	                var currentInd = -1, newInd;
	                if(animators[j].s.rn === 1){
	                    for(i = 0; i < len; i += 1){
	                        if(currentInd != letters[i].anIndexes[j]){
	                            currentInd = letters[i].anIndexes[j];
	                            newInd = indexes.splice(Math.floor(Math.random()*indexes.length),1)[0];
	                        }
	                        letters[i].anIndexes[j] = newInd;
	                    }
	                }
	            }
	            if(jLen === 0 && !('m' in data.t.p)){
	                data.singleShape = true;
	            }
	            documentData.yOffset = documentData.lh || documentData.s*1.2;
	            documentData.ls = documentData.ls || 0;
	            documentData.ascent = fontData.ascent*documentData.s/100;
	        }
	
	    }
	
	    var moduleOb = {};
	    moduleOb.completeData = completeData;
	
	    return moduleOb;
	}
	
	var dataManager = dataFunctionManager();
	var FontManager = (function(){
	
	    var maxWaitingTime = 5000;
	
	    function setUpNode(font, family){
	        var parentNode = document.createElement('span');
	        parentNode.style.fontFamily    = family;
	        var node = document.createElement('span');
	        // Characters that vary significantly among different fonts
	        node.innerHTML = 'giItT1WQy@!-/#';
	        // Visible - so we can measure it - but not on the screen
	        parentNode.style.position      = 'absolute';
	        parentNode.style.left          = '-10000px';
	        parentNode.style.top           = '-10000px';
	        // Large font size makes even subtle changes obvious
	        parentNode.style.fontSize      = '300px';
	        // Reset any font properties
	        parentNode.style.fontVariant   = 'normal';
	        parentNode.style.fontStyle     = 'normal';
	        parentNode.style.fontWeight    = 'normal';
	        parentNode.style.letterSpacing = '0';
	        parentNode.appendChild(node);
	        document.body.appendChild(parentNode);
	
	        // Remember width with no applied web font
	        var width = node.offsetWidth;
	        node.style.fontFamily = font + ', '+family;
	        return {node:node, w:width, parent:parentNode};
	    }
	
	    function checkLoadedFonts() {
	        var i, len = this.fonts.length;
	        var node, w;
	        var loadedCount = len;
	        for(i=0;i<len; i+= 1){
	            if(this.fonts[i].loaded){
	                loadedCount -= 1;
	                continue;
	            }
	            if(this.fonts[i].fOrigin === 't' || this.fonts[i].origin === 2){
	                if(window.Typekit && window.Typekit.load && this.typekitLoaded === 0){
	                    this.typekitLoaded = 1;
	                    try{window.Typekit.load({
	                        async: true,
	                        active: function() {
	                            this.typekitLoaded = 2;
	                        }.bind(this)
	                    });}catch(e){}
	                }
	                if(this.typekitLoaded === 2) {
	                    this.fonts[i].loaded = true;
	                }
	            } else if(this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0){
	                this.fonts[i].loaded = true;
	            } else{
	                node = this.fonts[i].monoCase.node;
	                w = this.fonts[i].monoCase.w;
	                if(node.offsetWidth !== w){
	                    loadedCount -= 1;
	                    this.fonts[i].loaded = true;
	                }else{
	                    node = this.fonts[i].sansCase.node;
	                    w = this.fonts[i].sansCase.w;
	                    if(node.offsetWidth !== w){
	                        loadedCount -= 1;
	                        this.fonts[i].loaded = true;
	                    }
	                }
	                if(this.fonts[i].loaded){
	                    this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
	                    this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
	                }
	            }
	        }
	
	        if(loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime){
	            setTimeout(checkLoadedFonts.bind(this),20);
	        }else{
	            setTimeout(function(){this.loaded = true;}.bind(this),0);
	
	        }
	    };
	
	    function createHelper(def, fontData){
	        var tHelper = document.createElementNS(svgNS,'text');
	        tHelper.style.fontSize = '100px';
	        tHelper.style.fontFamily = fontData.fFamily;
	        tHelper.textContent = '1';
	        if(fontData.fClass){
	            tHelper.style.fontFamily = 'inherit';
	            tHelper.className = fontData.fClass;
	        } else {
	            tHelper.style.fontFamily = fontData.fFamily;
	        }
	        def.appendChild(tHelper);
	        var tCanvasHelper = document.createElement('canvas').getContext('2d');
	        tCanvasHelper.font = '100px '+ fontData.fFamily;
	        return tCanvasHelper;
	        return tHelper;
	    }
	
	    function addFonts(fontData, defs){
	        if(!fontData){
	            this.loaded = true;
	            return;
	        }
	        if(this.chars){
	            this.loaded = true;
	            this.fonts = fontData.list;
	            return;
	        }
	
	        var fontArr = fontData.list;
	        var i, len = fontArr.length;
	        for(i=0; i<len; i+= 1){
	            fontArr[i].loaded = false;
	            fontArr[i].monoCase = setUpNode(fontArr[i].fFamily,'monospace');
	            fontArr[i].sansCase = setUpNode(fontArr[i].fFamily,'sans-serif');
	            if(!fontArr[i].fPath) {
	                fontArr[i].loaded = true;
	            }else if(fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3){
	                var s = document.createElement('style');
	                s.type = "text/css";
	                s.innerHTML = "@font-face {" + "font-family: "+fontArr[i].fFamily+"; font-style: normal; src: url('"+fontArr[i].fPath+"');}";
	                defs.appendChild(s);
	            } else if(fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1){
	                //<link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet' type='text/css'>
	                var l = document.createElement('link');
	                l.type = "text/css";
	                l.rel = "stylesheet";
	                l.href = fontArr[i].fPath;
	                defs.appendChild(l);
	            } else if(fontArr[i].fOrigin === 't' || fontArr[i].origin === 2){
	                //<link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet' type='text/css'>
	                var sc = document.createElement('script');
	                sc.setAttribute('src',fontArr[i].fPath);
	                defs.appendChild(sc);
	            }
	            fontArr[i].helper = createHelper(defs,fontArr[i]);
	            this.fonts.push(fontArr[i]);
	        }
	        checkLoadedFonts.bind(this)();
	    }
	
	    function addChars(chars){
	        if(!chars){
	            return;
	        }
	        if(!this.chars){
	            this.chars = [];
	        }
	        var i, len = chars.length;
	        var j, jLen = this.chars.length, found;
	        for(i=0;i<len;i+=1){
	            j = 0;
	            found = false;
	            while(j<jLen){
	                if(this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch){
	                    found = true;
	                }
	                j += 1;
	            }
	            if(!found){
	                this.chars.push(chars[i]);
	                jLen += 1;
	            }
	        }
	    }
	
	    function getCharData(char, style, font){
	        var i = 0, len = this.chars.length;
	        while( i < len) {
	            if(this.chars[i].ch === char && this.chars[i].style === style && this.chars[i].fFamily === font){
	                return this.chars[i];
	            }
	            i+= 1;
	        }
	    }
	
	    function measureText(char, fontName, size){
	        var fontData = this.getFontByName(fontName);
	        var tHelper = fontData.helper;
	        //tHelper.textContent = char;
	        return tHelper.measureText(char).width*size/100;
	        //return tHelper.getComputedTextLength()*size/100;
	    }
	
	    function getFontByName(name){
	        var i = 0, len = this.fonts.length;
	        while(i<len){
	            if(this.fonts[i].fName === name) {
	                return this.fonts[i];
	            }
	            i += 1;
	        }
	        return 'sans-serif';
	    }
	
	    var Font = function(){
	        this.fonts = [];
	        this.chars = null;
	        this.typekitLoaded = 0;
	        this.loaded = false;
	        this.initTime = Date.now();
	    };
	    Font.prototype.addChars = addChars;
	    Font.prototype.addFonts = addFonts;
	    Font.prototype.getCharData = getCharData;
	    Font.prototype.getFontByName = getFontByName;
	    Font.prototype.measureText = measureText;
	
	    return Font;
	
	}());
	var PropertyFactory = (function(){
	
	    var initFrame = -999999;
	
	    function getValue(){
	        if(this.elem.globalData.frameId === this.frameId){
	            return;
	        }
	        this.mdf = false;
	        var frameNum = this.comp.renderedFrame - this.offsetTime;
	        if(!(frameNum === this.lastFrame || (this.lastFrame !== initFrame && ((this.lastFrame >= this.keyframes[this.keyframes.length- 1].t-this.offsetTime && frameNum >= this.keyframes[this.keyframes.length- 1].t-this.offsetTime) || (this.lastFrame < this.keyframes[0].t-this.offsetTime && frameNum < this.keyframes[0].t-this.offsetTime))))){
	            var i = this.lastFrame < frameNum ? this._lastIndex : 0;
	            var len = this.keyframes.length- 1,flag = true;
	            var keyData, nextKeyData;
	
	            while(flag){
	                keyData = this.keyframes[i];
	                nextKeyData = this.keyframes[i+1];
	                if(i == len-1 && frameNum >= nextKeyData.t - this.offsetTime){
	                    if(keyData.h){
	                        keyData = nextKeyData;
	                    }
	                    break;
	                }
	                if((nextKeyData.t - this.offsetTime) > frameNum){
	                    break;
	                }
	                if(i < len - 1){
	                    i += 1;
	                }else{
	                    flag = false;
	                }
	            }
	
	            this._lastIndex = i;
	
	            var k, kLen,perc,jLen, j, fnc;
	            if(keyData.to){
	
	                if(!keyData.bezierData){
	                    bez.buildBezierData(keyData);
	                }
	                var bezierData = keyData.bezierData;
	                if(frameNum >= nextKeyData.t-this.offsetTime || frameNum < keyData.t-this.offsetTime){
	                    var ind = frameNum >= nextKeyData.t-this.offsetTime ? bezierData.points.length - 1 : 0;
	                    kLen = bezierData.points[ind].point.length;
	                    for(k = 0; k < kLen; k += 1){
	                        this.pv[k] = bezierData.points[ind].point[k];
	                        this.v[k] = this.mult ? this.pv[k]*this.mult : this.pv[k];
	                        if(this.lastPValue[k] !== this.pv[k]) {
	                            this.mdf = true;
	                            this.lastPValue[k] = this.pv[k];
	                        }
	                    }
	                    this._lastBezierData = null;
	                }else{
	                    if(keyData.__fnct){
	                        fnc = keyData.__fnct;
	                    }else{
	                        fnc = BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y,keyData.n).get;
	                        keyData.__fnct = fnc;
	                    }
	                    perc = fnc((frameNum-(keyData.t-this.offsetTime))/((nextKeyData.t-this.offsetTime)-(keyData.t-this.offsetTime)));
	                    var distanceInLine = bezierData.segmentLength*perc;
	
	                    var segmentPerc;
	                    var addedLength =  (this.lastFrame < frameNum && this._lastBezierData === bezierData) ? this._lastAddedLength : 0;
	                    j =  (this.lastFrame < frameNum && this._lastBezierData === bezierData) ? this._lastPoint : 0;
	                    flag = true;
	                    jLen = bezierData.points.length;
	                    while(flag){
	                        addedLength +=bezierData.points[j].partialLength;
	                        if(distanceInLine === 0 || perc === 0 || j == bezierData.points.length - 1){
	                            kLen = bezierData.points[j].point.length;
	                            for(k=0;k<kLen;k+=1){
	                                this.pv[k] = bezierData.points[j].point[k];
	                                this.v[k] = this.mult ? this.pv[k]*this.mult : this.pv[k];
	                                if(this.lastPValue[k] !== this.pv[k]) {
	                                    this.mdf = true;
	                                    this.lastPValue[k] = this.pv[k];
	                                }
	                            }
	                            break;
	                        }else if(distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j+1].partialLength){
	                            segmentPerc = (distanceInLine-addedLength)/(bezierData.points[j+1].partialLength);
	                            kLen = bezierData.points[j].point.length;
	                            for(k=0;k<kLen;k+=1){
	                                this.pv[k] = bezierData.points[j].point[k] + (bezierData.points[j+1].point[k] - bezierData.points[j].point[k])*segmentPerc;
	                                this.v[k] = this.mult ? this.pv[k] * this.mult : this.pv[k];
	                                if(this.lastPValue[k] !== this.pv[k]) {
	                                    this.mdf = true;
	                                    this.lastPValue[k] = this.pv[k];
	                                }
	                            }
	                            break;
	                        }
	                        if(j < jLen - 1){
	                            j += 1;
	                        }else{
	                            flag = false;
	                        }
	                    }
	                    this._lastPoint = j;
	                    this._lastAddedLength = addedLength - bezierData.points[j].partialLength;
	                    this._lastBezierData = bezierData;
	                }
	            }else{
	                var outX,outY,inX,inY, keyValue;
	                len = keyData.s.length;
	                for(i=0;i<len;i+=1){
	                    if(keyData.h !== 1){
	                        if(frameNum >= nextKeyData.t-this.offsetTime){
	                            perc = 1;
	                        }else if(frameNum < keyData.t-this.offsetTime){
	                            perc = 0;
	                        }else{
	                            if(keyData.o.x instanceof Array){
	                                if(!keyData.__fnct){
	                                    keyData.__fnct = [];
	                                }
	                                if (!keyData.__fnct[i]) {
	                                    outX = keyData.o.x[i] || keyData.o.x[0];
	                                    outY = keyData.o.y[i] || keyData.o.y[0];
	                                    inX = keyData.i.x[i] || keyData.i.x[0];
	                                    inY = keyData.i.y[i] || keyData.i.y[0];
	                                    fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
	                                    keyData.__fnct[i] = fnc;
	                                } else {
	                                    fnc = keyData.__fnct[i];
	                                }
	                            } else {
	                                if (!keyData.__fnct) {
	                                    outX = keyData.o.x;
	                                    outY = keyData.o.y;
	                                    inX = keyData.i.x;
	                                    inY = keyData.i.y;
	                                    fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
	                                    keyData.__fnct = fnc;
	                                } else{
	                                    fnc = keyData.__fnct;
	                                }
	                            }
	                            perc = fnc((frameNum-(keyData.t-this.offsetTime))/((nextKeyData.t-this.offsetTime)-(keyData.t-this.offsetTime)));
	                        }
	                    }
	                    if(this.sh && keyData.h !== 1){
	                        var initP = keyData.s[i];
	                        var endP = keyData.e[i];
	                        if(initP-endP < -180){
	                            initP += 360;
	                        } else if(initP-endP > 180){
	                            initP -= 360;
	                        }
	                        keyValue = initP+(endP-initP)*perc;
	                    } else {
	                        keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i]+(keyData.e[i]-keyData.s[i])*perc;
	                    }
	                    if(len === 1){
	                        this.v = this.mult ? keyValue*this.mult : keyValue;
	                        this.pv = keyValue;
	                        if(this.lastPValue != this.pv){
	                            this.mdf = true;
	                            this.lastPValue = this.pv;
	                        }
	                    }else{
	                        this.v[i] = this.mult ? keyValue*this.mult : keyValue;
	                        this.pv[i] = keyValue;
	                        if(this.lastPValue[i] !== this.pv[i]){
	                            this.mdf = true;
	                            this.lastPValue[i] = this.pv[i];
	                        }
	                    }
	                }
	            }
	        }
	        this.lastFrame = frameNum;
	        this.frameId = this.elem.globalData.frameId;
	    }
	
	    function getNoValue(){}
	
	    function ValueProperty(elem,data, mult){
	        this.mult = mult;
	        this.v = mult ? data.k * mult : data.k;
	        this.pv = data.k;
	        this.mdf = false;
	        this.comp = elem.comp;
	        this.k = false;
	        this.kf = false;
	        this.vel = 0;
	        this.getValue = getNoValue;
	    }
	
	    function MultiDimensionalProperty(elem,data, mult){
	        this.mult = mult;
	        this.data = data;
	        this.mdf = false;
	        this.comp = elem.comp;
	        this.k = false;
	        this.kf = false;
	        this.frameId = -1;
	        this.v = Array.apply(null, {length:data.k.length});
	        this.pv = Array.apply(null, {length:data.k.length});
	        this.lastValue = Array.apply(null, {length:data.k.length});
	        var arr = Array.apply(null, {length:data.k.length});
	        this.vel = arr.map(function () { return 0 });
	        var i, len = data.k.length;
	        for(i = 0;i<len;i+=1){
	            this.v[i] = mult ? data.k[i] * mult : data.k[i];
	            this.pv[i] = data.k[i];
	        }
	        this.getValue = getNoValue;
	    }
	
	    function KeyframedValueProperty(elem, data, mult){
	        this.keyframes = data.k;
	        this.offsetTime = elem.data.st;
	        this.lastValue = -99999;
	        this.lastPValue = -99999;
	        this.frameId = -1;
	        this._lastIndex = 0;
	        this.k = true;
	        this.kf = true;
	        this.data = data;
	        this.mult = mult;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.lastFrame = initFrame;
	        this.v = mult ? data.k[0].s[0]*mult : data.k[0].s[0];
	        this.pv = data.k[0].s[0];
	        this.getValue = getValue;
	    }
	
	    function KeyframedMultidimensionalProperty(elem, data, mult){
	        var i, len = data.k.length;
	        var s, e,to,ti;
	        for(i=0;i<len-1;i+=1){
	            if(data.k[i].to && data.k[i].s && data.k[i].e ){
	                s = data.k[i].s;
	                e = data.k[i].e;
	                to = data.k[i].to;
	                ti = data.k[i].ti;
	                if((s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],s[0] + to[0],s[1] + to[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],e[0] + ti[0],e[1] + ti[1])) || (s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],s[0] + to[0],s[1] + to[1],s[2] + to[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],e[0] + ti[0],e[1] + ti[1],e[2] + ti[2]))){
	                    data.k[i].to = null;
	                    data.k[i].ti = null;
	                }
	            }
	        }
	        this.keyframes = data.k;
	        this.offsetTime = elem.data.st;
	        this.k = true;
	        this.kf = true;
	        this.mult = mult;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.getValue = getValue;
	        this.frameId = -1;
	        this._lastIndex = 0;
	        this.v = Array.apply(null, {length:data.k[0].s.length});
	        this.pv = Array.apply(null, {length:data.k[0].s.length});
	        this.lastValue = Array.apply(null, {length:data.k[0].s.length});
	        this.lastPValue = Array.apply(null, {length:data.k[0].s.length});
	        this.lastFrame = initFrame;
	    }
	
	    var TransformProperty = (function() {
	        function positionGetter() {
	            if(this.p) {
	                return ExpressionValue(this.p);
	            } else {
	                return [this.px.v, this.py.v, this.pz ? this.pz.v : 0];
	            }
	        }
	        function xPositionGetter() {
	            return ExpressionValue(this.px);
	        }
	        function yPositionGetter() {
	            return ExpressionValue(this.py);
	        }
	        function zPositionGetter() {
	            return ExpressionValue(this.pz);
	        }
	        function anchorGetter() {
	            return ExpressionValue(this.a);
	        }
	        function orientationGetter() {
	            return ExpressionValue(this.or);
	        }
	        function rotationGetter() {
	            if(this.r) {
	                return ExpressionValue(this.r, 1/degToRads);
	            } else {
	                return ExpressionValue(this.rz, 1/degToRads);
	            }
	        }
	        function scaleGetter() {
	            return ExpressionValue(this.s, 100);
	        }
	        function opacityGetter() {
	            return ExpressionValue(this.o, 100);
	        }
	        function skewGetter() {
	            return ExpressionValue(this.sk);
	        }
	        function skewAxisGetter() {
	            return ExpressionValue(this.sa);
	        }
	        function applyToMatrix(mat) {
	            var i, len = this.dynamicProperties.length;
	            for(i = 0; i < len; i += 1) {
	                this.dynamicProperties[i].getValue();
	                if (this.dynamicProperties[i].mdf) {
	                    this.mdf = true;
	                }
	            }
	            if (this.a) {
	                mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	            }
	            if (this.s) {
	                mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	            }
	            if (this.r) {
	                mat.rotate(-this.r.v);
	            } else {
	                mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	            }
	            if (this.data.p.s) {
	                if (this.data.p.z) {
	                    mat.translate(this.px.v, this.py.v, -this.pz.v);
	                } else {
	                    mat.translate(this.px.v, this.py.v, 0);
	                }
	            } else {
	                mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
	            }
	        }
	        function processKeys(){
	            if (this.elem.globalData.frameId === this.frameId) {
	                return;
	            }
	
	            this.mdf = false;
	            var i, len = this.dynamicProperties.length;
	
	            for(i = 0; i < len; i += 1) {
	                this.dynamicProperties[i].getValue();
	                if (this.dynamicProperties[i].mdf) {
	                    this.mdf = true;
	                }
	            }
	            if (this.mdf) {
	                this.v.reset();
	                if (this.a) {
	                    this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	                }
	                if(this.s) {
	                    this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	                }
	                if (this.sk) {
	                    this.v.skewFromAxis(-this.sk.v, this.sa.v);
	                }
	                if (this.r) {
	                    this.v.rotate(-this.r.v);
	                } else {
	                    this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	                }
	                if (this.autoOriented && this.p.keyframes && this.p.getValueAtTime) {
	                    var v1,v2;
	                    if (this.p.lastFrame+this.p.offsetTime <= this.p.keyframes[0].t) {
	                        v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / this.elem.globalData.frameRate,0);
	                        v2 = this.p.getValueAtTime(this.p.keyframes[0].t / this.elem.globalData.frameRate, 0);
	                    } else if(this.p.lastFrame+this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
	                        v1 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t / this.elem.globalData.frameRate), 0);
	                        v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.01) / this.elem.globalData.frameRate, 0);
	                    } else {
	                        v1 = this.p.pv;
	                        v2 = this.p.getValueAtTime((this.p.lastFrame+this.p.offsetTime - 0.01) / this.elem.globalData.frameRate, this.p.offsetTime);
	                    }
	                    this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
	                }
	                if(this.data.p.s){
	                    if(this.data.p.z) {
	                        this.v.translate(this.px.v, this.py.v, -this.pz.v);
	                    } else {
	                        this.v.translate(this.px.v, this.py.v, 0);
	                    }
	                }else{
	                    this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
	                }
	            }
	            //console.log(this.v.to2dCSS())
	            this.frameId = this.elem.globalData.frameId;
	        }
	
	        function setInverted(){
	            this.inverted = true;
	            this.iv = new Matrix();
	            if(!this.k){
	                if(this.data.p.s){
	                    this.iv.translate(this.px.v,this.py.v,-this.pz.v);
	                }else{
	                    this.iv.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
	                }
	                if(this.r){
	                    this.iv.rotate(-this.r.v);
	                }else{
	                    this.iv.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
	                }
	                if(this.s){
	                    this.iv.scale(this.s.v[0],this.s.v[1],1);
	                }
	                if(this.a){
	                    this.iv.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);
	                }
	            }
	        }
	
	        function autoOrient(){
	            //
	            //var prevP = this.getValueAtTime();
	        }
	
	        return function TransformProperty(elem,data,arr){
	            this.elem = elem;
	            this.frameId = -1;
	            this.type = 'transform';
	            this.dynamicProperties = [];
	            this.mdf = false;
	            this.data = data;
	            this.getValue = processKeys;
	            this.applyToMatrix = applyToMatrix;
	            this.setInverted = setInverted;
	            this.autoOrient = autoOrient;
	            this.v = new Matrix();
	            if(data.p.s){
	                this.px = PropertyFactory.getProp(elem,data.p.x,0,0,this.dynamicProperties);
	                this.py = PropertyFactory.getProp(elem,data.p.y,0,0,this.dynamicProperties);
	                if(data.p.z){
	                    this.pz = PropertyFactory.getProp(elem,data.p.z,0,0,this.dynamicProperties);
	                }
	            }else{
	                this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
	            }
	            if(data.r) {
	                this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this.dynamicProperties);
	            } else if(data.rx) {
	                this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this.dynamicProperties);
	                this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this.dynamicProperties);
	                this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this.dynamicProperties);
	                this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this.dynamicProperties);
	            }
	            if(data.sk){
	                this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this.dynamicProperties);
	                this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this.dynamicProperties);
	            }
	            if(data.a) {
	                this.a = PropertyFactory.getProp(elem,data.a,1,0,this.dynamicProperties);
	            }
	            if(data.s) {
	                this.s = PropertyFactory.getProp(elem,data.s,1,0.01,this.dynamicProperties);
	            }
	            if(data.o){
	                this.o = PropertyFactory.getProp(elem,data.o,0,0.01,arr);
	            } else {
	                this.o = {mdf:false,v:1};
	            }
	            if(this.dynamicProperties.length){
	                arr.push(this);
	            }else{
	                if(this.a){
	                    this.v.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);
	                }
	                if(this.s){
	                    this.v.scale(this.s.v[0],this.s.v[1],this.s.v[2]);
	                }
	                if(this.sk){
	                    this.v.skewFromAxis(-this.sk.v,this.sa.v);
	                }
	                if(this.r){
	                    this.v.rotate(-this.r.v);
	                }else{
	                    this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	                }
	                if(this.data.p.s){
	                    if(data.p.z) {
	                        this.v.translate(this.px.v, this.py.v, -this.pz.v);
	                    } else {
	                        this.v.translate(this.px.v, this.py.v, 0);
	                    }
	                }else{
	                    this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
	                }
	            }
	            Object.defineProperty(this, "position", { get: positionGetter});
	            Object.defineProperty(this, "xPosition", { get: xPositionGetter});
	            Object.defineProperty(this, "yPosition", { get: yPositionGetter});
	            Object.defineProperty(this, "orientation", { get: orientationGetter});
	            Object.defineProperty(this, "anchorPoint", { get: anchorGetter});
	            Object.defineProperty(this, "rotation", { get: rotationGetter});
	            Object.defineProperty(this, "scale", { get: scaleGetter});
	            Object.defineProperty(this, "opacity", { get: opacityGetter});
	            Object.defineProperty(this, "skew", { get: skewGetter});
	            Object.defineProperty(this, "skewAxis", { get: skewAxisGetter});
	        }
	    }());
	
	    function getProp(elem,data,type, mult, arr) {
	        var p;
	        if(type === 2){
	            p = new TransformProperty(elem, data, arr);
	        } else if(data.a === 0){
	            if(type === 0) {
	                p = new ValueProperty(elem,data,mult);
	            } else {
	                p = new MultiDimensionalProperty(elem,data, mult);
	            }
	        } else if(data.a === 1){
	            if(type === 0) {
	                p = new KeyframedValueProperty(elem,data,mult);
	            } else {
	                p = new KeyframedMultidimensionalProperty(elem,data, mult);
	            }
	        } else if(!data.k.length){
	            p = new ValueProperty(elem,data, mult);
	        }else if(typeof(data.k[0]) === 'number'){
	            p = new MultiDimensionalProperty(elem,data, mult);
	        }else{
	            switch(type){
	                case 0:
	                    p = new KeyframedValueProperty(elem,data,mult);
	                    break;
	                case 1:
	                    p = new KeyframedMultidimensionalProperty(elem,data,mult);
	                    break;
	            }
	        }
	        if(p.k){
	            arr.push(p);
	        }
	        return p;
	    }
	
	    var getGradientProp = (function(){
	
	        function getValue(forceRender){
	            this.prop.getValue();
	            this.cmdf = false;
	            this.omdf = false;
	            if(this.prop.mdf || forceRender){
	                var i, len = this.data.p*4;
	                var mult, val;
	                for(i=0;i<len;i+=1){
	                    mult = i%4 === 0 ? 100 : 255;
	                    val = Math.round(this.prop.v[i]*mult);
	                    if(this.c[i] !== val){
	                        this.c[i] = val;
	                        this.cmdf = true;
	                    }
	                }
	                if(this.o.length){
	                    len = this.prop.v.length;
	                    for(i=this.data.p*4;i<len;i+=1){
	                        mult = i%2 === 0 ? 100 : 1;
	                        val = i%2 === 0 ?  Math.round(this.prop.v[i]*100):this.prop.v[i];
	                        if(this.o[i-this.data.p*4] !== val){
	                            this.o[i-this.data.p*4] = val;
	                            this.omdf = true;
	                        }
	                    }
	                }
	            }
	
	        }
	
	        function gradientProp(elem,data,arr){
	            this.prop = getProp(elem,data.k,1,null,[]);
	            this.data = data;
	            this.k = this.prop.k;
	            this.c = Array.apply(null,{length:data.p*4});
	            var cLength = data.k.k[0].s ? (data.k.k[0].s.length - data.p*4) : data.k.k.length - data.p*4;
	            this.o = Array.apply(null,{length:cLength});
	            this.cmdf = false;
	            this.omdf = false;
	            this.getValue = getValue;
	            if(this.prop.k){
	                arr.push(this);
	            }
	            this.getValue(true);
	        }
	
	        return function getGradientProp(elem,data,arr){
	            return new gradientProp(elem,data,arr);
	        }
	    }());
	
	
	
	
	    var DashProperty = (function(){
	
	        function processKeys(forceRender){
	            var i = 0, len = this.dataProps.length;
	
	            if(this.elem.globalData.frameId === this.frameId && !forceRender){
	                return;
	            }
	            this.mdf = false;
	            this.frameId = this.elem.globalData.frameId;
	            while(i<len){
	                if(this.dataProps[i].p.mdf){
	                    this.mdf = true;
	                    break;
	                }
	                i+=1;
	            }
	            if(this.mdf || forceRender){
	                if(this.renderer === 'svg') {
	                    this.dasharray = '';
	                }
	                for(i=0;i<len;i+=1){
	                    if(this.dataProps[i].n != 'o'){
	                        if(this.renderer === 'svg') {
	                            this.dasharray += ' ' + this.dataProps[i].p.v;
	                        }else{
	                            this.dasharray[i] = this.dataProps[i].p.v;
	                        }
	                    }else{
	                        this.dashoffset = this.dataProps[i].p.v;
	                    }
	                }
	            }
	        }
	
	        return function(elem, data,renderer, dynamicProperties){
	            this.elem = elem;
	            this.frameId = -1;
	            this.dataProps = new Array(data.length);
	            this.renderer = renderer;
	            this.mdf = false;
	            this.k = false;
	            if(this.renderer === 'svg'){
	                this.dasharray = '';
	            }else{
	
	                this.dasharray = new Array(data.length - 1);
	            }
	            this.dashoffset = 0;
	            var i, len = data.length, prop;
	            for(i=0;i<len;i+=1){
	                prop = PropertyFactory.getProp(elem,data[i].v,0, 0, dynamicProperties);
	                this.k = prop.k ? true : this.k;
	                this.dataProps[i] = {n:data[i].n,p:prop};
	            }
	            this.getValue = processKeys;
	            if(this.k){
	                dynamicProperties.push(this);
	            }else{
	                this.getValue(true);
	            }
	
	        }
	    }());
	
	    function getDashProp(elem, data,renderer, dynamicProperties) {
	        return new DashProperty(elem, data,renderer, dynamicProperties);
	    };
	
	    var TextSelectorProp = (function(){
	        var max = Math.max;
	        var min = Math.min;
	        var floor = Math.floor;
	        function updateRange(){
	            if(this.dynamicProperties.length){
	                var i, len = this.dynamicProperties.length;
	                for(i=0;i<len;i+=1){
	                    this.dynamicProperties[i].getValue();
	                    if(this.dynamicProperties[i].mdf){
	                        this.mdf = true;
	                    }
	                }
	            }
	            var totalChars = this.data.totalChars;
	            var divisor = this.data.r === 2 ? 1 : 100/totalChars;
	            var o = this.o.v/divisor;
	            var s = this.s.v/divisor + o;
	            var e = (this.e.v/divisor) + o;
	            if(s>e){
	                var _s = s;
	                s = e;
	                e = _s;
	            }
	            this.finalS = s;
	            this.finalE = e;
	        }
	
	        function getMult(ind){
	            //var easer = bez.getEasingCurve(this.ne.v/100,0,1-this.xe.v/100,1);
	            var easer = BezierFactory.getBezierEasing(this.ne.v/100,0,1-this.xe.v/100,1).get;
	            var mult = 0;
	            var s = this.finalS;
	            var e = this.finalE;
	            var type = this.data.sh;
	            if(type == 2){
	                if(e === s){
	                    mult = ind >= e ? 1 : 0;
	                }else{
	                    mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	                }
	                mult = easer(mult);
	            }else if(type == 3){
	                if(e === s){
	                    mult = ind >= e ? 0 : 1;
	                }else{
	                    mult = 1 - max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	                }
	
	                mult = easer(mult);
	            }else if(type == 4){
	                if(e === s){
	                    mult = 0;
	                }else{
	                    mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	                    if(mult<.5){
	                        mult *= 2;
	                    }else{
	                        mult = 1 - 2*(mult-0.5);
	                    }
	                }
	                mult = easer(mult);
	            }else if(type == 5){
	                if(e === s){
	                    mult = 0;
	                }else{
	                    var tot = e - s;
	                    /*ind += 0.5;
	                    mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind;*/
	                    ind = min(max(0,ind+0.5-s),e-s);
	                    var x = -tot/2+ind;
	                    var a = tot/2;
	                    mult = Math.sqrt(1 - (x*x)/(a*a));
	                }
	                mult = easer(mult);
	            }else if(type == 6){
	                if(e === s){
	                    mult = 0;
	                }else{
	                    ind = min(max(0,ind+0.5-s),e-s);
	                    mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind)/(e-s)))))/2;
	                    /*
	                     ind = Math.min(Math.max(s,ind),e-1);
	                     mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind-s)/(e-1-s)))))/2;
	                     mult = Math.max(mult,(1/(e-1-s))/(e-1-s));*/
	                }
	                mult = easer(mult);
	            }else {
	                if(ind >= floor(s)){
	                    if(ind-s < 0){
	                        mult = 1 - (s - ind);
	                    }else{
	                        mult = max(0,min(e-ind,1));
	                    }
	                }
	                mult = easer(mult);
	            }
	            return mult*this.a.v;
	        }
	
	        return function TextSelectorProp(elem,data, arr){
	            this.mdf = false;
	            this.k = false;
	            this.data = data;
	            this.dynamicProperties = [];
	            this.getValue = updateRange;
	            this.getMult = getMult;
	            this.comp = elem.comp;
	            this.finalS = 0;
	            this.finalE = 0;
	            this.s = PropertyFactory.getProp(elem,data.s || {k:0},0,0,this.dynamicProperties);
	            if('e' in data){
	                this.e = PropertyFactory.getProp(elem,data.e,0,0,this.dynamicProperties);
	            }else{
	                this.e = {v:data.r === 2 ? data.totalChars : 100};
	            }
	            this.o = PropertyFactory.getProp(elem,data.o || {k:0},0,0,this.dynamicProperties);
	            this.xe = PropertyFactory.getProp(elem,data.xe || {k:0},0,0,this.dynamicProperties);
	            this.ne = PropertyFactory.getProp(elem,data.ne || {k:0},0,0,this.dynamicProperties);
	            this.a = PropertyFactory.getProp(elem,data.a,0,0.01,this.dynamicProperties);
	            if(this.dynamicProperties.length){
	                arr.push(this);
	            }else{
	                this.getValue();
	            }
	        }
	    }());
	
	    function getTextSelectorProp(elem, data,arr) {
	        return new TextSelectorProp(elem, data, arr);
	    };
	
	    var ob = {};
	    ob.getProp = getProp;
	    ob.getDashProp = getDashProp;
	    ob.getTextSelectorProp = getTextSelectorProp;
	    ob.getGradientProp = getGradientProp;
	    return ob;
	}());
	function ShapePath(){
		this.c = false;
		this._length = 0;
		this._maxLength = 8;
		this.v = Array.apply(null,{length:this._maxLength});
		this.o = Array.apply(null,{length:this._maxLength});
		this.i = Array.apply(null,{length:this._maxLength});
	};
	
	ShapePath.prototype.setPathData = function(closed, len) {
		this.c = closed;
		while(len > this._maxLength){
			this.doubleArrayLength();
		}
		var i = 0;
		while(i < len){
			this.v[i] = point_pool.newPoint();
			this.o[i] = point_pool.newPoint();
			this.i[i] = point_pool.newPoint();
			i += 1;
		}
		this._length = len;
	};
	
	ShapePath.prototype.doubleArrayLength = function() {
		this.v = this.v.concat(Array.apply(null,{length:this._maxLength}))
		this.i = this.i.concat(Array.apply(null,{length:this._maxLength}))
		this.o = this.o.concat(Array.apply(null,{length:this._maxLength}))
		this._maxLength *= 2;
	};
	
	ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
		var arr;
		this._length = Math.max(this._length, pos + 1);
		if(this._length >= this._maxLength) {
			this.doubleArrayLength();
		}
		switch(type){
			case 'v':
				arr = this.v;
				break;
			case 'i':
				arr = this.i;
				break;
			case 'o':
				arr = this.o;
				break;
		}
		if(!arr[pos] || (arr[pos] && !replace)){
			arr[pos] = point_pool.newPoint();
		}
		arr[pos][0] = x;
		arr[pos][1] = y;
	};
	
	ShapePath.prototype.setTripleAt = function(vX,vY,oX,oY,iX,iY,pos, replace) {
		this.setXYAt(vX,vY,'v',pos, replace);
		this.setXYAt(oX,oY,'o',pos, replace);
		this.setXYAt(iX,iY,'i',pos, replace);
	};
	var ShapePropertyFactory = (function(){
	
	    var initFrame = -999999;
	
	    function interpolateShape() {
	        if(this.elem.globalData.frameId === this.frameId){
	            return;
	        }
	        this.mdf = false;
	        var frameNum = this.comp.renderedFrame - this.offsetTime;
	        if(!((this.lastFrame !== initFrame && ((this.lastFrame < this.keyframes[0].t-this.offsetTime && frameNum < this.keyframes[0].t-this.offsetTime) || (this.lastFrame > this.keyframes[this.keyframes.length - 1].t-this.offsetTime && frameNum > this.keyframes[this.keyframes.length - 1].t-this.offsetTime))))){
	            var keyPropS,keyPropE,isHold;
	            if(frameNum < this.keyframes[0].t-this.offsetTime){
	                keyPropS = this.keyframes[0].s[0];
	                isHold = true;
	                this._lastIndex = 0;
	            }else if(frameNum >= this.keyframes[this.keyframes.length - 1].t-this.offsetTime){
	                if(this.keyframes[this.keyframes.length - 2].h === 1){
	                    keyPropS = this.keyframes[this.keyframes.length - 1].s[0];
	                }else{
	                    keyPropS = this.keyframes[this.keyframes.length - 2].e[0];
	                }
	                isHold = true;
	            }else{
	                var i = this.lastFrame < initFrame ? this._lastIndex : 0;
	                var len = this.keyframes.length- 1,flag = true,keyData,nextKeyData, j, jLen, k, kLen;
	                while(flag){
	                    keyData = this.keyframes[i];
	                    nextKeyData = this.keyframes[i+1];
	                    if((nextKeyData.t - this.offsetTime) > frameNum){
	                        break;
	                    }
	                    if(i < len - 1){
	                        i += 1;
	                    }else{
	                        flag = false;
	                    }
	                }
	                isHold = keyData.h === 1;
	                this._lastIndex = i;
	
	                var perc;
	                if(!isHold){
	                    if(frameNum >= nextKeyData.t-this.offsetTime){
	                        perc = 1;
	                    }else if(frameNum < keyData.t-this.offsetTime){
	                        perc = 0;
	                    }else{
	                        var fnc;
	                        if(keyData.__fnct){
	                            fnc = keyData.__fnct;
	                        }else{
	                            fnc = BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y).get;
	                            keyData.__fnct = fnc;
	                        }
	                        perc = fnc((frameNum-(keyData.t-this.offsetTime))/((nextKeyData.t-this.offsetTime)-(keyData.t-this.offsetTime)));
	                    }
	                    keyPropE = keyData.e[0];
	                }
	                keyPropS = keyData.s[0];
	            }
	            jLen = this.v._length;
	            kLen = keyPropS.i[0].length;
	            var hasModified = false;
	            var vertexValue;
	            for(j=0;j<jLen;j+=1){
	                for(k=0;k<kLen;k+=1){
	                    if(isHold){
	                        vertexValue = keyPropS.i[j][k];
	                        if(this.v.i[j][k] !== vertexValue){
	                            this.v.i[j][k] = vertexValue;
	                            this.pv.i[j][k] = vertexValue;
	                            hasModified = true;
	                        }
	                        vertexValue = keyPropS.o[j][k];
	                        if(this.v.o[j][k] !== vertexValue){
	                            this.v.o[j][k] = vertexValue;
	                            this.pv.o[j][k] = vertexValue;
	                            hasModified = true;
	                        }
	                        vertexValue = keyPropS.v[j][k];
	                        if(this.v.v[j][k] !== vertexValue){
	                            this.v.v[j][k] = vertexValue;
	                            this.pv.v[j][k] = vertexValue;
	                            hasModified = true;
	                        }
	                    }else{
	                        vertexValue = keyPropS.i[j][k]+(keyPropE.i[j][k]-keyPropS.i[j][k])*perc;
	                        if(this.v.i[j][k] !== vertexValue){
	                            this.v.i[j][k] = vertexValue;
	                            this.pv.i[j][k] = vertexValue;
	                            hasModified = true;
	                        }
	                        vertexValue = keyPropS.o[j][k]+(keyPropE.o[j][k]-keyPropS.o[j][k])*perc;
	                        if(this.v.o[j][k] !== vertexValue){
	                            this.v.o[j][k] = vertexValue;
	                            this.pv.o[j][k] = vertexValue;
	                            hasModified = true;
	                        }
	                        vertexValue = keyPropS.v[j][k]+(keyPropE.v[j][k]-keyPropS.v[j][k])*perc;
	                        if(this.v.v[j][k] !== vertexValue){
	                            this.v.v[j][k] = vertexValue;
	                            this.pv.v[j][k] = vertexValue;
	                            hasModified = true;
	                        }
	                    }
	                }
	            }
	            this.mdf = hasModified;
	            this.v.c = keyPropS.c;
	            this.paths = this.localShapeCollection;
	        }
	
	        this.lastFrame = frameNum;
	        this.frameId = this.elem.globalData.frameId;
	    }
	
	    function getShapeValue(){
	        return this.v;
	    }
	
	    function resetShape(){
	        this.paths = this.localShapeCollection;
	        if(!this.k){
	            this.mdf = false;
	        }
	    }
	
	    function ShapeProperty(elem, data, type){
	        this.comp = elem.comp;
	        this.k = false;
	        this.mdf = false;
	        this.v = shape_pool.newShape();
	        var pathData = type === 3 ? data.pt.k : data.ks.k;
	        this.v.v = pathData.v;
	        this.v.i = pathData.i;
	        this.v.o = pathData.o;
	        this.v.c = pathData.c;
	        this.v._length = this.v.v.length;
	        this.getValue = getShapeValue;
	        this.pv = shape_pool.clone(this.v);
	        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.paths.addShape(this.v);
	        this.reset = resetShape;
	    }
	
	    function KeyframedShapeProperty(elem,data,type){
	        this.comp = elem.comp;
	        this.elem = elem;
	        this.offsetTime = elem.data.st;
	        this._lastIndex = 0;
	        this.getValue = interpolateShape;
	        this.keyframes = type === 3 ? data.pt.k : data.ks.k;
	        this.k = true;
	        this.kf = true;
	        var i, len = this.keyframes[0].s[0].i.length;
	        var jLen = this.keyframes[0].s[0].i[0].length;
	        this.v = shape_pool.newShape();
	        this.v.setPathData(this.keyframes[0].s[0].c, len);
	        this.pv = shape_pool.clone(this.v);
	        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.paths.addShape(this.v);
	        this.lastFrame = initFrame;
	        this.reset = resetShape;
	    }
	
	    var EllShapeProperty = (function(){
	
	        var cPoint = roundCorner;
	
	        function convertEllToPath(){
	            var p0 = this.p.v[0], p1 = this.p.v[1], s0 = this.s.v[0]/2, s1 = this.s.v[1]/2;
	            if(this.d !== 3){
	                this.v.v[0][0] = p0;
	                this.v.v[0][1] = p1-s1;
	                this.v.v[1][0] = p0 + s0;
	                this.v.v[1][1] = p1;
	                this.v.v[2][0] = p0;
	                this.v.v[2][1] = p1+s1;
	                this.v.v[3][0] = p0 - s0;
	                this.v.v[3][1] = p1;
	                this.v.i[0][0] = p0 - s0*cPoint;
	                this.v.i[0][1] = p1 - s1;
	                this.v.i[1][0] = p0 + s0;
	                this.v.i[1][1] = p1 - s1*cPoint;
	                this.v.i[2][0] = p0 + s0*cPoint;
	                this.v.i[2][1] = p1 + s1;
	                this.v.i[3][0] = p0 - s0;
	                this.v.i[3][1] = p1 + s1*cPoint;
	                this.v.o[0][0] = p0 + s0*cPoint;
	                this.v.o[0][1] = p1 - s1;
	                this.v.o[1][0] = p0 + s0;
	                this.v.o[1][1] = p1 + s1*cPoint;
	                this.v.o[2][0] = p0 - s0*cPoint;
	                this.v.o[2][1] = p1 + s1;
	                this.v.o[3][0] = p0 - s0;
	                this.v.o[3][1] = p1 - s1*cPoint;
	            }else{
	                this.v.v[0][0] = p0;
	                this.v.v[0][1] = p1-s1;
	                this.v.v[1][0] = p0 - s0;
	                this.v.v[1][1] = p1;
	                this.v.v[2][0] = p0;
	                this.v.v[2][1] = p1+s1;
	                this.v.v[3][0] = p0 + s0;
	                this.v.v[3][1] = p1;
	                this.v.i[0][0] = p0 + s0*cPoint;
	                this.v.i[0][1] = p1 - s1;
	                this.v.i[1][0] = p0 - s0;
	                this.v.i[1][1] = p1 - s1*cPoint;
	                this.v.i[2][0] = p0 - s0*cPoint;
	                this.v.i[2][1] = p1 + s1;
	                this.v.i[3][0] = p0 + s0;
	                this.v.i[3][1] = p1 + s1*cPoint;
	                this.v.o[0][0] = p0 - s0*cPoint;
	                this.v.o[0][1] = p1 - s1;
	                this.v.o[1][0] = p0 - s0;
	                this.v.o[1][1] = p1 + s1*cPoint;
	                this.v.o[2][0] = p0 + s0*cPoint;
	                this.v.o[2][1] = p1 + s1;
	                this.v.o[3][0] = p0 + s0;
	                this.v.o[3][1] = p1 - s1*cPoint;
	            }
	        }
	
	        function processKeys(frameNum){
	            var i, len = this.dynamicProperties.length;
	            if(this.elem.globalData.frameId === this.frameId){
	                return;
	            }
	            this.mdf = false;
	            this.frameId = this.elem.globalData.frameId;
	
	            for(i=0;i<len;i+=1){
	                this.dynamicProperties[i].getValue(frameNum);
	                if(this.dynamicProperties[i].mdf){
	                    this.mdf = true;
	                }
	            }
	            if(this.mdf){
	                this.convertEllToPath();
	            }
	        }
	
	        return function EllShapeProperty(elem,data) {
	            /*this.v = {
	                v: Array.apply(null,{length:4}),
	                i: Array.apply(null,{length:4}),
	                o: Array.apply(null,{length:4}),
	                c: true
	            };*/
	            this.v = shape_pool.newShape();
	            this.v.setPathData(true, 4);
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.paths = this.localShapeCollection;
	            this.localShapeCollection.addShape(this.v);
	            this.d = data.d;
	            this.dynamicProperties = [];
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.frameId = -1;
	            this.mdf = false;
	            this.getValue = processKeys;
	            this.convertEllToPath = convertEllToPath;
	            this.reset = resetShape;
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
	            this.s = PropertyFactory.getProp(elem,data.s,1,0,this.dynamicProperties);
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.convertEllToPath();
	            }
	        }
	    }());
	
	    var StarShapeProperty = (function() {
	
	        function convertPolygonToPath(){
	            var numPts = Math.floor(this.pt.v);
	            var angle = Math.PI*2/numPts;
	            /*this.v.v.length = numPts;
	            this.v.i.length = numPts;
	            this.v.o.length = numPts;*/
	            var rad = this.or.v;
	            var roundness = this.os.v;
	            var perimSegment = 2*Math.PI*rad/(numPts*4);
	            var i, currentAng = -Math.PI/ 2;
	            var dir = this.data.d === 3 ? -1 : 1;
	            currentAng += this.r.v;
	            this.v._length = 0;
	            for(i=0;i<numPts;i+=1){
	                var x = rad * Math.cos(currentAng);
	                var y = rad * Math.sin(currentAng);
	                var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
	                var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
	                x +=  + this.p.v[0];
	                y +=  + this.p.v[1];
	                this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);
	                /*this.v.v[i] = [x,y];
	                this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
	                this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];*/
	                currentAng += angle*dir;
	            }
	            this.paths.length = 0;
	            this.paths[0] = this.v;
	        }
	
	        function convertStarToPath() {
	            var numPts = Math.floor(this.pt.v)*2;
	            var angle = Math.PI*2/numPts;
	            /*this.v.v.length = numPts;
	            this.v.i.length = numPts;
	            this.v.o.length = numPts;*/
	            var longFlag = true;
	            var longRad = this.or.v;
	            var shortRad = this.ir.v;
	            var longRound = this.os.v;
	            var shortRound = this.is.v;
	            var longPerimSegment = 2*Math.PI*longRad/(numPts*2);
	            var shortPerimSegment = 2*Math.PI*shortRad/(numPts*2);
	            var i, rad,roundness,perimSegment, currentAng = -Math.PI/ 2;
	            currentAng += this.r.v;
	            var dir = this.data.d === 3 ? -1 : 1;
	            this.v._length = 0;
	            for(i=0;i<numPts;i+=1){
	                rad = longFlag ? longRad : shortRad;
	                roundness = longFlag ? longRound : shortRound;
	                perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
	                var x = rad * Math.cos(currentAng);
	                var y = rad * Math.sin(currentAng);
	                var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
	                var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
	                x +=  + this.p.v[0];
	                y +=  + this.p.v[1];
	                this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);
	
	                /*this.v.v[i] = [x,y];
	                this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
	                this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
	                this.v._length = numPts;*/
	                longFlag = !longFlag;
	                currentAng += angle*dir;
	            }
	        }
	
	        function processKeys() {
	            if(this.elem.globalData.frameId === this.frameId){
	                return;
	            }
	            this.mdf = false;
	            this.frameId = this.elem.globalData.frameId;
	            var i, len = this.dynamicProperties.length;
	
	            for(i=0;i<len;i+=1){
	                this.dynamicProperties[i].getValue();
	                if(this.dynamicProperties[i].mdf){
	                    this.mdf = true;
	                }
	            }
	            if(this.mdf){
	                this.convertToPath();
	            }
	        }
	
	        return function StarShapeProperty(elem,data) {
	            /*this.v = {
	                v: [],
	                i: [],
	                o: [],
	                c: true
	            };*/
	            this.v = shape_pool.newShape();
	            this.v.setPathData(true, 0);
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.data = data;
	            this.frameId = -1;
	            this.d = data.d;
	            this.dynamicProperties = [];
	            this.mdf = false;
	            this.getValue = processKeys;
	            this.reset = resetShape;
	            if(data.sy === 1){
	                this.ir = PropertyFactory.getProp(elem,data.ir,0,0,this.dynamicProperties);
	                this.is = PropertyFactory.getProp(elem,data.is,0,0.01,this.dynamicProperties);
	                this.convertToPath = convertStarToPath;
	            } else {
	                this.convertToPath = convertPolygonToPath;
	            }
	            this.pt = PropertyFactory.getProp(elem,data.pt,0,0,this.dynamicProperties);
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
	            this.r = PropertyFactory.getProp(elem,data.r,0,degToRads,this.dynamicProperties);
	            this.or = PropertyFactory.getProp(elem,data.or,0,0,this.dynamicProperties);
	            this.os = PropertyFactory.getProp(elem,data.os,0,0.01,this.dynamicProperties);
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.localShapeCollection.addShape(this.v);
	            this.paths = this.localShapeCollection;
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.convertToPath();
	            }
	        }
	    }());
	
	    var RectShapeProperty = (function() {
	        function processKeys(frameNum){
	            if(this.elem.globalData.frameId === this.frameId){
	                return;
	            }
	            this.mdf = false;
	            this.frameId = this.elem.globalData.frameId;
	            var i, len = this.dynamicProperties.length;
	
	            for(i=0;i<len;i+=1){
	                this.dynamicProperties[i].getValue(frameNum);
	                if(this.dynamicProperties[i].mdf){
	                    this.mdf = true;
	                }
	            }
	            if(this.mdf){
	                this.convertRectToPath();
	            }
	
	        }
	
	        function convertRectToPath(){
	            var p0 = this.p.v[0], p1 = this.p.v[1], v0 = this.s.v[0]/2, v1 = this.s.v[1]/2;
	            var round = bm_min(v0,v1,this.r.v);
	            var cPoint = round*(1-roundCorner);
	            this.v._length = 0;
	
	            if(this.d === 2 || this.d === 1) {
	                this.v.setTripleAt(p0+v0, p1-v1+round,p0+v0, p1-v1+round,p0+v0,p1-v1+cPoint,0, true);
	                this.v.setTripleAt(p0+v0, p1+v1-round,p0+v0, p1+v1-cPoint,p0+v0, p1+v1-round,1, true);
	                if(round!== 0){
	                    this.v.setTripleAt(p0+v0-round, p1+v1,p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,2, true);
	                    this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,p0-v0+round,p1+v1,3, true);
	                    this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,4, true);
	                    this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,p0-v0,p1-v1+round,5, true);
	                    this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,6, true);
	                    this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,p0+v0-round,p1-v1,7, true);
	                } else {
	                    this.v.setTripleAt(p0-v0,p1+v1,p0-v0+cPoint,p1+v1,p0-v0,p1+v1,2);
	                    this.v.setTripleAt(p0-v0,p1-v1,p0-v0,p1-v1+cPoint,p0-v0,p1-v1,3);
	                }
	            }else{
	                this.v.setTripleAt(p0+v0,p1-v1+round,p0+v0,p1-v1+cPoint,p0+v0,p1-v1+round,0, true);
	                if(round!== 0){
	                    this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,1, true);
	                    this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,p0-v0+round,p1-v1,2, true);
	                    this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,3, true);
	                    this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,p0-v0,p1+v1-round,4, true);
	                    this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,5, true);
	                    this.v.setTripleAt(p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,p0+v0-round,p1+v1,6, true);
	                    this.v.setTripleAt(p0+v0,p1+v1-round,p0+v0,p1+v1-round,p0+v0,p1+v1-cPoint,7, true);
	                } else {
	                    this.v.setTripleAt(p0-v0,p1-v1,p0-v0+cPoint,p1-v1,p0-v0,p1-v1,1, true);
	                    this.v.setTripleAt(p0-v0,p1+v1,p0-v0,p1+v1-cPoint,p0-v0,p1+v1,2, true);
	                    this.v.setTripleAt(p0+v0,p1+v1,p0+v0-cPoint,p1+v1,p0+v0,p1+v1,3, true);
	
	                }
	            }
	        }
	
	        return function RectShapeProperty(elem,data) {
	            this.v = shape_pool.newShape();
	            this.v.c = true;
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.localShapeCollection.addShape(this.v);
	            this.paths = this.localShapeCollection;
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.frameId = -1;
	            this.d = data.d;
	            this.dynamicProperties = [];
	            this.mdf = false;
	            this.getValue = processKeys;
	            this.convertRectToPath = convertRectToPath;
	            this.reset = resetShape;
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
	            this.s = PropertyFactory.getProp(elem,data.s,1,0,this.dynamicProperties);
	            this.r = PropertyFactory.getProp(elem,data.r,0,0,this.dynamicProperties);
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.convertRectToPath();
	            }
	        }
	    }());
	
	    function getShapeProp(elem,data,type, arr){
	        var prop;
	        if(type === 3 || type === 4){
	            var dataProp = type === 3 ? data.pt : data.ks;
	            var keys = dataProp.k;
	            if(dataProp.a === 1 || keys.length){
	                prop = new KeyframedShapeProperty(elem, data, type);
	            }else{
	                prop = new ShapeProperty(elem, data, type);
	            }
	        }else if(type === 5){
	            prop = new RectShapeProperty(elem, data);
	        }else if(type === 6){
	            prop = new EllShapeProperty(elem, data);
	        }else if(type === 7){
	            prop = new StarShapeProperty(elem, data);
	        }
	        if(prop.k){
	            arr.push(prop);
	        }
	        return prop;
	    }
	
	    var ob = {};
	    ob.getShapeProp = getShapeProp;
	    return ob;
	}());
	var ShapeModifiers = (function(){
	    var ob = {};
	    var modifiers = {};
	    ob.registerModifier = registerModifier;
	    ob.getModifier = getModifier;
	
	    function registerModifier(nm,factory){
	        if(!modifiers[nm]){
	            modifiers[nm] = factory;
	        }
	    }
	
	    function getModifier(nm,elem, data, dynamicProperties){
	        return new modifiers[nm](elem, data, dynamicProperties);
	    }
	
	    return ob;
	}());
	
	function ShapeModifier(){}
	ShapeModifier.prototype.initModifierProperties = function(){};
	ShapeModifier.prototype.addShapeToModifier = function(){};
	ShapeModifier.prototype.addShape = function(data){
	    if(!this.closed){
	        this.shapes.push({shape:data.sh, data: data, localShapeCollection:shapeCollection_pool.newShapeCollection()});
	        this.addShapeToModifier(data.sh);
	    }
	}
	ShapeModifier.prototype.init = function(elem,data,dynamicProperties){
	    this.elem = elem;
	    this.frameId = -1;
	    this.shapes = [];
	    this.dynamicProperties = [];
	    this.mdf = false;
	    this.closed = false;
	    this.k = false;
	    this.comp = elem.comp;
	    this.initModifierProperties(elem,data);
	    if(this.dynamicProperties.length){
	        this.k = true;
	        dynamicProperties.push(this);
	    }else{
	        this.getValue(true);
	    }
	}
	function TrimModifier(){};
	extendPrototype(ShapeModifier,TrimModifier);
	TrimModifier.prototype.processKeys = function(forceRender){
	    if(this.elem.globalData.frameId === this.frameId && !forceRender){
	        return;
	    }
	    this.mdf = forceRender ? true : false;
	    this.frameId = this.elem.globalData.frameId;
	    var i, len = this.dynamicProperties.length;
	
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	        if(this.dynamicProperties[i].mdf){
	            this.mdf = true;
	        }
	    }
	    if(this.mdf || forceRender){
	        var o = (this.o.v%360)/360;
	        if(o < 0){
	            o += 1;
	        }
	        var s = this.s.v + o;
	        var e = this.e.v + o;
	        if(s == e){
	
	        }
	        if(s>e){
	            var _s = s;
	            s = e;
	            e = _s;
	        }
	        this.sValue = s;
	        this.eValue = e;
	        this.oValue = o;
	    }
	}
	TrimModifier.prototype.initModifierProperties = function(elem,data){
	    this.sValue = 0;
	    this.eValue = 0;
	    this.oValue = 0;
	    this.getValue = this.processKeys;
	    this.s = PropertyFactory.getProp(elem,data.s,0,0.01,this.dynamicProperties);
	    this.e = PropertyFactory.getProp(elem,data.e,0,0.01,this.dynamicProperties);
	    this.o = PropertyFactory.getProp(elem,data.o,0,0,this.dynamicProperties);
	    this.m = data.m;
	    if(!this.dynamicProperties.length){
	        this.getValue(true);
	    }
	};
	
	TrimModifier.prototype.getSegmentsLength = function(shapeData){
	    var closed = shapeData.c;
	    var pathV = shapeData.v;
	    var pathO = shapeData.o;
	    var pathI = shapeData.i;
	    var i, len = shapeData._length;
	    var lengths = [];
	    var totalLength = 0;
	    for(i=0;i<len-1;i+=1){
	        lengths[i] = bez.getBezierLength(pathV[i],pathV[i+1],pathO[i],pathI[i+1]);
	        totalLength += lengths[i].addedLength;
	    }
	    if(closed){
	        lengths[i] = bez.getBezierLength(pathV[i],pathV[0],pathO[i],pathI[0]);
	        totalLength += lengths[i].addedLength;
	    }
	    return {lengths:lengths,totalLength:totalLength};
	}
	
	TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
	    var segments = []
	    if(e <= 1){
	        segments.push({
	            s: s,
	            e: e
	        })
	    }else if(s >= 1){
	        segments.push({
	            s: s - 1,
	            e: e - 1
	        })
	    }else{
	        segments.push({
	            s: s,
	            e: 1
	        })
	        segments.push({
	            s: 0,
	            e: e - 1
	        })
	    }
	    var shapeSegments = [];
	    var i, len = segments.length, segmentOb;
	    for(i = 0; i < len; i += 1) {
	        segmentOb = segments[i];
	        if (segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength) {
	            
	        } else {
	            var shapeS, shapeE;
	            if(segmentOb.s * totalModifierLength <= addedLength) {
	                shapeS = 0;
	            } else {
	                shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
	            }
	            if(segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
	                shapeE = 1;
	            } else {
	                shapeE = ((segmentOb.e * totalModifierLength - addedLength) / shapeLength);
	            }
	            shapeSegments.push([shapeS, shapeE]);
	        }
	    }
	    if(!shapeSegments.length){
	        shapeSegments.push([0,0]);
	    }
	    return shapeSegments;
	}
	
	TrimModifier.prototype.processShapes = function(firstFrame){
	    var shapePaths;
	    var i, len = this.shapes.length;
	    var j, jLen;
	    var s = this.sValue;
	    var e = this.eValue;
	    var pathsData,pathData, totalShapeLength, totalModifierLength = 0;
	
	    if(e === s){
	        for(i=0;i<len;i+=1){
	            this.shapes[i].localShapeCollection.releaseShapes();
	            this.shapes[i].shape.mdf = true;
	            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
	        }
	    } else if(!((e === 1 && s === 0) || (e===0 && s === 1))){
	        var segments = [], shapeData, localShapeCollection;
	        for(i=0;i<len;i+=1){
	            shapeData = this.shapes[i];
	            if(!shapeData.shape.mdf && !this.mdf && !firstFrame && this.m !== 2){
	                shapeData.shape.paths = shapeData.localShapeCollection;
	            } else {
	                shapePaths = shapeData.shape.paths;
	                jLen = shapePaths._length;
	                totalShapeLength = 0;
	                if(!shapeData.shape.mdf && shapeData.pathsData){
	                    totalShapeLength = shapeData.totalShapeLength;
	                } else {
	                    pathsData = [];
	                    for(j=0;j<jLen;j+=1){
	                        pathData = this.getSegmentsLength(shapePaths.shapes[j]);
	                        pathsData.push(pathData);
	                        totalShapeLength += pathData.totalLength;
	                    }
	                    shapeData.totalShapeLength = totalShapeLength;
	                    shapeData.pathsData = pathsData;
	                }
	
	                totalModifierLength += totalShapeLength;
	                shapeData.shape.mdf = true;
	            }
	        }
	        var shapeS = s, shapeE = e, addedLength = 0;
	        var j, jLen;
	        for(i = len - 1; i >= 0; i -= 1){
	            shapeData = this.shapes[i];
	            if (shapeData.shape.mdf) {
	                localShapeCollection = shapeData.localShapeCollection;
	                localShapeCollection.releaseShapes();
	                if(this.m === 2 && len > 1) {
	                    var edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
	                    addedLength += shapeData.totalShapeLength;
	                } else {
	                    edges = [[shapeS, shapeE]]
	                }
	                jLen = edges.length;
	                for (j = 0; j < jLen; j += 1) {
	                    shapeS = edges[j][0];
	                    shapeE = edges[j][1];
	                    segments.length = 0;
	                    if(shapeE <= 1){
	                        segments.push({
	                            s:shapeData.totalShapeLength * shapeS,
	                            e:shapeData.totalShapeLength * shapeE
	                        })
	                    }else if(shapeS >= 1){
	                        segments.push({
	                            s:shapeData.totalShapeLength * (shapeS - 1),
	                            e:shapeData.totalShapeLength * (shapeE - 1)
	                        })
	                    }else{
	                        segments.push({
	                            s:shapeData.totalShapeLength * shapeS,
	                            e:shapeData.totalShapeLength
	                        })
	                        segments.push({
	                            s:0,
	                            e:shapeData.totalShapeLength*(shapeE - 1)
	                        })
	                    }
	                    var newShapesData = this.addShapes(shapeData,segments[0]);
	                    if (segments[0].s !== segments[0].e) {
	                        var lastPos;
	                        if(segments.length > 1){
	                            if(shapeData.shape.v.c){
	                                var lastShape = newShapesData.pop();
	                                this.addPaths(newShapesData, localShapeCollection);
	                                newShapesData = this.addShapes(shapeData,segments[1], lastShape);
	                            } else {
	                                this.addPaths(newShapesData, localShapeCollection);
	                                newShapesData = this.addShapes(shapeData,segments[1]);
	                            }
	                        } 
	                        this.addPaths(newShapesData, localShapeCollection);
	                    }
	                    
	                }
	                shapeData.shape.paths = localShapeCollection;
	            }
	        }
	    } else if(this.mdf){
	        for(i=0;i<len;i+=1){
	            this.shapes[i].shape.mdf = true;
	        }
	    }
	    if(!this.dynamicProperties.length){
	        this.mdf = false;
	    }
	}
	
	TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
	    var i, len = newPaths.length;
	    for(i = 0; i < len; i += 1) {
	        localShapeCollection.addShape(newPaths[i])
	    }
	}
	
	TrimModifier.prototype.addSegment = function(pt1,pt2,pt3,pt4,shapePath,pos, newShape) {
	    /*console.log(pt1, 'vertex: v, at: ', pos);
	    console.log(pt2, 'vertex: o, at: ', pos);
	    console.log(pt3, 'vertex: i, at: ', pos + 1);
	    console.log(pt4, 'vertex: v, at: ', pos + 1);
	    console.log('newShape: ', newShape);*/
	    shapePath.setXYAt(pt2[0],pt2[1],'o',pos);
	    shapePath.setXYAt(pt3[0],pt3[1],'i',pos + 1);
	    if(newShape){
	        shapePath.setXYAt(pt1[0],pt1[1],'v',pos);
	    }
	    shapePath.setXYAt(pt4[0],pt4[1],'v',pos + 1);
	}
	
	TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath){
	    var pathsData = shapeData.pathsData;
	    var shapePaths = shapeData.shape.paths.shapes;
	    var i, len = shapeData.shape.paths._length, j, jLen;
	    var addedLength = 0;
	    var currentLengthData,segmentCount;
	    var lengths;
	    var segment;
	    var shapes = [];
	    var initPos;
	    var newShape = true;
	    if(!shapePath){
	        shapePath = shape_pool.newShape();
	        segmentCount = 0;
	        initPos = 0;
	    } else {
	        segmentCount = shapePath._length;
	        initPos = shapePath._length;
	    }
	    shapes.push(shapePath);
	    for(i=0;i<len;i+=1){
	        lengths = pathsData[i].lengths;
	        shapePath.c = shapePaths[i].c;
	        jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
	        for(j=1;j<jLen;j+=1){
	            currentLengthData = lengths[j-1];
	            if(addedLength + currentLengthData.addedLength < shapeSegment.s){
	                addedLength += currentLengthData.addedLength;
	                shapePath.c = false;
	            } else if(addedLength > shapeSegment.e){
	                shapePath.c = false;
	                break;
	            } else {
	                if(shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength){
	                    this.addSegment(shapePaths[i].v[j-1],shapePaths[i].o[j-1],shapePaths[i].i[j],shapePaths[i].v[j],shapePath,segmentCount,newShape);
	                    newShape = false;
	                } else {
	                    segment = bez.getNewSegment(shapePaths[i].v[j-1],shapePaths[i].v[j],shapePaths[i].o[j-1],shapePaths[i].i[j], (shapeSegment.s - addedLength)/currentLengthData.addedLength,(shapeSegment.e - addedLength)/currentLengthData.addedLength, lengths[j-1]);
	                    this.addSegment(segment.pt1,segment.pt3,segment.pt4,segment.pt2,shapePath,segmentCount,newShape);
	                    newShape = false;
	                    shapePath.c = false;
	                }
	                addedLength += currentLengthData.addedLength;
	                segmentCount += 1;
	            }
	        }
	        if(shapePaths[i].c){
	            currentLengthData = lengths[j-1];
	            if(addedLength <= shapeSegment.e){
	                var segmentLength = lengths[j-1].addedLength;
	                if(shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength){
	                    this.addSegment(shapePaths[i].v[j-1],shapePaths[i].o[j-1],shapePaths[i].i[0],shapePaths[i].v[0],shapePath,segmentCount,newShape);
	                    newShape = false;
	                }else{
	                    segment = bez.getNewSegment(shapePaths[i].v[j-1],shapePaths[i].v[0],shapePaths[i].o[j-1],shapePaths[i].i[0], (shapeSegment.s - addedLength)/segmentLength,(shapeSegment.e - addedLength)/segmentLength, lengths[j-1]);
	                    this.addSegment(segment.pt1,segment.pt3,segment.pt4,segment.pt2,shapePath,segmentCount,newShape);
	                    newShape = false;
	                    shapePath.c = false;
	                }
	            } else {
	                shapePath.c = false;
	            }
	            addedLength += currentLengthData.addedLength;
	            segmentCount += 1;
	        }
	        if(shapePath._length){
	            shapePath.setXYAt(shapePath.v[initPos][0],shapePath.v[initPos][1],'i',initPos);
	            shapePath.setXYAt(shapePath.v[shapePath._length - 1][0],shapePath.v[shapePath._length - 1][1],'o',shapePath._length - 1);
	        }
	        if(addedLength > shapeSegment.e){
	            break;
	        }
	        if(i<len-1){
	            shapePath = shape_pool.newShape();
	            newShape = true;
	            shapes.push(shapePath);
	            segmentCount = 0;
	        }
	    }
	    return shapes;
	
	}
	
	
	ShapeModifiers.registerModifier('tm',TrimModifier);
	function RoundCornersModifier(){};
	extendPrototype(ShapeModifier,RoundCornersModifier);
	RoundCornersModifier.prototype.processKeys = function(forceRender){
	    if(this.elem.globalData.frameId === this.frameId && !forceRender){
	        return;
	    }
	    this.mdf = forceRender ? true : false;
	    this.frameId = this.elem.globalData.frameId;
	    var i, len = this.dynamicProperties.length;
	
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	        if(this.dynamicProperties[i].mdf){
	            this.mdf = true;
	        }
	    }
	}
	RoundCornersModifier.prototype.initModifierProperties = function(elem,data){
	    this.getValue = this.processKeys;
	    this.rd = PropertyFactory.getProp(elem,data.r,0,null,this.dynamicProperties);
	    if(!this.dynamicProperties.length){
	        this.getValue(true);
	    }
	};
	
	RoundCornersModifier.prototype.processPath = function(path, round){
	    var cloned_path = shape_pool.newShape();
	    cloned_path.c = path.c;
	    var i, len = path._length;
	    var currentV,currentI,currentO,closerV, newV,newO,newI,distance,newPosPerc,index = 0;
	    var vX,vY,oX,oY,iX,iY;
	    for(i=0;i<len;i+=1){
	        currentV = path.v[i];
	        currentO = path.o[i];
	        currentI = path.i[i];
	        if(currentV[0]===currentO[0] && currentV[1]===currentO[1] && currentV[0]===currentI[0] && currentV[1]===currentI[1]){
	            if((i===0 || i === len - 1) && !path.c){
	                cloned_path.setTripleAt(currentV[0],currentV[1],currentO[0],currentO[1],currentI[0],currentI[1],index);
	                /*cloned_path.v[index] = currentV;
	                cloned_path.o[index] = currentO;
	                cloned_path.i[index] = currentI;*/
	                index += 1;
	            } else {
	                if(i===0){
	                    closerV = path.v[len-1];
	                } else {
	                    closerV = path.v[i-1];
	                }
	                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
	                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
	                vX = iX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
	                vY = iY = currentV[1]-(currentV[1]-closerV[1])*newPosPerc;
	                oX = vX-(vX-currentV[0])*roundCorner;
	                oY = vY-(vY-currentV[1])*roundCorner;
	                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
	                /*newV = [currentV[0]+(closerV[0]-currentV[0])*newPosPerc,currentV[1]-(currentV[1]-closerV[1])*newPosPerc];
	                newI = newV;
	                newO = [newV[0]-(newV[0]-currentV[0])*roundCorner,newV[1]-(newV[1]-currentV[1])*roundCorner];
	                cloned_path.v[index] = newV;
	                cloned_path.i[index] = newI;
	                cloned_path.o[index] = newO;*/
	                index += 1;
	
	                if(i === len - 1){
	                    closerV = path.v[0];
	                } else {
	                    closerV = path.v[i+1];
	                }
	                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
	                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
	                vX = oX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
	                vY = oY = currentV[1]+(closerV[1]-currentV[1])*newPosPerc;
	                iX = vX-(vX-currentV[0])*roundCorner;
	                iY = vY-(vY-currentV[1])*roundCorner;
	                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
	
	                /*newV = [currentV[0]+(closerV[0]-currentV[0])*newPosPerc,currentV[1]+(closerV[1]-currentV[1])*newPosPerc];
	                newI = [newV[0]-(newV[0]-currentV[0])*roundCorner,newV[1]-(newV[1]-currentV[1])*roundCorner];
	                newO = newV;
	                cloned_path.v[index] = newV;
	                cloned_path.i[index] = newI;
	                cloned_path.o[index] = newO;*/
	                index += 1;
	            }
	        } else {
	            /*cloned_path.v[index] = path.v[i];
	            cloned_path.o[index] = path.o[i];
	            cloned_path.i[index] = path.i[i];*/
	            cloned_path.setTripleAt(path.v[i][0],path.v[i][1],path.o[i][0],path.o[i][1],path.i[i][0],path.i[i][1],index);
	            index += 1;
	        }
	    }
	    return cloned_path;
	}
	
	RoundCornersModifier.prototype.processShapes = function(firstFrame){
	    var shapePaths;
	    var i, len = this.shapes.length;
	    var j, jLen;
	    var rd = this.rd.v;
	
	    if(rd !== 0){
	        var shapeData, newPaths, localShapeCollection;
	        for(i=0;i<len;i+=1){
	            shapeData = this.shapes[i];
	            newPaths = shapeData.shape.paths;
	            localShapeCollection = shapeData.localShapeCollection;
	            if(!(!shapeData.shape.mdf && !this.mdf && !firstFrame)){
	                localShapeCollection.releaseShapes();
	                shapeData.shape.mdf = true;
	                shapePaths = shapeData.shape.paths.shapes;
	                jLen = shapeData.shape.paths._length;
	                for(j=0;j<jLen;j+=1){
	                    localShapeCollection.addShape(this.processPath(shapePaths[j],rd));
	                }
	            }
	            shapeData.shape.paths = shapeData.localShapeCollection;
	        }
	
	    }
	    if(!this.dynamicProperties.length){
	        this.mdf = false;
	    }
	}
	
	
	ShapeModifiers.registerModifier('rd',RoundCornersModifier);
	function RepeaterModifier(){};
	RepeaterModifier.prototype.processKeys = function(forceRender){
	    if(this.elem.globalData.frameId === this.frameId && !forceRender){
	        return;
	    }
	    this.mdf = forceRender ? true : false;
	    var i, len = this.dynamicProperties.length;
	
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	        if(this.dynamicProperties[i].mdf){
	            this.mdf = true;
	        }
	    }
	};
	
	RepeaterModifier.prototype.initModifierProperties = function(elem,data){
	    this.getValue = this.processKeys;
	    this.c = PropertyFactory.getProp(elem,data.c,0,null,this.dynamicProperties);
	    this.o = PropertyFactory.getProp(elem,data.o,0,null,this.dynamicProperties);
	    this.tr = PropertyFactory.getProp(elem,data.tr,2,null,this.dynamicProperties);
	    this.data = data;
	    if(!this.dynamicProperties.length){
	        this.getValue(true);
	    }
	    this.pMatrix = new Matrix();
	    this.rMatrix = new Matrix();
	    this.sMatrix = new Matrix();
	    this.tMatrix = new Matrix();
	    this.matrix = new Matrix();
	};
	
	RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv){
	    var dir = inv ? -1 : 1;
	    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
	    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
	    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
	    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    rMatrix.rotate(-transform.r.v * dir * perc);
	    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    sMatrix.scale(inv ? 1/scaleX : scaleX, inv ? 1/scaleY : scaleY);
	    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	}
	
	RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData, dynamicProperties) {
	    this.elem = elem;
	    this.arr = arr;
	    this.pos = pos;
	    this.elemsData = elemsData;
	    this._currentCopies = 0;
	    this._elements = [];
	    this._groups = [];
	    this.dynamicProperties = [];
	    this.frameId = -1;
	    this.initModifierProperties(elem,arr[pos]);
	    var cont = 0;
	    while(pos>0){
	        pos -= 1;
	        //this._elements.unshift(arr.splice(pos,1)[0]);
	        this._elements.unshift(arr[pos]);
	        cont += 1;
	    }
	    if(this.dynamicProperties.length){
	        this.k = true;
	        dynamicProperties.push(this);
	    }else{
	        this.getValue(true);
	    }
	}
	
	RepeaterModifier.prototype.resetElements = function(elements){
	    var i, len = elements.length;
	    for(i = 0; i < len; i += 1) {
	        elements[i]._processed = false;
	        if(elements[i].ty === 'gr'){
	            this.resetElements(elements[i].it);
	        }
	    }
	}
	
	RepeaterModifier.prototype.cloneElements = function(elements){
	    var i, len = elements.length;
	    var newElements = JSON.parse(JSON.stringify(elements));
	    this.resetElements(newElements);
	    return newElements;
	}
	
	RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
	    var i, len = elements.length;
	    for(i = 0; i < len ; i += 1) {
	        elements[i]._render = renderFlag;
	        if(elements[i].ty === 'gr') {
	            this.changeGroupRender(elements[i].it, renderFlag);
	        }
	    }
	}
	
	RepeaterModifier.prototype.processShapes = function(firstFrame){
	
	    if(this.elem.globalData.frameId === this.frameId){
	        return;
	    }
	    this.frameId = this.elem.globalData.frameId;
	    if(!this.dynamicProperties.length && !firstFrame){
	        this.mdf = false;
	    }
	    if(this.mdf){
	        var copies = Math.ceil(this.c.v);
	        if(this._groups.length < copies){
	            while(this._groups.length < copies){
	                var group = {
	                    it:this.cloneElements(this._elements),
	                    ty:'gr'
	                }
	                group.it.push({"a":{"a":0,"ix":1,"k":[0,0]},"nm":"Transform","o":{"a":0,"ix":7,"k":100},"p":{"a":0,"ix":2,"k":[0,0]},"r":{"a":0,"ix":6,"k":0},"s":{"a":0,"ix":3,"k":[100,100]},"sa":{"a":0,"ix":5,"k":0},"sk":{"a":0,"ix":4,"k":0},"ty":"tr"});
	                
	                this.arr.splice(0,0,group);
	                this._groups.splice(0,0,group);
	                this._currentCopies += 1;
	            }
	            this.elem.reloadShapes();
	        }
	        var i, cont = 0, renderFlag;
	        for(i = 0; i  <= this._groups.length - 1; i += 1){
	            renderFlag = cont < copies;
	            this._groups[i]._render = renderFlag;
	            this.changeGroupRender(this._groups[i].it, renderFlag);
	            cont += 1;
	        }
	        
	        this._currentCopies = copies;
	        this.elem.firstFrame = true;
	        ////
	
	        var offset = this.o.v;
	        var offsetModulo = offset%1;
	        var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
	        var k;
	        var tMat = this.tr.v.props;
	        var pProps = this.pMatrix.props;
	        var rProps = this.rMatrix.props;
	        var sProps = this.sMatrix.props;
	        this.pMatrix.reset();
	        this.rMatrix.reset();
	        this.sMatrix.reset();
	        this.tMatrix.reset();
	        this.matrix.reset();
	        var iteration = 0;
	
	        if(offset > 0) {
	            while(iteration<roundOffset){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	                iteration += 1;
	            }
	            if(offsetModulo){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
	                iteration += offsetModulo;
	            }
	        } else if(offset < 0) {
	            while(iteration>roundOffset){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
	                iteration -= 1;
	            }
	            if(offsetModulo){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, - offsetModulo, true);
	                iteration -= offsetModulo;
	            }
	        }
	        i = this.data.m === 1 ? 0 : this._currentCopies - 1;
	        var dir = this.data.m === 1 ? 1 : -1;
	        cont = this._currentCopies;
	        while(cont){
	            if(iteration !== 0){
	                if((i !== 0 && dir === 1) || (i !== this._currentCopies - 1 && dir === -1)){
	                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	                }
	                this.matrix.transform(rProps[0],rProps[1],rProps[2],rProps[3],rProps[4],rProps[5],rProps[6],rProps[7],rProps[8],rProps[9],rProps[10],rProps[11],rProps[12],rProps[13],rProps[14],rProps[15]);
	                this.matrix.transform(sProps[0],sProps[1],sProps[2],sProps[3],sProps[4],sProps[5],sProps[6],sProps[7],sProps[8],sProps[9],sProps[10],sProps[11],sProps[12],sProps[13],sProps[14],sProps[15]);
	                this.matrix.transform(pProps[0],pProps[1],pProps[2],pProps[3],pProps[4],pProps[5],pProps[6],pProps[7],pProps[8],pProps[9],pProps[10],pProps[11],pProps[12],pProps[13],pProps[14],pProps[15]);
	                var items = this.elemsData[i].it;
	                var itemsTransform = items[items.length - 1].transform.mProps.v.props;
	                var j, jLen = itemsTransform.length;
	                for(j=0;j<jLen;j+=1) {
	                    itemsTransform[j] = this.matrix.props[j];
	                }
	                this.matrix.reset();
	            } else {
	                this.matrix.reset();
	                var items = this.elemsData[i].it;
	                var itemsTransform = items[items.length - 1].transform.mProps.v.props;
	                var j, jLen = itemsTransform.length;
	                for(j=0;j<jLen;j+=1) {
	                    itemsTransform[j] = this.matrix.props[j];
	                }
	            }
	            iteration += 1;
	            cont -= 1;
	            i += dir;
	        }
	    }
	}
	
	RepeaterModifier.prototype.addShape = function(){}
	
	ShapeModifiers.registerModifier('rp',RepeaterModifier);
	function ShapeCollection(){
		this._length = 0;
		this._maxLength = 4;
		this.shapes = Array.apply(null,{length:this._maxLength});
	};
	
	ShapeCollection.prototype.addShape = function(shapeData){
		if(this._length === this._maxLength){
			this.shapes = this.shapes.concat(Array.apply(null,{length:this._maxLength}));
			this._maxLength *= 2;
		}
		this.shapes[this._length] = shapeData;
		this._length += 1;
	};
	
	ShapeCollection.prototype.releaseShapes = function(){
		var i;
		for(i = 0; i < this._length; i += 1) {
			shape_pool.release(this.shapes[i]);
		}
		this._length = 0;
	};
	var ImagePreloader = (function(){
	
	    function imageLoaded(){
	        this.loadedAssets += 1;
	        if(this.loadedAssets === this.totalImages){
	        }
	    }
	
	    function getAssetsPath(assetData){
	        var path = '';
	        if(this.assetsPath){
	            var imagePath = assetData.p;
	            if(imagePath.indexOf('images/') !== -1){
	                imagePath = imagePath.split('/')[1];
	            }
	            path = this.assetsPath + imagePath;
	        } else {
	            path = this.path;
	            path += assetData.u ? assetData.u : '';
	            path += assetData.p;
	        }
	        return path;
	    }
	
	    function loadImage(path){
	        var img = document.createElement('img');
	        img.addEventListener('load', imageLoaded.bind(this), false);
	        img.addEventListener('error', imageLoaded.bind(this), false);
	        img.src = path;
	    }
	    function loadAssets(assets){
	        this.totalAssets = assets.length;
	        var i;
	        for(i=0;i<this.totalAssets;i+=1){
	            if(!assets[i].layers){
	                loadImage.bind(this)(getAssetsPath.bind(this)(assets[i]));
	                this.totalImages += 1;
	            }
	        }
	    }
	
	    function setPath(path){
	        this.path = path || '';
	    }
	
	    function setAssetsPath(path){
	        this.assetsPath = path || '';
	    }
	
	    return function ImagePreloader(){
	        this.loadAssets = loadAssets;
	        this.setAssetsPath = setAssetsPath;
	        this.setPath = setPath;
	        this.assetsPath = '';
	        this.path = '';
	        this.totalAssets = 0;
	        this.totalImages = 0;
	        this.loadedAssets = 0;
	    }
	}());
	var featureSupport = (function(){
		var ob = {
			maskType: true
		}
		if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
		   ob.maskType = false;
		}
		return ob;
	}());
	var filtersFactory = (function(){
		var ob = {};
		ob.createFilter = createFilter;
		ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
	
		function createFilter(filId){
	        	var fil = document.createElementNS(svgNS,'filter');
	        	fil.setAttribute('id',filId);
	                fil.setAttribute('filterUnits','objectBoundingBox');
	                fil.setAttribute('x','0%');
	                fil.setAttribute('y','0%');
	                fil.setAttribute('width','100%');
	                fil.setAttribute('height','100%');
	                return fil;
		}
	
		function createAlphaToLuminanceFilter(){
	                var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
	                feColorMatrix.setAttribute('type','matrix');
	                feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	                feColorMatrix.setAttribute('values','0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
	                return feColorMatrix;
		}
	
		return ob;
	}())
	var pooling = (function(){
	
		function double(arr){
			return arr.concat(Array.apply(null,{length:arr.length}))
		}
	
		return {
			double: double
		}
	}());
	var point_pool = (function(){
		var ob = {
			newPoint: newPoint,
			release: release
			/*,getLength:function(){return _length}
			,getCont:function(){return cont}*/
		}
	
		var _length = 0;
		var _maxLength = 8;
		var pool = Array.apply(null,{length:_maxLength});
	
		//var cont = 0;
	
		function newPoint(){
			//window.bm_newPoint = window.bm_newPoint ? window.bm_newPoint + 1 : 1;
			var point;
			if(_length){
				_length -= 1;
				point = pool[_length];
				//window.bm_reuse = window.bm_reuse ? window.bm_reuse + 1 : 1;
			} else {
				point = [0.1,0.1];
				//cont++;
				//console.log('new');
				//window.bm_new = window.bm_new ? window.bm_new + 1 : 1;
				//point._tst = cont++;
			}
			return point;
		}
	
		function release(point) {
			if(_length === _maxLength) {
				pool = pooling.double(pool);
				_maxLength = _maxLength*2;
			}
			pool[_length] = point;
			_length += 1;
			//window.bm_release = window.bm_release ? window.bm_release + 1 : 1;
			//console.log('release');
		}
	
	
		return ob;
	}());
	var shape_pool = (function(){
		var ob = {
			clone: clone,
			newShape: newShape,
			release: release,
			releaseArray: releaseArray
		}
	
		var _length = 0;
		var _maxLength = 4;
		var pool = Array.apply(null,{length:_maxLength});
	
		function newShape(){
			var shapePath;
			if(_length){
				_length -= 1;
				shapePath = pool[_length];
			} else {
				shapePath = new ShapePath();
			}
			return shapePath;
		}
	
		function release(shapePath) {
			if(_length === _maxLength) {
				pool = pooling.double(pool);
				_maxLength = _maxLength*2;
			}
			var len = shapePath._length, i;
			for(i = 0; i < len; i += 1) {
				point_pool.release(shapePath.v[i]);
				point_pool.release(shapePath.i[i]);
				point_pool.release(shapePath.o[i]);
				shapePath.v[i] = null;
				shapePath.i[i] = null;
				shapePath.o[i] = null;
			}
			shapePath._length = 0;
			shapePath.c = false;
			pool[_length] = shapePath;
			_length += 1;
		}
	
		function releaseArray(shapePathsCollection, length) {
			while(length--) {
				release(shapePathsCollection[length]);
			}
		}
	
		function clone(shape, transform) {
			var i, len = shape._length;
			var cloned = newShape();
			cloned._length = shape._length;
			cloned.c = shape.c;
	
			var pt;
			
			for(i = 0; i < len; i += 1) {
				if(transform){
					pt = transform.applyToPointArray(shape.v[i][0],shape.v[i][1],0,2);
					cloned.setXYAt(pt[0],pt[1],'v',i);
					point_pool.release(pt);
					pt = transform.applyToPointArray(shape.o[i][0],shape.o[i][1],0,2);
					cloned.setXYAt(pt[0],pt[1],'o',i);
					point_pool.release(pt);
					pt = transform.applyToPointArray(shape.i[i][0],shape.i[i][1],0,2);
					cloned.setXYAt(pt[0],pt[1],'i',i);
					point_pool.release(pt);
				}else{
					cloned.setTripleAt(shape.v[i][0],shape.v[i][1],shape.o[i][0],shape.o[i][1],shape.i[i][0],shape.i[i][1], i);
				}
			}
			return cloned
		}
	
	
		return ob;
	}());
	var shapeCollection_pool = (function(){
		var ob = {
			newShapeCollection: newShapeCollection,
			release: release,
			clone: clone
		}
	
		var _length = 0;
		var _maxLength = 4;
		var pool = Array.apply(null,{length:_maxLength});
	
		var cont = 0;
	
		function newShapeCollection(){
			var shapeCollection;
			if(_length){
				_length -= 1;
				shapeCollection = pool[_length];
			} else {
				shapeCollection = new ShapeCollection();
			}
			return shapeCollection;
		}
	
		function release(shapeCollection) {
			var i, len = shapeCollection._length;
			for(i = 0; i < len; i += 1) {
				shape_pool.release(shapeCollection.shapes[i]);
			}
			shapeCollection._length = 0;
	
			if(_length === _maxLength) {
				pool = pooling.double(pool);
				_maxLength = _maxLength*2;
			}
			pool[_length] = shapeCollection;
			_length += 1;
		}
	
		function clone(shapeCollection, originCollection) {
			release(shapeCollection);
			if(_length === _maxLength) {
				pool = pooling.double(pool);
				_maxLength = _maxLength*2;
			}
			pool[_length] = shapeCollection;
			_length += 1;
		}
	
	
		return ob;
	}());
	function BaseRenderer(){}
	BaseRenderer.prototype.checkLayers = function(num){
	    var i, len = this.layers.length, data;
	    this.completeLayers = true;
	    for (i = len - 1; i >= 0; i--) {
	        if (!this.elements[i]) {
	            data = this.layers[i];
	            if(data.ip - data.st <= (num - this.layers[i].st) && data.op - data.st > (num - this.layers[i].st))
	            {
	                this.buildItem(i);
	            }
	        }
	        this.completeLayers = this.elements[i] ? this.completeLayers:false;
	    }
	    this.checkPendingElements();
	};
	
	BaseRenderer.prototype.createItem = function(layer){
	    switch(layer.ty){
	        case 2:
	            return this.createImage(layer);
	        case 0:
	            return this.createComp(layer);
	        case 1:
	            return this.createSolid(layer);
	        case 4:
	            return this.createShape(layer);
	        case 5:
	            return this.createText(layer);
	        case 13:
	            return this.createCamera(layer);
	        case 99:
	            return null;
	    }
	    return this.createBase(layer);
	};
	
	BaseRenderer.prototype.createCamera = function(){
	    throw new Error('You\'re using a 3d camera. Try the html renderer.');
	}
	
	BaseRenderer.prototype.buildAllItems = function(){
	    var i, len = this.layers.length;
	    for(i=0;i<len;i+=1){
	        this.buildItem(i);
	    }
	    this.checkPendingElements();
	};
	
	BaseRenderer.prototype.includeLayers = function(newLayers){
	    this.completeLayers = false;
	    var i, len = newLayers.length;
	    var j, jLen = this.layers.length;
	    for(i=0;i<len;i+=1){
	        j = 0;
	        while(j<jLen){
	            if(this.layers[j].id == newLayers[i].id){
	                this.layers[j] = newLayers[i];
	                break;
	            }
	            j += 1;
	        }
	    }
	};
	
	BaseRenderer.prototype.setProjectInterface = function(pInterface){
	    this.globalData.projectInterface = pInterface;
	};
	
	BaseRenderer.prototype.initItems = function(){
	    if(!this.globalData.progressiveLoad){
	        this.buildAllItems();
	    }
	};
	BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy){
	    hierarchy = hierarchy || [];
	    var elements = this.elements;
	    var layers = this.layers;
	    var i=0, len = layers.length;
	    while(i<len){
	        if(layers[i].ind == parentName){
	            if(!elements[i] || elements[i] === true){
	                this.buildItem(i);
	                this.addPendingElement(element);
	            } else if(layers[i].parent !== undefined){
	                hierarchy.push(elements[i]);
	                elements[i]._isParent = true;
	                this.buildElementParenting(element,layers[i].parent, hierarchy);
	            } else {
	                hierarchy.push(elements[i]);
	                elements[i]._isParent = true;
	                element.setHierarchy(hierarchy);
	            }
	
	
	        }
	        i += 1;
	    }
	};
	
	BaseRenderer.prototype.addPendingElement = function(element){
	    this.pendingElements.push(element);
	};
	function SVGRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.globalData = {
	        frameNum: -1
	    };
	    this.renderConfig = {
	        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
	        progressiveLoad: (config && config.progressiveLoad) || false,
	        hideOnTransparent: (config && config.hideOnTransparent === false) ? false : true
	    };
	    this.globalData.renderConfig = this.renderConfig;
	    this.elements = [];
	    this.pendingElements = [];
	    this.destroyed = false;
	
	}
	
	extendPrototype(BaseRenderer,SVGRenderer);
	
	SVGRenderer.prototype.createBase = function (data) {
	    return new SVGBaseElement(data, this.layerElement,this.globalData,this);
	};
	
	SVGRenderer.prototype.createShape = function (data) {
	    return new IShapeElement(data, this.layerElement,this.globalData,this);
	};
	
	SVGRenderer.prototype.createText = function (data) {
	    return new SVGTextElement(data, this.layerElement,this.globalData,this);
	
	};
	
	SVGRenderer.prototype.createImage = function (data) {
	    return new IImageElement(data, this.layerElement,this.globalData,this);
	};
	
	SVGRenderer.prototype.createComp = function (data) {
	    return new ICompElement(data, this.layerElement,this.globalData,this);
	
	};
	
	SVGRenderer.prototype.createSolid = function (data) {
	    return new ISolidElement(data, this.layerElement,this.globalData,this);
	};
	
	SVGRenderer.prototype.configAnimation = function(animData){
	    this.layerElement = document.createElementNS(svgNS,'svg');
	    this.layerElement.setAttribute('xmlns','http://www.w3.org/2000/svg');
	    this.layerElement.setAttribute('width',animData.w);
	    this.layerElement.setAttribute('height',animData.h);
	    this.layerElement.setAttribute('viewBox','0 0 '+animData.w+' '+animData.h);
	    this.layerElement.setAttribute('preserveAspectRatio',this.renderConfig.preserveAspectRatio);
	    this.layerElement.style.width = '100%';
	    this.layerElement.style.height = '100%';
	    //this.layerElement.style.transform = 'translate3d(0,0,0)';
	    //this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
	    this.animationItem.wrapper.appendChild(this.layerElement);
	    //Mask animation
	    var defs = document.createElementNS(svgNS, 'defs');
	    this.globalData.defs = defs;
	    this.layerElement.appendChild(defs);
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.globalData.frameId = 0;
	    this.globalData.nm = animData.nm;
	    this.globalData.compSize = {
	        w: animData.w,
	        h: animData.h
	    };
	    this.data = animData;
	    this.globalData.frameRate = animData.fr;
	    var maskElement = document.createElementNS(svgNS, 'clipPath');
	    var rect = document.createElementNS(svgNS,'rect');
	    rect.setAttribute('width',animData.w);
	    rect.setAttribute('height',animData.h);
	    rect.setAttribute('x',0);
	    rect.setAttribute('y',0);
	    var maskId = 'animationMask_'+randomString(10);
	    maskElement.setAttribute('id', maskId);
	    maskElement.appendChild(rect);
	    var maskedElement = document.createElementNS(svgNS,'g');
	    maskedElement.setAttribute("clip-path", "url(#"+maskId+")");
	    this.layerElement.appendChild(maskedElement);
	    defs.appendChild(maskElement);
	    this.layerElement = maskedElement;
	    this.layers = animData.layers;
	    this.globalData.fontManager = new FontManager();
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts,defs);
	    this.elements = Array.apply(null,{length:animData.layers.length});
	};
	
	
	SVGRenderer.prototype.destroy = function () {
	    this.animationItem.wrapper.innerHTML = '';
	    this.layerElement = null;
	    this.globalData.defs = null;
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = 0; i < len; i++) {
	        if(this.elements[i]){
	            this.elements[i].destroy();
	        }
	    }
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	};
	
	SVGRenderer.prototype.updateContainerSize = function () {
	};
	
	SVGRenderer.prototype.buildItem  = function(pos){
	    var elements = this.elements;
	    if(elements[pos] || this.layers[pos].ty == 99){
	        return;
	    }
	    elements[pos] = true;
	    var element = this.createItem(this.layers[pos]);
	
	    elements[pos] = element;
	    if(expressionsPlugin){
	        if(this.layers[pos].ty === 0){
	            this.globalData.projectInterface.registerComposition(element);
	        }
	        element.initExpressions();
	    }
	    this.appendElementInPos(element,pos);
	    if(this.layers[pos].tt){
	        if(!this.elements[pos - 1] || this.elements[pos - 1] === true){
	            this.buildItem(pos - 1);
	            this.addPendingElement(element);
	        } else {
	            element.setMatte(elements[pos - 1].layerId);
	        }
	    }
	};
	
	SVGRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	        if(element.data.tt){
	            var i = 0, len = this.elements.length;
	            while(i<len){
	                if(this.elements[i] === element){
	                    element.setMatte(this.elements[i - 1].layerId);
	                    break;
	                }
	                i += 1;
	            }
	        }
	    }
	};
	
	SVGRenderer.prototype.renderFrame = function(num){
	    if(this.renderedFrame == num || this.destroyed){
	        return;
	    }
	    if(num === null){
	        num = this.renderedFrame;
	    }else{
	        this.renderedFrame = num;
	    }
	    //clearPoints();
	    /*console.log('-------');
	    console.log('FRAME ',num);*/
	    this.globalData.frameNum = num;
	    this.globalData.frameId += 1;
	    this.globalData.projectInterface.currentFrame = num;
	    var i, len = this.layers.length;
	    if(!this.completeLayers){
	        this.checkLayers(num);
	    }
	    for (i = len - 1; i >= 0; i--) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(num - this.layers[i].st);
	        }
	    }
	    for (i = len - 1; i >= 0; i--) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	};
	
	SVGRenderer.prototype.appendElementInPos = function(element, pos){
	    var newElement = element.getBaseElement();
	    if(!newElement){
	        return;
	    }
	    var i = 0;
	    var nextElement;
	    while(i<pos){
	        if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement()){
	            nextElement = this.elements[i].getBaseElement();
	        }
	        i += 1;
	    }
	    if(nextElement){
	        this.layerElement.insertBefore(newElement, nextElement);
	    } else {
	        this.layerElement.appendChild(newElement);
	    }
	};
	
	SVGRenderer.prototype.hide = function(){
	    this.layerElement.style.display = 'none';
	};
	
	SVGRenderer.prototype.show = function(){
	    this.layerElement.style.display = 'block';
	};
	
	SVGRenderer.prototype.searchExtraCompositions = function(assets){
	    var i, len = assets.length;
	    var floatingContainer = document.createElementNS(svgNS,'g');
	    for(i=0;i<len;i+=1){
	        if(assets[i].xt){
	            var comp = this.createComp(assets[i],floatingContainer,this.globalData.comp,null);
	            comp.initExpressions();
	            //comp.compInterface = CompExpressionInterface(comp);
	            //Expressions.addLayersInterface(comp.elements, this.globalData.projectInterface);
	            this.globalData.projectInterface.registerComposition(comp);
	        }
	    }
	};
	
	function MaskElement(data,element,globalData) {
	    this.dynamicProperties = [];
	    this.data = data;
	    this.element = element;
	    this.globalData = globalData;
	    this.paths = [];
	    this.storedData = [];
	    this.masksProperties = this.data.masksProperties;
	    this.viewData = new Array(this.masksProperties.length);
	    this.maskElement = null;
	    this.firstFrame = true;
	    var defs = this.globalData.defs;
	    var i, len = this.masksProperties.length;
	
	
	    var path, properties = this.masksProperties;
	    var count = 0;
	    var currentMasks = [];
	    var j, jLen;
	    var layerId = randomString(10);
	    var rect, expansor, feMorph,x;
	    var maskType = 'clipPath', maskRef = 'clip-path';
	    for (i = 0; i < len; i++) {
	
	        if((properties[i].mode !== 'a' && properties[i].mode !== 'n')|| properties[i].inv || properties[i].o.k !== 100){
	            maskType = 'mask';
	            maskRef = 'mask';
	        }
	
	        if((properties[i].mode == 's' || properties[i].mode == 'i') && count == 0){
	            rect = document.createElementNS(svgNS, 'rect');
	            rect.setAttribute('fill', '#ffffff');
	            rect.setAttribute('width', this.element.comp.data.w);
	            rect.setAttribute('height', this.element.comp.data.h);
	            currentMasks.push(rect);
	        } else {
	            rect = null;
	        }
	
	        path = document.createElementNS(svgNS, 'path');
	        if(properties[i].mode == 'n') {
	            this.viewData[i] = {
	                op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.dynamicProperties),
	                prop: ShapePropertyFactory.getShapeProp(this.element,properties[i],3,this.dynamicProperties,null),
	                elem: path
	            };
	            defs.appendChild(path);
	            continue;
	        }
	        count += 1;
	
	        if(properties[i].mode == 's'){
	            path.setAttribute('fill', '#000000');
	        }else{
	            path.setAttribute('fill', '#ffffff');
	        }
	        path.setAttribute('clip-rule','nonzero');
	
	        if(properties[i].x.k !== 0){
	            maskType = 'mask';
	            maskRef = 'mask';
	            x = PropertyFactory.getProp(this.element,properties[i].x,0,null,this.dynamicProperties);
	            var filterID = 'fi_'+randomString(10);
	            expansor = document.createElementNS(svgNS,'filter');
	            expansor.setAttribute('id',filterID);
	            feMorph = document.createElementNS(svgNS,'feMorphology');
	            feMorph.setAttribute('operator','dilate');
	            feMorph.setAttribute('in','SourceGraphic');
	            feMorph.setAttribute('radius','0');
	            expansor.appendChild(feMorph);
	            defs.appendChild(expansor);
	            if(properties[i].mode == 's'){
	                path.setAttribute('stroke', '#000000');
	            }else{
	                path.setAttribute('stroke', '#ffffff');
	            }
	        }else{
	            feMorph = null;
	            x = null;
	        }
	
	
	        this.storedData[i] = {
	             elem: path,
	             x: x,
	             expan: feMorph,
	            lastPath: '',
	            lastOperator:'',
	            filterId:filterID,
	            lastRadius:0
	        };
	        if(properties[i].mode == 'i'){
	            jLen = currentMasks.length;
	            var g = document.createElementNS(svgNS,'g');
	            for(j=0;j<jLen;j+=1){
	                g.appendChild(currentMasks[j]);
	            }
	            var mask = document.createElementNS(svgNS,'mask');
	            mask.setAttribute('mask-type','alpha');
	            mask.setAttribute('id',layerId+'_'+count);
	            mask.appendChild(path);
	            defs.appendChild(mask);
	            g.setAttribute('mask','url(#'+layerId+'_'+count+')');
	
	            currentMasks.length = 0;
	            currentMasks.push(g);
	        }else{
	            currentMasks.push(path);
	        }
	        if(properties[i].inv && !this.solidPath){
	            this.solidPath = this.createLayerSolidPath();
	        }
	        this.viewData[i] = {
	            elem: path,
	            lastPath: '',
	            op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.dynamicProperties),
	            prop:ShapePropertyFactory.getShapeProp(this.element,properties[i],3,this.dynamicProperties,null)
	        };
	        if(rect){
	            this.viewData[i].invRect = rect;
	        }
	        if(!this.viewData[i].prop.k){
	            this.drawPath(properties[i],this.viewData[i].prop.v,this.viewData[i]);
	        }
	    }
	
	    this.maskElement = document.createElementNS(svgNS, maskType);
	
	    len = currentMasks.length;
	    for(i=0;i<len;i+=1){
	        this.maskElement.appendChild(currentMasks[i]);
	    }
	
	    this.maskElement.setAttribute('id', layerId);
	    if(count > 0){
	        this.element.maskedElement.setAttribute(maskRef, "url(#" + layerId + ")");
	    }
	
	    defs.appendChild(this.maskElement);
	};
	
	MaskElement.prototype.getMaskProperty = function(pos){
	    return this.viewData[pos].prop;
	};
	
	MaskElement.prototype.prepareFrame = function(){
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	
	    }
	};
	
	MaskElement.prototype.renderFrame = function (finalMat) {
	    var i, len = this.masksProperties.length;
	    for (i = 0; i < len; i++) {
	        if(this.viewData[i].prop.mdf || this.firstFrame){
	            this.drawPath(this.masksProperties[i],this.viewData[i].prop.v,this.viewData[i]);
	        }
	        if(this.viewData[i].op.mdf || this.firstFrame){
	            this.viewData[i].elem.setAttribute('fill-opacity',this.viewData[i].op.v);
	        }
	        if(this.masksProperties[i].mode !== 'n'){
	            if(this.viewData[i].invRect && (this.element.finalTransform.mProp.mdf || this.firstFrame)){
	                this.viewData[i].invRect.setAttribute('x', -finalMat.props[12]);
	                this.viewData[i].invRect.setAttribute('y', -finalMat.props[13]);
	            }
	            if(this.storedData[i].x && (this.storedData[i].x.mdf || this.firstFrame)){
	                var feMorph = this.storedData[i].expan;
	                if(this.storedData[i].x.v < 0){
	                    if(this.storedData[i].lastOperator !== 'erode'){
	                        this.storedData[i].lastOperator = 'erode';
	                        this.storedData[i].elem.setAttribute('filter','url(#'+this.storedData[i].filterId+')');
	                    }
	                    feMorph.setAttribute('radius',-this.storedData[i].x.v);
	                }else{
	                    if(this.storedData[i].lastOperator !== 'dilate'){
	                        this.storedData[i].lastOperator = 'dilate';
	                        this.storedData[i].elem.setAttribute('filter',null);
	                    }
	                    this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v*2);
	
	                }
	            }
	        }
	    }
	    this.firstFrame = false;
	};
	
	MaskElement.prototype.getMaskelement = function () {
	    return this.maskElement;
	};
	
	MaskElement.prototype.createLayerSolidPath = function(){
	    var path = 'M0,0 ';
	    path += ' h' + this.globalData.compSize.w ;
	    path += ' v' + this.globalData.compSize.h ;
	    path += ' h-' + this.globalData.compSize.w ;
	    path += ' v-' + this.globalData.compSize.h + ' ';
	    return path;
	};
	
	MaskElement.prototype.drawPath = function(pathData,pathNodes,viewData){
	    var pathString = " M"+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    var i, len;
	    len = pathNodes._length;
	    for(i=1;i<len;i+=1){
	        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
	        pathString += " C"+bm_rnd(pathNodes.o[i-1][0])+','+bm_rnd(pathNodes.o[i-1][1]) + " "+bm_rnd(pathNodes.i[i][0])+','+bm_rnd(pathNodes.i[i][1]) + " "+bm_rnd(pathNodes.v[i][0])+','+bm_rnd(pathNodes.v[i][1]);
	    }
	        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    if(pathNodes.c && len > 1){
	        pathString += " C"+bm_rnd(pathNodes.o[i-1][0])+','+bm_rnd(pathNodes.o[i-1][1]) + " "+bm_rnd(pathNodes.i[0][0])+','+bm_rnd(pathNodes.i[0][1]) + " "+bm_rnd(pathNodes.v[0][0])+','+bm_rnd(pathNodes.v[0][1]);
	    }
	    //pathNodes.__renderedString = pathString;
	
	
	    if(viewData.lastPath !== pathString){
	        if(viewData.elem){
	            if(!pathNodes.c){
	                viewData.elem.setAttribute('d','');
	            }else if(pathData.inv){
	                viewData.elem.setAttribute('d',this.solidPath + pathString);
	            }else{
	                viewData.elem.setAttribute('d',pathString);
	            }
	        }
	        viewData.lastPath = pathString;
	    }
	};
	
	MaskElement.prototype.getMask = function(nm){
	    var i = 0, len = this.masksProperties.length;
	    while(i<len){
	        if(this.masksProperties[i].nm === nm){
	            return {
	                maskPath: this.viewData[i].prop.pv
	            }
	        }
	        i += 1;
	    }
	};
	
	MaskElement.prototype.destroy = function(){
	    this.element = null;
	    this.globalData = null;
	    this.maskElement = null;
	    this.data = null;
	    this.paths = null;
	    this.masksProperties = null;
	};
	function BaseElement(){
	};
	BaseElement.prototype.checkMasks = function(){
	    if(!this.data.hasMask){
	        return false;
	    }
	    var i = 0, len = this.data.masksProperties.length;
	    while(i<len) {
	        if((this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false)) {
	            return true;
	        }
	        i += 1;
	    }
	    return false;
	}
	
	BaseElement.prototype.checkParenting = function(){
	    if(this.data.parent !== undefined){
	        this.comp.buildElementParenting(this, this.data.parent);
	    }
	}
	
	BaseElement.prototype.prepareFrame = function(num){
	    if(this.data.ip - this.data.st <= num && this.data.op - this.data.st > num)
	    {
	        if(this.isVisible !== true){
	            this.elemMdf = true;
	            this.globalData.mdf = true;
	            this.isVisible = true;
	            this.firstFrame = true;
	            if(this.data.hasMask){
	                this.maskManager.firstFrame = true;
	            }
	        }
	    }else{
	        if(this.isVisible !== false){
	            this.elemMdf = true;
	            this.globalData.mdf = true;
	            this.isVisible = false;
	        }
	    }
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        if(this.isVisible || (this._isParent && this.dynamicProperties[i].type === 'transform')){
	            this.dynamicProperties[i].getValue();
	            if(this.dynamicProperties[i].mdf){
	                this.elemMdf = true;
	                this.globalData.mdf = true;
	            }
	        }
	    }
	    if(this.data.hasMask && this.isVisible){
	        this.maskManager.prepareFrame(num*this.data.sr);
	    }
	    
	    /* TODO check this
	    if(this.data.sy){
	        if(this.data.sy[0].renderedData[num]){
	            if(this.data.sy[0].renderedData[num].c){
	                this.feFlood.setAttribute('flood-color','rgb('+Math.round(this.data.sy[0].renderedData[num].c[0])+','+Math.round(this.data.sy[0].renderedData[num].c[1])+','+Math.round(this.data.sy[0].renderedData[num].c[2])+')');
	            }
	            if(this.data.sy[0].renderedData[num].s){
	                this.feMorph.setAttribute('radius',this.data.sy[0].renderedData[num].s);
	            }
	        }
	    }
	    */
	
	
	    this.currentFrameNum = num*this.data.sr;
	    return this.isVisible;
	};
	
	BaseElement.prototype.globalToLocal = function(pt){
	    var transforms = [];
	    transforms.push(this.finalTransform);
	    var flag = true;
	    var comp = this.comp;
	    while(flag){
	        if(comp.finalTransform){
	            if(comp.data.hasMask){
	                transforms.splice(0,0,comp.finalTransform);
	            }
	            comp = comp.comp;
	        } else {
	            flag = false;
	        }
	    }
	    var i, len = transforms.length,ptNew;
	    for(i=0;i<len;i+=1){
	        ptNew = transforms[i].mat.applyToPointArray(0,0,0);
	        //ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
	        pt = [pt[0] - ptNew[0],pt[1] - ptNew[1],0];
	    }
	    return pt;
	};
	
	BaseElement.prototype.initExpressions = function(){
	    this.layerInterface = LayerExpressionInterface(this);
	    //layers[i].layerInterface = LayerExpressionInterface(layers[i]);
	    //layers[i].layerInterface = LayerExpressionInterface(layers[i]);
	    if(this.data.hasMask){
	        this.layerInterface.registerMaskInterface(this.maskManager);
	    }
	    var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this,this.layerInterface);
	    this.layerInterface.registerEffectsInterface(effectsInterface);
	
	    if(this.data.ty === 0 || this.data.xt){
	        this.compInterface = CompExpressionInterface(this);
	    } else if(this.data.ty === 4){
	        this.layerInterface.shapeInterface = ShapeExpressionInterface.createShapeInterface(this.shapesData,this.itemsData,this.layerInterface);
	    } else if(this.data.ty === 5){
	        this.layerInterface.textInterface = TextExpressionInterface(this);
	    }
	}
	
	BaseElement.prototype.setBlendMode = function(){
	    var blendModeValue = '';
	    switch(this.data.bm){
	        case 1:
	            blendModeValue = 'multiply';
	            break;
	        case 2:
	            blendModeValue = 'screen';
	            break;
	        case 3:
	            blendModeValue = 'overlay';
	            break;
	        case 4:
	            blendModeValue = 'darken';
	            break;
	        case 5:
	            blendModeValue = 'lighten';
	            break;
	        case 6:
	            blendModeValue = 'color-dodge';
	            break;
	        case 7:
	            blendModeValue = 'color-burn';
	            break;
	        case 8:
	            blendModeValue = 'hard-light';
	            break;
	        case 9:
	            blendModeValue = 'soft-light';
	            break;
	        case 10:
	            blendModeValue = 'difference';
	            break;
	        case 11:
	            blendModeValue = 'exclusion';
	            break;
	        case 12:
	            blendModeValue = 'hue';
	            break;
	        case 13:
	            blendModeValue = 'saturation';
	            break;
	        case 14:
	            blendModeValue = 'color';
	            break;
	        case 15:
	            blendModeValue = 'luminosity';
	            break;
	    }
	    var elem = this.baseElement || this.layerElement;
	
	    elem.style['mix-blend-mode'] = blendModeValue;
	}
	
	BaseElement.prototype.init = function(){
	    if(!this.data.sr){
	        this.data.sr = 1;
	    }
	    this.dynamicProperties = [];
	    if(this.data.ef){
	        this.effects = new EffectsManager(this.data,this,this.dynamicProperties);
	        //this.effect = this.effectsManager.bind(this.effectsManager);
	    }
	    //this.elemInterface = buildLayerExpressionInterface(this);
	    this.hidden = false;
	    this.firstFrame = true;
	    this.isVisible = false;
	    this._isParent = false;
	    this.currentFrameNum = -99999;
	    this.lastNum = -99999;
	    if(this.data.ks){
	        this.finalTransform = {
	            mProp: PropertyFactory.getProp(this,this.data.ks,2,null,this.dynamicProperties),
	            matMdf: false,
	            opMdf: false,
	            mat: new Matrix(),
	            opacity: 1
	        };
	        if(this.data.ao){
	            this.finalTransform.mProp.autoOriented = true;
	        }
	        this.finalTransform.op = this.finalTransform.mProp.o;
	        this.transform = this.finalTransform.mProp;
	        if(this.data.ty !== 11){
	            this.createElements();
	        }
	        if(this.data.hasMask){
	            this.addMasks(this.data);
	        }
	    }
	    this.elemMdf = false;
	};
	BaseElement.prototype.getType = function(){
	    return this.type;
	};
	
	BaseElement.prototype.resetHierarchy = function(){
	    if(!this.hierarchy){
	        this.hierarchy = [];
	    }else{
	        this.hierarchy.length = 0;
	    }
	};
	
	BaseElement.prototype.getHierarchy = function(){
	    if(!this.hierarchy){
	        this.hierarchy = [];
	    }
	    return this.hierarchy;
	};
	
	BaseElement.prototype.setHierarchy = function(hierarchy){
	    this.hierarchy = hierarchy;
	};
	
	BaseElement.prototype.getLayerSize = function(){
	    if(this.data.ty === 5){
	        return {w:this.data.textData.width,h:this.data.textData.height};
	    }else{
	        return {w:this.data.width,h:this.data.height};
	    }
	};
	
	BaseElement.prototype.hide = function(){
	
	};
	
	BaseElement.prototype.mHelper = new Matrix();
	function SVGBaseElement(data,parentContainer,globalData,comp, placeholder){
	    this.globalData = globalData;
	    this.comp = comp;
	    this.data = data;
	    this.matteElement = null;
	    this.transformedElement = null;
	    this.isTransparent = false;
	    this.parentContainer = parentContainer;
	    this.layerId = placeholder ? placeholder.layerId : 'ly_'+randomString(10);
	    this.placeholder = placeholder;
	    this.init();
	};
	
	createElement(BaseElement, SVGBaseElement);
	
	SVGBaseElement.prototype.createElements = function(){
	    this.layerElement = document.createElementNS(svgNS,'g');
	    this.transformedElement = this.layerElement;
	    if(this.data.hasMask){
	        this.maskedElement = this.layerElement;
	    }
	    var layerElementParent = null;
	    if(this.data.td){
	        if(this.data.td == 3 || this.data.td == 1){
	            var masker = document.createElementNS(svgNS,'mask');
	            masker.setAttribute('id',this.layerId);
	            masker.setAttribute('mask-type',this.data.td == 3 ? 'luminance':'alpha');
	            masker.appendChild(this.layerElement);
	            layerElementParent = masker;
	            this.globalData.defs.appendChild(masker);
	            ////// This is only for IE and Edge when mask if of type alpha
	            if(!featureSupport.maskType && this.data.td == 1){
	                masker.setAttribute('mask-type','luminance');
	                var filId = randomString(10);
	                var fil = filtersFactory.createFilter(filId);
	                this.globalData.defs.appendChild(fil);
	                fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	                var gg = document.createElementNS(svgNS,'g');
	                gg.appendChild(this.layerElement);
	                layerElementParent = gg;
	                masker.appendChild(gg);
	                gg.setAttribute('filter','url(#'+filId+')');
	            }
	        }else if(this.data.td == 2){
	            var maskGroup = document.createElementNS(svgNS,'mask');
	            maskGroup.setAttribute('id',this.layerId);
	            maskGroup.setAttribute('mask-type','alpha');
	            var maskGrouper = document.createElementNS(svgNS,'g');
	            maskGroup.appendChild(maskGrouper);
	            var filId = randomString(10);
	            var fil = filtersFactory.createFilter(filId);
	            ////
	
	            var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
	            feColorMatrix.setAttribute('type','matrix');
	            feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	            feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 -1 1');
	            fil.appendChild(feColorMatrix);
	
	            ////
	            /*var feCTr = document.createElementNS(svgNS,'feComponentTransfer');
	            feCTr.setAttribute('in','SourceGraphic');
	            fil.appendChild(feCTr);
	            var feFunc = document.createElementNS(svgNS,'feFuncA');
	            feFunc.setAttribute('type','table');
	            feFunc.setAttribute('tableValues','1.0 0.0');
	            feCTr.appendChild(feFunc);*/
	            this.globalData.defs.appendChild(fil);
	            var alphaRect = document.createElementNS(svgNS,'rect');
	            alphaRect.setAttribute('width',this.comp.data.w);
	            alphaRect.setAttribute('height',this.comp.data.h);
	            alphaRect.setAttribute('x','0');
	            alphaRect.setAttribute('y','0');
	            alphaRect.setAttribute('fill','#ffffff');
	            alphaRect.setAttribute('opacity','0');
	            maskGrouper.setAttribute('filter','url(#'+filId+')');
	            maskGrouper.appendChild(alphaRect);
	            maskGrouper.appendChild(this.layerElement);
	            layerElementParent = maskGrouper;
	            if(!featureSupport.maskType){
	                maskGroup.setAttribute('mask-type','luminance');
	                fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	                var gg = document.createElementNS(svgNS,'g');
	                maskGrouper.appendChild(alphaRect);
	                gg.appendChild(this.layerElement);
	                layerElementParent = gg;
	                maskGrouper.appendChild(gg);
	            }
	            this.globalData.defs.appendChild(maskGroup);
	        }
	    }else if(this.data.hasMask || this.data.tt){
	        if(this.data.tt){
	            this.matteElement = document.createElementNS(svgNS,'g');
	            this.matteElement.appendChild(this.layerElement);
	            layerElementParent = this.matteElement;
	            this.baseElement = this.matteElement;
	        }else{
	            this.baseElement = this.layerElement;
	        }
	    }else{
	        this.baseElement = this.layerElement;
	    }
	    if((this.data.ln || this.data.cl) && (this.data.ty === 4 || this.data.ty === 0)){
	        if(this.data.ln){
	            this.layerElement.setAttribute('id',this.data.ln);
	        }
	        if(this.data.cl){
	            this.layerElement.setAttribute('class',this.data.cl);
	        }
	    }
	    if(this.data.ty === 0){
	            var cp = document.createElementNS(svgNS, 'clipPath');
	            var pt = document.createElementNS(svgNS,'path');
	            pt.setAttribute('d','M0,0 L'+this.data.w+',0'+' L'+this.data.w+','+this.data.h+' L0,'+this.data.h+'z');
	            var clipId = 'cp_'+randomString(8);
	            cp.setAttribute('id',clipId);
	            cp.appendChild(pt);
	            this.globalData.defs.appendChild(cp);
	        if(this.checkMasks()){
	            var cpGroup = document.createElementNS(svgNS,'g');
	            cpGroup.setAttribute('clip-path','url(#'+clipId+')');
	            cpGroup.appendChild(this.layerElement);
	            this.transformedElement = cpGroup;
	            if(layerElementParent){
	                layerElementParent.appendChild(this.transformedElement);
	            } else {
	                this.baseElement = this.transformedElement;
	            }
	        } else {
	            this.layerElement.setAttribute('clip-path','url(#'+clipId+')');
	        }
	        
	    }
	    if(this.data.bm !== 0){
	        this.setBlendMode();
	    }
	    if(this.layerElement !== this.parentContainer){
	        this.placeholder = null;
	    }
	    /* Todo performance killer
	    if(this.data.sy){
	        var filterID = 'st_'+randomString(10);
	        var c = this.data.sy[0].c.k;
	        var r = this.data.sy[0].s.k;
	        var expansor = document.createElementNS(svgNS,'filter');
	        expansor.setAttribute('id',filterID);
	        var feFlood = document.createElementNS(svgNS,'feFlood');
	        this.feFlood = feFlood;
	        if(!c[0].e){
	            feFlood.setAttribute('flood-color','rgb('+c[0]+','+c[1]+','+c[2]+')');
	        }
	        feFlood.setAttribute('result','base');
	        expansor.appendChild(feFlood);
	        var feMorph = document.createElementNS(svgNS,'feMorphology');
	        feMorph.setAttribute('operator','dilate');
	        feMorph.setAttribute('in','SourceGraphic');
	        feMorph.setAttribute('result','bigger');
	        this.feMorph = feMorph;
	        if(!r.length){
	            feMorph.setAttribute('radius',this.data.sy[0].s.k);
	        }
	        expansor.appendChild(feMorph);
	        var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
	        feColorMatrix.setAttribute('result','mask');
	        feColorMatrix.setAttribute('in','bigger');
	        feColorMatrix.setAttribute('type','matrix');
	        feColorMatrix.setAttribute('values','0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0');
	        expansor.appendChild(feColorMatrix);
	        var feComposite = document.createElementNS(svgNS,'feComposite');
	        feComposite.setAttribute('result','drop');
	        feComposite.setAttribute('in','base');
	        feComposite.setAttribute('in2','mask');
	        feComposite.setAttribute('operator','in');
	        expansor.appendChild(feComposite);
	        var feBlend = document.createElementNS(svgNS,'feBlend');
	        feBlend.setAttribute('in','SourceGraphic');
	        feBlend.setAttribute('in2','drop');
	        feBlend.setAttribute('mode','normal');
	        expansor.appendChild(feBlend);
	        this.globalData.defs.appendChild(expansor);
	        var cont = document.createElementNS(svgNS,'g');
	        if(this.layerElement === this.parentContainer){
	            this.layerElement = cont;
	        }else{
	            cont.appendChild(this.layerElement);
	        }
	        cont.setAttribute('filter','url(#'+filterID+')');
	        if(this.data.td){
	            cont.setAttribute('data-td',this.data.td);
	        }
	        if(this.data.td == 3){
	            this.globalData.defs.appendChild(cont);
	        }else if(this.data.td == 2){
	            maskGrouper.appendChild(cont);
	        }else if(this.data.td == 1){
	            masker.appendChild(cont);
	        }else{
	            if(this.data.hasMask && this.data.tt){
	                this.matteElement.appendChild(cont);
	            }else{
	                this.appendNodeToParent(cont);
	            }
	        }
	    }*/
	    if(this.data.ef){
	        this.effectsManager = new SVGEffects(this);
	    }
	    this.checkParenting();
	};
	
	
	SVGBaseElement.prototype.setBlendMode = BaseElement.prototype.setBlendMode;
	
	SVGBaseElement.prototype.renderFrame = function(parentTransform){
	    if(this.data.ty === 3 || this.data.hd || !this.isVisible){
	        return false;
	    }
	
	    this.lastNum = this.currentFrameNum;
	    this.finalTransform.opMdf = this.firstFrame || this.finalTransform.op.mdf;
	    this.finalTransform.matMdf = this.firstFrame || this.finalTransform.mProp.mdf;
	    this.finalTransform.opacity = this.finalTransform.op.v;
	
	    var mat;
	    var finalMat = this.finalTransform.mat;
	
	    if(this.hierarchy){
	        var i = 0, len = this.hierarchy.length;
	        if(!this.finalTransform.matMdf) {
	            while(i < len) {
	                if(this.hierarchy[i].finalTransform.mProp.mdf) {
	                    this.finalTransform.matMdf = true;
	                    break;
	                }
	                i += 1;
	            }
	        }
	        
	        if(this.finalTransform.matMdf) {
	            mat = this.finalTransform.mProp.v.props;
	            finalMat.cloneFromProps(mat);
	            for(i=0;i<len;i+=1){
	                mat = this.hierarchy[i].finalTransform.mProp.v.props;
	                finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
	            }
	        }
	        
	    }else if(this.isVisible){
	        finalMat = this.finalTransform.mProp.v;
	    }
	    if(this.finalTransform.matMdf && this.layerElement){
	        this.transformedElement.setAttribute('transform',finalMat.to2dCSS());
	    }
	    if(this.finalTransform.opMdf && this.layerElement){
	        if(this.finalTransform.op.v <= 0) {
	            if(!this.isTransparent && this.globalData.renderConfig.hideOnTransparent){
	                this.isTransparent = true;
	                this.hide();
	            }
	        } else if(this.hidden && this.isTransparent){
	            this.isTransparent = false;
	            this.show();
	        }
	        this.transformedElement.setAttribute('opacity',this.finalTransform.op.v);
	    }
	
	    if(this.data.hasMask){
	        this.maskManager.renderFrame(finalMat);
	    }
	    if(this.effectsManager){
	        this.effectsManager.renderFrame(this.firstFrame);
	    }
	    return this.isVisible;
	};
	
	SVGBaseElement.prototype.destroy = function(){
	    this.layerElement = null;
	    this.parentContainer = null;
	    if(this.matteElement) {
	        this.matteElement = null;
	    }
	    if(this.maskManager) {
	        this.maskManager.destroy();
	    }
	};
	
	SVGBaseElement.prototype.getBaseElement = function(){
	    return this.baseElement;
	};
	SVGBaseElement.prototype.addMasks = function(data){
	    this.maskManager = new MaskElement(data,this,this.globalData);
	};
	
	SVGBaseElement.prototype.setMatte = function(id){
	    if(!this.matteElement){
	        return;
	    }
	    this.matteElement.setAttribute("mask", "url(#" + id + ")");
	};
	
	SVGBaseElement.prototype.hide = function(){
	    if(!this.hidden){
	        this.layerElement.style.display = 'none';
	        this.hidden = true;
	    }
	};
	
	SVGBaseElement.prototype.show = function(){
	    if(this.isVisible && !this.isTransparent){
	        this.hidden = false;
	        this.layerElement.style.display = 'block';
	    }
	};
	
	function IShapeElement(data,parentContainer,globalData,comp, placeholder){
	    this.shapes = [];
	    this.shapesData = data.shapes;
	    this.stylesList = [];
	    this.itemsData = [];
	    this.prevViewData = [];
	    this.shapeModifiers = [];
	    this.processedElements = [];
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	}
	createElement(SVGBaseElement, IShapeElement);
	
	IShapeElement.prototype.identityMatrix = new Matrix();
	
	IShapeElement.prototype.lcEnum = {
	    '1': 'butt',
	    '2': 'round',
	    '3': 'butt'
	}
	
	IShapeElement.prototype.ljEnum = {
	    '1': 'miter',
	    '2': 'round',
	    '3': 'butt'
	}
	
	IShapeElement.prototype.searchProcessedElement = function(elem){
	    var i = this.processedElements.length;
	    while(i){
	        i -= 1;
	        if(this.processedElements[i].elem === elem){
	            return this.processedElements[i].pos;
	        }
	    }
	    return 0;
	};
	
	IShapeElement.prototype.addProcessedElement = function(elem, pos){
	    var i = this.processedElements.length;
	    while(i){
	        i -= 1;
	        if(this.processedElements[i].elem === elem){
	            this.processedElements[i].pos = pos;
	            break;
	        }
	    }
	    if(i === 0){
	        this.processedElements.push({
	            elem: elem,
	            pos: pos
	        })
	    }
	};
	
	IShapeElement.prototype.buildExpressionInterface = function(){};
	
	IShapeElement.prototype.createElements = function(){
	    //TODO check if I can use symbol so i can set its viewBox
	    this._parent.createElements.call(this);
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,this.dynamicProperties, 0, [], true);
	    if(!this.data.hd || this.data.td){
	        styleUnselectableDiv(this.layerElement);
	    }
	};
	
	IShapeElement.prototype.setGradientData = function(pathElement,arr,data){
	
	    var gradientId = 'gr_'+randomString(10);
	    var gfill;
	    if(arr.t === 1){
	        gfill = document.createElementNS(svgNS,'linearGradient');
	    } else {
	        gfill = document.createElementNS(svgNS,'radialGradient');
	    }
	    gfill.setAttribute('id',gradientId);
	    gfill.setAttribute('spreadMethod','pad');
	    gfill.setAttribute('gradientUnits','userSpaceOnUse');
	    var stops = [];
	    var stop, j, jLen;
	    jLen = arr.g.p*4;
	    for(j=0;j<jLen;j+=4){
	        stop = document.createElementNS(svgNS,'stop');
	        gfill.appendChild(stop);
	        stops.push(stop);
	    }
	    pathElement.setAttribute( arr.ty === 'gf' ? 'fill':'stroke','url(#'+gradientId+')');
	    this.globalData.defs.appendChild(gfill);
	    data.gf = gfill;
	    data.cst = stops;
	}
	
	IShapeElement.prototype.setGradientOpacity = function(arr, data, styleOb){
	    if((arr.g.k.k[0].s && arr.g.k.k[0].s.length > arr.g.p*4) || arr.g.k.k.length > arr.g.p*4){
	        var opFill;
	        var stop, j, jLen;
	        var mask = document.createElementNS(svgNS,"mask");
	        var maskElement = document.createElementNS(svgNS, 'path');
	        mask.appendChild(maskElement);
	        var opacityId = 'op_'+randomString(10);
	        var maskId = 'mk_'+randomString(10);
	        mask.setAttribute('id',maskId);
	        if(arr.t === 1){
	            opFill = document.createElementNS(svgNS,'linearGradient');
	        } else {
	            opFill = document.createElementNS(svgNS,'radialGradient');
	        }
	        opFill.setAttribute('id',opacityId);
	        opFill.setAttribute('spreadMethod','pad');
	        opFill.setAttribute('gradientUnits','userSpaceOnUse');
	        jLen = arr.g.k.k[0].s ? arr.g.k.k[0].s.length : arr.g.k.k.length;
	        var stops = [];
	        for(j=arr.g.p*4;j<jLen;j+=2){
	            stop = document.createElementNS(svgNS,'stop');
	            stop.setAttribute('stop-color','rgb(255,255,255)');
	            //stop.setAttribute('offset',Math.round(arr.y[j][0]*100)+'%');
	            //stop.setAttribute('style','stop-color:rgb(255,255,255);stop-opacity:'+arr.y[j][1]);
	            opFill.appendChild(stop);
	            stops.push(stop);
	        }
	        maskElement.setAttribute( arr.ty === 'gf' ? 'fill':'stroke','url(#'+opacityId+')');
	        this.globalData.defs.appendChild(opFill);
	        this.globalData.defs.appendChild(mask);
	        data.of = opFill;
	        data.ost = stops;
	        styleOb.msElem = maskElement;
	        return maskId;
	    }
	};
	
	IShapeElement.prototype.createStyleElement = function(data, level, dynamicProperties){
	    var elementData = {
	    };
	    var styleOb = {
	        data: data,
	        type: data.ty,
	        d: '',
	        ld: '',
	        lvl: level,
	        mdf: false,
	        closed: false
	    };
	    var pathElement = document.createElementNS(svgNS, "path");
	    elementData.o = PropertyFactory.getProp(this,data.o,0,0.01,dynamicProperties);
	    if(data.ty == 'st' || data.ty == 'gs') {
	        pathElement.setAttribute('stroke-linecap', this.lcEnum[data.lc] || 'round');
	        ////pathElement.style.strokeLinecap = this.lcEnum[data.lc] || 'round';
	        pathElement.setAttribute('stroke-linejoin',this.ljEnum[data.lj] || 'round');
	        ////pathElement.style.strokeLinejoin = this.ljEnum[data.lj] || 'round';
	        pathElement.setAttribute('fill-opacity','0');
	        ////pathElement.style.fillOpacity = 0;
	        if(data.lj == 1) {
	            pathElement.setAttribute('stroke-miterlimit',data.ml);
	            ////pathElement.style.strokeMiterlimit = data.ml;
	        }
	
	        elementData.w = PropertyFactory.getProp(this,data.w,0,null,dynamicProperties);
	        if(data.d){
	            var d = PropertyFactory.getDashProp(this,data.d,'svg',dynamicProperties);
	            if(!d.k){
	                pathElement.setAttribute('stroke-dasharray', d.dasharray);
	                ////pathElement.style.strokeDasharray = d.dasharray;
	                pathElement.setAttribute('stroke-dashoffset', d.dashoffset);
	                ////pathElement.style.strokeDashoffset = d.dashoffset;
	            }
	            elementData.d = d;
	        }
	
	    }
	    if(data.ty == 'fl' || data.ty == 'st'){
	        elementData.c = PropertyFactory.getProp(this,data.c,1,255,dynamicProperties);
	    } else {
	        elementData.g = PropertyFactory.getGradientProp(this,data.g,dynamicProperties);
	        if(data.t == 2){
	            elementData.h = PropertyFactory.getProp(this,data.h,1,0.01,dynamicProperties);
	            elementData.a = PropertyFactory.getProp(this,data.a,1,degToRads,dynamicProperties);
	        }
	        elementData.s = PropertyFactory.getProp(this,data.s,1,null,dynamicProperties);
	        elementData.e = PropertyFactory.getProp(this,data.e,1,null,dynamicProperties);
	        this.setGradientData(pathElement,data,elementData, styleOb);
	        var maskId = this.setGradientOpacity(data,elementData, styleOb);
	        if(maskId){
	            pathElement.setAttribute('mask','url(#'+maskId+')');
	        }
	    }
	    elementData.elem = pathElement;
	    //container.appendChild(pathElement);
	    if(data.r === 2) {
	        pathElement.setAttribute('fill-rule', 'evenodd');
	    }
	
	    if(data.ln){
	        pathElement.setAttribute('id',data.ln);
	    }
	    if(data.cl){
	        pathElement.setAttribute('class',data.cl);
	    }
	    styleOb.pElem = pathElement;
	    this.stylesList.push(styleOb);
	    elementData.style = styleOb;
	    return elementData;
	}
	
	IShapeElement.prototype.createGroupElement = function(data) {
	    var elementData = {
	        it: [],
	        prevViewData: []
	    };
	    var g = document.createElementNS(svgNS,'g');
	    elementData.gr = g;
	    if(data.ln){
	        elementData.gr.setAttribute('id',data.ln);
	    }
	    return elementData;
	}
	
	IShapeElement.prototype.createTransformElement = function(data, dynamicProperties) {
	    var elementData = {
	        transform : {
	            op: PropertyFactory.getProp(this,data.o,0,0.01,dynamicProperties),
	            mProps: PropertyFactory.getProp(this,data,2,null,dynamicProperties)
	        },
	        elements: []
	    };
	    return elementData;
	}
	
	IShapeElement.prototype.createShapeElement = function(data, ownTransformers, level, dynamicProperties) {
	    var elementData = {
	        elements : [],
	        caches:[],
	        styles : [],
	        transformers: ownTransformers,
	        lStr: ''
	    };
	    var ty = 4;
	    if(data.ty == 'rc'){
	        ty = 5;
	    }else if(data.ty == 'el'){
	        ty = 6;
	    }else if(data.ty == 'sr'){
	        ty = 7;
	    }
	    elementData.sh = ShapePropertyFactory.getShapeProp(this,data,ty,dynamicProperties);
	    elementData.lvl = level;
	    this.shapes.push(elementData.sh);
	    this.addShapeToModifiers(elementData);
	    return elementData;
	}
	
	var cont = 0;
	
	IShapeElement.prototype.setElementStyles = function(){
	    var j, jLen = this.stylesList.length;
	    var arr = [];
	    for(j=0;j<jLen;j+=1){
	        if(!this.stylesList[j].closed){
	            arr.push(this.stylesList[j]);
	        }
	    }
	    return arr;
	}
	
	IShapeElement.prototype.reloadShapes = function(){
	    this.firstFrame = true;
	    var i, len = this.itemsData.length;
	    for(i=0;i<len;i+=1){
	        this.prevViewData[i] = this.itemsData[i];
	    }
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,this.dynamicProperties, 0, [], true);
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	    }
	    this.renderModifiers();
	}
	
	IShapeElement.prototype.searchShapes = function(arr,itemsData,prevViewData,container,dynamicProperties, level, transformers, render){
	    var ownTransformers = [].concat(transformers);
	    var i, len = arr.length - 1;
	    var j, jLen;
	    var ownStyles = [], ownModifiers = [], styleOb, currentTransform, modifier, processedPos;
	    for(i=len;i>=0;i-=1){
	        processedPos = this.searchProcessedElement(arr[i]);
	        if(!processedPos){
	            arr[i]._render = render;
	        } else {
	            itemsData[i] = prevViewData[processedPos - 1];
	        }
	        if(arr[i].ty == 'fl' || arr[i].ty == 'st' || arr[i].ty == 'gf' || arr[i].ty == 'gs'){
	            if(!processedPos){
	                itemsData[i] = this.createStyleElement(arr[i], level, dynamicProperties);
	            } else {
	                itemsData[i].style.closed = false;
	            }
	            if(arr[i]._render){
	                container.appendChild(itemsData[i].elem);
	            }
	            ownStyles.push(itemsData[i].style);
	        }else if(arr[i].ty == 'gr'){
	            if(!processedPos){
	                itemsData[i] = this.createGroupElement(arr[i]);
	            } else {
	                jLen = itemsData[i].it.length;
	                for(j=0;j<jLen;j+=1){
	                    itemsData[i].prevViewData[j] = itemsData[i].it[j];
	                }
	            }
	            this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData,itemsData[i].gr,dynamicProperties, level + 1, ownTransformers, render);
	            if(arr[i]._render){
	                container.appendChild(itemsData[i].gr);
	            }
	        }else if(arr[i].ty == 'tr'){
	            if(!processedPos){
	                itemsData[i] = this.createTransformElement(arr[i], dynamicProperties);
	            }
	            currentTransform = itemsData[i].transform;
	            ownTransformers.push(currentTransform);
	        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
	            if(!processedPos){
	                itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level, dynamicProperties);
	            }
	            itemsData[i].elements = this.setElementStyles();
	
	        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd' || arr[i].ty == 'ms'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                modifier.init(this,arr[i],dynamicProperties);
	                itemsData[i] = modifier;
	                this.shapeModifiers.push(modifier);
	            } else {
	                modifier = itemsData[i];
	                modifier.closed = false;
	            }
	            ownModifiers.push(modifier);
	        }else if(arr[i].ty == 'rp'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                itemsData[i] = modifier;
	                modifier.init(this,arr,i,itemsData,dynamicProperties);
	                this.shapeModifiers.push(modifier);
	                render = false;
	            }else{
	                modifier = itemsData[i];
	                modifier.closed = true;
	            }
	            ownModifiers.push(modifier);
	        }
	        this.addProcessedElement(arr[i], i + 1);
	    }
	    len = ownStyles.length;
	    for(i=0;i<len;i+=1){
	        ownStyles[i].closed = true;
	    }
	    len = ownModifiers.length;
	    for(i=0;i<len;i+=1){
	        ownModifiers[i].closed = true;
	    }
	};
	
	IShapeElement.prototype.addShapeToModifiers = function(data) {
	    var i, len = this.shapeModifiers.length;
	    for(i=0;i<len;i+=1){
	        this.shapeModifiers[i].addShape(data);
	    }
	};
	
	IShapeElement.prototype.renderModifiers = function() {
	    if(!this.shapeModifiers.length){
	        return;
	    }
	    var i, len = this.shapes.length;
	    for(i=0;i<len;i+=1){
	        this.shapes[i].reset();
	    }
	
	
	    len = this.shapeModifiers.length;
	
	    for(i=len-1;i>=0;i-=1){
	        this.shapeModifiers[i].processShapes(this.firstFrame);
	    }
	};
	
	IShapeElement.prototype.renderFrame = function(parentMatrix){
	    //this.reloadShapes();
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	    if(this.hidden){
	        this.layerElement.style.display = 'block';
	        this.hidden = false;
	    }
	    this.renderModifiers();
	    var i, len = this.stylesList.length;
	    for(i=0;i<len;i+=1){
	        this.stylesList[i].d = '';
	        this.stylesList[i].mdf = false;
	    }
	    this.renderShape(this.shapesData,this.itemsData, null);
	
	    for (i = 0; i < len; i += 1) {
	        if (this.stylesList[i].ld === '0') {
	            this.stylesList[i].ld = '1';
	            this.stylesList[i].pElem.style.display = 'block';
	            //this.stylesList[i].parent.appendChild(this.stylesList[i].pElem);
	        }
	        if (this.stylesList[i].mdf || this.firstFrame) {
	            this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d);
	            if(this.stylesList[i].msElem){
	                this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
	            }
	        }
	    }
	    if (this.firstFrame) {
	        this.firstFrame = false;
	    }
	};
	
	IShapeElement.prototype.hide = function(){
	    if(!this.hidden){
	        this.layerElement.style.display = 'none';
	        var i, len = this.stylesList.length;
	        for(i=len-1;i>=0;i-=1){
	            if(this.stylesList[i].ld !== '0'){
	                this.stylesList[i].ld = '0';
	                this.stylesList[i].pElem.style.display = 'none';
	                if(this.stylesList[i].pElem.parentNode){
	                    this.stylesList[i].parent = this.stylesList[i].pElem.parentNode;
	                    //this.stylesList[i].pElem.parentNode.removeChild(this.stylesList[i].pElem);
	                }
	            }
	        }
	        this.hidden = true;
	    }
	};
	
	IShapeElement.prototype.renderShape = function(items,data, container){
	    var i, len = items.length - 1;
	    var ty;
	    for(i=len;i>=0;i-=1){
	        ty = items[i].ty;
	        if(ty == 'tr'){
	            if(this.firstFrame || data[i].transform.op.mdf && container){
	                container.setAttribute('opacity',data[i].transform.op.v);
	            }
	            if(this.firstFrame || data[i].transform.mProps.mdf && container){
	                container.setAttribute('transform',data[i].transform.mProps.v.to2dCSS());
	            }
	        }else if(ty == 'sh' || ty == 'el' || ty == 'rc' || ty == 'sr'){
	            this.renderPath(items[i],data[i]);
	        }else if(ty == 'fl'){
	            this.renderFill(items[i],data[i]);
	        }else if(ty == 'gf'){
	            this.renderGradient(items[i],data[i]);
	        }else if(ty == 'gs'){
	            this.renderGradient(items[i],data[i]);
	            this.renderStroke(items[i],data[i]);
	        }else if(ty == 'st'){
	            this.renderStroke(items[i],data[i]);
	        }else if(ty == 'gr'){
	            this.renderShape(items[i].it,data[i].it, data[i].gr);
	        }else if(ty == 'tm'){
	            //
	        }
	    }
	
	};
	
	IShapeElement.prototype.buildShapeString = function(pathNodes, length, closed, mat) {
	    var i, shapeString = '';
	    for(i = 1; i < length; i += 1) {
	        if (i === 1) {
	            shapeString += " M" + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
	        }
	        shapeString += " C" + mat.applyToPointStringified(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1]) + " " + mat.applyToPointStringified(pathNodes.i[i][0], pathNodes.i[i][1]) + " " + mat.applyToPointStringified(pathNodes.v[i][0], pathNodes.v[i][1]);
	    }
	    if (length === 1) {
	        shapeString += " M" + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
	    }
	    if (closed && length) {
	        shapeString += " C" + mat.applyToPointStringified(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1]) + " " + mat.applyToPointStringified(pathNodes.i[0][0], pathNodes.i[0][1]) + " " + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
	        shapeString += 'z';
	    }
	    return shapeString;
	};
	
	IShapeElement.prototype.renderPath = function(pathData,itemData){
	    var len, i, j, jLen,pathStringTransformed,redraw,pathNodes,l, lLen = itemData.elements.length;
	    var lvl = itemData.lvl;
	    if(!pathData._render){
	        return;
	    }
	    for(l=0;l<lLen;l+=1){
	        if(itemData.elements[l].data._render){
	            redraw = itemData.sh.mdf || this.firstFrame;
	            pathStringTransformed = 'M0 0';
	            var paths = itemData.sh.paths;
	            jLen = paths._length;
	            if(itemData.elements[l].lvl < lvl){
	                var mat = this.mHelper.reset(), props;
	                var iterations = lvl - itemData.elements[l].lvl;
	                var k = itemData.transformers.length-1;
	                while(iterations > 0) {
	                    redraw = itemData.transformers[k].mProps.mdf || redraw;
	                    props = itemData.transformers[k].mProps.v.props;
	                    mat.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
	                    iterations --;
	                    k --;
	                }
	                if(redraw){
	                    for(j=0;j<jLen;j+=1){
	                        pathNodes = paths.shapes[j];
	                        if(pathNodes && pathNodes._length){
	                            pathStringTransformed += this.buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
	                        }
	                    }
	                    itemData.caches[l] = pathStringTransformed;
	                } else {
	                    pathStringTransformed = itemData.caches[l];
	                }
	            } else {
	                if(redraw){
	                    for(j=0;j<jLen;j+=1){
	                        pathNodes = paths.shapes[j];
	                        if(pathNodes && pathNodes._length){
	                            pathStringTransformed += this.buildShapeString(pathNodes, pathNodes._length, pathNodes.c, this.identityMatrix);
	                        }
	                    }
	                    itemData.caches[l] = pathStringTransformed;
	                } else {
	                    pathStringTransformed = itemData.caches[l];
	                }
	            }
	            itemData.elements[l].d += pathStringTransformed;
	            itemData.elements[l].mdf = redraw || itemData.elements[l].mdf;
	        } else {
	            itemData.elements[l].mdf = true;
	        }
	    }
	};
	
	IShapeElement.prototype.renderFill = function(styleData,itemData){
	    var styleElem = itemData.style;
	
	    if(itemData.c.mdf || this.firstFrame){
	        styleElem.pElem.setAttribute('fill','rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')');
	        ////styleElem.pElem.style.fill = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
	    }
	    if(itemData.o.mdf || this.firstFrame){
	        styleElem.pElem.setAttribute('fill-opacity',itemData.o.v);
	    }
	};
	
	IShapeElement.prototype.renderGradient = function(styleData,itemData){
	    var gfill = itemData.gf;
	    var opFill = itemData.of;
	    var pt1 = itemData.s.v,pt2 = itemData.e.v;
	
	    if(itemData.o.mdf || this.firstFrame){
	        var attr = styleData.ty === 'gf' ? 'fill-opacity':'stroke-opacity';
	        itemData.elem.setAttribute(attr,itemData.o.v);
	    }
	    //clippedElement.setAttribute('transform','matrix(1,0,0,1,-100,0)');
	    if(itemData.s.mdf || this.firstFrame){
	        var attr1 = styleData.t === 1 ? 'x1':'cx';
	        var attr2 = attr1 === 'x1' ? 'y1':'cy';
	        gfill.setAttribute(attr1,pt1[0]);
	        gfill.setAttribute(attr2,pt1[1]);
	        if(opFill){
	            opFill.setAttribute(attr1,pt1[0]);
	            opFill.setAttribute(attr2,pt1[1]);
	        }
	    }
	    var stops, i, len, stop;
	    if(itemData.g.cmdf || this.firstFrame){
	        stops = itemData.cst;
	        var cValues = itemData.g.c;
	        len = stops.length;
	        for(i=0;i<len;i+=1){
	            stop = stops[i];
	            stop.setAttribute('offset',cValues[i*4]+'%');
	            stop.setAttribute('stop-color','rgb('+cValues[i*4+1]+','+cValues[i*4+2]+','+cValues[i*4+3]+')');
	        }
	    }
	    if(opFill && (itemData.g.omdf || this.firstFrame)){
	        stops = itemData.ost;
	        var oValues = itemData.g.o;
	        len = stops.length;
	        for(i=0;i<len;i+=1){
	            stop = stops[i];
	            stop.setAttribute('offset',oValues[i*2]+'%');
	            stop.setAttribute('stop-opacity',oValues[i*2+1]);
	        }
	    }
	    if(styleData.t === 1){
	        if(itemData.e.mdf  || this.firstFrame){
	            gfill.setAttribute('x2',pt2[0]);
	            gfill.setAttribute('y2',pt2[1]);
	            if(opFill){
	                opFill.setAttribute('x2',pt2[0]);
	                opFill.setAttribute('y2',pt2[1]);
	            }
	        }
	    } else {
	        var rad;
	        if(itemData.s.mdf || itemData.e.mdf || this.firstFrame){
	            rad = Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));
	            gfill.setAttribute('r',rad);
	            if(opFill){
	                opFill.setAttribute('r',rad);
	            }
	        }
	        if(itemData.e.mdf || itemData.h.mdf || itemData.a.mdf || this.firstFrame){
	            if(!rad){
	                rad = Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));
	            }
	            var ang = Math.atan2(pt2[1]-pt1[1], pt2[0]-pt1[0]);
	
	            var percent = itemData.h.v >= 1 ? 0.99 : itemData.h.v <= -1 ? -0.99:itemData.h.v;
	            var dist = rad*percent;
	            var x = Math.cos(ang + itemData.a.v)*dist + pt1[0];
	            var y = Math.sin(ang + itemData.a.v)*dist + pt1[1];
	            gfill.setAttribute('fx',x);
	            gfill.setAttribute('fy',y);
	            if(opFill){
	                opFill.setAttribute('fx',x);
	                opFill.setAttribute('fy',y);
	            }
	        }
	        //gfill.setAttribute('fy','200');
	    }
	};
	
	IShapeElement.prototype.renderStroke = function(styleData,itemData){
	    var styleElem = itemData.style;
	    //TODO fix dashes
	    var d = itemData.d;
	    var dasharray,dashoffset;
	    if(d && d.k && (d.mdf || this.firstFrame)){
	        styleElem.pElem.setAttribute('stroke-dasharray', d.dasharray);
	        ////styleElem.pElem.style.strokeDasharray = d.dasharray;
	        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset);
	        ////styleElem.pElem.style.strokeDashoffset = d.dashoffset;
	    }
	    if(itemData.c && (itemData.c.mdf || this.firstFrame)){
	        styleElem.pElem.setAttribute('stroke','rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')');
	        ////styleElem.pElem.style.stroke = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
	    }
	    if(itemData.o.mdf || this.firstFrame){
	        styleElem.pElem.setAttribute('stroke-opacity',itemData.o.v);
	    }
	    if(itemData.w.mdf || this.firstFrame){
	        styleElem.pElem.setAttribute('stroke-width',itemData.w.v);
	        if(styleElem.msElem){
	            styleElem.msElem.setAttribute('stroke-width',itemData.w.v);
	        }
	        ////styleElem.pElem.style.strokeWidth = itemData.w.v;
	    }
	};
	
	IShapeElement.prototype.destroy = function(){
	    this._parent.destroy.call(this._parent);
	    this.shapeData = null;
	    this.itemsData = null;
	    this.parentContainer = null;
	    this.placeholder = null;
	};
	
	function ITextElement(data, animationItem,parentContainer,globalData){
	}
	ITextElement.prototype.init = function(){
	    this._parent.init.call(this);
	
	    this.lettersChangedFlag = false;
	    this.currentTextDocumentData = {};
	    var data = this.data;
	    this.viewData = {
	        m:{
	            a: PropertyFactory.getProp(this,data.t.m.a,1,0,this.dynamicProperties)
	        }
	    };
	    var textData = this.data.t;
	    if(textData.a.length){
	        this.viewData.a = Array.apply(null,{length:textData.a.length});
	        var i, len = textData.a.length, animatorData, animatorProps;
	        for(i=0;i<len;i+=1){
	            animatorProps = textData.a[i];
	            animatorData = {
	                a: {},
	                s: {}
	            };
	            if('r' in animatorProps.a) {
	                animatorData.a.r = PropertyFactory.getProp(this,animatorProps.a.r,0,degToRads,this.dynamicProperties);
	            }
	            if('rx' in animatorProps.a) {
	                animatorData.a.rx = PropertyFactory.getProp(this,animatorProps.a.rx,0,degToRads,this.dynamicProperties);
	            }
	            if('ry' in animatorProps.a) {
	                animatorData.a.ry = PropertyFactory.getProp(this,animatorProps.a.ry,0,degToRads,this.dynamicProperties);
	            }
	            if('sk' in animatorProps.a) {
	                animatorData.a.sk = PropertyFactory.getProp(this,animatorProps.a.sk,0,degToRads,this.dynamicProperties);
	            }
	            if('sa' in animatorProps.a) {
	                animatorData.a.sa = PropertyFactory.getProp(this,animatorProps.a.sa,0,degToRads,this.dynamicProperties);
	            }
	            if('s' in animatorProps.a) {
	                animatorData.a.s = PropertyFactory.getProp(this,animatorProps.a.s,1,0.01,this.dynamicProperties);
	            }
	            if('a' in animatorProps.a) {
	                animatorData.a.a = PropertyFactory.getProp(this,animatorProps.a.a,1,0,this.dynamicProperties);
	            }
	            if('o' in animatorProps.a) {
	                animatorData.a.o = PropertyFactory.getProp(this,animatorProps.a.o,0,0.01,this.dynamicProperties);
	            }
	            if('p' in animatorProps.a) {
	                animatorData.a.p = PropertyFactory.getProp(this,animatorProps.a.p,1,0,this.dynamicProperties);
	            }
	            if('sw' in animatorProps.a) {
	                animatorData.a.sw = PropertyFactory.getProp(this,animatorProps.a.sw,0,0,this.dynamicProperties);
	            }
	            if('sc' in animatorProps.a) {
	                animatorData.a.sc = PropertyFactory.getProp(this,animatorProps.a.sc,1,0,this.dynamicProperties);
	            }
	            if('fc' in animatorProps.a) {
	                animatorData.a.fc = PropertyFactory.getProp(this,animatorProps.a.fc,1,0,this.dynamicProperties);
	            }
	            if('fh' in animatorProps.a) {
	                animatorData.a.fh = PropertyFactory.getProp(this,animatorProps.a.fh,0,0,this.dynamicProperties);
	            }
	            if('fs' in animatorProps.a) {
	                animatorData.a.fs = PropertyFactory.getProp(this,animatorProps.a.fs,0,0.01,this.dynamicProperties);
	            }
	            if('fb' in animatorProps.a) {
	                animatorData.a.fb = PropertyFactory.getProp(this,animatorProps.a.fb,0,0.01,this.dynamicProperties);
	            }
	            if('t' in animatorProps.a) {
	                animatorData.a.t = PropertyFactory.getProp(this,animatorProps.a.t,0,0,this.dynamicProperties);
	            }
	            animatorData.s = PropertyFactory.getTextSelectorProp(this,animatorProps.s,this.dynamicProperties);
	            animatorData.s.t = animatorProps.s.t;
	            this.viewData.a[i] = animatorData;
	        }
	    }else{
	        this.viewData.a = [];
	    }
	    if(textData.p && 'm' in textData.p){
	        this.viewData.p = {
	            f: PropertyFactory.getProp(this,textData.p.f,0,0,this.dynamicProperties),
	            l: PropertyFactory.getProp(this,textData.p.l,0,0,this.dynamicProperties),
	            r: textData.p.r,
	            m: this.maskManager.getMaskProperty(textData.p.m)
	        };
	        this.maskPath = true;
	    } else {
	        this.maskPath = false;
	    }
	};
	ITextElement.prototype.prepareFrame = function(num) {
	    var i = 0, len = this.data.t.d.k.length;
	    var textDocumentData = this.data.t.d.k[i].s;
	    i += 1;
	    while(i<len){
	        if(this.data.t.d.k[i].t > num){
	            break;
	        }
	        textDocumentData = this.data.t.d.k[i].s;
	        i += 1;
	    }
	    this.lettersChangedFlag = false;
	    if(textDocumentData !== this.currentTextDocumentData){
	        this.currentTextDocumentData = textDocumentData;
	        this.lettersChangedFlag = true;
	        this.buildNewText();
	    }
	    this._parent.prepareFrame.call(this, num);
	}
	
	ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
	    var j,jLen = shapes.length;
	    var k, kLen, pathNodes;
	    var shapeStr = '';
	    for(j=0;j<jLen;j+=1){
	        pathNodes = shapes[j].ks.k;
	        shapeStr += this.buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
	        /*kLen = pathNodes.i.length;
	        for(k=1;k<kLen;k+=1){
	            if(k==1){
	                shapeStr += " M"+matrixHelper.applyToPointStringified(pathNodes.v[0][0],pathNodes.v[0][1]);
	            }
	            shapeStr += " C"+matrixHelper.applyToPointStringified(pathNodes.o[k-1][0],pathNodes.o[k-1][1]) + " "+matrixHelper.applyToPointStringified(pathNodes.i[k][0],pathNodes.i[k][1]) + " "+matrixHelper.applyToPointStringified(pathNodes.v[k][0],pathNodes.v[k][1]);
	        }
	        shapeStr += " C"+matrixHelper.applyToPointStringified(pathNodes.o[k-1][0],pathNodes.o[k-1][1]) + " "+matrixHelper.applyToPointStringified(pathNodes.i[0][0],pathNodes.i[0][1]) + " "+matrixHelper.applyToPointStringified(pathNodes.v[0][0],pathNodes.v[0][1]);
	        shapeStr += 'z';*/
	    }
	    return shapeStr;
	};
	
	ITextElement.prototype.getMeasures = function(){
	
	    var matrixHelper = this.mHelper;
	    var renderType = this.renderType;
	    var data = this.data;
	    var xPos,yPos;
	    var i, len;
	    var documentData = this.currentTextDocumentData;
	    var letters = documentData.l;
	    if(this.maskPath) {
	        var mask = this.viewData.p.m;
	        if(!this.viewData.p.n || this.viewData.p.mdf){
	            var paths = mask.v;
	            if(this.viewData.p.r){
	                paths = reversePath(paths);
	            }
	            var pathInfo = {
	                tLength: 0,
	                segments: []
	            };
	            len = paths.v.length - 1;
	            var pathData;
	            var totalLength = 0;
	            for (i = 0; i < len; i += 1) {
	                pathData = {
	                    s: paths.v[i],
	                    e: paths.v[i + 1],
	                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
	                    ti: [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]
	                };
	                bez.buildBezierData(pathData);
	                pathInfo.tLength += pathData.bezierData.segmentLength;
	                pathInfo.segments.push(pathData);
	                totalLength += pathData.bezierData.segmentLength;
	            }
	            i = len;
	            if (mask.v.c) {
	                pathData = {
	                    s: paths.v[i],
	                    e: paths.v[0],
	                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
	                    ti: [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]
	                };
	                bez.buildBezierData(pathData);
	                pathInfo.tLength += pathData.bezierData.segmentLength;
	                pathInfo.segments.push(pathData);
	                totalLength += pathData.bezierData.segmentLength;
	            }
	            this.viewData.p.pi = pathInfo;
	        }
	        var pathInfo = this.viewData.p.pi;
	
	        var currentLength = this.viewData.p.f.v, segmentInd = 0, pointInd = 1, currentPoint, prevPoint, points;
	        var segmentLength = 0, flag = true;
	        var segments = pathInfo.segments;
	        if (currentLength < 0 && mask.v.c) {
	            if (pathInfo.tLength < Math.abs(currentLength)) {
	                currentLength = -Math.abs(currentLength) % pathInfo.tLength;
	            }
	            segmentInd = segments.length - 1;
	            points = segments[segmentInd].bezierData.points;
	            pointInd = points.length - 1;
	            while (currentLength < 0) {
	                currentLength += points[pointInd].partialLength;
	                pointInd -= 1;
	                if (pointInd < 0) {
	                    segmentInd -= 1;
	                    points = segments[segmentInd].bezierData.points;
	                    pointInd = points.length - 1;
	                }
	            }
	
	        }
	        points = segments[segmentInd].bezierData.points;
	        prevPoint = points[pointInd - 1];
	        currentPoint = points[pointInd];
	        var partialLength = currentPoint.partialLength;
	        var perc, tanAngle;
	    }
	
	
	    len = letters.length;
	    xPos = 0;
	    yPos = 0;
	    var yOff = documentData.s*1.2*.714;
	    var firstLine = true;
	    var renderedData = this.viewData, animatorProps, animatorSelector;
	    var j, jLen;
	    var lettersValue = Array.apply(null,{length:len}), letterValue;
	
	    jLen = renderedData.a.length;
	    var lastLetter;
	
	    var mult, ind = -1, offf, xPathPos, yPathPos;
	    var initPathPos = currentLength,initSegmentInd = segmentInd, initPointInd = pointInd, currentLine = -1;
	    var elemOpacity;
	    var sc,sw,fc,k;
	    var lineLength = 0;
	    var letterSw,letterSc,letterFc,letterM,letterP,letterO;
	    for( i = 0; i < len; i += 1) {
	        matrixHelper.reset();
	        elemOpacity = 1;
	        if(letters[i].n) {
	            xPos = 0;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            currentLength = initPathPos ;
	            firstLine = false;
	            lineLength = 0;
	            if(this.maskPath) {
	                segmentInd = initSegmentInd;
	                pointInd = initPointInd;
	                points = segments[segmentInd].bezierData.points;
	                prevPoint = points[pointInd - 1];
	                currentPoint = points[pointInd];
	                partialLength = currentPoint.partialLength;
	                segmentLength = 0;
	            }
	            lettersValue[i] = this.emptyProp;
	        }else{
	            if(this.maskPath) {
	                if(currentLine !== letters[i].line){
	                    switch(documentData.j){
	                        case 1:
	                            currentLength += totalLength - documentData.lineWidths[letters[i].line];
	                            break;
	                        case 2:
	                            currentLength += (totalLength - documentData.lineWidths[letters[i].line])/2;
	                            break;
	                    }
	                    currentLine = letters[i].line;
	                }
	                if (ind !== letters[i].ind) {
	                    if (letters[ind]) {
	                        currentLength += letters[ind].extra;
	                    }
	                    currentLength += letters[i].an / 2;
	                    ind = letters[i].ind;
	                }
	                currentLength += renderedData.m.a.v[0] * letters[i].an / 200;
	                var animatorOffset = 0;
	                for (j = 0; j < jLen; j += 1) {
	                    animatorProps = renderedData.a[j].a;
	                    if ('p' in animatorProps) {
	                        animatorSelector = renderedData.a[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
	                        if(mult.length){
	                            animatorOffset += animatorProps.p.v[0] * mult[0];
	                        } else{
	                            animatorOffset += animatorProps.p.v[0] * mult;
	                        }
	
	                    }
	                    if ('a' in animatorProps) {
	                        animatorSelector = renderedData.a[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
	                        if(mult.length){
	                            animatorOffset += animatorProps.a.v[0] * mult[0];
	                        } else{
	                            animatorOffset += animatorProps.a.v[0] * mult;
	                        }
	
	                    }
	                }
	                flag = true;
	                while (flag) {
	                    if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
	                        perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
	                        xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
	                        yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
	                        matrixHelper.translate(-renderedData.m.a.v[0]*letters[i].an/200, -(renderedData.m.a.v[1] * yOff / 100));
	                        flag = false;
	                    } else if (points) {
	                        segmentLength += currentPoint.partialLength;
	                        pointInd += 1;
	                        if (pointInd >= points.length) {
	                            pointInd = 0;
	                            segmentInd += 1;
	                            if (!segments[segmentInd]) {
	                                if (mask.v.c) {
	                                    pointInd = 0;
	                                    segmentInd = 0;
	                                    points = segments[segmentInd].bezierData.points;
	                                } else {
	                                    segmentLength -= currentPoint.partialLength;
	                                    points = null;
	                                }
	                            } else {
	                                points = segments[segmentInd].bezierData.points;
	                            }
	                        }
	                        if (points) {
	                            prevPoint = currentPoint;
	                            currentPoint = points[pointInd];
	                            partialLength = currentPoint.partialLength;
	                        }
	                    }
	                }
	                offf = letters[i].an / 2 - letters[i].add;
	                matrixHelper.translate(-offf, 0, 0);
	            } else {
	                offf = letters[i].an/2 - letters[i].add;
	                matrixHelper.translate(-offf,0,0);
	
	                // Grouping alignment
	                matrixHelper.translate(-renderedData.m.a.v[0]*letters[i].an/200, -renderedData.m.a.v[1]*yOff/100, 0);
	            }
	
	            lineLength += letters[i].l/2;
	            for(j=0;j<jLen;j+=1){
	                animatorProps = renderedData.a[j].a;
	                if ('t' in animatorProps) {
	                    animatorSelector = renderedData.a[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
	                    if(this.maskPath) {
	                        if(mult.length) {
	                            currentLength += animatorProps.t*mult[0];
	                        } else {
	                            currentLength += animatorProps.t*mult;
	                        }
	                    }else{
	                        if(mult.length) {
	                            xPos += animatorProps.t.v*mult[0];
	                        } else {
	                            xPos += animatorProps.t.v*mult;
	                        }
	                    }
	                }
	            }
	            lineLength += letters[i].l/2;
	            if(documentData.strokeWidthAnim) {
	                sw = documentData.sw || 0;
	            }
	            if(documentData.strokeColorAnim) {
	                if(documentData.sc){
	                    sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
	                }else{
	                    sc = [0,0,0];
	                }
	            }
	            if(documentData.fillColorAnim) {
	                fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
	            }
	            for(j=0;j<jLen;j+=1){
	                animatorProps = renderedData.a[j].a;
	                if ('a' in animatorProps) {
	                    animatorSelector = renderedData.a[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
	
	                    if(mult.length){
	                        matrixHelper.translate(-animatorProps.a.v[0]*mult[0], -animatorProps.a.v[1]*mult[1], animatorProps.a.v[2]*mult[2]);
	                    } else {
	                        matrixHelper.translate(-animatorProps.a.v[0]*mult, -animatorProps.a.v[1]*mult, animatorProps.a.v[2]*mult);
	                    }
	                }
	            }
	            for(j=0;j<jLen;j+=1){
	                animatorProps = renderedData.a[j].a;
	                if ('s' in animatorProps) {
	                    animatorSelector = renderedData.a[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
	                    if(mult.length){
	                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult[0]),1+((animatorProps.s.v[1]-1)*mult[1]),1);
	                    } else {
	                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult),1+((animatorProps.s.v[1]-1)*mult),1);
	                    }
	                }
	            }
	            for(j=0;j<jLen;j+=1) {
	                animatorProps = renderedData.a[j].a;
	                animatorSelector = renderedData.a[j].s;
	                mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
	                if ('sk' in animatorProps) {
	                    if(mult.length) {
	                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
	                    } else {
	                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
	                    }
	                }
	                if ('r' in animatorProps) {
	                    if(mult.length) {
	                        matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
	                    } else {
	                        matrixHelper.rotateZ(-animatorProps.r.v * mult);
	                    }
	                }
	                if ('ry' in animatorProps) {
	
	                    if(mult.length) {
	                        matrixHelper.rotateY(animatorProps.ry.v*mult[1]);
	                    }else{
	                        matrixHelper.rotateY(animatorProps.ry.v*mult);
	                    }
	                }
	                if ('rx' in animatorProps) {
	                    if(mult.length) {
	                        matrixHelper.rotateX(animatorProps.rx.v*mult[0]);
	                    } else {
	                        matrixHelper.rotateX(animatorProps.rx.v*mult);
	                    }
	                }
	                if ('o' in animatorProps) {
	                    if(mult.length) {
	                        elemOpacity += ((animatorProps.o.v)*mult[0] - elemOpacity)*mult[0];
	                    } else {
	                        elemOpacity += ((animatorProps.o.v)*mult - elemOpacity)*mult;
	                    }
	                }
	                if (documentData.strokeWidthAnim && 'sw' in animatorProps) {
	                    if(mult.length) {
	                        sw += animatorProps.sw.v*mult[0];
	                    } else {
	                        sw += animatorProps.sw.v*mult;
	                    }
	                }
	                if (documentData.strokeColorAnim && 'sc' in animatorProps) {
	                    for(k=0;k<3;k+=1){
	                        if(mult.length) {
	                            sc[k] = Math.round(255*(sc[k] + (animatorProps.sc.v[k] - sc[k])*mult[0]));
	                        } else {
	                            sc[k] = Math.round(255*(sc[k] + (animatorProps.sc.v[k] - sc[k])*mult));
	                        }
	                    }
	                }
	                if (documentData.fillColorAnim) {
	                    if('fc' in animatorProps){
	                        for(k=0;k<3;k+=1){
	                            if(mult.length) {
	                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult[0];
	                            } else {
	                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult;
	                                //console.log('mult',mult);
	                                //console.log(Math.round(fc[k] + (animatorProps.fc.v[k] - fc[k])*mult));
	                            }
	                        }
	                    }
	                    if('fh' in animatorProps){
	                        if(mult.length) {
	                            fc = addHueToRGB(fc,animatorProps.fh.v*mult[0]);
	                        } else {
	                            fc = addHueToRGB(fc,animatorProps.fh.v*mult);
	                        }
	                    }
	                    if('fs' in animatorProps){
	                        if(mult.length) {
	                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult[0]);
	                        } else {
	                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult);
	                        }
	                    }
	                    if('fb' in animatorProps){
	                        if(mult.length) {
	                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult[0]);
	                        } else {
	                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult);
	                        }
	                    }
	                }
	            }
	
	            for(j=0;j<jLen;j+=1){
	                animatorProps = renderedData.a[j].a;
	
	                if ('p' in animatorProps) {
	                    animatorSelector = renderedData.a[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
	                    if(this.maskPath) {
	                        if(mult.length) {
	                            matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
	                        } else {
	                            matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	                        }
	                    }else{
	                        if(mult.length) {
	                            matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
	                        } else {
	                            matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	                        }
	                    }
	                }
	            }
	            if(documentData.strokeWidthAnim){
	                letterSw = sw < 0 ? 0 : sw;
	            }
	            if(documentData.strokeColorAnim){
	                letterSc = 'rgb('+Math.round(sc[0]*255)+','+Math.round(sc[1]*255)+','+Math.round(sc[2]*255)+')';
	            }
	            if(documentData.fillColorAnim){
	                letterFc = 'rgb('+Math.round(fc[0]*255)+','+Math.round(fc[1]*255)+','+Math.round(fc[2]*255)+')';
	            }
	
	            if(this.maskPath) {
	                matrixHelper.translate(0,-documentData.ls);
	
	                matrixHelper.translate(0, renderedData.m.a.v[1]*yOff/100 + yPos,0);
	                if (data.t.p.p) {
	                    tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
	                    var rot = Math.atan(tanAngle) * 180 / Math.PI;
	                    if (currentPoint.point[0] < prevPoint.point[0]) {
	                        rot += 180;
	                    }
	                    matrixHelper.rotate(-rot * Math.PI / 180);
	                }
	                matrixHelper.translate(xPathPos, yPathPos, 0);
	                currentLength -= renderedData.m.a.v[0]*letters[i].an/200;
	                if(letters[i+1] && ind !== letters[i+1].ind){
	                    currentLength += letters[i].an / 2;
	                    currentLength += documentData.tr/1000*documentData.s;
	                }
	            }else{
	
	                matrixHelper.translate(xPos,yPos,0);
	
	                if(documentData.ps){
	                    //matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
	                    matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
	                }
	                switch(documentData.j){
	                    case 1:
	                        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]),0,0);
	                        break;
	                    case 2:
	                        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line])/2,0,0);
	                        break;
	                }
	                matrixHelper.translate(0,-documentData.ls);
	                matrixHelper.translate(offf,0,0);
	                matrixHelper.translate(renderedData.m.a.v[0]*letters[i].an/200,renderedData.m.a.v[1]*yOff/100,0);
	                xPos += letters[i].l + documentData.tr/1000*documentData.s;
	            }
	            if(renderType === 'html'){
	                letterM = matrixHelper.toCSS();
	            }else if(renderType === 'svg'){
	                letterM = matrixHelper.to2dCSS();
	            }else{
	                letterP = [matrixHelper.props[0],matrixHelper.props[1],matrixHelper.props[2],matrixHelper.props[3],matrixHelper.props[4],matrixHelper.props[5],matrixHelper.props[6],matrixHelper.props[7],matrixHelper.props[8],matrixHelper.props[9],matrixHelper.props[10],matrixHelper.props[11],matrixHelper.props[12],matrixHelper.props[13],matrixHelper.props[14],matrixHelper.props[15]];
	            }
	            letterO = elemOpacity;
	
	            lastLetter = this.renderedLetters[i];
	            if(lastLetter && (lastLetter.o !== letterO || lastLetter.sw !== letterSw || lastLetter.sc !== letterSc || lastLetter.fc !== letterFc)){
	                this.lettersChangedFlag = true;
	                letterValue = new LetterProps(letterO,letterSw,letterSc,letterFc,letterM,letterP);
	            }else{
	                if((renderType === 'svg' || renderType === 'html') && (!lastLetter || lastLetter.m !== letterM)){
	                    this.lettersChangedFlag = true;
	                    letterValue = new LetterProps(letterO,letterSw,letterSc,letterFc,letterM);
	                }else if(renderType === 'canvas' && (!lastLetter || (lastLetter.props[0] !== letterP[0] || lastLetter.props[1] !== letterP[1] || lastLetter.props[4] !== letterP[4] || lastLetter.props[5] !== letterP[5] || lastLetter.props[12] !== letterP[12] || lastLetter.props[13] !== letterP[13]))){
	                    this.lettersChangedFlag = true;
	                    letterValue = new LetterProps(letterO,letterSw,letterSc,letterFc,null,letterP);
	                } else {
	                    letterValue = lastLetter;
	                }
	            }
	            this.renderedLetters[i] = letterValue;
	        }
	    }
	};
	
	ITextElement.prototype.buildShapeString = IShapeElement.prototype.buildShapeString;
	
	ITextElement.prototype.emptyProp = new LetterProps();
	
	function SVGTextElement(data,parentContainer,globalData,comp, placeholder){
	    this.textSpans = [];
	    this.renderType = 'svg';
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	}
	createElement(SVGBaseElement, SVGTextElement);
	
	SVGTextElement.prototype.init = ITextElement.prototype.init;
	SVGTextElement.prototype.createPathShape = ITextElement.prototype.createPathShape;
	SVGTextElement.prototype.getMeasures = ITextElement.prototype.getMeasures;
	SVGTextElement.prototype.prepareFrame = ITextElement.prototype.prepareFrame;
	SVGTextElement.prototype.buildShapeString = ITextElement.prototype.buildShapeString;
	
	SVGTextElement.prototype.createElements = function(){
	
	    this._parent.createElements.call(this);
	
	
	    if(this.data.ln){
	        this.layerElement.setAttribute('id',this.data.ln);
	    }
	    if(this.data.cl){
	        this.layerElement.setAttribute('class',this.data.cl);
	    }
	};
	
	SVGTextElement.prototype.buildNewText = function(){
	    var i, len;
	
	    var documentData = this.currentTextDocumentData;
	    this.renderedLetters = Array.apply(null,{length:this.currentTextDocumentData.l ? this.currentTextDocumentData.l.length : 0});
	    if(documentData.fc) {
	        this.layerElement.setAttribute('fill', 'rgb(' + Math.round(documentData.fc[0]*255) + ',' + Math.round(documentData.fc[1]*255) + ',' + Math.round(documentData.fc[2]*255) + ')');
	    }else{
	        this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
	    }
	    if(documentData.sc){
	        this.layerElement.setAttribute('stroke', 'rgb(' + Math.round(documentData.sc[0]*255) + ',' + Math.round(documentData.sc[1]*255) + ',' + Math.round(documentData.sc[2]*255) + ')');
	        this.layerElement.setAttribute('stroke-width', documentData.sw);
	    }
	    this.layerElement.setAttribute('font-size', documentData.s);
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    if(fontData.fClass){
	        this.layerElement.setAttribute('class',fontData.fClass);
	    } else {
	        this.layerElement.setAttribute('font-family', fontData.fFamily);
	        var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
	        this.layerElement.setAttribute('font-style', fStyle);
	        this.layerElement.setAttribute('font-weight', fWeight);
	    }
	
	
	
	    var letters = documentData.l || [];
	    len = letters.length;
	    if(!len){
	        return;
	    }
	    var tSpan;
	    var matrixHelper = this.mHelper;
	    var shapes, shapeStr = '', singleShape = this.data.singleShape;
	    if (singleShape) {
	        var xPos = 0, yPos = 0, lineWidths = documentData.lineWidths, boxWidth = documentData.boxWidth, firstLine = true;
	    }
	    var cnt = 0;
	    for (i = 0;i < len ;i += 1) {
	        if(this.globalData.fontManager.chars){
	            if(!singleShape || i === 0){
	                tSpan = this.textSpans[cnt] ? this.textSpans[cnt] : document.createElementNS(svgNS,'path');
	            }
	        }else{
	            tSpan = this.textSpans[cnt] ? this.textSpans[cnt] : document.createElementNS(svgNS,'text');
	        }
	        tSpan.style.display = 'inherit';
	        tSpan.setAttribute('stroke-linecap', 'butt');
	        tSpan.setAttribute('stroke-linejoin','round');
	        tSpan.setAttribute('stroke-miterlimit','4');
	        //tSpan.setAttribute('visibility', 'hidden');
	        if(singleShape && letters[i].n) {
	            xPos = 0;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            firstLine = false;
	        }
	        matrixHelper.reset();
	        if(this.globalData.fontManager.chars) {
	            matrixHelper.scale(documentData.s / 100, documentData.s / 100);
	        }
	        if (singleShape) {
	            if(documentData.ps){
	                matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
	            }
	            matrixHelper.translate(0,-documentData.ls,0);
	            switch(documentData.j){
	                case 1:
	                    matrixHelper.translate(documentData.justifyOffset + (boxWidth - lineWidths[letters[i].line]),0,0);
	                    break;
	                case 2:
	                    matrixHelper.translate(documentData.justifyOffset + (boxWidth - lineWidths[letters[i].line])/2,0,0);
	                    break;
	            }
	            matrixHelper.translate(xPos, yPos, 0);
	        }
	        if(this.globalData.fontManager.chars){
	            var charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	            var shapeData;
	            if(charData){
	                shapeData = charData.data;
	            } else {
	                shapeData = null;
	            }
	            if(shapeData && shapeData.shapes){
	                shapes = shapeData.shapes[0].it;
	                if(!singleShape){
	                    shapeStr = '';
	                }
	                shapeStr += this.createPathShape(matrixHelper,shapes);
	                if(!singleShape){
	
	                    tSpan.setAttribute('d',shapeStr);
	                }
	            }
	            if(!singleShape){
	                this.layerElement.appendChild(tSpan);
	            }
	        }else{
	            tSpan.textContent = letters[i].val;
	            tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
	            this.layerElement.appendChild(tSpan);
	            if(singleShape){
	                tSpan.setAttribute('transform',matrixHelper.to2dCSS());
	            }
	        }
	        if(singleShape) {
	            xPos += letters[i].l || 0;
	            xPos += documentData.tr/1000*documentData.s;
	        }
	        //
	        this.textSpans[cnt] = tSpan;
	        cnt += 1;
	    }
	    if(!singleShape){
	        while(cnt < this.textSpans.length){
	            this.textSpans[cnt].style.display = 'none';
	            cnt += 1;
	        }
	    }
	    if(singleShape && this.globalData.fontManager.chars){
	        tSpan.setAttribute('d',shapeStr);
	        this.layerElement.appendChild(tSpan);
	    }
	}
	
	SVGTextElement.prototype.renderFrame = function(parentMatrix){
	
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	    if(this.hidden){
	        this.show();
	    }
	
	    if(this.data.singleShape){
	        return;
	    }
	    this.getMeasures();
	    if(!this.lettersChangedFlag){
	        return;
	    }
	    var  i,len;
	    var renderedLetters = this.renderedLetters;
	
	    var letters = this.currentTextDocumentData.l;
	
	    len = letters.length;
	    var renderedLetter;
	    for(i=0;i<len;i+=1){
	        if(letters[i].n){
	            continue;
	        }
	        renderedLetter = renderedLetters[i];
	        this.textSpans[i].setAttribute('transform',renderedLetter.m);
	        this.textSpans[i].setAttribute('opacity',renderedLetter.o);
	        if(renderedLetter.sw){
	            this.textSpans[i].setAttribute('stroke-width',renderedLetter.sw);
	        }
	        if(renderedLetter.sc){
	            this.textSpans[i].setAttribute('stroke',renderedLetter.sc);
	        }
	        if(renderedLetter.fc){
	            this.textSpans[i].setAttribute('fill',renderedLetter.fc);
	        }
	    }
	    if(this.firstFrame) {
	        this.firstFrame = false;
	    }
	}
	
	
	SVGTextElement.prototype.destroy = function(){
	    this._parent.destroy.call(this._parent);
	};
	function SVGTintFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
	    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f1');
	    filter.appendChild(feColorMatrix);
	    feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f2');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	    if(filterManager.effectElements[2].p.v !== 100 || filterManager.effectElements[2].p.k){
	        var feMerge = document.createElementNS(svgNS,'feMerge');
	        filter.appendChild(feMerge);
	        var feMergeNode;
	        feMergeNode = document.createElementNS(svgNS,'feMergeNode');
	        feMergeNode.setAttribute('in','SourceGraphic');
	        feMerge.appendChild(feMergeNode);
	        feMergeNode = document.createElementNS(svgNS,'feMergeNode');
	        feMergeNode.setAttribute('in','f2');
	        feMerge.appendChild(feMergeNode);
	    }
	}
	
	SVGTintFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager.mdf){
	        var colorBlack = this.filterManager.effectElements[0].p.v;
	        var colorWhite = this.filterManager.effectElements[1].p.v;
	        var opacity = this.filterManager.effectElements[2].p.v/100;
	        this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
	    }
	};
	function SVGFillFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	}
	SVGFillFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager.mdf){
	        var color = this.filterManager.effectElements[2].p.v;
	        var opacity = this.filterManager.effectElements[6].p.v;
	        this.matrixFilter.setAttribute('values','0 0 0 0 '+color[0]+' 0 0 0 0 '+color[1]+' 0 0 0 0 '+color[2]+' 0 0 0 '+opacity+' 0');
	    }
	};
	function SVGStrokeEffect(elem, filterManager){
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.elem = elem;
	    this.paths = [];
	}
	
	SVGStrokeEffect.prototype.initialize = function(){
	
	    var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	    var path,groupPath, i, len;
	    if(this.filterManager.effectElements[1].p.v === 1){
	        len = this.elem.maskManager.masksProperties.length;
	        i = 0;
	    } else {
	        i = this.filterManager.effectElements[0].p.v - 1;
	        len = i + 1;
	    }
	    groupPath = document.createElementNS(svgNS,'g'); 
	    groupPath.setAttribute('fill','none');
	    groupPath.setAttribute('stroke-linecap','round');
	    groupPath.setAttribute('stroke-dashoffset',1);
	    for(i;i<len;i+=1){
	        path = document.createElementNS(svgNS,'path');
	        groupPath.appendChild(path);
	        this.paths.push({p:path,m:i});
	    }
	    if(this.filterManager.effectElements[10].p.v === 3){
	        var mask = document.createElementNS(svgNS,'mask');
	        var id = 'stms_' + randomString(10);
	        mask.setAttribute('id',id);
	        mask.setAttribute('mask-type','alpha');
	        mask.appendChild(groupPath);
	        this.elem.globalData.defs.appendChild(mask);
	        var g = document.createElementNS(svgNS,'g');
	        g.setAttribute('mask','url(#'+id+')');
	        if(elemChildren[0]){
	            g.appendChild(elemChildren[0]);
	        }
	        this.elem.layerElement.appendChild(g);
	        this.masker = mask;
	        groupPath.setAttribute('stroke','#fff');
	    } else if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
	        if(this.filterManager.effectElements[10].p.v === 2){
	            var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	            while(elemChildren.length){
	                this.elem.layerElement.removeChild(elemChildren[0]);
	            }
	        }
	        this.elem.layerElement.appendChild(groupPath);
	        this.elem.layerElement.removeAttribute('mask');
	        groupPath.setAttribute('stroke','#fff');
	    }
	    this.initialized = true;
	    this.pathMasker = groupPath;
	}
	
	SVGStrokeEffect.prototype.renderFrame = function(forceRender){
	    if(!this.initialized){
	        this.initialize();
	    }
	    var i, len = this.paths.length;
	    var mask, path;
	    for(i=0;i<len;i+=1){
	        mask = this.elem.maskManager.viewData[this.paths[i].m];
	        path = this.paths[i].p;
	        if(forceRender || this.filterManager.mdf || mask.prop.mdf){
	            path.setAttribute('d',mask.lastPath);
	        }
	        if(forceRender || this.filterManager.effectElements[9].p.mdf || this.filterManager.effectElements[4].p.mdf || this.filterManager.effectElements[7].p.mdf || this.filterManager.effectElements[8].p.mdf || mask.prop.mdf){
	            var dasharrayValue;
	            if(this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100){
	                var s = Math.min(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
	                var e = Math.max(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
	                var l = path.getTotalLength();
	                dasharrayValue = '0 0 0 ' + l*s + ' ';
	                var lineLength = l*(e-s);
	                var segment = 1+this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
	                var units = Math.floor(lineLength/segment);
	                var j;
	                for(j=0;j<units;j+=1){
	                    dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100 + ' ';
	                }
	                dasharrayValue += '0 ' + l*10 + ' 0 0';
	            } else {
	                dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
	            }
	            path.setAttribute('stroke-dasharray',dasharrayValue);
	        }
	    }
	    if(forceRender || this.filterManager.effectElements[4].p.mdf){
	        this.pathMasker.setAttribute('stroke-width',this.filterManager.effectElements[4].p.v*2);
	    }
	    
	    if(forceRender || this.filterManager.effectElements[6].p.mdf){
	        this.pathMasker.setAttribute('opacity',this.filterManager.effectElements[6].p.v);
	    }
	    if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
	        if(forceRender || this.filterManager.effectElements[3].p.mdf){
	            var color = this.filterManager.effectElements[3].p.v;
	            this.pathMasker.setAttribute('stroke','rgb('+bm_floor(color[0]*255)+','+bm_floor(color[1]*255)+','+bm_floor(color[2]*255)+')');
	        }
	    }
	};
	function SVGTritoneFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
	    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f1');
	    filter.appendChild(feColorMatrix);
	    var feComponentTransfer = document.createElementNS(svgNS,'feComponentTransfer');
	    feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	    filter.appendChild(feComponentTransfer);
	    this.matrixFilter = feComponentTransfer;
	    var feFuncR = document.createElementNS(svgNS,'feFuncR');
	    feFuncR.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncR);
	    this.feFuncR = feFuncR;
	    var feFuncG = document.createElementNS(svgNS,'feFuncG');
	    feFuncG.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncG);
	    this.feFuncG = feFuncG;
	    var feFuncB = document.createElementNS(svgNS,'feFuncB');
	    feFuncB.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncB);
	    this.feFuncB = feFuncB;
	}
	
	SVGTritoneFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager.mdf){
	        var color1 = this.filterManager.effectElements[0].p.v;
	        var color2 = this.filterManager.effectElements[1].p.v;
	        var color3 = this.filterManager.effectElements[2].p.v;
	        var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0]
	        var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1]
	        var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2]
	        this.feFuncR.setAttribute('tableValues', tableR);
	        this.feFuncG.setAttribute('tableValues', tableG);
	        this.feFuncB.setAttribute('tableValues', tableB);
	        //var opacity = this.filterManager.effectElements[2].p.v/100;
	        //this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
	    }
	};
	function SVGProLevelsFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var effectElements = this.filterManager.effectElements;
	    var feComponentTransfer = document.createElementNS(svgNS,'feComponentTransfer');
	    var feFuncR, feFuncG, feFuncB;
	    
	    if(effectElements[9].p.k || effectElements[9].p.v !== 0 || effectElements[10].p.k || effectElements[10].p.v !== 1 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 0 || effectElements[13].p.k || effectElements[13].p.v !== 1){
	        this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
	    }
	    if(effectElements[16].p.k || effectElements[16].p.v !== 0 || effectElements[17].p.k || effectElements[17].p.v !== 1 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 0 || effectElements[20].p.k || effectElements[20].p.v !== 1){
	        this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
	    }
	    if(effectElements[23].p.k || effectElements[23].p.v !== 0 || effectElements[24].p.k || effectElements[24].p.v !== 1 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 0 || effectElements[27].p.k || effectElements[27].p.v !== 1){
	        this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	    if(effectElements[30].p.k || effectElements[30].p.v !== 0 || effectElements[31].p.k || effectElements[31].p.v !== 1 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 0 || effectElements[34].p.k || effectElements[34].p.v !== 1){
	        this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
	    }
	    
	    if(this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA){
	        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	        filter.appendChild(feComponentTransfer);
	        feComponentTransfer = document.createElementNS(svgNS,'feComponentTransfer');
	    }
	
	    if(effectElements[2].p.k || effectElements[2].p.v !== 0 || effectElements[3].p.k || effectElements[3].p.v !== 1 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 0 || effectElements[6].p.k || effectElements[6].p.v !== 1){
	
	        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	        filter.appendChild(feComponentTransfer);
	        this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
	        this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
	        this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	}
	
	SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
	    var feFunc = document.createElementNS(svgNS,type);
	    feFunc.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFunc);
	    return feFunc;
	};
	
	SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
	    var cnt = 0;
	    var segments = 256;
	    var perc;
	    var min = Math.min(inputBlack, inputWhite);
	    var max = Math.max(inputBlack, inputWhite);
	    var table = Array.call(null,{length:segments});
	    var colorValue;
	    var pos = 0;
	    var outputDelta = outputWhite - outputBlack; 
	    var inputDelta = inputWhite - inputBlack; 
	    while(cnt <= 256) {
	        perc = cnt/256;
	        if(perc <= min){
	            colorValue = inputDelta < 0 ? outputWhite : outputBlack;
	        } else if(perc >= max){
	            colorValue = inputDelta < 0 ? outputBlack : outputWhite;
	        } else {
	            colorValue = (outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma));
	        }
	        table[pos++] = colorValue;
	        cnt += 256/(segments-1);
	    }
	    return table.join(' ');
	};
	
	SVGProLevelsFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager.mdf){
	        var val, cnt, perc, bezier;
	        var effectElements = this.filterManager.effectElements;
	        if(this.feFuncRComposed && (forceRender || effectElements[2].p.mdf || effectElements[3].p.mdf || effectElements[4].p.mdf || effectElements[5].p.mdf || effectElements[6].p.mdf)){
	            val = this.getTableValue(effectElements[2].p.v,effectElements[3].p.v,effectElements[4].p.v,effectElements[5].p.v,effectElements[6].p.v);
	            this.feFuncRComposed.setAttribute('tableValues',val);
	            this.feFuncGComposed.setAttribute('tableValues',val);
	            this.feFuncBComposed.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncR && (forceRender || effectElements[9].p.mdf || effectElements[10].p.mdf || effectElements[11].p.mdf || effectElements[12].p.mdf || effectElements[13].p.mdf)){
	            val = this.getTableValue(effectElements[9].p.v,effectElements[10].p.v,effectElements[11].p.v,effectElements[12].p.v,effectElements[13].p.v);
	            this.feFuncR.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncG && (forceRender || effectElements[16].p.mdf || effectElements[17].p.mdf || effectElements[18].p.mdf || effectElements[19].p.mdf || effectElements[20].p.mdf)){
	            val = this.getTableValue(effectElements[16].p.v,effectElements[17].p.v,effectElements[18].p.v,effectElements[19].p.v,effectElements[20].p.v);
	            this.feFuncG.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncB && (forceRender || effectElements[23].p.mdf || effectElements[24].p.mdf || effectElements[25].p.mdf || effectElements[26].p.mdf || effectElements[27].p.mdf)){
	            val = this.getTableValue(effectElements[23].p.v,effectElements[24].p.v,effectElements[25].p.v,effectElements[26].p.v,effectElements[27].p.v);
	            this.feFuncB.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncA && (forceRender || effectElements[30].p.mdf || effectElements[31].p.mdf || effectElements[32].p.mdf || effectElements[33].p.mdf || effectElements[34].p.mdf)){
	            val = this.getTableValue(effectElements[30].p.v,effectElements[31].p.v,effectElements[32].p.v,effectElements[33].p.v,effectElements[34].p.v);
	            this.feFuncA.setAttribute('tableValues',val);
	        }
	        
	    }
	};
	function SVGDropShadowEffect(filter, filterManager){
	    /*<feGaussianBlur in="SourceAlpha" stdDeviation="3"/> <!-- stdDeviation is how much to blur -->
	  <feOffset dx="2" dy="2" result="offsetblur"/> <!-- how much to offset -->
	  <feMerge> 
	    <feMergeNode/> <!-- this contains the offset blurred image -->
	    <feMergeNode in="SourceGraphic"/> <!-- this contains the element that the filter is applied to -->
	  </feMerge>*/
	  /*<feFlood flood-color="#3D4574" flood-opacity="0.5" result="offsetColor"/>*/
	    filter.setAttribute('x','-100%');
	    filter.setAttribute('y','-100%');
	    filter.setAttribute('width','400%');
	    filter.setAttribute('height','400%');
	    this.filterManager = filterManager;
	
	    var feGaussianBlur = document.createElementNS(svgNS,'feGaussianBlur');
	    feGaussianBlur.setAttribute('in','SourceAlpha');
	    feGaussianBlur.setAttribute('result','drop_shadow_1');
	    feGaussianBlur.setAttribute('stdDeviation','0');
	    this.feGaussianBlur = feGaussianBlur;
	    filter.appendChild(feGaussianBlur);
	
	    var feOffset = document.createElementNS(svgNS,'feOffset');
	    feOffset.setAttribute('dx','25');
	    feOffset.setAttribute('dy','0');
	    feOffset.setAttribute('in','drop_shadow_1');
	    feOffset.setAttribute('result','drop_shadow_2');
	    this.feOffset = feOffset;
	    filter.appendChild(feOffset);
	    var feFlood = document.createElementNS(svgNS,'feFlood');
	    feFlood.setAttribute('flood-color','#00ff00');
	    feFlood.setAttribute('flood-opacity','1');
	    feFlood.setAttribute('result','drop_shadow_3');
	    this.feFlood = feFlood;
	    filter.appendChild(feFlood);
	
	    var feComposite = document.createElementNS(svgNS,'feComposite');
	    feComposite.setAttribute('in','drop_shadow_3');
	    feComposite.setAttribute('in2','drop_shadow_2');
	    feComposite.setAttribute('operator','in');
	    feComposite.setAttribute('result','drop_shadow_4');
	    filter.appendChild(feComposite);
	
	
	    var feMerge = document.createElementNS(svgNS,'feMerge');
	    filter.appendChild(feMerge);
	    var feMergeNode;
	    feMergeNode = document.createElementNS(svgNS,'feMergeNode');
	    feMerge.appendChild(feMergeNode);
	    feMergeNode = document.createElementNS(svgNS,'feMergeNode');
	    feMergeNode.setAttribute('in','SourceGraphic');
	    this.feMergeNode = feMergeNode;
	    this.feMerge = feMerge;
	    this.originalNodeAdded = false;
	    feMerge.appendChild(feMergeNode);
	}
	
	SVGDropShadowEffect.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager.mdf){
	        if(forceRender || this.filterManager.effectElements[4].p.mdf){
	            this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
	        }
	        if(forceRender || this.filterManager.effectElements[0].p.mdf){
	            var col = this.filterManager.effectElements[0].p.v;
	            this.feFlood.setAttribute('flood-color',rgbToHex(Math.round(col[0]*255),Math.round(col[1]*255),Math.round(col[2]*255)));
	        }
	        if(forceRender || this.filterManager.effectElements[1].p.mdf){
	            this.feFlood.setAttribute('flood-opacity',this.filterManager.effectElements[1].p.v/255);
	        }
	        if(forceRender || this.filterManager.effectElements[2].p.mdf || this.filterManager.effectElements[3].p.mdf){
	            var distance = this.filterManager.effectElements[3].p.v
	            var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads
	            var x = distance * Math.cos(angle)
	            var y = distance * Math.sin(angle)
	            this.feOffset.setAttribute('dx', x);
	            this.feOffset.setAttribute('dy', y);
	        }
	        /*if(forceRender || this.filterManager.effectElements[5].p.mdf){
	            if(this.filterManager.effectElements[5].p.v === 1 && this.originalNodeAdded) {
	                this.feMerge.removeChild(this.feMergeNode);
	                this.originalNodeAdded = false;
	            } else if(this.filterManager.effectElements[5].p.v === 0 && !this.originalNodeAdded) {
	                this.feMerge.appendChild(this.feMergeNode);
	                this.originalNodeAdded = true;
	            }
	        }*/
	    }
	};
	function SVGMatte3Effect(filterElem, filterManager, elem){
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.filterElem = filterElem;
	    this.elem = elem;
	    elem.matteElement = document.createElementNS(svgNS,'g');
	    elem.matteElement.appendChild(elem.layerElement);
	    elem.matteElement.appendChild(elem.transformedElement);
	    elem.baseElement = elem.matteElement;
	}
	
	SVGMatte3Effect.prototype.setElementAsMask = function(elem, mask) {
	    var masker = document.createElementNS(svgNS,'mask');
	    masker.setAttribute('id',mask.layerId);
	    masker.setAttribute('mask-type','alpha');
	    masker.appendChild(mask.layerElement);
	    elem.setMatte(mask.layerId);
	    mask.data.hd = false;
	    var defs = elem.globalData.defs;
	    defs.appendChild(masker);
	}
	
	SVGMatte3Effect.prototype.initialize = function() {
	    var ind = this.filterManager.effectElements[0].p.v;
	    var i = 0, len = this.elem.comp.elements.length;
	    while(i < len) {
	    	if(this.elem.comp.elements[i].data.ind === ind) {
	    		this.setElementAsMask(this.elem, this.elem.comp.elements[i]);
	    	}
	    	i += 1;
	    }
	    this.initialized = true;
	}
	
	SVGMatte3Effect.prototype.renderFrame = function() {
		if(!this.initialized) {
			this.initialize();
		}
	}
	function SVGEffects(elem){
	    var i, len = elem.data.ef.length;
	    var filId = randomString(10);
	    var fil = filtersFactory.createFilter(filId);
	    var count = 0;
	    this.filters = [];
	    var filterManager;
	    for(i=0;i<len;i+=1){
	        if(elem.data.ef[i].ty === 20){
	            count += 1;
	            filterManager = new SVGTintFilter(fil, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 21){
	            count += 1;
	            filterManager = new SVGFillFilter(fil, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 22){
	            filterManager = new SVGStrokeEffect(elem, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 23){
	            count += 1;
	            filterManager = new SVGTritoneFilter(fil, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 24){
	            count += 1;
	            filterManager = new SVGProLevelsFilter(fil, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 25){
	            count += 1;
	            filterManager = new SVGDropShadowEffect(fil, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 28){
	            //count += 1;
	            filterManager = new SVGMatte3Effect(fil, elem.effects.effectElements[i], elem);
	            this.filters.push(filterManager);
	        }
	    }
	    if(count){
	        elem.globalData.defs.appendChild(fil);
	        elem.layerElement.setAttribute('filter','url(#'+filId+')');
	    }
	}
	
	SVGEffects.prototype.renderFrame = function(firstFrame){
	    var i, len = this.filters.length;
	    for(i=0;i<len;i+=1){
	        this.filters[i].renderFrame(firstFrame);
	    }
	};
	function ICompElement(data,parentContainer,globalData,comp, placeholder){
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	    this.layers = data.layers;
	    this.supports3d = true;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? Array.apply(null,{length:this.layers.length}) : [];
	    if(this.data.tm){
	        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
	    }
	    if(this.data.xt){
	        this.layerElement = document.createElementNS(svgNS,'g');
	        this.buildAllItems();
	    } else if(!globalData.progressiveLoad){
	        this.buildAllItems();
	    }
	}
	createElement(SVGBaseElement, ICompElement);
	
	ICompElement.prototype.hide = function(){
	    if(!this.hidden){
	        this._parent.hide.call(this);
	        var i,len = this.elements.length;
	        for( i = 0; i < len; i+=1 ){
	            if(this.elements[i]){
	                this.elements[i].hide();
	            }
	        }
	    }
	};
	
	ICompElement.prototype.prepareFrame = function(num){
	    this._parent.prepareFrame.call(this,num);
	    if(this.isVisible===false && !this.data.xt){
	        return;
	    }
	
	    if(this.tm){
	        var timeRemapped = this.tm.v;
	        if(timeRemapped === this.data.op){
	            timeRemapped = this.data.op - 1;
	        }
	        this.renderedFrame = timeRemapped;
	    } else {
	        this.renderedFrame = num/this.data.sr;
	    }
	    var i,len = this.elements.length;
	    if(!this.completeLayers){
	        this.checkLayers(this.renderedFrame);
	    }
	    for( i = 0; i < len; i+=1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
	        }
	    }
	};
	
	ICompElement.prototype.renderFrame = function(parentMatrix){
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    var i,len = this.layers.length;
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	
	    if(this.hidden) {
	        this.show();
	    }
	    for( i = 0; i < len; i+=1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	
	ICompElement.prototype.setElements = function(elems){
	    this.elements = elems;
	};
	
	ICompElement.prototype.getElements = function(){
	    return this.elements;
	};
	
	ICompElement.prototype.destroy = function(){
	    this._parent.destroy.call(this._parent);
	    var i,len = this.layers.length;
	    for( i = 0; i < len; i+=1 ){
	        if(this.elements[i]){
	            this.elements[i].destroy();
	        }
	    }
	};
	
	ICompElement.prototype.checkLayers = SVGRenderer.prototype.checkLayers;
	ICompElement.prototype.buildItem = SVGRenderer.prototype.buildItem;
	ICompElement.prototype.buildAllItems = SVGRenderer.prototype.buildAllItems;
	ICompElement.prototype.buildElementParenting = SVGRenderer.prototype.buildElementParenting;
	ICompElement.prototype.createItem = SVGRenderer.prototype.createItem;
	ICompElement.prototype.createImage = SVGRenderer.prototype.createImage;
	ICompElement.prototype.createComp = SVGRenderer.prototype.createComp;
	ICompElement.prototype.createSolid = SVGRenderer.prototype.createSolid;
	ICompElement.prototype.createShape = SVGRenderer.prototype.createShape;
	ICompElement.prototype.createText = SVGRenderer.prototype.createText;
	ICompElement.prototype.createBase = SVGRenderer.prototype.createBase;
	ICompElement.prototype.appendElementInPos = SVGRenderer.prototype.appendElementInPos;
	ICompElement.prototype.checkPendingElements = SVGRenderer.prototype.checkPendingElements;
	ICompElement.prototype.addPendingElement = SVGRenderer.prototype.addPendingElement;
	function IImageElement(data,parentContainer,globalData,comp,placeholder){
	    this.assetData = globalData.getAssetData(data.refId);
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp,placeholder);
	}
	createElement(SVGBaseElement, IImageElement);
	
	IImageElement.prototype.createElements = function(){
	
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	
	    this._parent.createElements.call(this);
	
	    this.innerElem = document.createElementNS(svgNS,'image');
	    this.innerElem.setAttribute('width',this.assetData.w+"px");
	    this.innerElem.setAttribute('height',this.assetData.h+"px");
	    this.innerElem.setAttribute('preserveAspectRatio','xMidYMid slice');
	    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
	    this.maskedElement = this.innerElem;
	    this.layerElement.appendChild(this.innerElem);
	    if(this.data.ln){
	        this.layerElement.setAttribute('id',this.data.ln);
	    }
	    if(this.data.cl){
	        this.layerElement.setAttribute('class',this.data.cl);
	    }
	
	};
	
	IImageElement.prototype.renderFrame = function(parentMatrix){
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	    if(this.hidden){
	        this.show();
	    }
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	
	IImageElement.prototype.destroy = function(){
	    this._parent.destroy.call(this._parent);
	    this.innerElem =  null;
	};
	function ISolidElement(data,parentContainer,globalData,comp, placeholder){
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	}
	createElement(SVGBaseElement, ISolidElement);
	
	ISolidElement.prototype.createElements = function(){
	    this._parent.createElements.call(this);
	
	    var rect = document.createElementNS(svgNS,'rect');
	    ////rect.style.width = this.data.sw;
	    ////rect.style.height = this.data.sh;
	    ////rect.style.fill = this.data.sc;
	    rect.setAttribute('width',this.data.sw);
	    rect.setAttribute('height',this.data.sh);
	    rect.setAttribute('fill',this.data.sc);
	    this.layerElement.appendChild(rect);
	    this.innerElem = rect;
	    if(this.data.ln){
	        this.layerElement.setAttribute('id',this.data.ln);
	    }
	    if(this.data.cl){
	        this.layerElement.setAttribute('class',this.data.cl);
	    }
	};
	
	ISolidElement.prototype.renderFrame = IImageElement.prototype.renderFrame;
	ISolidElement.prototype.destroy = IImageElement.prototype.destroy;
	
	var animationManager = (function(){
	    var moduleOb = {};
	    var registeredAnimations = [];
	    var initTime = 0;
	    var len = 0;
	    var idled = true;
	    var playingAnimationsNum = 0;
	
	    function removeElement(ev){
	        var i = 0;
	        var animItem = ev.target;
	        while(i<len) {
	            if (registeredAnimations[i].animation === animItem) {
	                registeredAnimations.splice(i, 1);
	                i -= 1;
	                len -= 1;
	                if(!animItem.isPaused){
	                    subtractPlayingCount();   
	                }
	            }
	            i += 1;
	        }
	    }
	
	    function registerAnimation(element, animationData){
	        if(!element){
	            return null;
	        }
	        var i=0;
	        while(i<len){
	            if(registeredAnimations[i].elem == element && registeredAnimations[i].elem !== null ){
	                return registeredAnimations[i].animation;
	            }
	            i+=1;
	        }
	        var animItem = new AnimationItem();
	        setupAnimation(animItem, element);
	        animItem.setData(element, animationData);
	        return animItem;
	    }
	
	    function addPlayingCount(){
	        playingAnimationsNum += 1;
	        activate();
	    }
	
	    function subtractPlayingCount(){
	        playingAnimationsNum -= 1;
	        if(playingAnimationsNum === 0){
	            idled = true;
	        }
	    }
	
	    function setupAnimation(animItem, element){
	        animItem.addEventListener('destroy',removeElement);
	        animItem.addEventListener('_active',addPlayingCount);
	        animItem.addEventListener('_idle',subtractPlayingCount);
	        registeredAnimations.push({elem: element,animation:animItem});
	        len += 1;
	    }
	
	    function loadAnimation(params){
	        var animItem = new AnimationItem();
	        setupAnimation(animItem, null);
	        animItem.setParams(params);
	        return animItem;
	    }
	
	
	    function setSpeed(val,animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.setSpeed(val, animation);
	        }
	    }
	
	    function setDirection(val, animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.setDirection(val, animation);
	        }
	    }
	
	    function play(animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.play(animation);
	        }
	    }
	
	    function moveFrame (value, animation) {
	        initTime = Date.now();
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.moveFrame(value,animation);
	        }
	    }
	
	    function resume(nowTime) {
	
	        var elapsedTime = nowTime - initTime;
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.advanceTime(elapsedTime);
	        }
	        initTime = nowTime;
	        if(!idled) {
	            requestAnimationFrame(resume);
	        }
	    }
	
	    function first(nowTime){
	        initTime = nowTime;
	        requestAnimationFrame(resume);
	    }
	
	    function pause(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.pause(animation);
	        }
	    }
	
	    function goToAndStop(value,isFrame,animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.goToAndStop(value,isFrame,animation);
	        }
	    }
	
	    function stop(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.stop(animation);
	        }
	    }
	
	    function togglePause(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.togglePause(animation);
	        }
	    }
	
	    function destroy(animation) {
	        var i;
	        for(i=(len-1);i>=0;i-=1){
	            registeredAnimations[i].animation.destroy(animation);
	        }
	    }
	
	    function searchAnimations(animationData, standalone, renderer){
	        var animElements = document.getElementsByClassName('bodymovin');
	        var i, len = animElements.length;
	        for(i=0;i<len;i+=1){
	            if(renderer){
	                animElements[i].setAttribute('data-bm-type',renderer);
	            }
	            registerAnimation(animElements[i], animationData);
	        }
	        if(standalone && len === 0){
	            if(!renderer){
	                renderer = 'svg';
	            }
	            var body = document.getElementsByTagName('body')[0];
	            body.innerHTML = '';
	            var div = document.createElement('div');
	            div.style.width = '100%';
	            div.style.height = '100%';
	            div.setAttribute('data-bm-type',renderer);
	            body.appendChild(div);
	            registerAnimation(div, animationData);
	        }
	    }
	
	    function resize(){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.resize();
	        }
	    }
	
	    function start(){
	        requestAnimationFrame(first);
	    }
	
	    function activate(){
	        if(idled){
	            idled = false;
	            requestAnimationFrame(first);
	        }
	    }
	
	    //start();
	
	    setTimeout(start,0);
	
	    moduleOb.registerAnimation = registerAnimation;
	    moduleOb.loadAnimation = loadAnimation;
	    moduleOb.setSpeed = setSpeed;
	    moduleOb.setDirection = setDirection;
	    moduleOb.play = play;
	    moduleOb.moveFrame = moveFrame;
	    moduleOb.pause = pause;
	    moduleOb.stop = stop;
	    moduleOb.togglePause = togglePause;
	    moduleOb.searchAnimations = searchAnimations;
	    moduleOb.resize = resize;
	    moduleOb.start = start;
	    moduleOb.goToAndStop = goToAndStop;
	    moduleOb.destroy = destroy;
	    return moduleOb;
	}());
	var AnimationItem = function () {
	    this._cbs = [];
	    this.name = '';
	    this.path = '';
	    this.isLoaded = false;
	    this.currentFrame = 0;
	    this.currentRawFrame = 0;
	    this.totalFrames = 0;
	    this.frameRate = 0;
	    this.frameMult = 0;
	    this.playSpeed = 1;
	    this.playDirection = 1;
	    this.pendingElements = 0;
	    this.playCount = 0;
	    this.prerenderFramesFlag = true;
	    this.animationData = {};
	    this.layers = [];
	    this.assets = [];
	    this.isPaused = true;
	    this.autoplay = false;
	    this.loop = true;
	    this.renderer = null;
	    this.animationID = randomString(10);
	    this.scaleMode = 'fit';
	    this.assetsPath = '';
	    this.timeCompleted = 0;
	    this.segmentPos = 0;
	    this.subframeEnabled = subframeEnabled;
	    this.segments = [];
	    this.pendingSegment = false;
	    this._idle = true;
	    this.projectInterface = ProjectInterface();
	};
	
	AnimationItem.prototype.setParams = function(params) {
	    var self = this;
	    if(params.context){
	        this.context = params.context;
	    }
	    if(params.wrapper || params.container){
	        this.wrapper = params.wrapper || params.container;
	    }
	    var animType = params.animType ? params.animType : params.renderer ? params.renderer : 'svg';
	    switch(animType){
	        case 'canvas':
	            this.renderer = new CanvasRenderer(this, params.rendererSettings);
	            break;
	        case 'svg':
	            this.renderer = new SVGRenderer(this, params.rendererSettings);
	            break;
	        case 'hybrid':
	        case 'html':
	        default:
	            this.renderer = new HybridRenderer(this, params.rendererSettings);
	            break;
	    }
	    this.renderer.setProjectInterface(this.projectInterface);
	    this.animType = animType;
	
	    if(params.loop === '' || params.loop === null){
	    }else if(params.loop === false){
	        this.loop = false;
	    }else if(params.loop === true){
	        this.loop = true;
	    }else{
	        this.loop = parseInt(params.loop);
	    }
	    this.autoplay = 'autoplay' in params ? params.autoplay : true;
	    this.name = params.name ? params.name :  '';
	    this.prerenderFramesFlag = 'prerender' in params ? params.prerender : true;
	    this.autoloadSegments = params.hasOwnProperty('autoloadSegments') ? params.autoloadSegments :  true;
	    if(params.animationData){
	        self.configAnimation(params.animationData);
	    }else if(params.path){
	        if(params.path.substr(-4) != 'json'){
	            if (params.path.substr(-1, 1) != '/') {
	                params.path += '/';
	            }
	            params.path += 'data.json';
	        }
	
	        var xhr = new XMLHttpRequest();
	        if(params.path.lastIndexOf('\\') != -1){
	            this.path = params.path.substr(0,params.path.lastIndexOf('\\')+1);
	        }else{
	            this.path = params.path.substr(0,params.path.lastIndexOf('/')+1);
	        }
	        this.assetsPath = params.assetsPath;
	        this.fileName = params.path.substr(params.path.lastIndexOf('/')+1);
	        this.fileName = this.fileName.substr(0,this.fileName.lastIndexOf('.json'));
	        xhr.open('GET', params.path, true);
	        xhr.send();
	        xhr.onreadystatechange = function () {
	            if (xhr.readyState == 4) {
	                if(xhr.status == 200){
	                    self.configAnimation(JSON.parse(xhr.responseText));
	                }else{
	                    try{
	                        var response = JSON.parse(xhr.responseText);
	                        self.configAnimation(response);
	                    }catch(err){
	                    }
	                }
	            }
	        };
	    }
	};
	
	AnimationItem.prototype.setData = function (wrapper, animationData) {
	    var params = {
	        wrapper: wrapper,
	        animationData: animationData ? (typeof animationData  === "object") ? animationData : JSON.parse(animationData) : null
	    };
	    var wrapperAttributes = wrapper.attributes;
	
	    params.path = wrapperAttributes.getNamedItem('data-animation-path') ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') ? wrapperAttributes.getNamedItem('data-bm-path').value :  wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
	    params.animType = wrapperAttributes.getNamedItem('data-anim-type') ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') ? wrapperAttributes.getNamedItem('bm-type').value :  wrapperAttributes.getNamedItem('data-bm-renderer') ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : 'canvas';
	
	    var loop = wrapperAttributes.getNamedItem('data-anim-loop') ? wrapperAttributes.getNamedItem('data-anim-loop').value :  wrapperAttributes.getNamedItem('data-bm-loop') ? wrapperAttributes.getNamedItem('data-bm-loop').value :  wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
	    if(loop === ''){
	    }else if(loop === 'false'){
	        params.loop = false;
	    }else if(loop === 'true'){
	        params.loop = true;
	    }else{
	        params.loop = parseInt(loop);
	    }
	    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') ? wrapperAttributes.getNamedItem('data-anim-autoplay').value :  wrapperAttributes.getNamedItem('data-bm-autoplay') ? wrapperAttributes.getNamedItem('data-bm-autoplay').value :  wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
	    params.autoplay = autoplay !== "false";
	
	    params.name = wrapperAttributes.getNamedItem('data-name') ? wrapperAttributes.getNamedItem('data-name').value :  wrapperAttributes.getNamedItem('data-bm-name') ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value :  '';
	    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') ? wrapperAttributes.getNamedItem('data-anim-prerender').value :  wrapperAttributes.getNamedItem('data-bm-prerender') ? wrapperAttributes.getNamedItem('data-bm-prerender').value :  wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
	
	    if(prerender === 'false'){
	        params.prerender = false;
	    }
	    this.setParams(params);
	};
	
	AnimationItem.prototype.includeLayers = function(data) {
	    if(data.op > this.animationData.op){
	        this.animationData.op = data.op;
	        this.totalFrames = Math.floor(data.op - this.animationData.ip);
	        this.animationData.tf = this.totalFrames;
	    }
	    var layers = this.animationData.layers;
	    var i, len = layers.length;
	    var newLayers = data.layers;
	    var j, jLen = newLayers.length;
	    for(j=0;j<jLen;j+=1){
	        i = 0;
	        while(i<len){
	            if(layers[i].id == newLayers[j].id){
	                layers[i] = newLayers[j];
	                break;
	            }
	            i += 1;
	        }
	    }
	    if(data.chars || data.fonts){
	        this.renderer.globalData.fontManager.addChars(data.chars);
	        this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
	    }
	    if(data.assets){
	        len = data.assets.length;
	        for(i = 0; i < len; i += 1){
	            this.animationData.assets.push(data.assets[i]);
	        }
	    }
	    //this.totalFrames = 50;
	    //this.animationData.tf = 50;
	    this.animationData.__complete = false;
	    dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
	    this.renderer.includeLayers(data.layers);
	    if(expressionsPlugin){
	        expressionsPlugin.initExpressions(this);
	    }
	    this.renderer.renderFrame(null);
	    this.loadNextSegment();
	};
	
	AnimationItem.prototype.loadNextSegment = function() {
	    var segments = this.animationData.segments;
	    if(!segments || segments.length === 0 || !this.autoloadSegments){
	        this.trigger('data_ready');
	        this.timeCompleted = this.animationData.tf;
	        return;
	    }
	    var segment = segments.shift();
	    this.timeCompleted = segment.time * this.frameRate;
	    var xhr = new XMLHttpRequest();
	    var self = this;
	    var segmentPath = this.path+this.fileName+'_' + this.segmentPos + '.json';
	    this.segmentPos += 1;
	    xhr.open('GET', segmentPath, true);
	    xhr.send();
	    xhr.onreadystatechange = function () {
	        if (xhr.readyState == 4) {
	            if(xhr.status == 200){
	                self.includeLayers(JSON.parse(xhr.responseText));
	            }else{
	                try{
	                    var response = JSON.parse(xhr.responseText);
	                    self.includeLayers(response);
	                }catch(err){
	                }
	            }
	        }
	    };
	};
	
	AnimationItem.prototype.loadSegments = function() {
	    var segments = this.animationData.segments;
	    if(!segments) {
	        this.timeCompleted = this.animationData.tf;
	    }
	    this.loadNextSegment();
	};
	
	AnimationItem.prototype.configAnimation = function (animData) {
	    if(this.renderer && this.renderer.destroyed){
	        return;
	    }
	    //console.log(JSON.parse(JSON.stringify(animData)));
	    //animData.w = Math.round(animData.w/blitter);
	    //animData.h = Math.round(animData.h/blitter);
	    this.animationData = animData;
	    this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
	    this.animationData.tf = this.totalFrames;
	    this.renderer.configAnimation(animData);
	    if(!animData.assets){
	        animData.assets = [];
	    }
	    if(animData.comps) {
	        animData.assets = animData.assets.concat(animData.comps);
	        animData.comps = null;
	    }
	    this.renderer.searchExtraCompositions(animData.assets);
	
	    this.layers = this.animationData.layers;
	    this.assets = this.animationData.assets;
	    this.frameRate = this.animationData.fr;
	    this.firstFrame = Math.round(this.animationData.ip);
	    this.frameMult = this.animationData.fr / 1000;
	    this.trigger('config_ready');
	    this.imagePreloader = new ImagePreloader();
	    this.imagePreloader.setAssetsPath(this.assetsPath);
	    this.imagePreloader.setPath(this.path);
	    this.imagePreloader.loadAssets(animData.assets);
	    this.loadSegments();
	    this.updaFrameModifier();
	    if(this.renderer.globalData.fontManager){
	        this.waitForFontsLoaded();
	    }else{
	        dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
	        this.checkLoaded();
	    }
	};
	
	AnimationItem.prototype.waitForFontsLoaded = (function(){
	    function checkFontsLoaded(){
	        if(this.renderer.globalData.fontManager.loaded){
	            dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
	            //this.renderer.buildItems(this.animationData.layers);
	            this.checkLoaded();
	        }else{
	            setTimeout(checkFontsLoaded.bind(this),20);
	        }
	    }
	
	    return function(){
	        checkFontsLoaded.bind(this)();
	    }
	}());
	
	AnimationItem.prototype.addPendingElement = function () {
	    this.pendingElements += 1;
	}
	
	AnimationItem.prototype.elementLoaded = function () {
	    this.pendingElements--;
	    this.checkLoaded();
	};
	
	AnimationItem.prototype.checkLoaded = function () {
	    if (this.pendingElements === 0) {
	        if(expressionsPlugin){
	            expressionsPlugin.initExpressions(this);
	        }
	        this.renderer.initItems();
	        setTimeout(function(){
	            this.trigger('DOMLoaded');
	        }.bind(this),0);
	        this.isLoaded = true;
	        this.gotoFrame();
	        if(this.autoplay){
	            this.play();
	        }
	    }
	};
	
	AnimationItem.prototype.resize = function () {
	    this.renderer.updateContainerSize();
	};
	
	AnimationItem.prototype.setSubframe = function(flag){
	    this.subframeEnabled = flag ? true : false;
	}
	
	AnimationItem.prototype.gotoFrame = function () {
	    if(this.subframeEnabled){
	        this.currentFrame = this.currentRawFrame;
	    }else{
	        this.currentFrame = Math.floor(this.currentRawFrame);
	    }
	
	    if(this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted){
	        this.currentFrame = this.timeCompleted;
	    }
	    this.trigger('enterFrame');
	    this.renderFrame();
	};
	
	AnimationItem.prototype.renderFrame = function () {
	    if(this.isLoaded === false){
	        return;
	    }
	    //console.log('this.currentFrame:',this.currentFrame + this.firstFrame);
	    this.renderer.renderFrame(this.currentFrame + this.firstFrame);
	};
	
	AnimationItem.prototype.play = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === true){
	        this.isPaused = false;
	        if(this._idle){
	            this._idle = false;
	            this.trigger('_active');
	        }
	    }
	};
	
	AnimationItem.prototype.pause = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === false){
	        this.isPaused = true;
	        if(!this.pendingSegment){
	            this._idle = true;
	            this.trigger('_idle');
	        }
	    }
	};
	
	AnimationItem.prototype.togglePause = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === true){
	        this.play();
	    }else{
	        this.pause();
	    }
	};
	
	AnimationItem.prototype.stop = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    this.pause();
	    this.currentFrame = this.currentRawFrame = 0;
	    this.playCount = 0;
	    this.gotoFrame();
	};
	
	AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(isFrame){
	        this.setCurrentRawFrameValue(value);
	    }else{
	        this.setCurrentRawFrameValue(value * this.frameModifier);
	    }
	    this.pause();
	};
	
	AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
	    this.goToAndStop(value, isFrame, name);
	    this.play();
	};
	
	AnimationItem.prototype.advanceTime = function (value) {
	    if(this.pendingSegment){
	        this.pendingSegment = false;
	        this.adjustSegment(this.segments.shift());
	        if(this.isPaused){
	            this.play();
	        }
	        return;
	    }
	    if (this.isPaused === true || this.isLoaded === false) {
	        return;
	    }
	    this.setCurrentRawFrameValue(this.currentRawFrame + value * this.frameModifier);
	};
	
	AnimationItem.prototype.updateAnimation = function (perc) {
	    this.setCurrentRawFrameValue(this.totalFrames * perc);
	};
	
	AnimationItem.prototype.moveFrame = function (value, name) {
	    if(name && this.name != name){
	        return;
	    }
	    this.setCurrentRawFrameValue(this.currentRawFrame+value);
	};
	
	AnimationItem.prototype.adjustSegment = function(arr){
	    this.playCount = 0;
	    if(arr[1] < arr[0]){
	        if(this.frameModifier > 0){
	            if(this.playSpeed < 0){
	                this.setSpeed(-this.playSpeed);
	            } else {
	                this.setDirection(-1);
	            }
	        }
	        this.totalFrames = arr[0] - arr[1];
	        this.firstFrame = arr[1];
	        this.setCurrentRawFrameValue(this.totalFrames - 0.01);
	    } else if(arr[1] > arr[0]){
	        if(this.frameModifier < 0){
	            if(this.playSpeed < 0){
	                this.setSpeed(-this.playSpeed);
	            } else {
	                this.setDirection(1);
	            }
	        }
	        this.totalFrames = arr[1] - arr[0];
	        this.firstFrame = arr[0];
	        this.setCurrentRawFrameValue(0);
	    }
	    this.trigger('segmentStart');
	};
	AnimationItem.prototype.setSegment = function (init,end) {
	    var pendingFrame = -1;
	    if(this.isPaused) {
	        if (this.currentRawFrame + this.firstFrame < init) {
	            pendingFrame = init;
	        } else if (this.currentRawFrame + this.firstFrame > end) {
	            pendingFrame = end - init - 0.01;
	        }
	    }
	
	    this.firstFrame = init;
	    this.totalFrames = end - init;
	    if(pendingFrame !== -1) {
	        this.goToAndStop(pendingFrame,true);
	    }
	}
	
	AnimationItem.prototype.playSegments = function (arr,forceFlag) {
	    if(typeof arr[0] === 'object'){
	        var i, len = arr.length;
	        for(i=0;i<len;i+=1){
	            this.segments.push(arr[i]);
	        }
	    }else{
	        this.segments.push(arr);
	    }
	    if(forceFlag){
	        this.adjustSegment(this.segments.shift());
	    }
	    if(this.isPaused){
	        this.play();
	    }
	};
	
	AnimationItem.prototype.resetSegments = function (forceFlag) {
	    this.segments.length = 0;
	    this.segments.push([this.animationData.ip*this.frameRate,Math.floor(this.animationData.op - this.animationData.ip+this.animationData.ip*this.frameRate)]);
	    if(forceFlag){
	        this.adjustSegment(this.segments.shift());
	    }
	};
	AnimationItem.prototype.checkSegments = function(){
	    if(this.segments.length){
	        this.pendingSegment = true;
	    }
	}
	
	AnimationItem.prototype.remove = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    this.renderer.destroy();
	};
	
	AnimationItem.prototype.destroy = function (name) {
	    if((name && this.name != name) || (this.renderer && this.renderer.destroyed)){
	        return;
	    }
	    this.renderer.destroy();
	    this.trigger('destroy');
	    this._cbs = null;
	    this.onEnterFrame = this.onLoopComplete = this.onComplete = this.onSegmentStart = this.onDestroy = null;
	};
	
	AnimationItem.prototype.setCurrentRawFrameValue = function(value){
	    this.currentRawFrame = value;
	    //console.log(this.totalFrames);
	    if (this.currentRawFrame >= this.totalFrames) {
	        this.checkSegments();
	        if(this.loop === false){
	            this.currentRawFrame = this.totalFrames - 0.01;
	            this.gotoFrame();
	            this.pause();
	            this.trigger('complete');
	            return;
	        }else{
	            this.trigger('loopComplete');
	            this.playCount += 1;
	            if((this.loop !== true && this.playCount == this.loop) || this.pendingSegment){
	                this.currentRawFrame = this.totalFrames - 0.01;
	                this.gotoFrame();
	                this.pause();
	                this.trigger('complete');
	                return;
	            } else {
	                this.currentRawFrame = this.currentRawFrame % this.totalFrames;
	            }
	        }
	    } else if (this.currentRawFrame < 0) {
	        this.checkSegments();
	        this.playCount -= 1;
	        if(this.playCount < 0){
	            this.playCount = 0;
	        }
	        if(this.loop === false  || this.pendingSegment){
	            this.currentRawFrame = 0;
	            this.gotoFrame();
	            this.pause();
	            this.trigger('complete');
	            return;
	        }else{
	            this.trigger('loopComplete');
	            this.currentRawFrame = (this.totalFrames + this.currentRawFrame) % this.totalFrames;
	            this.gotoFrame();
	            return;
	        }
	    }
	
	    this.gotoFrame();
	};
	
	AnimationItem.prototype.setSpeed = function (val) {
	    this.playSpeed = val;
	    this.updaFrameModifier();
	};
	
	AnimationItem.prototype.setDirection = function (val) {
	    this.playDirection = val < 0 ? -1 : 1;
	    this.updaFrameModifier();
	};
	
	AnimationItem.prototype.updaFrameModifier = function () {
	    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
	};
	
	AnimationItem.prototype.getPath = function () {
	    return this.path;
	};
	
	AnimationItem.prototype.getAssetsPath = function (assetData) {
	    var path = '';
	    if(this.assetsPath){
	        var imagePath = assetData.p;
	        if(imagePath.indexOf('images/') !== -1){
	            imagePath = imagePath.split('/')[1];
	        }
	        path = this.assetsPath + imagePath;
	    } else {
	        path = this.path;
	        path += assetData.u ? assetData.u : '';
	        path += assetData.p;
	    }
	    return path;
	};
	
	AnimationItem.prototype.getAssetData = function (id) {
	    var i = 0, len = this.assets.length;
	    while (i < len) {
	        if(id == this.assets[i].id){
	            return this.assets[i];
	        }
	        i += 1;
	    }
	};
	
	AnimationItem.prototype.hide = function () {
	    this.renderer.hide();
	};
	
	AnimationItem.prototype.show = function () {
	    this.renderer.show();
	};
	
	AnimationItem.prototype.getAssets = function () {
	    return this.assets;
	};
	
	AnimationItem.prototype.trigger = function(name){
	    if(this._cbs && this._cbs[name]){
	        switch(name){
	            case 'enterFrame':
	                this.triggerEvent(name,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
	                break;
	            case 'loopComplete':
	                this.triggerEvent(name,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
	                break;
	            case 'complete':
	                this.triggerEvent(name,new BMCompleteEvent(name,this.frameMult));
	                break;
	            case 'segmentStart':
	                this.triggerEvent(name,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
	                break;
	            case 'destroy':
	                this.triggerEvent(name,new BMDestroyEvent(name,this));
	                break;
	            default:
	                this.triggerEvent(name);
	        }
	    }
	    if(name === 'enterFrame' && this.onEnterFrame){
	        this.onEnterFrame.call(this,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
	    }
	    if(name === 'loopComplete' && this.onLoopComplete){
	        this.onLoopComplete.call(this,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
	    }
	    if(name === 'complete' && this.onComplete){
	        this.onComplete.call(this,new BMCompleteEvent(name,this.frameMult));
	    }
	    if(name === 'segmentStart' && this.onSegmentStart){
	        this.onSegmentStart.call(this,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
	    }
	    if(name === 'destroy' && this.onDestroy){
	        this.onDestroy.call(this,new BMDestroyEvent(name,this));
	    }
	};
	
	AnimationItem.prototype.addEventListener = _addEventListener;
	AnimationItem.prototype.removeEventListener = _removeEventListener;
	AnimationItem.prototype.triggerEvent = _triggerEvent;
	
	function CanvasRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.renderConfig = {
	        clearCanvas: (config && config.clearCanvas !== undefined) ? config.clearCanvas : true,
	        context: (config && config.context) || null,
	        progressiveLoad: (config && config.progressiveLoad) || false,
	        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet'
	    };
	    this.renderConfig.dpr = (config && config.dpr) || 1;
	    if (this.animationItem.wrapper) {
	        this.renderConfig.dpr = (config && config.dpr) || window.devicePixelRatio || 1;
	    }
	    this.renderedFrame = -1;
	    this.globalData = {
	        frameNum: -1
	    };
	    this.contextData = {
	        saved : Array.apply(null,{length:15}),
	        savedOp: Array.apply(null,{length:15}),
	        cArrPos : 0,
	        cTr : new Matrix(),
	        cO : 1
	    };
	    var i, len = 15;
	    for(i=0;i<len;i+=1){
	        this.contextData.saved[i] = Array.apply(null,{length:16});
	    }
	    this.elements = [];
	    this.pendingElements = [];
	    this.transformMat = new Matrix();
	    this.completeLayers = false;
	}
	extendPrototype(BaseRenderer,CanvasRenderer);
	
	CanvasRenderer.prototype.createBase = function (data) {
	    return new CVBaseElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.createShape = function (data) {
	    return new CVShapeElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.createText = function (data) {
	    return new CVTextElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.createImage = function (data) {
	    return new CVImageElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.createComp = function (data) {
	    return new CVCompElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.createSolid = function (data) {
	    return new CVSolidElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.ctxTransform = function(props){
	    if(props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0){
	        return;
	    }
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.transform(props[0],props[1],props[4],props[5],props[12],props[13]);
	        return;
	    }
	    this.transformMat.cloneFromProps(props);
	    this.transformMat.transform(this.contextData.cTr.props[0],this.contextData.cTr.props[1],this.contextData.cTr.props[2],this.contextData.cTr.props[3],this.contextData.cTr.props[4],this.contextData.cTr.props[5],this.contextData.cTr.props[6],this.contextData.cTr.props[7],this.contextData.cTr.props[8],this.contextData.cTr.props[9],this.contextData.cTr.props[10],this.contextData.cTr.props[11],this.contextData.cTr.props[12],this.contextData.cTr.props[13],this.contextData.cTr.props[14],this.contextData.cTr.props[15])
	    //this.contextData.cTr.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
	    this.contextData.cTr.cloneFromProps(this.transformMat.props);
	    var trProps = this.contextData.cTr.props;
	    this.canvasContext.setTransform(trProps[0],trProps[1],trProps[4],trProps[5],trProps[12],trProps[13]);
	};
	
	CanvasRenderer.prototype.ctxOpacity = function(op){
	    if(op === 1){
	        return;
	    }
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
	        return;
	    }
	    this.contextData.cO *= op < 0 ? 0 : op;
	    this.canvasContext.globalAlpha = this.contextData.cO;
	};
	
	CanvasRenderer.prototype.reset = function(){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.restore();
	        return;
	    }
	    this.contextData.cArrPos = 0;
	    this.contextData.cTr.reset();
	    this.contextData.cO = 1;
	};
	
	CanvasRenderer.prototype.save = function(actionFlag){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.save();
	        return;
	    }
	    if(actionFlag){
	        this.canvasContext.save();
	    }
	    var props = this.contextData.cTr.props;
	    if(this.contextData.saved[this.contextData.cArrPos] === null || this.contextData.saved[this.contextData.cArrPos] === undefined){
	        this.contextData.saved[this.contextData.cArrPos] = new Array(16);
	    }
	    var i,arr = this.contextData.saved[this.contextData.cArrPos];
	    for(i=0;i<16;i+=1){
	        arr[i] = props[i];
	    }
	    this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO;
	    this.contextData.cArrPos += 1;
	};
	
	CanvasRenderer.prototype.restore = function(actionFlag){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.restore();
	        return;
	    }
	    if(actionFlag){
	        this.canvasContext.restore();
	    }
	    this.contextData.cArrPos -= 1;
	    var popped = this.contextData.saved[this.contextData.cArrPos];
	    var i,arr = this.contextData.cTr.props;
	    for(i=0;i<16;i+=1){
	        arr[i] = popped[i];
	    }
	    this.canvasContext.setTransform(popped[0],popped[1],popped[4],popped[5],popped[12],popped[13]);
	    popped = this.contextData.savedOp[this.contextData.cArrPos];
	    this.contextData.cO = popped;
	    this.canvasContext.globalAlpha = popped;
	};
	
	CanvasRenderer.prototype.configAnimation = function(animData){
	    if(this.animationItem.wrapper){
	        this.animationItem.container = document.createElement('canvas');
	        this.animationItem.container.style.width = '100%';
	        this.animationItem.container.style.height = '100%';
	        //this.animationItem.container.style.transform = 'translate3d(0,0,0)';
	        //this.animationItem.container.style.webkitTransform = 'translate3d(0,0,0)';
	        this.animationItem.container.style.transformOrigin = this.animationItem.container.style.mozTransformOrigin = this.animationItem.container.style.webkitTransformOrigin = this.animationItem.container.style['-webkit-transform'] = "0px 0px 0px";
	        this.animationItem.wrapper.appendChild(this.animationItem.container);
	        this.canvasContext = this.animationItem.container.getContext('2d');
	    }else{
	        this.canvasContext = this.renderConfig.context;
	    }
	    this.data = animData;
	    this.globalData.canvasContext = this.canvasContext;
	    this.globalData.renderer = this;
	    this.globalData.isDashed = false;
	    this.globalData.totalFrames = Math.floor(animData.tf);
	    this.globalData.compWidth = animData.w;
	    this.globalData.compHeight = animData.h;
	    this.globalData.frameRate = animData.fr;
	    this.globalData.frameId = 0;
	    this.globalData.compSize = {
	        w: animData.w,
	        h: animData.h
	    };
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.layers = animData.layers;
	    this.transformCanvas = {};
	    this.transformCanvas.w = animData.w;
	    this.transformCanvas.h = animData.h;
	    this.globalData.fontManager = new FontManager();
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts,document.body);
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem);
	    this.globalData.addPendingElement = this.animationItem.addPendingElement.bind(this.animationItem);
	    this.globalData.transformCanvas = this.transformCanvas;
	    this.elements = Array.apply(null,{length:animData.layers.length});
	
	    this.updateContainerSize();
	};
	
	CanvasRenderer.prototype.updateContainerSize = function () {
	    var elementWidth,elementHeight;
	    if(this.animationItem.wrapper && this.animationItem.container){
	        elementWidth = this.animationItem.wrapper.offsetWidth;
	        elementHeight = this.animationItem.wrapper.offsetHeight;
	        this.animationItem.container.setAttribute('width',elementWidth * this.renderConfig.dpr );
	        this.animationItem.container.setAttribute('height',elementHeight * this.renderConfig.dpr);
	    }else{
	        elementWidth = this.canvasContext.canvas.width * this.renderConfig.dpr;
	        elementHeight = this.canvasContext.canvas.height * this.renderConfig.dpr;
	    }
	    var elementRel,animationRel;
	    if(this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1){
	        var par = this.renderConfig.preserveAspectRatio.split(' ');
	        var fillType = par[1] || 'meet';
	        var pos = par[0] || 'xMidYMid';
	        var xPos = pos.substr(0,4);
	        var yPos = pos.substr(4);
	        elementRel = elementWidth/elementHeight;
	        animationRel = this.transformCanvas.w/this.transformCanvas.h;
	        if(animationRel>elementRel && fillType === 'meet' || animationRel<elementRel && fillType === 'slice'){
	            this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	            this.transformCanvas.sy = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	        }else{
	            this.transformCanvas.sx = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
	            this.transformCanvas.sy = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
	        }
	
	        if(xPos === 'xMid' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
	            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))/2*this.renderConfig.dpr;
	        } else if(xPos === 'xMax' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
	            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))*this.renderConfig.dpr;
	        } else {
	            this.transformCanvas.tx = 0;
	        }
	        if(yPos === 'YMid' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
	            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w))/2)*this.renderConfig.dpr;
	        } else if(yPos === 'YMax' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
	            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w)))*this.renderConfig.dpr;
	        } else {
	            this.transformCanvas.ty = 0;
	        }
	
	    }else if(this.renderConfig.preserveAspectRatio == 'none'){
	        this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	        this.transformCanvas.sy = elementHeight/(this.transformCanvas.h/this.renderConfig.dpr);
	        this.transformCanvas.tx = 0;
	        this.transformCanvas.ty = 0;
	    }else{
	        this.transformCanvas.sx = this.renderConfig.dpr;
	        this.transformCanvas.sy = this.renderConfig.dpr;
	        this.transformCanvas.tx = 0;
	        this.transformCanvas.ty = 0;
	    }
	    this.transformCanvas.props = [this.transformCanvas.sx,0,0,0,0,this.transformCanvas.sy,0,0,0,0,1,0,this.transformCanvas.tx,this.transformCanvas.ty,0,1];
	    var i, len = this.elements.length;
	    for(i=0;i<len;i+=1){
	        if(this.elements[i] && this.elements[i].data.ty === 0){
	            this.elements[i].resize(this.globalData.transformCanvas);
	        }
	    }
	};
	
	CanvasRenderer.prototype.destroy = function () {
	    if(this.renderConfig.clearCanvas) {
	        this.animationItem.wrapper.innerHTML = '';
	    }
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = len - 1; i >= 0; i-=1) {
	        this.elements[i].destroy();
	    }
	    this.elements.length = 0;
	    this.globalData.canvasContext = null;
	    this.animationItem.container = null;
	    this.destroyed = true;
	};
	
	CanvasRenderer.prototype.renderFrame = function(num){
	    if((this.renderedFrame == num && this.renderConfig.clearCanvas === true) || this.destroyed || num === null){
	        return;
	    }
	    this.renderedFrame = num;
	    this.globalData.frameNum = num - this.animationItem.firstFrame;
	    this.globalData.frameId += 1;
	    this.globalData.projectInterface.currentFrame = num;
	    if(this.renderConfig.clearCanvas === true){
	        this.reset();
	        this.canvasContext.save();
	        //this.canvasContext.canvas.width = this.canvasContext.canvas.width;
	        this.canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w*this.transformCanvas.sx, this.transformCanvas.h*this.transformCanvas.sy);
	    }else{
	        this.save();
	    }
	    this.ctxTransform(this.transformCanvas.props);
	    this.canvasContext.beginPath();
	    this.canvasContext.rect(0,0,this.transformCanvas.w,this.transformCanvas.h);
	    this.canvasContext.closePath();
	    this.canvasContext.clip();
	
	    //console.log('--------');
	    //console.log('NEW: ',num);
	    var i, len = this.layers.length;
	    if(!this.completeLayers){
	        this.checkLayers(num);
	    }
	
	    for (i = 0; i < len; i++) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(num - this.layers[i].st);
	        }
	    }
	    for (i = len - 1; i >= 0; i-=1) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	    if(this.renderConfig.clearCanvas !== true){
	        this.restore();
	    } else {
	        this.canvasContext.restore();
	    }
	};
	
	CanvasRenderer.prototype.buildItem = function(pos){
	    var elements = this.elements;
	    if(elements[pos] || this.layers[pos].ty == 99){
	        return;
	    }
	    var element = this.createItem(this.layers[pos], this,this.globalData);
	    elements[pos] = element;
	    element.initExpressions();
	    if(this.layers[pos].ty === 0){
	        element.resize(this.globalData.transformCanvas);
	    }
	};
	
	CanvasRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	    }
	};
	
	CanvasRenderer.prototype.hide = function(){
	    this.animationItem.container.style.display = 'none';
	};
	
	CanvasRenderer.prototype.show = function(){
	    this.animationItem.container.style.display = 'block';
	};
	
	CanvasRenderer.prototype.searchExtraCompositions = function(assets){
	    var i, len = assets.length;
	    var floatingContainer = document.createElementNS(svgNS,'g');
	    for(i=0;i<len;i+=1){
	        if(assets[i].xt){
	            var comp = this.createComp(assets[i],this.globalData.comp,this.globalData);
	            comp.initExpressions();
	            //comp.compInterface = CompExpressionInterface(comp);
	            //Expressions.addLayersInterface(comp.elements, this.globalData.projectInterface);
	            this.globalData.projectInterface.registerComposition(comp);
	        }
	    }
	};
	function HybridRenderer(animationItem){
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.globalData = {
	        frameNum: -1
	    };
	    this.pendingElements = [];
	    this.elements = [];
	    this.threeDElements = [];
	    this.destroyed = false;
	    this.camera = null;
	    this.supports3d = true;
	
	}
	
	extendPrototype(BaseRenderer,HybridRenderer);
	
	HybridRenderer.prototype.buildItem = SVGRenderer.prototype.buildItem;
	
	HybridRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	    }
	};
	
	HybridRenderer.prototype.appendElementInPos = function(element, pos){
	    var newElement = element.getBaseElement();
	    if(!newElement){
	        return;
	    }
	    var layer = this.layers[pos];
	    if(!layer.ddd || !this.supports3d){
	        var i = 0;
	        var nextElement;
	        while(i<pos){
	            if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement){
	                nextElement = this.elements[i].getBaseElement();
	            }
	            i += 1;
	        }
	        if(nextElement){
	            if(!layer.ddd || !this.supports3d){
	                this.layerElement.insertBefore(newElement, nextElement);
	            }
	        } else {
	            if(!layer.ddd || !this.supports3d){
	                this.layerElement.appendChild(newElement);
	            }
	        }
	    } else {
	        this.addTo3dContainer(newElement,pos);
	    }
	};
	
	
	HybridRenderer.prototype.createBase = function (data) {
	    return new SVGBaseElement(data, this.layerElement,this.globalData,this);
	};
	
	HybridRenderer.prototype.createShape = function (data) {
	    if(!this.supports3d){
	        return new IShapeElement(data, this.layerElement,this.globalData,this);
	    }
	    return new HShapeElement(data, this.layerElement,this.globalData,this);
	};
	
	HybridRenderer.prototype.createText = function (data) {
	    if(!this.supports3d){
	        return new SVGTextElement(data, this.layerElement,this.globalData,this);
	    }
	    return new HTextElement(data, this.layerElement,this.globalData,this);
	};
	
	HybridRenderer.prototype.createCamera = function (data) {
	    this.camera = new HCameraElement(data, this.layerElement,this.globalData,this);
	    return this.camera;
	};
	
	HybridRenderer.prototype.createImage = function (data) {
	    if(!this.supports3d){
	        return new IImageElement(data, this.layerElement,this.globalData,this);
	    }
	    return new HImageElement(data, this.layerElement,this.globalData,this);
	};
	
	HybridRenderer.prototype.createComp = function (data) {
	    if(!this.supports3d){
	        return new ICompElement(data, this.layerElement,this.globalData,this);
	    }
	    return new HCompElement(data, this.layerElement,this.globalData,this);
	
	};
	
	HybridRenderer.prototype.createSolid = function (data) {
	    if(!this.supports3d){
	        return new ISolidElement(data, this.layerElement,this.globalData,this);
	    }
	    return new HSolidElement(data, this.layerElement,this.globalData,this);
	};
	
	HybridRenderer.prototype.getThreeDContainer = function(pos){
	    var perspectiveElem = document.createElement('div');
	    styleDiv(perspectiveElem);
	    perspectiveElem.style.width = this.globalData.compSize.w+'px';
	    perspectiveElem.style.height = this.globalData.compSize.h+'px';
	    perspectiveElem.style.transformOrigin = perspectiveElem.style.mozTransformOrigin = perspectiveElem.style.webkitTransformOrigin = "50% 50%";
	    var container = document.createElement('div');
	    styleDiv(container);
	    container.style.transform = container.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	    perspectiveElem.appendChild(container);
	    this.resizerElem.appendChild(perspectiveElem);
	    var threeDContainerData = {
	        container:container,
	        perspectiveElem:perspectiveElem,
	        startPos: pos,
	        endPos: pos
	    };
	    this.threeDElements.push(threeDContainerData);
	    return threeDContainerData;
	};
	
	HybridRenderer.prototype.build3dContainers = function(){
	    var i, len = this.layers.length;
	    var lastThreeDContainerData;
	    for(i=0;i<len;i+=1){
	        if(this.layers[i].ddd){
	            if(!lastThreeDContainerData){
	                lastThreeDContainerData = this.getThreeDContainer(i);
	            }
	            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos,i);
	        } else {
	            lastThreeDContainerData = null;
	        }
	    }
	};
	
	HybridRenderer.prototype.addTo3dContainer = function(elem,pos){
	    var i = 0, len = this.threeDElements.length;
	    while(i<len){
	        if(pos <= this.threeDElements[i].endPos){
	            var j = this.threeDElements[i].startPos;
	            var nextElement;
	            while(j<pos){
	                if(this.elements[j] && this.elements[j].getBaseElement){
	                    nextElement = this.elements[j].getBaseElement();
	                }
	                j += 1;
	            }
	            if(nextElement){
	                this.threeDElements[i].container.insertBefore(elem, nextElement);
	            } else {
	                this.threeDElements[i].container.appendChild(elem);
	            }
	            break;
	        }
	        i += 1;
	    }
	};
	
	HybridRenderer.prototype.configAnimation = function(animData){
	    var resizerElem = document.createElement('div');
	    var wrapper = this.animationItem.wrapper;
	    resizerElem.style.width = animData.w+'px';
	    resizerElem.style.height = animData.h+'px';
	    this.resizerElem = resizerElem;
	    styleDiv(resizerElem);
	    resizerElem.style.transformStyle = resizerElem.style.webkitTransformStyle = resizerElem.style.mozTransformStyle = "flat";
	    wrapper.appendChild(resizerElem);
	
	    resizerElem.style.overflow = 'hidden';
	    var svg = document.createElementNS(svgNS,'svg');
	    svg.setAttribute('width','1');
	    svg.setAttribute('height','1');
	    styleDiv(svg);
	    this.resizerElem.appendChild(svg);
	    var defs = document.createElementNS(svgNS,'defs');
	    svg.appendChild(defs);
	    this.globalData.defs = defs;
	    this.data = animData;
	    //Mask animation
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem);
	    this.globalData.frameId = 0;
	    this.globalData.compSize = {
	        w: animData.w,
	        h: animData.h
	    };
	    this.globalData.frameRate = animData.fr;
	    this.layers = animData.layers;
	    this.globalData.fontManager = new FontManager();
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts,svg);
	    this.layerElement = this.resizerElem;
	    this.build3dContainers();
	    this.updateContainerSize();
	};
	
	HybridRenderer.prototype.destroy = function () {
	    this.animationItem.wrapper.innerHTML = '';
	    this.animationItem.container = null;
	    this.globalData.defs = null;
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = 0; i < len; i++) {
	        this.elements[i].destroy();
	    }
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	};
	
	HybridRenderer.prototype.updateContainerSize = function () {
	    var elementWidth = this.animationItem.wrapper.offsetWidth;
	    var elementHeight = this.animationItem.wrapper.offsetHeight;
	    var elementRel = elementWidth/elementHeight;
	    var animationRel = this.globalData.compSize.w/this.globalData.compSize.h;
	    var sx,sy,tx,ty;
	    if(animationRel>elementRel){
	        sx = elementWidth/(this.globalData.compSize.w);
	        sy = elementWidth/(this.globalData.compSize.w);
	        tx = 0;
	        ty = ((elementHeight-this.globalData.compSize.h*(elementWidth/this.globalData.compSize.w))/2);
	    }else{
	        sx = elementHeight/(this.globalData.compSize.h);
	        sy = elementHeight/(this.globalData.compSize.h);
	        tx = (elementWidth-this.globalData.compSize.w*(elementHeight/this.globalData.compSize.h))/2;
	        ty = 0;
	    }
	    this.resizerElem.style.transform = this.resizerElem.style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,'+sy+',0,0,0,0,1,0,'+tx+','+ty+',0,1)';
	};
	
	HybridRenderer.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
	
	HybridRenderer.prototype.hide = function(){
	    this.resizerElem.style.display = 'none';
	};
	
	HybridRenderer.prototype.show = function(){
	    this.resizerElem.style.display = 'block';
	};
	
	HybridRenderer.prototype.initItems = function(){
	    this.buildAllItems();
	    if(this.camera){
	        this.camera.setup();
	    } else {
	        var cWidth = this.globalData.compSize.w;
	        var cHeight = this.globalData.compSize.h;
	        var i, len = this.threeDElements.length;
	        for(i=0;i<len;i+=1){
	            this.threeDElements[i].perspectiveElem.style.perspective = this.threeDElements[i].perspectiveElem.style.webkitPerspective = Math.sqrt(Math.pow(cWidth,2) + Math.pow(cHeight,2)) + 'px';
	        }
	    }
	};
	
	HybridRenderer.prototype.searchExtraCompositions = function(assets){
	    var i, len = assets.length;
	    var floatingContainer = document.createElement('div');
	    for(i=0;i<len;i+=1){
	        if(assets[i].xt){
	            var comp = this.createComp(assets[i],floatingContainer,this.globalData.comp,null);
	            comp.initExpressions();
	            this.globalData.projectInterface.registerComposition(comp);
	        }
	    }
	};
	function CVBaseElement(data, comp,globalData){
	    this.globalData = globalData;
	    this.data = data;
	    this.comp = comp;
	    this.canvasContext = globalData.canvasContext;
	    this.init();
	}
	
	createElement(BaseElement, CVBaseElement);
	
	CVBaseElement.prototype.createElements = function(){
	    this.checkParenting();
	};
	
	CVBaseElement.prototype.checkBlendMode = function(globalData){
	    if(globalData.blendMode !== this.data.bm) {
	        globalData.blendMode = this.data.bm;
	
	        var blendModeValue = '';
	        switch (this.data.bm) {
	            case 0:
	                blendModeValue = 'normal';
	                break;
	            case 1:
	                blendModeValue = 'multiply';
	                break;
	            case 2:
	                blendModeValue = 'screen';
	                break;
	            case 3:
	                blendModeValue = 'overlay';
	                break;
	            case 4:
	                blendModeValue = 'darken';
	                break;
	            case 5:
	                blendModeValue = 'lighten';
	                break;
	            case 6:
	                blendModeValue = 'color-dodge';
	                break;
	            case 7:
	                blendModeValue = 'color-burn';
	                break;
	            case 8:
	                blendModeValue = 'hard-light';
	                break;
	            case 9:
	                blendModeValue = 'soft-light';
	                break;
	            case 10:
	                blendModeValue = 'difference';
	                break;
	            case 11:
	                blendModeValue = 'exclusion';
	                break;
	            case 12:
	                blendModeValue = 'hue';
	                break;
	            case 13:
	                blendModeValue = 'saturation';
	                break;
	            case 14:
	                blendModeValue = 'color';
	                break;
	            case 15:
	                blendModeValue = 'luminosity';
	                break;
	        }
	        globalData.canvasContext.globalCompositeOperation = blendModeValue;
	    }
	};
	
	
	CVBaseElement.prototype.renderFrame = function(parentTransform){
	    if(this.data.ty === 3){
	        return false;
	    }
	        this.checkBlendMode(this.data.ty === 0?this.parentGlobalData:this.globalData);
	
	    if(!this.isVisible){
	        return this.isVisible;
	    }
	    this.finalTransform.opMdf = this.finalTransform.op.mdf;
	    this.finalTransform.matMdf = this.finalTransform.mProp.mdf;
	    this.finalTransform.opacity = this.finalTransform.op.v;
	
	    var mat;
	    var finalMat = this.finalTransform.mat;
	
	    if(this.hierarchy){
	        var i, len = this.hierarchy.length;
	        mat = this.finalTransform.mProp.v.props;
	        finalMat.cloneFromProps(mat);
	        for(i=0;i<len;i+=1){
	            this.finalTransform.matMdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : this.finalTransform.matMdf;
	            mat = this.hierarchy[i].finalTransform.mProp.v.props;
	            finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
	        }
	    }else{
	        if(!parentTransform){
	            finalMat.cloneFromProps(this.finalTransform.mProp.v.props);
	        }else{
	            mat = this.finalTransform.mProp.v.props;
	            finalMat.cloneFromProps(mat);
	        }
	    }
	
	    if(parentTransform){
	        mat = parentTransform.mat.props;
	        finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
	        this.finalTransform.opacity *= parentTransform.opacity;
	        this.finalTransform.opMdf = parentTransform.opMdf ? true : this.finalTransform.opMdf;
	        this.finalTransform.matMdf = parentTransform.matMdf ? true : this.finalTransform.matMdf
	    }
	
	    if(this.data.hasMask){
	        this.globalData.renderer.save(true);
	        this.maskManager.renderFrame(this.data.ty === 0?null:finalMat);
	    }
	    if(this.data.hd){
	        this.isVisible = false;
	    }
	    return this.isVisible;
	
	};
	
	CVBaseElement.prototype.addMasks = function(data){
	    this.maskManager = new CVMaskElement(data,this,this.globalData);
	};
	
	
	CVBaseElement.prototype.destroy = function(){
	    this.canvasContext = null;
	    this.data = null;
	    this.globalData = null;
	    if(this.maskManager) {
	        this.maskManager.destroy();
	    }
	};
	
	CVBaseElement.prototype.mHelper = new Matrix();
	
	function CVCompElement(data, comp,globalData){
	    this._parent.constructor.call(this,data, comp,globalData);
	    var compGlobalData = {};
	    for(var s in globalData){
	        if(globalData.hasOwnProperty(s)){
	            compGlobalData[s] = globalData[s];
	        }
	    }
	    compGlobalData.renderer = this;
	    compGlobalData.compHeight = this.data.h;
	    compGlobalData.compWidth = this.data.w;
	    this.renderConfig = {
	        clearCanvas: true
	    };
	    this.contextData = {
	        saved : Array.apply(null,{length:15}),
	        savedOp: Array.apply(null,{length:15}),
	        cArrPos : 0,
	        cTr : new Matrix(),
	        cO : 1
	    };
	    this.completeLayers = false;
	    var i, len = 15;
	    for(i=0;i<len;i+=1){
	        this.contextData.saved[i] = Array.apply(null,{length:16});
	    }
	    this.transformMat = new Matrix();
	    this.parentGlobalData = this.globalData;
	    var cv = document.createElement('canvas');
	    //document.body.appendChild(cv);
	    compGlobalData.canvasContext = cv.getContext('2d');
	    this.canvasContext = compGlobalData.canvasContext;
	    cv.width = this.data.w;
	    cv.height = this.data.h;
	    this.canvas = cv;
	    this.globalData = compGlobalData;
	    this.layers = data.layers;
	    this.pendingElements = [];
	    this.elements = Array.apply(null,{length:this.layers.length});
	    if(this.data.tm){
	        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
	    }
	    if(this.data.xt || !globalData.progressiveLoad){
	        this.buildAllItems();
	    }
	}
	createElement(CVBaseElement, CVCompElement);
	
	CVCompElement.prototype.ctxTransform = CanvasRenderer.prototype.ctxTransform;
	CVCompElement.prototype.ctxOpacity = CanvasRenderer.prototype.ctxOpacity;
	CVCompElement.prototype.save = CanvasRenderer.prototype.save;
	CVCompElement.prototype.restore = CanvasRenderer.prototype.restore;
	CVCompElement.prototype.reset =  function(){
	    this.contextData.cArrPos = 0;
	    this.contextData.cTr.reset();
	    this.contextData.cO = 1;
	};
	CVCompElement.prototype.resize = function(transformCanvas){
	    var maxScale = Math.max(transformCanvas.sx,transformCanvas.sy);
	    this.canvas.width = this.data.w*maxScale;
	    this.canvas.height = this.data.h*maxScale;
	    this.transformCanvas = {
	        sc:maxScale,
	        w:this.data.w*maxScale,
	        h:this.data.h*maxScale,
	        props:[maxScale,0,0,0,0,maxScale,0,0,0,0,1,0,0,0,0,1]
	    }
	    var i,len = this.elements.length;
	    for( i = 0; i < len; i+=1 ){
	        if(this.elements[i] && this.elements[i].data.ty === 0){
	            this.elements[i].resize(transformCanvas);
	        }
	    }
	};
	
	CVCompElement.prototype.prepareFrame = function(num){
	    this.globalData.frameId = this.parentGlobalData.frameId;
	    this.globalData.mdf = false;
	    this._parent.prepareFrame.call(this,num);
	    if(this.isVisible===false && !this.data.xt){
	        return;
	    }
	    var timeRemapped = num;
	    if(this.tm){
	        timeRemapped = this.tm.v;
	        if(timeRemapped === this.data.op){
	            timeRemapped = this.data.op - 1;
	        }
	    }
	    this.renderedFrame = timeRemapped/this.data.sr;
	    var i,len = this.elements.length;
	
	    if(!this.completeLayers){
	        this.checkLayers(num);
	    }
	
	    for( i = 0; i < len; i+=1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(timeRemapped/this.data.sr - this.layers[i].st);
	            if(this.elements[i].data.ty === 0 && this.elements[i].globalData.mdf){
	                this.globalData.mdf = true;
	            }
	        }
	    }
	    if(this.globalData.mdf && !this.data.xt){
	        this.canvasContext.clearRect(0, 0, this.data.w, this.data.h);
	        this.ctxTransform(this.transformCanvas.props);
	    }
	};
	
	CVCompElement.prototype.renderFrame = function(parentMatrix){
	    if(this._parent.renderFrame.call(this,parentMatrix)===false){
	        return;
	    }
	    if(this.globalData.mdf){
	        var i,len = this.layers.length;
	        for( i = len - 1; i >= 0; i -= 1 ){
	            if(this.completeLayers || this.elements[i]){
	                this.elements[i].renderFrame();
	            }
	        }
	    }
	    if(this.data.hasMask){
	        this.globalData.renderer.restore(true);
	    }
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	    this.parentGlobalData.renderer.save();
	    this.parentGlobalData.renderer.ctxTransform(this.finalTransform.mat.props);
	    this.parentGlobalData.renderer.ctxOpacity(this.finalTransform.opacity);
	    this.parentGlobalData.renderer.canvasContext.drawImage(this.canvas,0,0,this.data.w,this.data.h);
	    this.parentGlobalData.renderer.restore();
	
	    if(this.globalData.mdf){
	        this.reset();
	    }
	};
	
	CVCompElement.prototype.setElements = function(elems){
	    this.elements = elems;
	};
	
	CVCompElement.prototype.getElements = function(){
	    return this.elements;
	};
	
	CVCompElement.prototype.destroy = function(){
	    var i,len = this.layers.length;
	    for( i = len - 1; i >= 0; i -= 1 ){
	        this.elements[i].destroy();
	    }
	    this.layers = null;
	    this.elements = null;
	    this._parent.destroy.call(this._parent);
	};
	CVCompElement.prototype.checkLayers = CanvasRenderer.prototype.checkLayers;
	CVCompElement.prototype.buildItem = CanvasRenderer.prototype.buildItem;
	CVCompElement.prototype.checkPendingElements = CanvasRenderer.prototype.checkPendingElements;
	CVCompElement.prototype.addPendingElement = CanvasRenderer.prototype.addPendingElement;
	CVCompElement.prototype.buildAllItems = CanvasRenderer.prototype.buildAllItems;
	CVCompElement.prototype.createItem = CanvasRenderer.prototype.createItem;
	CVCompElement.prototype.createImage = CanvasRenderer.prototype.createImage;
	CVCompElement.prototype.createComp = CanvasRenderer.prototype.createComp;
	CVCompElement.prototype.createSolid = CanvasRenderer.prototype.createSolid;
	CVCompElement.prototype.createShape = CanvasRenderer.prototype.createShape;
	CVCompElement.prototype.createText = CanvasRenderer.prototype.createText;
	CVCompElement.prototype.createBase = CanvasRenderer.prototype.createBase;
	CVCompElement.prototype.buildElementParenting = CanvasRenderer.prototype.buildElementParenting;
	function CVImageElement(data, comp,globalData){
	    this.assetData = globalData.getAssetData(data.refId);
	    this._parent.constructor.call(this,data, comp,globalData);
	    this.globalData.addPendingElement();
	}
	createElement(CVBaseElement, CVImageElement);
	
	CVImageElement.prototype.createElements = function(){
	    var imageLoaded = function(){
	        this.globalData.elementLoaded();
	        if(this.assetData.w !== this.img.width || this.assetData.h !== this.img.height){
	            var canvas = document.createElement('canvas');
	            canvas.width = this.assetData.w;
	            canvas.height = this.assetData.h;
	            var ctx = canvas.getContext('2d');
	
	            var imgW = this.img.width;
	            var imgH = this.img.height;
	            var imgRel = imgW / imgH;
	            var canvasRel = this.assetData.w/this.assetData.h;
	            var widthCrop, heightCrop;
	            if(imgRel>canvasRel){
	                heightCrop = imgH;
	                widthCrop = heightCrop*canvasRel;
	            } else {
	                widthCrop = imgW;
	                heightCrop = widthCrop/canvasRel;
	            }
	            ctx.drawImage(this.img,(imgW-widthCrop)/2,(imgH-heightCrop)/2,widthCrop,heightCrop,0,0,this.assetData.w,this.assetData.h);
	            this.img = canvas;
	        }
	    }.bind(this);
	    var imageFailed = function(){
	        this.failed = true;
	        this.globalData.elementLoaded();
	    }.bind(this);
	
	    this.img = new Image();
	    this.img.addEventListener('load', imageLoaded, false);
	    this.img.addEventListener('error', imageFailed, false);
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    this.img.src = assetPath;
	
	    this._parent.createElements.call(this);
	
	};
	
	CVImageElement.prototype.renderFrame = function(parentMatrix){
	    if(this.failed){
	        return;
	    }
	    if(this._parent.renderFrame.call(this,parentMatrix)===false){
	        return;
	    }
	    var ctx = this.canvasContext;
	    this.globalData.renderer.save();
	    var finalMat = this.finalTransform.mat.props;
	    this.globalData.renderer.ctxTransform(finalMat);
	    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
	    ctx.drawImage(this.img,0,0);
	    this.globalData.renderer.restore(this.data.hasMask);
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	
	CVImageElement.prototype.destroy = function(){
	    this.img = null;
	    this._parent.destroy.call(this._parent);
	};
	
	function CVMaskElement(data,element){
	    this.data = data;
	    this.element = element;
	    this.dynamicProperties = [];
	    this.masksProperties = this.data.masksProperties;
	    this.viewData = new Array(this.masksProperties.length);
	    var i, len = this.masksProperties.length;
	    for (i = 0; i < len; i++) {
	        this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element,this.masksProperties[i],3,this.dynamicProperties,null);
	    }
	}
	
	CVMaskElement.prototype.getMaskProperty = function(pos){
	    return this.viewData[pos];
	};
	
	CVMaskElement.prototype.prepareFrame = function(num){
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue(num);
	        if(this.dynamicProperties[i].mdf){
	            this.element.globalData.mdf = true;
	        }
	    }
	};
	
	CVMaskElement.prototype.renderFrame = function (transform) {
	    var ctx = this.element.canvasContext;
	    var i, len = this.data.masksProperties.length;
	    var pt,pt2,pt3,data, hasMasks = false;
	    for (i = 0; i < len; i++) {
	        if(this.masksProperties[i].mode === 'n'){
	            continue;
	        }
	        if(hasMasks === false){
	            ctx.beginPath();
	            hasMasks = true;
	        }
	        if (this.masksProperties[i].inv) {
	            ctx.moveTo(0, 0);
	            ctx.lineTo(this.element.globalData.compWidth, 0);
	            ctx.lineTo(this.element.globalData.compWidth, this.element.globalData.compHeight);
	            ctx.lineTo(0, this.element.globalData.compHeight);
	            ctx.lineTo(0, 0);
	        }
	        data = this.viewData[i].v;
	        pt = transform ? transform.applyToPointArray(data.v[0][0],data.v[0][1],0):data.v[0];
	        ctx.moveTo(pt[0], pt[1]);
	        var j, jLen = data._length;
	        for (j = 1; j < jLen; j++) {
	            pt = transform ? transform.applyToPointArray(data.o[j - 1][0],data.o[j - 1][1],0) : data.o[j - 1];
	            pt2 = transform ? transform.applyToPointArray(data.i[j][0],data.i[j][1],0) : data.i[j];
	            pt3 = transform ? transform.applyToPointArray(data.v[j][0],data.v[j][1],0) : data.v[j];
	            ctx.bezierCurveTo(pt[0], pt[1], pt2[0], pt2[1], pt3[0], pt3[1]);
	        }
	        pt = transform ? transform.applyToPointArray(data.o[j - 1][0],data.o[j - 1][1],0) : data.o[j - 1];
	        pt2 = transform ? transform.applyToPointArray(data.i[0][0],data.i[0][1],0) : data.i[0];
	        pt3 = transform ? transform.applyToPointArray(data.v[0][0],data.v[0][1],0) : data.v[0];
	        ctx.bezierCurveTo(pt[0], pt[1], pt2[0], pt2[1], pt3[0], pt3[1]);
	    }
	    if(hasMasks){
	        ctx.clip();
	    }
	};
	
	CVMaskElement.prototype.getMask = function(nm){
	    var i = 0, len = this.masksProperties.length;
	    while(i<len){
	        if(this.masksProperties[i].nm === nm){
	            return {
	                maskPath: this.viewData[i].pv
	            }
	        }
	        i += 1;
	    }
	};
	
	CVMaskElement.prototype.destroy = function(){
	    this.element = null;
	};
	function CVShapeElement(data, comp,globalData){
	    this.shapes = [];
	    this.shapesData = data.shapes;
	    this.stylesList = [];
	    this.itemsData = [];
	    this.prevViewData = [];
	    this.shapeModifiers = [];
	    this.processedElements = [];
	    this._parent.constructor.call(this,data, comp,globalData);
	}
	createElement(CVBaseElement, CVShapeElement);
	
	CVShapeElement.prototype.transformHelper = {opacity:1,mat:new Matrix(),matMdf:false,opMdf:false};
	
	CVShapeElement.prototype.dashResetter = [];
	
	CVShapeElement.prototype.createElements = function(){
	
	    this._parent.createElements.call(this);
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.dynamicProperties, true);
	};
	
	CVShapeElement.prototype.createStyleElement = function(data, dynamicProperties){
	    var styleElem = {
	        data: data,
	        type: data.ty,
	        elements: []
	    };
	    var elementData = {};
	    if(data.ty == 'fl' || data.ty == 'st'){
	        elementData.c = PropertyFactory.getProp(this,data.c,1,255,dynamicProperties);
	        if(!elementData.c.k){
	            styleElem.co = 'rgb('+bm_floor(elementData.c.v[0])+','+bm_floor(elementData.c.v[1])+','+bm_floor(elementData.c.v[2])+')';
	        }
	    }
	    elementData.o = PropertyFactory.getProp(this,data.o,0,0.01,dynamicProperties);
	    if(data.ty == 'st') {
	        styleElem.lc = this.lcEnum[data.lc] || 'round';
	        styleElem.lj = this.ljEnum[data.lj] || 'round';
	        if(data.lj == 1) {
	            styleElem.ml = data.ml;
	        }
	        elementData.w = PropertyFactory.getProp(this,data.w,0,null,dynamicProperties);
	        if(!elementData.w.k){
	            styleElem.wi = elementData.w.v;
	        }
	        if(data.d){
	            var d = PropertyFactory.getDashProp(this,data.d,'canvas',dynamicProperties);
	            elementData.d = d;
	            if(!elementData.d.k){
	                styleElem.da = elementData.d.dasharray;
	                styleElem.do = elementData.d.dashoffset;
	            }
	        }
	
	    } else {
	
	        styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
	    }
	    this.stylesList.push(styleElem);
	    elementData.style = styleElem;
	    return elementData;
	}
	
	CVShapeElement.prototype.createGroupElement = function(data) {
	    var elementData = {
	        it: [],
	        prevViewData: []
	    };
	    return elementData;
	}
	
	CVShapeElement.prototype.createTransformElement = function(data, dynamicProperties) {
	    var elementData = {
	        transform : {
	            mat: new Matrix(),
	            opacity: 1,
	            matMdf:false,
	            opMdf:false,
	            op: PropertyFactory.getProp(this,data.o,0,0.01,dynamicProperties),
	            mProps: PropertyFactory.getProp(this,data,2,null,dynamicProperties)
	        },
	        elements: []
	    };
	    return elementData;
	}
	
	CVShapeElement.prototype.createShapeElement = function(data, dynamicProperties) {
	    var elementData = {
	        nodes:[],
	        trNodes:[],
	        tr:[0,0,0,0,0,0]
	    };
	    var ty = 4;
	    if(data.ty == 'rc'){
	        ty = 5;
	    }else if(data.ty == 'el'){
	        ty = 6;
	    }else if(data.ty == 'sr'){
	        ty = 7;
	    }
	    elementData.sh = ShapePropertyFactory.getShapeProp(this,data,ty,dynamicProperties);
	    this.shapes.push(elementData.sh);
	    this.addShapeToModifiers(elementData);
	    jLen = this.stylesList.length;
	    var hasStrokes = false, hasFills = false;
	    for(j=0;j<jLen;j+=1){
	        if(!this.stylesList[j].closed){
	            this.stylesList[j].elements.push(elementData);
	            if(this.stylesList[j].type === 'st'){
	                hasStrokes = true;
	            }else{
	                hasFills = true;
	            }
	        }
	    }
	    elementData.st = hasStrokes;
	    elementData.fl = hasFills;
	    return elementData;
	}
	
	CVShapeElement.prototype.reloadShapes = function(){
	    this.firstFrame = true;
	    var i, len = this.itemsData.length;
	    for(i=0;i<len;i+=1){
	        this.prevViewData[i] = this.itemsData[i];
	    }
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.dynamicProperties, true);
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	    }
	    this.renderModifiers();
	}
	
	CVShapeElement.prototype.searchShapes = function(arr,itemsData, prevViewData,dynamicProperties, render){
	    var i, len = arr.length - 1;
	    var j, jLen;
	    var ownArrays = [], ownModifiers = [], processedPos;
	    for(i=len;i>=0;i-=1){
	        processedPos = this.searchProcessedElement(arr[i]);
	        if(!processedPos){
	            arr[i]._render = render;
	        } else {
	            itemsData[i] = prevViewData[processedPos - 1];
	        }
	        if(arr[i].ty == 'fl' || arr[i].ty == 'st'){
	            if(!processedPos){
	                itemsData[i] = this.createStyleElement(arr[i], dynamicProperties);
	            } else {
	                itemsData[i].style.closed = false;
	            }
	            
	            ownArrays.push(itemsData[i].style);
	        }else if(arr[i].ty == 'gr'){
	            if(!processedPos){
	                itemsData[i] = this.createGroupElement(arr[i]);
	            } else {
	                jLen = itemsData[i].it.length;
	                for(j=0;j<jLen;j+=1){
	                    itemsData[i].prevViewData[j] = itemsData[i].it[j];
	                }
	            }
	            this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData,dynamicProperties, render);
	        }else if(arr[i].ty == 'tr'){
	            if(!processedPos){
	                itemsData[i] = this.createTransformElement(arr[i], dynamicProperties);
	            }
	        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
	            if(!processedPos){
	                itemsData[i] = this.createShapeElement(arr[i], dynamicProperties);
	            }
	            
	        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd'){
	            if(!processedPos){
	                var modifier = ShapeModifiers.getModifier(arr[i].ty);
	                modifier.init(this,arr[i],dynamicProperties);
	                itemsData[i] = modifier;
	                this.shapeModifiers.push(modifier);
	            } else {
	                modifier = itemsData[i];
	                modifier.closed = false;
	            }
	            ownModifiers.push(modifier);
	        } else if(arr[i].ty == 'rp'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                itemsData[i] = modifier;
	                modifier.init(this,arr,i,itemsData,dynamicProperties);
	                this.shapeModifiers.push(modifier);
	                render = false;
	            }else{
	                modifier = itemsData[i];
	                modifier.closed = true;
	            }
	            ownModifiers.push(modifier);
	        }
	        this.addProcessedElement(arr[i], i + 1);
	    }
	    len = ownArrays.length;
	    for(i=0;i<len;i+=1){
	        ownArrays[i].closed = true;
	    }
	    len = ownModifiers.length;
	    for(i=0;i<len;i+=1){
	        ownModifiers[i].closed = true;
	    }
	};
	
	CVShapeElement.prototype.addShapeToModifiers = IShapeElement.prototype.addShapeToModifiers;
	CVShapeElement.prototype.renderModifiers = IShapeElement.prototype.renderModifiers;
	CVShapeElement.prototype.lcEnum = IShapeElement.prototype.lcEnum;
	CVShapeElement.prototype.ljEnum = IShapeElement.prototype.ljEnum;
	CVShapeElement.prototype.searchProcessedElement = IShapeElement.prototype.searchProcessedElement;
	CVShapeElement.prototype.addProcessedElement = IShapeElement.prototype.addProcessedElement;
	
	CVShapeElement.prototype.renderFrame = function(parentMatrix){
	    if(this._parent.renderFrame.call(this, parentMatrix)===false){
	        return;
	    }
	    this.transformHelper.mat.reset();
	    this.transformHelper.opacity = this.finalTransform.opacity;
	    this.transformHelper.matMdf = false;
	    this.transformHelper.opMdf = this.finalTransform.opMdf;
	    this.renderModifiers();
	    this.renderShape(this.transformHelper,null,null,true);
	    if(this.data.hasMask){
	        this.globalData.renderer.restore(true);
	    }
	};
	
	CVShapeElement.prototype.renderShape = function(parentTransform,items,data,isMain){
	    var i, len;
	    if(!items){
	        items = this.shapesData;
	        len = this.stylesList.length;
	        for(i=0;i<len;i+=1){
	            this.stylesList[i].d = '';
	            this.stylesList[i].mdf = false;
	        }
	    }
	    if(!data){
	        data = this.itemsData;
	    }
	    ///
	    ///
	    len = items.length - 1;
	    var groupTransform,groupMatrix;
	    groupTransform = parentTransform;
	    for(i=len;i>=0;i-=1){
	        if(items[i].ty == 'tr'){
	            groupTransform = data[i].transform;
	            var mtArr = data[i].transform.mProps.v.props;
	            groupTransform.matMdf = groupTransform.mProps.mdf;
	            groupTransform.opMdf = groupTransform.op.mdf;
	            groupMatrix = groupTransform.mat;
	            groupMatrix.cloneFromProps(mtArr);
	            if(parentTransform){
	                var props = parentTransform.mat.props;
	                groupTransform.opacity = parentTransform.opacity;
	                groupTransform.opacity *= data[i].transform.op.v;
	                groupTransform.matMdf = parentTransform.matMdf ? true : groupTransform.matMdf;
	                groupTransform.opMdf = parentTransform.opMdf ? true : groupTransform.opMdf;
	                groupMatrix.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
	            }else{
	                groupTransform.opacity = groupTransform.op.o;
	            }
	        }else if(items[i].ty == 'sh' || items[i].ty == 'el' || items[i].ty == 'rc' || items[i].ty == 'sr'){
	            this.renderPath(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'fl'){
	            this.renderFill(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'st'){
	            this.renderStroke(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'gr'){
	            this.renderShape(groupTransform,items[i].it,data[i].it);
	        }else if(items[i].ty == 'tm'){
	            //
	        }
	    }
	    if(!isMain){
	        return;
	    }
	    len = this.stylesList.length;
	    var j, jLen, k, kLen,elems,nodes, renderer = this.globalData.renderer, ctx = this.globalData.canvasContext, type;
	    renderer.save();
	    renderer.ctxTransform(this.finalTransform.mat.props);
	    for(i=0;i<len;i+=1){
	        type = this.stylesList[i].type;
	        if((type === 'st' && this.stylesList[i].wi === 0) || !this.stylesList[i].data._render){
	            continue;
	        }
	        renderer.save();
	        elems = this.stylesList[i].elements;
	        if(type === 'st'){
	            ctx.strokeStyle = this.stylesList[i].co;
	            ctx.lineWidth = this.stylesList[i].wi;
	            ctx.lineCap = this.stylesList[i].lc;
	            ctx.lineJoin = this.stylesList[i].lj;
	            ctx.miterLimit = this.stylesList[i].ml || 0;
	        }else{
	            ctx.fillStyle = this.stylesList[i].co;
	        }
	        renderer.ctxOpacity(this.stylesList[i].coOp);
	        if(type !== 'st'){
	            ctx.beginPath();
	        }
	        jLen = elems.length;
	        for(j=0;j<jLen;j+=1){
	            if(type === 'st'){
	                ctx.beginPath();
	                if(this.stylesList[i].da){
	                    ctx.setLineDash(this.stylesList[i].da);
	                    ctx.lineDashOffset = this.stylesList[i].do;
	                    this.globalData.isDashed = true;
	                }else if(this.globalData.isDashed){
	                    ctx.setLineDash(this.dashResetter);
	                    this.globalData.isDashed = false;
	                }
	            }
	            nodes = elems[j].trNodes;
	            kLen = nodes.length;
	
	            for(k=0;k<kLen;k+=1){
	                if(nodes[k].t == 'm'){
	                    ctx.moveTo(nodes[k].p[0],nodes[k].p[1]);
	                }else if(nodes[k].t == 'c'){
	                    ctx.bezierCurveTo(nodes[k].p1[0],nodes[k].p1[1],nodes[k].p2[0],nodes[k].p2[1],nodes[k].p3[0],nodes[k].p3[1]);
	                }else{
	                    ctx.closePath();
	                }
	            }
	            if(type === 'st'){
	                ctx.stroke();
	            }
	        }
	        if(type !== 'st'){
	            ctx.fill(this.stylesList[i].r);
	        }
	        renderer.restore();
	    }
	    renderer.restore();
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	CVShapeElement.prototype.renderPath = function(pathData,itemData,groupTransform){
	    var len, i, j,jLen;
	    var redraw = groupTransform.matMdf || itemData.sh.mdf || this.firstFrame;
	    if(redraw) {
	        var paths = itemData.sh.paths;
	        jLen = paths._length;
	        var pathStringTransformed = itemData.trNodes;
	        pathStringTransformed.length = 0;
	        for(j=0;j<jLen;j+=1){
	            var pathNodes = paths.shapes[j];
	            if(pathNodes && pathNodes.v){
	                len = pathNodes._length;
	                for (i = 1; i < len; i += 1) {
	                    if (i == 1) {
	                        pathStringTransformed.push({
	                            t: 'm',
	                            p: groupTransform.mat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	                        });
	                    }
	                    pathStringTransformed.push({
	                        t: 'c',
	                        p1: groupTransform.mat.applyToPointArray(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1], 0),
	                        p2: groupTransform.mat.applyToPointArray(pathNodes.i[i][0], pathNodes.i[i][1], 0),
	                        p3: groupTransform.mat.applyToPointArray(pathNodes.v[i][0], pathNodes.v[i][1], 0)
	                    });
	                }
	                if (len == 1) {
	                    pathStringTransformed.push({
	                        t: 'm',
	                        p: groupTransform.mat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	                    });
	                }
	                if (pathNodes.c && len) {
	                    pathStringTransformed.push({
	                        t: 'c',
	                        p1: groupTransform.mat.applyToPointArray(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1], 0),
	                        p2: groupTransform.mat.applyToPointArray(pathNodes.i[0][0], pathNodes.i[0][1], 0),
	                        p3: groupTransform.mat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	                    });
	                    pathStringTransformed.push({
	                        t: 'z'
	                    });
	                }
	                itemData.lStr = pathStringTransformed;
	            }
	
	        }
	
	        if (itemData.st) {
	            for (i = 0; i < 16; i += 1) {
	                itemData.tr[i] = groupTransform.mat.props[i];
	            }
	        }
	        itemData.trNodes = pathStringTransformed;
	
	    }
	};
	
	
	
	CVShapeElement.prototype.renderFill = function(styleData,itemData, groupTransform){
	    var styleElem = itemData.style;
	
	    if(itemData.c.mdf || this.firstFrame){
	        styleElem.co = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
	    }
	    if(itemData.o.mdf || groupTransform.opMdf || this.firstFrame){
	        styleElem.coOp = itemData.o.v*groupTransform.opacity;
	    }
	};
	
	CVShapeElement.prototype.renderStroke = function(styleData,itemData, groupTransform){
	    var styleElem = itemData.style;
	    //TODO fix dashes
	    var d = itemData.d;
	    var dasharray,dashoffset;
	    if(d && (d.mdf  || this.firstFrame)){
	        styleElem.da = d.dasharray;
	        styleElem.do = d.dashoffset;
	    }
	    if(itemData.c.mdf || this.firstFrame){
	        styleElem.co = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
	    }
	    if(itemData.o.mdf || groupTransform.opMdf || this.firstFrame){
	        styleElem.coOp = itemData.o.v*groupTransform.opacity;
	    }
	    if(itemData.w.mdf || this.firstFrame){
	        styleElem.wi = itemData.w.v;
	    }
	};
	
	
	CVShapeElement.prototype.destroy = function(){
	    this.shapesData = null;
	    this.globalData = null;
	    this.canvasContext = null;
	    this.stylesList.length = 0;
	    this.itemData.length = 0;
	    this._parent.destroy.call(this._parent);
	};
	
	
	function CVSolidElement(data, comp,globalData){
	    this._parent.constructor.call(this,data, comp,globalData);
	}
	createElement(CVBaseElement, CVSolidElement);
	
	CVSolidElement.prototype.renderFrame = function(parentMatrix){
	    if(this._parent.renderFrame.call(this, parentMatrix)===false){
	        return;
	    }
	    var ctx = this.canvasContext;
	    this.globalData.renderer.save();
	    this.globalData.renderer.ctxTransform(this.finalTransform.mat.props);
	    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
	    ctx.fillStyle=this.data.sc;
	    ctx.fillRect(0,0,this.data.sw,this.data.sh);
	    this.globalData.renderer.restore(this.data.hasMask);
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	function CVTextElement(data, comp, globalData){
	    this.textSpans = [];
	    this.yOffset = 0;
	    this.fillColorAnim = false;
	    this.strokeColorAnim = false;
	    this.strokeWidthAnim = false;
	    this.stroke = false;
	    this.fill = false;
	    this.justifyOffset = 0;
	    this.currentRender = null;
	    this.renderType = 'canvas';
	    this.values = {
	        fill: 'rgba(0,0,0,0)',
	        stroke: 'rgba(0,0,0,0)',
	        sWidth: 0,
	        fValue: ''
	    }
	    this._parent.constructor.call(this,data,comp, globalData);
	}
	createElement(CVBaseElement, CVTextElement);
	
	CVTextElement.prototype.init = ITextElement.prototype.init;
	CVTextElement.prototype.getMeasures = ITextElement.prototype.getMeasures;
	CVTextElement.prototype.getMult = ITextElement.prototype.getMult;
	CVTextElement.prototype.prepareFrame = ITextElement.prototype.prepareFrame;
	
	CVTextElement.prototype.tHelper = document.createElement('canvas').getContext('2d');
	
	CVTextElement.prototype.createElements = function(){
	
	    this._parent.createElements.call(this);
	    //console.log('this.data: ',this.data);
	
	};
	
	CVTextElement.prototype.buildNewText = function(){
	    var documentData = this.currentTextDocumentData;
	    this.renderedLetters = Array.apply(null,{length:this.currentTextDocumentData.l ? this.currentTextDocumentData.l.length : 0});
	
	    var hasFill = false;
	    if(documentData.fc) {
	        hasFill = true;
	        this.values.fill = 'rgb(' + Math.round(documentData.fc[0]*255) + ',' + Math.round(documentData.fc[1]*255) + ',' + Math.round(documentData.fc[2]*255) + ')';
	    }else{
	        this.values.fill = 'rgba(0,0,0,0)';
	    }
	    this.fill = hasFill;
	    var hasStroke = false;
	    if(documentData.sc){
	        hasStroke = true;
	        this.values.stroke = 'rgb(' + Math.round(documentData.sc[0]*255) + ',' + Math.round(documentData.sc[1]*255) + ',' + Math.round(documentData.sc[2]*255) + ')';
	        this.values.sWidth = documentData.sw;
	    }
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    var i, len;
	    var letters = documentData.l;
	    var matrixHelper = this.mHelper;
	    this.stroke = hasStroke;
	    this.values.fValue = documentData.s + 'px '+ this.globalData.fontManager.getFontByName(documentData.f).fFamily;
	    len = documentData.t.length;
	    this.tHelper.font = this.values.fValue;
	    var charData, shapeData, k, kLen, shapes, j, jLen, pathNodes, commands, pathArr, singleShape = this.data.singleShape;
	    if (singleShape) {
	        var xPos = 0, yPos = 0, lineWidths = documentData.lineWidths, boxWidth = documentData.boxWidth, firstLine = true;
	    }
	    var cnt = 0;
	    for (i = 0;i < len ;i += 1) {
	        charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	        var shapeData;
	        if(charData){
	            shapeData = charData.data;
	        } else {
	            shapeData = null;
	        }
	        matrixHelper.reset();
	        if(singleShape && letters[i].n) {
	            xPos = 0;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            firstLine = false;
	        }
	
	        if(shapeData && shapeData.shapes){
	            shapes = shapeData.shapes[0].it;
	            jLen = shapes.length;
	            matrixHelper.scale(documentData.s/100,documentData.s/100);
	            if(singleShape){
	                if(documentData.ps){
	                    matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
	                }
	                matrixHelper.translate(0,-documentData.ls,0);
	                switch(documentData.j){
	                    case 1:
	                        matrixHelper.translate(documentData.justifyOffset + (boxWidth - lineWidths[letters[i].line]),0,0);
	                        break;
	                    case 2:
	                        matrixHelper.translate(documentData.justifyOffset + (boxWidth - lineWidths[letters[i].line])/2,0,0);
	                        break;
	                }
	                matrixHelper.translate(xPos,yPos,0);
	            }
	            commands = new Array(jLen);
	            for(j=0;j<jLen;j+=1){
	                kLen = shapes[j].ks.k.i.length;
	                pathNodes = shapes[j].ks.k;
	                pathArr = [];
	                for(k=1;k<kLen;k+=1){
	                    if(k==1){
	                        pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
	                    }
	                    pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToY(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToX(pathNodes.v[k][0],pathNodes.v[k][1],0),matrixHelper.applyToY(pathNodes.v[k][0],pathNodes.v[k][1],0));
	                }
	                pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToY(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
	                commands[j] = pathArr;
	            }
	        }else{
	            commands = [];
	        }
	        if(singleShape){
	            xPos += letters[i].l;
	        }
	        if(this.textSpans[cnt]){
	            this.textSpans[cnt].elem = commands;
	        } else {
	            this.textSpans[cnt] = {elem: commands};
	        }
	        cnt +=1;
	    }
	}
	
	CVTextElement.prototype.renderFrame = function(parentMatrix){
	    if(this._parent.renderFrame.call(this, parentMatrix)===false){
	        return;
	    }
	    var ctx = this.canvasContext;
	    var finalMat = this.finalTransform.mat.props;
	    this.globalData.renderer.save();
	    this.globalData.renderer.ctxTransform(finalMat);
	    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
	    ctx.font = this.values.fValue;
	    ctx.lineCap = 'butt';
	    ctx.lineJoin = 'miter';
	    ctx.miterLimit = 4;
	
	    if(!this.data.singleShape){
	        this.getMeasures();
	    }
	
	    var  i,len, j, jLen, k, kLen;
	    var renderedLetters = this.renderedLetters;
	
	    var letters = this.currentTextDocumentData.l;
	
	    len = letters.length;
	    var renderedLetter;
	    var lastFill = null, lastStroke = null, lastStrokeW = null, commands, pathArr;
	    for(i=0;i<len;i+=1){
	        if(letters[i].n){
	            continue;
	        }
	        renderedLetter = renderedLetters[i];
	        if(renderedLetter){
	            this.globalData.renderer.save();
	            this.globalData.renderer.ctxTransform(renderedLetter.props);
	            this.globalData.renderer.ctxOpacity(renderedLetter.o);
	        }
	        if(this.fill){
	            if(renderedLetter && renderedLetter.fc){
	                if(lastFill !== renderedLetter.fc){
	                    lastFill = renderedLetter.fc;
	                    ctx.fillStyle = renderedLetter.fc;
	                }
	            }else if(lastFill !== this.values.fill){
	                lastFill = this.values.fill;
	                ctx.fillStyle = this.values.fill;
	            }
	            commands = this.textSpans[i].elem;
	            jLen = commands.length;
	            this.globalData.canvasContext.beginPath();
	            for(j=0;j<jLen;j+=1) {
	                pathArr = commands[j];
	                kLen = pathArr.length;
	                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	                for (k = 2; k < kLen; k += 6) {
	                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	                }
	            }
	            this.globalData.canvasContext.closePath();
	            this.globalData.canvasContext.fill();
	            ///ctx.fillText(this.textSpans[i].val,0,0);
	        }
	        if(this.stroke){
	            if(renderedLetter && renderedLetter.sw){
	                if(lastStrokeW !== renderedLetter.sw){
	                    lastStrokeW = renderedLetter.sw;
	                    ctx.lineWidth = renderedLetter.sw;
	                }
	            }else if(lastStrokeW !== this.values.sWidth){
	                lastStrokeW = this.values.sWidth;
	                ctx.lineWidth = this.values.sWidth;
	            }
	            if(renderedLetter && renderedLetter.sc){
	                if(lastStroke !== renderedLetter.sc){
	                    lastStroke = renderedLetter.sc;
	                    ctx.strokeStyle = renderedLetter.sc;
	                }
	            }else if(lastStroke !== this.values.stroke){
	                lastStroke = this.values.stroke;
	                ctx.strokeStyle = this.values.stroke;
	            }
	            commands = this.textSpans[i].elem;
	            jLen = commands.length;
	            this.globalData.canvasContext.beginPath();
	            for(j=0;j<jLen;j+=1) {
	                pathArr = commands[j];
	                kLen = pathArr.length;
	                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	                for (k = 2; k < kLen; k += 6) {
	                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	                }
	            }
	            this.globalData.canvasContext.closePath();
	            this.globalData.canvasContext.stroke();
	            ///ctx.strokeText(letters[i].val,0,0);
	        }
	        if(renderedLetter) {
	            this.globalData.renderer.restore();
	        }
	    }
	    /*if(this.data.hasMask){
	     this.globalData.renderer.restore(true);
	     }*/
	    this.globalData.renderer.restore(this.data.hasMask);
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	function HBaseElement(data,parentContainer,globalData,comp, placeholder){
	    this.globalData = globalData;
	    this.comp = comp;
	    this.data = data;
	    this.matteElement = null;
	    this.parentContainer = parentContainer;
	    this.layerId = placeholder ? placeholder.layerId : 'ly_'+randomString(10);
	    this.placeholder = placeholder;
	    this.init();
	};
	
	createElement(BaseElement, HBaseElement);
	HBaseElement.prototype.checkBlendMode = function(){
	
	};
	HBaseElement.prototype.setBlendMode = BaseElement.prototype.setBlendMode;
	
	/*HBaseElement.prototype.appendNodeToParent = function(node) {
	    if(this.data.hd){
	        return;
	    }
	    if(this.placeholder){
	        var g = this.placeholder.phElement;
	        g.parentNode.insertBefore(node, g);
	        //g.parentNode.removeChild(g);
	    }else{
	        this.parentContainer.appendChild(node);
	    }
	};*/
	
	
	HBaseElement.prototype.getBaseElement = function(){
	    return this.baseElement;
	};
	
	HBaseElement.prototype.createElements = function(){
	    if(this.data.hasMask){
	        this.layerElement = document.createElementNS(svgNS,'svg');
	        styleDiv(this.layerElement);
	        //this.appendNodeToParent(this.layerElement);
	        this.baseElement = this.layerElement;
	        this.maskedElement = this.layerElement;
	    }else{
	        this.layerElement = this.parentContainer;
	    }
	    this.transformedElement = this.layerElement;
	    if(this.data.ln && (this.data.ty === 4 || this.data.ty === 0)){
	        if(this.layerElement === this.parentContainer){
	            this.layerElement = document.createElementNS(svgNS,'g');
	            //this.appendNodeToParent(this.layerElement);
	            this.baseElement = this.layerElement;
	        }
	        this.layerElement.setAttribute('id',this.data.ln);
	    }
	    this.setBlendMode();
	    if(this.layerElement !== this.parentContainer){
	        this.placeholder = null;
	    }
	    this.checkParenting();
	};
	
	HBaseElement.prototype.renderFrame = function(parentTransform){
	    if(this.data.ty === 3){
	        return false;
	    }
	
	    if(this.currentFrameNum === this.lastNum || !this.isVisible){
	        return this.isVisible;
	    }
	    this.lastNum = this.currentFrameNum;
	
	    this.finalTransform.opMdf = this.finalTransform.op.mdf;
	    this.finalTransform.matMdf = this.finalTransform.mProp.mdf;
	    this.finalTransform.opacity = this.finalTransform.op.v;
	    if(this.firstFrame){
	        this.finalTransform.opMdf = true;
	        this.finalTransform.matMdf = true;
	    }
	
	    var mat;
	    var finalMat = this.finalTransform.mat;
	
	    if(this.hierarchy){
	        var i, len = this.hierarchy.length;
	
	        mat = this.finalTransform.mProp.v.props;
	        finalMat.cloneFromProps(mat);
	        for(i=0;i<len;i+=1){
	            this.finalTransform.matMdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : this.finalTransform.matMdf;
	            mat = this.hierarchy[i].finalTransform.mProp.v.props;
	            finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
	        }
	    }else{
	        if(this.isVisible && this.finalTransform.matMdf){
	            if(!parentTransform){
	                finalMat.cloneFromProps(this.finalTransform.mProp.v.props);
	            }else{
	                mat = this.finalTransform.mProp.v.props;
	                finalMat.cloneFromProps(mat);
	            }
	        }
	    }
	    if(this.data.hasMask){
	        this.maskManager.renderFrame(finalMat);
	    }
	
	    if(parentTransform){
	        mat = parentTransform.mat.props;
	        finalMat.cloneFromProps(mat);
	        this.finalTransform.opacity *= parentTransform.opacity;
	        this.finalTransform.opMdf = parentTransform.opMdf ? true : this.finalTransform.opMdf;
	        this.finalTransform.matMdf = parentTransform.matMdf ? true : this.finalTransform.matMdf
	    }
	
	    if(this.finalTransform.matMdf){
	        this.transformedElement.style.transform = this.transformedElement.style.webkitTransform = finalMat.toCSS();
	        this.finalMat = finalMat;
	    }
	    if(this.finalTransform.opMdf){
	        this.transformedElement.style.opacity = this.finalTransform.opacity;
	    }
	    return this.isVisible;
	};
	
	HBaseElement.prototype.destroy = function(){
	    this.layerElement = null;
	    this.transformedElement = null;
	    this.parentContainer = null;
	    if(this.matteElement) {
	        this.matteElement = null;
	    }
	    if(this.maskManager) {
	        this.maskManager.destroy();
	        this.maskManager = null;
	    }
	};
	
	HBaseElement.prototype.getDomElement = function(){
	    return this.layerElement;
	};
	HBaseElement.prototype.addMasks = function(data){
	    this.maskManager = new MaskElement(data,this,this.globalData);
	};
	
	HBaseElement.prototype.hide = function(){
	};
	
	HBaseElement.prototype.setMatte = function(){
	
	}
	
	HBaseElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;
	function HSolidElement(data,parentContainer,globalData,comp, placeholder){
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	}
	createElement(HBaseElement, HSolidElement);
	
	HSolidElement.prototype.createElements = function(){
	    var parent = document.createElement('div');
	    styleDiv(parent);
	    var cont = document.createElementNS(svgNS,'svg');
	    styleDiv(cont);
	    cont.setAttribute('width',this.data.sw);
	    cont.setAttribute('height',this.data.sh);
	    parent.appendChild(cont);
	    this.layerElement = parent;
	    this.transformedElement = parent;
	    //this.appendNodeToParent(parent);
	    this.baseElement = parent;
	    this.innerElem = parent;
	    if(this.data.ln){
	        this.innerElem.setAttribute('id',this.data.ln);
	    }
	    if(this.data.bm !== 0){
	        this.setBlendMode();
	    }
	    var rect = document.createElementNS(svgNS,'rect');
	    rect.setAttribute('width',this.data.sw);
	    rect.setAttribute('height',this.data.sh);
	    rect.setAttribute('fill',this.data.sc);
	    cont.appendChild(rect);
	    if(this.data.hasMask){
	        this.maskedElement = rect;
	    }
	    this.checkParenting();
	};
	
	
	
	HSolidElement.prototype.hide = SVGBaseElement.prototype.hide;
	HSolidElement.prototype.show = SVGBaseElement.prototype.show;
	HSolidElement.prototype.renderFrame = IImageElement.prototype.renderFrame;
	HSolidElement.prototype.destroy = IImageElement.prototype.destroy;
	function HCompElement(data,parentContainer,globalData,comp, placeholder){
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	    this.layers = data.layers;
	    this.supports3d = true;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = Array.apply(null,{length:this.layers.length});
	    if(this.data.tm){
	        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
	    }
	    if(this.data.hasMask) {
	        this.supports3d = false;
	    }
	    if(this.data.xt){
	        this.layerElement = document.createElement('div');
	    }
	    this.buildAllItems();
	
	}
	createElement(HBaseElement, HCompElement);
	
	HCompElement.prototype.createElements = function(){
	    var divElement = document.createElement('div');
	    styleDiv(divElement);
	    if(this.data.ln){
	        divElement.setAttribute('id',this.data.ln);
	    }
	    divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
	    if(this.data.hasMask){
	        var compSvg = document.createElementNS(svgNS,'svg');
	        styleDiv(compSvg);
	        compSvg.setAttribute('width',this.data.w);
	        compSvg.setAttribute('height',this.data.h);
	        var g = document.createElementNS(svgNS,'g');
	        compSvg.appendChild(g);
	        divElement.appendChild(compSvg);
	        this.maskedElement = g;
	        this.baseElement = divElement;
	        this.layerElement = g;
	        this.transformedElement = divElement;
	    }else{
	        this.layerElement = divElement;
	        this.baseElement = this.layerElement;
	        this.transformedElement = divElement;
	    }
	    //this.appendNodeToParent(this.layerElement);
	    this.checkParenting();
	};
	
	HCompElement.prototype.hide = ICompElement.prototype.hide;
	HCompElement.prototype.prepareFrame = ICompElement.prototype.prepareFrame;
	HCompElement.prototype.setElements = ICompElement.prototype.setElements;
	HCompElement.prototype.getElements = ICompElement.prototype.getElements;
	HCompElement.prototype.destroy = ICompElement.prototype.destroy;
	
	HCompElement.prototype.renderFrame = function(parentMatrix){
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    var i,len = this.layers.length;
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	
	    this.hidden = false;
	
	    for( i = 0; i < len; i+=1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	
	HCompElement.prototype.checkLayers = BaseRenderer.prototype.checkLayers;
	HCompElement.prototype.buildItem = HybridRenderer.prototype.buildItem;
	HCompElement.prototype.checkPendingElements = HybridRenderer.prototype.checkPendingElements;
	HCompElement.prototype.addPendingElement = HybridRenderer.prototype.addPendingElement;
	HCompElement.prototype.buildAllItems = BaseRenderer.prototype.buildAllItems;
	HCompElement.prototype.createItem = HybridRenderer.prototype.createItem;
	HCompElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;
	HCompElement.prototype.createImage = HybridRenderer.prototype.createImage;
	HCompElement.prototype.createComp = HybridRenderer.prototype.createComp;
	HCompElement.prototype.createSolid = HybridRenderer.prototype.createSolid;
	HCompElement.prototype.createShape = HybridRenderer.prototype.createShape;
	HCompElement.prototype.createText = HybridRenderer.prototype.createText;
	HCompElement.prototype.createBase = HybridRenderer.prototype.createBase;
	HCompElement.prototype.appendElementInPos = HybridRenderer.prototype.appendElementInPos;
	function HShapeElement(data,parentContainer,globalData,comp, placeholder){
	    this.shapes = [];
	    this.shapesData = data.shapes;
	    this.stylesList = [];
	    this.itemsData = [];
	    this.prevViewData = [];
	    this.shapeModifiers = [];
	    this.processedElements = [];
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	    this.currentBBox = {
	        x:999999,
	        y: -999999,
	        h: 0,
	        w: 0
	    };
	}
	createElement(HBaseElement, HShapeElement);
	var parent = HShapeElement.prototype._parent;
	extendPrototype(IShapeElement, HShapeElement);
	HShapeElement.prototype._parent = parent;
	HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderFrame;
	
	HShapeElement.prototype.createElements = function(){
	    var parent = document.createElement('div');
	    styleDiv(parent);
	    var cont = document.createElementNS(svgNS,'svg');
	    styleDiv(cont);
	    var size = this.comp.data ? this.comp.data : this.globalData.compSize;
	    cont.setAttribute('width',size.w);
	    cont.setAttribute('height',size.h);
	    if(this.data.hasMask){
	        var g = document.createElementNS(svgNS,'g');
	        parent.appendChild(cont);
	        cont.appendChild(g);
	        this.maskedElement = g;
	        this.layerElement = g;
	        this.shapesContainer = g;
	    }else{
	        parent.appendChild(cont);
	        this.layerElement = cont;
	        this.shapesContainer = document.createElementNS(svgNS,'g');
	        this.layerElement.appendChild(this.shapesContainer);
	    }
	    if(!this.data.hd){
	        //this.parentContainer.appendChild(parent);
	        this.baseElement = parent;
	    }
	    this.innerElem = parent;
	    if(this.data.ln){
	        this.innerElem.setAttribute('id',this.data.ln);
	    }
	
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,this.dynamicProperties,0, [], true);
	    this.buildExpressionInterface();
	    this.layerElement = parent;
	    this.transformedElement = parent;
	    this.shapeCont = cont;
	    if(this.data.bm !== 0){
	        this.setBlendMode();
	    }
	    this.checkParenting();
	};
	
	HShapeElement.prototype.renderFrame = function(parentMatrix){
	    var firstFrame = this.firstFrame;
	    this._renderShapeFrame();
	
	    if(this.isVisible && (this.elemMdf || firstFrame)){
	        var boundingBox = this.shapeCont.getBBox();
	        var changed = false;
	        if(this.currentBBox.w !== boundingBox.width){
	            this.currentBBox.w = boundingBox.width;
	            this.shapeCont.setAttribute('width',boundingBox.width);
	            changed = true;
	        }
	        if(this.currentBBox.h !== boundingBox.height){
	            this.currentBBox.h = boundingBox.height;
	            this.shapeCont.setAttribute('height',boundingBox.height);
	            changed = true;
	        }
	        if(changed  || this.currentBBox.x !== boundingBox.x  || this.currentBBox.y !== boundingBox.y){
	            this.currentBBox.w = boundingBox.width;
	            this.currentBBox.h = boundingBox.height;
	            this.currentBBox.x = boundingBox.x;
	            this.currentBBox.y = boundingBox.y;
	
	            this.shapeCont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
	            this.shapeCont.style.transform = this.shapeCont.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        }
	    }
	
	};
	function HTextElement(data,parentContainer,globalData,comp, placeholder){
	    this.textSpans = [];
	    this.textPaths = [];
	    this.currentBBox = {
	        x:999999,
	        y: -999999,
	        h: 0,
	        w: 0
	    }
	    this.renderType = 'svg';
	    this.isMasked = false;
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	
	}
	createElement(HBaseElement, HTextElement);
	
	HTextElement.prototype.init = ITextElement.prototype.init;
	HTextElement.prototype.getMeasures = ITextElement.prototype.getMeasures;
	HTextElement.prototype.createPathShape = ITextElement.prototype.createPathShape;
	HTextElement.prototype.prepareFrame = ITextElement.prototype.prepareFrame;
	HTextElement.prototype.buildShapeString = ITextElement.prototype.buildShapeString;
	
	HTextElement.prototype.createElements = function(){
	    this.isMasked = this.checkMasks();
	    var parent = document.createElement('div');
	    styleDiv(parent);
	    this.layerElement = parent;
	    this.transformedElement = parent;
	    if(this.isMasked){
	        this.renderType = 'svg';
	        var cont = document.createElementNS(svgNS,'svg');
	        styleDiv(cont);
	        this.cont = cont;
	        this.compW = this.comp.data.w;
	        this.compH = this.comp.data.h;
	        cont.setAttribute('width',this.compW);
	        cont.setAttribute('height',this.compH);
	        var g = document.createElementNS(svgNS,'g');
	        cont.appendChild(g);
	        parent.appendChild(cont);
	        this.maskedElement = g;
	        this.innerElem = g;
	    } else {
	        this.renderType = 'html';
	        this.innerElem = parent;
	    }
	    this.baseElement = parent;
	
	    this.checkParenting();
	
	};
	
	HTextElement.prototype.buildNewText = function(){
	    var documentData = this.currentTextDocumentData;
	    this.renderedLetters = Array.apply(null,{length:this.currentTextDocumentData.l ? this.currentTextDocumentData.l.length : 0});
	    if(documentData.fc) {
	        this.innerElem.style.color = this.innerElem.style.fill = 'rgb(' + Math.round(documentData.fc[0]*255) + ',' + Math.round(documentData.fc[1]*255) + ',' + Math.round(documentData.fc[2]*255) + ')';
	        ////this.innerElem.setAttribute('fill', 'rgb(' + documentData.fc[0] + ',' + documentData.fc[1] + ',' + documentData.fc[2] + ')');
	    }else{
	        this.innerElem.style.color = this.innerElem.style.fill = 'rgba(0,0,0,0)';
	        ////this.innerElem.setAttribute('fill', 'rgba(0,0,0,0)');
	    }
	    if(documentData.sc){
	        ////this.innerElem.setAttribute('stroke', 'rgb(' + documentData.sc[0] + ',' + documentData.sc[1] + ',' + documentData.sc[2] + ')');
	        this.innerElem.style.stroke = 'rgb(' + Math.round(documentData.sc[0]*255) + ',' + Math.round(documentData.sc[1]*255) + ',' + Math.round(documentData.sc[2]*255) + ')';
	        ////this.innerElem.setAttribute('stroke-width', documentData.sw);
	        this.innerElem.style.strokeWidth = documentData.sw+'px';
	    }
	    ////this.innerElem.setAttribute('font-size', documentData.s);
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    if(!this.globalData.fontManager.chars){
	        this.innerElem.style.fontSize = documentData.s+'px';
	        this.innerElem.style.lineHeight = documentData.s+'px';
	        if(fontData.fClass){
	            this.innerElem.className = fontData.fClass;
	        } else {
	            ////this.innerElem.setAttribute('font-family', fontData.fFamily);
	            this.innerElem.style.fontFamily = fontData.fFamily;
	            var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
	            ////this.innerElem.setAttribute('font-style', fStyle);
	            this.innerElem.style.fontStyle = fStyle;
	            ////this.innerElem.setAttribute('font-weight', fWeight);
	            this.innerElem.style.fontWeight = fWeight;
	        }
	    }
	    var i, len;
	
	    var letters = documentData.l;
	    len = letters.length;
	    var tSpan,tParent,tCont;
	    var matrixHelper = this.mHelper;
	    var shapes, shapeStr = '';
	    var cnt = 0;
	    for (i = 0;i < len ;i += 1) {
	        if(this.globalData.fontManager.chars){
	            if(!this.textPaths[cnt]){
	                tSpan = document.createElementNS(svgNS,'path');
	                tSpan.setAttribute('stroke-linecap', 'butt');
	                tSpan.setAttribute('stroke-linejoin','round');
	                tSpan.setAttribute('stroke-miterlimit','4');
	            } else {
	                tSpan = this.textPaths[cnt];
	            }
	            if(!this.isMasked){
	                if(this.textSpans[cnt]){
	                    tParent = this.textSpans[cnt];
	                    tCont = tParent.children[0];
	                } else {
	
	                    tParent = document.createElement('div');
	                    tCont = document.createElementNS(svgNS,'svg');
	                    tCont.appendChild(tSpan);
	                    styleDiv(tParent);
	                }
	            }
	        }else{
	            if(!this.isMasked){
	                if(this.textSpans[cnt]){
	                    tParent = this.textSpans[cnt];
	                    tSpan = this.textPaths[cnt];
	                } else {
	                    tParent = document.createElement('span');
	                    styleDiv(tParent);
	                    tSpan = document.createElement('span');
	                    styleDiv(tSpan);
	                    tParent.appendChild(tSpan);
	                }
	            } else {
	                tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : document.createElementNS(svgNS,'text');
	            }
	        }
	        //tSpan.setAttribute('visibility', 'hidden');
	        if(this.globalData.fontManager.chars){
	            var charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	            var shapeData;
	            if(charData){
	                shapeData = charData.data;
	            } else {
	                shapeData = null;
	            }
	            matrixHelper.reset();
	            if(shapeData && shapeData.shapes){
	                shapes = shapeData.shapes[0].it;
	                matrixHelper.scale(documentData.s/100,documentData.s/100);
	                shapeStr = this.createPathShape(matrixHelper,shapes);
	                tSpan.setAttribute('d',shapeStr);
	            }
	            if(!this.isMasked){
	                this.innerElem.appendChild(tParent);
	                if(shapeData && shapeData.shapes){
	                    document.body.appendChild(tCont);
	
	                    var boundingBox = tCont.getBBox();
	                    tCont.setAttribute('width',boundingBox.width);
	                    tCont.setAttribute('height',boundingBox.height);
	                    tCont.setAttribute('viewBox',boundingBox.x+' '+ boundingBox.y+' '+ boundingBox.width+' '+ boundingBox.height);
	                    tCont.style.transform = tCont.style.webkitTransform = 'translate(' + boundingBox.x + 'px,' + boundingBox.y + 'px)';
	
	                    letters[i].yOffset = boundingBox.y;
	                    tParent.appendChild(tCont);
	
	                } else{
	                    tCont.setAttribute('width',1);
	                    tCont.setAttribute('height',1);
	                }
	            }else{
	                this.innerElem.appendChild(tSpan);
	            }
	        }else{
	            tSpan.textContent = letters[i].val;
	            tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
	            if(!this.isMasked){
	                this.innerElem.appendChild(tParent);
	                //
	                tSpan.style.transform = tSpan.style.webkitTransform = 'translate3d(0,'+ -documentData.s/1.2+'px,0)';
	            } else {
	                this.innerElem.appendChild(tSpan);
	            }
	        }
	        //
	        if(!this.isMasked){
	            this.textSpans[cnt] = tParent;
	        }else{
	            this.textSpans[cnt] = tSpan;
	        }
	        this.textSpans[cnt].style.display = 'block';
	        this.textPaths[cnt] = tSpan;
	        cnt += 1;
	    }
	    while(cnt < this.textSpans.length){
	        this.textSpans[cnt].style.display = 'none';
	        cnt += 1;
	    }
	}
	
	HTextElement.prototype.hide = SVGTextElement.prototype.hide;
	
	HTextElement.prototype.renderFrame = function(parentMatrix){
	
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	    if(this.hidden){
	        this.hidden = false;
	        this.innerElem.style.display = 'block';
	        this.layerElement.style.display = 'block';
	    }
	
	    if(this.data.singleShape){
	        if(!this.firstFrame && !this.lettersChangedFlag){
	            return;
	        } else {
	            // Todo Benchmark if using this is better than getBBox
	             if(this.isMasked && this.finalTransform.matMdf){
	                 this.cont.setAttribute('viewBox',-this.finalTransform.mProp.p.v[0]+' '+ -this.finalTransform.mProp.p.v[1]+' '+this.compW+' '+this.compH);
	                this.cont.style.transform = this.cont.style.webkitTransform = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
	             }
	        }
	    }
	
	    this.getMeasures();
	    if(!this.lettersChangedFlag){
	        return;
	    }
	    var  i,len;
	    var renderedLetters = this.renderedLetters;
	
	    var letters = this.currentTextDocumentData.l;
	
	    len = letters.length;
	    var renderedLetter;
	    for(i=0;i<len;i+=1){
	        if(letters[i].n){
	            continue;
	        }
	        renderedLetter = renderedLetters[i];
	        if(!this.isMasked){
	            this.textSpans[i].style.transform = this.textSpans[i].style.webkitTransform = renderedLetter.m;
	        }else{
	            this.textSpans[i].setAttribute('transform',renderedLetter.m);
	        }
	        ////this.textSpans[i].setAttribute('opacity',renderedLetter.o);
	        this.textSpans[i].style.opacity = renderedLetter.o;
	        if(renderedLetter.sw){
	            this.textPaths[i].setAttribute('stroke-width',renderedLetter.sw);
	        }
	        if(renderedLetter.sc){
	            this.textPaths[i].setAttribute('stroke',renderedLetter.sc);
	        }
	        if(renderedLetter.fc){
	            this.textPaths[i].setAttribute('fill',renderedLetter.fc);
	            this.textPaths[i].style.color = renderedLetter.fc;
	        }
	    }
	    if(this.isVisible && (this.elemMdf || this.firstFrame)){
	        if(this.innerElem.getBBox){
	            var boundingBox = this.innerElem.getBBox();
	
	            if(this.currentBBox.w !== boundingBox.width){
	                this.currentBBox.w = boundingBox.width;
	                this.cont.setAttribute('width',boundingBox.width);
	            }
	            if(this.currentBBox.h !== boundingBox.height){
	                this.currentBBox.h = boundingBox.height;
	                this.cont.setAttribute('height',boundingBox.height);
	            }
	            if(this.currentBBox.w !== boundingBox.width || this.currentBBox.h !== boundingBox.height  || this.currentBBox.x !== boundingBox.x  || this.currentBBox.y !== boundingBox.y){
	                this.currentBBox.w = boundingBox.width;
	                this.currentBBox.h = boundingBox.height;
	                this.currentBBox.x = boundingBox.x;
	                this.currentBBox.y = boundingBox.y;
	
	                this.cont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
	                this.cont.style.transform = this.cont.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	            }
	        }
	    }
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	}
	
	
	HTextElement.prototype.destroy = SVGTextElement.prototype.destroy;
	function HImageElement(data,parentContainer,globalData,comp, placeholder){
	    this.assetData = globalData.getAssetData(data.refId);
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	}
	createElement(HBaseElement, HImageElement);
	
	HImageElement.prototype.createElements = function(){
	
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    var img = new Image();
	
	    if(this.data.hasMask){
	        var parent = document.createElement('div');
	        styleDiv(parent);
	        var cont = document.createElementNS(svgNS,'svg');
	        styleDiv(cont);
	        cont.setAttribute('width',this.assetData.w);
	        cont.setAttribute('height',this.assetData.h);
	        parent.appendChild(cont);
	        this.imageElem = document.createElementNS(svgNS,'image');
	        this.imageElem.setAttribute('width',this.assetData.w+"px");
	        this.imageElem.setAttribute('height',this.assetData.h+"px");
	        this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
	        cont.appendChild(this.imageElem);
	        this.layerElement = parent;
	        this.transformedElement = parent;
	        this.baseElement = parent;
	        this.innerElem = parent;
	        this.maskedElement = this.imageElem;
	    } else {
	        styleDiv(img);
	        this.layerElement = img;
	        this.baseElement = img;
	        this.innerElem = img;
	        this.transformedElement = img;
	    }
	    img.src = assetPath;
	    if(this.data.ln){
	        this.innerElem.setAttribute('id',this.data.ln);
	    }
	    this.checkParenting();
	};
	
	HImageElement.prototype.hide = HSolidElement.prototype.hide;
	HImageElement.prototype.renderFrame = HSolidElement.prototype.renderFrame;
	HImageElement.prototype.destroy = HSolidElement.prototype.destroy;
	function HCameraElement(data,parentContainer,globalData,comp, placeholder){
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	    this.pe = PropertyFactory.getProp(this,data.pe,0,0,this.dynamicProperties);
	    if(data.ks.p.s){
	        this.px = PropertyFactory.getProp(this,data.ks.p.x,1,0,this.dynamicProperties);
	        this.py = PropertyFactory.getProp(this,data.ks.p.y,1,0,this.dynamicProperties);
	        this.pz = PropertyFactory.getProp(this,data.ks.p.z,1,0,this.dynamicProperties);
	    }else{
	        this.p = PropertyFactory.getProp(this,data.ks.p,1,0,this.dynamicProperties);
	    }
	    if(data.ks.a){
	        this.a = PropertyFactory.getProp(this,data.ks.a,1,0,this.dynamicProperties);
	    }
	    if(data.ks.or.k.length && data.ks.or.k[0].to){
	        var i,len = data.ks.or.k.length;
	        for(i=0;i<len;i+=1){
	            data.ks.or.k[i].to = null;
	            data.ks.or.k[i].ti = null;
	        }
	    }
	    this.or = PropertyFactory.getProp(this,data.ks.or,1,degToRads,this.dynamicProperties);
	    this.or.sh = true;
	    this.rx = PropertyFactory.getProp(this,data.ks.rx,0,degToRads,this.dynamicProperties);
	    this.ry = PropertyFactory.getProp(this,data.ks.ry,0,degToRads,this.dynamicProperties);
	    this.rz = PropertyFactory.getProp(this,data.ks.rz,0,degToRads,this.dynamicProperties);
	    this.mat = new Matrix();
	}
	createElement(HBaseElement, HCameraElement);
	
	HCameraElement.prototype.setup = function() {
	    var i, len = this.comp.threeDElements.length, comp;
	    for(i=0;i<len;i+=1){
	        //[perspectiveElem,container]
	        comp = this.comp.threeDElements[i];
	        comp.perspectiveElem.style.perspective = comp.perspectiveElem.style.webkitPerspective = this.pe.v+'px';
	        comp.container.style.transformOrigin = comp.container.style.mozTransformOrigin = comp.container.style.webkitTransformOrigin = "0px 0px 0px";
	        comp.perspectiveElem.style.transform = comp.perspectiveElem.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	    }
	};
	
	HCameraElement.prototype.createElements = function(){
	};
	
	HCameraElement.prototype.hide = function(){
	};
	
	HCameraElement.prototype.renderFrame = function(){
	    var mdf = this.firstFrame;
	    var i, len;
	    if(this.hierarchy){
	        len = this.hierarchy.length;
	        for(i=0;i<len;i+=1){
	            mdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : mdf;
	        }
	    }
	    if(mdf || (this.p && this.p.mdf) || (this.px && (this.px.mdf || this.py.mdf || this.pz.mdf)) || this.rx.mdf || this.ry.mdf || this.rz.mdf || this.or.mdf || (this.a && this.a.mdf)) {
	        this.mat.reset();
	
	        if(this.p){
	            this.mat.translate(-this.p.v[0],-this.p.v[1],this.p.v[2]);
	        }else{
	            this.mat.translate(-this.px.v,-this.py.v,this.pz.v);
	        }
	        if(this.a){
	            var diffVector = [this.p.v[0]-this.a.v[0],this.p.v[1]-this.a.v[1],this.p.v[2]-this.a.v[2]];
	            var mag = Math.sqrt(Math.pow(diffVector[0],2)+Math.pow(diffVector[1],2)+Math.pow(diffVector[2],2));
	            //var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
	            var lookDir = [diffVector[0]/mag,diffVector[1]/mag,diffVector[2]/mag];
	            var lookLengthOnXZ = Math.sqrt( lookDir[2]*lookDir[2] + lookDir[0]*lookDir[0] );
	            var m_rotationX = (Math.atan2( lookDir[1], lookLengthOnXZ ));
	            var m_rotationY = (Math.atan2( lookDir[0], -lookDir[2]));
	            this.mat.rotateY(m_rotationY).rotateX(-m_rotationX);
	
	        }
	        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
	        this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
	        this.mat.translate(this.globalData.compSize.w/2,this.globalData.compSize.h/2,0);
	        this.mat.translate(0,0,this.pe.v);
	        if(this.hierarchy){
	            var mat;
	            len = this.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                mat = this.hierarchy[i].finalTransform.mProp.iv.props;
	                this.mat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],-mat[12],-mat[13],mat[14],mat[15]);
	            }
	        }
	        len = this.comp.threeDElements.length;
	        var comp;
	        for(i=0;i<len;i+=1){
	            comp = this.comp.threeDElements[i];
	            comp.container.style.transform = comp.container.style.webkitTransform = this.mat.toCSS();
	        }
	    }
	    this.firstFrame = false;
	};
	
	HCameraElement.prototype.destroy = function(){
	};
	var Expressions = (function(){
	    var ob = {};
	    ob.initExpressions = initExpressions;
	
	
	    function initExpressions(animation){
	        animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
	        animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
	    }
	   return ob;
	}());
	
	expressionsPlugin = Expressions;
	
	(function addPropertyDecorator() {
	
	    function getStaticValueAtTime() {
	        return this.pv;
	    }
	
	    function getValueAtTime(frameNum, offsetTime) {
	        frameNum *= this.elem.globalData.frameRate;
	        var i = 0,len = this.keyframes.length- 1,dir= 1,flag = true;
	        var keyData, nextKeyData;
	        offsetTime = offsetTime === undefined ? this.offsetTime : 0;
	        //console.log(this.offsetTime);
	        var retVal = typeof this.pv === 'object' ? [this.pv.length] : 0;
	
	        while(flag){
	            keyData = this.keyframes[i];
	            nextKeyData = this.keyframes[i+1];
	            if(i == len-1 && frameNum >= nextKeyData.t - offsetTime){
	                if(keyData.h){
	                    keyData = nextKeyData;
	                }
	                break;
	            }
	            if((nextKeyData.t - offsetTime) > frameNum){
	                break;
	            }
	            if(i < len - 1){
	                i += dir;
	            }else{
	                flag = false;
	            }
	        }
	
	        var k, kLen,perc,jLen, j = 0, fnc;
	        if (keyData.to) {
	
	            if (!keyData.bezierData) {
	                bez.buildBezierData(keyData);
	            }
	            var bezierData = keyData.bezierData;
	            if (frameNum >= nextKeyData.t-offsetTime || frameNum < keyData.t-offsetTime) {
	                var ind = frameNum >= nextKeyData.t-offsetTime ? bezierData.points.length - 1 : 0;
	                kLen = bezierData.points[ind].point.length;
	                for(k = 0; k < kLen; k += 1){
	                    retVal[k] = bezierData.points[ind].point[k];
	                }
	            } else {
	                if (keyData.__fnct) {
	                    fnc = keyData.__fnct;
	                } else {
	                    //fnc = bez.getEasingCurve(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y,keyData.n);
	                    fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
	                    keyData.__fnct = fnc;
	                }
	                perc = fnc((frameNum - (keyData.t - offsetTime)) / ((nextKeyData.t - offsetTime) - (keyData.t - offsetTime)));
	                var distanceInLine = bezierData.segmentLength * perc;
	
	                var segmentPerc;
	                var addedLength = 0;
	                dir = 1;
	                flag = true;
	                jLen = bezierData.points.length;
	                while(flag) {
	                    addedLength += bezierData.points[j].partialLength*dir;
	                    if (distanceInLine === 0 || perc === 0 || j == bezierData.points.length - 1) {
	                        kLen = bezierData.points[j].point.length;
	                        for (k = 0; k < kLen; k += 1) {
	                            retVal[k] = bezierData.points[j].point[k];
	                        }
	                        break;
	                    } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j+1].partialLength){
	                        segmentPerc = (distanceInLine - addedLength) / (bezierData.points[j + 1].partialLength);
	                        kLen = bezierData.points[j].point.length;
	                        for (k = 0; k < kLen; k += 1) {
	                            retVal[k] = bezierData.points[j].point[k] + (bezierData.points[j+1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
	                        }
	                        break;
	                    }
	                    if (j < jLen - 1 && dir == 1 || j > 0 && dir == -1) {
	                        j += dir;
	                    } else {
	                        flag = false;
	                    }
	                }
	            }
	        } else {
	            var outX,outY,inX,inY, isArray = false, keyValue;
	            len = keyData.s.length;
	            for(i=0;i<len;i+=1){
	                if(keyData.h !== 1){
	                    if(keyData.o.x instanceof Array){
	                        isArray = true;
	                        if(!keyData.__fnct){
	                            keyData.__fnct = [];
	                        }
	                        if(!keyData.__fnct[i]){
	                            outX = keyData.o.x[i] || keyData.o.x[0];
	                            outY = keyData.o.y[i] || keyData.o.y[0];
	                            inX = keyData.i.x[i] || keyData.i.x[0];
	                            inY = keyData.i.y[i] || keyData.i.y[0];
	                        }
	                    }else{
	                        isArray = false;
	                        if(!keyData.__fnct) {
	                            outX = keyData.o.x;
	                            outY = keyData.o.y;
	                            inX = keyData.i.x;
	                            inY = keyData.i.y;
	                        }
	                    }
	                    if(isArray){
	                        if(keyData.__fnct[i]){
	                            fnc = keyData.__fnct[i];
	                        }else{
	                            //fnc = bez.getEasingCurve(outX,outY,inX,inY);
	                            fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
	                            keyData.__fnct[i] = fnc;
	                        }
	                    }else{
	                        if(keyData.__fnct){
	                            fnc = keyData.__fnct;
	                        }else{
	                            //fnc = bez.getEasingCurve(outX,outY,inX,inY);
	                            fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
	                            keyData.__fnct = fnc;
	                        }
	                    }
	                    if(frameNum >= nextKeyData.t-offsetTime){
	                        perc = 1;
	                    }else if(frameNum < keyData.t-offsetTime){
	                        perc = 0;
	                    }else{
	                        perc = fnc((frameNum-(keyData.t-offsetTime))/((nextKeyData.t-offsetTime)-(keyData.t-offsetTime)));
	                    }
	                }
	                if(this.sh && keyData.h !== 1){
	                    var initP = keyData.s[i];
	                    var endP = keyData.e[i];
	                    if(initP-endP < -180){
	                        initP += 360;
	                    } else if(initP-endP > 180){
	                        initP -= 360;
	                    }
	                    keyValue = initP+(endP-initP)*perc;
	                } else {
	                    keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i]+(keyData.e[i]-keyData.s[i])*perc;
	                }
	                if(len === 1){
	                    retVal = keyValue;
	                }else{
	                    retVal[i] = keyValue;
	                }
	            }
	        }
	        return retVal;
	    }
	
	    function getVelocityAtTime(frameNum) {
	        if(this.vel !== undefined){
	            return this.vel;
	        }
	        var delta = -0.01;
	        //frameNum += this.elem.data.st;
	        var v1 = this.getValueAtTime(frameNum, 0);
	        var v2 = this.getValueAtTime(frameNum + delta, 0);
	        var velocity;
	        if(v1.length){
	            velocity = Array.apply(null,{length:v1.length});
	            var i;
	            for(i=0;i<v1.length;i+=1){
	                //removing frameRate
	                //if needed, don't add it here
	                //velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
	                velocity[i] = (v2[i] - v1[i])/delta;
	            }
	        } else {
	            velocity = (v2 - v1)/delta;
	        }
	        return velocity;
	    };
	
	    function setGroupProperty(propertyGroup){
	        this.propertyGroup = propertyGroup;
	    }
	
	    function searchExpressions(elem,data,prop){
	        if(data.x){
	            prop.k = true;
	            prop.x = true;
	            if(prop.getValue) {
	                prop.getPreValue = prop.getValue;
	            }
	            prop.getValue = ExpressionManager.initiateExpression.bind(prop)(elem,data,prop);
	        }
	    }
	
	    function getTransformValueAtTime(time) {
	        console.log('time:', time)
	    }
	
	    function getTransformStaticValueAtTime(time) {
	
	    }
	
	    var TextExpressionSelectorProp = (function(){
	
	        function getValueProxy(index,total){
	            this.textIndex = index+1;
	            this.textTotal = total;
	            this.getValue();
	            return this.v;
	        }
	
	        return function TextExpressionSelectorProp(elem,data){
	            this.pv = 1;
	            this.comp = elem.comp;
	            this.elem = elem;
	            this.mult = .01;
	            this.type = 'textSelector';
	            this.textTotal = data.totalChars;
	            this.selectorValue = 100;
	            this.lastValue = [1,1,1];
	            searchExpressions.bind(this)(elem,data,this);
	            this.getMult = getValueProxy;
	            this.getVelocityAtTime = getVelocityAtTime;
	            if(this.kf){
	                this.getValueAtTime = getValueAtTime.bind(this);
	            } else {
	                this.getValueAtTime = getStaticValueAtTime.bind(this);
	            }
	            this.setGroupProperty = setGroupProperty;
	        }
	    }());
	
	
	    var propertyGetProp = PropertyFactory.getProp;
	    PropertyFactory.getProp = function(elem,data,type, mult, arr){
	        var prop = propertyGetProp(elem,data,type, mult, arr);
	        prop.getVelocityAtTime = getVelocityAtTime;
	        if(type === 2) {
	            if(prop.dynamicProperties.length) {
	                prop.getValueAtTime = getTransformValueAtTime.bind(prop);
	            } else {
	                prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
	            }
	        } else {
	            if(prop.kf){
	                prop.getValueAtTime = getValueAtTime.bind(prop);
	            } else {
	                prop.getValueAtTime = getStaticValueAtTime.bind(prop);
	            }
	        }
	        prop.setGroupProperty = setGroupProperty;
	        var isAdded = prop.k;
	        if(data.ix !== undefined){
	            Object.defineProperty(prop,'propertyIndex',{
	                get: function(){
	                    return data.ix;
	                }
	            })
	        }
	        searchExpressions(elem,data,prop);
	        if(!isAdded && prop.x){
	            arr.push(prop);
	        }
	
	        return prop;
	    }
	
	    var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
	    ShapePropertyFactory.getShapeProp = function(elem,data,type, arr, trims){
	        var prop = propertyGetShapeProp(elem,data,type, arr, trims);
	        prop.setGroupProperty = setGroupProperty;
	        if(prop.kf){
	            prop.getValueAtTime = getValueAtTime;
	        } else {
	            prop.getValueAtTime = getStaticValueAtTime;
	        }
	        var isAdded = prop.k;
	        if(data.ix !== undefined){
	            Object.defineProperty(prop,'propertyIndex',{
	                get: function(){
	                    return data.ix;
	                }
	            })
	        }
	        if(type === 3){
	            searchExpressions(elem,data.pt,prop);
	        } else if(type === 4){
	            searchExpressions(elem,data.ks,prop);
	        }
	        if(!isAdded && prop.x){
	            arr.push(prop);
	        }
	        return prop;
	    }
	
	    var propertyGetTextProp = PropertyFactory.getTextSelectorProp;
	    PropertyFactory.getTextSelectorProp = function(elem, data,arr){
	        if(data.t === 1){
	            return new TextExpressionSelectorProp(elem, data,arr);
	        } else {
	            return propertyGetTextProp(elem,data,arr);
	        }
	    }
	}());
	var ExpressionManager = (function(){
	    var ob = {};
	    var Math = BMMath;
	    var window = null;
	    var document = null;
	
	    function duplicatePropertyValue(value, mult){
	        mult = mult || 1;
	
	        if(typeof value === 'number'  || value instanceof Number){
	            return value*mult;
	        }else if(value.i){
	            return JSON.parse(JSON.stringify(value));
	        }else{
	            var arr = Array.apply(null,{length:value.length});
	            var i, len = value.length;
	            for(i=0;i<len;i+=1){
	                arr[i]=value[i]*mult;
	            }
	            return arr;
	        }
	    }
	
	    function shapesEqual(shape1, shape2) {
	        if(shape1._length !== shape2._length || shape1.c !== shape2.c){
	            return false;
	        }
	        var i, len = shape1._length;
	        for(i = 0; i < len; i += 1) {
	            if(shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1]
	                || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1]
	                || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]){
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function $bm_neg(a){
	        var tOfA = typeof a;
	        if(tOfA === 'number' || tOfA === 'boolean'  || a instanceof Number ){
	            return -a;
	        }
	        if(a.constructor === Array){
	            var i, lenA = a.length;
	            var retArr = [];
	            for(i=0;i<lenA;i+=1){
	                retArr[i] = -a[i];
	            }
	            return retArr;
	        }
	    }
	
	    function sum(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        if(tOfA === 'string' || tOfB === 'string'){
	            return a + b;
	        }
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string'  || b instanceof Number)) {
	            return a + b;
	        }
	        if(a.constructor === Array && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
	            a[0] = a[0] + b;
	            return a;
	        }
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && b.constructor === Array){
	            b[0] = a + b[0];
	            return b;
	        }
	        if(a.constructor === Array && b.constructor === Array){
	            
	            var i = 0, lenA = a.length, lenB = b.length;
	            var retArr = [];
	            while(i<lenA || i < lenB){
	                if((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)){
	                    retArr[i] = a[i] + b[i];
	                }else{
	                    retArr[i] = b[i] == undefined ? a[i] : a[i] || b[i];
	                }
	                i += 1;
	            }
	            return retArr;
	        }
	        return 0;
	    }
	    var add = sum;
	
	    function sub(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
	            if(tOfA === 'string') {
	                a = parseInt(a);
	            }
	            if(tOfB === 'string') {
	                b = parseInt(b);
	            }
	            return a - b;
	        }
	        if( a.constructor === Array && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
	            a[0] = a[0] - b;
	            return a;
	        }
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) &&  b.constructor === Array){
	            b[0] = a - b[0];
	            return b;
	        }
	        if(a.constructor === Array && b.constructor === Array){
	            var i = 0, lenA = a.length, lenB = b.length;
	            var retArr = [];
	            while(i<lenA || i < lenB){
	                if((typeof a[i] === 'number' || a[i] instanceof Number) && typeof (typeof b[i] === 'number' || b[i] instanceof Number)){
	                    retArr[i] = a[i] - b[i];
	                }else{
	                    retArr[i] = b[i] == undefined ? a[i] : a[i] || b[i];
	                }
	                i += 1;
	            }
	            return retArr;
	        }
	        return 0;
	    }
	
	    function mul(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        var arr;
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
	            return a * b;
	        }
	
	        var i, len;
	        if(a.constructor === Array && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
	            len = a.length;
	            arr = Array.apply(null,{length:len});
	            for(i=0;i<len;i+=1){
	                arr[i] = a[i] * b;
	            }
	            return arr;
	        }
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && b.constructor === Array){
	            len = b.length;
	            arr = Array.apply(null,{length:len});
	            for(i=0;i<len;i+=1){
	                arr[i] = a * b[i];
	            }
	            return arr;
	        }
	        return 0;
	    }
	
	    function div(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        var arr;
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
	            return a / b;
	        }
	        var i, len;
	        if(a.constructor === Array && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number  )){
	            len = a.length;
	            arr = Array.apply(null,{length:len});
	            for(i=0;i<len;i+=1){
	                arr[i] = a[i] / b;
	            }
	            return arr;
	        }
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && b.constructor === Array){
	            len = b.length;
	            arr = Array.apply(null,{length:len});
	            for(i=0;i<len;i+=1){
	                arr[i] = a / b[i];
	            }
	            return arr;
	        }
	        return 0;
	    }
	    function mod(a,b) {
	        if(typeof a === 'string') {
	            a = parseInt(a);
	        }
	        if(typeof b === 'string') {
	            b = parseInt(b);
	        }
	        return a % b;
	    }
	
	    function clamp(num, min, max) {
	        if(min > max){
	            var mm = max;
	            max = min;
	            min = mm;
	        }
	        return Math.min(Math.max(num, min), max);
	    }
	
	    function radiansToDegrees(val) {
	        return val/degToRads;
	    }
	    var radians_to_degrees = radiansToDegrees;
	
	    function degreesToRadians(val) {
	        return val*degToRads;
	    }
	    var degrees_to_radians = radiansToDegrees;
	
	    var helperLengthArray = [0,0,0,0,0,0];
	
	    function length(arr1,arr2){
	        if(typeof arr1 === 'number' || arr1 instanceof Number){
	            arr2 = arr2 || 0;
	            return Math.abs(arr1 - arr2);
	        }
	        if(!arr2){
	            arr2 = helperLengthArray;
	        }
	        var i,len = Math.min(arr1.length,arr2.length);
	        var addedLength = 0;
	        for(i=0;i<len;i+=1){
	            addedLength += Math.pow(arr2[i]-arr1[i],2);
	        }
	        return Math.sqrt(addedLength);
	    }
	
	    function normalize(vec){
	        return div(vec, length(vec));
	    }
	
	    function rgbToHsl(val){
	        var r = val[0]; var g = val[1]; var b = val[2];
	        var max = Math.max(r, g, b), min = Math.min(r, g, b);
	        var h, s, l = (max + min) / 2;
	
	        if(max == min){
	            h = s = 0; // achromatic
	        }else{
	            var d = max - min;
	            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	            switch(max){
	                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	                case g: h = (b - r) / d + 2; break;
	                case b: h = (r - g) / d + 4; break;
	            }
	            h /= 6;
	        }
	
	        return [h, s, l,val[3]];
	    }
	    function hslToRgb(val){
	        var h = val[0];
	        var s = val[1];
	        var l = val[2];
	
	        var r, g, b;
	
	        if(s == 0){
	            r = g = b = l; // achromatic
	        }else{
	            function hue2rgb(p, q, t){
	                if(t < 0) t += 1;
	                if(t > 1) t -= 1;
	                if(t < 1/6) return p + (q - p) * 6 * t;
	                if(t < 1/2) return q;
	                if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
	                return p;
	            }
	
	            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	            var p = 2 * l - q;
	            r = hue2rgb(p, q, h + 1/3);
	            g = hue2rgb(p, q, h);
	            b = hue2rgb(p, q, h - 1/3);
	        }
	
	        return [r, g , b, val[3]];
	    }
	
	    function linear(t, tMin, tMax, value1, value2){
	        if(value1 === undefined || value2 === undefined){
	            return linear(t,0,1,tMin,tMax);
	        }
	        if(t <= tMin) {
	            return value1;
	        }else if(t >= tMax){
	            return value2;
	        }
	        var perc = tMax === tMin ? 0 : (t-tMin)/(tMax-tMin);
	        if(!value1.length){
	            return value1 + (value2-value1)*perc;
	        }
	        var i, len = value1.length;
	        var arr = Array.apply( null, { length: len } );
	        for(i=0;i<len;i+=1){
	            arr[i] = value1[i] + (value2[i]-value1[i])*perc;
	        }
	        return arr;
	    }
	    function random(min,max){
	        if(max === undefined){
	            if(min === undefined){
	                min = 0;
	                max = 1;
	            } else {
	                max = min;
	                min = undefined;
	            }
	        }
	        if(max.length){
	            var i, len = max.length;
	            if(!min){
	                min = Array.apply(null,{length:len});
	            }
	            var arr = Array.apply(null,{length:len});
	            var rnd = BMMath.random();
	            for(i=0;i<len;i+=1){
	                arr[i] = min[i] + rnd*(max[i]-min[i])
	            }
	            return arr;
	        }
	        if(min === undefined){
	            min = 0;
	        }
	        var rndm = BMMath.random();
	        return min + rndm*(max-min);
	    }
	
	    function initiateExpression(elem,data,property){
	        var val = data.x;
	        var needsVelocity = /velocity(?![\w\d])/.test(val);
	        var _needsRandom = val.indexOf('random') !== -1;
	        var elemType = elem.data.ty;
	        var transform,content,effect;
	        var thisComp = elem.comp;
	        var thisProperty = property;
	        elem.comp.frameDuration = 1/elem.comp.globalData.frameRate;
	        var inPoint = elem.data.ip/elem.comp.globalData.frameRate;
	        var outPoint = elem.data.op/elem.comp.globalData.frameRate;
	        var width = elem.data.sw ? elem.data.sw : 0;
	        var height = elem.data.sh ? elem.data.sh : 0;
	        var toWorld,fromWorld,anchorPoint,thisLayer,thisComp;
	        var fn = new Function();
	        //var fnStr = 'var fn = function(){'+val+';this.v = $bm_rt;}';
	        //eval(fnStr);
	
	        var fn = eval('[function(){' + val+';this.v = $bm_rt;}' + ']')[0];
	        var bindedFn = fn.bind(this);
	        var numKeys = property.kf ? data.k.length : 0;
	
	        var wiggle = function wiggle(freq,amp){
	            var i,j, len = this.pv.length ? this.pv.length : 1;
	            var addedAmps = Array.apply(null,{len:len});
	            for(j=0;j<len;j+=1){
	                addedAmps[j] = 0;
	            }
	            freq = 5;
	            var iterations = Math.floor(time*freq);
	            i = 0;
	            j = 0;
	            while(i<iterations){
	                //var rnd = BMMath.random();
	                for(j=0;j<len;j+=1){
	                    addedAmps[j] += -amp + amp*2*BMMath.random();
	                    //addedAmps[j] += -amp + amp*2*rnd;
	                }
	                i += 1;
	            }
	            //var rnd2 = BMMath.random();
	            var periods = time*freq;
	            var perc = periods - Math.floor(periods);
	            var arr = Array.apply({length:len});
	            if(len>1){
	                for(j=0;j<len;j+=1){
	                    arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*BMMath.random())*perc;
	                    //arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
	                    //arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
	                }
	                return arr;
	            } else {
	                return this.pv + addedAmps[0] + (-amp + amp*2*BMMath.random())*perc;
	            }
	        }.bind(this);
	
	        var loopIn = function loopIn(type,duration, durationFlag) {
	            if(!this.k){
	                return this.pv;
	            }
	            var currentFrame = time*elem.comp.globalData.frameRate;
	            var keyframes = this.keyframes;
	            var firstKeyFrame = keyframes[0].t;
	            if(currentFrame>=firstKeyFrame){
	                return this.pv;
	            }else{
	                var cycleDuration, lastKeyFrame;
	                if(!durationFlag){
	                    if(!duration || duration > keyframes.length - 1){
	                        duration = keyframes.length - 1;
	                    }
	                    lastKeyFrame = keyframes[duration].t;
	                    cycleDuration = lastKeyFrame - firstKeyFrame;
	                } else {
	                    if(!duration){
	                        cycleDuration = Math.max(0,this.elem.data.op - firstKeyFrame);
	                    } else {
	                        cycleDuration = Math.abs(elem.comp.globalData.frameRate*duration);
	                    }
	                    lastKeyFrame = firstKeyFrame + cycleDuration;
	                }
	                var i, len, ret;
	                if(type === 'pingpong') {
	                    var iterations = Math.floor((firstKeyFrame - currentFrame)/cycleDuration);
	                    if(iterations % 2 === 0){
	                        return this.getValueAtTime(((firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	                    }
	                } else if(type === 'offset'){
	                    var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                    var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                    var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	                    var repeats = Math.floor((firstKeyFrame - currentFrame)/cycleDuration)+1;
	                    if(this.pv.length){
	                        ret = new Array(initV.length);
	                        len = ret.length;
	                        for(i=0;i<len;i+=1){
	                            ret[i] = current[i]-(endV[i]-initV[i])*repeats;
	                        }
	                        return ret;
	                    }
	                    return current-(endV-initV)*repeats;
	                } else if(type === 'continue'){
	                    var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                    var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
	                    if(this.pv.length){
	                        ret = new Array(firstValue.length);
	                        len = ret.length;
	                        for(i=0;i<len;i+=1){
	                            ret[i] = firstValue[i] + (firstValue[i]-nextFirstValue[i])*(firstKeyFrame - currentFrame)/0.001;
	                        }
	                        return ret;
	                    }
	                    return firstValue + (firstValue-nextFirstValue)*(firstKeyFrame - currentFrame)/0.001;
	                }
	                return this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	            }
	        }.bind(this);
	
	        var loopInDuration = function loopInDuration(type,duration){
	            return loopIn(type,duration,true);
	        }.bind(this);
	
	        var loopOut = function loopOut(type,duration,durationFlag){
	            if(!this.k || !this.keyframes){
	                return this.pv;
	            }
	            var currentFrame = time*elem.comp.globalData.frameRate;
	            var keyframes = this.keyframes;
	            var lastKeyFrame = keyframes[keyframes.length - 1].t;
	            if(currentFrame<=lastKeyFrame){
	                return this.pv;
	            }else{
	                var cycleDuration, firstKeyFrame;
	                if(!durationFlag){
	                    if(!duration || duration > keyframes.length - 1){
	                        duration = keyframes.length - 1;
	                    }
	                    firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
	                    cycleDuration = lastKeyFrame - firstKeyFrame;
	                } else {
	                    if(!duration){
	                        cycleDuration = Math.max(0,lastKeyFrame - this.elem.data.ip);
	                    } else {
	                        cycleDuration = Math.abs(lastKeyFrame - elem.comp.globalData.frameRate*duration);
	                    }
	                    firstKeyFrame = lastKeyFrame - cycleDuration;
	                }
	                var i, len, ret;
	                if(type === 'pingpong') {
	                    var iterations = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
	                    if(iterations % 2 !== 0){
	                        return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	                    }
	                } else if(type === 'offset'){
	                    var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                    var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                    var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	                    var repeats = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
	                    if(this.pv.length){
	                        ret = new Array(initV.length);
	                        len = ret.length;
	                        for(i=0;i<len;i+=1){
	                            ret[i] = (endV[i]-initV[i])*repeats + current[i];
	                        }
	                        return ret;
	                    }
	                    return (endV-initV)*repeats + current;
	                } else if(type === 'continue'){
	                    var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                    var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
	                    if(this.pv.length){
	                        ret = new Array(lastValue.length);
	                        len = ret.length;
	                        for(i=0;i<len;i+=1){
	                            ret[i] = lastValue[i] + (lastValue[i]-nextLastValue[i])*((currentFrame - lastKeyFrame)/ this.comp.globalData.frameRate)/0.0005;
	                        }
	                        return ret;
	                    }
	                    return lastValue + (lastValue-nextLastValue)*(((currentFrame - lastKeyFrame))/0.001);
	                }
	                return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	            }
	        }.bind(this);
	        var loop_out = loopOut;
	
	        var loopOutDuration = function loopOutDuration(type,duration){
	            return loopOut(type,duration,true);
	        }.bind(this);
	
	        var valueAtTime = function valueAtTime(t) {
	            return this.getValueAtTime(t, 0);
	        }.bind(this);
	
	        var velocityAtTime;
	        if(this.getVelocityAtTime) {
	            velocityAtTime = this.getVelocityAtTime.bind(this);
	        }
	
	        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
	
	        function lookAt(elem1,elem2){
	            var fVec = [elem2[0]-elem1[0],elem2[1]-elem1[1],elem2[2]-elem1[2]];
	            var pitch = Math.atan2(fVec[0],Math.sqrt(fVec[1]*fVec[1]+fVec[2]*fVec[2]))/degToRads;
	            var yaw = -Math.atan2(fVec[1],fVec[2])/degToRads;
	            return [yaw,pitch,0];
	        };
	
	        function easeOut(t, val1, val2){
	            return -(val2-val1) * t*(t-2) + val1;
	        };
	
	        function nearestKey(time){
	            var i, len = data.k.length,index,keyTime;
	            if(!data.k.length || typeof(data.k[0]) === 'number'){
	                index = 0;
	                keyTime = 0;
	            } else {
	                index = -1;
	                time *= elem.comp.globalData.frameRate;
	                if (time < data.k[0].t) {
	                    index = 1;
	                    keyTime = data.k[0].t;
	                } else {
	                    for(i=0;i<len-1;i+=1){
	                        if(time === data.k[i].t){
	                            index = i + 1;
	                            keyTime = data.k[i].t;
	                            break;
	                        }else if(time>data.k[i].t && time<data.k[i+1].t){
	                            if(time-data.k[i].t > data.k[i+1].t - time){
	                                index = i + 2;
	                                keyTime = data.k[i+1].t;
	                            } else {
	                                index = i + 1;
	                                keyTime = data.k[i].t;
	                            }
	                            break;
	                        }
	                    }
	                    if(index === -1){
	                        index = i + 1;
	                        keyTime = data.k[i].t;
	                    }
	                }
	                
	            }
	            var ob = {};
	            ob.index = index;
	            ob.time = keyTime/elem.comp.globalData.frameRate;
	            return ob;
	        };
	
	        function key(ind){
	            var ob, i, len;
	            if(!data.k.length || typeof(data.k[0]) === 'number'){
	                throw new Error('The property has no keyframe at index ' + ind);
	            }
	            ind -= 1;
	            ob = {
	                time: data.k[ind].t/elem.comp.globalData.frameRate
	            };
	            var arr;
	            if(ind === data.k.length - 1 && !data.k[ind].h){
	                arr = data.k[ind-1].e;
	            }else{
	                arr = data.k[ind].s;
	            }
	            len = arr.length;
	            for(i=0;i<len;i+=1){
	                ob[i] = arr[i];
	            }
	            return ob;
	        };
	
	        function framesToTime(frames,fps){
	            if(!fps){
	                fps = elem.comp.globalData.frameRate;
	            }
	            return frames/fps;
	        };
	
	        function timeToFrames(t,fps){
	            if(!t && t !== 0){
	                t = time;
	            }
	            if(!fps){
	                fps = elem.comp.globalData.frameRate;
	            }
	            return t*fps;
	        };
	
	        function seedRandom(seed){
	            BMMath.seedrandom(randSeed + seed);
	        };
	
	        var time,velocity, value,textIndex,textTotal,selectorValue;
	        var index = elem.data.ind;
	        var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	        var parent;
	        var randSeed = Math.floor(Math.random()*1000000);
	        function execute(){
	            if(_needsRandom){
	                seedRandom(randSeed);
	            }
	            if(this.frameExpressionId === elem.globalData.frameId && this.type !== 'textSelector'){
	                return;
	            }
	            if(this.lock){
	                this.v = duplicatePropertyValue(this.pv,this.mult);
	                return true;
	            }
	            if(this.type === 'textSelector'){
	                textIndex = this.textIndex;
	                textTotal = this.textTotal;
	                selectorValue = this.selectorValue;
	            }
	            if(!thisLayer){
	                thisLayer = elem.layerInterface;
	                thisComp = elem.comp.compInterface;
	                toWorld = thisLayer.toWorld.bind(thisLayer);
	                fromWorld = thisLayer.fromWorld.bind(thisLayer);
	            }
	            if(!transform){
	                transform = elem.layerInterface("ADBE Transform Group");
	                anchorPoint = transform.anchorPoint;
	            }
	            
	            if(elemType === 4 && !content){
	                content = thisLayer("ADBE Root Vectors Group");
	            }
	            if(!effect){
	                effect = thisLayer(4);
	            }
	            hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	            if(hasParent && !parent){
	                parent = elem.hierarchy[0].layerInterface;
	            }
	            this.lock = true;
	            if(this.getPreValue){
	                this.getPreValue();
	            }
	            value = this.pv;
	            time = this.comp.renderedFrame/this.comp.globalData.frameRate;
	            if(needsVelocity){
	                velocity = velocityAtTime(time);
	            }
	            bindedFn();
	            this.frameExpressionId = elem.globalData.frameId;
	            var i,len;
	            if(this.mult){
	                if(typeof this.v === 'number' || this.v instanceof Number || typeof this.v === 'string'){
	                    this.v *= this.mult;
	                }else if(this.v.length === 1){
	                    this.v = this.v[0] * this.mult;
	                }else{
	                    len = this.v.length;
	                    if(value === this.v){
	                        this.v = len === 2 ? [value[0],value[1]] : [value[0],value[1],value[2]];
	                    }
	                    for(i = 0; i < len; i += 1){
	                        this.v[i] *= this.mult;
	                    }
	                }
	            }
	            if(this.v.length === 1){
	                this.v = this.v[0];
	            }
	            if(typeof this.v === 'number' || this.v instanceof Number || typeof this.v === 'string'){
	                if(this.lastValue !== this.v){
	                    this.lastValue = this.v;
	                    this.mdf = true;
	                }
	            }else if(this.v._length){
	                if(!shapesEqual(this.v,this.localShapeCollection.shapes[0])){
	                    this.mdf = true;
	                    this.localShapeCollection.releaseShapes();
	                    this.localShapeCollection.addShape(shape_pool.clone(this.v));
	                }
	            }else{
	                len = this.v.length;
	                for(i = 0; i < len; i += 1){
	                    if(this.v[i] !== this.lastValue[i]){
	                        this.lastValue[i] = this.v[i];
	                        this.mdf = true;
	                    }
	                }
	            }
	            this.lock = false;
	        }
	        return execute;
	    };
	
	    ob.initiateExpression = initiateExpression;
	    return ob;
	}());
	var ShapeExpressionInterface = (function(){
	    var ob = {
	        createShapeInterface:createShapeInterface,
	        createGroupInterface:createGroupInterface,
	        createTrimInterface:createTrimInterface,
	        createStrokeInterface:createStrokeInterface,
	        createTransformInterface:createTransformInterface,
	        createEllipseInterface:createEllipseInterface,
	        createStarInterface:createStarInterface,
	        createRectInterface:createRectInterface,
	        createRoundedInterface:createRoundedInterface,
	        createRepatearInterface:createRepatearInterface,
	        createPathInterface:createPathInterface,
	        createFillInterface:createFillInterface
	    };
	    function createShapeInterface(shapes,view,propertyGroup){
	        return shapeInterfaceFactory(shapes,view,propertyGroup);
	    }
	    function createGroupInterface(shapes,view,propertyGroup){
	        return groupInterfaceFactory(shapes,view,propertyGroup);
	    }
	    function createFillInterface(shape,view,propertyGroup){
	        return fillInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createStrokeInterface(shape,view,propertyGroup){
	        return strokeInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createTrimInterface(shape,view,propertyGroup){
	        return trimInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createTransformInterface(shape,view,propertyGroup){
	        return transformInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createEllipseInterface(shape,view,propertyGroup){
	        return ellipseInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createStarInterface(shape,view,propertyGroup){
	        return starInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createRectInterface(shape,view,propertyGroup){
	        return rectInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createRoundedInterface(shape,view,propertyGroup){
	        return roundedInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createRepatearInterface(shape,view,propertyGroup){
	        return repeaterInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createPathInterface(shape,view,propertyGroup){
	        return pathInterfaceFactory(shape,view,propertyGroup);
	    }
	
	    function iterateElements(shapes,view, propertyGroup){
	        var arr = [];
	        var i, len = shapes ? shapes.length : 0;
	        for(i=0;i<len;i+=1){
	            if(shapes[i].ty == 'gr'){
	                arr.push(ShapeExpressionInterface.createGroupInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'fl'){
	                arr.push(ShapeExpressionInterface.createFillInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'st'){
	                arr.push(ShapeExpressionInterface.createStrokeInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'tm'){
	                arr.push(ShapeExpressionInterface.createTrimInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'tr'){
	                //arr.push(ShapeExpressionInterface.createTransformInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'el'){
	                arr.push(ShapeExpressionInterface.createEllipseInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'sr'){
	                arr.push(ShapeExpressionInterface.createStarInterface(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'sh'){
	                arr.push(ShapeExpressionInterface.createPathInterface(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rc'){
	                arr.push(ShapeExpressionInterface.createRectInterface(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rd'){
	                arr.push(ShapeExpressionInterface.createRoundedInterface(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rp'){
	                arr.push(ShapeExpressionInterface.createRepatearInterface(shapes[i],view[i],propertyGroup));
	            } else{
	                //console.log(shapes[i].ty);
	            }
	        }
	        return arr;
	    }
	
	    var shapeInterfaceFactory = (function(){
	        return function(shapes,view,propertyGroup){
	            var interfaces;
	            function _interfaceFunction(value){
	                if(typeof value === 'number'){
	                    return interfaces[value-1];
	                } else {
	                    var i = 0, len = interfaces.length;
	                    while(i<len){
	                        if(interfaces[i]._name === value){
	                            return interfaces[i];
	                        }
	                        i+=1;
	                    }
	                }
	            }
	            _interfaceFunction.propertyGroup = propertyGroup;
	            interfaces = iterateElements(shapes, view, _interfaceFunction);
	            return _interfaceFunction;
	        }
	    }());
	
	    var contentsInterfaceFactory = (function(){
	       return function(shape,view, propertyGroup){
	           var interfaces;
	           var interfaceFunction = function _interfaceFunction(value){
	               var i = 0, len = interfaces.length;
	                while(i<len){
	                    if(interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value){
	                       return interfaces[i];
	                    }
	                    i+=1;
	                }
	                if(typeof value === 'number'){
	                   return interfaces[value-1];
	                }
	           };
	           interfaceFunction.propertyGroup = function(val){
	               if(val === 1){
	                   return interfaceFunction;
	               } else{
	                   return propertyGroup(val-1);
	               }
	           };
	           interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
	           interfaceFunction.numProperties = interfaces.length;
	           interfaceFunction.propertyIndex = shape.cix;
	
	           return interfaceFunction;
	       }
	    }());
	
	    var groupInterfaceFactory = (function(){
	        return function(shape,view, propertyGroup){
	            var interfaceFunction = function _interfaceFunction(value){
	                switch(value){
	                    case 'ADBE Vectors Group':
	                    case 'Contents':
	                    case 2:
	                        return interfaceFunction.content;
	                    case 'ADBE Vector Transform Group':
	                    case 3:
	                    default:
	                        return interfaceFunction.transform;
	                }
	                /*if(value === 'ADBE Vector Transform Group'){
	                    return interfaceFunction.transform;
	                    var i = 0, len = interfaces.length;
	                    while(i<len){
	                        if(interfaces[i].ty === 'tr'){
	                            return interfaces[i];
	                        }
	                        i+=1;
	                    }
	                    return null;
	                }
	                if(typeof value === 'number'){
	                    return interfaces[value-1];
	                } else {
	                    var i = 0, len = interfaces.length;
	                    while(i<len){
	                        if(interfaces[i]._name === value){
	                            return interfaces[i];
	                        }
	                        i+=1;
	                    }
	                }*/
	            }
	            interfaceFunction.propertyGroup = function(val){
	                if(val === 1){
	                    return interfaceFunction;
	                } else{
	                    return propertyGroup(val-1);
	                }
	            };
	            var content = contentsInterfaceFactory(shape,view,interfaceFunction.propertyGroup);
	            var transformInterface = ShapeExpressionInterface.createTransformInterface(shape.it[shape.it.length - 1],view.it[view.it.length - 1],interfaceFunction.propertyGroup);
	            interfaceFunction.content = content;
	            interfaceFunction.transform = transformInterface;
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            //interfaceFunction.content = interfaceFunction;
	            interfaceFunction.numProperties = shape.np;
	            interfaceFunction.propertyIndex = shape.ix;
	            interfaceFunction.nm = shape.nm;
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var fillInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	
	            function interfaceFunction(val){
	                if(val === 'Color' || val === 'color'){
	                    return interfaceFunction.color;
	                } else if(val === 'Opacity' || val === 'opacity'){
	                    return interfaceFunction.opacity;
	                }
	            }
	            Object.defineProperty(interfaceFunction, 'color', {
	                get: function(){
	                    return ExpressionValue(view.c, 1 / view.c.mult, 'color');
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'opacity', {
	                get: function(){
	                    return ExpressionValue(view.o, 100);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
	            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });
	
	            view.c.setGroupProperty(propertyGroup);
	            view.o.setGroupProperty(propertyGroup);
	            return interfaceFunction;
	        }
	    }());
	
	    var strokeInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val === 1){
	                    return ob;
	                } else{
	                    return propertyGroup(val-1);
	                }
	            };
	            function _dashPropertyGroup(val){
	                if(val === 1){
	                    return dashOb;
	                } else{
	                    return _propertyGroup(val-1);
	                }
	            };
	            function addPropertyToDashOb(i) {
	                Object.defineProperty(dashOb, shape.d[i].nm, {
	                    get: function(){
	                        return ExpressionValue(view.d.dataProps[i].p)
	                    }
	                });
	            }
	            var i, len = shape.d ? shape.d.length : 0;
	            var dashOb = {}
	            for (i = 0; i < len; i += 1) {
	                addPropertyToDashOb(i);
	                view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
	            }
	
	            function interfaceFunction(val){
	                if(val === 'Color' || val === 'color'){
	                    return interfaceFunction.color;
	                } else if(val === 'Opacity' || val === 'opacity'){
	                    return interfaceFunction.opacity;
	                } else if(val === 'Stroke Width' || val === 'stroke width'){
	                    return interfaceFunction.strokeWidth;
	                }
	            }
	            Object.defineProperty(interfaceFunction, 'color', {
	                get: function(){
	                    return ExpressionValue(view.c, 1 / view.c.mult, 'color');
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'opacity', {
	                get: function(){
	                    return ExpressionValue(view.o, 100);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'strokeWidth', {
	                get: function(){
	                    return ExpressionValue(view.w);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'dash', {
	                get: function(){
	                    return dashOb;
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
	            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });
	
	            view.c.setGroupProperty(_propertyGroup);
	            view.o.setGroupProperty(_propertyGroup);
	            view.w.setGroupProperty(_propertyGroup);
	            return interfaceFunction;
	        }
	    }());
	
	    var trimInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            interfaceFunction.propertyIndex = shape.ix;
	
	            view.s.setGroupProperty(_propertyGroup);
	            view.e.setGroupProperty(_propertyGroup);
	            view.o.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(val){
	                if(val === shape.e.ix || val === 'End' || val === 'end'){
	                    return interfaceFunction.end;
	                }
	                if(val === shape.s.ix){
	                    return interfaceFunction.start;
	                }
	                if(val === shape.o.ix){
	                    return interfaceFunction.offset;
	                }
	            }
	            interfaceFunction.propertyIndex = shape.ix;
	            Object.defineProperty(interfaceFunction, 'start', {
	                get: function(){
	                    return ExpressionValue(view.s, 1 / view.s.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'end', {
	                get: function(){
	                    return ExpressionValue(view.e, 1 / view.e.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'offset', {
	                get: function(){
	                    return ExpressionValue(view.o);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var transformInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            view.transform.mProps.o.setGroupProperty(_propertyGroup);
	            view.transform.mProps.p.setGroupProperty(_propertyGroup);
	            view.transform.mProps.a.setGroupProperty(_propertyGroup);
	            view.transform.mProps.s.setGroupProperty(_propertyGroup);
	            view.transform.mProps.r.setGroupProperty(_propertyGroup);
	            if(view.transform.mProps.sk){
	                view.transform.mProps.sk.setGroupProperty(_propertyGroup);
	                view.transform.mProps.sa.setGroupProperty(_propertyGroup);
	            }
	            view.transform.op.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(value){
	                if(shape.a.ix === value){
	                    return interfaceFunction.anchorPoint;
	                }
	                if(shape.o.ix === value){
	                    return interfaceFunction.opacity;
	                }
	                if(shape.p.ix === value){
	                    return interfaceFunction.position;
	                }
	                if(shape.r.ix === value){
	                    return interfaceFunction.rotation;
	                }
	                if(shape.s.ix === value){
	                    return interfaceFunction.scale;
	                }
	                if(shape.sk && shape.sk.ix === value){
	                    return interfaceFunction.skew;
	                }
	                if(shape.sa && shape.sa.ix === value){
	                    return interfaceFunction.skewAxis;
	                }
	                if(value === 'Opacity') {
	                    return interfaceFunction.opacity;
	                }
	                if(value === 'Position') {
	                    return interfaceFunction.position;
	                }
	                if(value === 'Anchor Point') {
	                    return interfaceFunction.anchorPoint;
	                }
	                if(value === 'Scale') {
	                    return interfaceFunction.scale;
	                }
	                if(value === 'Rotation' || value === 'ADBE Vector Rotation') {
	                    return interfaceFunction.rotation;
	                }
	                if(value === 'Skew') {
	                    return interfaceFunction.skew;
	                }
	                if(value === 'Skew Axis') {
	                    return interfaceFunction.skewAxis;
	                }
	
	            }
	            Object.defineProperty(interfaceFunction, 'opacity', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.o, 1/view.transform.mProps.o.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'position', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.p);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'anchorPoint', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.a);
	                }
	            });
	            var scaleArray = [];
	            Object.defineProperty(interfaceFunction, 'scale', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.s, 1 / view.transform.mProps.s.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'rotation', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.r, 1 / view.transform.mProps.r.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'skew', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.sk);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'skewAxis', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.sa);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.ty = 'tr';
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var ellipseInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            interfaceFunction.propertyIndex = shape.ix;
	            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	            prop.s.setGroupProperty(_propertyGroup);
	            prop.p.setGroupProperty(_propertyGroup);
	            function interfaceFunction(value){
	                if(shape.p.ix === value){
	                    return interfaceFunction.position;
	                }
	                if(shape.s.ix === value){
	                    return interfaceFunction.size;
	                }
	            }
	            Object.defineProperty(interfaceFunction, 'size', {
	                get: function(){
	                    return ExpressionValue(prop.s);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'position', {
	                get: function(){
	                    return ExpressionValue(prop.p);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var starInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	            interfaceFunction.propertyIndex = shape.ix;
	            prop.or.setGroupProperty(_propertyGroup);
	            prop.os.setGroupProperty(_propertyGroup);
	            prop.pt.setGroupProperty(_propertyGroup);
	            prop.p.setGroupProperty(_propertyGroup);
	            prop.r.setGroupProperty(_propertyGroup);
	            if(shape.ir){
	                prop.ir.setGroupProperty(_propertyGroup);
	                prop.is.setGroupProperty(_propertyGroup);
	            }
	
	            function interfaceFunction(value){
	                if(shape.p.ix === value){
	                    return interfaceFunction.position;
	                }
	                if(shape.r.ix === value){
	                    return interfaceFunction.rotation;
	                }
	                if(shape.pt.ix === value){
	                    return interfaceFunction.points;
	                }
	                if(shape.or.ix === value || 'ADBE Vector Star Outer Radius' === value){
	                    return interfaceFunction.outerRadius;
	                }
	                if(shape.os.ix === value){
	                    return interfaceFunction.outerRoundness;
	                }
	                if(shape.ir && (shape.ir.ix === value || 'ADBE Vector Star Inner Radius' === value)){
	                    return interfaceFunction.innerRadius;
	                }
	                if(shape.is && shape.is.ix === value){
	                    return interfaceFunction.innerRoundness;
	                }
	
	            }
	            Object.defineProperty(interfaceFunction, 'position', {
	                get: function(){
	                    return ExpressionValue(prop.p);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'rotation', {
	                get: function(){
	                    return ExpressionValue(prop.r, 1 / prop.r.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'points', {
	                get: function(){
	                    return ExpressionValue(prop.pt);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'outerRadius', {
	                get: function(){
	                    return ExpressionValue(prop.or);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'outerRoundness', {
	                get: function(){
	                    return ExpressionValue(prop.os);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'innerRadius', {
	                get: function(){
	                    if(!prop.ir){
	                        return 0;
	                    }
	                    return ExpressionValue(prop.ir);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'innerRoundness', {
	                get: function(){
	                    if(!prop.is){
	                        return 0;
	                    }
	                    return ExpressionValue(prop.is, 1 / prop.is.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var rectInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	            interfaceFunction.propertyIndex = shape.ix;
	            prop.p.setGroupProperty(_propertyGroup);
	            prop.s.setGroupProperty(_propertyGroup);
	            prop.r.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(value){
	                if(shape.p.ix === value){
	                    return interfaceFunction.position;
	                }
	                if(shape.r.ix === value){
	                    return interfaceFunction.roundness;
	                }
	                if(shape.s.ix === value || value === 'Size'){
	                    return interfaceFunction.size;
	                }
	
	            }
	            Object.defineProperty(interfaceFunction, 'position', {
	                get: function(){
	                    return ExpressionValue(prop.p);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'roundness', {
	                get: function(){
	                    return ExpressionValue(prop.r);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'size', {
	                get: function(){
	                    return ExpressionValue(prop.s);
	                }
	            });
	
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var roundedInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            var prop = view;
	            interfaceFunction.propertyIndex = shape.ix;
	            prop.rd.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(value){
	                if(shape.r.ix === value || 'Round Corners 1' === value){
	                    return interfaceFunction.radius;
	                }
	
	            }
	            Object.defineProperty(interfaceFunction, 'radius', {
	                get: function(){
	                    return ExpressionValue(prop.rd);
	                }
	            });
	
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var repeaterInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            var prop = view;
	            interfaceFunction.propertyIndex = shape.ix;
	            prop.c.setGroupProperty(_propertyGroup);
	            prop.o.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(value){
	                if(shape.c.ix === value || 'Copies' === value){
	                    return interfaceFunction.copies;
	                } else if(shape.o.ix === value || 'Offset' === value){
	                    return interfaceFunction.offset;
	                }
	
	            }
	            Object.defineProperty(interfaceFunction, 'copies', {
	                get: function(){
	                    return ExpressionValue(prop.c);
	                }
	            });
	
	            Object.defineProperty(interfaceFunction, 'offset', {
	                get: function(){
	                    return ExpressionValue(prop.o);
	                }
	            });
	
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var pathInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            prop.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(val){
	                if(val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 2){
	                    return interfaceFunction.path;
	                }
	            }
	            Object.defineProperty(interfaceFunction, 'path', {
	                get: function(){
	                    if(prop.k){
	                        prop.getValue();
	                    }
	                    return prop.v;
	                    //return shape_pool.clone(prop.v);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'shape', {
	                get: function(){
	                    if(prop.k){
	                        prop.getValue();
	                    }
	                    return prop.v;
	                    //return shape_pool.clone(prop.v);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
	            Object.defineProperty(interfaceFunction, 'ix', { value: shape.ix });
	            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });
	            return interfaceFunction;
	        }
	    }());
	
	
	    return ob;
	}())
	
	var TextExpressionInterface = (function(){
		return function(elem){
	        function _thisLayerFunction(){
	        }
	        Object.defineProperty(_thisLayerFunction, "sourceText", {
	            get: function(){
	            	if(!elem.currentTextDocumentData.t) {
	            		return ''
	            	}
	                return elem.currentTextDocumentData.t;
	            }
	        });
	        return _thisLayerFunction;
	    }
	}())
	var LayerExpressionInterface = (function (){
	    function toWorld(arr, time){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        var transformMat;
	        if(time) {
	            //Todo implement value at time on transform properties
	            //transformMat = this._elem.finalTransform.mProp.getValueAtTime(time);
	            transformMat = this._elem.finalTransform.mProp;
	        } else {
	            transformMat = this._elem.finalTransform.mProp;
	        }
	        transformMat.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
	        }
	        return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
	    }
	    function fromWorld(arr, time){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        var transformMat;
	        if(time) {
	            //Todo implement value at time on transform properties
	            //transformMat = this._elem.finalTransform.mProp.getValueAtTime(time);
	            transformMat = this._elem.finalTransform.mProp;
	        } else {
	            transformMat = this._elem.finalTransform.mProp;
	        }
	        transformMat.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.inversePoint(arr);
	        }
	        return toWorldMat.inversePoint(arr);
	    }
	    function fromComp(arr){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.inversePoint(arr);
	        }
	        return toWorldMat.inversePoint(arr);
	    }
	
	
	    return function(elem){
	
	        var transformInterface = TransformExpressionInterface(elem.transform);
	
	        function _registerMaskInterface(maskManager){
	            _thisLayerFunction.mask = maskManager.getMask.bind(maskManager);
	        }
	        function _registerEffectsInterface(effects){
	            _thisLayerFunction.effect = effects;
	        }
	
	        function _thisLayerFunction(name){
	            switch(name){
	                case "ADBE Root Vectors Group":
	                case "Contents":
	                case 2:
	                    return _thisLayerFunction.shapeInterface;
	                case 1:
	                case 6:
	                case "Transform":
	                case "transform":
	                case "ADBE Transform Group":
	                    return transformInterface;
	                case 4:
	                case "ADBE Effect Parade":
	                    return _thisLayerFunction.effect;
	            }
	        }
	        _thisLayerFunction.toWorld = toWorld;
	        _thisLayerFunction.fromWorld = fromWorld;
	        _thisLayerFunction.toComp = toWorld;
	        _thisLayerFunction.fromComp = fromComp;
	        _thisLayerFunction._elem = elem;
	        Object.defineProperty(_thisLayerFunction, 'hasParent', {
	            get: function(){
	                return !!elem.hierarchy;
	            }
	        });
	        Object.defineProperty(_thisLayerFunction, 'parent', {
	            get: function(){
	                return elem.hierarchy[0].layerInterface;
	            }
	        });
	        Object.defineProperty(_thisLayerFunction, "rotation", {
	            get: function(){
	                return transformInterface.rotation;
	            }
	        });
	        Object.defineProperty(_thisLayerFunction, "scale", {
	            get: function () {
	                return transformInterface.scale;
	            }
	        });
	
	        Object.defineProperty(_thisLayerFunction, "position", {
	            get: function () {
	                return transformInterface.position;
	            }
	        });
	
	        Object.defineProperty(_thisLayerFunction, "anchorPoint", {
	            get: function () {
	                return transformInterface.anchorPoint;
	            }
	        });
	
	        Object.defineProperty(_thisLayerFunction, "transform", {
	            get: function () {
	                return transformInterface;
	            }
	        });
	
	        Object.defineProperty(_thisLayerFunction, "width", {
	            get: function () {
	                if(elem.data.ty === 0) {
	                    return elem.data.w
	                }
	                return 100;
	            }
	        });
	
	        Object.defineProperty(_thisLayerFunction, "height", {
	            get: function () {
	                if(elem.data.ty === 0) {
	                    return elem.data.h
	                }
	                return 100;
	            }
	        });
	
	        Object.defineProperty(_thisLayerFunction, "source", {
	            get: function () {
	                return elem.data.refId;
	            }
	        });
	
	        Object.defineProperty(_thisLayerFunction, "_name", { value:elem.data.nm });
	        Object.defineProperty(_thisLayerFunction, "content", {
	            get: function(){
	                return _thisLayerFunction.shapeInterface;
	            }
	        });
	
	        Object.defineProperty(_thisLayerFunction, "active", {
	            get: function(){
	                return elem.isVisible;
	            }
	        });
	
	        Object.defineProperty(_thisLayerFunction, "text", {
	            get: function(){
	                return _thisLayerFunction.textInterface;
	            }
	        });
	
	        _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
	        _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
	        return _thisLayerFunction;
	    }
	}());
	
	var CompExpressionInterface = (function (){
	    return function(comp){
	        function _thisLayerFunction(name){
	            var i=0, len = comp.layers.length;
	            while(i<len){
	                if(comp.layers[i].nm === name || comp.layers[i].ind === name){
	                    return comp.elements[i].layerInterface;
	                }
	                i += 1;
	            }
	            return {active:false}
	        }
	        Object.defineProperty(_thisLayerFunction, "_name", { value:comp.data.nm });
	        _thisLayerFunction.layer = _thisLayerFunction;
	        _thisLayerFunction.pixelAspect = 1;
	        _thisLayerFunction.height = comp.globalData.compSize.h;
	        _thisLayerFunction.width = comp.globalData.compSize.w;
	        _thisLayerFunction.pixelAspect = 1;
	        _thisLayerFunction.frameDuration = 1/comp.globalData.frameRate;
	        return _thisLayerFunction;
	    }
	}());
	var TransformExpressionInterface = (function (){
	    return function(transform){
	        function _thisFunction(name){
	            switch(name){
	                case "scale":
	                case "Scale":
	                case "ADBE Scale":
	                case 6:
	                    return _thisFunction.scale;
	                case "rotation":
	                case "Rotation":
	                case "ADBE Rotation":
	                case "ADBE Rotate Z":
	                case 10:
	                    return _thisFunction.rotation;
	                case "position":
	                case "Position":
	                case "ADBE Position":
	                case 2:
	                    return transform.position;
	                case "anchorPoint":
	                case "AnchorPoint":
	                case "Anchor Point":
	                case "ADBE AnchorPoint":
	                case 1:
	                    return _thisFunction.anchorPoint;
	                case "opacity":
	                case "Opacity":
	                case 11:
	                    return _thisFunction.opacity;
	            }
	        }
	
	        Object.defineProperty(_thisFunction, "rotation", {
	            get: function(){
	                return transform.rotation;
	            }
	        });
	        Object.defineProperty(_thisFunction, "scale", {
	            get: function () {
	                return transform.scale;
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "position", {
	            get: function () {
	                return transform.position;
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "xPosition", {
	            get: function () {
	                return transform.xPosition;
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "yPosition", {
	            get: function () {
	                return transform.yPosition;
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "anchorPoint", {
	            get: function () {
	                return transform.anchorPoint;
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "opacity", {
	            get: function () {
	                return transform.opacity;
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "skew", {
	            get: function () {
	                return transform.skew;
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "skewAxis", {
	            get: function () {
	                return transform.skewAxis;
	            }
	        });
	
	        return _thisFunction;
	    }
	}());
	var ProjectInterface = (function (){
	
	    function registerComposition(comp){
	        this.compositions.push(comp);
	    }
	
	    return function(){
	        function _thisProjectFunction(name){
	            var i = 0, len = this.compositions.length;
	            while(i<len){
	                if(this.compositions[i].data && this.compositions[i].data.nm === name){
	                    if(this.compositions[i].prepareFrame) {
	                        this.compositions[i].prepareFrame(this.currentFrame);
	                    }
	                    return this.compositions[i].compInterface;
	                }
	                i+=1;
	            }
	        }
	
	        _thisProjectFunction.compositions = [];
	        _thisProjectFunction.currentFrame = 0;
	
	        _thisProjectFunction.registerComposition = registerComposition;
	
	
	
	        return _thisProjectFunction;
	    }
	}());
	var EffectsExpressionInterface = (function (){
	    var ob = {
	        createEffectsInterface: createEffectsInterface
	    };
	
	    function createEffectsInterface(elem, propertyGroup){
	        if(elem.effects){
	
	            var effectElements = [];
	            var effectsData = elem.data.ef;
	            var i, len = elem.effects.effectElements.length;
	            for(i=0;i<len;i+=1){
	                effectElements.push(createGroupInterface(effectsData[i],elem.effects.effectElements[i],propertyGroup,elem));
	            }
	
	            return function(name){
	                var effects = elem.data.ef, i = 0, len = effects.length;
	                while(i<len) {
	                    if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
	                        return effectElements[i];
	                    }
	                    i += 1;
	                }
	            }
	        }
	    }
	
	    function createGroupInterface(data,elements, propertyGroup, elem){
	        var effectElements = [];
	        var i, len = data.ef.length;
	        for(i=0;i<len;i+=1){
	            if(data.ef[i].ty === 5){
	                effectElements.push(createGroupInterface(data.ef[i],elements.effectElements[i],propertyGroup, elem));
	            } else {
	                effectElements.push(createValueInterface(elements.effectElements[i],data.ef[i].ty, elem));
	            }
	        }
	        var groupInterface = function(name){
	            var effects = data.ef, i = 0, len = effects.length;
	            while(i<len) {
	                if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
	                    if(effects[i].ty === 5){
	                        return effectElements[i];
	                    } else {
	                        return effectElements[i]();
	                    }
	                }
	                i += 1;
	            }
	            return effectElements[0]();
	        }
	        if(data.mn === 'ADBE Color Control'){
	            Object.defineProperty(groupInterface, 'color', {
	                get: function(){
	                    return effectElements[0]();
	                }
	            });
	        }
	        Object.defineProperty(groupInterface, 'numProperties', {
	            get: function(){
	                return data.np;
	            }
	        });
	        groupInterface.active = data.en !== 0;
	        return groupInterface
	    }
	
	    function createValueInterface(element, type, elem){
	        return function(){
	            if(type === 10){
	                return elem.comp.compInterface(element.p.v);
	            }
	            return ExpressionValue(element.p);
	        }
	    }
	
	    return ob;
	
	}());
	var ExpressionValue = (function() {
		return function(elementProp, mult, type) {
	        var expressionValue, arrayValue;
	
			if (elementProp.k) {
	            elementProp.getValue();
	        }
	        var i, len, arrValue;
	        if (type) {
	        	if(type === 'color') {
	        		len = 4;
			        expressionValue = Array.apply(null, {length: len});
			        arrValue = Array.apply(null, {length: len});
			        for (i = 0; i < len; i += 1) {
			            expressionValue[i] = arrValue[i] = (mult && i < 3) ? elementProp.v[i] * mult : 1;
			        }
		        	expressionValue.value = arrValue;
	        	}
	        } else if (typeof elementProp.v === 'number' || elementProp.v instanceof Number){
	            expressionValue = mult ? new Number(elementProp.v * mult) : new Number(elementProp.v);
	            expressionValue.value = mult ? elementProp.v * mult : elementProp.v;
	        } else {
	        	len = elementProp.v.length;
		        expressionValue = Array.apply(null, {length: len});
		        arrValue = Array.apply(null, {length: len});
		        for (i = 0; i < len; i += 1) {
		            expressionValue[i] = arrValue[i] = mult ? elementProp.v[i] * mult : elementProp.v[i];
		        }
		        expressionValue.value = arrValue;
	        }
	        
	        expressionValue.numKeys = elementProp.keyframes ? elementProp.keyframes.length : 0;
	        expressionValue.key = function(pos) {
	            if (!expressionValue.numKeys) {
	                return 0;
	            } else {
	                return elementProp.keyframes[pos-1].t;
	            }
	        };
	        expressionValue.valueAtTime = elementProp.getValueAtTime;
	        expressionValue.propertyGroup = elementProp.propertyGroup;
	        return expressionValue;
		}
	}())
	function SliderEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
	}
	function AngleEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
	}
	function ColorEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,1,0,dynamicProperties);
	}
	function PointEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,1,0,dynamicProperties);
	}
	function LayerIndexEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
	}
	function MaskIndexEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
	}
	function CheckboxEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
	}
	function NoValueEffect(){
	    this.p = {};
	}
	function EffectsManager(data,element,dynamicProperties){
	    var effects = data.ef;
	    this.effectElements = [];
	    var i,len = effects.length;
	    var effectItem;
	    for(i=0;i<len;i++) {
	        effectItem = new GroupEffect(effects[i],element,dynamicProperties);
	        this.effectElements.push(effectItem);
	    }
	}
	
	function GroupEffect(data,element,dynamicProperties){
	    this.dynamicProperties = [];
	    this.init(data,element,this.dynamicProperties);
	    if(this.dynamicProperties.length){
	        dynamicProperties.push(this);
	    }
	}
	
	GroupEffect.prototype.getValue = function(){
	    this.mdf = false;
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	        this.mdf = this.dynamicProperties[i].mdf ? true : this.mdf;
	    }
	};
	
	GroupEffect.prototype.init = function(data,element,dynamicProperties){
	    this.data = data;
	    this.mdf = false;
	    this.effectElements = [];
	    var i, len = this.data.ef.length;
	    var eff, effects = this.data.ef;
	    for(i=0;i<len;i+=1){
	        switch(effects[i].ty){
	            case 0:
	                eff = new SliderEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 1:
	                eff = new AngleEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 2:
	                eff = new ColorEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 3:
	                eff = new PointEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 4:
	            case 7:
	                eff = new CheckboxEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 10:
	                eff = new LayerIndexEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 11:
	                eff = new MaskIndexEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 5:
	                eff = new EffectsManager(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 6:
	                eff = new NoValueEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	        }
	    }
	};
	    var bodymovinjs = {};
	
	    function play(animation) {
	        animationManager.play(animation);
	    }
	
	    function pause(animation) {
	        animationManager.pause(animation);
	    }
	
	    function togglePause(animation) {
	        animationManager.togglePause(animation);
	    }
	
	    function setSpeed(value, animation) {
	        animationManager.setSpeed(value, animation);
	    }
	
	    function setDirection(value, animation) {
	        animationManager.setDirection(value, animation);
	    }
	
	    function stop(animation) {
	        animationManager.stop(animation);
	    }
	
	    function moveFrame(value) {
	        animationManager.moveFrame(value);
	    }
	
	    function searchAnimations() {
	        if (standalone === true) {
	            animationManager.searchAnimations(animationData, standalone, renderer);
	        } else {
	            animationManager.searchAnimations();
	        }
	    }
	
	    function registerAnimation(elem) {
	        return animationManager.registerAnimation(elem);
	    }
	
	    function resize() {
	        animationManager.resize();
	    }
	
	    function start() {
	        animationManager.start();
	    }
	
	    function goToAndStop(val, isFrame, animation) {
	        animationManager.goToAndStop(val, isFrame, animation);
	    }
	
	    function setSubframeRendering(flag) {
	        subframeEnabled = flag;
	    }
	
	    function loadAnimation(params) {
	        if (standalone === true) {
	            params.animationData = JSON.parse(animationData);
	        }
	        return animationManager.loadAnimation(params);
	    }
	
	    function destroy(animation) {
	        return animationManager.destroy(animation);
	    }
	
	    function setQuality(value) {
	        if (typeof value === 'string') {
	            switch (value) {
	                case 'high':
	                    defaultCurveSegments = 200;
	                    break;
	                case 'medium':
	                    defaultCurveSegments = 50;
	                    break;
	                case 'low':
	                    defaultCurveSegments = 10;
	                    break;
	            }
	        } else if (!isNaN(value) && value > 1) {
	            defaultCurveSegments = value;
	        }
	        if (defaultCurveSegments >= 50) {
	            roundValues(false);
	        } else {
	            roundValues(true);
	        }
	    }
	
	    function inBrowser() {
	        return typeof navigator !== 'undefined';
	    }
	
	    function installPlugin(type, plugin) {
	        if (type === 'expressions') {
	            expressionsPlugin = plugin;
	        }
	    }
	
	    function getFactory(name) {
	        switch (name) {
	            case "propertyFactory":
	                return PropertyFactory;
	            case "shapePropertyFactory":
	                return ShapePropertyFactory;
	            case "matrix":
	                return Matrix;
	        }
	    }
	    bodymovinjs.play = play;
	    bodymovinjs.pause = pause;
	    bodymovinjs.togglePause = togglePause;
	    bodymovinjs.setSpeed = setSpeed;
	    bodymovinjs.setDirection = setDirection;
	    bodymovinjs.stop = stop;
	    bodymovinjs.moveFrame = moveFrame;
	    bodymovinjs.searchAnimations = searchAnimations;
	    bodymovinjs.registerAnimation = registerAnimation;
	    bodymovinjs.loadAnimation = loadAnimation;
	    bodymovinjs.setSubframeRendering = setSubframeRendering;
	    bodymovinjs.resize = resize;
	    bodymovinjs.start = start;
	    bodymovinjs.goToAndStop = goToAndStop;
	    bodymovinjs.destroy = destroy;
	    bodymovinjs.setQuality = setQuality;
	    bodymovinjs.inBrowser = inBrowser;
	    bodymovinjs.installPlugin = installPlugin;
	    bodymovinjs.__getFactory = getFactory;
	    bodymovinjs.version = '4.10.2';
	
	    function checkReady() {
	        if (document.readyState === "complete") {
	            clearInterval(readyStateCheckInterval);
	            searchAnimations();
	        }
	    }
	
	    function getQueryVariable(variable) {
	        var vars = queryString.split('&');
	        for (var i = 0; i < vars.length; i++) {
	            var pair = vars[i].split('=');
	            if (decodeURIComponent(pair[0]) == variable) {
	                return decodeURIComponent(pair[1]);
	            }
	        }
	    }
	    var standalone = '__[STANDALONE]__';
	    var animationData = '__[ANIMATIONDATA]__';
	    var renderer = '';
	    if (standalone) {
	        var scripts = document.getElementsByTagName('script');
	        var index = scripts.length - 1;
	        var myScript = scripts[index] || {
	            src: ''
	        };
	        var queryString = myScript.src.replace(/^[^\?]+\??/, '');
	        renderer = getQueryVariable('renderer');
	    }
	    var readyStateCheckInterval = setInterval(checkReady, 100);
	    return bodymovinjs;
	}));

/***/ },
/* 643 */
500,
/* 644 */
12,
/* 645 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 646 */
645,
/* 647 */
645,
/* 648 */
645,
/* 649 */
645,
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	"use strict";
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function (condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	module.exports.Dispatcher = __webpack_require__(652);


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Dispatcher
	 * 
	 * @preventMunge
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(650);
	
	var _prefix = 'ID_';
	
	/**
	 * Dispatcher is used to broadcast payloads to registered callbacks. This is
	 * different from generic pub-sub systems in two ways:
	 *
	 *   1) Callbacks are not subscribed to particular events. Every payload is
	 *      dispatched to every registered callback.
	 *   2) Callbacks can be deferred in whole or part until other callbacks have
	 *      been executed.
	 *
	 * For example, consider this hypothetical flight destination form, which
	 * selects a default city when a country is selected:
	 *
	 *   var flightDispatcher = new Dispatcher();
	 *
	 *   // Keeps track of which country is selected
	 *   var CountryStore = {country: null};
	 *
	 *   // Keeps track of which city is selected
	 *   var CityStore = {city: null};
	 *
	 *   // Keeps track of the base flight price of the selected city
	 *   var FlightPriceStore = {price: null}
	 *
	 * When a user changes the selected city, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'city-update',
	 *     selectedCity: 'paris'
	 *   });
	 *
	 * This payload is digested by `CityStore`:
	 *
	 *   flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'city-update') {
	 *       CityStore.city = payload.selectedCity;
	 *     }
	 *   });
	 *
	 * When the user selects a country, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'country-update',
	 *     selectedCountry: 'australia'
	 *   });
	 *
	 * This payload is digested by both stores:
	 *
	 *   CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       CountryStore.country = payload.selectedCountry;
	 *     }
	 *   });
	 *
	 * When the callback to update `CountryStore` is registered, we save a reference
	 * to the returned token. Using this token with `waitFor()`, we can guarantee
	 * that `CountryStore` is updated before the callback that updates `CityStore`
	 * needs to query its data.
	 *
	 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       // `CountryStore.country` may not be updated.
	 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
	 *       // `CountryStore.country` is now guaranteed to be updated.
	 *
	 *       // Select the default city for the new country
	 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
	 *     }
	 *   });
	 *
	 * The usage of `waitFor()` can be chained, for example:
	 *
	 *   FlightPriceStore.dispatchToken =
	 *     flightDispatcher.register(function(payload) {
	 *       switch (payload.actionType) {
	 *         case 'country-update':
	 *         case 'city-update':
	 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
	 *           FlightPriceStore.price =
	 *             getFlightPriceStore(CountryStore.country, CityStore.city);
	 *           break;
	 *     }
	 *   });
	 *
	 * The `country-update` payload will be guaranteed to invoke the stores'
	 * registered callbacks in order: `CountryStore`, `CityStore`, then
	 * `FlightPriceStore`.
	 */
	
	var Dispatcher = (function () {
	  function Dispatcher() {
	    _classCallCheck(this, Dispatcher);
	
	    this._callbacks = {};
	    this._isDispatching = false;
	    this._isHandled = {};
	    this._isPending = {};
	    this._lastID = 1;
	  }
	
	  /**
	   * Registers a callback to be invoked with every dispatched payload. Returns
	   * a token that can be used with `waitFor()`.
	   */
	
	  Dispatcher.prototype.register = function register(callback) {
	    var id = _prefix + this._lastID++;
	    this._callbacks[id] = callback;
	    return id;
	  };
	
	  /**
	   * Removes a callback based on its token.
	   */
	
	  Dispatcher.prototype.unregister = function unregister(id) {
	    !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.unregister(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	    delete this._callbacks[id];
	  };
	
	  /**
	   * Waits for the callbacks specified to be invoked before continuing execution
	   * of the current callback. This method should only be used by a callback in
	   * response to a dispatched payload.
	   */
	
	  Dispatcher.prototype.waitFor = function waitFor(ids) {
	    !this._isDispatching ?  false ? invariant(false, 'Dispatcher.waitFor(...): Must be invoked while dispatching.') : invariant(false) : undefined;
	    for (var ii = 0; ii < ids.length; ii++) {
	      var id = ids[ii];
	      if (this._isPending[id]) {
	        !this._isHandled[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): Circular dependency detected while ' + 'waiting for `%s`.', id) : invariant(false) : undefined;
	        continue;
	      }
	      !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	      this._invokeCallback(id);
	    }
	  };
	
	  /**
	   * Dispatches a payload to all registered callbacks.
	   */
	
	  Dispatcher.prototype.dispatch = function dispatch(payload) {
	    !!this._isDispatching ?  false ? invariant(false, 'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.') : invariant(false) : undefined;
	    this._startDispatching(payload);
	    try {
	      for (var id in this._callbacks) {
	        if (this._isPending[id]) {
	          continue;
	        }
	        this._invokeCallback(id);
	      }
	    } finally {
	      this._stopDispatching();
	    }
	  };
	
	  /**
	   * Is this Dispatcher currently dispatching.
	   */
	
	  Dispatcher.prototype.isDispatching = function isDispatching() {
	    return this._isDispatching;
	  };
	
	  /**
	   * Call the callback stored with the given id. Also do some internal
	   * bookkeeping.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._invokeCallback = function _invokeCallback(id) {
	    this._isPending[id] = true;
	    this._callbacks[id](this._pendingPayload);
	    this._isHandled[id] = true;
	  };
	
	  /**
	   * Set up bookkeeping needed when dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._startDispatching = function _startDispatching(payload) {
	    for (var id in this._callbacks) {
	      this._isPending[id] = false;
	      this._isHandled[id] = false;
	    }
	    this._pendingPayload = payload;
	    this._isDispatching = true;
	  };
	
	  /**
	   * Clear bookkeeping used for dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._stopDispatching = function _stopDispatching() {
	    delete this._pendingPayload;
	    this._isDispatching = false;
	  };
	
	  return Dispatcher;
	})();
	
	module.exports = Dispatcher;

/***/ },
/* 653 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(191);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(93);
	
	var _DOMUtils = __webpack_require__(140);
	
	var _DOMStateStorage = __webpack_require__(278);
	
	var _PathUtils = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(191);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(93);
	
	var _PathUtils = __webpack_require__(69);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(192);
	
	var _BrowserProtocol = __webpack_require__(191);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(655);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(140);
	
	var _createHistory = __webpack_require__(193);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(192);
	
	var _DOMUtils = __webpack_require__(140);
	
	var _HashProtocol = __webpack_require__(654);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(193);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(93);
	
	var _PathUtils = __webpack_require__(69);
	
	var _createHistory = __webpack_require__(193);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 659 */
/***/ function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function hyphenateStyleName(string) {
	    return string in cache
	    ? cache[string]
	    : cache[string] = string
	      .replace(uppercasePattern, '-$&')
	      .toLowerCase()
	      .replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 660 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function addQueryString(url, params) {
	  if (params && (typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
	    var queryString = '',
	        e = encodeURIComponent;
	
	    // Must encode data
	    for (var paramName in params) {
	      queryString += '&' + e(paramName) + '=' + e(params[paramName]);
	    }
	
	    if (!queryString) {
	      return url;
	    }
	
	    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
	  }
	
	  return url;
	}
	
	// https://gist.github.com/Xeoncross/7663273
	function ajax(url, options, callback, data, cache) {
	
	  if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
	    if (!cache) {
	      data['_t'] = new Date();
	    }
	    // URL encoded form data must be in querystring format
	    data = addQueryString('', data).slice(1);
	  }
	
	  if (options.queryStringParams) {
	    url = addQueryString(url, options.queryStringParams);
	  }
	
	  try {
	    var x;
	    if (XMLHttpRequest) {
	      x = new XMLHttpRequest();
	    } else {
	      x = new ActiveXObject('MSXML2.XMLHTTP.3.0');
	    }
	    x.open(data ? 'POST' : 'GET', url, 1);
	    if (!options.crossDomain) {
	      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	    }
	    x.withCredentials = !!options.withCredentials;
	    if (data) {
	      x.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	    }
	    var h = options.customHeaders;
	    if (h) {
	      for (var i in h) {
	        x.setRequestHeader(i, h[i]);
	      }
	    }
	    x.onreadystatechange = function () {
	      x.readyState > 3 && callback && callback(x.responseText, x);
	    };
	    x.send(data);
	  } catch (e) {
	    console && console.log(e);
	  }
	}
	
	exports.default = ajax;

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(662);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _ajax = __webpack_require__(660);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function getDefaults() {
	  return {
	    loadPath: '/locales/{{lng}}/{{ns}}.json',
	    addPath: 'locales/add/{{lng}}/{{ns}}',
	    allowMultiLoading: false,
	    parse: JSON.parse,
	    crossDomain: false,
	    ajax: _ajax2.default
	  };
	}
	
	var Backend = function () {
	  function Backend(services) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Backend);
	
	    this.init(services, options);
	
	    this.type = 'backend';
	  }
	
	  _createClass(Backend, [{
	    key: 'init',
	    value: function init(services) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this.services = services;
	      this.options = utils.defaults(options, this.options || {}, getDefaults());
	    }
	  }, {
	    key: 'readMulti',
	    value: function readMulti(languages, namespaces, callback) {
	      var loadPath = this.options.loadPath;
	      if (typeof this.options.loadPath === 'function') {
	        loadPath = this.options.loadPath(languages, namespaces);
	      }
	
	      var url = this.services.interpolator.interpolate(loadPath, { lng: languages.join('+'), ns: namespaces.join('+') });
	
	      this.loadUrl(url, callback);
	    }
	  }, {
	    key: 'read',
	    value: function read(language, namespace, callback) {
	      var loadPath = this.options.loadPath;
	      if (typeof this.options.loadPath === 'function') {
	        loadPath = this.options.loadPath([language], [namespace]);
	      }
	
	      var url = this.services.interpolator.interpolate(loadPath, { lng: language, ns: namespace });
	
	      this.loadUrl(url, callback);
	    }
	  }, {
	    key: 'loadUrl',
	    value: function loadUrl(url, callback) {
	      var _this = this;
	
	      this.options.ajax(url, this.options, function (data, xhr) {
	        if (xhr.status >= 500 && xhr.status < 600) return callback('failed loading ' + url, true /* retry */);
	        if (xhr.status >= 400 && xhr.status < 500) return callback('failed loading ' + url, false /* no retry */);
	
	        var ret = void 0,
	            err = void 0;
	        try {
	          ret = _this.options.parse(data, url);
	        } catch (e) {
	          err = 'failed parsing ' + url + ' to json';
	        }
	        if (err) return callback(err, false);
	        callback(null, ret);
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create(languages, namespace, key, fallbackValue) {
	      var _this2 = this;
	
	      if (typeof languages === 'string') languages = [languages];
	
	      var payload = {};
	      payload[key] = fallbackValue || '';
	
	      languages.forEach(function (lng) {
	        var url = _this2.services.interpolator.interpolate(_this2.options.addPath, { lng: lng, ns: namespace });
	
	        _this2.options.ajax(url, _this2.options, function (data, xhr) {
	          //const statusCode = xhr.status.toString();
	          // TODO: if statusCode === 4xx do log
	        }, payload);
	      });
	    }
	  }]);
	
	  return Backend;
	}();
	
	Backend.type = 'backend';
	
	exports.default = Backend;

/***/ },
/* 662 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaults = defaults;
	exports.extend = extend;
	var arr = [];
	var each = arr.forEach;
	var slice = arr.slice;
	
	function defaults(obj) {
	  each.call(slice.call(arguments, 1), function (source) {
	    if (source) {
	      for (var prop in source) {
	        if (obj[prop] === undefined) obj[prop] = source[prop];
	      }
	    }
	  });
	  return obj;
	}
	
	function extend(obj) {
	  each.call(slice.call(arguments, 1), function (source) {
	    if (source) {
	      for (var prop in source) {
	        obj[prop] = source[prop];
	      }
	    }
	  });
	  return obj;
	}

/***/ },
/* 663 */
[1178, 661],
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _utils = __webpack_require__(108);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _logger = __webpack_require__(70);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(107);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	function remove(arr, what) {
	  var found = arr.indexOf(what);
	
	  while (found !== -1) {
	    arr.splice(found, 1);
	    found = arr.indexOf(what);
	  }
	}
	
	var Connector = function (_EventEmitter) {
	  _inherits(Connector, _EventEmitter);
	
	  function Connector(backend, store, services) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    _classCallCheck(this, Connector);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.backend = backend;
	    _this.store = store;
	    _this.services = services;
	    _this.options = options;
	    _this.logger = _logger2.default.create('backendConnector');
	
	    _this.state = {};
	    _this.queue = [];
	
	    _this.backend && _this.backend.init && _this.backend.init(services, options.backend, options);
	    return _this;
	  }
	
	  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, callback) {
	    var _this2 = this;
	
	    // find what needs to be loaded
	    var toLoad = [],
	        pending = [],
	        toLoadLanguages = [],
	        toLoadNamespaces = [];
	
	    languages.forEach(function (lng) {
	      var hasAllNamespaces = true;
	
	      namespaces.forEach(function (ns) {
	        var name = lng + '|' + ns;
	
	        if (_this2.store.hasResourceBundle(lng, ns)) {
	          _this2.state[name] = 2; // loaded
	        } else if (_this2.state[name] < 0) {
	          // nothing to do for err
	        } else if (_this2.state[name] === 1) {
	          if (pending.indexOf(name) < 0) pending.push(name);
	        } else {
	          _this2.state[name] = 1; // pending
	
	          hasAllNamespaces = false;
	
	          if (pending.indexOf(name) < 0) pending.push(name);
	          if (toLoad.indexOf(name) < 0) toLoad.push(name);
	          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
	        }
	      });
	
	      if (!hasAllNamespaces) toLoadLanguages.push(lng);
	    });
	
	    if (toLoad.length || pending.length) {
	      this.queue.push({
	        pending: pending,
	        loaded: {},
	        errors: [],
	        callback: callback
	      });
	    }
	
	    return {
	      toLoad: toLoad,
	      pending: pending,
	      toLoadLanguages: toLoadLanguages,
	      toLoadNamespaces: toLoadNamespaces
	    };
	  };
	
	  Connector.prototype.loaded = function loaded(name, err, data) {
	    var _this3 = this;
	
	    var _name$split = name.split('|'),
	        _name$split2 = _slicedToArray(_name$split, 2),
	        lng = _name$split2[0],
	        ns = _name$split2[1];
	
	    if (err) this.emit('failedLoading', lng, ns, err);
	
	    if (data) {
	      this.store.addResourceBundle(lng, ns, data);
	    }
	
	    // set loaded
	    this.state[name] = err ? -1 : 2;
	    // callback if ready
	    this.queue.forEach(function (q) {
	      utils.pushPath(q.loaded, [lng], ns);
	      remove(q.pending, name);
	
	      if (err) q.errors.push(err);
	
	      if (q.pending.length === 0 && !q.done) {
	        _this3.emit('loaded', q.loaded);
	        q.errors.length ? q.callback(q.errors) : q.callback();
	        q.done = true;
	      }
	    });
	
	    // remove done load requests
	    this.queue = this.queue.filter(function (q) {
	      return !q.done;
	    });
	  };
	
	  Connector.prototype.read = function read(lng, ns, fcName, tried, wait, callback) {
	    var _this4 = this;
	
	    if (!tried) tried = 0;
	    if (!wait) wait = 250;
	
	    if (!lng.length) return callback(null, {}); // noting to load
	
	    this.backend[fcName](lng, ns, function (err, data) {
	      if (err && data /* = retryFlag */ && tried < 5) {
	        setTimeout(function () {
	          _this4.read.call(_this4, lng, ns, fcName, ++tried, wait * 2, callback);
	        }, wait);
	        return;
	      }
	      callback(err, data);
	    });
	  };
	
	  Connector.prototype.load = function load(languages, namespaces, callback) {
	    var _this5 = this;
	
	    if (!this.backend) {
	      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
	      return callback && callback();
	    }
	    var options = _extends({}, this.backend.options, this.options.backend);
	
	    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
	    if (typeof namespaces === 'string') namespaces = [namespaces];
	
	    var toLoad = this.queueLoad(languages, namespaces, callback);
	    if (!toLoad.toLoad.length) {
	      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
	      return; // pendings will trigger callback
	    }
	
	    // load with multi-load
	    if (options.allowMultiLoading && this.backend.readMulti) {
	      this.read(toLoad.toLoadLanguages, toLoad.toLoadNamespaces, 'readMulti', null, null, function (err, data) {
	        if (err) _this5.logger.warn('loading namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading failed', err);
	        if (!err && data) _this5.logger.log('loaded namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading', data);
	
	        toLoad.toLoad.forEach(function (name) {
	          var _name$split3 = name.split('|'),
	              _name$split4 = _slicedToArray(_name$split3, 2),
	              l = _name$split4[0],
	              n = _name$split4[1];
	
	          var bundle = utils.getPath(data, [l, n]);
	          if (bundle) {
	            _this5.loaded(name, err, bundle);
	          } else {
	            var _err = 'loading namespace ' + n + ' for language ' + l + ' via multiloading failed';
	            _this5.loaded(name, _err);
	            _this5.logger.error(_err);
	          }
	        });
	      });
	    }
	
	    // load one by one
	    else {
	        (function () {
	          var readOne = function readOne(name) {
	            var _this6 = this;
	
	            var _name$split5 = name.split('|'),
	                _name$split6 = _slicedToArray(_name$split5, 2),
	                lng = _name$split6[0],
	                ns = _name$split6[1];
	
	            this.read(lng, ns, 'read', null, null, function (err, data) {
	              if (err) _this6.logger.warn('loading namespace ' + ns + ' for language ' + lng + ' failed', err);
	              if (!err && data) _this6.logger.log('loaded namespace ' + ns + ' for language ' + lng, data);
	
	              _this6.loaded(name, err, data);
	            });
	          };
	
	          ;
	
	          toLoad.toLoad.forEach(function (name) {
	            readOne.call(_this5, name);
	          });
	        })();
	      }
	  };
	
	  Connector.prototype.reload = function reload(languages, namespaces) {
	    var _this7 = this;
	
	    if (!this.backend) {
	      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
	    }
	    var options = _extends({}, this.backend.options, this.options.backend);
	
	    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
	    if (typeof namespaces === 'string') namespaces = [namespaces];
	
	    // load with multi-load
	    if (options.allowMultiLoading && this.backend.readMulti) {
	      this.read(languages, namespaces, 'readMulti', null, null, function (err, data) {
	        if (err) _this7.logger.warn('reloading namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading failed', err);
	        if (!err && data) _this7.logger.log('reloaded namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading', data);
	
	        languages.forEach(function (l) {
	          namespaces.forEach(function (n) {
	            var bundle = utils.getPath(data, [l, n]);
	            if (bundle) {
	              _this7.loaded(l + '|' + n, err, bundle);
	            } else {
	              var _err2 = 'reloading namespace ' + n + ' for language ' + l + ' via multiloading failed';
	              _this7.loaded(l + '|' + n, _err2);
	              _this7.logger.error(_err2);
	            }
	          });
	        });
	      });
	    }
	
	    // load one by one
	    else {
	        (function () {
	          var readOne = function readOne(name) {
	            var _this8 = this;
	
	            var _name$split7 = name.split('|'),
	                _name$split8 = _slicedToArray(_name$split7, 2),
	                lng = _name$split8[0],
	                ns = _name$split8[1];
	
	            this.read(lng, ns, 'read', null, null, function (err, data) {
	              if (err) _this8.logger.warn('reloading namespace ' + ns + ' for language ' + lng + ' failed', err);
	              if (!err && data) _this8.logger.log('reloaded namespace ' + ns + ' for language ' + lng, data);
	
	              _this8.loaded(name, err, data);
	            });
	          };
	
	          ;
	
	          languages.forEach(function (l) {
	            namespaces.forEach(function (n) {
	              readOne.call(_this7, l + '|' + n);
	            });
	          });
	        })();
	      }
	  };
	
	  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue) {
	    if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue);
	
	    // write to store to avoid resending
	    if (!languages || !languages[0]) return;
	    this.store.addResource(languages[0], namespace, key, fallbackValue);
	  };
	
	  return Connector;
	}(_EventEmitter3.default);
	
	exports.default = Connector;

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(108);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _logger = __webpack_require__(70);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(107);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Connector = function (_EventEmitter) {
	  _inherits(Connector, _EventEmitter);
	
	  function Connector(cache, store, services) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    _classCallCheck(this, Connector);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.cache = cache;
	    _this.store = store;
	    _this.services = services;
	    _this.options = options;
	    _this.logger = _logger2.default.create('cacheConnector');
	
	    _this.cache && _this.cache.init && _this.cache.init(services, options.cache, options);
	    return _this;
	  }
	
	  Connector.prototype.load = function load(languages, namespaces, callback) {
	    var _this2 = this;
	
	    if (!this.cache) return callback && callback();
	    var options = _extends({}, this.cache.options, this.options.cache);
	
	    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
	    if (typeof namespaces === 'string') namespaces = [namespaces];
	
	    if (options.enabled) {
	      this.cache.load(languages, function (err, data) {
	        if (err) _this2.logger.error('loading languages ' + languages.join(', ') + ' from cache failed', err);
	        if (data) {
	          for (var l in data) {
	            for (var n in data[l]) {
	              if (n === 'i18nStamp') continue;
	              var bundle = data[l][n];
	              if (bundle) _this2.store.addResourceBundle(l, n, bundle);
	            }
	          }
	        }
	        if (callback) callback();
	      });
	    } else {
	      if (callback) callback();
	    }
	  };
	
	  Connector.prototype.save = function save() {
	    if (this.cache && this.options.cache && this.options.cache.enabled) this.cache.save(this.store.data);
	  };
	
	  return Connector;
	}(_EventEmitter3.default);
	
	exports.default = Connector;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(108);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _logger = __webpack_require__(70);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Interpolator = function () {
	  function Interpolator() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Interpolator);
	
	    this.logger = _logger2.default.create('interpolator');
	
	    this.init(options, true);
	  }
	
	  Interpolator.prototype.init = function init() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var reset = arguments[1];
	
	    if (reset) {
	      this.options = options;
	      this.format = options.interpolation && options.interpolation.format || function (value) {
	        return value;
	      };
	      this.escape = options.interpolation && options.interpolation.escape || utils.escape;
	    }
	    if (!options.interpolation) options.interpolation = { escapeValue: true };
	
	    var iOpts = options.interpolation;
	
	    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
	
	    this.prefix = iOpts.prefix ? utils.regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
	    this.suffix = iOpts.suffix ? utils.regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
	
	    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
	
	    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
	    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
	
	    this.nestingPrefix = iOpts.nestingPrefix ? utils.regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || utils.regexEscape('$t(');
	    this.nestingSuffix = iOpts.nestingSuffix ? utils.regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || utils.regexEscape(')');
	
	    // the regexp
	    this.resetRegExp();
	  };
	
	  Interpolator.prototype.reset = function reset() {
	    if (this.options) this.init(this.options);
	  };
	
	  Interpolator.prototype.resetRegExp = function resetRegExp() {
	    // the regexp
	    var regexpStr = this.prefix + '(.+?)' + this.suffix;
	    this.regexp = new RegExp(regexpStr, 'g');
	
	    var regexpUnescapeStr = this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
	    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
	
	    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
	    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
	  };
	
	  Interpolator.prototype.interpolate = function interpolate(str, data, lng) {
	    var _this = this;
	
	    var match = void 0,
	        value = void 0;
	
	    function regexSafe(val) {
	      return val.replace(/\$/g, '$$$$');
	    }
	
	    var handleFormat = function handleFormat(key) {
	      if (key.indexOf(_this.formatSeparator) < 0) return utils.getPath(data, key);
	
	      var p = key.split(_this.formatSeparator);
	      var k = p.shift().trim();
	      var f = p.join(_this.formatSeparator).trim();
	
	      return _this.format(utils.getPath(data, k), f, lng);
	    };
	
	    this.resetRegExp();
	
	    // unescape if has unescapePrefix/Suffix
	    while (match = this.regexpUnescape.exec(str)) {
	      var _value = handleFormat(match[1].trim());
	      str = str.replace(match[0], _value);
	      this.regexpUnescape.lastIndex = 0;
	    }
	
	    // regular escape on demand
	    while (match = this.regexp.exec(str)) {
	      value = handleFormat(match[1].trim());
	      if (typeof value !== 'string') value = utils.makeString(value);
	      if (!value) {
	        this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
	        value = '';
	      }
	      value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
	      str = str.replace(match[0], value);
	      this.regexp.lastIndex = 0;
	    }
	    return str;
	  };
	
	  Interpolator.prototype.nest = function nest(str, fc) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var match = void 0,
	        value = void 0;
	
	    var clonedOptions = _extends({}, options);
	    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup
	
	    function regexSafe(val) {
	      return val.replace(/\$/g, '$$$$');
	    }
	
	    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
	    function handleHasOptions(key) {
	      if (key.indexOf(',') < 0) return key;
	
	      var p = key.split(',');
	      key = p.shift();
	      var optionsString = p.join(',');
	      optionsString = this.interpolate(optionsString, clonedOptions);
	      optionsString = optionsString.replace(/'/g, '"');
	
	      try {
	        clonedOptions = JSON.parse(optionsString);
	      } catch (e) {
	        this.logger.error('failed parsing options string in nesting for key ' + key, e);
	      }
	
	      return key;
	    }
	
	    // regular escape on demand
	    while (match = this.nestingRegexp.exec(str)) {
	      value = fc(handleHasOptions.call(this, match[1].trim()), clonedOptions);
	      if (typeof value !== 'string') value = utils.makeString(value);
	      if (!value) {
	        this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
	        value = '';
	      }
	      // Nested keys should not be escaped by default #854
	      // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
	      str = str.replace(match[0], value);
	      this.regexp.lastIndex = 0;
	    }
	    return str;
	  };
	
	  return Interpolator;
	}();
	
	exports.default = Interpolator;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _logger = __webpack_require__(70);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function capitalize(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	var LanguageUtil = function () {
	  function LanguageUtil(options) {
	    _classCallCheck(this, LanguageUtil);
	
	    this.options = options;
	
	    this.whitelist = this.options.whitelist || false;
	    this.logger = _logger2.default.create('languageUtils');
	  }
	
	  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
	    if (!code || code.indexOf('-') < 0) return null;
	
	    var p = code.split('-');
	    if (p.length === 2) return null;
	    p.pop();
	    return this.formatLanguageCode(p.join('-'));
	  };
	
	  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
	    if (!code || code.indexOf('-') < 0) return code;
	
	    var p = code.split('-');
	    return this.formatLanguageCode(p[0]);
	  };
	
	  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
	    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
	    if (typeof code === 'string' && code.indexOf('-') > -1) {
	      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
	      var p = code.split('-');
	
	      if (this.options.lowerCaseLng) {
	        p = p.map(function (part) {
	          return part.toLowerCase();
	        });
	      } else if (p.length === 2) {
	        p[0] = p[0].toLowerCase();
	        p[1] = p[1].toUpperCase();
	
	        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
	      } else if (p.length === 3) {
	        p[0] = p[0].toLowerCase();
	
	        // if lenght 2 guess it's a country
	        if (p[1].length === 2) p[1] = p[1].toUpperCase();
	        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
	
	        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
	        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
	      }
	
	      return p.join('-');
	    } else {
	      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
	    }
	  };
	
	  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code, exactMatch) {
	    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist && !exactMatch) {
	      code = this.getLanguagePartFromCode(code);
	    }
	    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1 ? true : false;
	  };
	
	  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
	    if (!fallbacks) return [];
	    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
	    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
	
	    if (!code) return fallbacks.default || [];
	
	    // asume we have an object defining fallbacks
	    var found = fallbacks[code];
	    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
	    if (!found) found = fallbacks[this.formatLanguageCode(code)];
	    if (!found) found = fallbacks.default;
	
	    return found || [];
	  };
	
	  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
	    var _this = this;
	
	    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
	
	    var codes = [];
	    var addCode = function addCode(code) {
	      var exactMatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!code) return;
	      if (_this.isWhitelisted(code, exactMatch)) {
	        codes.push(code);
	      } else {
	        _this.logger.warn('rejecting non-whitelisted language code: ' + code);
	      }
	    };
	
	    if (typeof code === 'string' && code.indexOf('-') > -1) {
	      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code), true);
	      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code), true);
	      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
	    } else if (typeof code === 'string') {
	      addCode(this.formatLanguageCode(code));
	    }
	
	    fallbackCodes.forEach(function (fc) {
	      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
	    });
	
	    return codes;
	  };
	
	  return LanguageUtil;
	}();
	
	;
	
	exports.default = LanguageUtil;

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _logger = __webpack_require__(70);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
	/* eslint-disable */
	var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'es_ar', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt', 'pt_br', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];
	
	var _rulesPluralsTypes = {
	  1: function _(n) {
	    return Number(n > 1);
	  },
	  2: function _(n) {
	    return Number(n != 1);
	  },
	  3: function _(n) {
	    return 0;
	  },
	  4: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  5: function _(n) {
	    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
	  },
	  6: function _(n) {
	    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
	  },
	  7: function _(n) {
	    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  8: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
	  },
	  9: function _(n) {
	    return Number(n >= 2);
	  },
	  10: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
	  },
	  11: function _(n) {
	    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
	  },
	  12: function _(n) {
	    return Number(n % 10 != 1 || n % 100 == 11);
	  },
	  13: function _(n) {
	    return Number(n !== 0);
	  },
	  14: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
	  },
	  15: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  16: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
	  },
	  17: function _(n) {
	    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
	  },
	  18: function _(n) {
	    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
	  },
	  19: function _(n) {
	    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
	  },
	  20: function _(n) {
	    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
	  },
	  21: function _(n) {
	    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
	  }
	};
	/* eslint-enable */
	
	function createRules() {
	  var l,
	      rules = {};
	  sets.forEach(function (set) {
	    set.lngs.forEach(function (l) {
	      return rules[l] = {
	        numbers: set.nr,
	        plurals: _rulesPluralsTypes[set.fc]
	      };
	    });
	  });
	  return rules;
	}
	
	var PluralResolver = function () {
	  function PluralResolver(languageUtils) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, PluralResolver);
	
	    this.languageUtils = languageUtils;
	    this.options = options;
	
	    this.logger = _logger2.default.create('pluralResolver');
	
	    this.rules = createRules();
	  }
	
	  PluralResolver.prototype.addRule = function addRule(lng, obj) {
	    this.rules[lng] = obj;
	  };
	
	  PluralResolver.prototype.getRule = function getRule(code) {
	    return this.rules[this.languageUtils.getLanguagePartFromCode(code)];
	  };
	
	  PluralResolver.prototype.needsPlural = function needsPlural(code) {
	    var rule = this.getRule(code);
	
	    return rule && rule.numbers.length <= 1 ? false : true;
	  };
	
	  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
	    var _this = this;
	
	    var rule = this.getRule(code);
	
	    if (rule) {
	      var _ret = function () {
	        if (rule.numbers.length === 1) return {
	            v: ''
	          }; // only singular
	
	        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
	        var suffix = rule.numbers[idx];
	
	        // special treatment for lngs only having singular and plural
	        if (_this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
	          if (suffix === 2) {
	            suffix = 'plural';
	          } else if (suffix === 1) {
	            suffix = '';
	          }
	        }
	
	        var returnSuffix = function returnSuffix() {
	          return _this.options.prepend && suffix.toString() ? _this.options.prepend + suffix.toString() : suffix.toString();
	        };
	
	        // COMPATIBILITY JSON
	        // v1
	        if (_this.options.compatibilityJSON === 'v1') {
	          if (suffix === 1) return {
	              v: ''
	            };
	          if (typeof suffix === 'number') return {
	              v: '_plural_' + suffix.toString()
	            };
	          return {
	            v: returnSuffix()
	          };
	        }
	        // v2
	        else if (_this.options.compatibilityJSON === 'v2' || rule.numbers.length === 2 && rule.numbers[0] === 1) {
	            return {
	              v: returnSuffix()
	            };
	          }
	          // v3 - gettext index
	          else if (rule.numbers.length === 2 && rule.numbers[0] === 1) {
	              return {
	                v: returnSuffix()
	              };
	            }
	        return {
	          v: _this.options.prepend && idx.toString() ? _this.options.prepend + idx.toString() : idx.toString()
	        };
	      }();
	
	      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	    } else {
	      this.logger.warn('no plural rule found for: ' + code);
	      return '';
	    }
	  };
	
	  return PluralResolver;
	}();
	
	;
	
	exports.default = PluralResolver;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _EventEmitter2 = __webpack_require__(107);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	var _utils = __webpack_require__(108);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var ResourceStore = function (_EventEmitter) {
	  _inherits(ResourceStore, _EventEmitter);
	
	  function ResourceStore() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };
	
	    _classCallCheck(this, ResourceStore);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.data = data;
	    _this.options = options;
	    return _this;
	  }
	
	  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
	    if (this.options.ns.indexOf(ns) < 0) {
	      this.options.ns.push(ns);
	    }
	  };
	
	  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
	    var index = this.options.ns.indexOf(ns);
	    if (index > -1) {
	      this.options.ns.splice(index, 1);
	    }
	  };
	
	  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    var keySeparator = options.keySeparator || this.options.keySeparator;
	    if (keySeparator === undefined) keySeparator = '.';
	
	    var path = [lng, ns];
	    if (key && typeof key !== 'string') path = path.concat(key);
	    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
	
	    if (lng.indexOf('.') > -1) {
	      path = lng.split('.');
	    }
	
	    return utils.getPath(this.data, path);
	  };
	
	  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
	    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };
	
	    var keySeparator = this.options.keySeparator;
	    if (keySeparator === undefined) keySeparator = '.';
	
	    var path = [lng, ns];
	    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
	
	    if (lng.indexOf('.') > -1) {
	      path = lng.split('.');
	      value = ns;
	      ns = path[1];
	    }
	
	    this.addNamespaces(ns);
	
	    utils.setPath(this.data, path, value);
	
	    if (!options.silent) this.emit('added', lng, ns, key, value);
	  };
	
	  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
	    for (var m in resources) {
	      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
	    }
	    this.emit('added', lng, ns, resources);
	  };
	
	  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
	    var path = [lng, ns];
	    if (lng.indexOf('.') > -1) {
	      path = lng.split('.');
	      deep = resources;
	      resources = ns;
	      ns = path[1];
	    }
	
	    this.addNamespaces(ns);
	
	    var pack = utils.getPath(this.data, path) || {};
	
	    if (deep) {
	      utils.deepExtend(pack, resources, overwrite);
	    } else {
	      pack = _extends({}, pack, resources);
	    }
	
	    utils.setPath(this.data, path, pack);
	
	    this.emit('added', lng, ns, resources);
	  };
	
	  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
	    if (this.hasResourceBundle(lng, ns)) {
	      delete this.data[lng][ns];
	    }
	    this.removeNamespaces(ns);
	
	    this.emit('removed', lng, ns);
	  };
	
	  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
	    return this.getResource(lng, ns) !== undefined;
	  };
	
	  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
	    if (!ns) ns = this.options.defaultNS;
	
	    // TODO: COMPATIBILITY remove extend in v2.1.0
	    if (this.options.compatibilityAPI === 'v1') return _extends({}, this.getResource(lng, ns));
	
	    return this.getResource(lng, ns);
	  };
	
	  ResourceStore.prototype.toJSON = function toJSON() {
	    return this.data;
	  };
	
	  return ResourceStore;
	}(_EventEmitter3.default);
	
	exports.default = ResourceStore;

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _logger = __webpack_require__(70);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(107);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	var _postProcessor = __webpack_require__(283);
	
	var _postProcessor2 = _interopRequireDefault(_postProcessor);
	
	var _v = __webpack_require__(282);
	
	var compat = _interopRequireWildcard(_v);
	
	var _utils = __webpack_require__(108);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Translator = function (_EventEmitter) {
	  _inherits(Translator, _EventEmitter);
	
	  function Translator(services) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Translator);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    utils.copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector'], services, _this);
	
	    _this.options = options;
	    _this.logger = _logger2.default.create('translator');
	    return _this;
	  }
	
	  Translator.prototype.changeLanguage = function changeLanguage(lng) {
	    if (lng) this.language = lng;
	  };
	
	  Translator.prototype.exists = function exists(key) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };
	
	    if (this.options.compatibilityAPI === 'v1') {
	      options = compat.convertTOptions(options);
	    }
	
	    return this.resolve(key, options) !== undefined;
	  };
	
	  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
	    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
	    if (nsSeparator === undefined) nsSeparator = ':';
	    var keySeparator = options.keySeparator || this.options.keySeparator || '.';
	
	    var namespaces = options.ns || this.options.defaultNS;
	    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
	      var parts = key.split(nsSeparator);
	      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
	      key = parts.join(keySeparator);
	    }
	    if (typeof namespaces === 'string') namespaces = [namespaces];
	
	    return {
	      key: key,
	      namespaces: namespaces
	    };
	  };
	
	  Translator.prototype.translate = function translate(keys) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
	      options = this.options.overloadTranslationOptionHandler(arguments);
	    } else if (this.options.compatibilityAPI === 'v1') {
	      options = compat.convertTOptions(options);
	    }
	
	    // non valid keys handling
	    if (keys === undefined || keys === null || keys === '') return '';
	    if (typeof keys === 'number') keys = String(keys);
	    if (typeof keys === 'string') keys = [keys];
	
	    // separators
	    var keySeparator = options.keySeparator || this.options.keySeparator || '.';
	
	    // get namespace(s)
	
	    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
	        key = _extractFromKey.key,
	        namespaces = _extractFromKey.namespaces;
	
	    var namespace = namespaces[namespaces.length - 1];
	
	    // return key on CIMode
	    var lng = options.lng || this.language;
	    var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
	    if (lng && lng.toLowerCase() === 'cimode') {
	      if (appendNamespaceToCIMode) {
	        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
	        return namespace + nsSeparator + key;
	      }
	
	      return key;
	    }
	
	    // resolve from store
	    var res = this.resolve(keys, options);
	
	    var resType = Object.prototype.toString.apply(res);
	    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
	    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
	
	    // object
	    if (res && typeof res !== 'string' && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
	      if (!options.returnObjects && !this.options.returnObjects) {
	        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
	        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(key, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
	      }
	
	      // if we got a separator we loop over children - else we just return object as is
	      // as having it set to false means no hierarchy so no lookup for nested values
	      if (options.keySeparator || this.options.keySeparator) {
	        var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy
	
	        for (var m in res) {
	          if (res.hasOwnProperty(m)) {
	            copy[m] = this.translate('' + key + keySeparator + m, _extends({}, options, { joinArrays: false, ns: namespaces }));
	          }
	        }
	        res = copy;
	      }
	    }
	    // array special treatment
	    else if (joinArrays && resType === '[object Array]') {
	        res = res.join(joinArrays);
	        if (res) res = this.extendTranslation(res, key, options);
	      }
	      // string, empty or null
	      else {
	          var usedDefault = false,
	              usedKey = false;
	
	          // fallback value
	          if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
	            usedDefault = true;
	            res = options.defaultValue;
	          }
	          if (!this.isValidLookup(res)) {
	            usedKey = true;
	            res = key;
	          }
	
	          // save missing
	          if (usedKey || usedDefault) {
	            this.logger.log('missingKey', lng, namespace, key, res);
	
	            var lngs = [];
	            var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
	            if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
	              for (var i = 0; i < fallbackLngs.length; i++) {
	                lngs.push(fallbackLngs[i]);
	              }
	            } else if (this.options.saveMissingTo === 'all') {
	              lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
	            } else {
	              //(this.options.saveMissingTo === 'current' || (this.options.saveMissingTo === 'fallback' && this.options.fallbackLng[0] === false) ) {
	              lngs.push(options.lng || this.language);
	            }
	
	            if (this.options.saveMissing) {
	              if (this.options.missingKeyHandler) {
	                this.options.missingKeyHandler(lngs, namespace, key, res);
	              } else if (this.backendConnector && this.backendConnector.saveMissing) {
	                this.backendConnector.saveMissing(lngs, namespace, key, res);
	              }
	            }
	
	            this.emit('missingKey', lngs, namespace, key, res);
	          }
	
	          // extend
	          res = this.extendTranslation(res, key, options);
	
	          // append namespace if still key
	          if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;
	
	          // parseMissingKeyHandler
	          if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
	        }
	
	    // return
	    return res;
	  };
	
	  Translator.prototype.extendTranslation = function extendTranslation(res, key, options) {
	    var _this2 = this;
	
	    if (options.interpolation) this.interpolator.init(_extends({}, options, { interpolation: _extends({}, this.options.interpolation, options.interpolation) }));
	
	    // interpolate
	    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
	    if (this.options.interpolation.defaultVariables) data = _extends({}, this.options.interpolation.defaultVariables, data);
	    res = this.interpolator.interpolate(res, data, this.language);
	
	    // nesting
	    res = this.interpolator.nest(res, function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _this2.translate.apply(_this2, args);
	    }, options);
	
	    if (options.interpolation) this.interpolator.reset();
	
	    // post process
	    var postProcess = options.postProcess || this.options.postProcess;
	    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
	
	    if (res !== undefined && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
	      res = _postProcessor2.default.handle(postProcessorNames, res, key, options, this);
	    }
	
	    return res;
	  };
	
	  Translator.prototype.resolve = function resolve(keys) {
	    var _this3 = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var found = void 0;
	
	    if (typeof keys === 'string') keys = [keys];
	
	    // forEach possible key
	    keys.forEach(function (k) {
	      if (_this3.isValidLookup(found)) return;
	
	      var _extractFromKey2 = _this3.extractFromKey(k, options),
	          key = _extractFromKey2.key,
	          namespaces = _extractFromKey2.namespaces;
	
	      if (_this3.options.fallbackNS) namespaces = namespaces.concat(_this3.options.fallbackNS);
	
	      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
	      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
	
	      var codes = options.lngs ? options.lngs : _this3.languageUtils.toResolveHierarchy(options.lng || _this3.language);
	
	      namespaces.forEach(function (ns) {
	        if (_this3.isValidLookup(found)) return;
	
	        codes.forEach(function (code) {
	          if (_this3.isValidLookup(found)) return;
	
	          var finalKey = key;
	          var finalKeys = [finalKey];
	
	          var pluralSuffix = void 0;
	          if (needsPluralHandling) pluralSuffix = _this3.pluralResolver.getSuffix(code, options.count);
	
	          // fallback for plural if context not found
	          if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
	
	          // get key for context if needed
	          if (needsContextHandling) finalKeys.push(finalKey += '' + _this3.options.contextSeparator + options.context);
	
	          // get key for plural if needed
	          if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
	
	          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
	          var possibleKey = void 0;
	          while (possibleKey = finalKeys.pop()) {
	            if (_this3.isValidLookup(found)) continue;
	            found = _this3.getResource(code, ns, possibleKey, options);
	          }
	        });
	      });
	    });
	
	    return found;
	  };
	
	  Translator.prototype.isValidLookup = function isValidLookup(res) {
	    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
	  };
	
	  Translator.prototype.getResource = function getResource(code, ns, key) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    return this.resourceStore.getResource(code, ns, key, options);
	  };
	
	  return Translator;
	}(_EventEmitter3.default);
	
	exports.default = Translator;

/***/ },
/* 671 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.get = get;
	exports.transformOptions = transformOptions;
	function get() {
	  return {
	    debug: false,
	    initImmediate: true,
	
	    ns: ['translation'],
	    defaultNS: ['translation'],
	    fallbackLng: ['dev'],
	    fallbackNS: false, // string or array of namespaces
	
	    whitelist: false, // array with whitelisted languages
	    nonExplicitWhitelist: false,
	    load: 'all', // | currentOnly | languageOnly
	    preload: false, // array with preload languages
	
	    simplifyPluralSuffix: true,
	    keySeparator: '.',
	    nsSeparator: ':',
	    pluralSeparator: '_',
	    contextSeparator: '_',
	
	    saveMissing: false, // enable to send missing values
	    saveMissingTo: 'fallback', // 'current' || 'all'
	    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling
	
	    postProcess: false, // string or array of postProcessor names
	    returnNull: true, // allows null value as valid translation
	    returnEmptyString: true, // allows empty string value as valid translation
	    returnObjects: false,
	    joinArrays: false, // or string to join array
	    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
	    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
	    appendNamespaceToMissingKey: false,
	    appendNamespaceToCIMode: false,
	    overloadTranslationOptionHandler: function overloadTranslationOptionHandler(args) {
	      return { defaultValue: args[1] };
	    },
	
	    interpolation: {
	      escapeValue: true,
	      format: function format(value, _format, lng) {
	        return value;
	      },
	      prefix: '{{',
	      suffix: '}}',
	      formatSeparator: ',',
	      // prefixEscaped: '{{',
	      // suffixEscaped: '}}',
	      // unescapeSuffix: '',
	      unescapePrefix: '-',
	
	      nestingPrefix: '$t(',
	      nestingSuffix: ')',
	      // nestingPrefixEscaped: '$t(',
	      // nestingSuffixEscaped: ')',
	      defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
	    }
	  };
	}
	
	function transformOptions(options) {
	  // create namespace object if namespace is passed in as string
	  if (typeof options.ns === 'string') options.ns = [options.ns];
	  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
	  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
	
	  // extend whitelist with cimode
	  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) options.whitelist.push('cimode');
	
	  return options;
	}

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _logger = __webpack_require__(70);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(107);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	var _ResourceStore = __webpack_require__(669);
	
	var _ResourceStore2 = _interopRequireDefault(_ResourceStore);
	
	var _Translator = __webpack_require__(670);
	
	var _Translator2 = _interopRequireDefault(_Translator);
	
	var _LanguageUtils = __webpack_require__(667);
	
	var _LanguageUtils2 = _interopRequireDefault(_LanguageUtils);
	
	var _PluralResolver = __webpack_require__(668);
	
	var _PluralResolver2 = _interopRequireDefault(_PluralResolver);
	
	var _Interpolator = __webpack_require__(666);
	
	var _Interpolator2 = _interopRequireDefault(_Interpolator);
	
	var _BackendConnector = __webpack_require__(664);
	
	var _BackendConnector2 = _interopRequireDefault(_BackendConnector);
	
	var _CacheConnector = __webpack_require__(665);
	
	var _CacheConnector2 = _interopRequireDefault(_CacheConnector);
	
	var _defaults2 = __webpack_require__(671);
	
	var _postProcessor = __webpack_require__(283);
	
	var _postProcessor2 = _interopRequireDefault(_postProcessor);
	
	var _v = __webpack_require__(282);
	
	var compat = _interopRequireWildcard(_v);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	function noop() {};
	
	var I18n = function (_EventEmitter) {
	  _inherits(I18n, _EventEmitter);
	
	  function I18n() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments[1];
	
	    _classCallCheck(this, I18n);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.options = (0, _defaults2.transformOptions)(options);
	    _this.services = {};
	    _this.logger = _logger2.default;
	    _this.modules = { external: [] };
	
	    if (callback && !_this.isInitialized && !options.isClone) {
	      var _ret;
	
	      // https://github.com/i18next/i18next/issues/879
	      if (!_this.options.initImmediate) return _ret = _this.init(options, callback), _possibleConstructorReturn(_this, _ret);
	      setTimeout(function () {
	        _this.init(options, callback);
	      }, 0);
	    }
	    return _this;
	  }
	
	  I18n.prototype.init = function init(options, callback) {
	    var _this2 = this;
	
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    if (!options) options = {};
	
	    if (options.compatibilityAPI === 'v1') {
	      this.options = _extends({}, (0, _defaults2.get)(), (0, _defaults2.transformOptions)(compat.convertAPIOptions(options)), {});
	    } else if (options.compatibilityJSON === 'v1') {
	      this.options = _extends({}, (0, _defaults2.get)(), (0, _defaults2.transformOptions)(compat.convertJSONOptions(options)), {});
	    } else {
	      this.options = _extends({}, (0, _defaults2.get)(), this.options, (0, _defaults2.transformOptions)(options));
	    }
	    if (!callback) callback = noop;
	
	    function createClassOnDemand(ClassOrObject) {
	      if (!ClassOrObject) return;
	      if (typeof ClassOrObject === 'function') return new ClassOrObject();
	      return ClassOrObject;
	    }
	
	    // init services
	    if (!this.options.isClone) {
	      if (this.modules.logger) {
	        _logger2.default.init(createClassOnDemand(this.modules.logger), this.options);
	      } else {
	        _logger2.default.init(null, this.options);
	      }
	
	      var lu = new _LanguageUtils2.default(this.options);
	      this.store = new _ResourceStore2.default(this.options.resources, this.options);
	
	      var s = this.services;
	      s.logger = _logger2.default;
	      s.resourceStore = this.store;
	      s.resourceStore.on('added removed', function (lng, ns) {
	        s.cacheConnector.save();
	      });
	      s.languageUtils = lu;
	      s.pluralResolver = new _PluralResolver2.default(lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON, simplifyPluralSuffix: this.options.simplifyPluralSuffix });
	      s.interpolator = new _Interpolator2.default(this.options);
	
	      s.backendConnector = new _BackendConnector2.default(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
	      // pipe events from backendConnector
	      s.backendConnector.on('*', function (event) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        _this2.emit.apply(_this2, [event].concat(args));
	      });
	
	      s.backendConnector.on('loaded', function (loaded) {
	        s.cacheConnector.save();
	      });
	
	      s.cacheConnector = new _CacheConnector2.default(createClassOnDemand(this.modules.cache), s.resourceStore, s, this.options);
	      // pipe events from backendConnector
	      s.cacheConnector.on('*', function (event) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	          args[_key2 - 1] = arguments[_key2];
	        }
	
	        _this2.emit.apply(_this2, [event].concat(args));
	      });
	
	      if (this.modules.languageDetector) {
	        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
	        s.languageDetector.init(s, this.options.detection, this.options);
	      }
	
	      this.translator = new _Translator2.default(this.services, this.options);
	      // pipe events from translator
	      this.translator.on('*', function (event) {
	        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	          args[_key3 - 1] = arguments[_key3];
	        }
	
	        _this2.emit.apply(_this2, [event].concat(args));
	      });
	
	      this.modules.external.forEach(function (m) {
	        if (m.init) m.init(_this2);
	      });
	    }
	
	    // append api
	    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle'];
	    storeApi.forEach(function (fcName) {
	      _this2[fcName] = function () {
	        return this.store[fcName].apply(this.store, arguments);
	      };
	    });
	
	    // TODO: COMPATIBILITY remove this
	    if (this.options.compatibilityAPI === 'v1') compat.appendBackwardsAPI(this);
	
	    var load = function load() {
	      _this2.changeLanguage(_this2.options.lng, function (err, t) {
	        _this2.isInitialized = true;
	        _this2.logger.log('initialized', _this2.options);
	        _this2.emit('initialized', _this2.options);
	
	        callback(err, t);
	      });
	    };
	
	    if (this.options.resources || !this.options.initImmediate) {
	      load();
	    } else {
	      setTimeout(load, 0);
	    }
	
	    return this;
	  };
	
	  I18n.prototype.loadResources = function loadResources() {
	    var _this3 = this;
	
	    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	
	    if (!this.options.resources) {
	      var _ret2 = function () {
	        if (_this3.language && _this3.language.toLowerCase() === 'cimode') return {
	            v: callback()
	          }; // avoid loading resources for cimode
	
	        var toLoad = [];
	
	        var append = function append(lng) {
	          if (!lng) return;
	          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
	          lngs.forEach(function (l) {
	            if (toLoad.indexOf(l) < 0) toLoad.push(l);
	          });
	        };
	
	        if (!_this3.language) {
	          // at least load fallbacks in this case
	          var fallbacks = _this3.services.languageUtils.getFallbackCodes(_this3.options.fallbackLng);
	          fallbacks.forEach(function (l) {
	            return append(l);
	          });
	        } else {
	          append(_this3.language);
	        }
	
	        if (_this3.options.preload) {
	          _this3.options.preload.forEach(function (l) {
	            return append(l);
	          });
	        }
	
	        _this3.services.cacheConnector.load(toLoad, _this3.options.ns, function () {
	          _this3.services.backendConnector.load(toLoad, _this3.options.ns, callback);
	        });
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    } else {
	      callback(null);
	    }
	  };
	
	  I18n.prototype.reloadResources = function reloadResources(lngs, ns) {
	    if (!lngs) lngs = this.languages;
	    if (!ns) ns = this.options.ns;
	    this.services.backendConnector.reload(lngs, ns);
	  };
	
	  I18n.prototype.use = function use(module) {
	    if (module.type === 'backend') {
	      this.modules.backend = module;
	    }
	
	    if (module.type === 'cache') {
	      this.modules.cache = module;
	    }
	
	    if (module.type === 'logger' || module.log && module.warn && module.error) {
	      this.modules.logger = module;
	    }
	
	    if (module.type === 'languageDetector') {
	      this.modules.languageDetector = module;
	    }
	
	    if (module.type === 'postProcessor') {
	      _postProcessor2.default.addPostProcessor(module);
	    }
	
	    if (module.type === '3rdParty') {
	      this.modules.external.push(module);
	    }
	
	    return this;
	  };
	
	  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
	    var _this4 = this;
	
	    var done = function done(err) {
	      if (lng) {
	        _this4.emit('languageChanged', lng);
	        _this4.logger.log('languageChanged', lng);
	      }
	
	      if (callback) callback(err, function () {
	        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	          args[_key4] = arguments[_key4];
	        }
	
	        return _this4.t.apply(_this4, args);
	      });
	    };
	
	    if (!lng && this.services.languageDetector) lng = this.services.languageDetector.detect();
	
	    if (lng) {
	      this.language = lng;
	      this.languages = this.services.languageUtils.toResolveHierarchy(lng);
	
	      this.translator.changeLanguage(lng);
	
	      if (this.services.languageDetector) this.services.languageDetector.cacheUserLanguage(lng);
	    }
	
	    this.loadResources(function (err) {
	      done(err);
	    });
	  };
	
	  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
	    var _this5 = this;
	
	    var fixedT = function fixedT(key) {
	      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var options = _extends({}, opts);
	      options.lng = options.lng || fixedT.lng;
	      options.ns = options.ns || fixedT.ns;
	      return _this5.t(key, options);
	    };
	    fixedT.lng = lng;
	    fixedT.ns = ns;
	    return fixedT;
	  };
	
	  I18n.prototype.t = function t() {
	    return this.translator && this.translator.translate.apply(this.translator, arguments);
	  };
	
	  I18n.prototype.exists = function exists() {
	    return this.translator && this.translator.exists.apply(this.translator, arguments);
	  };
	
	  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
	    this.options.defaultNS = ns;
	  };
	
	  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
	    var _this6 = this;
	
	    if (!this.options.ns) return callback && callback();
	    if (typeof ns === 'string') ns = [ns];
	
	    ns.forEach(function (n) {
	      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
	    });
	
	    this.loadResources(callback);
	  };
	
	  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
	    if (typeof lngs === 'string') lngs = [lngs];
	    var preloaded = this.options.preload || [];
	
	    var newLngs = lngs.filter(function (lng) {
	      return preloaded.indexOf(lng) < 0;
	    });
	    // Exit early if all given languages are already preloaded
	    if (!newLngs.length) return callback();
	
	    this.options.preload = preloaded.concat(newLngs);
	    this.loadResources(callback);
	  };
	
	  I18n.prototype.dir = function dir(lng) {
	    if (!lng) lng = this.language;
	    if (!lng) return 'rtl';
	
	    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
	
	    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
	  };
	
	  I18n.prototype.createInstance = function createInstance() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments[1];
	
	    return new I18n(options, callback);
	  };
	
	  I18n.prototype.cloneInstance = function cloneInstance() {
	    var _this7 = this;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	
	    var mergedOptions = _extends({}, options, this.options, { isClone: true });
	    var clone = new I18n(mergedOptions, callback);
	    var membersToCopy = ['store', 'services', 'language'];
	    membersToCopy.forEach(function (m) {
	      clone[m] = _this7[m];
	    });
	    clone.translator = new _Translator2.default(clone.services, clone.options);
	    clone.translator.on('*', function (event) {
	      for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	        args[_key5 - 1] = arguments[_key5];
	      }
	
	      clone.emit.apply(clone, [event].concat(args));
	    });
	    clone.init(mergedOptions, callback);
	
	    return clone;
	  };
	
	  return I18n;
	}(_EventEmitter3.default);
	
	exports.default = new I18n();

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.use = exports.t = exports.setDefaultNamespace = exports.on = exports.off = exports.loadResources = exports.loadNamespaces = exports.loadLanguages = exports.init = exports.getFixedT = exports.exists = exports.dir = exports.createInstance = exports.cloneInstance = exports.changeLanguage = undefined;
	
	var _i18next = __webpack_require__(672);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _i18next2.default;
	var changeLanguage = exports.changeLanguage = _i18next2.default.changeLanguage.bind(_i18next2.default);
	var cloneInstance = exports.cloneInstance = _i18next2.default.cloneInstance.bind(_i18next2.default);
	var createInstance = exports.createInstance = _i18next2.default.createInstance.bind(_i18next2.default);
	var dir = exports.dir = _i18next2.default.dir.bind(_i18next2.default);
	var exists = exports.exists = _i18next2.default.exists.bind(_i18next2.default);
	var getFixedT = exports.getFixedT = _i18next2.default.getFixedT.bind(_i18next2.default);
	var init = exports.init = _i18next2.default.init.bind(_i18next2.default);
	var loadLanguages = exports.loadLanguages = _i18next2.default.loadLanguages.bind(_i18next2.default);
	var loadNamespaces = exports.loadNamespaces = _i18next2.default.loadNamespaces.bind(_i18next2.default);
	var loadResources = exports.loadResources = _i18next2.default.loadResources.bind(_i18next2.default);
	var off = exports.off = _i18next2.default.off.bind(_i18next2.default);
	var on = exports.on = _i18next2.default.on.bind(_i18next2.default);
	var setDefaultNamespace = exports.setDefaultNamespace = _i18next2.default.setDefaultNamespace.bind(_i18next2.default);
	var t = exports.t = _i18next2.default.t.bind(_i18next2.default);
	var use = exports.use = _i18next2.default.use.bind(_i18next2.default);

/***/ },
/* 674 */
[1178, 673],
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _joinPrefixedValue = __webpack_require__(141);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(195);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return (0, _joinPrefixedValue2.default)(property, value, function (prefix, value) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	
	var _joinPrefixedValue = __webpack_require__(141);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 677 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = { flex: true, 'inline-flex': true };
	
	function flex(property, value) {
	  if (property === 'display' && values[value]) {
	    return {
	      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 678 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(property, value) {
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 679 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    return {
	      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	    };
	  }
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _joinPrefixedValue = __webpack_require__(141);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(195);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.match(values) !== null) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 681 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return { position: ['-webkit-sticky', 'sticky'] };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _joinPrefixedValue = __webpack_require__(141);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties[property] && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(659);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _capitalizeString = __webpack_require__(285);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _isPrefixedValue = __webpack_require__(195);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _prefixProps = __webpack_require__(284);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true
	};
	
	function transition(property, value) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties[property]) {
	    var _ref2;
	
	    var outputValue = prefixValue(value);
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (value) {
	      return value.match(/-moz-|-ms-/) === null;
	    }).join(',');
	
	    // if the property is already prefixed
	    if (property.indexOf('Webkit') > -1) {
	      return _defineProperty({}, property, webkitOutput);
	    }
	
	    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _capitalizeString2.default)(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
	  }
	}
	
	function prefixValue(value) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  // iterate each single value and check for transitioned properties
	  // that need to be prefixed as well
	  multipleValues.forEach(function (val, index) {
	    multipleValues[index] = Object.keys(_prefixProps2.default).reduce(function (out, prefix) {
	      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';
	
	      Object.keys(_prefixProps2.default[prefix]).forEach(function (prop) {
	        var dashCaseProperty = (0, _hyphenateStyleName2.default)(prop);
	
	        if (val.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	          // join all prefixes and create a new value
	          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
	        }
	      });
	      return out;
	    }, val);
	  });
	
	  return multipleValues.join(',');
	}
	module.exports = exports['default'];

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixAll;
	
	var _prefixProps = __webpack_require__(284);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _capitalizeString = __webpack_require__(285);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = __webpack_require__(686);
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _position = __webpack_require__(681);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = __webpack_require__(675);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _cursor = __webpack_require__(676);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _flex = __webpack_require__(677);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(682);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(680);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(683);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(678);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(679);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// special flexbox specifications
	
	
	var plugins = [_position2.default, _calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];
	
	/**
	 * Returns a prefixed version of the style object using all vendor prefixes
	 * @param {Object} styles - Style object that gets prefixed properties added
	 * @returns {Object} - Style object with prefixed properties and values
	 */
	function prefixAll(styles) {
	  Object.keys(styles).forEach(function (property) {
	    var value = styles[property];
	    if (value instanceof Object && !Array.isArray(value)) {
	      // recurse through nested style objects
	      styles[property] = prefixAll(value);
	    } else {
	      Object.keys(_prefixProps2.default).forEach(function (prefix) {
	        var properties = _prefixProps2.default[prefix];
	        // add prefixes if needed
	        if (properties[property]) {
	          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
	        }
	      });
	    }
	  });
	
	  Object.keys(styles).forEach(function (property) {
	    [].concat(styles[property]).forEach(function (value, index) {
	      // resolve every special plugins
	      plugins.forEach(function (plugin) {
	        return assignStyles(styles, plugin(property, value));
	      });
	    });
	  });
	
	  return (0, _sortPrefixedStyle2.default)(styles);
	}
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (value) {
	        var valueIndex = baseValue.indexOf(value);
	        if (valueIndex > -1) {
	          base[property].splice(valueIndex, 1);
	        }
	        base[property].push(value);
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ },
/* 685 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
	};
	
	module.exports = exports["default"];

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sortPrefixedStyle;
	
	var _isPrefixedProperty = __webpack_require__(685);
	
	var _isPrefixedProperty2 = _interopRequireDefault(_isPrefixedProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sortPrefixedStyle(style) {
	  return Object.keys(style).sort(function (left, right) {
	    if ((0, _isPrefixedProperty2.default)(left) && !(0, _isPrefixedProperty2.default)(right)) {
	      return -1;
	    } else if (!(0, _isPrefixedProperty2.default)(left) && (0, _isPrefixedProperty2.default)(right)) {
	      return 1;
	    }
	    return 0;
	  }).reduce(function (sortedStyle, prop) {
	    sortedStyle[prop] = style[prop];
	    return sortedStyle;
	  }, {});
	}
	module.exports = exports['default'];

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(684)


/***/ },
/* 688 */
/***/ function(module, exports) {

	module.exports = isFunction
	
	var toString = Object.prototype.toString
	
	function isFunction (fn) {
	  var string = toString.call(fn)
	  return string === '[object Function]' ||
	    (typeof fn === 'function' && string !== '[object RegExp]') ||
	    (typeof window !== 'undefined' &&
	     // IE8 and below
	     (fn === window.setTimeout ||
	      fn === window.alert ||
	      fn === window.confirm ||
	      fn === window.prompt))
	};


/***/ },
/* 689 */
/***/ function(module, exports) {

	module.exports = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ },
/* 690 */
/***/ function(module, exports) {

	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};


/***/ },
/* 691 */
/***/ function(module, exports) {

	/**
	 * The code was extracted from:
	 * https://github.com/davidchambers/Base64.js
	 */
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function InvalidCharacterError(message) {
	  this.message = message;
	}
	
	InvalidCharacterError.prototype = new Error();
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
	function polyfill (input) {
	  var str = String(input).replace(/=+$/, '');
	  if (str.length % 4 == 1) {
	    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
	  }
	  for (
	    // initialize result and counters
	    var bc = 0, bs, buffer, idx = 0, output = '';
	    // get next character
	    buffer = str.charAt(idx++);
	    // character found in table? initialize bit storage and add its ascii value;
	    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
	      // and if not first of each 4 characters,
	      // convert the first 8 bits to one ascii character
	      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
	  ) {
	    // try to find character in table (0-63, not found => -1)
	    buffer = chars.indexOf(buffer);
	  }
	  return output;
	}
	
	
	module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	var atob = __webpack_require__(691);
	
	function b64DecodeUnicode(str) {
	  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
	    var code = p.charCodeAt(0).toString(16).toUpperCase();
	    if (code.length < 2) {
	      code = '0' + code;
	    }
	    return '%' + code;
	  }));
	}
	
	module.exports = function(str) {
	  var output = str.replace(/-/g, "+").replace(/_/g, "/");
	  switch (output.length % 4) {
	    case 0:
	      break;
	    case 2:
	      output += "==";
	      break;
	    case 3:
	      output += "=";
	      break;
	    default:
	      throw "Illegal base64url string!";
	  }
	
	  try{
	    return b64DecodeUnicode(output);
	  } catch (err) {
	    return atob(output);
	  }
	};


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = is_valid;
	
	var _parse = __webpack_require__(109);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	var _metadata = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Checks if a given phone number is valid
	//
	// Example use cases:
	//
	// ```js
	// is_valid('8005553535', 'RU')
	// is_valid('8005553535', 'RU', metadata)
	// is_valid({ phone: '8005553535', country: 'RU' })
	// is_valid({ phone: '8005553535', country: 'RU' }, metadata)
	// is_valid('+78005553535')
	// is_valid('+78005553535', metadata)
	// ```
	//
	function is_valid(first_argument, second_argument, third_argument) {
		var _sort_out_arguments = sort_out_arguments(first_argument, second_argument, third_argument),
		    input = _sort_out_arguments.input,
		    metadata = _sort_out_arguments.metadata;
	
		// Sanity check
	
	
		if (!metadata) {
			throw new Error('Metadata not passed');
		}
	
		if (!input) {
			return false;
		}
	
		if (!input.country) {
			return false;
		}
	
		var country_metadata = metadata.countries[input.country];
	
		if ((0, _metadata.get_types)(country_metadata)) {
			if (!(0, _parse.get_number_type)(input.phone, input.country, metadata)) {
				return false;
			}
		}
	
		return true;
	}
	
	// Sort out arguments
	function sort_out_arguments(first_argument, second_argument, third_argument) {
		var input = void 0;
		var metadata = void 0;
	
		if (typeof first_argument === 'string') {
			// If country code is supplied
			if (typeof second_argument === 'string') {
				metadata = third_argument;
	
				// `parse` extracts phone numbers from raw text,
				// therefore it will cut off all "garbage" characters,
				// while this `validate` function needs to verify
				// that the phone number contains no "garbage"
				// therefore the explicit `is_viable_phone_number` check.
				if ((0, _parse.is_viable_phone_number)(first_argument)) {
					input = (0, _parse2.default)(first_argument, second_argument, metadata);
				}
			}
			// Just an international phone number is supplied
			else {
					metadata = second_argument;
	
					// `parse` extracts phone numbers from raw text,
					// therefore it will cut off all "garbage" characters,
					// while this `validate` function needs to verify
					// that the phone number contains no "garbage"
					// therefore the explicit `is_viable_phone_number` check.
					if ((0, _parse.is_viable_phone_number)(first_argument)) {
						input = (0, _parse2.default)(first_argument, metadata);
					}
				}
		} else {
			// The `first_argument` must be a valid phone number
			// as a whole, not just a part of it which gets parsed here.
			if (first_argument && first_argument.phone && (0, _parse.is_viable_phone_number)(first_argument.phone)) {
				input = first_argument;
			}
	
			metadata = second_argument;
		}
	
		return { input: input, metadata: metadata };
	}
	//# sourceMappingURL=validate.js.map

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	exports = module.exports = {}
	
	exports.parse             = __webpack_require__(109).default
	exports.format            = __webpack_require__(198).default
	exports.get_number_type   = __webpack_require__(109).get_number_type
	exports.is_valid_number   = __webpack_require__(693).default
	exports.as_you_type       = __webpack_require__(287).default
	exports.DIGIT_PLACEHOLDER = __webpack_require__(287).DIGIT_PLACEHOLDER
	
	// camelCase aliases
	exports.getNumberType = exports.get_number_type
	exports.isValidNumber = exports.is_valid_number
	exports.asYouType     = exports.as_you_type
	
	// exports['default'] = ...

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var custom   = __webpack_require__(694)
	var metadata = __webpack_require__(1116)
	
	exports = module.exports = {}
	
	exports.parse = function parse()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.parse.apply(this, parameters)
	}
	
	exports.format = function format()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.format.apply(this, parameters)
	}
	
	exports.get_number_type = function get_number_type()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.getNumberType.apply(this, parameters)
	}
	
	exports.is_valid_number = function is_valid_number()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.isValidNumber.apply(this, parameters)
	}
	
	exports.as_you_type = function as_you_type(country)
	{
		custom.asYouType.call(this, country, metadata)
	}
	
	exports.as_you_type.prototype = Object.create(custom.asYouType.prototype, {})
	exports.as_you_type.prototype.constructor = exports.as_you_type
	
	exports.DIGIT_PLACEHOLDER = custom.DIGIT_PLACEHOLDER
	
	// camelCase aliases
	exports.getNumberType = exports.get_number_type
	exports.isValidNumber = exports.is_valid_number
	exports.asYouType = exports.as_you_type


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 289,
		"./af.js": 289,
		"./ar": 296,
		"./ar-dz": 290,
		"./ar-dz.js": 290,
		"./ar-kw": 291,
		"./ar-kw.js": 291,
		"./ar-ly": 292,
		"./ar-ly.js": 292,
		"./ar-ma": 293,
		"./ar-ma.js": 293,
		"./ar-sa": 294,
		"./ar-sa.js": 294,
		"./ar-tn": 295,
		"./ar-tn.js": 295,
		"./ar.js": 296,
		"./az": 297,
		"./az.js": 297,
		"./be": 298,
		"./be.js": 298,
		"./bg": 299,
		"./bg.js": 299,
		"./bn": 300,
		"./bn.js": 300,
		"./bo": 301,
		"./bo.js": 301,
		"./br": 302,
		"./br.js": 302,
		"./bs": 303,
		"./bs.js": 303,
		"./ca": 304,
		"./ca.js": 304,
		"./cs": 305,
		"./cs.js": 305,
		"./cv": 306,
		"./cv.js": 306,
		"./cy": 307,
		"./cy.js": 307,
		"./da": 308,
		"./da.js": 308,
		"./de": 311,
		"./de-at": 309,
		"./de-at.js": 309,
		"./de-ch": 310,
		"./de-ch.js": 310,
		"./de.js": 311,
		"./dv": 312,
		"./dv.js": 312,
		"./el": 313,
		"./el.js": 313,
		"./en-au": 314,
		"./en-au.js": 314,
		"./en-ca": 315,
		"./en-ca.js": 315,
		"./en-gb": 316,
		"./en-gb.js": 316,
		"./en-ie": 317,
		"./en-ie.js": 317,
		"./en-nz": 318,
		"./en-nz.js": 318,
		"./eo": 319,
		"./eo.js": 319,
		"./es": 321,
		"./es-do": 320,
		"./es-do.js": 320,
		"./es.js": 321,
		"./et": 322,
		"./et.js": 322,
		"./eu": 323,
		"./eu.js": 323,
		"./fa": 324,
		"./fa.js": 324,
		"./fi": 325,
		"./fi.js": 325,
		"./fo": 326,
		"./fo.js": 326,
		"./fr": 329,
		"./fr-ca": 327,
		"./fr-ca.js": 327,
		"./fr-ch": 328,
		"./fr-ch.js": 328,
		"./fr.js": 329,
		"./fy": 330,
		"./fy.js": 330,
		"./gd": 331,
		"./gd.js": 331,
		"./gl": 332,
		"./gl.js": 332,
		"./gom-latn": 333,
		"./gom-latn.js": 333,
		"./he": 334,
		"./he.js": 334,
		"./hi": 335,
		"./hi.js": 335,
		"./hr": 336,
		"./hr.js": 336,
		"./hu": 337,
		"./hu.js": 337,
		"./hy-am": 338,
		"./hy-am.js": 338,
		"./id": 339,
		"./id.js": 339,
		"./is": 340,
		"./is.js": 340,
		"./it": 341,
		"./it.js": 341,
		"./ja": 342,
		"./ja.js": 342,
		"./jv": 343,
		"./jv.js": 343,
		"./ka": 344,
		"./ka.js": 344,
		"./kk": 345,
		"./kk.js": 345,
		"./km": 346,
		"./km.js": 346,
		"./kn": 347,
		"./kn.js": 347,
		"./ko": 348,
		"./ko.js": 348,
		"./ky": 349,
		"./ky.js": 349,
		"./lb": 350,
		"./lb.js": 350,
		"./lo": 351,
		"./lo.js": 351,
		"./lt": 352,
		"./lt.js": 352,
		"./lv": 353,
		"./lv.js": 353,
		"./me": 354,
		"./me.js": 354,
		"./mi": 355,
		"./mi.js": 355,
		"./mk": 356,
		"./mk.js": 356,
		"./ml": 357,
		"./ml.js": 357,
		"./mr": 358,
		"./mr.js": 358,
		"./ms": 360,
		"./ms-my": 359,
		"./ms-my.js": 359,
		"./ms.js": 360,
		"./my": 361,
		"./my.js": 361,
		"./nb": 362,
		"./nb.js": 362,
		"./ne": 363,
		"./ne.js": 363,
		"./nl": 365,
		"./nl-be": 364,
		"./nl-be.js": 364,
		"./nl.js": 365,
		"./nn": 366,
		"./nn.js": 366,
		"./pa-in": 367,
		"./pa-in.js": 367,
		"./pl": 368,
		"./pl.js": 368,
		"./pt": 370,
		"./pt-br": 369,
		"./pt-br.js": 369,
		"./pt.js": 370,
		"./ro": 371,
		"./ro.js": 371,
		"./ru": 372,
		"./ru.js": 372,
		"./sd": 373,
		"./sd.js": 373,
		"./se": 374,
		"./se.js": 374,
		"./si": 375,
		"./si.js": 375,
		"./sk": 376,
		"./sk.js": 376,
		"./sl": 377,
		"./sl.js": 377,
		"./sq": 378,
		"./sq.js": 378,
		"./sr": 380,
		"./sr-cyrl": 379,
		"./sr-cyrl.js": 379,
		"./sr.js": 380,
		"./ss": 381,
		"./ss.js": 381,
		"./sv": 382,
		"./sv.js": 382,
		"./sw": 383,
		"./sw.js": 383,
		"./ta": 384,
		"./ta.js": 384,
		"./te": 385,
		"./te.js": 385,
		"./tet": 386,
		"./tet.js": 386,
		"./th": 387,
		"./th.js": 387,
		"./tl-ph": 388,
		"./tl-ph.js": 388,
		"./tlh": 389,
		"./tlh.js": 389,
		"./tr": 390,
		"./tr.js": 390,
		"./tzl": 391,
		"./tzl.js": 391,
		"./tzm": 393,
		"./tzm-latn": 392,
		"./tzm-latn.js": 392,
		"./tzm.js": 393,
		"./uk": 394,
		"./uk.js": 394,
		"./ur": 395,
		"./ur.js": 395,
		"./uz": 397,
		"./uz-latn": 396,
		"./uz-latn.js": 396,
		"./uz.js": 397,
		"./vi": 398,
		"./vi.js": 398,
		"./x-pseudo": 399,
		"./x-pseudo.js": 399,
		"./yo": 400,
		"./yo.js": 400,
		"./zh-cn": 401,
		"./zh-cn.js": 401,
		"./zh-hk": 402,
		"./zh-hk.js": 402,
		"./zh-tw": 403,
		"./zh-tw.js": 403
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 696;


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(199);
	var invariant = __webpack_require__(406);
	var ReactPropTypesSecret = __webpack_require__(405);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(199);
	var invariant = __webpack_require__(406);
	var warning = __webpack_require__(701);
	
	var ReactPropTypesSecret = __webpack_require__(405);
	var checkPropTypes = __webpack_require__(698);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 701 */
[1179, 199],
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(704);
	var parse = __webpack_require__(703);
	var formats = __webpack_require__(407);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(408);
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    parameterLimit: 1000,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	
	    for (var i = 0; i < parts.length; ++i) {
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder);
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder);
	            val = options.decoder(part.slice(pos + 1), defaults.decoder);
	        }
	        if (has.call(obj, key)) {
	            obj[key] = [].concat(obj[key]).concat(val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function parseObjectRecursive(chain, val, options) {
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj;
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(parseObject(chain, val, options));
	    } else {
	        obj = options.plainObjects ? Object.create(null) : {};
	        var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	        var index = parseInt(cleanRoot, 10);
	        if (
	            !isNaN(index)
	            && root !== cleanRoot
	            && String(index) === cleanRoot
	            && index >= 0
	            && (options.parseArrays && index <= options.arrayLimit)
	        ) {
	            obj = [];
	            obj[index] = parseObject(chain, val, options);
	        } else {
	            obj[cleanRoot] = parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys
	        // that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options);
	};
	
	module.exports = function (str, opts) {
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
	    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
	    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options);
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(408);
	var formats = __webpack_require__(407);
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
	        return prefix + '[]';
	    },
	    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
	        return prefix;
	    }
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaults = {
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var stringify = function stringify( // eslint-disable-line func-name-matching
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    formatter,
	    encodeValuesOnly
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (Array.isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (Array.isArray(obj)) {
	            values = values.concat(stringify(
	                obj[key],
	                generateArrayPrefix(prefix, key),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        } else {
	            values = values.concat(stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        }
	    }
	
	    return values;
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
	    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
	    var sort = typeof options.sort === 'function' ? options.sort : null;
	    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
	    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
	    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
	    if (typeof options.format === 'undefined') {
	        options.format = formats.default;
	    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
	        throw new TypeError('Unknown format option provided.');
	    }
	    var formatter = formats.formatters[options.format];
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (Array.isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    } else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (sort) {
	        objKeys.sort(sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        keys = keys.concat(stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            strictNullHandling,
	            skipNulls,
	            encode ? encoder : null,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            formatter,
	            encodeValuesOnly
	        ));
	    }
	
	    var joined = keys.join(delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1153);
	var objectAssign = __webpack_require__(15);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(697)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function() {
	  root.requestAnimationFrame = raf
	  root.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	var always = __webpack_require__(94);
	
	
	/**
	 * A function that always returns `false`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.always, R.T
	 * @example
	 *
	 *      R.F(); //=> false
	 */
	module.exports = always(false);


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	var always = __webpack_require__(94);
	
	
	/**
	 * A function that always returns `true`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.always, R.F
	 * @example
	 *
	 *      R.T(); //=> true
	 */
	module.exports = always(true);


/***/ },
/* 709 */
/***/ function(module, exports) {

	/**
	 * A special placeholder value used to specify "gaps" within curried functions,
	 * allowing partial application of any combination of arguments, regardless of
	 * their positions.
	 *
	 * If `g` is a curried ternary function and `_` is `R.__`, the following are
	 * equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2, _)(1, 3)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @constant
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @example
	 *
	 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
	 *      greet('Alice'); //=> 'Hello, Alice!'
	 */
	module.exports = {'@@functional/placeholder': true};


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(50);
	var _curry1 = __webpack_require__(6);
	var curryN = __webpack_require__(35);
	
	
	/**
	 * Creates a new list iteration function from an existing one by adding two new
	 * parameters to its callback function: the current index, and the entire list.
	 *
	 * This would turn, for instance, Ramda's simple `map` function into one that
	 * more closely resembles `Array.prototype.map`. Note that this will only work
	 * for functions in which the iteration callback function is the first
	 * parameter, and where the list is the last parameter. (This latter might be
	 * unimportant if the list parameter is not used.)
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Function
	 * @category List
	 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
	 * @param {Function} fn A list iteration function that does not pass index or list to its callback
	 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
	 * @example
	 *
	 *      var mapIndexed = R.addIndex(R.map);
	 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
	 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
	 */
	module.exports = _curry1(function addIndex(fn) {
	  return curryN(fn.length, function() {
	    var idx = 0;
	    var origFn = arguments[0];
	    var list = arguments[arguments.length - 1];
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = function() {
	      var result = origFn.apply(this, _concat(arguments, [idx, list]));
	      idx += 1;
	      return result;
	    };
	    return fn.apply(this, args);
	  });
	});


/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _xall = __webpack_require__(782);
	
	
	/**
	 * Returns `true` if all elements of the list match the predicate, `false` if
	 * there are any that don't.
	 *
	 * Dispatches to the `all` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
	 *         otherwise.
	 * @see R.any, R.none, R.transduce
	 * @example
	 *
	 *      var equals3 = R.equals(3);
	 *      R.all(equals3)([3, 3, 3, 3]); //=> true
	 *      R.all(equals3)([3, 3, 1, 3]); //=> false
	 */
	module.exports = _curry2(_dispatchable(['all'], _xall, function all(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (!fn(list[idx])) {
	      return false;
	    }
	    idx += 1;
	  }
	  return true;
	}));


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var curryN = __webpack_require__(35);
	var max = __webpack_require__(95);
	var pluck = __webpack_require__(115);
	var reduce = __webpack_require__(57);
	
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if every one of the provided predicates is satisfied
	 * by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.anyPass
	 * @example
	 *
	 *      var isQueen = R.propEq('rank', 'Q');
	 *      var isSpade = R.propEq('suit', '♠︎');
	 *      var isQueenOfSpades = R.allPass([isQueen, isSpade]);
	 *
	 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
	 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
	 */
	module.exports = _curry1(function allPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function() {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (!preds[idx].apply(this, arguments)) {
	        return false;
	      }
	      idx += 1;
	    }
	    return true;
	  });
	});


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var curryN = __webpack_require__(35);
	var max = __webpack_require__(95);
	var pluck = __webpack_require__(115);
	var reduce = __webpack_require__(57);
	
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if at least one of the provided predicates is
	 * satisfied by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.allPass
	 * @example
	 *
	 *      var isClub = R.propEq('suit', '♣');
	 *      var isSpade = R.propEq('suit', '♠');
	 *      var isBlackCard = R.anyPass([isClub, isSpade]);
	 *
	 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
	 */
	module.exports = _curry1(function anyPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function() {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (preds[idx].apply(this, arguments)) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  });
	});


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	var _aperture = __webpack_require__(765);
	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _xaperture = __webpack_require__(783);
	
	
	/**
	 * Returns a new list, composed of n-tuples of consecutive elements If `n` is
	 * greater than the length of the list, an empty list is returned.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @param {Number} n The size of the tuples to create
	 * @param {Array} list The list to split into `n`-length tuples
	 * @return {Array} The resulting list of `n`-length tuples
	 * @see R.transduce
	 * @example
	 *
	 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
	 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
	 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
	 */
	module.exports = _curry2(_dispatchable([], _xaperture, _aperture));


/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(50);
	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns a new list containing the contents of the given list, followed by
	 * the given element.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The element to add to the end of the new list.
	 * @param {Array} list The list of elements to add a new item to.
	 *        list.
	 * @return {Array} A new list containing the elements of the old list followed by `el`.
	 * @see R.prepend
	 * @example
	 *
	 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
	 *      R.append('tests', []); //=> ['tests']
	 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
	 */
	module.exports = _curry2(function append(el, list) {
	  return _concat(list, [el]);
	});


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var apply = __webpack_require__(412);
	var curryN = __webpack_require__(35);
	var map = __webpack_require__(43);
	var max = __webpack_require__(95);
	var pluck = __webpack_require__(115);
	var reduce = __webpack_require__(57);
	var values = __webpack_require__(464);
	
	
	/**
	 * Given a spec object recursively mapping properties to functions, creates a
	 * function producing an object of the same structure, by mapping each property
	 * to the result of calling its associated function with the supplied arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
	 * @param {Object} spec an object recursively mapping properties to functions for
	 *        producing the values for these properties.
	 * @return {Function} A function that returns an object of the same structure
	 * as `spec', with each property set to the value returned by calling its
	 * associated function with the supplied arguments.
	 * @see R.converge, R.juxt
	 * @example
	 *
	 *      var getMetrics = R.applySpec({
	 *                                      sum: R.add,
	 *                                      nested: { mul: R.multiply }
	 *                                   });
	 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
	 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
	 */
	module.exports = _curry1(function applySpec(spec) {
	  spec = map(function(v) { return typeof v == 'function' ? v : applySpec(v); },
	             spec);
	  return curryN(reduce(max, 0, pluck('length', values(spec))),
	                function() {
	                  var args = arguments;
	                  return map(function(f) { return apply(f, args); }, spec);
	                });
	});


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Makes an ascending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
	 * @example
	 *
	 *      var byAge = R.ascend(R.prop('age'));
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByYoungestFirst = R.sort(byAge, people);
	 */
	module.exports = _curry3(function ascend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa < bb ? -1 : aa > bb ? 1 : 0;
	});


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var nAry = __webpack_require__(154);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 2 parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> c) -> (a, b -> c)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 2.
	 * @example
	 *
	 *      var takesThreeArgs = function(a, b, c) {
	 *        return [a, b, c];
	 *      };
	 *      takesThreeArgs.length; //=> 3
	 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      var takesTwoArgs = R.binary(takesThreeArgs);
	 *      takesTwoArgs.length; //=> 2
	 *      // Only 2 arguments are passed to the wrapped function
	 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
	 * @symb R.binary(f)(a, b, c) = f(a, b)
	 */
	module.exports = _curry1(function binary(fn) {
	  return nAry(2, fn);
	});


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _isFunction = __webpack_require__(148);
	var and = __webpack_require__(410);
	var lift = __webpack_require__(153);
	
	
	/**
	 * A function which calls the two provided functions and returns the `&&`
	 * of the results.
	 * It returns the result of the first function if it is false-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * false-y value.
	 *
	 * In addition to functions, `R.both` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f A predicate
	 * @param {Function} g Another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
	 * @see R.and
	 * @example
	 *
	 *      var gt10 = R.gt(R.__, 10)
	 *      var lt20 = R.lt(R.__, 20)
	 *      var f = R.both(gt10, lt20);
	 *      f(15); //=> true
	 *      f(30); //=> false
	 */
	module.exports = _curry2(function both(f, g) {
	  return _isFunction(f) ?
	    function _both() {
	      return f.apply(this, arguments) && g.apply(this, arguments);
	    } :
	    lift(and)(f, g);
	});


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	var curry = __webpack_require__(145);
	
	
	/**
	 * Returns the result of calling its first argument with the remaining
	 * arguments. This is occasionally useful as a converging function for
	 * `R.converge`: the left branch can produce a function while the right branch
	 * produces a value to be passed to that function as an argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig (*... -> a),*... -> a
	 * @param {Function} fn The function to apply to the remaining arguments.
	 * @param {...*} args Any number of positional arguments.
	 * @return {*}
	 * @see R.apply
	 * @example
	 *
	 *      R.call(R.add, 1, 2); //=> 3
	 *
	 *      var indentN = R.pipe(R.times(R.always(' ')),
	 *                           R.join(''),
	 *                           R.replace(/^(?!$)/gm));
	 *
	 *      var format = R.converge(R.call, [
	 *                                  R.pipe(R.prop('indent'), indentN),
	 *                                  R.prop('value')
	 *                              ]);
	 *
	 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
	 * @symb R.call(f, a, b) = f(a, b)
	 */
	module.exports = curry(function call(fn) {
	  return fn.apply(this, Array.prototype.slice.call(arguments, 1));
	});


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	/**
	 * Restricts a number to be within a range.
	 *
	 * Also works for other ordered types such as Strings and Dates.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a -> a
	 * @param {Number} minimum The lower limit of the clamp (inclusive)
	 * @param {Number} maximum The upper limit of the clamp (inclusive)
	 * @param {Number} value Value to be clamped
	 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
	 * @example
	 *
	 *      R.clamp(1, 10, -5) // => 1
	 *      R.clamp(1, 10, 15) // => 10
	 *      R.clamp(1, 10, 4)  // => 4
	 */
	module.exports = _curry3(function clamp(min, max, value) {
	  if (min > max) {
	    throw new Error('min must not be greater than max in clamp(min, max, value)');
	  }
	  return value < min ? min :
	         value > max ? max :
	         value;
	});


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	var _clone = __webpack_require__(426);
	var _curry1 = __webpack_require__(6);
	
	
	/**
	 * Creates a deep copy of the value which may contain (nested) `Array`s and
	 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
	 * assigned by reference rather than copied
	 *
	 * Dispatches to a `clone` method if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {*} -> {*}
	 * @param {*} value The object or array to clone
	 * @return {*} A deeply cloned copy of `val`
	 * @example
	 *
	 *      var objects = [{}, {}, {}];
	 *      var objectsClone = R.clone(objects);
	 *      objects === objectsClone; //=> false
	 *      objects[0] === objectsClone[0]; //=> false
	 */
	module.exports = _curry1(function clone(value) {
	  return value != null && typeof value.clone === 'function' ?
	    value.clone() :
	    _clone(value, [], [], true);
	});


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	
	
	/**
	 * Makes a comparator function out of a function that reports whether the first
	 * element is less than the second.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a, b -> Boolean) -> (a, b -> Number)
	 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
	 * is less than the second, `false` otherwise
	 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
	 * @example
	 *
	 *      var byAge = R.comparator((a, b) => a.age < b.age);
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByIncreasingAge = R.sort(byAge, people);
	 */
	module.exports = _curry1(function comparator(pred) {
	  return function(a, b) {
	    return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
	  };
	});


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	var lift = __webpack_require__(153);
	var not = __webpack_require__(448);
	
	
	/**
	 * Takes a function `f` and returns a function `g` such that if called with the same arguments
	 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
	 *
	 * `R.complement` may be applied to any functor
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> *) -> (*... -> Boolean)
	 * @param {Function} f
	 * @return {Function}
	 * @see R.not
	 * @example
	 *
	 *      var isNotNil = R.complement(R.isNil);
	 *      isNil(null); //=> true
	 *      isNotNil(null); //=> false
	 *      isNil(7); //=> false
	 *      isNotNil(7); //=> true
	 */
	module.exports = lift(not);


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	var pipeP = __webpack_require__(454);
	var reverse = __webpack_require__(157);
	
	
	/**
	 * Performs right-to-left composition of one or more Promise-returning
	 * functions. The rightmost function may have any arity; the remaining
	 * functions must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((y -> Promise z), (x -> Promise y), ..., (a -> Promise b)) -> (a -> Promise z)
	 * @param {...Function} functions The functions to compose
	 * @return {Function}
	 * @see R.pipeP
	 * @example
	 *
	 *      var db = {
	 *        users: {
	 *          JOE: {
	 *            name: 'Joe',
	 *            followers: ['STEVE', 'SUZY']
	 *          }
	 *        }
	 *      }
	 *
	 *      // We'll pretend to do a db lookup which returns a promise
	 *      var lookupUser = (userId) => Promise.resolve(db.users[userId])
	 *      var lookupFollowers = (user) => Promise.resolve(user.followers)
	 *      lookupUser('JOE').then(lookupFollowers)
	 *
	 *      //  followersForUser :: String -> Promise [UserId]
	 *      var followersForUser = R.composeP(lookupFollowers, lookupUser);
	 *      followersForUser('JOE').then(followers => console.log('Followers:', followers))
	 *      // Followers: ["STEVE","SUZY"]
	 */
	module.exports = function composeP() {
	  if (arguments.length === 0) {
	    throw new Error('composeP requires at least one argument');
	  }
	  return pipeP.apply(this, reverse(arguments));
	};


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(55);
	var _curry1 = __webpack_require__(6);
	var map = __webpack_require__(43);
	var max = __webpack_require__(95);
	var reduce = __webpack_require__(57);
	
	
	/**
	 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
	 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
	 * to `fn` are applied to each of the predicates in turn until one returns a
	 * "truthy" value, at which point `fn` returns the result of applying its
	 * arguments to the corresponding transformer. If none of the predicates
	 * matches, `fn` returns undefined.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Logic
	 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
	 * @param {Array} pairs A list of [predicate, transformer]
	 * @return {Function}
	 * @example
	 *
	 *      var fn = R.cond([
	 *        [R.equals(0),   R.always('water freezes at 0°C')],
	 *        [R.equals(100), R.always('water boils at 100°C')],
	 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
	 *      ]);
	 *      fn(0); //=> 'water freezes at 0°C'
	 *      fn(50); //=> 'nothing special happens at 50°C'
	 *      fn(100); //=> 'water boils at 100°C'
	 */
	module.exports = _curry1(function cond(pairs) {
	  var arity = reduce(max,
	                     0,
	                     map(function(pair) { return pair[0].length; }, pairs));
	  return _arity(arity, function() {
	    var idx = 0;
	    while (idx < pairs.length) {
	      if (pairs[idx][0].apply(this, arguments)) {
	        return pairs[idx][1].apply(this, arguments);
	      }
	      idx += 1;
	    }
	  });
	});


/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var constructN = __webpack_require__(416);
	
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> {*}) -> (* -> {*})
	 * @param {Function} fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @example
	 *
	 *      // Constructor function
	 *      function Animal(kind) {
	 *        this.kind = kind;
	 *      };
	 *      Animal.prototype.sighting = function() {
	 *        return "It's a " + this.kind + "!";
	 *      }
	 *
	 *      var AnimalConstructor = R.construct(Animal)
	 *
	 *      // Notice we no longer need the 'new' keyword:
	 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
	 *
	 *      var animalTypes = ["Lion", "Tiger", "Bear"];
	 *      var animalSighting = R.invoker(0, 'sighting');
	 *      var sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
	 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
	 */
	module.exports = _curry1(function construct(Fn) {
	  return constructN(Fn.length, Fn);
	});


/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(81);
	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns `true` if the specified value is equal, in `R.equals` terms, to at
	 * least one element of the given list; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Boolean
	 * @param {Object} a The item to compare against.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
	 * @see R.any
	 * @example
	 *
	 *      R.contains(3, [1, 2, 3]); //=> true
	 *      R.contains(4, [1, 2, 3]); //=> false
	 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
	 *      R.contains([42], [[42]]); //=> true
	 */
	module.exports = _curry2(_contains);


/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	var reduceBy = __webpack_require__(155);
	
	
	/**
	 * Counts the elements of a list according to how many match each value of a
	 * key generated by the supplied function. Returns an object mapping the keys
	 * produced by `fn` to the number of occurrences in the list. Note that all
	 * keys are coerced to strings because of how JavaScript objects work.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig (a -> String) -> [a] -> {*}
	 * @param {Function} fn The function used to map values to keys.
	 * @param {Array} list The list to count elements from.
	 * @return {Object} An object mapping keys to number of occurrences in the list.
	 * @example
	 *
	 *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
	 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
	 *
	 *      var letters = ['a', 'b', 'A', 'a', 'B', 'c'];
	 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
	 */
	module.exports = reduceBy(function(acc, elem) { return acc + 1; }, 0);


/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	var add = __webpack_require__(143);
	
	
	/**
	 * Decrements its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n - 1
	 * @see R.inc
	 * @example
	 *
	 *      R.dec(42); //=> 41
	 */
	module.exports = add(-1);


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Makes a descending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
	 * @example
	 *
	 *      var byAge = R.descend(R.prop('age'));
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByOldestFirst = R.sort(byAge, people);
	 */
	module.exports = _curry3(function descend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa > bb ? -1 : aa < bb ? 1 : 0;
	});


/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var assoc = __webpack_require__(144);
	var dissoc = __webpack_require__(421);
	
	
	/**
	 * Makes a shallow clone of an object, omitting the property at the given path.
	 * Note that this copies and flattens prototype properties onto the new object
	 * as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.11.0
	 * @category Object
	 * @sig [String] -> {k: v} -> {k: v}
	 * @param {Array} path The path to the value to omit
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object without the property at path
	 * @see R.assocPath
	 * @example
	 *
	 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
	 */
	module.exports = _curry2(function dissocPath(path, obj) {
	  switch (path.length) {
	    case 0:
	      return obj;
	    case 1:
	      return dissoc(path[0], obj);
	    default:
	      var head = path[0];
	      var tail = Array.prototype.slice.call(path, 1);
	      return obj[head] == null ? obj : assoc(head, dissocPath(tail, obj[head]), obj);
	  }
	});


/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Divides two numbers. Equivalent to `a / b`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a / b`.
	 * @see R.multiply
	 * @example
	 *
	 *      R.divide(71, 100); //=> 0.71
	 *
	 *      var half = R.divide(R.__, 2);
	 *      half(42); //=> 21
	 *
	 *      var reciprocal = R.divide(1);
	 *      reciprocal(4);   //=> 0.25
	 */
	module.exports = _curry2(function divide(a, b) { return a / b; });


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _dropLast = __webpack_require__(767);
	var _xdropLast = __webpack_require__(786);
	
	
	/**
	 * Returns a list containing all but the last `n` elements of the given `list`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements of `list` to skip.
	 * @param {Array} list The list of elements to consider.
	 * @return {Array} A copy of the list with only the first `list.length - n` elements
	 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
	 * @example
	 *
	 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(3, 'ramda');               //=> 'ra'
	 */
	module.exports = _curry2(_dispatchable([], _xdropLast, _dropLast));


/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _dropLastWhile = __webpack_require__(768);
	var _xdropLastWhile = __webpack_require__(787);
	
	
	/**
	 * Returns a new list excluding all the tailing elements of a given list which
	 * satisfy the supplied predicate function. It passes each value from the right
	 * to the supplied predicate function, skipping elements until the predicate
	 * function returns a `falsy` value. The predicate function is applied to one argument:
	 * *(value)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} predicate The function to be called on each element
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
	 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
	 * @example
	 *
	 *      var lteThree = x => x <= 3;
	 *
	 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
	 */
	module.exports = _curry2(_dispatchable([], _xdropLastWhile, _dropLastWhile));


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(24);
	var _xdropRepeatsWith = __webpack_require__(438);
	var dropRepeatsWith = __webpack_require__(423);
	var equals = __webpack_require__(54);
	
	
	/**
	 * Returns a new list without any consecutively repeating elements. `R.equals`
	 * is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
	 */
	module.exports = _curry1(_dispatchable([], _xdropRepeatsWith(equals), dropRepeatsWith(equals)));


/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _xdropWhile = __webpack_require__(788);
	
	
	/**
	 * Returns a new list excluding the leading elements of a given list which
	 * satisfy the supplied predicate function. It passes each value to the supplied
	 * predicate function, skipping elements while the predicate function returns
	 * `true`. The predicate function is applied to one argument: *(value)*.
	 *
	 * Dispatches to the `dropWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.takeWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      var lteTwo = x => x <= 2;
	 *
	 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
	 */
	module.exports = _curry2(_dispatchable(['dropWhile'], _xdropWhile, function dropWhile(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len && pred(list[idx])) {
	    idx += 1;
	  }
	  return Array.prototype.slice.call(list, idx);
	}));


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _isFunction = __webpack_require__(148);
	var lift = __webpack_require__(153);
	var or = __webpack_require__(450);
	
	
	/**
	 * A function wrapping calls to the two functions in an `||` operation,
	 * returning the result of the first function if it is truth-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * truth-y value.
	 *
	 * In addition to functions, `R.either` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f a predicate
	 * @param {Function} g another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
	 * @see R.or
	 * @example
	 *
	 *      var gt10 = x => x > 10;
	 *      var even = x => x % 2 === 0;
	 *      var f = R.either(gt10, even);
	 *      f(101); //=> true
	 *      f(8); //=> true
	 */
	module.exports = _curry2(function either(f, g) {
	  return _isFunction(f) ?
	    function _either() {
	      return f.apply(this, arguments) || g.apply(this, arguments);
	    } :
	    lift(or)(f, g);
	});


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	var equals = __webpack_require__(54);
	
	
	/**
	 * Takes a function and two values in its domain and returns `true` if the
	 * values map to the same value in the codomain; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Relation
	 * @sig (a -> b) -> a -> a -> Boolean
	 * @param {Function} f
	 * @param {*} x
	 * @param {*} y
	 * @return {Boolean}
	 * @example
	 *
	 *      R.eqBy(Math.abs, 5, -5); //=> true
	 */
	module.exports = _curry3(function eqBy(f, x, y) {
	  return equals(f(x), f(y));
	});


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	var equals = __webpack_require__(54);
	
	
	/**
	 * Reports whether two objects have the same value, in `R.equals` terms, for
	 * the specified property. Useful as a curried predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig k -> {k: v} -> {k: v} -> Boolean
	 * @param {String} prop The name of the property to compare
	 * @param {Object} obj1
	 * @param {Object} obj2
	 * @return {Boolean}
	 *
	 * @example
	 *
	 *      var o1 = { a: 1, b: 2, c: 3, d: 4 };
	 *      var o2 = { a: 10, b: 20, c: 3, d: 40 };
	 *      R.eqProps('a', o1, o2); //=> false
	 *      R.eqProps('c', o1, o2); //=> true
	 */
	module.exports = _curry3(function eqProps(prop, obj1, obj2) {
	  return equals(obj1[prop], obj2[prop]);
	});


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Creates a new object by recursively evolving a shallow copy of `object`,
	 * according to the `transformation` functions. All non-primitive properties
	 * are copied by reference.
	 *
	 * A `transformation` function will not be invoked if its corresponding key
	 * does not exist in the evolved object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
	 * @param {Object} transformations The object specifying transformation functions to apply
	 *        to the object.
	 * @param {Object} object The object to be transformed.
	 * @return {Object} The transformed object.
	 * @example
	 *
	 *      var tomato  = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
	 *      var transformations = {
	 *        firstName: R.trim,
	 *        lastName: R.trim, // Will not get invoked.
	 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
	 *      };
	 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
	 */
	module.exports = _curry2(function evolve(transformations, object) {
	  var result = {};
	  var transformation, key, type;
	  for (key in object) {
	    transformation = transformations[key];
	    type = typeof transformation;
	    result[key] = type === 'function'                 ? transformation(object[key])
	                : transformation && type === 'object' ? evolve(transformation, object[key])
	                                                      : object[key];
	  }
	  return result;
	});


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _xfind = __webpack_require__(790);
	
	
	/**
	 * Returns the first element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Dispatches to the `find` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 *        desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
	 *      R.find(R.propEq('a', 4))(xs); //=> undefined
	 */
	module.exports = _curry2(_dispatchable(['find'], _xfind, function find(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx += 1;
	  }
	}));


/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _xfindIndex = __webpack_require__(791);
	
	
	/**
	 * Returns the index of the first element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
	 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	module.exports = _curry2(_dispatchable([], _xfindIndex, function findIndex(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	}));


/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _xfindLast = __webpack_require__(792);
	
	
	/**
	 * Returns the last element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
	 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
	 */
	module.exports = _curry2(_dispatchable([], _xfindLast, function findLast(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx -= 1;
	  }
	}));


/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _xfindLastIndex = __webpack_require__(793);
	
	
	/**
	 * Returns the index of the last element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
	 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	module.exports = _curry2(_dispatchable([], _xfindLastIndex, function findLastIndex(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx -= 1;
	  }
	  return -1;
	}));


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var _makeFlat = __webpack_require__(436);
	
	
	/**
	 * Returns a new list by pulling every item out of it (and all its sub-arrays)
	 * and putting them in a new array, depth-first.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b]
	 * @param {Array} list The array to consider.
	 * @return {Array} The flattened list.
	 * @see R.unnest
	 * @example
	 *
	 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
	 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
	 */
	module.exports = _curry1(_makeFlat(true));


/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(110);
	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Iterate over an input `list`, calling a provided function `fn` for each
	 * element in the list.
	 *
	 * `fn` receives one argument: *(value)*.
	 *
	 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.forEach` method. For more
	 * details on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
	 *
	 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
	 * the original array. In some libraries this function is named `each`.
	 *
	 * Dispatches to the `forEach` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> *) -> [a] -> [a]
	 * @param {Function} fn The function to invoke. Receives one argument, `value`.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} The original list.
	 * @see R.addIndex
	 * @example
	 *
	 *      var printXPlusFive = x => console.log(x + 5);
	 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
	 *      // logs 6
	 *      // logs 7
	 *      // logs 8
	 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
	 */
	module.exports = _curry2(_checkForMethod('forEach', function forEach(fn, list) {
	  var len = list.length;
	  var idx = 0;
	  while (idx < len) {
	    fn(list[idx]);
	    idx += 1;
	  }
	  return list;
	}));


/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var keys = __webpack_require__(56);
	
	
	/**
	 * Iterate over an input `object`, calling a provided function `fn` for each
	 * key and value in the object.
	 *
	 * `fn` receives three argument: *(value, key, obj)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Object
	 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
	 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
	 * @param {Object} obj The object to iterate over.
	 * @return {Object} The original object.
	 * @example
	 *
	 *      var printKeyConcatValue = (value, key) => console.log(key + ':' + value);
	 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
	 *      // logs x:1
	 *      // logs y:2
	 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
	 */
	module.exports = _curry2(function forEachObjIndexed(fn, obj) {
	  var keyList = keys(obj);
	  var idx = 0;
	  while (idx < keyList.length) {
	    var key = keyList[idx];
	    fn(obj[key], key, obj);
	    idx += 1;
	  }
	  return obj;
	});


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	
	
	/**
	 * Creates a new object from a list key-value pairs. If a key appears in
	 * multiple pairs, the rightmost pair is included in the object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [[k,v]] -> {k: v}
	 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
	 * @return {Object} The object made by pairing up `keys` and `values`.
	 * @see R.toPairs, R.pair
	 * @example
	 *
	 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry1(function fromPairs(pairs) {
	  var result = {};
	  var idx = 0;
	  while (idx < pairs.length) {
	    result[pairs[idx][0]] = pairs[idx][1];
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(110);
	var _curry2 = __webpack_require__(2);
	var reduceBy = __webpack_require__(155);
	
	/**
	 * Splits a list into sub-lists stored in an object, based on the result of
	 * calling a String-returning function on each element, and grouping the
	 * results according to values returned.
	 *
	 * Dispatches to the `groupBy` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> String) -> [a] -> {String: [a]}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} list The array to group
	 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
	 *         that produced that key when passed to `fn`.
	 * @see R.transduce
	 * @example
	 *
	 *      var byGrade = R.groupBy(function(student) {
	 *        var score = student.score;
	 *        return score < 65 ? 'F' :
	 *               score < 70 ? 'D' :
	 *               score < 80 ? 'C' :
	 *               score < 90 ? 'B' : 'A';
	 *      });
	 *      var students = [{name: 'Abby', score: 84},
	 *                      {name: 'Eddy', score: 58},
	 *                      // ...
	 *                      {name: 'Jack', score: 69}];
	 *      byGrade(students);
	 *      // {
	 *      //   'A': [{name: 'Dianne', score: 99}],
	 *      //   'B': [{name: 'Abby', score: 84}]
	 *      //   // ...,
	 *      //   'F': [{name: 'Eddy', score: 58}]
	 *      // }
	 */
	module.exports = _curry2(_checkForMethod('groupBy', reduceBy(function(acc, item) {
	  if (acc == null) {
	    acc = [];
	  }
	  acc.push(item);
	  return acc;
	}, null)));


/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	/**
	 * Takes a list and returns a list of lists where each sublist's elements are
	 * all "equal" according to the provided equality function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.21.0
	 * @category List
	 * @sig ((a, a) → Boolean) → [a] → [[a]]
	 * @param {Function} fn Function for determining whether two given (adjacent)
	 *        elements should be in the same group
	 * @param {Array} list The array to group. Also accepts a string, which will be
	 *        treated as a list of characters.
	 * @return {List} A list that contains sublists of equal elements,
	 *         whose concatenations are equal to the original list.
	 * @example
	 *
	 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
	 *
	 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
	 *
	 * R.groupWith(R.eqBy(isVowel), 'aestiou')
	 * //=> ['ae', 'st', 'iou']
	 */
	module.exports = _curry2(function(fn, list) {
	  var res = [];
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    var nextidx = idx + 1;
	    while (nextidx < len && fn(list[idx], list[nextidx])) {
	      nextidx += 1;
	    }
	    res.push(list.slice(idx, nextidx));
	    idx = nextidx;
	  }
	  return res;
	});


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns `true` if the first argument is greater than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.lt
	 * @example
	 *
	 *      R.gt(2, 1); //=> true
	 *      R.gt(2, 2); //=> false
	 *      R.gt(2, 3); //=> false
	 *      R.gt('a', 'z'); //=> false
	 *      R.gt('z', 'a'); //=> true
	 */
	module.exports = _curry2(function gt(a, b) { return a > b; });


/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns `true` if the first argument is greater than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.lte
	 * @example
	 *
	 *      R.gte(2, 1); //=> true
	 *      R.gte(2, 2); //=> true
	 *      R.gte(2, 3); //=> false
	 *      R.gte('a', 'z'); //=> false
	 *      R.gte('z', 'a'); //=> true
	 */
	module.exports = _curry2(function gte(a, b) { return a >= b; });


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _has = __webpack_require__(39);
	
	
	/**
	 * Returns whether or not an object has an own property with the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      var hasName = R.has('name');
	 *      hasName({name: 'alice'});   //=> true
	 *      hasName({name: 'bob'});     //=> true
	 *      hasName({});                //=> false
	 *
	 *      var point = {x: 0, y: 0};
	 *      var pointHas = R.has(R.__, point);
	 *      pointHas('x');  //=> true
	 *      pointHas('y');  //=> true
	 *      pointHas('z');  //=> false
	 */
	module.exports = _curry2(_has);


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns whether or not an object or its prototype chain has a property with
	 * the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      function Rectangle(width, height) {
	 *        this.width = width;
	 *        this.height = height;
	 *      }
	 *      Rectangle.prototype.area = function() {
	 *        return this.width * this.height;
	 *      };
	 *
	 *      var square = new Rectangle(2, 2);
	 *      R.hasIn('width', square);  //=> true
	 *      R.hasIn('area', square);  //=> true
	 */
	module.exports = _curry2(function hasIn(prop, obj) {
	  return prop in obj;
	});


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	var nth = __webpack_require__(113);
	
	
	/**
	 * Returns the first element of the given list or string. In some libraries
	 * this function is named `first`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {*}
	 * @see R.tail, R.init, R.last
	 * @example
	 *
	 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
	 *      R.head([]); //=> undefined
	 *
	 *      R.head('abc'); //=> 'a'
	 *      R.head(''); //=> ''
	 */
	module.exports = nth(0);


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	var curryN = __webpack_require__(35);
	
	
	/**
	 * Creates a function that will process either the `onTrue` or the `onFalse`
	 * function depending upon the result of the `condition` predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
	 * @param {Function} condition A predicate function
	 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
	 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
	 * @return {Function} A new unary function that will process either the `onTrue` or the `onFalse`
	 *                    function depending upon the result of the `condition` predicate.
	 * @see R.unless, R.when
	 * @example
	 *
	 *      var incCount = R.ifElse(
	 *        R.has('count'),
	 *        R.over(R.lensProp('count'), R.inc),
	 *        R.assoc('count', 1)
	 *      );
	 *      incCount({});           //=> { count: 1 }
	 *      incCount({ count: 1 }); //=> { count: 2 }
	 */
	module.exports = _curry3(function ifElse(condition, onTrue, onFalse) {
	  return curryN(Math.max(condition.length, onTrue.length, onFalse.length),
	    function _ifElse() {
	      return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
	    }
	  );
	});


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	var add = __webpack_require__(143);
	
	
	/**
	 * Increments its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n + 1
	 * @see R.dec
	 * @example
	 *
	 *      R.inc(42); //=> 43
	 */
	module.exports = add(1);


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	var reduceBy = __webpack_require__(155);
	
	
	/**
	 * Given a function that generates a key, turns a list of objects into an
	 * object indexing the objects by the given key. Note that if multiple
	 * objects generate the same value for the indexing key only the last value
	 * will be included in the generated object.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} array The array of objects to index
	 * @return {Object} An object indexing each array element by the given property.
	 * @example
	 *
	 *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
	 *      R.indexBy(R.prop('id'), list);
	 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
	 */
	module.exports = reduceBy(function(acc, elem) { return elem; }, null);


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _indexOf = __webpack_require__(431);
	var _isArray = __webpack_require__(71);
	
	
	/**
	 * Returns the position of the first occurrence of an item in an array, or -1
	 * if the item is not included in the array. `R.equals` is used to determine
	 * equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.lastIndexOf
	 * @example
	 *
	 *      R.indexOf(3, [1,2,3,4]); //=> 2
	 *      R.indexOf(10, [1,2,3,4]); //=> -1
	 */
	module.exports = _curry2(function indexOf(target, xs) {
	  return typeof xs.indexOf === 'function' && !_isArray(xs) ?
	    xs.indexOf(target) :
	    _indexOf(xs, target, 0);
	});


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	var slice = __webpack_require__(82);
	
	
	/**
	 * Returns all but the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.last, R.head, R.tail
	 * @example
	 *
	 *      R.init([1, 2, 3]);  //=> [1, 2]
	 *      R.init([1, 2]);     //=> [1]
	 *      R.init([1]);        //=> []
	 *      R.init([]);         //=> []
	 *
	 *      R.init('abc');  //=> 'ab'
	 *      R.init('ab');   //=> 'a'
	 *      R.init('a');    //=> ''
	 *      R.init('');     //=> ''
	 */
	module.exports = slice(0, -1);


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Inserts the supplied element into the list, at index `index`. _Note that
	 * this is not destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} index The position to insert the element
	 * @param {*} elt The element to insert into the Array
	 * @param {Array} list The list to insert into
	 * @return {Array} A new Array with `elt` inserted at `index`.
	 * @example
	 *
	 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
	 */
	module.exports = _curry3(function insert(idx, elt, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(idx, 0, elt);
	  return result;
	});


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Inserts the sub-list into the list, at index `index`. _Note that this is not
	 * destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig Number -> [a] -> [a] -> [a]
	 * @param {Number} index The position to insert the sub-list
	 * @param {Array} elts The sub-list to insert into the Array
	 * @param {Array} list The list to insert the sub-list into
	 * @return {Array} A new Array with `elts` inserted starting at `index`.
	 * @example
	 *
	 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
	 */
	module.exports = _curry3(function insertAll(idx, elts, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  return [].concat(Array.prototype.slice.call(list, 0, idx),
	                   elts,
	                   Array.prototype.slice.call(list, idx));
	});


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(81);
	
	
	// A simple Set type that honours R.equals semantics
	module.exports = (function() {
	  function _Set() {
	    /* globals Set */
	    this._nativeSet = typeof Set === 'function' ? new Set() : null;
	    this._items = {};
	  }
	
	  // until we figure out why jsdoc chokes on this
	  // @param item The item to add to the Set
	  // @returns {boolean} true if the item did not exist prior, otherwise false
	  //
	  _Set.prototype.add = function(item) {
	    return !hasOrAdd(item, true, this);
	  };
	
	  //
	  // @param item The item to check for existence in the Set
	  // @returns {boolean} true if the item exists in the Set, otherwise false
	  //
	  _Set.prototype.has = function(item) {
	    return hasOrAdd(item, false, this);
	  };
	
	  //
	  // Combines the logic for checking whether an item is a member of the set and
	  // for adding a new item to the set.
	  //
	  // @param item       The item to check or add to the Set instance.
	  // @param shouldAdd  If true, the item will be added to the set if it doesn't
	  //                   already exist.
	  // @param set        The set instance to check or add to.
	  // @return {boolean} true if the item already existed, otherwise false.
	  //
	  function hasOrAdd(item, shouldAdd, set) {
	    var type = typeof item;
	    var prevSize, newSize;
	    switch (type) {
	      case 'string':
	      case 'number':
	        // distinguish between +0 and -0
	        if (item === 0 && 1 / item === -Infinity) {
	          if (set._items['-0']) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items['-0'] = true;
	            }
	            return false;
	          }
	        }
	        // these types can all utilise the native Set
	        if (set._nativeSet !== null) {
	          if (shouldAdd) {
	            prevSize = set._nativeSet.size;
	            set._nativeSet.add(item);
	            newSize = set._nativeSet.size;
	            return newSize === prevSize;
	          } else {
	            return set._nativeSet.has(item);
	          }
	        } else {
	          if (!(type in set._items)) {
	            if (shouldAdd) {
	              set._items[type] = {};
	              set._items[type][item] = true;
	            }
	            return false;
	          } else if (item in set._items[type]) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items[type][item] = true;
	            }
	            return false;
	          }
	        }
	
	      case 'boolean':
	        // set._items['boolean'] holds a two element array
	        // representing [ falseExists, trueExists ]
	        if (type in set._items) {
	          var bIdx = item ? 1 : 0;
	          if (set._items[type][bIdx]) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items[type][bIdx] = true;
	            }
	            return false;
	          }
	        } else {
	          if (shouldAdd) {
	            set._items[type] = item ? [false, true] : [true, false];
	          }
	          return false;
	        }
	
	      case 'function':
	        // compare functions for reference equality
	        if (set._nativeSet !== null) {
	          if (shouldAdd) {
	            prevSize = set._nativeSet.size;
	            set._nativeSet.add(item);
	            newSize = set._nativeSet.size;
	            return newSize === prevSize;
	          } else {
	            return set._nativeSet.has(item);
	          }
	        } else {
	          if (!(type in set._items)) {
	            if (shouldAdd) {
	              set._items[type] = [item];
	            }
	            return false;
	          }
	          if (!_contains(item, set._items[type])) {
	            if (shouldAdd) {
	              set._items[type].push(item);
	            }
	            return false;
	          }
	          return true;
	        }
	
	      case 'undefined':
	        if (set._items[type]) {
	          return true;
	        } else {
	          if (shouldAdd) {
	            set._items[type] = true;
	          }
	          return false;
	        }
	
	      case 'object':
	        if (item === null) {
	          if (!set._items['null']) {
	            if (shouldAdd) {
	              set._items['null'] = true;
	            }
	            return false;
	          }
	          return true;
	        }
	      /* falls through */
	      default:
	        // reduce the search size of heterogeneous sets by creating buckets
	        // for each type.
	        type = Object.prototype.toString.call(item);
	        if (!(type in set._items)) {
	          if (shouldAdd) {
	            set._items[type] = [item];
	          }
	          return false;
	        }
	        // scan through all previously applied items
	        if (!_contains(item, set._items[type])) {
	          if (shouldAdd) {
	            set._items[type].push(item);
	          }
	          return false;
	        }
	        return true;
	    }
	  }
	  return _Set;
	}());


/***/ },
/* 765 */
/***/ function(module, exports) {

	module.exports = function _aperture(n, list) {
	  var idx = 0;
	  var limit = list.length - (n - 1);
	  var acc = new Array(limit >= 0 ? limit : 0);
	  while (idx < limit) {
	    acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
	    idx += 1;
	  }
	  return acc;
	};


/***/ },
/* 766 */
/***/ function(module, exports) {

	module.exports = function _arrayFromIterator(iter) {
	  var list = [];
	  var next;
	  while (!(next = iter.next()).done) {
	    list.push(next.value);
	  }
	  return list;
	};


/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	var take = __webpack_require__(459);
	
	module.exports = function dropLast(n, xs) {
	  return take(n < xs.length ? xs.length - n : 0, xs);
	};


/***/ },
/* 768 */
/***/ function(module, exports) {

	module.exports = function dropLastWhile(pred, list) {
	  var idx = list.length - 1;
	  while (idx >= 0 && pred(list[idx])) {
	    idx -= 1;
	  }
	  return Array.prototype.slice.call(list, 0, idx + 1);
	};


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	var _arrayFromIterator = __webpack_require__(766);
	var _functionName = __webpack_require__(772);
	var _has = __webpack_require__(39);
	var identical = __webpack_require__(425);
	var keys = __webpack_require__(56);
	var type = __webpack_require__(212);
	
	
	module.exports = function _equals(a, b, stackA, stackB) {
	  if (identical(a, b)) {
	    return true;
	  }
	
	  if (type(a) !== type(b)) {
	    return false;
	  }
	
	  if (a == null || b == null) {
	    return false;
	  }
	
	  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
	    return typeof a.equals === 'function' && a.equals(b) &&
	           typeof b.equals === 'function' && b.equals(a);
	  }
	
	  switch (type(a)) {
	    case 'Arguments':
	    case 'Array':
	    case 'Object':
	      if (typeof a.constructor === 'function' &&
	          _functionName(a.constructor) === 'Promise') {
	        return a === b;
	      }
	      break;
	    case 'Boolean':
	    case 'Number':
	    case 'String':
	      if (!(typeof a === typeof b && identical(a.valueOf(), b.valueOf()))) {
	        return false;
	      }
	      break;
	    case 'Date':
	      if (!identical(a.valueOf(), b.valueOf())) {
	        return false;
	      }
	      break;
	    case 'Error':
	      return a.name === b.name && a.message === b.message;
	    case 'RegExp':
	      if (!(a.source === b.source &&
	            a.global === b.global &&
	            a.ignoreCase === b.ignoreCase &&
	            a.multiline === b.multiline &&
	            a.sticky === b.sticky &&
	            a.unicode === b.unicode)) {
	        return false;
	      }
	      break;
	    case 'Map':
	    case 'Set':
	      if (!_equals(_arrayFromIterator(a.entries()), _arrayFromIterator(b.entries()), stackA, stackB)) {
	        return false;
	      }
	      break;
	    case 'Int8Array':
	    case 'Uint8Array':
	    case 'Uint8ClampedArray':
	    case 'Int16Array':
	    case 'Uint16Array':
	    case 'Int32Array':
	    case 'Uint32Array':
	    case 'Float32Array':
	    case 'Float64Array':
	      break;
	    case 'ArrayBuffer':
	      break;
	    default:
	      // Values of other types are only equal if identical.
	      return false;
	  }
	
	  var keysA = keys(a);
	  if (keysA.length !== keys(b).length) {
	    return false;
	  }
	
	  var idx = stackA.length - 1;
	  while (idx >= 0) {
	    if (stackA[idx] === a) {
	      return stackB[idx] === b;
	    }
	    idx -= 1;
	  }
	
	  stackA.push(a);
	  stackB.push(b);
	  idx = keysA.length - 1;
	  while (idx >= 0) {
	    var key = keysA[idx];
	    if (!(_has(key, b) && _equals(b[key], a[key], stackA, stackB))) {
	      return false;
	    }
	    idx -= 1;
	  }
	  stackA.pop();
	  stackB.pop();
	  return true;
	};


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	var _forceReduced = __webpack_require__(771);
	var _reduce = __webpack_require__(49);
	var _xfBase = __webpack_require__(27);
	var isArrayLike = __webpack_require__(112);
	
	module.exports = (function() {
	  var preservingReduced = function(xf) {
	    return {
	      '@@transducer/init': _xfBase.init,
	      '@@transducer/result': function(result) {
	        return xf['@@transducer/result'](result);
	      },
	      '@@transducer/step': function(result, input) {
	        var ret = xf['@@transducer/step'](result, input);
	        return ret['@@transducer/reduced'] ? _forceReduced(ret) : ret;
	      }
	    };
	  };
	
	  return function _xcat(xf) {
	    var rxf = preservingReduced(xf);
	    return {
	      '@@transducer/init': _xfBase.init,
	      '@@transducer/result': function(result) {
	        return rxf['@@transducer/result'](result);
	      },
	      '@@transducer/step': function(result, input) {
	        return !isArrayLike(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
	      }
	    };
	  };
	}());


/***/ },
/* 771 */
/***/ function(module, exports) {

	module.exports = function _forceReduced(x) {
	  return {
	    '@@transducer/value': x,
	    '@@transducer/reduced': true
	  };
	};


/***/ },
/* 772 */
/***/ function(module, exports) {

	module.exports = function _functionName(f) {
	  // String(x => x) evaluates to "x => x", so the pattern may not match.
	  var match = String(f).match(/^function (\w*)/);
	  return match == null ? '' : match[1];
	};


/***/ },
/* 773 */
/***/ function(module, exports) {

	module.exports = function _isRegExp(x) {
	  return Object.prototype.toString.call(x) === '[object RegExp]';
	};


/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	var _has = __webpack_require__(39);
	
	// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	module.exports = function _objectAssign(target) {
	  if (target == null) {
	    throw new TypeError('Cannot convert undefined or null to object');
	  }
	
	  var output = Object(target);
	  var idx = 1;
	  var length = arguments.length;
	  while (idx < length) {
	    var source = arguments[idx];
	    if (source != null) {
	      for (var nextKey in source) {
	        if (_has(nextKey, source)) {
	          output[nextKey] = source[nextKey];
	        }
	      }
	    }
	    idx += 1;
	  }
	  return output;
	};


/***/ },
/* 775 */
/***/ function(module, exports) {

	module.exports = function _of(x) { return [x]; };


/***/ },
/* 776 */
/***/ function(module, exports) {

	module.exports = function _pipe(f, g) {
	  return function() {
	    return g.call(this, f.apply(this, arguments));
	  };
	};


/***/ },
/* 777 */
/***/ function(module, exports) {

	module.exports = function _pipeP(f, g) {
	  return function() {
	    var ctx = this;
	    return f.apply(ctx, arguments).then(function(x) {
	      return g.call(ctx, x);
	    });
	  };
	};


/***/ },
/* 778 */
/***/ function(module, exports) {

	module.exports = function _quote(s) {
	  var escaped = s
	    .replace(/\\/g, '\\\\')
	    .replace(/[\b]/g, '\\b')  // \b matches word boundary; [\b] matches backspace
	    .replace(/\f/g, '\\f')
	    .replace(/\n/g, '\\n')
	    .replace(/\r/g, '\\r')
	    .replace(/\t/g, '\\t')
	    .replace(/\v/g, '\\v')
	    .replace(/\0/g, '\\0');
	
	  return '"' + escaped.replace(/"/g, '\\"') + '"';
	};


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(206);
	var _identity = __webpack_require__(208);
	var _isTransformer = __webpack_require__(209);
	var isArrayLike = __webpack_require__(112);
	var objOf = __webpack_require__(449);
	
	
	module.exports = (function() {
	  var _stepCatArray = {
	    '@@transducer/init': Array,
	    '@@transducer/step': function(xs, x) {
	      xs.push(x);
	      return xs;
	    },
	    '@@transducer/result': _identity
	  };
	  var _stepCatString = {
	    '@@transducer/init': String,
	    '@@transducer/step': function(a, b) { return a + b; },
	    '@@transducer/result': _identity
	  };
	  var _stepCatObject = {
	    '@@transducer/init': Object,
	    '@@transducer/step': function(result, input) {
	      return _assign(
	        result,
	        isArrayLike(input) ? objOf(input[0], input[1]) : input
	      );
	    },
	    '@@transducer/result': _identity
	  };
	
	  return function _stepCat(obj) {
	    if (_isTransformer(obj)) {
	      return obj;
	    }
	    if (isArrayLike(obj)) {
	      return _stepCatArray;
	    }
	    if (typeof obj === 'string') {
	      return _stepCatString;
	    }
	    if (typeof obj === 'object') {
	      return _stepCatObject;
	    }
	    throw new Error('Cannot create transformer for ' + obj);
	  };
	}());


/***/ },
/* 780 */
/***/ function(module, exports) {

	/**
	 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
	 */
	module.exports = (function() {
	  var pad = function pad(n) { return (n < 10 ? '0' : '') + n; };
	
	  return typeof Date.prototype.toISOString === 'function' ?
	    function _toISOString(d) {
	      return d.toISOString();
	    } :
	    function _toISOString(d) {
	      return (
	        d.getUTCFullYear() + '-' +
	        pad(d.getUTCMonth() + 1) + '-' +
	        pad(d.getUTCDate()) + 'T' +
	        pad(d.getUTCHours()) + ':' +
	        pad(d.getUTCMinutes()) + ':' +
	        pad(d.getUTCSeconds()) + '.' +
	        (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z'
	      );
	    };
	}());


/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(81);
	var _map = __webpack_require__(151);
	var _quote = __webpack_require__(778);
	var _toISOString = __webpack_require__(780);
	var keys = __webpack_require__(56);
	var reject = __webpack_require__(156);
	
	
	module.exports = function _toString(x, seen) {
	  var recur = function recur(y) {
	    var xs = seen.concat([x]);
	    return _contains(y, xs) ? '<Circular>' : _toString(y, xs);
	  };
	
	  //  mapPairs :: (Object, [String]) -> [String]
	  var mapPairs = function(obj, keys) {
	    return _map(function(k) { return _quote(k) + ': ' + recur(obj[k]); }, keys.slice().sort());
	  };
	
	  switch (Object.prototype.toString.call(x)) {
	    case '[object Arguments]':
	      return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';
	    case '[object Array]':
	      return '[' + _map(recur, x).concat(mapPairs(x, reject(function(k) { return /^\d+$/.test(k); }, keys(x)))).join(', ') + ']';
	    case '[object Boolean]':
	      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
	    case '[object Date]':
	      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';
	    case '[object Null]':
	      return 'null';
	    case '[object Number]':
	      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
	    case '[object String]':
	      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);
	    case '[object Undefined]':
	      return 'undefined';
	    default:
	      if (typeof x.toString === 'function') {
	        var repr = x.toString();
	        if (repr !== '[object Object]') {
	          return repr;
	        }
	      }
	      return '{' + mapPairs(x, keys(x)).join(', ') + '}';
	  }
	};


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _reduced = __webpack_require__(72);
	var _xfBase = __webpack_require__(27);
	
	
	module.exports = (function() {
	  function XAll(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.all = true;
	  }
	  XAll.prototype['@@transducer/init'] = _xfBase.init;
	  XAll.prototype['@@transducer/result'] = function(result) {
	    if (this.all) {
	      result = this.xf['@@transducer/step'](result, true);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAll.prototype['@@transducer/step'] = function(result, input) {
	    if (!this.f(input)) {
	      this.all = false;
	      result = _reduced(this.xf['@@transducer/step'](result, false));
	    }
	    return result;
	  };
	
	  return _curry2(function _xall(f, xf) { return new XAll(f, xf); });
	}());


/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(50);
	var _curry2 = __webpack_require__(2);
	var _xfBase = __webpack_require__(27);
	
	
	module.exports = (function() {
	  function XAperture(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XAperture.prototype['@@transducer/init'] = _xfBase.init;
	  XAperture.prototype['@@transducer/result'] = function(result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XAperture.prototype['@@transducer/step'] = function(result, input) {
	    this.store(input);
	    return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
	  };
	  XAperture.prototype.store = function(input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	  XAperture.prototype.getCopy = function() {
	    return _concat(Array.prototype.slice.call(this.acc, this.pos),
	                   Array.prototype.slice.call(this.acc, 0, this.pos));
	  };
	
	  return _curry2(function _xaperture(n, xf) { return new XAperture(n, xf); });
	}());


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _flatCat = __webpack_require__(770);
	var map = __webpack_require__(43);
	
	
	module.exports = _curry2(function _xchain(f, xf) {
	  return map(f, _flatCat(xf));
	});


/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _xfBase = __webpack_require__(27);
	
	
	module.exports = (function() {
	  function XDrop(n, xf) {
	    this.xf = xf;
	    this.n = n;
	  }
	  XDrop.prototype['@@transducer/init'] = _xfBase.init;
	  XDrop.prototype['@@transducer/result'] = _xfBase.result;
	  XDrop.prototype['@@transducer/step'] = function(result, input) {
	    if (this.n > 0) {
	      this.n -= 1;
	      return result;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdrop(n, xf) { return new XDrop(n, xf); });
	}());


/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _xfBase = __webpack_require__(27);
	
	
	module.exports = (function() {
	  function XDropLast(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XDropLast.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLast.prototype['@@transducer/result'] =  function(result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLast.prototype['@@transducer/step'] = function(result, input) {
	    if (this.full) {
	      result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
	    }
	    this.store(input);
	    return result;
	  };
	  XDropLast.prototype.store = function(input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	
	  return _curry2(function _xdropLast(n, xf) { return new XDropLast(n, xf); });
	}());


/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _reduce = __webpack_require__(49);
	var _xfBase = __webpack_require__(27);
	
	module.exports = (function() {
	  function XDropLastWhile(fn, xf) {
	    this.f = fn;
	    this.retained = [];
	    this.xf = xf;
	  }
	  XDropLastWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLastWhile.prototype['@@transducer/result'] = function(result) {
	    this.retained = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLastWhile.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.retain(result, input)
	                         : this.flush(result, input);
	  };
	  XDropLastWhile.prototype.flush = function(result, input) {
	    result = _reduce(
	      this.xf['@@transducer/step'],
	      result,
	      this.retained
	    );
	    this.retained = [];
	    return this.xf['@@transducer/step'](result, input);
	  };
	  XDropLastWhile.prototype.retain = function(result, input) {
	    this.retained.push(input);
	    return result;
	  };
	
	  return _curry2(function _xdropLastWhile(fn, xf) { return new XDropLastWhile(fn, xf); });
	}());


/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _xfBase = __webpack_require__(27);
	
	
	module.exports = (function() {
	  function XDropWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XDropWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XDropWhile.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f) {
	      if (this.f(input)) {
	        return result;
	      }
	      this.f = null;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdropWhile(f, xf) { return new XDropWhile(f, xf); });
	}());


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _xfBase = __webpack_require__(27);
	
	
	module.exports = (function() {
	  function XFilter(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFilter.prototype['@@transducer/init'] = _xfBase.init;
	  XFilter.prototype['@@transducer/result'] = _xfBase.result;
	  XFilter.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
	  };
	
	  return _curry2(function _xfilter(f, xf) { return new XFilter(f, xf); });
	}());


/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _reduced = __webpack_require__(72);
	var _xfBase = __webpack_require__(27);
	
	
	module.exports = (function() {
	  function XFind(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.found = false;
	  }
	  XFind.prototype['@@transducer/init'] = _xfBase.init;
	  XFind.prototype['@@transducer/result'] = function(result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, void 0);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFind.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, input));
	    }
	    return result;
	  };
	
	  return _curry2(function _xfind(f, xf) { return new XFind(f, xf); });
	}());


/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _reduced = __webpack_require__(72);
	var _xfBase = __webpack_require__(27);
	
	
	module.exports = (function() {
	  function XFindIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.found = false;
	  }
	  XFindIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindIndex.prototype['@@transducer/result'] = function(result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, -1);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFindIndex.prototype['@@transducer/step'] = function(result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, this.idx));
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindIndex(f, xf) { return new XFindIndex(f, xf); });
	}());


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _xfBase = __webpack_require__(27);
	
	
	module.exports = (function() {
	  function XFindLast(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFindLast.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLast.prototype['@@transducer/result'] = function(result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
	  };
	  XFindLast.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.last = input;
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindLast(f, xf) { return new XFindLast(f, xf); });
	}());


/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _xfBase = __webpack_require__(27);
	
	
	module.exports = (function() {
	  function XFindLastIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.lastIdx = -1;
	  }
	  XFindLastIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLastIndex.prototype['@@transducer/result'] = function(result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
	  };
	  XFindLastIndex.prototype['@@transducer/step'] = function(result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.lastIdx = this.idx;
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindLastIndex(f, xf) { return new XFindLastIndex(f, xf); });
	}());


/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _xfBase = __webpack_require__(27);
	
	
	module.exports = (function() {
	  function XMap(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XMap.prototype['@@transducer/init'] = _xfBase.init;
	  XMap.prototype['@@transducer/result'] = _xfBase.result;
	  XMap.prototype['@@transducer/step'] = function(result, input) {
	    return this.xf['@@transducer/step'](result, this.f(input));
	  };
	
	  return _curry2(function _xmap(f, xf) { return new XMap(f, xf); });
	}());


/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(147);
	var _has = __webpack_require__(39);
	var _xfBase = __webpack_require__(27);
	
	
	module.exports = (function() {
	  function XReduceBy(valueFn, valueAcc, keyFn, xf) {
	    this.valueFn = valueFn;
	    this.valueAcc = valueAcc;
	    this.keyFn = keyFn;
	    this.xf = xf;
	    this.inputs = {};
	  }
	  XReduceBy.prototype['@@transducer/init'] = _xfBase.init;
	  XReduceBy.prototype['@@transducer/result'] = function(result) {
	    var key;
	    for (key in this.inputs) {
	      if (_has(key, this.inputs)) {
	        result = this.xf['@@transducer/step'](result, this.inputs[key]);
	        if (result['@@transducer/reduced']) {
	          result = result['@@transducer/value'];
	          break;
	        }
	      }
	    }
	    this.inputs = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XReduceBy.prototype['@@transducer/step'] = function(result, input) {
	    var key = this.keyFn(input);
	    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
	    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
	    return result;
	  };
	
	  return _curryN(4, [],
	                 function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
	                   return new XReduceBy(valueFn, valueAcc, keyFn, xf);
	                 });
	}());


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _reduced = __webpack_require__(72);
	var _xfBase = __webpack_require__(27);
	
	module.exports = (function() {
	  function XTake(n, xf) {
	    this.xf = xf;
	    this.n = n;
	    this.i = 0;
	  }
	  XTake.prototype['@@transducer/init'] = _xfBase.init;
	  XTake.prototype['@@transducer/result'] = _xfBase.result;
	  XTake.prototype['@@transducer/step'] = function(result, input) {
	    this.i += 1;
	    var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
	    return this.i >= this.n ? _reduced(ret) : ret;
	  };
	
	  return _curry2(function _xtake(n, xf) { return new XTake(n, xf); });
	}());


/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _reduced = __webpack_require__(72);
	var _xfBase = __webpack_require__(27);
	
	
	module.exports = (function() {
	  function XTakeWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XTakeWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XTakeWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XTakeWhile.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : _reduced(result);
	  };
	
	  return _curry2(function _xtakeWhile(f, xf) { return new XTakeWhile(f, xf); });
	}());


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(81);
	var _curry2 = __webpack_require__(2);
	var _filter = __webpack_require__(430);
	var flip = __webpack_require__(146);
	var uniq = __webpack_require__(213);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of those
	 * elements common to both lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The list of elements found in both `list1` and `list2`.
	 * @see R.intersectionWith
	 * @example
	 *
	 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
	 */
	module.exports = _curry2(function intersection(list1, list2) {
	  var lookupList, filteredList;
	  if (list1.length > list2.length) {
	    lookupList = list1;
	    filteredList = list2;
	  } else {
	    lookupList = list2;
	    filteredList = list1;
	  }
	  return uniq(_filter(flip(_contains)(lookupList), filteredList));
	});


/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(207);
	var _curry3 = __webpack_require__(9);
	var uniqWith = __webpack_require__(214);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of those
	 * elements common to both lists. Duplication is determined according to the
	 * value returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate function that determines whether
	 *        the two supplied elements are equal.
	 * @param {Array} list1 One list of items to compare
	 * @param {Array} list2 A second list of items to compare
	 * @return {Array} A new list containing those elements common to both lists.
	 * @see R.intersection
	 * @example
	 *
	 *      var buffaloSpringfield = [
	 *        {id: 824, name: 'Richie Furay'},
	 *        {id: 956, name: 'Dewey Martin'},
	 *        {id: 313, name: 'Bruce Palmer'},
	 *        {id: 456, name: 'Stephen Stills'},
	 *        {id: 177, name: 'Neil Young'}
	 *      ];
	 *      var csny = [
	 *        {id: 204, name: 'David Crosby'},
	 *        {id: 456, name: 'Stephen Stills'},
	 *        {id: 539, name: 'Graham Nash'},
	 *        {id: 177, name: 'Neil Young'}
	 *      ];
	 *
	 *      R.intersectionWith(R.eqBy(R.prop('id')), buffaloSpringfield, csny);
	 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
	 */
	module.exports = _curry3(function intersectionWith(pred, list1, list2) {
	  var lookupList, filteredList;
	  if (list1.length > list2.length) {
	    lookupList = list1;
	    filteredList = list2;
	  } else {
	    lookupList = list2;
	    filteredList = list1;
	  }
	  var results = [];
	  var idx = 0;
	  while (idx < filteredList.length) {
	    if (_containsWith(pred, filteredList[idx], lookupList)) {
	      results[results.length] = filteredList[idx];
	    }
	    idx += 1;
	  }
	  return uniqWith(pred, results);
	});


/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(110);
	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Creates a new list with the separator interposed between elements.
	 *
	 * Dispatches to the `intersperse` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} separator The element to add to the list.
	 * @param {Array} list The list to be interposed.
	 * @return {Array} The new list.
	 * @example
	 *
	 *      R.intersperse('n', ['ba', 'a', 'a']); //=> ['ba', 'n', 'a', 'n', 'a']
	 */
	module.exports = _curry2(_checkForMethod('intersperse', function intersperse(separator, list) {
	  var out = [];
	  var idx = 0;
	  var length = list.length;
	  while (idx < length) {
	    if (idx === length - 1) {
	      out.push(list[idx]);
	    } else {
	      out.push(list[idx], separator);
	    }
	    idx += 1;
	  }
	  return out;
	}));


/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	var _clone = __webpack_require__(426);
	var _curry3 = __webpack_require__(9);
	var _isTransformer = __webpack_require__(209);
	var _reduce = __webpack_require__(49);
	var _stepCat = __webpack_require__(779);
	
	
	/**
	 * Transforms the items of the list with the transducer and appends the
	 * transformed items to the accumulator using an appropriate iterator function
	 * based on the accumulator type.
	 *
	 * The accumulator can be an array, string, object or a transformer. Iterated
	 * items will be appended to arrays and concatenated to strings. Objects will
	 * be merged directly or 2-item arrays will be merged as key, value pairs.
	 *
	 * The accumulator can also be a transformer object that provides a 2-arity
	 * reducing iterator function, step, 0-arity initial value function, init, and
	 * 1-arity result extraction function result. The step function is used as the
	 * iterator function in reduce. The result function is used to convert the
	 * final accumulator into the return type and in most cases is R.identity. The
	 * init function is used to provide the initial accumulator.
	 *
	 * The iteration is performed with R.reduce after initializing the transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig a -> (b -> b) -> [c] -> a
	 * @param {*} acc The initial accumulator value.
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *
	 *      R.into([], transducer, numbers); //=> [2, 3]
	 *
	 *      var intoArray = R.into([]);
	 *      intoArray(transducer, numbers); //=> [2, 3]
	 */
	module.exports = _curry3(function into(acc, xf, list) {
	  return _isTransformer(acc) ?
	    _reduce(xf(acc), acc['@@transducer/init'](), list) :
	    _reduce(xf(_stepCat(acc)), _clone(acc, [], [], false), list);
	});


/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var _has = __webpack_require__(39);
	var keys = __webpack_require__(56);
	
	
	/**
	 * Same as R.invertObj, however this accounts for objects with duplicate values
	 * by putting the values into an array.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: [ s, ... ]}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object with keys
	 * in an array.
	 * @example
	 *
	 *      var raceResultsByFirstName = {
	 *        first: 'alice',
	 *        second: 'jake',
	 *        third: 'alice',
	 *      };
	 *      R.invert(raceResultsByFirstName);
	 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
	 */
	module.exports = _curry1(function invert(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    var val = obj[key];
	    var list = _has(val, out) ? out[val] : (out[val] = []);
	    list[list.length] = key;
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var keys = __webpack_require__(56);
	
	
	/**
	 * Returns a new object with the keys of the given object as values, and the
	 * values of the given object, which are coerced to strings, as keys. Note
	 * that the last key found is preferred when handling the same value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: s}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object
	 * @example
	 *
	 *      var raceResults = {
	 *        first: 'alice',
	 *        second: 'jake'
	 *      };
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': 'first', 'jake':'second' }
	 *
	 *      // Alternatively:
	 *      var raceResults = ['alice', 'jake'];
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': '0', 'jake':'1' }
	 */
	module.exports = _curry1(function invertObj(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    out[obj[key]] = key;
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var empty = __webpack_require__(424);
	var equals = __webpack_require__(54);
	
	
	/**
	 * Returns `true` if the given value is its type's empty value; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> Boolean
	 * @param {*} x
	 * @return {Boolean}
	 * @see R.empty
	 * @example
	 *
	 *      R.isEmpty([1, 2, 3]);   //=> false
	 *      R.isEmpty([]);          //=> true
	 *      R.isEmpty('');          //=> true
	 *      R.isEmpty(null);        //=> false
	 *      R.isEmpty({});          //=> true
	 *      R.isEmpty({length: 0}); //=> false
	 */
	module.exports = _curry1(function isEmpty(x) {
	  return x != null && equals(x, empty(x));
	});


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	
	
	/**
	 * Checks if the input value is `null` or `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Type
	 * @sig * -> Boolean
	 * @param {*} x The value to test.
	 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
	 * @example
	 *
	 *      R.isNil(null); //=> true
	 *      R.isNil(undefined); //=> true
	 *      R.isNil(0); //=> false
	 *      R.isNil([]); //=> false
	 */
	module.exports = _curry1(function isNil(x) { return x == null; });


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(111);
	
	
	/**
	 * Returns a string made by inserting the `separator` between each element and
	 * concatenating all the elements into a single string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig String -> [a] -> String
	 * @param {Number|String} separator The string used to separate the elements.
	 * @param {Array} xs The elements to join into a string.
	 * @return {String} str The string made by concatenating `xs` with `separator`.
	 * @see R.split
	 * @example
	 *
	 *      var spacer = R.join(' ');
	 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
	 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
	 */
	module.exports = invoker(1, 'join');


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	
	
	/**
	 * Returns a list containing the names of all the properties of the supplied
	 * object, including prototype properties.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.keysIn(f); //=> ['x', 'y']
	 */
	module.exports = _curry1(function keysIn(obj) {
	  var prop;
	  var ks = [];
	  for (prop in obj) {
	    ks[ks.length] = prop;
	  }
	  return ks;
	});


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _isArray = __webpack_require__(71);
	var equals = __webpack_require__(54);
	
	
	/**
	 * Returns the position of the last occurrence of an item in an array, or -1 if
	 * the item is not included in the array. `R.equals` is used to determine
	 * equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.indexOf
	 * @example
	 *
	 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
	 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
	 */
	module.exports = _curry2(function lastIndexOf(target, xs) {
	  if (typeof xs.lastIndexOf === 'function' && !_isArray(xs)) {
	    return xs.lastIndexOf(target);
	  } else {
	    var idx = xs.length - 1;
	    while (idx >= 0) {
	      if (equals(xs[idx], target)) {
	        return idx;
	      }
	      idx -= 1;
	    }
	    return -1;
	  }
	});


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var lens = __webpack_require__(152);
	var nth = __webpack_require__(113);
	var update = __webpack_require__(462);
	
	
	/**
	 * Returns a lens whose focus is the specified index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Number -> Lens s a
	 * @param {Number} n
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var headLens = R.lensIndex(0);
	 *
	 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
	 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
	 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
	 */
	module.exports = _curry1(function lensIndex(n) {
	  return lens(nth(n), update(n));
	});


/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var assocPath = __webpack_require__(413);
	var lens = __webpack_require__(152);
	var path = __webpack_require__(114);
	
	
	/**
	 * Returns a lens whose focus is the specified path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig [Idx] -> Lens s a
	 * @param {Array} path The path to use.
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var xHeadYLens = R.lensPath(['x', 0, 'y']);
	 *
	 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> 2
	 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
	 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
	 */
	module.exports = _curry1(function lensPath(p) {
	  return lens(path(p), assocPath(p));
	});


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var assoc = __webpack_require__(144);
	var lens = __webpack_require__(152);
	var prop = __webpack_require__(210);
	
	
	/**
	 * Returns a lens whose focus is the specified property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig String -> Lens s a
	 * @param {String} k
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	module.exports = _curry1(function lensProp(k) {
	  return lens(prop(k), assoc(k));
	});


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns `true` if the first argument is less than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.gt
	 * @example
	 *
	 *      R.lt(2, 1); //=> false
	 *      R.lt(2, 2); //=> false
	 *      R.lt(2, 3); //=> true
	 *      R.lt('a', 'z'); //=> true
	 *      R.lt('z', 'a'); //=> false
	 */
	module.exports = _curry2(function lt(a, b) { return a < b; });


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns `true` if the first argument is less than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.gte
	 * @example
	 *
	 *      R.lte(2, 1); //=> false
	 *      R.lte(2, 2); //=> true
	 *      R.lte(2, 3); //=> true
	 *      R.lte('a', 'z'); //=> true
	 *      R.lte('z', 'a'); //=> false
	 */
	module.exports = _curry2(function lte(a, b) { return a <= b; });


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * The mapAccum function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from left to right, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * The iterator function receives two arguments, *acc* and *value*, and should
	 * return a tuple *[acc, value]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (acc -> x -> (acc, y)) -> acc -> [x] -> (acc, [y])
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.addIndex, R.mapAccumRight
	 * @example
	 *
	 *      var digits = ['1', '2', '3', '4'];
	 *      var appender = (a, b) => [a + b, a + b];
	 *
	 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
	 * @symb R.mapAccum(f, a, [b, c, d]) = [
	 *   f(f(f(a, b)[0], c)[0], d)[0],
	 *   [
	 *     f(a, b)[1],
	 *     f(f(a, b)[0], c)[1],
	 *     f(f(f(a, b)[0], c)[0], d)[1]
	 *   ]
	 * ]
	 */
	module.exports = _curry3(function mapAccum(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var tuple = [acc];
	  while (idx < len) {
	    tuple = fn(tuple[0], list[idx]);
	    result[idx] = tuple[1];
	    idx += 1;
	  }
	  return [tuple[0], result];
	});


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * The mapAccumRight function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from right to left, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * Similar to `mapAccum`, except moves through the input list from the right to
	 * the left.
	 *
	 * The iterator function receives two arguments, *value* and *acc*, and should
	 * return a tuple *[value, acc]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (x-> acc -> (y, acc)) -> acc -> [x] -> ([y], acc)
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.addIndex, R.mapAccum
	 * @example
	 *
	 *      var digits = ['1', '2', '3', '4'];
	 *      var append = (a, b) => [a + b, a + b];
	 *
	 *      R.mapAccumRight(append, 5, digits); //=> [['12345', '2345', '345', '45'], '12345']
	 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
	 *   [
	 *     f(b, f(c, f(d, a)[0])[0])[1],
	 *     f(c, f(d, a)[0])[1],
	 *     f(d, a)[1],
	 *   ]
	 *   f(b, f(c, f(d, a)[0])[0])[0],
	 * ]
	 */
	module.exports = _curry3(function mapAccumRight(fn, acc, list) {
	  var idx = list.length - 1;
	  var result = [];
	  var tuple = [acc];
	  while (idx >= 0) {
	    tuple = fn(list[idx], tuple[0]);
	    result[idx] = tuple[1];
	    idx -= 1;
	  }
	  return [result, tuple[0]];
	});


/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _reduce = __webpack_require__(49);
	var keys = __webpack_require__(56);
	
	
	/**
	 * An Object-specific version of `map`. The function is applied to three
	 * arguments: *(value, key, obj)*. If only the value is significant, use
	 * `map` instead.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig ((*, String, Object) -> *) -> Object -> Object
	 * @param {Function} fn
	 * @param {Object} obj
	 * @return {Object}
	 * @see R.map
	 * @example
	 *
	 *      var values = { x: 1, y: 2, z: 3 };
	 *      var prependKeyAndDouble = (num, key, obj) => key + (num * 2);
	 *
	 *      R.mapObjIndexed(prependKeyAndDouble, values); //=> { x: 'x2', y: 'y4', z: 'z6' }
	 */
	module.exports = _curry2(function mapObjIndexed(fn, obj) {
	  return _reduce(function(acc, key) {
	    acc[key] = fn(obj[key], key, obj);
	    return acc;
	  }, {}, keys(obj));
	});


/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Tests a regular expression against a String. Note that this function will
	 * return an empty array when there are no matches. This differs from
	 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
	 * which returns `null` when there are no matches.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig RegExp -> String -> [String | Undefined]
	 * @param {RegExp} rx A regular expression.
	 * @param {String} str The string to match against
	 * @return {Array} The list of matches or empty array.
	 * @see R.test
	 * @example
	 *
	 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
	 *      R.match(/a/, 'b'); //=> []
	 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
	 */
	module.exports = _curry2(function match(rx, str) {
	  return str.match(rx) || [];
	});


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _isInteger = __webpack_require__(433);
	
	
	/**
	 * mathMod behaves like the modulo operator should mathematically, unlike the
	 * `%` operator (and by extension, R.modulo). So while "-17 % 5" is -2,
	 * mathMod(-17, 5) is 3. mathMod requires Integer arguments, and returns NaN
	 * when the modulus is zero or negative.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} m The dividend.
	 * @param {Number} p the modulus.
	 * @return {Number} The result of `b mod a`.
	 * @example
	 *
	 *      R.mathMod(-17, 5);  //=> 3
	 *      R.mathMod(17, 5);   //=> 2
	 *      R.mathMod(17, -5);  //=> NaN
	 *      R.mathMod(17, 0);   //=> NaN
	 *      R.mathMod(17.2, 5); //=> NaN
	 *      R.mathMod(17, 5.3); //=> NaN
	 *
	 *      var clock = R.mathMod(R.__, 12);
	 *      clock(15); //=> 3
	 *      clock(24); //=> 0
	 *
	 *      var seventeenMod = R.mathMod(17);
	 *      seventeenMod(3);  //=> 2
	 *      seventeenMod(4);  //=> 1
	 *      seventeenMod(10); //=> 7
	 */
	module.exports = _curry2(function mathMod(m, p) {
	  if (!_isInteger(m)) { return NaN; }
	  if (!_isInteger(p) || p < 1) { return NaN; }
	  return ((m % p) + p) % p;
	});


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * larger result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.max, R.minBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      var square = n => n * n;
	 *
	 *      R.maxBy(square, -3, 2); //=> -3
	 *
	 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
	 *      R.reduce(R.maxBy(square), 0, []); //=> 0
	 */
	module.exports = _curry3(function maxBy(f, a, b) {
	  return f(b) > f(a) ? b : a;
	});


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var mean = __webpack_require__(445);
	
	
	/**
	 * Returns the median of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @example
	 *
	 *      R.median([2, 9, 7]); //=> 7
	 *      R.median([7, 2, 10, 9]); //=> 8
	 *      R.median([]); //=> NaN
	 */
	module.exports = _curry1(function median(list) {
	  var len = list.length;
	  if (len === 0) {
	    return NaN;
	  }
	  var width = 2 - len % 2;
	  var idx = (len - width) / 2;
	  return mean(Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    return a < b ? -1 : a > b ? 1 : 0;
	  }).slice(idx, idx + width));
	});


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(55);
	var _curry1 = __webpack_require__(6);
	var _has = __webpack_require__(39);
	var toString = __webpack_require__(116);
	
	
	/**
	 * Creates a new function that, when invoked, caches the result of calling `fn`
	 * for a given argument set and returns the result. Subsequent calls to the
	 * memoized `fn` with the same argument set will not result in an additional
	 * call to `fn`; instead, the cached result for that set of arguments will be
	 * returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (*... -> a) -> (*... -> a)
	 * @param {Function} fn The function to memoize.
	 * @return {Function} Memoized version of `fn`.
	 * @example
	 *
	 *      var count = 0;
	 *      var factorial = R.memoize(n => {
	 *        count += 1;
	 *        return R.product(R.range(1, n + 1));
	 *      });
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      count; //=> 1
	 */
	module.exports = _curry1(function memoize(fn) {
	  var cache = {};
	  return _arity(fn.length, function() {
	    var key = toString(arguments);
	    if (!_has(key, cache)) {
	      cache[key] = fn.apply(this, arguments);
	    }
	    return cache[key];
	  });
	});


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(206);
	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Create a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects,
	 * the value from the second object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> {k: v} -> {k: v}
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeWith, R.mergeWithKey
	 * @example
	 *
	 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
	 *      //=> { 'name': 'fred', 'age': 40 }
	 *
	 *      var resetToDefault = R.merge(R.__, {x: 0});
	 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
	 * @symb R.merge({ x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: 5, z: 3 }
	 */
	module.exports = _curry2(function merge(l, r) {
	  return _assign({}, l, r);
	});


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(206);
	var _curry1 = __webpack_require__(6);
	
	
	/**
	 * Merges a list of objects together into one object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig [{k: v}] -> {k: v}
	 * @param {Array} list An array of objects
	 * @return {Object} A merged object.
	 * @see R.reduce
	 * @example
	 *
	 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
	 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
	 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
	 */
	module.exports = _curry1(function mergeAll(list) {
	  return _assign.apply(null, [{}].concat(list));
	});


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	var mergeWithKey = __webpack_require__(446);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the values
	 * associated with the key in each object, with the result being used as the
	 * value associated with the key in the returned object. The key will be
	 * excluded from the returned object if the resulting value is `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig (a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.merge, R.mergeWithKey
	 * @example
	 *
	 *      R.mergeWith(R.concat,
	 *                  { a: true, values: [10, 20] },
	 *                  { b: true, values: [15, 35] });
	 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
	 */
	module.exports = _curry3(function mergeWith(fn, l, r) {
	  return mergeWithKey(function(_, _l, _r) {
	    return fn(_l, _r);
	  }, l, r);
	});


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns the smaller of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.minBy, R.max
	 * @example
	 *
	 *      R.min(789, 123); //=> 123
	 *      R.min('a', 'b'); //=> 'a'
	 */
	module.exports = _curry2(function min(a, b) { return b < a ? b : a; });


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * smaller result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.min, R.maxBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      var square = n => n * n;
	 *
	 *      R.minBy(square, -3, 2); //=> 2
	 *
	 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
	 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
	 */
	module.exports = _curry3(function minBy(f, a, b) {
	  return f(b) < f(a) ? b : a;
	});


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Divides the first parameter by the second and returns the remainder. Note
	 * that this function preserves the JavaScript-style behavior for modulo. For
	 * mathematical modulo see `mathMod`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The value to the divide.
	 * @param {Number} b The pseudo-modulus
	 * @return {Number} The result of `b % a`.
	 * @see R.mathMod
	 * @example
	 *
	 *      R.modulo(17, 3); //=> 2
	 *      // JS behavior:
	 *      R.modulo(-17, 3); //=> -2
	 *      R.modulo(17, -3); //=> 2
	 *
	 *      var isOdd = R.modulo(R.__, 2);
	 *      isOdd(42); //=> 0
	 *      isOdd(21); //=> 1
	 */
	module.exports = _curry2(function modulo(a, b) { return a % b; });


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	
	
	/**
	 * Negates its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number}
	 * @example
	 *
	 *      R.negate(42); //=> -42
	 */
	module.exports = _curry1(function negate(n) { return -n; });


/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	var _complement = __webpack_require__(428);
	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _xany = __webpack_require__(437);
	var any = __webpack_require__(411);
	
	
	/**
	 * Returns `true` if no elements of the list match the predicate, `false`
	 * otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
	 * @see R.all, R.any
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
	 *      R.none(isEven, [1, 3, 5, 7, 8, 11]); //=> false
	 */
	module.exports = _curry2(_complement(_dispatchable(['any'], _xany, any)));


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var curryN = __webpack_require__(35);
	var nth = __webpack_require__(113);
	
	
	/**
	 * Returns a function which returns its nth argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig Number -> *... -> *
	 * @param {Number} n
	 * @return {Function}
	 * @example
	 *
	 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
	 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
	 * @symb R.nthArg(-1)(a, b, c) = c
	 * @symb R.nthArg(0)(a, b, c) = a
	 * @symb R.nthArg(1)(a, b, c) = b
	 */
	module.exports = _curry1(function nthArg(n) {
	  var arity = n < 0 ? 1 : n + 1;
	  return curryN(arity, function() {
	    return nth(n, arguments);
	  });
	});


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var _of = __webpack_require__(775);
	
	
	/**
	 * Returns a singleton array containing the value provided.
	 *
	 * Note this `of` is different from the ES6 `of`; See
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> [a]
	 * @param {*} x any value
	 * @return {Array} An array wrapping `x`.
	 * @example
	 *
	 *      R.of(null); //=> [null]
	 *      R.of([42]); //=> [[42]]
	 */
	module.exports = _curry1(_of);


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(81);
	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns a partial copy of an object omitting the keys specified.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [String] -> {String: *} -> {String: *}
	 * @param {Array} names an array of String property names to omit from the new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with properties from `names` not on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
	 */
	module.exports = _curry2(function omit(names, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (!_contains(prop, names)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(55);
	var _curry1 = __webpack_require__(6);
	
	
	/**
	 * Accepts a function `fn` and returns a function that guards invocation of
	 * `fn` such that `fn` can only ever be called once, no matter how many times
	 * the returned function is invoked. The first value calculated is returned in
	 * subsequent invocations.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a... -> b) -> (a... -> b)
	 * @param {Function} fn The function to wrap in a call-only-once wrapper.
	 * @return {Function} The wrapped function.
	 * @example
	 *
	 *      var addOneOnce = R.once(x => x + 1);
	 *      addOneOnce(10); //=> 11
	 *      addOneOnce(addOneOnce(50)); //=> 11
	 */
	module.exports = _curry1(function once(fn) {
	  var called = false;
	  var result;
	  return _arity(fn.length, function() {
	    if (called) {
	      return result;
	    }
	    called = true;
	    result = fn.apply(this, arguments);
	    return result;
	  });
	});


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category List
	 * @sig a -> b -> (a,b)
	 * @param {*} fst
	 * @param {*} snd
	 * @return {Array}
	 * @see R.objOf, R.of
	 * @example
	 *
	 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
	 */
	module.exports = _curry2(function pair(fst, snd) { return [fst, snd]; });


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(50);
	var _createPartialApplicator = __webpack_require__(429);
	
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided initially followed by the arguments provided to `g`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partialRight
	 * @example
	 *
	 *      var multiply2 = (a, b) => a * b;
	 *      var double = R.partial(multiply2, [2]);
	 *      double(2); //=> 4
	 *
	 *      var greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      var sayHello = R.partial(greet, ['Hello']);
	 *      var sayHelloToMs = R.partial(sayHello, ['Ms.']);
	 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
	 */
	module.exports = _createPartialApplicator(_concat);


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(50);
	var _createPartialApplicator = __webpack_require__(429);
	var flip = __webpack_require__(146);
	
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided to `g` followed by the arguments provided initially.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partial
	 * @example
	 *
	 *      var greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
	 *
	 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
	 */
	module.exports = _createPartialApplicator(flip(_concat));


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	var filter = __webpack_require__(204);
	var juxt = __webpack_require__(441);
	var reject = __webpack_require__(156);
	
	
	/**
	 * Takes a predicate and a list or other "filterable" object and returns the
	 * pair of filterable objects of the same type of elements which do and do not
	 * satisfy, the predicate, respectively.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
	 * @param {Function} pred A predicate to determine which side the element belongs to.
	 * @param {Array} filterable the list (or other filterable) to partition.
	 * @return {Array} An array, containing first the subset of elements that satisfy the
	 *         predicate, and second the subset of elements that do not satisfy.
	 * @see R.filter, R.reject
	 * @example
	 *
	 *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
	 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
	 *
	 *      R.partition(R.contains('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
	 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
	 */
	module.exports = juxt([filter, reject]);


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	var equals = __webpack_require__(54);
	var path = __webpack_require__(114);
	
	
	/**
	 * Determines whether a nested path on an object has a specific value, in
	 * `R.equals` terms. Most likely used to filter a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Relation
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> Boolean
	 * @param {Array} path The path of the nested property to use
	 * @param {*} val The value to compare the nested property with
	 * @param {Object} obj The object to check the nested property in
	 * @return {Boolean} `true` if the value equals the nested object property,
	 *         `false` otherwise.
	 * @example
	 *
	 *      var user1 = { address: { zipCode: 90210 } };
	 *      var user2 = { address: { zipCode: 55555 } };
	 *      var user3 = { name: 'Bob' };
	 *      var users = [ user1, user2, user3 ];
	 *      var isFamous = R.pathEq(['address', 'zipCode'], 90210);
	 *      R.filter(isFamous, users); //=> [ user1 ]
	 */
	module.exports = _curry3(function pathEq(_path, val, obj) {
	  return equals(path(_path, obj), val);
	});


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	var defaultTo = __webpack_require__(418);
	var path = __webpack_require__(114);
	
	
	/**
	 * If the given, non-null object has a value at the given path, returns the
	 * value at that path. Otherwise returns the provided default value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig a -> [Idx] -> {a} -> a
	 * @param {*} d The default value.
	 * @param {Array} p The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path` of the supplied object or the default value.
	 * @example
	 *
	 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
	 */
	module.exports = _curry3(function pathOr(d, p, obj) {
	  return defaultTo(d, path(p, obj));
	});


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	var path = __webpack_require__(114);
	
	
	/**
	 * Returns `true` if the specified object property at given path satisfies the
	 * given predicate; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Logic
	 * @typedefn Idx = String | Int
	 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
	 * @param {Function} pred
	 * @param {Array} propPath
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.propSatisfies, R.path
	 * @example
	 *
	 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
	 */
	module.exports = _curry3(function pathSatisfies(pred, propPath, obj) {
	  return propPath.length > 0 && pred(path(propPath, obj));
	});


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns a partial copy of an object containing only the keys specified. If
	 * the key does not exist, the property is ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.omit, R.props
	 * @example
	 *
	 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
	 */
	module.exports = _curry2(function pick(names, obj) {
	  var result = {};
	  var idx = 0;
	  while (idx < names.length) {
	    if (names[idx] in obj) {
	      result[names[idx]] = obj[names[idx]];
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns a partial copy of an object containing only the keys that satisfy
	 * the supplied predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig (v, k -> Boolean) -> {k: v} -> {k: v}
	 * @param {Function} pred A predicate to determine whether or not a key
	 *        should be included on the output object.
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties that satisfy `pred`
	 *         on it.
	 * @see R.pick, R.filter
	 * @example
	 *
	 *      var isUpperCase = (val, key) => key.toUpperCase() === key;
	 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
	 */
	module.exports = _curry2(function pickBy(test, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (test(obj[prop], prop, obj)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	var composeK = __webpack_require__(415);
	var reverse = __webpack_require__(157);
	
	/**
	 * Returns the left-to-right Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.pipeK(f, g, h)` is equivalent to `R.pipe(R.chain(f), R.chain(g), R.chain(h))`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((a -> m b), (b -> m c), ..., (y -> m z)) -> (a -> m z)
	 * @param {...Function}
	 * @return {Function}
	 * @see R.composeK
	 * @example
	 *
	 *      //  parseJson :: String -> Maybe *
	 *      //  get :: String -> Object -> Maybe *
	 *
	 *      //  getStateCode :: Maybe String -> Maybe String
	 *      var getStateCode = R.pipeK(
	 *        parseJson,
	 *        get('user'),
	 *        get('address'),
	 *        get('state'),
	 *        R.compose(Maybe.of, R.toUpper)
	 *      );
	 *
	 *      getStateCode('{"user":{"address":{"state":"ny"}}}');
	 *      //=> Just('NY')
	 *      getStateCode('[Invalid JSON]');
	 *      //=> Nothing()
	 * @symb R.pipeK(f, g, h)(a) = R.chain(h, R.chain(g, f(a)))
	 */
	module.exports = function pipeK() {
	  if (arguments.length === 0) {
	    throw new Error('pipeK requires at least one argument');
	  }
	  return composeK.apply(this, reverse(arguments));
	};


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	var multiply = __webpack_require__(447);
	var reduce = __webpack_require__(57);
	
	
	/**
	 * Multiplies together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The product of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.product([2,4,6,8,100,1]); //=> 38400
	 */
	module.exports = reduce(multiply, 1);


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	var _map = __webpack_require__(151);
	var identity = __webpack_require__(205);
	var pickAll = __webpack_require__(452);
	var useWith = __webpack_require__(463);
	
	
	/**
	 * Reasonable analog to SQL `select` statement.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @category Relation
	 * @sig [k] -> [{k: v}] -> [{k: v}]
	 * @param {Array} props The property names to project
	 * @param {Array} objs The objects to query
	 * @return {Array} An array of objects with just the `props` properties.
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
	 *      var kids = [abby, fred];
	 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
	 */
	module.exports = useWith(_map, [pickAll, identity]); // passing `identity` gives correct arity


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	var equals = __webpack_require__(54);
	
	
	/**
	 * Returns `true` if the specified object property is equal, in `R.equals`
	 * terms, to the given value; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig String -> a -> Object -> Boolean
	 * @param {String} name
	 * @param {*} val
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.equals, R.propSatisfies
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond'};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown'};
	 *      var rusty = {name: 'Rusty', age: 10, hair: 'brown'};
	 *      var alois = {name: 'Alois', age: 15, disposition: 'surly'};
	 *      var kids = [abby, fred, rusty, alois];
	 *      var hasBrownHair = R.propEq('hair', 'brown');
	 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
	 */
	module.exports = _curry3(function propEq(name, val, obj) {
	  return equals(val, obj[name]);
	});


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	var is = __webpack_require__(440);
	
	
	/**
	 * Returns `true` if the specified object property is of the given type;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Type
	 * @sig Type -> String -> Object -> Boolean
	 * @param {Function} type
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.is, R.propSatisfies
	 * @example
	 *
	 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
	 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
	 *      R.propIs(Number, 'x', {});            //=> false
	 */
	module.exports = _curry3(function propIs(type, name, obj) {
	  return is(type, obj[name]);
	});


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	var _has = __webpack_require__(39);
	
	
	/**
	 * If the given, non-null object has an own property with the specified name,
	 * returns the value of that property. Otherwise returns the provided default
	 * value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Object
	 * @sig a -> String -> Object -> a
	 * @param {*} val The default value.
	 * @param {String} p The name of the property to return.
	 * @param {Object} obj The object to query.
	 * @return {*} The value of given property of the supplied object or the default value.
	 * @example
	 *
	 *      var alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      var favorite = R.prop('favoriteLibrary');
	 *      var favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
	 *
	 *      favorite(alice);  //=> undefined
	 *      favoriteWithDefault(alice);  //=> 'Ramda'
	 */
	module.exports = _curry3(function propOr(val, p, obj) {
	  return (obj != null && _has(p, obj)) ? obj[p] : val;
	});


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Returns `true` if the specified object property satisfies the given
	 * predicate; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Logic
	 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
	 * @param {Function} pred
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.propEq, R.propIs
	 * @example
	 *
	 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
	 */
	module.exports = _curry3(function propSatisfies(pred, name, obj) {
	  return pred(obj[name]);
	});


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> [v]
	 * @param {Array} ps The property names to fetch
	 * @param {Object} obj The object to query
	 * @return {Array} The corresponding values or partially applied function.
	 * @example
	 *
	 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
	 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
	 *
	 *      var fullName = R.compose(R.join(' '), R.props(['first', 'last']));
	 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
	 */
	module.exports = _curry2(function props(ps, obj) {
	  var len = ps.length;
	  var out = [];
	  var idx = 0;
	
	  while (idx < len) {
	    out[idx] = obj[ps[idx]];
	    idx += 1;
	  }
	
	  return out;
	});


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _isNumber = __webpack_require__(434);
	
	
	/**
	 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> Number -> [Number]
	 * @param {Number} from The first number in the list.
	 * @param {Number} to One more than the last number in the list.
	 * @return {Array} The list of numbers in tthe set `[a, b)`.
	 * @example
	 *
	 *      R.range(1, 5);    //=> [1, 2, 3, 4]
	 *      R.range(50, 53);  //=> [50, 51, 52]
	 */
	module.exports = _curry2(function range(from, to) {
	  if (!(_isNumber(from) && _isNumber(to))) {
	    throw new TypeError('Both arguments to range must be numbers');
	  }
	  var result = [];
	  var n = from;
	  while (n < to) {
	    result.push(n);
	    n += 1;
	  }
	  return result;
	});


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(147);
	var _reduce = __webpack_require__(49);
	var _reduced = __webpack_require__(72);
	
	
	/**
	 * Like `reduce`, `reduceWhile` returns a single item by iterating through
	 * the list, successively calling the iterator function. `reduceWhile` also
	 * takes a predicate that is evaluated before each step. If the predicate returns
	 * `false`, it "short-circuits" the iteration and returns the current value
	 * of the accumulator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.22.0
	 * @category List
	 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} pred The predicate. It is passed the accumulator and the
	 *        current element.
	 * @param {Function} fn The iterator function. Receives two values, the
	 *        accumulator and the current element.
	 * @param {*} a The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced
	 * @example
	 *
	 *      var isOdd = (acc, x) => x % 2 === 1;
	 *      var xs = [1, 3, 5, 60, 777, 800];
	 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
	 *
	 *      var ys = [2, 4, 6]
	 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
	 */
	module.exports = _curryN(4, [], function _reduceWhile(pred, fn, a, list) {
	  return _reduce(function(acc, x) {
	    return pred(acc, x) ? fn(acc, x) : _reduced(acc);
	  }, a, list);
	});


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var _reduced = __webpack_require__(72);
	
	/**
	 * Returns a value wrapped to indicate that it is the final value of the reduce
	 * and transduce functions. The returned value should be considered a black
	 * box: the internal structure is not guaranteed to be stable.
	 *
	 * Note: this optimization is unavailable to functions not explicitly listed
	 * above. For instance, it is not currently supported by reduceRight.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category List
	 * @sig a -> *
	 * @param {*} x The final value of the reduce.
	 * @return {*} The wrapped value.
	 * @see R.reduce, R.transduce
	 * @example
	 *
	 *      R.reduce(
	 *        R.pipe(R.add, R.when(R.gte(R.__, 10), R.reduced)),
	 *        0,
	 *        [1, 2, 3, 4, 5]) // 10
	 */
	
	module.exports = _curry1(_reduced);


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Removes the sub-list of `list` starting at index `start` and containing
	 * `count` elements. _Note that this is not destructive_: it returns a copy of
	 * the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @param {Number} start The position to start removing elements
	 * @param {Number} count The number of elements to remove
	 * @param {Array} list The list to remove from
	 * @return {Array} A new Array with `count` elements from `start` removed.
	 * @example
	 *
	 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
	 */
	module.exports = _curry3(function remove(start, count, list) {
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(start, count);
	  return result;
	});


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var always = __webpack_require__(94);
	var times = __webpack_require__(460);
	
	
	/**
	 * Returns a fixed list of size `n` containing a specified identical value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig a -> n -> [a]
	 * @param {*} value The value to repeat.
	 * @param {Number} n The desired size of the output list.
	 * @return {Array} A new array containing `n` `value`s.
	 * @example
	 *
	 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
	 *
	 *      var obj = {};
	 *      var repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
	 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
	 * @symb R.repeat(a, 0) = []
	 * @symb R.repeat(a, 1) = [a]
	 * @symb R.repeat(a, 2) = [a, a]
	 */
	module.exports = _curry2(function repeat(value, n) {
	  return times(always(value), n);
	});


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Replace a substring or regex match in a string with a replacement.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category String
	 * @sig RegExp|String -> String -> String -> String
	 * @param {RegExp|String} pattern A regular expression or a substring to match.
	 * @param {String} replacement The string to replace the matches with.
	 * @param {String} str The String to do the search and replacement in.
	 * @return {String} The result.
	 * @example
	 *
	 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *
	 *      // Use the "g" (global) flag to replace all occurrences:
	 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
	 */
	module.exports = _curry3(function replace(regex, replacement, str) {
	  return str.replace(regex, replacement);
	});


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Scan is similar to reduce, but returns a list of successively reduced values
	 * from the left
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (a,b -> a) -> a -> [b] -> [a]
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} A list of all intermediately reduced values.
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
	 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
	 */
	module.exports = _curry3(function scan(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [acc];
	  while (idx < len) {
	    acc = fn(acc, list[idx]);
	    result[idx + 1] = acc;
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	var always = __webpack_require__(94);
	var over = __webpack_require__(451);
	
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> a -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
	 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
	 */
	module.exports = _curry3(function set(lens, v, x) {
	  return over(lens, always(v), x);
	});


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns a copy of the list, sorted according to the comparator function,
	 * which should accept two values at a time and return a negative number if the
	 * first value is smaller, a positive number if it's larger, and zero if they
	 * are equal. Please note that this is a **copy** of the list. It does not
	 * modify the original.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a,a -> Number) -> [a] -> [a]
	 * @param {Function} comparator A sorting function :: a -> b -> Int
	 * @param {Array} list The list to sort
	 * @return {Array} a new array with its elements sorted by the comparator function.
	 * @example
	 *
	 *      var diff = function(a, b) { return a - b; };
	 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
	 */
	module.exports = _curry2(function sort(comparator, list) {
	  return Array.prototype.slice.call(list, 0).sort(comparator);
	});


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Sorts the list according to the supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> [a] -> [a]
	 * @param {Function} fn
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted by the keys generated by `fn`.
	 * @example
	 *
	 *      var sortByFirstItem = R.sortBy(R.prop(0));
	 *      var sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
	 *      var pairs = [[-1, 1], [-2, 2], [-3, 3]];
	 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
	 *      var alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      var bob = {
	 *        name: 'Bob',
	 *        age: -10
	 *      };
	 *      var clara = {
	 *        name: 'clara',
	 *        age: 314.159
	 *      };
	 *      var people = [clara, bob, alice];
	 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
	 */
	module.exports = _curry2(function sortBy(fn, list) {
	  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    var aa = fn(a);
	    var bb = fn(b);
	    return aa < bb ? -1 : aa > bb ? 1 : 0;
	  });
	});


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Sorts a list according to a list of comparators.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Relation
	 * @sig [a -> a -> Number] -> [a] -> [a]
	 * @param {Array} functions A list of comparator functions.
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted according to the comarator functions.
	 * @example
	 *
	 *      var alice = {
	 *        name: 'alice',
	 *        age: 40
	 *      };
	 *      var bob = {
	 *        name: 'bob',
	 *        age: 30
	 *      };
	 *      var clara = {
	 *        name: 'clara',
	 *        age: 40
	 *      };
	 *      var people = [clara, bob, alice];
	 *      var ageNameSort = R.sortWith([
	 *        R.descend(R.prop('age')),
	 *        R.ascend(R.prop('name'))
	 *      ]);
	 *      ageNameSort(people); //=> [alice, clara, bob]
	 */
	module.exports = _curry2(function sortWith(fns, list) {
	  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    var result = 0;
	    var i = 0;
	    while (result === 0 && i < fns.length) {
	      result = fns[i](a, b);
	      i += 1;
	    }
	    return result;
	  });
	});


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(111);
	
	
	/**
	 * Splits a string into an array of strings based on the given
	 * separator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig (String | RegExp) -> String -> [String]
	 * @param {String|RegExp} sep The pattern.
	 * @param {String} str The string to separate into an array.
	 * @return {Array} The array of strings from `str` separated by `str`.
	 * @see R.join
	 * @example
	 *
	 *      var pathComponents = R.split('/');
	 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
	 *
	 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
	 */
	module.exports = invoker(1, 'split');


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var length = __webpack_require__(443);
	var slice = __webpack_require__(82);
	
	
	/**
	 * Splits a given list or string at a given index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig Number -> [a] -> [[a], [a]]
	 * @sig Number -> String -> [String, String]
	 * @param {Number} index The index where the array/string is split.
	 * @param {Array|String} array The array/string to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
	 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
	 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
	 */
	module.exports = _curry2(function splitAt(index, array) {
	  return [slice(0, index, array), slice(index, length(array), array)];
	});


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var slice = __webpack_require__(82);
	
	
	/**
	 * Splits a collection into slices of the specified length.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @sig Number -> String -> [String]
	 * @param {Number} n
	 * @param {Array} list
	 * @return {Array}
	 * @example
	 *
	 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
	 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
	 */
	module.exports = _curry2(function splitEvery(n, list) {
	  if (n <= 0) {
	    throw new Error('First argument to splitEvery must be a positive integer');
	  }
	  var result = [];
	  var idx = 0;
	  while (idx < list.length) {
	    result.push(slice(idx, idx += n, list));
	  }
	  return result;
	});


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Takes a list and a predicate and returns a pair of lists with the following properties:
	 *
	 *  - the result of concatenating the two output lists is equivalent to the input list;
	 *  - none of the elements of the first output list satisfies the predicate; and
	 *  - if the second output list is non-empty, its first element satisfies the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
	 * @param {Function} pred The predicate that determines where the array is split.
	 * @param {Array} list The array to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
	 */
	module.exports = _curry2(function splitWhen(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var prefix = [];
	
	  while (idx < len && !pred(list[idx])) {
	    prefix.push(list[idx]);
	    idx += 1;
	  }
	
	  return [prefix, Array.prototype.slice.call(list, idx)];
	});


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Subtracts its second argument from its first argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a - b`.
	 * @see R.add
	 * @example
	 *
	 *      R.subtract(10, 8); //=> 2
	 *
	 *      var minus5 = R.subtract(R.__, 5);
	 *      minus5(17); //=> 12
	 *
	 *      var complementaryAngle = R.subtract(90);
	 *      complementaryAngle(30); //=> 60
	 *      complementaryAngle(72); //=> 18
	 */
	module.exports = _curry2(function subtract(a, b) {
	  return Number(a) - Number(b);
	});


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var concat = __webpack_require__(203);
	var difference = __webpack_require__(419);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
	 * @example
	 *
	 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
	 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
	 */
	module.exports = _curry2(function symmetricDifference(list1, list2) {
	  return concat(difference(list1, list2), difference(list2, list1));
	});


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	var concat = __webpack_require__(203);
	var differenceWith = __webpack_require__(420);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both. Duplication is determined according to the value
	 * returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifference, R.difference, R.differenceWith
	 * @example
	 *
	 *      var eqA = R.eqBy(R.prop('a'));
	 *      var l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
	 *      var l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
	 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
	 */
	module.exports = _curry3(function symmetricDifferenceWith(pred, list1, list2) {
	  return concat(differenceWith(pred, list1, list2), differenceWith(pred, list2, list1));
	});


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var drop = __webpack_require__(422);
	
	
	/**
	 * Returns a new list containing the last `n` elements of the given list.
	 * If `n > list.length`, returns a list of `list.length` elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements to return.
	 * @param {Array} xs The collection to consider.
	 * @return {Array}
	 * @see R.dropLast
	 * @example
	 *
	 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(3, 'ramda');               //=> 'mda'
	 */
	module.exports = _curry2(function takeLast(n, xs) {
	  return drop(n >= 0 ? xs.length - n : 0, xs);
	});


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns a new list containing the last `n` elements of a given list, passing
	 * each value to the supplied predicate function, and terminating when the
	 * predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropLastWhile, R.addIndex
	 * @example
	 *
	 *      var isNotOne = x => x !== 1;
	 *
	 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
	 */
	module.exports = _curry2(function takeLastWhile(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0 && fn(list[idx])) {
	    idx -= 1;
	  }
	  return Array.prototype.slice.call(list, idx + 1);
	});


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var _dispatchable = __webpack_require__(24);
	var _xtakeWhile = __webpack_require__(797);
	
	
	/**
	 * Returns a new list containing the first `n` elements of a given list,
	 * passing each value to the supplied predicate function, and terminating when
	 * the predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * Dispatches to the `takeWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isNotFour = x => x !== 4;
	 *
	 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
	 */
	module.exports = _curry2(_dispatchable(['takeWhile'], _xtakeWhile, function takeWhile(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len && fn(list[idx])) {
	    idx += 1;
	  }
	  return Array.prototype.slice.call(list, 0, idx);
	}));


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Runs the given function with the supplied object, then returns the object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a -> *) -> a -> a
	 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
	 * @param {*} x
	 * @return {*} `x`.
	 * @example
	 *
	 *      var sayX = x => console.log('x is ' + x);
	 *      R.tap(sayX, 100); //=> 100
	 *      // logs 'x is 100'
	 * @symb R.tap(f, a) = a
	 */
	module.exports = _curry2(function tap(fn, x) {
	  fn(x);
	  return x;
	});


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	var _cloneRegExp = __webpack_require__(427);
	var _curry2 = __webpack_require__(2);
	var _isRegExp = __webpack_require__(773);
	var toString = __webpack_require__(116);
	
	
	/**
	 * Determines whether a given string matches a given regular expression.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category String
	 * @sig RegExp -> String -> Boolean
	 * @param {RegExp} pattern
	 * @param {String} str
	 * @return {Boolean}
	 * @see R.match
	 * @example
	 *
	 *      R.test(/^x/, 'xyz'); //=> true
	 *      R.test(/^y/, 'xyz'); //=> false
	 */
	module.exports = _curry2(function test(pattern, str) {
	  if (!_isRegExp(pattern)) {
	    throw new TypeError('‘test’ requires a value of type RegExp as its first argument; received ' + toString(pattern));
	  }
	  return _cloneRegExp(pattern).test(str);
	});


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(111);
	
	
	/**
	 * The lower case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to lower case.
	 * @return {String} The lower case version of `str`.
	 * @see R.toUpper
	 * @example
	 *
	 *      R.toLower('XYZ'); //=> 'xyz'
	 */
	module.exports = invoker(0, 'toLowerCase');


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var _has = __webpack_require__(39);
	
	
	/**
	 * Converts an object into an array of key, value arrays. Only the object's
	 * own properties are used.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own properties.
	 * @see R.fromPairs
	 * @example
	 *
	 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
	 */
	module.exports = _curry1(function toPairs(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    if (_has(prop, obj)) {
	      pairs[pairs.length] = [prop, obj[prop]];
	    }
	  }
	  return pairs;
	});


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	
	
	/**
	 * Converts an object into an array of key, value arrays. The object's own
	 * properties and prototype properties are used. Note that the order of the
	 * output array is not guaranteed to be consistent across different JS
	 * platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own
	 *         and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
	 */
	module.exports = _curry1(function toPairsIn(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    pairs[pairs.length] = [prop, obj[prop]];
	  }
	  return pairs;
	});


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(111);
	
	
	/**
	 * The upper case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to upper case.
	 * @return {String} The upper case version of `str`.
	 * @see R.toLower
	 * @example
	 *
	 *      R.toUpper('abc'); //=> 'ABC'
	 */
	module.exports = invoker(0, 'toUpperCase');


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	var _reduce = __webpack_require__(49);
	var _xwrap = __webpack_require__(439);
	var curryN = __webpack_require__(35);
	
	
	/**
	 * Initializes a transducer using supplied iterator function. Returns a single
	 * item by iterating through the list, successively calling the transformed
	 * iterator function and passing it an accumulator value and the current value
	 * from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It will be
	 * wrapped as a transformer to initialize the transducer. A transformer can be
	 * passed directly in place of an iterator function. In both cases, iteration
	 * may be stopped early with the `R.reduced` function.
	 *
	 * A transducer is a function that accepts a transformer and returns a
	 * transformer and can be composed directly.
	 *
	 * A transformer is an an object that provides a 2-arity reducing iterator
	 * function, step, 0-arity initial value function, init, and 1-arity result
	 * extraction function, result. The step function is used as the iterator
	 * function in reduce. The result function is used to convert the final
	 * accumulator into the return type and in most cases is R.identity. The init
	 * function can be used to provide an initial accumulator, but is ignored by
	 * transduce.
	 *
	 * The iteration is performed with R.reduce after initializing the transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (c -> c) -> (a,b -> a) -> a -> [b] -> a
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array. Wrapped as transformer, if necessary, and used to
	 *        initialize the transducer
	 * @param {*} acc The initial accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced, R.into
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *
	 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
	 */
	module.exports = curryN(4, function transduce(xf, fn, acc, list) {
	  return _reduce(xf(typeof fn === 'function' ? _xwrap(fn) : fn), acc, list);
	});


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	
	
	/**
	 * Transposes the rows and columns of a 2D list.
	 * When passed a list of `n` lists of length `x`,
	 * returns a list of `x` lists of length `n`.
	 *
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [[a]] -> [[a]]
	 * @param {Array} list A 2D list
	 * @return {Array} A 2D list
	 * @example
	 *
	 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
	 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 *
	 * If some of the rows are shorter than the following rows, their elements are skipped:
	 *
	 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
	 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
	 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
	 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
	 */
	module.exports = _curry1(function transpose(outerlist) {
	  var i = 0;
	  var result = [];
	  while (i < outerlist.length) {
	    var innerlist = outerlist[i];
	    var j = 0;
	    while (j < innerlist.length) {
	      if (typeof result[j] === 'undefined') {
	        result[j] = [];
	      }
	      result[j].push(innerlist[j]);
	      j += 1;
	    }
	    i += 1;
	  }
	  return result;
	});


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	var map = __webpack_require__(43);
	var sequence = __webpack_require__(457);
	
	
	/**
	 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
	 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
	 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
	 * into an Applicative of Traversable.
	 *
	 * Dispatches to the `sequence` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
	 * @param {Function} of
	 * @param {Function} f
	 * @param {*} traversable
	 * @return {*}
	 * @see R.sequence
	 * @example
	 *
	 *      // Returns `Nothing` if the given divisor is `0`
	 *      safeDiv = n => d => d === 0 ? Nothing() : Just(n / d)
	 *
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Just([5, 2.5, 2])
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Nothing
	 */
	module.exports = _curry3(function traverse(of, f, traversable) {
	  return sequence(of, map(f, traversable));
	});


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	
	
	/**
	 * Removes (strips) whitespace from both ends of the string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to trim.
	 * @return {String} Trimmed version of `str`.
	 * @example
	 *
	 *      R.trim('   xyz  '); //=> 'xyz'
	 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
	 */
	module.exports = (function() {
	  var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	           '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' +
	           '\u2029\uFEFF';
	  var zeroWidth = '\u200b';
	  var hasProtoTrim = (typeof String.prototype.trim === 'function');
	  if (!hasProtoTrim || (ws.trim() || !zeroWidth.trim())) {
	    return _curry1(function trim(str) {
	      var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
	      var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
	      return str.replace(beginRx, '').replace(endRx, '');
	    });
	  } else {
	    return _curry1(function trim(str) {
	      return str.trim();
	    });
	  }
	}());


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(55);
	var _concat = __webpack_require__(50);
	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
	 * function evaluates the `tryer`; if it does not throw, it simply returns the
	 * result. If the `tryer` *does* throw, the returned function evaluates the
	 * `catcher` function and returns its result. Note that for effective
	 * composition with this function, both the `tryer` and `catcher` functions
	 * must return the same type of results.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
	 * @param {Function} tryer The function that may throw.
	 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
	 * @return {Function} A new function that will catch exceptions and send then to the catcher.
	 * @example
	 *
	 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
	 *      R.tryCatch(R.prop('x'), R.F)(null);      //=> false
	 */
	module.exports = _curry2(function _tryCatch(tryer, catcher) {
	  return _arity(tryer.length, function() {
	    try {
	      return tryer.apply(this, arguments);
	    } catch (e) {
	      return catcher.apply(this, _concat([e], arguments));
	    }
	  });
	});


/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	
	
	/**
	 * Takes a function `fn`, which takes a single array argument, and returns a
	 * function which:
	 *
	 *   - takes any number of positional arguments;
	 *   - passes these arguments to `fn` as an array; and
	 *   - returns the result.
	 *
	 * In other words, R.unapply derives a variadic function from a function which
	 * takes an array. R.unapply is the inverse of R.apply.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Function
	 * @sig ([*...] -> a) -> (*... -> a)
	 * @param {Function} fn
	 * @return {Function}
	 * @see R.apply
	 * @example
	 *
	 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
	 * @symb R.unapply(f)(a, b) = f([a, b])
	 */
	module.exports = _curry1(function unapply(fn) {
	  return function() {
	    return fn(Array.prototype.slice.call(arguments, 0));
	  };
	});


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	var nAry = __webpack_require__(154);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 1 parameter. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> b) -> (a -> b)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 1.
	 * @example
	 *
	 *      var takesTwoArgs = function(a, b) {
	 *        return [a, b];
	 *      };
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      var takesOneArg = R.unary(takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only 1 argument is passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.unary(f)(a, b, c) = f(a)
	 */
	module.exports = _curry1(function unary(fn) {
	  return nAry(1, fn);
	});


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var curryN = __webpack_require__(35);
	
	
	/**
	 * Returns a function of arity `n` from a (manually) curried function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Function
	 * @sig Number -> (a -> b) -> (a -> c)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to uncurry.
	 * @return {Function} A new function.
	 * @see R.curry
	 * @example
	 *
	 *      var addFour = a => b => c => d => a + b + c + d;
	 *
	 *      var uncurriedAddFour = R.uncurryN(4, addFour);
	 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
	 */
	module.exports = _curry2(function uncurryN(depth, fn) {
	  return curryN(depth, function() {
	    var currentDepth = 1;
	    var value = fn;
	    var idx = 0;
	    var endIdx;
	    while (currentDepth <= depth && typeof value === 'function') {
	      endIdx = currentDepth === depth ? arguments.length : idx + value.length;
	      value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
	      currentDepth += 1;
	      idx = endIdx;
	    }
	    return value;
	  });
	});


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Builds a list from a seed value. Accepts an iterator function, which returns
	 * either false to stop iteration or an array of length 2 containing the value
	 * to add to the resulting list and the seed to be used in the next call to the
	 * iterator function.
	 *
	 * The iterator function receives one argument: *(seed)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (a -> [b]) -> * -> [b]
	 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
	 *        either false to quit iteration or an array of length two to proceed. The element
	 *        at index 0 of this array will be added to the resulting array, and the element
	 *        at index 1 will be passed to the next call to `fn`.
	 * @param {*} seed The seed value.
	 * @return {Array} The final list.
	 * @example
	 *
	 *      var f = n => n > 50 ? false : [-n, n + 10];
	 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
	 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
	 */
	module.exports = _curry2(function unfold(fn, seed) {
	  var pair = fn(seed);
	  var result = [];
	  while (pair && pair.length) {
	    result[result.length] = pair[0];
	    pair = fn(pair[1]);
	  }
	  return result;
	});


/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(50);
	var _curry2 = __webpack_require__(2);
	var compose = __webpack_require__(202);
	var uniq = __webpack_require__(213);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @example
	 *
	 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
	 */
	module.exports = _curry2(compose(uniq, _concat));


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(50);
	var _curry3 = __webpack_require__(9);
	var uniqWith = __webpack_require__(214);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list. Duplication is determined according to the value returned by
	 * applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig (a -> a -> Boolean) -> [*] -> [*] -> [*]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @see R.union
	 * @example
	 *
	 *      var l1 = [{a: 1}, {a: 2}];
	 *      var l2 = [{a: 1}, {a: 4}];
	 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
	 */
	module.exports = _curry3(function unionWith(pred, list1, list2) {
	  return uniqWith(pred, _concat(list1, list2));
	});


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is not satisfied, the function will return the result of
	 * calling the `whenFalseFn` function with the same argument. If the predicate
	 * is satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred        A predicate function
	 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
	 *                               to a falsy value.
	 * @param {*}        x           An object to test with the `pred` function and
	 *                               pass to `whenFalseFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
	 * @see R.ifElse, R.when
	 * @example
	 *
	 *      // coerceArray :: (a|[a]) -> [a]
	 *      var coerceArray = R.unless(R.isArrayLike, R.of);
	 *      coerceArray([1, 2, 3]); //=> [1, 2, 3]
	 *      coerceArray(1);         //=> [1]
	 */
	module.exports = _curry3(function unless(pred, whenFalseFn, x) {
	  return pred(x) ? x : whenFalseFn(x);
	});


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	var _identity = __webpack_require__(208);
	var chain = __webpack_require__(201);
	
	
	/**
	 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
	 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain c => c (c a) -> c a
	 * @param {*} list
	 * @return {*}
	 * @see R.flatten, R.chain
	 * @example
	 *
	 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
	 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
	 */
	module.exports = chain(_identity);


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Takes a predicate, a transformation function, and an initial value,
	 * and returns a value of the same type as the initial value.
	 * It does so by applying the transformation until the predicate is satisfied,
	 * at which point it returns the satisfactory value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred A predicate function
	 * @param {Function} fn The iterator function
	 * @param {*} init Initial value
	 * @return {*} Final value that satisfies predicate
	 * @example
	 *
	 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
	 */
	module.exports = _curry3(function until(pred, fn, init) {
	  var val = init;
	  while (!pred(val)) {
	    val = fn(val);
	  }
	  return val;
	});


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(6);
	
	
	/**
	 * Returns a list of all the properties, including prototype properties, of the
	 * supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.valuesIn(f); //=> ['X', 'Y']
	 */
	module.exports = _curry1(function valuesIn(obj) {
	  var prop;
	  var vs = [];
	  for (prop in obj) {
	    vs[vs.length] = obj[prop];
	  }
	  return vs;
	});


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Returns a "view" of the given data structure, determined by the given lens.
	 * The lens's focus determines which portion of the data structure is visible.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> s -> a
	 * @param {Lens} lens
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});  //=> 1
	 *      R.view(xLens, {x: 4, y: 2});  //=> 4
	 */
	module.exports = (function() {
	  // `Const` is a functor that effectively ignores the function given to `map`.
	  var Const = function(x) {
	    return {value: x, map: function() { return this; }};
	  };
	
	  return _curry2(function view(lens, x) {
	    // Using `Const` effectively ignores the setter function of the `lens`,
	    // leaving the value returned by the getter function unmodified.
	    return lens(Const)(x).value;
	  });
	}());


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is satisfied, the function will return the result of calling
	 * the `whenTrueFn` function with the same argument. If the predicate is not
	 * satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred       A predicate function
	 * @param {Function} whenTrueFn A function to invoke when the `condition`
	 *                              evaluates to a truthy value.
	 * @param {*}        x          An object to test with the `pred` function and
	 *                              pass to `whenTrueFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
	 * @see R.ifElse, R.unless
	 * @example
	 *
	 *      // truncate :: String -> String
	 *      var truncate = R.when(
	 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
	 *        R.pipe(R.take(10), R.append('…'), R.join(''))
	 *      );
	 *      truncate('12345');         //=> '12345'
	 *      truncate('0123456789ABC'); //=> '0123456789…'
	 */
	module.exports = _curry3(function when(pred, whenTrueFn, x) {
	  return pred(x) ? whenTrueFn(x) : x;
	});


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	var equals = __webpack_require__(54);
	var map = __webpack_require__(43);
	var where = __webpack_require__(465);
	
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec, false otherwise. An object satisfies the spec if, for each of the
	 * spec's own properties, accessing that property of the object gives the same
	 * value (in `R.equals` terms) as accessing that property of the spec.
	 *
	 * `whereEq` is a specialization of [`where`](#where).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @sig {String: *} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @see R.where
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      var pred = R.whereEq({a: 1, b: 2});
	 *
	 *      pred({a: 1});              //=> false
	 *      pred({a: 1, b: 2});        //=> true
	 *      pred({a: 1, b: 2, c: 3});  //=> true
	 *      pred({a: 1, b: 1});        //=> false
	 */
	module.exports = _curry2(function whereEq(spec, testObj) {
	  return where(map(equals, spec), testObj);
	});


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(81);
	var _curry2 = __webpack_require__(2);
	var flip = __webpack_require__(146);
	var reject = __webpack_require__(156);
	
	
	/**
	 * Returns a new list without values in the first argument.
	 * `R.equals` is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @param {Array} list1 The values to be removed from `list2`.
	 * @param {Array} list2 The array to remove values from.
	 * @return {Array} The new array without values in `list1`.
	 * @see R.transduce
	 * @example
	 *
	 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
	 */
	module.exports = _curry2(function(xs, list) {
	  return reject(flip(_contains)(xs), list);
	});


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Creates a new list out of the two supplied by creating each possible pair
	 * from the lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The list made by combining each possible pair from
	 *         `as` and `bs` into pairs (`[a, b]`).
	 * @example
	 *
	 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
	 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
	 */
	module.exports = _curry2(function xprod(a, b) { // = xprodWith(prepend); (takes about 3 times as long...)
	  var idx = 0;
	  var ilen = a.length;
	  var j;
	  var jlen = b.length;
	  var result = [];
	  while (idx < ilen) {
	    j = 0;
	    while (j < jlen) {
	      result[result.length] = [a[idx], b[j]];
	      j += 1;
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Creates a new list out of the two supplied by pairing up equally-positioned
	 * items from both lists. The returned list is truncated to the length of the
	 * shorter of the two input lists.
	 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
	 * @example
	 *
	 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
	 */
	module.exports = _curry2(function zip(a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = [a[idx], b[idx]];
	    idx += 1;
	  }
	  return rv;
	});


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(2);
	
	
	/**
	 * Creates a new object out of a list of keys and a list of values.
	 * Key/value pairing is truncated to the length of the shorter of the two lists.
	 * Note: `zipObj` is equivalent to `pipe(zipWith(pair), fromPairs)`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [String] -> [*] -> {String: *}
	 * @param {Array} keys The array that will be properties on the output object.
	 * @param {Array} values The list of values on the output object.
	 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
	 * @example
	 *
	 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry2(function zipObj(keys, values) {
	  var idx = 0;
	  var len = Math.min(keys.length, values.length);
	  var out = {};
	  while (idx < len) {
	    out[keys[idx]] = values[idx];
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(9);
	
	
	/**
	 * Creates a new list out of the two supplied by applying the function to each
	 * equally-positioned pair in the lists. The returned list is truncated to the
	 * length of the shorter of the two input lists.
	 *
	 * @function
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a,b -> c) -> [a] -> [b] -> [c]
	 * @param {Function} fn The function used to combine the two elements into one value.
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
	 *         using `fn`.
	 * @example
	 *
	 *      var f = (x, y) => {
	 *        // ...
	 *      };
	 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
	 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
	 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
	 */
	module.exports = _curry3(function zipWith(fn, a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = fn(a[idx], b[idx]);
	    idx += 1;
	  }
	  return rv;
	});


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CLEAR_ICON = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CLEAR_ICON = exports.CLEAR_ICON = _react2.default.createElement(
	  "svg",
	  { height: "20", width: "20", viewBox: "0 0 24 24" },
	  _react2.default.createElement("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }),
	  _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	);

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(58);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactFlex = __webpack_require__(41);
	
	var _reactField = __webpack_require__(991);
	
	var _reactField2 = _interopRequireDefault(_reactField);
	
	var _DateFormatInput = __webpack_require__(215);
	
	var _DateFormatInput2 = _interopRequireDefault(_DateFormatInput);
	
	var _reactInlineBlock = __webpack_require__(122);
	
	var _reactInlineBlock2 = _interopRequireDefault(_reactInlineBlock);
	
	var _icons = __webpack_require__(901);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _join = __webpack_require__(32);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _toMoment2 = __webpack_require__(33);
	
	var _toMoment3 = _interopRequireDefault(_toMoment2);
	
	var _Calendar = __webpack_require__(467);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _joinFunctions = __webpack_require__(117);
	
	var _joinFunctions2 = _interopRequireDefault(_joinFunctions);
	
	var _assignDefined = __webpack_require__(83);
	
	var _assignDefined2 = _interopRequireDefault(_assignDefined);
	
	var _forwardTime = __webpack_require__(161);
	
	var _forwardTime2 = _interopRequireDefault(_forwardTime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var POSITIONS = { top: 'top', bottom: 'bottom' };
	
	var getPicker = function getPicker(props) {
	  return _react2.default.Children.toArray(props.children).filter(function (c) {
	    return c && c.props && c.props.isDatePicker;
	  })[0] || _react2.default.createElement(_Calendar2.default, null);
	};
	
	var FIND_INPUT = function FIND_INPUT(c) {
	  return c && (c.type === 'input' || c.props && c.isDateInput);
	};
	
	var preventDefault = function preventDefault(event) {
	  event.preventDefault();
	};
	
	var DateField = function (_Component) {
	  _inherits(DateField, _Component);
	
	  function DateField(props) {
	    _classCallCheck(this, DateField);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DateField).call(this, props));
	
	    _this.state = {
	      value: props.defaultValue === undefined ? '' : props.defaultValue,
	      expanded: props.defaultExpanded || false,
	      focused: false
	    };
	    return _this;
	  }
	
	  _createClass(DateField, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unmounted = true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = this.prepareProps(this.props);
	
	      var flexProps = (0, _objectAssign2.default)({}, props);
	
	      delete flexProps.activeDate;
	      delete flexProps.cleanup;
	      delete flexProps.clearIcon;
	      delete flexProps.collapseOnDateClick;
	      delete flexProps.date;
	      delete flexProps.dateFormat;
	      delete flexProps.expanded;
	      delete flexProps.expandOnFocus;
	      delete flexProps.footer;
	      delete flexProps.forceValidDate;
	      delete flexProps.locale;
	      delete flexProps.onExpand;
	      delete flexProps.onExpandChange;
	      delete flexProps.onCollapse;
	      delete flexProps.minDate;
	      delete flexProps.maxDate;
	      delete flexProps.pickerProps;
	      delete flexProps.position;
	      delete flexProps.showClock;
	      delete flexProps.skipTodayTime;
	      delete flexProps.strict;
	      delete flexProps.valid;
	      delete flexProps.validateOnBlur;
	      delete flexProps.viewDate;
	      delete flexProps.value;
	      delete flexProps.text;
	      delete flexProps.theme;
	      delete flexProps.updateOnDateClick;
	
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(flexProps);
	      }
	
	      return _react2.default.createElement(
	        _reactFlex.Flex,
	        _extends({
	          inline: true,
	          row: true,
	          wrap: false
	        }, flexProps),
	        this.renderInput(),
	        this.renderClearIcon(),
	        this.renderCalendarIcon(),
	        this.renderPicker()
	      );
	    }
	  }, {
	    key: 'renderInput',
	    value: function renderInput() {
	      var props = this.p;
	      var inputProps = this.prepareInputProps(props);
	
	      var input = void 0;
	
	      if (props.renderInput) {
	        input = props.renderInput(inputProps);
	      }
	
	      if (input === undefined) {
	        input = props.children.filter(FIND_INPUT)[0];
	
	        var FieldInput = props.forceValidDate ? _DateFormatInput2.default : _reactField2.default;
	
	        var propsForInput = (0, _objectAssign2.default)({}, inputProps);
	
	        if (!props.forceValidDate) {
	          delete propsForInput.date;
	          delete propsForInput.maxDate;
	          delete propsForInput.minDate;
	          delete propsForInput.dateFormat;
	        }
	
	        input = input ? _react2.default.cloneElement(input, propsForInput) : _react2.default.createElement(FieldInput, propsForInput);
	      }
	
	      return input;
	    }
	  }, {
	    key: 'renderClearIcon',
	    value: function renderClearIcon() {
	      var props = this.p;
	
	      if (!props.clearIcon || props.forceValidDate || props.disabled) {
	        return undefined;
	      }
	
	      var clearIcon = props.clearIcon === true ? _icons.CLEAR_ICON : props.clearIcon;
	
	      var clearIconProps = {
	        style: {
	          visibility: props.text ? 'visible' : 'hidden'
	        },
	        className: 'react-date-field__clear-icon',
	        onMouseDown: this.onClearMouseDown,
	        children: clearIcon
	      };
	
	      var result = void 0;
	
	      if (props.renderClearIcon) {
	        result = props.renderClearIcon(clearIconProps);
	      }
	
	      if (result === undefined) {
	        result = _react2.default.createElement(_reactInlineBlock2.default, clearIconProps);
	      }
	
	      return result;
	    }
	  }, {
	    key: 'onClearMouseDown',
	    value: function onClearMouseDown(event) {
	      event.preventDefault();
	      this.onFieldChange('');
	
	      if (!this.isFocused()) {
	        this.focus();
	      }
	    }
	  }, {
	    key: 'renderCalendarIcon',
	    value: function renderCalendarIcon() {
	      var result = void 0;
	      var renderIcon = this.props.renderCalendarIcon;
	
	      var calendarIconProps = {
	        className: 'react-date-field__calendar-icon',
	        onMouseDown: this.onCalendarIconMouseDown,
	        children: _react2.default.createElement('div', { className: 'react-date-field__calendar-icon-inner' })
	      };
	
	      if (renderIcon) {
	        result = renderIcon(calendarIconProps);
	      }
	
	      if (result === undefined) {
	        result = _react2.default.createElement('div', calendarIconProps);
	      }
	
	      return result;
	    }
	  }, {
	    key: 'onCalendarIconMouseDown',
	    value: function onCalendarIconMouseDown(event) {
	      if (this.props.disabled) {
	        return;
	      }
	      event.preventDefault();
	
	      if (!this.isFocused()) {
	        this.focus();
	      }
	
	      this.toggleExpand();
	    }
	  }, {
	    key: 'prepareExpanded',
	    value: function prepareExpanded(props) {
	      return props.expanded === undefined ? this.state.expanded : props.expanded;
	    }
	  }, {
	    key: 'prepareDate',
	    value: function prepareDate(props, pickerProps) {
	      props = props || this.p;
	      pickerProps = pickerProps || props.pickerProps;
	
	      var locale = props.locale || pickerProps.locale;
	      var dateFormat = props.dateFormat || pickerProps.dateFormat;
	
	      var value = props.value === undefined ? this.state.value : props.value;
	
	      var date = this.toMoment(value);
	      var valid = date.isValid();
	
	      if (value && typeof value != 'string' && valid) {
	        value = this.format(date);
	      }
	
	      if (date && valid) {
	        this.lastValidDate = date;
	      } else {
	        value = this.state.value;
	      }
	
	      var viewDate = this.state.viewDate || this.lastValidDate || new Date();
	      var activeDate = this.state.activeDate || this.lastValidDate || new Date();
	
	      return {
	        viewDate: viewDate,
	        activeDate: activeDate,
	        dateFormat: dateFormat,
	        locale: locale,
	        valid: valid,
	        date: date,
	        value: value
	      };
	    }
	  }, {
	    key: 'preparePickerProps',
	    value: function preparePickerProps(props) {
	      var picker = getPicker(props, this);
	
	      if (!picker) {
	        return null;
	      }
	
	      return picker.props || {};
	    }
	  }, {
	    key: 'prepareProps',
	    value: function prepareProps(thisProps) {
	      var props = this.p = (0, _objectAssign2.default)({}, thisProps);
	
	      props.children = _react2.default.Children.toArray(props.children);
	
	      props.expanded = this.prepareExpanded(props);
	      props.pickerProps = this.preparePickerProps(props);
	
	      var input = props.children.filter(FIND_INPUT)[0];
	
	      if (input && input.type == 'input') {
	        props.rawInput = true;
	        props.forceValidDate = false;
	      }
	
	      var dateInfo = this.prepareDate(props, props.pickerProps);
	
	      (0, _objectAssign2.default)(props, dateInfo);
	
	      if (props.text === undefined) {
	        props.text = this.state.text;
	
	        if (props.text == null) {
	          props.text = props.valid && props.date ? props.value : this.props.value;
	        }
	      }
	
	      if (props.text === undefined) {
	        props.text = '';
	      }
	
	      props.className = this.prepareClassName(props);
	
	      return props;
	    }
	  }, {
	    key: 'prepareClassName',
	    value: function prepareClassName(props) {
	      var position = POSITIONS[props.pickerProps.position || props.pickerPosition] || 'bottom';
	
	      return (0, _join2.default)(['react-date-field', props.className, props.disabled && 'react-date-field--disabled', props.theme && 'react-date-field--theme-' + props.theme, 'react-date-field--picker-position-' + position, this.isLazyFocused() && (0, _join2.default)('react-date-field--focused', props.focusedClassName), this.isExpanded() && (0, _join2.default)('react-date-field--expanded', props.expandedClassName), !props.valid && (0, _join2.default)(props.invalidClassName, 'react-date-field--invalid')]);
	    }
	  }, {
	    key: 'prepareInputProps',
	    value: function prepareInputProps(props) {
	      var _this2 = this;
	
	      var input = props.children.filter(FIND_INPUT)[0];
	      var inputProps = input && input.props || {};
	
	      var onBlur = (0, _joinFunctions2.default)(inputProps.onBlur, this.onFieldBlur);
	      var onFocus = (0, _joinFunctions2.default)(inputProps.onFocus, this.onFieldFocus);
	      var onChange = (0, _joinFunctions2.default)(inputProps.onChange, this.onFieldChange);
	      var onKeyDown = (0, _joinFunctions2.default)(inputProps.onKeyDown, this.onFieldKeyDown);
	
	      var newInputProps = (0, _objectAssign2.default)({}, inputProps, {
	
	        ref: function ref(f) {
	          _this2.field = f;
	        },
	        date: props.date,
	
	        onFocus: onFocus,
	        onBlur: onBlur,
	        onChange: onChange,
	
	        dateFormat: props.dateFormat,
	        value: props.text || '',
	
	        onKeyDown: onKeyDown,
	
	        className: (0, _join2.default)('react-date-field__input', inputProps.className)
	      });
	
	      (0, _assignDefined2.default)(newInputProps, {
	        placeholder: props.placeholder,
	        disabled: props.disabled,
	        minDate: props.minDate,
	        maxDate: props.maxDate
	      });
	
	      return newInputProps;
	    }
	  }, {
	    key: 'renderPicker',
	    value: function renderPicker() {
	      var _this3 = this;
	
	      var props = this.p;
	
	      if (this.isExpanded()) {
	        var newExpand = !this.picker;
	        var picker = getPicker(props, this);
	
	        var pickerProps = props.pickerProps;
	
	        var onMouseDown = (0, _joinFunctions2.default)(pickerProps.onMouseDown, this.onPickerMouseDown);
	        var onChange = (0, _joinFunctions2.default)(pickerProps.onChange, this.onPickerChange);
	
	        var date = props.valid && props.date;
	        var footer = pickerProps.footer !== undefined ? pickerProps.footer : props.footer;
	
	        var viewDate = newExpand && date ? date : props.viewDate;
	        var activeDate = newExpand && date ? date : props.activeDate;
	
	        return _react2.default.cloneElement(picker, (0, _assignDefined2.default)({
	          ref: function ref(p) {
	            _this3.picker = _this3.pickerView = p;
	
	            if (p && p.getView) {
	              _this3.pickerView = p.getView();
	            }
	
	            if (!_this3.state.viewDate) {
	              _this3.onViewDateChange(props.viewDate);
	            }
	          },
	
	          footer: footer,
	
	          focusOnNavMouseDown: false,
	          focusOnFooterMouseDown: false,
	
	          insideField: true,
	          showClock: props.showClock,
	
	          getTransitionTime: this.getTime,
	
	          updateOnWheel: props.updateOnWheel,
	
	          onClockInputBlur: this.onClockInputBlur,
	          onClockEnterKey: this.onClockEnterKey,
	          onClockEscapeKey: this.onClockEscapeKey,
	
	          footerClearDate: props.clearDate || props.minDate,
	
	          onFooterCancelClick: this.onFooterCancelClick,
	          onFooterTodayClick: this.onFooterTodayClick,
	          onFooterOkClick: this.onFooterOkClick,
	          onFooterClearClick: this.onFooterClearClick,
	
	          dateFormat: props.dateFormat,
	          theme: props.theme || pickerProps.theme,
	          arrows: props.navBarArrows,
	
	          className: (0, _join2.default)(pickerProps.className, 'react-date-field__picker'),
	
	          date: date || null,
	
	          tabIndex: -1,
	
	          viewDate: viewDate,
	          activeDate: activeDate,
	          locale: props.locale,
	
	          onViewDateChange: this.onViewDateChange,
	          onActiveDateChange: this.onActiveDateChange,
	          onTimeChange: this.onTimeChange,
	
	          onTransitionStart: this.onTransitionStart,
	
	          onMouseDown: onMouseDown,
	          onChange: onChange
	        }, {
	          minDate: props.minDate,
	          maxDate: props.maxDate
	        }));
	      }
	
	      this.time = null;
	
	      return null;
	    }
	  }, {
	    key: 'onTimeChange',
	    value: function onTimeChange(value, timeFormat) {
	      var timeMoment = this.toMoment(value, { dateFormat: timeFormat });
	
	      var time = ['hour', 'minute', 'second', 'millisecond'].reduce(function (acc, part) {
	        acc[part] = timeMoment.get(part);
	        return acc;
	      }, {});
	
	      this.time = time;
	    }
	  }, {
	    key: 'getTime',
	    value: function getTime() {
	      return this.time;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      var config = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      var dateMoment = this.toMoment(value);
	      var dateString = this.format(dateMoment);
	
	      this.setDate(dateString, (0, _objectAssign2.default)(config, { dateMoment: dateMoment }));
	    }
	  }, {
	    key: 'onFooterOkClick',
	    value: function onFooterOkClick() {
	      var activeDate = this.p.activeDate;
	
	      if (activeDate) {
	        var date = this.toMoment(activeDate);
	
	        (0, _forwardTime2.default)(this.time, date);
	
	        this.setValue(date, { skipTime: !!this.time });
	      }
	
	      this.setExpanded(false);
	    }
	  }, {
	    key: 'onFooterCancelClick',
	    value: function onFooterCancelClick() {
	      this.setExpanded(false);
	    }
	  }, {
	    key: 'onFooterTodayClick',
	    value: function onFooterTodayClick() {
	      var today = this.toMoment(new Date()).startOf('day');
	
	      this.onPickerChange(this.format(today), { dateMoment: today });
	      this.onViewDateChange(today);
	      this.onActiveDateChange(today);
	
	      return false;
	    }
	  }, {
	    key: 'onFooterClearClick',
	    value: function onFooterClearClick() {
	      var clearDate = this.props.clearDate === undefined ? this.props.minDate : this.props.clearDate;
	
	      if (clearDate !== undefined) {
	        this.setValue(clearDate, {
	          skipTime: true
	        });
	      }
	
	      this.setExpanded(false);
	
	      return false;
	    }
	  }, {
	    key: 'toMoment',
	    value: function toMoment(value, props) {
	      if (_moment2.default.isMoment(value)) {
	        return value;
	      }
	
	      props = props || this.p;
	
	      var date = (0, _toMoment3.default)(value, {
	        strict: props.strict,
	        locale: props.locale,
	        dateFormat: props.displayFormat || props.dateFormat || this.p.dateFormat
	      });
	
	      if (!date.isValid() && props.displayFormat) {
	        date = (0, _toMoment3.default)(value, {
	          strict: props.strict,
	          locale: props.locale,
	          dateFormat: props.dateFormat || this.p.dateFormat
	        });
	      }
	
	      return date;
	    }
	  }, {
	    key: 'isValid',
	    value: function isValid(text) {
	      if (text === undefined) {
	        text = this.p.text;
	      }
	
	      return this.toMoment(text).isValid();
	    }
	  }, {
	    key: 'onViewDateChange',
	    value: function onViewDateChange(viewDate) {
	      this.setState({
	        viewDate: viewDate
	      });
	    }
	  }, {
	    key: 'onActiveDateChange',
	    value: function onActiveDateChange(activeDate) {
	      this.setState({
	        activeDate: activeDate
	      });
	    }
	  }, {
	    key: 'onViewKeyDown',
	    value: function onViewKeyDown(event) {
	      var key = event.key;
	
	      if (this.pickerView) {
	        // } && (key == 'Escape' || key == 'Enter' || (key in NAV_KEYS))) {
	        this.pickerView.onViewKeyDown(event);
	      }
	    }
	  }, {
	    key: 'onPickerMouseDown',
	    value: function onPickerMouseDown(event) {
	      preventDefault(event);
	
	      if (!this.isFocused()) {
	        this.focus();
	      }
	    }
	  }, {
	    key: 'isHistoryViewVisible',
	    value: function isHistoryViewVisible() {
	      if (this.picker && this.picker.isHistoryViewVisible) {
	        return this.picker.isHistoryViewVisible();
	      }
	
	      return false;
	    }
	  }, {
	    key: 'onFieldKeyDown',
	    value: function onFieldKeyDown(event) {
	      var key = event.key;
	      var expanded = this.isExpanded();
	      var historyVisible = this.isHistoryViewVisible();
	
	      if (key == 'Enter' && !historyVisible) {
	        this.onViewKeyDown(event);
	        this.toggleExpand();
	        return false;
	      }
	
	      if (historyVisible && (key == 'Escape' || key == 'Enter')) {
	        this.onViewKeyDown(event);
	        return false;
	      }
	
	      if (key == 'Escape') {
	        if (expanded) {
	          this.setExpanded(false);
	          return false;
	        }
	      }
	
	      if (expanded) {
	        if (key in _Calendar.NAV_KEYS) {
	          this.onViewKeyDown(event);
	          return false;
	        }
	        // if (!currentPosition || !currentPosition.time) {
	        //   // the time has not changed, so it's safe to forward the event
	        //   this.onViewKeyDown(event)
	        //   return false
	        // }
	      }
	
	      return true;
	    }
	  }, {
	    key: 'getInput',
	    value: function getInput() {
	      return (0, _reactDom.findDOMNode)(this.field);
	    }
	  }, {
	    key: 'isFocused',
	    value: function isFocused() {
	      return this.state.focused;
	    }
	  }, {
	    key: 'isLazyFocused',
	    value: function isLazyFocused() {
	      return this.isFocused() || this.isTimeInputFocused();
	    }
	  }, {
	    key: 'isTimeInputFocused',
	    value: function isTimeInputFocused() {
	      if (this.pickerView && this.pickerView.isTimeInputFocused) {
	        return this.pickerView.isTimeInputFocused();
	      }
	
	      return false;
	    }
	  }, {
	    key: 'onFieldFocus',
	    value: function onFieldFocus(event) {
	      if (this.state.focused) {
	        return;
	      }
	
	      this.setState({
	        focused: true
	      });
	
	      if (this.props.expandOnFocus) {
	        this.setExpanded(true);
	      }
	
	      this.props.onFocus(event);
	    }
	  }, {
	    key: 'onFieldBlur',
	    value: function onFieldBlur(event) {
	      var _this4 = this;
	
	      if (!this.isFocused()) {
	        return;
	      }
	
	      this.setState({
	        focused: false
	      });
	
	      this.props.onBlur(event);
	
	      if (!this.pickerView || !this.pickerView.isTimeInputFocused) {
	        this.onLazyBlur();
	        return;
	      }
	
	      setTimeout(function () {
	        return _this4.onLazyBlur();
	      }, 0);
	    }
	  }, {
	    key: 'onClockEnterKey',
	    value: function onClockEnterKey() {
	      if (!this.isFocused()) {
	        this.focus();
	      }
	
	      this.onFooterOkClick();
	    }
	  }, {
	    key: 'onClockEscapeKey',
	    value: function onClockEscapeKey() {
	      if (!this.isFocused()) {
	        this.focus();
	      }
	
	      this.onFooterCancelClick();
	    }
	  }, {
	    key: 'onClockInputBlur',
	    value: function onClockInputBlur() {
	      var _this5 = this;
	
	      setTimeout(function () {
	        if (!_this5.isFocused()) {
	          _this5.onLazyBlur();
	        }
	      }, 0);
	    }
	  }, {
	    key: 'onLazyBlur',
	    value: function onLazyBlur() {
	      var _this6 = this;
	
	      if (this.unmounted) {
	        return;
	      }
	
	      if (this.isTimeInputFocused()) {
	        return;
	      }
	
	      this.setExpanded(false);
	
	      if (!this.isValid() && this.props.validateOnBlur) {
	        (function () {
	          var value = _this6.lastValidDate && _this6.p.text != '' ? _this6.format(_this6.lastValidDate) : '';
	
	          setTimeout(function () {
	            _this6.onFieldChange(value);
	          }, 0);
	        })();
	      }
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange() {}
	  }, {
	    key: 'isExpanded',
	    value: function isExpanded() {
	      return this.p.expanded;
	    }
	  }, {
	    key: 'toggleExpand',
	    value: function toggleExpand() {
	      this.setExpanded(!this.p.expanded);
	    }
	  }, {
	    key: 'setExpanded',
	    value: function setExpanded(bool) {
	      var _this7 = this;
	
	      var props = this.p;
	
	      if (bool === props.expanded) {
	        return;
	      }
	
	      if (!bool) {
	        this.onCollapse();
	      } else {
	        this.setState({}, function () {
	          _this7.onExpand();
	        });
	      }
	
	      if (bool && props.valid) {
	        this.setState({
	          // viewDate: props.date,
	          activeDate: props.date
	        });
	      }
	
	      if (this.props.expanded === undefined) {
	        this.setState({
	          expanded: bool
	        });
	      }
	
	      this.props.onExpandChange(bool);
	    }
	  }, {
	    key: 'onCollapse',
	    value: function onCollapse() {
	      this.props.onCollapse();
	    }
	  }, {
	    key: 'onExpand',
	    value: function onExpand() {
	      this.props.onExpand();
	    }
	  }, {
	    key: 'onFieldChange',
	    value: function onFieldChange(value) {
	      if (this.p.rawInput && typeof value != 'string') {
	        var event = value;
	        value = event.target.value;
	      }
	
	      var dateMoment = value == '' ? null : this.toMoment(value);
	
	      if (dateMoment === null || dateMoment.isValid()) {
	        this.onChange(dateMoment);
	      }
	
	      this.onTextChange(value);
	    }
	  }, {
	    key: 'onTextChange',
	    value: function onTextChange(text) {
	      if (this.props.text === undefined && this.props.value === undefined) {
	        this.setState({
	          text: text
	        });
	      }
	
	      if (this.props.onTextChange) {
	        this.props.onTextChange(text);
	      }
	    }
	  }, {
	    key: 'onPickerChange',
	    value: function onPickerChange(dateString, _ref, event) {
	      var dateMoment = _ref.dateMoment;
	      var forceUpdate = _ref.forceUpdate;
	
	      var isEnter = event && event.key == 'Enter';
	      var updateOnDateClick = forceUpdate ? true : this.props.updateOnDateClick || isEnter;
	
	      if (updateOnDateClick) {
	        (0, _forwardTime2.default)(this.time, dateMoment);
	
	        this.setDate(dateString, { dateMoment: dateMoment });
	
	        if (this.props.collapseOnDateClick || isEnter) {
	          this.setExpanded(false);
	        }
	      }
	    }
	  }, {
	    key: 'setDate',
	    value: function setDate(dateString, _ref2) {
	      var dateMoment = _ref2.dateMoment;
	      var _ref2$skipTime = _ref2.skipTime;
	      var skipTime = _ref2$skipTime === undefined ? false : _ref2$skipTime;
	
	      var props = this.p;
	
	      var currentDate = props.date;
	
	      if (props.valid && currentDate) {
	        var dateFormat = props.dateFormat.toLowerCase();
	
	        var hasTime = dateFormat.indexOf('k') != -1 || dateFormat.indexOf('h') != -1;
	
	        if (hasTime && !skipTime) {
	          ['hour', 'minute', 'second', 'millisecond'].forEach(function (part) {
	            dateMoment.set(part, currentDate.get(part));
	          });
	        }
	      }
	
	      this.onTextChange(this.format(dateMoment));
	      this.onChange(dateMoment);
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(dateMoment) {
	      if (dateMoment != null && !_moment2.default.isMoment(dateMoment)) {
	        dateMoment = this.toMoment(dateMoment);
	      }
	
	      (0, _forwardTime2.default)(this.time, dateMoment);
	
	      var newState = {};
	
	      if (this.props.value === undefined) {
	        (0, _objectAssign2.default)(newState, {
	          text: null,
	          value: dateMoment
	        });
	      }
	
	      newState.activeDate = dateMoment;
	
	      if (!this.pickerView || !this.pickerView.isInView || !this.pickerView.isInView(dateMoment)) {
	        newState.viewDate = dateMoment;
	      }
	
	      if (this.props.onChange) {
	        this.props.onChange(this.format(dateMoment), { dateMoment: dateMoment });
	      }
	
	      this.setState(newState);
	    }
	  }, {
	    key: 'format',
	    value: function format(mom, _format) {
	      return mom == null ? '' : mom.format(_format || this.p.displayFormat || this.p.dateFormat);
	    }
	  }, {
	    key: 'focusField',
	    value: function focusField() {
	      var input = (0, _reactDom.findDOMNode)(this.field);
	
	      if (input) {
	        input.focus();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.focusField();
	    }
	  }]);
	
	  return DateField;
	}(_reactClass2.default);
	
	exports.default = DateField;
	
	
	DateField.defaultProps = {
	  showClock: undefined,
	
	  forceValidDate: false,
	  strict: true,
	
	  expandOnFocus: true,
	
	  updateOnDateClick: false,
	  collapseOnDateClick: false,
	
	  theme: 'default',
	
	  footer: true,
	
	  onBlur: function onBlur() {},
	  onFocus: function onFocus() {},
	
	  clearIcon: true,
	  validateOnBlur: true,
	
	  onExpandChange: function onExpandChange() {},
	  onCollapse: function onCollapse() {},
	  onExpand: function onExpand() {},
	
	  minDate: (0, _moment2.default)('1000-01-01', 'YYYY-MM-DD'),
	  maxDate: (0, _moment2.default)('9999-12-31 HH:mm:ss', 'YYYY-MM-DD 23:59:59'),
	
	  skipTodayTime: false
	};
	
	DateField.propTypes = {
	  dateFormat: _react.PropTypes.string.isRequired
	};

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFormats = undefined;
	
	var _leftPad = __webpack_require__(219);
	
	var _leftPad2 = _interopRequireDefault(_leftPad);
	
	var _clamp = __webpack_require__(476);
	
	var _clamp2 = _interopRequireDefault(_clamp);
	
	var _times = __webpack_require__(162);
	
	var _times2 = _interopRequireDefault(_times);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value, format) {
	  value *= 1;
	  return value >= format.min && value <= format.max;
	};
	
	var replaceAt = function replaceAt(_ref) {
	  var value = _ref.value;
	  var index = _ref.index;
	  var _ref$len = _ref.len;
	  var len = _ref$len === undefined ? 1 : _ref$len;
	  var str = _ref.str;
	
	  return value.substring(0, index) + str + value.substring(index + len);
	};
	
	var handleArrow = function handleArrow(format, _ref2) {
	  var currentValue = _ref2.currentValue;
	  var key = _ref2.key;
	  var dir = _ref2.dir;
	
	  dir = dir || (key == 'ArrowUp' ? 1 : -1);
	
	  return {
	    value: (0, _clamp2.default)(currentValue * 1 + dir, {
	      min: format.min,
	      max: format.max,
	      circular: true
	    }),
	    caretPos: true
	  };
	};
	
	var handleArrowLeftPad = function handleArrowLeftPad(format, config) {
	  var _handleArrow = handleArrow(format, config);
	
	  var value = _handleArrow.value;
	  var caretPos = _handleArrow.caretPos;
	
	
	  return {
	    value: (0, _leftPad2.default)(value),
	    caretPos: caretPos
	  };
	};
	
	var handlePage = function handlePage(format, config) {
	  config.dir = config.dir || (config.key == 'PageUp' ? 10 : -10);
	
	  return handleArrow(format, config);
	};
	
	var handlePageLeftPad = function handlePageLeftPad(format, config) {
	  config.dir = config.dir || (config.key == 'PageUp' ? 10 : -10);
	
	  return handleArrowLeftPad(format, config);
	};
	
	var handleUpdate = function handleUpdate(value, format, _ref3) {
	  var range = _ref3.range;
	
	  value *= 1;
	
	  var len = range.end - range.start + 1;
	  var pow10 = ('1' + (0, _times2.default)(3 - len).map(function () {
	    return '0';
	  }).join('')) * 1;
	  var modLen = value % pow10;
	
	  var newValue = (0, _clamp2.default)(value, { min: format.min, max: format.max, circular: false });
	
	  if (pow10 > 1 && value % pow10 == 0) {
	    // the user is modifying the millenium or century
	    newValue += modLen;
	    // so we try to keep the century
	    newValue = (0, _clamp2.default)(newValue, { min: format.min, max: format.max, circular: false });
	  }
	
	  return newValue;
	};
	
	var handleUnidentified = function handleUnidentified(format, _ref4) {
	  var event = _ref4.event;
	  var currentValue = _ref4.currentValue;
	  var range = _ref4.range;
	
	  var newChar = String.fromCharCode(event.which);
	  var index = range.start - format.start;
	
	  var caretPos = { start: range.start + 1 };
	
	  if (newChar * 1 != newChar) {
	    return {
	      preventDefault: false,
	      value: currentValue
	    };
	  }
	
	  // caretPos
	  var value = void 0;
	  var valid = void 0;
	
	  value = replaceAt({ value: currentValue, index: index, str: newChar });
	  valid = isValid(value, format);
	
	  if (!valid && index == 0 && newChar == ('' + format.max)[0]) {
	    valid = true;
	    value = format.max;
	    caretPos.start++;
	  }
	
	  if (!valid) {
	    do {
	      value = (0, _times2.default)(index).map(function () {
	        return '0';
	      }).join('') + replaceAt({ value: currentValue, index: index, str: newChar }).substring(index);
	
	      valid = isValid(value, format);
	      index++;
	
	      if (!valid) {
	        caretPos.start++;
	      }
	    } while (!valid && index <= format.end);
	  }
	
	  if (valid) {
	    value = handleUpdate(value, format, { range: range });
	  } else {
	    var defaultValue = format.default;
	    value = 1 * replaceAt({ value: defaultValue, index: defaultValue.length - 1, str: newChar });
	
	    if (isValid(value, format)) {
	      caretPos.start = format.start + defaultValue.length;
	    } else {
	      caretPos.start = range.start + 1;
	      value = currentValue;
	    }
	  }
	
	  return {
	    value: value,
	    caretPos: caretPos
	  };
	};
	
	var handleUnidentifiedLeftPad = function handleUnidentifiedLeftPad(format, config) {
	  var _handleUnidentified = handleUnidentified(format, config);
	
	  var value = _handleUnidentified.value;
	  var caretPos = _handleUnidentified.caretPos;
	  var preventDefault = _handleUnidentified.preventDefault;
	
	
	  return {
	    value: (0, _leftPad2.default)(value),
	    caretPos: caretPos,
	    preventDefault: preventDefault
	  };
	};
	
	var handleYearUnidentified = handleUnidentified;
	
	var handleDelete = function handleDelete(format, _ref5) {
	  var range = _ref5.range;
	  var currentValue = _ref5.currentValue;
	  var dir = _ref5.dir;
	
	  dir = dir || 0;
	
	  if (range.start <= format.start && range.end >= format.end) {
	    return {
	      value: format.default,
	      caretPos: true
	    };
	  }
	
	  var len = range.end - range.start + 1;
	  var str = (0, _times2.default)(len).map(function () {
	    return '0';
	  }).join('');
	  var index = range.start - format.start + dir;
	
	  var value = replaceAt({ value: currentValue, index: index, str: str, len: len }) * 1;
	
	  value = (0, _leftPad2.default)(handleUpdate(value, format, { range: range }));
	
	  return {
	    value: value,
	    caretPos: { start: range.start + (dir < 0 ? -1 : 1) }
	  };
	};
	
	var handleBackspace = function handleBackspace(format, config) {
	  config.dir = -1;
	  return handleDelete(format, config);
	};
	
	var toggleMeridiem = function toggleMeridiem(_ref6) {
	  var upper = _ref6.upper;
	  var value = _ref6.value;
	
	  if (upper) {
	    return value == 'AM' ? 'PM' : 'AM';
	  }
	
	  return value == 'am' ? 'pm' : 'am';
	};
	
	var handleMeridiemArrow = function handleMeridiemArrow(format, _ref7) {
	  var currentValue = _ref7.currentValue;
	
	  return {
	    value: toggleMeridiem({ upper: format.upper, value: currentValue }),
	    caretPos: true
	  };
	};
	
	var handleMeridiemDelete = function handleMeridiemDelete(format, _ref8) {
	  var dir = _ref8.dir;
	  var range = _ref8.range;
	
	  dir = dir || 0;
	
	  if (range.start <= format.start && range.end >= format.end) {
	    return {
	      value: format.default,
	      caretPos: true
	    };
	  }
	
	  return {
	    value: format.upper ? 'AM' : 'am',
	    caretPos: { start: range.start + (dir < 0 ? -1 : 1) }
	  };
	};
	
	var handleMeridiemBackspace = function handleMeridiemBackspace(format, config) {
	  config.dir = -1;
	  return handleMeridiemDelete(format, config);
	};
	
	var getFormats = function getFormats() {
	  return {
	    YYYY: {
	      min: 100,
	      max: 9999,
	      default: '0100',
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handleArrow: handleArrow,
	      handlePageUp: handlePage,
	      handlePageDown: handlePage,
	      handleUnidentified: handleYearUnidentified
	    },
	
	    // YY: {
	    //   default: '00'
	    // },
	
	    // M: { min: 1, max: 12, default: '1', maxLen: 2 },
	    MM: {
	      min: 1,
	      max: 12,
	      default: '01',
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handlePageUp: handlePageLeftPad,
	      handlePageDown: handlePageLeftPad,
	      handleUnidentified: handleUnidentifiedLeftPad,
	      handleArrow: handleArrowLeftPad
	    },
	
	    // D: { min: 1, max: 31, default: '1', maxLen: 2 },
	    DD: {
	      min: 1,
	      max: 31,
	      default: '01',
	      handlePageUp: handlePageLeftPad,
	      handlePageDown: handlePageLeftPad,
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handleUnidentified: handleUnidentifiedLeftPad,
	      handleArrow: handleArrowLeftPad
	    },
	
	    // H: {
	    //   min: 0, max: 23, default: '0', maxLen: 2,
	    //   handleDelete,
	    //   handleBackspace,
	    //   handleArrow: handleArrowLeftPad,
	    //   handlePageUp: handlePageLeftPad,
	    //   handlePageDown: handlePageLeftPad
	    // },
	    HH: {
	      time: true,
	      min: 0, max: 23, default: '00',
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handleUnidentified: handleUnidentifiedLeftPad,
	      handleArrow: handleArrowLeftPad,
	      handlePageUp: handlePageLeftPad,
	      handlePageDown: handlePageLeftPad
	    },
	
	    // h: { min: 1, max: 12, default: '1', maxLen: 2,
	    //   handleArrow: handleArrowLeftPad,
	    //   handlePageUp: handlePageLeftPad,
	    //   handlePageDown: handlePageLeftPad
	    // },
	    hh: { min: 1, max: 12, default: '01',
	      time: true,
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handleUnidentified: handleUnidentifiedLeftPad,
	      handleArrow: handleArrowLeftPad,
	      handlePageUp: handlePageLeftPad,
	      handlePageDown: handlePageLeftPad
	    },
	
	    a: {
	      time: true,
	      length: 2,
	      default: 'am',
	      handleArrow: handleMeridiemArrow,
	      handlePageUp: handleMeridiemArrow,
	      handlePageDown: handleMeridiemArrow,
	      handleDelete: handleMeridiemDelete,
	      handleBackspace: handleMeridiemBackspace
	    },
	    A: {
	      length: 2,
	      time: true,
	      default: 'AM', upper: true,
	      handleArrow: handleMeridiemArrow,
	      handlePageUp: handleMeridiemArrow,
	      handlePageDown: handleMeridiemArrow,
	      handleDelete: handleMeridiemDelete,
	      handleBackspace: handleMeridiemBackspace
	    },
	
	    // m: { min: 0, max: 59, default: '0', maxLen: 2 },
	    mm: { min: 0, max: 59, default: '00',
	      time: true,
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handleUnidentified: handleUnidentifiedLeftPad,
	      handleArrow: handleArrowLeftPad,
	      handlePageUp: handlePageLeftPad,
	      handlePageDown: handlePageLeftPad
	    },
	
	    // s: { min: 0, max: 59, default: '0' },
	    ss: {
	      time: true,
	      min: 0, max: 59, default: '00',
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handleUnidentified: handleUnidentifiedLeftPad,
	      handleArrow: handleArrowLeftPad,
	      handlePageUp: handlePageLeftPad,
	      handlePageDown: handlePageLeftPad
	    }
	  };
	};
	
	exports.getFormats = getFormats;
	exports.default = getFormats();

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _formats = __webpack_require__(903);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SUGGESTIONS = {
	  Y: ['YYYY', 'YY'],
	  M: ['MM'],
	  D: ['DD'],
	  H: ['HH'],
	  h: ['hh'],
	  m: ['mm'],
	  s: ['ss']
	};
	
	exports.default = function (format) {
	  var index = 0;
	  var positionIndex = 0;
	
	  var suggestions = void 0;
	  var suggestionMatch = void 0;
	
	  var positions = [];
	  var matches = [];
	
	  while (index < format.length) {
	    var char = format[index];
	    var match = _formats2.default[char];
	    var matchObject = void 0;
	
	    suggestionMatch = null;
	    suggestions = SUGGESTIONS[char];
	
	    if (!match && !suggestions) {
	      positions[positionIndex] = char;
	      matches.push(char);
	    } else {
	      if (suggestions && suggestions.length) {
	        // it might be a longer match
	        suggestionMatch = suggestions.filter(function (s) {
	          return format.substr(index, s.length) == s;
	        })[0];
	      }
	
	      if (!suggestionMatch) {
	        if (!_formats2.default[char]) {
	          console.warn('Format ' + char + ' is not supported yet!');
	          if (suggestions) {
	            console.warn('Use one of ["' + suggestions.join(',') + '"]');
	          }
	          positions[positionIndex] = char;
	          matches.push(char);
	        } else {
	          // we found a match, with no other suggestion
	
	          var currentFormat = _formats2.default[char];
	          var start = positionIndex;
	          var end = positionIndex + (currentFormat.length || 1) - 1;
	
	          matchObject = (0, _objectAssign2.default)({}, currentFormat, { format: char, start: start, end: end });
	
	          for (; start <= end; start++) {
	            positions[positionIndex] = matchObject;
	            positionIndex++;
	          }
	          index++;
	          matches.push(matchObject);
	          continue; // to skip incrementing twice
	        }
	      } else {
	          matchObject = (0, _objectAssign2.default)({}, _formats2.default[suggestionMatch], {
	            format: suggestionMatch, start: positionIndex
	          });
	          matches.push(matchObject);
	
	          var endIndex = positionIndex + suggestionMatch.length;
	
	          matchObject.end = endIndex - 1;
	          while (positionIndex < endIndex) {
	            positions[positionIndex] = matchObject;
	            positionIndex++;
	            index++;
	          }
	          continue; // to skip incrementing index once more
	        }
	    }
	
	    positionIndex++;
	    index++;
	  }
	
	  return { positions: positions, matches: matches };
	};

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderNavBar = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _reactFlex = __webpack_require__(41);
	
	var _reactInlineBlock = __webpack_require__(122);
	
	var _reactInlineBlock2 = _interopRequireDefault(_reactInlineBlock);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _clampRange = __webpack_require__(475);
	
	var _clampRange2 = _interopRequireDefault(_clampRange);
	
	var _NavBar = __webpack_require__(160);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _toMoment = __webpack_require__(33);
	
	var _toMoment2 = _interopRequireDefault(_toMoment);
	
	var _join = __webpack_require__(32);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _isInRange2 = __webpack_require__(477);
	
	var _isInRange3 = _interopRequireDefault(_isInRange2);
	
	var _BasicMonthView = __webpack_require__(466);
	
	var _MonthView = __webpack_require__(159);
	
	var _MonthView2 = _interopRequireDefault(_MonthView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var times = function times(count) {
	  return [].concat(_toConsumableArray(new Array(count))).map(function (v, i) {
	    return i;
	  });
	};
	
	var prepareDate = function prepareDate(props, state) {
	  if (props.range) {
	    return null;
	  }
	
	  return props.date === undefined ? state.date : props.date;
	};
	
	var prepareViewDate = function prepareViewDate(props, state) {
	  return props.viewDate === undefined ? state.viewDate : state.propViewDate || props.viewDate;
	};
	
	var prepareRange = function prepareRange(props, state) {
	  return props.range && props.range.length ? props.range : state.range;
	};
	
	var prepareActiveDate = function prepareActiveDate(props, state) {
	  var fallbackDate = prepareDate(props, state) || (prepareRange(props, state) || [])[0];
	
	  var activeDate = props.activeDate === undefined ?
	  // only fallback to date if activeDate not specified
	  state.activeDate || fallbackDate : props.activeDate;
	
	  if (activeDate && props.inViewStart && props.inViewEnd && props.constrainActiveInView) {
	    var activeMoment = this.toMoment(activeDate);
	
	    if (!(0, _isInRange3.default)(activeMoment, [props.inViewStart, props.inViewEnd])) {
	      var date = fallbackDate;
	      var dateMoment = this.toMoment(date);
	
	      if (date && (0, _isInRange3.default)(dateMoment, [props.inViewStart, props.inViewEnd])) {
	        return date;
	      }
	
	      return null;
	    }
	  }
	
	  return activeDate;
	};
	
	var prepareViews = function prepareViews(props) {
	  var daysInView = [];
	
	  var viewMoments = [];
	
	  var viewMoment = props.viewMoment;
	
	  var index = 0;
	  var size = props.size;
	
	  while (index < size) {
	    var mom = this.toMoment(viewMoment).startOf('day').add(index, 'month');
	    var days = (0, _BasicMonthView.getDaysInMonthView)(mom, props);
	
	    viewMoments.push(mom);
	    daysInView.push(days);
	
	    index++;
	  }
	
	  props.daysInView = daysInView;
	  props.viewMoments = viewMoments;
	
	  var lastViewDays = daysInView[size - 1];
	
	  props.inViewStart = daysInView[0][0];
	  props.inViewEnd = lastViewDays[lastViewDays.length - 1];
	};
	
	var _renderNavBar = function _renderNavBar(config, navBarProps) {
	  var props = this.props;
	  var index = config.index;
	  var viewMoment = config.viewMoment;
	
	
	  navBarProps = (0, _objectAssign2.default)({}, navBarProps, {
	    secondary: true,
	
	    minDate: config.minDate || props.minDate,
	    maxDate: config.maxDate || props.maxDate,
	
	    renderNavNext: config.renderHiddenNav || this.renderHiddenNav,
	    renderNavPrev: config.renderHiddenNav || this.renderHiddenNav,
	
	    viewMoment: viewMoment,
	
	    onViewDateChange: config.onViewDateChange || this.onNavViewDateChange,
	    onUpdate: config.onUpdate || this.updateViewMoment,
	
	    enableHistoryView: props.enableHistoryView
	  });
	
	  if (index == 0) {
	    delete navBarProps.renderNavPrev;
	  }
	
	  if (index == props.perRow - 1) {
	    delete navBarProps.renderNavNext;
	  }
	
	  return _react2.default.createElement(_NavBar2.default, navBarProps);
	};
	
	exports.renderNavBar = _renderNavBar;
	
	var MultiMonthView = function (_Component) {
	  _inherits(MultiMonthView, _Component);
	
	  function MultiMonthView(props) {
	    _classCallCheck(this, MultiMonthView);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(MultiMonthView).call(this, props));
	
	    _this.state = {
	      hoverRange: null,
	      range: props.defaultRange,
	      date: props.defaultDate,
	      activeDate: props.defaultActiveDate,
	      viewDate: props.defaultViewDate
	    };
	    return _this;
	  }
	
	  _createClass(MultiMonthView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateToMoment(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.locale != this.props.locale || nextProps.dateFormat != this.props.dateFormat) {
	        this.updateToMoment(nextProps);
	      }
	
	      // if (nextProps.viewDate && !nextProps.forceViewUpdate){
	
	      //   //this is here in order not to change view if already in view
	      //   const viewMoment = this.toMoment(nextProps.viewDate)
	
	      //   if (this.isInRange(viewMoment) && !nextProps.forceViewUpdate){
	      //     console.log(this.format(viewMoment), this.format(this.p.viewStart),
	      // this.format(this.p.viewEnd))
	      //     this.setState({
	      //       propViewDate: this.p.viewMoment
	      //     })
	      //   } else {
	      //     debugger
	      //     this.setState({
	      //       propViewDate: null
	      //     })
	      //   }
	      // }
	    }
	  }, {
	    key: 'updateToMoment',
	    value: function updateToMoment(props) {
	      this.toMoment = function (value, dateFormat) {
	        return (0, _toMoment2.default)(value, {
	          locale: props.locale,
	          dateFormat: dateFormat || props.dateFormat
	        });
	      };
	    }
	  }, {
	    key: 'prepareProps',
	    value: function prepareProps(thisProps, state) {
	      var _this2 = this;
	
	      var props = (0, _objectAssign2.default)({}, thisProps);
	      state = state || this.state;
	
	      props.viewMoment = this.toMoment(prepareViewDate(props, state));
	
	      // viewStart is the first day of the first month displayed
	      // viewEnd is the last day of the last month displayed
	      props.viewStart = this.toMoment(props.viewMoment).startOf('month');
	      props.viewEnd = this.toMoment(props.viewStart).add(props.size - 1, 'month').endOf('month');
	
	      // but we also have inViewStart, which can be a day before viewStart
	      // which is in displayed as belonging to the prev month
	      // but is displayed in the current view since it's on the same week
	      // as viewStart
	      //
	      // same for inViewEnd, which is a day after viewEnd - the last day in the same week
	      prepareViews.call(this, props);
	
	      var activeDate = prepareActiveDate.call(this, props, state);
	
	      if (activeDate) {
	        props.activeDate = +this.toMoment(activeDate);
	      }
	
	      props.date = prepareDate(props, state);
	
	      if (!props.date) {
	        var range = prepareRange(props, state);
	
	        if (range) {
	          props.range = range.map(function (d) {
	            return _this2.toMoment(d).startOf('day');
	          });
	          props.rangeStart = state.rangeStart || (props.range.length == 1 ? props.range[0] : null);
	        }
	      }
	
	      return props;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.views = [];
	      var props = this.p = this.prepareProps(this.props, this.state);
	      var size = props.size;
	
	      var rowCount = Math.ceil(size / props.perRow);
	      var children = times(rowCount).map(this.renderRow).filter(function (x) {
	        return !!x;
	      });
	
	      var className = (0, _join2.default)(props.className, 'react-date-picker__multi-month-view', props.theme && 'react-date-picker__multi-month-view--theme-' + props.theme);
	
	      var footer = (0, _MonthView.renderFooter)(props, this);
	
	      if (footer) {
	        children.push(footer);
	      }
	
	      var flexProps = (0, _objectAssign2.default)({}, props);
	
	      delete flexProps.activeDate;
	      delete flexProps.clockTabIndex;
	      delete flexProps.constrainActiveInView;
	      delete flexProps.constrainViewDate;
	      delete flexProps.date;
	      delete flexProps.dateFormat;
	      delete flexProps.daysInView;
	      delete flexProps.defaultRange;
	      delete flexProps.enableHistoryView;
	      delete flexProps.footer;
	      delete flexProps.footerClearDate;
	      delete flexProps.forceViewUpdate;
	      delete flexProps.highlightRangeOnMouseMove;
	      delete flexProps.inViewEnd;
	      delete flexProps.inViewStart;
	      delete flexProps.isDatePicker;
	      delete flexProps.locale;
	      delete flexProps.navigation;
	      delete flexProps.onViewDateChange;
	      delete flexProps.perRow;
	      delete flexProps.range;
	      delete flexProps.rangeStart;
	      delete flexProps.renderNavBar;
	      delete flexProps.theme;
	      delete flexProps.viewDate;
	      delete flexProps.viewEnd;
	      delete flexProps.viewMoment;
	      delete flexProps.viewMoments;
	      delete flexProps.viewStart;
	
	      return _react2.default.createElement(_reactFlex.Flex, _extends({
	        column: true,
	        inline: true,
	        alignItems: 'stretch',
	        wrap: false
	      }, flexProps, {
	        className: className,
	        children: children
	      }));
	    }
	  }, {
	    key: 'renderRow',
	    value: function renderRow(rowIndex) {
	      var _this3 = this;
	
	      var props = this.p;
	      var viewProps = (0, _objectAssign2.default)({}, this.p);
	
	      delete viewProps.forceViewUpdate;
	      delete viewProps.index;
	      delete viewProps.inViewEnd;
	      delete viewProps.inViewStart;
	      delete viewProps.navigate;
	      delete viewProps.perRow;
	      delete viewProps.viewEnd;
	      delete viewProps.viewMoments;
	      delete viewProps.viewStart;
	
	      var children = times(props.perRow).map(function (i) {
	        var index = rowIndex * props.perRow + i;
	
	        if (index >= props.size) {
	          return null;
	        }
	
	        return _this3.renderView(viewProps, index, props.size);
	      });
	
	      return _react2.default.createElement(_reactFlex.Flex, { inline: true, row: true, wrap: false, children: children });
	    }
	  }, {
	    key: 'renderView',
	    value: function renderView(viewProps, index, size) {
	      var _this4 = this;
	
	      var props = this.p;
	      var viewMoment = props.viewMoments[index];
	
	      var range = void 0;
	
	      if (props.range) {
	        range = props.rangeStart && props.range.length == 0 ? [props.rangeStart] : props.range;
	      }
	
	      return _react2.default.createElement(_MonthView2.default, _extends({
	        ref: function ref(view) {
	          _this4.views[index] = view;
	        },
	        constrainViewDate: false
	      }, viewProps, {
	
	        className: null,
	
	        index: index,
	
	        footer: false,
	        constrainActiveInView: false,
	
	        navigate: this.onMonthNavigate.bind(this, index),
	        hoverRange: this.state.hoverRange,
	        onHoverRangeChange: this.setHoverRange,
	
	        activeDate: props.activeDate,
	
	        onActiveDateChange: this.onActiveDateChange,
	        onViewDateChange: this.onAdjustViewDateChange,
	
	        date: props.date,
	        defaultDate: null,
	        onChange: this.onChange,
	
	        range: range,
	        defaultRange: null,
	        onRangeChange: this.onRangeChange,
	
	        viewMoment: viewMoment,
	
	        insideMultiView: true,
	
	        daysInView: props.daysInView[index],
	
	        showDaysBeforeMonth: index == 0,
	        showDaysAfterMonth: index == size - 1,
	
	        select: this.select,
	
	        renderNavBar: this.props.navigation && (this.props.renderNavBar || this.renderNavBar).bind(this, { index: index, viewMoment: viewMoment })
	      }));
	    }
	  }, {
	    key: 'onFooterTodayClick',
	    value: function onFooterTodayClick() {
	      this.views[0].onFooterTodayClick();
	    }
	  }, {
	    key: 'onFooterClearClick',
	    value: function onFooterClearClick() {
	      this.views[0].onFooterClearClick();
	    }
	  }, {
	    key: 'onFooterOkClick',
	    value: function onFooterOkClick() {
	      this.views[0].onFooterOkClick();
	    }
	  }, {
	    key: 'onFooterCancelClick',
	    value: function onFooterCancelClick() {
	      this.views[0].onFooterCancelClick();
	    }
	  }, {
	    key: 'isFocused',
	    value: function isFocused() {
	      var firstView = this.views[0];
	
	      if (firstView) {
	        return firstView.isFocused();
	      }
	
	      return false;
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      var firstView = this.views[0];
	
	      if (firstView) {
	        firstView.focus();
	      }
	    }
	  }, {
	    key: 'setHoverRange',
	    value: function setHoverRange(hoverRange) {
	      this.setState({
	        hoverRange: hoverRange
	      });
	    }
	  }, {
	    key: 'select',
	    value: function select(_ref) {
	      var dateMoment = _ref.dateMoment;
	      var timestamp = _ref.timestamp;
	
	      // if (!dateMoment) {
	      //   return
	      // }
	
	      var props = this.p;
	
	      var visibleRange = [props.inViewStart, props.inViewEnd];
	
	      // TODO check why this was needed
	      // if (!isInRange(dateMoment, { range: visibleRange, inclusive: true })) {
	      //   return
	      // }
	
	      this.onAdjustViewDateChange({ dateMoment: dateMoment, timestamp: timestamp });
	      this.onActiveDateChange({ dateMoment: dateMoment, timestamp: timestamp });
	
	      var range = props.range;
	
	      if (range) {
	        this.selectRange({ dateMoment: dateMoment, timestamp: timestamp });
	      } else {
	        this.onChange({ dateMoment: dateMoment, timestamp: timestamp }, event);
	      }
	    }
	  }, {
	    key: 'selectRange',
	    value: function selectRange(_ref2) {
	      var dateMoment = _ref2.dateMoment;
	      var timestamp = _ref2.timestamp;
	
	      return _MonthView2.default.prototype.selectRange.call(this, { dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }, {
	    key: 'onRangeChange',
	    value: function onRangeChange(range) {
	      return _MonthView2.default.prototype.onRangeChange.call(this, range);
	    }
	  }, {
	    key: 'onViewKeyDown',
	    value: function onViewKeyDown() {
	      var view = this.views[0];
	      if (view) {
	        view.onViewKeyDown.apply(view, arguments);
	      }
	    }
	  }, {
	    key: 'renderNavBar',
	    value: function renderNavBar(config, navBarProps) {
	      return _renderNavBar.call(this, config, navBarProps);
	    }
	  }, {
	    key: 'onMonthNavigate',
	    value: function onMonthNavigate(index, dir, event, getNavigationDate) {
	      var props = this.p;
	
	      event.preventDefault();
	
	      if (!props.activeDate) {
	        return;
	      }
	
	      var key = event.key;
	
	      var homeEndDate = key == 'Home' ? props.viewStart : props.viewEnd;
	
	      var mom = key == 'Home' || key == 'End' ? homeEndDate : props.activeDate;
	
	      var nextMoment = getNavigationDate(dir, this.toMoment(mom));
	
	      var viewMoment = this.toMoment(nextMoment);
	
	      this.onActiveDateChange({
	        dateMoment: nextMoment,
	        timestamp: +nextMoment
	      });
	
	      if (this.isInRange(viewMoment)) {
	        return;
	      }
	
	      if (viewMoment.isAfter(props.viewEnd)) {
	        viewMoment.add(-props.size + 1, 'month');
	      }
	
	      this.onViewDateChange({
	        dateMoment: viewMoment,
	        timestamp: +viewMoment
	      });
	    }
	  }, {
	    key: 'onAdjustViewDateChange',
	    value: function onAdjustViewDateChange(_ref3) {
	      var dateMoment = _ref3.dateMoment;
	      var timestamp = _ref3.timestamp;
	
	      var props = this.p;
	
	      var update = dateMoment == null;
	
	      if (dateMoment && dateMoment.isAfter(props.viewEnd)) {
	        dateMoment = this.toMoment(dateMoment).add(-props.size + 1, 'month');
	        timestamp = +dateMoment;
	        update = true;
	      } else if (dateMoment && dateMoment.isBefore(props.viewStart)) {
	        update = true;
	      }
	
	      if (update) {
	        this.onViewDateChange({ dateMoment: dateMoment, timestamp: timestamp });
	      }
	    }
	  }, {
	    key: 'updateViewMoment',
	    value: function updateViewMoment(dateMoment, dir) {
	      var sign = dir < 0 ? -1 : 1;
	      var abs = Math.abs(dir);
	
	      var newMoment = this.toMoment(this.p.viewStart);
	
	      newMoment.add(sign, abs == 1 ? 'month' : 'year');
	
	      return newMoment;
	    }
	  }, {
	    key: 'renderHiddenNav',
	    value: function renderHiddenNav(props) {
	      return _react2.default.createElement(_reactInlineBlock2.default, _extends({}, props, { style: { visibility: 'hidden' } }));
	    }
	  }, {
	    key: 'isInRange',
	    value: function isInRange(moment) {
	      return (0, _isInRange3.default)(moment, [this.p.viewStart, this.p.viewEnd]);
	    }
	  }, {
	    key: 'isInView',
	    value: function isInView(moment) {
	      return this.isInRange(moment);
	    }
	  }, {
	    key: 'onNavViewDateChange',
	    value: function onNavViewDateChange(dateString, _ref4) {
	      var dateMoment = _ref4.dateMoment;
	      var timestamp = _ref4.timestamp;
	
	      this.onViewDateChange({ dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }, {
	    key: 'onViewDateChange',
	    value: function onViewDateChange(_ref5) {
	      var dateMoment = _ref5.dateMoment;
	      var timestamp = _ref5.timestamp;
	
	      if (this.props.viewDate === undefined) {
	        this.setState({
	          viewDate: timestamp
	        });
	      }
	
	      if (this.props.onViewDateChange) {
	        var dateString = this.format(dateMoment);
	        this.props.onViewDateChange(dateString, { dateMoment: dateMoment, dateString: dateString, timestamp: timestamp });
	      }
	    }
	  }, {
	    key: 'onActiveDateChange',
	    value: function onActiveDateChange(_ref6) {
	      var dateMoment = _ref6.dateMoment;
	      var timestamp = _ref6.timestamp;
	
	      var valid = this.views.reduce(function (isValid, view) {
	        return isValid && view.isValidActiveDate(timestamp);
	      }, true);
	
	      if (!valid) {
	        return;
	      }
	
	      var props = this.p;
	      var range = props.range;
	
	      if (range && props.rangeStart) {
	        this.setState({
	          rangeStart: props.rangeStart,
	          range: (0, _clampRange2.default)([props.rangeStart, dateMoment])
	        });
	      }
	
	      if (this.props.activeDate === undefined) {
	        this.setState({
	          activeDate: timestamp
	        });
	      }
	
	      if (this.props.onActiveDateChange) {
	        var dateString = this.format(dateMoment);
	        this.props.onActiveDateChange(dateString, { dateMoment: dateMoment, dateString: dateString, timestamp: timestamp });
	      }
	    }
	  }, {
	    key: 'gotoViewDate',
	    value: function gotoViewDate(_ref7) {
	      var dateMoment = _ref7.dateMoment;
	      var timestamp = _ref7.timestamp;
	
	      if (!timestamp) {
	        timestamp = +dateMoment;
	      }
	
	      this.onViewDateChange({ dateMoment: dateMoment, timestamp: timestamp });
	      this.onActiveDateChange({ dateMoment: dateMoment, timestamp: timestamp });
	    }
	  }, {
	    key: 'format',
	    value: function format(mom) {
	      return mom == null ? '' : mom.format(this.props.dateFormat);
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(_ref8, event) {
	      var dateMoment = _ref8.dateMoment;
	      var timestamp = _ref8.timestamp;
	
	      if (this.props.date === undefined) {
	        this.setState({
	          date: timestamp
	        });
	      }
	
	      if (this.props.onChange) {
	        var dateString = this.format(dateMoment);
	        this.props.onChange(dateString, { dateMoment: dateMoment, dateString: dateString, timestamp: timestamp }, event);
	      }
	    }
	  }, {
	    key: 'getViewSize',
	    value: function getViewSize() {
	      return this.props.size;
	    }
	  }]);
	
	  return MultiMonthView;
	}(_reactClass2.default);
	
	exports.default = MultiMonthView;
	
	
	MultiMonthView.defaultProps = {
	  perRow: 2,
	  size: 2,
	
	  enableHistoryView: true,
	
	  footerClearDate: null,
	
	  isDatePicker: true,
	  forceViewUpdate: false,
	
	  navigation: true,
	  theme: 'default',
	
	  constrainActiveInView: true,
	
	  dateFormat: 'YYYY-MM-DD'
	};
	
	MultiMonthView.propTypes = {};

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref10) {
	  var oldValue = _ref10.oldValue;
	  var range = _ref10.range;
	  var event = _ref10.event;
	  var _ref10$separator = _ref10.separator;
	  var separator = _ref10$separator === undefined ? ':' : _ref10$separator;
	  var incrementNext = _ref10.incrementNext;
	  var circular = _ref10.circular;
	  var propagate = _ref10.propagate;
	  var hours24 = _ref10.hours24;
	  var meridiem = _ref10.meridiem;
	
	
	  var newChar = String.fromCharCode(event.which);
	  var start = range.start;
	  var end = range.end;
	  var key = event.key;
	
	
	  if (key == 'Delete' || key == 'Backspace') {
	    return getValueOnDelete({
	      key: key,
	      oldValue: oldValue,
	      range: range,
	      separator: separator,
	      meridiem: meridiem
	    });
	  }
	
	  var dir = ARROWS[key];
	
	  if (dir) {
	    return getValueOnDirection({
	      hours24: hours24,
	      meridiem: meridiem,
	      dir: dir,
	      oldValue: oldValue,
	      range: range,
	      circular: circular,
	      propagate: propagate,
	      separator: separator,
	      incrementNext: incrementNext
	    });
	  }
	
	  if (key == 'Unidentified' && newChar * 1 == newChar) {
	    return getValueOnNumber({
	      num: newChar * 1,
	      circular: circular,
	      separator: separator,
	      oldValue: oldValue,
	      range: range,
	      meridiem: meridiem
	    });
	  }
	
	  return {
	    value: oldValue
	  };
	};
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _toTimeValue = __webpack_require__(473);
	
	var _toTimeValue2 = _interopRequireDefault(_toTimeValue);
	
	var _leftPad = __webpack_require__(219);
	
	var _leftPad2 = _interopRequireDefault(_leftPad);
	
	var _clamp = __webpack_require__(476);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var removeAt = function removeAt(_ref) {
	  var value = _ref.value;
	  var index = _ref.index;
	  var _ref$len = _ref.len;
	  var len = _ref$len === undefined ? 1 : _ref$len;
	
	  return value.substring(0, index) + value.substring(index + len);
	};
	
	var replaceAt = function replaceAt(_ref2) {
	  var value = _ref2.value;
	  var index = _ref2.index;
	  var _ref2$len = _ref2.len;
	  var len = _ref2$len === undefined ? 1 : _ref2$len;
	  var str = _ref2.str;
	
	  return value.substring(0, index) + str + value.substring(index + len);
	};
	
	var replaceBetween = function replaceBetween(_ref3) {
	  var value = _ref3.value;
	  var start = _ref3.start;
	  var end = _ref3.end;
	  var str = _ref3.str;
	
	  return (value.substring(0, start) || '') + str + (value.substring(end) || '');
	};
	
	var toggleMeridiem = function toggleMeridiem(meridiem) {
	  return {
	    am: 'pm',
	    AM: 'PM',
	    pm: 'am',
	    PM: 'pm'
	  }[meridiem];
	};
	
	var getValueOnDelete = function getValueOnDelete(_ref4) {
	  var oldValue = _ref4.oldValue;
	  var range = _ref4.range;
	  var key = _ref4.key;
	  var separator = _ref4.separator;
	  var meridiem = _ref4.meridiem;
	  var start = range.start;
	  var end = range.end;
	
	
	  var selectedValue = oldValue.substring(start, end);
	
	  var value = void 0;
	
	  if (selectedValue) {
	
	    var replacement = selectedValue.split('').map(function (c) {
	      if (c == separator || c == ' ') {
	        return c;
	      }
	
	      if (meridiem && c * 1 != c) {
	        return c == 'p' ? 'a' : c == 'P' ? 'A' : c;
	      }
	
	      return 0;
	    }).join('');
	
	    value = replaceBetween({ value: oldValue, start: start, end: end, str: replacement });
	
	    return {
	      value: value,
	      update: value != oldValue,
	      caretPos: key == 'Backspace' ? start : end
	    };
	  } else {
	
	    var back = key == 'Backspace';
	    var index = start + (back ? -1 : 0);
	    var caretPos = start + (back ? -1 : 1);
	
	    if (index < 0) {
	      return {
	        value: oldValue,
	        update: false
	      };
	    }
	
	    var char = oldValue[index];
	
	    value = oldValue;
	
	    var _replacement = char == separator || char == ' ' ? char : 0;
	
	    if (char && char * 1 != char && _replacement === 0 && meridiem) {
	      if (char == 'p') {
	        _replacement = 'a';
	      } else if (char == 'P') {
	        _replacement = 'A';
	      } else if (char == 'M' || char == 'm' || char == 'a' || char == 'A') {
	        _replacement = char;
	      }
	    }
	
	    value = replaceAt({ value: oldValue, index: index, str: _replacement });
	
	    return {
	      update: value != oldValue,
	      value: value,
	      caretPos: caretPos
	    };
	  }
	};
	
	var ARROWS = {
	  ArrowUp: 1,
	  ArrowDown: -1,
	  PageUp: 10,
	  PageDown: -10
	};
	
	var TIME_PARTS = {
	  24: [{ start: 0, end: 2, name: 'hours', max: 23 }, { start: 3, end: 5, name: 'minutes', max: 59 }, { start: 6, end: 8, name: 'seconds', max: 59 }],
	  12: [{ start: 0, end: 2, name: 'hours', max: 12, min: 1 }, { start: 3, end: 5, name: 'minutes', max: 59 }, { start: 6, end: 8, name: 'seconds', max: 59 }]
	};
	
	var getActiveTimePartIndex = function getActiveTimePartIndex(_ref5) {
	  var value = _ref5.value;
	  var timeValue = _ref5.timeValue;
	  var separator = _ref5.separator;
	  var range = _ref5.range;
	  var hours24 = _ref5.hours24;
	  var meridiem = _ref5.meridiem;
	  var start = range.start;
	
	  var timeParts = TIME_PARTS[hours24 ? 24 : 12];
	
	  var partIndex = 0;
	  var currentPart = void 0;
	
	  while (currentPart = timeParts[partIndex]) {
	
	    if (currentPart.name == 'seconds' && timeValue && !timeValue.seconds) {
	      return 4; //the index of the meridiem
	    }
	    if (start >= currentPart.start && start <= currentPart.end) {
	      return partIndex;
	    }
	
	    partIndex++;
	  }
	
	  return 4;
	};
	
	var getTimePartAt = function getTimePartAt(index, _ref6) {
	  var hours24 = _ref6.hours24;
	
	  return (0, _objectAssign2.default)({}, TIME_PARTS[hours24 ? 24 : 12][index]);
	};
	
	var getActiveTimePart = function getActiveTimePart(_ref7) {
	  var value = _ref7.value;
	  var timeValue = _ref7.timeValue;
	  var separator = _ref7.separator;
	  var range = _ref7.range;
	  var hours24 = _ref7.hours24;
	  var meridiem = _ref7.meridiem;
	
	
	  var index = getActiveTimePartIndex({ value: value, timeValue: timeValue, separator: separator, range: range, hours24: hours24 });
	
	  if (index == 4 && meridiem) {
	    var timePart = {
	      start: 6, end: 8, name: 'meridiem'
	    };
	
	    if (timeValue.seconds) {
	      timePart.start += 3;
	      timePart.end += 3;
	    }
	
	    return timePart;
	  }
	
	  return getTimePartAt(index, { hours24: hours24 });
	};
	
	var getValueOnDirection = function getValueOnDirection(_ref8) {
	  var oldValue = _ref8.oldValue;
	  var range = _ref8.range;
	  var separator = _ref8.separator;
	  var dir = _ref8.dir;
	  var incrementNext = _ref8.incrementNext;
	  var circular = _ref8.circular;
	  var propagate = _ref8.propagate;
	  var hours24 = _ref8.hours24;
	  var meridiem = _ref8.meridiem;
	  var start = range.start;
	  var end = range.end;
	
	
	  var value = void 0;
	
	  var timeValue = (0, _toTimeValue2.default)({ value: oldValue, separator: separator, meridiem: meridiem });
	  var activeTimePart = getActiveTimePart({ value: oldValue, timeValue: timeValue, separator: separator, range: range, hours24: hours24, meridiem: meridiem });
	
	  if (activeTimePart.name != 'meridiem') {
	    timeValue[activeTimePart.name] = dir + timeValue[activeTimePart.name] * 1;
	  }
	
	  var hours = timeValue.hours;
	  var minutes = timeValue.minutes;
	  var seconds = timeValue.seconds;
	
	
	  var toggleMeridiemValue = false;
	
	  hours *= 1;
	  minutes *= 1;
	
	  if (seconds) {
	    seconds *= 1;
	  }
	
	  if (activeTimePart.name != 'meridiem') {
	
	    if (seconds && (seconds > 59 || seconds < 0)) {
	
	      if (propagate) {
	        minutes += seconds > 59 ? 1 : -1;
	      }
	
	      if (circular) {
	        seconds %= 60;
	
	        if (seconds < 0) {
	          seconds = 60 + seconds;
	        }
	      }
	    }
	
	    if (minutes && (minutes > 59 || minutes < 0)) {
	      if (propagate) {
	        hours += minutes > 59 ? 1 : -1;
	      }
	
	      if (circular) {
	        minutes %= 60;
	
	        if (minutes < 0) {
	          minutes = 60 + minutes;
	        }
	      }
	    }
	
	    if (meridiem && circular && (hours > 12 || hours < 1)) {
	      toggleMeridiemValue = true;
	    }
	  }
	
	  hours = (0, _leftPad2.default)((0, _clamp.clampHour)(hours * 1, { circular: circular, max: activeTimePart.max, min: activeTimePart.min }));
	  minutes = (0, _leftPad2.default)((0, _clamp.clampMinute)(minutes * 1, { circular: circular }));
	
	  if (seconds != undefined) {
	    seconds = (0, _leftPad2.default)((0, _clamp.clampSecond)(seconds * 1, { circular: circular }));
	  }
	
	  value = hours + separator + minutes;
	
	  if (seconds) {
	    value += separator + seconds;
	  }
	
	  if (activeTimePart.name == 'meridiem') {
	    toggleMeridiemValue = true;
	  }
	
	  if (meridiem) {
	    value += ' ' + (toggleMeridiemValue ? toggleMeridiem(timeValue.meridiem) : timeValue.meridiem);
	  }
	
	  return {
	    value: value,
	    caretPos: activeTimePart || range.start,
	    update: oldValue != value
	  };
	};
	
	var getValueOnNumber = function getValueOnNumber(_ref9) {
	  var oldValue = _ref9.oldValue;
	  var num = _ref9.num;
	  var range = _ref9.range;
	  var separator = _ref9.separator;
	  var circular = _ref9.circular;
	  var hours24 = _ref9.hours24;
	  var meridiem = _ref9.meridiem;
	
	  var activeTimePartIndex = getActiveTimePartIndex({ value: oldValue, separator: separator, range: range, hours24: hours24 });
	  var activeTimePart = getTimePartAt(activeTimePartIndex, { hours24: hours24 });
	
	  if (activeTimePart && range.start == range.end && activeTimePart.end == range.end) {
	    activeTimePart = getTimePartAt(activeTimePartIndex + 1, { hours24: hours24 });
	  }
	
	  if (!activeTimePart) {
	    return {
	      value: value,
	      update: false
	    };
	  }
	
	  var name = activeTimePart.name;
	  var timeParts = (0, _toTimeValue2.default)({ value: oldValue, separator: separator, meridiem: meridiem });
	
	  var timePartValue = timeParts[name] + '';
	
	  var caretPos = void 0;
	
	  if (range.start <= activeTimePart.start) {
	    var maxFirstChar = (activeTimePart.max + '').charAt(0) * 1;
	
	    caretPos = range.start + (num > maxFirstChar ? 3 : range.start < activeTimePart.start ? 2 : 1);
	    timeParts[name] = num > maxFirstChar ? '0' + num : num + timeParts[name].charAt(1);
	  } else {
	    caretPos = range.start + 2;
	    timeParts[name] = (0, _clamp.clampNamed)(name, replaceAt({ value: timePartValue, index: 1, str: num }) * 1, { circular: circular });
	  }
	
	  var hours = timeParts.hours;
	  var minutes = timeParts.minutes;
	  var seconds = timeParts.seconds;
	
	
	  var value = hours + separator + minutes;
	
	  if (seconds) {
	    value += separator + seconds;
	  }
	
	  if (meridiem) {
	    value += ' ' + timeParts.meridiem;
	  }
	
	  return {
	    value: value,
	    caretPos: caretPos,
	    update: true
	  };
	};

/***/ },
/* 907 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = getSelectionEnd;
	var document = global.document;
	
	function getSelectionEnd(o) {
	    if (o.createTextRange && !global.getSelection) {
	        var r = document.selection.createRange().duplicate();
	        r.moveStart('character', -o.value.length);
	        return r.text.length;
	    } else return o.selectionEnd;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 908 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = getSelectionStart;
	var document = global.document;
	
	//from http://javascript.nwbox.com/cursor_position/, but added the !window.getSelection check, which
	//is needed for newer versions of IE, which adhere to standards
	function getSelectionStart(o) {
	    if (o.createTextRange && !global.getSelection) {
	        var r = document.selection.createRange().duplicate();
	        r.moveEnd('character', o.value.length);
	        if (r.text == '') return o.value.length;
	        return o.value.lastIndexOf(r.text);
	    } else return o.selectionStart;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 909 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setCaretPosition;
	function setCaretPosition(elem, caretPos) {
	  var start = caretPos;
	  var end = caretPos;
	
	  if (caretPos && (caretPos.start != undefined || caretPos.end != undefined)) {
	    start = caretPos.start || 0;
	    end = caretPos.end || start;
	  }
	
	  if (elem != null) {
	    if (elem.createTextRange) {
	      var range = elem.createTextRange();
	      range.moveStart('character', start);
	      range.moveEnd('character', end);
	      range.select();
	    } else {
	      elem.focus();
	      elem.setSelectionRange(start, end);
	    }
	  }
	}

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(58);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _TimeInput = __webpack_require__(218);
	
	var _TimeInput2 = _interopRequireDefault(_TimeInput);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _toMoment = __webpack_require__(33);
	
	var _toMoment2 = _interopRequireDefault(_toMoment);
	
	var _join = __webpack_require__(32);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _Clock = __webpack_require__(158);
	
	var _Clock2 = _interopRequireDefault(_Clock);
	
	var _reactFlex = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimePicker = function (_Component) {
	  _inherits(TimePicker, _Component);
	
	  function TimePicker(props) {
	    _classCallCheck(this, TimePicker);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TimePicker).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  // prepareDate(props){
	  //   return toMoment(props.date, props)
	  // }
	
	  _createClass(TimePicker, [{
	    key: 'render',
	    value: function render() {
	
	      var props = this.p = (0, _objectAssign2.default)({}, this.props);
	      props.children = _react2.default.Children.toArray(props.children);
	
	      var timeFormat = props.timeFormat.toLowerCase();
	
	      // props.date = this.prepareDate(props)
	      props.hasTime = props.hasTime || timeFormat.indexOf('k') != -1 || timeFormat.indexOf('h') != -1;
	
	      var className = (0, _join2.default)(props.className, 'react-date-picker__time-picker', props.theme && 'react-date-picker__time-picker--theme-' + props.theme);
	
	      return _react2.default.createElement(
	        _reactFlex.Flex,
	        _extends({
	          inline: true,
	          column: true,
	          wrap: false
	        }, this.props, {
	          className: className }),
	        this.renderClock(),
	        this.renderInput()
	      );
	    }
	  }, {
	    key: 'renderInput',
	    value: function renderInput() {
	      return _react2.default.createElement(_TimeInput2.default, {
	        className: 'react-date-picker__time-picker-input',
	        format: this.props.timeFormat || this.props.format,
	        defaultValue: this.props.value || this.props.defaultValue,
	        onChange: this.onTimeChange
	      });
	    }
	  }, {
	    key: 'onTimeChange',
	    value: function onTimeChange(value) {
	      var time = value.split(':');
	
	      var seconds = time[0] * 3600 + parseInt(time[1], 10) * 60;
	
	      if (time[2]) {
	        seconds += parseInt(time[2], 10);
	      }
	
	      this.setState({
	        seconds: seconds
	      });
	
	      if (this.props.onChange) {
	        this.props.onChange(value);
	      }
	    }
	  }, {
	    key: 'renderClock',
	    value: function renderClock() {
	
	      var props = this.p;
	      var clock = props.children.filter(function (child) {
	        return child && child.props && child.props.isTimePickerClock;
	      })[0];
	
	      var clockProps = {
	        seconds: this.state.seconds,
	        showSecondsHand: true
	      };
	
	      if (clock) {
	        return _react2.default.cloneElement(clock, clockProps);
	      }
	
	      return _react2.default.createElement(_Clock2.default, clockProps);
	    }
	  }]);
	
	  return TimePicker;
	}(_reactClass2.default);
	
	exports.default = TimePicker;
	
	
	TimePicker.defaultProps = {
	  format: 'HH:mm:ss a',
	  theme: 'default',
	  isTimePicker: true
	};
	
	TimePicker.propTypes = {};

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(58);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _objectAssign = __webpack_require__(26);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _join = __webpack_require__(32);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _toMoment2 = __webpack_require__(33);
	
	var _toMoment3 = _interopRequireDefault(_toMoment2);
	
	var _forwardTime = __webpack_require__(161);
	
	var _forwardTime2 = _interopRequireDefault(_forwardTime);
	
	var _getTransitionEnd = __webpack_require__(912);
	
	var _getTransitionEnd2 = _interopRequireDefault(_getTransitionEnd);
	
	var _assignDefined = __webpack_require__(83);
	
	var _assignDefined2 = _interopRequireDefault(_assignDefined);
	
	var _MonthView = __webpack_require__(159);
	
	var _NavBar = __webpack_require__(160);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _reactFlex = __webpack_require__(41);
	
	var _times = __webpack_require__(162);
	
	var _times2 = _interopRequireDefault(_times);
	
	var _reactInlineBlock = __webpack_require__(122);
	
	var _reactInlineBlock2 = _interopRequireDefault(_reactInlineBlock);
	
	var _reactStyleNormalizer = __webpack_require__(525);
	
	var _reactStyleNormalizer2 = _interopRequireDefault(_reactStyleNormalizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderHiddenNav = function renderHiddenNav(props) {
	  return _react2.default.createElement(_reactInlineBlock2.default, _extends({}, props, { style: { visibility: 'hidden' } }));
	};
	
	var joinFunctions = function joinFunctions(a, b) {
	  if (a && b) {
	    return function () {
	      a.apply(undefined, arguments);
	      b.apply(undefined, arguments);
	    };
	  }
	
	  return a || b;
	};
	
	var TRANSITION_DURATION = '0.4s';
	
	var TransitionView = function (_Component) {
	  _inherits(TransitionView, _Component);
	
	  function TransitionView(props) {
	    _classCallCheck(this, TransitionView);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TransitionView).call(this, props));
	
	    var child = _react2.default.Children.toArray(_this.props.children)[0];
	    var childProps = child.props;
	
	    var viewDate = props.viewDate || props.defaultViewDate || props.defaultDate || props.date || childProps.viewDate || childProps.defaultViewDate || childProps.defaultDate || childProps.date;
	
	    var dateFormat = props.dateFormat || childProps.dateFormat;
	    var locale = props.locale || childProps.locale;
	
	    _this.state = {
	      rendered: false,
	      viewDate: _this.toMoment(viewDate, { dateFormat: dateFormat, locale: locale })
	    };
	    return _this;
	  }
	
	  _createClass(TransitionView, [{
	    key: 'toMoment',
	    value: function toMoment(value, props) {
	      props = props || this.props;
	
	      return (0, _toMoment3.default)(value, {
	        locale: props.locale,
	        dateFormat: props.dateFormat
	      });
	    }
	  }, {
	    key: 'format',
	    value: function format(mom, props) {
	      props = props || this.props;
	      return mom.format(props.dateFormat);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        rendered: true
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.viewDate) {
	        // this is in order to transition when the prop changes
	        // if we were to simply do setState({ viewDate }) it wouldn't have had a transition
	        this.transitionTo(nextProps.viewDate, nextProps);
	      }
	    }
	  }, {
	    key: 'transitionTo',
	    value: function transitionTo(date, props) {
	      props = props || this.props;
	
	      var dateMoment = this.toMoment(date, props);
	
	      this.doTransition(dateMoment);
	    }
	  }, {
	    key: 'getViewChild',
	    value: function getViewChild() {
	      return _react2.default.Children.toArray(this.props.children).filter(function (c) {
	        return c && c.props && c.props.isDatePicker;
	      })[0];
	    }
	  }, {
	    key: 'prepareChildProps',
	    value: function prepareChildProps(child, extraProps) {
	      if (this.view) {
	        return this.view.p;
	      }
	
	      child = child || this.getViewChild();
	
	      return (0, _objectAssign2.default)({}, child.props, extraProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var props = this.props;
	
	      var child = this.child = this.getViewChild();
	
	      var viewDate = this.state.viewDate || props.viewMoment || props.viewDate;
	
	      var renderedChildProps = this.renderedChildProps = this.prepareChildProps(child, (0, _assignDefined2.default)({
	        viewDate: viewDate
	      }));
	
	      viewDate = this.state.viewDate || renderedChildProps.viewMoment || renderedChildProps.viewDate;
	
	      if (!this.state.transition) {
	        this.viewDate = viewDate;
	      }
	
	      var multiView = !!(child.props.size && child.props.size >= 2);
	
	      var onViewDateChange = joinFunctions(this.onViewDateChange, props.onViewDateChange);
	
	      // TODO make transition view pass all props, as is to child component
	      var newProps = {
	        key: 'picker',
	        ref: function ref(v) {
	          _this2.view = v;
	        },
	
	        viewDate: this.viewDate,
	        onViewDateChange: onViewDateChange,
	        navigation: multiView,
	        constrainActiveInView: props.constrainActiveInView,
	
	        className: (0, _join2.default)(child.props.className, 'react-date-picker__center')
	      };
	
	      // only pass those down if they have been specified
	      // as props on this TransitionView
	      (0, _assignDefined2.default)(newProps, {
	        // tabIndex: -1,
	        range: props.range,
	        date: props.date,
	        activeDate: props.activeDate,
	        footer: false,
	        insideField: props.insideField,
	
	        defaultRange: props.defaultRange,
	        defaultDate: props.defaultDate,
	        defaultActiveDate: props.defaultActiveDate,
	
	        // this is here in order to ensure time changes are reflected
	        // when using a TransitionView inside a DateField
	        onTimeChange: props.onTimeChange,
	        onClockInputBlur: props.onClockInputBlur,
	        onClockInputFocus: props.onClockInputFocus,
	        onClockEnterKey: props.onClockEnterKey,
	        onClockEscapeKey: props.onClockEscapeKey,
	        showClock: props.showClock,
	
	        tabIndex: props.tabIndex,
	
	        dateFormat: props.dateFormat,
	        locale: props.locale,
	        theme: props.theme,
	
	        minDate: props.minDate,
	        maxDate: props.maxDate,
	        onKeyDown: this.onKeyDown,
	        onBlur: this.onBlur
	      });
	
	      if (props.onChange) {
	        newProps.onChange = joinFunctions(props.onChange, renderedChildProps.onChange);
	      }
	      if (props.onRangeChange) {
	        newProps.onRangeChange = joinFunctions(props.onRangeChange, renderedChildProps.onRangeChange);
	      }
	
	      if (props.onActiveDateChange) {
	        newProps.onActiveDateChange = joinFunctions(props.onActiveDateChange, renderedChildProps.onActiveDateChange);
	      }
	
	      if (this.state.transition) {
	        this.transitionDurationStyle = (0, _reactStyleNormalizer2.default)({
	          transitionDuration: props.transitionDuration || TRANSITION_DURATION
	        });
	
	        newProps.style = (0, _objectAssign2.default)({}, child.props.style, this.transitionDurationStyle);
	
	        newProps.className = (0, _join2.default)(newProps.className, 'react-date-picker--transition', 'react-date-picker--transition-' + (this.state.transition == -1 ? 'left' : 'right'));
	      }
	
	      var navBar = void 0;
	
	      var navBarProps = {
	        minDate: props.minDate || renderedChildProps.minDate,
	        maxDate: props.maxDate || renderedChildProps.maxDate,
	        enableHistoryView: props.enableHistoryView === undefined ? renderedChildProps.enableHistoryView : props.enableHistoryView,
	        secondary: true,
	        viewDate: this.nextViewDate || this.viewDate,
	        onViewDateChange: onViewDateChange,
	        multiView: multiView
	      };
	
	      if (props.navigation) {
	        navBar = this.renderNavBar((0, _objectAssign2.default)({}, navBarProps, { mainNavBar: true }));
	      }
	
	      var footer = void 0;
	
	      if (props.footer) {
	        footer = (0, _MonthView.renderFooter)(props, props.insideField ? props : this.view);
	      }
	
	      if (multiView) {
	        newProps.renderNavBar = this.renderMultiViewNavBar.bind(this, navBarProps);
	      }
	
	      var clone = _react2.default.cloneElement(child, newProps);
	
	      var flexProps = (0, _objectAssign2.default)({}, props);
	
	      delete flexProps.constrainActiveInView;
	      delete flexProps.enableHistoryView;
	      delete flexProps.focusOnNavMouseDown;
	      delete flexProps.focusOnTransitionEnd;
	      delete flexProps.footerClearDate;
	      delete flexProps.isDatePicker;
	      delete flexProps.navigation;
	      delete flexProps.onTransitionEnd;
	      delete flexProps.onTransitionStart;
	      delete flexProps.theme;
	
	      return _react2.default.createElement(
	        _reactFlex.Flex,
	        _extends({
	          column: true,
	          inline: true,
	          wrap: false,
	          alignItems: 'stretch'
	        }, flexProps, {
	          className: (0, _join2.default)(props.className, 'react-date-picker__transition-month-view', props.theme && 'react-date-picker__transition-month-view--theme-' + props.theme)
	        }),
	        navBar,
	        _react2.default.createElement(
	          _reactFlex.Flex,
	          { inline: true, row: true, style: { position: 'relative' } },
	          this.renderAt(-1, { multiView: multiView, navBarProps: navBarProps }),
	          clone,
	          this.renderAt(1, { multiView: multiView, navBarProps: navBarProps })
	        ),
	        footer
	      );
	    }
	  }, {
	    key: 'tryNavBarKeyDown',
	    value: function tryNavBarKeyDown(event) {
	      if (this.navBar && this.navBar.getHistoryView) {
	        var historyView = this.navBar.getHistoryView();
	
	        if (historyView && historyView.onKeyDown) {
	          historyView.onKeyDown(event);
	          return true;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(event) {
	      var initialKeyDown = this.child.onKeyDown;
	
	      if (this.tryNavBarKeyDown(event)) {
	        return false;
	      }
	
	      if (initialKeyDown) {
	        return initialKeyDown(event);
	      }
	    }
	  }, {
	    key: 'isHistoryViewVisible',
	    value: function isHistoryViewVisible() {
	      if (this.navBar && this.navBar.isHistoryViewVisible) {
	        return this.navBar.isHistoryViewVisible();
	      }
	
	      return false;
	    }
	  }, {
	    key: 'showHistoryView',
	    value: function showHistoryView() {
	      if (this.navBar) {
	        this.navBar.showHistoryView();
	      }
	    }
	  }, {
	    key: 'hideHistoryView',
	    value: function hideHistoryView() {
	      if (this.navBar) {
	        this.navBar.hideHistoryView();
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(event) {
	      var initialBlur = this.child.onBlur;
	
	      this.hideHistoryView();
	
	      if (initialBlur) {
	        initialBlur(event);
	      }
	
	      return true;
	    }
	
	    /**
	     * This method is only called when rendering the NavBar of the MonthViews
	     * that are not on the first row of the MultiMonthView
	     *
	     * @param  {Object} navBarProps
	     * @param  {Object} config
	     * @return {ReactNode}
	     */
	
	  }, {
	    key: 'renderMultiViewNavBar',
	    value: function renderMultiViewNavBar(navBarProps, config) {
	      var index = config.index;
	
	      var count = this.child.props.perRow;
	
	      if (index >= count) {
	        var viewDate = this.toMoment(navBarProps.viewDate).add(index, 'month');
	
	        return _react2.default.createElement(_NavBar2.default, _extends({}, navBarProps, {
	          renderNavNext: renderHiddenNav,
	          renderNavPrev: renderHiddenNav,
	          onViewDateChange: null,
	          viewDate: this.toMoment(viewDate)
	        }));
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderNavBar',
	    value: function renderNavBar(navBarProps) {
	      var _this3 = this;
	
	      navBarProps = (0, _objectAssign2.default)({}, navBarProps);
	
	      if (navBarProps.mainNavBar) {
	        navBarProps.ref = function (navBar) {
	          _this3.navBar = navBar;
	        };
	        navBarProps.onMouseDown = this.onNavMouseDown;
	      }
	
	      var props = this.props;
	      var _navBarProps = navBarProps;
	      var multiView = _navBarProps.multiView;
	
	
	      var navBar = _react2.default.Children.toArray(props.children).filter(function (c) {
	        return c && c.props && c.props.isDatePickerNavBar;
	      })[0];
	
	      var newProps = navBarProps;
	
	      if (navBar) {
	        newProps = (0, _objectAssign2.default)({}, navBarProps, navBar.props);
	
	        // have viewDate & onViewDateChange win over initial navBar.props
	        newProps.viewDate = navBarProps.viewDate;
	        newProps.onViewDateChange = navBarProps.onViewDateChange;
	      }
	
	      if (multiView) {
	        var _ret = function () {
	          var count = _this3.child.props.perRow;
	          var viewSize = _this3.getViewSize();
	
	          var bars = (0, _times2.default)(count).map(function (index) {
	            var onUpdate = function onUpdate(dateMoment, dir) {
	              var mom = _this3.toMoment(newProps.viewDate);
	
	              if (Math.abs(dir) == 1) {
	                mom.add(dir * viewSize, 'month');
	              } else {
	                var sign = dir > 0 ? 1 : -1;
	
	                mom.add(sign, 'year');
	              }
	
	              return mom;
	            };
	
	            var barProps = (0, _objectAssign2.default)({}, newProps, {
	              onUpdate: onUpdate,
	              renderNavNext: renderHiddenNav,
	              renderNavPrev: renderHiddenNav,
	              viewDate: _this3.toMoment(newProps.viewDate).add(index, 'month')
	            });
	
	            if (index == 0) {
	              delete barProps.renderNavPrev;
	            }
	            if (index == count - 1) {
	              delete barProps.renderNavNext;
	            }
	
	            return _react2.default.createElement(_NavBar2.default, _extends({ flex: true }, barProps));
	          });
	
	          return {
	            v: _react2.default.createElement(_reactFlex.Flex, { row: true, children: bars })
	          };
	        }();
	
	        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	      }
	
	      return navBar ? _react2.default.cloneElement(navBar, newProps) : _react2.default.createElement(_NavBar2.default, newProps);
	    }
	  }, {
	    key: 'getViewSize',
	    value: function getViewSize() {
	      return this.view && this.view.getViewSize ? this.view.getViewSize() || 1 : 1;
	    }
	  }, {
	    key: 'renderAt',
	    value: function renderAt(index, _ref) {
	      var multiView = _ref.multiView;
	      var navBarProps = _ref.navBarProps;
	
	      if (!this.state.rendered || !this.view) {
	        // || this.state.prepareTransition != -index ) {
	        return null;
	      }
	
	      var viewSize = this.getViewSize();
	      var viewDiff = viewSize * index;
	
	      var childProps = this.child.props;
	      var renderedProps = this.renderedChildProps;
	
	      var viewDate = this.toMoment(this.viewDate).add(viewDiff, 'month');
	
	      if (this.nextViewDate && this.state.prepareTransition == -index) {
	        // we're transitioning to this viewDate, so make sure
	        // it renders the date we'll need at the end of the transition
	        viewDate = this.nextViewDate;
	      }
	
	      var date = renderedProps.date || renderedProps.moment;
	
	      if (this.state.transitionTime) {
	        date = (0, _forwardTime2.default)(this.state.transitionTime, this.toMoment(date));
	        // console.log('date.format', date.format('HH:mm'));
	      }
	
	      var newProps = (0, _objectAssign2.default)({
	        date: date,
	        readOnly: true,
	        range: renderedProps.range,
	        activeDate: renderedProps.activeDate,
	        dateFormat: renderedProps.dateFormat,
	        locale: renderedProps.locale,
	        tabIndex: -1,
	        clockTabIndex: -1,
	        navigation: multiView,
	        viewDate: viewDate,
	        key: index,
	        footer: false,
	        className: (0, _join2.default)(childProps.className, 'react-date-picker__' + (index == -1 ? 'prev' : 'next'))
	      });
	
	      (0, _assignDefined2.default)(newProps, {
	        showClock: renderedProps.showClock,
	        minDate: renderedProps.minDate,
	        maxDate: renderedProps.maxDate
	      });
	
	      if (this.state.transition && this.state.transition != index) {
	        newProps.style = (0, _objectAssign2.default)({}, childProps.style, this.transitionDurationStyle);
	        newProps.className = (0, _join2.default)(newProps.className, 'react-date-picker--transition', 'react-date-picker--transition-' + (this.state.transition == -1 ? 'left' : 'right'));
	      }
	
	      if (multiView) {
	        newProps.renderNavBar = this.renderMultiViewNavBar.bind(this, (0, _objectAssign2.default)({}, navBarProps, { viewDate: viewDate, onViewDateChange: null }));
	      }
	
	      return _react2.default.cloneElement(this.child, newProps);
	    }
	  }, {
	    key: 'getView',
	    value: function getView() {
	      return this.view;
	    }
	  }, {
	    key: 'isInView',
	    value: function isInView() {
	      var _view;
	
	      return (_view = this.view).isInView.apply(_view, arguments);
	    }
	  }, {
	    key: 'onViewDateChange',
	    value: function onViewDateChange(dateString, _ref2) {
	      var dateMoment = _ref2.dateMoment;
	
	      this.doTransition(dateMoment);
	    }
	  }, {
	    key: 'doTransition',
	    value: function doTransition(dateMoment) {
	      var _this4 = this;
	
	      if (this.state.transition) {
	        // this.nextViewDate = dateMoment
	        return;
	      }
	      // to protect of null, which will default to current date
	      dateMoment = this.toMoment(dateMoment);
	
	      var newMoment = this.toMoment(dateMoment).startOf('month');
	      var viewMoment = this.toMoment(this.viewDate).startOf('month');
	
	      if (newMoment.format('YYYY-MM') == viewMoment.format('YYYY-MM')) {
	        return;
	      }
	
	      var navNext = newMoment.isAfter(viewMoment);
	      var transition = navNext ? -1 : 1;
	      var viewSize = this.getViewSize();
	
	      if (Math.abs(viewSize) > 1) {
	        var temp = this.toMoment(viewMoment).add(viewSize * -transition, 'month');
	
	        if (navNext) {
	          dateMoment = dateMoment.isAfter(temp) ? dateMoment : temp;
	        } else {
	          dateMoment = dateMoment.isBefore(temp) ? dateMoment : temp;
	        }
	      }
	
	      var transitionTime = this.props.getTransitionTime ? this.props.getTransitionTime() : null;
	
	      this.setState({
	        transitionTime: transitionTime,
	        prepareTransition: transition
	      }, function () {
	        setTimeout(function () {
	          // in order to allow this.view.p to update
	          if (!(0, _reactDom.findDOMNode)(_this4.view)) {
	            return;
	          }
	
	          _this4.nextViewDate = dateMoment;
	
	          _this4.addTransitionEnd();
	
	          _this4.setState({
	            transition: transition
	          });
	        });
	      });
	    }
	  }, {
	    key: 'addTransitionEnd',
	    value: function addTransitionEnd() {
	      var dom = (0, _reactDom.findDOMNode)(this.view);
	
	      if (dom) {
	        dom.addEventListener((0, _getTransitionEnd2.default)(), this.onTransitionEnd, false);
	      }
	    }
	  }, {
	    key: 'removeTransitionEnd',
	    value: function removeTransitionEnd(dom) {
	      dom = dom || (0, _reactDom.findDOMNode)(this.view);
	
	      if (dom) {
	        dom.removeEventListener((0, _getTransitionEnd2.default)(), this.onTransitionEnd);
	      }
	    }
	  }, {
	    key: 'onTransitionEnd',
	    value: function onTransitionEnd() {
	      this.removeTransitionEnd();
	
	      if (!this.nextViewDate) {
	        return;
	      }
	
	      this.setState({
	        viewDate: this.nextViewDate,
	        transition: 0,
	        prepareTransition: 0
	      });
	
	      if (this.props.focusOnTransitionEnd) {
	        this.focus();
	      }
	
	      delete this.nextViewDate;
	    }
	  }, {
	    key: 'onNavMouseDown',
	    value: function onNavMouseDown() {
	      if (this.props.focusOnNavMouseDown && !this.isFocused()) {
	        this.focus();
	      }
	    }
	  }, {
	    key: 'isFocused',
	    value: function isFocused() {
	      var view = this.getView();
	
	      if (view) {
	        return view.isFocused();
	      }
	
	      return false;
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.getView().focus();
	    }
	  }]);
	
	  return TransitionView;
	}(_reactClass2.default);
	
	exports.default = TransitionView;
	
	
	TransitionView.propTypes = {
	  children: _react2.default.PropTypes.node.isRequired
	};
	
	TransitionView.defaultProps = {
	  focusOnNavMouseDown: true,
	
	  onTransitionStart: function onTransitionStart() {},
	  onTransitionEnd: function onTransitionEnd() {},
	
	  footerClearDate: null,
	  enableHistoryView: true,
	  constrainActiveInView: false,
	  focusOnTransitionEnd: false,
	  navigation: true,
	  theme: 'default',
	  isDatePicker: true
	};

/***/ },
/* 912 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Transition-end mapping
	 */
	
	var map = {
	  'WebkitTransition': 'webkitTransitionEnd',
	  'MozTransition': 'transitionend',
	  'OTransition': 'oTransitionEnd',
	  'msTransition': 'MSTransitionEnd',
	  'transition': 'transitionend'
	};
	
	var EL = void 0;
	var RESULT = void 0;
	
	exports.default = function () {
	  if (!EL) {
	    EL = document.createElement('p');
	  }
	
	  if (RESULT) {
	    return RESULT;
	  }
	
	  for (var transition in map) {
	    if (null != EL.style[transition]) {
	      RESULT = map[transition];
	      break;
	    }
	  }
	
	  return RESULT;
	};

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimeInput = exports.TimePicker = exports.Calendar = exports.DateField = exports.ClockInput = exports.Clock = exports.Footer = exports.NavBar = exports.MultiMonthView = exports.TransitionView = exports.DateFormatSpinnerInput = exports.DateFormatInput = exports.HistoryView = exports.DecadeView = exports.YearView = exports.MonthView = exports.DateEditor = exports.DatePicker = undefined;
	
	var _MonthView = __webpack_require__(159);
	
	var _MonthView2 = _interopRequireDefault(_MonthView);
	
	var _TimePicker = __webpack_require__(910);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	var _TimeInput = __webpack_require__(218);
	
	var _TimeInput2 = _interopRequireDefault(_TimeInput);
	
	var _TransitionView = __webpack_require__(911);
	
	var _TransitionView2 = _interopRequireDefault(_TransitionView);
	
	var _MultiMonthView = __webpack_require__(905);
	
	var _MultiMonthView2 = _interopRequireDefault(_MultiMonthView);
	
	var _HistoryView = __webpack_require__(470);
	
	var _HistoryView2 = _interopRequireDefault(_HistoryView);
	
	var _YearView = __webpack_require__(474);
	
	var _YearView2 = _interopRequireDefault(_YearView);
	
	var _DecadeView = __webpack_require__(216);
	
	var _DecadeView2 = _interopRequireDefault(_DecadeView);
	
	var _NavBar = __webpack_require__(160);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _Footer = __webpack_require__(217);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Clock = __webpack_require__(158);
	
	var _Clock2 = _interopRequireDefault(_Clock);
	
	var _ClockInput = __webpack_require__(468);
	
	var _ClockInput2 = _interopRequireDefault(_ClockInput);
	
	var _DateField = __webpack_require__(902);
	
	var _DateField2 = _interopRequireDefault(_DateField);
	
	var _Calendar = __webpack_require__(467);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _DateFormatInput = __webpack_require__(215);
	
	var _DateFormatInput2 = _interopRequireDefault(_DateFormatInput);
	
	var _DateFormatSpinnerInput = __webpack_require__(469);
	
	var _DateFormatSpinnerInput2 = _interopRequireDefault(_DateFormatSpinnerInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MonthView2.default;
	
	// allow people to import with other aliases as well
	
	var DatePicker = exports.DatePicker = _Calendar2.default;
	var DateEditor = exports.DateEditor = _DateField2.default;
	
	exports.MonthView = _MonthView2.default;
	exports.YearView = _YearView2.default;
	exports.DecadeView = _DecadeView2.default;
	exports.HistoryView = _HistoryView2.default;
	exports.DateFormatInput = _DateFormatInput2.default;
	exports.DateFormatSpinnerInput = _DateFormatSpinnerInput2.default;
	exports.TransitionView = _TransitionView2.default;
	exports.MultiMonthView = _MultiMonthView2.default;
	exports.NavBar = _NavBar2.default;
	exports.Footer = _Footer2.default;
	exports.Clock = _Clock2.default;
	exports.ClockInput = _ClockInput2.default;
	exports.DateField = _DateField2.default;
	exports.Calendar = _Calendar2.default;
	exports.TimePicker = _TimePicker2.default;
	exports.TimeInput = _TimeInput2.default;

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toMoment = __webpack_require__(33);
	
	var _toMoment2 = _interopRequireDefault(_toMoment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONFIG = {
	  // the format in which days should be displayed in month view
	  dayFormat: 'D',
	
	  // the format in which months should be displayed in year view
	  monthFormat: 'MMMM',
	
	  // the format in which years should be displayed in decade view
	  yearFormat: 'YYYY'
	};
	
	var f = function f(mom, format) {
	  return (0, _toMoment2.default)(mom).format(format);
	};
	
	exports.default = {
	  day: function day(mom, format) {
	    return f(mom, format || CONFIG.dayFormat);
	  },
	  month: function month(mom, format) {
	    return f(mom, format || CONFIG.monthFormat);
	  },
	  year: function year(mom, format) {
	    return f(mom, format || CONFIG.yearFormat);
	  }
	};

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeekDayNames;
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_WEEK_START_DAY = (0, _moment2.default)().startOf('week').format('d') * 1;
	
	function getWeekDayNames(startDay, locale) {
	  var weekDays = void 0;
	
	  if (locale) {
	    var data = _moment2.default.localeData(locale);
	
	    weekDays = data && data._weekdaysShort ? data._weekdaysShort : weekDays;
	  }
	
	  weekDays = (weekDays || _moment2.default.weekdaysShort()).concat();
	
	  var names = weekDays;
	  var index = startDay == null ? DEFAULT_WEEK_START_DAY : startDay;
	
	  while (index > 0) {
	    names.push(names.shift());
	    index--;
	  }
	
	  return names;
	}

/***/ },
/* 916 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(21);
	
	var focusNode = __webpack_require__(501);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(119);
	var ExecutionEnvironment = __webpack_require__(40);
	var FallbackCompositionState = __webpack_require__(924);
	var SyntheticCompositionEvent = __webpack_require__(961);
	var SyntheticInputEvent = __webpack_require__(964);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(478);
	var ExecutionEnvironment = __webpack_require__(40);
	var ReactInstrumentation = __webpack_require__(51);
	
	var camelizeStyleName = __webpack_require__(980);
	var dangerousStyleValue = __webpack_require__(970);
	var hyphenateStyleName = __webpack_require__(987);
	var memoizeStringOnly = __webpack_require__(990);
	var warning = __webpack_require__(19);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(118);
	var EventPropagators = __webpack_require__(119);
	var ExecutionEnvironment = __webpack_require__(40);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactUpdates = __webpack_require__(59);
	var SyntheticEvent = __webpack_require__(62);
	
	var inputValueTracking = __webpack_require__(494);
	var getEventTarget = __webpack_require__(232);
	var isEventSupported = __webpack_require__(233);
	var isTextInputElement = __webpack_require__(496);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var DOMLazyTree = __webpack_require__(96);
	var ExecutionEnvironment = __webpack_require__(40);
	
	var createNodesFromMarkup = __webpack_require__(983);
	var emptyFunction = __webpack_require__(63);
	var invariant = __webpack_require__(12);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 922 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(119);
	var ReactDOMComponentTree = __webpack_require__(21);
	var SyntheticMouseEvent = __webpack_require__(164);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var PooledClass = __webpack_require__(85);
	
	var getTextContentAccessor = __webpack_require__(493);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(97);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(98);
	
	var instantiateReactComponent = __webpack_require__(495);
	var KeyEscapeUtils = __webpack_require__(224);
	var shouldUpdateReactComponent = __webpack_require__(234);
	var traverseAllChildren = __webpack_require__(498);
	var warning = __webpack_require__(19);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://api.hvb-investments.com"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(528);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(220);
	var ReactDOMIDOperations = __webpack_require__(934);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(15);
	
	var React = __webpack_require__(102);
	var ReactComponentEnvironment = __webpack_require__(226);
	var ReactCurrentOwner = __webpack_require__(66);
	var ReactErrorUtils = __webpack_require__(227);
	var ReactInstanceMap = __webpack_require__(120);
	var ReactInstrumentation = __webpack_require__(51);
	var ReactNodeTypes = __webpack_require__(488);
	var ReactReconciler = __webpack_require__(98);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(500);
	var invariant = __webpack_require__(12);
	var shallowEqual = __webpack_require__(236);
	var shouldUpdateReactComponent = __webpack_require__(234);
	var warning = __webpack_require__(19);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactDefaultInjection = __webpack_require__(942);
	var ReactMount = __webpack_require__(487);
	var ReactReconciler = __webpack_require__(98);
	var ReactUpdates = __webpack_require__(59);
	var ReactVersion = __webpack_require__(955);
	
	var findDOMNode = __webpack_require__(971);
	var getHostComponentFromComposite = __webpack_require__(492);
	var renderSubtreeIntoContainer = __webpack_require__(978);
	var warning = __webpack_require__(19);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(15);
	
	var AutoFocusUtils = __webpack_require__(917);
	var CSSPropertyOperations = __webpack_require__(919);
	var DOMLazyTree = __webpack_require__(96);
	var DOMNamespaces = __webpack_require__(221);
	var DOMProperty = __webpack_require__(97);
	var DOMPropertyOperations = __webpack_require__(480);
	var EventPluginHub = __webpack_require__(118);
	var EventPluginRegistry = __webpack_require__(222);
	var ReactBrowserEventEmitter = __webpack_require__(163);
	var ReactDOMComponentFlags = __webpack_require__(481);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactDOMInput = __webpack_require__(935);
	var ReactDOMOption = __webpack_require__(936);
	var ReactDOMSelect = __webpack_require__(482);
	var ReactDOMTextarea = __webpack_require__(939);
	var ReactInstrumentation = __webpack_require__(51);
	var ReactMultiChild = __webpack_require__(948);
	var ReactServerRenderingTransaction = __webpack_require__(953);
	
	var emptyFunction = __webpack_require__(63);
	var escapeTextContentForBrowser = __webpack_require__(166);
	var invariant = __webpack_require__(12);
	var isEventSupported = __webpack_require__(233);
	var shallowEqual = __webpack_require__(236);
	var inputValueTracking = __webpack_require__(494);
	var validateDOMNesting = __webpack_require__(235);
	var warning = __webpack_require__(19);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(235);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var DOMLazyTree = __webpack_require__(96);
	var ReactDOMComponentTree = __webpack_require__(21);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 933 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(220);
	var ReactDOMComponentTree = __webpack_require__(21);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(15);
	
	var DOMPropertyOperations = __webpack_require__(480);
	var LinkedValueUtils = __webpack_require__(225);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactUpdates = __webpack_require__(59);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(19);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var React = __webpack_require__(102);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactDOMSelect = __webpack_require__(482);
	
	var warning = __webpack_require__(19);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(40);
	
	var getNodeForCharacterOffset = __webpack_require__(975);
	var getTextContentAccessor = __webpack_require__(493);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(15);
	
	var DOMChildrenOperations = __webpack_require__(220);
	var DOMLazyTree = __webpack_require__(96);
	var ReactDOMComponentTree = __webpack_require__(21);
	
	var escapeTextContentForBrowser = __webpack_require__(166);
	var invariant = __webpack_require__(12);
	var validateDOMNesting = __webpack_require__(235);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(15);
	
	var LinkedValueUtils = __webpack_require__(225);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactUpdates = __webpack_require__(59);
	
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(19);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var ReactUpdates = __webpack_require__(59);
	var Transaction = __webpack_require__(165);
	
	var emptyFunction = __webpack_require__(63);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(916);
	var BeforeInputEventPlugin = __webpack_require__(918);
	var ChangeEventPlugin = __webpack_require__(920);
	var DefaultEventPluginOrder = __webpack_require__(922);
	var EnterLeaveEventPlugin = __webpack_require__(923);
	var HTMLDOMPropertyConfig = __webpack_require__(925);
	var ReactComponentBrowserEnvironment = __webpack_require__(927);
	var ReactDOMComponent = __webpack_require__(930);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactDOMEmptyComponent = __webpack_require__(932);
	var ReactDOMTreeTraversal = __webpack_require__(940);
	var ReactDOMTextComponent = __webpack_require__(938);
	var ReactDefaultBatchingStrategy = __webpack_require__(941);
	var ReactEventListener = __webpack_require__(945);
	var ReactInjection = __webpack_require__(946);
	var ReactReconcileTransaction = __webpack_require__(951);
	var SVGDOMPropertyConfig = __webpack_require__(956);
	var SelectEventPlugin = __webpack_require__(957);
	var SimpleEventPlugin = __webpack_require__(958);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 943 */
529,
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(118);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var EventListener = __webpack_require__(499);
	var ExecutionEnvironment = __webpack_require__(40);
	var PooledClass = __webpack_require__(85);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactUpdates = __webpack_require__(59);
	
	var getEventTarget = __webpack_require__(232);
	var getUnboundedScrollPosition = __webpack_require__(985);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(97);
	var EventPluginHub = __webpack_require__(118);
	var EventPluginUtils = __webpack_require__(223);
	var ReactComponentEnvironment = __webpack_require__(226);
	var ReactEmptyComponent = __webpack_require__(483);
	var ReactBrowserEventEmitter = __webpack_require__(163);
	var ReactHostComponent = __webpack_require__(485);
	var ReactUpdates = __webpack_require__(59);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(969);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactComponentEnvironment = __webpack_require__(226);
	var ReactInstanceMap = __webpack_require__(120);
	var ReactInstrumentation = __webpack_require__(51);
	
	var ReactCurrentOwner = __webpack_require__(66);
	var ReactReconciler = __webpack_require__(98);
	var ReactChildReconciler = __webpack_require__(926);
	
	var emptyFunction = __webpack_require__(63);
	var flattenChildren = __webpack_require__(972);
	var invariant = __webpack_require__(12);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 950 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var CallbackQueue = __webpack_require__(479);
	var PooledClass = __webpack_require__(85);
	var ReactBrowserEventEmitter = __webpack_require__(163);
	var ReactInputSelection = __webpack_require__(486);
	var ReactInstrumentation = __webpack_require__(51);
	var Transaction = __webpack_require__(165);
	var ReactUpdateQueue = __webpack_require__(228);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(949);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(15);
	
	var PooledClass = __webpack_require__(85);
	var Transaction = __webpack_require__(165);
	var ReactInstrumentation = __webpack_require__(51);
	var ReactServerUpdateQueue = __webpack_require__(954);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(228);
	
	var warning = __webpack_require__(19);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 955 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.1';

/***/ },
/* 956 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(119);
	var ExecutionEnvironment = __webpack_require__(40);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactInputSelection = __webpack_require__(486);
	var SyntheticEvent = __webpack_require__(62);
	
	var getActiveElement = __webpack_require__(502);
	var isTextInputElement = __webpack_require__(496);
	var shallowEqual = __webpack_require__(236);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var EventListener = __webpack_require__(499);
	var EventPropagators = __webpack_require__(119);
	var ReactDOMComponentTree = __webpack_require__(21);
	var SyntheticAnimationEvent = __webpack_require__(959);
	var SyntheticClipboardEvent = __webpack_require__(960);
	var SyntheticEvent = __webpack_require__(62);
	var SyntheticFocusEvent = __webpack_require__(963);
	var SyntheticKeyboardEvent = __webpack_require__(965);
	var SyntheticMouseEvent = __webpack_require__(164);
	var SyntheticDragEvent = __webpack_require__(962);
	var SyntheticTouchEvent = __webpack_require__(966);
	var SyntheticTransitionEvent = __webpack_require__(967);
	var SyntheticUIEvent = __webpack_require__(121);
	var SyntheticWheelEvent = __webpack_require__(968);
	
	var emptyFunction = __webpack_require__(63);
	var getEventCharCode = __webpack_require__(230);
	var invariant = __webpack_require__(12);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(62);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(62);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(62);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(164);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(121);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(62);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(121);
	
	var getEventCharCode = __webpack_require__(230);
	var getEventKey = __webpack_require__(973);
	var getEventModifierState = __webpack_require__(231);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(121);
	
	var getEventModifierState = __webpack_require__(231);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(62);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(164);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 969 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(478);
	var warning = __webpack_require__(19);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactCurrentOwner = __webpack_require__(66);
	var ReactDOMComponentTree = __webpack_require__(21);
	var ReactInstanceMap = __webpack_require__(120);
	
	var getHostComponentFromComposite = __webpack_require__(492);
	var invariant = __webpack_require__(12);
	var warning = __webpack_require__(19);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(224);
	var traverseAllChildren = __webpack_require__(498);
	var warning = __webpack_require__(19);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://api.hvb-investments.com"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(528);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(230);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 974 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 975 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(40);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(166);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(487);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 979 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 980 */
[1181, 979],
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(989);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(40);
	
	var createArrayFromMixed = __webpack_require__(982);
	var getMarkupWrap = __webpack_require__(984);
	var invariant = __webpack_require__(12);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(40);
	
	var invariant = __webpack_require__(12);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 985 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 986 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 987 */
[1182, 986],
/* 988 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(988);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 990 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(58);
	
	var _objectAssign = __webpack_require__(15);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	
	  displayName: 'Field',
	
	  propTypes: {
	    type: _react.PropTypes.string,
	    stopChangePropagation: _react.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      stopChangePropagation: true,
	      type: 'text'
	    };
	  },
	  render: function render() {
	    var onChange = null;
	
	    if (typeof this.props.onChange === 'function') {
	      //only pass our onChange if the user provided one
	      //so the React warning is still displayed if the user didn't provide onChange
	      //but provided value
	      onChange = this.onChange;
	    }
	
	    var inputProps = (0, _objectAssign2.default)({}, this.props);
	
	    delete inputProps.stopChangePropagation;
	
	    return _react2.default.createElement('input', _extends({}, inputProps, { onChange: onChange, ref: 'input' }));
	  },
	  focus: function focus() {
	    (0, _reactDom.findDOMNode)(this.refs.input).focus();
	  },
	  onChange: function onChange(event) {
	    if (this.props.stopChangePropagation) {
	      event.stopPropagation();
	    }
	
	    this.props.onChange(event.target.value, event);
	  }
	});

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(15);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _join = __webpack_require__(237);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _props2className = __webpack_require__(504);
	
	var _props2className2 = _interopRequireDefault(_props2className);
	
	var _cleanup = __webpack_require__(503);
	
	var _cleanup2 = _interopRequireDefault(_cleanup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Flex = function (_Component) {
	  _inherits(Flex, _Component);
	
	  function Flex() {
	    _classCallCheck(this, Flex);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Flex).apply(this, arguments));
	  }
	
	  _createClass(Flex, [{
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	      var className = (0, _join2.default)('react-flex', (0, _props2className2.default)(props));
	
	      var allProps = (0, _objectAssign2.default)({}, props);
	
	      (0, _cleanup2.default)(allProps);
	
	      allProps.className = className;
	
	      if (props.factory) {
	        return props.factory(allProps);
	      }
	
	      return _react2.default.createElement('div', allProps);
	    }
	  }]);
	
	  return Flex;
	}(_reactClass2.default);
	
	Flex.defaultProps = {
	  row: true,
	  wrap: true,
	  alignItems: 'center',
	  display: 'flex'
	};
	
	Flex.propTypes = {
	
	  flex: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.bool]),
	
	  display: _react.PropTypes.oneOf(['flex', 'inline-flex']),
	
	  inline: _react.PropTypes.bool,
	
	  reverse: _react.PropTypes.bool,
	
	  row: _react.PropTypes.bool,
	  column: _react.PropTypes.bool,
	  wrap: _react.PropTypes.bool,
	
	  alignItems: _react.PropTypes.string,
	  alignContent: _react.PropTypes.string,
	  justifyContent: _react.PropTypes.string
	};
	
	exports.default = Flex;

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(15);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	var _join = __webpack_require__(237);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _props2className = __webpack_require__(504);
	
	var _props2className2 = _interopRequireDefault(_props2className);
	
	var _cleanup = __webpack_require__(503);
	
	var _cleanup2 = _interopRequireDefault(_cleanup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FlexItem = function (_Component) {
	  _inherits(FlexItem, _Component);
	
	  function FlexItem() {
	    _classCallCheck(this, FlexItem);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(FlexItem).apply(this, arguments));
	  }
	
	  _createClass(FlexItem, [{
	    key: 'render',
	    value: function render() {
	
	      var props = this.props;
	      var className = (0, _join2.default)('react-flex-item', (0, _props2className2.default)(props));
	
	      var allProps = (0, _objectAssign2.default)({}, props);
	
	      (0, _cleanup2.default)(allProps);
	
	      allProps.className = className;
	
	      if (props.factory) {
	        return props.factory(allProps);
	      }
	
	      return _react2.default.createElement('div', allProps);
	    }
	  }]);
	
	  return FlexItem;
	}(_reactClass2.default);
	
	FlexItem.defaultProps = {
	  flex: 1
	};
	
	FlexItem.propTypes = {
	  display: _react.PropTypes.oneOf(['flex', 'inline-flex']),
	  inline: function inline(props, propName) {
	    if (props[propName] !== undefined) {
	      return new Error('"inline" prop should not be used on "Item". Use "display=\'inline-flex\'" instead');
	    }
	  },
	
	  flex: _react.PropTypes.any,
	  flexGrow: _react.PropTypes.any,
	  flexShrink: _react.PropTypes.any,
	  flexBasis: _react.PropTypes.any
	};
	
	exports.default = FlexItem;

/***/ },
/* 994 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = 'react-flex-v2';

/***/ },
/* 995 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (props) {
	  return props.flex === false ? 0 : props.flex === true ? 1 : props.flex;
	};

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var I18nextProvider = function (_Component) {
	  _inherits(I18nextProvider, _Component);
	
	  function I18nextProvider(props, context) {
	    _classCallCheck(this, I18nextProvider);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(I18nextProvider).call(this, props, context));
	
	    _this.i18n = props.i18n;
	    return _this;
	  }
	
	  _createClass(I18nextProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return { i18n: this.i18n };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.i18n !== nextProps.i18n) {
	        throw new Error('[react-i18next][I18nextProvider]does not support changing the i18n object.');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	      return _react.Children.only(children);
	    }
	  }]);
	
	  return I18nextProvider;
	}(_react.Component);
	
	I18nextProvider.propTypes = {
	  i18n: _react.PropTypes.object.isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	
	I18nextProvider.childContextTypes = {
	  i18n: _react.PropTypes.object.isRequired
	};
	
	exports.default = I18nextProvider;

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Interpolate = function (_Component) {
	  _inherits(Interpolate, _Component);
	
	  function Interpolate(props, context) {
	    _classCallCheck(this, Interpolate);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Interpolate).call(this, props, context));
	
	    _this.i18n = context.i18n;
	    _this.t = context.t;
	    return _this;
	  }
	
	  _createClass(Interpolate, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var parent = this.props.parent || 'span';
	      var REGEXP = this.props.regexp || this.i18n.services.interpolator.regexp;
	      var _props = this.props;
	      var className = _props.className;
	      var style = _props.style;
	
	      // Set to true if you want to use raw HTML in translation values
	      // See https://github.com/i18next/react-i18next/issues/189
	
	      var useDangerouslySetInnerHTML = this.props.useDangerouslySetInnerHTML || false;
	      var dangerouslySetInnerHTMLPartElement = this.props.dangerouslySetInnerHTMLPartElement || 'span';
	
	      var tOpts = _extends({}, this.props.options, { interpolation: { prefix: '#$?', suffix: '?$#' } });
	      var format = this.t(this.props.i18nKey, tOpts);
	
	      if (!format || typeof format !== 'string') return _react2.default.createElement('noscript', null);
	
	      var children = [];
	
	      var handleFormat = function handleFormat(key, props) {
	        if (key.indexOf(_this2.i18n.options.interpolation.formatSeparator) < 0) {
	          if (props[key] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + key + ' for interpolating ' + format);
	          return props[key];
	        }
	
	        var p = key.split(_this2.i18n.options.interpolation.formatSeparator);
	        var k = p.shift().trim();
	        var f = p.join(_this2.i18n.options.interpolation.formatSeparator).trim();
	
	        if (props[key] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + k + ' for interpolating ' + format);
	        return _this2.i18n.options.interpolation.format(props[k], f, _this2.i18n.language);
	      };
	
	      format.split(REGEXP).reduce(function (memo, match, index) {
	        var child = void 0;
	
	        if (index % 2 === 0) {
	          if (match.length === 0) return memo;
	          if (useDangerouslySetInnerHTML) {
	            child = _react2.default.createElement(dangerouslySetInnerHTMLPartElement, { dangerouslySetInnerHTML: { __html: match } });
	          } else {
	            child = match;
	          }
	        } else {
	          child = handleFormat(match, _this2.props);
	        }
	
	        memo.push(child);
	        return memo;
	      }, children);
	
	      return _react2.default.createElement.apply(this, [parent, { className: className, style: style }].concat(children));
	    }
	  }]);
	
	  return Interpolate;
	}(_react.Component);
	
	Interpolate.propTypes = {
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string
	};
	
	Interpolate.contextTypes = {
	  i18n: _react.PropTypes.object.isRequired,
	  t: _react.PropTypes.func.isRequired
	};
	
	exports.default = Interpolate;

/***/ },
/* 998 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = loadNamespaces;
	// Borrowed from https://github.com/Rezonans/redux-async-connect/blob/master/modules/ReduxAsyncConnect.js#L16
	function eachComponents(components, iterator) {
	  for (var i = 0, l = components.length; i < l; i++) {
	    // eslint-disable-line id-length
	    if (_typeof(components[i]) === 'object') {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = Object.entries(components[i])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = _slicedToArray(_step.value, 2);
	
	          var key = _step$value[0];
	          var value = _step$value[1];
	
	          iterator(value, i, key);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    } else {
	      iterator(components[i], i);
	    }
	  }
	}
	
	function filterAndFlattenComponents(components) {
	  var flattened = [];
	  eachComponents(components, function (Component) {
	    if (Component && Component.namespaces) {
	
	      Component.namespaces.forEach(function (namespace) {
	        if (flattened.indexOf(namespace) === -1) {
	          flattened.push(namespace);
	        }
	      });
	    }
	  });
	  return flattened;
	}
	
	function loadNamespaces(_ref) {
	  var components = _ref.components;
	  var i18n = _ref.i18n;
	
	  var allNamespaces = filterAndFlattenComponents(components);
	
	  return new Promise(function (resolve) {
	    i18n.loadNamespaces(allNamespaces, resolve);
	  });
	}

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = translate;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(281);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getDisplayName(component) {
	  return component.displayName || component.name || 'Component';
	}
	
	function translate(namespaces) {
	  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	  var _options$withRef = options.withRef;
	  var withRef = _options$withRef === undefined ? false : _options$withRef;
	  var _options$wait = options.wait;
	  var wait = _options$wait === undefined ? false : _options$wait;
	  var _options$bindI18n = options.bindI18n;
	  var bindI18n = _options$bindI18n === undefined ? 'languageChanged loaded' : _options$bindI18n;
	  var _options$bindStore = options.bindStore;
	  var bindStore = _options$bindStore === undefined ? 'added removed' : _options$bindStore;
	  var _options$translateFun = options.translateFuncName;
	  var translateFuncName = _options$translateFun === undefined ? 't' : _options$translateFun;
	
	
	  return function Wrapper(WrappedComponent) {
	    var Translate = function (_Component) {
	      _inherits(Translate, _Component);
	
	      function Translate(props, context) {
	        _classCallCheck(this, Translate);
	
	        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Translate).call(this, props, context));
	
	        _this.i18n = context.i18n || props.i18n;
	        namespaces = namespaces || _this.i18n.options.defaultNS;
	
	        _this.state = {
	          i18nLoadedAt: null,
	          ready: false
	        };
	
	        _this.onI18nChanged = _this.onI18nChanged.bind(_this);
	        return _this;
	      }
	
	      _createClass(Translate, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	          return _defineProperty({}, translateFuncName, this[translateFuncName]);
	        }
	      }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	          this[translateFuncName] = this.i18n.getFixedT(null, namespaces);
	        }
	      }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          var _this2 = this;
	
	          var bind = function bind() {
	            bindI18n && _this2.i18n.on(bindI18n, _this2.onI18nChanged);
	            bindStore && _this2.i18n.store && _this2.i18n.store.on(bindStore, _this2.onI18nChanged);
	          };
	
	          this.mounted = true;
	          this.i18n.loadNamespaces(namespaces, function () {
	            var ready = function ready() {
	              if (_this2.mounted) _this2.setState({ ready: true });
	              if (wait && _this2.mounted) bind();
	            };
	
	            if (_this2.i18n.isInitialized) return ready();
	
	            var initialized = function initialized() {
	              // due to emitter removing issue in i18next we need to delay remove
	              setTimeout(function () {
	                _this2.i18n.off('initialized', initialized);
	              }, 1000);
	              ready();
	            };
	            _this2.i18n.on('initialized', initialized);
	          });
	          if (!wait) bind();
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          var _this3 = this;
	
	          this.mounted = false;
	          if (this.onI18nChanged) {
	            if (bindI18n) {
	              var p = bindI18n.split(' ');
	              p.forEach(function (f) {
	                return _this3.i18n.off(f, _this3.onI18nChanged);
	              });
	            }
	            if (bindStore) {
	              var _p = bindStore.split(' ');
	              _p.forEach(function (f) {
	                return _this3.i18n.store && _this3.i18n.store.off(f, _this3.onI18nChanged);
	              });
	            }
	          }
	        }
	      }, {
	        key: 'onI18nChanged',
	        value: function onI18nChanged() {
	          if (!this.mounted) return;
	
	          this.setState({ i18nLoadedAt: new Date() });
	        }
	      }, {
	        key: 'getWrappedInstance',
	        value: function getWrappedInstance() {
	          if (!withRef) {
	            // eslint-disable-next-line no-console
	            console.error('To access the wrapped instance, you need to specify ' + '{ withRef: true } as the second argument of the translate() call.');
	          }
	
	          return this.refs.wrappedInstance;
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _extraProps;
	
	          var _state = this.state;
	          var i18nLoadedAt = _state.i18nLoadedAt;
	          var ready = _state.ready;
	
	          var extraProps = (_extraProps = { i18nLoadedAt: i18nLoadedAt }, _defineProperty(_extraProps, translateFuncName, this[translateFuncName]), _defineProperty(_extraProps, 'i18n', this.i18n), _extraProps);
	
	          if (withRef) {
	            extraProps.ref = 'wrappedInstance';
	          }
	
	          if (!ready && wait) return null;
	
	          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, extraProps));
	        }
	      }]);
	
	      return Translate;
	    }(_react.Component);
	
	    Translate.WrappedComponent = WrappedComponent;
	
	    Translate.contextTypes = {
	      i18n: _react.PropTypes.object
	    };
	
	    Translate.childContextTypes = _defineProperty({}, translateFuncName, _react.PropTypes.func.isRequired);
	
	    Translate.displayName = 'Translate(' + getDisplayName(WrappedComponent) + ')';
	
	    Translate.namespaces = namespaces;
	
	    return (0, _hoistNonReactStatics2.default)(Translate, WrappedComponent);
	  };
	}

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inputRange = __webpack_require__(1002);
	
	var _inputRange2 = _interopRequireDefault(_inputRange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore
	 * @typedef {Object} ClientRect
	 * @property {number} height
	 * @property {number} left
	 * @property {number} top
	 * @property {number} width
	 */
	
	/**
	 * @typedef {Object} InputRangeClassNames
	 * @property {string} activeTrack
	 * @property {string} disabledInputRange
	 * @property {string} inputRange
	 * @property {string} labelContainer
	 * @property {string} maxLabel
	 * @property {string} minLabel
	 * @property {string} slider
	 * @property {string} sliderContainer
	 * @property {string} track
	 * @property {string} valueLabel
	 */
	
	/**
	 * @typedef {Function} LabelFormatter
	 * @param {number} value
	 * @param {string} type
	 * @return {string}
	 */
	
	/**
	 * @ignore
	 * @typedef {Object} Point
	 * @property {number} x
	 * @property {number} y
	 */
	
	/**
	 * @typedef {Object} Range
	 * @property {number} min - Min value
	 * @property {number} max - Max value
	 */
	
	exports.default = _inputRange2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=index.js.map

/***/ },
/* 1001 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	* Default CSS class names
	* @ignore
	* @type {InputRangeClassNames}
	*/
	var DEFAULT_CLASS_NAMES = {
	  activeTrack: 'input-range__track input-range__track--active',
	  disabledInputRange: 'input-range input-range--disabled',
	  inputRange: 'input-range',
	  labelContainer: 'input-range__label-container',
	  maxLabel: 'input-range__label input-range__label--max',
	  minLabel: 'input-range__label input-range__label--min',
	  slider: 'input-range__slider',
	  sliderContainer: 'input-range__slider-container',
	  track: 'input-range__track input-range__track--background',
	  valueLabel: 'input-range__label input-range__label--value'
	};
	
	exports.default = DEFAULT_CLASS_NAMES;
	module.exports = exports['default'];
	//# sourceMappingURL=default-class-names.js.map

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _desc, _value, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(181);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _valueTransformer = __webpack_require__(1008);
	
	var valueTransformer = _interopRequireWildcard(_valueTransformer);
	
	var _defaultClassNames = __webpack_require__(1001);
	
	var _defaultClassNames2 = _interopRequireDefault(_defaultClassNames);
	
	var _label = __webpack_require__(505);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _rangePropType = __webpack_require__(1004);
	
	var _rangePropType2 = _interopRequireDefault(_rangePropType);
	
	var _valuePropType = __webpack_require__(1007);
	
	var _valuePropType2 = _interopRequireDefault(_valuePropType);
	
	var _slider = __webpack_require__(1005);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _track = __webpack_require__(1006);
	
	var _track2 = _interopRequireDefault(_track);
	
	var _utils = __webpack_require__(168);
	
	var _keyCodes = __webpack_require__(1003);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	/**
	 * A React component that allows users to input numeric values within a range
	 * by dragging its sliders.
	 */
	var InputRange = (_class = function (_React$Component) {
	  _inherits(InputRange, _React$Component);
	
	  _createClass(InputRange, null, [{
	    key: 'propTypes',
	
	    /**
	     * @ignore
	     * @override
	     * @return {Object}
	     */
	    get: function get() {
	      return {
	        ariaLabelledby: _propTypes2.default.string,
	        ariaControls: _propTypes2.default.string,
	        classNames: _propTypes2.default.objectOf(_propTypes2.default.string),
	        disabled: _propTypes2.default.bool,
	        draggableTrack: _propTypes2.default.bool,
	        formatLabel: _propTypes2.default.func,
	        maxValue: _rangePropType2.default,
	        minValue: _rangePropType2.default,
	        name: _propTypes2.default.string,
	        onChangeStart: _propTypes2.default.func,
	        onChange: _propTypes2.default.func.isRequired,
	        onChangeComplete: _propTypes2.default.func,
	        step: _propTypes2.default.number,
	        value: _valuePropType2.default
	      };
	    }
	
	    /**
	     * @ignore
	     * @override
	     * @return {Object}
	     */
	
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        classNames: _defaultClassNames2.default,
	        disabled: false,
	        maxValue: 10,
	        minValue: 0,
	        step: 1
	      };
	    }
	
	    /**
	     * @param {Object} props
	     * @param {string} [props.ariaLabelledby]
	     * @param {string} [props.ariaControls]
	     * @param {InputRangeClassNames} [props.classNames]
	     * @param {boolean} [props.disabled = false]
	     * @param {Function} [props.formatLabel]
	     * @param {number|Range} [props.maxValue = 10]
	     * @param {number|Range} [props.minValue = 0]
	     * @param {string} [props.name]
	     * @param {string} props.onChange
	     * @param {Function} [props.onChangeComplete]
	     * @param {Function} [props.onChangeStart]
	     * @param {number} [props.step = 1]
	     * @param {number|Range} props.value
	     */
	
	  }]);
	
	  function InputRange(props) {
	    _classCallCheck(this, InputRange);
	
	    /**
	     * @private
	     * @type {?number}
	     */
	    var _this = _possibleConstructorReturn(this, (InputRange.__proto__ || Object.getPrototypeOf(InputRange)).call(this, props));
	
	    _this.startValue = null;
	
	    /**
	     * @private
	     * @type {?Component}
	     */
	    _this.node = null;
	
	    /**
	     * @private
	     * @type {?Component}
	     */
	    _this.trackNode = null;
	
	    /**
	     * @private
	     * @type {bool}
	     */
	    _this.isSliderDragging = false;
	    return _this;
	  }
	
	  /**
	   * @ignore
	   * @override
	   * @return {void}
	   */
	
	
	  _createClass(InputRange, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeDocumentMouseUpListener();
	      this.removeDocumentTouchEndListener();
	    }
	
	    /**
	     * Return the CSS class name of the component
	     * @private
	     * @return {string}
	     */
	
	  }, {
	    key: 'getComponentClassName',
	    value: function getComponentClassName() {
	      if (!this.props.disabled) {
	        return this.props.classNames.inputRange;
	      }
	
	      return this.props.classNames.disabledInputRange;
	    }
	
	    /**
	     * Return the bounding rect of the track
	     * @private
	     * @return {ClientRect}
	     */
	
	  }, {
	    key: 'getTrackClientRect',
	    value: function getTrackClientRect() {
	      return this.trackNode.getClientRect();
	    }
	
	    /**
	     * Return the slider key closest to a point
	     * @private
	     * @param {Point} position
	     * @return {string}
	     */
	
	  }, {
	    key: 'getKeyByPosition',
	    value: function getKeyByPosition(position) {
	      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
	      var positions = valueTransformer.getPositionsFromValues(values, this.props.minValue, this.props.maxValue, this.getTrackClientRect());
	
	      if (this.isMultiValue()) {
	        var distanceToMin = (0, _utils.distanceTo)(position, positions.min);
	        var distanceToMax = (0, _utils.distanceTo)(position, positions.max);
	
	        if (distanceToMin < distanceToMax) {
	          return 'min';
	        }
	      }
	
	      return 'max';
	    }
	
	    /**
	     * Return all the slider keys
	     * @private
	     * @return {string[]}
	     */
	
	  }, {
	    key: 'getKeys',
	    value: function getKeys() {
	      if (this.isMultiValue()) {
	        return ['min', 'max'];
	      }
	
	      return ['max'];
	    }
	
	    /**
	     * Return true if the difference between the new and the current value is
	     * greater or equal to the step amount of the component
	     * @private
	     * @param {Range} values
	     * @return {boolean}
	     */
	
	  }, {
	    key: 'hasStepDifference',
	    value: function hasStepDifference(values) {
	      var currentValues = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
	
	      return (0, _utils.length)(values.min, currentValues.min) >= this.props.step || (0, _utils.length)(values.max, currentValues.max) >= this.props.step;
	    }
	
	    /**
	     * Return true if the component accepts a min and max value
	     * @private
	     * @return {boolean}
	     */
	
	  }, {
	    key: 'isMultiValue',
	    value: function isMultiValue() {
	      return (0, _utils.isObject)(this.props.value);
	    }
	
	    /**
	     * Return true if the range is within the max and min value of the component
	     * @private
	     * @param {Range} values
	     * @return {boolean}
	     */
	
	  }, {
	    key: 'isWithinRange',
	    value: function isWithinRange(values) {
	      if (this.isMultiValue()) {
	        return values.min >= this.props.minValue && values.max <= this.props.maxValue && values.min < values.max;
	      }
	
	      return values.max >= this.props.minValue && values.max <= this.props.maxValue;
	    }
	
	    /**
	     * Return true if the new value should trigger a render
	     * @private
	     * @param {Range} values
	     * @return {boolean}
	     */
	
	  }, {
	    key: 'shouldUpdate',
	    value: function shouldUpdate(values) {
	      return this.isWithinRange(values) && this.hasStepDifference(values);
	    }
	
	    /**
	     * Update the position of a slider
	     * @private
	     * @param {string} key
	     * @param {Point} position
	     * @return {void}
	     */
	
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition(key, position) {
	      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
	      var positions = valueTransformer.getPositionsFromValues(values, this.props.minValue, this.props.maxValue, this.getTrackClientRect());
	
	      positions[key] = position;
	
	      this.updatePositions(positions);
	    }
	
	    /**
	     * Update the positions of multiple sliders
	     * @private
	     * @param {Object} positions
	     * @param {Point} positions.min
	     * @param {Point} positions.max
	     * @return {void}
	     */
	
	  }, {
	    key: 'updatePositions',
	    value: function updatePositions(positions) {
	      var values = {
	        min: valueTransformer.getValueFromPosition(positions.min, this.props.minValue, this.props.maxValue, this.getTrackClientRect()),
	        max: valueTransformer.getValueFromPosition(positions.max, this.props.minValue, this.props.maxValue, this.getTrackClientRect())
	      };
	
	      var transformedValues = {
	        min: valueTransformer.getStepValueFromValue(values.min, this.props.step),
	        max: valueTransformer.getStepValueFromValue(values.max, this.props.step)
	      };
	
	      this.updateValues(transformedValues);
	    }
	
	    /**
	     * Update the value of a slider
	     * @private
	     * @param {string} key
	     * @param {number} value
	     * @return {void}
	     */
	
	  }, {
	    key: 'updateValue',
	    value: function updateValue(key, value) {
	      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
	
	      values[key] = value;
	
	      this.updateValues(values);
	    }
	
	    /**
	     * Update the values of multiple sliders
	     * @private
	     * @param {Range|number} values
	     * @return {void}
	     */
	
	  }, {
	    key: 'updateValues',
	    value: function updateValues(values) {
	      if (!this.shouldUpdate(values)) {
	        return;
	      }
	
	      this.props.onChange(this.isMultiValue() ? values : values.max);
	    }
	
	    /**
	     * Increment the value of a slider by key name
	     * @private
	     * @param {string} key
	     * @return {void}
	     */
	
	  }, {
	    key: 'incrementValue',
	    value: function incrementValue(key) {
	      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
	      var value = values[key] + this.props.step;
	
	      this.updateValue(key, value);
	    }
	
	    /**
	     * Decrement the value of a slider by key name
	     * @private
	     * @param {string} key
	     * @return {void}
	     */
	
	  }, {
	    key: 'decrementValue',
	    value: function decrementValue(key) {
	      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
	      var value = values[key] - this.props.step;
	
	      this.updateValue(key, value);
	    }
	
	    /**
	     * Listen to mouseup event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'addDocumentMouseUpListener',
	    value: function addDocumentMouseUpListener() {
	      this.removeDocumentMouseUpListener();
	      this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
	    }
	
	    /**
	     * Listen to touchend event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'addDocumentTouchEndListener',
	    value: function addDocumentTouchEndListener() {
	      this.removeDocumentTouchEndListener();
	      this.node.ownerDocument.addEventListener('touchend', this.handleTouchEnd);
	    }
	
	    /**
	     * Stop listening to mouseup event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'removeDocumentMouseUpListener',
	    value: function removeDocumentMouseUpListener() {
	      this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
	    }
	
	    /**
	     * Stop listening to touchend event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'removeDocumentTouchEndListener',
	    value: function removeDocumentTouchEndListener() {
	      this.node.ownerDocument.removeEventListener('touchend', this.handleTouchEnd);
	    }
	
	    /**
	     * Handle any "mousemove" event received by the slider
	     * @private
	     * @param {SyntheticEvent} event
	     * @param {string} key
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleSliderDrag',
	    value: function handleSliderDrag(event, key) {
	      var _this2 = this;
	
	      if (this.props.disabled) {
	        return;
	      }
	
	      var position = valueTransformer.getPositionFromEvent(event, this.getTrackClientRect());
	      this.isSliderDragging = true;
	      requestAnimationFrame(function () {
	        return _this2.updatePosition(key, position);
	      });
	    }
	
	    /**
	     * Handle any "mousemove" event received by the track
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleTrackDrag',
	    value: function handleTrackDrag(event, prevEvent) {
	      if (this.props.disabled || !this.props.draggableTrack || this.isSliderDragging) {
	        return;
	      }
	
	      var _props = this.props,
	          maxValue = _props.maxValue,
	          minValue = _props.minValue,
	          _props$value = _props.value,
	          max = _props$value.max,
	          min = _props$value.min;
	
	
	      var position = valueTransformer.getPositionFromEvent(event, this.getTrackClientRect());
	      var value = valueTransformer.getValueFromPosition(position, minValue, maxValue, this.getTrackClientRect());
	      var stepValue = valueTransformer.getStepValueFromValue(value, this.props.step);
	
	      var prevPosition = valueTransformer.getPositionFromEvent(prevEvent, this.getTrackClientRect());
	      var prevValue = valueTransformer.getValueFromPosition(prevPosition, minValue, maxValue, this.getTrackClientRect());
	      var prevStepValue = valueTransformer.getStepValueFromValue(prevValue, this.props.step);
	
	      var offset = prevStepValue - stepValue;
	
	      var transformedValues = {
	        min: min - offset,
	        max: max - offset
	      };
	
	      this.updateValues(transformedValues);
	    }
	
	    /**
	     * Handle any "keydown" event received by the slider
	     * @private
	     * @param {SyntheticEvent} event
	     * @param {string} key
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleSliderKeyDown',
	    value: function handleSliderKeyDown(event, key) {
	      if (this.props.disabled) {
	        return;
	      }
	
	      switch (event.keyCode) {
	        case _keyCodes.LEFT_ARROW:
	        case _keyCodes.DOWN_ARROW:
	          event.preventDefault();
	          this.decrementValue(key);
	          break;
	
	        case _keyCodes.RIGHT_ARROW:
	        case _keyCodes.UP_ARROW:
	          event.preventDefault();
	          this.incrementValue(key);
	          break;
	
	        default:
	          break;
	      }
	    }
	
	    /**
	     * Handle any "mousedown" event received by the track
	     * @private
	     * @param {SyntheticEvent} event
	     * @param {Point} position
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleTrackMouseDown',
	    value: function handleTrackMouseDown(event, position) {
	      if (this.props.disabled) {
	        return;
	      }
	
	      var _props2 = this.props,
	          maxValue = _props2.maxValue,
	          minValue = _props2.minValue,
	          _props2$value = _props2.value,
	          max = _props2$value.max,
	          min = _props2$value.min;
	
	
	      event.preventDefault();
	
	      var value = valueTransformer.getValueFromPosition(position, minValue, maxValue, this.getTrackClientRect());
	      var stepValue = valueTransformer.getStepValueFromValue(value, this.props.step);
	
	      if (!this.props.draggableTrack || stepValue > max || stepValue < min) {
	        this.updatePosition(this.getKeyByPosition(position), position);
	      }
	    }
	
	    /**
	     * Handle the start of any mouse/touch event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleInteractionStart',
	    value: function handleInteractionStart() {
	      if (this.props.onChangeStart) {
	        this.props.onChangeStart(this.props.value);
	      }
	
	      if (this.props.onChangeComplete && !(0, _utils.isDefined)(this.startValue)) {
	        this.startValue = this.props.value;
	      }
	    }
	
	    /**
	     * Handle the end of any mouse/touch event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleInteractionEnd',
	    value: function handleInteractionEnd() {
	      if (this.isSliderDragging) {
	        this.isSliderDragging = false;
	      }
	
	      if (!this.props.onChangeComplete || !(0, _utils.isDefined)(this.startValue)) {
	        return;
	      }
	
	      if (this.startValue !== this.props.value) {
	        this.props.onChangeComplete(this.props.value);
	      }
	
	      this.startValue = null;
	    }
	
	    /**
	     * Handle any "keydown" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(event) {
	      this.handleInteractionStart(event);
	    }
	
	    /**
	     * Handle any "keyup" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleKeyUp',
	    value: function handleKeyUp(event) {
	      this.handleInteractionEnd(event);
	    }
	
	    /**
	     * Handle any "mousedown" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleMouseDown',
	    value: function handleMouseDown(event) {
	      this.handleInteractionStart(event);
	      this.addDocumentMouseUpListener();
	    }
	
	    /**
	     * Handle any "mouseup" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     */
	
	  }, {
	    key: 'handleMouseUp',
	    value: function handleMouseUp(event) {
	      this.handleInteractionEnd(event);
	      this.removeDocumentMouseUpListener();
	    }
	
	    /**
	     * Handle any "touchstart" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleTouchStart',
	    value: function handleTouchStart(event) {
	      this.handleInteractionStart(event);
	      this.addDocumentTouchEndListener();
	    }
	
	    /**
	     * Handle any "touchend" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     */
	
	  }, {
	    key: 'handleTouchEnd',
	    value: function handleTouchEnd(event) {
	      this.handleInteractionEnd(event);
	      this.removeDocumentTouchEndListener();
	    }
	
	    /**
	     * Return JSX of sliders
	     * @private
	     * @return {JSX.Element}
	     */
	
	  }, {
	    key: 'renderSliders',
	    value: function renderSliders() {
	      var _this3 = this;
	
	      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
	      var percentages = valueTransformer.getPercentagesFromValues(values, this.props.minValue, this.props.maxValue);
	
	      return this.getKeys().map(function (key) {
	        var value = values[key];
	        var percentage = percentages[key];
	
	        var _props3 = _this3.props,
	            maxValue = _props3.maxValue,
	            minValue = _props3.minValue;
	
	
	        if (key === 'min') {
	          maxValue = values.max;
	        } else {
	          minValue = values.min;
	        }
	
	        var slider = _react2.default.createElement(_slider2.default, {
	          ariaLabelledby: _this3.props.ariaLabelledby,
	          ariaControls: _this3.props.ariaControls,
	          classNames: _this3.props.classNames,
	          formatLabel: _this3.props.formatLabel,
	          key: key,
	          maxValue: maxValue,
	          minValue: minValue,
	          onSliderDrag: _this3.handleSliderDrag,
	          onSliderKeyDown: _this3.handleSliderKeyDown,
	          percentage: percentage,
	          type: key,
	          value: value });
	
	        return slider;
	      });
	    }
	
	    /**
	     * Return JSX of hidden inputs
	     * @private
	     * @return {JSX.Element}
	     */
	
	  }, {
	    key: 'renderHiddenInputs',
	    value: function renderHiddenInputs() {
	      var _this4 = this;
	
	      if (!this.props.name) {
	        return [];
	      }
	
	      var isMultiValue = this.isMultiValue();
	      var values = valueTransformer.getValueFromProps(this.props, isMultiValue);
	
	      return this.getKeys().map(function (key) {
	        var value = values[key];
	        var name = isMultiValue ? '' + _this4.props.name + (0, _utils.captialize)(key) : _this4.props.name;
	
	        return _react2.default.createElement('input', { key: key, type: 'hidden', name: name, value: value });
	      });
	    }
	
	    /**
	     * @ignore
	     * @override
	     * @return {JSX.Element}
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var componentClassName = this.getComponentClassName();
	      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
	      var percentages = valueTransformer.getPercentagesFromValues(values, this.props.minValue, this.props.maxValue);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          'aria-disabled': this.props.disabled,
	          ref: function ref(node) {
	            _this5.node = node;
	          },
	          className: componentClassName,
	          onKeyDown: this.handleKeyDown,
	          onKeyUp: this.handleKeyUp,
	          onMouseDown: this.handleMouseDown,
	          onTouchStart: this.handleTouchStart },
	        _react2.default.createElement(
	          _label2.default,
	          {
	            classNames: this.props.classNames,
	            formatLabel: this.props.formatLabel,
	            type: 'min' },
	          this.props.minValue
	        ),
	        _react2.default.createElement(
	          _track2.default,
	          {
	            classNames: this.props.classNames,
	            draggableTrack: this.props.draggableTrack,
	            ref: function ref(trackNode) {
	              _this5.trackNode = trackNode;
	            },
	            percentages: percentages,
	            onTrackDrag: this.handleTrackDrag,
	            onTrackMouseDown: this.handleTrackMouseDown },
	          this.renderSliders()
	        ),
	        _react2.default.createElement(
	          _label2.default,
	          {
	            classNames: this.props.classNames,
	            formatLabel: this.props.formatLabel,
	            type: 'max' },
	          this.props.maxValue
	        ),
	        this.renderHiddenInputs()
	      );
	    }
	  }]);
	
	  return InputRange;
	}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleSliderDrag', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleSliderDrag'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTrackDrag', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTrackDrag'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleSliderKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleSliderKeyDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTrackMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTrackMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleInteractionStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleInteractionStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleInteractionEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleInteractionEnd'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchEnd'), _class.prototype)), _class);
	exports.default = InputRange;
	module.exports = exports['default'];
	//# sourceMappingURL=input-range.js.map

/***/ },
/* 1003 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/** @ignore */
	var DOWN_ARROW = exports.DOWN_ARROW = 40;
	
	/** @ignore */
	var LEFT_ARROW = exports.LEFT_ARROW = 37;
	
	/** @ignore */
	var RIGHT_ARROW = exports.RIGHT_ARROW = 39;
	
	/** @ignore */
	var UP_ARROW = exports.UP_ARROW = 38;
	//# sourceMappingURL=key-codes.js.map

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rangePropType;
	
	var _utils = __webpack_require__(168);
	
	/**
	 * @ignore
	 * @param {Object} props - React component props
	 * @return {?Error} Return Error if validation fails
	 */
	function rangePropType(props) {
	  var maxValue = props.maxValue,
	      minValue = props.minValue;
	
	
	  if (!(0, _utils.isNumber)(minValue) || !(0, _utils.isNumber)(maxValue)) {
	    return new Error('"minValue" and "maxValue" must be a number');
	  }
	
	  if (minValue >= maxValue) {
	    return new Error('"minValue" must be smaller than "maxValue"');
	  }
	}
	module.exports = exports['default'];
	//# sourceMappingURL=range-prop-type.js.map

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _desc, _value, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(181);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _label = __webpack_require__(505);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	/**
	 * @ignore
	 */
	var Slider = (_class = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  _createClass(Slider, null, [{
	    key: 'propTypes',
	
	    /**
	     * Accepted propTypes of Slider
	     * @override
	     * @return {Object}
	     * @property {Function} ariaLabelledby
	     * @property {Function} ariaControls
	     * @property {Function} className
	     * @property {Function} formatLabel
	     * @property {Function} maxValue
	     * @property {Function} minValue
	     * @property {Function} onSliderDrag
	     * @property {Function} onSliderKeyDown
	     * @property {Function} percentage
	     * @property {Function} type
	     * @property {Function} value
	     */
	    get: function get() {
	      return {
	        ariaLabelledby: _propTypes2.default.string,
	        ariaControls: _propTypes2.default.string,
	        classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
	        formatLabel: _propTypes2.default.func,
	        maxValue: _propTypes2.default.number,
	        minValue: _propTypes2.default.number,
	        onSliderDrag: _propTypes2.default.func.isRequired,
	        onSliderKeyDown: _propTypes2.default.func.isRequired,
	        percentage: _propTypes2.default.number.isRequired,
	        type: _propTypes2.default.string.isRequired,
	        value: _propTypes2.default.number.isRequired
	      };
	    }
	
	    /**
	     * @param {Object} props
	     * @param {string} [props.ariaLabelledby]
	     * @param {string} [props.ariaControls]
	     * @param {InputRangeClassNames} props.classNames
	     * @param {Function} [props.formatLabel]
	     * @param {number} [props.maxValue]
	     * @param {number} [props.minValue]
	     * @param {Function} props.onSliderKeyDown
	     * @param {Function} props.onSliderDrag
	     * @param {number} props.percentage
	     * @param {number} props.type
	     * @param {number} props.value
	     */
	
	  }]);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    /**
	     * @private
	     * @type {?Component}
	     */
	    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));
	
	    _this.node = null;
	    return _this;
	  }
	
	  /**
	   * @ignore
	   * @override
	   * @return {void}
	   */
	
	
	  _createClass(Slider, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeDocumentMouseMoveListener();
	      this.removeDocumentMouseUpListener();
	      this.removeDocumentTouchEndListener();
	      this.removeDocumentTouchMoveListener();
	    }
	
	    /**
	     * @private
	     * @return {Object}
	     */
	
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var perc = (this.props.percentage || 0) * 100;
	      var style = {
	        position: 'absolute',
	        left: perc + '%'
	      };
	
	      return style;
	    }
	
	    /**
	     * Listen to mousemove event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'addDocumentMouseMoveListener',
	    value: function addDocumentMouseMoveListener() {
	      this.removeDocumentMouseMoveListener();
	      this.node.ownerDocument.addEventListener('mousemove', this.handleMouseMove);
	    }
	
	    /**
	     * Listen to mouseup event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'addDocumentMouseUpListener',
	    value: function addDocumentMouseUpListener() {
	      this.removeDocumentMouseUpListener();
	      this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
	    }
	
	    /**
	     * Listen to touchmove event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'addDocumentTouchMoveListener',
	    value: function addDocumentTouchMoveListener() {
	      this.removeDocumentTouchMoveListener();
	      this.node.ownerDocument.addEventListener('touchmove', this.handleTouchMove);
	    }
	
	    /**
	     * Listen to touchend event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'addDocumentTouchEndListener',
	    value: function addDocumentTouchEndListener() {
	      this.removeDocumentTouchEndListener();
	      this.node.ownerDocument.addEventListener('touchend', this.handleTouchEnd);
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'removeDocumentMouseMoveListener',
	    value: function removeDocumentMouseMoveListener() {
	      this.node.ownerDocument.removeEventListener('mousemove', this.handleMouseMove);
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'removeDocumentMouseUpListener',
	    value: function removeDocumentMouseUpListener() {
	      this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'removeDocumentTouchMoveListener',
	    value: function removeDocumentTouchMoveListener() {
	      this.node.ownerDocument.removeEventListener('touchmove', this.handleTouchMove);
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'removeDocumentTouchEndListener',
	    value: function removeDocumentTouchEndListener() {
	      this.node.ownerDocument.removeEventListener('touchend', this.handleTouchEnd);
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleMouseDown',
	    value: function handleMouseDown() {
	      this.addDocumentMouseMoveListener();
	      this.addDocumentMouseUpListener();
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleMouseUp',
	    value: function handleMouseUp() {
	      this.removeDocumentMouseMoveListener();
	      this.removeDocumentMouseUpListener();
	    }
	
	    /**
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleMouseMove',
	    value: function handleMouseMove(event) {
	      this.props.onSliderDrag(event, this.props.type);
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleTouchStart',
	    value: function handleTouchStart() {
	      this.addDocumentTouchEndListener();
	      this.addDocumentTouchMoveListener();
	    }
	
	    /**
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleTouchMove',
	    value: function handleTouchMove(event) {
	      this.props.onSliderDrag(event, this.props.type);
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleTouchEnd',
	    value: function handleTouchEnd() {
	      this.removeDocumentTouchMoveListener();
	      this.removeDocumentTouchEndListener();
	    }
	
	    /**
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(event) {
	      this.props.onSliderKeyDown(event, this.props.type);
	    }
	
	    /**
	     * @override
	     * @return {JSX.Element}
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var style = this.getStyle();
	
	      return _react2.default.createElement(
	        'span',
	        {
	          className: this.props.classNames.sliderContainer,
	          ref: function ref(node) {
	            _this2.node = node;
	          },
	          style: style },
	        _react2.default.createElement(
	          _label2.default,
	          {
	            classNames: this.props.classNames,
	            formatLabel: this.props.formatLabel,
	            type: 'value' },
	          this.props.value
	        ),
	        _react2.default.createElement('div', {
	          'aria-labelledby': this.props.ariaLabelledby,
	          'aria-controls': this.props.ariaControls,
	          'aria-valuemax': this.props.maxValue,
	          'aria-valuemin': this.props.minValue,
	          'aria-valuenow': this.props.value,
	          className: this.props.classNames.slider,
	          draggable: 'false',
	          onKeyDown: this.handleKeyDown,
	          onMouseDown: this.handleMouseDown,
	          onTouchStart: this.handleTouchStart,
	          role: 'slider',
	          tabIndex: '0' })
	      );
	    }
	  }]);
	
	  return Slider;
	}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchEnd'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyDown'), _class.prototype)), _class);
	exports.default = Slider;
	module.exports = exports['default'];
	//# sourceMappingURL=slider.js.map

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _desc, _value, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(181);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	/**
	 * @ignore
	 */
	var Track = (_class = function (_React$Component) {
	  _inherits(Track, _React$Component);
	
	  _createClass(Track, null, [{
	    key: 'propTypes',
	
	    /**
	     * @override
	     * @return {Object}
	     * @property {Function} children
	     * @property {Function} classNames
	     * @property {Boolean} draggableTrack
	     * @property {Function} onTrackDrag
	     * @property {Function} onTrackMouseDown
	     * @property {Function} percentages
	     */
	    get: function get() {
	      return {
	        children: _propTypes2.default.node.isRequired,
	        classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
	        draggableTrack: _propTypes2.default.bool,
	        onTrackDrag: _propTypes2.default.func,
	        onTrackMouseDown: _propTypes2.default.func.isRequired,
	        percentages: _propTypes2.default.objectOf(_propTypes2.default.number).isRequired
	      };
	    }
	
	    /**
	     * @param {Object} props
	     * @param {InputRangeClassNames} props.classNames
	     * @param {Boolean} props.draggableTrack
	     * @param {Function} props.onTrackDrag
	     * @param {Function} props.onTrackMouseDown
	     * @param {number} props.percentages
	     */
	
	  }]);
	
	  function Track(props) {
	    _classCallCheck(this, Track);
	
	    /**
	     * @private
	     * @type {?Component}
	     */
	    var _this = _possibleConstructorReturn(this, (Track.__proto__ || Object.getPrototypeOf(Track)).call(this, props));
	
	    _this.node = null;
	    _this.trackDragEvent = null;
	    return _this;
	  }
	
	  /**
	   * @private
	   * @return {ClientRect}
	   */
	
	
	  _createClass(Track, [{
	    key: 'getClientRect',
	    value: function getClientRect() {
	      return this.node.getBoundingClientRect();
	    }
	
	    /**
	     * @private
	     * @return {Object} CSS styles
	     */
	
	  }, {
	    key: 'getActiveTrackStyle',
	    value: function getActiveTrackStyle() {
	      var width = (this.props.percentages.max - this.props.percentages.min) * 100 + '%';
	      var left = this.props.percentages.min * 100 + '%';
	
	      return { left: left, width: width };
	    }
	
	    /**
	     * Listen to mousemove event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'addDocumentMouseMoveListener',
	    value: function addDocumentMouseMoveListener() {
	      this.removeDocumentMouseMoveListener();
	      this.node.ownerDocument.addEventListener('mousemove', this.handleMouseMove);
	    }
	
	    /**
	     * Listen to mouseup event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'addDocumentMouseUpListener',
	    value: function addDocumentMouseUpListener() {
	      this.removeDocumentMouseUpListener();
	      this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'removeDocumentMouseMoveListener',
	    value: function removeDocumentMouseMoveListener() {
	      this.node.ownerDocument.removeEventListener('mousemove', this.handleMouseMove);
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'removeDocumentMouseUpListener',
	    value: function removeDocumentMouseUpListener() {
	      this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
	    }
	
	    /**
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleMouseMove',
	    value: function handleMouseMove(event) {
	      if (!this.props.draggableTrack) {
	        return;
	      }
	
	      if (this.trackDragEvent !== null) {
	        this.props.onTrackDrag(event, this.trackDragEvent);
	      }
	
	      this.trackDragEvent = event;
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleMouseUp',
	    value: function handleMouseUp() {
	      if (!this.props.draggableTrack) {
	        return;
	      }
	
	      this.removeDocumentMouseMoveListener();
	      this.removeDocumentMouseUpListener();
	      this.trackDragEvent = null;
	    }
	
	    /**
	     * @private
	     * @param {SyntheticEvent} event - User event
	     */
	
	  }, {
	    key: 'handleMouseDown',
	    value: function handleMouseDown(event) {
	      var clientX = event.touches ? event.touches[0].clientX : event.clientX;
	      var trackClientRect = this.getClientRect();
	      var position = {
	        x: clientX - trackClientRect.left,
	        y: 0
	      };
	
	      this.props.onTrackMouseDown(event, position);
	
	      if (this.props.draggableTrack) {
	        this.addDocumentMouseMoveListener();
	        this.addDocumentMouseUpListener();
	      }
	    }
	
	    /**
	     * @private
	     * @param {SyntheticEvent} event - User event
	     */
	
	  }, {
	    key: 'handleTouchStart',
	    value: function handleTouchStart(event) {
	      event.preventDefault();
	
	      this.handleMouseDown(event);
	    }
	
	    /**
	     * @override
	     * @return {JSX.Element}
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var activeTrackStyle = this.getActiveTrackStyle();
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: this.props.classNames.track,
	          onMouseDown: this.handleMouseDown,
	          onTouchStart: this.handleTouchStart,
	          ref: function ref(node) {
	            _this2.node = node;
	          } },
	        _react2.default.createElement('div', {
	          style: activeTrackStyle,
	          className: this.props.classNames.activeTrack }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Track;
	}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleMouseMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype)), _class);
	exports.default = Track;
	module.exports = exports['default'];
	//# sourceMappingURL=track.js.map

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = valuePropType;
	
	var _utils = __webpack_require__(168);
	
	/**
	 * @ignore
	 * @param {Object} props
	 * @return {?Error} Return Error if validation fails
	 */
	function valuePropType(props, propName) {
	  var maxValue = props.maxValue,
	      minValue = props.minValue;
	
	  var value = props[propName];
	
	  if (!(0, _utils.isNumber)(value) && (!(0, _utils.isObject)(value) || !(0, _utils.isNumber)(value.min) || !(0, _utils.isNumber)(value.max))) {
	    return new Error('"' + propName + '" must be a number or a range object');
	  }
	
	  if ((0, _utils.isNumber)(value) && (value < minValue || value > maxValue)) {
	    return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
	  }
	
	  if ((0, _utils.isObject)(value) && (value.min < minValue || value.min > maxValue || value.max < minValue || value.max > maxValue)) {
	    return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
	  }
	}
	module.exports = exports['default'];
	//# sourceMappingURL=value-prop-type.js.map

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getPercentageFromPosition = getPercentageFromPosition;
	exports.getValueFromPosition = getValueFromPosition;
	exports.getValueFromProps = getValueFromProps;
	exports.getPercentageFromValue = getPercentageFromValue;
	exports.getPercentagesFromValues = getPercentagesFromValues;
	exports.getPositionFromValue = getPositionFromValue;
	exports.getPositionsFromValues = getPositionsFromValues;
	exports.getPositionFromEvent = getPositionFromEvent;
	exports.getStepValueFromValue = getStepValueFromValue;
	
	var _utils = __webpack_require__(168);
	
	/**
	 * Convert a point into a percentage value
	 * @ignore
	 * @param {Point} position
	 * @param {ClientRect} clientRect
	 * @return {number} Percentage value
	 */
	function getPercentageFromPosition(position, clientRect) {
	  var length = clientRect.width;
	  var sizePerc = position.x / length;
	
	  return sizePerc || 0;
	}
	
	/**
	 * Convert a point into a model value
	 * @ignore
	 * @param {Point} position
	 * @param {number} minValue
	 * @param {number} maxValue
	 * @param {ClientRect} clientRect
	 * @return {number}
	 */
	function getValueFromPosition(position, minValue, maxValue, clientRect) {
	  var sizePerc = getPercentageFromPosition(position, clientRect);
	  var valueDiff = maxValue - minValue;
	
	  return minValue + valueDiff * sizePerc;
	}
	
	/**
	 * Convert props into a range value
	 * @ignore
	 * @param {Object} props
	 * @param {boolean} isMultiValue
	 * @return {Range}
	 */
	function getValueFromProps(props, isMultiValue) {
	  if (isMultiValue) {
	    return _extends({}, props.value);
	  }
	
	  return {
	    min: props.minValue,
	    max: props.value
	  };
	}
	
	/**
	 * Convert a model value into a percentage value
	 * @ignore
	 * @param {number} value
	 * @param {number} minValue
	 * @param {number} maxValue
	 * @return {number}
	 */
	function getPercentageFromValue(value, minValue, maxValue) {
	  var validValue = (0, _utils.clamp)(value, minValue, maxValue);
	  var valueDiff = maxValue - minValue;
	  var valuePerc = (validValue - minValue) / valueDiff;
	
	  return valuePerc || 0;
	}
	
	/**
	 * Convert model values into percentage values
	 * @ignore
	 * @param {Range} values
	 * @param {number} minValue
	 * @param {number} maxValue
	 * @return {Range}
	 */
	function getPercentagesFromValues(values, minValue, maxValue) {
	  return {
	    min: getPercentageFromValue(values.min, minValue, maxValue),
	    max: getPercentageFromValue(values.max, minValue, maxValue)
	  };
	}
	
	/**
	 * Convert a value into a point
	 * @ignore
	 * @param {number} value
	 * @param {number} minValue
	 * @param {number} maxValue
	 * @param {ClientRect} clientRect
	 * @return {Point} Position
	 */
	function getPositionFromValue(value, minValue, maxValue, clientRect) {
	  var length = clientRect.width;
	  var valuePerc = getPercentageFromValue(value, minValue, maxValue);
	  var positionValue = valuePerc * length;
	
	  return {
	    x: positionValue,
	    y: 0
	  };
	}
	
	/**
	 * Convert a range of values into points
	 * @ignore
	 * @param {Range} values
	 * @param {number} minValue
	 * @param {number} maxValue
	 * @param {ClientRect} clientRect
	 * @return {Range}
	 */
	function getPositionsFromValues(values, minValue, maxValue, clientRect) {
	  return {
	    min: getPositionFromValue(values.min, minValue, maxValue, clientRect),
	    max: getPositionFromValue(values.max, minValue, maxValue, clientRect)
	  };
	}
	
	/**
	 * Convert an event into a point
	 * @ignore
	 * @param {Event} event
	 * @param {ClientRect} clientRect
	 * @return {Point}
	 */
	function getPositionFromEvent(event, clientRect) {
	  var length = clientRect.width;
	
	  var _ref = event.touches ? event.touches[0] : event,
	      clientX = _ref.clientX;
	
	  return {
	    x: (0, _utils.clamp)(clientX - clientRect.left, 0, length),
	    y: 0
	  };
	}
	
	/**
	 * Convert a value into a step value
	 * @ignore
	 * @param {number} value
	 * @param {number} valuePerStep
	 * @return {number}
	 */
	function getStepValueFromValue(value, valuePerStep) {
	  return Math.round(value / valuePerStep) * valuePerStep;
	}
	//# sourceMappingURL=value-transformer.js.map

/***/ },
/* 1009 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = captialize;
	/**
	 * Captialize a string
	 * @ignore
	 * @param {string} string
	 * @return {string}
	 */
	function captialize(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	module.exports = exports["default"];
	//# sourceMappingURL=captialize.js.map

/***/ },
/* 1010 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = clamp;
	/**
	 * Clamp a value between a min and max value
	 * @ignore
	 * @param {number} value
	 * @param {number} min
	 * @param {number} max
	 * @return {number}
	 */
	function clamp(value, min, max) {
	  return Math.min(Math.max(value, min), max);
	}
	module.exports = exports["default"];
	//# sourceMappingURL=clamp.js.map

/***/ },
/* 1011 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = distanceTo;
	/**
	 * Calculate the distance between pointA and pointB
	 * @ignore
	 * @param {Point} pointA
	 * @param {Point} pointB
	 * @return {number} Distance
	 */
	function distanceTo(pointA, pointB) {
	  var xDiff = Math.pow(pointB.x - pointA.x, 2);
	  var yDiff = Math.pow(pointB.y - pointA.y, 2);
	
	  return Math.sqrt(xDiff + yDiff);
	}
	module.exports = exports["default"];
	//# sourceMappingURL=distance-to.js.map

/***/ },
/* 1012 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDefined;
	/**
	 * Check if a value is defined
	 * @ignore
	 * @param {*} value
	 * @return {boolean}
	 */
	function isDefined(value) {
	  return value !== undefined && value !== null;
	}
	module.exports = exports["default"];
	//# sourceMappingURL=is-defined.js.map

/***/ },
/* 1013 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isNumber;
	/**
	 * Check if a value is a number
	 * @ignore
	 * @param {*} value
	 * @return {boolean}
	 */
	function isNumber(value) {
	  return typeof value === 'number';
	}
	module.exports = exports['default'];
	//# sourceMappingURL=is-number.js.map

/***/ },
/* 1014 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isObject;
	/**
	 * Check if a value is an object
	 * @ignore
	 * @param {*} value
	 * @return {boolean}
	 */
	function isObject(value) {
	  return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
	}
	module.exports = exports['default'];
	//# sourceMappingURL=is-object.js.map

/***/ },
/* 1015 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = length;
	/**
	 * Calculate the absolute difference between two numbers
	 * @ignore
	 * @param {number} numA
	 * @param {number} numB
	 * @return {number}
	 */
	function length(numA, numB) {
	  return Math.abs(numA - numB);
	}
	module.exports = exports["default"];
	//# sourceMappingURL=length.js.map

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NotifyResize = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactClass = __webpack_require__(25);
	
	var _reactClass2 = _interopRequireDefault(_reactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var notifyResizeStyle = {
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  width: '100%',
	  height: '100%',
	  zIndex: -1,
	  overflow: 'hidden',
	  display: 'block',
	  pointerEvents: 'none',
	  opacity: 0
	};
	
	var expandToolStyle = {
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  width: '100%',
	  height: '100%',
	  overflow: 'auto'
	};
	
	var contractToolStyle = {
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  width: '100%',
	  height: '100%',
	  overflow: 'auto'
	};
	
	var contractToolInnerStyle = {
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  width: '200%',
	  height: '200%'
	};
	
	var NotifyResize = function (_Component) {
	  _inherits(NotifyResize, _Component);
	
	  function NotifyResize(props) {
	    _classCallCheck(this, NotifyResize);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(NotifyResize).call(this, props));
	
	    _this.state = {
	      notifyResizeWidth: 0,
	      notifyResizeHeight: 0,
	
	      expandToolWidth: 0,
	      expandToolHeight: 0,
	
	      contractToolWidth: 0,
	      contractToolHeight: 0
	    };
	
	    return _this;
	  }
	
	  _createClass(NotifyResize, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof this.props.onMount === 'function') {
	        this.props.onMount(this);
	      }
	
	      this.resetResizeTool();
	
	      if (this.props.notifyOnMount) {
	        var _notifyResizeSize = this.notifyResizeSize;
	        var width = _notifyResizeSize.notifyResizeWidth;
	        var height = _notifyResizeSize.notifyResizeHeight;
	
	        this.onResize({ width: width, height: height });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: 'notifyResize',
	          style: notifyResizeStyle,
	          onScroll: this.checkResize
	        },
	        this.renderExpandTool(),
	        this.renderContractTool()
	      );
	    }
	  }, {
	    key: 'renderExpandTool',
	    value: function renderExpandTool() {
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: 'expandTool',
	          className: 'expandTool',
	          style: expandToolStyle
	        },
	        _react2.default.createElement('div', {
	          ref: 'expandToolInner',
	          className: 'expandToolInner',
	          style: {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: this.state.expandToolWidth,
	            height: this.state.expandToolHeight
	          }
	        })
	      );
	    }
	  }, {
	    key: 'renderContractTool',
	    value: function renderContractTool() {
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: 'contractTool',
	          className: 'contractTool',
	          style: contractToolStyle,
	          onScroll: this.checkResize
	        },
	        _react2.default.createElement('div', { ref: 'contractInner', style: contractToolInnerStyle })
	      );
	    }
	  }, {
	    key: 'resetResizeTool',
	    value: function resetResizeTool() {
	      this.setDimensions();
	      this.scrollToBottomExpandTool();
	    }
	  }, {
	    key: 'setDimensions',
	    value: function setDimensions() {
	      var _notifyResizeSize2 = this.notifyResizeSize = this.getDimensions();
	
	      var notifyResizeWidth = _notifyResizeSize2.notifyResizeWidth;
	      var notifyResizeHeight = _notifyResizeSize2.notifyResizeHeight;
	
	      // Resize tool will be bigger than it's parent by 1 pixel in each direction
	
	      this.setState({
	        notifyResizeWidth: notifyResizeWidth,
	        notifyResizeHeight: notifyResizeHeight,
	        expandToolWidth: notifyResizeWidth + 1,
	        expandToolHeight: notifyResizeHeight + 1
	      });
	    }
	  }, {
	    key: 'getDimensions',
	    value: function getDimensions() {
	      var notifyResize = this.refs.notifyResize;
	      var node = notifyResize.parentElement || notifyResize;
	
	      var size = void 0;
	
	      if (typeof this.props.measureSize == 'function') {
	        size = this.props.measureSize(node, notifyResize);
	      } else {
	        size = {
	          width: node.offsetWidth,
	          height: node.offsetHeight
	        };
	      }
	
	      return {
	        notifyResizeWidth: size.width,
	        notifyResizeHeight: size.height
	      };
	    }
	  }, {
	    key: 'scrollToBottomExpandTool',
	    value: function scrollToBottomExpandTool() {
	      var _this2 = this;
	
	      // so the scroll moves when element resizes
	
	      if (this.refs.notifyResize) {
	        setTimeout(function () {
	          // scroll to bottom
	          var expandTool = _this2.refs.expandTool;
	
	          if (expandTool) {
	            expandTool.scrollTop = expandTool.scrollHeight;
	            expandTool.scrollLeft = expandTool.scrollWidth;
	          }
	
	          var contractTool = _this2.refs.contractTool;
	          if (contractTool) {
	            contractTool.scrollTop = contractTool.scrollHeight;
	            contractTool.scrollLeft = contractTool.scrollWidth;
	          }
	        }, 0);
	      }
	    }
	  }, {
	    key: 'checkResize',
	    value: function checkResize() {
	      var _getDimensions = this.getDimensions();
	
	      var notifyResizeWidth = _getDimensions.notifyResizeWidth;
	      var notifyResizeHeight = _getDimensions.notifyResizeHeight;
	
	
	      if (notifyResizeWidth !== this.state.notifyResizeWidth || notifyResizeHeight !== this.state.notifyResizeHeight) {
	        // reset resizeToolDimensions
	        this.onResize({
	          width: notifyResizeWidth,
	          height: notifyResizeHeight
	        });
	        this.resetResizeTool();
	      }
	    }
	  }, {
	    key: 'onResize',
	    value: function onResize(_ref) {
	      var width = _ref.width;
	      var height = _ref.height;
	
	      if (typeof this.props.onResize === 'function') {
	        this.props.onResize({ width: width, height: height });
	      }
	    }
	  }]);
	
	  return NotifyResize;
	}(_reactClass2.default);
	
	NotifyResize.propTypes = {
	  onResize: _react.PropTypes.func,
	  onMount: _react.PropTypes.func,
	  notifyOnMount: _react.PropTypes.bool
	};
	
	var notifyResize = function notifyResize(Component) {
	  return function (_Component2) {
	    _inherits(NotifyResizeWrapper, _Component2);
	
	    function NotifyResizeWrapper() {
	      _classCallCheck(this, NotifyResizeWrapper);
	
	      return _possibleConstructorReturn(this, Object.getPrototypeOf(NotifyResizeWrapper).apply(this, arguments));
	    }
	
	    _createClass(NotifyResizeWrapper, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var component = this.component = this.refs.component;
	
	        // check if they are mounted
	        if (!this.notifyResize) {
	          console.warn('For notifyResize to work you must render resizeTool from {props.resizeTool}');
	        }
	      }
	    }, {
	      key: 'onNotifyResizeMount',
	      value: function onNotifyResizeMount(notifier) {
	        this.notifyResize = notifier;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	
	        var resizeTool = _react2.default.createElement(NotifyResize, {
	          onResize: this.onResize,
	          onMount: this.onNotifyResizeMount,
	
	          notifyOnMount: this.props.notifyOnMount
	        });
	
	        return _react2.default.createElement(Component, _extends({ ref: 'component' }, this.props, { resizeTool: resizeTool }));
	      }
	    }, {
	      key: 'onResize',
	      value: function onResize() {
	        if (typeof this.props.onResize === 'function') {
	          var _props;
	
	          (_props = this.props).onResize.apply(_props, arguments);
	        }
	
	        if (typeof this.refs.component.onResize === 'function') {
	          var _refs$component;
	
	          (_refs$component = this.refs.component).onResize.apply(_refs$component, arguments);
	        }
	      }
	    }]);
	
	    return NotifyResizeWrapper;
	  }(Component);
	};
	
	exports.default = notifyResize;
	exports.NotifyResize = NotifyResize;

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(61);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(506);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(61);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(8);
	
	var _routerWarning = __webpack_require__(100);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(508);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(61);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(8);
	
	var _routerWarning = __webpack_require__(100);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(73);
	
	var _InternalPropTypes = __webpack_require__(123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(61);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(8);
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(73);
	
	var _InternalPropTypes = __webpack_require__(123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(61);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(8);
	
	var _createTransitionManager2 = __webpack_require__(512);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(123);
	
	var _RouterContext = __webpack_require__(241);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(73);
	
	var _RouterUtils = __webpack_require__(509);
	
	var _routerWarning = __webpack_require__(100);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(238);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(241);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(100);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(656);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(511);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(99);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(238);
	
	var _PromiseUtils = __webpack_require__(507);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(99);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(657);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(511);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(99);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(139);
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(510);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(512);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(73);
	
	var _RouterUtils = __webpack_require__(509);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(238);
	
	var _PromiseUtils = __webpack_require__(507);
	
	var _PatternUtils = __webpack_require__(99);
	
	var _routerWarning = __webpack_require__(100);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(61);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(281);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(239);
	
	var _PropTypes = __webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(1119).enable();
	  window.Promise = __webpack_require__(1118);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1131);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(1117);


/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(169);
	
	__webpack_require__(648);
	
	var _Landing = __webpack_require__(1094);
	
	var _Landing2 = _interopRequireDefault(_Landing);
	
	var _Login = __webpack_require__(1083);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Signup = __webpack_require__(1093);
	
	var _Signup2 = _interopRequireDefault(_Signup);
	
	var _ResetPassword = __webpack_require__(1092);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _Public = __webpack_require__(1101);
	
	var _Public2 = _interopRequireDefault(_Public);
	
	var _Profile = __webpack_require__(1087);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _Settings = __webpack_require__(1088);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	var _MoreSettings = __webpack_require__(1084);
	
	var _MoreSettings2 = _interopRequireDefault(_MoreSettings);
	
	var _NCNDA = __webpack_require__(1085);
	
	var _NCNDA2 = _interopRequireDefault(_NCNDA);
	
	var _Password = __webpack_require__(1086);
	
	var _Password2 = _interopRequireDefault(_Password);
	
	var _Terms = __webpack_require__(1091);
	
	var _Terms2 = _interopRequireDefault(_Terms);
	
	var _Success = __webpack_require__(1090);
	
	var _Success2 = _interopRequireDefault(_Success);
	
	var _SignupError = __webpack_require__(1089);
	
	var _SignupError2 = _interopRequireDefault(_SignupError);
	
	var _ActivateAccount = __webpack_require__(1051);
	
	var _ActivateAccount2 = _interopRequireDefault(_ActivateAccount);
	
	var _LoginAdmin = __webpack_require__(1095);
	
	var _LoginAdmin2 = _interopRequireDefault(_LoginAdmin);
	
	var _Error = __webpack_require__(1077);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	var _Search = __webpack_require__(1109);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _SearchByContinent = __webpack_require__(1106);
	
	var _SearchByContinent2 = _interopRequireDefault(_SearchByContinent);
	
	var _SearchByCountry = __webpack_require__(1107);
	
	var _SearchByCountry2 = _interopRequireDefault(_SearchByCountry);
	
	var _SearchByCity = __webpack_require__(1105);
	
	var _SearchByCity2 = _interopRequireDefault(_SearchByCity);
	
	var _SearchCityDetails = __webpack_require__(1108);
	
	var _SearchCityDetails2 = _interopRequireDefault(_SearchCityDetails);
	
	var _PropertiesList = __webpack_require__(1103);
	
	var _PropertiesList2 = _interopRequireDefault(_PropertiesList);
	
	var _MapSearch = __webpack_require__(1102);
	
	var _MapSearch2 = _interopRequireDefault(_MapSearch);
	
	var _PropertyDetails = __webpack_require__(1104);
	
	var _PropertyDetails2 = _interopRequireDefault(_PropertyDetails);
	
	var _connectToStores = __webpack_require__(258);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	var _AuthSources = __webpack_require__(75);
	
	var _ProfileSettings = __webpack_require__(1099);
	
	var _ProfileSettings2 = _interopRequireDefault(_ProfileSettings);
	
	var _PersonalInfo = __webpack_require__(1096);
	
	var _PersonalInfo2 = _interopRequireDefault(_PersonalInfo);
	
	var _Preferences = __webpack_require__(1097);
	
	var _Preferences2 = _interopRequireDefault(_Preferences);
	
	var _Security = __webpack_require__(1098);
	
	var _Security2 = _interopRequireDefault(_Security);
	
	var _AdminPublic = __webpack_require__(1065);
	
	var _AdminPublic2 = _interopRequireDefault(_AdminPublic);
	
	var _AdminProperties = __webpack_require__(1064);
	
	var _AdminProperties2 = _interopRequireDefault(_AdminProperties);
	
	var _AdminPropertyDetails = __webpack_require__(1063);
	
	var _AdminPropertyDetails2 = _interopRequireDefault(_AdminPropertyDetails);
	
	var _AdminUsers = __webpack_require__(1068);
	
	var _AdminUsers2 = _interopRequireDefault(_AdminUsers);
	
	var _AdminUserDetails = __webpack_require__(1067);
	
	var _AdminUserDetails2 = _interopRequireDefault(_AdminUserDetails);
	
	var _AdminRequests = __webpack_require__(1066);
	
	var _AdminRequests2 = _interopRequireDefault(_AdminRequests);
	
	var _AdminCategories = __webpack_require__(1055);
	
	var _AdminCategories2 = _interopRequireDefault(_AdminCategories);
	
	var _EditCategory = __webpack_require__(1054);
	
	var _EditCategory2 = _interopRequireDefault(_EditCategory);
	
	var _AdminLocations = __webpack_require__(1062);
	
	var _AdminLocations2 = _interopRequireDefault(_AdminLocations);
	
	var _AdminCities = __webpack_require__(1056);
	
	var _AdminCities2 = _interopRequireDefault(_AdminCities);
	
	var _EditCity = __webpack_require__(1059);
	
	var _EditCity2 = _interopRequireDefault(_EditCity);
	
	var _AdminContinents = __webpack_require__(1057);
	
	var _AdminContinents2 = _interopRequireDefault(_AdminContinents);
	
	var _EditContinent = __webpack_require__(1060);
	
	var _EditContinent2 = _interopRequireDefault(_EditContinent);
	
	var _AdminCountries = __webpack_require__(1058);
	
	var _AdminCountries2 = _interopRequireDefault(_AdminCountries);
	
	var _EditCountry = __webpack_require__(1061);
	
	var _EditCountry2 = _interopRequireDefault(_EditCountry);
	
	var _EditAdmin = __webpack_require__(1053);
	
	var _EditAdmin2 = _interopRequireDefault(_EditAdmin);
	
	var _AdminsOverview = __webpack_require__(1052);
	
	var _AdminsOverview2 = _interopRequireDefault(_AdminsOverview);
	
	var _Favorite = __webpack_require__(1081);
	
	var _Favorite2 = _interopRequireDefault(_Favorite);
	
	var _FavoriteList = __webpack_require__(1078);
	
	var _FavoriteList2 = _interopRequireDefault(_FavoriteList);
	
	var _FavoriteMap = __webpack_require__(1079);
	
	var _FavoriteMap2 = _interopRequireDefault(_FavoriteMap);
	
	var _FavoriteProperties = __webpack_require__(1080);
	
	var _FavoriteProperties2 = _interopRequireDefault(_FavoriteProperties);
	
	var _Agreements = __webpack_require__(1076);
	
	var _Agreements2 = _interopRequireDefault(_Agreements);
	
	var _SalesMandate = __webpack_require__(1075);
	
	var _SalesMandate2 = _interopRequireDefault(_SalesMandate);
	
	var _AmbassadorAgreement = __webpack_require__(1069);
	
	var _AmbassadorAgreement2 = _interopRequireDefault(_AmbassadorAgreement);
	
	var _CollaborationAgreement = __webpack_require__(1070);
	
	var _CollaborationAgreement2 = _interopRequireDefault(_CollaborationAgreement);
	
	var _LetterOfIntent = __webpack_require__(1072);
	
	var _LetterOfIntent2 = _interopRequireDefault(_LetterOfIntent);
	
	var _NDA = __webpack_require__(1073);
	
	var _NDA2 = _interopRequireDefault(_NDA);
	
	var _NDFA = __webpack_require__(1074);
	
	var _NDFA2 = _interopRequireDefault(_NDFA);
	
	var _CommissionAgreement = __webpack_require__(1071);
	
	var _CommissionAgreement2 = _interopRequireDefault(_CommissionAgreement);
	
	var _AboutPangaea = __webpack_require__(1082);
	
	var _AboutPangaea2 = _interopRequireDefault(_AboutPangaea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactRouter.Router,
	        { history: _reactRouter.browserHistory },
	        _react2.default.createElement(
	          _reactRouter.Route,
	          {
	            path: '/',
	            component: (0, _connectToStores2.default)(_Public2.default),
	            onEnter: _AuthSources.requireAuth },
	          _react2.default.createElement(_reactRouter.IndexRedirect, { to: '/search/' }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: '/profile', component: _ProfileSettings2.default },
	            _react2.default.createElement(_reactRouter.IndexRedirect, { to: '/profile/profile_info' }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'profile_info', component: _PersonalInfo2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'preferences', component: _Preferences2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'security', component: _Security2.default })
	          ),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: '/search', component: _Search2.default },
	            _react2.default.createElement(_reactRouter.IndexRedirect, { to: '/search/region' }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'properties', component: _PropertiesList2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'map', component: _MapSearch2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'region', component: _SearchByContinent2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'region/:continent', component: _SearchByCountry2.default }),
	            _react2.default.createElement(_reactRouter.Route, {
	              path: 'region/:continent/:country',
	              component: _SearchByCity2.default
	            }),
	            _react2.default.createElement(_reactRouter.Route, {
	              path: 'region/:continent/:country/:city',
	              component: _SearchCityDetails2.default
	            })
	          ),
	          _react2.default.createElement(_reactRouter.Route, { path: '/property/:id', component: _PropertyDetails2.default }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: '/favorite', component: _Favorite2.default },
	            _react2.default.createElement(_reactRouter.IndexRedirect, { to: '/favorite/properties' }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'properties', component: _FavoriteProperties2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'list', component: _FavoriteList2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'map', component: _FavoriteMap2.default })
	          )
	        ),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: '/landing', component: (0, _connectToStores2.default)(_Landing2.default) },
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'signup', component: _Signup2.default },
	            _react2.default.createElement(_reactRouter.IndexRedirect, { to: '/landing/signup/profile' }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'profile', component: _Profile2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'settings', component: _Settings2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'more-settings', component: _MoreSettings2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'password', component: _Password2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'terms', component: _Terms2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'ncnda', component: _NCNDA2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'success', component: _Success2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'error', component: _SignupError2.default })
	          ),
	          _react2.default.createElement(_reactRouter.Route, { path: 'login', component: (0, _connectToStores2.default)(_Login2.default) }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'about_pangaea', component: _AboutPangaea2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'reset', component: _ResetPassword2.default })
	        ),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: '/agreements', component: _Agreements2.default },
	          _react2.default.createElement(_reactRouter.IndexRedirect, { to: '/agreements/letter_of_intent' }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'sales_mandate', component: _SalesMandate2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'letter_of_intent', component: _LetterOfIntent2.default }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: 'collaboration_agreement',
	            component: _CollaborationAgreement2.default
	          }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: 'ambassador_agreement',
	            component: _AmbassadorAgreement2.default
	          }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'non_disclosure_and_fee_agreement', component: _NDFA2.default }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: 'commission_agreement',
	            component: _CommissionAgreement2.default
	          }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'non_disclosure_agreement', component: _NDA2.default })
	        ),
	        _react2.default.createElement(_reactRouter.Route, { path: '/activate_account/:id', component: _ActivateAccount2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: '/admin-login', component: (0, _connectToStores2.default)(_LoginAdmin2.default) }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          {
	            path: '/admin',
	            component: (0, _connectToStores2.default)(_AdminPublic2.default),
	            onEnter: _AuthSources.requireAdminAuth },
	          _react2.default.createElement(_reactRouter.IndexRedirect, { to: '/admin/properties' }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'properties', component: _AdminProperties2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'properties/:id', component: _AdminPropertyDetails2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'users', component: _AdminUsers2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'users/:id', component: _AdminUserDetails2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'requests', component: _AdminRequests2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'categories', component: _AdminCategories2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'categories/:id', component: _EditCategory2.default }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'locations', component: _AdminLocations2.default },
	            _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'cities' }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'continents', component: _AdminContinents2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'continents/:id', component: _EditContinent2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'countries', component: _AdminCountries2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'countries/:id', component: _EditCountry2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'cities', component: _AdminCities2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'cities/:id', component: _EditCity2.default })
	          ),
	          _react2.default.createElement(_reactRouter.Route, { path: 'admins', component: _AdminsOverview2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'admins/:id', component: _EditAdmin2.default })
	        ),
	        _react2.default.createElement(_reactRouter.Route, { path: '*', component: _Error2.default })
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Colors = __webpack_require__(242);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var type = {
	  base: 'Brown, sans-serif'
	};
	
	var size = {
	  title: '22px',
	  header: '18px',
	  text: '14px',
	  medium: '12px',
	  small: '10px'
	};
	
	var weight = {
	  normal: 300,
	  light: 100
	};
	
	var style = {
	  Title: {
	    fontFamily: type.base,
	    fontSize: size.title,
	    fontWeight: weight.normal,
	    letterSpacing: '1px',
	    textTransform: 'uppercase',
	    color: _Colors2.default.black
	  },
	  Header: {
	    fontFamily: type.base,
	    fontSize: size.header,
	    lineHeight: '1.0',
	    letterSpacing: '1px',
	    fontWeight: weight.normal,
	    color: _Colors2.default.black
	  },
	  Text: {
	    fontFamily: type.base,
	    fontSize: size.text,
	    lineHeight: '1.0',
	    letterSpacing: '1px',
	    fontWeight: weight.light,
	    color: _Colors2.default.black
	  },
	  Label: {
	    fontFamily: type.base,
	    fontSize: size.text,
	    lineHeight: '1.0',
	    letterSpacing: '1px',
	    color: _Colors2.default.black,
	    fontWeight: weight.normal
	  },
	  Input: {
	    fontFamily: type.base,
	    fontSize: size.medium,
	    letterSpacing: '1px',
	    color: _Colors2.default.darkGrey,
	    fontWeight: weight.light
	  },
	  Button: {
	    fontFamily: type.base,
	    fontSize: size.small,
	    lineHeight: '1.0',
	    letterSpacing: '1px',
	    fontWeight: weight.normal,
	    color: _Colors2.default.black
	  },
	  Small: {
	    fontFamily: type.base,
	    fontSize: size.small,
	    fontWeight: weight.light,
	    letterSpacing: '1px',
	    color: _Colors2.default.black
	  }
	};
	
	exports.default = { style: style, type: type, size: size, weight: weight };

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Colors = __webpack_require__(242);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var breakpoints = {
	  mobile: '768px',
	  tablet: '992px',
	  giant: '1200px'
	};
	
	var grid = {
	  tablet: '720px',
	  desktop: '960px',
	  mobile: '332px', // in case of mobile it takes 20px as padding,
	  giant: '1140px'
	};
	
	var borders = {
	  default: '1px solid ' + _Colors2.default.lightGrey,
	  defaultOrange: '1px solid ' + _Colors2.default.primary,
	  defaultRadius: '4px',
	  headerBorder: 'solid 1px ' + _Colors2.default.lightGrey,
	  inputBorder: 'solid 1px ' + _Colors2.default.lightGrey,
	  orangeBorder: 'solid 1px ' + _Colors2.default.primary,
	  boldBoder: 'solid 3px ' + _Colors2.default.lightGrey,
	  defaultBorder: 'solid 2px ' + _Colors2.default.lightGrey,
	  searchbar: 'solid 1px #e6e6e6'
	};
	
	var components = {
	  sidebar: '200px',
	  navbarDefault: '64px',
	  profilePhoto: '142px',
	  landingFooter: '64px',
	  searchbar: '60px',
	  adminNavbar: '60',
	  adminScreensMinWidth: '1024px',
	  cardContainerSpacing: '25px',
	  adminAvatarSize: 38,
	  inputFormHeight: '30px',
	  customThemeSpacing: '32px',
	  navbarMobileLogoMargins: '94px',
	  themeMobileMargins: '20px',
	  adminContent: 'calc(100vh - 60px)',
	  adminListRow: '150px',
	  adminLogoSize: '130px',
	  landingLogoSize: '170px',
	  mobileSearchBarSize: '80px',
	  listSize: '180px',
	  mobileMenu: '225px',
	  modalHeight: '470px',
	  modalWidth: '515px',
	  modalContainer: '400px'
	};
	
	var shadows = {
	  default: '0 1px 5px rgba(0, 0, 0, 0.1)',
	  defaultShadow: '0 4px 8px 0 rgba(81, 96, 115, 0.18)',
	  cardShadow: '0 4px 5px 0 rgba(81, 96, 115, 0.12);',
	  cardContainerShadow: '0 2px 4px 0 #b6b6b6',
	  adminNavbarShadow: '0 1px 3px 0 #b6b6b6',
	  rowShadow: '0 2px 4px 0 rgba(44, 48, 48, 0.2)'
	};
	
	var overlay = {
	  width: '100%',
	  height: '100%',
	  position: 'absolute',
	  backdropFilter: 'blur(2px)',
	  backgroundColor: _Colors2.default.overlay
	};
	
	var margins = {
	  base: '20px',
	  tiny: '5px',
	  small: '10px',
	  medium: '15px',
	  large: '25px',
	  largeLarger: '27px',
	  larger: '30px',
	  big: '50px'
	};
	
	exports.default = {
	  borders: borders,
	  shadows: shadows,
	  overlay: overlay,
	  margins: margins,
	  components: components,
	  breakpoints: breakpoints,
	  grid: grid
	};

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18next = __webpack_require__(674);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _i18nextXhrBackend = __webpack_require__(663);
	
	var _i18nextXhrBackend2 = _interopRequireDefault(_i18nextXhrBackend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Cache from 'i18next-localstorage-cache'
	
	_i18next2.default.use(_i18nextXhrBackend2.default)
	// .use(Cache)
	// .use(LanguageDetector)
	.init({
	  fallbackLng: 'en-GB',
	
	  // have a common namespace used around the full app
	  ns: ['common'],
	  defaultNS: 'common',
	  debug: ("production") === 'development',
	
	  // cache: {
	  //   enabled: true
	  // },
	
	  interpolation: {
	    escapeValue: false, // not needed for react!!
	    formatSeparator: ',',
	    format: function format(value, _format, lng) {
	      if (_format === 'uppercase') return value.toUpperCase();
	      return value;
	    }
	  }
	});
	
	exports.default = _i18next2.default;

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  height: 40px;\n  width: 40px;\n  bottom: 0;\n  left: ', 'px;\n  backgroundColor: ', ';\n  outline: none;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n\n  &:hover {\n    backgroundColor: ', ';\n  }\n\n  svg {\n    margin-left: 10px;\n    margin-top: 10px;\n    height: 20px;\n    width: 20px;\n\n    g {\n      fill-rule: nonzero;\n      path:nth-child(3) {\n        fill: white;\n      }\n    }\n  }\n\n  @media screen and (max-width: ', ') {\n    display: none;\n  }\n'], ['\n  position: absolute;\n  height: 40px;\n  width: 40px;\n  bottom: 0;\n  left: ', 'px;\n  backgroundColor: ', ';\n  outline: none;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n\n  &:hover {\n    backgroundColor: ', ';\n  }\n\n  svg {\n    margin-left: 10px;\n    margin-top: 10px;\n    height: 20px;\n    width: 20px;\n\n    g {\n      fill-rule: nonzero;\n      path:nth-child(3) {\n        fill: white;\n      }\n    }\n  }\n\n  @media screen and (max-width: ', ') {\n    display: none;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	var _Edit = __webpack_require__(175);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var IconWrapper = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.pictureSize - 40;
	}, _Themes.Colors.lightGrey, _Themes.Colors.darkGrey, _Themes.Metrics.breakpoints.tablet);
	
	var propTypes = {
	  onClick: _react.PropTypes.func
	};
	
	var EditPictureButton = function (_Component) {
	  _inherits(EditPictureButton, _Component);
	
	  function EditPictureButton() {
	    _classCallCheck(this, EditPictureButton);
	
	    return _possibleConstructorReturn(this, (EditPictureButton.__proto__ || Object.getPrototypeOf(EditPictureButton)).apply(this, arguments));
	  }
	
	  _createClass(EditPictureButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        IconWrapper,
	        Object.assign({ onClick: this.props.onClick }, this.props),
	        _react2.default.createElement(_Edit2.default, null)
	      );
	    }
	  }]);
	
	  return EditPictureButton;
	}(_react.Component);
	
	EditPictureButton.propTypes = propTypes;
	
	exports.default = EditPictureButton;

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  .calendarTitle {\n    margin-bottom: ', ';\n    ', ';\n    color: ', ';\n  }\n'], ['\n  position: relative;\n  .calendarTitle {\n    margin-bottom: ', ';\n    ', ';\n    color: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  border: ', '\n  border-radius: ', ';\n  padding: 8px;\n  min-height: 30px;\n  cursor: pointer;\n'], ['\n  border: ', '\n  border-radius: ', ';\n  padding: 8px;\n  min-height: 30px;\n  cursor: pointer;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n'], ['\n  ', ';\n  color: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  outline: none;\n  ', ';\n'], ['\n  outline: none;\n  ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  ', ';\n  color: ', ';\n'], ['\n  margin-top: ', ';\n  ', ';\n  color: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  position: absolute;\n  .react-date-picker__calendar--theme-default{\n    background: ', ';\n    border: ', ';\n    box-shadow: ', ';\n    border-radius: ', ';\n    ', ';\n    margin-top: ', ';\n    padding: ', ';\n\n    .react-date-picker__nav-bar-date  {\n      ', ';\n      color: ', '\n      pointer-events: none;\n    }\n\n    .react-date-picker__nav-bar-secondary-arrow {\n      display: none !important;\n    }\n\n    .react-date-picker__nav-bar-arrow {\n      margin-right: ', ';\n      margin-left: ', ';\n    }\n\n    .react-date-picker__month-view-day--weekend-highlight, .react-date-picker__month-view-day--today-highlight {\n      ', ';\n      color: ', '\n    }\n\n    .react-date-picker__month-view-day-text{\n      &:hover{\n        background: ', ' !important;\n        color: ', ';\n      }\n    }\n    .react-date-picker__month-view-day--next-month, .react-date-picker__month-view-day--prev-month{\n      ', ';\n      color: ', ';\n    }\n  }\n'], ['\n  position: absolute;\n  .react-date-picker__calendar--theme-default{\n    background: ', ';\n    border: ', ';\n    box-shadow: ', ';\n    border-radius: ', ';\n    ', ';\n    margin-top: ', ';\n    padding: ', ';\n\n    .react-date-picker__nav-bar-date  {\n      ', ';\n      color: ', '\n      pointer-events: none;\n    }\n\n    .react-date-picker__nav-bar-secondary-arrow {\n      display: none !important;\n    }\n\n    .react-date-picker__nav-bar-arrow {\n      margin-right: ', ';\n      margin-left: ', ';\n    }\n\n    .react-date-picker__month-view-day--weekend-highlight, .react-date-picker__month-view-day--today-highlight {\n      ', ';\n      color: ', '\n    }\n\n    .react-date-picker__month-view-day-text{\n      &:hover{\n        background: ', ' !important;\n        color: ', ';\n      }\n    }\n    .react-date-picker__month-view-day--next-month, .react-date-picker__month-view-day--prev-month{\n      ', ';\n      color: ', ';\n    }\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n'], ['\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDatePicker = __webpack_require__(913);
	
	__webpack_require__(646);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CalendarContainer = _styledComponents2.default.div(_templateObject, _Themes.Metrics.margins.small, _Themes.Fonts.style.Label, _Themes.Colors.black);
	
	var PlaceholderContainer = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.borders.default, _Themes.Metrics.borders.defaultRadius);
	
	var Date = _styledComponents2.default.div(_templateObject3, _Themes.Fonts.style.Input, _Themes.Colors.black);
	
	var Placeholder = _styledComponents2.default.div(_templateObject4, _Themes.Fonts.style.Input);
	
	var Error = _styledComponents2.default.div(_templateObject5, _Themes.Metrics.margins.tiny, _Themes.Fonts.style.Input, _Themes.Colors.red);
	
	var DatePickerContainer = _styledComponents2.default.div(_templateObject6, _Themes.Colors.white, _Themes.Metrics.borders.default, _Themes.Metrics.shadows.defaultShadow, _Themes.Metrics.borders.defaultRadius, _Themes.Fonts.style.Input, _Themes.Metrics.margins.small, _Themes.Metrics.margins.small, _Themes.Fonts.style.Input, _Themes.Colors.black, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base, _Themes.Fonts.style.Input, _Themes.Colors.black, _Themes.Colors.primary, _Themes.Colors.white, _Themes.Fonts.style.Input, _Themes.Colors.lightGrey);
	
	var Title = _styledComponents2.default.div(_templateObject7, _Themes.Metrics.margins.small, _Themes.Fonts.style.Label, _Themes.Colors.black);
	
	var Calendar = function (_Component) {
	  _inherits(Calendar, _Component);
	
	  function Calendar(props) {
	    _classCallCheck(this, Calendar);
	
	    var _this = _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props));
	
	    _this.state = {
	      open: false
	    };
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.toggleDatePicker = _this.toggleDatePicker.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(Calendar, [{
	    key: 'handleSelect',
	    value: function handleSelect(value) {
	      var _this2 = this;
	
	      this.setState({ open: false }, function () {
	        return _this2.props.handleSelect(value);
	      });
	    }
	  }, {
	    key: 'toggleDatePicker',
	    value: function toggleDatePicker(event) {
	      this.setState({ open: !this.state.open });
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur() {
	      var _this3 = this;
	
	      setTimeout(function () {
	        if (_this3.props.handleBlur) {
	          _this3.props.handleBlur();
	        }
	        _this3.setState({
	          open: false
	        });
	      }, 250);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props;
	      var title = _props.title;
	      var value = _props.value;
	      var error = _props.error;
	
	      return _react2.default.createElement(
	        CalendarContainer,
	        Object.assign({}, this.props, {
	          tabIndex: '-1',
	          onBlur: this.handleBlur }),
	        _react2.default.createElement(
	          Title,
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          PlaceholderContainer,
	          { onClick: this.toggleDatePicker },
	          _react2.default.createElement(
	            Placeholder,
	            null,
	            value ? _react2.default.createElement(
	              Date,
	              null,
	              value
	            ) : 'Select a Date'
	          )
	        ),
	        this.state.open && _react2.default.createElement(
	          DatePickerContainer,
	          null,
	          _react2.default.createElement(_reactDatePicker.DatePicker, {
	            navigation: true,
	            locale: 'en',
	            forceValidDate: true,
	            highlightWeekends: false,
	            highlightToday: false,
	            weekNumbers: false,
	            weekStartDay: 0,
	            footer: false,
	            weekDayNames: false,
	            style: _Themes.Fonts.style.Text,
	            dateFormat: 'DD/MM/YYYY',
	            onChange: function onChange(dateString, _ref) {
	              var dateMoment = _ref.dateMoment;
	              var timestamp = _ref.timestamp;
	              return _this4.handleSelect(dateString);
	            }
	          })
	        ),
	        error && _react2.default.createElement(
	          Error,
	          { className: 'error' },
	          error
	        )
	      );
	    }
	  }]);
	
	  return Calendar;
	}(_react.Component);
	
	Calendar.propTypes = {
	  title: _react.PropTypes.string,
	  handleSelect: _react.PropTypes.func,
	  handleBlur: _react.PropTypes.func,
	  value: _react.PropTypes.string,
	  error: _react.PropTypes.string
	};
	
	exports.default = Calendar;

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  border: ', ';\n  width: 100%;\n  min-height: 315px;\n  position: relative;\n  overflow: hidden;\n  background: ', ';\n'], ['\n  border: ', ';\n  width: 100%;\n  min-height: 315px;\n  position: relative;\n  overflow: hidden;\n  background: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 190px;\n  overflow: hidden;\n  background: url(', ') no-repeat center;\n  background-size: cover;\n  position: relative;\n'], ['\n  width: 100%;\n  height: 190px;\n  overflow: hidden;\n  background: url(', ') no-repeat center;\n  background-size: cover;\n  position: relative;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  overflow-y: scroll;\n  margin-top: ', ';\n  ', ';\n'], ['\n  overflow-y: scroll;\n  margin-top: ', ';\n  ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  height: 50px;\n  right: 10px;\n  top: 5px;\n  width: 80px;\n  cursor: pointer;\n  z-index: 1;\n'], ['\n  position: absolute;\n  height: 50px;\n  right: 10px;\n  top: 5px;\n  width: 80px;\n  cursor: pointer;\n  z-index: 1;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.3);\n  height: 100%;\n  width: 100%;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.3);\n  height: 100%;\n  width: 100%;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Card = _styledComponents2.default.div(_templateObject, _Themes.Metrics.borders.default, _Themes.Colors.white);
	
	var ImageContainer = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.src;
	});
	
	var Content = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.base, _Themes.Fonts.style.Text);
	
	var Icon = _styledComponents2.default.div(_templateObject4);
	
	var Layer = _styledComponents2.default.div(_templateObject5);
	
	var CardWithImage = function CardWithImage(props) {
	  var imgSrc = props.imgSrc;
	  var children = props.children;
	  var icon = props.icon;
	
	
	  return _react2.default.createElement(
	    Card,
	    props,
	    _react2.default.createElement(
	      ImageContainer,
	      { src: imgSrc },
	      icon && _react2.default.createElement(
	        Icon,
	        null,
	        icon
	      ),
	      _react2.default.createElement(Layer, null)
	    ),
	    _react2.default.createElement(
	      Content,
	      null,
	      children
	    )
	  );
	};
	
	CardWithImage.propTypes = {
	  children: _react.PropTypes.node,
	  imgSrc: _react.PropTypes.string.isRequired,
	  icon: _react.PropTypes.node
	};
	
	exports.default = CardWithImage;

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['margin: ', ' 0;'], ['margin: ', ' 0;']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  max-width: ', ';\n  height: auto;\n  border: ', ';\n  border-radius: ', ';\n  cursor: pointer;\n  background: ', ';\n  position: relative;\n  outline: none;\n\n  .placeholder {\n    ', ';\n    padding: ', ' 0;\n    width: 100%;\n  }\n\n  .top-container {\n    margin-right: ', ';\n    margin-left: ', ';\n    text-align: left;\n  }\n\n  .list {\n    height: inherit;\n    margin: 0 ', ' ', '\n      ', ';\n  }\n\n  @media screen and (max-width: 768px) {\n    width: 100%;\n\n    .placeholder {\n      margin-right: ', ';\n    }\n  }\n'], ['\n  max-width: ', ';\n  height: auto;\n  border: ', ';\n  border-radius: ', ';\n  cursor: pointer;\n  background: ', ';\n  position: relative;\n  outline: none;\n\n  .placeholder {\n    ', ';\n    padding: ', ' 0;\n    width: 100%;\n  }\n\n  .top-container {\n    margin-right: ', ';\n    margin-left: ', ';\n    text-align: left;\n  }\n\n  .list {\n    height: inherit;\n    margin: 0 ', ' ', '\n      ', ';\n  }\n\n  @media screen and (max-width: 768px) {\n    width: 100%;\n\n    .placeholder {\n      margin-right: ', ';\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  height: auto;\n  margin-bottom: ', ';\n  text-align: left;\n'], ['\n  margin-top: ', ';\n  height: auto;\n  margin-bottom: ', ';\n  text-align: left;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 3px;\n  right: ', ';\n  transform: ', ';\n'], ['\n  position: absolute;\n  top: 3px;\n  right: ', ';\n  transform: ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteral(['padding-left: 0;'], ['padding-left: 0;']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  transform: scale(0.7);\n  margin-right: ', ';\n'], ['\n  transform: scale(0.7);\n  margin-right: ', ';\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  svg {\n    float: right;\n  }\n'], ['\n  svg {\n    float: right;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['vertical-align: -2px;'], ['vertical-align: -2px;']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Themes = __webpack_require__(5);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _List = __webpack_require__(124);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Arrow = __webpack_require__(101);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	var _ListItem = __webpack_require__(125);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Tag = __webpack_require__(127);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _CloseIcon = __webpack_require__(65);
	
	var _CloseIcon2 = _interopRequireDefault(_CloseIcon);
	
	var _Checkbox = __webpack_require__(171);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Header = _styledComponents2.default.div(_templateObject, _Themes.Metrics.margins.small);
	
	var DropdownContainer = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.width ? props.width : '265px';
	}, _Themes.Metrics.borders.default, _Themes.Metrics.borders.defaultRadius, _Themes.Colors.white, _Themes.Fonts.style.Text, _Themes.Metrics.margins.small, _Themes.Metrics.margins.small, _Themes.Metrics.margins.small, _Themes.Metrics.margins.small, _Themes.Metrics.margins.small, _Themes.Metrics.margins.small, _Themes.Metrics.margins.small);
	var Tags = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.tiny, _Themes.Metrics.margins.small);
	
	var ArrowIcon = _styledComponents2.default.div(_templateObject4, _Themes.Metrics.margins.small, function (props) {
	  return props.visible ? 'rotate(0deg)' : 'rotate(180deg)';
	});
	
	var CustomListItem = (0, _styledComponents2.default)(_ListItem2.default)(_templateObject5);
	
	var CustomCheckbox = (0, _styledComponents2.default)(_Checkbox2.default)(_templateObject6, _Themes.Metrics.margins.medium);
	
	var ItemContainer = _styledComponents2.default.div(_templateObject7);
	
	var Item = _styledComponents2.default.span(_templateObject8);
	
	var CheckboxDropdown = function (_Component) {
	  _inherits(CheckboxDropdown, _Component);
	
	  function CheckboxDropdown(props) {
	    _classCallCheck(this, CheckboxDropdown);
	
	    var _this = _possibleConstructorReturn(this, (CheckboxDropdown.__proto__ || Object.getPrototypeOf(CheckboxDropdown)).call(this, props));
	
	    _this.state = {
	      open: false,
	      selectAllChecked: false,
	      itemsChecked: {}
	    };
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleSelectAllClick = _this.handleSelectAllClick.bind(_this);
	    _this.handleItemClick = _this.handleItemClick.bind(_this);
	    _this.handleTagClose = _this.handleTagClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(CheckboxDropdown, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var options = this.props.options;
	
	
	      if (options.length === 0 && nextProps.options.length > 0) {
	        this.setState({
	          itemsChecked: nextProps.options.reduce(function (itemsChecked, option) {
	            itemsChecked[option.id] = false;
	            return itemsChecked;
	          }, this.state.itemsChecked)
	        });
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      this.setState({ open: !this.state.open });
	    }
	  }, {
	    key: 'handleSelectAllClick',
	    value: function handleSelectAllClick(_ref) {
	      var options = _ref.options;
	      var handleSelectAll = _ref.handleSelectAll;
	
	      var check = !this.state.selectAllChecked;
	
	      var itemsChecked = options.reduce(function (items, item) {
	        items[item.id] = check;
	        return items;
	      }, this.state.itemsChecked);
	
	      var selectedOptions = check ? options : [];
	
	      this.setState({ selectAllChecked: check, itemsChecked: itemsChecked }, function () {
	        return handleSelectAll(selectedOptions);
	      });
	    }
	  }, {
	    key: 'handleItemClick',
	    value: function handleItemClick(_ref2) {
	      var item = _ref2.item;
	      var handleSelect = _ref2.handleSelect;
	      var itemsChecked = this.state.itemsChecked;
	
	      var check = !itemsChecked[item.id];
	
	      this.setState({
	        selectAllChecked: false,
	        itemsChecked: Object.assign({}, itemsChecked, _defineProperty({}, item.id, check))
	      }, function () {
	        return handleSelect(item);
	      });
	    }
	  }, {
	    key: 'handleTagClose',
	    value: function handleTagClose(_ref3) {
	      var tag = _ref3.tag;
	      var handleSelect = _ref3.handleSelect;
	      var itemsChecked = this.state.itemsChecked;
	
	
	      this.setState({
	        selectAllChecked: false,
	        itemsChecked: Object.assign({}, itemsChecked, _defineProperty({}, tag.id, false))
	      }, function () {
	        return handleSelect(tag);
	      });
	    }
	  }, {
	    key: 'renderOptions',
	    value: function renderOptions(_ref4) {
	      var _this2 = this;
	
	      var options = _ref4.options;
	      var showCheckBox = _ref4.showCheckBox;
	      var handleSelect = _ref4.handleSelect;
	      var itemsChecked = this.state.itemsChecked;
	
	
	      return options.map(function (item, index) {
	        return _react2.default.createElement(
	          CustomListItem,
	          {
	            odd: index % 2 === 0,
	            key: index,
	            onClick: function onClick() {
	              return _this2.handleItemClick({ item: item, handleSelect: handleSelect });
	            } },
	          showCheckBox ? _react2.default.createElement(
	            ItemContainer,
	            null,
	            _react2.default.createElement(CustomCheckbox, {
	              checked: itemsChecked[item.id],
	              id: 'interestsCheckBoxId-' + index,
	              className: 'checkbox'
	            }),
	            _react2.default.createElement(
	              Item,
	              null,
	              item.name
	            )
	          ) : _react2.default.createElement(
	            ItemContainer,
	            null,
	            _react2.default.createElement(
	              Item,
	              null,
	              item.name
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'renderTags',
	    value: function renderTags(_ref5) {
	      var _this3 = this;
	
	      var selectedOptions = _ref5.selectedOptions;
	      var handleSelect = _ref5.handleSelect;
	
	      return selectedOptions.map(function (el, index) {
	        return _react2.default.createElement(_Tag2.default, {
	          key: 'Tag-' + el.name + '-index',
	          text: el.name,
	          icon: _react2.default.createElement(_CloseIcon2.default, {
	            onClick: function onClick() {
	              return _this3.handleTagClose({ tag: el, handleSelect: handleSelect });
	            }
	          })
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state;
	      var open = _state.open;
	      var selectAllChecked = _state.selectAllChecked;
	      var _props = this.props;
	      var showSelectAll = _props.showSelectAll;
	      var showCheckBox = _props.showCheckBox;
	      var placeholder = _props.placeholder;
	      var options = _props.options;
	      var handleSelect = _props.handleSelect;
	      var handleSelectAll = _props.handleSelectAll;
	      var selectedOptions = _props.selectedOptions;
	      var showTags = _props.showTags;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          DropdownContainer,
	          Object.assign({}, this.props, {
	            tabIndex: '-1',
	            onBlur: open && this.handleClick }),
	          _react2.default.createElement(
	            'div',
	            { className: 'top-container', onClick: this.handleClick },
	            _react2.default.createElement(
	              ArrowIcon,
	              { visible: this.state.open },
	              _react2.default.createElement(_Arrow2.default, null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'placeholder' },
	              placeholder
	            )
	          ),
	          _react2.default.createElement(
	            _List2.default,
	            { className: 'list', hide: !this.state.open },
	            showSelectAll ? _react2.default.createElement(
	              Header,
	              {
	                onClick: function onClick() {
	                  return _this4.handleSelectAllClick({ options: options, handleSelectAll: handleSelectAll });
	                } },
	              _react2.default.createElement(CustomCheckbox, {
	                id: 'interestsCheckBoxId',
	                className: 'checkbox',
	                checked: selectAllChecked
	              }),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Select All'
	              )
	            ) : null,
	            this.renderOptions({ options: options, showCheckBox: showCheckBox, handleSelect: handleSelect })
	          )
	        ),
	        _react2.default.createElement(
	          Tags,
	          null,
	          showTags ? this.renderTags({ selectedOptions: selectedOptions, handleSelect: handleSelect }) : null
	        )
	      );
	    }
	  }]);
	
	  return CheckboxDropdown;
	}(_react.Component);
	
	CheckboxDropdown.propTypes = {
	  showSelectAll: _react.PropTypes.any,
	  options: _react.PropTypes.array.isRequired,
	  selectedOptions: _react.PropTypes.array,
	  placeholder: _react.PropTypes.string.isRequired,
	  handleSelect: _react.PropTypes.func,
	  handleSelectAll: _react.PropTypes.func,
	  showTags: _react.PropTypes.bool
	};
	
	CheckboxDropdown.defaultProps = {
	  showSelectAll: false,
	  showCheckBox: false
	};
	
	exports.default = CheckboxDropdown;

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mapIcon = __webpack_require__(1127);
	
	var _mapIcon2 = _interopRequireDefault(_mapIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStyle = [{
	  elementType: 'geometry',
	  stylers: [{
	    color: '#212121'
	  }]
	}, {
	  elementType: 'labels.icon',
	  stylers: [{
	    visibility: 'off'
	  }]
	}, {
	  elementType: 'labels.text.fill',
	  stylers: [{
	    color: '#757575'
	  }]
	}, {
	  elementType: 'labels.text.stroke',
	  stylers: [{
	    color: '#212121'
	  }]
	}, {
	  featureType: 'administrative',
	  elementType: 'geometry',
	  stylers: [{
	    color: '#757575'
	  }]
	}, {
	  featureType: 'administrative.country',
	  elementType: 'labels.text.fill',
	  stylers: [{
	    color: '#9e9e9e'
	  }]
	}, {
	  featureType: 'administrative.land_parcel',
	  stylers: [{
	    visibility: 'off'
	  }]
	}, {
	  featureType: 'administrative.land_parcel',
	  elementType: 'labels',
	  stylers: [{
	    visibility: 'off'
	  }]
	}, {
	  featureType: 'administrative.locality',
	  elementType: 'labels.text.fill',
	  stylers: [{
	    color: '#bdbdbd'
	  }]
	}, {
	  featureType: 'poi',
	  elementType: 'labels.text',
	  stylers: [{
	    visibility: 'off'
	  }]
	}, {
	  featureType: 'poi',
	  elementType: 'labels.text.fill',
	  stylers: [{
	    color: '#757575'
	  }]
	}, {
	  featureType: 'poi.park',
	  elementType: 'geometry',
	  stylers: [{
	    color: '#181818'
	  }]
	}, {
	  featureType: 'poi.park',
	  elementType: 'labels.text.fill',
	  stylers: [{
	    color: '#616161'
	  }]
	}, {
	  featureType: 'poi.park',
	  elementType: 'labels.text.stroke',
	  stylers: [{
	    color: '#1b1b1b'
	  }]
	}, {
	  featureType: 'road',
	  elementType: 'geometry.fill',
	  stylers: [{
	    color: '#2c2c2c'
	  }]
	}, {
	  featureType: 'road',
	  elementType: 'labels.text.fill',
	  stylers: [{
	    color: '#8a8a8a'
	  }]
	}, {
	  featureType: 'road.arterial',
	  elementType: 'geometry',
	  stylers: [{
	    color: '#373737'
	  }]
	}, {
	  featureType: 'road.highway',
	  elementType: 'geometry',
	  stylers: [{
	    color: '#3c3c3c'
	  }]
	}, {
	  featureType: 'road.highway.controlled_access',
	  elementType: 'geometry',
	  stylers: [{
	    color: '#4e4e4e'
	  }]
	}, {
	  featureType: 'road.local',
	  elementType: 'labels',
	  stylers: [{
	    visibility: 'off'
	  }]
	}, {
	  featureType: 'road.local',
	  elementType: 'labels.text.fill',
	  stylers: [{
	    color: '#616161'
	  }]
	}, {
	  featureType: 'transit',
	  elementType: 'labels.text.fill',
	  stylers: [{
	    color: '#757575'
	  }]
	}, {
	  featureType: 'water',
	  elementType: 'geometry',
	  stylers: [{
	    color: '#000000'
	  }]
	}, {
	  featureType: 'water',
	  elementType: 'geometry.fill',
	  stylers: [{
	    color: '#d6e5ec'
	  }]
	}, {
	  featureType: 'water',
	  elementType: 'labels.text.fill',
	  stylers: [{
	    color: '#3d3d3d'
	  }]
	}]; /* globals google */
	/* globals MarkerClusterer */
	
	
	var iconStyle = [{
	  height: 56,
	  url: _mapIcon2.default,
	  width: 56
	}];
	
	var defaultMapOptions = {
	  maxZoom: 15,
	  minZoom: 2,
	  styles: mapStyle
	};
	
	var createMap = function createMap(settings, ref) {
	  var mapOptions = Object.assign({}, defaultMapOptions, settings);
	  return new google.maps.Map(ref, mapOptions);
	};
	
	var createMarkers = function createMarkers(map, list, handleSelect) {
	  return list.map(function (el, index) {
	    var location = new google.maps.LatLng(parseFloat(el.latlng.latitude), parseFloat(el.latlng.longitude));
	    var marker = new google.maps.Marker({
	      position: location,
	      icon: {
	        path: google.maps.SymbolPath.CIRCLE,
	        fillOpacity: 0.5,
	        fillColor: '#C78C2F',
	        strokeOpacity: 1.0,
	        strokeColor: '#C78C2F',
	        strokeWeight: 2.0,
	        scale: 50
	      },
	      map: map
	    });
	    if (handleSelect) {
	      google.maps.event.addListener(marker, 'click', function () {
	        handleSelect(el.id);
	      });
	    }
	    return marker;
	  });
	};
	
	var createMarkerCluster = function createMarkerCluster(_ref) {
	  var map = _ref.map;
	  var markers = _ref.markers;
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { styles: iconStyle, minimumClusterSize: 1, maxZoom: 10 };
	
	  var markerCluster = new MarkerClusterer(map, markers, options);
	  return markerCluster;
	};
	
	exports.default = { mapStyle: mapStyle, createMap: createMap, createMarkers: createMarkers, createMarkerCluster: createMarkerCluster };

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  transition: ease-out all 0.5s;\n  background-color: white;\n  position: absolute;\n  height: 40px;\n  width: calc(100vw - 30px);\n  border: ', ';\n  box-shadow: 0 1px 3px 0px rgba(0, 0, 0, 0.08) !important;\n  border-radius: 4px;\n  z-index: 2;\n  left: 15px;\n  top: 80px;\n\n  &.open {\n    transition: ease-in all 0.3s;\n    box-shadow: none;\n    height: 100vh;\n    width: 100vw;\n    overflow: none;\n    left: 0;\n    top: 0;\n  }\n'], ['\n  transition: ease-out all 0.5s;\n  background-color: white;\n  position: absolute;\n  height: 40px;\n  width: calc(100vw - 30px);\n  border: ', ';\n  box-shadow: 0 1px 3px 0px rgba(0, 0, 0, 0.08) !important;\n  border-radius: 4px;\n  z-index: 2;\n  left: 15px;\n  top: 80px;\n\n  &.open {\n    transition: ease-in all 0.3s;\n    box-shadow: none;\n    height: 100vh;\n    width: 100vw;\n    overflow: none;\n    left: 0;\n    top: 0;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  height: 40px;\n  position: relative;\n  svg {\n    position: absolute;\n    right: 5%;\n  }\n'], ['\n  height: 40px;\n  position: relative;\n  svg {\n    position: absolute;\n    right: 5%;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  text-align: center;\n  padding: ', ';\n  margin-top: ', ';\n  position: absolute;\n  bottom: ', ';\n  width: 100%;\n\n  button {\n    background: ', ';\n    color: ', ';\n    float: inherit;\n    width: 100%;\n  }\n'], ['\n  text-align: center;\n  padding: ', ';\n  margin-top: ', ';\n  position: absolute;\n  bottom: ', ';\n  width: 100%;\n\n  button {\n    background: ', ';\n    color: ', ';\n    float: inherit;\n    width: 100%;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  display: none;\n\n  @media screen and (max-width: ', ') {\n    height: 60px;\n    display: block;\n  }\n'], ['\n  display: none;\n\n  @media screen and (max-width: ', ') {\n    height: 60px;\n    display: block;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  margin: 12px ', ';\n  span {\n    float: left;\n    ', ';\n    color: ', ';\n    font-size: ', ';\n  }\n  svg {\n    float: right;\n    margin-top: -3px;\n    fill: ', ';\n  }\n  transition: ease-in all 0.3s;\n  opacity: 1;\n\n  &.open {\n    transition: ease-in all 0.1s;\n    opacity: 0;\n  }\n'], ['\n  margin: 12px ', ';\n  span {\n    float: left;\n    ', ';\n    color: ', ';\n    font-size: ', ';\n  }\n  svg {\n    float: right;\n    margin-top: -3px;\n    fill: ', ';\n  }\n  transition: ease-in all 0.3s;\n  opacity: 1;\n\n  &.open {\n    transition: ease-in all 0.1s;\n    opacity: 0;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  pointer-events: none;\n  opacity: 0;\n  height: calc(100% - ', ');\n  overflow: none;\n  &.open {\n    pointer-events: all;\n    opacity: 1;\n    transition: ease-in all 0.2s;\n    transition-delay: 0.3s;\n  }\n'], ['\n  pointer-events: none;\n  opacity: 0;\n  height: calc(100% - ', ');\n  overflow: none;\n  &.open {\n    pointer-events: all;\n    opacity: 1;\n    transition: ease-in all 0.2s;\n    transition-delay: 0.3s;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  max-height: calc(100% - 100px);\n  overflow-y: scroll;\n'], ['\n  max-height: calc(100% - 100px);\n  overflow-y: scroll;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Themes = __webpack_require__(5);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _CloseIcon = __webpack_require__(65);
	
	var _CloseIcon2 = _interopRequireDefault(_CloseIcon);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject, _Themes.Metrics.borders.default);
	
	var Close = _styledComponents2.default.div(_templateObject2);
	
	var Apply = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.small, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base, _Themes.Colors.primary, _Themes.Colors.white);
	
	var MenuWrapper = _styledComponents2.default.div(_templateObject4, _Themes.Metrics.breakpoints.mobile);
	
	var MenuButton = _styledComponents2.default.div(_templateObject5, _Themes.Metrics.margins.small, _Themes.Fonts.style.Text, _Themes.Colors.darkgrey, _Themes.Fonts.size.medium, _Themes.Colors.primary);
	
	var MenuBody = _styledComponents2.default.div(_templateObject6, _Themes.Metrics.margins.base);
	
	var Children = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject7);
	
	var MobileMenu = function (_Component) {
	  _inherits(MobileMenu, _Component);
	
	  function MobileMenu() {
	    _classCallCheck(this, MobileMenu);
	
	    return _possibleConstructorReturn(this, (MobileMenu.__proto__ || Object.getPrototypeOf(MobileMenu)).apply(this, arguments));
	  }
	
	  _createClass(MobileMenu, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var open = _props.open;
	      var toggleMenu = _props.toggleMenu;
	      var apply = _props.apply;
	      var label = _props.label;
	      var icon = _props.icon;
	
	      return _react2.default.createElement(
	        MenuWrapper,
	        { className: open && 'open' },
	        _react2.default.createElement(
	          Container,
	          { className: open && 'open' },
	          _react2.default.createElement(
	            MenuButton,
	            { onClick: toggleMenu, className: open && 'open' },
	            _react2.default.createElement(
	              'span',
	              null,
	              label
	            ),
	            icon
	          ),
	          _react2.default.createElement(
	            MenuBody,
	            { className: open && 'open' },
	            _react2.default.createElement(
	              Close,
	              null,
	              _react2.default.createElement(_CloseIcon2.default, { onClick: toggleMenu })
	            ),
	            _react2.default.createElement(
	              Children,
	              null,
	              children
	            ),
	            _react2.default.createElement(
	              Apply,
	              null,
	              apply
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MobileMenu;
	}(_react.Component);
	
	MobileMenu.propTypes = {
	  label: _react.PropTypes.string,
	  children: _react.PropTypes.node,
	  apply: _react.PropTypes.node,
	  toggleMenu: _react.PropTypes.func,
	  open: _react.PropTypes.bool,
	  icon: _react.PropTypes.node
	};
	
	exports.default = MobileMenu;

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: ', ';\n  background-color: ', ';\n  border-bottom: ', ';\n  box-shadow: ', ';\n  display: inline-block;\n  position: relative;\n'], ['\n  width: 100%;\n  height: ', ';\n  background-color: ', ';\n  border-bottom: ', ';\n  box-shadow: ', ';\n  display: inline-block;\n  position: relative;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: ', ';\n  height: ', ';\n  padding-right: ', ';\n  ', ';\n  float: ', ';\n  @media screen and (max-width: ', ') {\n    display: ', ';\n  }\n'], ['\n  display: ', ';\n  height: ', ';\n  padding-right: ', ';\n  ', ';\n  float: ', ';\n  @media screen and (max-width: ', ') {\n    display: ', ';\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  display: table;\n  height: ', ';\n  margin-right: ', ';\n  margin-left: ', ';\n'], ['\n  display: table;\n  height: ', ';\n  margin-right: ', ';\n  margin-left: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  display: table-cell;\n  vertical-align: middle;\n  cursor: pointer;\n'], ['\n  display: table-cell;\n  vertical-align: middle;\n  cursor: pointer;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  position: relative;\n  display: none;\n\n  @media screen and (max-width: ', ') {\n    display: block;\n  }\n'], ['\n  position: relative;\n  display: none;\n\n  @media screen and (max-width: ', ') {\n    display: block;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: -100vw;\n  background: ', ';\n  width: ', ';\n  height: 100vh;\n  transition: ease left 0.5s;\n  z-index: 6;\n\n  @media screen and (max-width: ', ') {\n    &.active {\n      transition: ease left 0.5s;\n      left: 0vw;\n    }\n  }\n'], ['\n  position: absolute;\n  top: 0;\n  left: -100vw;\n  background: ', ';\n  width: ', ';\n  height: 100vh;\n  transition: ease left 0.5s;\n  z-index: 6;\n\n  @media screen and (max-width: ', ') {\n    &.active {\n      transition: ease left 0.5s;\n      left: 0vw;\n    }\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  display: block;\n  margin-top: ', ';\n  margin-right: ', ';\n  text-align: right;\n'], ['\n  display: block;\n  margin-top: ', ';\n  margin-right: ', ';\n  text-align: right;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  position: absolute;\n  width: 100vw;\n  height: 100vh;\n  display: none;\n  z-index: 6;\n  transition: ease opacity 0.5s;\n\n  @media screen and (max-width: ', ') {\n    &.active {\n      background: rgba(0, 0, 0, 0.5);\n      transition: ease opacity 0.5s;\n      display: block;\n    }\n  }\n'], ['\n  position: absolute;\n  width: 100vw;\n  height: 100vh;\n  display: none;\n  z-index: 6;\n  transition: ease opacity 0.5s;\n\n  @media screen and (max-width: ', ') {\n    &.active {\n      background: rgba(0, 0, 0, 0.5);\n      transition: ease opacity 0.5s;\n      display: block;\n    }\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  cursor: pointer;\n  display: inline-block;\n  position: relative ', ';\n  font-weight: ', ';\n  color: ', ';\n  margin-top: ', ';\n\n  &:hover {\n    color: ', ';\n  }\n\n  &.active {\n    color: ', ';\n  }\n'], ['\n  cursor: pointer;\n  display: inline-block;\n  position: relative ', ';\n  font-weight: ', ';\n  color: ', ';\n  margin-top: ', ';\n\n  &:hover {\n    color: ', ';\n  }\n\n  &.active {\n    color: ', ';\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteral(['margin-left: ', ';'], ['margin-left: ', ';']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  width: calc(100vw - ', ');\n  text-align: center;\n'], ['\n  width: calc(100vw - ', ');\n  text-align: center;\n']),
	    _templateObject12 = _taggedTemplateLiteral(['padding-left: ', ';'], ['padding-left: ', ';']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(169);
	
	var _Themes = __webpack_require__(5);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Burger = __webpack_require__(520);
	
	var _Burger2 = _interopRequireDefault(_Burger);
	
	var _BackArrow = __webpack_require__(77);
	
	var _BackArrow2 = _interopRequireDefault(_BackArrow);
	
	var _CloseIcon = __webpack_require__(65);
	
	var _CloseIcon2 = _interopRequireDefault(_CloseIcon);
	
	var _DropdownLinkContainer = __webpack_require__(515);
	
	var _DropdownLinkContainer2 = _interopRequireDefault(_DropdownLinkContainer);
	
	var _MobileStore = __webpack_require__(1110);
	
	var _MobileStore2 = _interopRequireDefault(_MobileStore);
	
	var _connectToStores = __webpack_require__(258);
	
	var _connectToStores2 = _interopRequireDefault(_connectToStores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var NavbarContainer = _styledComponents2.default.div(_templateObject, _Themes.Metrics.components.navbarDefault, _Themes.Colors.white, _Themes.Metrics.borders.default, _Themes.Metrics.shadows.default);
	
	var ElementOutsideContainer = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.hideOnDesktop ? 'none' : 'inline-block';
	}, _Themes.Metrics.components.navbarDefault, function (props) {
	  return props.border ? _Themes.Metrics.margins.larger : 0;
	}, function (props) {
	  return props.border && 'border-right: ' + _Themes.Metrics.borders.headerBorder;
	}, function (props) {
	  return props.right ? 'right' : 'left';
	}, _Themes.Metrics.breakpoints.tablet, function (props) {
	  return props.hideOnMobile ? 'none' : 'inline-block';
	});
	
	var ElementInsideContainer = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.components.navbarDefault, function (props) {
	  return props.mgRight ? _Themes.Metrics.margins.larger : 0;
	}, function (props) {
	  return props.mgLeft ? _Themes.Metrics.margins.larger : 0;
	});
	
	var Element = _styledComponents2.default.div(_templateObject4);
	
	var MobileMenuContainer = _styledComponents2.default.div(_templateObject5, _Themes.Metrics.breakpoints.tablet);
	
	var MobileMenu = _styledComponents2.default.div(_templateObject6, _Themes.Colors.white, _Themes.Metrics.components.mobileMenu, _Themes.Metrics.breakpoints.tablet);
	
	var CustomCloseIcon = (0, _styledComponents2.default)(_CloseIcon2.default)(_templateObject7, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base);
	
	var Overlay = _styledComponents2.default.div(_templateObject8, _Themes.Metrics.breakpoints.tablet);
	
	var LinkComponent = _styledComponents2.default.div(_templateObject9, _Themes.Fonts.style.Text, _Themes.Fonts.weight.normal, function (props) {
	  return props.active ? _Themes.Colors.primary : _Themes.Colors.black;
	}, _Themes.Metrics.margins.larger, _Themes.Colors.primary, _Themes.Colors.primary);
	
	var MobileBurger = _styledComponents2.default.div(_templateObject10, _Themes.Metrics.margins.medium);
	
	var MobileBack = _styledComponents2.default.div(_templateObject10, _Themes.Metrics.margins.largeLarger);
	
	var MobileLogo = _styledComponents2.default.div(_templateObject11, _Themes.Metrics.components.navbarMobileLogoMargins);
	
	var Links = _styledComponents2.default.div(_templateObject12, _Themes.Metrics.margins.large);
	
	var Navbar = function (_Component) {
	  _inherits(Navbar, _Component);
	
	  function Navbar(props) {
	    _classCallCheck(this, Navbar);
	
	    var _this = _possibleConstructorReturn(this, (Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call(this, props));
	
	    _this.state = {
	      activeDropdown: null
	    };
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    _this.mobileLinks = _this.mobileLinks.bind(_this);
	    _this.navBarLinks = _this.navBarLinks.bind(_this);
	    return _this;
	  }
	
	  _createClass(Navbar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      this.setState({ activeDropdown: null });
	    }
	  }, {
	    key: 'mobileLinks',
	    value: function mobileLinks() {
	      var _props = this.props;
	      var links = _props.links;
	      var activeDropdown = _props.activeDropdown;
	      var selectDropdown = _props.selectDropdown;
	
	      return links.map(function (link, index) {
	        return _react2.default.createElement(_DropdownLinkContainer2.default, {
	          key: 'mobile-dropdown-links-' + index,
	          link: link,
	          sublinks: link.sublinks,
	          toggleDropdown: selectDropdown,
	          open: activeDropdown === link.label
	        });
	      });
	    }
	  }, {
	    key: 'navBarLinks',
	    value: function navBarLinks() {
	      var _props2 = this.props;
	      var links = _props2.links;
	      var activeDropdown = _props2.activeDropdown;
	      var selectDropdown = _props2.selectDropdown;
	
	      return links.map(function (link, index) {
	        return _react2.default.createElement(_DropdownLinkContainer2.default, {
	          key: 'dropdown-links-' + index,
	          link: link,
	          sublinks: link.sublinks,
	          toggleDropdown: selectDropdown,
	          open: activeDropdown === link.label
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var left = _props3.left;
	      var right = _props3.right;
	      var middle = _props3.middle;
	      var logout = _props3.logout;
	      var toggleMobileMenu = _props3.toggleMobileMenu;
	      var mobileMenuOpen = _props3.mobileMenuOpen;
	      var handleBlur = _props3.handleBlur;
	      var backButton = _props3.backButton;
	      var router = _props3.router;
	
	
	      return _react2.default.createElement(
	        NavbarContainer,
	        Object.assign({}, this.props, { onBlur: handleBlur, tabIndex: '-1' }),
	        _react2.default.createElement(
	          MobileMenuContainer,
	          null,
	          _react2.default.createElement(Overlay, {
	            className: mobileMenuOpen && 'active',
	            onClick: toggleMobileMenu
	          }),
	          _react2.default.createElement(
	            MobileMenu,
	            { className: mobileMenuOpen && 'active' },
	            _react2.default.createElement(CustomCloseIcon, { onClick: toggleMobileMenu }),
	            _react2.default.createElement(
	              ElementInsideContainer,
	              null,
	              _react2.default.createElement(
	                Element,
	                null,
	                middle
	              )
	            ),
	            _react2.default.createElement(
	              Links,
	              null,
	              this.mobileLinks(),
	              _react2.default.createElement(
	                LinkComponent,
	                { logout: true, onClick: logout },
	                'Logout'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          ElementOutsideContainer,
	          { hideOnDesktop: true },
	          _react2.default.createElement(
	            ElementInsideContainer,
	            null,
	            _react2.default.createElement(
	              Element,
	              null,
	              backButton ? _react2.default.createElement(
	                MobileBack,
	                null,
	                _react2.default.createElement(_BackArrow2.default, { onClick: function onClick() {
	                    return router.goBack();
	                  } })
	              ) : _react2.default.createElement(
	                MobileBurger,
	                null,
	                _react2.default.createElement(_Burger2.default, { onClick: toggleMobileMenu })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          ElementOutsideContainer,
	          { hideOnDesktop: true },
	          _react2.default.createElement(
	            ElementInsideContainer,
	            null,
	            _react2.default.createElement(
	              Element,
	              null,
	              _react2.default.createElement(
	                MobileLogo,
	                null,
	                left
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          ElementOutsideContainer,
	          { hideOnMobile: true, border: true },
	          _react2.default.createElement(
	            ElementInsideContainer,
	            { mgLeft: true },
	            _react2.default.createElement(
	              Element,
	              null,
	              left
	            )
	          )
	        ),
	        _react2.default.createElement(
	          ElementOutsideContainer,
	          { hideOnMobile: true },
	          _react2.default.createElement(
	            ElementInsideContainer,
	            null,
	            _react2.default.createElement(
	              Element,
	              null,
	              middle
	            )
	          )
	        ),
	        _react2.default.createElement(
	          ElementOutsideContainer,
	          { hideOnMobile: true, border: true, right: true },
	          _react2.default.createElement(
	            ElementInsideContainer,
	            null,
	            _react2.default.createElement(
	              Element,
	              null,
	              right
	            )
	          )
	        ),
	        _react2.default.createElement(
	          ElementOutsideContainer,
	          { hideOnMobile: true, right: true },
	          _react2.default.createElement(
	            ElementInsideContainer,
	            null,
	            _react2.default.createElement(
	              Element,
	              null,
	              this.navBarLinks()
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_MobileStore2.default];
	    }
	  }, {
	    key: 'getPropsFromStores',
	    value: function getPropsFromStores() {
	      var mobileState = _MobileStore2.default.getState();
	      return {
	        backButton: mobileState.backButton
	      };
	    }
	  }]);
	
	  return Navbar;
	}(_react.Component);
	
	Navbar.propTypes = {
	  left: _react.PropTypes.node,
	  middle: _react.PropTypes.node,
	  right: _react.PropTypes.node,
	  links: _react.PropTypes.array,
	  logout: _react.PropTypes.func,
	  toggleMobileMenu: _react.PropTypes.func.isRequired,
	  mobileMenuOpen: _react.PropTypes.bool.isRequired,
	  handleBlur: _react.PropTypes.func,
	  activeDropdown: _react.PropTypes.string,
	  selectDropdown: _react.PropTypes.func
	};
	
	exports.default = (0, _connectToStores2.default)((0, _reactRouter.withRouter)(Navbar));

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: table;\n  position: relative;\n  cursor: pointer;\n'], ['\n  display: table;\n  position: relative;\n  cursor: pointer;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: table-cell;\n  vertical-align: middle;\n'], ['\n  display: table-cell;\n  vertical-align: middle;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  display: table-cell;\n  vertical-align: middle;\n\n  svg {\n    transform: rotate(180deg);\n    vertical-align: middle;\n  }\n'], ['\n  display: table-cell;\n  vertical-align: middle;\n\n  svg {\n    transform: rotate(180deg);\n    vertical-align: middle;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  display: ', ';\n  width: 150px;\n  z-index: 3;\n  background: white;\n  padding: ', ';\n  position: absolute;\n  right: 0;\n  top: calc(', ' - 1px);\n  border: ', ';\n'], ['\n  display: ', ';\n  width: 150px;\n  z-index: 3;\n  background: white;\n  padding: ', ';\n  position: absolute;\n  right: 0;\n  top: calc(', ' - 1px);\n  border: ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  ', ';\n  padding: ', ' 0;\n  &:hover {\n    color: ', ';\n  }\n'], ['\n  ', ';\n  padding: ', ' 0;\n  &:hover {\n    color: ', ';\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: -12px;\n  right: 30px;\n  width: 25px;\n'], ['\n  position: absolute;\n  top: -12px;\n  right: 30px;\n  width: 25px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Arrow = __webpack_require__(101);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	var _MenuPointer = __webpack_require__(522);
	
	var _MenuPointer2 = _interopRequireDefault(_MenuPointer);
	
	var _Themes = __webpack_require__(5);
	
	var _placeholder = __webpack_require__(1129);
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var DropdownToggleContainer = _styledComponents2.default.div(_templateObject);
	
	var AvatarContainer = _styledComponents2.default.div(_templateObject2);
	
	var ArrowContainer = _styledComponents2.default.div(_templateObject3);
	
	var Menu = _styledComponents2.default.div(_templateObject4, function (props) {
	  return props.open ? 'block' : 'none';
	}, _Themes.Metrics.margins.base, _Themes.Metrics.margins.big, _Themes.Metrics.borders.default);
	
	var MenuItem = _styledComponents2.default.div(_templateObject5, _Themes.Fonts.style.Label, _Themes.Metrics.margins.small, _Themes.Colors.primary);
	
	var CustomMenuPointer = (0, _styledComponents2.default)(_MenuPointer2.default)(_templateObject6);
	
	var ProfileDropdownSettings = function (_Component) {
	  _inherits(ProfileDropdownSettings, _Component);
	
	  function ProfileDropdownSettings(props) {
	    _classCallCheck(this, ProfileDropdownSettings);
	
	    var _this = _possibleConstructorReturn(this, (ProfileDropdownSettings.__proto__ || Object.getPrototypeOf(ProfileDropdownSettings)).call(this, props));
	
	    _this.state = {
	      open: false
	    };
	    _this.toggleDropdown = _this.toggleDropdown.bind(_this);
	    _this.closeMenu = _this.closeMenu.bind(_this);
	    return _this;
	  }
	
	  _createClass(ProfileDropdownSettings, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return this.state.open !== nextState.open;
	    }
	  }, {
	    key: 'closeMenu',
	    value: function closeMenu() {
	      this.setState({ open: false });
	    }
	  }, {
	    key: 'toggleDropdown',
	    value: function toggleDropdown() {
	      this.setState({ open: !this.state.open });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	
	      return _react2.default.createElement(
	        DropdownToggleContainer,
	        {
	          tabIndex: '-1',
	          onBlur: this.closeMenu,
	          onClick: this.toggleDropdown },
	        _react2.default.createElement(
	          AvatarContainer,
	          null,
	          _react2.default.createElement(_Avatar2.default, {
	            withBorder: true,
	            size: _Themes.Metrics.components.adminAvatarSize,
	            imageSrc: admin.picture || _placeholder2.default
	          })
	        ),
	        _react2.default.createElement(
	          ArrowContainer,
	          null,
	          _react2.default.createElement(_Arrow2.default, null)
	        ),
	        _react2.default.createElement(
	          Menu,
	          { open: this.state.open },
	          _react2.default.createElement(CustomMenuPointer, null),
	          dropdownLinks && dropdownLinks.map(function (el, index) {
	            return _react2.default.createElement(
	              MenuItem,
	              { key: 'admin-dropdown-' + index, onClick: el.onClick },
	              el.label
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return ProfileDropdownSettings;
	}(_react.Component);
	
	ProfileDropdownSettings.propTypes = {
	  admin: _react.PropTypes.object,
	  router: _react.PropTypes.object,
	  t: _react.PropTypes.func,
	  dropdownLinks: _react.PropTypes.array
	};
	
	exports.default = ProfileDropdownSettings;

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: none;\n  @media screen and (max-width: ', ') {\n    display: ', ';\n    height: ', ';\n  }\n'], ['\n  display: none;\n  @media screen and (max-width: ', ') {\n    display: ', ';\n    height: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  pointer-events: none;\n  opacity: 0;\n  height: calc(100% - 40px);\n  &.open {\n    pointer-events: all;\n    opacity: 1;\n    transition: ease-in all 0.2s;\n    transition-delay: 0.3s;\n  }\n'], ['\n  pointer-events: none;\n  opacity: 0;\n  height: calc(100% - 40px);\n  &.open {\n    pointer-events: all;\n    opacity: 1;\n    transition: ease-in all 0.2s;\n    transition-delay: 0.3s;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  transition: ease-out all 0.5s;\n  background-color: white;\n  position: absolute;\n  height: 40px;\n  width: calc(100vw - 30px);\n  border: ', ';\n  z-index: 2;\n  left: 15px;\n  top: calc(', ' + ', ');\n\n  &.open {\n    transition: ease-in all 0.3s;\n    box-shadow: none;\n    height: 100vh;\n    width: 100vw;\n    left: 0;\n    top: 0;\n  }\n'], ['\n  transition: ease-out all 0.5s;\n  background-color: white;\n  position: absolute;\n  height: 40px;\n  width: calc(100vw - 30px);\n  border: ', ';\n  z-index: 2;\n  left: 15px;\n  top: calc(', ' + ', ');\n\n  &.open {\n    transition: ease-in all 0.3s;\n    box-shadow: none;\n    height: 100vh;\n    width: 100vw;\n    left: 0;\n    top: 0;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  float: left;\n  ', ';\n  margin-top: ', ';\n  font-size: ', ';\n'], ['\n  float: left;\n  ', ';\n  margin-top: ', ';\n  font-size: ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  float: right;\n  #filters {\n    fill: ', ';\n  }\n'], ['\n  float: right;\n  #filters {\n    fill: ', ';\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  padding: ', ';\n  &.open {\n    transition: ease-in all 0.3s;\n    opacity: 0;\n    padding: 0;\n  }\n'], ['\n  padding: ', ';\n  &.open {\n    transition: ease-in all 0.3s;\n    opacity: 0;\n    padding: 0;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  height: 40px;\n  position: relative;\n  svg {\n    position: absolute;\n    right: ', ';\n    top: ', ';\n  }\n'], ['\n  height: 40px;\n  position: relative;\n  svg {\n    position: absolute;\n    right: ', ';\n    top: ', ';\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  text-align: center;\n  background: ', ';\n  color: ', ';\n  float: inherit;\n  width: calc(100% - (2 * ', '));\n  margin-left: ', ';\n  margin-right: ', ';\n  position: absolute;\n  bottom: ', ';\n'], ['\n  text-align: center;\n  background: ', ';\n  color: ', ';\n  float: inherit;\n  width: calc(100% - (2 * ', '));\n  margin-left: ', ';\n  margin-right: ', ';\n  position: absolute;\n  bottom: ', ';\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  max-height: calc(100% - 60px);\n  overflow-y: scroll;\n  padding: 0 ', ';\n'], ['\n  max-height: calc(100% - 60px);\n  overflow-y: scroll;\n  padding: 0 ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Themes = __webpack_require__(5);
	
	var _reactI18next = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Filter = __webpack_require__(1114);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	var _CloseIcon = __webpack_require__(65);
	
	var _CloseIcon2 = _interopRequireDefault(_CloseIcon);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject, _Themes.Metrics.breakpoints.tablet, function (props) {
	  return props.isAdmin ? 'none' : 'block';
	}, _Themes.Metrics.components.mobileSearchBarSize);
	
	var Forms = _styledComponents2.default.div(_templateObject2);
	
	var FiltersContainer = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.borders.default, _Themes.Metrics.components.navbarDefault, _Themes.Metrics.margins.base);
	
	var ButtonText = _styledComponents2.default.div(_templateObject4, _Themes.Fonts.style.Text, _Themes.Metrics.margins.tiny, _Themes.Fonts.size.medium);
	
	var ButtonIcon = _styledComponents2.default.div(_templateObject5, _Themes.Colors.primary);
	
	var FilterButton = _styledComponents2.default.div(_templateObject6, _Themes.Metrics.margins.small);
	
	var CloseButton = _styledComponents2.default.div(_templateObject7, _Themes.Metrics.margins.base, _Themes.Metrics.margins.small);
	
	var Apply = (0, _styledComponents2.default)(_Button2.default)(_templateObject8, _Themes.Colors.primary, _Themes.Colors.white, _Themes.Metrics.components.themeMobileMargins, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base);
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject9, _Themes.Metrics.margins.base);
	
	var MobileSearchBar = function (_Component) {
	  _inherits(MobileSearchBar, _Component);
	
	  function MobileSearchBar() {
	    _classCallCheck(this, MobileSearchBar);
	
	    return _possibleConstructorReturn(this, (MobileSearchBar.__proto__ || Object.getPrototypeOf(MobileSearchBar)).apply(this, arguments));
	  }
	
	  _createClass(MobileSearchBar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var openModal = _props.openModal;
	      var toggleModal = _props.toggleModal;
	      var apply = _props.apply;
	      var clearFilters = _props.clearFilters;
	      var t = _props.t;
	      var isAdmin = _props.isAdmin;
	
	      return _react2.default.createElement(
	        Container,
	        { className: openModal && 'open', isAdmin: isAdmin },
	        _react2.default.createElement(
	          FiltersContainer,
	          { className: openModal && 'open' },
	          _react2.default.createElement(
	            FilterButton,
	            { onClick: toggleModal, className: openModal && 'open' },
	            _react2.default.createElement(
	              ButtonText,
	              null,
	              t('Filter')
	            ),
	            _react2.default.createElement(
	              ButtonIcon,
	              null,
	              _react2.default.createElement(_Filter2.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            Forms,
	            { className: openModal && 'open' },
	            _react2.default.createElement(
	              CloseButton,
	              null,
	              _react2.default.createElement(_CloseIcon2.default, { onClick: toggleModal })
	            ),
	            _react2.default.createElement(
	              CustomThemeContainer,
	              null,
	              children,
	              _react2.default.createElement(_Button2.default, {
	                secondary: true,
	                onClick: clearFilters,
	                label: t('Clear All Filters')
	              })
	            ),
	            _react2.default.createElement(Apply, { onClick: apply, label: 'Apply' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return MobileSearchBar;
	}(_react.Component);
	
	MobileSearchBar.propTypes = {
	  children: _react.PropTypes.node,
	  apply: _react.PropTypes.func,
	  toggleModal: _react.PropTypes.func,
	  openModal: _react.PropTypes.bool,
	  clearFilters: _react.PropTypes.func,
	  t: _react.PropTypes.func,
	  isAdmin: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'search'], { wait: true })(MobileSearchBar);

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  height: calc(100vh - ', ');\n  width: ', ';\n  z-index: -1;\n'], ['\n  height: calc(100vh - ', ');\n  width: ', ';\n  z-index: -1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: calc(', ' + ', ');\n  z-index: 3;\n  position: absolute;\n  width: 100%;\n'], ['\n  margin-top: calc(', ' + ', ');\n  z-index: 3;\n  position: absolute;\n  width: 100%;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  min-height: 130px;\n  height: auto;\n  margin-bottom: ', ';\n'], ['\n  min-height: 130px;\n  height: auto;\n  margin-bottom: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  padding: 0;\n'], ['\n  padding: 0;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  padding-left: ', ';\n  padding-right: ', ';\n'], ['\n  padding-left: ', ';\n  padding-right: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  ', ';\n  margin-bottom: ', ';\n'], ['\n  ', ';\n  margin-bottom: ', ';\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  marginRight: ', ';\n'], ['\n  marginRight: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Themes = __webpack_require__(5);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _Dropdown = __webpack_require__(60);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _RangePicker = __webpack_require__(126);
	
	var _RangePicker2 = _interopRequireDefault(_RangePicker);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SearchSource = __webpack_require__(18);
	
	var _SearchableDropdown = __webpack_require__(64);
	
	var _SearchableDropdown2 = _interopRequireDefault(_SearchableDropdown);
	
	var _MultiSelectDropdown = __webpack_require__(516);
	
	var _MultiSelectDropdown2 = _interopRequireDefault(_MultiSelectDropdown);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _Constants = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var MoreFiltersContainer = _styledComponents2.default.div(_templateObject, _Themes.Metrics.components.navbarDefault, function (props) {
	  return props.isAdminPage ? 'calc(100vw - ' + _Themes.Metrics.components.sidebar + ')' : '100vw';
	});
	
	var Container = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.components.searchbar, _Themes.Metrics.margins.big);
	
	var FormGroup = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.small);
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject4);
	
	var CustomThird = (0, _styledComponents2.default)(_gridStyled.Third)(_templateObject5, _Themes.Metrics.margins.small, _Themes.Metrics.margins.small);
	
	var Title = _styledComponents2.default.div(_templateObject6, _Themes.Fonts.style.Label, _Themes.Metrics.margins.small);
	
	var ClearFilters = (0, _styledComponents2.default)(_Button2.default)(_templateObject7, _Themes.Metrics.margins.base);
	
	var MoreFilters = function (_Component) {
	  _inherits(MoreFilters, _Component);
	
	  function MoreFilters(props) {
	    _classCallCheck(this, MoreFilters);
	
	    var _this = _possibleConstructorReturn(this, (MoreFilters.__proto__ || Object.getPrototypeOf(MoreFilters)).call(this, props));
	
	    _this.state = {
	      searchCountry: '',
	      searchContinent: '',
	      searchCity: '',
	      countries: [],
	      continents: [],
	      cities: []
	    };
	
	    _this.handleSearch = _this.handleSearch.bind(_this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  _createClass(MoreFilters, [{
	    key: 'handleSearch',
	    value: function handleSearch(key, search) {
	      var _this2 = this;
	
	      switch (key) {
	        case 'country':
	          (0, _SearchSource.searchCountries)({ where: { name: { startsWith: search } } }).then(function (response) {
	            _this2.setState({ searchCountry: search, countries: response.data });
	          }).catch(function (error) {
	            console.log(error);
	          });
	          break;
	        case 'continent':
	          (0, _SearchSource.searchContinents)({ where: { name: { startsWith: search } } }).then(function (response) {
	            _this2.setState({
	              searchContinent: search,
	              continents: response.data
	            });
	          }).catch(function (error) {
	            console.log(error);
	          });
	          break;
	        case 'city':
	          (0, _SearchSource.searchCities)({ where: { city: { startsWith: search } } }).then(function (response) {
	            _this2.setState({ searchCity: search, cities: response.data });
	          }).catch(function (error) {
	            console.log(error);
	          });
	          break;
	        default:
	          return;
	      }
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(type, value) {
	      this.props.handleSelect(type, value);
	      this.setState({
	        searchCountry: '',
	        searchContinent: '',
	        searchCity: ''
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var settings = _props.settings;
	      var handleDropdownSelect = _props.handleDropdownSelect;
	      var handleRange = _props.handleRange;
	      var _handleSelect = _props.handleSelect;
	      var isAdminPage = _props.isAdminPage;
	      var t = _props.t;
	      var categories = _props.categories;
	      var _state = this.state;
	      var cities = _state.cities;
	      var countries = _state.countries;
	      var continents = _state.continents;
	      var searchCategory = _state.searchCategory;
	      var searchContinent = _state.searchContinent;
	      var searchCountry = _state.searchCountry;
	      var searchCity = _state.searchCity;
	
	
	      return _react2.default.createElement(
	        MoreFiltersContainer,
	        { isAdminPage: isAdminPage },
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            _ThemeContainer2.default,
	            null,
	            _react2.default.createElement(
	              CustomGrid,
	              null,
	              _react2.default.createElement(
	                CustomThird,
	                null,
	                _react2.default.createElement(
	                  FormGroup,
	                  null,
	                  _react2.default.createElement(
	                    Title,
	                    null,
	                    t('Type of Asset')
	                  ),
	                  _react2.default.createElement(_MultiSelectDropdown2.default, {
	                    options: categories,
	                    showTags: true,
	                    selectedOptions: settings.preferredCategories,
	                    value: searchCategory,
	                    handleSelect: function handleSelect(value) {
	                      _handleSelect('preferredCategories', value);
	                    },
	                    placeholder: 'Filter By Type of Asset',
	                    accessor: function accessor(d) {
	                      return d.name;
	                    },
	                    tagsAccessor: function tagsAccessor(d) {
	                      return d.name;
	                    }
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                CustomThird,
	                null,
	                _react2.default.createElement(
	                  FormGroup,
	                  null,
	                  _react2.default.createElement(
	                    Title,
	                    null,
	                    t('Portfolio')
	                  ),
	                  _react2.default.createElement(_Dropdown2.default, {
	                    options: [true, false],
	                    accessor: function accessor(d) {
	                      return d ? 'Yes' : 'No';
	                    },
	                    selectedOption: settings.portfolio,
	                    handleSelect: function handleSelect(el) {
	                      return handleDropdownSelect('portfolio', el);
	                    },
	                    placeholder: 'Filter By Portfolio'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                CustomThird,
	                null,
	                _react2.default.createElement(
	                  FormGroup,
	                  null,
	                  _react2.default.createElement(
	                    Title,
	                    null,
	                    t('Continent')
	                  ),
	                  _react2.default.createElement(_SearchableDropdown2.default, {
	                    showTags: true,
	                    selectedOptions: settings.preferredRegions,
	                    options: continents,
	                    value: searchContinent,
	                    handleSearch: function handleSearch(event) {
	                      _this3.handleSearch('continent', event.target.value);
	                    },
	                    handleSelect: function handleSelect(value) {
	                      _this3.handleSelect('preferredRegions', value);
	                    },
	                    placeholder: 'Filter By Continent',
	                    accessor: function accessor(d) {
	                      return d.name;
	                    },
	                    tagsAccessor: function tagsAccessor(d) {
	                      return d.name;
	                    }
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              CustomGrid,
	              null,
	              _react2.default.createElement(
	                CustomThird,
	                null,
	                _react2.default.createElement(
	                  FormGroup,
	                  null,
	                  _react2.default.createElement(
	                    Title,
	                    null,
	                    t('Country')
	                  ),
	                  _react2.default.createElement(_SearchableDropdown2.default, {
	                    options: countries,
	                    selectedOptions: settings.preferredCountries,
	                    showTags: true,
	                    value: searchCountry,
	                    handleSearch: function handleSearch(event) {
	                      _this3.handleSearch('country', event.target.value);
	                    },
	                    handleSelect: function handleSelect(value) {
	                      _this3.handleSelect('preferredCountries', value);
	                    },
	                    placeholder: 'Filter By Country',
	                    accessor: function accessor(d) {
	                      return d.name;
	                    },
	                    tagsAccessor: function tagsAccessor(d) {
	                      return d.name;
	                    }
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                CustomThird,
	                null,
	                _react2.default.createElement(
	                  FormGroup,
	                  null,
	                  _react2.default.createElement(
	                    Title,
	                    null,
	                    t('City')
	                  ),
	                  _react2.default.createElement(_SearchableDropdown2.default, {
	                    options: cities,
	                    value: searchCity,
	                    showTags: true,
	                    selectedOptions: settings.preferredCities,
	                    handleSearch: function handleSearch(event) {
	                      _this3.handleSearch('city', event.target.value);
	                    },
	                    handleSelect: function handleSelect(value) {
	                      _this3.handleSelect('preferredCities', value);
	                    },
	                    placeholder: 'Filter By City',
	                    accessor: function accessor(d) {
	                      return d.city;
	                    },
	                    tagsAccessor: function tagsAccessor(d) {
	                      return d.city;
	                    }
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                CustomThird,
	                null,
	                _react2.default.createElement(
	                  FormGroup,
	                  null,
	                  _react2.default.createElement(
	                    Title,
	                    null,
	                    t('Number of Keys')
	                  ),
	                  _react2.default.createElement(_RangePicker2.default, {
	                    max: _Constants.maxRooms,
	                    minValue: settings.minNoRooms,
	                    maxValue: settings.maxNoRooms,
	                    handleChange: function handleChange(value) {
	                      return handleRange('minNoRooms', 'maxNoRooms', value);
	                    },
	                    step: _Constants.defaultRoomsStep
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              CustomGrid,
	              null,
	              _react2.default.createElement(
	                CustomThird,
	                null,
	                _react2.default.createElement(
	                  FormGroup,
	                  null,
	                  _react2.default.createElement(
	                    Title,
	                    null,
	                    t('Estimated Yield')
	                  ),
	                  _react2.default.createElement(_RangePicker2.default, {
	                    max: _Constants.maxYield,
	                    step: _Constants.defaultYieldStep,
	                    minValue: settings.minYield,
	                    maxValue: settings.maxYield,
	                    unit: '%',
	                    rightUnit: true,
	                    handleChange: function handleChange(value) {
	                      return handleRange('minYield', 'maxYield', value);
	                    }
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                CustomThird,
	                null,
	                _react2.default.createElement(
	                  FormGroup,
	                  null,
	                  _react2.default.createElement(
	                    Title,
	                    null,
	                    t('Price')
	                  ),
	                  _react2.default.createElement(_RangePicker2.default, {
	                    max: _Constants.maxPrice,
	                    step: _Constants.defaultPriceStep,
	                    minValue: settings.minInvestment,
	                    maxValue: settings.maxInvestment,
	                    unit: '€',
	                    handleChange: function handleChange(value) {
	                      return handleRange('minInvestment', 'maxInvestment', value);
	                    }
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _gridStyled2.default,
	              {
	                style: { marginTop: _Themes.Metrics.margins.large, textAlign: 'right' } },
	              _react2.default.createElement(ClearFilters, {
	                secondary: true,
	                onClick: this.props.clearFilters,
	                label: 'Clear all filters'
	              }),
	              _react2.default.createElement(_Button2.default, { onClick: this.props.apply, label: 'Apply' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MoreFilters;
	}(_react.Component);
	
	MoreFilters.propTypes = {
	  settings: _react.PropTypes.object,
	  handleRange: _react.PropTypes.func,
	  handleSelect: _react.PropTypes.func,
	  categories: _react.PropTypes.array,
	  apply: _react.PropTypes.func,
	  t: _react.PropTypes.func,
	  handleDropdownSelect: _react.PropTypes.func,
	  clearFilters: _react.PropTypes.func,
	  isAdminPage: _react.PropTypes.bool
	};
	
	exports.default = MoreFilters;

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  ', ';\n  margin-top: ', ';\n  cursor: pointer;\n  display: inline-block;\n'], ['\n  ', ';\n  margin-top: ', ';\n  cursor: pointer;\n  display: inline-block;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: 30px;\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  svg {\n    position: absolute;\n    top: -16px;\n    right: 0px;\n    transform: ', ';\n    fill: ', ';\n  }\n'], ['\n  width: 30px;\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  svg {\n    position: absolute;\n    top: -16px;\n    right: 0px;\n    transform: ', ';\n    fill: ', ';\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  display: ', ';\n  position: absolute;\n  top: ', ';\n  left: -1px;\n  border: ', ';\n  background: ', ';\n  min-width: 260px;\n  z-index: 2;\n  padding: ', ';\n  .dropdown-component {\n    ', ';\n    ', ';\n  }\n  .dropdown-header {\n    padding-top: ', ';\n    padding-left: ', ';\n  }\n\n  .tags {\n    ', ';\n  }\n'], ['\n  display: ', ';\n  position: absolute;\n  top: ', ';\n  left: -1px;\n  border: ', ';\n  background: ', ';\n  min-width: 260px;\n  z-index: 2;\n  padding: ', ';\n  .dropdown-component {\n    ', ';\n    ', ';\n  }\n  .dropdown-header {\n    padding-top: ', ';\n    padding-left: ', ';\n  }\n\n  .tags {\n    ', ';\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  display: ', ';\n  padding: 0 ', ';\n  border-right: ', ';\n  background: ', ';\n  z-index: 3;\n  position: ', ';\n  height: 100%;\n  cursor: pointer;\n  border-bottom: ', ';\n  .dropdown-button {\n    background: transparent;\n    border: none;\n    position: ', ';\n    z-index: ', ';\n  }\n'], ['\n  display: ', ';\n  padding: 0 ', ';\n  border-right: ', ';\n  background: ', ';\n  z-index: 3;\n  position: ', ';\n  height: 100%;\n  cursor: pointer;\n  border-bottom: ', ';\n  .dropdown-button {\n    background: transparent;\n    border: none;\n    position: ', ';\n    z-index: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Themes = __webpack_require__(5);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Arrow = __webpack_require__(101);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Label = _styledComponents2.default.div(_templateObject, _Themes.Fonts.style.Text, _Themes.Metrics.margins.base);
	
	var ArrowContainer = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.isActive ? 'rotate(0deg)' : 'rotate(180deg)';
	}, _Themes.Colors.primary);
	
	var DropdownBox = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.isActive ? 'block' : 'none';
	}, function (props) {
	  return props.isMoreFilters ? '0px' : '58px';
	}, function (props) {
	  return props.isMoreFilters ? 'none' : _Themes.Metrics.borders.default;
	}, _Themes.Colors.white, function (props) {
	  return props.isMoreFilters || props.dropdown ? 0 : _Themes.Metrics.margins.small;
	}, function (props) {
	  return props.dropdown && 'padding: 0';
	}, function (props) {
	  return props.dropdown && 'width: calc(100% - 2px)';
	}, function (props) {
	  return props.isMoreFilters ? 0 : _Themes.Metrics.margins.small;
	}, function (props) {
	  return props.isMoreFilters ? 0 : _Themes.Metrics.margins.small;
	}, function (props) {
	  return props.dropdown && 'margin-left: ' + _Themes.Metrics.margins.small;
	});
	
	var DropdownContainer = _styledComponents2.default.div(_templateObject4, function (props) {
	  return props.isMoreFilters ? 'inline' : 'inline-block';
	}, _Themes.Metrics.margins.small, _Themes.Metrics.borders.default, function (props) {
	  return props.isMoreFilters && props.isActive ? 'transparent' : _Themes.Colors.white;
	}, function (props) {
	  return props.isMoreFilters ? 'static' : 'relative';
	}, function (props) {
	  if (!props.isActive && props.active === 'More Filters') {
	    return _Themes.Metrics.borders.default;
	  }
	  if (props.isActive) {
	    return _Themes.Metrics.borders.defaultOrange;
	  } else {
	    return 'none';
	  }
	}, function (props) {
	  return props.isMoreFilters && props.isActive ? 'absolute' : 'inherit';
	}, function (props) {
	  return props.isMoreFilters && props.isActive ? 3 : 'inherit';
	});
	
	var SearchDropdown = function (_Component) {
	  _inherits(SearchDropdown, _Component);
	
	  function SearchDropdown() {
	    _classCallCheck(this, SearchDropdown);
	
	    return _possibleConstructorReturn(this, (SearchDropdown.__proto__ || Object.getPrototypeOf(SearchDropdown)).apply(this, arguments));
	  }
	
	  _createClass(SearchDropdown, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var id = _props.id;
	      var active = _props.active;
	      var onBlur = _props.onBlur;
	      var onFocus = _props.onFocus;
	      var _onClick = _props.onClick;
	      var dropdown = _props.dropdown;
	
	      var isActive = id === active;
	      var isMoreFilters = isActive && id === 'More Filters';
	      return _react2.default.createElement(
	        DropdownContainer,
	        {
	          isMoreFilters: isMoreFilters,
	          isActive: isActive,
	          active: active },
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'dropdown-button',
	            onFocus: onFocus,
	            onBlur: onBlur,
	            id: 'button-' + id,
	            onClick: function onClick() {
	              return _onClick(id);
	            } },
	          _react2.default.createElement(
	            Label,
	            null,
	            id
	          ),
	          _react2.default.createElement(
	            ArrowContainer,
	            null,
	            _react2.default.createElement(_Arrow2.default, null)
	          )
	        ),
	        _react2.default.createElement(
	          DropdownBox,
	          {
	            id: id,
	            tabIndex: '-1',
	            onFocus: onFocus,
	            onBlur: onBlur,
	            isMoreFilters: isMoreFilters,
	            isActive: isActive,
	            dropdown: dropdown },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return SearchDropdown;
	}(_react.Component);
	
	SearchDropdown.propTypes = {
	  active: _react.PropTypes.string,
	  id: _react.PropTypes.string.isRequired,
	  onBlur: _react.PropTypes.func.isRequired,
	  onFocus: _react.PropTypes.func.isRequired,
	  onClick: _react.PropTypes.func.isRequired,
	  children: _react.PropTypes.node,
	  dropdown: _react.PropTypes.bool
	};
	
	exports.default = SearchDropdown;

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  text-align: center;\n  p {\n    ', ';\n    padding-top: ', ';\n    color: ', ';\n    margin: 0px;\n    line-height: 15px;\n  }\n'], ['\n  text-align: center;\n  p {\n    ', ';\n    padding-top: ', ';\n    color: ', ';\n    margin: 0px;\n    line-height: 15px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  max-width: 200px;\n  margin-left: calc((100% - 200px)/2)\n  text-align: center;\n'], ['\n  max-width: 200px;\n  margin-left: calc((100% - 200px)/2)\n  text-align: center;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Tile = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.textStyle || _Themes.Fonts.style.Text;
	}, _Themes.Metrics.margins.base, _Themes.Colors.black);
	
	var Icon = _styledComponents2.default.div(_templateObject2);
	
	var TileWithIcon = function TileWithIcon(props) {
	  var icon = props.icon;
	  var text = props.text;
	
	
	  return _react2.default.createElement(
	    Tile,
	    props,
	    _react2.default.createElement(
	      Icon,
	      null,
	      icon
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      text
	    )
	  );
	};
	
	TileWithIcon.propTypes = {
	  icon: _react.PropTypes.node,
	  text: _react.PropTypes.node,
	  textStyle: _react.PropTypes.object
	};
	
	exports.default = TileWithIcon;

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(58);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactI18next = __webpack_require__(7);
	
	var _App = __webpack_require__(1034);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _i18n = __webpack_require__(1037);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	__webpack_require__(649);
	
	__webpack_require__(645);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(
	  _reactI18next.I18nextProvider,
	  { i18n: _i18n2.default },
	  _react2.default.createElement(_App2.default, null)
	), document.getElementById('root'));

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  .landing-page {\n    display: block;\n    width: 100vw;\n    height: 100vh;\n    background: #2d3030;\n    text-align: center;\n    position: relative;\n\n    .background {\n      position: absolute;\n      top: 0px;\n      left: 0px;\n      opacity: 0.3;\n      background: url(\'../img/Landing/landing.jpg\') no-repeat center;\n      background-size: cover;\n      width: 100vw;\n      height: 100vh;\n\n      -webkit-backdrop-filter: blur(2px);\n      backdrop-filter: blur(2px);\n      filter: blur(2px);\n    }\n  }\n'], ['\n  .landing-page {\n    display: block;\n    width: 100vw;\n    height: 100vh;\n    background: #2d3030;\n    text-align: center;\n    position: relative;\n\n    .background {\n      position: absolute;\n      top: 0px;\n      left: 0px;\n      opacity: 0.3;\n      background: url(\'../img/Landing/landing.jpg\') no-repeat center;\n      background-size: cover;\n      width: 100vw;\n      height: 100vh;\n\n      -webkit-backdrop-filter: blur(2px);\n      backdrop-filter: blur(2px);\n      filter: blur(2px);\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SuccessModal = __webpack_require__(37);
	
	var _SuccessModal2 = _interopRequireDefault(_SuccessModal);
	
	var _AuthActions = __webpack_require__(53);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.main(_templateObject);
	
	var ActivateAccount = function (_Component) {
	  _inherits(ActivateAccount, _Component);
	
	  function ActivateAccount() {
	    _classCallCheck(this, ActivateAccount);
	
	    return _possibleConstructorReturn(this, (ActivateAccount.__proto__ || Object.getPrototypeOf(ActivateAccount)).apply(this, arguments));
	  }
	
	  _createClass(ActivateAccount, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var t = _props.t;
	      var router = _props.router;
	
	      return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'landing-page' },
	          _react2.default.createElement('div', { className: 'background' }),
	          _react2.default.createElement(_SuccessModal2.default, {
	            header: t('Activate Account'),
	            visible: true,
	            closeAction: function closeAction() {
	              _AuthActions2.default.logout();
	              router.replace('/');
	            },
	            message: t('Thank you for completing the preliminary steps.  We will be in touch shortly in order to arrange a personal conversation.')
	          })
	        )
	      );
	    }
	  }]);
	
	  return ActivateAccount;
	}(_react.Component);
	
	ActivateAccount.propTypes = {
	  errorMessage: _react.PropTypes.string,
	  user: _react.PropTypes.object,
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'landing'], { wait: true })(ActivateAccount);

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['min-height: 100%;'], ['min-height: 100%;']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n  max-height: ', ';\n  overflow-y: scroll;\n'], ['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n  max-height: ', ';\n  overflow-y: scroll;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  padding-bottom: ', ';\n  border-bottom: ', ';\n'], ['\n  padding-bottom: ', ';\n  border-bottom: ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  height: 50px;\n  border-bottom: ', ';\n  padding: ', ' 0;\n  cursor: pointer;\n  position: relative;\n  svg {\n    position: absolute;\n    right: 0;\n    top: ', ';\n    float: right;\n    cursor: pointer;\n  }\n'], ['\n  height: 50px;\n  border-bottom: ', ';\n  padding: ', ' 0;\n  cursor: pointer;\n  position: relative;\n  svg {\n    position: absolute;\n    right: 0;\n    top: ', ';\n    float: right;\n    cursor: pointer;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['', ';'], ['', ';']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(29);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactI18next = __webpack_require__(7);
	
	var _AdminNavbar = __webpack_require__(36);
	
	var _AdminNavbar2 = _interopRequireDefault(_AdminNavbar);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Trash = __webpack_require__(89);
	
	var _Trash2 = _interopRequireDefault(_Trash);
	
	var _Themes = __webpack_require__(5);
	
	var _AdminSource = __webpack_require__(31);
	
	var _DialogModal = __webpack_require__(46);
	
	var _DialogModal2 = _interopRequireDefault(_DialogModal);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var PageContainer = _styledComponents2.default.div(_templateObject);
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject2, _Themes.Metrics.margins.base);
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject3, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.adminContent);
	
	var SearchArea = _styledComponents2.default.div(_templateObject4, _Themes.Metrics.margins.base, _Themes.Metrics.borders.default);
	
	var Admin = _styledComponents2.default.div(_templateObject5, _Themes.Metrics.borders.default, _Themes.Metrics.margins.base, _Themes.Metrics.margins.medium);
	
	var AdminName = _styledComponents2.default.div(_templateObject6, _Themes.Fonts.style.Label);
	
	var AdminsOverview = function (_Component) {
	  _inherits(AdminsOverview, _Component);
	
	  function AdminsOverview(props) {
	    _classCallCheck(this, AdminsOverview);
	
	    var _this = _possibleConstructorReturn(this, (AdminsOverview.__proto__ || Object.getPrototypeOf(AdminsOverview)).call(this, props));
	
	    _this.state = {
	      name: '',
	      modal: false,
	      admins: [],
	      adminToDelete: null
	    };
	    _this.fetchAdmins = _this.fetchAdmins.bind(_this);
	    _this.handleDelete = _this.handleDelete.bind(_this);
	    _this.selectAdmin = _this.selectAdmin.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(AdminsOverview, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var _state = this.state;
	      var name = _state.name;
	      var modal = _state.modal;
	      var admins = _state.admins;
	      var adminToDelete = _state.adminToDelete;
	
	      if (name !== nextState.name || modal !== nextState.modal || !(0, _immutable.fromJS)(nextState.admins).equals((0, _immutable.fromJS)(admins)) || adminToDelete !== nextState.adminToDelete) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.fetchAdmins();
	    }
	  }, {
	    key: 'fetchAdmins',
	    value: function fetchAdmins() {
	      var _this2 = this;
	
	      (0, _AdminSource.searchAdmins)({ sort: 'name ASC' }).then(function (response) {
	        return _this2.setState({ admins: response.data });
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'handleDelete',
	    value: function handleDelete() {
	      var _this3 = this;
	
	      (0, _AdminSource.deleteAdmin)(this.state.adminToDelete.id).then(function (response) {
	        _this3.setState({ adminToDelete: null, modal: false }, function () {
	          return _this3.fetchAdmins();
	        });
	      }).catch(function (error) {
	        return console.log(error);
	      });
	    }
	  }, {
	    key: 'selectAdmin',
	    value: function selectAdmin(admin) {
	      this.setState({ adminToDelete: admin, modal: true });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var _this4 = this;
	
	      this.setState({ name: event.target.value }, function () {
	        (0, _AdminSource.searchAdmins)({
	          where: { name: { startsWith: _this4.state.name } },
	          sort: 'name ASC'
	        }).then(function (response) {
	          return _this4.setState({ admins: response.data });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state2 = this.state;
	      var name = _state2.name;
	      var admins = _state2.admins;
	      var modal = _state2.modal;
	      var _props = this.props;
	      var t = _props.t;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	      var router = _props.router;
	
	
	      return _react2.default.createElement(
	        PageContainer,
	        null,
	        _react2.default.createElement(_AdminNavbar2.default, {
	          fixedSearchBar: true,
	          admin: admin,
	          rightSideActions: [{
	            label: t('Create Admin'),
	            secondary: true,
	            onClick: function onClick() {
	              return router.push('/admin/admins/new');
	            }
	          }],
	          dropdownLinks: dropdownLinks
	        }),
	        _react2.default.createElement(_DialogModal2.default, {
	          visible: modal,
	          header: t('Delete Admin'),
	          message: t('Do you really want to delete this admin?'),
	          buttons: {
	            apply: { label: t('Delete'), onClick: this.handleDelete },
	            cancel: {
	              label: t('Cancel'),
	              onClick: function onClick() {
	                _this5.setState({ modal: false });
	              }
	            }
	          },
	          closeAction: this.toggleModal
	        }),
	        _react2.default.createElement(
	          CustomThemeContainer,
	          null,
	          _react2.default.createElement(
	            CustomCardContainer,
	            { title: t('Admins') },
	            _react2.default.createElement(
	              SearchArea,
	              null,
	              _react2.default.createElement(_Input2.default, {
	                placeholder: t('Search for admins'),
	                title: t('Name'),
	                handleChange: this.handleChange,
	                value: name,
	                name: 'name'
	              })
	            ),
	            admins && admins.length > 0 && admins.map(function (el, index) {
	              return _react2.default.createElement(
	                Admin,
	                {
	                  key: 'admin-' + index,
	                  onClick: function onClick() {
	                    return router.push('/admin/admins/' + el.id);
	                  } },
	                _react2.default.createElement(
	                  AdminName,
	                  null,
	                  el.name
	                ),
	                admin.email !== el.email && _react2.default.createElement(_Trash2.default, {
	                  onClick: function onClick(event) {
	                    event.stopPropagation();
	                    _this5.selectAdmin(el);
	                  }
	                })
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminsOverview;
	}(_react.Component);
	
	AdminsOverview.propTypes = {
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  admin: _react.PropTypes.object,
	  dropdownLinks: _react.PropTypes.array
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'admin', 'forms'], { wait: true })(AdminsOverview);

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['min-height: 100%;'], ['min-height: 100%;']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n  max-height: ', ';\n  overflow-y: scroll;\n'], ['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n  max-height: ', ';\n  overflow-y: scroll;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  margin-bottom: ', ';\n  cursor: pointer;\n\n  span {\n    padding-left: ', ';\n    ', ';\n  }\n'], ['\n  margin-top: ', ';\n  margin-bottom: ', ';\n  cursor: pointer;\n\n  span {\n    padding-left: ', ';\n    ', ';\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _reactI18next = __webpack_require__(7);
	
	var _AdminNavbar = __webpack_require__(36);
	
	var _AdminNavbar2 = _interopRequireDefault(_AdminNavbar);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Validations = __webpack_require__(44);
	
	var _Defaults = __webpack_require__(34);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _BackArrow = __webpack_require__(77);
	
	var _BackArrow2 = _interopRequireDefault(_BackArrow);
	
	var _Themes = __webpack_require__(5);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _AdminSource = __webpack_require__(31);
	
	var _SuccessModal = __webpack_require__(37);
	
	var _SuccessModal2 = _interopRequireDefault(_SuccessModal);
	
	var _ErrorModal = __webpack_require__(30);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	var _DialogModal = __webpack_require__(46);
	
	var _DialogModal2 = _interopRequireDefault(_DialogModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var PageContainer = _styledComponents2.default.div(_templateObject);
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject2, _Themes.Metrics.margins.base);
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject3, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.adminContent);
	
	var ArrowContainer = _styledComponents2.default.div(_templateObject4, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base, _Themes.Metrics.margins.medium, _Themes.Fonts.style.Header);
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject5, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, function (props) {
	  return props.noPadLeft ? 0 : _Themes.Metrics.margins.medium;
	}, function (props) {
	  return props.noPadRight ? 0 : _Themes.Metrics.margins.medium;
	});
	
	var EditAdmin = function (_Component) {
	  _inherits(EditAdmin, _Component);
	
	  function EditAdmin(props) {
	    _classCallCheck(this, EditAdmin);
	
	    var _this = _possibleConstructorReturn(this, (EditAdmin.__proto__ || Object.getPrototypeOf(EditAdmin)).call(this, props));
	
	    _this.state = {
	      create: false,
	      adminToUpdate: _ramda2.default.clone(_Defaults.adminDefault),
	      modal: false,
	      errors: _ramda2.default.clone(_Defaults.adminDefault),
	      password: '',
	      passwordError: '',
	      passwordConfirmation: ''
	    };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handlePasswordChange = _this.handlePasswordChange.bind(_this);
	    _this.handleDelete = _this.handleDelete.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    _this.handlePasswordBlur = _this.handlePasswordBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditAdmin, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var id = this.props.params.id;
	
	      if (id !== 'new') {
	        (0, _AdminSource.searchAdmins)({ id: id }).then(function (response) {
	          return _this2.setState({ adminToUpdate: response.data });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      } else {
	        this.setState({ create: true });
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event, key) {
	      var adminToUpdate = this.state.adminToUpdate;
	
	      adminToUpdate[key] = event.target.value;
	      this.setState({ adminToUpdate: adminToUpdate });
	    }
	  }, {
	    key: 'handlePasswordChange',
	    value: function handlePasswordChange(event, key) {
	      var state = this.state;
	      state[key] = event.target.value;
	      this.setState({ state: state });
	    }
	  }, {
	    key: 'handleDelete',
	    value: function handleDelete() {
	      var _this3 = this;
	
	      var router = this.props.router;
	
	      (0, _AdminSource.deleteAdmin)(this.state.adminToUpdate.id).then(function (response) {
	        return router.goBack();
	      }).error(function (error) {
	        console.log(error);
	        _this3.toggleModal('error');
	      });
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur(name, value, errors) {
	      var newErrors = (0, _Validations.validateInput)(name, value, errors);
	      this.setState({ errors: newErrors });
	    }
	  }, {
	    key: 'handlePasswordBlur',
	    value: function handlePasswordBlur() {
	      var t = this.props.t;
	      var _state = this.state;
	      var password = _state.password;
	      var passwordConfirmation = _state.passwordConfirmation;
	
	      this.setState({
	        passwordError: passwordConfirmation !== password ? t('Passwords don\'t match') : ''
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var _this4 = this;
	
	      var t = this.props.t;
	      var _state2 = this.state;
	      var create = _state2.create;
	      var adminToUpdate = _state2.adminToUpdate;
	      var passwordConfirmation = _state2.passwordConfirmation;
	      var password = _state2.password;
	      var errors = _state2.errors;
	
	      var validation = (0, _Validations.validateForm)(adminToUpdate, errors);
	      if (validation.valid && passwordConfirmation === password) {
	        if (create) {
	          if (password.length > 0) {
	            var admin = Object.assign({}, adminToUpdate, { password: password });
	            (0, _AdminSource.createAdmin)(admin).then(function (response) {
	              return _this4.toggleModal('success');
	            }).catch(function (error) {
	              console.log(error);
	              _this4.toggleModal('error');
	            });
	          } else {
	            this.setState({ passwordError: t('This field is Required') });
	          }
	        } else {
	          var _admin = adminToUpdate;
	          if (password.length > 0 && password === passwordConfirmation) {
	            _admin = Object.assign({}, adminToUpdate, { password: password });
	          }
	          (0, _AdminSource.updateAdmin)(_admin).then(function (response) {
	            return _this4.toggleModal('success');
	          }).catch(function (error) {
	            console.log(error);
	            _this4.toggleModal('error');
	          });
	        }
	      }
	    }
	  }, {
	    key: 'toggleModal',
	    value: function toggleModal(modal) {
	      this.setState({ modal: modal });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state3 = this.state;
	      var adminToUpdate = _state3.adminToUpdate;
	      var create = _state3.create;
	      var passwordConfirmation = _state3.passwordConfirmation;
	      var password = _state3.password;
	      var modal = _state3.modal;
	      var errors = _state3.errors;
	      var passwordError = _state3.passwordError;
	      var _props = this.props;
	      var t = _props.t;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	      var router = _props.router;
	
	
	      var actions = [{ label: t('Save'), primary: true, onClick: this.handleSubmit }];
	      if (!create && admin.email !== adminToUpdate.email) {
	        actions.push({
	          label: t('Delete Admin'),
	          secondary: true,
	          onClick: function onClick() {
	            return _this5.toggleModal('dialog');
	          }
	        });
	      }
	
	      return _react2.default.createElement(
	        PageContainer,
	        null,
	        _react2.default.createElement(_AdminNavbar2.default, {
	          admin: admin,
	          dropdownLinks: dropdownLinks,
	          rightSideActions: actions
	        }),
	        _react2.default.createElement(_ErrorModal2.default, {
	          visible: modal === 'error',
	          message: t('There was an error on ' + (create ? 'creating' : 'updating') + ' the admin'),
	          closeAction: this.toggleModal,
	          header: t('Error')
	        }),
	        _react2.default.createElement(_SuccessModal2.default, {
	          visible: modal === 'success',
	          message: t('The admin was successfully ' + (create ? 'created' : 'updated')),
	          closeAction: this.toggleModal,
	          header: t('Admin Updated')
	        }),
	        _react2.default.createElement(_DialogModal2.default, {
	          visible: modal === 'dialog',
	          message: t('Do you really want to delete the admin?'),
	          closeAction: this.toggleModal,
	          header: t('Delete Admin'),
	          buttons: {
	            apply: { label: t('Delete'), onClick: this.handleDelete },
	            cancel: { label: t('Cancel'), onClick: this.toggleModal }
	          }
	        }),
	        _react2.default.createElement(
	          CustomThemeContainer,
	          null,
	          _react2.default.createElement(
	            ArrowContainer,
	            { onClick: function onClick() {
	                return router.goBack();
	              } },
	            _react2.default.createElement(_BackArrow2.default, null),
	            _react2.default.createElement(
	              'span',
	              null,
	              create ? t('Insert Admin') : adminToUpdate.name
	            )
	          ),
	          _react2.default.createElement(
	            CustomCardContainer,
	            { title: t('Personal Info') },
	            _react2.default.createElement(
	              CustomGrid,
	              { noPadTop: true, noPadLeft: true, noPadRight: true },
	              _react2.default.createElement(
	                CustomGrid,
	                { xs: 1 / 2, noPadTop: true, noPadLeft: true },
	                _react2.default.createElement(_Input2.default, {
	                  required: true,
	                  name: 'name',
	                  placeholder: t('Name'),
	                  title: t('Name'),
	                  handleChange: function handleChange(event) {
	                    return _this5.handleChange(event, 'name');
	                  },
	                  value: adminToUpdate.name,
	                  error: errors['name'],
	                  handleBlur: function handleBlur() {
	                    return _this5.handleBlur('name', adminToUpdate.name, errors);
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                CustomGrid,
	                { xs: 1 / 2, noPadTop: true, noPadRight: true },
	                _react2.default.createElement(_Input2.default, {
	                  name: 'email',
	                  required: true,
	                  placeholder: t('E-mail'),
	                  title: t('E-mail'),
	                  handleChange: function handleChange(event) {
	                    return _this5.handleChange(event, 'email');
	                  },
	                  value: adminToUpdate.email,
	                  error: errors['email'],
	                  handleBlur: function handleBlur() {
	                    return _this5.handleBlur('email', adminToUpdate.email, errors);
	                  }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            CustomCardContainer,
	            { title: t('Change Password') },
	            _react2.default.createElement(
	              CustomGrid,
	              { noPadTop: true, noPadLeft: true, noPadRight: true },
	              _react2.default.createElement(
	                CustomGrid,
	                { xs: 1 / 2, noPadTop: true, noPadLeft: true },
	                _react2.default.createElement(_Input2.default, {
	                  type: 'password',
	                  placeholder: t('Password'),
	                  title: t('Password'),
	                  handleChange: function handleChange(event) {
	                    return _this5.handlePasswordChange(event, 'password');
	                  },
	                  value: password,
	                  error: passwordError,
	                  handleBlur: this.handlePasswordBlur
	                })
	              ),
	              _react2.default.createElement(
	                CustomGrid,
	                { xs: 1 / 2, noPadTop: true, noPadRight: true },
	                _react2.default.createElement(_Input2.default, {
	                  type: 'password',
	                  placeholder: t('Confirm Password'),
	                  title: t('Confirm Password'),
	                  handleChange: function handleChange(event) {
	                    return _this5.handlePasswordChange(event, 'passwordConfirmation');
	                  },
	                  value: passwordConfirmation,
	                  handleBlur: this.handlePasswordBlur
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditAdmin;
	}(_react.Component);
	
	EditAdmin.propTypes = {
	  t: _react.PropTypes.func,
	  params: _react.PropTypes.object,
	  admin: _react.PropTypes.object,
	  dropdownLinks: _react.PropTypes.array,
	  router: _react.PropTypes.object
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'admin', 'forms'], { wait: true })(EditAdmin);

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  max-height: ', ';\n  overflow-y: scroll;\n'], ['\n  max-height: ', ';\n  overflow-y: scroll;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n\n  button {\n    margin-top: ', ';\n    float: right;\n  }\n'], ['\n  margin-top: ', ';\n\n  button {\n    margin-top: ', ';\n    float: right;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  margin-bottom: ', ';\n  cursor: pointer;\n\n  span {\n    padding-left: ', ';\n    ', ';\n  }\n'], ['\n  margin-top: ', ';\n  margin-bottom: ', ';\n  cursor: pointer;\n\n  span {\n    padding-left: ', ';\n    ', ';\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n'], ['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['height: 50px;'], ['height: 50px;']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _AdminNavbar = __webpack_require__(36);
	
	var _AdminNavbar2 = _interopRequireDefault(_AdminNavbar);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _AdminSource = __webpack_require__(31);
	
	var _SearchSource = __webpack_require__(18);
	
	var _Defaults = __webpack_require__(34);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Themes = __webpack_require__(5);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _BackArrow = __webpack_require__(77);
	
	var _BackArrow2 = _interopRequireDefault(_BackArrow);
	
	var _ErrorModal = __webpack_require__(30);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	var _SuccessModal = __webpack_require__(37);
	
	var _SuccessModal2 = _interopRequireDefault(_SuccessModal);
	
	var _DialogModal = __webpack_require__(46);
	
	var _DialogModal2 = _interopRequireDefault(_DialogModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject, _Themes.Metrics.components.adminContent);
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject2, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base);
	
	var ArrowContainer = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base, _Themes.Metrics.margins.medium, _Themes.Fonts.style.Header);
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject4, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.customThemeSpacing);
	
	var ButtonContainer = _styledComponents2.default.div(_templateObject5);
	
	var EditCategory = function (_Component) {
	  _inherits(EditCategory, _Component);
	
	  function EditCategory(props) {
	    _classCallCheck(this, EditCategory);
	
	    var _this = _possibleConstructorReturn(this, (EditCategory.__proto__ || Object.getPrototypeOf(EditCategory)).call(this, props));
	
	    _this.state = {
	      create: false,
	      category: _ramda2.default.clone(_Defaults.categoryDefault),
	      modal: false
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    _this.handleDelete = _this.handleDelete.bind(_this);
	    _this.openDeleteModal = _this.openDeleteModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditCategory, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var params = this.props.params;
	
	      if (params.id !== 'new') {
	        (0, _SearchSource.searchCategories)({ id: params.id }).then(function (response) {
	          return _this2.setState({ category: response.data });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      } else {
	        this.setState({ create: true });
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var category = this.state.category;
	
	      category.name = event.target.value;
	      this.setState({ category: category });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var _this3 = this;
	
	      var _state = this.state;
	      var category = _state.category;
	      var create = _state.create;
	
	
	      if (create) {
	        (0, _AdminSource.createCategory)(category.name).then(function (response) {
	          return _this3.setState({
	            modal: 'success',
	            category: _ramda2.default.clone(_Defaults.categoryDefault)
	          });
	        }).catch(function (error) {
	          console.log(error);
	          _this3.setState({ modal: 'error' });
	        });
	      } else {
	        (0, _AdminSource.updateCategory)(category).then(function (response) {
	          return _this3.setState({ modal: 'success' });
	        }).catch(function (error) {
	          console.log(error);
	          _this3.setState({ modal: 'error' });
	        });
	      }
	    }
	  }, {
	    key: 'handleDelete',
	    value: function handleDelete() {
	      var _this4 = this;
	
	      var router = this.props.router;
	
	      (0, _AdminSource.deleteCategory)(this.state.category.id).then(function (response) {
	        return router.goBack();
	      }).catch(function (error) {
	        console.log(error);
	        _this4.setState({ modal: 'error' });
	      });
	    }
	  }, {
	    key: 'openDeleteModal',
	    value: function openDeleteModal() {
	      this.setState({ modal: 'dialog' });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.setState({ modal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var t = _props.t;
	      var router = _props.router;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	      var _state2 = this.state;
	      var category = _state2.category;
	      var modal = _state2.modal;
	      var create = _state2.create;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_AdminNavbar2.default, {
	          admin: admin,
	          fixedSearchBar: true,
	          dropdownLinks: dropdownLinks,
	          rightSideActions: create ? [] : [{
	            label: t('Delete Category'),
	            secondary: true,
	            onClick: this.openDeleteModal
	          }]
	        }),
	        _react2.default.createElement(_ErrorModal2.default, {
	          visible: modal === 'error',
	          message: t('There was an error on ' + (create ? 'creating' : 'updating') + ' the category'),
	          closeAction: this.closeModal,
	          header: t('Error')
	        }),
	        _react2.default.createElement(_SuccessModal2.default, {
	          visible: modal === 'success',
	          message: t('The category was successfully ' + (create ? 'created' : 'updated')),
	          closeAction: this.closeModal,
	          header: t('Category Updated')
	        }),
	        _react2.default.createElement(_DialogModal2.default, {
	          visible: modal === 'dialog',
	          message: t('Do you really want to delete the category?'),
	          closeAction: this.closeModal,
	          header: t('Delete Category'),
	          buttons: {
	            apply: { label: t('Delete'), onClick: this.handleDelete },
	            cancel: { label: t('Cancel'), onClick: this.closeModal }
	          }
	        }),
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            CustomThemeContainer,
	            null,
	            _react2.default.createElement(
	              ArrowContainer,
	              { onClick: function onClick() {
	                  return router.goBack();
	                } },
	              _react2.default.createElement(_BackArrow2.default, null),
	              _react2.default.createElement(
	                'span',
	                null,
	                create ? t('Insert Category') : category.name
	              )
	            ),
	            _react2.default.createElement(
	              CustomCardContainer,
	              {
	                title: create ? t('New Category') : t('Edit Category') },
	              _react2.default.createElement(_Input2.default, {
	                handleChange: this.handleChange,
	                title: t('Category Name'),
	                value: category.name
	              }),
	              _react2.default.createElement(
	                ButtonContainer,
	                null,
	                _react2.default.createElement(_Button2.default, {
	                  onClick: this.handleSubmit,
	                  label: create ? t('Add') : t('Save')
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditCategory;
	}(_react.Component);
	
	EditCategory.propTypes = {
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  params: _react.PropTypes.object,
	  admin: _react.PropTypes.object,
	  dropdownLinks: _react.PropTypes.array
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'admin'], { wait: true })(EditCategory);

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding-bottom: ', ';\n  border-bottom: ', ';\n'], ['\n  padding-bottom: ', ';\n  border-bottom: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['', ';'], ['', ';']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  height: 50px;\n  border-bottom: ', ';\n  padding: ', ' 0;\n  cursor: pointer;\n  position: relative;\n  svg {\n    position: absolute;\n    right: 0;\n    top: ', ';\n    float: right;\n    cursor: pointer;\n  }\n'], ['\n  height: 50px;\n  border-bottom: ', ';\n  padding: ', ' 0;\n  cursor: pointer;\n  position: relative;\n  svg {\n    position: absolute;\n    right: 0;\n    top: ', ';\n    float: right;\n    cursor: pointer;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n  max-height: ', ';\n  overflow-y: scroll;\n'], ['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n  max-height: ', ';\n  overflow-y: scroll;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  max-height: ', ';\n  overflow-y: scroll;\n'], ['\n  max-height: ', ';\n  overflow-y: scroll;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _immutable = __webpack_require__(29);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _AdminNavbar = __webpack_require__(36);
	
	var _AdminNavbar2 = _interopRequireDefault(_AdminNavbar);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _AdminSource = __webpack_require__(31);
	
	var _SearchSource = __webpack_require__(18);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Themes = __webpack_require__(5);
	
	var _Trash = __webpack_require__(89);
	
	var _Trash2 = _interopRequireDefault(_Trash);
	
	var _DialogModal = __webpack_require__(46);
	
	var _DialogModal2 = _interopRequireDefault(_DialogModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject, _Themes.Metrics.margins.base);
	
	var EditArea = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.margins.base, _Themes.Metrics.borders.default);
	
	var CategoryName = _styledComponents2.default.div(_templateObject3, _Themes.Fonts.style.Label);
	
	var Category = _styledComponents2.default.div(_templateObject4, _Themes.Metrics.borders.default, _Themes.Metrics.margins.base, _Themes.Metrics.margins.medium);
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject5, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.adminContent);
	
	var Container = _styledComponents2.default.div(_templateObject6, _Themes.Metrics.components.adminContent);
	
	var AdminCategories = function (_Component) {
	  _inherits(AdminCategories, _Component);
	
	  function AdminCategories(props) {
	    _classCallCheck(this, AdminCategories);
	
	    var _this = _possibleConstructorReturn(this, (AdminCategories.__proto__ || Object.getPrototypeOf(AdminCategories)).call(this, props));
	
	    _this.state = {
	      name: '',
	      categories: [],
	      categoryToDelete: null,
	      modal: false
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleDelete = _this.handleDelete.bind(_this);
	    _this.fetchCategories = _this.fetchCategories.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(AdminCategories, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var _state = this.state;
	      var name = _state.name;
	      var modal = _state.modal;
	      var categories = _state.categories;
	      var categoryToDelete = _state.categoryToDelete;
	
	      if (name !== nextState.name || modal !== nextState.modal || !(0, _immutable.fromJS)(nextState.categories).equals((0, _immutable.fromJS)(categories)) || categoryToDelete !== nextState.categoryToDelete) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.fetchCategories();
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var _this2 = this;
	
	      this.setState({ name: event.target.value }, function () {
	        return (0, _SearchSource.searchCategories)({
	          where: {
	            name: {
	              startsWith: _this2.state.name
	            }
	          }
	        }).then(function (response) {
	          return _this2.setState({ categories: response.data });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      });
	    }
	  }, {
	    key: 'selectCategoryToDelete',
	    value: function selectCategoryToDelete(el) {
	      this.setState({ categoryToDelete: el, modal: 'dialog' });
	    }
	  }, {
	    key: 'fetchCategories',
	    value: function fetchCategories() {
	      var _this3 = this;
	
	      return (0, _SearchSource.searchCategories)().then(function (response) {
	        return _this3.setState({ categories: response.data });
	      }).catch(function (error) {
	        return console.log(error);
	      });
	    }
	  }, {
	    key: 'handleDelete',
	    value: function handleDelete() {
	      var _this4 = this;
	
	      (0, _AdminSource.deleteCategory)(this.state.categoryToDelete.id).then(function (response) {
	        return _this4.setState({ modal: false }, _this4.fetchCategories());
	      }).catch(function (error) {
	        console.log(error);
	        _this4.setState({ modal: false });
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.setState({ modal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props = this.props;
	      var t = _props.t;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	      var router = _props.router;
	      var _state2 = this.state;
	      var name = _state2.name;
	      var categories = _state2.categories;
	      var modal = _state2.modal;
	
	      return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(_AdminNavbar2.default, {
	          admin: admin,
	          fixedSearchBar: true,
	          dropdownLinks: dropdownLinks,
	          rightSideActions: [{
	            label: t('Create Category'),
	            secondary: true,
	            onClick: function onClick() {
	              return router.push('/admin/categories/new');
	            }
	          }]
	        }),
	        _react2.default.createElement(
	          CustomThemeContainer,
	          null,
	          _react2.default.createElement(_DialogModal2.default, {
	            visible: modal === 'dialog',
	            header: t('Delete Category'),
	            message: t('Do you really want to delete the category?'),
	            buttons: {
	              apply: { label: t('Delete'), onClick: this.handleDelete },
	              cancel: { label: t('Cancel'), onClick: this.closeModal }
	            },
	            closeAction: this.closeModal
	          }),
	          _react2.default.createElement(
	            CustomCardContainer,
	            { title: t('Categories') },
	            _react2.default.createElement(
	              EditArea,
	              null,
	              _react2.default.createElement(_Input2.default, {
	                placeholder: t('Search category'),
	                handleChange: this.handleChange,
	                value: name
	              })
	            ),
	            categories && categories.length > 0 && categories.map(function (category, index) {
	              return _react2.default.createElement(
	                Category,
	                {
	                  key: 'category-' + index,
	                  onClick: function onClick() {
	                    return router.push('/admin/categories/' + category.id);
	                  } },
	                _react2.default.createElement(
	                  CategoryName,
	                  null,
	                  category.name
	                ),
	                _react2.default.createElement(_Trash2.default, {
	                  onClick: function onClick(event) {
	                    event.stopPropagation();
	                    _this5.selectCategoryToDelete(category);
	                  }
	                })
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminCategories;
	}(_react.Component);
	
	AdminCategories.propTypes = {
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  admin: _react.PropTypes.object,
	  dropdownLinks: _react.PropTypes.array
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'admin'], { wait: true })(AdminCategories);

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  overflow-y: scroll;\n  max-height: ', ';\n'], ['\n  overflow-y: scroll;\n  max-height: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['margin-top: ', ';'], ['margin-top: ', ';']),
	    _templateObject4 = _taggedTemplateLiteral(['', ';'], ['', ';']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  right: 0;\n  top: ', ';\n'], ['\n  position: absolute;\n  right: 0;\n  top: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  border-bottom: ', ';\n  height: 50px;\n  cursor: pointer;\n  padding: 18px 0;\n  position: relative;\n'], ['\n  border-bottom: ', ';\n  height: 50px;\n  cursor: pointer;\n  padding: 18px 0;\n  position: relative;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  border-bottom: ', ';\n  height: 50px;\n'], ['\n  border-bottom: ', ';\n  height: 50px;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n'], ['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(29);
	
	var _AdminNavbar = __webpack_require__(36);
	
	var _AdminNavbar2 = _interopRequireDefault(_AdminNavbar);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SearchSource = __webpack_require__(18);
	
	var _AdminSource = __webpack_require__(31);
	
	var _reactI18next = __webpack_require__(7);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _Trash = __webpack_require__(89);
	
	var _Trash2 = _interopRequireDefault(_Trash);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _Themes = __webpack_require__(5);
	
	var _ErrorModal = __webpack_require__(30);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	var _DialogModal = __webpack_require__(46);
	
	var _DialogModal2 = _interopRequireDefault(_DialogModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject, _Themes.Metrics.margins.base);
	
	var Container = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.components.adminContent);
	
	var List = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.base);
	
	var Name = _styledComponents2.default.div(_templateObject4, _Themes.Fonts.style.Label);
	
	var ThrashContainer = _styledComponents2.default.div(_templateObject5, _Themes.Metrics.margins.base);
	
	var City = _styledComponents2.default.div(_templateObject6, _Themes.Metrics.borders.default);
	
	var SearchContainer = _styledComponents2.default.div(_templateObject7, _Themes.Metrics.borders.defaultBorder);
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject8, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.customThemeSpacing);
	
	var AdminPictures = function (_Component) {
	  _inherits(AdminPictures, _Component);
	
	  function AdminPictures(props) {
	    _classCallCheck(this, AdminPictures);
	
	    var _this = _possibleConstructorReturn(this, (AdminPictures.__proto__ || Object.getPrototypeOf(AdminPictures)).call(this, props));
	
	    _this.state = {
	      cities: [],
	      cityToDelete: null,
	      name: '',
	      modal: false
	    };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleDelete = _this.handleDelete.bind(_this);
	    _this.fetchCities = _this.fetchCities.bind(_this);
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(AdminPictures, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var _state = this.state;
	      var name = _state.name;
	      var modal = _state.modal;
	      var cities = _state.cities;
	      var cityToDelete = _state.cityToDelete;
	
	      if (name !== nextState.name || modal !== nextState.modal || !(0, _immutable.fromJS)(nextState.cities).equals((0, _immutable.fromJS)(cities)) || cityToDelete !== nextState.cityToDelete) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.fetchCities();
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var _this2 = this;
	
	      this.setState({ name: event.target.value }, function () {
	        (0, _SearchSource.searchCities)({
	          where: {
	            city: {
	              startsWith: _this2.state.name
	            }
	          },
	          sort: 'city ASC'
	        }).then(function (response) {
	          return _this2.setState({ cities: response.data });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      });
	    }
	  }, {
	    key: 'fetchCities',
	    value: function fetchCities() {
	      var _this3 = this;
	
	      (0, _SearchSource.searchCities)({ sort: 'city ASC' }).then(function (response) {
	        return _this3.setState({ cities: response.data });
	      }).catch(function (error) {
	        return console.log(error);
	      });
	    }
	  }, {
	    key: 'handleDelete',
	    value: function handleDelete() {
	      var _this4 = this;
	
	      (0, _AdminSource.deleteCity)(this.state.cityToDelete.id).then(function (response) {
	        _this4.setState({ modal: false, name: '' }, function () {
	          return _this4.fetchCities();
	        });
	      }).catch(function (error) {
	        console.log(error);
	        _this4.toggleModal('error');
	      });
	    }
	  }, {
	    key: 'toggleModal',
	    value: function toggleModal(modal) {
	      this.setState({ modal: modal });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props = this.props;
	      var t = _props.t;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	      var router = _props.router;
	      var _state2 = this.state;
	      var name = _state2.name;
	      var cities = _state2.cities;
	      var modal = _state2.modal;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_AdminNavbar2.default, {
	          admin: admin,
	          fixedSearchBar: true,
	          dropdownLinks: dropdownLinks,
	          rightSideActions: [{
	            label: t('Create City'),
	            secondary: true,
	            onClick: function onClick() {
	              return router.push('/admin/locations/cities/new');
	            }
	          }]
	        }),
	        _react2.default.createElement(_ErrorModal2.default, {
	          visible: modal === 'error',
	          message: t('There was a problem when deleting a city'),
	          closeAction: function closeAction() {
	            return _this5.toggleModal(false);
	          },
	          header: t('Error')
	        }),
	        _react2.default.createElement(_DialogModal2.default, {
	          visible: modal === 'dialog',
	          message: t('Do you want to delete this city?'),
	          closeAction: function closeAction() {
	            return _this5.toggleModal(false);
	          },
	          buttons: {
	            apply: { label: t('Delete'), onClick: this.handleDelete },
	            cancel: {
	              label: t('Cancel'),
	              onClick: function onClick() {
	                return _this5.toggleModal(false);
	              }
	            }
	          }
	        }),
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            CustomThemeContainer,
	            null,
	            _react2.default.createElement(
	              CustomCardContainer,
	              { title: t('Cities') },
	              _react2.default.createElement(
	                SearchContainer,
	                null,
	                _react2.default.createElement(_Input2.default, {
	                  handleChange: this.handleChange,
	                  value: name,
	                  placeholder: t('Search for cities')
	                })
	              ),
	              _react2.default.createElement(
	                List,
	                null,
	                cities && cities.length > 0 && cities.map(function (city, index) {
	                  return _react2.default.createElement(
	                    City,
	                    {
	                      key: 'city-' + city.city + '-' + index,
	                      onClick: function onClick() {
	                        return router.push('/admin/locations/cities/' + city.id);
	                      } },
	                    _react2.default.createElement(
	                      Name,
	                      null,
	                      city.city
	                    ),
	                    _react2.default.createElement(
	                      ThrashContainer,
	                      null,
	                      _react2.default.createElement(_Trash2.default, {
	                        onClick: function onClick(event) {
	                          event.stopPropagation();
	                          _this5.setState({
	                            cityToDelete: city,
	                            modal: 'dialog'
	                          });
	                        }
	                      })
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminPictures;
	}(_react.Component);
	
	AdminPictures.propTypes = {
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  admin: _react.PropTypes.object,
	  dropdownLinks: _react.PropTypes.array
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'admin'], { wait: true })(AdminPictures);

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  overflow-y: scroll;\n  max-height: ', ';\n'], ['\n  overflow-y: scroll;\n  max-height: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['margin-top: ', ';'], ['margin-top: ', ';']),
	    _templateObject4 = _taggedTemplateLiteral(['', ';'], ['', ';']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  right: 0;\n  top: ', ';\n'], ['\n  position: absolute;\n  right: 0;\n  top: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  border-bottom: ', ';\n  height: 50px;\n  cursor: pointer;\n  padding: 18px 0;\n  position: relative;\n'], ['\n  border-bottom: ', ';\n  height: 50px;\n  cursor: pointer;\n  padding: 18px 0;\n  position: relative;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  border-bottom: ', ';\n  height: 50px;\n'], ['\n  border-bottom: ', ';\n  height: 50px;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n'], ['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(29);
	
	var _AdminNavbar = __webpack_require__(36);
	
	var _AdminNavbar2 = _interopRequireDefault(_AdminNavbar);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SearchSource = __webpack_require__(18);
	
	var _AdminSource = __webpack_require__(31);
	
	var _reactI18next = __webpack_require__(7);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _Trash = __webpack_require__(89);
	
	var _Trash2 = _interopRequireDefault(_Trash);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _Themes = __webpack_require__(5);
	
	var _ErrorModal = __webpack_require__(30);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	var _DialogModal = __webpack_require__(46);
	
	var _DialogModal2 = _interopRequireDefault(_DialogModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject, _Themes.Metrics.margins.base);
	
	var Container = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.components.adminContent);
	
	var List = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.base);
	
	var Name = _styledComponents2.default.div(_templateObject4, _Themes.Fonts.style.Label);
	
	var ThrashContainer = _styledComponents2.default.div(_templateObject5, _Themes.Metrics.margins.base);
	
	var Continent = _styledComponents2.default.div(_templateObject6, _Themes.Metrics.borders.default);
	
	var SearchContainer = _styledComponents2.default.div(_templateObject7, _Themes.Metrics.borders.defaultBorder);
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject8, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.customThemeSpacing);
	
	var AdminContinents = function (_Component) {
	  _inherits(AdminContinents, _Component);
	
	  function AdminContinents(props) {
	    _classCallCheck(this, AdminContinents);
	
	    var _this = _possibleConstructorReturn(this, (AdminContinents.__proto__ || Object.getPrototypeOf(AdminContinents)).call(this, props));
	
	    _this.state = {
	      continents: [],
	      continentToDelete: null,
	      name: '',
	      modal: false
	    };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleDelete = _this.handleDelete.bind(_this);
	    _this.fetchContinents = _this.fetchContinents.bind(_this);
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(AdminContinents, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var _state = this.state;
	      var name = _state.name;
	      var modal = _state.modal;
	      var continents = _state.continents;
	      var continentToDelete = _state.continentToDelete;
	
	      if (name !== nextState.name || modal !== nextState.modal || !(0, _immutable.fromJS)(nextState.continents).equals((0, _immutable.fromJS)(continents)) || continentToDelete !== nextState.continentToDelete) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.fetchContinents();
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var _this2 = this;
	
	      this.setState({ name: event.target.value }, function () {
	        (0, _SearchSource.searchContinents)({
	          where: { name: { startsWith: _this2.state.name } },
	          sort: 'name ASC'
	        }).then(function (response) {
	          return _this2.setState({ continents: response.data });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      });
	    }
	  }, {
	    key: 'fetchContinents',
	    value: function fetchContinents() {
	      var _this3 = this;
	
	      (0, _SearchSource.searchContinents)({ sort: 'name ASC' }).then(function (response) {
	        return _this3.setState({ continents: response.data });
	      }).catch(function (error) {
	        return console.log(error);
	      });
	    }
	  }, {
	    key: 'handleDelete',
	    value: function handleDelete() {
	      var _this4 = this;
	
	      (0, _AdminSource.deleteContinent)(this.state.continentToDelete.id).then(function (response) {
	        _this4.setState({ modal: false, name: '' }, function () {
	          return _this4.fetchContinents();
	        });
	      }).catch(function (error) {
	        console.log(error);
	        _this4.toggleModal('error');
	      });
	    }
	  }, {
	    key: 'toggleModal',
	    value: function toggleModal(modal) {
	      this.setState({ modal: modal });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props = this.props;
	      var t = _props.t;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	      var router = _props.router;
	      var _state2 = this.state;
	      var name = _state2.name;
	      var continents = _state2.continents;
	      var modal = _state2.modal;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_AdminNavbar2.default, {
	          admin: admin,
	          fixedSearchBar: true,
	          dropdownLinks: dropdownLinks,
	          rightSideActions: [{
	            label: t('Create Continent'),
	            secondary: true,
	            onClick: function onClick() {
	              return router.push('/admin/locations/continents/new');
	            }
	          }]
	        }),
	        _react2.default.createElement(_ErrorModal2.default, {
	          visible: modal === 'error',
	          message: t('There was a problem when deleting a continent'),
	          closeAction: function closeAction() {
	            return _this5.toggleModal(false);
	          },
	          header: t('Error')
	        }),
	        _react2.default.createElement(_DialogModal2.default, {
	          visible: modal === 'dialog',
	          message: t('Do you want to delete this continent?'),
	          closeAction: function closeAction() {
	            return _this5.toggleModal(false);
	          },
	          buttons: {
	            apply: { label: t('Delete'), onClick: this.handleDelete },
	            cancel: {
	              label: t('Cancel'),
	              onClick: function onClick() {
	                return _this5.toggleModal(false);
	              }
	            }
	          }
	        }),
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            CustomThemeContainer,
	            null,
	            _react2.default.createElement(
	              CustomCardContainer,
	              { title: t('Continents') },
	              _react2.default.createElement(
	                SearchContainer,
	                null,
	                _react2.default.createElement(_Input2.default, {
	                  handleChange: this.handleChange,
	                  value: name,
	                  placeholder: t('Search for continents')
	                })
	              ),
	              _react2.default.createElement(
	                List,
	                null,
	                continents && continents.length > 0 && continents.map(function (continent, index) {
	                  return _react2.default.createElement(
	                    Continent,
	                    {
	                      key: 'continent-' + continent.name + '-' + index,
	                      onClick: function onClick() {
	                        return router.push('/admin/locations/continents/' + continent.id);
	                      } },
	                    _react2.default.createElement(
	                      Name,
	                      null,
	                      continent.name
	                    ),
	                    _react2.default.createElement(
	                      ThrashContainer,
	                      null,
	                      _react2.default.createElement(_Trash2.default, {
	                        onClick: function onClick(event) {
	                          event.stopPropagation();
	                          _this5.setState({
	                            continentToDelete: continent,
	                            modal: 'dialog'
	                          });
	                        }
	                      })
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminContinents;
	}(_react.Component);
	
	AdminContinents.propTypes = {
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  admin: _react.PropTypes.object,
	  dropdownLinks: _react.PropTypes.array
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'admin'], { wait: true })(AdminContinents);

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  overflow-y: scroll;\n  max-height: ', ';\n'], ['\n  overflow-y: scroll;\n  max-height: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['margin-top: ', ';'], ['margin-top: ', ';']),
	    _templateObject4 = _taggedTemplateLiteral(['', ';'], ['', ';']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  right: 0;\n  top: ', ';\n'], ['\n  position: absolute;\n  right: 0;\n  top: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  border-bottom: ', ';\n  height: 50px;\n  cursor: pointer;\n  padding: 18px 0;\n  position: relative;\n'], ['\n  border-bottom: ', ';\n  height: 50px;\n  cursor: pointer;\n  padding: 18px 0;\n  position: relative;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  border-bottom: ', ';\n  height: 50px;\n'], ['\n  border-bottom: ', ';\n  height: 50px;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n'], ['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(29);
	
	var _AdminNavbar = __webpack_require__(36);
	
	var _AdminNavbar2 = _interopRequireDefault(_AdminNavbar);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SearchSource = __webpack_require__(18);
	
	var _AdminSource = __webpack_require__(31);
	
	var _reactI18next = __webpack_require__(7);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _Trash = __webpack_require__(89);
	
	var _Trash2 = _interopRequireDefault(_Trash);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _Themes = __webpack_require__(5);
	
	var _ErrorModal = __webpack_require__(30);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	var _DialogModal = __webpack_require__(46);
	
	var _DialogModal2 = _interopRequireDefault(_DialogModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject, _Themes.Metrics.margins.base);
	
	var Container = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.components.adminContent);
	
	var List = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.base);
	
	var Name = _styledComponents2.default.div(_templateObject4, _Themes.Fonts.style.Label);
	
	var ThrashContainer = _styledComponents2.default.div(_templateObject5, _Themes.Metrics.margins.base);
	
	var Country = _styledComponents2.default.div(_templateObject6, _Themes.Metrics.borders.default);
	
	var SearchContainer = _styledComponents2.default.div(_templateObject7, _Themes.Metrics.borders.defaultBorder);
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject8, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.customThemeSpacing);
	
	var AdminCountries = function (_Component) {
	  _inherits(AdminCountries, _Component);
	
	  function AdminCountries(props) {
	    _classCallCheck(this, AdminCountries);
	
	    var _this = _possibleConstructorReturn(this, (AdminCountries.__proto__ || Object.getPrototypeOf(AdminCountries)).call(this, props));
	
	    _this.state = {
	      countries: [],
	      countryToDelete: null,
	      name: '',
	      modal: false
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleDelete = _this.handleDelete.bind(_this);
	    _this.fetchCountries = _this.fetchCountries.bind(_this);
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(AdminCountries, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var _state = this.state;
	      var name = _state.name;
	      var modal = _state.modal;
	      var countries = _state.countries;
	      var countryToDelete = _state.countryToDelete;
	
	      if (name !== nextState.name || modal !== nextState.modal || !(0, _immutable.fromJS)(nextState.countries).equals((0, _immutable.fromJS)(countries)) || countryToDelete !== nextState.countryToDelete) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.fetchCountries();
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var _this2 = this;
	
	      this.setState({ name: event.target.value }, function () {
	        (0, _SearchSource.searchCountries)({
	          where: {
	            name: {
	              startsWith: _this2.state.name
	            }
	          },
	          sort: 'name ASC'
	        }).then(function (response) {
	          return _this2.setState({ countries: response.data });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      });
	    }
	  }, {
	    key: 'fetchCountries',
	    value: function fetchCountries() {
	      var _this3 = this;
	
	      (0, _SearchSource.searchCountries)({ sort: 'name ASC' }).then(function (response) {
	        return _this3.setState({ countries: response.data });
	      }).catch(function (error) {
	        return console.log(error);
	      });
	    }
	  }, {
	    key: 'handleDelete',
	    value: function handleDelete() {
	      var _this4 = this;
	
	      (0, _AdminSource.deleteCountry)(this.state.countryToDelete.id).then(function (response) {
	        _this4.setState({ modal: false, name: '' }, function () {
	          return _this4.fetchCountries();
	        });
	      }).catch(function (error) {
	        console.log(error);
	        _this4.toggleModal('error');
	      });
	    }
	  }, {
	    key: 'toggleModal',
	    value: function toggleModal(modal) {
	      this.setState({ modal: modal });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props = this.props;
	      var t = _props.t;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	      var router = _props.router;
	      var _state2 = this.state;
	      var name = _state2.name;
	      var countries = _state2.countries;
	      var modal = _state2.modal;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_AdminNavbar2.default, {
	          admin: admin,
	          fixedSearchBar: true,
	          dropdownLinks: dropdownLinks,
	          rightSideActions: [{
	            label: t('Create Country'),
	            secondary: true,
	            onClick: function onClick() {
	              return router.push('/admin/locations/countries/new');
	            }
	          }]
	        }),
	        _react2.default.createElement(_ErrorModal2.default, {
	          visible: modal === 'error',
	          message: t('There was a problem when deleting a country'),
	          closeAction: function closeAction() {
	            return _this5.toggleModal(false);
	          },
	          header: t('Error')
	        }),
	        _react2.default.createElement(_DialogModal2.default, {
	          visible: modal === 'dialog',
	          message: t('Do you want to delete this country?'),
	          closeAction: function closeAction() {
	            return _this5.toggleModal(false);
	          },
	          buttons: {
	            apply: { label: t('Delete'), onClick: this.handleDelete },
	            cancel: {
	              label: t('Cancel'),
	              onClick: function onClick() {
	                return _this5.toggleModal(false);
	              }
	            }
	          }
	        }),
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            CustomThemeContainer,
	            null,
	            _react2.default.createElement(
	              CustomCardContainer,
	              { title: t('Countries') },
	              _react2.default.createElement(
	                SearchContainer,
	                null,
	                _react2.default.createElement(_Input2.default, {
	                  handleChange: this.handleChange,
	                  value: name,
	                  placeholder: t('Search for countries')
	                })
	              ),
	              _react2.default.createElement(
	                List,
	                null,
	                countries && countries.length > 0 && countries.map(function (country, index) {
	                  return _react2.default.createElement(
	                    Country,
	                    {
	                      key: 'country-' + country.name + '-' + index,
	                      onClick: function onClick() {
	                        return router.push('/admin/locations/countries/' + country.id);
	                      } },
	                    _react2.default.createElement(
	                      Name,
	                      null,
	                      country.name
	                    ),
	                    _react2.default.createElement(
	                      ThrashContainer,
	                      null,
	                      _react2.default.createElement(_Trash2.default, {
	                        onClick: function onClick(event) {
	                          event.stopPropagation();
	                          _this5.setState({
	                            countryToDelete: country,
	                            modal: 'dialog'
	                          });
	                        }
	                      })
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminCountries;
	}(_react.Component);
	
	AdminCountries.propTypes = {
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  admin: _react.PropTypes.object,
	  dropdownLinks: _react.PropTypes.array
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'admin'], { wait: true })(AdminCountries);

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  max-height: ', ';\n  overflow-y: scroll;\n'], ['\n  max-height: ', ';\n  overflow-y: scroll;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin: ', ' 0;\n  cursor: pointer;\n  span {\n    margin-left: ', ';\n    ', ';\n  }\n'], ['\n  margin: ', ' 0;\n  cursor: pointer;\n  span {\n    margin-left: ', ';\n    ', ';\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  height: 136px;\n  width: 136px;\n  background: ', ';\n  background-size: cover;\n  position: relative;\n'], ['\n  height: 136px;\n  width: 136px;\n  background: ', ';\n  background-size: cover;\n  position: relative;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  background: ', ';\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  cursor: pointer;\n  right: -', ';\n  bottom: -', ';\n  border-radius: 50%;\n  svg {\n    margin: 8px;\n    #icon-outline {\n      fill: ', ';\n    }\n  }\n\n  &:hover {\n    background: ', ';\n  }\n'], ['\n  background: ', ';\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  cursor: pointer;\n  right: -', ';\n  bottom: -', ';\n  border-radius: 50%;\n  svg {\n    margin: 8px;\n    #icon-outline {\n      fill: ', ';\n    }\n  }\n\n  &:hover {\n    background: ', ';\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n  margin: 0 auto;\n  text-align: center;\n  padding: ', ';\n  cursor: pointer;\n\n  svg {\n    margin: 0 auto;\n    margin-bottom: ', ';\n    display: block;\n    #plus-icon {\n      fill: ', ';\n    }\n  }\n'], ['\n  ', ';\n  color: ', ';\n  margin: 0 auto;\n  text-align: center;\n  padding: ', ';\n  cursor: pointer;\n\n  svg {\n    margin: 0 auto;\n    margin-bottom: ', ';\n    display: block;\n    #plus-icon {\n      fill: ', ';\n    }\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  ', ';\n  margin-bottom: ', ';\n'], ['\n  ', ';\n  margin-bottom: ', ';\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  padding-left: ', ';\n  padding-right: ', ';\n  margin-top: ', ';\n'], ['\n  padding-left: ', ';\n  padding-right: ', ';\n  margin-top: ', ';\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  padding: 0 32px !important; \n'], ['\n  padding: 0 32px !important; \n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  ', ';\n  margin-top: ', ';\n  color: ', ';\n'], ['\n  ', ';\n  margin-top: ', ';\n  color: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _SearchSource = __webpack_require__(18);
	
	var _AdminSource = __webpack_require__(31);
	
	var _reactI18next = __webpack_require__(7);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _AdminNavbar = __webpack_require__(36);
	
	var _AdminNavbar2 = _interopRequireDefault(_AdminNavbar);
	
	var _Themes = __webpack_require__(5);
	
	var _BackArrow = __webpack_require__(77);
	
	var _BackArrow2 = _interopRequireDefault(_BackArrow);
	
	var _Edit = __webpack_require__(175);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _Add = __webpack_require__(130);
	
	var _Add2 = _interopRequireDefault(_Add);
	
	var _SearchableDropdown = __webpack_require__(64);
	
	var _SearchableDropdown2 = _interopRequireDefault(_SearchableDropdown);
	
	var _UploadPicture = __webpack_require__(128);
	
	var _UploadPicture2 = _interopRequireDefault(_UploadPicture);
	
	var _Textarea = __webpack_require__(74);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _SuccessModal = __webpack_require__(37);
	
	var _SuccessModal2 = _interopRequireDefault(_SuccessModal);
	
	var _ErrorModal = __webpack_require__(30);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	var _DialogModal = __webpack_require__(46);
	
	var _DialogModal2 = _interopRequireDefault(_DialogModal);
	
	var _Defaults = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject, _Themes.Metrics.components.adminContent);
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject2, _Themes.Metrics.margins.base);
	
	var BackArrowContainer = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base, _Themes.Fonts.style.Header);
	
	var Picture = _styledComponents2.default.div(_templateObject4, function (props) {
	  return props.imageSrc ? 'url(\'' + props.imageSrc + '\') no-repeat center' : _Themes.Colors.lightGrey;
	});
	
	var EditIcon = _styledComponents2.default.div(_templateObject5, _Themes.Colors.lightGrey, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base, _Themes.Colors.white, _Themes.Colors.darkGrey);
	
	var ImportPicture = _styledComponents2.default.div(_templateObject6, _Themes.Fonts.style.Text, _Themes.Colors.white, _Themes.Metrics.margins.larger, _Themes.Metrics.margins.medium, _Themes.Colors.white);
	
	var FormTitle = _styledComponents2.default.div(_templateObject7, _Themes.Fonts.style.Label, _Themes.Metrics.margins.small);
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject8, function (props) {
	  return props.noPadLeft ? 0 : _Themes.Metrics.margins.small;
	}, function (props) {
	  return props.noPadRight ? 0 : _Themes.Metrics.margins.small;
	}, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	});
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject9);
	
	var Error = _styledComponents2.default.div(_templateObject10, _Themes.Fonts.style.Input, _Themes.Metrics.margins.tiny, _Themes.Colors.red);
	
	var EditPictures = function (_Component) {
	  _inherits(EditPictures, _Component);
	
	  function EditPictures(props) {
	    _classCallCheck(this, EditPictures);
	
	    var _this = _possibleConstructorReturn(this, (EditPictures.__proto__ || Object.getPrototypeOf(EditPictures)).call(this, props));
	
	    _this.state = {
	      city: _ramda2.default.clone(_Defaults.cityDefault),
	      countries: [],
	      countryName: '',
	      imageError: '',
	      modal: '',
	      create: false
	    };
	    _this.handleUpload = _this.handleUpload.bind(_this);
	    _this.handleUpdate = _this.handleUpdate.bind(_this);
	    _this.handleDeleteCity = _this.handleDeleteCity.bind(_this);
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    _this.handleError = _this.handleError.bind(_this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.handleSearchCountry = _this.handleSearchCountry.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditPictures, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var params = this.props.params;
	
	      if (params.id !== 'new') {
	        (0, _SearchSource.searchCities)({ id: params.id }).then(function (response) {
	          return _this2.setState({
	            city: response.data,
	            countryName: response.data.country.name
	          });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      } else {
	        this.setState({ create: true });
	      }
	    }
	  }, {
	    key: 'handleUpload',
	    value: function handleUpload(file, result) {
	      var city = this.state.city;
	
	      city.picture = { file: file, result: result };
	      this.setState({ city: city, imageError: null });
	    }
	  }, {
	    key: 'handleUpdate',
	    value: function handleUpdate() {
	      var _this3 = this;
	
	      var _state = this.state;
	      var city = _state.city;
	      var create = _state.create;
	
	      if (create) {
	        (0, _AdminSource.createCity)(city).then(function (response) {
	          var cityCreated = response.data[0] || response.data;
	          _this3.setState({ city: cityCreated, modal: 'success' });
	        }).catch(function (error) {
	          console.log(error);
	          _this3.setState({ modal: 'error' });
	        });
	      } else {
	        (0, _AdminSource.updateCity)(city).then(function (response) {
	          _this3.setState({ city: response.data, modal: 'success' });
	        }).catch(function (error) {
	          console.log(error);
	          _this3.setState({ modal: 'error' });
	        });
	      }
	    }
	  }, {
	    key: 'handleSearchCountry',
	    value: function handleSearchCountry(event) {
	      var _this4 = this;
	
	      this.setState({ countryName: event.target.value }, function () {
	        (0, _SearchSource.searchCountries)({
	          where: { name: { startsWith: _this4.state.countryName } }
	        }).then(function (response) {
	          return _this4.setState({ countries: response.data });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      });
	    }
	  }, {
	    key: 'handleDeleteCity',
	    value: function handleDeleteCity() {
	      var _this5 = this;
	
	      (0, _AdminSource.deleteCity)(this.state.city.id).then(function (response) {
	        return _this5.props.router.goBack();
	      }).catch(function (error) {
	        console.log(error);
	        _this5.setState({ modal: 'error' });
	      });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event, key) {
	      var city = this.state.city;
	
	      if (key === 'lat' || key === 'lng') {
	        city.latlng[key] = event.target.value;
	      } else {
	        city[key] = event.target.value;
	      }
	      this.setState({ city: city });
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(el) {
	      var city = this.state.city;
	
	      city.country = el;
	      this.setState({ city: city, countryName: el.name });
	    }
	  }, {
	    key: 'toggleModal',
	    value: function toggleModal(modal) {
	      this.setState({ modal: modal });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      var t = this.props.t;
	
	      this.setState({
	        imageError: t('Image too large (2MB max) or has an invalid type')
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props = this.props;
	      var t = _props.t;
	      var router = _props.router;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	      var _state2 = this.state;
	      var city = _state2.city;
	      var modal = _state2.modal;
	      var imageError = _state2.imageError;
	      var create = _state2.create;
	      var countryName = _state2.countryName;
	      var countries = _state2.countries;
	
	      var adminActions = [{ label: t('Save'), secondary: true, onClick: this.handleUpdate }];
	      if (!create) {
	        adminActions.push({
	          label: t('Delete City'),
	          cancel: true,
	          onClick: function onClick() {
	            return _this6.toggleModal('dialog');
	          }
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_AdminNavbar2.default, {
	          admin: admin,
	          dropdownLinks: dropdownLinks,
	          fixedSearchBar: true,
	          rightSideActions: adminActions
	        }),
	        _react2.default.createElement(_SuccessModal2.default, {
	          visible: modal === 'success',
	          message: t('City successfuly ' + (create ? 'created' : 'updated') + '.'),
	          header: t('City ' + (create ? 'Created' : 'Updated')),
	          closeAction: this.toggleModal
	        }),
	        _react2.default.createElement(_ErrorModal2.default, {
	          visible: modal === 'error',
	          message: t('There was a problem when ' + (create ? 'creating' : 'updating') + ' the city.'),
	          header: t('Error'),
	          closeAction: this.toggleModal
	        }),
	        _react2.default.createElement(_DialogModal2.default, {
	          visible: modal === 'dialog',
	          message: t('Do you want to delete this city?'),
	          header: t('Delete City'),
	          closeAction: this.toggleModal,
	          buttons: {
	            apply: {
	              label: 'Cancel',
	              onClick: this.toggleModal
	            },
	            cancel: {
	              label: 'Delete',
	              onClick: this.handleDeleteCity
	            }
	          }
	        }),
	        _react2.default.createElement(
	          Container,
	          null,
	          city && _react2.default.createElement(
	            CustomThemeContainer,
	            null,
	            _react2.default.createElement(
	              BackArrowContainer,
	              null,
	              _react2.default.createElement(_BackArrow2.default, { onClick: function onClick() {
	                  return router.goBack();
	                } }),
	              _react2.default.createElement(
	                'span',
	                { className: 'name' },
	                create ? t('Insert City') : city.city
	              )
	            ),
	            _react2.default.createElement(
	              CustomCardContainer,
	              {
	                title: create ? t('Create New City') : t('Edit City') },
	              _react2.default.createElement(
	                CustomGrid,
	                { noPadTop: true, noPadLeft: true, noPadRight: true },
	                _react2.default.createElement(_Input2.default, {
	                  value: city.city,
	                  title: t('City'),
	                  handleChange: function handleChange(event) {
	                    return _this6.handleChange(event, 'city');
	                  },
	                  placeholder: t('City Name')
	                })
	              ),
	              _react2.default.createElement(
	                CustomGrid,
	                { noPadLeft: true, noPadRight: true },
	                _react2.default.createElement(
	                  CustomGrid,
	                  { xs: 1 / 3, noPadLeft: true, noPadTop: true },
	                  _react2.default.createElement(
	                    FormTitle,
	                    null,
	                    t('Country')
	                  ),
	                  _react2.default.createElement(_SearchableDropdown2.default, {
	                    value: countryName,
	                    handleSelect: this.handleSelect,
	                    handleSearch: this.handleSearchCountry,
	                    placeholder: t('Country name'),
	                    options: countries,
	                    accessor: function accessor(d) {
	                      return d.name;
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  CustomGrid,
	                  { xs: 1 / 3, noPadTop: true },
	                  _react2.default.createElement(_Input2.default, {
	                    value: '' + city.latlng.lat,
	                    title: t('Latitude'),
	                    placeholder: t('Latitude'),
	                    handleChange: function handleChange(event) {
	                      return _this6.handleChange(event, 'lat');
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  CustomGrid,
	                  { xs: 1 / 3, noPadRight: true, noPadTop: true },
	                  _react2.default.createElement(_Input2.default, {
	                    value: '' + city.latlng.lng,
	                    title: t('Longitude'),
	                    handleChange: function handleChange(event) {
	                      return _this6.handleChange(event, 'lng');
	                    },
	                    placeholder: t('Longitude')
	                  })
	                ),
	                _react2.default.createElement(
	                  CustomGrid,
	                  { noPadLeft: true, noPadRight: true },
	                  _react2.default.createElement(_Textarea2.default, {
	                    title: t('Description'),
	                    value: city.description,
	                    handleChange: function handleChange(event) {
	                      return _this6.handleChange(event, 'description');
	                    },
	                    placeholder: t('City description')
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                CustomGrid,
	                { noPadLeft: true, noPadRight: true },
	                _react2.default.createElement(
	                  Picture,
	                  {
	                    imageSrc: city.picture && city.picture.result || city.picture },
	                  _react2.default.createElement(_UploadPicture2.default, {
	                    uploadButton: city.picture ? _react2.default.createElement(
	                      EditIcon,
	                      null,
	                      _react2.default.createElement(_Edit2.default, null)
	                    ) : _react2.default.createElement(
	                      ImportPicture,
	                      null,
	                      _react2.default.createElement(_Add2.default, null),
	                      t('Import Picture')
	                    ),
	                    handleError: this.handleError,
	                    handleUploaded: this.handleUpload
	                  })
	                ),
	                imageError && _react2.default.createElement(
	                  Error,
	                  null,
	                  imageError
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditPictures;
	}(_react.Component);
	
	EditPictures.propTypes = {
	  router: _react.PropTypes.object,
	  params: _react.PropTypes.object,
	  t: _react.PropTypes.func,
	  admin: _react.PropTypes.object,
	  dropdownLinks: _react.PropTypes.array
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'admin'], { wait: true })(EditPictures);

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  max-height: ', ';\n  overflow-y: scroll;\n'], ['\n  max-height: ', ';\n  overflow-y: scroll;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin: ', ' 0;\n  cursor: pointer;\n  span {\n    margin-left: ', ';\n    ', ';\n  }\n'], ['\n  margin: ', ' 0;\n  cursor: pointer;\n  span {\n    margin-left: ', ';\n    ', ';\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  height: 136px;\n  width: 136px;\n  background: ', ';\n  background-size: cover;\n  position: relative;\n'], ['\n  height: 136px;\n  width: 136px;\n  background: ', ';\n  background-size: cover;\n  position: relative;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  background: ', ';\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  cursor: pointer;\n  right: -', ';\n  bottom: -', ';\n  border-radius: 50%;\n  svg {\n    margin: 8px;\n    #icon-outline {\n      fill: ', ';\n    }\n  }\n\n  &:hover {\n    background: ', ';\n  }\n'], ['\n  background: ', ';\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  cursor: pointer;\n  right: -', ';\n  bottom: -', ';\n  border-radius: 50%;\n  svg {\n    margin: 8px;\n    #icon-outline {\n      fill: ', ';\n    }\n  }\n\n  &:hover {\n    background: ', ';\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n  margin: 0 auto;\n  text-align: center;\n  padding: ', ';\n  cursor: pointer;\n\n  svg {\n    margin: 0 auto;\n    margin-bottom: ', ';\n    display: block;\n    #plus-icon {\n      fill: ', ';\n    }\n  }\n'], ['\n  ', ';\n  color: ', ';\n  margin: 0 auto;\n  text-align: center;\n  padding: ', ';\n  cursor: pointer;\n\n  svg {\n    margin: 0 auto;\n    margin-bottom: ', ';\n    display: block;\n    #plus-icon {\n      fill: ', ';\n    }\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  padding-left: ', ';\n  padding-right: ', ';\n  margin-top: ', ';\n'], ['\n  padding-left: ', ';\n  padding-right: ', ';\n  margin-top: ', ';\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  padding: 0 32px !important; \n'], ['\n  padding: 0 32px !important; \n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  ', ';\n  margin-top: ', ';\n  color: ', ';\n'], ['\n  ', ';\n  margin-top: ', ';\n  color: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _SearchSource = __webpack_require__(18);
	
	var _AdminSource = __webpack_require__(31);
	
	var _reactI18next = __webpack_require__(7);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _AdminNavbar = __webpack_require__(36);
	
	var _AdminNavbar2 = _interopRequireDefault(_AdminNavbar);
	
	var _Themes = __webpack_require__(5);
	
	var _BackArrow = __webpack_require__(77);
	
	var _BackArrow2 = _interopRequireDefault(_BackArrow);
	
	var _Edit = __webpack_require__(175);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _Add = __webpack_require__(130);
	
	var _Add2 = _interopRequireDefault(_Add);
	
	var _Textarea = __webpack_require__(74);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _UploadPicture = __webpack_require__(128);
	
	var _UploadPicture2 = _interopRequireDefault(_UploadPicture);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _SuccessModal = __webpack_require__(37);
	
	var _SuccessModal2 = _interopRequireDefault(_SuccessModal);
	
	var _ErrorModal = __webpack_require__(30);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	var _DialogModal = __webpack_require__(46);
	
	var _DialogModal2 = _interopRequireDefault(_DialogModal);
	
	var _Defaults = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject, _Themes.Metrics.components.adminContent);
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject2, _Themes.Metrics.margins.base);
	
	var BackArrowContainer = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base, _Themes.Fonts.style.Header);
	
	var Picture = _styledComponents2.default.div(_templateObject4, function (props) {
	  return props.imageSrc ? 'url(\'' + props.imageSrc + '\') no-repeat center' : _Themes.Colors.lightGrey;
	});
	
	var EditIcon = _styledComponents2.default.div(_templateObject5, _Themes.Colors.lightGrey, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base, _Themes.Colors.white, _Themes.Colors.darkGrey);
	
	var ImportPicture = _styledComponents2.default.div(_templateObject6, _Themes.Fonts.style.Text, _Themes.Colors.white, _Themes.Metrics.margins.larger, _Themes.Metrics.margins.medium, _Themes.Colors.white);
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject7, function (props) {
	  return props.noPadLeft ? 0 : _Themes.Metrics.margins.small;
	}, function (props) {
	  return props.noPadRight ? 0 : _Themes.Metrics.margins.small;
	}, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	});
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject8);
	
	var Error = _styledComponents2.default.div(_templateObject9, _Themes.Fonts.style.Input, _Themes.Metrics.margins.tiny, _Themes.Colors.red);
	
	var EditPictures = function (_Component) {
	  _inherits(EditPictures, _Component);
	
	  function EditPictures(props) {
	    _classCallCheck(this, EditPictures);
	
	    var _this = _possibleConstructorReturn(this, (EditPictures.__proto__ || Object.getPrototypeOf(EditPictures)).call(this, props));
	
	    _this.state = {
	      continent: _ramda2.default.clone(_Defaults.continentDefault),
	      imageError: '',
	      modal: '',
	      create: false
	    };
	    _this.handleUpload = _this.handleUpload.bind(_this);
	    _this.handleUpdate = _this.handleUpdate.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleDeleteContinent = _this.handleDeleteContinent.bind(_this);
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    _this.handleError = _this.handleError.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditPictures, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var params = this.props.params;
	
	      if (params.id !== 'new') {
	        (0, _SearchSource.searchContinents)({ id: params.id }).then(function (response) {
	          return _this2.setState({ continent: response.data });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      } else {
	        this.setState({ create: true });
	      }
	    }
	  }, {
	    key: 'handleUpload',
	    value: function handleUpload(file, result) {
	      var continent = this.state.continent;
	
	      continent.picture = { file: file, result: result };
	      this.setState({ continent: continent, imageError: null });
	    }
	  }, {
	    key: 'handleUpdate',
	    value: function handleUpdate() {
	      var _this3 = this;
	
	      var _state = this.state;
	      var continent = _state.continent;
	      var create = _state.create;
	
	      if (create) {
	        (0, _AdminSource.createContinent)(continent).then(function (response) {
	          var continentCreated = response.data[0] || response.data;
	          _this3.setState({ continent: continentCreated, modal: 'success' });
	        }).catch(function (error) {
	          console.log(error);
	          _this3.setState({ modal: 'error' });
	        });
	      } else {
	        (0, _AdminSource.updateContinent)(continent).then(function (response) {
	          _this3.setState({ continent: response.data, modal: 'success' });
	        }).catch(function (error) {
	          console.log(error);
	          _this3.setState({ modal: 'error' });
	        });
	      }
	    }
	  }, {
	    key: 'handleDeleteContinent',
	    value: function handleDeleteContinent() {
	      var _this4 = this;
	
	      (0, _AdminSource.deleteContinent)(this.state.continent.id).then(function (response) {
	        return _this4.props.router.goBack();
	      }).catch(function (error) {
	        console.log(error);
	        _this4.setState({ modal: 'error' });
	      });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event, key) {
	      var continent = this.state.continent;
	
	      continent[key] = event.target.value;
	      this.setState({ continent: continent });
	    }
	  }, {
	    key: 'toggleModal',
	    value: function toggleModal(modal) {
	      this.setState({ modal: modal });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      var t = this.props.t;
	
	      this.setState({
	        imageError: t('Image too large (2MB max) or has an invalid type')
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props = this.props;
	      var t = _props.t;
	      var router = _props.router;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	      var _state2 = this.state;
	      var continent = _state2.continent;
	      var modal = _state2.modal;
	      var imageError = _state2.imageError;
	      var create = _state2.create;
	
	      var adminActions = [{ label: t('Save'), secondary: true, onClick: this.handleUpdate }];
	      if (!create) {
	        adminActions.push({
	          label: t('Delete Continent'),
	          cancel: true,
	          onClick: function onClick() {
	            return _this5.toggleModal('dialog');
	          }
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_AdminNavbar2.default, {
	          admin: admin,
	          dropdownLinks: dropdownLinks,
	          fixedSearchBar: true,
	          rightSideActions: adminActions
	        }),
	        _react2.default.createElement(_SuccessModal2.default, {
	          visible: modal === 'success',
	          message: t('Continent successfuly ' + (create ? 'created' : 'updated') + '.'),
	          header: t('Continent ' + (create ? 'Created' : 'Updated')),
	          closeAction: this.toggleModal
	        }),
	        _react2.default.createElement(_ErrorModal2.default, {
	          visible: modal === 'error',
	          message: t('There was a problem when ' + (create ? 'creating' : 'updating') + ' the continent.'),
	          header: t('Error'),
	          closeAction: this.toggleModal
	        }),
	        _react2.default.createElement(_DialogModal2.default, {
	          visible: modal === 'dialog',
	          message: t('Do you want to delete this continent?'),
	          header: t('Delete Continent'),
	          closeAction: this.toggleModal,
	          buttons: {
	            apply: {
	              label: 'Cancel',
	              onClick: this.toggleModal
	            },
	            cancel: {
	              label: 'Delete',
	              onClick: this.handleDeleteContinent
	            }
	          }
	        }),
	        _react2.default.createElement(
	          Container,
	          null,
	          continent && _react2.default.createElement(
	            CustomThemeContainer,
	            null,
	            _react2.default.createElement(
	              BackArrowContainer,
	              null,
	              _react2.default.createElement(_BackArrow2.default, { onClick: function onClick() {
	                  return router.goBack();
	                } }),
	              _react2.default.createElement(
	                'span',
	                { className: 'name' },
	                create ? t('Insert Continent') : continent.name
	              )
	            ),
	            _react2.default.createElement(
	              CustomCardContainer,
	              {
	                title: create ? t('Create New Continent') : t('Edit Continent') },
	              _react2.default.createElement(
	                CustomGrid,
	                { noPadTop: true, noPadLeft: true, noPadRight: true },
	                _react2.default.createElement(_Input2.default, {
	                  value: continent.name,
	                  title: t('Continent'),
	                  handleChange: function handleChange(event) {
	                    return _this5.handleChange(event, 'name');
	                  },
	                  placeholder: t('Continent Name')
	                })
	              ),
	              _react2.default.createElement(
	                CustomGrid,
	                { noPadLeft: true, noPadRight: true },
	                _react2.default.createElement(_Textarea2.default, {
	                  title: t('Description'),
	                  value: continent.description,
	                  handleChange: function handleChange(event) {
	                    return _this5.handleChange(event, 'description');
	                  },
	                  placeholder: t('Country description')
	                })
	              ),
	              _react2.default.createElement(
	                CustomGrid,
	                { noPadLeft: true, noPadRight: true },
	                _react2.default.createElement(
	                  Picture,
	                  {
	                    imageSrc: continent.picture && continent.picture.result || continent.picture },
	                  _react2.default.createElement(_UploadPicture2.default, {
	                    uploadButton: continent.picture ? _react2.default.createElement(
	                      EditIcon,
	                      null,
	                      _react2.default.createElement(_Edit2.default, null)
	                    ) : _react2.default.createElement(
	                      ImportPicture,
	                      null,
	                      _react2.default.createElement(_Add2.default, null),
	                      t('Import Picture')
	                    ),
	                    handleError: this.handleError,
	                    handleUploaded: this.handleUpload
	                  })
	                ),
	                imageError && _react2.default.createElement(
	                  Error,
	                  null,
	                  imageError
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditPictures;
	}(_react.Component);
	
	EditPictures.propTypes = {
	  router: _react.PropTypes.object,
	  params: _react.PropTypes.object,
	  t: _react.PropTypes.func,
	  admin: _react.PropTypes.object,
	  dropdownLinks: _react.PropTypes.array
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'admin'], { wait: true })(EditPictures);

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  max-height: ', ';\n  overflow-y: scroll;\n'], ['\n  max-height: ', ';\n  overflow-y: scroll;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin: ', ' 0;\n  cursor: pointer;\n  span {\n    margin-left: ', ';\n    ', ';\n  }\n'], ['\n  margin: ', ' 0;\n  cursor: pointer;\n  span {\n    margin-left: ', ';\n    ', ';\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  height: 136px;\n  width: 136px;\n  background: ', ';\n  background-size: cover;\n  position: relative;\n'], ['\n  height: 136px;\n  width: 136px;\n  background: ', ';\n  background-size: cover;\n  position: relative;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  background: ', ';\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  cursor: pointer;\n  right: -', ';\n  bottom: -', ';\n  border-radius: 50%;\n  svg {\n    margin: 8px;\n    #icon-outline {\n      fill: ', ';\n    }\n  }\n\n  &:hover {\n    background: ', ';\n  }\n'], ['\n  background: ', ';\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  cursor: pointer;\n  right: -', ';\n  bottom: -', ';\n  border-radius: 50%;\n  svg {\n    margin: 8px;\n    #icon-outline {\n      fill: ', ';\n    }\n  }\n\n  &:hover {\n    background: ', ';\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n  margin: 0 auto;\n  text-align: center;\n  padding: ', ';\n  cursor: pointer;\n\n  svg {\n    margin: 0 auto;\n    margin-bottom: ', ';\n    display: block;\n    #plus-icon {\n      fill: ', ';\n    }\n  }\n'], ['\n  ', ';\n  color: ', ';\n  margin: 0 auto;\n  text-align: center;\n  padding: ', ';\n  cursor: pointer;\n\n  svg {\n    margin: 0 auto;\n    margin-bottom: ', ';\n    display: block;\n    #plus-icon {\n      fill: ', ';\n    }\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  ', ';\n  margin-bottom: ', ';\n'], ['\n  ', ';\n  margin-bottom: ', ';\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  padding-left: ', ';\n  padding-right: ', ';\n  margin-top: ', ';\n'], ['\n  padding-left: ', ';\n  padding-right: ', ';\n  margin-top: ', ';\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  padding: 0 32px !important; \n'], ['\n  padding: 0 32px !important; \n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  ', ';\n  margin-top: ', ';\n  color: ', ';\n'], ['\n  ', ';\n  margin-top: ', ';\n  color: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _SearchSource = __webpack_require__(18);
	
	var _AdminSource = __webpack_require__(31);
	
	var _reactI18next = __webpack_require__(7);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _AdminNavbar = __webpack_require__(36);
	
	var _AdminNavbar2 = _interopRequireDefault(_AdminNavbar);
	
	var _Themes = __webpack_require__(5);
	
	var _BackArrow = __webpack_require__(77);
	
	var _BackArrow2 = _interopRequireDefault(_BackArrow);
	
	var _Edit = __webpack_require__(175);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _Add = __webpack_require__(130);
	
	var _Add2 = _interopRequireDefault(_Add);
	
	var _SearchableDropdown = __webpack_require__(64);
	
	var _SearchableDropdown2 = _interopRequireDefault(_SearchableDropdown);
	
	var _UploadPicture = __webpack_require__(128);
	
	var _UploadPicture2 = _interopRequireDefault(_UploadPicture);
	
	var _Textarea = __webpack_require__(74);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _SuccessModal = __webpack_require__(37);
	
	var _SuccessModal2 = _interopRequireDefault(_SuccessModal);
	
	var _ErrorModal = __webpack_require__(30);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	var _DialogModal = __webpack_require__(46);
	
	var _DialogModal2 = _interopRequireDefault(_DialogModal);
	
	var _Defaults = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject, _Themes.Metrics.components.adminContent);
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject2, _Themes.Metrics.margins.base);
	
	var BackArrowContainer = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base, _Themes.Fonts.style.Header);
	
	var Picture = _styledComponents2.default.div(_templateObject4, function (props) {
	  return props.imageSrc ? 'url(\'' + props.imageSrc + '\') no-repeat center' : _Themes.Colors.lightGrey;
	});
	
	var EditIcon = _styledComponents2.default.div(_templateObject5, _Themes.Colors.lightGrey, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base, _Themes.Colors.white, _Themes.Colors.darkGrey);
	
	var ImportPicture = _styledComponents2.default.div(_templateObject6, _Themes.Fonts.style.Text, _Themes.Colors.white, _Themes.Metrics.margins.larger, _Themes.Metrics.margins.medium, _Themes.Colors.white);
	
	var FormTitle = _styledComponents2.default.div(_templateObject7, _Themes.Fonts.style.Label, _Themes.Metrics.margins.small);
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject8, function (props) {
	  return props.noPadLeft ? 0 : _Themes.Metrics.margins.small;
	}, function (props) {
	  return props.noPadRight ? 0 : _Themes.Metrics.margins.small;
	}, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	});
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject9);
	
	var Error = _styledComponents2.default.div(_templateObject10, _Themes.Fonts.style.Input, _Themes.Metrics.margins.tiny, _Themes.Colors.red);
	
	var EditPictures = function (_Component) {
	  _inherits(EditPictures, _Component);
	
	  function EditPictures(props) {
	    _classCallCheck(this, EditPictures);
	
	    var _this = _possibleConstructorReturn(this, (EditPictures.__proto__ || Object.getPrototypeOf(EditPictures)).call(this, props));
	
	    _this.state = {
	      country: _ramda2.default.clone(_Defaults.countryDefault),
	      continents: [],
	      continentName: '',
	      imageError: '',
	      modal: '',
	      create: false
	    };
	    _this.handleUpload = _this.handleUpload.bind(_this);
	    _this.handleUpdate = _this.handleUpdate.bind(_this);
	    _this.handleDeleteCountry = _this.handleDeleteCountry.bind(_this);
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    _this.handleError = _this.handleError.bind(_this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.handleSearchContinent = _this.handleSearchContinent.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditPictures, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var params = this.props.params;
	
	      if (params.id !== 'new') {
	        (0, _SearchSource.searchCountries)({ id: params.id }).then(function (response) {
	          return _this2.setState({
	            country: response.data,
	            continentName: response.data.continent.name
	          });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      } else {
	        this.setState({ create: true });
	      }
	    }
	  }, {
	    key: 'handleUpload',
	    value: function handleUpload(file, result) {
	      var country = this.state.country;
	
	      country.picture = { file: file, result: result };
	      this.setState({ country: country, imageError: null });
	    }
	  }, {
	    key: 'handleUpdate',
	    value: function handleUpdate() {
	      var _this3 = this;
	
	      var _state = this.state;
	      var country = _state.country;
	      var create = _state.create;
	
	      if (create) {
	        (0, _AdminSource.createCountry)(country).then(function (response) {
	          var countryCreated = response.data[0] || response.data;
	          _this3.setState({ country: countryCreated, modal: 'success' });
	        }).catch(function (error) {
	          console.log(error);
	          _this3.setState({ modal: 'error' });
	        });
	      } else {
	        (0, _AdminSource.updateCountry)(country).then(function (response) {
	          _this3.setState({ country: response.data, modal: 'success' });
	        }).catch(function (error) {
	          console.log(error);
	          _this3.setState({ modal: 'error' });
	        });
	      }
	    }
	  }, {
	    key: 'handleSearchContinent',
	    value: function handleSearchContinent(event) {
	      var _this4 = this;
	
	      this.setState({ continentName: event.target.value }, function () {
	        (0, _SearchSource.searchContinents)({
	          where: { name: { startsWith: _this4.state.continentName } }
	        }).then(function (response) {
	          return _this4.setState({ continents: response.data });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      });
	    }
	  }, {
	    key: 'handleDeleteCountry',
	    value: function handleDeleteCountry() {
	      var _this5 = this;
	
	      (0, _AdminSource.deleteCountry)(this.state.country.id).then(function (response) {
	        return _this5.props.router.goBack();
	      }).catch(function (error) {
	        console.log(error);
	        _this5.setState({ modal: 'error' });
	      });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event, key) {
	      var country = this.state.country;
	
	      country[key] = event.target.value;
	      this.setState({ country: country });
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(el) {
	      var country = this.state.country;
	
	      country.continent = el;
	      this.setState({ country: country, continentName: el.name });
	    }
	  }, {
	    key: 'toggleModal',
	    value: function toggleModal(modal) {
	      this.setState({ modal: modal });
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      var t = this.props.t;
	
	      this.setState({
	        imageError: t('Image too large (2MB max) or has an invalid type')
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props = this.props;
	      var t = _props.t;
	      var router = _props.router;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	      var _state2 = this.state;
	      var country = _state2.country;
	      var modal = _state2.modal;
	      var imageError = _state2.imageError;
	      var create = _state2.create;
	      var continentName = _state2.continentName;
	      var continents = _state2.continents;
	
	      var adminActions = [{ label: t('Save'), secondary: true, onClick: this.handleUpdate }];
	      if (!create) {
	        adminActions.push({
	          label: t('Delete Country'),
	          cancel: true,
	          onClick: function onClick() {
	            return _this6.toggleModal('dialog');
	          }
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_AdminNavbar2.default, {
	          admin: admin,
	          dropdownLinks: dropdownLinks,
	          fixedSearchBar: true,
	          rightSideActions: adminActions
	        }),
	        _react2.default.createElement(_SuccessModal2.default, {
	          visible: modal === 'success',
	          message: t('Country successfuly ' + (create ? 'created' : 'updated') + '.'),
	          header: t('Country ' + (create ? 'Created' : 'Updated')),
	          closeAction: this.toggleModal
	        }),
	        _react2.default.createElement(_ErrorModal2.default, {
	          visible: modal === 'error',
	          message: t('There was a problem when ' + (create ? 'creating' : 'updating') + ' the country.'),
	          header: t('Error'),
	          closeAction: this.toggleModal
	        }),
	        _react2.default.createElement(_DialogModal2.default, {
	          visible: modal === 'dialog',
	          message: t('Do you want to delete this country?'),
	          header: t('Delete Country'),
	          closeAction: this.toggleModal,
	          buttons: {
	            apply: {
	              label: 'Cancel',
	              onClick: this.toggleModal
	            },
	            cancel: {
	              label: 'Delete',
	              onClick: this.handleDeleteCountry
	            }
	          }
	        }),
	        _react2.default.createElement(
	          Container,
	          null,
	          country && _react2.default.createElement(
	            CustomThemeContainer,
	            null,
	            _react2.default.createElement(
	              BackArrowContainer,
	              null,
	              _react2.default.createElement(_BackArrow2.default, { onClick: function onClick() {
	                  return router.goBack();
	                } }),
	              _react2.default.createElement(
	                'span',
	                { className: 'name' },
	                create ? t('Insert Country') : country.name
	              )
	            ),
	            _react2.default.createElement(
	              CustomCardContainer,
	              {
	                title: create ? t('Create New Country') : t('Edit Country') },
	              _react2.default.createElement(
	                CustomGrid,
	                { noPadTop: true, noPadLeft: true, noPadRight: true },
	                _react2.default.createElement(_Input2.default, {
	                  value: country.name,
	                  title: t('Country'),
	                  handleChange: function handleChange(event) {
	                    return _this6.handleChange(event, 'name');
	                  },
	                  placeholder: t('Country Name')
	                })
	              ),
	              _react2.default.createElement(
	                CustomGrid,
	                { noPadLeft: true, noPadRight: true },
	                _react2.default.createElement(
	                  CustomGrid,
	                  { xs: 1 / 3, noPadLeft: true, noPadTop: true },
	                  _react2.default.createElement(
	                    FormTitle,
	                    null,
	                    t('Continent')
	                  ),
	                  _react2.default.createElement(_SearchableDropdown2.default, {
	                    value: continentName,
	                    handleSelect: this.handleSelect,
	                    handleSearch: this.handleSearchContinent,
	                    placeholder: t('Continent name'),
	                    options: continents,
	                    accessor: function accessor(d) {
	                      return d.name;
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  CustomGrid,
	                  { noPadLeft: true, noPadRight: true },
	                  _react2.default.createElement(_Textarea2.default, {
	                    title: t('Description'),
	                    value: country.description,
	                    handleChange: function handleChange(event) {
	                      return _this6.handleChange(event, 'description');
	                    },
	                    placeholder: t('Country description')
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                CustomGrid,
	                { noPadLeft: true, noPadRight: true },
	                _react2.default.createElement(
	                  Picture,
	                  {
	                    imageSrc: country.picture && country.picture.result || country.picture },
	                  _react2.default.createElement(_UploadPicture2.default, {
	                    uploadButton: country.picture ? _react2.default.createElement(
	                      EditIcon,
	                      null,
	                      _react2.default.createElement(_Edit2.default, null)
	                    ) : _react2.default.createElement(
	                      ImportPicture,
	                      null,
	                      _react2.default.createElement(_Add2.default, null),
	                      t('Import Picture')
	                    ),
	                    handleError: this.handleError,
	                    handleUploaded: this.handleUpload
	                  })
	                ),
	                imageError && _react2.default.createElement(
	                  Error,
	                  null,
	                  imageError
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditPictures;
	}(_react.Component);
	
	EditPictures.propTypes = {
	  router: _react.PropTypes.object,
	  params: _react.PropTypes.object,
	  t: _react.PropTypes.func,
	  admin: _react.PropTypes.object,
	  dropdownLinks: _react.PropTypes.array
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'admin'], { wait: true })(EditPictures);

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminLocations = function (_Component) {
	  _inherits(AdminLocations, _Component);
	
	  function AdminLocations() {
	    _classCallCheck(this, AdminLocations);
	
	    return _possibleConstructorReturn(this, (AdminLocations.__proto__ || Object.getPrototypeOf(AdminLocations)).apply(this, arguments));
	  }
	
	  _createClass(AdminLocations, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        children && _react2.default.cloneElement(children, {
	          admin: admin,
	          dropdownLinks: dropdownLinks
	        })
	      );
	    }
	  }]);
	
	  return AdminLocations;
	}(_react.Component);
	
	AdminLocations.propTypes = {
	  children: _react.PropTypes.node,
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  admin: _react.PropTypes.object,
	  dropdownLinks: _react.PropTypes.array
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'admin'], { wait: true })(AdminLocations);

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n  ', ';\n'], ['\n  margin-bottom: ', ';\n  ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  .switch {\n    float: right;\n  }\n\n  span {\n    ', ';\n  }\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  .switch {\n    float: right;\n  }\n\n  span {\n    ', ';\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  span {\n    ', ';\n  }\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  span {\n    ', ';\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral([''], ['']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  border: ', ';\n  border-radius: ', ';\n  height: 150px;\n  max-height: none;\n'], ['\n  margin-top: ', ';\n  border: ', ';\n  border-radius: ', ';\n  height: 150px;\n  max-height: none;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  span {\n    ', ';\n    margin-left: ', ';\n  }\n\n  svg {\n    cursor: pointer;\n  }\n'], ['\n  margin-top: ', ';\n  span {\n    ', ';\n    margin-left: ', ';\n  }\n\n  svg {\n    cursor: pointer;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  background: ', ';\n  height: 137px;\n  width: 137px;\n  padding: ', ';\n  ', ';\n  color: ', ';\n  text-transform: capitalize;\n  text-align: center;\n  cursor: pointer;\n\n  svg {\n    margin: 0 auto;\n    margin-bottom: 20px;\n    display: block;\n    #plus-icon {\n      fill: white;\n    }\n  }\n'], ['\n  background: ', ';\n  height: 137px;\n  width: 137px;\n  padding: ', ';\n  ', ';\n  color: ', ';\n  text-transform: capitalize;\n  text-align: center;\n  cursor: pointer;\n\n  svg {\n    margin: 0 auto;\n    margin-bottom: 20px;\n    display: block;\n    #plus-icon {\n      fill: white;\n    }\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n  max-height: ', ';\n  overflow-y: scroll;\n'], ['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n  max-height: ', ';\n  overflow-y: scroll;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _bluebird = __webpack_require__(80);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	var _Validations = __webpack_require__(44);
	
	var _SearchSource = __webpack_require__(18);
	
	var _AdminSource = __webpack_require__(31);
	
	var _Utils = __webpack_require__(22);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _AdminNavbar = __webpack_require__(36);
	
	var _AdminNavbar2 = _interopRequireDefault(_AdminNavbar);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _Dropdown = __webpack_require__(60);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SearchableDropdown = __webpack_require__(64);
	
	var _SearchableDropdown2 = _interopRequireDefault(_SearchableDropdown);
	
	var _Switch = __webpack_require__(518);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	var _List = __webpack_require__(124);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(125);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _BackArrow = __webpack_require__(77);
	
	var _BackArrow2 = _interopRequireDefault(_BackArrow);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Add = __webpack_require__(130);
	
	var _Add2 = _interopRequireDefault(_Add);
	
	var _UploadPicture = __webpack_require__(128);
	
	var _UploadPicture2 = _interopRequireDefault(_UploadPicture);
	
	var _Textarea = __webpack_require__(74);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _SuccessModal = __webpack_require__(37);
	
	var _SuccessModal2 = _interopRequireDefault(_SuccessModal);
	
	var _ErrorModal = __webpack_require__(30);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	var _DialogModal = __webpack_require__(46);
	
	var _DialogModal2 = _interopRequireDefault(_DialogModal);
	
	var _Defaults = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject, _Themes.Metrics.margins.larger);
	
	var Title = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.margins.small, _Themes.Fonts.style.Label);
	
	var CustomHalf = (0, _styledComponents2.default)(_gridStyled.Half)(_templateObject3, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, function (props) {
	  return props.noPadLeft ? 0 : _Themes.Metrics.margins.medium;
	}, function (props) {
	  return props.noPadRight ? 0 : _Themes.Metrics.margins.medium;
	}, _Themes.Fonts.style.Text);
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject4, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, function (props) {
	  return props.noPadLeft ? 0 : _Themes.Metrics.margins.medium;
	}, function (props) {
	  return props.noPadRight ? 0 : _Themes.Metrics.margins.medium;
	}, _Themes.Fonts.style.Text);
	
	var UserSearchBox = _styledComponents2.default.div(_templateObject5);
	
	var CustomList = (0, _styledComponents2.default)(_List2.default)(_templateObject6, _Themes.Metrics.margins.medium, _Themes.Metrics.borders.default, _Themes.Metrics.borders.defaultRadius);
	
	var BackArrowContainer = _styledComponents2.default.div(_templateObject7, _Themes.Metrics.margins.larger, _Themes.Fonts.style.Header, _Themes.Metrics.margins.medium);
	
	var UploadButton = _styledComponents2.default.div(_templateObject8, _Themes.Colors.lightGrey, _Themes.Metrics.margins.larger, _Themes.Fonts.style.Input, _Themes.Colors.white);
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject9, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.adminContent);
	
	var AdminPropertyDetails = function (_Component) {
	  _inherits(AdminPropertyDetails, _Component);
	
	  function AdminPropertyDetails(props) {
	    _classCallCheck(this, AdminPropertyDetails);
	
	    var _this = _possibleConstructorReturn(this, (AdminPropertyDetails.__proto__ || Object.getPrototypeOf(AdminPropertyDetails)).call(this, props));
	
	    _this.state = {
	      create: false,
	      property: null,
	      categories: [],
	      countries: [],
	      continents: [],
	      cities: [],
	      searchCountry: '',
	      searchContinent: '',
	      searchCity: '',
	      searchUsersToAdd: '',
	      searchUsersToRemove: '',
	      authorizedUsers: [],
	      searchedUsers: [],
	      errors: {
	        title: '',
	        city: '',
	        realLocation: '',
	        description: '',
	        category: '',
	        yield: '',
	        price: '',
	        country: '',
	        continent: '',
	        imageUpload: ''
	      },
	      modalType: '',
	      modalMessage: ''
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleSwitch = _this.handleSwitch.bind(_this);
	    _this.handleSearchLocation = _this.handleSearchLocation.bind(_this);
	    _this.handleSelectLocation = _this.handleSelectLocation.bind(_this);
	    _this.handleDropdownSelect = _this.handleDropdownSelect.bind(_this);
	    _this.handleSearchUser = _this.handleSearchUser.bind(_this);
	    _this.handleDelete = _this.handleDelete.bind(_this);
	    _this.filterUsers = _this.filterUsers.bind(_this);
	    _this.uploadPicture = _this.uploadPicture.bind(_this);
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    _this.handleSearchableDropdownBlur = _this.handleSearchableDropdownBlur.bind(_this);
	    _this.validateForm = _this.validateForm.bind(_this);
	    _this.handleValidate = _this.handleValidate.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handleUploadImageError = _this.handleUploadImageError.bind(_this);
	    return _this;
	  }
	
	  _createClass(AdminPropertyDetails, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var params = this.props.params;
	
	
	      _bluebird2.default.all([(0, _AdminSource.searchUsers)({ limit: 10, sort: 'name ASC' }), (0, _SearchSource.searchCategories)(), params.id !== 'new' ? (0, _AdminSource.searchProperties)({ id: params.id }) : null]).spread(function (usersResponse, categoriesResponse, propertyResponse) {
	        var property = propertyResponse ? propertyResponse.data : null;
	        _this2.setState({
	          create: params.id === 'new',
	          searchedUsers: property ? _ramda2.default.differenceWith(function (userA, userB) {
	            return userA.id === userB.id;
	          }, usersResponse.data, property.usersHaveAccess) : usersResponse.data,
	          categories: categoriesResponse.data,
	          property: property || _ramda2.default.clone(_Defaults.propertyDefault),
	          authorizedUsers: property ? property.usersHaveAccess : [],
	          searchCity: property ? property.city.city : '',
	          searchCountry: property ? property.country.name : '',
	          searchContinent: property ? property.continent.name : ''
	        });
	      }).catch(console.error);
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event, key) {
	      var property = this.state.property;
	
	      property[key] = event.target.value;
	      this.setState({ property: property });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var _this3 = this;
	
	      var _state = this.state;
	      var property = _state.property;
	      var create = _state.create;
	
	      var updatedProperty = property;
	      if (this.validateForm()) {
	        updatedProperty.city = updatedProperty.city.id;
	        updatedProperty.country = updatedProperty.country.id;
	        updatedProperty.continent = updatedProperty.continent.id;
	        updatedProperty.category = updatedProperty.category.id;
	        if (create) {
	          (0, _AdminSource.createProperty)(updatedProperty).then(function (response) {
	            return _this3.toggleModal({ type: 'success' });
	          }).catch(function (error) {
	            console.log(error);
	            _this3.toggleModal({ type: 'error' });
	          });
	        } else {
	          (0, _AdminSource.updateProperty)(updatedProperty).then(function (response) {
	            _this3.setState({ property: response.data }, function () {
	              return _this3.toggleModal({ type: 'success' });
	            });
	          }).catch(function (error) {
	            console.log(error);
	            _this3.toggleModal({ type: 'error' });
	          });
	        }
	      }
	    }
	  }, {
	    key: 'handleDelete',
	    value: function handleDelete() {
	      var _this4 = this;
	
	      var router = this.props.router;
	
	      (0, _AdminSource.deleteProperty)(this.state.property.id).then(function (response) {
	        return router.replace('/admin');
	      }).catch(function (error) {
	        console.log(error);
	        _this4.toggleModal({ type: 'error' });
	      });
	    }
	  }, {
	    key: 'handleSwitch',
	    value: function handleSwitch(key) {
	      var property = this.state.property;
	
	      property[key] = !property[key];
	      this.setState({ property: property });
	    }
	  }, {
	    key: 'handleSearchLocation',
	    value: function handleSearchLocation(event, key) {
	      var _this5 = this;
	
	      var value = event.target.value;
	      switch (key) {
	        case 'continent':
	          this.setState({ searchContinent: value }, function () {
	            (0, _SearchSource.searchContinents)({ where: { name: { startsWith: value } } }).then(function (response) {
	              return _this5.setState({ continents: response.data });
	            }).catch(function (error) {
	              return console.log(error);
	            });
	          });
	          break;
	        case 'country':
	          this.setState({ searchCountry: value }, function () {
	            (0, _SearchSource.searchCountries)({ where: { name: { startsWith: value } } }).then(function (response) {
	              return _this5.setState({ countries: response.data });
	            }).catch(function (error) {
	              return console.log(error);
	            });
	          });
	          break;
	        case 'city':
	          this.setState({ searchCity: value }, function () {
	            (0, _SearchSource.searchCities)({ where: { city: { startsWith: value } } }).then(function (response) {
	              return _this5.setState({ cities: response.data });
	            }).catch(function (error) {
	              return console.log(error);
	            });
	          });
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'handleSelectLocation',
	    value: function handleSelectLocation(el, key) {
	      var _state2 = this.state;
	      var property = _state2.property;
	      var errors = _state2.errors;
	
	      property[key] = el;
	      property.latlng = {
	        latitude: 0,
	        longitude: 0
	      };
	
	      errors[key] = '';
	
	      this.setState({
	        property: property,
	        errors: errors,
	        searchCity: property.city ? property.city.city : '',
	        searchCountry: property.country ? property.country.name : '',
	        searchContinent: property.continent ? property.continent.name : ''
	      });
	    }
	  }, {
	    key: 'handleSearchUser',
	    value: function handleSearchUser(event) {
	      var _this6 = this;
	
	      var value = event.target.value;
	      this.setState({ searchUsersToAdd: value }, function () {
	        (0, _AdminSource.searchUsers)({
	          or: [{ email: { startsWith: value } }, { firstName: { startsWith: value } }, { lastName: { startsWith: value } }],
	          sort: 'name ASC',
	          limit: 30
	        }).then(function (response) {
	          var searchedUsers = _ramda2.default.differenceWith(function (userA, userB) {
	            return userA.id === userB.id;
	          }, response.data, _this6.state.authorizedUsers);
	          _this6.setState({ searchedUsers: searchedUsers });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      });
	    }
	  }, {
	    key: 'handleDropdownSelect',
	    value: function handleDropdownSelect(el, key) {
	      var _state3 = this.state;
	      var errors = _state3.errors;
	      var property = _state3.property;
	
	      property[key] = el;
	      errors[key] = '';
	      this.setState({ property: property, errors: errors });
	    }
	  }, {
	    key: 'filterUsers',
	    value: function filterUsers(event) {
	      var property = this.state.property;
	
	      var users = property.usersHaveAccess;
	      var value = event.target.value;
	      if (value.length !== 0) {
	        var cond = function cond(d) {
	          return _ramda2.default.or(_ramda2.default.test(RegExp(value.toLowerCase()), d.firstName.toLowerCase()), _ramda2.default.test(RegExp(value.toLowerCase()), d.lastName.toLowerCase()));
	        };
	        users = _ramda2.default.filter(cond, users);
	      }
	      this.setState({ authorizedUsers: users, searchUsersToRemove: value });
	    }
	  }, {
	    key: 'handleSelectUser',
	    value: function handleSelectUser(el) {
	      var property = _ramda2.default.clone(this.state.property);
	      property.usersHaveAccess = (0, _Utils.addOrRemoveObjectFromList)(property.usersHaveAccess, el);
	      var searchedUsers = _ramda2.default.sort(_ramda2.default.descend(_ramda2.default.prop('firstName')), (0, _Utils.addOrRemoveObjectFromList)(this.state.searchedUsers, el));
	      this.setState({
	        property: property,
	        searchedUsers: searchedUsers,
	        authorizedUsers: property.usersHaveAccess
	      });
	    }
	  }, {
	    key: 'uploadPicture',
	    value: function uploadPicture(file, result) {
	      var _state4 = this.state;
	      var property = _state4.property;
	      var errors = _state4.errors;
	
	      property.picture = {
	        file: file,
	        result: result
	      };
	      this.setState({ property: property, errors: Object.assign({}, errors, { imageUpload: '' }) });
	    }
	  }, {
	    key: 'handleSearchableDropdownBlur',
	    value: function handleSearchableDropdownBlur() {
	      var property = this.state.property;
	
	      this.setState({
	        searchCity: property.city ? property.city.city : '',
	        searchCountry: property.country ? property.country.name : '',
	        searchContinent: property.continent ? property.continent.name : ''
	      });
	    }
	  }, {
	    key: 'toggleModal',
	    value: function toggleModal(_ref) {
	      var type = _ref.type;
	      var message = _ref.message;
	
	      this.setState({ modalType: type, modalMessage: message });
	    }
	  }, {
	    key: 'handleValidate',
	    value: function handleValidate(name, value, errors) {
	      var newErrors = (0, _Validations.validateInput)(name, value, errors);
	      this.setState({ errors: newErrors });
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm() {
	      var _state5 = this.state;
	      var errors = _state5.errors;
	      var property = _state5.property;
	
	      var requiredFields = document.querySelectorAll('[required]');
	      var valid = true;
	      for (var k = 0; k < requiredFields.length; k++) {
	        var name = requiredFields[k].id || requiredFields[k].name;
	        errors = (0, _Validations.validateInput)(name, property[name], errors);
	        valid = valid && errors[name] === '';
	      }
	      this.setState({ errors: errors });
	      return valid;
	    }
	  }, {
	    key: 'handleUploadImageError',
	    value: function handleUploadImageError(error) {
	      var _state6 = this.state;
	      var errors = _state6.errors;
	      var property = _state6.property;
	
	
	      var update = {
	        errors: Object.assign({}, errors, { imageUpload: error }),
	        property: Object.assign({}, property, { picture: null })
	      };
	      this.setState(update);
	    }
	  }, {
	    key: 'mainInfoCard',
	    value: function mainInfoCard() {
	      var _this7 = this;
	
	      var t = this.props.t;
	      var _state7 = this.state;
	      var property = _state7.property;
	      var categories = _state7.categories;
	      var errors = _state7.errors;
	
	
	      return _react2.default.createElement(
	        CustomCardContainer,
	        { title: t('Main Info') },
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadLeft: true, noPadTop: true },
	          _react2.default.createElement(_Input2.default, {
	            required: true,
	            title: t('Name'),
	            handleChange: function handleChange(event) {
	              return _this7.handleChange(event, 'title');
	            },
	            value: property.title,
	            placeholder: t('Insert the property name'),
	            error: errors['title'],
	            name: 'title',
	            handleBlur: function handleBlur(event) {
	              return _this7.handleValidate('title', property.title, errors);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadRight: true, noPadTop: true },
	          _react2.default.createElement(
	            Title,
	            null,
	            t('Property Type'),
	            '*'
	          ),
	          _react2.default.createElement(_Dropdown2.default, {
	            handleSelect: function handleSelect(el) {
	              return _this7.handleDropdownSelect(el, 'category');
	            },
	            accessor: function accessor(d) {
	              return d.name;
	            },
	            title: t('Property Type'),
	            options: categories,
	            selectedOption: property.category,
	            placeholder: t('Select the property type'),
	            name: 'category',
	            required: true,
	            handleBlur: function handleBlur(event) {
	              return _this7.handleValidate('category', property.category, errors);
	            },
	            error: errors['category']
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadLeft: true },
	          _react2.default.createElement(
	            Title,
	            null,
	            t('Portfolio')
	          ),
	          _react2.default.createElement(_Dropdown2.default, {
	            accessor: function accessor(d) {
	              return d ? t('Yes') : t('No');
	            },
	            handleSelect: function handleSelect(el) {
	              return _this7.handleDropdownSelect(el, 'portfolio');
	            },
	            selectedOption: property.portfolio,
	            options: [true, false],
	            placeholder: t('Does this property have portfolio?')
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadRight: true },
	          _react2.default.createElement(_Input2.default, {
	            required: true,
	            title: t('Price €'),
	            handleChange: function handleChange(event) {
	              return _this7.handleChange(event, 'price');
	            },
	            value: '' + property.price,
	            placeholder: t('Insert Price in EUR'),
	            error: errors['price'],
	            name: 'price',
	            handleBlur: function handleBlur(event) {
	              return _this7.handleValidate('price', property.price, errors);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadLeft: true },
	          _react2.default.createElement(_Input2.default, {
	            title: t('Usable Area (m2)'),
	            handleChange: function handleChange(event) {
	              return _this7.handleChange(event, 'usableArea');
	            },
	            value: '' + property.usableArea,
	            placeholder: t('Insert Land Area'),
	            name: 'usableArea'
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadRight: true },
	          _react2.default.createElement(_Input2.default, {
	            title: t('Land Area (m2)'),
	            handleChange: function handleChange(event) {
	              return _this7.handleChange(event, 'area');
	            },
	            value: '' + property.area,
	            placeholder: t('Insert Usable Area'),
	            name: 'area'
	          })
	        )
	      );
	    }
	  }, {
	    key: 'addressCard',
	    value: function addressCard() {
	      var _this8 = this;
	
	      var t = this.props.t;
	      var _state8 = this.state;
	      var property = _state8.property;
	      var countries = _state8.countries;
	      var continents = _state8.continents;
	      var cities = _state8.cities;
	      var searchCity = _state8.searchCity;
	      var searchCountry = _state8.searchCountry;
	      var searchContinent = _state8.searchContinent;
	      var errors = _state8.errors;
	
	
	      return _react2.default.createElement(
	        CustomCardContainer,
	        { title: t('Address') },
	        _react2.default.createElement(
	          CustomGrid,
	          { xs: 1 / 3, noPadLeft: true, noPadTop: true },
	          _react2.default.createElement(
	            Title,
	            null,
	            t('Continent'),
	            '*'
	          ),
	          _react2.default.createElement(_SearchableDropdown2.default, {
	            required: true,
	            options: continents,
	            placeholder: t('Search for continents'),
	            handleSearch: function handleSearch(event) {
	              return _this8.handleSearchLocation(event, 'continent');
	            },
	            handleSelect: function handleSelect(el) {
	              return _this8.handleSelectLocation(el, 'continent');
	            },
	            value: searchContinent,
	            accessor: function accessor(d) {
	              return d.name;
	            },
	            handleBlur: this.handleSearchableDropdownBlur,
	            error: errors['continent'],
	            inputName: 'continent',
	            handleInputBlur: function handleInputBlur(event) {
	              return _this8.handleValidate('continent', property.continent, errors);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomGrid,
	          { xs: 1 / 3, noPadTop: true },
	          _react2.default.createElement(
	            Title,
	            null,
	            t('Country'),
	            '*'
	          ),
	          _react2.default.createElement(_SearchableDropdown2.default, {
	            required: true,
	            options: countries,
	            placeholder: t('Search for continents'),
	            handleSearch: function handleSearch(event) {
	              return _this8.handleSearchLocation(event, 'country');
	            },
	            handleSelect: function handleSelect(el) {
	              return _this8.handleSelectLocation(el, 'country');
	            },
	            value: searchCountry,
	            accessor: function accessor(d) {
	              return d.name;
	            },
	            handleBlur: this.handleSearchableDropdownBlur,
	            error: errors['country'],
	            handleInputBlur: function handleInputBlur(event) {
	              return _this8.handleValidate('country', property.country, errors);
	            },
	            inputName: 'country'
	          })
	        ),
	        _react2.default.createElement(
	          CustomGrid,
	          { xs: 1 / 3, noPadRight: true, noPadTop: true },
	          _react2.default.createElement(
	            Title,
	            null,
	            t('City'),
	            '*'
	          ),
	          _react2.default.createElement(_SearchableDropdown2.default, {
	            required: true,
	            placeholder: t('Search for cities'),
	            options: cities,
	            handleSearch: function handleSearch(event) {
	              return _this8.handleSearchLocation(event, 'city');
	            },
	            handleSelect: function handleSelect(el) {
	              return _this8.handleSelectLocation(el, 'city');
	            },
	            value: searchCity,
	            accessor: function accessor(d) {
	              return d.city;
	            },
	            handleBlur: this.handleSearchableDropdownBlur,
	            error: errors['city'],
	            inputName: 'city',
	            handleInputBlur: function handleInputBlur(event) {
	              return _this8.handleValidate('city', property.title, errors);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomGrid,
	          { noPadLeft: true, noPadRight: true },
	          _react2.default.createElement(_Input2.default, {
	            required: true,
	            title: t('Address'),
	            handleChange: function handleChange(event) {
	              return _this8.handleChange(event, 'realLocation');
	            },
	            value: property.realLocation,
	            placeholder: t('Insert the Address of property'),
	            error: errors['realLocation'],
	            name: 'realLocation',
	            handleBlur: function handleBlur(event) {
	              return _this8.handleValidate('realLocation', property.realLocation, errors);
	            }
	          })
	        )
	      );
	    }
	  }, {
	    key: 'moreInfoCard',
	    value: function moreInfoCard() {
	      var _this9 = this;
	
	      var t = this.props.t;
	      var _state9 = this.state;
	      var property = _state9.property;
	      var errors = _state9.errors;
	
	      return _react2.default.createElement(
	        CustomCardContainer,
	        { title: t('More Info') },
	        _react2.default.createElement(
	          CustomGrid,
	          { noPadLeft: true, noPadRight: true, noPadTop: true },
	          _react2.default.createElement(_Textarea2.default, {
	            required: true,
	            title: t('Description'),
	            handleChange: function handleChange(event) {
	              return _this9.handleChange(event, 'description');
	            },
	            value: property.description,
	            placeholder: t('Insert the property description'),
	            error: errors['description'],
	            name: 'description',
	            handleBlur: function handleBlur(event) {
	              return _this9.handleValidate('description', property.description, errors);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadLeft: true },
	          _react2.default.createElement(_Input2.default, {
	            title: t('Lead'),
	            handleChange: function handleChange(event) {
	              return _this9.handleChange(event, 'lead');
	            },
	            value: property.lead,
	            placeholder: t('Insert the property lead')
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadRight: true },
	          _react2.default.createElement(_Input2.default, {
	            required: true,
	            title: t('Estimated Yield (%)'),
	            handleChange: function handleChange(event) {
	              return _this9.handleChange(event, 'yield');
	            },
	            value: '' + property.yield,
	            placeholder: t('Estimated Yield'),
	            error: errors['yield'],
	            name: 'yield',
	            handleBlur: function handleBlur(event) {
	              return _this9.handleValidate('yield', property.yield, errors);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadLeft: true },
	          _react2.default.createElement(_Input2.default, {
	            required: true,
	            title: t('Number of Keys'),
	            handleChange: function handleChange(event) {
	              return _this9.handleChange(event, 'noRooms');
	            },
	            value: '' + property.noRooms,
	            placeholder: t('Insert Number of Keys'),
	            error: errors['noRooms'],
	            name: 'noRooms',
	            handleBlur: function handleBlur(event) {
	              return _this9.handleValidate('noRooms', property.noRooms, errors);
	            }
	          })
	        )
	      );
	    }
	  }, {
	    key: 'imageCard',
	    value: function imageCard() {
	      var _this10 = this;
	
	      var t = this.props.t;
	      var _state10 = this.state;
	      var property = _state10.property;
	      var errors = _state10.errors;
	
	      return _react2.default.createElement(
	        CustomCardContainer,
	        { title: t('Images') },
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadLeft: true, noPadTop: true },
	          _react2.default.createElement(
	            'span',
	            null,
	            t('Do you want to use the pre-defined city image?')
	          )
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadRight: true, noPadTop: true },
	          _react2.default.createElement(_Switch2.default, {
	            className: 'switch',
	            active: property.useDefaultPictures,
	            onClick: function onClick() {
	              return _this10.handleSwitch('useDefaultPictures');
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomGrid,
	          { noPadLeft: true, noPadRight: true },
	          property.picture ? _react2.default.createElement(_Avatar2.default, {
	            size: 136,
	            buttonClass: 'edit-button',
	            imageSrc: property.picture.result || property.picture,
	            onEdit: this.uploadPicture,
	            handleError: this.handleUploadImageError,
	            error: errors['imageUpload']
	          }) : _react2.default.createElement(_UploadPicture2.default, {
	            handleUploaded: this.uploadPicture,
	            uploadButton: _react2.default.createElement(
	              UploadButton,
	              null,
	              _react2.default.createElement(_Add2.default, null),
	              t('Import picture')
	            ),
	            handleError: this.handleUploadImageError,
	            error: errors['imageUpload']
	          })
	        )
	      );
	    }
	  }, {
	    key: 'permissionsCard',
	    value: function permissionsCard() {
	      var _this11 = this;
	
	      var t = this.props.t;
	      var _state11 = this.state;
	      var property = _state11.property;
	      var searchUsersToAdd = _state11.searchUsersToAdd;
	      var searchUsersToRemove = _state11.searchUsersToRemove;
	      var searchedUsers = _state11.searchedUsers;
	      var authorizedUsers = _state11.authorizedUsers;
	
	      return _react2.default.createElement(
	        CustomCardContainer,
	        { title: t('Permissions') },
	        _react2.default.createElement(
	          CustomGrid,
	          { noPadLeft: true, noPadRight: true },
	          _react2.default.createElement(
	            CustomHalf,
	            { noPadLeft: true, noPadTop: true },
	            _react2.default.createElement(
	              Title,
	              null,
	              t('Permissions')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              t('Is this property available for everyone?')
	            )
	          ),
	          _react2.default.createElement(
	            CustomHalf,
	            { noPadRight: true, noPadTop: true },
	            _react2.default.createElement(_Switch2.default, {
	              className: 'switch',
	              active: property.fullAccess,
	              onClick: function onClick() {
	                return _this11.handleSwitch('fullAccess');
	              }
	            })
	          )
	        ),
	        !property.fullAccess ? _react2.default.createElement(
	          CustomGrid,
	          { noPadLeft: true, noPadTop: true },
	          _react2.default.createElement(
	            CustomHalf,
	            { noPadLeft: true },
	            _react2.default.createElement(
	              UserSearchBox,
	              null,
	              _react2.default.createElement(_Input2.default, {
	                title: t('Unauthorized'),
	                handleChange: this.handleSearchUser,
	                placeholder: t('Search for users'),
	                value: searchUsersToAdd
	              }),
	              _react2.default.createElement(
	                CustomList,
	                null,
	                searchedUsers.map(function (el, index) {
	                  return _react2.default.createElement(
	                    _ListItem2.default,
	                    {
	                      odd: index % 2 === 0,
	                      key: 'user-to-add-' + index,
	                      onClick: function onClick() {
	                        return _this11.handleSelectUser(el);
	                      } },
	                    el.firstName,
	                    ' ',
	                    el.lastName
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            CustomHalf,
	            { noPadRight: true },
	            _react2.default.createElement(
	              UserSearchBox,
	              null,
	              _react2.default.createElement(_Input2.default, {
	                title: t('Authorized'),
	                handleChange: this.filterUsers,
	                placeholder: t('Search for users'),
	                value: searchUsersToRemove
	              }),
	              _react2.default.createElement(
	                CustomList,
	                null,
	                authorizedUsers.map(function (el, index) {
	                  return _react2.default.createElement(
	                    _ListItem2.default,
	                    {
	                      odd: index % 2 === 0,
	                      key: 'user-to-remove-' + index,
	                      onClick: function onClick() {
	                        return _this11.handleSelectUser(el);
	                      } },
	                    el.firstName,
	                    ' ',
	                    el.lastName
	                  );
	                })
	              )
	            )
	          )
	        ) : null,
	        _react2.default.createElement(
	          CustomGrid,
	          { noPadLeft: true, noPadRight: true },
	          _react2.default.createElement(
	            CustomHalf,
	            { noPadLeft: true },
	            _react2.default.createElement(
	              Title,
	              null,
	              t('Publish Property')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              t('Do you want to publish this property?')
	            )
	          ),
	          _react2.default.createElement(
	            CustomHalf,
	            { noPadRight: true },
	            _react2.default.createElement(_Switch2.default, {
	              className: 'switch',
	              active: property.published,
	              onClick: function onClick() {
	                return _this11.handleSwitch('published');
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          CustomGrid,
	          { noPadLeft: true, noPadRight: true },
	          _react2.default.createElement(
	            CustomHalf,
	            { noPadLeft: true },
	            _react2.default.createElement(
	              Title,
	              null,
	              t('Available Property')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              t('Is this property sold?')
	            )
	          ),
	          _react2.default.createElement(
	            CustomHalf,
	            { noPadRight: true },
	            _react2.default.createElement(_Switch2.default, {
	              className: 'switch',
	              active: property.sold,
	              onClick: function onClick() {
	                return _this11.handleSwitch('sold');
	              }
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this12 = this;
	
	      var _props = this.props;
	      var t = _props.t;
	      var router = _props.router;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	      var _state12 = this.state;
	      var property = _state12.property;
	      var create = _state12.create;
	      var modalType = _state12.modalType;
	      var modalMessage = _state12.modalMessage;
	
	      var actions = [{ label: t('Save'), primary: true, onClick: this.handleSubmit }];
	      if (!create) {
	        actions.push({
	          label: t('Delete Property'),
	          cancel: true,
	          onClick: function onClick() {
	            return _this12.toggleModal({ type: 'dialog' });
	          }
	        });
	      }
	
	      return _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(_AdminNavbar2.default, {
	          admin: admin,
	          dropdownLinks: dropdownLinks,
	          rightSideActions: actions
	        }),
	        _react2.default.createElement(_DialogModal2.default, {
	          visible: modalType === 'dialog',
	          message: modalMessage ? t(modalMessage) : t('Are you sure that you want to delete this property?'),
	          closeAction: this.toggleModal,
	          header: t('Delete Property'),
	          buttons: {
	            apply: { label: t('Delete'), onClick: this.handleDelete },
	            cancel: { label: t('Cancel'), onClick: this.toggleModal }
	          }
	        }),
	        _react2.default.createElement(_SuccessModal2.default, {
	          visible: modalType === 'success',
	          message: modalMessage ? t(modalMessage) : t('Property successfully ' + (create ? 'created' : 'updated')),
	          closeAction: this.toggleModal,
	          header: t('Property ' + (create ? 'Created' : 'Updated'))
	        }),
	        _react2.default.createElement(_ErrorModal2.default, {
	          visible: modalType === 'error',
	          message: modalMessage ? t(modalMessage) : t('There was a problem when ' + (create ? 'creating' : 'updating') + ' the property'),
	          closeAction: this.toggleModal,
	          header: t('Error')
	        }),
	        property && _react2.default.createElement(
	          CustomThemeContainer,
	          null,
	          _react2.default.createElement(
	            BackArrowContainer,
	            null,
	            _react2.default.createElement(_BackArrow2.default, { onClick: function onClick() {
	                return router.goBack();
	              } }),
	            _react2.default.createElement(
	              'span',
	              null,
	              create ? t('Insert Property') : property.title
	            )
	          ),
	          this.mainInfoCard(),
	          this.addressCard(),
	          this.moreInfoCard(),
	          this.imageCard(),
	          this.permissionsCard()
	        )
	      );
	    }
	  }]);
	
	  return AdminPropertyDetails;
	}(_react.Component);
	
	AdminPropertyDetails.propTypes = {
	  t: _react.PropTypes.func,
	  params: _react.PropTypes.object,
	  router: _react.PropTypes.object,
	  location: _react.PropTypes.object,
	  admin: _react.PropTypes.object,
	  dropdownLinks: _react.PropTypes.array
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'admin', 'forms'], { wait: true })(AdminPropertyDetails);

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  height: calc(100vh - (', ' + ', '))\n  margin-top: calc(', 'px - 1px);\n\n  .searchbar-container {\n    top: calc(', 'px - 1px);\n  }\n'], ['\n  height: calc(100vh - (', ' + ', '))\n  margin-top: calc(', 'px - 1px);\n\n  .searchbar-container {\n    top: calc(', 'px - 1px);\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: calc(', ' - 1px);\n  height: calc(\n    100vh - (', 'px +\n          ', ')\n  );\n  .table-checkbox {\n    svg {\n      padding-top: 13px;\n    }\n  }\n\n  #table-body {\n    padding: 0 ', ' !important;\n  }\n'], ['\n  margin-top: calc(', ' - 1px);\n  height: calc(\n    100vh - (', 'px +\n          ', ')\n  );\n  .table-checkbox {\n    svg {\n      padding-top: 13px;\n    }\n  }\n\n  #table-body {\n    padding: 0 ', ' !important;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  margin-bottom: ', ';\n'], ['\n  margin-top: ', ';\n  margin-bottom: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  border: ', ';\n  border-radius: ', ';\n  height: 150px;\n  overflow: scroll;\n'], ['\n  border: ', ';\n  border-radius: ', ';\n  height: 150px;\n  overflow: scroll;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  text-align: left;\n  padding: ', ';\n  ', ';\n  cursor: pointer;\n'], ['\n  text-align: left;\n  padding: ', ';\n  ', ';\n  cursor: pointer;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['text-align: left;'], ['text-align: left;']),
	    _templateObject7 = _taggedTemplateLiteral([''], ['']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  ', ';\n  text-align: left;\n'], ['\n  ', ';\n  text-align: left;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n  height: ', ';\n  button {\n    float: right;\n  }\n'], ['\n  margin-bottom: ', ';\n  height: ', ';\n  button {\n    float: right;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  padding-left: ', ';\n  padding-right: ', ';\n  margin-bottom: ', ';\n'], ['\n  padding-left: ', ';\n  padding-right: ', ';\n  margin-bottom: ', ';\n']),
	    _templateObject11 = _taggedTemplateLiteral(['margin-top: ', ';'], ['margin-top: ', ';']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactI18next = __webpack_require__(7);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _gridStyled = __webpack_require__(17);
	
	var _AdminSource = __webpack_require__(31);
	
	var _Utils = __webpack_require__(22);
	
	var _Defaults = __webpack_require__(34);
	
	var _SearchSource = __webpack_require__(18);
	
	var _Themes = __webpack_require__(5);
	
	var _AdminNavbar = __webpack_require__(36);
	
	var _AdminNavbar2 = _interopRequireDefault(_AdminNavbar);
	
	var _SearchBar = __webpack_require__(245);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _Table = __webpack_require__(172);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Modal = __webpack_require__(42);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Checkbox = __webpack_require__(171);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.section(_templateObject, _Themes.Metrics.components.navbarDefault, _Themes.Metrics.components.searchbar, _Themes.Metrics.components.adminNavbar, _Themes.Metrics.components.adminNavbar);
	
	var TableContainer = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.components.searchbar, _Themes.Metrics.components.adminNavbar, _Themes.Metrics.components.searchbar, _Themes.Metrics.margins.larger);
	
	var InputContainer = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.small, _Themes.Metrics.margins.larger);
	
	var ListContainer = _styledComponents2.default.div(_templateObject4, _Themes.Metrics.borders.default, _Themes.Metrics.borders.defaultRadius);
	
	var User = _styledComponents2.default.div(_templateObject5, _Themes.Metrics.margins.small, _Themes.Fonts.style.Text);
	
	var ModalHeader = _styledComponents2.default.div(_templateObject6);
	
	var UsersList = _styledComponents2.default.div(_templateObject7);
	
	var Label = _styledComponents2.default.div(_templateObject8, _Themes.Fonts.style.Text);
	
	var ButtonContainer = _styledComponents2.default.div(_templateObject9, _Themes.Metrics.margins.base, _Themes.Metrics.margins.larger);
	
	var CustomHalf = (0, _styledComponents2.default)(_gridStyled.Half)(_templateObject10, function (props) {
	  return props.noPadLeft ? 0 : _Themes.Metrics.margins.small;
	}, function (props) {
	  return props.noPadRight ? 0 : _Themes.Metrics.margins.small;
	}, function (props) {
	  return props.mgSmall ? _Themes.Metrics.margins.tiny : _Themes.Metrics.margins.base;
	});
	
	var NoUsers = _styledComponents2.default.div(_templateObject11, _Themes.Metrics.margins.base);
	
	var AdminProperties = function (_Component) {
	  _inherits(AdminProperties, _Component);
	
	  function AdminProperties(props) {
	    _classCallCheck(this, AdminProperties);
	
	    var _this = _possibleConstructorReturn(this, (AdminProperties.__proto__ || Object.getPrototypeOf(AdminProperties)).call(this, props));
	
	    _this.state = {
	      userSearch: '',
	      open: false,
	      counter: 0,
	      canLoadMore: true,
	      isFetching: false,
	      allPropertiesSelected: false,
	      properties: [],
	      selectedProperties: [],
	      selectedUsers: [],
	      users: [],
	      settings: _ramda2.default.clone(_Defaults.searchQueryDefault),
	      tableHeaderKeys: _ramda2.default.prepend({
	        title: props.t('Select All'),
	        key: 'selected',
	        width: 80,
	        accessor: function accessor(d) {
	          return _react2.default.createElement(_Checkbox2.default, {
	            className: 'table-checkbox',
	            id: 'checkbox-' + d.id,
	            checked: (0, _Utils.isElementSelected)(d, _this.state.selectedProperties),
	            onClick: function onClick(event) {
	              event.stopPropagation();
	              _this.selectElement(d, 'selectedProperties');
	            }
	          });
	        },
	        sort: null,
	        onClick: _this.selectAllProperties
	      }, _ramda2.default.clone(_Defaults.tableKeysDefault))
	    };
	    _this.updateSettings = _this.updateSettings.bind(_this);
	    _this.propertyDetails = _this.propertyDetails.bind(_this);
	    _this.retrieveProperties = _this.retrieveProperties.bind(_this);
	    _this.filterProperties = _this.filterProperties.bind(_this);
	    _this.handleSort = _this.handleSort.bind(_this);
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    _this.selectAllProperties = _this.selectAllProperties.bind(_this);
	    _this.handleSearch = _this.handleSearch.bind(_this);
	    _this.usersToAdd = _this.usersToAdd.bind(_this);
	    _this.selectElement = _this.selectElement.bind(_this);
	    _this.updatePropertiesUsers = _this.updatePropertiesUsers.bind(_this);
	    return _this;
	  }
	
	  _createClass(AdminProperties, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.retrieveProperties();
	    }
	  }, {
	    key: 'retrieveProperties',
	    value: function retrieveProperties() {
	      var _this2 = this;
	
	      var _state = this.state;
	      var settings = _state.settings;
	      var counter = _state.counter;
	      var properties = _state.properties;
	
	      this.setState({ isFetching: true }, function () {
	        (0, _SearchSource.findProperties)({ settings: settings, skip: counter, limit: 50 }).then(function (response) {
	          var _response$data = response.data;
	          var _response$data$result = _response$data.results;
	          var results = _response$data$result === undefined ? [] : _response$data$result;
	          var noResults = _response$data.noResults;
	
	          var propertiesSet = _ramda2.default.concat(properties, results);
	          propertiesSet = propertiesSet.map(function (el) {
	            return Object.assign({}, el, { selected: false });
	          });
	          _this2.setState({
	            properties: propertiesSet,
	            counter: propertiesSet.length,
	            canLoadMore: propertiesSet.length < noResults,
	            isFetching: false
	          });
	        }).catch(function (error) {
	          console.log(error);
	          _this2.setState({ isFetching: false });
	        });
	      });
	    }
	  }, {
	    key: 'filterProperties',
	    value: function filterProperties() {
	      var _this3 = this;
	
	      var settings = this.state.settings;
	
	      this.setState({ isFetching: true }, function () {
	        (0, _SearchSource.findProperties)({ settings: settings, limit: 50 }).then(function (response) {
	          var _response$data2 = response.data;
	          var _response$data2$resul = _response$data2.results;
	          var results = _response$data2$resul === undefined ? [] : _response$data2$resul;
	          var noResults = _response$data2.noResults;
	
	          var propertiesSet = results.map(function (el) {
	            return Object.assign({}, el, { selected: false });
	          });
	          _this3.setState({
	            properties: propertiesSet,
	            counter: propertiesSet.length,
	            canLoadMore: propertiesSet.length < noResults,
	            isFetching: false
	          });
	        }).catch(function (error) {
	          console.log(error);
	          _this3.setState({ isFetching: false });
	        });
	      });
	    }
	  }, {
	    key: 'updateSettings',
	    value: function updateSettings(settings) {
	      var _this4 = this;
	
	      this.setState({ settings: settings }, function () {
	        _this4.filterProperties();
	      });
	    }
	  }, {
	    key: 'propertyDetails',
	    value: function propertyDetails(id) {
	      this.props.router.push('/admin/properties/' + id);
	    }
	  }, {
	    key: 'handleSort',
	    value: function handleSort(el) {
	      var keys = _ramda2.default.clone(this.state.tableHeaderKeys);
	      var keyIndex = _ramda2.default.findIndex(_ramda2.default.propEq('title', el.title), keys);
	      var result = (0, _Utils.sortArray)(el, this.state.properties);
	      keys.forEach(function (el) {
	        el.sort = null;
	      });
	      keys[keyIndex] = result.sortKey;
	      this.setState({ properties: result.list, tableHeaderKeys: keys });
	    }
	  }, {
	    key: 'toggleModal',
	    value: function toggleModal() {
	      this.setState({ open: !this.state.open, userSearch: '' });
	    }
	  }, {
	    key: 'selectAllProperties',
	    value: function selectAllProperties() {
	      var _state2 = this.state;
	      var properties = _state2.properties;
	      var allPropertiesSelected = _state2.allPropertiesSelected;
	
	      this.setState({
	        allPropertiesSelected: !allPropertiesSelected,
	        selectedProperties: allPropertiesSelected ? [] : properties
	      });
	    }
	  }, {
	    key: 'selectElement',
	    value: function selectElement(el, arrayName) {
	      var newState = this.state;
	      newState[arrayName] = (0, _Utils.addOrRemoveObjectFromList)(newState[arrayName], el);
	      this.setState(newState);
	    }
	  }, {
	    key: 'handleSearch',
	    value: function handleSearch(event) {
	      var _this5 = this;
	
	      var name = event.target.value;
	      this.setState({ userSearch: name }, function () {
	        (0, _AdminSource.findUsersByName)(name).then(function (response) {
	          _this5.setState({ users: response.data });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      });
	    }
	  }, {
	    key: 'updatePropertiesUsers',
	    value: function updatePropertiesUsers() {
	      var _this6 = this;
	
	      var _state3 = this.state;
	      var selectedUsers = _state3.selectedUsers;
	      var selectedProperties = _state3.selectedProperties;
	
	      var properties = selectedProperties.map(function (property) {
	        return property.id;
	      });
	      var users = selectedUsers.map(function (user) {
	        return user.id;
	      });
	      (0, _AdminSource.addUsersToProperties)(properties, users).then(function (response) {
	        return _this6.toggleModal();
	      }).catch(function (error) {
	        return console.log(error);
	      });
	    }
	  }, {
	    key: 'usersToAdd',
	    value: function usersToAdd() {
	      var _this7 = this;
	
	      var _state4 = this.state;
	      var users = _state4.users;
	      var userSearch = _state4.userSearch;
	      var selectedUsers = _state4.selectedUsers;
	      var t = this.props.t;
	
	      var usersList = '';
	
	      usersList = users.length > 0 ? users.map(function (el, index) {
	        return _react2.default.createElement(
	          User,
	          {
	            onClick: function onClick() {
	              return _this7.selectElement(el, 'selectedUsers');
	            },
	            key: 'user-' + index },
	          el.firstName + ' ' + el.lastName
	        );
	      }) : _react2.default.createElement(
	        NoUsers,
	        null,
	        t('There are no users')
	      );
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          InputContainer,
	          null,
	          _react2.default.createElement(_Input2.default, {
	            value: userSearch,
	            handleChange: this.handleSearch,
	            placeholder: t('Search for name')
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadLeft: true, mgSmall: true },
	          _react2.default.createElement(
	            Label,
	            null,
	            t('Users')
	          )
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadRight: true, mgSmall: true },
	          _react2.default.createElement(
	            Label,
	            null,
	            t('Selected Users')
	          )
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadLeft: true },
	          _react2.default.createElement(
	            UsersList,
	            null,
	            _react2.default.createElement(
	              ListContainer,
	              null,
	              usersList
	            )
	          )
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadRight: true },
	          _react2.default.createElement(
	            ListContainer,
	            null,
	            selectedUsers.length > 0 && selectedUsers.map(function (el, index) {
	              return _react2.default.createElement(
	                User,
	                {
	                  onClick: function onClick() {
	                    return _this7.selectElement(el, 'selectedUsers');
	                  },
	                  key: 'selecteduser-' + index },
	                el.firstName + ' ' + el.lastName
	              );
	            }),
	            selectedUsers.length === 0 && _react2.default.createElement(
	              NoUsers,
	              null,
	              t('There are no users selected')
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var t = _props.t;
	      var router = _props.router;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	
	      var _R$clone = _ramda2.default.clone(this.state);
	
	      var tableHeaderKeys = _R$clone.tableHeaderKeys;
	      var properties = _R$clone.properties;
	      var settings = _R$clone.settings;
	      var canLoadMore = _R$clone.canLoadMore;
	      var isFetching = _R$clone.isFetching;
	      var open = _R$clone.open;
	      var selectedProperties = _R$clone.selectedProperties;
	
	      var width = window.screen.availWidth - 200;
	      var height = document.getElementById('propertyList') && document.getElementById('propertyList').offsetHeight;
	
	      return _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          _Modal2.default,
	          {
	            visible: open,
	            closeAction: this.toggleModal,
	            style: {
	              padding: _Themes.Metrics.margins.small + ' ' + _Themes.Metrics.margins.large
	            },
	            header: _react2.default.createElement(
	              ModalHeader,
	              null,
	              t('Add users to ' + selectedProperties.length + ' properties')
	            ) },
	          this.usersToAdd(),
	          _react2.default.createElement(
	            ButtonContainer,
	            null,
	            _react2.default.createElement(_Button2.default, {
	              secondary: true,
	              onClick: this.updatePropertiesUsers,
	              label: 'Save'
	            })
	          )
	        ),
	        _react2.default.createElement(_AdminNavbar2.default, {
	          dropdownLinks: dropdownLinks,
	          fixedSearchBar: true,
	          admin: admin,
	          rightSideActions: [{
	            label: t('Add Users'),
	            primary: true,
	            onClick: this.toggleModal,
	            disabled: selectedProperties.length === 0
	          }, {
	            label: t('Create Property'),
	            secondary: true,
	            onClick: function onClick() {
	              router.push('/admin/properties/new');
	            }
	          }]
	        }),
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(_SearchBar2.default, {
	            isAdmin: true,
	            settings: settings,
	            updateSettings: this.updateSettings,
	            isAdminPage: true
	          }),
	          _react2.default.createElement(
	            TableContainer,
	            { id: 'propertyList' },
	            _react2.default.createElement(_Table2.default, {
	              data: properties,
	              keys: tableHeaderKeys,
	              height: height,
	              width: width,
	              isFetching: isFetching,
	              loadMore: this.retrieveProperties,
	              canLoadMore: canLoadMore,
	              handleSort: this.handleSort,
	              rowClick: this.propertyDetails,
	              selectedElements: selectedProperties
	            })
	          ),
	          children
	        )
	      );
	    }
	  }]);
	
	  return AdminProperties;
	}(_react.Component);
	
	AdminProperties.propTypes = {
	  children: _react.PropTypes.node,
	  admin: _react.PropTypes.object,
	  router: _react.PropTypes.object,
	  location: _react.PropTypes.object,
	  t: _react.PropTypes.func,
	  dropdownLinks: _react.PropTypes.array
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'admin', 'forms'], { wait: true })(AdminProperties);

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  max-width: 100vw;\n  overflow-x: scroll;\n'], ['\n  max-width: 100vw;\n  overflow-x: scroll;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  min-width: ', ';\n\n  & > * {\n    float: left;\n  }\n'], ['\n  min-width: ', ';\n\n  & > * {\n    float: left;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  height: 100vh;\n  width: calc(100% - ', ');\n  left: ', ';\n  background: ', ';\n  top: 0;\n\n  & > div {\n    height: 100%;\n  }\n'], ['\n  height: 100vh;\n  width: calc(100% - ', ');\n  left: ', ';\n  background: ', ';\n  top: 0;\n\n  & > div {\n    height: 100%;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  width: ', ';\n  height: ', ';\n'], ['\n  width: ', ';\n  height: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _AuthStore = __webpack_require__(129);
	
	var _AuthStore2 = _interopRequireDefault(_AuthStore);
	
	var _AuthActions = __webpack_require__(53);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _Sidebar = __webpack_require__(517);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Themes = __webpack_require__(5);
	
	var _Pangea = __webpack_require__(131);
	
	var _Pangea2 = _interopRequireDefault(_Pangea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var ScrollableContainer = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.components.adminScreensMinWidth);
	
	var AdminScreenContent = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.components.sidebar, _Themes.Metrics.components.sidebar, _Themes.Colors.lightGrey);
	
	var CustomLogo = (0, _styledComponents2.default)(_Pangea2.default)(_templateObject4, _Themes.Metrics.components.adminLogoSize, _Themes.Metrics.components.adminLogoSize);
	
	var AdminPublic = function (_Component) {
	  _inherits(AdminPublic, _Component);
	
	  function AdminPublic(props) {
	    _classCallCheck(this, AdminPublic);
	
	    var _this = _possibleConstructorReturn(this, (AdminPublic.__proto__ || Object.getPrototypeOf(AdminPublic)).call(this, props));
	
	    _this.state = { items: [], currentItem: '' };
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(AdminPublic, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return _AuthStore2.default.getState();
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (this.props.admin && !nextProps.admin) {
	        this.props.router.replace('/landing');
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _AuthStore2.default.listen(this.onChange);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _AuthStore2.default.unlisten(this.onChange);
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(state) {
	      this.setState(state);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var admin = _props.admin;
	      var router = _props.router;
	
	      var dropdownLinks = [{
	        label: 'Profile',
	        onClick: function onClick() {
	          return router.replace('/admin/admins/' + admin.id);
	        }
	      }, { label: 'Log Out', onClick: function onClick() {
	          return _AuthActions2.default.logoutAdmin();
	        } }];
	      return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(
	          ScrollableContainer,
	          null,
	          _react2.default.createElement(_Sidebar2.default, {
	            links: [{ to: '/admin/properties', label: 'Properties' }, { to: '/admin/users', label: 'Users' }, { to: '/admin/requests', label: 'Requests' }, {
	              id: 'locations',
	              label: 'Locations',
	              to: '/admin/locations/',
	              sublinks: [{ to: '/admin/locations/cities', label: 'Cities' }, { to: '/admin/locations/countries', label: 'Countries' }, { to: '/admin/locations/continents', label: 'Continents' }]
	            }, { to: '/admin/categories', label: 'Categories' }, { to: '/admin/admins', label: 'Admins' }],
	            logo: _react2.default.createElement(CustomLogo, null)
	          }),
	          _react2.default.createElement(
	            AdminScreenContent,
	            null,
	            children && _react2.default.cloneElement(children, {
	              admin: admin,
	              dropdownLinks: dropdownLinks
	            })
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_AuthStore2.default];
	    }
	  }, {
	    key: 'getPropsFromStores',
	    value: function getPropsFromStores() {
	      var authState = _AuthStore2.default.getState();
	      return {
	        admin: authState.admin
	      };
	    }
	  }]);
	
	  return AdminPublic;
	}(_react.Component);
	
	AdminPublic.propTypes = {
	  children: _react.PropTypes.node,
	  admin: _react.PropTypes.object,
	  router: _react.PropTypes.object
	};
	
	exports.default = AdminPublic;

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  height: 100vh;\n  overflow: hidden;\n  position: relative;\n'], ['\n  height: 100vh;\n  overflow: hidden;\n  position: relative;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['', ';'], ['', ';']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  display: table-cell;\n  vertical-align: middle;\n  ', ';\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  display: table-cell;\n  vertical-align: middle;\n  ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n  max-height: ', ';\n  overflow-y: scroll;\n'], ['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n  max-height: ', ';\n  overflow-y: scroll;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  ', ';\n  cursor: pointer;\n  float: right;\n'], ['\n  ', ';\n  cursor: pointer;\n  float: right;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  border-bottom: ', ';\n  height: ', ';\n  width: 100%;\n  display: table;\n  ', ';\n  cursor: pointer;\n'], ['\n  border-bottom: ', ';\n  height: ', ';\n  width: 100%;\n  display: table;\n  ', ';\n  cursor: pointer;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  margin-right: ', ';\n'], ['\n  margin-right: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _immutable = __webpack_require__(29);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _Utils = __webpack_require__(22);
	
	var _AdminSource = __webpack_require__(31);
	
	var _AdminNavbar = __webpack_require__(36);
	
	var _AdminNavbar2 = _interopRequireDefault(_AdminNavbar);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Themes = __webpack_require__(5);
	
	var _Checkbox = __webpack_require__(171);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Tag = __webpack_require__(127);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _Loader = __webpack_require__(45);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var PageContainer = _styledComponents2.default.section(_templateObject);
	
	var Preference = _styledComponents2.default.div(_templateObject2, _Themes.Fonts.style.Text);
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject3, _Themes.Metrics.margins.base);
	
	var Title = _styledComponents2.default.div(_templateObject2, _Themes.Fonts.style.Label);
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject4, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, function (props) {
	  return props.noPadLeft ? 0 : _Themes.Metrics.margins.medium;
	}, function (props) {
	  return props.noPadRight ? 0 : _Themes.Metrics.margins.medium;
	}, function (props) {
	  return props.width && 'width: ' + props.width + 'px';
	});
	var CustomGridContainer = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject5, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, function (props) {
	  return props.noPadLeft ? 0 : _Themes.Metrics.margins.medium;
	}, function (props) {
	  return props.noPadRight ? 0 : _Themes.Metrics.margins.medium;
	});
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject6, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.adminContent);
	
	var SelectAll = _styledComponents2.default.div(_templateObject7, _Themes.Fonts.style.header);
	
	var User = _styledComponents2.default.div(_templateObject8, _Themes.Metrics.borders.headerBorder, _Themes.Metrics.components.adminListRow, _Themes.Fonts.style.Text);
	
	var CustomTag = (0, _styledComponents2.default)(_Tag2.default)(_templateObject9, _Themes.Metrics.margins.small);
	
	var AdminRequests = function (_Component) {
	  _inherits(AdminRequests, _Component);
	
	  function AdminRequests(props) {
	    _classCallCheck(this, AdminRequests);
	
	    var _this = _possibleConstructorReturn(this, (AdminRequests.__proto__ || Object.getPrototypeOf(AdminRequests)).call(this, props));
	
	    _this.state = {
	      selectedUsers: [],
	      users: [],
	      allUsersSelected: false,
	      isFetching: false,
	      canLoadMore: true
	    };
	
	    _this.fetchUsers = _this.fetchUsers.bind(_this);
	    _this.selectAll = _this.selectAll.bind(_this);
	    _this.selectUser = _this.selectUser.bind(_this);
	    _this.handleAcceptUsers = _this.handleAcceptUsers.bind(_this);
	    _this.handleRejectUsers = _this.handleRejectUsers.bind(_this);
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(AdminRequests, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var _state = this.state;
	      var canLoadMore = _state.canLoadMore;
	      var isFetching = _state.isFetching;
	      var users = _state.users;
	      var allUsersSelected = _state.allUsersSelected;
	      var selectedUsers = _state.selectedUsers;
	
	      if (canLoadMore !== nextState.canLoadMore || isFetching !== nextState.isFetching || !(0, _immutable.fromJS)(nextState.users).equals((0, _immutable.fromJS)(users)) || !(0, _immutable.fromJS)(nextState.selectedUsers).equals((0, _immutable.fromJS)(selectedUsers)) || allUsersSelected !== nextState.allUsersSelected) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.fetchUsers();
	    }
	  }, {
	    key: 'fetchUsers',
	    value: function fetchUsers() {
	      var _this2 = this;
	
	      (0, _AdminSource.findUsers)({
	        query: { state: 'pending' },
	        limit: 30,
	        skip: this.state.users.length
	      }).then(function (response) {
	        var list = _ramda2.default.concat(_this2.state.users, response.data.results);
	        _this2.setState({
	          users: list,
	          canLoadMore: list.length < response.data.noElems,
	          isFetching: false
	        });
	      }).catch(function (error) {
	        console.log(error);
	        _this2.setState({ isFetching: false });
	      });
	    }
	  }, {
	    key: 'handleAcceptUsers',
	    value: function handleAcceptUsers() {
	      var _this3 = this;
	
	      (0, _AdminSource.acceptUsers)(this.state.selectedUsers).then(function (response) {
	        (0, _AdminSource.findUsers)({ query: { state: 'pending' }, limit: 30 }).then(function (response) {
	          return _this3.setState({
	            users: response.data.results,
	            canLoadMore: response.data.results < response.data.noElems
	          });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      }).catch(function (error) {
	        return console.log(error);
	      });
	    }
	  }, {
	    key: 'handleRejectUsers',
	    value: function handleRejectUsers() {
	      var _this4 = this;
	
	      (0, _AdminSource.rejectUsers)(this.state.selectedUsers).then(function (response) {
	        (0, _AdminSource.findUsers)({ query: { state: 'pending' }, limit: 5 }).then(function (response) {
	          return _this4.setState({
	            users: response.data.results,
	            canLoadMore: response.data.results < response.data.noElems
	          });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      }).catch(function (error) {
	        return console.log(error);
	      });
	    }
	  }, {
	    key: 'selectAll',
	    value: function selectAll() {
	      var _state2 = this.state;
	      var allUsersSelected = _state2.allUsersSelected;
	      var users = _state2.users;
	      var selectedUsers = _state2.selectedUsers;
	
	      if (allUsersSelected) {
	        selectedUsers = [];
	      } else {
	        selectedUsers = users;
	      }
	      this.setState({ selectedUsers: selectedUsers, allUsersSelected: !allUsersSelected });
	    }
	  }, {
	    key: 'selectUser',
	    value: function selectUser(user) {
	      var selectedUsers = this.state.selectedUsers;
	
	      this.setState({
	        selectedUsers: (0, _Utils.addOrRemoveObjectFromList)(selectedUsers, user)
	      });
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll(event) {
	      var _this5 = this;
	
	      var _state3 = this.state;
	      var canLoadMore = _state3.canLoadMore;
	      var isFetching = _state3.isFetching;
	
	      var element = document.getElementById('admin-requests');
	      var hiddenPixels = element.scrollTop;
	      var difference = element.scrollHeight - element.clientHeight;
	      var scrollPrecentage = hiddenPixels / difference * 100;
	      if (scrollPrecentage > 90 && !isFetching && canLoadMore) {
	        this.setState({ isFetching: true }, function () {
	          return _this5.fetchUsers();
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props = this.props;
	      var t = _props.t;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	      var router = _props.router;
	      var _state4 = this.state;
	      var users = _state4.users;
	      var selectedUsers = _state4.selectedUsers;
	      var isFetching = _state4.isFetching;
	
	      return _react2.default.createElement(
	        PageContainer,
	        null,
	        _react2.default.createElement(_AdminNavbar2.default, {
	          fixedSearchBar: true,
	          dropdownLinks: dropdownLinks,
	          rightSideActions: [{
	            label: t('Accept'),
	            disabled: selectedUsers.length === 0,
	            primary: true,
	            onClick: this.handleAcceptUsers
	          }, {
	            label: t('Reject'),
	            disabled: selectedUsers.length === 0,
	            secondary: true,
	            onClick: this.handleRejectUsers
	          }],
	          admin: admin
	        }),
	        _react2.default.createElement(_Loader2.default, { visible: isFetching }),
	        _react2.default.createElement(
	          CustomThemeContainer,
	          { id: 'admin-requests', onScroll: this.handleScroll },
	          _react2.default.createElement(
	            CustomCardContainer,
	            {
	              title: _react2.default.createElement(
	                'div',
	                null,
	                t('User Requests'),
	                _react2.default.createElement(
	                  SelectAll,
	                  { onClick: this.selectAll },
	                  t('Select All')
	                )
	              ) },
	            users && users.length > 0 && users.map(function (el, index) {
	              return _react2.default.createElement(
	                User,
	                {
	                  key: 'user-' + el.email,
	                  onClick: function onClick() {
	                    return router.push('/admin/users/' + el.id);
	                  } },
	                _react2.default.createElement(
	                  CustomGrid,
	                  { xs: 0.5, noPadLeft: true, noPadRight: true, noPadTop: true },
	                  _react2.default.createElement(
	                    CustomGrid,
	                    { noPadLeft: true, noPadTop: true, width: 40 },
	                    _react2.default.createElement(_Checkbox2.default, {
	                      id: 'checkbox-' + el.email,
	                      checked: (0, _Utils.isElementInArray)(selectedUsers, el),
	                      className: 'checkbox',
	                      onClick: function onClick(event) {
	                        event.stopPropagation();
	                        _this6.selectUser(el);
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    CustomGrid,
	                    { noPadLeft: true, noPadTop: true, width: 90 },
	                    _react2.default.createElement(_Avatar2.default, { imageSrc: el.picture, size: 90 })
	                  ),
	                  _react2.default.createElement(
	                    CustomGrid,
	                    { noPadLeft: true, noPadRight: true, noPadTop: true },
	                    _react2.default.createElement(
	                      Title,
	                      null,
	                      el.firstName + ' ' + el.lastName
	                    ),
	                    _react2.default.createElement(
	                      Preference,
	                      null,
	                      el.email
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  CustomGrid,
	                  { xs: 0.5, noPadLeft: true, noPadRight: true, noPadTop: true },
	                  _react2.default.createElement(
	                    CustomGridContainer,
	                    {
	                      xs: 1 / 4,
	                      noPadLeft: true,
	                      noPadRight: true,
	                      noPadTop: true },
	                    _react2.default.createElement(
	                      Title,
	                      null,
	                      t('Number of keys')
	                    ),
	                    _react2.default.createElement(
	                      Preference,
	                      null,
	                      el.minNoRooms,
	                      '-',
	                      el.maxNoRooms
	                    )
	                  ),
	                  _react2.default.createElement(
	                    CustomGridContainer,
	                    {
	                      xs: 1 / 4,
	                      noPadLeft: true,
	                      noPadRight: true,
	                      noPadTop: true },
	                    _react2.default.createElement(
	                      Title,
	                      null,
	                      t('Estimated Yield')
	                    ),
	                    _react2.default.createElement(
	                      Preference,
	                      null,
	                      el.minYield,
	                      '-',
	                      el.maxYield
	                    )
	                  ),
	                  _react2.default.createElement(
	                    CustomGridContainer,
	                    {
	                      xs: 1 / 4,
	                      noPadLeft: true,
	                      noPadRight: true,
	                      noPadTop: true },
	                    _react2.default.createElement(
	                      Title,
	                      null,
	                      t('Price')
	                    ),
	                    _react2.default.createElement(
	                      Preference,
	                      null,
	                      (0, _Utils.numberWithCommas)(el.minInvestment),
	                      '-',
	                      (0, _Utils.numberWithCommas)(el.maxInvestment)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    CustomGridContainer,
	                    {
	                      xs: 1 / 4,
	                      noPadLeft: true,
	                      noPadRight: true,
	                      noPadTop: true },
	                    _react2.default.createElement(
	                      Title,
	                      null,
	                      t('Area')
	                    ),
	                    _react2.default.createElement(
	                      Preference,
	                      null,
	                      el.minArea,
	                      '-',
	                      el.maxArea
	                    )
	                  ),
	                  el.preferredCategories.length > 0 && _react2.default.createElement(
	                    'div',
	                    { style: { marginTop: _Themes.Metrics.margins.base } },
	                    el.preferredCategories.length > 0 && el.preferredCategories.map(function (category, index) {
	                      return _react2.default.createElement(CustomTag, {
	                        text: category.name,
	                        key: 'tag-' + el.email + '-' + index
	                      });
	                    })
	                  )
	                )
	              );
	            }),
	            users.length === 0 && _react2.default.createElement(
	              CustomGrid,
	              { noPadLeft: true, noPadRight: true, noPadTop: true },
	              _react2.default.createElement(
	                Preference,
	                null,
	                t('There are no Requests')
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminRequests;
	}(_react.Component);
	
	AdminRequests.propTypes = {
	  t: _react.PropTypes.func,
	  admin: _react.PropTypes.object,
	  dropdownLinks: _react.PropTypes.array,
	  router: _react.PropTypes.object
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'admin', 'forms'], { wait: true })(AdminRequests);

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral([''], ['']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n  max-height: ', ';\n  overflow-y: scroll;\n'], ['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n  max-height: ', ';\n  overflow-y: scroll;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  span {\n    ', ';\n    margin-left: ', ';\n  }\n\n  svg {\n    cursor: pointer;\n  }\n'], ['\n  margin-top: ', ';\n  span {\n    ', ';\n    margin-left: ', ';\n  }\n\n  svg {\n    cursor: pointer;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n  margin-bottom: ', ';\n'], ['\n  ', ';\n  color: ', ';\n  margin-bottom: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteral(['', ';'], ['', ';']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  .right {\n    float: right;\n  }\n  .left: {\n    float: left;\n  }\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  .right {\n    float: right;\n  }\n  .left: {\n    float: left;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  .right {\n    float: right;\n  }\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  .right {\n    float: right;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  border-bottom: ', ';\n  padding-bottom: ', ';\n'], ['\n  border-bottom: ', ';\n  padding-bottom: ', ';\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  width: 110px;\n  ', ';\n  border: 1px solid transparent;\n  padding: ', ' ', ';\n  background: ', ';\n  cursor: pointer;\n  color: ', ';\n  outline: none;\n  text-transform: uppercase;\n  text-decoration: none;\n  float: left;\n\n  &:hover {\n    border: 1px solid ', ';\n    background: transparent;\n    color: ', ';\n  }\n'], ['\n  width: 110px;\n  ', ';\n  border: 1px solid transparent;\n  padding: ', ' ', ';\n  background: ', ';\n  cursor: pointer;\n  color: ', ';\n  outline: none;\n  text-transform: uppercase;\n  text-decoration: none;\n  float: left;\n\n  &:hover {\n    border: 1px solid ', ';\n    background: transparent;\n    color: ', ';\n  }\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  border-bottom: ', ';\n  padding: ', ' 0;\n  position: relative;\n'], ['\n  border-bottom: ', ';\n  padding: ', ' 0;\n  position: relative;\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: ', ';\n  right: 0;\n'], ['\n  position: absolute;\n  top: ', ';\n  right: 0;\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n  ', ';\n  width: auto;\n  display: inline-block;\n  border: 1px solid transparent;\n  padding: ', ' ', ';\n  background: ', ';\n  cursor: pointer;\n  color: ', ';\n  outline: none;\n  text-transform: uppercase;\n\n  &:hover {\n    border: 1px solid ', ';\n    background: transparent;\n    color: ', ';\n  }\n'], ['\n  ', ';\n  width: auto;\n  display: inline-block;\n  border: 1px solid transparent;\n  padding: ', ' ', ';\n  background: ', ';\n  cursor: pointer;\n  color: ', ';\n  outline: none;\n  text-transform: uppercase;\n\n  &:hover {\n    border: 1px solid ', ';\n    background: transparent;\n    color: ', ';\n  }\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n  position: relative;\n  float: left;\n  cursor: pointer !important;\n  margin-right: ', ';\n  input {\n    width: 0.1px;\n    height: 0.1px;\n    opacity: 0;\n    overflow: hidden;\n    position: absolute;\n    z-index: -1;\n  }\n'], ['\n  position: relative;\n  float: left;\n  cursor: pointer !important;\n  margin-right: ', ';\n  input {\n    width: 0.1px;\n    height: 0.1px;\n    opacity: 0;\n    overflow: hidden;\n    position: absolute;\n    z-index: -1;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactI18next = __webpack_require__(7);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _AdminNavbar = __webpack_require__(36);
	
	var _AdminNavbar2 = _interopRequireDefault(_AdminNavbar);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Constants = __webpack_require__(52);
	
	var _AdminSource = __webpack_require__(31);
	
	var _SearchSource = __webpack_require__(18);
	
	var _UserSource = __webpack_require__(246);
	
	var _Themes = __webpack_require__(5);
	
	var _Utils = __webpack_require__(22);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Textarea = __webpack_require__(74);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _Dropdown = __webpack_require__(60);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SearchableDropdown = __webpack_require__(64);
	
	var _SearchableDropdown2 = _interopRequireDefault(_SearchableDropdown);
	
	var _BackArrow = __webpack_require__(77);
	
	var _BackArrow2 = _interopRequireDefault(_BackArrow);
	
	var _Switch = __webpack_require__(518);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	var _RangePicker = __webpack_require__(126);
	
	var _RangePicker2 = _interopRequireDefault(_RangePicker);
	
	var _Trash = __webpack_require__(89);
	
	var _Trash2 = _interopRequireDefault(_Trash);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Validations = __webpack_require__(44);
	
	var _DialogModal = __webpack_require__(46);
	
	var _DialogModal2 = _interopRequireDefault(_DialogModal);
	
	var _SuccessModal = __webpack_require__(37);
	
	var _SuccessModal2 = _interopRequireDefault(_SuccessModal);
	
	var _ErrorModal = __webpack_require__(30);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	var _Defaults = __webpack_require__(34);
	
	var _reactRouter = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* globals FileReader */
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject2, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.adminContent);
	
	var BackArrowContainer = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.larger, _Themes.Fonts.style.Header, _Themes.Metrics.margins.medium);
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject4, _Themes.Metrics.margins.base);
	
	var FormTitle = _styledComponents2.default.div(_templateObject5, _Themes.Fonts.style.Label, function (props) {
	  return props.primary ? _Themes.Colors.primary : _Themes.Colors.black;
	}, _Themes.Metrics.margins.small);
	
	var Text = _styledComponents2.default.div(_templateObject6, _Themes.Fonts.style.Text);
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject7, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, function (props) {
	  return props.noPadLeft ? 0 : _Themes.Metrics.margins.medium;
	}, function (props) {
	  return props.noPadRight ? 0 : _Themes.Metrics.margins.medium;
	});
	
	var CustomThird = (0, _styledComponents2.default)(_gridStyled.Third)(_templateObject8, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, function (props) {
	  return props.noPadLeft ? 0 : _Themes.Metrics.margins.medium;
	}, function (props) {
	  return props.noPadRight ? 0 : _Themes.Metrics.margins.medium;
	});
	
	var CustomHalf = (0, _styledComponents2.default)(_gridStyled.Half)(_templateObject9, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, function (props) {
	  return props.noPadLeft ? 0 : _Themes.Metrics.margins.medium;
	}, function (props) {
	  return props.noPadRight ? 0 : _Themes.Metrics.margins.medium;
	});
	
	var EditPreferenceArea = _styledComponents2.default.div(_templateObject10, _Themes.Metrics.borders.default, _Themes.Metrics.margins.base);
	
	var ViewNdaButton = _styledComponents2.default.a(_templateObject11, _Themes.Fonts.style.Button, _Themes.Metrics.margins.small, _Themes.Metrics.margins.large, _Themes.Colors.black, _Themes.Colors.white, _Themes.Colors.black, _Themes.Colors.black);
	
	var PreferenceContainer = _styledComponents2.default.div(_templateObject12, _Themes.Metrics.borders.headerBorder, _Themes.Metrics.margins.base);
	
	var CustomTrash = (0, _styledComponents2.default)(_Trash2.default)(_templateObject13, _Themes.Metrics.margins.base);
	
	var UploadButton = _styledComponents2.default.label(_templateObject14, _Themes.Fonts.style.Button, _Themes.Metrics.margins.small, _Themes.Metrics.margins.large, _Themes.Colors.black, _Themes.Colors.white, _Themes.Colors.black, _Themes.Colors.black);
	
	var NdaContainer = _styledComponents2.default.div(_templateObject15, _Themes.Metrics.margins.base);
	
	var AdminUserDetails = function (_Component) {
	  _inherits(AdminUserDetails, _Component);
	
	  function AdminUserDetails(props) {
	    _classCallCheck(this, AdminUserDetails);
	
	    var _this = _possibleConstructorReturn(this, (AdminUserDetails.__proto__ || Object.getPrototypeOf(AdminUserDetails)).call(this, props));
	
	    _this.state = {
	      creation: false,
	      properties: [],
	      locations: [],
	      categories: [],
	      searchProperty: '',
	      searchCategory: '',
	      searchLocation: '',
	      user: _ramda2.default.clone(_Defaults.userDefault),
	      userPreferences: [],
	      modal: false,
	      locationType: null,
	      errors: {
	        firstName: '',
	        lastName: '',
	        email: '',
	        phoneNumber: '',
	        address: '',
	        imageUpload: ''
	      },
	      preference: _ramda2.default.clone(_Defaults.preferenceDefault),
	      isSaved: true
	    };
	    _this.personalInfo = _this.personalInfo.bind(_this);
	    _this.otherInfo = _this.otherInfo.bind(_this);
	    _this.preferences = _this.preferences.bind(_this);
	    _this.handleUpload = _this.handleUpload.bind(_this);
	    _this.handleSwitch = _this.handleSwitch.bind(_this);
	    _this.handleChangeGeneric = _this.handleChangeGeneric.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleDropdownSelect = _this.handleDropdownSelect.bind(_this);
	    _this.handleSelectCategory = _this.handleSelectCategory.bind(_this);
	    _this.handleAddPreference = _this.handleAddPreference.bind(_this);
	    _this.handleRemovePreference = _this.handleRemovePreference.bind(_this);
	    _this.handleRange = _this.handleRange.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handleDelete = _this.handleDelete.bind(_this);
	    _this.validateForm = _this.validateForm.bind(_this);
	    _this.handleValidate = _this.handleValidate.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    _this.openModal = _this.openModal.bind(_this);
	    _this.fetchUser = _this.fetchUser.bind(_this);
	    _this.handleUploadNda = _this.handleUploadNda.bind(_this);
	    _this.handleSelectLocationType = _this.handleSelectLocationType.bind(_this);
	    _this.handleUploadImageError = _this.handleUploadImageError.bind(_this);
	    _this.routerWillLeave = _this.routerWillLeave.bind(_this);
	    return _this;
	  }
	
	  _createClass(AdminUserDetails, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var params = this.props.params;
	
	      (0, _SearchSource.searchCategories)().then(function (response) {
	        return _this2.setState({ categories: response.data });
	      }).catch(function (error) {
	        return console.log(error);
	      });
	      if (params.id === 'new') {
	        this.setState({ creation: true });
	      } else {
	        this.fetchUser();
	      }
	      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
	    }
	  }, {
	    key: 'routerWillLeave',
	    value: function routerWillLeave(nextLocation) {
	      var t = this.props.t;
	
	
	      if (!this.state.isSaved) return t('Your changes are not saved! Are you sure you want to leave?');
	    }
	  }, {
	    key: 'handleValidate',
	    value: function handleValidate(name, value, errors) {
	      var newErrors = (0, _Validations.validateInput)(name, value, errors);
	      this.setState({ errors: newErrors });
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm() {
	      var _state = this.state;
	      var errors = _state.errors;
	      var user = _state.user;
	
	      var requiredFields = document.querySelectorAll('[required]');
	      var valid = true;
	      requiredFields.forEach(function (field) {
	        var name = field.id || field.name;
	        errors = (0, _Validations.validateInput)(name, user[name], errors);
	        valid = valid && errors[name] === '';
	      });
	      this.setState({ errors: errors });
	      return valid;
	    }
	  }, {
	    key: 'handleUpload',
	    value: function handleUpload(file, result) {
	      var user = _ramda2.default.clone(this.state.user);
	      user.picture = { file: file, result: result };
	      this.setState({
	        user: user,
	        errors: Object.assign({}, this.state.errors, { imageUpload: '' }),
	        isSaved: false
	      });
	    }
	  }, {
	    key: 'handleUploadImageError',
	    value: function handleUploadImageError(error) {
	      var _state2 = this.state;
	      var errors = _state2.errors;
	      var user = _state2.user;
	
	
	      var update = {
	        errors: Object.assign({}, errors, { imageUpload: error }),
	        user: Object.assign({}, user, { picture: null })
	      };
	      this.setState(update);
	    }
	  }, {
	    key: 'handleUploadNda',
	    value: function handleUploadNda(event) {
	      var _this3 = this;
	
	      var user = this.state.user;
	
	      if (event.target.files) {
	        var reader = new FileReader();
	        var file = event.target.files[0];
	        reader.readAsDataURL(file);
	        reader.onloadend = function () {
	          user.nda = file;
	          (0, _AdminSource.uploadNda)(user).then(function (response) {
	            user.nda = response.data.nda;
	            _this3.setState({ user: user, modal: 'success' });
	          }).catch(function (error) {
	            return console.log(error);
	          });
	        };
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var _this4 = this;
	
	      var _state3 = this.state;
	      var user = _state3.user;
	      var creation = _state3.creation;
	
	      if (this.validateForm()) {
	        if (creation) {
	          (0, _AdminSource.createUser)(user).then(function (response) {
	            console.log(response);
	            _this4.setState({
	              user: response.data,
	              modal: 'success',
	              creation: false,
	              isSaved: false
	            });
	          }).catch(function (error) {
	            console.log(error);
	            _this4.setState({ modal: 'error' });
	          });
	        } else {
	          delete user.preferences;
	          (0, _AdminSource.updateUser)(user).then(function (response) {
	            return _this4.setState({
	              user: response.data,
	              modal: 'success',
	              isSaved: true
	            });
	          }).catch(function (error) {
	            console.log(error);
	            _this4.setState({ modal: 'error' });
	          });
	        }
	      }
	    }
	  }, {
	    key: 'handleDelete',
	    value: function handleDelete() {
	      var _this5 = this;
	
	      var router = this.props.router;
	
	      (0, _AdminSource.deleteUser)(this.state.user).then(function (res) {
	        return router.goBack();
	      }).catch(function (error) {
	        console.log(error);
	        _this5.setState({ modal: 'error' });
	      });
	    }
	  }, {
	    key: 'handleChangeGeneric',
	    value: function handleChangeGeneric(event, key) {
	      var _this6 = this;
	
	      var state = _ramda2.default.clone(this.state);
	      var value = event.target.value;
	      switch (key) {
	        case 'property':
	          this.setState({ searchProperty: value }, function () {
	            (0, _SearchSource.searchProperty)({ where: { name: { startsWith: value } } }).then(function (response) {
	              return _this6.setState({
	                properties: response.data,
	                isSaved: false
	              });
	            }).catch(function (error) {
	              return console.log(error);
	            });
	          });
	          break;
	        case 'location':
	          (0, _SearchSource.searchLocations)({ criteria: value }).then(function (res) {
	            var _res$data = res.data;
	            var cities = _res$data.cities;
	            var countries = _res$data.countries;
	            var continents = _res$data.continents;
	
	            _this6.setState({
	              searchLocation: value,
	              isSaved: false,
	              locations: [].concat(_toConsumableArray(cities.map(function (city) {
	                return Object.assign({}, city, {
	                  type: 'city'
	                });
	              })), _toConsumableArray(countries.map(function (country) {
	                return Object.assign({}, country, { type: 'country' });
	              })), _toConsumableArray(continents.map(function (continent) {
	                return Object.assign({}, continent, {
	                  type: 'continent'
	                });
	              })))
	            });
	          }).catch(function (error) {
	            return console.log(error);
	          });
	          break;
	        case 'category':
	          this.setState({ searchCategory: value }, function () {
	            (0, _SearchSource.searchCategories)({ where: { name: { startsWith: value } } }).then(function (response) {
	              return _this6.setState({
	                categories: response.data,
	                isSaved: false
	              });
	            }).catch(function (error) {
	              return console.log(error);
	            });
	          });
	          break;
	        case 'preferenceName':
	          var preference = this.state.preference;
	
	          preference.name = value;
	          this.setState({
	            preference: preference,
	            isSaved: false
	          });
	          break;
	        default:
	          state[key] = value;
	          this.setState({
	            state: state,
	            isSaved: false
	          });
	          break;
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event, key) {
	      var user = this.state.user;
	
	      user[key] = event.target.value;
	      this.setState({
	        user: user,
	        isSaved: false
	      });
	    }
	  }, {
	    key: 'handleDropdownSelect',
	    value: function handleDropdownSelect(el) {
	      var preference = this.state.preference;
	
	
	      preference[el.type] = el;
	
	      return this.setState({
	        searchLocation: el.name,
	        preference: preference,
	        isSaved: false
	      });
	    }
	  }, {
	    key: 'handleRemovePreference',
	    value: function handleRemovePreference(preference) {
	      var _this7 = this;
	
	      (0, _UserSource.removePreference)(preference.id).then(function (response) {
	        return _this7.fetchUser();
	      }).catch(function (error) {
	        return console.log(error);
	      });
	    }
	  }, {
	    key: 'handleAddPreference',
	    value: function handleAddPreference() {
	      var _this8 = this;
	
	      (0, _UserSource.addPreference)(this.state.user.id, this.state.preference).then(function (response) {
	        _this8.setState({
	          isSaved: false,
	          searchLocation: '',
	          preference: {
	            name: '',
	            city: null,
	            category: null,
	            country: null,
	            continent: null,
	            minNoRooms: 0,
	            maxNoRooms: _Constants.maxRooms,
	            minYield: 0,
	            maxYield: _Constants.maxYield,
	            minPrice: 0,
	            maxPrice: _Constants.maxPrice,
	            minArea: 0,
	            maxArea: _Constants.maxArea
	          }
	        }, function () {
	          return _this8.fetchUser();
	        });
	      }).catch(function (error) {
	        return console.log(error);
	      });
	    }
	  }, {
	    key: 'handleSwitch',
	    value: function handleSwitch(key) {
	      var user = _ramda2.default.clone(this.state.user);
	      user[key] = !user[key];
	      this.setState({
	        user: user,
	        isSaved: false
	      });
	    }
	  }, {
	    key: 'handleRange',
	    value: function handleRange(minKey, maxKey) {
	      var _this9 = this;
	
	      return function (value) {
	        var preference = _this9.state.preference;
	
	        preference[minKey] = value.min;
	        preference[maxKey] = value.max;
	        _this9.setState({
	          preference: preference,
	          isSaved: false
	        });
	      };
	    }
	  }, {
	    key: 'handleSelectCategory',
	    value: function handleSelectCategory(el) {
	      var preference = this.state.preference;
	
	      preference.category = el;
	      this.setState({
	        preference: preference,
	        isSaved: false
	      });
	    }
	  }, {
	    key: 'handleSelectLocationType',
	    value: function handleSelectLocationType(type) {
	      this.setState({ locationType: type === 'None' ? null : type });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.setState({ modal: false });
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal(modal) {
	      this.setState({ modal: modal });
	    }
	  }, {
	    key: 'personalInfo',
	    value: function personalInfo() {
	      var _this10 = this;
	
	      var _state4 = this.state;
	      var user = _state4.user;
	      var errors = _state4.errors;
	      var t = this.props.t;
	
	      return _react2.default.createElement(
	        CustomCardContainer,
	        { title: t('Personal Info') },
	        _react2.default.createElement(
	          CustomGrid,
	          { noPadLeft: true, noPadRight: true, noPadTop: true },
	          _react2.default.createElement(
	            FormTitle,
	            null,
	            t('Profile Picture')
	          ),
	          _react2.default.createElement(_Avatar2.default, {
	            imageSrc: user.picture && (user.picture.result || user.picture),
	            size: 140,
	            onEdit: this.handleUpload,
	            handleError: this.handleUploadImageError,
	            error: errors['imageUpload']
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadLeft: true },
	          _react2.default.createElement(_Input2.default, {
	            title: t('First Name'),
	            required: true,
	            handleChange: function handleChange(event) {
	              return _this10.handleChange(event, 'firstName');
	            },
	            value: user.firstName,
	            placeholder: t('Insert user first name'),
	            error: errors['firstName'],
	            name: 'firstName',
	            handleBlur: function handleBlur(event) {
	              return _this10.handleValidate('firstName', user.firstName, errors);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadRight: true },
	          _react2.default.createElement(_Input2.default, {
	            title: t('Last Name'),
	            required: true,
	            handleChange: function handleChange(event) {
	              return _this10.handleChange(event, 'lastName');
	            },
	            value: user.lastName,
	            placeholder: t('Insert user last name'),
	            error: errors['lastName'],
	            name: 'lastName',
	            handleBlur: function handleBlur(event) {
	              return _this10.handleValidate('lastName', user.lastName, errors);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadLeft: true },
	          _react2.default.createElement(_Input2.default, {
	            title: t('E-mail'),
	            required: true,
	            handleChange: function handleChange(event) {
	              return _this10.handleChange(event, 'email');
	            },
	            value: user.email,
	            placeholder: t('Insert user email'),
	            error: errors['email'],
	            name: 'email',
	            handleBlur: function handleBlur(event) {
	              return _this10.handleValidate('email', user.email, errors);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadRight: true },
	          _react2.default.createElement(_Input2.default, {
	            title: t('Phone Number'),
	            required: true,
	            handleChange: function handleChange(event) {
	              return _this10.handleChange(event, 'phoneNumber');
	            },
	            value: user.phoneNumber,
	            placeholder: t('Insert user phone number'),
	            error: errors['phoneNumber'],
	            name: 'phoneNumber',
	            handleBlur: function handleBlur(event) {
	              return _this10.handleValidate('phoneNumber', user.phoneNumber, errors);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomGrid,
	          { noPadLeft: true, noPadRight: true },
	          _react2.default.createElement(_Input2.default, {
	            title: t('Address'),
	            required: true,
	            handleChange: function handleChange(event) {
	              return _this10.handleChange(event, 'address');
	            },
	            value: user.address,
	            placeholder: t('Insert user address'),
	            error: errors['address'],
	            name: 'address',
	            handleBlur: function handleBlur(event) {
	              return _this10.handleValidate('address', user.address, errors);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadLeft: true },
	          _react2.default.createElement(_Input2.default, {
	            title: t('Company'),
	            handleChange: function handleChange(event) {
	              return _this10.handleChange(event, 'company');
	            },
	            value: user.company,
	            placeholder: t('Insert user company')
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadRight: true },
	          _react2.default.createElement(_Input2.default, {
	            title: t('Job Title'),
	            handleChange: function handleChange(event) {
	              return _this10.handleChange(event, 'jobTitle');
	            },
	            value: user.jobTitle,
	            placeholder: t('Insert user job title')
	          })
	        ),
	        _react2.default.createElement(
	          CustomGrid,
	          { noPadLeft: true, noPadRight: true },
	          _react2.default.createElement(_Textarea2.default, {
	            title: t('Brief Description'),
	            handleChange: function handleChange(event) {
	              return _this10.handleChange(event, 'description');
	            },
	            value: user.description,
	            placeholder: t('Insert user description')
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadLeft: true },
	          _react2.default.createElement(_Input2.default, {
	            title: t('City'),
	            handleChange: function handleChange(event) {
	              return _this10.handleChange(event, 'city');
	            },
	            value: user.city,
	            placeholder: t('Insert city')
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadRight: true },
	          _react2.default.createElement(_Input2.default, {
	            title: t('Country'),
	            handleChange: function handleChange(event) {
	              return _this10.handleChange(event, 'country');
	            },
	            value: user.country,
	            placeholder: t('Insert country')
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadLeft: true },
	          _react2.default.createElement(_Input2.default, {
	            title: t('Skype Name'),
	            handleChange: function handleChange(event) {
	              return _this10.handleChange(event, 'skypeName');
	            },
	            value: user.skypeName,
	            placeholder: t('Insert user skype name')
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadRight: true },
	          _react2.default.createElement(_Input2.default, {
	            title: t('Linkedin Profile'),
	            handleChange: function handleChange(event) {
	              return _this10.handleChange(event, 'linkedinUrl');
	            },
	            value: user.linkedinUrl,
	            placeholder: t('Insert user linkedin profile')
	          })
	        )
	      );
	    }
	  }, {
	    key: 'otherInfo',
	    value: function otherInfo() {
	      var _this11 = this;
	
	      var _state5 = this.state;
	      var user = _state5.user;
	      var creation = _state5.creation;
	      var t = this.props.t;
	
	      return _react2.default.createElement(
	        CustomCardContainer,
	        { title: t('Documents and Other Info') },
	        !creation && _react2.default.createElement(
	          CustomGrid,
	          { noPadLeft: true, noPadTop: true },
	          _react2.default.createElement(
	            FormTitle,
	            null,
	            t('NDA')
	          ),
	          _react2.default.createElement(
	            CustomGrid,
	            { xs: 1, noPadLeft: true, noPadTop: true },
	            _react2.default.createElement(
	              NdaContainer,
	              null,
	              _react2.default.createElement('input', {
	                type: 'file',
	                name: 'nda-upload',
	                id: 'nda-upload',
	                onChange: this.handleUploadNda
	              }),
	              _react2.default.createElement(
	                UploadButton,
	                { htmlFor: 'nda-upload' },
	                t('Upload')
	              )
	            ),
	            user.nda && _react2.default.createElement(
	              ViewNdaButton,
	              { href: user.nda, target: '_blank' },
	              t('View Nda')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          CustomGrid,
	          { noPadLeft: true, noPadTop: true },
	          _react2.default.createElement(
	            CustomHalf,
	            { noPadLeft: true },
	            _react2.default.createElement(
	              FormTitle,
	              null,
	              t('Permissions')
	            ),
	            _react2.default.createElement(
	              Text,
	              null,
	              t('Has this user full access?')
	            )
	          ),
	          _react2.default.createElement(
	            CustomHalf,
	            { noPadRight: true },
	            _react2.default.createElement(_Switch2.default, {
	              className: 'right',
	              active: user.hasFullAccess,
	              onClick: function onClick() {
	                return _this11.handleSwitch('hasFullAccess');
	              }
	            })
	          )
	        ),
	        user.recommendedBy && _react2.default.createElement(
	          CustomGrid,
	          { noPadLeft: true, noPadTop: true },
	          _react2.default.createElement(
	            CustomHalf,
	            { noPadLeft: true },
	            _react2.default.createElement(
	              FormTitle,
	              null,
	              t('Recommended by')
	            ),
	            _react2.default.createElement(
	              Text,
	              null,
	              user.recommendedBy
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'preferences',
	    value: function preferences() {
	      var _this12 = this;
	
	      var _state6 = this.state;
	      var categories = _state6.categories;
	      var locations = _state6.locations;
	      var preference = _state6.preference;
	      var userPreferences = _state6.userPreferences;
	      var searchLocation = _state6.searchLocation;
	      var t = this.props.t;
	
	      return _react2.default.createElement(
	        CustomCardContainer,
	        { title: t('Preferences') },
	        _react2.default.createElement(
	          EditPreferenceArea,
	          null,
	          _react2.default.createElement(
	            CustomThird,
	            { noPadLeft: true, noPadTop: true },
	            _react2.default.createElement(_Input2.default, {
	              title: t('Name'),
	              placeholder: t('Insert the preference name'),
	              handleChange: function handleChange(event) {
	                return _this12.handleChangeGeneric(event, 'preferenceName');
	              },
	              value: preference.name
	            })
	          ),
	          _react2.default.createElement(
	            CustomThird,
	            { noPadTop: true },
	            _react2.default.createElement(
	              FormTitle,
	              null,
	              t('Property Type')
	            ),
	            _react2.default.createElement(_Dropdown2.default, {
	              accessor: function accessor(el) {
	                return el.name;
	              },
	              handleSelect: function handleSelect(el) {
	                return _this12.handleSelectCategory(el);
	              },
	              placeholder: t('Choose your favourite categories'),
	              options: categories,
	              selectedOption: preference.category
	            })
	          ),
	          _react2.default.createElement(
	            CustomThird,
	            { noPadRight: true, noPadTop: true },
	            _react2.default.createElement(
	              FormTitle,
	              null,
	              t('Location')
	            ),
	            _react2.default.createElement(_SearchableDropdown2.default, {
	              value: searchLocation,
	              placeholder: t('Choose location'),
	              options: locations,
	              handleSearch: function handleSearch(event) {
	                return _this12.handleChangeGeneric(event, 'location');
	              },
	              handleSelect: function handleSelect(el) {
	                return _this12.handleDropdownSelect(el);
	              },
	              accessor: function accessor(location) {
	                return location.name;
	              }
	            })
	          ),
	          _react2.default.createElement(
	            CustomGrid,
	            { noPadLeft: true, sm: 1 / 4 },
	            _react2.default.createElement(_RangePicker2.default, {
	              title: t('Number of Keys'),
	              max: _Constants.maxRooms,
	              minValue: preference.minNoRooms,
	              maxValue: preference.maxNoRooms,
	              handleChange: function handleChange(value) {
	                return _this12.handleRange('minNoRooms', 'maxNoRooms')(value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            CustomGrid,
	            { sm: 1 / 4 },
	            _react2.default.createElement(_RangePicker2.default, {
	              title: t('Estimated Yield'),
	              max: _Constants.maxYield,
	              minValue: preference.minYield,
	              maxValue: preference.maxYield,
	              handleChange: function handleChange(value) {
	                return _this12.handleRange('minYield', 'maxYield')(value);
	              },
	              unit: '%',
	              rightUnit: true
	            })
	          ),
	          _react2.default.createElement(
	            CustomGrid,
	            { sm: 1 / 4 },
	            _react2.default.createElement(_RangePicker2.default, {
	              title: t('Price'),
	              max: _Constants.maxPrice,
	              minValue: preference.minPrice,
	              maxValue: preference.maxPrice,
	              handleChange: function handleChange(value) {
	                return _this12.handleRange('minPrice', 'maxPrice')(value);
	              },
	              unit: '€'
	            })
	          ),
	          _react2.default.createElement(
	            CustomGrid,
	            { sm: 1 / 4 },
	            _react2.default.createElement(_RangePicker2.default, {
	              title: t('Area'),
	              max: _Constants.maxArea,
	              minValue: preference.minArea,
	              maxValue: preference.maxArea,
	              handleChange: function handleChange(value) {
	                return _this12.handleRange('minArea', 'maxArea')(value);
	              },
	              unit: 'm2',
	              rightUnit: true
	            })
	          ),
	          _react2.default.createElement(
	            CustomGrid,
	            { noPadLeft: true, noPadRight: true },
	            _react2.default.createElement(_Button2.default, {
	              className: 'right',
	              label: t('Add'),
	              onClick: this.handleAddPreference
	            })
	          )
	        ),
	        userPreferences.length > 0 && userPreferences.map(function (pref, index) {
	          return _react2.default.createElement(
	            PreferenceContainer,
	            { key: 'pref-' + index },
	            _react2.default.createElement(
	              CustomGrid,
	              { noPadLeft: true, noPadRight: true, noPadTop: true },
	              _react2.default.createElement(
	                FormTitle,
	                { primary: true },
	                pref.name
	              )
	            ),
	            _react2.default.createElement(
	              CustomGrid,
	              { xs: 1 / 6, noPadLeft: true, noPadRight: true },
	              _react2.default.createElement(
	                FormTitle,
	                null,
	                t('Property Type')
	              ),
	              _react2.default.createElement(
	                Text,
	                null,
	                pref.category.name
	              )
	            ),
	            _react2.default.createElement(
	              CustomGrid,
	              { xs: 1 / 6, noPadLeft: true, noPadRight: true },
	              pref.city && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  FormTitle,
	                  null,
	                  t('City')
	                ),
	                _react2.default.createElement(
	                  Text,
	                  { key: 'key-city-' + index },
	                  pref.city.name
	                )
	              ),
	              pref.country && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  FormTitle,
	                  null,
	                  t('Country')
	                ),
	                _react2.default.createElement(
	                  Text,
	                  { key: 'key-country-' + index },
	                  pref.country.name
	                )
	              ),
	              pref.continent && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  FormTitle,
	                  null,
	                  t('Continent')
	                ),
	                _react2.default.createElement(
	                  Text,
	                  { key: 'key-continent-' + index },
	                  pref.continent.name
	                )
	              )
	            ),
	            _react2.default.createElement(
	              CustomGrid,
	              { xs: 1 / 6, noPadLeft: true, noPadRight: true },
	              _react2.default.createElement(
	                FormTitle,
	                null,
	                t('Number of Keys')
	              ),
	              _react2.default.createElement(
	                Text,
	                null,
	                pref.minNoRooms,
	                ' -',
	                ' ',
	                pref.maxNoRooms ? pref.maxNoRooms : _Constants.maxRooms + '+'
	              )
	            ),
	            _react2.default.createElement(
	              CustomGrid,
	              { xs: 1 / 6, noPadLeft: true, noPadRight: true },
	              _react2.default.createElement(
	                FormTitle,
	                null,
	                t('Estimated Yield')
	              ),
	              _react2.default.createElement(
	                Text,
	                null,
	                pref.minYield,
	                ' -',
	                ' ',
	                pref.maxYield ? pref.maxYield + '%' : _Constants.maxYield + '%+'
	              )
	            ),
	            _react2.default.createElement(
	              CustomGrid,
	              { xs: 1 / 6, noPadLeft: true, noPadRight: true },
	              _react2.default.createElement(
	                FormTitle,
	                null,
	                t('Price')
	              ),
	              _react2.default.createElement(
	                Text,
	                null,
	                pref.minPrice,
	                ' -',
	                ' ',
	                pref.maxPrice ? (0, _Utils.numberWithCommas)(pref.maxPrice) + '\u20AC' : (0, _Utils.numberWithCommas)(_Constants.maxPrice) + '\u20AC+'
	              )
	            ),
	            _react2.default.createElement(
	              CustomGrid,
	              { xs: 1 / 6, noPadLeft: true, noPadRight: true },
	              _react2.default.createElement(
	                FormTitle,
	                null,
	                t('Area')
	              ),
	              _react2.default.createElement(
	                Text,
	                null,
	                pref.minArea,
	                ' -',
	                ' ',
	                pref.maxArea ? (0, _Utils.numberWithCommas)(pref.maxArea) + 'm2' : (0, _Utils.numberWithCommas)(_Constants.maxArea) + 'm2+'
	              )
	            ),
	            _react2.default.createElement(CustomTrash, {
	              onClick: function onClick() {
	                return _this12.handleRemovePreference(pref);
	              }
	            })
	          );
	        })
	      );
	    }
	  }, {
	    key: 'fetchUser',
	    value: function fetchUser() {
	      var _this13 = this;
	
	      var params = this.props.params;
	
	      (0, _AdminSource.searchUsers)({ id: params.id }).then(function (response) {
	        _this13.setState({ user: response.data }, function () {
	          var user = _this13.state.user;
	          if (user.preferences.length > 0) {
	            var criteria = {};
	            criteria.id = user.preferences.map(function (pref) {
	              return pref.id;
	            });
	            (0, _UserSource.fetchPreferences)(criteria).then(function (response) {
	              _this13.setState({ userPreferences: response.data.results });
	            }).catch(function (error) {
	              return console.log(error);
	            });
	          }
	        });
	      }).catch(function (error) {
	        return console.log(error);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this14 = this;
	
	      var _state7 = this.state;
	      var user = _state7.user;
	      var creation = _state7.creation;
	      var modal = _state7.modal;
	      var _props = this.props;
	      var t = _props.t;
	      var router = _props.router;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	
	
	      var actions = [{ label: t('Save'), primary: true, onClick: this.handleSubmit }];
	      if (!creation) {
	        actions.push({
	          label: t('Delete User'),
	          cancel: true,
	          onClick: function onClick() {
	            return _this14.openModal('dialog');
	          }
	        });
	      }
	
	      return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(_AdminNavbar2.default, {
	          admin: admin,
	          dropdownLinks: dropdownLinks,
	          rightSideActions: actions
	        }),
	        _react2.default.createElement(
	          CustomThemeContainer,
	          null,
	          _react2.default.createElement(_DialogModal2.default, {
	            visible: modal === 'dialog',
	            message: t('Are you sure that you want to delete this user?'),
	            closeAction: this.closeModal,
	            header: t('Delete User'),
	            buttons: {
	              apply: { label: t('Delete'), onClick: this.handleDelete },
	              cancel: { label: t('Cancel'), onClick: this.closeModal }
	            }
	          }),
	          _react2.default.createElement(_SuccessModal2.default, {
	            visible: modal === 'success',
	            message: t('User successfuly ' + (creation ? 'created' : 'updated') + '.'),
	            closeAction: this.closeModal,
	            header: t('User ' + (creation ? 'Created' : 'Updated'))
	          }),
	          _react2.default.createElement(_ErrorModal2.default, {
	            visible: modal === 'error',
	            message: t('There was a problem when ' + (creation ? 'creating' : 'updating') + ' the user'),
	            closeAction: this.closeModal,
	            header: t('Error')
	          }),
	          _react2.default.createElement(
	            BackArrowContainer,
	            null,
	            _react2.default.createElement(_BackArrow2.default, { onClick: function onClick() {
	                return router.goBack();
	              } }),
	            _react2.default.createElement(
	              'span',
	              null,
	              creation ? t('Insert User') : user.firstName + ' ' + user.lastName
	            )
	          ),
	          user && this.personalInfo(),
	          user && this.otherInfo(),
	          user && !creation && this.preferences()
	        )
	      );
	    }
	  }]);
	
	  return AdminUserDetails;
	}(_react.Component);
	
	AdminUserDetails.propTypes = {
	  admin: _react.PropTypes.object,
	  t: _react.PropTypes.func,
	  params: _react.PropTypes.object,
	  router: _react.PropTypes.object,
	  location: _react.PropTypes.object,
	  dropdownLinks: _react.PropTypes.array
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'forms', 'admin'], { wait: true })((0, _reactRouter.withRouter)(AdminUserDetails));

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  height: 100vh;\n  overflow: hidden;\n  position: relative;\n'], ['\n  height: 100vh;\n  overflow: hidden;\n  position: relative;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: calc(', 'px - 1px);\n  .searchbar-container {\n    top: calc(', 'px - 1px);\n  }\n  max-height: calc(\n    ', ' - (', 'px +\n          20px)\n  );\n  overflow-y: scroll;\n'], ['\n  margin-top: calc(', 'px - 1px);\n  .searchbar-container {\n    top: calc(', 'px - 1px);\n  }\n  max-height: calc(\n    ', ' - (', 'px +\n          20px)\n  );\n  overflow-y: scroll;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  ', ';\n  text-transform: ', ';\n'], ['\n  ', ';\n  text-transform: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['', ';'], ['', ';']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  width: 100%;\n  .title {\n    float: left;\n  }\n  .select-all {\n    float: right;\n    cursor: pointer;\n  }\n'], ['\n  width: 100%;\n  .title {\n    float: left;\n  }\n  .select-all {\n    float: right;\n    cursor: pointer;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  border-bottom: ', ';\n  height: ', ';\n  width: 100%;\n  display: table;\n  ', ';\n  cursor: pointer;\n'], ['\n  border-bottom: ', ';\n  height: ', ';\n  width: 100%;\n  display: table;\n  ', ';\n  cursor: pointer;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  display: table-cell;\n  vertical-align: middle;\n  ', ';\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  display: table-cell;\n  vertical-align: middle;\n  ', ';\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  margin-right: ', ';\n'], ['\n  margin-right: ', ';\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n  max-height: ', ';\n  overflow-y: scroll;\n'], ['\n  padding-left: ', ' !important;\n  padding-right: ', ' !important;\n  max-height: ', ';\n  overflow-y: scroll;\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  .header {\n    text-align: left;\n    text-transform: capitalize;\n  }\n  #modal-body {\n    max-height: 450px;  \n    text-align: left;\n    padding: ', ';\n  }\n  .footer {\n    padding: ', ';\n    margin-top: -', ';\n    button {\n      float: right;\n    }\n  }\n'], ['\n  .header {\n    text-align: left;\n    text-transform: capitalize;\n  }\n  #modal-body {\n    max-height: 450px;  \n    text-align: left;\n    padding: ', ';\n  }\n  .footer {\n    padding: ', ';\n    margin-top: -', ';\n    button {\n      float: right;\n    }\n  }\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n'], ['\n  margin-bottom: ', ';\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  margin-bottom: ', ';\n'], ['\n  margin-top: ', ';\n  margin-bottom: ', ';\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n  padding: ', ';\n  margin-top: -', ';\n  button {\n    float: right;\n  }\n'], ['\n  padding: ', ';\n  margin-top: -', ';\n  button {\n    float: right;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _reactI18next = __webpack_require__(7);
	
	var _AdminSource = __webpack_require__(31);
	
	var _MailSource = __webpack_require__(519);
	
	var _Themes = __webpack_require__(5);
	
	var _Utils = __webpack_require__(22);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _AdminNavbar = __webpack_require__(36);
	
	var _AdminNavbar2 = _interopRequireDefault(_AdminNavbar);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Tag = __webpack_require__(127);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _Checkbox = __webpack_require__(171);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Modal = __webpack_require__(42);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Textarea = __webpack_require__(74);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CloseIcon = __webpack_require__(65);
	
	var _CloseIcon2 = _interopRequireDefault(_CloseIcon);
	
	var _SearchBar = __webpack_require__(245);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _Constants = __webpack_require__(52);
	
	var _Defaults = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var PageContainer = _styledComponents2.default.section(_templateObject);
	
	var Container = _styledComponents2.default.section(_templateObject2, _Themes.Metrics.components.adminNavbar, _Themes.Metrics.components.adminNavbar, _Themes.Metrics.components.adminContent, _Themes.Metrics.components.adminNavbar);
	
	var Title = _styledComponents2.default.div(_templateObject3, _Themes.Fonts.style.Label, function (props) {
	  return props.capitalize ? 'uppercase' : 'none';
	});
	
	var Preference = _styledComponents2.default.div(_templateObject4, _Themes.Fonts.style.Text);
	
	var CardContainerTitle = _styledComponents2.default.div(_templateObject5);
	
	var User = _styledComponents2.default.div(_templateObject6, _Themes.Metrics.borders.headerBorder, _Themes.Metrics.components.adminListRow, _Themes.Fonts.style.Text);
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject7, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, function (props) {
	  return props.noPadLeft ? 0 : _Themes.Metrics.margins.medium;
	}, function (props) {
	  return props.noPadRight ? 0 : _Themes.Metrics.margins.medium;
	}, function (props) {
	  return props.width && 'width: ' + props.width + 'px';
	});
	
	var CustomGridContainer = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject8, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, function (props) {
	  return props.noPadLeft ? 0 : _Themes.Metrics.margins.medium;
	}, function (props) {
	  return props.noPadRight ? 0 : _Themes.Metrics.margins.medium;
	});
	
	var CustomTag = (0, _styledComponents2.default)(_Tag2.default)(_templateObject9, _Themes.Metrics.margins.small);
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject10, _Themes.Metrics.margins.larger);
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject11, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.customThemeSpacing, _Themes.Metrics.components.adminContent);
	
	var CustomModal = (0, _styledComponents2.default)(_Modal2.default)(_templateObject12, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base, _Themes.Metrics.margins.larger);
	
	var CustomInput = (0, _styledComponents2.default)(_Input2.default)(_templateObject13, _Themes.Metrics.margins.base);
	
	var EmailUsersContainer = _styledComponents2.default.div(_templateObject14, _Themes.Metrics.margins.small, _Themes.Metrics.margins.base);
	
	var ModalFooter = _styledComponents2.default.div(_templateObject15, _Themes.Metrics.margins.base, _Themes.Metrics.margins.larger);
	
	var NoUsers = _styledComponents2.default.div(_templateObject4, _Themes.Fonts.style.Text);
	
	var AdminUsers = function (_Component) {
	  _inherits(AdminUsers, _Component);
	
	  function AdminUsers(props) {
	    _classCallCheck(this, AdminUsers);
	
	    var _this = _possibleConstructorReturn(this, (AdminUsers.__proto__ || Object.getPrototypeOf(AdminUsers)).call(this, props));
	
	    _this.state = {
	      users: [],
	      selectedUsers: [],
	      allUsersSelected: false,
	      openModal: false,
	      emailBody: '',
	      emailSubject: '',
	      isFetching: false,
	      query: _ramda2.default.clone(_Defaults.searchQueryDefault)
	    };
	    _this.retrieveUsers = _this.retrieveUsers.bind(_this);
	    _this.selectUser = _this.selectUser.bind(_this);
	    _this.selectAllUsers = _this.selectAllUsers.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.toogleModal = _this.toogleModal.bind(_this);
	    _this.userDetails = _this.userDetails.bind(_this);
	    _this.sendEmails = _this.sendEmails.bind(_this);
	    _this.updateSettings = _this.updateSettings.bind(_this);
	    return _this;
	  }
	
	  _createClass(AdminUsers, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.retrieveUsers();
	    }
	  }, {
	    key: 'updateSettings',
	    value: function updateSettings(query) {
	      var _this2 = this;
	
	      this.setState({ query: query }, function () {
	        _this2.retrieveUsers();
	      });
	    }
	  }, {
	    key: 'retrieveUsers',
	    value: function retrieveUsers() {
	      var _this3 = this;
	
	      var _state = this.state;
	      var users = _state.users;
	      var query = _state.query;
	
	      var queryObj = Object.assign({}, query, { state: 'approved' });
	
	      if (queryObj.preferredCategories.length === 0) {
	        delete queryObj.preferredCategories;
	      }
	
	      if (queryObj.preferredCities.length === 0) {
	        delete queryObj.preferredCities;
	      }
	
	      if (queryObj.preferredRegions.length === 0) {
	        delete queryObj.preferredRegions;
	      }
	
	      if (queryObj.preferredCountries.length === 0) {
	        delete queryObj.preferredCountries;
	      }
	
	      if (queryObj.maxInvestment === _Constants.maxPrice) {
	        delete queryObj.maxInvestment;
	      }
	
	      if (queryObj.maxNoRooms === _Constants.maxRooms) {
	        delete queryObj.maxNoRooms;
	      }
	
	      if (queryObj.maxYield === _Constants.maxYield) {
	        delete queryObj.maxYield;
	      }
	
	      (0, _AdminSource.findUsers)({ query: queryObj, skip: users.length, limit: 30 }).then(function (response) {
	        return _this3.setState({ users: response.data.results });
	      }).catch(function (error) {
	        return console.log(error);
	      });
	    }
	  }, {
	    key: 'selectUser',
	    value: function selectUser(el) {
	      var selectedUsers = this.state.selectedUsers;
	
	      this.setState({
	        selectedUsers: (0, _Utils.addOrRemoveObjectFromList)(selectedUsers, el)
	      });
	    }
	  }, {
	    key: 'selectAllUsers',
	    value: function selectAllUsers() {
	      var _state2 = this.state;
	      var allUsersSelected = _state2.allUsersSelected;
	      var users = _state2.users;
	      var selectedUsers = _state2.selectedUsers;
	
	      if (allUsersSelected) {
	        selectedUsers = [];
	      } else {
	        selectedUsers = users;
	      }
	      this.setState({ selectedUsers: selectedUsers, allUsersSelected: !allUsersSelected });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event, key) {
	      this.setState(_defineProperty({}, key, event.target.value));
	    }
	  }, {
	    key: 'toogleModal',
	    value: function toogleModal() {
	      this.setState({ openModal: !this.state.openModal });
	    }
	  }, {
	    key: 'userDetails',
	    value: function userDetails(id) {
	      this.props.router.push('/admin/users/' + id);
	    }
	  }, {
	    key: 'sendEmails',
	    value: function sendEmails() {
	      var _this4 = this;
	
	      var users = this.state.selectedUsers.map(function (user) {
	        return user.id;
	      });
	      this.setState({ isFetching: true }, function () {
	        (0, _MailSource.sendMultipleEmails)(users, _this4.state.emailBody, _this4.state.emailSubject).then(function () {
	          _this4.setState({
	            selectedUsers: [],
	            allUsersSelected: false,
	            openModal: false,
	            emailBody: '',
	            emailSubject: '',
	            isFetching: false
	          });
	        }).catch(function (err) {
	          console.log(err);
	          _this4.setState({
	            selectedUsers: [],
	            allUsersSelected: false,
	            openModal: false,
	            emailBody: '',
	            emailSubject: '',
	            isFetching: false
	          });
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props = this.props;
	      var router = _props.router;
	      var t = _props.t;
	      var admin = _props.admin;
	      var dropdownLinks = _props.dropdownLinks;
	      var _state3 = this.state;
	      var users = _state3.users;
	      var selectedUsers = _state3.selectedUsers;
	      var openModal = _state3.openModal;
	      var emailBody = _state3.emailBody;
	      var emailSubject = _state3.emailSubject;
	      var isFetching = _state3.isFetching;
	      var query = _state3.query;
	
	
	      return _react2.default.createElement(
	        PageContainer,
	        null,
	        _react2.default.createElement(
	          CustomModal,
	          {
	            visible: openModal,
	            header: t('Send E-mail'),
	            closeAction: this.toogleModal,
	            footer: _react2.default.createElement(
	              ModalFooter,
	              null,
	              _react2.default.createElement(_Button2.default, {
	                disabled: isFetching,
	                label: t('Send'),
	                onClick: this.sendEmails
	              })
	            ) },
	          _react2.default.createElement(
	            Title,
	            null,
	            t('To')
	          ),
	          _react2.default.createElement(
	            EmailUsersContainer,
	            null,
	            selectedUsers.map(function (el, index) {
	              return _react2.default.createElement(_Tag2.default, {
	                key: 'user-email-' + el.email,
	                text: el.firstName + ' ' + el.lastName,
	                icon: _react2.default.createElement(_CloseIcon2.default, { onClick: function onClick() {
	                    return _this5.selectUser(el);
	                  } })
	              });
	            })
	          ),
	          _react2.default.createElement(CustomInput, {
	            title: t('Subject'),
	            handleChange: function handleChange(event) {
	              return _this5.handleChange(event, 'emailSubject');
	            },
	            email: emailSubject,
	            placeholder: t('Insert Subject')
	          }),
	          _react2.default.createElement(_Textarea2.default, {
	            title: t('E-mail'),
	            handleChange: function handleChange(event) {
	              return _this5.handleChange(event, 'emailBody');
	            },
	            value: emailBody,
	            placeholder: t('Write your e-mail in here')
	          })
	        ),
	        _react2.default.createElement(_AdminNavbar2.default, {
	          fixedSearchBar: true,
	          rightSideActions: [{
	            label: t('Create User'),
	            secondary: true,
	            onClick: function onClick() {
	              return router.push('/admin/users/new');
	            }
	          }, {
	            label: t('Send Email'),
	            primary: true,
	            onClick: function onClick() {
	              return _this5.toogleModal();
	            },
	            disabled: selectedUsers.length === 0
	          }],
	          admin: admin,
	          dropdownLinks: dropdownLinks
	        }),
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(_SearchBar2.default, {
	            settings: query,
	            updateSettings: this.updateSettings,
	            isAdminPage: true
	          }),
	          _react2.default.createElement(
	            CustomThemeContainer,
	            null,
	            _react2.default.createElement(
	              CustomCardContainer,
	              {
	                title: _react2.default.createElement(
	                  CardContainerTitle,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'title' },
	                    t('Users')
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'select-all',
	                      onClick: function onClick() {
	                        return _this5.selectAllUsers();
	                      } },
	                    t('Select All')
	                  )
	                ) },
	              users && users.length > 0 ? users.map(function (el, index) {
	                return _react2.default.createElement(
	                  User,
	                  {
	                    key: 'user-' + el.email,
	                    onClick: function onClick() {
	                      return _this5.userDetails(el.id);
	                    } },
	                  _react2.default.createElement(
	                    CustomGrid,
	                    { xs: 0.5, noPadLeft: true, noPadRight: true, noPadTop: true },
	                    _react2.default.createElement(
	                      CustomGrid,
	                      { noPadLeft: true, noPadTop: true, width: 40 },
	                      _react2.default.createElement(_Checkbox2.default, {
	                        id: 'checkbox-' + el.email,
	                        checked: (0, _Utils.isElementInArray)(selectedUsers, el),
	                        className: 'checkbox',
	                        onClick: function onClick(event) {
	                          event.stopPropagation();
	                          _this5.selectUser(el);
	                        }
	                      })
	                    ),
	                    _react2.default.createElement(
	                      CustomGrid,
	                      { noPadLeft: true, noPadTop: true, width: 90 },
	                      _react2.default.createElement(_Avatar2.default, { imageSrc: el.picture, size: 90 })
	                    ),
	                    _react2.default.createElement(
	                      CustomGrid,
	                      { noPadLeft: true, noPadRight: true, noPadTop: true },
	                      _react2.default.createElement(
	                        Title,
	                        {
	                          capitalize: true },
	                        el.firstName + ' ' + el.lastName
	                      ),
	                      _react2.default.createElement(
	                        Preference,
	                        null,
	                        el.email
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    CustomGrid,
	                    { xs: 0.5, noPadLeft: true, noPadRight: true, noPadTop: true },
	                    _react2.default.createElement(
	                      CustomGridContainer,
	                      {
	                        xs: 1 / 3,
	                        noPadLeft: true,
	                        noPadRight: true,
	                        noPadTop: true },
	                      _react2.default.createElement(
	                        Title,
	                        null,
	                        t('Number of keys')
	                      ),
	                      _react2.default.createElement(
	                        Preference,
	                        null,
	                        el.minNoRooms,
	                        '-',
	                        el.maxNoRooms
	                      )
	                    ),
	                    _react2.default.createElement(
	                      CustomGridContainer,
	                      {
	                        xs: 1 / 3,
	                        noPadLeft: true,
	                        noPadRight: true,
	                        noPadTop: true },
	                      _react2.default.createElement(
	                        Title,
	                        null,
	                        t('Estimated Yield')
	                      ),
	                      _react2.default.createElement(
	                        Preference,
	                        null,
	                        el.minYield,
	                        '-',
	                        el.maxYield
	                      )
	                    ),
	                    _react2.default.createElement(
	                      CustomGridContainer,
	                      {
	                        xs: 1 / 3,
	                        noPadLeft: true,
	                        noPadRight: true,
	                        noPadTop: true },
	                      _react2.default.createElement(
	                        Title,
	                        null,
	                        t('Price')
	                      ),
	                      _react2.default.createElement(
	                        Preference,
	                        null,
	                        (0, _Utils.numberWithCommas)(el.minInvestment),
	                        '-',
	                        (0, _Utils.numberWithCommas)(el.maxInvestment)
	                      )
	                    ),
	                    el.preferredCategories.length > 0 && _react2.default.createElement(
	                      'div',
	                      { style: { marginTop: _Themes.Metrics.margins.base } },
	                      el.preferredCategories.length > 0 && el.preferredCategories.map(function (category, index) {
	                        return _react2.default.createElement(CustomTag, {
	                          text: category.name,
	                          key: 'tag-' + el.email + '-' + index
	                        });
	                      })
	                    )
	                  )
	                );
	              }) : _react2.default.createElement(
	                NoUsers,
	                null,
	                t('There are no users')
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminUsers;
	}(_react.Component);
	
	AdminUsers.propTypes = {
	  admin: _react.PropTypes.object,
	  router: _react.PropTypes.object,
	  t: _react.PropTypes.func,
	  dropdownLinks: _react.PropTypes.array
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'forms', 'admin'], { wait: true })(AdminUsers);

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding-left: ', ';\n  padding-right: ', ';\n  button {\n    margin-top: ', ';\n    float: right\n  }\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n'], ['\n  padding-left: ', ';\n  padding-right: ', ';\n  button {\n    margin-top: ', ';\n    float: right\n  }\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  height: 100%;\n'], ['\n  height: 100%;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  padding-left: 0;\n  list-style: none;\n  ', ';\n\n  li {\n    margin: ', ' 0;\n    padding-bottom: ', ';\n    border-bottom: ', ';\n\n    li {\n      padding-bottom: 0;\n      margin: ', ' 0;\n      border-bottom: none;\n    }\n  }\n'], ['\n  padding-left: 0;\n  list-style: none;\n  ', ';\n\n  li {\n    margin: ', ' 0;\n    padding-bottom: ', ';\n    border-bottom: ', ';\n\n    li {\n      padding-bottom: 0;\n      margin: ', ' 0;\n      border-bottom: none;\n    }\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  padding-left: 0;\n  ', ';\n\n  counter-reset: item;\n  li:before {\n    content: counters(item, ".") ".";\n    counter-increment: item;\n  }\n  ol {\n    padding-left: ', ';\n  }\n\n  li {\n    display: block;\n    padding-bottom: ', ';\n    border-bottom: none;\n  }\n'], ['\n  padding-left: 0;\n  ', ';\n\n  counter-reset: item;\n  li:before {\n    content: counters(item, ".") ".";\n    counter-increment: item;\n  }\n  ol {\n    padding-left: ', ';\n  }\n\n  li {\n    display: block;\n    padding-bottom: ', ';\n    border-bottom: none;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  ', ';\n  margin-top: ', ';\n'], ['\n  ', ';\n  margin-top: ', ';\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n  ', ';\n'], ['\n  margin-bottom: ', ';\n  ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _reactI18next = __webpack_require__(7);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _Themes = __webpack_require__(5);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Validations = __webpack_require__(44);
	
	var _ContractsSource = __webpack_require__(76);
	
	var _Loader = __webpack_require__(45);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.base, _Themes.Metrics.breakpoints.mobile);
	
	var CustomHalf = (0, _styledComponents2.default)(_gridStyled.Half)(_templateObject2, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.breakpoints.mobile);
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject3);
	
	var List = _styledComponents2.default.ul(_templateObject4, _Themes.Fonts.style.Text, _Themes.Metrics.margins.base, _Themes.Metrics.margins.small, _Themes.Metrics.borders.default, _Themes.Metrics.margins.small);
	
	var OrderedList = _styledComponents2.default.ol(_templateObject5, _Themes.Fonts.style.Text, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.small);
	
	var Terms = _styledComponents2.default.div(_templateObject6, _Themes.Fonts.style.Text, _Themes.Metrics.margins.base);
	
	var Title = _styledComponents2.default.div(_templateObject7, _Themes.Metrics.margins.small, _Themes.Fonts.style.Label);
	
	var CollaborationAgreement = function (_Component) {
	  _inherits(CollaborationAgreement, _Component);
	
	  function CollaborationAgreement(props) {
	    _classCallCheck(this, CollaborationAgreement);
	
	    var _this = _possibleConstructorReturn(this, (CollaborationAgreement.__proto__ || Object.getPrototypeOf(CollaborationAgreement)).call(this, props));
	
	    _this.state = {
	      name: '',
	      company: '',
	      address: '',
	      phoneNumber: '',
	      email: '',
	      function: '',
	      generating: false,
	      errors: {
	        name: '',
	        company: '',
	        address: '',
	        phoneNumber: '',
	        email: '',
	        function: ''
	      }
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.downloadFile = _this.downloadFile.bind(_this);
	    _this.handleValidate = _this.handleValidate.bind(_this);
	    return _this;
	  }
	
	  _createClass(CollaborationAgreement, [{
	    key: 'handleChange',
	    value: function handleChange(event, key) {
	      var state = _ramda2.default.clone(this.state);
	      state[key] = event.target.value;
	      this.setState(state);
	    }
	  }, {
	    key: 'downloadFile',
	    value: function downloadFile() {
	      var _this2 = this;
	
	      var errors = this.state.errors;
	
	      var validation = (0, _Validations.validateForm)(this.state, errors);
	
	      if (validation.valid) {
	        this.setState({ generating: true }, function () {
	          (0, _ContractsSource.generateAmbassadorAgreement)({
	            name: _this2.state.name,
	            company: _this2.state.company,
	            address: _this2.state.address,
	            phoneNumber: _this2.state.phoneNumber,
	            email: _this2.state.email,
	            function: _this2.state.function
	          }).then(function (response) {
	            _this2.setState({ generating: false });
	            document.location = response.data.url;
	          }).catch(console.error);
	        });
	      } else {
	        this.setState({ errors: validation.errors });
	      }
	    }
	  }, {
	    key: 'handleValidate',
	    value: function handleValidate(name, value, errors) {
	      var newErrors = (0, _Validations.validateInput)(name, value, errors);
	      this.setState({ errors: newErrors });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var t = this.props.t;
	      var errors = this.state.errors;
	
	      var keys = [{ key: 'name', label: t('Name'), placeholder: t('Name') }, { key: 'company', label: t('Company'), placeholder: t('Company Name') }, {
	        key: 'address',
	        label: t('Address'),
	        placeholder: t('Company Address')
	      }, { key: 'phoneNumber', label: t('Phone'), placeholder: t('Phone Number') }, { key: 'email', label: t('Email'), placeholder: t('E-mail') }, { key: 'function', label: t('Function'), placeholder: t('Function') }];
	
	      return _react2.default.createElement(
	        CustomCardContainer,
	        { title: t('NDA & Ambassador Agreement') },
	        _react2.default.createElement(_Loader2.default, { visible: this.state.generating }),
	        _react2.default.createElement(
	          CustomGrid,
	          null,
	          _react2.default.createElement(
	            Terms,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Whereby the Ambassador wishes to introduce Business Associates and Clients to HvB in quality of HvB Ambassador.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Whereby the Parties wish to maintain the confidentiality and/or the proprietary nature of the Confidential Information disclosed.'
	            ),
	            'Whereby the Parties wish to set the basis for a lasting business relationship.',
	            _react2.default.createElement(
	              List,
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Definitions'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    '\u201CBusiness Associates\u201D means, business affiliates, investors, financers, Clients, employees, vendors, asset owners, Intermediaries and any other third party relations.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    '\u201CClient\u201D means third parties directly interested in acquiring or selling real estate or other assets.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    '\u201CConfidential Information\u201D means any and all information disclosed orally or in writing or made available by any Party ("Disclosing Party") to another Party ("Recipient") so long as not explicitly designated as not confidential by the Disclosing Party. In addition, the existence and terms of this Agreement shall also be treated as Confidential Information.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    '\u201CInvestment\u201D means, any transfer of funds or any other assets, of which the value can be determined, in view to purchase, grant a loan, lease, or otherwise benefit the owner of an asset.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    '\u201CTransaction\u201D means, the sale of one (1) asset either directly listed in HvB\u2019s portfolio or sold through or by a Business Associate of HvB.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Confidentiality and Non-Disclosure'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Parties agree to maintain the confidentiality of the Confidential Information and to prevent its unauthorized dissemination or use, subject to the exceptions enumerated in Section 2.5. of this Agreement.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Parties agree not to use the Confidential Information for purposes other than that necessary to consider and enable the business relationship or pursue transaction between or involving the Parties or one of the Parties.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Recipient shall protect the Confidential Information by using the same degree of care, but no less than reasonable care, to prevent the unauthorized use, dissemination or publication of the Confidential Information as the Recipient uses to protect its own Confidential Information.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Recipient shall limit its internal disclosure of the Confidential Information to only those employees, accountants, attorneys and affiliates who have a need to know the information for the limited purpose of the proposed business relationship or transaction between the Parties.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement shall impose no obligations with respect to Confidential Information which:',
	                    _react2.default.createElement(
	                      OrderedList,
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is disclosed with the prior written consent of the Disclosing Party;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is now, or hereafter becomes, through no act or failure to act on the part of the Recipient, generally known or available to the public;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'was already known by Recipient before receiving such information from the Disclosing Party, as evidenced by written documents;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is information which the Recipient can document was independently developed by the Recipient without reference to or use of any Confidential Information received from the Disclosing Party;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is required to be disclosed pursuant governmental agencies or law. In such cases, the Recipient seeking to disclose Confidential Information will provide to the Disclosing Party notice prior to such disclosure so as to afford the Disclosing Party a reasonable opportunity to file objections to the disclosure with the appropriate agency or entity.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Recipient acknowledges and agrees that all the Confidential Information of the Disclosing Party is and shall remain the sole and exclusive property of the Disclosing Party, free of any and all claims of the Recipient.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Ambassador'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Ambassador is authorised to act as an Ambassador of HvB. In doing so, the Ambassador shall act with utmost professionalism and diligence and in respect of the values of HvB.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Ambassador herewith explicitly permits HvB, after successful introduction of his Business Associates, to contact Business Associates directly, for the purpose to consider and enable or pursue a Transaction involving that Business Associate.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Ambassador is not authorized to represent HvB or conclude any agreement for or in the name of HvB, without the prior explicit written consent of HvB.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Ambassador Fee'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'In the case of a successful Transaction including a Business Associate introduced to HvB by the Ambassador, the Ambassador is entitled to receive a commission fee. No Ambassador Fee applies if HvB is already in contact with the Business Associate or already has knowledge of the availability of the asset prior to the introduction by the Ambassador.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The commission fee is structured as follows:',
	                    _react2.default.createElement(
	                      OrderedList,
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'In case of a direct introduction to an investor or the owner of an asset, the ambassador commission is of 0.1% of the total Transaction value, capped at CHF 100\u2019000 per successful Transaction, for the first 3 Transactions.'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'In case of a direct introduction to an intermediary, directly representing an investor or the owner of an asset, the ambassador commission is of 0.05% of the total Transaction value, capped at CHF 50\u2019000 per successful Transaction, for the first 3 Transactions.'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'In case of an introduction to any other Business Associate, other than those described in clauses 4.2.1. and 4.2.2. above, the ambassador commission is of 0.025% of the total Transaction value, capped at CHF 25\u2019000, only for the first Transaction. The same applies for the simple delivery of contact information, not publically available, of investors or asset owners or their direct representatives, without corresponding introduction.'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Validity and Termination'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement shall be valid once signed by both Parties.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The obligations in this Agreement are continuing and shall survive the termination of any discussions or negotiations between the Parties.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement may be terminated by either Party for any reason and at any time, by written notice given to the other Party. However, any such termination shall have no effect on the rights and obligations of the Parties under this Agreement in respect to Transactions executed, or in the process of being executed prior to such termination and especially with regards to Confidential Information client and contact protection.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Amendments'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Any amendment of this Agreement shall only be valid if made in written form and if signed by both Parties.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Governing law and jurisdiction'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement shall in all respects be governed by and construed in accordance with Swiss law, without giving effect to its conflict of law principles. All disputes arising from or in connection with this Agreement, including disputes regarding its conclusion, validity, binding effect, amendment, breach, termination or rescission, shall be subject to the exclusive jurisdiction of courts of the Canton of Zurich.'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        keys.map(function (el, index) {
	          return _react2.default.createElement(
	            CustomHalf,
	            {
	              key: el.key,
	              noPadLeft: index % 2 === 0,
	              noPadRight: index % 2 === 1 },
	            _react2.default.createElement(_Input2.default, {
	              placeholder: el.placeholder,
	              name: el.key,
	              required: true,
	              title: el.label,
	              value: _this3.state[el.key],
	              handleChange: function handleChange(event) {
	                return _this3.handleChange(event, el.key);
	              },
	              error: errors[el.key],
	              handleBlur: function handleBlur(event) {
	                return _this3.handleValidate(el.key, _this3.state[el.key], errors);
	              }
	            })
	          );
	        }),
	        _react2.default.createElement(
	          CustomGrid,
	          null,
	          _react2.default.createElement(_Button2.default, { label: t('Download'), onClick: this.downloadFile })
	        )
	      );
	    }
	  }]);
	
	  return CollaborationAgreement;
	}(_react.Component);
	
	CollaborationAgreement.propTypes = {
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  children: _react.PropTypes.node
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'forms', 'admin'], { wait: true })(CollaborationAgreement);

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding-left: ', ';\n  padding-right: ', ';\n  button {\n    margin-top: ', ';\n    float: right\n  }\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n'], ['\n  padding-left: ', ';\n  padding-right: ', ';\n  button {\n    margin-top: ', ';\n    float: right\n  }\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  height: 100%;\n'], ['\n  height: 100%;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  padding-left: 0;\n  list-style: none;\n  ', ';\n\n  li {\n    margin: ', ' 0;\n    padding-bottom: ', ';\n    border-bottom: ', ';\n\n    li {\n      padding-bottom: 0;\n      margin: ', ' 0;\n      border-bottom: none;\n    }\n  }\n'], ['\n  padding-left: 0;\n  list-style: none;\n  ', ';\n\n  li {\n    margin: ', ' 0;\n    padding-bottom: ', ';\n    border-bottom: ', ';\n\n    li {\n      padding-bottom: 0;\n      margin: ', ' 0;\n      border-bottom: none;\n    }\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  padding-left: 0;\n  ', ';\n\n  counter-reset: item;\n  li:before {\n    content: counters(item, ".") ".";\n    counter-increment: item;\n  }\n  ol {\n    padding-left: ', ';\n  }\n\n  li {\n    display: block;\n    margin: ', ' 0;\n    border-bottom: none;\n  }\n'], ['\n  padding-left: 0;\n  ', ';\n\n  counter-reset: item;\n  li:before {\n    content: counters(item, ".") ".";\n    counter-increment: item;\n  }\n  ol {\n    padding-left: ', ';\n  }\n\n  li {\n    display: block;\n    margin: ', ' 0;\n    border-bottom: none;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  ', ';\n  margin-top: ', ';\n'], ['\n  ', ';\n  margin-top: ', ';\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n  ', ';\n'], ['\n  margin-bottom: ', ';\n  ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _reactI18next = __webpack_require__(7);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _Themes = __webpack_require__(5);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Validations = __webpack_require__(44);
	
	var _ContractsSource = __webpack_require__(76);
	
	var _Dropdown = __webpack_require__(60);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Loader = __webpack_require__(45);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.base, _Themes.Metrics.breakpoints.mobile);
	
	var CustomHalf = (0, _styledComponents2.default)(_gridStyled.Half)(_templateObject2, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.breakpoints.mobile);
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject3);
	
	var List = _styledComponents2.default.ul(_templateObject4, _Themes.Fonts.style.Text, _Themes.Metrics.margins.base, _Themes.Metrics.margins.small, _Themes.Metrics.borders.default, _Themes.Metrics.margins.small);
	
	var OrderedList = _styledComponents2.default.ol(_templateObject5, _Themes.Fonts.style.Text, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.small);
	
	var Terms = _styledComponents2.default.div(_templateObject6, _Themes.Fonts.style.Text, _Themes.Metrics.margins.base);
	
	var Title = _styledComponents2.default.div(_templateObject7, _Themes.Metrics.margins.small, _Themes.Fonts.style.Label);
	
	var CollaborationAgreement = function (_Component) {
	  _inherits(CollaborationAgreement, _Component);
	
	  function CollaborationAgreement(props) {
	    _classCallCheck(this, CollaborationAgreement);
	
	    var _this = _possibleConstructorReturn(this, (CollaborationAgreement.__proto__ || Object.getPrototypeOf(CollaborationAgreement)).call(this, props));
	
	    var commissions = [];
	    var commission = 0.25;
	    while (commission <= 3) {
	      commissions.push(commission + '%');
	      commission += 0.25;
	    }
	    _this.state = {
	      options: commissions,
	      commission: '',
	      name: '',
	      company: '',
	      address: '',
	      phoneNumber: '',
	      email: '',
	      function: '',
	      generating: false,
	      errors: {
	        commission: '',
	        name: '',
	        company: '',
	        address: '',
	        phoneNumber: '',
	        email: '',
	        function: ''
	      }
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.downloadFile = _this.downloadFile.bind(_this);
	    _this.handleValidate = _this.handleValidate.bind(_this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  _createClass(CollaborationAgreement, [{
	    key: 'handleChange',
	    value: function handleChange(event, key) {
	      var state = _ramda2.default.clone(this.state);
	      state[key] = event.target.value;
	      this.setState(state);
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(el, key) {
	      var state = _ramda2.default.clone(this.state);
	      state[key] = el.toString();
	      this.setState(state);
	    }
	  }, {
	    key: 'downloadFile',
	    value: function downloadFile() {
	      var _this2 = this;
	
	      var errors = this.state.errors;
	
	      var validation = (0, _Validations.validateForm)(this.state, errors);
	
	      if (validation.valid) {
	        this.setState({ generating: true }, function () {
	          (0, _ContractsSource.generateCollaborationAgreement)({
	            name: _this2.state.name,
	            company: _this2.state.company,
	            address: _this2.state.address,
	            phoneNumber: _this2.state.phoneNumber,
	            email: _this2.state.email,
	            function: _this2.state.function,
	            commission: _this2.state.commission
	          }).then(function (response) {
	            _this2.setState({ generating: false });
	            document.location = response.data.url;
	          }).catch(console.error);
	        });
	      } else {
	        this.setState({ errors: validation.errors });
	      }
	    }
	  }, {
	    key: 'handleValidate',
	    value: function handleValidate(name, value, errors) {
	      var newErrors = (0, _Validations.validateInput)(name, value, errors);
	      this.setState({ errors: newErrors });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var t = this.props.t;
	      var errors = this.state.errors;
	
	      var keys = [{ key: 'name', label: t('Name'), placeholder: t('Name') }, { key: 'company', label: t('Company'), placeholder: t('Company Name') }, {
	        key: 'address',
	        label: t('Address'),
	        placeholder: t('Company Address')
	      }, { key: 'phoneNumber', label: t('Phone'), placeholder: t('Phone Number') }, { key: 'email', label: t('Email'), placeholder: t('E-mail') }, { key: 'function', label: t('Function'), placeholder: t('Function') }];
	
	      return _react2.default.createElement(
	        CustomCardContainer,
	        { title: t('NCNDA & Collaboration Agreement') },
	        _react2.default.createElement(_Loader2.default, { visible: this.state.generating }),
	        _react2.default.createElement(
	          CustomGrid,
	          null,
	          _react2.default.createElement(
	            Terms,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Whereby the Parties wish to initiate their collaboration on the potential sale of real estate related transactions worldwide, and therefore wish to define more clearly the terms under which they plan to execute the Transactions, and the manner and amount of commission payment deriving from such Transactions.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Whereby the Parties wish to maintain the confidentiality and/or the proprietary nature of the Confidential Information disclosed.'
	            ),
	            'Whereby the Parties wish to set the basis for a lasting business relationship.',
	            _react2.default.createElement(
	              List,
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Definitions'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    '\u201CBusiness Associates\u201D means, business affiliates, investors, financers, Clients, employees, vendors, asset owners, Intermediaries and any other third party relations.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    '\u201CClient\u201D means third parties directly interested in acquiring or selling real estate or other assets.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    '\u201CCommission\u201D means, any monetary compensation paid by a Client, a Business Associate or any other person and/or entity in consideration of introductions made and/or transactions successfully closed.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    '\u201CConfidential Information\u201D means any and all information disclosed orally or in writing or made available by any Party ("Disclosing Party") to another Party ("Recipient") as long as not explicitly designated as not confidential by the Disclosing Party. In addition, the existence and terms of this Agreement shall also be treated as Confidential Information.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    '\u201CIntermediary\u201D means any Party or third party that does not have a direct mandate from a Client, but works with other Business Associates, who themselves have the direct mandate'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    '\u201CTotal Commission\u201D means the pot composed of both buyer and seller side commission.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    '\u201CTransaction\u201D means, the sale of one (1) asset either directly listed in HvB\u2019s portfolio or sold through or by a Business Associate and/or a Client of HvB.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Confidentiality and Non-Disclosure'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Parties agree to maintain the confidentiality of the Confidential Information and to prevent its unauthorized dissemination or use, subject to the exceptions enumerated in Section 2.5. of this Agreement.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Parties agree not to use the Confidential Information for purposes other than that necessary to consider and enable the business relationship or pursue Transactions between or involving the Parties or one of the Parties.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Recipient shall protect the Confidential Information by using a high degree of care, to prevent the unauthorized use, dissemination or publication of the Confidential Information.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Recipient shall limit its internal disclosure of the Confidential Information to only those employees, accountants, attorneys and affiliates who have a provable need to access the information for the limited purpose of the proposed business relationship or transaction between the Parties.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement shall impose no obligations with respect to Confidential Information which:',
	                    _react2.default.createElement(
	                      OrderedList,
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is disclosed with the prior written consent of the Disclosing Party;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is now, or hereafter becomes, through no act or failure to act on the part of the Recipient, generally known or available to the public;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'was already known by the Recipient before receiving such information from the Disclosing Party, as evidenced by written documents;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is information which the Recipient can document was independently developed by the Recipient without reference to or use of any Confidential Information received from the Disclosing Party;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is required to be disclosed pursuant governmental agencies or law. In such cases, the Recipient seeking to disclose Confidential Information will provide notice to the Disclosing Party prior to such disclosure to afford the Disclosing Party a reasonable opportunity to file objections to the disclosure with the appropriate agency or entity. In case Confidential Information must legally be disclosed, the Disclosing Party is responsible to disclose not more than the absolute minimum necessary.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Recipient acknowledges and agrees that all the Confidential Information of the Disclosing Party is and shall remain the sole and exclusive property of the Disclosing Party, free of any and all claims of the Recipient.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Each Party shall be responsible for compliance with all applicable federal, state and local (in foreign jurisdictions) laws and regulations, including all applicable rules of self-regulatory organizations. To the extent that either Party fails to comply with such regulations, it shall indemnify the other Party or parties from any damages resulting from the violation.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Non-Circumvention and Non-Solicitation'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Parties agree not to directly or indirectly circumvent each other and not to work/ deal/ transact with Business Associates introduced by each Party at any time, without the knowledge and explicit permission of the introducing Party. This clause is valid indefinitely, and is not affected by a possible cancellation of this Agreement.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'In case of unauthorized circumvention or solicitation, in addition to the Commission usually due to the affected Party, the violating Party is liable to pay to the affected Party a penalty equal to the total Commission obtained by the violating Party on this Transaction.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The payment of the penalty in no way transfers the ownership of the Client or Business Associate to the violating Party. Any further Transaction with the concerned Client or Business Associate, without express approval of the affected Party, shall trigger this penalty anew.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Commission'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Parties shall share the Commission in a 50:50 ratio, i.e. each Party will receive 50% of the Total Commission, perceived from both seller and buyer, with regards to the total Transaction price.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Each Party is responsible to sign non-disclosure and commission agreements with their respective Clients upfront, whereby the Parties aim to reach a commission from both, the seller and/or the buyer respectively',
	                    ' ',
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      this.state.commission || t('COMMISSION')
	                    ),
	                    '.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'In case a Party is an Intermediary, the following applies:',
	                    _react2.default.createElement(
	                      OrderedList,
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'the Party shall disclose to the other Party the identity of the Business Associate directly mandated by the Client;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'the Party shall conclude with the Business Associate an agreement covering the essential points of the present Agreement, i.e. non-disclosure, non-circumvention and commission;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'the commission sharing, as defined in clause 4.1 above, is not affected by the fact that one Party is an Intermediary for a particular Transaction, i.e. the other Party remains entitled to 50% of the Total Commission on the total Transaction value.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'A different commission sharing structure between the Parties may only be agreed in writing.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Parties\u2019 share of the Commission is to be paid to the account defined by each Party within a period of 7 (seven) days after the successful completion of the Transaction.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Validity and Termination'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement shall be valid once signed by both Parties, from the last date written below.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement may be terminated by either Party for any reason and at any time, by written notice given to the other Party. However, any such termination shall have no effect on the rights and obligations of the Parties under this Agreement in respect to Transactions executed, or in the process of being executed prior to such termination and especially with regards to Confidential Information client and contact protection.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Amendments'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Any amendment of this Agreement shall only be valid if made in written form and if signed by both Parties.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Governing law and jurisdiction'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement shall in all respects be governed by and construed in accordance with Swiss law, without giving effect to its conflict of law principles. All disputes arising from or in connection with this Agreement, including disputes regarding its conclusion, validity, binding effect, amendment, breach, termination or rescission, shall be subject to the exclusive jurisdiction of the courts of the Canton of Zurich.'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { key: 'commission', noPadRight: true },
	          _react2.default.createElement(
	            Title,
	            null,
	            t('Commission')
	          ),
	          _react2.default.createElement(_Dropdown2.default, {
	            placeholder: t('Select commission value'),
	            options: this.state.options,
	            selectedOption: this.state.commission,
	            handleSelect: function handleSelect(el) {
	              return _this3.handleSelect(el, 'commission');
	            },
	            error: errors.commission,
	            handleBlur: function handleBlur(event) {
	              return _this3.handleValidate('commission', _this3.state.commission, errors);
	            },
	            name: 'commission',
	            required: true
	          })
	        ),
	        keys.map(function (el, index) {
	          return _react2.default.createElement(
	            CustomHalf,
	            {
	              key: el.key,
	              noPadLeft: index % 2 === 0,
	              noPadRight: index % 2 === 1 },
	            _react2.default.createElement(_Input2.default, {
	              placeholder: el.placeholder,
	              name: el.key,
	              required: true,
	              title: el.label,
	              value: _this3.state[el.key],
	              handleChange: function handleChange(event) {
	                return _this3.handleChange(event, el.key);
	              },
	              error: errors[el.key],
	              handleBlur: function handleBlur(event) {
	                return _this3.handleValidate(el.key, _this3.state[el.key], errors);
	              }
	            })
	          );
	        }),
	        _react2.default.createElement(
	          CustomGrid,
	          null,
	          _react2.default.createElement(_Button2.default, { label: t('Download'), onClick: this.downloadFile })
	        )
	      );
	    }
	  }]);
	
	  return CollaborationAgreement;
	}(_react.Component);
	
	CollaborationAgreement.propTypes = {
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  children: _react.PropTypes.node
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'forms', 'admin'], { wait: true })(CollaborationAgreement);

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding-left: ', ';\n  padding-right: ', ';\n  button {\n    margin-top: ', ';\n    float: right\n  }\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n'], ['\n  padding-left: ', ';\n  padding-right: ', ';\n  button {\n    margin-top: ', ';\n    float: right\n  }\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  height: 100%;\n'], ['\n  height: 100%;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  padding-left: 0;\n  list-style: none;\n  ', ';\n\n  li {\n    margin: ', ' 0;\n    padding-bottom: ', ';\n    border-bottom: ', ';\n\n    li {\n      padding-bottom: 0;\n      margin: ', ' 0;\n      border-bottom: none;\n    }\n  }\n'], ['\n  padding-left: 0;\n  list-style: none;\n  ', ';\n\n  li {\n    margin: ', ' 0;\n    padding-bottom: ', ';\n    border-bottom: ', ';\n\n    li {\n      padding-bottom: 0;\n      margin: ', ' 0;\n      border-bottom: none;\n    }\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  ', ';\n  margin-top: ', ';\n'], ['\n  ', ';\n  margin-top: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n  ', ';\n'], ['\n  margin-bottom: ', ';\n  ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _reactI18next = __webpack_require__(7);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _Themes = __webpack_require__(5);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Validations = __webpack_require__(44);
	
	var _Dropdown = __webpack_require__(60);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _ContractsSource = __webpack_require__(76);
	
	var _Loader = __webpack_require__(45);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.base, _Themes.Metrics.breakpoints.mobile);
	
	var CustomHalf = (0, _styledComponents2.default)(_gridStyled.Half)(_templateObject2, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.breakpoints.mobile);
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject3);
	
	var List = _styledComponents2.default.ul(_templateObject4, _Themes.Fonts.style.Text, _Themes.Metrics.margins.base, _Themes.Metrics.margins.small, _Themes.Metrics.borders.default, _Themes.Metrics.margins.small);
	
	var Terms = _styledComponents2.default.div(_templateObject5, _Themes.Fonts.style.Text, _Themes.Metrics.margins.base);
	
	var Title = _styledComponents2.default.div(_templateObject6, _Themes.Metrics.margins.small, _Themes.Fonts.style.Label);
	
	var CommissionAgreement = function (_Component) {
	  _inherits(CommissionAgreement, _Component);
	
	  function CommissionAgreement(props) {
	    _classCallCheck(this, CommissionAgreement);
	
	    var _this = _possibleConstructorReturn(this, (CommissionAgreement.__proto__ || Object.getPrototypeOf(CommissionAgreement)).call(this, props));
	
	    var commissions = [];
	    var commission = 0.25;
	    while (commission <= 5) {
	      commissions.push(commission + '%');
	      commission += 0.25;
	    }
	    _this.state = {
	      options: commissions,
	      name: '',
	      company: '',
	      address: '',
	      phoneNumber: '',
	      email: '',
	      transaction: '',
	      commission: '',
	      validity: '',
	      generating: false,
	      errors: {
	        validity: '',
	        transaction: '',
	        name: '',
	        company: '',
	        address: '',
	        phoneNumber: '',
	        email: '',
	        commission: ''
	      }
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.downloadFile = _this.downloadFile.bind(_this);
	    _this.handleValidate = _this.handleValidate.bind(_this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  _createClass(CommissionAgreement, [{
	    key: 'handleChange',
	    value: function handleChange(event, key) {
	      var state = _ramda2.default.clone(this.state);
	      state[key] = event.target.value;
	      this.setState(state);
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(el, key) {
	      var state = _ramda2.default.clone(this.state);
	      state[key] = el.toString();
	      this.setState(state);
	    }
	  }, {
	    key: 'downloadFile',
	    value: function downloadFile() {
	      var _this2 = this;
	
	      var errors = this.state.errors;
	
	      var validation = (0, _Validations.validateForm)(this.state, errors);
	
	      if (validation.valid) {
	        this.setState({ generating: true }, function () {
	          (0, _ContractsSource.generateCommissionAgreement)({
	            name: _this2.state.name,
	            company: _this2.state.company,
	            address: _this2.state.address,
	            phoneNumber: _this2.state.phoneNumber,
	            email: _this2.state.email,
	            transaction: _this2.state.transaction,
	            commission: _this2.state.commission,
	            validity: _this2.state.validity
	          }).then(function (response) {
	            _this2.setState({ generating: false });
	            document.location = response.data.url;
	          }).catch(console.error);
	        });
	      } else {
	        this.setState({ errors: validation.errors });
	      }
	    }
	  }, {
	    key: 'handleValidate',
	    value: function handleValidate(name, value, errors) {
	      var newErrors = (0, _Validations.validateInput)(name, value, errors);
	      this.setState({ errors: newErrors });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var t = this.props.t;
	      var errors = this.state.errors;
	
	
	      var transactionKeys = [{
	        key: 'transaction',
	        label: t('Transaction'),
	        placeholder: t('Transaction Number')
	      }];
	
	      var keys = [{ key: 'name', label: t('Name'), placeholder: t('Name') }, { key: 'company', label: t('Company'), placeholder: t('Company Name') }, {
	        key: 'address',
	        label: t('Address'),
	        placeholder: t('Company Address')
	      }, { key: 'phoneNumber', label: t('Phone'), placeholder: t('Phone Number') }, { key: 'email', label: t('Email'), placeholder: t('E-mail') }];
	
	      var validityOptions = ['All future transactions between the Client and leads introduced by HvB', 'The following transaction'];
	
	      return _react2.default.createElement(
	        CustomCardContainer,
	        { title: t('Commission Agreement') },
	        _react2.default.createElement(_Loader2.default, { visible: this.state.generating }),
	        _react2.default.createElement(
	          CustomHalf,
	          { key: 'validity', noPadRight: true },
	          _react2.default.createElement(
	            Title,
	            null,
	            t('Validity')
	          ),
	          _react2.default.createElement(_Dropdown2.default, {
	            placeholder: t('Select the validity of the transaction'),
	            options: validityOptions,
	            selectedOption: this.state.validity,
	            handleSelect: function handleSelect(el) {
	              return _this3.handleSelect(el, 'validity');
	            },
	            error: errors.validity,
	            handleBlur: function handleBlur(event) {
	              return _this3.handleValidate('validity', _this3.state.validity, errors);
	            },
	            name: 'validity',
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { key: 'commission', noPadRight: true },
	          _react2.default.createElement(
	            Title,
	            null,
	            t('Commission')
	          ),
	          _react2.default.createElement(_Dropdown2.default, {
	            placeholder: t('Select commission value'),
	            options: this.state.options,
	            selectedOption: this.state.commission,
	            handleSelect: function handleSelect(el) {
	              return _this3.handleSelect(el, 'commission');
	            },
	            error: errors.commission,
	            handleBlur: function handleBlur(event) {
	              return _this3.handleValidate('commission', _this3.state.commission, errors);
	            },
	            name: 'commission',
	            required: true
	          })
	        ),
	        this.state.validity === validityOptions[1] && transactionKeys.map(function (el, index) {
	          return _react2.default.createElement(
	            CustomHalf,
	            {
	              key: el.key,
	              noPadLeft: index % 2 === 0,
	              noPadRight: index % 2 === 1 },
	            _react2.default.createElement(_Input2.default, {
	              placeholder: el.placeholder,
	              name: el.key,
	              required: true,
	              title: el.label,
	              value: _this3.state[el.key],
	              handleChange: function handleChange(event) {
	                return _this3.handleChange(event, el.key);
	              },
	              error: errors[el.key],
	              handleBlur: function handleBlur(event) {
	                return _this3.handleValidate(el.key, _this3.state[el.key], errors);
	              }
	            })
	          );
	        }),
	        _react2.default.createElement(
	          CustomGrid,
	          null,
	          _react2.default.createElement(
	            Terms,
	            null,
	            _react2.default.createElement(
	              List,
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Validity'
	                ),
	                'This Agreement is valid for',
	                ' ',
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  this.state.validity || t('TRANSACTION VALIDITY')
	                ),
	                '.'
	              ),
	              this.state.validity === validityOptions[1] && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Transaction'
	                ),
	                'Transaction Number:',
	                ' ',
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  this.state.transaction || t('TRANSACTION NUMBER')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'The transaction number corresponds to the number allocated by HvB to a specific property on the HvB web-based portfolio.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Commission'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'The Client agrees to pay, in consideration for the introduction made by HvB, a per deal Commission of',
	                  ' ',
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    this.state.commission || t('COMMISSION')
	                  ),
	                  ' of the total Transaction value directly to HvB in case of a successful Transaction.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'The Commission is to be paid to the account defined by HvB latest 7 (seven) days after performance of the Investment.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Non-Circumvention and Non-Solicitation'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'The Client agrees not to directly or indirectly circumvent HvB and not to work/ deal/ transact with leads introduced by each HvB at any time, without the knowledge and explicit permission of HvB. This clause is valid indefinitely, and is not affected by a possible cancellation of this Agreement.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'In case of unauthorized circumvention or solicitation, in addition to the Commission usually due to HvB for the concerned Transaction, the violating Party is liable to pay to HvB a penalty of 5% of the total Transaction value.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'The payment of the penalty in no way transfers the ownership of the lead the violating Party. Any further Transaction with the concerned Client or Business Associate, without express approval of the affected Party, shall trigger this penalty anew.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Governing law and jurisdiction'
	                ),
	                'This Agreement shall in all respects be governed by and construed in accordance with Swiss law, without giving effect to its conflict of law principles. All disputes arising from or in connection with this Agreement, including disputes regarding its conclusion, validity, binding effect, amendment, breach, termination or rescission, shall be subject to the exclusive jurisdiction of courts of the Canton of Zurich.'
	              )
	            )
	          )
	        ),
	        keys.map(function (el, index) {
	          return _react2.default.createElement(
	            CustomHalf,
	            {
	              key: el.key,
	              noPadLeft: index % 2 === 0,
	              noPadRight: index % 2 === 1 },
	            _react2.default.createElement(_Input2.default, {
	              placeholder: el.placeholder,
	              name: el.key,
	              required: true,
	              title: el.label,
	              value: _this3.state[el.key],
	              handleChange: function handleChange(event) {
	                return _this3.handleChange(event, el.key);
	              },
	              error: errors[el.key],
	              handleBlur: function handleBlur(event) {
	                return _this3.handleValidate(el.key, _this3.state[el.key], errors);
	              }
	            })
	          );
	        }),
	        _react2.default.createElement(
	          CustomGrid,
	          null,
	          _react2.default.createElement(_Button2.default, { label: t('Download'), onClick: this.downloadFile })
	        )
	      );
	    }
	  }]);
	
	  return CommissionAgreement;
	}(_react.Component);
	
	CommissionAgreement.propTypes = {
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  children: _react.PropTypes.node
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'forms', 'admin'], { wait: true })(CommissionAgreement);

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding-left: ', ';\n  padding-right: ', ';\n  button {\n    margin-top: ', ';\n    float: right\n  }\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n'], ['\n  padding-left: ', ';\n  padding-right: ', ';\n  button {\n    margin-top: ', ';\n    float: right\n  }\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  height: 100%;\n'], ['\n  height: 100%;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  padding-left: 0;\n  list-style: none;\n  ', ';\n\n  li {\n    margin: ', ' 0;\n    padding-bottom: ', ';\n    border-bottom: ', ';\n  }\n'], ['\n  padding-left: 0;\n  list-style: none;\n  ', ';\n\n  li {\n    margin: ', ' 0;\n    padding-bottom: ', ';\n    border-bottom: ', ';\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  ', ';\n  margin-top: ', ';\n'], ['\n  ', ';\n  margin-top: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n  ', ';\n'], ['\n  margin-bottom: ', ';\n  ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _reactI18next = __webpack_require__(7);
	
	var _Themes = __webpack_require__(5);
	
	var _Validations = __webpack_require__(44);
	
	var _ContractsSource = __webpack_require__(76);
	
	var _Utils = __webpack_require__(22);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__(60);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Calendar = __webpack_require__(1039);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _Loader = __webpack_require__(45);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.base, _Themes.Metrics.breakpoints.mobile);
	
	var CustomHalf = (0, _styledComponents2.default)(_gridStyled.Half)(_templateObject2, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.breakpoints.mobile);
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject3);
	
	var List = _styledComponents2.default.ul(_templateObject4, _Themes.Fonts.style.Text, _Themes.Metrics.margins.base, _Themes.Metrics.margins.small, _Themes.Metrics.borders.default);
	
	var Terms = _styledComponents2.default.div(_templateObject5, _Themes.Fonts.style.Text, _Themes.Metrics.margins.base);
	
	var Title = _styledComponents2.default.div(_templateObject6, _Themes.Metrics.margins.small, _Themes.Fonts.style.Label);
	
	var LetterOfIntent = function (_Component) {
	  _inherits(LetterOfIntent, _Component);
	
	  function LetterOfIntent(props) {
	    _classCallCheck(this, LetterOfIntent);
	
	    var _this = _possibleConstructorReturn(this, (LetterOfIntent.__proto__ || Object.getPrototypeOf(LetterOfIntent)).call(this, props));
	
	    var commissions = [];
	    var commission = 0.25;
	    while (commission <= 5) {
	      commissions.push(commission + '%');
	      commission += 0.25;
	    }
	    _this.state = {
	      options: commissions,
	      buyerName: '',
	      buyerFunction: '',
	      buyerCompany: '',
	      buyerStreetNr: '',
	      buyerZipCode: '',
	      buyerCountry: '',
	      buyerCity: '',
	      sellerName: '',
	      sellerStreetNr: '',
	      sellerZipCode: '',
	      sellerCountry: '',
	      sellerCity: '',
	      property: '',
	      price: '',
	      sellerBank: '',
	      commission: '',
	      authorization: '',
	      validityDate: '',
	      generating: false,
	      errors: {
	        buyerFunction: '',
	        buyerName: '',
	        buyerCompany: '',
	        buyerStreetNr: '',
	        buyerZipCode: '',
	        buyerCountry: '',
	        buyerCity: '',
	        sellerName: '',
	        sellerStreetNr: '',
	        sellerZipCode: '',
	        sellerCountry: '',
	        sellerCity: '',
	        property: '',
	        price: '',
	        sellerBank: '',
	        commission: '',
	        authorization: '',
	        validityDate: ''
	      }
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.downloadFile = _this.downloadFile.bind(_this);
	    _this.handleValidate = _this.handleValidate.bind(_this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  _createClass(LetterOfIntent, [{
	    key: 'handleChange',
	    value: function handleChange(event, key) {
	      var state = _ramda2.default.clone(this.state);
	      state[key] = event.target.value;
	      this.setState(state);
	    }
	  }, {
	    key: 'downloadFile',
	    value: function downloadFile() {
	      var _this2 = this;
	
	      var _R$clone = _ramda2.default.clone(this.state.errors);
	
	      var errors = _R$clone.errors;
	
	      var validation = (0, _Validations.validateForm)(this.state, errors);
	      if (validation.valid) {
	        this.setState({ generating: true }, function () {
	          (0, _ContractsSource.generateLetterOfIntent)({
	            sellerName: _this2.state.sellerName,
	            sellerZipCode: _this2.state.sellerZipCode,
	            sellerAddress: _this2.state.sellerStreetNr,
	            sellerCountry: _this2.state.sellerCountry,
	            sellerCity: _this2.state.sellerCity,
	            price: (0, _Utils.numberWithCommas)(parseInt(_this2.state.price, 10)) + '\u20AC',
	            authorization: _this2.state.authorization,
	            propertyName: _this2.state.property,
	            name: _this2.state.buyerName,
	            companyName: _this2.state.buyerCompany,
	            country: _this2.state.buyerCountry,
	            city: _this2.state.buyerCity,
	            function: _this2.state.buyerFunction,
	            address: _this2.state.buyerStreetNr,
	            zipCode: _this2.state.buyerZipCode,
	            commission: _this2.state.commission,
	            bank: _this2.state.sellerBank,
	            validityDate: _this2.state.validityDate
	          }).then(function (response) {
	            document.location = response.data.url;
	            _this2.setState({ generating: false });
	          }).catch(console.error);
	        });
	      } else {
	        this.setState({ errors: validation.errors });
	      }
	    }
	  }, {
	    key: 'handleValidate',
	    value: function handleValidate(name, value, errors) {
	      var newErrors = (0, _Validations.validateInput)(name, value, errors);
	      this.setState({ errors: newErrors });
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(el, key) {
	      var state = _ramda2.default.clone(this.state);
	      state[key] = el.toString();
	      this.setState(state);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var t = this.props.t;
	
	      var _R$clone2 = _ramda2.default.clone(this.state);
	
	      var errors = _R$clone2.errors;
	
	      var sellerKeys = [{
	        key: 'property',
	        label: t('Property name'),
	        placeholder: t('Property Name')
	      }, {
	        key: 'sellerName',
	        label: t('Seller Name or Company Name'),
	        placeholder: t('Name of the seller')
	      }, {
	        key: 'sellerStreetNr',
	        label: t('Seller Street Number'),
	        placeholder: t('Street Number')
	      }, {
	        key: 'sellerZipCode',
	        label: t('Seller Zip Code'),
	        placeholder: t('Zip Code')
	      }, {
	        key: 'sellerCountry',
	        label: t('Seller Country'),
	        placeholder: t('Country')
	      }, { key: 'sellerCity', label: t('Seller\'s City'), placeholder: t('City') }, { key: 'sellerBank', label: t('Seller\'s Bank'), placeholder: t('Bank') }, { key: 'price', label: t('Price'), placeholder: t('Price Value') }];
	
	      var buyerKeys = [{ key: 'buyerName', label: t('Name '), placeholder: t('Name') }, {
	        key: 'buyerCompany',
	        label: t('Buyer Company Name'),
	        placeholder: t('Company Name')
	      }, {
	        key: 'buyerFunction',
	        label: t('Buyer Function'),
	        placeholder: t('Function')
	      }, {
	        key: 'buyerStreetNr',
	        label: t('Buyer Street Number'),
	        placeholder: t('Street Number')
	      }, {
	        key: 'buyerZipCode',
	        label: t('Buyer Zip Code'),
	        placeholder: t('Zip Code')
	      }, {
	        key: 'buyerCountry',
	        label: t('Buyer Country'),
	        placeholder: t('Country')
	      }, { key: 'buyerCity', label: t('Buyer\'s City'), placeholder: t('City') }];
	
	      var authorizations = [t('Seller'), t('Seller\'s Bank')];
	
	      return _react2.default.createElement(
	        CustomCardContainer,
	        { title: t('Letter of Intent') },
	        _react2.default.createElement(_Loader2.default, { visible: this.state.generating }),
	        sellerKeys.map(function (el, index) {
	          return _react2.default.createElement(
	            CustomHalf,
	            {
	              key: el.key,
	              noPadLeft: index % 2 === 0,
	              noPadRight: index % 2 === 1 },
	            _react2.default.createElement(_Input2.default, {
	              placeholder: el.placeholder,
	              name: el.key,
	              required: true,
	              title: el.label,
	              value: _this3.state[el.key],
	              handleChange: function handleChange(event) {
	                return _this3.handleChange(event, el.key);
	              },
	              error: errors[el.key],
	              handleBlur: function handleBlur(event) {
	                return _this3.handleValidate(el.key, _this3.state[el.key], errors);
	              }
	            })
	          );
	        }),
	        _react2.default.createElement(
	          CustomHalf,
	          { key: 'authorization', noPadRight: true },
	          _react2.default.createElement(
	            Title,
	            null,
	            t('Authorization')
	          ),
	          _react2.default.createElement(_Dropdown2.default, {
	            placeholder: t('Select the authorization method'),
	            options: authorizations,
	            selectedOption: this.state.authorization,
	            handleSelect: function handleSelect(el) {
	              return _this3.handleSelect(el, 'authorization');
	            },
	            error: errors.authorization,
	            handleBlur: function handleBlur(event) {
	              return _this3.handleValidate('authorization', _this3.state.authorization, errors);
	            },
	            name: 'authorization',
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { key: 'commission', noPadRight: true },
	          _react2.default.createElement(
	            Title,
	            null,
	            t('Commission')
	          ),
	          _react2.default.createElement(_Dropdown2.default, {
	            placeholder: t('Select commission value'),
	            options: this.state.options,
	            selectedOption: this.state.commission,
	            handleSelect: function handleSelect(el) {
	              return _this3.handleSelect(el, 'commission');
	            },
	            error: errors.commission,
	            handleBlur: function handleBlur(event) {
	              return _this3.handleValidate('commission', _this3.state.commission, errors);
	            },
	            name: 'commission',
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { key: 'calendar' },
	          _react2.default.createElement(_Calendar2.default, {
	            id: 'validityDate',
	            error: errors.validityDate,
	            title: t('Validity Date'),
	            value: this.state.validityDate,
	            handleSelect: function handleSelect(value) {
	              return _this3.handleSelect(value, 'validityDate');
	            },
	            handleBlur: function handleBlur(event) {
	              return _this3.handleValidate('validityDate', _this3.state.validityDate, errors);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomGrid,
	          null,
	          _react2.default.createElement(
	            Terms,
	            null,
	            'The Buyer intends to purchase the',
	            this.state.property ? ' '.concat(this.state.property) : _react2.default.createElement(
	              'b',
	              null,
	              ' ',
	              t('PROPERTY'),
	              ' '
	            ),
	            '(the "Asset"), including all of the intellectual property, movable property, real property, the customer- and supplier relationships and all contracts and assets which are related to its business (the "Business") and which are required to operate the Business as it is operated as of the signing of this Letter of Intent. Now therefore, the Parties wish to set forth in this Letter of Intent the main terms of the Transaction as follows:',
	            _react2.default.createElement(
	              List,
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Negotiation of Sale and Purchase'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'The Parties shall negotiate in good faith the conclusion of a purchase agreement regarding the Transaction (the "Purchase Agreement")'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Purchase Price'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'The purchase price (the "Purchase Price") shall be',
	                  this.state.price ? ' '.concat(this.state.price).concat('€ ') : _react2.default.createElement(
	                    'b',
	                    null,
	                    ' ',
	                    t('PRICE')
	                  ),
	                  ', including a',
	                  this.state.commission ? ' '.concat(this.state.commission).concat(' ') : _react2.default.createElement(
	                    'b',
	                    null,
	                    ' ',
	                    t('COMMISSION'),
	                    ' '
	                  ),
	                  'buyer commission fee in favor of HvB Investment AG\u2019s designated bank account, subject to any material negative findings in the course of the due diligence. We hereby authorize',
	                  this.state.sellerBank ? ' '.concat(this.state.sellerBank).concat(' ') : _react2.default.createElement(
	                    'b',
	                    null,
	                    ' ',
	                    t('BANK'),
	                    ' '
	                  ),
	                  'to initiate the transaction of the',
	                  this.state.commission ? ' '.concat(this.state.commission).concat(' ') : _react2.default.createElement(
	                    'b',
	                    null,
	                    ' ',
	                    t('COMMISSION'),
	                    ' '
	                  ),
	                  'commission fee after a successful closing.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Benefits and Risks'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'The benefits and risks of the Business shall transfer upon Closing.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Representations and Warranties'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'The Purchase Agreement shall contain customary representations and warranties, guarantees and covenants from the Seller, as are usual for transactions of this nature. A liability cap shall be discussed and agreed between the Parties during the due diligence. The statute of limitations for any claims under the Purchase Agreement shall be two (2) years. In order to secure any claims the Buyer may have following a breach of representations and warranties, guarantees or covenants, the Purchase Agreement may provide for an escrow amount to be funded out of the purchase price.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Transfer of Agreements'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'In general, contracts may only be transferred with the approval of the counterparty. Should a contractual counterparty reject the approval, the Seller shall terminate such contract as soon as possible. Until termination of the contract, the Parties shall put each other into the same position as if the contract were transferred.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Conditions Precedents'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'The Purchase Agreement shall be subject to the approval of the board of directors of Buyer, the absence of a material adverse change and, to the extent necessary, any other approval required from authorities.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Actions between Signing and Closing'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Between signing and closing, the Seller shall operate the Business in the ordinary course of business, provide access and transfer all necessary data to the Buyer and obtain all consents to transfer material contracts.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Due diligence'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Upon execution of this Letter of Intent, the Parties shall start with the preparations for a comprehensive due diligence review of the Business, such due diligence to examine and cover, but not be limited to, financial, commercial, legal, tax, environmental, and insurance aspects, as deemed appropriate by Buyer. Upon delivery of the relevant due diligence request lists by Buyer, Seller shall prepare an appropriate data room providing for all the relevant information and documentation that can be reasonably expected during a structured due diligence process and/or which was specifically requested by Buyer (the \u201CData Room\u201D). Buyer and its advisors shall be granted reasonable access to the Seller and to the Data Room as well as to the Seller\u2019s external accountant and the Seller\u2019s books and records, in order to allow Buyer to conduct the above described due diligence review within 4 weeks as of the date hereof, provided, however, that such due diligence investigation shall permit the Seller the uninterrupted continuation of its activities.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Exclusivity'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'The Parties agree that during the Exclusivity Period (as defined below), conversations and negotiations regarding the transactions are only conducted with the other Party. The Parties agree that during the Exclusivity Period, neither Seller nor any representatives of the foregoing shall, directly or indirectly, solicit or enter into discussions or negotiations with, or provide any information to, or entertain or accept any offer of any other person concerning the potential sale of the Asset or the potential sale of any or all of the Business with any person other than Buyer and Buyer. The "Exclusivity Period" shall mean the period commencing on the date hereof and ending on the earlier of: (i) the date on which Seller and Buyer mutually agree in writing that the purchase contemplated herein cannot be concluded, or (ii)',
	                  this.state.validityDate ? ' '.concat(this.state.validityDate) : _react2.default.createElement(
	                    'b',
	                    null,
	                    ' ',
	                    t('VALIDITY DATE')
	                  ),
	                  '.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Confidentiality'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Each of the Parties hereto and all their representatives shall maintain the confidentiality of all information received from the other in connection with the transaction contemplated herein, except (i) information in the public domain or independently received from a third party with a right to disclose such information or (ii) to the extent that disclosure is required by law. No public announcement of this LOI or the Transaction will be made, nor will any announcement be made to the employees, partners, suppliers or any other party related to the Business, unless such announcement has the prior written approval of the Parties Each of the Parties shall also abstain from disclosing any aspect of their negotiations or the existence of this Letter of Intent or the transactions contemplated herein to any other person, except for persons being involved in the transaction. If the transaction contemplated herein is not concluded for any reason, all information and material received by the other Party hereto and its representatives shall be returned promptly to the party having provided such information.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Expenses'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'The Parties shall each be responsible for its own fees, costs, and expenses incurred in connection with the Transaction.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Binding Provisions'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'The provisions of this Letter of Intent shall not be legally binding and enforceable with the exception of sections 9 (Exclusivity), 10 (Confidentiality), 11 (Expenses), 12 (Binding Provisions), 13 (Term), 14 (Miscellaneous) and 15 (Governing Law /Arbitration). In particular, the Parties recognise that this Letter of Intent does neither constitute an offer to purchase nor a consent to sell the Business of the Seller, nor does it create any legally enforceable rights that would compel any of the Parties to proceed further with the negotiations.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Term'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'This Letter of Intent shall expire upon the earlier of (a) the execution of the Purchase Agreement or (b)',
	                  this.state.validityDate ? ' '.concat(this.state.validityDate) : _react2.default.createElement(
	                    'b',
	                    null,
	                    ' ',
	                    t('VALIDITY DATE')
	                  ),
	                  ', unless extended by agreement of the Parties.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Miscellaneous'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'This Letter of Intent or any rights thereof may not be transferred, assigned, pledged or hypothecated by either Party to a third party, unless previously agreed to in writing by the other Party. This Letter of Intent may be amended or terminated only by an instrument in writing signed by the Parties. Should any of the provisions of this Letter of Intent prove to be or become void or unenforceable, such provision shall be deemed to be replaced by another clause the substance whereof shall be as close as possible to the economic purpose of the clause which is void or unenforceable. The validity of the other clauses of this Letter of Intent shall not be affected thereby. The same rule shall apply to a supplementary interpretation of this Letter of Intent. All other documents relating the transactions will be drafted in English.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Governing Law / Arbitration'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'This Letter of Intent shall be governed by and construed in accordance with the laws of Switzerland. All disputes arising out of or in connection with the present contract shall be finally settled under the Rules of Arbitration of the International Chamber of Commerce by one or more arbitrators appointed in accordance with the said Rules. The number of arbitrators shall be one. The arbitral proceedings shall be conducted in English. The seat of arbitration shall be Zurich, Switzerland.'
	                )
	              )
	            )
	          )
	        ),
	        buyerKeys.map(function (el, index) {
	          return _react2.default.createElement(
	            CustomHalf,
	            {
	              key: el.key,
	              noPadLeft: index % 2 === 0,
	              noPadRight: index % 2 === 1 },
	            _react2.default.createElement(_Input2.default, {
	              placeholder: el.placeholder,
	              name: el.key,
	              required: true,
	              title: el.label,
	              value: _this3.state[el.key],
	              handleChange: function handleChange(event) {
	                return _this3.handleChange(event, el.key);
	              },
	              error: errors[el.key],
	              handleBlur: function handleBlur(event) {
	                return _this3.handleValidate(el.key, _this3.state[el.key], errors);
	              }
	            })
	          );
	        }),
	        _react2.default.createElement(
	          CustomGrid,
	          null,
	          _react2.default.createElement(_Button2.default, { label: t('Download'), onClick: this.downloadFile })
	        )
	      );
	    }
	  }]);
	
	  return LetterOfIntent;
	}(_react.Component);
	
	LetterOfIntent.propTypes = {
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  children: _react.PropTypes.node
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'forms', 'admin'], { wait: true })(LetterOfIntent);

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding-left: ', ';\n  padding-right: ', ';\n  button {\n    margin-top: ', ';\n    float: right\n  }\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n'], ['\n  padding-left: ', ';\n  padding-right: ', ';\n  button {\n    margin-top: ', ';\n    float: right\n  }\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  height: 100%;\n'], ['\n  height: 100%;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  padding-left: 0;\n  list-style: none;\n  ', ';\n\n  li {\n    margin: ', ' 0;\n    padding-bottom: ', ';\n    border-bottom: ', ';\n\n    li {\n      padding-bottom: 0;\n      margin: ', ' 0;\n      border-bottom: none;\n    }\n  }\n'], ['\n  padding-left: 0;\n  list-style: none;\n  ', ';\n\n  li {\n    margin: ', ' 0;\n    padding-bottom: ', ';\n    border-bottom: ', ';\n\n    li {\n      padding-bottom: 0;\n      margin: ', ' 0;\n      border-bottom: none;\n    }\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['', ';'], ['', ';']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n  ', ';\n'], ['\n  margin-bottom: ', ';\n  ', ';\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  padding-left: 0;\n  ', ';\n\n  counter-reset: item;\n  li:before {\n    content: counters(item, ".") ".";\n    counter-increment: item;\n  }\n  ol {\n    padding-left: ', ';\n  }\n\n  li {\n    display: block;\n    margin: ', ' 0;\n    border-bottom: none;\n  }\n'], ['\n  padding-left: 0;\n  ', ';\n\n  counter-reset: item;\n  li:before {\n    content: counters(item, ".") ".";\n    counter-increment: item;\n  }\n  ol {\n    padding-left: ', ';\n  }\n\n  li {\n    display: block;\n    margin: ', ' 0;\n    border-bottom: none;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _reactI18next = __webpack_require__(7);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _Themes = __webpack_require__(5);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ContractsSource = __webpack_require__(76);
	
	var _Validations = __webpack_require__(44);
	
	var _Loader = __webpack_require__(45);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.base, _Themes.Metrics.breakpoints.mobile);
	
	var CustomHalf = (0, _styledComponents2.default)(_gridStyled.Half)(_templateObject2, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.breakpoints.mobile);
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject3);
	
	var List = _styledComponents2.default.ul(_templateObject4, _Themes.Fonts.style.Text, _Themes.Metrics.margins.base, _Themes.Metrics.margins.small, _Themes.Metrics.borders.default, _Themes.Metrics.margins.small);
	
	var Terms = _styledComponents2.default.div(_templateObject5, _Themes.Fonts.style.Text);
	
	var Title = _styledComponents2.default.div(_templateObject6, _Themes.Metrics.margins.small, _Themes.Fonts.style.Label);
	
	var OrderedList = _styledComponents2.default.ol(_templateObject7, _Themes.Fonts.style.Text, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.small);
	
	var NDA = function (_Component) {
	  _inherits(NDA, _Component);
	
	  function NDA(props) {
	    _classCallCheck(this, NDA);
	
	    var _this = _possibleConstructorReturn(this, (NDA.__proto__ || Object.getPrototypeOf(NDA)).call(this, props));
	
	    _this.state = {
	      name: '',
	      company: '',
	      address: '',
	      phoneNumber: '',
	      email: '',
	      generating: false,
	      errors: {
	        name: '',
	        company: '',
	        address: '',
	        phone: '',
	        email: ''
	      }
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.downloadFile = _this.downloadFile.bind(_this);
	    _this.handleValidate = _this.handleValidate.bind(_this);
	    return _this;
	  }
	
	  _createClass(NDA, [{
	    key: 'handleChange',
	    value: function handleChange(event, key) {
	      var state = _ramda2.default.clone(this.state);
	      state[key] = event.target.value;
	      this.setState(state);
	    }
	  }, {
	    key: 'downloadFile',
	    value: function downloadFile() {
	      var _this2 = this;
	
	      var _R$clone = _ramda2.default.clone(this.state.errors);
	
	      var errors = _R$clone.errors;
	
	      var validation = (0, _Validations.validateForm)(this.state, errors);
	      if (validation.valid) {
	        this.setState({ generating: true }, function () {
	          (0, _ContractsSource.generateWebNda)({
	            name: _this2.state.name,
	            company: _this2.state.company,
	            address: _this2.state.address,
	            phoneNumber: _this2.state.phoneNumber,
	            email: _this2.state.email
	          }).then(function (response) {
	            _this2.setState({ generating: false });
	            document.location = response.data.url;
	          }).catch(console.error);
	        });
	      } else {
	        this.setState({ errors: validation.errors });
	      }
	    }
	  }, {
	    key: 'handleValidate',
	    value: function handleValidate(name, value, errors) {
	      var newErrors = (0, _Validations.validateInput)(name, value, errors);
	      this.setState({ errors: newErrors });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var t = this.props.t;
	      var errors = this.state.errors;
	
	      var keys = [{ key: 'name', label: t('Name'), placeholder: t('Name') }, { key: 'company', label: t('Company'), placeholder: t('Company Name') }, {
	        key: 'address',
	        label: t('Address'),
	        placeholder: t('Company Address')
	      }, { key: 'phoneNumber', label: t('Phone'), placeholder: t('Phone Number') }, { key: 'email', label: t('E-mail'), placeholder: t('E-mail') }];
	
	      return _react2.default.createElement(
	        CustomCardContainer,
	        { title: t('Non Disclosure Agreement') },
	        _react2.default.createElement(_Loader2.default, { visible: this.state.generating }),
	        _react2.default.createElement(
	          CustomGrid,
	          null,
	          _react2.default.createElement(
	            Terms,
	            null,
	            _react2.default.createElement(
	              List,
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Confidentiality and Non-Disclosure'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  { noPadTop: true },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Client agrees to maintain the confidentiality of the Confidential Information received by HvB and to prevent its unauthorized dissemination or use, subject to the exceptions enumerated in Section 5 of this Agreement.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Client agrees not to use the Confidential Information for purposes other than necessary to consider and enable the business relationship or transaction.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Client shall protect the Confidential Information by using a high degree of care, to prevent the unauthorized use, dissemination or publication of the Confidential Information.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Client shall limit its internal disclosure of the Confidential Information to only those employees, accountants, attorneys and affiliates who have a provable need to access the information for the limited purpose of the proposed business relationship or transaction.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement shall impose no obligations with respect to Confidential Information which:',
	                    _react2.default.createElement(
	                      OrderedList,
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is disclosed with the prior written consent of HvB;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is now, or hereafter becomes, through no act or failure to act on the part of the Client, generally known or available to the public;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'was already known by the Client before receiving such information from HvB, as evidenced by written documents;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is information which the Client can document was independently developed by the Client without reference to or use of any Confidential Information received from HvB;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is required to be disclosed pursuant to governmental agencies or law. In such cases, the Client seeking to disclose Confidential Information will provide notice to HvB prior to such disclosure to afford HvB a reasonable opportunity to file objections to the disclosure with the appropriate agency or entity. In case Confidential Information must legally be disclosed, the Client is responsible to disclose not more than the absolute minimum necessary.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Client acknowledges and agrees that all the Confidential Information is and shall remain the sole and exclusive property of HvB, free of any and all claims of the Client.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Governing law and jurisdiction'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement shall in all respects be governed by and construed in accordance with Swiss law, without giving effect to its conflict of law principles. All disputes arising from or in connection with this Agreement, including disputes regarding its conclusion, validity, binding effect, amendment, breach, termination or rescission, shall be subject to the exclusive jurisdiction of courts of the Canton of Zurich.'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        keys.map(function (el, index) {
	          return _react2.default.createElement(
	            CustomHalf,
	            {
	              key: el.key,
	              noPadLeft: index % 2 === 0,
	              noPadRight: index % 2 === 1 },
	            _react2.default.createElement(_Input2.default, {
	              placeholder: el.placeholder,
	              name: el.key,
	              required: true,
	              title: el.label,
	              value: _this3.state[el.key],
	              handleChange: function handleChange(event) {
	                return _this3.handleChange(event, el.key);
	              },
	              error: errors[el.key],
	              handleBlur: function handleBlur(event) {
	                return _this3.handleValidate(el.key, _this3.state[el.key], errors);
	              }
	            })
	          );
	        }),
	        _react2.default.createElement(
	          CustomGrid,
	          null,
	          _react2.default.createElement(_Button2.default, { label: t('Download'), onClick: this.downloadFile })
	        )
	      );
	    }
	  }]);
	
	  return NDA;
	}(_react.Component);
	
	NDA.propTypes = {
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  children: _react.PropTypes.node
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'forms', 'admin'], { wait: true })(NDA);

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding-left: ', ';\n  padding-right: ', ';\n  button {\n    margin-top: ', ';\n    float: right\n  }\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n'], ['\n  padding-left: ', ';\n  padding-right: ', ';\n  button {\n    margin-top: ', ';\n    float: right\n  }\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  height: 100%;\n'], ['\n  height: 100%;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  padding-left: 0;\n  list-style: none;\n  ', ';\n\n  li {\n    margin: ', ' 0;\n    padding-bottom: ', ';\n    border-bottom: ', ';\n\n    li {\n      padding-bottom: 0;\n      margin: ', ' 0;\n      border-bottom: none;\n    }\n  }\n'], ['\n  padding-left: 0;\n  list-style: none;\n  ', ';\n\n  li {\n    margin: ', ' 0;\n    padding-bottom: ', ';\n    border-bottom: ', ';\n\n    li {\n      padding-bottom: 0;\n      margin: ', ' 0;\n      border-bottom: none;\n    }\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  padding-left: 0;\n  ', ';\n\n  counter-reset: item;\n  li:before {\n    content: counters(item, ".") ".";\n    counter-increment: item;\n  }\n  ol {\n    padding-left: ', ';\n  }\n\n  li {\n    display: block;\n    margin: ', ' 0;\n    border-bottom: none;\n  }\n'], ['\n  padding-left: 0;\n  ', ';\n\n  counter-reset: item;\n  li:before {\n    content: counters(item, ".") ".";\n    counter-increment: item;\n  }\n  ol {\n    padding-left: ', ';\n  }\n\n  li {\n    display: block;\n    margin: ', ' 0;\n    border-bottom: none;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  ', ';\n  margin-top: ', ';\n'], ['\n  ', ';\n  margin-top: ', ';\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n  ', ';\n'], ['\n  margin-bottom: ', ';\n  ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _reactI18next = __webpack_require__(7);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _Themes = __webpack_require__(5);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Validations = __webpack_require__(44);
	
	var _ContractsSource = __webpack_require__(76);
	
	var _Loader = __webpack_require__(45);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.base, _Themes.Metrics.breakpoints.mobile);
	
	var CustomHalf = (0, _styledComponents2.default)(_gridStyled.Half)(_templateObject2, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.breakpoints.mobile);
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject3);
	
	var List = _styledComponents2.default.ul(_templateObject4, _Themes.Fonts.style.Text, _Themes.Metrics.margins.base, _Themes.Metrics.margins.small, _Themes.Metrics.borders.default, _Themes.Metrics.margins.small);
	
	var OrderedList = _styledComponents2.default.ol(_templateObject5, _Themes.Fonts.style.Text, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.small);
	
	var Terms = _styledComponents2.default.div(_templateObject6, _Themes.Fonts.style.Text, _Themes.Metrics.margins.base);
	
	var Title = _styledComponents2.default.div(_templateObject7, _Themes.Metrics.margins.small, _Themes.Fonts.style.Label);
	
	var NDFA = function (_Component) {
	  _inherits(NDFA, _Component);
	
	  function NDFA(props) {
	    _classCallCheck(this, NDFA);
	
	    var _this = _possibleConstructorReturn(this, (NDFA.__proto__ || Object.getPrototypeOf(NDFA)).call(this, props));
	
	    _this.state = {
	      name: '',
	      company: '',
	      address: '',
	      phoneNumber: '',
	      email: '',
	      function: '',
	      generating: false,
	      errors: {
	        name: '',
	        company: '',
	        address: '',
	        phoneNumber: '',
	        email: '',
	        function: ''
	      }
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.downloadFile = _this.downloadFile.bind(_this);
	    _this.handleValidate = _this.handleValidate.bind(_this);
	    return _this;
	  }
	
	  _createClass(NDFA, [{
	    key: 'handleChange',
	    value: function handleChange(event, key) {
	      var state = _ramda2.default.clone(this.state);
	      state[key] = event.target.value;
	      this.setState(state);
	    }
	  }, {
	    key: 'downloadFile',
	    value: function downloadFile() {
	      var _this2 = this;
	
	      var errors = this.state.errors;
	
	      var validation = (0, _Validations.validateForm)(this.state, errors);
	
	      if (validation.valid) {
	        this.setState({ generating: true }, function () {
	          (0, _ContractsSource.generateNCNDAWebsiteAgreement)({
	            name: _this2.state.name,
	            company: _this2.state.company,
	            address: _this2.state.address,
	            phoneNumber: _this2.state.phoneNumber,
	            email: _this2.state.email,
	            function: _this2.state.function
	          }).then(function (response) {
	            _this2.setState({ generating: false });
	            document.location = response.data.url;
	          }).catch(console.error);
	        });
	      } else {
	        this.setState({ errors: validation.errors });
	      }
	    }
	  }, {
	    key: 'handleValidate',
	    value: function handleValidate(name, value, errors) {
	      var newErrors = (0, _Validations.validateInput)(name, value, errors);
	      this.setState({ errors: newErrors });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var t = this.props.t;
	      var errors = this.state.errors;
	
	      var keys = [{ key: 'name', label: t('Name'), placeholder: t('Name') }, { key: 'company', label: t('Company'), placeholder: t('Company Name') }, {
	        key: 'address',
	        label: t('Address'),
	        placeholder: t('Company Address')
	      }, { key: 'phoneNumber', label: t('Phone'), placeholder: t('Phone Number') }, { key: 'email', label: t('E-mail'), placeholder: t('E-mail') }, { key: 'function', label: t('Function'), placeholder: t('Function') }];
	
	      return _react2.default.createElement(
	        CustomCardContainer,
	        {
	          title: t('Non-Circumvention / Non-Disclosure and Fee Agreement') },
	        _react2.default.createElement(_Loader2.default, { visible: this.state.generating }),
	        _react2.default.createElement(
	          CustomGrid,
	          null,
	          _react2.default.createElement(
	            Terms,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Whereby',
	              ' ',
	              _react2.default.createElement(
	                'b',
	                null,
	                this.state.company || this.state.name || t('NAME')
	              ),
	              ' ',
	              'requested access to information on assets in the portfolio of HvB.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Whereby the Parties desire to disclose, on a confidential basis, certain information, process, clients, business contacts and documents considered confidential and/or proprietary by the Parties concerning their respective businesses.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The Parties wish to maintain the confidentiality and/or the proprietary nature of the confidential information disclosed.'
	            ),
	            'By this Agreement, the Parties wish to set the basis for a lasting business relationship.',
	            _react2.default.createElement(
	              List,
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Definitions'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    '\u201CBusiness Associates\u201D means, business affiliates, investors, financers, clients, employees, vendors, asset owners and any other third-party relations.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    '\u201CClient\u201D means third parties directly interested in acquiring or selling real estate or other assets.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    '\u201CCommission\u201D means, any monetary compensation paid by a Client, a Business Associate or any other person and/or entity in consideration of introductions made and/or transactions successfully closed.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    '\u201CConfidential Information\u201D means any and all information disclosed orally or in writing or made available by any Party ("Disclosing Party") to another Party ("Recipient") so long as not explicitly designated as not confidential by the Disclosing Party. In addition, the existence and terms of this Agreement shall also be treated as Confidential Information.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    '\u201CTransaction\u201D means, the sale of one (1) asset either directly listed in HvB\u2019s portfolio or sold through or by a Business Associate of HvB.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Confidentiality and Non-Disclosure'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Parties agree to maintain the confidentiality of the Confidential Information and to prevent its unauthorized dissemination or use, subject to the exceptions enumerated in Section 2.5. of this Agreement.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Parties agree not to use the Confidential Information for purposes other than necessary to consider and enable the business relationship or pursue transaction between or involving the Parties or one of the Parties.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Recipient shall protect the Confidential Information by using a high degree of care, to prevent the unauthorized use, dissemination or publication of the Confidential Information.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Recipient shall limit its internal disclosure of the Confidential Information to only those employees, accountants, attorneys and affiliates who have a provable need to access the information for the limited purpose of the proposed business relationship or transaction between the Parties.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement shall impose no obligations with respect to Confidential Information which:',
	                    _react2.default.createElement(
	                      OrderedList,
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is disclosed with the prior written consent of the Disclosing Party;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is now, or hereafter becomes, through no act or failure to act on the part of the Recipient, generally known or available to the public;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'was already known by Recipient before receiving such information from the Disclosing Party, as evidenced by written documents;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is information which the Recipient can document was independently developed by the Recipient without reference to or use of any Confidential Information received from the Disclosing Party;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is required to be disclosed pursuant governmental agencies or law. In such cases, the Recipient seeking to disclose Confidential Information will provide notice to the Disclosing Party prior to such disclosure to afford the Disclosing Party a reasonable opportunity to file objections to the disclosure with the appropriate agency or entity. In case Confidential Information must legally be disclosed, the Disclosing Party is responsible to disclose not more than the absolute minimum necessary.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Recipient acknowledges and agrees that all the Confidential Information of the Disclosing Party is and shall remain the sole and exclusive property of the Disclosing Party, free of any and all claims of the Recipient.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Each Party shall be responsible for compliance with all applicable federal, state and local (in foreign jurisdictions) laws and regulations, including all applicable rules of self-regulatory organizations. To the extent that either Party fails to comply with such regulations, it shall indemnify the other Party or parties from any damages resulting from the violation.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Non-Circumvention and Non-Solicitation'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Parties agree not to directly or indirectly circumvent each other and not to work/ deal/ transact with Business Associates introduced by each Party at any time, without the knowledge and explicit permission of the introducing Party. This clause is valid indefinitely, and is not affected by a possible cancellation of this Agreement.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'In case of unauthorized circumvention or solicitation, in addition to the Commission usually due to the affected Party, the violating Party is liable to pay to the affected Party a penalty of 5% of the total Transaction value.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The payment of the penalty in no way transfers the ownership of the Client or Business Associate to the violating Party. Any further Transaction with the concerned Client or Business Associate, without express approval of the affected Party, shall trigger this penalty anew.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Commission'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      this.state.company || this.state.name || t('NAME')
	                    ),
	                    ' ',
	                    'agrees to pay, in consideration for the introduction made by HvB, a per deal Commission of 2.25% of the total Transaction value directly to HvB in case of a successful Transaction.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Commission is to be paid to the account defined by HvB latest 7 (seven) days after performance of the Investment.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Validity and Termination'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement shall be valid once signed by both Parties by the date stated on the agreement.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement may be terminated by either Party for any reason and at any time, by written notice given to the other Party. However, any such termination shall have no effect on the rights and obligations of the Parties under this Agreement in respect to Transactions executed, or in the process of being executed prior to such termination and especially with regards to Confidential Information, client and contact protection.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Amendments'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Any amendment of this Agreement shall only be valid if made in written form and if signed by both Parties.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Governing law and jurisdiction'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement shall in all respects be governed by and construed in accordance with Swiss law, without giving effect to its conflict of law principles. All disputes arising from or in connection with this Agreement, including disputes regarding its conclusion, validity, binding effect, amendment, breach, termination or rescission, shall be subject to the exclusive jurisdiction of the courts of the Canton of Zurich.'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        keys.map(function (el, index) {
	          return _react2.default.createElement(
	            CustomHalf,
	            {
	              key: el.key,
	              noPadLeft: index % 2 === 0,
	              noPadRight: index % 2 === 1 },
	            _react2.default.createElement(_Input2.default, {
	              placeholder: el.placeholder,
	              name: el.key,
	              required: true,
	              title: el.label,
	              value: _this3.state[el.key],
	              handleChange: function handleChange(event) {
	                return _this3.handleChange(event, el.key);
	              },
	              error: errors[el.key],
	              handleBlur: function handleBlur(event) {
	                return _this3.handleValidate(el.key, _this3.state[el.key], errors);
	              }
	            })
	          );
	        }),
	        _react2.default.createElement(
	          CustomGrid,
	          null,
	          _react2.default.createElement(_Button2.default, { label: t('Download'), onClick: this.downloadFile }),
	          _react2.default.createElement(_Button2.default, { label: t('Download'), onClick: this.downloadFile })
	        )
	      );
	    }
	  }]);
	
	  return NDFA;
	}(_react.Component);
	
	NDFA.propTypes = {
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  children: _react.PropTypes.node
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'forms', 'admin'], { wait: true })(NDFA);

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding-left: ', ';\n  padding-right: ', ';\n  button {\n    margin-top: ', ';\n    float: right\n  }\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n'], ['\n  padding-left: ', ';\n  padding-right: ', ';\n  button {\n    margin-top: ', ';\n    float: right\n  }\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  height: 100%;\n'], ['\n  height: 100%;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  padding-left: 0;\n  list-style: none;\n  ', ';\n\n  li {\n    margin: ', ' 0;\n    padding-bottom: ', ';\n    border-bottom: ', ';\n\n    li {\n      padding-bottom: 0;\n      margin: ', ' 0;\n      border-bottom: none;\n    }\n  }\n'], ['\n  padding-left: 0;\n  list-style: none;\n  ', ';\n\n  li {\n    margin: ', ' 0;\n    padding-bottom: ', ';\n    border-bottom: ', ';\n\n    li {\n      padding-bottom: 0;\n      margin: ', ' 0;\n      border-bottom: none;\n    }\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  ', ';\n  margin-top: ', ';\n'], ['\n  ', ';\n  margin-top: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n  ', ';\n'], ['\n  margin-bottom: ', ';\n  ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _reactI18next = __webpack_require__(7);
	
	var _CardContainer = __webpack_require__(23);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	var _Themes = __webpack_require__(5);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Validations = __webpack_require__(44);
	
	var _Dropdown = __webpack_require__(60);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Utils = __webpack_require__(22);
	
	var _ContractsSource = __webpack_require__(76);
	
	var _Loader = __webpack_require__(45);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.base, _Themes.Metrics.breakpoints.mobile);
	
	var CustomHalf = (0, _styledComponents2.default)(_gridStyled.Half)(_templateObject2, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.breakpoints.mobile);
	
	var CustomCardContainer = (0, _styledComponents2.default)(_CardContainer2.default)(_templateObject3);
	
	var List = _styledComponents2.default.ul(_templateObject4, _Themes.Fonts.style.Text, _Themes.Metrics.margins.base, _Themes.Metrics.margins.small, _Themes.Metrics.borders.default, _Themes.Metrics.margins.small);
	
	var Terms = _styledComponents2.default.div(_templateObject5, _Themes.Fonts.style.Text, _Themes.Metrics.margins.base);
	
	var Title = _styledComponents2.default.div(_templateObject6, _Themes.Metrics.margins.small, _Themes.Fonts.style.Label);
	
	var SalesMandate = function (_Component) {
	  _inherits(SalesMandate, _Component);
	
	  function SalesMandate(props) {
	    _classCallCheck(this, SalesMandate);
	
	    var _this = _possibleConstructorReturn(this, (SalesMandate.__proto__ || Object.getPrototypeOf(SalesMandate)).call(this, props));
	
	    var commissions = [];
	    var commission = 0.25;
	    while (commission <= 5) {
	      commissions.push(commission + '%');
	      commission += 0.25;
	    }
	    _this.state = {
	      options: commissions,
	      mandateType: '',
	      period: '',
	      propertyName: '',
	      propertyPrice: '',
	      propertyAddress: '',
	      propertyType: '',
	      commission: '',
	      name: '',
	      company: '',
	      address: '',
	      phoneNumber: '',
	      email: '',
	      generating: false,
	      errors: {
	        mandateType: '',
	        period: '',
	        propertyName: '',
	        propertyPrice: '',
	        propertyAddress: '',
	        propertyType: '',
	        commission: '',
	        name: '',
	        company: '',
	        address: '',
	        phoneNumber: '',
	        email: ''
	      }
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.downloadFile = _this.downloadFile.bind(_this);
	    _this.handleValidate = _this.handleValidate.bind(_this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  _createClass(SalesMandate, [{
	    key: 'handleChange',
	    value: function handleChange(event, key) {
	      var state = _ramda2.default.clone(this.state);
	      state[key] = event.target.value;
	      this.setState(state);
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(el, key) {
	      var state = _ramda2.default.clone(this.state);
	      state[key] = el.toString();
	      this.setState(state);
	    }
	  }, {
	    key: 'downloadFile',
	    value: function downloadFile() {
	      var _this2 = this;
	
	      var errors = this.state.errors;
	
	      var validation = (0, _Validations.validateForm)(this.state, errors);
	
	      if (validation.valid) {
	        this.setState({ generating: true }, function () {
	          (0, _ContractsSource.generateSalesMandate)({
	            mandateType: _this2.state.mandateType,
	            period: _this2.state.period,
	            propertyName: _this2.state.propertyName,
	            propertyPrice: (0, _Utils.numberWithCommas)(_this2.state.propertyPrice) + '\u20AC',
	            propertyAddress: _this2.state.propertyAddress,
	            propertyType: _this2.state.propertyType,
	            commission: _this2.state.commission,
	            name: _this2.state.name,
	            company: _this2.state.company,
	            address: _this2.state.address,
	            phoneNumber: _this2.state.phoneNumber,
	            email: _this2.state.email
	          }).then(function (response) {
	            _this2.setState({ generating: false });
	            document.location = response.data.url;
	          }).catch(console.error);
	        });
	      } else {
	        this.setState({ errors: validation.errors });
	      }
	    }
	  }, {
	    key: 'handleValidate',
	    value: function handleValidate(name, value, errors) {
	      var newErrors = (0, _Validations.validateInput)(name, value, errors);
	      this.setState({ errors: newErrors });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var t = this.props.t;
	      var errors = this.state.errors;
	
	
	      var keys = [{ key: 'name', label: t('Name'), placeholder: t('Name') }, { key: 'company', label: t('Company'), placeholder: t('Company Name') }, {
	        key: 'address',
	        label: t('Address'),
	        placeholder: t('Company Address')
	      }, { key: 'phoneNumber', label: t('Phone'), placeholder: t('Phone Number') }, { key: 'email', label: t('Email'), placeholder: t('E-mail') }];
	
	      var propertyKeys = [{
	        key: 'propertyName',
	        label: t('Property Name'),
	        placeholder: t('Name')
	      }, {
	        key: 'propertyAddress',
	        label: t('Property Address'),
	        placeholder: t('Street, number, city, postal code, country')
	      }, {
	        key: 'propertyPrice',
	        label: t('Property Price'),
	        placeholder: t('Price')
	      }];
	
	      var propertyTypes = ['Commercial', 'Residential', 'Mixed-use', 'Hotel', 'Other'];
	
	      var periods = ['3 Months', '6 months', '1 year', '2 years'];
	
	      var mandateTypes = ['Exclusive', 'Non-Exclusive'];
	
	      return _react2.default.createElement(
	        CustomCardContainer,
	        { title: t('Sales Mandate') },
	        _react2.default.createElement(_Loader2.default, { visible: this.state.generating }),
	        propertyKeys.map(function (el, index) {
	          return _react2.default.createElement(
	            CustomHalf,
	            {
	              key: el.key,
	              noPadLeft: index % 2 === 0,
	              noPadRight: index % 2 === 1 },
	            _react2.default.createElement(_Input2.default, {
	              placeholder: el.placeholder,
	              name: el.key,
	              required: true,
	              title: el.label,
	              value: _this3.state[el.key],
	              handleChange: function handleChange(event) {
	                return _this3.handleChange(event, el.key);
	              },
	              error: errors[el.key],
	              handleBlur: function handleBlur(event) {
	                return _this3.handleValidate(el.key, _this3.state[el.key], errors);
	              }
	            })
	          );
	        }),
	        _react2.default.createElement(
	          CustomHalf,
	          { key: 'propertyType', noPadRight: true },
	          _react2.default.createElement(
	            Title,
	            null,
	            t('Property Type')
	          ),
	          _react2.default.createElement(_Dropdown2.default, {
	            placeholder: t('Select the type of property'),
	            options: propertyTypes,
	            selectedOption: this.state.propertyType,
	            handleSelect: function handleSelect(el) {
	              return _this3.handleSelect(el, 'propertyType');
	            },
	            error: errors.propertyType,
	            handleBlur: function handleBlur(event) {
	              return _this3.handleValidate('propertyType', _this3.state.propertyType, errors);
	            },
	            name: 'propertyType',
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { key: 'mandateType', noPadRight: true },
	          _react2.default.createElement(
	            Title,
	            null,
	            t('Mandate Type')
	          ),
	          _react2.default.createElement(_Dropdown2.default, {
	            placeholder: t('Select the type of mandate'),
	            options: mandateTypes,
	            selectedOption: this.state.mandateType,
	            handleSelect: function handleSelect(el) {
	              return _this3.handleSelect(el, 'mandateType');
	            },
	            error: errors.mandateType,
	            handleBlur: function handleBlur(event) {
	              return _this3.handleValidate('mandateType', _this3.state.mandateType, errors);
	            },
	            name: 'mandateType',
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { key: 'period', noPadRight: true },
	          _react2.default.createElement(
	            Title,
	            null,
	            t('Mandate Period')
	          ),
	          _react2.default.createElement(_Dropdown2.default, {
	            placeholder: t('Select the period of mandate'),
	            options: periods,
	            selectedOption: this.state.period,
	            handleSelect: function handleSelect(el) {
	              return _this3.handleSelect(el, 'period');
	            },
	            error: errors.period,
	            handleBlur: function handleBlur(event) {
	              return _this3.handleValidate('period', _this3.state.period, errors);
	            },
	            name: 'period',
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          { key: 'commission', noPadRight: true },
	          _react2.default.createElement(
	            Title,
	            null,
	            t('Commission')
	          ),
	          _react2.default.createElement(_Dropdown2.default, {
	            placeholder: t('Select commission value'),
	            options: this.state.options,
	            selectedOption: this.state.commission,
	            handleSelect: function handleSelect(el) {
	              return _this3.handleSelect(el, 'commission');
	            },
	            error: errors.commission,
	            handleBlur: function handleBlur(event) {
	              return _this3.handleValidate('commission', _this3.state.commission, errors);
	            },
	            name: 'commission',
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          CustomGrid,
	          null,
	          _react2.default.createElement(
	            Terms,
	            null,
	            _react2.default.createElement(
	              List,
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Property Detail'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Property Name:',
	                  ' ',
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    this.state.propertyName || t('PROPERTY NAME')
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Address:',
	                  ' ',
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    this.state.propertyAddress || t('PROPERTY ADDRESS')
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Type: ',
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    this.state.propertyType || t('PROPERTY TYPE')
	                  )
	                ),
	                'This listing is off-market and confidential. The listing will be made on HvB\u2019s private and secured web-based portfolio in an anonymised fashion by using broad indications as to price, type of property, size, estimate yield, approximate location etc.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Agent Appointment'
	                ),
	                'We/I hereby appoint HvB to act as a Seller\u2019s Agent for the above-mentioned Property. HvB shall actively search, identify and propose a buyer for the Property under the following terms:',
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Type of mandate:',
	                  ' ',
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    this.state.mandateType || t('MANDATE TYPE')
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Appointment Period: ',
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    this.state.period || t('PERIOD')
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Should any sale be concluded within 12 months after the end of the appointment period, with a lead introduced by HvB during the appointment period, the below agreed brokerage fees are still due.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Listing Price and Brokerage Fees'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Listing Price:',
	                  ' ',
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    this.state.propertyPrice ? (0, _Utils.numberWithCommas)(this.state.propertyPrice) + '\u20AC' : t('PROPERTY PRICE')
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Currency: ',
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    t('EUR')
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Brokerage Fee: ',
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    this.state.commission || t('FEE')
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Governing law and jurisdiction'
	                ),
	                'This Agreement shall in all respects be governed by and construed in accordance with Swiss law, without giving effect to its conflict of law principles. All disputes arising from or in connection with this Agreement, including disputes regarding its conclusion, validity, binding effect, amendment, breach, termination or rescission, shall be subject to the exclusive jurisdiction of courts of the Canton of Zurich.'
	              )
	            )
	          )
	        ),
	        keys.map(function (el, index) {
	          return _react2.default.createElement(
	            CustomHalf,
	            {
	              key: el.key,
	              noPadLeft: index % 2 === 0,
	              noPadRight: index % 2 === 1 },
	            _react2.default.createElement(_Input2.default, {
	              placeholder: el.placeholder,
	              name: el.key,
	              required: true,
	              title: el.label,
	              value: _this3.state[el.key],
	              handleChange: function handleChange(event) {
	                return _this3.handleChange(event, el.key);
	              },
	              error: errors[el.key],
	              handleBlur: function handleBlur(event) {
	                return _this3.handleValidate(el.key, _this3.state[el.key], errors);
	              }
	            })
	          );
	        }),
	        _react2.default.createElement(
	          CustomGrid,
	          null,
	          _react2.default.createElement(_Button2.default, { label: t('Download'), onClick: this.downloadFile })
	        )
	      );
	    }
	  }]);
	
	  return SalesMandate;
	}(_react.Component);
	
	SalesMandate.propTypes = {
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  children: _react.PropTypes.node
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'forms', 'admin'], { wait: true })(SalesMandate);

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: auto;\n  height: 100vh;\n'], ['\n  width: auto;\n  height: 100vh;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: ', ';\n  background-color: ', ';\n  border-bottom: ', ';\n  box-shadow: ', ';\n  text-align: center;\n  line-height: ', ';\n  position: relative;\n'], ['\n  width: 100%;\n  height: ', ';\n  background-color: ', ';\n  border-bottom: ', ';\n  box-shadow: ', ';\n  text-align: center;\n  line-height: ', ';\n  position: relative;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: calc(\n    100vh - (', ' + ', ' +\n          ', ')\n  );\n  background-color: ', ';\n  border: ', ';\n  border-radius: ', ';\n  box-shadow: ', ';\n'], ['\n  width: 100%;\n  height: calc(\n    100vh - (', ' + ', ' +\n          ', ')\n  );\n  background-color: ', ';\n  border: ', ';\n  border-radius: ', ';\n  box-shadow: ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  height: 100vh;\n  width: 100%;\n  background: ', ';\n  transition: width 0.5s ease;\n  float: left;\n  &.active {\n    width: calc(100% - ', ');\n  }\n'], ['\n  height: 100vh;\n  width: 100%;\n  background: ', ';\n  transition: width 0.5s ease;\n  float: left;\n  &.active {\n    width: calc(100% - ', ');\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  margin-left: -', ';\n  transition: margin-left 0.5s ease;\n  z-index: 2;\n  float: left;\n\n  &.active {\n    margin-left: 0;\n  }\n'], ['\n  margin-left: -', ';\n  transition: margin-left 0.5s ease;\n  z-index: 2;\n  float: left;\n\n  &.active {\n    margin-left: 0;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  float: right;\n\n  path {\n    fill: ', ';\n  }\n'], ['\n  float: right;\n\n  path {\n    fill: ', ';\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: calc((100% - 50px)/2)\n  left: calc((100% - 50px)/2);\n  cursor: pointer;\n  width: 50px;\n  height: 50px;\n'], ['\n  position: absolute;\n  top: calc((100% - 50px)/2)\n  left: calc((100% - 50px)/2);\n  cursor: pointer;\n  width: 50px;\n  height: 50px;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  float: left;\n  margin-top: ', ';\n  margin-left: ', ';\n  opacity: 1;\n  transition: 0.3s opacity ease;\n\n  &.active {\n    opacity: 0;\n    pointer-events: none;\n  }\n'], ['\n  float: left;\n  margin-top: ', ';\n  margin-left: ', ';\n  opacity: 1;\n  transition: 0.3s opacity ease;\n\n  &.active {\n    opacity: 0;\n    pointer-events: none;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _Themes = __webpack_require__(5);
	
	var _Pangea = __webpack_require__(131);
	
	var _Pangea2 = _interopRequireDefault(_Pangea);
	
	var _Sidebar = __webpack_require__(517);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _CloseIcon = __webpack_require__(65);
	
	var _CloseIcon2 = _interopRequireDefault(_CloseIcon);
	
	var _Burger = __webpack_require__(520);
	
	var _Burger2 = _interopRequireDefault(_Burger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject2, _Themes.Metrics.margins.big);
	
	var Navbar = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.components.navbarDefault, _Themes.Colors.white, _Themes.Metrics.borders.default, _Themes.Metrics.shadows.default, _Themes.Metrics.components.navbarDefault);
	
	var FormContainer = _styledComponents2.default.div(_templateObject4, _Themes.Metrics.components.navbarDefault, _Themes.Metrics.margins.big, _Themes.Metrics.margins.base, _Themes.Colors.white, _Themes.Metrics.borders.default, _Themes.Metrics.borders.defaultRadius, _Themes.Metrics.shadows.default);
	
	var ScreenContent = _styledComponents2.default.div(_templateObject5, _Themes.Colors.lightGrey, _Themes.Metrics.components.sidebar);
	
	var CustomSidebar = (0, _styledComponents2.default)(_Sidebar2.default)(_templateObject6, _Themes.Metrics.components.sidebar);
	
	var CustomCloseIcon = (0, _styledComponents2.default)(_CloseIcon2.default)(_templateObject7, _Themes.Colors.white);
	
	var CustomLogo = (0, _styledComponents2.default)(_Pangea2.default)(_templateObject8);
	
	var CustomBurger = (0, _styledComponents2.default)(_Burger2.default)(_templateObject9, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.larger);
	
	var Agreements = function (_Component) {
	  _inherits(Agreements, _Component);
	
	  function Agreements(props) {
	    _classCallCheck(this, Agreements);
	
	    var _this = _possibleConstructorReturn(this, (Agreements.__proto__ || Object.getPrototypeOf(Agreements)).call(this, props));
	
	    _this.state = {
	      open: false
	    };
	    _this.toggleSidebar = _this.toggleSidebar.bind(_this);
	    return _this;
	  }
	
	  _createClass(Agreements, [{
	    key: 'toggleSidebar',
	    value: function toggleSidebar() {
	      this.setState({ open: !this.state.open });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var t = _props.t;
	      var router = _props.router;
	
	      return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(CustomSidebar, {
	          className: this.state.open && 'active',
	          logo: _react2.default.createElement(CustomCloseIcon, { onClick: this.toggleSidebar }),
	          links: [{
	            to: '/agreements/letter_of_intent',
	            label: t('Letter of Intent')
	          }, {
	            to: '/agreements/collaboration_agreement',
	            label: t('NCNDA & Collaboration Agreement')
	          }, {
	            to: '/agreements/non_disclosure_and_fee_agreement',
	            label: t('Non-Circumvention / Non-Disclosure and Fee Agreement')
	          }, {
	            to: '/agreements/ambassador_agreement',
	            label: t('NDA & Ambassador Agreement')
	          }, { to: '/agreements/sales_mandate', label: t('Sales Mandate') }, {
	            to: '/agreements/commission_agreement',
	            label: t('Commission Agreement')
	          }, {
	            to: '/agreements/non_disclosure_agreement',
	            label: t('Non Disclosure Agreement')
	          }]
	        }),
	        _react2.default.createElement(
	          ScreenContent,
	          { className: this.state.open && 'active' },
	          _react2.default.createElement(
	            Navbar,
	            null,
	            _react2.default.createElement(CustomBurger, {
	              onClick: this.toggleSidebar,
	              className: this.state.open && 'active'
	            }),
	            _react2.default.createElement(CustomLogo, { onClick: function onClick() {
	                return router.push('/');
	              } })
	          ),
	          _react2.default.createElement(
	            CustomThemeContainer,
	            null,
	            _react2.default.createElement(
	              FormContainer,
	              null,
	              children
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Agreements;
	}(_react.Component);
	
	Agreements.propTypes = {
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  children: _react.PropTypes.node
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'forms'], { wait: true })(Agreements);

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  text-align: center;\n  height: calc(100vh - ', ')\n  display: table;\n  margin: 0 auto;\n\n  .infos {\n    display: table-cell;\n    vertical-align: middle;\n\n    svg {\n      width: 146px;\n      height: 164px;\n    }\n\n    .number {\n      ', '\n      color: ', ';\n      font-size: 200px;\n      font-weight: 400;\n    }\n\n    h1 {\n      ', '\n      color: ', ';\n      font-weight: ', ';\n    }\n    span {\n      font-size: ', ';\n    }\n    button {\n      margin: 0 auto;\n      display: block;\n      margin-top: 50px;\n    }\n  }\n\n  @media screen and (max-width: ', ') {\n    .infos {\n      .number {\n        font-size: 160px;\n      }\n    }\n  }\n'], ['\n  text-align: center;\n  height: calc(100vh - ', ')\n  display: table;\n  margin: 0 auto;\n\n  .infos {\n    display: table-cell;\n    vertical-align: middle;\n\n    svg {\n      width: 146px;\n      height: 164px;\n    }\n\n    .number {\n      ', '\n      color: ', ';\n      font-size: 200px;\n      font-weight: 400;\n    }\n\n    h1 {\n      ', '\n      color: ', ';\n      font-weight: ', ';\n    }\n    span {\n      font-size: ', ';\n    }\n    button {\n      margin: 0 auto;\n      display: block;\n      margin-top: 50px;\n    }\n  }\n\n  @media screen and (max-width: ', ') {\n    .infos {\n      .number {\n        font-size: 160px;\n      }\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Themes = __webpack_require__(5);
	
	var _reactI18next = __webpack_require__(7);
	
	var _Pangea = __webpack_require__(131);
	
	var _Pangea2 = _interopRequireDefault(_Pangea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.section(_templateObject, _Themes.Metrics.components.navbarDefault, _Themes.Fonts.style.Title, _Themes.Colors.primary, _Themes.Fonts.style.Title, _Themes.Colors.primary, _Themes.Fonts.weight.normal, _Themes.Fonts.size.medium, _Themes.Metrics.breakpoints.mobile);
	
	var Error = function Error(props) {
	  var t = props.t;
	  var router = props.router;
	
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'infos' },
	      _react2.default.createElement(_Pangea2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'number' },
	        '404'
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        t('Page Not Fount')
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        t('The page you are looking for isn’t here')
	      ),
	      _react2.default.createElement(_Button2.default, {
	        onClick: function onClick() {
	          router.replace('/');
	        },
	        label: t('Go to Homepage')
	      })
	    )
	  );
	};
	
	Error.propTypes = {
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object
	};
	
	exports.default = (0, _reactI18next.translate)(['common'], { wait: true })(Error);

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  height: calc(100vh - ', ');\n'], ['\n  height: calc(100vh - ', ');\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _Table = __webpack_require__(172);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Themes = __webpack_require__(5);
	
	var _SearchSource = __webpack_require__(18);
	
	var _reactI18next = __webpack_require__(7);
	
	var _Utils = __webpack_require__(22);
	
	var _Defaults = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject, _Themes.Metrics.components.navbarDefault);
	
	var FavoriteList = function (_Component) {
	  _inherits(FavoriteList, _Component);
	
	  function FavoriteList(props) {
	    _classCallCheck(this, FavoriteList);
	
	    var _this = _possibleConstructorReturn(this, (FavoriteList.__proto__ || Object.getPrototypeOf(FavoriteList)).call(this, props));
	
	    _this.state = {
	      width: window.screen.availWidth,
	      height: document.getElementById('propertyList') && document.getElementById('propertyList').offsetHeight,
	      properties: props.user.preferredProperties || [],
	      tableHeaderKeys: _ramda2.default.clone(_Defaults.tableKeysDefault)
	    };
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    _this.sortElements = _this.sortElements.bind(_this);
	    return _this;
	  }
	
	  _createClass(FavoriteList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var ids = this.state.properties.map(function (el) {
	        return el.id;
	      });
	      (0, _SearchSource.findPropertiesById)(ids).then(function (response) {
	        _this2.setState({ properties: response.data });
	      }).catch(function (error) {
	        console.log(error);
	      });
	      this.updateDimensions();
	      window.addEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      this.setState({
	        width: window.screen.availWidth,
	        height: document.getElementById('propertyList') && document.getElementById('propertyList').offsetHeight
	      });
	      this.forceUpdate();
	    }
	  }, {
	    key: 'sortElements',
	    value: function sortElements(el) {
	      var keys = _ramda2.default.clone(this.state.tableHeaderKeys);
	      var keyIndex = _ramda2.default.findIndex(_ramda2.default.propEq('title', el.title), keys);
	      var result = (0, _Utils.sortArray)(el, this.state.properties);
	      keys.forEach(function (el) {
	        el.sort = null;
	      });
	      keys[keyIndex] = result.sortKey;
	      this.setState({ properties: result.list, tableHeaderKeys: keys });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var propertyDetails = this.props.propertyDetails;
	
	      return _react2.default.createElement(
	        Container,
	        { id: 'propertyList' },
	        _react2.default.createElement(_Table2.default, {
	          keys: this.state.tableHeaderKeys,
	          data: this.state.properties,
	          rowClick: propertyDetails,
	          width: this.state.width,
	          height: this.state.height,
	          handleSort: this.sortElements
	        })
	      );
	    }
	  }]);
	
	  return FavoriteList;
	}(_react.Component);
	
	FavoriteList.propTypes = {
	  user: _react.PropTypes.object,
	  propertyDetails: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  t: _react.PropTypes.func
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'favorite'], { wait: true })(FavoriteList);

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  height: calc(100vh - ', ');\n  width: 100vw;\n  overflow: hidden;\n  position: relative;\n\n  @media screen and (max-width: ', ') {\n    height: calc(100vh - ', ');\n    margin-top: ', ';\n  }\n'], ['\n  height: calc(100vh - ', ');\n  width: 100vw;\n  overflow: hidden;\n  position: relative;\n\n  @media screen and (max-width: ', ') {\n    height: calc(100vh - ', ');\n    margin-top: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Map = __webpack_require__(244);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject, _Themes.Metrics.components.navbarDefault, _Themes.Metrics.breakpoints.mobile, _Themes.Metrics.components.navbarDefault, _Themes.Metrics.margins.base);
	
	var FavoriteMap = function (_Component) {
	  _inherits(FavoriteMap, _Component);
	
	  function FavoriteMap() {
	    _classCallCheck(this, FavoriteMap);
	
	    return _possibleConstructorReturn(this, (FavoriteMap.__proto__ || Object.getPrototypeOf(FavoriteMap)).apply(this, arguments));
	  }
	
	  _createClass(FavoriteMap, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var user = _props.user;
	      var propertyDetails = _props.propertyDetails;
	
	      return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(_Map2.default, {
	          initialCenter: {
	            lat: 0,
	            lng: 0
	          },
	          places: user.preferredProperties,
	          handleSelect: propertyDetails
	        })
	      );
	    }
	  }]);
	
	  return FavoriteMap;
	}(_react.Component);
	
	FavoriteMap.propTypes = {
	  user: _react.PropTypes.object,
	  propertyDetails: _react.PropTypes.func
	};
	
	exports.default = FavoriteMap;

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  transition: ease 0.5s transform;\n  cursor: pointer;\n\n  &:hover {\n    transform: scale(1.02);\n    transition: ease 0.5s transform;\n  }\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  transition: ease 0.5s transform;\n  cursor: pointer;\n\n  &:hover {\n    transform: scale(1.02);\n    transition: ease 0.5s transform;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  text-align: center;\n  ', ';\n  margin-top: ', ';\n'], ['\n  text-align: center;\n  ', ';\n  margin-top: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n'], ['\n  ', ';\n  color: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['', ';'], ['', ';']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n  margin-top: ', ';\n'], ['\n  ', ';\n  color: ', ';\n  margin-top: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  padding-top: ', ';\n  ', ';\n  color: ', ';\n  display: -webkit-box;\n  height: ', ';\n  margin: 0 auto;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n'], ['\n  padding-top: ', ';\n  ', ';\n  color: ', ';\n  display: -webkit-box;\n  height: ', ';\n  margin: 0 auto;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n  span {\n    color: ', ';\n  }\n'], ['\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n  span {\n    color: ', ';\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  padding-left: ', ';\n  padding-right: ', ';\n\n  .sort-title {\n    color: black;\n    margin: ', ' 0;\n  }\n'], ['\n  padding-left: ', ';\n  padding-right: ', ';\n\n  .sort-title {\n    color: black;\n    margin: ', ' 0;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteral(['margin-top: ', ';'], ['margin-top: ', ';']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  height: calc(100vh - ', ');\n  overflow-y: scroll;\n'], ['\n  height: calc(100vh - ', ');\n  overflow-y: scroll;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _bluebird = __webpack_require__(80);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _immutable = __webpack_require__(29);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactI18next = __webpack_require__(7);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _CardWithImage = __webpack_require__(1040);
	
	var _CardWithImage2 = _interopRequireDefault(_CardWithImage);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _Themes = __webpack_require__(5);
	
	var _Key = __webpack_require__(176);
	
	var _Key2 = _interopRequireDefault(_Key);
	
	var _SearchSource = __webpack_require__(18);
	
	var _Dropdown = __webpack_require__(60);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _default_city = __webpack_require__(524);
	
	var _default_city2 = _interopRequireDefault(_default_city);
	
	var _Defaults = __webpack_require__(34);
	
	var _Utils = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CardContainer = (0, _styledComponents2.default)(_gridStyled.Half)(_templateObject, _Themes.Metrics.margins.larger, _Themes.Metrics.margins.small, _Themes.Metrics.margins.small);
	
	var NoProperty = _styledComponents2.default.div(_templateObject2, _Themes.Fonts.style.Text, _Themes.Metrics.margins.larger);
	
	var Title = _styledComponents2.default.div(_templateObject3, _Themes.Fonts.style.Input, _Themes.Colors.black);
	
	var DropdownTitle = _styledComponents2.default.div(_templateObject4, _Themes.Fonts.style.Label);
	
	var Category = _styledComponents2.default.div(_templateObject5, _Themes.Fonts.style.Input, _Themes.Colors.primary, _Themes.Metrics.margins.tiny);
	
	var Description = _styledComponents2.default.div(_templateObject6, _Themes.Metrics.margins.small, _Themes.Fonts.style.Small, _Themes.Colors.black, _Themes.Metrics.margins.big);
	
	var Info = _styledComponents2.default.div(_templateObject7, _Themes.Metrics.margins.small, _Themes.Fonts.style.Input, _Themes.Colors.black, _Themes.Colors.primary);
	
	var SortContainer = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject8, _Themes.Metrics.margins.small, _Themes.Metrics.margins.small, _Themes.Metrics.margins.small);
	
	var Container = _styledComponents2.default.div(_templateObject9, _Themes.Metrics.margins.larger);
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject10, _Themes.Metrics.components.navbarDefault);
	
	var FavoriteProperties = function (_Component) {
	  _inherits(FavoriteProperties, _Component);
	
	  function FavoriteProperties(props) {
	    _classCallCheck(this, FavoriteProperties);
	
	    var _this = _possibleConstructorReturn(this, (FavoriteProperties.__proto__ || Object.getPrototypeOf(FavoriteProperties)).call(this, props));
	
	    _this.state = {
	      properties: props.user.preferredProperties || [],
	      sortOptions: _ramda2.default.clone(_Defaults.sortOptionsDefault),
	      selectedSort: null
	    };
	    _this.handleSort = _this.handleSort.bind(_this);
	    return _this;
	  }
	
	  _createClass(FavoriteProperties, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var _state = this.state;
	      var properties = _state.properties;
	      var selectedSort = _state.selectedSort;
	      var sortOptions = _state.sortOptions;
	      var user = this.props.user;
	
	      if (!(0, _immutable.fromJS)(user).equals((0, _immutable.fromJS)(nextProps.user)) || !(0, _immutable.fromJS)(properties).equals((0, _immutable.fromJS)(nextState.properties)) || !(0, _immutable.fromJS)(sortOptions).equals((0, _immutable.fromJS)(nextState.sortOptions)) || selectedSort !== nextState.selectedSort) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var user = this.props.user;
	
	
	      var properties = _ramda2.default.clone(user.preferredProperties);
	      var ids = [];
	
	      if (properties.length > 0) {
	        properties.forEach(function (el) {
	          ids = _ramda2.default.union(ids, [el.city]);
	        });
	
	        _bluebird2.default.all([(0, _SearchSource.searchCategories)(), (0, _SearchSource.searchCities)({ where: { id: ids } })]).spread(function (categoriesResponse, citiesReponse) {
	          var categoriesHash = {};
	          var citiesHash = {};
	          categoriesResponse.data.forEach(function (category) {
	            categoriesHash[category.id] = category;
	          });
	
	          citiesReponse.data.forEach(function (city) {
	            citiesHash[city.id] = city.picture || _default_city2.default;
	          });
	
	          properties = _ramda2.default.map(function (d) {
	            d.category = categoriesHash[d.category].name;
	            d.picture = d.useDefaultPictures ? citiesHash[d.city] : d.picture;
	            return d;
	          }, properties);
	
	          _this2.setState({ properties: properties });
	        }).catch(console.error);
	      }
	    }
	  }, {
	    key: 'handleSort',
	    value: function handleSort(el) {
	      var properties = this.state.properties;
	
	
	      if (!el || properties.length === 0) {
	        return;
	      }
	
	      var key = el.key;
	      var direction = el.direction;
	      properties.sort(function (elementA, elementB) {
	        var valueA = elementA[key];
	        var valueB = elementB[key];
	        var sortVal = 0;
	
	        if (valueA > valueB) {
	          sortVal = 1;
	        }
	        if (valueA < valueB) {
	          sortVal = -1;
	        }
	        if (sortVal !== 0 && direction === _Utils.SortTypes.DESC) {
	          sortVal *= -1;
	        }
	        return sortVal;
	      });
	
	      this.setState({
	        properties: properties,
	        selectedSort: el
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state;
	      var properties = _state2.properties;
	      var selectedSort = _state2.selectedSort;
	      var sortOptions = _state2.sortOptions;
	      var _props = this.props;
	      var t = _props.t;
	      var router = _props.router;
	
	      var list = properties.length > 0 && properties.map(function (el, index) {
	        return _react2.default.createElement(
	          CardContainer,
	          { key: 'property-' + index, xs: 1, sm: 1 },
	          _react2.default.createElement(
	            _CardWithImage2.default,
	            {
	              imgSrc: el.picture,
	              onClick: function onClick() {
	                router.push('/property/' + el.id);
	              },
	              icon: _react2.default.createElement(_Key2.default, null) },
	            _react2.default.createElement(
	              _gridStyled2.default,
	              { xs: 2 / 3 },
	              _react2.default.createElement(
	                Title,
	                null,
	                el.title
	              ),
	              _react2.default.createElement(
	                Category,
	                null,
	                el.category
	              ),
	              _react2.default.createElement(
	                Description,
	                null,
	                el.description
	              )
	            ),
	            _react2.default.createElement(
	              _gridStyled2.default,
	              { xs: 1 / 3 },
	              _react2.default.createElement(
	                Info,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('Value'),
	                  ': '
	                ),
	                (0, _Utils.numberWithCommas)(el.price),
	                '\u20AC'
	              ),
	              _react2.default.createElement(
	                Info,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('Yield'),
	                  ': '
	                ),
	                el.yield,
	                '%'
	              ),
	              _react2.default.createElement(
	                Info,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  t('Keys'),
	                  ': '
	                ),
	                el.noRooms
	              )
	            )
	          )
	        );
	      });
	
	      return _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          CustomThemeContainer,
	          null,
	          properties.length === 0 ? _react2.default.createElement(
	            NoProperty,
	            null,
	            t('You have no favorite properties')
	          ) : _react2.default.createElement(
	            Container,
	            null,
	            _react2.default.createElement(
	              SortContainer,
	              { sm: 1 / 2 },
	              _react2.default.createElement(
	                DropdownTitle,
	                { className: 'sort-title' },
	                t('Sort By')
	              ),
	              _react2.default.createElement(_Dropdown2.default, {
	                placeholder: t('Select sort option'),
	                options: sortOptions,
	                handleSelect: this.handleSort,
	                selectedOption: selectedSort,
	                accessor: function accessor(d) {
	                  return d.label;
	                }
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              list
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FavoriteProperties;
	}(_react.Component);
	
	FavoriteProperties.propTypes = {
	  user: _react.PropTypes.object,
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'favorite'], { wait: true })(FavoriteProperties);

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Favorite = function (_Component) {
	  _inherits(Favorite, _Component);
	
	  function Favorite(props) {
	    _classCallCheck(this, Favorite);
	
	    var _this = _possibleConstructorReturn(this, (Favorite.__proto__ || Object.getPrototypeOf(Favorite)).call(this, props));
	
	    _this.propertyDetails = _this.propertyDetails.bind(_this);
	    return _this;
	  }
	
	  _createClass(Favorite, [{
	    key: 'propertyDetails',
	    value: function propertyDetails(id) {
	      this.props.router.push('/property/' + id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var user = _props.user;
	      var children = _props.children;
	
	      return _react2.default.createElement(
	        'section',
	        null,
	        children && _react2.default.cloneElement(children, {
	          user: user,
	          propertyDetails: this.propertyDetails
	        })
	      );
	    }
	  }]);
	
	  return Favorite;
	}(_react.Component);
	
	Favorite.propTypes = {
	  user: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  router: _react.PropTypes.object
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'favorite'], { wait: true })(Favorite);

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral([''], ['']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: ', ';\n  height: ', ';\n'], ['\n  width: ', ';\n  height: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactI18next = __webpack_require__(7);
	
	var _Themes = __webpack_require__(5);
	
	var _Modal = __webpack_require__(42);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Pangea = __webpack_require__(131);
	
	var _Pangea2 = _interopRequireDefault(_Pangea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var CustomLogo = (0, _styledComponents2.default)(_Pangea2.default)(_templateObject2, _Themes.Metrics.components.adminLogoSize, _Themes.Metrics.components.adminLogoSize);
	
	var AboutPangaea = function (_Component) {
	  _inherits(AboutPangaea, _Component);
	
	  function AboutPangaea() {
	    _classCallCheck(this, AboutPangaea);
	
	    return _possibleConstructorReturn(this, (AboutPangaea.__proto__ || Object.getPrototypeOf(AboutPangaea)).apply(this, arguments));
	  }
	
	  _createClass(AboutPangaea, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var t = _props.t;
	      var router = _props.router;
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        {
	          visible: true,
	          header: t('About Pangaea'),
	          closeAction: function closeAction() {
	            router.replace('/landing');
	          } },
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(CustomLogo, null),
	          _react2.default.createElement(
	            'p',
	            null,
	            t('Pangaea is an exclusive real estate investment platform for\n            high-end, off-market assets. Access to Pangea is reserved for\n            approved investors only. Pangea features hundreds of off-market\n            properties worldwide, with a core focus on the DACH region and\n            Europe.')
	          )
	        )
	      );
	    }
	  }]);
	
	  return AboutPangaea;
	}(_react.Component);
	
	AboutPangaea.propTypes = {
	  router: _react.PropTypes.object,
	  errorMessage: _react.PropTypes.string,
	  t: _react.PropTypes.func,
	  location: _react.PropTypes.object
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'landing'], { wait: true })(AboutPangaea);

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral([''], ['']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n\n  .inputTitle {\n    color: ', ';\n  }\n'], ['\n  margin-bottom: ', ';\n\n  .inputTitle {\n    color: ', ';\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n'], ['\n  margin-top: ', ';\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  ', ';\n\n  div {\n    margin-bottom: ', ';\n    span {\n      cursor: pointer;\n    }\n  }\n'], ['\n  ', ';\n\n  div {\n    margin-bottom: ', ';\n    span {\n      cursor: pointer;\n    }\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n\n  button {\n    float: right;\n    &.linkedin {\n      float: left;\n      background: url(\'', '\') no-repeat center;\n      padding: 0;\n      height: 32px;\n      border: 0px;\n      width: 175px;\n      background-size: cover;\n      border-radius: 0;\n      float: left;\n    }\n  }\n\n  .left {\n    float: left;\n  }\n\n  @media screen and (max-width: ', '){\n    .left {\n      float: none;\n    }\n\n    button {\n      float: none;\n      margin-bottom: ', ';\n      &.linkedin {\n        float: none;\n      }\n    }\n  }\n'], ['\n  margin-top: ', ';\n\n  button {\n    float: right;\n    &.linkedin {\n      float: left;\n      background: url(\'', '\') no-repeat center;\n      padding: 0;\n      height: 32px;\n      border: 0px;\n      width: 175px;\n      background-size: cover;\n      border-radius: 0;\n      float: left;\n    }\n  }\n\n  .left {\n    float: left;\n  }\n\n  @media screen and (max-width: ', '){\n    .left {\n      float: none;\n    }\n\n    button {\n      float: none;\n      margin-bottom: ', ';\n      &.linkedin {\n        float: none;\n      }\n    }\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  ', ';\n  margin-top: -', ';\n  margin-bottom: ', ';\n'], ['\n  ', ';\n  margin-top: -', ';\n  margin-bottom: ', ';\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  padding: 0 ', ';\n'], ['\n  padding: 0 ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _qs = __webpack_require__(702);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _gridStyled = __webpack_require__(17);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactI18next = __webpack_require__(7);
	
	var _Themes = __webpack_require__(5);
	
	var _AuthActions = __webpack_require__(53);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _config = __webpack_require__(88);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Modal = __webpack_require__(42);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _linkedin = __webpack_require__(1120);
	
	var _linkedin2 = _interopRequireDefault(_linkedin);
	
	var _AuthStore = __webpack_require__(129);
	
	var _AuthStore2 = _interopRequireDefault(_AuthStore);
	
	var _ErrorMessages = __webpack_require__(243);
	
	var _AuthSources = __webpack_require__(75);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var CustomInput = (0, _styledComponents2.default)(_Input2.default)(_templateObject2, _Themes.Metrics.margins.base, _Themes.Colors.primary);
	
	var Error = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.tiny, _Themes.Metrics.margins.small, _Themes.Fonts.style.Input, _Themes.Colors.red);
	
	var Links = _styledComponents2.default.div(_templateObject4, _Themes.Fonts.style.Small, _Themes.Metrics.margins.tiny);
	
	var Buttons = _styledComponents2.default.div(_templateObject5, _Themes.Metrics.margins.larger, _linkedin2.default, _Themes.Metrics.breakpoints.mobile, _Themes.Metrics.margins.base);
	
	var Text = _styledComponents2.default.div(_templateObject6, _Themes.Fonts.style.Text, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base);
	
	var CustomHalf = (0, _styledComponents2.default)(_gridStyled.Half)(_templateObject7, _Themes.Metrics.margins.medium);
	
	var Login = function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login(props) {
	    _classCallCheck(this, Login);
	
	    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));
	
	    _this.state = {
	      email: '',
	      password: '',
	      code: '',
	      id: ''
	    };
	
	    _this.handleEmailChange = _this.handleEmailChange.bind(_this);
	    _this.handlePasswordChange = _this.handlePasswordChange.bind(_this);
	    _this.handleCodeChange = _this.handleCodeChange.bind(_this);
	    _this.handleLogin = _this.handleLogin.bind(_this);
	    _this.linkedinLogin = _this.linkedinLogin.bind(_this);
	    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
	    _this.handleValidateCode = _this.handleValidateCode.bind(_this);
	    _this.handleResendCode = _this.handleResendCode.bind(_this);
	    return _this;
	  }
	
	  _createClass(Login, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (!this.props.errorMessage && nextProps.errorMessage) {
	        var _props$location$query = this.props.location.query;
	        var firstName = _props$location$query.firstName;
	        var lastName = _props$location$query.lastName;
	        var email = _props$location$query.email;
	        var linkedin = _props$location$query.linkedin;
	        var company = _props$location$query.company;
	        var jobTitle = _props$location$query.jobTitle;
	        var id = _props$location$query.id;
	
	        var linkedinError = nextProps.errorMessage === 'Your account is not activated' || nextProps.errorMessage === 'Your account is not approved yet';
	        if (email && !linkedinError) {
	          this.props.router.push('/landing/signup?id=' + id + '&email=' + email + '&firstName=' + encodeURIComponent(firstName) + '&lastName=' + encodeURIComponent(lastName) + '&linkedin=' + linkedin + '&company=' + encodeURIComponent(company) + '&jobTitle=' + encodeURIComponent(jobTitle));
	        }
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var _props$location$query2 = this.props.location.query;
	      var email = _props$location$query2.email;
	      var id = _props$location$query2.id;
	
	
	      if (email && email !== '') {
	        (0, _AuthSources.loginUser)({ email: email, linkedinId: id }).then(function (response) {
	          if (email === _config2.default.DEMO_EMAIL) {
	            _AuthActions2.default.loginSuccess(response.data);
	          } else {
	            _this2.setState({ id: response.data.id });
	          }
	        }).catch(function (error) {
	          return error.response.status === 403 ? _AuthActions2.default.loginFailed(error.response.data) : _AuthActions2.default.loginFailed(_ErrorMessages.errorMessages.general);
	        });
	      }
	    }
	  }, {
	    key: 'handleCodeChange',
	    value: function handleCodeChange(event) {
	      this.setState({ code: event.target.value });
	    }
	  }, {
	    key: 'handlePasswordChange',
	    value: function handlePasswordChange(event) {
	      this.setState({ password: event.target.value });
	    }
	  }, {
	    key: 'handleEmailChange',
	    value: function handleEmailChange(event) {
	      this.setState({ email: event.target.value });
	    }
	  }, {
	    key: 'handleLogin',
	    value: function handleLogin() {
	      var _this3 = this;
	
	      var _state = this.state;
	      var email = _state.email;
	      var password = _state.password;
	
	      if (email.length > 0 && password.length > 0) {
	        (0, _AuthSources.loginUser)({ email: email, password: password }).then(function (response) {
	          if (email === _config2.default.DEMO_EMAIL) {
	            _AuthActions2.default.loginSuccess(response.data);
	          } else {
	            _this3.setState({ id: response.data.id }, _AuthActions2.default.cleanError);
	          }
	        }).catch(function (error) {
	          return error.response.status === 403 ? _AuthActions2.default.loginFailed(error.response.data) : _AuthActions2.default.loginFailed(_ErrorMessages.errorMessages.general);
	        });
	      }
	    }
	  }, {
	    key: 'handleResendCode',
	    value: function handleResendCode() {
	      (0, _AuthSources.resendCode)(this.state.id);
	    }
	  }, {
	    key: 'handleValidateCode',
	    value: function handleValidateCode() {
	      var _state2 = this.state;
	      var id = _state2.id;
	      var code = _state2.code;
	
	      _AuthActions2.default.validateCode(id, code);
	    }
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(event) {
	      var code = this.state.code;
	
	      if (event.key === 'Enter') {
	        code ? this.handleValidateCode() : this.handleLogin();
	      }
	    }
	  }, {
	    key: 'linkedinLogin',
	    value: function linkedinLogin() {
	      window.location = 'https://www.linkedin.com/oauth/v2/authorization?' + _qs2.default.stringify({
	        client_id: _config2.default.Oauth2.clientId,
	        redirect_uri: _config2.default.Oauth2.authCalbackURI,
	        scope: _config2.default.Oauth2.scope,
	        state: _config2.default.Oauth2.state,
	        response_type: 'code'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var errorMessage = _props.errorMessage;
	      var t = _props.t;
	      var router = _props.router;
	      var _state3 = this.state;
	      var email = _state3.email;
	      var password = _state3.password;
	      var code = _state3.code;
	      var id = _state3.id;
	
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        {
	          visible: true,
	          header: t('Login'),
	          closeAction: function closeAction() {
	            router.replace('/landing');
	          } },
	        id ? _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            Text,
	            null,
	            t('Please insert the code that was sent to your number.')
	          ),
	          _react2.default.createElement(CustomInput, {
	            value: code,
	            title: 'SMS Code',
	            type: code,
	            handleChange: this.handleCodeChange
	          }),
	          errorMessage && _react2.default.createElement(
	            Error,
	            null,
	            t(errorMessage)
	          ),
	          _react2.default.createElement(
	            Buttons,
	            null,
	            _react2.default.createElement(
	              CustomHalf,
	              null,
	              _react2.default.createElement(_Button2.default, {
	                label: 'Enter',
	                onClick: this.handleValidateCode,
	                handleKeyPress: this.handleKeyPress
	              })
	            ),
	            _react2.default.createElement(
	              CustomHalf,
	              null,
	              _react2.default.createElement(_Button2.default, {
	                label: 'Resend Code',
	                onClick: this.handleResendCode,
	                secondary: true,
	                className: 'left'
	              })
	            )
	          )
	        ) : _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(CustomInput, {
	            value: email,
	            title: 'E-mail',
	            type: 'e-mail',
	            handleChange: this.handleEmailChange
	          }),
	          _react2.default.createElement(CustomInput, {
	            value: password,
	            type: 'password',
	            handleChange: this.handlePasswordChange,
	            title: 'Password',
	            handleKeyPress: this.handleKeyPress
	          }),
	          errorMessage && _react2.default.createElement(
	            Error,
	            null,
	            t(errorMessage)
	          ),
	          _react2.default.createElement(
	            Links,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              t('Become a Member?'),
	              _react2.default.createElement(
	                'span',
	                { onClick: function onClick() {
	                    return router.push('/landing/signup');
	                  } },
	                '  ' + t('Click Here')
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'reset',
	                onClick: function onClick() {
	                  return router.push('/landing/reset');
	                } },
	              _react2.default.createElement(
	                'span',
	                null,
	                t('Reset Password')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Buttons,
	            null,
	            _react2.default.createElement(
	              CustomHalf,
	              null,
	              _react2.default.createElement(_Button2.default, {
	                disabled: !(email.length > 0) || !(password.length > 0),
	                label: 'Login',
	                onClick: this.handleLogin
	              })
	            ),
	            _react2.default.createElement(
	              CustomHalf,
	              null,
	              _react2.default.createElement('button', { onClick: this.linkedinLogin, className: 'linkedin' })
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return _AuthStore2.default.getState();
	    }
	  }, {
	    key: 'getStores',
	    value: function getStores() {
	      return [_AuthStore2.default];
	    }
	  }, {
	    key: 'getPropsFromStores',
	    value: function getPropsFromStores() {
	      return {
	        errorMessage: _AuthStore2.default.getState().errorMessage
	      };
	    }
	  }]);
	
	  return Login;
	}(_react.Component);
	
	Login.propTypes = {
	  router: _react.PropTypes.object,
	  errorMessage: _react.PropTypes.string,
	  t: _react.PropTypes.func,
	  location: _react.PropTypes.object
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'landing'], { wait: true })(Login);

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  .inputTitle {\n    color: ', ';\n  }\n'], ['\n  .inputTitle {\n    color: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Modal = __webpack_require__(42);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomInput = (0, _styledComponents2.default)(_Input2.default)(_templateObject, _Themes.Colors.primary);
	
	var CustomButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject2, _Themes.Metrics.margins.large);
	
	var MoreSettings = function MoreSettings(props) {
	  var profile = props.profile;
	  var t = props.t;
	  var _handleChange = props.handleChange;
	  var next = props.next;
	  var router = props.router;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      visible: true,
	      closeAction: function closeAction() {
	        return router.push('/landing');
	      },
	      header: _react2.default.createElement(
	        'div',
	        { className: 'header' },
	        t('More Info')
	      ),
	      backAction: router.goBack },
	    _react2.default.createElement(CustomInput, {
	      width: '100%',
	      title: t('Who recommended HvB to you?'),
	      placeholder: t('Name'),
	      key: 'recommendedBy',
	      handleChange: function handleChange(event) {
	        return _handleChange('recommendedBy', event);
	      }
	    }),
	    _react2.default.createElement(CustomButton, {
	      label: 'Next',
	      onClick: function onClick() {
	        if (profile.linkedinId) {
	          next('/landing/signup/terms');
	        } else {
	          next('/landing/signup/password');
	        }
	      }
	    })
	  );
	};
	
	MoreSettings.propTypes = {
	  handleChange: _react.PropTypes.func.isRequired,
	  profile: _react.PropTypes.object.isRequired,
	  next: _react.PropTypes.func.isRequired,
	  router: _react.PropTypes.object,
	  t: _react.PropTypes.func
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'landing', 'forms'], { wait: true })(MoreSettings);

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n'], ['\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding-left: 0;\n  ', ';\n  line-height: 1.8;\n\n  counter-reset: item;\n  li:before {\n    content: counters(item, ".") ".";\n    counter-increment: item;\n  }\n  ol {\n    padding-left: ', ';\n  }\n\n  li {\n    padding-bottom: ', ';\n    display: block;\n    margin: ', ' 0;\n    border-bottom: none;\n  }\n'], ['\n  padding-left: 0;\n  ', ';\n  line-height: 1.8;\n\n  counter-reset: item;\n  li:before {\n    content: counters(item, ".") ".";\n    counter-increment: item;\n  }\n  ol {\n    padding-left: ', ';\n  }\n\n  li {\n    padding-bottom: ', ';\n    display: block;\n    margin: ', ' 0;\n    border-bottom: none;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  ', ';\n  margin-top: ', ';\n'], ['\n  ', ';\n  margin-top: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  ', ';\n  letter-spacing: 0;\n'], ['\n  ', ';\n  letter-spacing: 0;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  .modalContainer {\n    width: 90%;\n    max-height: 100%;\n\n    @media screen and (max-width: ', ') {\n      max-height: 100vh;\n      width: 100vw;\n    }\n  }\n  #modal-body {\n    max-height: 650px;\n    text-align: left;\n\n    @media screen and (max-width: ', ') {\n      height: calc(100vh - 68px);\n      width: 100vw;\n      max-height: none;\n      box-shadow: none;\n    }\n  }\n'], ['\n  .modalContainer {\n    width: 90%;\n    max-height: 100%;\n\n    @media screen and (max-width: ', ') {\n      max-height: 100vh;\n      width: 100vw;\n    }\n  }\n  #modal-body {\n    max-height: 650px;\n    text-align: left;\n\n    @media screen and (max-width: ', ') {\n      height: calc(100vh - 68px);\n      width: 100vw;\n      max-height: none;\n      box-shadow: none;\n    }\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  margin-right: ', ';\n  float: left;\n\n  @media screen and (max-width: ', ') {\n    float: none;\n    margin-left: calc((100% - 118px)/2);\n  }\n'], ['\n  margin-right: ', ';\n  float: left;\n\n  @media screen and (max-width: ', ') {\n    float: none;\n    margin-left: calc((100% - 118px)/2);\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  @media screen and (max-width: ', ') {\n    font-size: 16px;\n  }\n'], ['\n  @media screen and (max-width: ', ') {\n    font-size: 16px;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['text-align: left;'], ['text-align: left;']),
	    _templateObject9 = _taggedTemplateLiteral(['text-align: right;'], ['text-align: right;']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  text-align: left;\n  margin-top: ', ';\n'], ['\n  text-align: left;\n  margin-top: ', ';\n']),
	    _templateObject11 = _taggedTemplateLiteral(['margin-top: ', ';'], ['margin-top: ', ';']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  margin-right: ', ';\n  float: left;\n  width: ', ';\n  display: inline-block;\n  border: 1px solid ', ';\n  border-radius: 0;\n  padding: ', ' ', ';\n  background: transparent;\n  cursor: pointer;\n  outline: none;\n  text-transform: uppercase;\n  text-decoration: none;\n  ', ';\n  color: ', ';\n  pointer-events: all;\n\n  &:hover {\n    border: 1px solid transparent;\n    background: ', ';\n    color: ', ';\n  }\n\n  @media screen and (max-width: ', ') {\n    float: none;\n    margin-left: calc((100% - 118px)/2);\n  }\n'], ['\n  margin-right: ', ';\n  float: left;\n  width: ', ';\n  display: inline-block;\n  border: 1px solid ', ';\n  border-radius: 0;\n  padding: ', ' ', ';\n  background: transparent;\n  cursor: pointer;\n  outline: none;\n  text-transform: uppercase;\n  text-decoration: none;\n  ', ';\n  color: ', ';\n  pointer-events: all;\n\n  &:hover {\n    border: 1px solid transparent;\n    background: ', ';\n    color: ', ';\n  }\n\n  @media screen and (max-width: ', ') {\n    float: none;\n    margin-left: calc((100% - 118px)/2);\n  }\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  ', ';\n  width: auto;\n  display: inline-block;\n  border: 1px solid transparent;\n  padding: ', ' ', ';\n  background: ', ';\n  cursor: pointer;\n  color: ', ';\n  outline: none;\n  text-transform: uppercase;\n\n  &:hover {\n    border: 1px solid ', ';\n    background: transparent;\n    color: ', ';\n  }\n'], ['\n  ', ';\n  width: auto;\n  display: inline-block;\n  border: 1px solid transparent;\n  padding: ', ' ', ';\n  background: ', ';\n  cursor: pointer;\n  color: ', ';\n  outline: none;\n  text-transform: uppercase;\n\n  &:hover {\n    border: 1px solid ', ';\n    background: transparent;\n    color: ', ';\n  }\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n  position: relative;\n  float: left;\n  cursor: pointer !important;\n  input {\n    width: 0.1px;\n    height: 0.1px;\n    opacity: 0;\n    overflow: hidden;\n    position: absolute;\n    z-index: -1;\n  }\n\n  label {\n    display: block;\n    @media screen and (max-width: ', ') {\n      display: none;\n    }\n  }\n  span {\n    display: none;\n    ', ';\n    color: ', ';\n    @media screen and (max-width: ', ') {\n      display: block;\n    }\n  }\n\n  @media screen and (max-width: ', ') {\n    float: none;\n    text-align: center;\n    margin-top: ', ';\n  }\n'], ['\n  position: relative;\n  float: left;\n  cursor: pointer !important;\n  input {\n    width: 0.1px;\n    height: 0.1px;\n    opacity: 0;\n    overflow: hidden;\n    position: absolute;\n    z-index: -1;\n  }\n\n  label {\n    display: block;\n    @media screen and (max-width: ', ') {\n      display: none;\n    }\n  }\n  span {\n    display: none;\n    ', ';\n    color: ', ';\n    @media screen and (max-width: ', ') {\n      display: block;\n    }\n  }\n\n  @media screen and (max-width: ', ') {\n    float: none;\n    text-align: center;\n    margin-top: ', ';\n  }\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n  margin-top: 20px;\n  p {\n    line-height: 1.8;\n  }\n'], ['\n  margin-top: 20px;\n  p {\n    line-height: 1.8;\n  }\n']),
	    _templateObject16 = _taggedTemplateLiteral(['\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 1;\n'], ['\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 1;\n']),
	    _templateObject17 = _taggedTemplateLiteral(['color: ', ' !important;'], ['color: ', ' !important;']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactI18next = __webpack_require__(7);
	
	var _Themes = __webpack_require__(5);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ContractsSource = __webpack_require__(76);
	
	var _Modal = __webpack_require__(42);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _AdminSource = __webpack_require__(31);
	
	var _Loader = __webpack_require__(45);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Error = _styledComponents2.default.div(_templateObject, _Themes.Metrics.margins.small, _Themes.Fonts.style.Input, _Themes.Colors.red);
	
	var OrderedList = _styledComponents2.default.ol(_templateObject2, _Themes.Fonts.style.Text, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.small, _Themes.Metrics.margins.small);
	
	var Terms = _styledComponents2.default.div(_templateObject3, _Themes.Fonts.style.Text, _Themes.Metrics.margins.base);
	
	var ListTitle = _styledComponents2.default.b(_templateObject4, _Themes.Fonts.style.Header);
	
	var CustomModal = (0, _styledComponents2.default)(_Modal2.default)(_templateObject5, _Themes.Metrics.breakpoints.mobile, _Themes.Metrics.breakpoints.mobile);
	
	var CustomButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject6, _Themes.Metrics.margins.small, _Themes.Metrics.breakpoints.mobile);
	
	var Header = _styledComponents2.default.div(_templateObject7, _Themes.Metrics.breakpoints.mobile);
	
	var Parties = _styledComponents2.default.div(_templateObject8);
	
	var Disclaimer = _styledComponents2.default.div(_templateObject9);
	
	var Party = _styledComponents2.default.div(_templateObject10, _Themes.Metrics.margins.base);
	
	var Filler = _styledComponents2.default.div(_templateObject11, _Themes.Metrics.margins.base);
	
	var DownloadButton = _styledComponents2.default.a(_templateObject12, _Themes.Metrics.margins.small, function (props) {
	  return props.fullWidth ? '100%' : 'auto';
	}, _Themes.Colors.primary, _Themes.Metrics.margins.small, _Themes.Metrics.margins.large, _Themes.Fonts.style.Button, _Themes.Colors.primary, _Themes.Colors.primary, _Themes.Colors.white, _Themes.Metrics.breakpoints.mobile);
	
	var UploadButton = _styledComponents2.default.label(_templateObject13, _Themes.Fonts.style.Button, _Themes.Metrics.margins.small, _Themes.Metrics.margins.large, _Themes.Colors.black, _Themes.Colors.white, _Themes.Colors.black, _Themes.Colors.black);
	
	var NdaContainer = _styledComponents2.default.div(_templateObject14, _Themes.Metrics.breakpoints.mobile, _Themes.Fonts.style.Text, _Themes.Colors.darkGrey, _Themes.Metrics.breakpoints.mobile, _Themes.Metrics.breakpoints.mobile, _Themes.Metrics.margins.base);
	
	var MgTop20 = _styledComponents2.default.div(_templateObject15);
	
	var LoaderContainer = _styledComponents2.default.div(_templateObject16);
	
	var AlertText = _styledComponents2.default.p(_templateObject17, _Themes.Colors.red);
	
	var NCNDA = function (_Component) {
	  _inherits(NCNDA, _Component);
	
	  function NCNDA(props) {
	    _classCallCheck(this, NCNDA);
	
	    var _this = _possibleConstructorReturn(this, (NCNDA.__proto__ || Object.getPrototypeOf(NCNDA)).call(this, props));
	
	    _this.state = {
	      loading: false,
	      url: '',
	      error: ''
	    };
	    _this.generateNCNDA = _this.generateNCNDA.bind(_this);
	    _this.handleUploadNda = _this.handleUploadNda.bind(_this);
	    return _this;
	  }
	
	  _createClass(NCNDA, [{
	    key: 'generateNCNDA',
	    value: function generateNCNDA() {
	      var _this2 = this;
	
	      var profile = this.props.profile;
	
	
	      this.setState({
	        loading: true
	      }, function () {
	        (0, _ContractsSource.generateNCNDAWebsiteAgreement)({
	          name: profile.firstName + ' ' + profile.lastName,
	          company: profile.company,
	          address: profile.address,
	          country: profile.country,
	          city: profile.city,
	          phoneNumber: profile.phoneNumber,
	          email: profile.email,
	          jobTitle: profile.jobTitle
	        }).then(function (response) {
	          _this2.setState({
	            loading: false,
	            url: response.data.url
	          });
	        }).catch(console.error);
	      });
	    }
	  }, {
	    key: 'handleUploadNda',
	    value: function handleUploadNda(event) {
	      var _this3 = this;
	
	      var _props = this.props;
	      var profile = _props.profile;
	      var next = _props.next;
	      var router = _props.router;
	      var t = _props.t;
	
	      var file = event.target.files[0];
	      if (file) {
	        this.setState({ loading: true }, function () {
	          var reader = new FileReader();
	          reader.readAsDataURL(file);
	          reader.onloadend = function () {
	            profile.nda = file;
	            _this3.setState({ loading: true }, function () {
	              return (0, _AdminSource.uploadNda)(profile).then(function (response) {
	                if (router.location.query.state) {
	                  next('/landing/signup/success?state=success');
	                } else {
	                  next('/landing/signup/success');
	                }
	              }).catch(function (error) {
	                console.log(error);
	                _this3.setState({
	                  loading: false,
	                  error: t('There was a problem on uploading the file.')
	                });
	              });
	            });
	          };
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var t = _props2.t;
	      var profile = _props2.profile;
	      var router = _props2.router;
	      var _state = this.state;
	      var loading = _state.loading;
	      var error = _state.error;
	
	      return _react2.default.createElement(
	        CustomModal,
	        {
	          visible: true,
	          closeAction: function closeAction() {
	            return router.push('/landing');
	          },
	          header: _react2.default.createElement(
	            Header,
	            { className: 'header' },
	            t('Non-Disclosure and Fee Agreement')
	          ),
	          backAction: router.goBack },
	        loading && _react2.default.createElement(
	          LoaderContainer,
	          null,
	          _react2.default.createElement(_Loader2.default, { visible: loading })
	        ),
	        _react2.default.createElement(
	          Terms,
	          null,
	          _react2.default.createElement(
	            Parties,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                Filler,
	                null,
	                'Between'
	              ),
	              _react2.default.createElement(
	                Party,
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'HvB Investments AG'
	                ),
	                ', M\xFCnsterhof 6, 8001 Zurich, Switzerland (\u201C',
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'HvB'
	                ),
	                '\u201D)'
	              ),
	              _react2.default.createElement(
	                Filler,
	                null,
	                'and'
	              ),
	              _react2.default.createElement(
	                Party,
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  profile.company || profile.firstName + ' ' + profile.lastName
	                ),
	                profile.address ? ', ' + profile.address : '',
	                profile.city ? ', ' + profile.city : '',
	                profile.country ? ', ' + profile.country : ''
	              ),
	              _react2.default.createElement(
	                Disclaimer,
	                null,
	                '(Individually a \u201C',
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'Party'
	                ),
	                '\u201D, together the \u201C',
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'Parties'
	                ),
	                '\u201D)'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            MgTop20,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Background'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Whereby',
	              ' ',
	              profile.company || profile.firstName + ' ' + profile.lastName,
	              ' ',
	              'requested access to information on assets in the portfolio of HvB.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Whereby the Parties desire to disclose, on a confidential basis, certain information, process, clients, business contacts and documents considered confidential and/or proprietary by the Parties concerning their respective businesses.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The Parties wish to maintain the confidentiality and/or the proprietary nature of the confidential information disclosed.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'By this Agreement, the Parties wish to set the basis for a lasting business relationship.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'The Parties agree on the following:'
	              )
	            ),
	            _react2.default.createElement(
	              OrderedList,
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  ListTitle,
	                  null,
	                  'Definitions'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      '\u201CBusiness Associates\u201D'
	                    ),
	                    ' means, business affiliates, investors, financers, Clients, employees, vendors, asset owners, Intermediaries and any other third party relations.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      '\u201CClient\u201D'
	                    ),
	                    ' means third parties directly interested in acquiring or selling real estate or other assets.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      '\u201CCommission\u201D'
	                    ),
	                    ' means, any monetary compensation paid by a Client, a Business Associate or any other person and/or entity in consideration of introductions made and/or transactions successfully closed.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      '"Commission"'
	                    ),
	                    ' means any and all information disclosed orally or in writing or made available by any Party ("Disclosing Party") to another Party ("Recipient") so long as not explicitly designated as not confidential by the Disclosing Party. In addition, the existence and terms of this Agreement shall also be treated as Confidential Information.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      '"Total Commission"'
	                    ),
	                    ' means the pot composed of both buyer and seller side commission.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      '"Transaction"'
	                    ),
	                    ' means, the sale of one (1) asset either directly listed in HvB\u2019s portfolio or sold through or by a Business Associate and/or a Client of HvB.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  ListTitle,
	                  null,
	                  'Confidentiality and Non-Disclosure'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Parties agree to maintain the confidentiality of the Confidential Information and to prevent its unauthorized dissemination or use, subject to the exceptions enumerated in Section 2.5. of this Agreement.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Parties agree not to use the Confidential Information for purposes other than that necessary to consider and enable the business relationship or pursue transaction between or involving the Parties or one of the Parties.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Recipient shall protect the Confidential Information by using the same degree of care, but no less than reasonable care, to prevent the unauthorized use, dissemination or publication of the Confidential Information as the Recipient uses to protect its own Confidential Information.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Recipient shall limit its internal disclosure of the Confidential Information to only those employees, accountants, attorneys and affiliates who have a need to know the information for the limited purpose of the proposed business relationship or transaction between the Parties.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement shall impose no obligations with respect to Confidential Information which:',
	                    _react2.default.createElement(
	                      'ol',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is disclosed with the prior written consent of the Disclosing Party;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is now, or hereafter becomes, through no act or failure to act on the part of the Recipient, generally known or available to the public;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'was already known by Recipient before receiving such information from the Disclosing Party, as evidenced by written documents;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is information which the Recipient can document was independently developed by the Recipient without reference to or use of any Confidential Information received from the Disclosing Party;'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'is required to be disclosed pursuant governmental agencies or law. In such cases, the Recipient seeking to disclose Confidential Information will provide to the Disclosing Party notice prior to such disclosure so as to afford the Disclosing Party a reasonable opportunity to file objections to the disclosure with the appropriate agency or entity.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Recipient acknowledges and agrees that all the Confidential Information of the Disclosing Party is and shall remain the sole and exclusive property of the Disclosing Party, free of any and all claims of the Recipient.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Each Party shall be responsible for compliance with all applicable federal, state and local (in foreign jurisdictions) laws and regulations, including all applicable rules of self-regulatory organizations. To the extent that either Party fails to comply with such regulations, it shall indemnify the other Party or parties from any damages resulting from the violation.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  ListTitle,
	                  null,
	                  'Non-Circumvention and Non-Solicitation'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Parties agree not to directly or indirectly circumvent each other and not to work/ deal/ transact with Business Associates introduced by each Party at any time, without the knowledge and explicit permission of the introducing Party. This clause is valid indefinitely, and is not affected by a possible cancellation of this Agreement.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'In case of unauthorized circumvention or solicitation, in addition to the Commission usually due to the affected Party, the violating Party is liable to pay to the affected Party a penalty of 5% of the total Transaction value.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The payment of the penalty in no way transfers the ownership of the Client or Business Associate to the violating Party. Any further Transaction with the concerned Client or Business Associate, without express approval of the affected Party, shall trigger this penalty anew.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  ListTitle,
	                  null,
	                  'Commission'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    profile.company || profile.firstName + ' ' + profile.lastName,
	                    ' ',
	                    'agrees to pay, in consideration for the property presented by HvB, a per deal Commission of the total Transaction value \u2013 as outlined for each property individually \u2013 directly to HvB in case of a successful Transaction.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Commission is to be paid to the account defined by HvB latest 7 (seven) days after performance of the Investment.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  ListTitle,
	                  null,
	                  'Validity and Termination'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement shall be valid once signed by both Parties by the date stated on the agreement.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement may be terminated by either Party for any reason and at any time, by written notice given to the other Party. However, any such termination shall have no effect on the rights and obligations of the Parties under this Agreement in respect to Transactions executed, or in the process of being executed prior to such termination and especially with regards to Confidential Information, client and contact protection.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  ListTitle,
	                  null,
	                  'Amendments'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Any amendment of this Agreement shall only be valid if made in written form and if signed by both Parties.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  ListTitle,
	                  null,
	                  'Governing law and jurisdiction'
	                ),
	                _react2.default.createElement(
	                  OrderedList,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'This Agreement shall in all respects be governed by and construed in accordance with Swiss law, without giving effect to its conflict of law principles. All disputes arising from or in connection with this Agreement, including disputes regarding its conclusion, validity, binding effect, amendment, breach, termination or rescission, shall be subject to the exclusive jurisdiction of the courts of the Canton of Zurich.'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        error && _react2.default.createElement(
	          Error,
	          null,
	          error
	        ),
	        !this.state.url && _react2.default.createElement(CustomButton, { label: t('Generate'), onClick: this.generateNCNDA }),
	        this.state.url && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            AlertText,
	            null,
	            'Please upload the NDA signed.'
	          ),
	          _react2.default.createElement(
	            DownloadButton,
	            { href: this.state.url, target: '_blank' },
	            'Print'
	          ),
	          _react2.default.createElement(
	            NdaContainer,
	            null,
	            _react2.default.createElement('input', {
	              type: 'file',
	              name: 'nda-upload',
	              id: 'nda-upload',
	              onChange: this.handleUploadNda
	            }),
	            _react2.default.createElement(
	              UploadButton,
	              { htmlFor: 'nda-upload' },
	              t('Upload')
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              t('Please upload the file on the web version')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NCNDA;
	}(_react.Component);
	
	NCNDA.propTypes = {
	  confirmPassword: _react.PropTypes.string,
	  handleConfirm: _react.PropTypes.func.isRequired,
	  handleChange: _react.PropTypes.func.isRequired,
	  profile: _react.PropTypes.object.isRequired,
	  next: _react.PropTypes.func.isRequired,
	  router: _react.PropTypes.object,
	  t: _react.PropTypes.func
	};
	
	NCNDA.defaultprops = {
	  profile: {}
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'forms', 'admin'], {
	  wait: true
	})(NCNDA);

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n\n  .inputTitle {\n    color: ', ';\n  }\n'], ['\n  margin-bottom: ', ';\n\n  .inputTitle {\n    color: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n'], ['\n  margin-top: ', ';\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Modal = __webpack_require__(42);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomInput = (0, _styledComponents2.default)(_Input2.default)(_templateObject, _Themes.Metrics.margins.base, _Themes.Colors.primary);
	
	var CustomButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject2, _Themes.Metrics.margins.large);
	
	var Error = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.tiny, _Themes.Metrics.margins.small, _Themes.Fonts.style.Input, _Themes.Colors.red);
	
	var Password = function Password(props) {
	  var profile = props.profile;
	  var t = props.t;
	  var _handleChange = props.handleChange;
	  var handleConfirm = props.handleConfirm;
	  var confirmPassword = props.confirmPassword;
	  var next = props.next;
	  var router = props.router;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      visible: true,
	      closeAction: function closeAction() {
	        return router.push('/landing');
	      },
	      header: _react2.default.createElement(
	        'div',
	        { className: 'header' },
	        t('Password')
	      ),
	      backAction: props.router.goBack },
	    _react2.default.createElement(CustomInput, {
	      type: 'password',
	      placeholder: t('Insert your password'),
	      title: t('Password'),
	      key: 'pass',
	      value: profile.password,
	      handleChange: function handleChange(event) {
	        return _handleChange('password', event);
	      }
	    }),
	    _react2.default.createElement(CustomInput, {
	      type: 'password',
	      key: 'confirmPass',
	      value: confirmPassword,
	      title: t('Confirm Password'),
	      handleChange: handleConfirm,
	      placeholder: t('Confirm your password')
	    }),
	    profile.password.length > 0 && profile.password !== confirmPassword ? _react2.default.createElement(
	      Error,
	      null,
	      t("Passwords don't match")
	    ) : '',
	    _react2.default.createElement(CustomButton, {
	      label: t('Next'),
	      onClick: function onClick() {
	        return next('/landing/signup/terms');
	      },
	      disabled: !(profile.password.length > 0 && profile.password === confirmPassword)
	    })
	  );
	};
	
	Password.propTypes = {
	  confirmPassword: _react.PropTypes.string,
	  handleConfirm: _react.PropTypes.func.isRequired,
	  handleChange: _react.PropTypes.func.isRequired,
	  profile: _react.PropTypes.object.isRequired,
	  next: _react.PropTypes.func.isRequired,
	  router: _react.PropTypes.object,
	  t: _react.PropTypes.func
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'landing', 'forms'], { wait: true })(Password);

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n  \n  .inputTitle {\n    color: ', ';\n  }\n'], ['\n  margin-bottom: ', ';\n  \n  .inputTitle {\n    color: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n'], ['\n  margin-top: ', ';\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Modal = __webpack_require__(42);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomInput = (0, _styledComponents2.default)(_Input2.default)(_templateObject, _Themes.Metrics.margins.base, _Themes.Colors.primary);
	var Error = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.margins.tiny, _Themes.Metrics.margins.small, _Themes.Fonts.style.Input, _Themes.Colors.red);
	
	var Profile = function Profile(props) {
	  var _handleChange = props.handleChange;
	  var _handleBlur = props.handleBlur;
	  var errors = props.errors;
	  var profile = props.profile;
	  var t = props.t;
	  var router = props.router;
	  var next = props.next;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      visible: true,
	      closeAction: function closeAction() {
	        return router.push('/landing');
	      },
	      header: _react2.default.createElement(
	        'div',
	        { className: 'header' },
	        t('Profile Info')
	      ),
	      className: 'profileModal' },
	    _react2.default.createElement(CustomInput, {
	      name: 'firstName',
	      required: true,
	      title: t('First Name'),
	      value: profile.firstName,
	      handleBlur: function handleBlur(event) {
	        return _handleBlur('firstName', profile.firstName, errors);
	      },
	      handleChange: function handleChange(event) {
	        return _handleChange('firstName', event);
	      },
	      error: errors['firstName']
	    }),
	    _react2.default.createElement(CustomInput, {
	      name: 'lastName',
	      required: true,
	      title: t('Last Name'),
	      value: profile.lastName,
	      error: errors['lastName'],
	      handleBlur: function handleBlur(event) {
	        return _handleBlur('lastName', profile.lastName, errors);
	      },
	      handleChange: function handleChange(event) {
	        return _handleChange('lastName', event);
	      }
	    }),
	    _react2.default.createElement(CustomInput, {
	      required: true,
	      name: 'email',
	      type: 'e-mail',
	      value: profile.email,
	      title: t('E-mail'),
	      error: errors['email'],
	      handleBlur: function handleBlur(event) {
	        return _handleBlur('email', profile.email, errors);
	      },
	      handleChange: function handleChange(event) {
	        return _handleChange('email', event);
	      }
	    }),
	    _react2.default.createElement(CustomInput, {
	      required: true,
	      name: 'phoneNumber',
	      type: 'phone',
	      handleBlur: function handleBlur(event) {
	        return _handleBlur('phoneNumber', profile.phoneNumber, errors);
	      },
	      value: profile.phoneNumber,
	      error: errors['phoneNumber'],
	      title: t('Phone Number'),
	      handleChange: function handleChange(event) {
	        return _handleChange('phoneNumber', event);
	      }
	    }),
	    _react2.default.createElement(CustomInput, {
	      key: 'company',
	      title: t('Company'),
	      value: profile.company,
	      handleChange: function handleChange(event) {
	        return _handleChange('company', event);
	      }
	    }),
	    _react2.default.createElement(CustomInput, {
	      key: 'jobTitle',
	      title: t('Job Title'),
	      value: profile.jobTitle,
	      handleChange: function handleChange(event) {
	        return _handleChange('jobTitle', event);
	      }
	    }),
	    _react2.default.createElement(CustomInput, {
	      name: 'address',
	      required: true,
	      title: t('Address'),
	      value: profile.address,
	      error: errors['address'],
	      handleBlur: function handleBlur(event) {
	        return _handleBlur('address', profile.address, errors);
	      },
	      handleChange: function handleChange(event) {
	        return _handleChange('address', event);
	      }
	    }),
	    _react2.default.createElement(CustomInput, {
	      name: 'city',
	      required: true,
	      title: t('City'),
	      value: profile.city,
	      handleChange: function handleChange(event) {
	        return _handleChange('city', event);
	      },
	      error: errors['city'],
	      handleBlur: function handleBlur(event) {
	        return _handleBlur('city', profile.city, errors);
	      }
	    }),
	    _react2.default.createElement(CustomInput, {
	      name: 'country',
	      required: true,
	      title: t('Country'),
	      value: profile.country,
	      handleChange: function handleChange(event) {
	        return _handleChange('country', event);
	      },
	      error: errors['country'],
	      handleBlur: function handleBlur(event) {
	        return _handleBlur('country', profile.country, errors);
	      }
	    }),
	    _react2.default.createElement(CustomInput, {
	      title: t('Skype Name'),
	      value: profile.skypeName,
	      handleChange: function handleChange(event) {
	        return _handleChange('skypeName', event);
	      }
	    }),
	    _react2.default.createElement(CustomInput, {
	      title: t('Linkedin Profile'),
	      value: profile.linkedinUrl,
	      handleChange: function handleChange(event) {
	        return _handleChange('linkedinUrl', event);
	      }
	    }),
	    _react2.default.createElement(
	      Error,
	      null,
	      errors.general
	    ),
	    _react2.default.createElement(_Button2.default, {
	      label: t('Next'),
	      onClick: function onClick() {
	        return next('/landing/signup/settings');
	      }
	    })
	  );
	};
	
	Profile.propTypes = {
	  handleChange: _react.PropTypes.func.isRequired,
	  next: _react.PropTypes.func.isRequired,
	  errors: _react.PropTypes.object,
	  handleBlur: _react.PropTypes.func,
	  profile: _react.PropTypes.object.isRequired,
	  router: _react.PropTypes.object,
	  t: _react.PropTypes.func
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'landing', 'forms'], { wait: true })(Profile);

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n'], ['\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n\n  .picker {\n    .title {\n      color: ', ';\n    }\n  }\n'], ['\n  margin-bottom: ', ';\n\n  .picker {\n    .title {\n      color: ', ';\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactI18next = __webpack_require__(7);
	
	var _Modal = __webpack_require__(42);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CheckboxDropdown = __webpack_require__(1041);
	
	var _CheckboxDropdown2 = _interopRequireDefault(_CheckboxDropdown);
	
	var _SearchableDropdown = __webpack_require__(64);
	
	var _SearchableDropdown2 = _interopRequireDefault(_SearchableDropdown);
	
	var _RangePicker = __webpack_require__(126);
	
	var _RangePicker2 = _interopRequireDefault(_RangePicker);
	
	var _Constants = __webpack_require__(52);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var FormTitle = _styledComponents2.default.div(_templateObject, _Themes.Metrics.margins.small, _Themes.Fonts.style.Label, _Themes.Colors.primary);
	
	var Form = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.margins.base, _Themes.Colors.primary);
	
	var CustomButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject3, _Themes.Metrics.margins.large);
	
	var Settings = function Settings(props) {
	  var searches = props.searches;
	  var handleRange = props.handleRange;
	  var _handleSelect = props.handleSelect;
	  var _handleSelectAll = props.handleSelectAll;
	  var _handleSearch = props.handleSearch;
	  var profile = props.profile;
	  var t = props.t;
	  var next = props.next;
	  var router = props.router;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      visible: true,
	      closeAction: function closeAction() {
	        return props.router.push('/landing');
	      },
	      header: _react2.default.createElement(
	        'div',
	        { className: 'header' },
	        t('Investor Profile')
	      ),
	      backAction: router.goBack },
	    _react2.default.createElement(
	      Form,
	      null,
	      _react2.default.createElement(
	        FormTitle,
	        null,
	        t('Please indicate the types of properties you are interested in')
	      ),
	      _react2.default.createElement(_CheckboxDropdown2.default, {
	        showSelectAll: true,
	        showCheckBox: true,
	        key: 'property',
	        id: 'property',
	        showTags: true,
	        width: '100%',
	        placeholder: t('Types of assets'),
	        options: searches.categories,
	        selectedOptions: profile.preferredCategories,
	        handleSelect: function handleSelect(el) {
	          return _handleSelect('preferredCategories', el);
	        },
	        handleSelectAll: function handleSelectAll(list) {
	          return _handleSelectAll('preferredCategories', list);
	        }
	      })
	    ),
	    _react2.default.createElement(
	      Form,
	      null,
	      _react2.default.createElement(
	        FormTitle,
	        null,
	        t('Continent')
	      ),
	      _react2.default.createElement(_SearchableDropdown2.default, {
	        key: 'continents',
	        id: 'continents',
	        showTags: true,
	        value: searches.continentSearch,
	        placeholder: t('Specify the continents you wish to focus on'),
	        options: searches.continents,
	        selectedOptions: profile.preferredRegions,
	        handleSearch: function handleSearch(event) {
	          return _handleSearch(event, 'preferredRegions');
	        },
	        handleSelect: function handleSelect(el) {
	          return _handleSelect('preferredRegions', el);
	        },
	        accessor: function accessor(d) {
	          return d.name;
	        },
	        tagsAccessor: function tagsAccessor(d) {
	          return d.name;
	        }
	      })
	    ),
	    _react2.default.createElement(
	      Form,
	      null,
	      _react2.default.createElement(
	        FormTitle,
	        null,
	        t('Country')
	      ),
	      _react2.default.createElement(_SearchableDropdown2.default, {
	        key: 'countries',
	        id: 'countries',
	        showTags: true,
	        value: searches.countrySearch,
	        placeholder: t('Specify the countries you wish to focus on'),
	        options: searches.countries,
	        selectedOptions: profile.preferredCountries,
	        handleSearch: function handleSearch(event) {
	          return _handleSearch(event, 'preferredCountries');
	        },
	        handleSelect: function handleSelect(el) {
	          return _handleSelect('preferredCountries', el);
	        },
	        accessor: function accessor(d) {
	          return d.name;
	        },
	        tagsAccessor: function tagsAccessor(d) {
	          return d.name;
	        }
	      })
	    ),
	    _react2.default.createElement(
	      Form,
	      null,
	      _react2.default.createElement(
	        FormTitle,
	        null,
	        t('City')
	      ),
	      _react2.default.createElement(_SearchableDropdown2.default, {
	        key: 'cities',
	        id: 'cities',
	        showTags: true,
	        value: searches.citySearch,
	        placeholder: t('Specify the cities you wish to focus on'),
	        options: searches.cities,
	        selectedOptions: profile.preferredCities,
	        handleSearch: function handleSearch(event) {
	          return _handleSearch(event, 'preferredCities');
	        },
	        handleSelect: function handleSelect(el) {
	          return _handleSelect('preferredCities', el);
	        },
	        accessor: function accessor(d) {
	          return d.city + ', ' + d.country.name;
	        },
	        tagsAccessor: function tagsAccessor(d) {
	          return d.city;
	        }
	      })
	    ),
	    _react2.default.createElement(
	      Form,
	      null,
	      _react2.default.createElement(_RangePicker2.default, {
	        key: 'keys',
	        title: t('Size of the desired object (keys/rooms)'),
	        minValue: profile.minNoRooms,
	        maxValue: profile.maxNoRooms,
	        step: _Constants.defaultRoomsStep,
	        max: _Constants.maxRooms,
	        handleChange: function handleChange(value) {
	          return handleRange('minNoRooms', 'maxNoRooms', value);
	        },
	        className: 'rangeForm'
	      })
	    ),
	    _react2.default.createElement(
	      Form,
	      null,
	      _react2.default.createElement(_RangePicker2.default, {
	        key: 'investment',
	        title: t('Price range'),
	        minValue: profile.minInvestment,
	        maxValue: profile.maxInvestment,
	        max: _Constants.maxPrice,
	        step: _Constants.defaultPriceStep,
	        unit: '€',
	        handleChange: function handleChange(value) {
	          return handleRange('minInvestment', 'maxInvestment', value);
	        },
	        className: 'rangeForm'
	      })
	    ),
	    _react2.default.createElement(
	      Form,
	      null,
	      _react2.default.createElement(_RangePicker2.default, {
	        key: 'yield',
	        minValue: profile.minYield,
	        maxValue: profile.maxYield,
	        title: t('Target yield'),
	        max: _Constants.maxYield,
	        step: _Constants.defaultYieldStep,
	        unit: '%',
	        rightUnit: true,
	        handleChange: function handleChange(value) {
	          return handleRange('minYield', 'maxYield', value);
	        },
	        className: 'rangeForm'
	      })
	    ),
	    _react2.default.createElement(
	      Form,
	      null,
	      _react2.default.createElement(_RangePicker2.default, {
	        key: 'yield',
	        minValue: profile.minArea,
	        maxValue: profile.maxArea,
	        title: t('Area'),
	        max: _Constants.maxArea,
	        step: _Constants.defaultAreaStep,
	        unit: 'm2',
	        rightUnit: true,
	        handleChange: function handleChange(value) {
	          return handleRange('minArea', 'maxArea', value);
	        },
	        className: 'rangeForm'
	      })
	    ),
	    _react2.default.createElement(CustomButton, {
	      label: 'Next',
	      onClick: function onClick() {
	        return next('/landing/signup/more-settings');
	      }
	    })
	  );
	};
	
	Settings.propTypes = {
	  handleRange: _react.PropTypes.func.isRequired,
	  handleSelect: _react.PropTypes.func.isRequired,
	  handleSearch: _react.PropTypes.func.isRequired,
	  searches: _react.PropTypes.object.isRequired,
	  profile: _react.PropTypes.object.isRequired,
	  next: _react.PropTypes.func.isRequired,
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'landing', 'forms'], { wait: true })(Settings);

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _ErrorModal = __webpack_require__(30);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SignupError = function SignupError(props) {
	  var t = props.t;
	  var errorMessage = props.errorMessage;
	  var router = props.router;
	
	
	  return _react2.default.createElement(_ErrorModal2.default, {
	    visible: true,
	    closeAction: function closeAction() {
	      return router.push('/landing');
	    },
	    backAction: router.goBack,
	    header: t('Error'),
	    message: errorMessage
	  });
	};
	
	SignupError.propTypes = {
	  errorMessage: _react.PropTypes.string,
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'landing', 'forms'], { wait: true })(SignupError);

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin: 0 auto;\n  margin-top: ', ';\n  display: block;\n\n'], ['\n  margin: 0 auto;\n  margin-top: ', ';\n  display: block;\n\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _SuccessModal = __webpack_require__(37);
	
	var _SuccessModal2 = _interopRequireDefault(_SuccessModal);
	
	var _AuthSources = __webpack_require__(75);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject, _Themes.Metrics.margins.large);
	
	var Success = function Success(props) {
	  var t = props.t;
	  var router = props.router;
	  var profile = props.profile;
	
	  var uploadSuccess = props.location.query.state;
	  return _react2.default.createElement(_SuccessModal2.default, {
	    visible: true,
	    backAction: router.goBack,
	    closeAction: function closeAction() {
	      return router.push('/landing');
	    },
	    header: t('Thank You'),
	    message: _react2.default.createElement(
	      'div',
	      null,
	      uploadSuccess ? t('The file was uploaded with success.') : t('You will receive a confirmation e-mail. Please follow the link to activate your account.'),
	      !uploadSuccess && _react2.default.createElement(CustomButton, {
	        secondary: true,
	        onClick: function onClick() {
	          return (0, _AuthSources.resendConfirmationEmail)(profile.id);
	        },
	        label: t('Re-send Confirmation E-mail')
	      })
	    )
	  });
	};
	
	Success.propTypes = {
	  t: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  profile: _react.PropTypes.object
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'landing', 'forms'], { wait: true })(Success);

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  height: 565px;\n'], ['\n  height: 565px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  ', ';\n  text-align: justify;\n'], ['\n  ', ';\n  text-align: justify;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  .modalContainer {\n    max-height: none !important;\n  }\n'], ['\n  .modalContainer {\n    max-height: none !important;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactI18next = __webpack_require__(7);
	
	var _Modal = __webpack_require__(42);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Loader = __webpack_require__(45);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomLoader = (0, _styledComponents2.default)(_Loader2.default)(_templateObject);
	
	var TermsAndConditions = _styledComponents2.default.div(_templateObject2, _Themes.Fonts.style.Text);
	
	var CustomButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject3, _Themes.Metrics.margins.large);
	
	var CustomModal = (0, _styledComponents2.default)(_Modal2.default)(_templateObject4);
	
	var Terms = function Terms(props) {
	  var t = props.t;
	  var handleRegister = props.handleRegister;
	  var router = props.router;
	  var fetching = props.fetching;
	
	  return _react2.default.createElement(
	    CustomModal,
	    {
	      visible: true,
	      closeAction: function closeAction() {
	        return router.push('/landing');
	      },
	      header: _react2.default.createElement(
	        'div',
	        { className: 'header' },
	        t('Terms and Conditions')
	      ),
	      footer: _react2.default.createElement(
	        'div',
	        { className: 'header' },
	        _react2.default.createElement(CustomButton, { label: t('Agree'), onClick: handleRegister })
	      ),
	      backAction: router.goBack },
	    _react2.default.createElement(CustomLoader, { visible: fetching }),
	    _react2.default.createElement(
	      TermsAndConditions,
	      null,
	      t('Terms')
	    )
	  );
	};
	
	Terms.propTypes = {
	  handleRegister: _react.PropTypes.func.isRequired,
	  profile: _react.PropTypes.object.isRequired,
	  router: _react.PropTypes.object,
	  t: _react.PropTypes.func,
	  fetching: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'landing', 'forms'], { wait: true })(Terms);

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral([''], ['']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-top: 0;\n  margin-bottom: ', ';\n'], ['\n  margin-top: 0;\n  margin-bottom: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Themes = __webpack_require__(5);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _AuthSources = __webpack_require__(75);
	
	var _Modal = __webpack_require__(42);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _SuccessModal = __webpack_require__(37);
	
	var _SuccessModal2 = _interopRequireDefault(_SuccessModal);
	
	var _ErrorModal = __webpack_require__(30);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var CustomButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject2, _Themes.Metrics.margins.base);
	
	var CustomText = _styledComponents2.default.p(_templateObject3, _Themes.Metrics.margins.base);
	
	var ResetPassword = function (_Component) {
	  _inherits(ResetPassword, _Component);
	
	  function ResetPassword(props) {
	    _classCallCheck(this, ResetPassword);
	
	    var _this = _possibleConstructorReturn(this, (ResetPassword.__proto__ || Object.getPrototypeOf(ResetPassword)).call(this, props));
	
	    _this.state = {
	      email: '',
	      error: null,
	      modal: false
	    };
	    _this.handleEmailChange = _this.handleEmailChange.bind(_this);
	    _this.handleSend = _this.handleSend.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(ResetPassword, [{
	    key: 'handleEmailChange',
	    value: function handleEmailChange(event) {
	      this.setState({ email: event.target.value });
	    }
	  }, {
	    key: 'handleSend',
	    value: function handleSend() {
	      var _this2 = this;
	
	      (0, _AuthSources.resetPassword)(this.state.email).then(function (response) {
	        _this2.setState({ modal: 'success' });
	      }).catch(function () {
	        _this2.setState({
	          modal: 'error',
	          error: 'An error occurred'
	        });
	      });
	    }
	  }, {
	    key: 'handleClose',
	    value: function handleClose() {
	      this.setState({
	        success: false,
	        email: null,
	        error: ''
	      });
	      this.props.router.push('/landing');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	      var modal = this.state.modal;
	
	      var content = '';
	
	      if (this.state.modal) {
	        content = modal === 'success' ? _react2.default.createElement(_SuccessModal2.default, {
	          visible: true,
	          header: t('Reset Password'),
	          closeAction: this.handleClose,
	          message: t('An email has been sent to reset your password')
	        }) : _react2.default.createElement(_ErrorModal2.default, {
	          visible: true,
	          header: t('Error'),
	          closeAction: this.handleClose,
	          message: t('There was an error when reseting your password')
	        });
	      } else {
	        content = _react2.default.createElement(
	          _Modal2.default,
	          {
	            visible: true,
	            header: _react2.default.createElement(
	              'div',
	              { className: 'header' },
	              t('Reset Password')
	            ),
	            closeAction: this.handleClose },
	          _react2.default.createElement(
	            CustomText,
	            null,
	            t('Please insert your email and we will send you a link to reset your password')
	          ),
	          _react2.default.createElement(_Input2.default, {
	            handleChange: this.handleEmailChange,
	            error: this.state.error,
	            placeholder: t('Insert your email')
	          }),
	          _react2.default.createElement(CustomButton, {
	            className: 'success-button',
	            label: t('Send'),
	            onClick: this.handleSend
	          })
	        );
	      }
	
	      return _react2.default.createElement(
	        Container,
	        null,
	        content
	      );
	    }
	  }]);
	
	  return ResetPassword;
	}(_react.Component);
	
	ResetPassword.propTypes = {
	  router: _react.PropTypes.object,
	  t: _react.PropTypes.func
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'landing'], { wait: true })(ResetPassword);

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  text-align: center;\n\n  h1 {\n    margin-bottom: ', ';\n    margin-top: ', ';\n    ', ';\n  }\n\n  .error-view {\n    button {\n      margin-top: ', ';\n    }\n  }\n\n  ul {\n    padding: 0;\n    list-style: none;\n    text-align: left;\n\n    li {\n      display: inline-block;\n      width: 33%;\n    }\n  }\n\n  .other {\n    .inputTitle {\n      display: inline-block;\n      color: ', ';\n    }\n    .formContainer {\n      margin-left: ', ';\n      display: inline-block;\n    }\n  }\n\n  p {\n    ', ';\n    &.justify {\n      text-align: justify;\n    }\n  }\n\n  @media screen and (max-width: 768px) {\n    ul {\n      li {\n        width: 50%;\n      }\n    }\n  }\n'], ['\n  text-align: center;\n\n  h1 {\n    margin-bottom: ', ';\n    margin-top: ', ';\n    ', ';\n  }\n\n  .error-view {\n    button {\n      margin-top: ', ';\n    }\n  }\n\n  ul {\n    padding: 0;\n    list-style: none;\n    text-align: left;\n\n    li {\n      display: inline-block;\n      width: 33%;\n    }\n  }\n\n  .other {\n    .inputTitle {\n      display: inline-block;\n      color: ', ';\n    }\n    .formContainer {\n      margin-left: ', ';\n      display: inline-block;\n    }\n  }\n\n  p {\n    ', ';\n    &.justify {\n      text-align: justify;\n    }\n  }\n\n  @media screen and (max-width: 768px) {\n    ul {\n      li {\n        width: 50%;\n      }\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _Themes = __webpack_require__(5);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _AuthActions = __webpack_require__(53);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _jwtDecode = __webpack_require__(196);
	
	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);
	
	var _Utils = __webpack_require__(22);
	
	var _Validations = __webpack_require__(44);
	
	var _AuthSources = __webpack_require__(75);
	
	var _ErrorMessages = __webpack_require__(243);
	
	var _SearchSource = __webpack_require__(18);
	
	var _Defaults = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject, _Themes.Metrics.margins.base, _Themes.Metrics.margins.base, _Themes.Fonts.style.OrangeSubtitle, _Themes.Metrics.margins.base, _Themes.Colors.black, _Themes.Metrics.margins.base, _Themes.Fonts.style.Text);
	
	var Signup = function (_Component) {
	  _inherits(Signup, _Component);
	
	  function Signup(props) {
	    _classCallCheck(this, Signup);
	
	    var _this = _possibleConstructorReturn(this, (Signup.__proto__ || Object.getPrototypeOf(Signup)).call(this, props));
	
	    _this.state = {
	      profile: _ramda2.default.clone(_Defaults.userDefault),
	      searches: {
	        categories: [],
	        cities: [],
	        citySearch: '',
	        countries: [],
	        countrySearch: '',
	        continents: [],
	        continentSearch: ''
	      },
	      confirmPassword: '',
	      errors: {
	        firstName: '',
	        lastName: '',
	        email: '',
	        phoneNumber: '',
	        address: '',
	        city: '',
	        country: '',
	        general: ''
	      },
	      fetching: false,
	      errorMessage: ''
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleRegister = _this.handleRegister.bind(_this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.handleSelectAll = _this.handleSelectAll.bind(_this);
	    _this.handleSearch = _this.handleSearch.bind(_this);
	    _this.handleRange = _this.handleRange.bind(_this);
	    _this.handleConfirm = _this.handleConfirm.bind(_this);
	    _this.validateForm = _this.validateForm.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    _this.next = _this.next.bind(_this);
	    return _this;
	  }
	
	  _createClass(Signup, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var _props$location$query = this.props.location.query;
	      var firstName = _props$location$query.firstName;
	      var lastName = _props$location$query.lastName;
	      var email = _props$location$query.email;
	      var linkedin = _props$location$query.linkedin;
	      var company = _props$location$query.company;
	      var id = _props$location$query.id;
	      var state = _props$location$query.state;
	      var jobTitle = _props$location$query.jobTitle;
	      var error = _props$location$query.error;
	      var router = this.props.router;
	
	      if (error) {
	        var errorMessage = _ErrorMessages.errorMessages.linkedinAuthentication;
	        this.setState({ errorMessage: errorMessage }, function () {
	          return router.push('/landing/signup/error');
	        });
	        return;
	      }
	      if (email) {
	        var profile = this.state.profile;
	        profile.firstName = firstName;
	        profile.lastName = lastName;
	        profile.email = email;
	        profile.company = company;
	        profile.jobTitle = jobTitle;
	        profile.linkedinUrl = linkedin;
	        profile.linkedinId = id;
	        this.setState({ profile: profile });
	      }
	
	      if (state) {
	        var _profile = (0, _jwtDecode2.default)(window.localStorage.getItem('hvbToken')).user;
	        this.setState({ profile: _profile });
	      }
	
	      (0, _SearchSource.fetchPublicCategories)().then(function (response) {
	        var searches = _this2.state.searches;
	
	        searches.categories = response.data;
	        _this2.setState({ searches: searches });
	      }).catch(function (error) {
	        return console.log(error);
	      });
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(key, el) {
	      var profile = this.state.profile;
	
	      var selectedOptions = this.state.profile[key];
	      profile[key] = (0, _Utils.addOrRemoveObjectFromList)(selectedOptions, el);
	
	      if (key === 'preferredCities' || key === 'preferredCountries' || key === 'preferredRegions') {
	        var searches = {
	          categories: [],
	          cities: [],
	          citySearch: '',
	          countries: [],
	          countrySearch: '',
	          continents: [],
	          continentSearch: ''
	        };
	        this.setState({ profile: profile, searches: searches });
	      } else {
	        this.setState({ profile: profile });
	      }
	    }
	  }, {
	    key: 'handleSelectAll',
	    value: function handleSelectAll(key, list) {
	      var _this3 = this;
	
	      this.setState({ profile: Object.assign({}, this.state.profile, _defineProperty({}, key, _Defaults.userDefault[key])) }, function () {
	        return list.forEach(function (el) {
	          return _this3.handleSelect(key, el);
	        });
	      });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(key, event) {
	      var profile = this.state.profile;
	
	      profile[key] = event.target.value;
	      this.setState({ profile: profile });
	    }
	  }, {
	    key: 'handleConfirm',
	    value: function handleConfirm(event) {
	      this.setState({ confirmPassword: event.target.value });
	    }
	  }, {
	    key: 'handleRange',
	    value: function handleRange(minKey, maxKey, value) {
	      var profile = this.state.profile;
	      profile[minKey] = value.min;
	      profile[maxKey] = value.max;
	      this.setState({ profile: profile });
	    }
	  }, {
	    key: 'handleSearch',
	    value: function handleSearch(event, key) {
	      var _this4 = this;
	
	      var searches = this.state.searches;
	
	      var value = event.target.value;
	      switch (key) {
	        case 'preferredCities':
	          (0, _SearchSource.searchPublicCity)({
	            where: { city: { startsWith: value } }
	          }).then(function (response) {
	            searches.citySearch = value;
	            searches.cities = response.data;
	            _this4.setState({ searches: searches });
	          });
	          break;
	        case 'preferredCountries':
	          (0, _SearchSource.searchPublicCountry)({
	            where: { name: { startsWith: value } }
	          }).then(function (response) {
	            searches.countrySearch = value;
	            searches.countries = response.data;
	            _this4.setState({ searches: searches });
	          });
	          break;
	        case 'preferredRegions':
	          (0, _SearchSource.searchPublicContinent)({
	            where: { name: { startsWith: value } }
	          }).then(function (response) {
	            searches.continentSearch = value;
	            searches.continents = response.data;
	            _this4.setState({ searches: searches });
	          });
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'handleRegister',
	    value: function handleRegister() {
	      var _this5 = this;
	
	      var profile = _ramda2.default.clone(this.state.profile);
	      var router = this.props.router;
	
	      profile.preferredCities = profile.preferredCities.length > 0 && profile.preferredCities.map(function (el) {
	        return el.id;
	      });
	
	      profile.preferredCountries = profile.preferredCountries.length > 0 && profile.preferredCountries.map(function (el) {
	        return el.id;
	      });
	
	      profile.preferredRegions = profile.preferredRegions.length > 0 && profile.preferredRegions.map(function (el) {
	        return el.id;
	      });
	
	      profile.preferredCategories = profile.preferredCategories.length > 0 && profile.preferredCategories.map(function (el) {
	        return el.id;
	      });
	
	      this.setState({ fetching: true }, function () {
	        return (0, _AuthSources.registerUser)(profile).then(function (response) {
	          _this5.setState({ fetching: false, profile: response.data.token.user }, function () {
	            router.push('/landing/signup/ncnda');
	            _AuthActions2.default.storeToken(response.data.token);
	          });
	        }).catch(function (error) {
	          var errorMessage = _ErrorMessages.errorMessages.general;
	          if (error.response && (0, _Utils.isErrorOfInvalidAttribute)(error.response, 'email', 'unique')) {
	            errorMessage = _ErrorMessages.errorMessages.emailAlreadyExists;
	          }
	
	          _this5.setState({ fetching: false, errorMessage: errorMessage }, function () {
	            return router.push('/landing/signup/error');
	          });
	        });
	      });
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm() {
	      var requiredFields = document.querySelectorAll('[required]');
	      var errors = this.state.errors;
	      var valid = true;
	      for (var k = 0; k < requiredFields.length; k++) {
	        errors = (0, _Validations.validateInput)(requiredFields[k].name, this.state.profile[requiredFields[k].name], errors);
	        valid = valid && errors[requiredFields[k].name] === '';
	      }
	      errors.general = !valid ? 'Please fill in all the required fields' : '';
	      this.setState({ errors: errors });
	      return valid;
	    }
	  }, {
	    key: 'next',
	    value: function next(route) {
	      if (this.validateForm()) {
	        this.props.router.push(route);
	      }
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur(name, value, errors) {
	      var newErrors = (0, _Validations.validateInput)(name, value, errors);
	      this.setState({ errors: newErrors });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	      return _react2.default.createElement(
	        Container,
	        null,
	        children && _react2.default.cloneElement(children, {
	          profile: this.state.profile,
	          searches: this.state.searches,
	          confirmPassword: this.state.confirmPassword,
	          validForm: this.state.validForm,
	          errors: this.state.errors,
	          handleSelect: this.handleSelect,
	          handleSelectAll: this.handleSelectAll,
	          handleChange: this.handleChange,
	          handleConfirm: this.handleConfirm,
	          handleSearch: this.handleSearch,
	          handleRegister: this.handleRegister,
	          handleBlur: this.handleBlur,
	          handleRange: this.handleRange,
	          next: this.next,
	          fetching: this.state.fetching,
	          errorMessage: this.state.errorMessage
	        })
	      );
	    }
	  }]);
	
	  return Signup;
	}(_react.Component);
	
	Signup.propTypes = {
	  errorMessage: _react.PropTypes.string,
	  location: _react.PropTypes.object,
	  router: _react.PropTypes.object,
	  children: _react.PropTypes.node
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'landing', 'forms'], { wait: true })(Signup);

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: block;\n  width: 100vw;\n  height: 100vh;\n  position: relative;\n\n  @media screen and (max-width: ', ') {\n    height: 100vh;\n  }\n'], ['\n  display: block;\n  width: 100vw;\n  height: 100vh;\n  position: relative;\n\n  @media screen and (max-width: ', ') {\n    height: 100vh;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  height: ', ';\n  width: 100vw;\n  text-align: center;\n  background-color: ', ';\n'], ['\n  height: ', ';\n  width: 100vw;\n  text-align: center;\n  background-color: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  ', ';\n  padding: ', ' 0;\n'], ['\n  ', ';\n  padding: ', ' 0;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  object-fit: fill;\n  width: 100vw;\n  height: 100vh;\n  display: block;\n  @media screen and (max-width: ', ') {\n    object-fit: cover;\n  }\n'], ['\n  object-fit: fill;\n  width: 100vw;\n  height: 100vh;\n  display: block;\n  @media screen and (max-width: ', ') {\n    object-fit: cover;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  opacity: 0.3;\n  background: url(', ') no-repeat center;\n  background-size: cover;\n  -webkit-backdrop-filter: blur(2px);\n  backdrop-filter: blur(2px);\n  filter: blur(2px);\n  pointer-events: none;\n'], ['\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  opacity: 0.3;\n  background: url(', ') no-repeat center;\n  background-size: cover;\n  -webkit-backdrop-filter: blur(2px);\n  backdrop-filter: blur(2px);\n  filter: blur(2px);\n  pointer-events: none;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  text-align: center;\n  height: 100vh;\n  overflow-y: scroll;\n'], ['\n  text-align: center;\n  height: 100vh;\n  overflow-y: scroll;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  display: table-cell;\n  vertical-align: middle;\n  width: 100vw;\n  height: 100vh;\n  position: relative;\n'], ['\n  display: table-cell;\n  vertical-align: middle;\n  width: 100vw;\n  height: 100vh;\n  position: relative;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n'], ['\n  ', ';\n  color: ', ';\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  margin-right: ', ';\n'], ['\n  margin-right: ', ';\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  width: ', ';\n  margin-left: calc((100% - ', ')/2)\n  border-bottom: ', ';\n  margin-bottom: ', ';\n'], ['\n  width: ', ';\n  margin-left: calc((100% - ', ')/2)\n  border-bottom: ', ';\n  margin-bottom: ', ';\n']),
	    _templateObject12 = _taggedTemplateLiteral(['padding: ', ' 0;'], ['padding: ', ' 0;']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  text-align: center;\n  padding: ', ' 0;\n  ', ';\n  color: ', ';\n'], ['\n  text-align: center;\n  padding: ', ' 0;\n  ', ';\n  color: ', ';\n']),
	    _templateObject14 = _taggedTemplateLiteral(['padding: ', ';'], ['padding: ', ';']),
	    _templateObject15 = _taggedTemplateLiteral(['\n  border-bottom: ', ';\n  border-top: ', ';\n  padding: ', ';\n'], ['\n  border-bottom: ', ';\n  border-top: ', ';\n  padding: ', ';\n']),
	    _templateObject16 = _taggedTemplateLiteral(['\n  line-height: ', ';\n  color: ', ';\n'], ['\n  line-height: ', ';\n  color: ', ';\n']),
	    _templateObject17 = _taggedTemplateLiteral(['\n  position: absolute;\n  display: table;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  background: rgba(48, 48, 48, 0.8);\n'], ['\n  position: absolute;\n  display: table;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  background: rgba(48, 48, 48, 0.8);\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _Themes = __webpack_require__(5);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _HvbWhite = __webpack_require__(521);
	
	var _HvbWhite2 = _interopRequireDefault(_HvbWhite);
	
	var _AuthStore = __webpack_require__(129);
	
	var _AuthStore2 = _interopRequireDefault(_AuthStore);
	
	var _introVideo = __webpack_require__(1126);
	
	var _introVideo2 = _interopRequireDefault(_introVideo);
	
	var _introImage = __webpack_require__(1125);
	
	var _introImage2 = _interopRequireDefault(_introImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var LandingContainer = _styledComponents2.default.div(_templateObject, _Themes.Metrics.breakpoints.mobile);
	
	var Contacts = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.components.landingFooter, _Themes.Colors.white);
	
	var Contact = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject3, _Themes.Fonts.style.Text, _Themes.Metrics.margins.medium);
	
	var BackgroundVideo = _styledComponents2.default.video(_templateObject4, _Themes.Metrics.breakpoints.mobile);
	
	var BackgroundImage = _styledComponents2.default.div(_templateObject5, _introImage2.default);
	
	var Container = _styledComponents2.default.main(_templateObject6);
	
	var InfosContainer = _styledComponents2.default.div(_templateObject7);
	
	var Title = _styledComponents2.default.div(_templateObject8, _Themes.Fonts.style.Header, _Themes.Colors.white);
	
	var CustomButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject9, _Themes.Metrics.margins.big);
	
	var AboutButton = (0, _styledComponents2.default)(CustomButton)(_templateObject10, _Themes.Metrics.margins.small);
	
	var LogoContainer = _styledComponents2.default.div(_templateObject11, _Themes.Metrics.components.landingLogoSize, _Themes.Metrics.components.landingLogoSize, _Themes.Metrics.borders.orangeBorder, _Themes.Metrics.margins.larger);
	
	var Body = _styledComponents2.default.div(_templateObject12, _Themes.Metrics.margins.base);
	
	var StyledGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject13, _Themes.Metrics.margins.small, _Themes.Fonts.style.Text, _Themes.Colors.primary);
	
	var Intro = _styledComponents2.default.div(_templateObject14, _Themes.Metrics.margins.big);
	
	var ContainerWithBorder = _styledComponents2.default.div(_templateObject15, _Themes.Metrics.borders.default, _Themes.Metrics.borders.default, _Themes.Metrics.margins.base);
	
	var Description = _styledComponents2.default.p(_templateObject16, _Themes.Metrics.margins.large, _Themes.Colors.black);
	
	var Wrapper = _styledComponents2.default.div(_templateObject17);
	
	var Landing = function (_Component) {
	  _inherits(Landing, _Component);
	
	  function Landing() {
	    _classCallCheck(this, Landing);
	
	    return _possibleConstructorReturn(this, (Landing.__proto__ || Object.getPrototypeOf(Landing)).apply(this, arguments));
	  }
	
	  _createClass(Landing, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (!this.props.user && nextProps.user) {
	        this.props.router.replace('/');
	      }
	    }
	  }, {
	    key: 'getBackground',
	    value: function getBackground() {
	      if (window.matchMedia('(min-width:' + _Themes.Metrics.breakpoints.tablet + ')').matches) {
	        return _react2.default.createElement(
	          BackgroundVideo,
	          { loop: true, autoPlay: true },
	          _react2.default.createElement('source', { src: _introVideo2.default, type: 'video/mp4' })
	        );
	      }
	      return _react2.default.createElement(BackgroundImage, null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var t = _props.t;
	      var children = _props.children;
	      var router = _props.router;
	
	
	      return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(
	          LandingContainer,
	          null,
	          this.getBackground(),
	          children || _react2.default.createElement(
	            Wrapper,
	            null,
	            _react2.default.createElement(
	              InfosContainer,
	              null,
	              _react2.default.createElement(
	                LogoContainer,
	                null,
	                _react2.default.createElement(_HvbWhite2.default, null)
	              ),
	              _react2.default.createElement(
	                Title,
	                null,
	                t('Discretion, Trust, Excellence')
	              ),
	              _react2.default.createElement(AboutButton, {
	                label: t('About Pangaea'),
	                onClick: function onClick() {
	                  return router.push('/landing/about_pangaea');
	                }
	              }),
	              _react2.default.createElement(CustomButton, {
	                primary: true,
	                label: t('Login'),
	                onClick: function onClick() {
	                  return router.push('/landing/login');
	                }
	              })
	            )
	          )
	        ),
	        !children && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            Body,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(StyledGrid, { md: 1 / 8 }),
	              _react2.default.createElement(
	                StyledGrid,
	                { md: 3 / 4 },
	                _react2.default.createElement(
	                  Intro,
	                  null,
	                  _react2.default.createElement(
	                    Description,
	                    null,
	                    t('HvB Investments is a boutique Swiss real estate investment firm specializing in high-end commercial and residential properties. It\'s our passion to navigate investors through the complexity of real estate markets. We focus on and cater to the very specific investment priorities of high net worth individuals and their families, as well as best-in-class institutional investors from around the world. We specialize in and pride ourselves on understanding our clients\u2019 needs and investment criteria to deliver quality projects through rigorous research across our extensive and exclusive network. HvB provides investors access to Pangaea, our exclusive platform for high-end off-market real estate assets.')
	                  )
	                )
	              ),
	              _react2.default.createElement(StyledGrid, { md: 1 / 8 })
	            ),
	            _react2.default.createElement(
	              ContainerWithBorder,
	              null,
	              _react2.default.createElement(
	                StyledGrid,
	                { md: 1 / 5 },
	                t('Geneva')
	              ),
	              _react2.default.createElement(
	                StyledGrid,
	                { md: 1 / 5 },
	                t('London')
	              ),
	              _react2.default.createElement(
	                StyledGrid,
	                { md: 1 / 5 },
	                t('São Paulo')
	              ),
	              _react2.default.createElement(
	                StyledGrid,
	                { md: 1 / 5 },
	                t('Singapore')
	              ),
	              _react2.default.createElement(
	                StyledGrid,
	                { md: 1 / 5 },
	                t('Zurich')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Contacts,
	            null,
	            _react2.default.createElement(
	              Contact,
	              { md: 1 / 2 },
	              'invest@hvb-investments.com'
	            ),
	            _react2.default.createElement(
	              Contact,
	              { md: 1 / 2 },
	              'Münsterhof 6, 8001 Zürich'
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return _AuthStore2.default.getState();
	    }
	  }, {
	    key: 'getStores',
	    value: function getStores() {
	      return [_AuthStore2.default];
	    }
	  }, {
	    key: 'getPropsFromStores',
	    value: function getPropsFromStores() {
	      var authState = _AuthStore2.default.getState();
	      return {
	        user: authState.user,
	        fetching: authState.fetching,
	        errorMessage: authState.errorMessage
	      };
	    }
	  }]);
	
	  return Landing;
	}(_react.Component);
	
	Landing.propTypes = {
	  errorMessage: _react.PropTypes.string,
	  user: _react.PropTypes.object,
	  router: _react.PropTypes.object,
	  t: _react.PropTypes.func,
	  children: _react.PropTypes.node
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'landing'], { wait: true })(Landing);

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  height: 100vh;\n  width: 100vw;\n  min-width: 750px;\n  display: table;\n  text-align: center;\n  backgroundColor: ', ';\n  background: url(', ') no-repeat center;\n  background-size: cover;\n  min-width: ', ';\n  overflow-x: scroll;\n'], ['\n  height: 100vh;\n  width: 100vw;\n  min-width: 750px;\n  display: table;\n  text-align: center;\n  backgroundColor: ', ';\n  background: url(', ') no-repeat center;\n  background-size: cover;\n  min-width: ', ';\n  overflow-x: scroll;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  height: 100%;\n  width: 100%;\n  display: table-cell;\n  vertical-align: middle;\n'], ['\n  height: 100%;\n  width: 100%;\n  display: table-cell;\n  vertical-align: middle;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  width: 130px;\n  margin-left: calc((100% - 130px)/2)\n  margin-bottom: 30px;\n'], ['\n  width: 130px;\n  margin-left: calc((100% - 130px)/2)\n  margin-bottom: 30px;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  display: block;\n  width: 515px;\n  min-height: 358px;\n  max-height: 515px;\n  padding: 40px 95px;\n  margin: 0 auto;\n  overflow-y: scroll;\n  backgroundColor: ', ';\n'], ['\n  display: block;\n  width: 515px;\n  min-height: 358px;\n  max-height: 515px;\n  padding: 40px 95px;\n  margin: 0 auto;\n  overflow-y: scroll;\n  backgroundColor: ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  .inputTitle {\n    color: ', ';\n  }\n'], ['\n  margin-top: ', ';\n  .inputTitle {\n    color: ', ';\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n'], ['\n  ', ';\n  color: ', ';\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  display: ', '\n  margin: ', ' 0;\n  ', ';\n  color: ', ';\n'], ['\n  display: ', '\n  margin: ', ' 0;\n  ', ';\n  color: ', ';\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _Themes = __webpack_require__(5);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _HvbWhite = __webpack_require__(521);
	
	var _HvbWhite2 = _interopRequireDefault(_HvbWhite);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _AuthActions = __webpack_require__(53);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _AuthStore = __webpack_require__(129);
	
	var _AuthStore2 = _interopRequireDefault(_AuthStore);
	
	var _adminBackgroundImage = __webpack_require__(1124);
	
	var _adminBackgroundImage2 = _interopRequireDefault(_adminBackgroundImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var PageContainer = _styledComponents2.default.div(_templateObject, _Themes.Colors.darkGrey, _adminBackgroundImage2.default, _Themes.Metrics.components.adminScreensMinWidth);
	
	var Content = _styledComponents2.default.div(_templateObject2);
	
	var LogoContainer = _styledComponents2.default.div(_templateObject3);
	
	var LoginBox = _styledComponents2.default.div(_templateObject4, _Themes.Colors.white);
	
	var CustomInput = (0, _styledComponents2.default)(_Input2.default)(_templateObject5, _Themes.Metrics.margins.large, _Themes.Colors.primary);
	
	var Title = _styledComponents2.default.div(_templateObject6, _Themes.Fonts.style.Title, _Themes.Colors.primary);
	
	var ErrorMessage = _styledComponents2.default.div(_templateObject7, function (props) {
	  return props.visible ? 'block' : 'none';
	}, _Themes.Metrics.margins.small, _Themes.Fonts.style.Small, _Themes.Colors.red);
	
	var LoginButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject8, _Themes.Metrics.margins.larger);
	
	var LoginAdmin = function (_Component) {
	  _inherits(LoginAdmin, _Component);
	
	  function LoginAdmin(props) {
	    _classCallCheck(this, LoginAdmin);
	
	    var _this = _possibleConstructorReturn(this, (LoginAdmin.__proto__ || Object.getPrototypeOf(LoginAdmin)).call(this, props));
	
	    _this.state = {
	      email: '',
	      password: ''
	    };
	    _this.handleLogin = _this.handleLogin.bind(_this);
	    _this.handleEmailChange = _this.handleEmailChange.bind(_this);
	    _this.handlePasswordChange = _this.handlePasswordChange.bind(_this);
	    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
	    return _this;
	  }
	
	  _createClass(LoginAdmin, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (!this.props.admin && nextProps.admin) {
	        this.props.router.replace('/admin');
	      }
	    }
	  }, {
	    key: 'handleEmailChange',
	    value: function handleEmailChange(event) {
	      var value = event.target.value;
	      this.setState({ email: value });
	    }
	  }, {
	    key: 'handlePasswordChange',
	    value: function handlePasswordChange(event) {
	      var value = event.target.value;
	      this.setState({ password: value });
	    }
	  }, {
	    key: 'handleLogin',
	    value: function handleLogin() {
	      var _state = this.state;
	      var email = _state.email;
	      var password = _state.password;
	
	      _AuthActions2.default.loginAdmin(email, password);
	    }
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(event) {
	      if (event.key === 'Enter') {
	        this.handleLogin();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var t = this.props.t;
	      var errorMessage = this.props.errorMessage;
	
	      return _react2.default.createElement(
	        'main',
	        null,
	        _react2.default.createElement(
	          PageContainer,
	          null,
	          _react2.default.createElement(
	            Content,
	            null,
	            _react2.default.createElement(
	              LogoContainer,
	              null,
	              _react2.default.createElement(_HvbWhite2.default, null)
	            ),
	            _react2.default.createElement(
	              LoginBox,
	              null,
	              _react2.default.createElement(
	                Title,
	                null,
	                t('Admin')
	              ),
	              _react2.default.createElement(CustomInput, {
	                type: 'email',
	                title: t('E-mail'),
	                handleChange: this.handleEmailChange
	              }),
	              _react2.default.createElement(CustomInput, {
	                type: 'password',
	                title: t('Password'),
	                handleChange: this.handlePasswordChange,
	                handleKeyPress: this.handleKeyPress
	              }),
	              _react2.default.createElement(
	                ErrorMessage,
	                { visible: errorMessage },
	                errorMessage
	              ),
	              _react2.default.createElement(LoginButton, { label: t('Log in'), onClick: this.handleLogin })
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return _AuthStore2.default.getState();
	    }
	  }, {
	    key: 'getStores',
	    value: function getStores() {
	      return [_AuthStore2.default];
	    }
	  }, {
	    key: 'getPropsFromStores',
	    value: function getPropsFromStores() {
	      var authState = _AuthStore2.default.getState();
	      return {
	        admin: authState.admin,
	        fetching: authState.fetching,
	        errorMessage: authState.errorMessage
	      };
	    }
	  }]);
	
	  return LoginAdmin;
	}(_react.Component);
	
	LoginAdmin.propTypes = {
	  t: _react.PropTypes.func,
	  errorMessage: _react.PropTypes.string,
	  admin: _react.PropTypes.object,
	  router: _react.PropTypes.object
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'landing'], { wait: true })(LoginAdmin);

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', '){\n    padding-left: 0;\n    padding-right: 0;\n  }\n'], ['\n  padding-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', '){\n    padding-left: 0;\n    padding-right: 0;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  @media screen and (max-width: ', '){\n    padding-left: 0;\n    padding-right: 0;\n  }\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  @media screen and (max-width: ', '){\n    padding-left: 0;\n    padding-right: 0;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n\n  @media screen and (max-width: ', ') {\n    ', ';\n  }\n'], ['\n  margin-bottom: ', ';\n  ', ';\n  color: ', ';\n\n  @media screen and (max-width: ', ') {\n    ', ';\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  margin-left: ', ';\n  ', ';\n  color: ', ';\n'], ['\n  margin-top: ', ';\n  margin-left: ', ';\n  ', ';\n  color: ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteral(['margin-top: ', ';'], ['margin-top: ', ';']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  float: right;\n  margin-top: ', ';\n  @media screen and (max-width: ', ') {\n    text-align: center;\n    background: ', ';\n    color: ', ';\n    float: inherit;\n    width: 100%;\n  }\n'], ['\n  float: right;\n  margin-top: ', ';\n  @media screen and (max-width: ', ') {\n    text-align: center;\n    background: ', ';\n    color: ', ';\n    float: inherit;\n    width: 100%;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactI18next = __webpack_require__(7);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _Textarea = __webpack_require__(74);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Validations = __webpack_require__(44);
	
	var _AuthActions = __webpack_require__(53);
	
	var _Themes = __webpack_require__(5);
	
	var _SuccessModal = __webpack_require__(37);
	
	var _SuccessModal2 = _interopRequireDefault(_SuccessModal);
	
	var _AuthSources = __webpack_require__(75);
	
	var _ErrorModal = __webpack_require__(30);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomHalf = (0, _styledComponents2.default)(_gridStyled.Half)(_templateObject, _Themes.Metrics.margins.base, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.breakpoints.mobile);
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject2, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.breakpoints.mobile);
	
	var Title = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.small, _Themes.Fonts.style.Label, _Themes.Colors.black, _Themes.Metrics.breakpoints.tablet, function (props) {
	  return props.isUploadTitle && 'display: none';
	});
	
	var Error = _styledComponents2.default.div(_templateObject4, _Themes.Metrics.margins.tiny, _Themes.Metrics.margins.large, _Themes.Fonts.style.Input, _Themes.Colors.red);
	
	var Container = _styledComponents2.default.div(_templateObject5, _Themes.Metrics.margins.larger);
	
	var CustomButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject6, _Themes.Metrics.margins.larger, _Themes.Metrics.breakpoints.mobile, _Themes.Colors.primary, _Themes.Colors.whiteThree);
	
	var PersonalInfo = function (_Component) {
	  _inherits(PersonalInfo, _Component);
	
	  function PersonalInfo(props) {
	    _classCallCheck(this, PersonalInfo);
	
	    var _this = _possibleConstructorReturn(this, (PersonalInfo.__proto__ || Object.getPrototypeOf(PersonalInfo)).call(this, props));
	
	    _this.state = {
	      user: props.user,
	      successModalOpen: false,
	      fileUploadError: false,
	      errors: {
	        firstName: '',
	        lastName: '',
	        email: '',
	        phoneNumber: '',
	        address: ''
	      }
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleUpdate = _this.handleUpdate.bind(_this);
	    _this.handleProfilePictureUpload = _this.handleProfilePictureUpload.bind(_this);
	    _this.handleUploadError = _this.handleUploadError.bind(_this);
	    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    _this.validateForm = _this.validateForm.bind(_this);
	    return _this;
	  }
	
	  _createClass(PersonalInfo, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ user: nextProps.user });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event, key) {
	      var user = this.state.user;
	      user[key] = event.target.value;
	      this.setState({ user: user });
	    }
	  }, {
	    key: 'handleProfilePictureUpload',
	    value: function handleProfilePictureUpload(file, result) {
	      var user = this.state.user;
	      user.picture = { file: file, result: result };
	      this.setState({ user: user, fileUploadError: false });
	    }
	  }, {
	    key: 'handleUploadError',
	    value: function handleUploadError() {
	      this.setState({ fileUploadError: true });
	    }
	  }, {
	    key: 'handleUpdate',
	    value: function handleUpdate() {
	      var _this2 = this;
	
	      var user = this.state.user;
	
	      if (this.validateForm()) {
	        (0, _AuthSources.updateUser)(user).then(function (response) {
	          _this2.setState({ modal: 'success' }, function () {
	            return (0, _AuthActions.updateToken)(response.data.authToken);
	          });
	        }).catch(function (error) {
	          console.log(error);
	          _this2.setState({ modal: 'error' });
	        });
	      }
	    }
	  }, {
	    key: 'handleCloseModal',
	    value: function handleCloseModal() {
	      this.setState({ modal: false });
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur(name, value, errors) {
	      var newErrors = (0, _Validations.validateInput)(name, value, errors);
	      this.setState({ errors: newErrors });
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm() {
	      var requiredFields = document.querySelectorAll('[required]');
	      var errors = this.state.errors;
	      var valid = true;
	      for (var k = 0; k < requiredFields.length; k++) {
	        errors = (0, _Validations.validateInput)(requiredFields[k].name, this.state.user[requiredFields[k].name], errors);
	        valid = valid && errors[requiredFields[k].name] === '';
	      }
	      this.setState({ errors: errors });
	      return valid;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state;
	      var user = _state.user;
	      var fileUploadError = _state.fileUploadError;
	      var errors = _state.errors;
	      var modal = _state.modal;
	      var t = this.props.t;
	
	      return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(_SuccessModal2.default, {
	          visible: modal === 'success',
	          closeAction: this.handleCloseModal,
	          header: t('Profile Updated'),
	          message: t('Your Profile was successfully updated')
	        }),
	        _react2.default.createElement(_ErrorModal2.default, {
	          visible: modal === 'error',
	          closeAction: this.handleCloseModal,
	          header: t('Error'),
	          message: t('There was an error when updating your profile')
	        }),
	        _react2.default.createElement(
	          CustomGrid,
	          { noPadTop: true },
	          _react2.default.createElement(
	            Title,
	            { isUploadTitle: true },
	            t('Upload Picture')
	          ),
	          _react2.default.createElement(_Avatar2.default, {
	            size: parseInt(_Themes.Metrics.components.profilePhoto, 10),
	            imageSrc: user.picture && (user.picture.result || user.picture),
	            onEdit: this.handleProfilePictureUpload,
	            handleError: this.handleUploadError,
	            className: 'avatar'
	          }),
	          fileUploadError && _react2.default.createElement(
	            Error,
	            null,
	            t('Max size 2MB')
	          )
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          null,
	          _react2.default.createElement(_Input2.default, {
	            title: t('First Name'),
	            value: user.firstName,
	            handleChange: function handleChange(event) {
	              return _this3.handleChange(event, 'firstName');
	            },
	            required: true,
	            error: errors['firstName'],
	            name: 'firstName',
	            handleBlur: function handleBlur(event) {
	              return _this3.handleBlur('firstName', user.firstName, errors);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          null,
	          _react2.default.createElement(_Input2.default, {
	            title: t('E-mail'),
	            value: user.email,
	            handleChange: function handleChange(event) {
	              return _this3.handleChange(event, 'email');
	            },
	            required: true,
	            error: errors['email'],
	            name: 'email',
	            handleBlur: function handleBlur(event) {
	              return _this3.handleBlur('email', user.email, errors);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          null,
	          _react2.default.createElement(_Input2.default, {
	            title: t('Last Name'),
	            value: user.lastName,
	            handleChange: function handleChange(event) {
	              return _this3.handleChange(event, 'lastName');
	            },
	            required: true,
	            error: errors['lastName'],
	            name: 'lastName',
	            handleBlur: function handleBlur(event) {
	              return _this3.handleBlur('lastName', user.lastName, errors);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          null,
	          _react2.default.createElement(_Input2.default, {
	            title: t('Phone Number'),
	            value: user.phoneNumber,
	            handleChange: function handleChange(event) {
	              return _this3.handleChange(event, 'phoneNumber');
	            },
	            required: true,
	            error: errors['phoneNumber'],
	            name: 'phoneNumber',
	            handleBlur: function handleBlur(event) {
	              return _this3.handleBlur('phoneNumber', user.phoneNumber, errors);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          null,
	          _react2.default.createElement(_Input2.default, {
	            title: t('Company'),
	            value: user.company,
	            handleChange: function handleChange(event) {
	              return _this3.handleChange(event, 'company');
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          null,
	          _react2.default.createElement(_Input2.default, {
	            title: t('Job Title'),
	            value: user.jobTitle,
	            handleChange: function handleChange(event) {
	              return _this3.handleChange(event, 'jobTitle');
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomGrid,
	          null,
	          _react2.default.createElement(_Textarea2.default, {
	            value: user.description,
	            title: t('Brief Description'),
	            handleChange: function handleChange(event) {
	              return _this3.handleChange(event, 'description');
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomGrid,
	          null,
	          _react2.default.createElement(_Input2.default, {
	            title: t('Address'),
	            value: user.address,
	            handleChange: function handleChange(event) {
	              return _this3.handleChange(event, 'address');
	            },
	            required: true,
	            error: errors['address'],
	            name: 'address',
	            handleBlur: function handleBlur(event) {
	              return _this3.handleBlur('address', user.address, errors);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          null,
	          _react2.default.createElement(_Input2.default, {
	            title: t('City'),
	            value: user.city,
	            handleChange: function handleChange(event) {
	              return _this3.handleChange(event, 'city');
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          null,
	          _react2.default.createElement(_Input2.default, {
	            title: t('Country'),
	            value: user.country,
	            handleChange: function handleChange(event) {
	              return _this3.handleChange(event, 'country');
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          null,
	          _react2.default.createElement(_Input2.default, {
	            title: t('Skype Name'),
	            value: user.skypeName,
	            handleChange: function handleChange(event) {
	              return _this3.handleChange(event, 'skypeName');
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomHalf,
	          null,
	          _react2.default.createElement(_Input2.default, {
	            title: t('Linkedin Profile'),
	            value: user.linkedinUrl,
	            handleChange: function handleChange(event) {
	              return _this3.handleChange(event, 'linkedinUrl');
	            }
	          })
	        ),
	        _react2.default.createElement(
	          CustomGrid,
	          { noPadTop: true, style: { paddingBottom: _Themes.Metrics.margins.base } },
	          _react2.default.createElement(CustomButton, { label: t('Save'), onClick: this.handleUpdate })
	        )
	      );
	    }
	  }]);
	
	  return PersonalInfo;
	}(_react.Component);
	
	PersonalInfo.propTypes = {
	  user: _react.PropTypes.object,
	  t: _react.PropTypes.func
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'settings', 'forms'], { wait: true })(PersonalInfo);

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral([''], ['']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  border-bottom: ', ';\n  padding: ', ' 0;\n  position: relative;\n'], ['\n  border-bottom: ', ';\n  padding: ', ' 0;\n  position: relative;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  right: 20px;\n  top: ', ';\n\n  svg {\n    cursor: pointer;\n    transition: ease transform 0.2s;\n\n    &:hover {\n      transform: scale(1.2);\n      transition: ease transform 0.2s;\n    }\n  }\n\n  @media screen and (max-width: ', ') {\n    right: 0;\n  }\n'], ['\n  position: absolute;\n  right: 20px;\n  top: ', ';\n\n  svg {\n    cursor: pointer;\n    transition: ease transform 0.2s;\n\n    &:hover {\n      transform: scale(1.2);\n      transition: ease transform 0.2s;\n    }\n  }\n\n  @media screen and (max-width: ', ') {\n    right: 0;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  padding-left: 0;\n  padding-right: 0;\n  ', ';\n  span {\n    ', ';\n  }\n'], ['\n  padding-left: 0;\n  padding-right: 0;\n  ', ';\n  span {\n    ', ';\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  padding-left: ', ';\n  padding-right: ', ';\n'], ['\n  padding-left: ', ';\n  padding-right: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n'], ['\n  margin-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n'], ['\n  ', ';\n  color: ', ';\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  ', ';\n  display: block;\n  margin-top: ', ';\n  margin-bottom: ', ';\n\n  @media screen and (max-width: ', ') {\n    margin-right: ', ';\n  }\n'], ['\n  ', ';\n  display: block;\n  margin-top: ', ';\n  margin-bottom: ', ';\n\n  @media screen and (max-width: ', ') {\n    margin-right: ', ';\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  display: inline-block;\n'], ['\n  display: inline-block;\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  padding: ', ' 0;\n  border-bottom: ', ';\n\n  @media screen and (max-width: ', ') {\n    display: none;\n  }\n'], ['\n  padding: ', ' 0;\n  border-bottom: ', ';\n\n  @media screen and (max-width: ', ') {\n    display: none;\n  }\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  float: right;\n  margin-top: ', ';\n\n  @media screen and (max-width: ', ') {\n    text-align: center;\n    background: ', ';\n    color: ', ';\n    float: inherit;\n    width: 100%;\n  }\n'], ['\n  float: right;\n  margin-top: ', ';\n\n  @media screen and (max-width: ', ') {\n    text-align: center;\n    background: ', ';\n    color: ', ';\n    float: inherit;\n    width: 100%;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactI18next = __webpack_require__(7);
	
	var _bluebird = __webpack_require__(80);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _Constants = __webpack_require__(52);
	
	var _Utils = __webpack_require__(22);
	
	var _Defaults = __webpack_require__(34);
	
	var _Themes = __webpack_require__(5);
	
	var _SearchSource = __webpack_require__(18);
	
	var _UserSource = __webpack_require__(246);
	
	var _AuthActions = __webpack_require__(53);
	
	var _Validations = __webpack_require__(44);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _RangePicker = __webpack_require__(126);
	
	var _RangePicker2 = _interopRequireDefault(_RangePicker);
	
	var _SearchableDropdown = __webpack_require__(64);
	
	var _SearchableDropdown2 = _interopRequireDefault(_SearchableDropdown);
	
	var _Dropdown = __webpack_require__(60);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Trash = __webpack_require__(89);
	
	var _Trash2 = _interopRequireDefault(_Trash);
	
	var _MobileMenu = __webpack_require__(1043);
	
	var _MobileMenu2 = _interopRequireDefault(_MobileMenu);
	
	var _Add = __webpack_require__(130);
	
	var _Add2 = _interopRequireDefault(_Add);
	
	var _SuccessModal = __webpack_require__(37);
	
	var _SuccessModal2 = _interopRequireDefault(_SuccessModal);
	
	var _ErrorModal = __webpack_require__(30);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	var _DialogModal = __webpack_require__(46);
	
	var _DialogModal2 = _interopRequireDefault(_DialogModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var PreferenceContainer = _styledComponents2.default.div(_templateObject2, _Themes.Metrics.borders.default, _Themes.Metrics.margins.base);
	
	var TrashIcon = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.margins.base, _Themes.Metrics.breakpoints.mobile);
	
	var Preference = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject4, _Themes.Fonts.style.Label, _Themes.Fonts.style.Text);
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject5, function (props) {
	  return props.noPadLeft ? 0 : _Themes.Metrics.margins.medium;
	}, function (props) {
	  return props.noPadRight ? 0 : _Themes.Metrics.margins.medium;
	});
	
	var CustomThird = (0, _styledComponents2.default)(_gridStyled.Third)(_templateObject6, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, function (props) {
	  return props.noPadLeft ? 0 : _Themes.Metrics.margins.medium;
	}, function (props) {
	  return props.noPadRight ? 0 : _Themes.Metrics.margins.medium;
	});
	
	var PreferenceTitle = _styledComponents2.default.div(_templateObject7, _Themes.Fonts.style.Label, _Themes.Colors.primary);
	
	var FormTitle = _styledComponents2.default.div(_templateObject8, _Themes.Fonts.style.Label, _Themes.Metrics.margins.base, _Themes.Metrics.margins.small, _Themes.Metrics.breakpoints.mobile, _Themes.Metrics.margins.small);
	var CustomFormTitle = (0, _styledComponents2.default)(FormTitle)(_templateObject9);
	
	var EditArea = _styledComponents2.default.section(_templateObject10, _Themes.Metrics.margins.base, _Themes.Metrics.borders.default, _Themes.Metrics.breakpoints.mobile);
	
	var PreferencesArea = _styledComponents2.default.div(_templateObject);
	
	var CustomButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject11, _Themes.Metrics.margins.base, _Themes.Metrics.breakpoints.mobile, _Themes.Colors.primary, _Themes.Colors.white);
	
	var Preferences = function (_Component) {
	  _inherits(Preferences, _Component);
	
	  function Preferences(props) {
	    _classCallCheck(this, Preferences);
	
	    var _this = _possibleConstructorReturn(this, (Preferences.__proto__ || Object.getPrototypeOf(Preferences)).call(this, props));
	
	    _this.state = {
	      location: [],
	      locationSearch: '',
	      categories: [],
	      modal: null,
	      mobileMenuOpen: false,
	      userPreferences: [],
	      preferenceToDelete: null,
	      preference: _ramda2.default.clone(_Defaults.preferenceDefault),
	      errors: {
	        name: '',
	        category: ''
	      }
	    };
	    _this.handleSearch = _this.handleSearch.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleRange = _this.handleRange.bind(_this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.handleUpdate = _this.handleUpdate.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    _this.selectPreferenceToDelete = _this.selectPreferenceToDelete.bind(_this);
	    _this.toggleModal = _this.toggleModal.bind(_this);
	    _this.toggleMobileMenu = _this.toggleMobileMenu.bind(_this);
	    _this.cancel = _this.cancel.bind(_this);
	    _this.delete = _this.delete.bind(_this);
	    _this.validateForm = _this.validateForm.bind(_this);
	    return _this;
	  }
	
	  _createClass(Preferences, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var user = this.props.user;
	
	      var criteria = {};
	      if (user.preferences.length > 0) {
	        criteria.id = user.preferences.map(function (el) {
	          return el.id;
	        });
	      }
	
	      _bluebird2.default.all([(0, _SearchSource.searchCategories)(), user.preferences.length > 0 ? (0, _UserSource.fetchPreferences)(criteria) : []]).spread(function (categoriesResponse, preferencesResponse) {
	        var data = preferencesResponse.data;
	        _this2.setState({
	          categories: categoriesResponse.data,
	          userPreferences: data && data.results.length > 0 ? data.results : []
	        });
	      }).catch(console.error);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      var user = nextProps.user;
	
	      if (user.preferences.length > 0) {
	        var criteria = {};
	        criteria.id = user.preferences.map(function (el) {
	          return el.id;
	        });
	        (0, _UserSource.fetchPreferences)(criteria).then(function (response) {
	          _this3.setState({ userPreferences: response.data.results });
	        }).catch(console.error);
	      } else {
	        this.setState({ userPreferences: [] });
	      }
	    }
	  }, {
	    key: 'handleSearch',
	    value: function handleSearch(event) {
	      var _this4 = this;
	
	      var search = event.target.value;
	
	      this.setState({ locationSearch: search }, function () {
	        (0, _SearchSource.searchLocations)({ criteria: search }).then(function (res) {
	          var _res$data = res.data;
	          var cities = _res$data.cities;
	          var countries = _res$data.countries;
	          var continents = _res$data.continents;
	
	
	          _this4.setState({
	            location: [].concat(_toConsumableArray(cities.map(function (city) {
	              return Object.assign({}, city, {
	                type: 'city'
	              });
	            })), _toConsumableArray(countries.map(function (country) {
	              return Object.assign({}, country, { type: 'country' });
	            })), _toConsumableArray(continents.map(function (continent) {
	              return Object.assign({}, continent, {
	                type: 'continent'
	              });
	            })))
	          });
	        }).catch(console.error);
	      });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var preference = this.state.preference;
	
	      preference.name = event.target.value;
	      this.setState({ preference: preference });
	    }
	  }, {
	    key: 'handleRange',
	    value: function handleRange(minKey, maxKey, value) {
	      var preference = this.state.preference;
	
	      preference[minKey] = value.min;
	      preference[maxKey] = value.max;
	      this.setState({ preference: preference });
	    }
	  }, {
	    key: 'handleUpdate',
	    value: function handleUpdate() {
	      var _this5 = this;
	
	      if (this.validateForm()) {
	        (0, _UserSource.addPreference)(this.props.user.id, this.state.preference).then(function (response) {
	          (0, _AuthActions.updateToken)(response.data.authToken);
	          _this5.setState({
	            locationSearch: '',
	            modal: 'success',
	            mobileMenuOpen: false,
	            preferenceToDelete: null,
	            preference: _ramda2.default.clone(_Defaults.preferenceDefault)
	          });
	        }).catch(function (error) {
	          console.error(error);
	          _this5.setState({ modal: 'error' });
	        });
	      }
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(key, el) {
	      var _state = this.state;
	      var preference = _state.preference;
	      var errors = _state.errors;
	
	      preference[key] = el;
	      errors[key] = '';
	
	      if (key === 'location') {
	        preference[el.type] = el;
	
	        return this.setState({
	          locationSearch: el.name,
	          preference: preference,
	          errors: errors
	        });
	      }
	
	      this.setState({ preference: preference, errors: errors });
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur(key) {
	      var _state2 = this.state;
	      var errors = _state2.errors;
	      var preference = _state2.preference;
	
	      var newErrors = (0, _Validations.validateInput)(key, preference[key], errors);
	      this.setState({ errors: newErrors });
	    }
	  }, {
	    key: 'toggleModal',
	    value: function toggleModal(modalKey) {
	      this.setState({ modal: this.state.modal ? null : modalKey });
	    }
	  }, {
	    key: 'toggleMobileMenu',
	    value: function toggleMobileMenu() {
	      this.setState({ mobileMenuOpen: !this.state.mobileMenuOpen });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      var _this6 = this;
	
	      var user = this.props.user;
	
	      (0, _UserSource.deleteUserPreference)(this.state.preferenceToDelete, user.id).then(function (response) {
	        (0, _AuthActions.updateToken)(response.data.authToken);
	        _this6.setState({ modal: 'success', preferenceToDelete: null });
	      }).catch(function (error) {
	        console.log(error);
	        _this6.setState({ modal: 'error', preferenceToDelete: null });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.setState({ modal: null, preferenceToDelete: null });
	    }
	  }, {
	    key: 'selectPreferenceToDelete',
	    value: function selectPreferenceToDelete(id) {
	      this.setState({ preferenceToDelete: id, modal: 'delete' });
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm() {
	      var _state3 = this.state;
	      var preference = _state3.preference;
	      var errors = _state3.errors;
	
	      var valid = true;
	      var keys = Object.keys(errors);
	      keys.forEach(function (key) {
	        var returnErros = (0, _Validations.validateInput)(key, preference[key], errors);
	        errors = Object.assign({}, errors, returnErros);
	        valid = valid && errors[key] === '';
	      });
	      this.setState({ errors: errors });
	      return valid;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var t = this.props.t;
	      var _state4 = this.state;
	      var location = _state4.location;
	      var locationSearch = _state4.locationSearch;
	      var categories = _state4.categories;
	      var preference = _state4.preference;
	      var userPreferences = _state4.userPreferences;
	      var modal = _state4.modal;
	      var errors = _state4.errors;
	
	      var list = userPreferences.length > 0 && userPreferences.map(function (pref, index) {
	        return _react2.default.createElement(
	          PreferenceContainer,
	          { key: 'preference-' + index },
	          _react2.default.createElement(
	            TrashIcon,
	            null,
	            _react2.default.createElement(_Trash2.default, { onClick: function onClick() {
	                return _this7.selectPreferenceToDelete(pref.id);
	              } })
	          ),
	          _react2.default.createElement(
	            CustomGrid,
	            null,
	            _react2.default.createElement(
	              PreferenceTitle,
	              null,
	              pref.name
	            )
	          ),
	          _react2.default.createElement(
	            CustomGrid,
	            null,
	            _react2.default.createElement(
	              Preference,
	              { sm: 1 / 6 },
	              _react2.default.createElement(
	                FormTitle,
	                null,
	                t('Type of Asset')
	              ),
	              _react2.default.createElement(
	                'span',
	                { key: 'key-category-' + index },
	                pref.category && pref.category.name
	              )
	            ),
	            _react2.default.createElement(
	              Preference,
	              { sm: 1 / 6 },
	              pref.city && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  FormTitle,
	                  null,
	                  t('City')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { key: 'key-city-' + index },
	                  '' + pref.city.name
	                )
	              ),
	              pref.country && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  FormTitle,
	                  null,
	                  t('Country')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { key: 'key-country-' + index },
	                  pref.country.name
	                )
	              ),
	              pref.continent && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  FormTitle,
	                  null,
	                  t('Continent')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { key: 'key-continent-' + index },
	                  pref.continent.name
	                )
	              )
	            ),
	            _react2.default.createElement(
	              Preference,
	              { sm: 1 / 6 },
	              _react2.default.createElement(
	                FormTitle,
	                null,
	                t('Number of Keys')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                pref.minNoRooms,
	                ' -',
	                ' ',
	                pref.maxNoRooms ? '' + pref.maxNoRooms : _Constants.maxRooms + '+'
	              )
	            ),
	            _react2.default.createElement(
	              Preference,
	              { sm: 1 / 6 },
	              _react2.default.createElement(
	                FormTitle,
	                null,
	                t('Estimated Yield')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                pref.minYield,
	                '% -',
	                ' ',
	                pref.maxYield ? pref.maxYield + '%' : _Constants.maxYield + '%+'
	              )
	            ),
	            _react2.default.createElement(
	              Preference,
	              { sm: 1 / 6 },
	              _react2.default.createElement(
	                FormTitle,
	                null,
	                t('Price')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                '\u20AC',
	                (0, _Utils.numberWithCommas)(pref.minPrice),
	                ' -',
	                ' ',
	                pref.maxPrice ? '\u20AC' + (0, _Utils.numberWithCommas)(pref.maxPrice) : '\u20AC' + (0, _Utils.numberWithCommas)(_Constants.maxPrice) + '+'
	              )
	            ),
	            _react2.default.createElement(
	              Preference,
	              { sm: 1 / 6 },
	              _react2.default.createElement(
	                FormTitle,
	                null,
	                t('Area')
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                (0, _Utils.numberWithCommas)(pref.minArea),
	                'm2 -',
	                ' ',
	                pref.maxArea ? (0, _Utils.numberWithCommas)(pref.maxArea) + 'm2' : (0, _Utils.numberWithCommas)(_Constants.maxArea) + 'm2+'
	              )
	            )
	          )
	        );
	      });
	
	      return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(
	          _MobileMenu2.default,
	          {
	            label: t('Add Search Request'),
	            apply: _react2.default.createElement(_Button2.default, {
	              onClick: this.handleUpdate,
	              label: t('Add'),
	              primary: true,
	              fullWidth: true
	            }),
	            toggleMenu: this.toggleMobileMenu,
	            open: this.state.mobileMenuOpen,
	            icon: _react2.default.createElement(_Add2.default, null) },
	          _react2.default.createElement(_Input2.default, {
	            required: true,
	            title: _react2.default.createElement(
	              CustomFormTitle,
	              null,
	              t('Name')
	            ),
	            handleChange: this.handleChange,
	            name: 'name',
	            placeholder: t('Name this search request'),
	            value: preference.name,
	            handleBlur: function handleBlur() {
	              return _this7.handleBlur('name');
	            },
	            error: errors['name']
	          }),
	          _react2.default.createElement(
	            FormTitle,
	            null,
	            t('Property Type')
	          ),
	          _react2.default.createElement(_Dropdown2.default, {
	            accessor: function accessor(el) {
	              return el.name;
	            },
	            handleSelect: function handleSelect(el) {
	              return _this7.handleSelect('category', el);
	            },
	            placeholder: t('Choose your favourite categories'),
	            options: categories,
	            selectedOption: preference.category,
	            required: true,
	            name: 'category',
	            handleBlur: function handleBlur() {
	              return _this7.handleBlur('category');
	            },
	            error: errors['category']
	          }),
	          _react2.default.createElement(
	            FormTitle,
	            null,
	            t('Location')
	          ),
	          _react2.default.createElement(_SearchableDropdown2.default, {
	            required: true,
	            value: locationSearch,
	            placeholder: t('Choose location'),
	            options: location,
	            handleSearch: this.handleSearch,
	            handleSelect: function handleSelect(el) {
	              return _this7.handleSelect('location', el);
	            },
	            accessor: function accessor(location) {
	              return location.name;
	            },
	            name: 'location',
	            handleBlur: function handleBlur() {
	              return _this7.handleBlur('location');
	            },
	            error: errors['location']
	          }),
	          _react2.default.createElement(_RangePicker2.default, {
	            title: _react2.default.createElement(
	              FormTitle,
	              null,
	              t('Number of Keys')
	            ),
	            max: _Constants.maxRooms,
	            step: _Constants.defaultRoomsStep,
	            minValue: preference.minNoRooms,
	            maxValue: preference.maxNoRooms,
	            handleChange: function handleChange(value) {
	              return _this7.handleRange('minNoRooms', 'maxNoRooms', value);
	            }
	          }),
	          _react2.default.createElement(_RangePicker2.default, {
	            title: _react2.default.createElement(
	              FormTitle,
	              null,
	              t('Estimated Yield')
	            ),
	            minValue: preference.minYield,
	            maxValue: preference.maxYield,
	            unit: '%',
	            rightUnit: true,
	            max: _Constants.maxYield,
	            step: _Constants.defaultYieldStep,
	            handleChange: function handleChange(value) {
	              return _this7.handleRange('minYield', 'maxYield', value);
	            }
	          }),
	          _react2.default.createElement(_RangePicker2.default, {
	            title: _react2.default.createElement(
	              FormTitle,
	              null,
	              t('Price')
	            ),
	            minValue: preference.minPrice,
	            maxValue: preference.maxPrice,
	            unit: '€',
	            handleChange: function handleChange(value) {
	              return _this7.handleRange('minPrice', 'maxPrice', value);
	            },
	            max: _Constants.maxPrice,
	            step: _Constants.defaultPriceStep
	          }),
	          _react2.default.createElement(_RangePicker2.default, {
	            title: _react2.default.createElement(
	              FormTitle,
	              null,
	              t('Area')
	            ),
	            minValue: preference.minArea,
	            maxValue: preference.maxArea,
	            handleChange: function handleChange(value) {
	              return _this7.handleRange('minArea', 'maxArea', value);
	            },
	            max: _Constants.maxArea,
	            unit: 'm2',
	            rightUnit: true,
	            step: _Constants.defaultAreaStep
	          })
	        ),
	        _react2.default.createElement(
	          EditArea,
	          null,
	          _react2.default.createElement(
	            CustomThird,
	            { noPadLeft: true },
	            _react2.default.createElement(_Input2.default, {
	              required: true,
	              title: t('Name'),
	              handleChange: this.handleChange,
	              placeholder: t('Name this preference'),
	              value: preference.name,
	              handleBlur: function handleBlur() {
	                return _this7.handleBlur('name');
	              },
	              error: errors['name']
	            })
	          ),
	          _react2.default.createElement(
	            CustomThird,
	            { noPadTop: true },
	            _react2.default.createElement(
	              FormTitle,
	              null,
	              t('Type of Asset')
	            ),
	            _react2.default.createElement(_Dropdown2.default, {
	              required: true,
	              accessor: function accessor(el) {
	                return el.name;
	              },
	              handleSelect: function handleSelect(el) {
	                return _this7.handleSelect('category', el);
	              },
	              placeholder: t('Choose your favourite categories'),
	              options: categories,
	              selectedOption: preference.category,
	              name: 'category',
	              handleBlur: function handleBlur() {
	                return _this7.handleBlur('category');
	              },
	              error: errors['category']
	            })
	          ),
	          _react2.default.createElement(
	            CustomThird,
	            { noPadTop: true, noPadRight: true },
	            _react2.default.createElement(
	              FormTitle,
	              null,
	              t('Location')
	            ),
	            _react2.default.createElement(_SearchableDropdown2.default, {
	              required: true,
	              value: locationSearch,
	              placeholder: t('Choose location'),
	              options: location,
	              handleSearch: this.handleSearch,
	              handleSelect: function handleSelect(el) {
	                return _this7.handleSelect('location', el);
	              },
	              accessor: function accessor(location) {
	                return location.name;
	              },
	              name: 'location',
	              handleBlur: function handleBlur() {
	                return _this7.handleBlur('location');
	              },
	              error: errors['location']
	            })
	          ),
	          _react2.default.createElement(
	            CustomGrid,
	            { noPadLeft: true, sm: 1 / 4 },
	            _react2.default.createElement(_RangePicker2.default, {
	              title: _react2.default.createElement(
	                FormTitle,
	                null,
	                t('Number of Keys')
	              ),
	              minValue: preference.minNoRooms,
	              maxValue: preference.maxNoRooms,
	              max: _Constants.maxRooms,
	              step: _Constants.defaultRoomsStep,
	              handleChange: function handleChange(value) {
	                return _this7.handleRange('minNoRooms', 'maxNoRooms', value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            CustomGrid,
	            { sm: 1 / 4 },
	            _react2.default.createElement(_RangePicker2.default, {
	              title: _react2.default.createElement(
	                FormTitle,
	                null,
	                t('Estimated Yield')
	              ),
	              minValue: preference.minYield,
	              maxValue: preference.maxYield,
	              max: _Constants.maxYield,
	              step: _Constants.defaultYieldStep,
	              unit: '%',
	              rightUnit: true,
	              handleChange: function handleChange(value) {
	                return _this7.handleRange('minYield', 'maxYield', value);
	              }
	            })
	          ),
	          _react2.default.createElement(
	            CustomGrid,
	            { sm: 1 / 4 },
	            _react2.default.createElement(_RangePicker2.default, {
	              title: _react2.default.createElement(
	                FormTitle,
	                null,
	                t('Price')
	              ),
	              minValue: preference.minPrice,
	              maxValue: preference.maxPrice,
	              unit: '€',
	              handleChange: function handleChange(value) {
	                return _this7.handleRange('minPrice', 'maxPrice', value);
	              },
	              max: _Constants.maxPrice,
	              step: _Constants.defaultPriceStep
	            })
	          ),
	          _react2.default.createElement(
	            CustomGrid,
	            { noPadRight: true, sm: 1 / 4 },
	            _react2.default.createElement(_RangePicker2.default, {
	              title: _react2.default.createElement(
	                FormTitle,
	                null,
	                t('Area')
	              ),
	              minValue: preference.minArea,
	              maxValue: preference.maxArea,
	              handleChange: function handleChange(value) {
	                return _this7.handleRange('minArea', 'maxArea', value);
	              },
	              max: _Constants.maxArea,
	              unit: 'm2',
	              rightUnit: true,
	              step: _Constants.defaultAreaStep
	            })
	          ),
	          _react2.default.createElement(
	            CustomGrid,
	            { noPadRight: true, noPadLeft: true },
	            _react2.default.createElement(CustomButton, { label: t('Add'), onClick: this.handleUpdate })
	          )
	        ),
	        _react2.default.createElement(
	          PreferencesArea,
	          null,
	          _react2.default.createElement(_SuccessModal2.default, {
	            message: t('Your preferences were successfuly updated'),
	            closeAction: function closeAction() {
	              return _this7.toggleModal('success');
	            },
	            header: t('Success'),
	            visible: modal === 'success'
	          }),
	          _react2.default.createElement(_ErrorModal2.default, {
	            message: t('There was an error when updating your preferences'),
	            closeAction: function closeAction() {
	              return _this7.toggleModal('error');
	            },
	            header: t('Error'),
	            visible: modal === 'error'
	          }),
	          _react2.default.createElement(_DialogModal2.default, {
	            message: t('Do you really want to remove this preference?'),
	            closeAction: function closeAction() {
	              return _this7.toggleModal('delete');
	            },
	            header: t('Remove Preference'),
	            visible: modal === 'delete',
	            buttons: {
	              apply: {
	                label: t('Delete'),
	                onClick: this.delete
	              },
	              cancel: {
	                label: t('Cancel'),
	                onClick: this.cancel
	              }
	            }
	          }),
	          list
	        )
	      );
	    }
	  }]);
	
	  return Preferences;
	}(_react.Component);
	
	Preferences.propTypes = {
	  user: _react.PropTypes.object.isRequired,
	  t: _react.PropTypes.func
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'settings', 'forms'], { wait: true })(Preferences);

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  height: calc(\n    100vh - (', ' + ', ')\n  );\n  position: relative;\n'], ['\n  margin-top: ', ';\n  height: calc(\n    100vh - (', ' + ', ')\n  );\n  position: relative;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  float: right;\n  margin-top: ', ';\n\n  @media screen and (max-width: ', ') {\n    text-align: center;\n    margin-top: 0;\n    position: absolute;\n    bottom: ', ';\n    background: ', ';\n    color: ', ';\n    float: inherit;\n    width: 100%;\n  }\n'], ['\n  float: right;\n  margin-top: ', ';\n\n  @media screen and (max-width: ', ') {\n    text-align: center;\n    margin-top: 0;\n    position: absolute;\n    bottom: ', ';\n    background: ', ';\n    color: ', ';\n    float: inherit;\n    width: 100%;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  padding-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', '){\n    padding-left: 0;\n    padding-right: 0;\n  }\n'], ['\n  padding-top: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n\n  @media screen and (max-width: ', '){\n    padding-left: 0;\n    padding-right: 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _AuthSources = __webpack_require__(75);
	
	var _AuthActions = __webpack_require__(53);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _Input = __webpack_require__(13);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _Themes = __webpack_require__(5);
	
	var _SuccessModal = __webpack_require__(37);
	
	var _SuccessModal2 = _interopRequireDefault(_SuccessModal);
	
	var _ErrorModal = __webpack_require__(30);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject, _Themes.Metrics.margins.larger, _Themes.Metrics.components.navbarDefault, _Themes.Metrics.margins.big);
	
	var CustomButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject2, _Themes.Metrics.margins.larger, _Themes.Metrics.breakpoints.mobile, _Themes.Metrics.margins.base, _Themes.Colors.primary, _Themes.Colors.whiteThree);
	
	var CustomHalf = (0, _styledComponents2.default)(_gridStyled.Half)(_templateObject3, function (props) {
	  return props.noPadTop ? 0 : _Themes.Metrics.margins.base;
	}, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.breakpoints.mobile);
	
	var CustomGrid = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject3, _Themes.Metrics.margins.base, _Themes.Metrics.margins.medium, _Themes.Metrics.margins.medium, _Themes.Metrics.breakpoints.mobile);
	
	var Security = function (_Component) {
	  _inherits(Security, _Component);
	
	  function Security(props) {
	    _classCallCheck(this, Security);
	
	    var _this = _possibleConstructorReturn(this, (Security.__proto__ || Object.getPrototypeOf(Security)).call(this, props));
	
	    _this.state = {
	      user: _this.props.user,
	      currentPassword: '',
	      newPassword: '',
	      confirmNewPassword: '',
	      modal: false,
	      validInput: false
	    };
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(Security, [{
	    key: 'handleChange',
	    value: function handleChange(_ref) {
	      var _setState;
	
	      var key = _ref.key;
	      var evt = _ref.evt;
	
	      var validInput = this.state.newPassword.length > 0 && this.state.confirmNewPassword.length > 0 && this.state.currentPassword === this.state.confirmNewPassword && this.state.currentPassword.length > 0;
	      this.setState((_setState = {}, _defineProperty(_setState, key, evt.target.value), _defineProperty(_setState, 'validInput', validInput), _setState));
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var _this2 = this;
	
	      (0, _AuthSources.updatePassword)(this.state.currentPassword, this.state.newPassword).then(function (response) {
	        _this2.setState({
	          modal: 'success',
	          currentPassword: '',
	          newPassword: '',
	          confirmNewPassword: ''
	        }, function () {
	          return _AuthActions2.default.updateToken(response.data.authToken);
	        });
	      }).catch(function (error) {
	        console.log(error);
	        _this2.setState({
	          modal: 'error',
	          currentPassword: '',
	          newPassword: '',
	          confirmNewPassword: ''
	        });
	      });
	    }
	  }, {
	    key: 'handleClose',
	    value: function handleClose() {
	      this.setState({ modal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var t = this.props.t;
	      var modal = this.state.modal;
	
	      return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(_SuccessModal2.default, {
	          visible: modal === 'success',
	          closeAction: this.handleClose,
	          header: t('Password Updated'),
	          message: t('Your password was successfully updated')
	        }),
	        _react2.default.createElement(_ErrorModal2.default, {
	          visible: modal === 'error',
	          closeAction: this.handleClose,
	          header: t('Error'),
	          message: t('There was an error when updating your password')
	        }),
	        _react2.default.createElement(
	          CustomHalf,
	          { noPadTop: true },
	          _react2.default.createElement(_Input2.default, {
	            placeholder: t('Insert Old Password'),
	            type: 'password',
	            title: t('Old Password'),
	            handleChange: function handleChange(event) {
	              return _this3.handleChange({ key: 'currentPassword', evt: event });
	            },
	            value: this.state.currentPassword
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            CustomHalf,
	            null,
	            _react2.default.createElement(_Input2.default, {
	              type: 'password',
	              placeholder: t('Insert new Password'),
	              title: t('New Password'),
	              handleChange: function handleChange(event) {
	                return _this3.handleChange({ key: 'newPassword', evt: event });
	              },
	              value: this.state.newPassword
	            })
	          ),
	          _react2.default.createElement(
	            CustomHalf,
	            null,
	            _react2.default.createElement(_Input2.default, {
	              type: 'password',
	              placeholder: t('Confirm Old Password'),
	              title: t('Confirm New Password'),
	              handleChange: function handleChange(event) {
	                return _this3.handleChange({ key: 'confirmNewPassword', evt: event });
	              },
	              value: this.state.confirmNewPassword
	            })
	          )
	        ),
	        _react2.default.createElement(
	          CustomGrid,
	          null,
	          _react2.default.createElement(CustomButton, { label: t('Save'), onClick: this.handleSubmit })
	        )
	      );
	    }
	  }]);
	
	  return Security;
	}(_react.Component);
	
	Security.propTypes = {
	  user: _react.PropTypes.object,
	  t: _react.PropTypes.func
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'settings'], { wait: true })(Security);

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  max-height: calc(100vh - ', ');\n  overflow-y: scroll;\n'], ['\n  max-height: calc(100vh - ', ');\n  overflow-y: scroll;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _Themes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject, _Themes.Metrics.components.navbarDefault);
	
	var ProfileSettings = function (_Component) {
	  _inherits(ProfileSettings, _Component);
	
	  function ProfileSettings(props) {
	    _classCallCheck(this, ProfileSettings);
	
	    var _this = _possibleConstructorReturn(this, (ProfileSettings.__proto__ || Object.getPrototypeOf(ProfileSettings)).call(this, props));
	
	    _this.state = {
	      user: _this.props.user
	    };
	    return _this;
	  }
	
	  _createClass(ProfileSettings, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var user = _props.user;
	
	      return _react2.default.createElement(
	        CustomThemeContainer,
	        null,
	        children && _react2.default.cloneElement(children, {
	          user: user,
	          handleUpdate: this.handleUpdate
	        })
	      );
	    }
	  }]);
	
	  return ProfileSettings;
	}(_react.Component);
	
	ProfileSettings.propTypes = {
	  user: _react.PropTypes.object,
	  children: _react.PropTypes.node
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'settings'], { wait: true })(ProfileSettings);

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 450px;\n  padding-top: 10px;\n  margin-left: ', ';\n\n  @media screen and (max-width: ', ') {\n    width: calc(', ' - 40px);\n    padding-top: 0;\n    margin-left: ', ';\n  }\n'], ['\n  width: 450px;\n  padding-top: 10px;\n  margin-left: ', ';\n\n  @media screen and (max-width: ', ') {\n    width: calc(', ' - 40px);\n    padding-top: 0;\n    margin-left: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: 50px;\n  height: 50px;\n'], ['\n  width: 50px;\n  height: 50px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactI18next = __webpack_require__(7);
	
	var _SearchSource = __webpack_require__(18);
	
	var _AuthActions = __webpack_require__(53);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _Themes = __webpack_require__(5);
	
	var _Navbar = __webpack_require__(1044);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _SearchableDropdown = __webpack_require__(64);
	
	var _SearchableDropdown2 = _interopRequireDefault(_SearchableDropdown);
	
	var _Pangea = __webpack_require__(131);
	
	var _Pangea2 = _interopRequireDefault(_Pangea);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _DropdownLinkContainer = __webpack_require__(515);
	
	var _DropdownLinkContainer2 = _interopRequireDefault(_DropdownLinkContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var SearchContainer = _styledComponents2.default.div(_templateObject, _Themes.Metrics.margins.larger, _Themes.Metrics.breakpoints.mobile, _Themes.Metrics.components.mobileMenu, _Themes.Metrics.margins.base);
	
	var CustomLogo = (0, _styledComponents2.default)(_Pangea2.default)(_templateObject2);
	
	var NavbarWrapper = function (_Component) {
	  _inherits(NavbarWrapper, _Component);
	
	  function NavbarWrapper(props) {
	    _classCallCheck(this, NavbarWrapper);
	
	    var _this = _possibleConstructorReturn(this, (NavbarWrapper.__proto__ || Object.getPrototypeOf(NavbarWrapper)).call(this, props));
	
	    _this.state = {
	      activeDropdown: null,
	      size: window.screen.availWidth,
	      properties: [],
	      search: '',
	      mobileMenu: false
	    };
	
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    _this.handleSearch = _this.handleSearch.bind(_this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.toggleMobileMenu = _this.toggleMobileMenu.bind(_this);
	    _this.selectDropdown = _this.selectDropdown.bind(_this);
	    _this.selectRoute = _this.selectRoute.bind(_this);
	    return _this;
	  }
	
	  _createClass(NavbarWrapper, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      window.addEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.setState({ activeDropdown: null });
	      }, 200);
	    }
	  }, {
	    key: 'handleSearch',
	    value: function handleSearch(event) {
	      var _this3 = this;
	
	      var value = event.target.value;
	      this.setState({ search: value }, function () {
	        var query = {
	          or: [{ title: { startsWith: value } }, { description: { startsWith: value } }],
	          published: true,
	          sold: false
	        };
	
	        (0, _SearchSource.searchProperties)(query).then(function (response) {
	          return _this3.setState({ properties: response.data });
	        }).catch(console.error);
	      });
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(property) {
	      var router = this.props.router;
	
	      this.setState({ mobileMenu: false, search: '' }, function () {
	        return router.replace('/property/' + property.id);
	      });
	    }
	  }, {
	    key: 'selectRoute',
	    value: function selectRoute(route) {
	      var router = this.props.router;
	
	      this.setState({ mobileMenu: false, activeDropdown: null }, function () {
	        return router.replace(route);
	      });
	    }
	  }, {
	    key: 'toggleMobileMenu',
	    value: function toggleMobileMenu() {
	      this.setState({ mobileMenu: !this.state.mobileMenu });
	    }
	  }, {
	    key: 'selectDropdown',
	    value: function selectDropdown(el) {
	      this.setState({
	        activeDropdown: this.state.activeDropdown === el ? null : el
	      });
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      this.setState({ size: window.screen.availWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props;
	      var router = _props.router;
	      var user = _props.user;
	      var t = _props.t;
	      var _state = this.state;
	      var search = _state.search;
	      var properties = _state.properties;
	      var mobileMenu = _state.mobileMenu;
	      var activeDropdown = _state.activeDropdown;
	
	
	      var links = this.state.size < 768 ? [{
	        label: t('Search'),
	        to: '/search',
	        sublinks: [{
	          label: t('Continent'),
	          onClick: function onClick() {
	            return _this4.selectRoute('/search/region');
	          }
	        }, {
	          label: t('List'),
	          onClick: function onClick() {
	            return _this4.selectRoute('/search/properties');
	          }
	        }, {
	          label: t('Map'),
	          onClick: function onClick() {
	            return _this4.selectRoute('/search/map');
	          }
	        }]
	      }, {
	        label: t('Favorite'),
	        onClick: function onClick() {
	          return _this4.selectRoute('/favorite');
	        },
	        sublinks: [{
	          label: t('Cards'),
	          onClick: function onClick() {
	            return _this4.selectRoute('/favorite/properties');
	          }
	        }, {
	          label: t('List'),
	          onClick: function onClick() {
	            return _this4.selectRoute('/favorite/list');
	          }
	        }, {
	          label: t('Map'),
	          onClick: function onClick() {
	            return _this4.selectRoute('/favorite/map');
	          }
	        }]
	      }, {
	        label: t('Search Request'),
	        onClick: function onClick() {
	          return _this4.selectRoute('/profile/preferences');
	        }
	      }, {
	        label: t('Profile Info'),
	        onClick: function onClick() {
	          return _this4.selectRoute('/profile/profile_info');
	        }
	      }, {
	        label: t('Change Password'),
	        onClick: function onClick() {
	          return _this4.selectRoute('/profile/security');
	        }
	      }] : [{
	        label: t('Search'),
	        onClick: function onClick() {
	          return _this4.selectRoute('/search');
	        },
	        sublinks: [{
	          label: t('Continent'),
	          onClick: function onClick() {
	            return _this4.selectRoute('/search/region');
	          },
	          id: 'region'
	        }, {
	          label: t('List'),
	          onClick: function onClick() {
	            return _this4.selectRoute('/search/properties');
	          },
	          id: 'properties'
	        }, {
	          label: t('Map'),
	          onClick: function onClick() {
	            return _this4.selectRoute('/search/map');
	          },
	          id: 'map'
	        }]
	      }, {
	        label: t('Favorite'),
	        onClick: function onClick() {
	          return _this4.selectRoute('/favorite');
	        },
	        sublinks: [{
	          label: t('Cards'),
	          onClick: function onClick() {
	            return _this4.selectRoute('/favorite/properties');
	          },
	          id: 'properties'
	        }, {
	          label: t('List'),
	          onClick: function onClick() {
	            return _this4.selectRoute('/favorite/list');
	          },
	          id: 'list'
	        }, {
	          label: t('Map'),
	          onClick: function onClick() {
	            return _this4.selectRoute('/favorite/map');
	          },
	          id: 'map'
	        }]
	      }, {
	        label: t('Search Request'),
	        onClick: function onClick() {
	          return _this4.selectRoute('/profile/preferences');
	        },
	        id: 'preferences'
	      }];
	
	      var profileLinks = [{
	        label: t('Profile Info'),
	        onClick: function onClick() {
	          return _this4.selectRoute('/profile/profile_info');
	        },
	        id: 'profile_info'
	      }, {
	        label: t('Change Password'),
	        onClick: function onClick() {
	          return _this4.selectRoute('/profile/security');
	        },
	        id: 'security'
	      }, { label: t('Logout'), onClick: function onClick() {
	          return _AuthActions2.default.logout();
	        } }];
	
	      return _react2.default.createElement(_Navbar2.default, {
	        middle: _react2.default.createElement(
	          SearchContainer,
	          null,
	          _react2.default.createElement(_SearchableDropdown2.default, {
	            placeholder: t('Search properties'),
	            value: search,
	            options: properties,
	            handleSearch: this.handleSearch,
	            handleSelect: this.handleSelect,
	            accessor: function accessor(d) {
	              return d.title;
	            }
	          })
	        ),
	        left: _react2.default.createElement(CustomLogo, {
	          onClick: function onClick() {
	            router.push('/');
	          }
	        }),
	        right: _react2.default.createElement(_DropdownLinkContainer2.default, {
	          avatar: _react2.default.createElement(_Avatar2.default, {
	            imageSrc: user.picture,
	            size: 38,
	            onClick: function onClick() {
	              return _this4.selectDropdown('user-dropdown');
	            },
	            className: 'avatar'
	          }),
	          open: activeDropdown === 'user-dropdown',
	          sublinks: profileLinks
	        }),
	        links: links,
	        logout: _AuthActions2.default.logout,
	        toggleMobileMenu: this.toggleMobileMenu,
	        mobileMenuOpen: mobileMenu,
	        handleBlur: this.handleBlur,
	        activeDropdown: activeDropdown,
	        selectDropdown: this.selectDropdown,
	        selectRoute: this.selectRoute
	      });
	    }
	  }]);
	
	  return NavbarWrapper;
	}(_react.Component);
	
	NavbarWrapper.propTypes = {
	  t: _react.PropTypes.func,
	  user: _react.PropTypes.object,
	  router: _react.PropTypes.object
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'forms', 'search'], { wait: true })(NavbarWrapper);

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  height: calc(100vh - ', ');\n  margin-top: -', ';\n  overflow: hidden;\n'], ['\n  height: calc(100vh - ', ');\n  margin-top: -', ';\n  overflow: hidden;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['height: 100vh;'], ['height: 100vh;']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _AuthStore = __webpack_require__(129);
	
	var _AuthStore2 = _interopRequireDefault(_AuthStore);
	
	var _Themes = __webpack_require__(5);
	
	var _NavbarWrapper = __webpack_require__(1100);
	
	var _NavbarWrapper2 = _interopRequireDefault(_NavbarWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Page = _styledComponents2.default.div(_templateObject, _Themes.Metrics.components.navbarDefault, _Themes.Metrics.margins.tiny);
	
	var Container = _styledComponents2.default.section(_templateObject2);
	
	var Public = function (_Component) {
	  _inherits(Public, _Component);
	
	  function Public() {
	    _classCallCheck(this, Public);
	
	    return _possibleConstructorReturn(this, (Public.__proto__ || Object.getPrototypeOf(Public)).apply(this, arguments));
	  }
	
	  _createClass(Public, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return _AuthStore2.default.getState();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps, nextState) {
	      if (this.props.user && !nextProps.user) {
	        this.props.router.replace('/landing');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var router = _props.router;
	      var user = _props.user;
	
	      return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(_NavbarWrapper2.default, { user: user, router: router }),
	        _react2.default.createElement(
	          Page,
	          null,
	          children && _react2.default.cloneElement(children, {
	            user: user
	          })
	        )
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_AuthStore2.default];
	    }
	  }, {
	    key: 'getPropsFromStores',
	    value: function getPropsFromStores() {
	      var authState = _AuthStore2.default.getState();
	      return {
	        user: authState.user,
	        fetching: authState.fetching,
	        hvbToken: authState.hvbToken,
	        errorMessage: authState.errorMessage
	      };
	    }
	  }]);
	
	  return Public;
	}(_react.Component);
	
	Public.propTypes = {
	  children: _react.PropTypes.node,
	  user: _react.PropTypes.object,
	  router: _react.PropTypes.object
	};
	
	exports.default = Public;

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  height: calc(100vh - (', ' + ', '))\n  margin-top: calc(', ' - 1px);\n  width: 100vw;\n  overflow: hidden;\n  position: relative;\n\n  @media screen and (max-width: ', ') {\n    height: calc(100vh - (', ' + ', '));\n    margin-top: 0;\n  }\n'], ['\n  height: calc(100vh - (', ' + ', '))\n  margin-top: calc(', ' - 1px);\n  width: 100vw;\n  overflow: hidden;\n  position: relative;\n\n  @media screen and (max-width: ', ') {\n    height: calc(100vh - (', ' + ', '));\n    margin-top: 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SearchSource = __webpack_require__(18);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Map = __webpack_require__(244);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _Themes = __webpack_require__(5);
	
	var _immutable = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.section(_templateObject, _Themes.Metrics.components.navbarDefault, _Themes.Metrics.components.searchbar, _Themes.Metrics.components.searchbar, _Themes.Metrics.breakpoints.tablet, _Themes.Metrics.components.navbarDefault, _Themes.Metrics.components.mobileSearchBarSize);
	
	var MapSearch = function (_Component) {
	  _inherits(MapSearch, _Component);
	
	  function MapSearch(props) {
	    _classCallCheck(this, MapSearch);
	
	    var _this = _possibleConstructorReturn(this, (MapSearch.__proto__ || Object.getPrototypeOf(MapSearch)).call(this, props));
	
	    _this.state = {
	      properties: [],
	      isFetching: false
	    };
	    _this.searchProperties = _this.searchProperties.bind(_this);
	    return _this;
	  }
	
	  _createClass(MapSearch, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.searchProperties(this.props.settings);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _immutable.fromJS)(this.props.settings).equals((0, _immutable.fromJS)(nextProps.settings))) {
	        this.searchProperties(nextProps.settings);
	      }
	    }
	  }, {
	    key: 'searchProperties',
	    value: function searchProperties(settings) {
	      var _this2 = this;
	
	      var query = Object.assign({}, settings, { published: true, sold: false });
	      this.setState({ isFetching: true }, function () {
	        (0, _SearchSource.findProperties)({ settings: query, skip: -1, limit: -1 }).then(function (response) {
	          _this2.setState({
	            properties: response.data.results,
	            isFetching: false
	          });
	        }).catch(function (error) {
	          console.log(error);
	        });
	      });
	    }
	  }, {
	    key: 'propertyDetail',
	    value: function propertyDetail(id) {
	      this.props.router.push('/property/' + id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var propertyDetails = this.props.propertyDetails;
	
	      var propList = this.state.properties.length > 0 && this.state.properties || [];
	
	      return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(_Map2.default, {
	          initialCenter: {
	            lat: 0,
	            lng: 0
	          },
	          places: propList,
	          handleSelect: propertyDetails
	        })
	      );
	    }
	  }]);
	
	  return MapSearch;
	}(_react.Component);
	
	MapSearch.propTypes = {
	  user: _react.PropTypes.object,
	  propertyDetails: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  settings: _react.PropTypes.object
	};
	
	exports.default = MapSearch;

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  height: calc(\n    100vh - (', ' +\n          ', ')\n  );\n  margin-top: calc(', ' - 1px);\n  button {\n    margin-top: ', ';\n  }\n  position: relative;\n\n  @media screen and (max-width: ', ') {\n    margin-top: 0;\n  }\n'], ['\n  height: calc(\n    100vh - (', ' +\n          ', ')\n  );\n  margin-top: calc(', ' - 1px);\n  button {\n    margin-top: ', ';\n  }\n  position: relative;\n\n  @media screen and (max-width: ', ') {\n    margin-top: 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _Table = __webpack_require__(172);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Utils = __webpack_require__(22);
	
	var _SearchSource = __webpack_require__(18);
	
	var _Themes = __webpack_require__(5);
	
	var _Key = __webpack_require__(176);
	
	var _Key2 = _interopRequireDefault(_Key);
	
	var _Constants = __webpack_require__(52);
	
	var _immutable = __webpack_require__(29);
	
	var _Defaults = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.section(_templateObject, _Themes.Metrics.components.navbarDefault, _Themes.Metrics.components.searchbar, _Themes.Metrics.components.searchbar, _Themes.Metrics.margins.base, _Themes.Metrics.breakpoints.tablet);
	
	var PropertiesList = function (_Component) {
	  _inherits(PropertiesList, _Component);
	
	  function PropertiesList(props) {
	    _classCallCheck(this, PropertiesList);
	
	    var _this = _possibleConstructorReturn(this, (PropertiesList.__proto__ || Object.getPrototypeOf(PropertiesList)).call(this, props));
	
	    _this.state = {
	      properties: [],
	      counter: 0,
	      isFetching: false,
	      canLoadMore: true,
	      keys: _ramda2.default.prepend({
	        title: 'Favorite',
	        key: 'favorite',
	        accessor: function accessor(d) {
	          return (0, _Utils.isUserFavorite)(_this.props.user, d) ? _react2.default.createElement(_Key2.default, null) : _react2.default.createElement(_Key2.default, { className: 'notFavorite' });
	        },
	        sortAccessor: function sortAccessor(d) {
	          return (0, _Utils.isUserFavorite)(_this.props.user, d);
	        },
	        width: 80,
	        sort: null
	      }, _ramda2.default.clone(_Defaults.tableKeysDefault))
	    };
	    _this.searchProperties = _this.searchProperties.bind(_this);
	    _this.propertyDetail = _this.propertyDetail.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    _this.handleSort = _this.handleSort.bind(_this);
	    _this.loadMoreProperties = _this.loadMoreProperties.bind(_this);
	    return _this;
	  }
	
	  _createClass(PropertiesList, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _immutable.fromJS)(this.props.settings).equals((0, _immutable.fromJS)(nextProps.settings))) {
	        this.searchProperties(nextProps.settings);
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.searchProperties(this.props.settings);
	      window.addEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      this.forceUpdate();
	    }
	  }, {
	    key: 'searchProperties',
	    value: function searchProperties(settings) {
	      var _this2 = this;
	
	      this.setState({ isFetching: true }, function () {
	        var query = Object.assign({}, settings, { published: true, sold: false });
	        (0, _SearchSource.findProperties)({ settings: query, skip: 0, limit: _Constants.defaultLimit }).then(function (response) {
	          var _response$data = response.data;
	          var _response$data$result = _response$data.results;
	          var results = _response$data$result === undefined ? [] : _response$data$result;
	          var noResults = _response$data.noResults;
	
	          _this2.setState({
	            properties: results,
	            counter: results.length,
	            isFetching: false,
	            canLoadMore: results.length < noResults
	          });
	        }).catch(console.error);
	      });
	    }
	  }, {
	    key: 'loadMoreProperties',
	    value: function loadMoreProperties() {
	      var _this3 = this;
	
	      var _state = this.state;
	      var counter = _state.counter;
	      var properties = _state.properties;
	      var canLoadMore = _state.canLoadMore;
	      var settings = this.props.settings;
	
	      var query = Object.assign({}, settings, { published: true, sold: false });
	      if (canLoadMore) {
	        this.setState({ isFetching: true }, function () {
	          (0, _SearchSource.findProperties)({ settings: query, skip: counter, limit: _Constants.defaultLimit }).then(function (response) {
	            var _response$data2 = response.data;
	            var _response$data2$resul = _response$data2.results;
	            var results = _response$data2$resul === undefined ? [] : _response$data2$resul;
	            var noResults = _response$data2.noResults;
	
	            var newList = _ramda2.default.union(properties, results);
	            _this3.setState({
	              properties: newList,
	              counter: newList.length,
	              isFetching: false,
	              canLoadMore: newList.length < noResults
	            });
	          }).catch(console.error);
	        });
	      }
	    }
	  }, {
	    key: 'handleSort',
	    value: function handleSort(el) {
	      var keys = _ramda2.default.clone(this.state.tableHeaderKeys);
	      var keyIndex = _ramda2.default.findIndex(_ramda2.default.propEq('title', el.title), keys);
	      var result = (0, _Utils.sortArray)(el, this.state.properties);
	      keys.forEach(function (el) {
	        el.sort = null;
	      });
	      keys[keyIndex] = result.sortKey;
	      this.setState({ properties: result.list, tableHeaderKeys: keys });
	    }
	  }, {
	    key: 'propertyDetail',
	    value: function propertyDetail(id) {
	      var router = this.props.router;
	
	      router.push('/property/' + id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var width = window.screen.availWidth;
	      var height = document.getElementById('propertyList') && document.getElementById('propertyList').offsetHeight;
	      return _react2.default.createElement(
	        Container,
	        { id: 'propertyList' },
	        _react2.default.createElement(_Table2.default, {
	          keys: this.state.keys,
	          data: this.state.properties,
	          isFetching: this.state.isFetching,
	          rowClick: this.propertyDetail,
	          loadMore: this.loadMoreProperties,
	          width: width,
	          height: height,
	          handleSort: this.handleSort,
	          canLoadMore: this.state.canLoadMore
	        })
	      );
	    }
	  }]);
	
	  return PropertiesList;
	}(_react.Component);
	
	PropertiesList.propTypes = {
	  settings: _react.PropTypes.object,
	  router: _react.PropTypes.object,
	  user: _react.PropTypes.object
	};
	
	exports.default = PropertiesList;

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  text-align: center;\n  overflow-y: scroll;\n  height: calc(100vh - ', ');\n  ', ';\n  .map {\n    display: block;\n    width: 100vw;\n    height: 700px;\n    margin-top: 60px;\n    position: relative;\n  }\n'], ['\n  text-align: center;\n  overflow-y: scroll;\n  height: calc(100vh - ', ');\n  ', ';\n  .map {\n    display: block;\n    width: 100vw;\n    height: 700px;\n    margin-top: 60px;\n    position: relative;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding-bottom: 0;\n'], ['\n  padding-bottom: 0;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin: 40px 0;\n\n  @media screen and (max-width: ', ') {\n    margin: ', ' 0;\n  }\n'], ['\n  margin: 40px 0;\n\n  @media screen and (max-width: ', ') {\n    margin: ', ' 0;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  height: 100px;\n'], ['\n  height: 100px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  ', ';\n  color: ', ';\n  span {\n    color: ', ';\n  }\n'], ['\n  margin-top: ', ';\n  ', ';\n  color: ', ';\n  span {\n    color: ', ';\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  ', ';\n  ', ';\n\n  @media screen and (max-width: ', '){\n    float: none;\n    margin-bottom: ', ';\n  }\n'], ['\n  ', ';\n  ', ';\n\n  @media screen and (max-width: ', '){\n    float: none;\n    margin-bottom: ', ';\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['background-color: ', ';'], ['background-color: ', ';']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  ', ';\n  margin-bottom: ', ';\n  color: ', ';\n'], ['\n  ', ';\n  margin-bottom: ', ';\n  color: ', ';\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  width: 500px;\n  margin-left: calc((100% - 500px)/2);\n  padding: ', ' 0;\n  color: white;\n  text-align: center;\n\n  @media screen and (max-width: ', ') {\n    width: inherit;\n    margin-left: 0;\n  }\n'], ['\n  width: 500px;\n  margin-left: calc((100% - 500px)/2);\n  padding: ', ' 0;\n  color: white;\n  text-align: center;\n\n  @media screen and (max-width: ', ') {\n    width: inherit;\n    margin-left: 0;\n  }\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  ', ';\n  text-transform: uppercase;\n  color: ', ';\n  margin-top: ', ';\n'], ['\n  ', ';\n  text-transform: uppercase;\n  color: ', ';\n  margin-top: ', ';\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n  margin-top: ', ';\n'], ['\n  ', ';\n  color: ', ';\n  margin-top: ', ';\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  color: ', ';\n  border-bottom: ', ';\n  padding: 40px 0;\n  margin-bottom: ', ';\n'], ['\n  color: ', ';\n  border-bottom: ', ';\n  padding: 40px 0;\n  margin-bottom: ', ';\n']),
	    _templateObject14 = _taggedTemplateLiteral(['margin: ', ' 0;'], ['margin: ', ' 0;']),
	    _templateObject15 = _taggedTemplateLiteral(['\n  padding: 0 40px;\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n'], ['\n  padding: 0 40px;\n  @media screen and (max-width: ', ') {\n    padding: 0;\n  }\n']),
	    _templateObject16 = _taggedTemplateLiteral(['\n  ', ';\n  color: ', ';\n  margin-bottom: ', ';\n'], ['\n  ', ';\n  color: ', ';\n  margin-bottom: ', ';\n']),
	    _templateObject17 = _taggedTemplateLiteral(['\n  ', ';\n  text-transform: uppercase;\n  margin-top: ', ';\n'], ['\n  ', ';\n  text-transform: uppercase;\n  margin-top: ', ';\n']),
	    _templateObject18 = _taggedTemplateLiteral(['\n  margin-top: ', ';\n\n  p {\n    margin: ', ';\n  }\n\n  button {\n    margin-top: ', ';\n    margin-bottom: ', ';\n  }\n  textarea {\n    width: 495px;\n    margin-left: calc((1005 - 495px)/2);\n\n    @media screen and (max-width: ', ') {\n      width: 100%;\n      margin-left: 0;\n    }\n  }\n'], ['\n  margin-top: ', ';\n\n  p {\n    margin: ', ';\n  }\n\n  button {\n    margin-top: ', ';\n    margin-bottom: ', ';\n  }\n  textarea {\n    width: 495px;\n    margin-left: calc((1005 - 495px)/2);\n\n    @media screen and (max-width: ', ') {\n      width: 100%;\n      margin-left: 0;\n    }\n  }\n']),
	    _templateObject19 = _taggedTemplateLiteral(['\n  border-top: ', ';\n  padding: ', ' 0;\n  ', ';\n  color: ', ';\n'], ['\n  border-top: ', ';\n  padding: ', ' 0;\n  ', ';\n  color: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gridStyled = __webpack_require__(17);
	
	var _gridStyled2 = _interopRequireDefault(_gridStyled);
	
	var _SearchSource = __webpack_require__(18);
	
	var _Textarea = __webpack_require__(74);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _Button = __webpack_require__(10);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Map = __webpack_require__(244);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _Themes = __webpack_require__(5);
	
	var _MailSource = __webpack_require__(519);
	
	var _UserSource = __webpack_require__(246);
	
	var _AuthActions = __webpack_require__(53);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _ThemeContainer = __webpack_require__(20);
	
	var _ThemeContainer2 = _interopRequireDefault(_ThemeContainer);
	
	var _Key = __webpack_require__(176);
	
	var _Key2 = _interopRequireDefault(_Key);
	
	var _SuccessModal = __webpack_require__(37);
	
	var _SuccessModal2 = _interopRequireDefault(_SuccessModal);
	
	var _ErrorModal = __webpack_require__(30);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	var _Utils = __webpack_require__(22);
	
	var _showBackButton = __webpack_require__(173);
	
	var _showBackButton2 = _interopRequireDefault(_showBackButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.section(_templateObject, _Themes.Metrics.components.navbarDefault, _Themes.Fonts.style.Text);
	
	var CustomThemeContainer = (0, _styledComponents2.default)(_ThemeContainer2.default)(_templateObject2);
	
	var PropertyNameContainer = _styledComponents2.default.div(_templateObject3, _Themes.Metrics.breakpoints.mobile, _Themes.Metrics.margins.base);
	
	var FavoriteIcon = (0, _styledComponents2.default)(_Key2.default)(_templateObject4);
	
	var PropertyTitle = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject5, _Themes.Metrics.margins.larger, _Themes.Fonts.style.Title, _Themes.Colors.black, _Themes.Colors.primary);
	
	var ButtonsContainer = (0, _styledComponents2.default)(_gridStyled2.default)(_templateObject6, _Themes.Metrics.margins.larger);
	
	var CustomRequestButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject7, function (props) {
	  return props.left && 'float: left';
	}, function (props) {
	  return props.right && 'float: right';
	}, _Themes.Metrics.breakpoints.mobile, _Themes.Metrics.margins.small);
	
	var DetailsContainer = _styledComponents2.default.div(_templateObject8, _Themes.Colors.black);
	
	var DetailsTitle = _styledComponents2.default.div(_templateObject9, _Themes.Fonts.style.Header, _Themes.Metrics.margins.base, _Themes.Colors.white);
	
	var Details = _styledComponents2.default.div(_templateObject10, _Themes.Metrics.margins.big, _Themes.Metrics.breakpoints.mobile);
	
	var TitleDetail = _styledComponents2.default.div(_templateObject11, _Themes.Fonts.style.Text, _Themes.Colors.primary, _Themes.Metrics.margins.larger);
	
	var Detail = _styledComponents2.default.div(_templateObject12, _Themes.Fonts.style.Text, _Themes.Colors.white, _Themes.Metrics.margins.base);
	
	var Description = _styledComponents2.default.div(_templateObject13, _Themes.Colors.black, _Themes.Metrics.borders.default, _Themes.Metrics.margins.base);
	
	var LocationsContainer = _styledComponents2.default.div(_templateObject14, _Themes.Metrics.margins.base);
	
	var CustomHalf = (0, _styledComponents2.default)(_gridStyled.Half)(_templateObject15, _Themes.Metrics.breakpoints.mobile);
	
	var LocationsTitle = _styledComponents2.default.div(_templateObject16, _Themes.Fonts.style.Header, _Themes.Colors.primary, _Themes.Metrics.margins.base);
	
	var LocationTitle = _styledComponents2.default.div(_templateObject17, _Themes.Fonts.style.Text, _Themes.Metrics.margins.base);
	
	var Location = _styledComponents2.default.div(_templateObject12, _Themes.Fonts.style.Text, _Themes.Colors.primary, _Themes.Metrics.margins.base);
	
	var ContactRequest = _styledComponents2.default.div(_templateObject18, _Themes.Metrics.margins.larger, _Themes.Metrics.margins.large, _Themes.Metrics.margins.large, _Themes.Metrics.margins.larger, _Themes.Metrics.breakpoints.mobile);
	
	var ContactRequestTitle = _styledComponents2.default.div(_templateObject16, _Themes.Fonts.style.Text, _Themes.Colors.primary, _Themes.Metrics.margins.medium);
	
	var Contacts = _styledComponents2.default.div(_templateObject19, _Themes.Metrics.borders.default, _Themes.Metrics.margins.big, _Themes.Fonts.style.Input, _Themes.Colors.black);
	
	var PropertyDetails = function (_Component) {
	  _inherits(PropertyDetails, _Component);
	
	  function PropertyDetails(props) {
	    _classCallCheck(this, PropertyDetails);
	
	    var _this = _possibleConstructorReturn(this, (PropertyDetails.__proto__ || Object.getPrototypeOf(PropertyDetails)).call(this, props));
	
	    _this.state = {
	      property: null,
	      contactForm: '',
	      modal: false,
	      modalHeader: '',
	      modalMessage: '',
	      routeId: '',
	      favoriteProperty: false
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.sendEmail = _this.sendEmail.bind(_this);
	    _this.addToFavorites = _this.addToFavorites.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    _this.removeFromFavorites = _this.removeFromFavorites.bind(_this);
	    return _this;
	  }
	
	  _createClass(PropertyDetails, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var user = _props.user;
	      var router = _props.router;
	
	      (0, _SearchSource.findPropertyById)(router.params.id).then(function (response) {
	        _this2.setState({
	          property: response.data,
	          favoriteProperty: (0, _Utils.isUserFavorite)(user, response.data),
	          routeId: router.params.id
	        });
	      }).catch(console.error);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      var user = this.props.user;
	
	      if (this.state.routeId !== nextProps.router.params.id) {
	        (0, _SearchSource.findPropertyById)(nextProps.router.params.id).then(function (response) {
	          _this3.setState({
	            property: response.data,
	            favoriteProperty: (0, _Utils.isUserFavorite)(user, response.data),
	            routeId: nextProps.router.params.id
	          });
	          return;
	        }).catch(console.error);
	      }
	
	      if (user.preferredProperties.length !== nextProps.user.preferredProperties.length) {
	        this.setState({
	          favoriteProperty: (0, _Utils.isUserFavorite)(nextProps.user, this.state.property)
	        });
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      this.setState({ contactForm: event.target.value });
	    }
	  }, {
	    key: 'sendEmail',
	    value: function sendEmail(message) {
	      var _this4 = this;
	
	      var t = this.props.t;
	
	      (0, _MailSource.propertyContactRequest)(this.state.property.id, message).then(function (response) {
	        _this4.setState({
	          modal: 'success',
	          modalHeader: t('Mail Sent'),
	          modalMessage: t('Your contact request was successfully sent')
	        });
	      }).catch(function (error) {
	        console.log(error);
	        _this4.setState({
	          modal: 'error',
	          modalHeader: t('Error'),
	          modalMessage: t('There was a prolem when sending the email')
	        });
	      });
	    }
	  }, {
	    key: 'addToFavorites',
	    value: function addToFavorites() {
	      var _this5 = this;
	
	      var t = this.props.t;
	
	      (0, _UserSource.addToFavorites)(this.props.user.id, this.state.property.id, 'property').then(function (response) {
	        _this5.setState({
	          favoriteProperty: true,
	          modal: 'success',
	          modalHeader: t('Property Added'),
	          modalMessage: t('The property was successfully added to your favourites')
	        });
	        _AuthActions2.default.updateToken(response.data.authToken);
	      }).catch(function (error) {
	        console.log(error);
	        _this5.setState({
	          modal: 'error',
	          modalHeader: t('Error'),
	          modalMessage: t('There was an error when adding the property to your favourites')
	        });
	      });
	    }
	  }, {
	    key: 'removeFromFavorites',
	    value: function removeFromFavorites() {
	      var _this6 = this;
	
	      var t = this.props.t;
	
	      (0, _UserSource.removeFromFavorites)(this.props.user.id, this.state.property.id, 'property').then(function (response) {
	        _this6.setState({
	          favoriteProperty: false,
	          modal: 'success',
	          modalHeader: t('Property Removed'),
	          modalMessage: t('The property was successfully removed from your favourites')
	        });
	        _AuthActions2.default.updateToken(response.data.authToken);
	      }).catch(function (error) {
	        console.log(error);
	        _this6.setState({
	          modal: 'error',
	          modalHeader: t('Error'),
	          modalMessage: t('There was an error when removing the property from favorites')
	        });
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.setState({
	        modal: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var _state = this.state;
	      var property = _state.property;
	      var favoriteProperty = _state.favoriteProperty;
	      var modal = _state.modal;
	      var modalHeader = _state.modalHeader;
	      var modalMessage = _state.modalMessage;
	      var t = this.props.t;
	
	      return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(_ErrorModal2.default, {
	          visible: modal === 'error',
	          message: modalMessage,
	          closeAction: this.closeModal,
	          header: modalHeader
	        }),
	        _react2.default.createElement(_SuccessModal2.default, {
	          visible: modal === 'success',
	          message: modalMessage,
	          closeAction: this.closeModal,
	          header: modalHeader
	        }),
	        property ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            CustomThemeContainer,
	            null,
	            _react2.default.createElement(
	              PropertyNameContainer,
	              null,
	              _react2.default.createElement(FavoriteIcon, {
	                className: '' + (!this.state.favoriteProperty && 'notFavorite')
	              }),
	              _react2.default.createElement(
	                PropertyTitle,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  property.title,
	                  ', '
	                ),
	                property.city.city
	              ),
	              _react2.default.createElement(
	                ButtonsContainer,
	                null,
	                _react2.default.createElement(
	                  _gridStyled.Half,
	                  null,
	                  _react2.default.createElement(CustomRequestButton, {
	                    right: true,
	                    label: t('Request for more information'),
	                    onClick: function onClick() {
	                      window.location.href = '#property-contact';
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  _gridStyled.Half,
	                  null,
	                  _react2.default.createElement(CustomRequestButton, {
	                    left: true,
	                    label: favoriteProperty ? t('Favorite') : t('Add to Favorites'),
	                    onClick: function onClick() {
	                      favoriteProperty ? _this7.removeFromFavorites() : _this7.addToFavorites();
	                    },
	                    grey: favoriteProperty
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            DetailsContainer,
	            null,
	            _react2.default.createElement(
	              CustomThemeContainer,
	              null,
	              _react2.default.createElement(
	                Details,
	                null,
	                _react2.default.createElement(
	                  DetailsTitle,
	                  null,
	                  t('Property Details')
	                ),
	                _react2.default.createElement(
	                  CustomHalf,
	                  { xs: 1 / 2 },
	                  _react2.default.createElement(
	                    TitleDetail,
	                    null,
	                    t('Property Type')
	                  ),
	                  _react2.default.createElement(
	                    Detail,
	                    null,
	                    property.category.name
	                  )
	                ),
	                _react2.default.createElement(
	                  CustomHalf,
	                  { xs: 1 / 2 },
	                  _react2.default.createElement(
	                    TitleDetail,
	                    null,
	                    t('Property Area')
	                  ),
	                  _react2.default.createElement(
	                    Detail,
	                    null,
	                    property.area
	                  )
	                ),
	                _react2.default.createElement(
	                  CustomHalf,
	                  { xs: 1 / 2 },
	                  _react2.default.createElement(
	                    TitleDetail,
	                    null,
	                    t('Number of Keys')
	                  ),
	                  _react2.default.createElement(
	                    Detail,
	                    null,
	                    property.noRooms
	                  )
	                ),
	                _react2.default.createElement(
	                  CustomHalf,
	                  { xs: 1 / 2 },
	                  _react2.default.createElement(
	                    TitleDetail,
	                    null,
	                    t('Portfolio')
	                  ),
	                  _react2.default.createElement(
	                    Detail,
	                    null,
	                    property.portfolio ? 'Yes' : 'No'
	                  )
	                ),
	                _react2.default.createElement(
	                  CustomHalf,
	                  { xs: 1 / 2 },
	                  _react2.default.createElement(
	                    TitleDetail,
	                    null,
	                    t('Estimated Yield')
	                  ),
	                  _react2.default.createElement(
	                    Detail,
	                    null,
	                    property.yield,
	                    '%'
	                  )
	                ),
	                _react2.default.createElement(
	                  CustomHalf,
	                  { xs: 1 / 2 },
	                  _react2.default.createElement(
	                    TitleDetail,
	                    null,
	                    t('Price')
	                  ),
	                  _react2.default.createElement(
	                    Detail,
	                    null,
	                    (0, _Utils.numberWithCommas)(property.price),
	                    '\u20AC'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            CustomThemeContainer,
	            null,
	            _react2.default.createElement(
	              Description,
	              null,
	              property.description
	            ),
	            _react2.default.createElement(
	              LocationsContainer,
	              null,
	              _react2.default.createElement(
	                LocationsTitle,
	                null,
	                t('Property Location')
	              ),
	              _react2.default.createElement(
	                _gridStyled2.default,
	                null,
	                _react2.default.createElement(
	                  _gridStyled.Third,
	                  { className: 'location-container' },
	                  _react2.default.createElement(
	                    LocationTitle,
	                    null,
	                    t('Continent')
	                  ),
	                  _react2.default.createElement(
	                    Location,
	                    null,
	                    property.continent.name
	                  )
	                ),
	                _react2.default.createElement(
	                  _gridStyled.Third,
	                  { className: 'location-container' },
	                  _react2.default.createElement(
	                    LocationTitle,
	                    null,
	                    t('Country')
	                  ),
	                  _react2.default.createElement(
	                    Location,
	                    null,
	                    property.country.name
	                  )
	                ),
	                _react2.default.createElement(
	                  _gridStyled.Third,
	                  { className: 'location-container' },
	                  _react2.default.createElement(
	                    LocationTitle,
	                    null,
	                    t('Metropolitan Area')
	                  ),
	                  _react2.default.createElement(
	                    Location,
	                    null,
	                    property.city.city
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'map' },
	              property && _react2.default.createElement(_Map2.default, {
	                initialCenter: {
	                  lat: parseFloat(property.latlng.latitude),
	                  lng: parseFloat(property.latlng.longitude)
	                },
	                places: [property],
	                zoom: 12,
	                scrollable: false,
	                draggable: false,
	                disableUI: true
	              })
	            )
	          ),
	          _react2.default.createElement(
	            CustomThemeContainer,
	            null,
	            _react2.default.createElement(
	              ContactRequest,
	              { id: 'property-contact' },
	              _react2.default.createElement(
	                ContactRequestTitle,
	                null,
	                t('Request for more information')
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                t('Interested in this house? Please contact us')
	              ),
	              _react2.default.createElement(_Textarea2.default, {
	                handleChange: this.handleChange,
	                placeholder: t('Drop us a line'),
	                value: this.state.contactForm
	              }),
	              _react2.default.createElement(_Button2.default, {
	                onClick: function onClick() {
	                  return _this7.sendEmail(_this7.state.contactForm);
	                },
	                label: 'Send'
	              })
	            )
	          )
	        ) : t('Not Found'),
	        _react2.default.createElement(
	          Contacts,
	          null,
	          _react2.default.createElement(
	            _gridStyled.Half,
	            null,
	            'invest@hvb-investments.com'
	          ),
	          _react2.default.createElement(
	            _gridStyled.Half,
	            null,
	            'M\xFCnsterhof 6, 8001 Z\xFCrich'
	          )
	        )
	      );
	    }
	  }]);
	
	  return PropertyDetails;
	}(_react.Component);
	
	PropertyDetails.propTypes = {
	  router: _react.PropTypes.object,
	  user: _react.PropTypes.object,
	  t: _react.PropTypes.func
	};
	
	exports.default = (0, _reactI18next.translate)(['common', 'search', 'forms'], { wait: true })((0, _showBackButton2.default)(PropertyDetails));

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _immutable = __webpack_require__(29);
	
	var _bluebird = __webpack_require__(80);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _SearchSource = __webpack_require__(18);
	
	var _Utils = __webpack_require__(22);
	
	var _SearchResult = __webpack_require__(174);
	
	var _SearchResult2 = _interopRequireDefault(_SearchResult);
	
	var _showBackButton = __webpack_require__(173);
	
	var _showBackButton2 = _interopRequireDefault(_showBackButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  user: _react.PropTypes.object,
	  router: _react.PropTypes.object,
	  params: _react.PropTypes.object,
	  location: _react.PropTypes.object
	};
	
	var SearchByCity = function (_Component) {
	  _inherits(SearchByCity, _Component);
	
	  function SearchByCity(props) {
	    _classCallCheck(this, SearchByCity);
	
	    var _this = _possibleConstructorReturn(this, (SearchByCity.__proto__ || Object.getPrototypeOf(SearchByCity)).call(this, props));
	
	    _this.state = {
	      parent: {},
	      cities: [],
	      canLoadMore: true,
	      isFetching: false
	    };
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.loadMore = _this.loadMore.bind(_this);
	    return _this;
	  }
	
	  _createClass(SearchByCity, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var _state = this.state;
	      var cities = _state.cities;
	      var canLoadMore = _state.canLoadMore;
	      var isFetching = _state.isFetching;
	
	      if (!(0, _immutable.fromJS)(cities).equals((0, _immutable.fromJS)(nextState.cities)) || canLoadMore !== nextState.canLoadMore || isFetching !== nextState.isFetching) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var params = _props.params;
	      var location = _props.location;
	
	      var countryId = location.query.id || this.state.countryId;
	      this.setState({ isFetching: true }, function () {
	        var query = countryId ? { id: countryId } : { where: { name: params.country } };
	
	        (0, _SearchSource.searchCountries)(query).then(function (response) {
	          var country = response.data[0] || response.data;
	          return _bluebird2.default.all([country, (0, _SearchSource.searchCitieswithProperties)({ id: country.id })]).spread(function (country, response) {
	            _this2.setState({
	              parent: country,
	              cities: response.data.results,
	              canLoadMore: response.data.results.length < response.data.noElements,
	              isFetching: false
	            });
	          }).catch(function (error) {
	            return console.log(error);
	          });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      });
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(el) {
	      this.props.router.push('/search/region/' + this.props.params.continent + '/' + this.props.params.country + '/' + (0, _Utils.slugify)(el.city) + '?id=' + el.id);
	    }
	  }, {
	    key: 'loadMore',
	    value: function loadMore() {
	      var _this3 = this;
	
	      var _state2 = this.state;
	      var cities = _state2.cities;
	      var parent = _state2.parent;
	
	      this.setState({ isFetching: true }, function () {
	        (0, _SearchSource.searchCitieswithProperties)({ id: parent.id, skip: cities.length }).then(function (response) {
	          var list = _ramda2.default.sortBy(_ramda2.default.prop('city'), _ramda2.default.union(cities, response.data));
	          _this3.setState({
	            cities: list,
	            canLoadMore: list.length < response.data.noElements,
	            isFetching: false
	          });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$params = this.props.params;
	      var country = _props$params.country;
	      var continent = _props$params.continent;
	      var _state3 = this.state;
	      var canLoadMore = _state3.canLoadMore;
	      var isFetching = _state3.isFetching;
	      var cities = _state3.cities;
	      var parent = _state3.parent;
	
	      var title = (0, _Utils.unslugify)(country);
	      var path = {
	        continent: (0, _Utils.unslugify)(continent),
	        country: (0, _Utils.unslugify)(country),
	        city: null
	      };
	      return _react2.default.createElement(_SearchResult2.default, {
	        router: this.props.router,
	        type: 'city',
	        path: path,
	        handleClick: this.handleClick,
	        parent: parent,
	        results: cities,
	        title: title,
	        loadMore: this.loadMore,
	        canLoadMore: canLoadMore,
	        isFetching: isFetching
	      });
	    }
	  }]);
	
	  return SearchByCity;
	}(_react.Component);
	
	SearchByCity.propTypes = propTypes;
	
	exports.default = (0, _showBackButton2.default)(SearchByCity);

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SearchSource = __webpack_require__(18);
	
	var _SearchResult = __webpack_require__(174);
	
	var _SearchResult2 = _interopRequireDefault(_SearchResult);
	
	var _Utils = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchByContinent = function (_Component) {
	  _inherits(SearchByContinent, _Component);
	
	  function SearchByContinent(props) {
	    _classCallCheck(this, SearchByContinent);
	
	    var _this = _possibleConstructorReturn(this, (SearchByContinent.__proto__ || Object.getPrototypeOf(SearchByContinent)).call(this, props));
	
	    _this.state = {
	      results: []
	    };
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(SearchByContinent, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      (0, _SearchSource.searchContinentsWithProperties)().then(function (response) {
	        _this2.setState({ results: response.data.results });
	      }).catch(function (error) {
	        console.log(error);
	      });
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(el) {
	      this.props.router.push('/search/region/' + (0, _Utils.slugify)(el.name) + '?id=' + el.id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_SearchResult2.default, {
	        type: 'continent',
	        router: this.props.router,
	        handleClick: this.handleClick,
	        results: this.state.results,
	        title: 'World'
	      });
	    }
	  }]);
	
	  return SearchByContinent;
	}(_react.Component);
	
	SearchByContinent.propTypes = {
	  user: _react.PropTypes.object,
	  router: _react.PropTypes.object
	};
	
	exports.default = SearchByContinent;

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _immutable = __webpack_require__(29);
	
	var _bluebird = __webpack_require__(80);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _SearchSource = __webpack_require__(18);
	
	var _Utils = __webpack_require__(22);
	
	var _SearchResult = __webpack_require__(174);
	
	var _SearchResult2 = _interopRequireDefault(_SearchResult);
	
	var _showBackButton = __webpack_require__(173);
	
	var _showBackButton2 = _interopRequireDefault(_showBackButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchByCountry = function (_Component) {
	  _inherits(SearchByCountry, _Component);
	
	  function SearchByCountry(props) {
	    _classCallCheck(this, SearchByCountry);
	
	    var _this = _possibleConstructorReturn(this, (SearchByCountry.__proto__ || Object.getPrototypeOf(SearchByCountry)).call(this, props));
	
	    _this.state = {
	      parent: {},
	      countries: [],
	      canLoadMore: true,
	      isFetching: false
	    };
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.loadMore = _this.loadMore.bind(_this);
	    return _this;
	  }
	
	  _createClass(SearchByCountry, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var _state = this.state;
	      var countries = _state.countries;
	      var canLoadMore = _state.canLoadMore;
	      var isFetching = _state.isFetching;
	
	      if (!(0, _immutable.fromJS)(countries).equals((0, _immutable.fromJS)(nextState.countries)) || canLoadMore !== nextState.canLoadMore || isFetching !== nextState.isFetching) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var params = _props.params;
	      var location = _props.location;
	
	      var continentId = location.query.id || this.state.continentId;
	      this.setState({ isFetching: true }, function () {
	        var query = continentId ? { id: continentId } : { where: { name: params.continent } };
	
	        (0, _SearchSource.searchContinents)(query).then(function (response) {
	          var continent = response.data[0] || response.data;
	          return _bluebird2.default.all([continent, (0, _SearchSource.searchCountriesWithProperties)({ id: continent.id })]).spread(function (parent, response) {
	            _this2.setState({
	              parent: continent,
	              countries: response.data.results,
	              canLoadMore: response.data.results.length < response.data.noElements,
	              isFetching: false
	            });
	          }).catch(function (error) {
	            return console.log(error);
	          });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      });
	    }
	  }, {
	    key: 'loadMore',
	    value: function loadMore() {
	      var _this3 = this;
	
	      var _state2 = this.state;
	      var countries = _state2.countries;
	      var parent = _state2.parent;
	
	      this.setState({ isFetching: true }, function () {
	        (0, _SearchSource.searchCountriesWithProperties)({ id: parent.id, skip: countries.length }).then(function (response) {
	          var list = _ramda2.default.sortBy(_ramda2.default.prop('name'), _ramda2.default.union(countries, response.data.results));
	          _this3.setState({
	            countries: list,
	            canLoadMore: list.length < response.data.noElements,
	            isFetching: false
	          });
	        }).catch(function (error) {
	          return console.log(error);
	        });
	      });
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(el) {
	      this.props.router.push('/search/region/' + this.props.params.continent + '/' + (0, _Utils.slugify)(el.name) + '?id=' + el.id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var continent = this.props.params.continent;
	      var _state3 = this.state;
	      var canLoadMore = _state3.canLoadMore;
	      var isFetching = _state3.isFetching;
	      var countries = _state3.countries;
	      var parent = _state3.parent;
	
	      var title = (0, _Utils.unslugify)(continent);
	      var path = {
	        continent: (0, _Utils.unslugify)(continent),
	        country: null,
	        city: null
	      };
	      return _react2.default.createElement(_SearchResult2.default, {
	        type: 'country',
	        router: this.props.router,
	        path: path,
	        handleClick: this.handleClick,
	        results: countries,
	        title: title,
	        parent: parent,
	        isFetching: isFetching,
	        canLoadMore: canLoadMore,
	        loadMore: this.loadMore
	      });
	    }
	  }]);
	
	  return SearchByCountry;
	}(_react.Component);
	
	SearchByCountry.propTypes = {
	  user: _react.PropTypes.object,
	  updatePath: _react.PropTypes.func,
	  router: _react.PropTypes.object,
	  params: _react.PropTypes.object,
	  location: _react.PropTypes.object
	};
	
	exports.default = (0, _showBackButton2.default)(SearchByCountry);

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _bluebird = __webpack_require__(80);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _Utils = __webpack_require__(22);
	
	var _SearchSource = __webpack_require__(18);
	
	var _SearchResult = __webpack_require__(174);
	
	var _SearchResult2 = _interopRequireDefault(_SearchResult);
	
	var _Key = __webpack_require__(176);
	
	var _Key2 = _interopRequireDefault(_Key);
	
	var _showBackButton = __webpack_require__(173);
	
	var _showBackButton2 = _interopRequireDefault(_showBackButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var capitalize = function capitalize(d) {
	  return d.replace(/\w\S*/g, function (txt) {
	    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	  });
	};
	
	var SearchCityDetails = function (_Component) {
	  _inherits(SearchCityDetails, _Component);
	
	  function SearchCityDetails(props) {
	    _classCallCheck(this, SearchCityDetails);
	
	    var _this = _possibleConstructorReturn(this, (SearchCityDetails.__proto__ || Object.getPrototypeOf(SearchCityDetails)).call(this, props));
	
	    _this.state = {
	      parent: {},
	      properties: [],
	      canLoadMore: true,
	      isFetching: false,
	      categories: [],
	      keys: [{
	        title: 'Favorite',
	        key: 'favorite',
	        accessor: function accessor(d) {
	          return (0, _Utils.isUserFavorite)(_this.props.user, d) ? _react2.default.createElement(_Key2.default, null) : _react2.default.createElement(_Key2.default, { className: 'notFavorite' });
	        },
	        sortAccessor: function sortAccessor(d) {
	          return (0, _Utils.isUserFavorite)(_this.props.user, d);
	        },
	        width: 80,
	        sort: null
	      }, {
	        title: 'Title',
	        key: 'title',
	        width: 300,
	        className: 'title',
	        sort: null
	      }, {
	        title: 'Continent',
	        key: 'continent',
	        width: 150,
	        sort: null
	      }, {
	        title: 'Country',
	        key: 'country',
	        width: 150,
	        sort: null
	      }, {
	        title: 'City',
	        key: 'city',
	        width: 200,
	        sort: null
	      }, {
	        title: 'Category',
	        key: 'category',
	        width: 250,
	        accessor: function accessor(d) {
	          return d.category.name;
	        },
	        sort: null
	      }, {
	        title: 'Keys',
	        key: 'noRooms',
	        width: 100,
	        sort: null
	      }, {
	        title: 'Portfolio',
	        key: 'portfolio',
	        width: 100,
	        accessor: function accessor(d) {
	          return d.portfolio ? 'Yes' : 'No';
	        },
	        sort: null
	      }, {
	        title: 'Price',
	        key: 'price',
	        width: 100,
	        unit: '€',
	        accessor: function accessor(d) {
	          return (0, _Utils.numberWithCommas)(d.price);
	        },
	        sortAccessor: function sortAccessor(d) {
	          return d.price;
	        },
	        sort: null
	      }, {
	        title: 'Yield',
	        key: 'yield',
	        width: 100,
	        unit: '%',
	        sort: null
	      }, {
	        title: 'Area',
	        key: 'area',
	        width: 100,
	        unit: 'm2',
	        accessor: function accessor(d) {
	          return (0, _Utils.numberWithCommas)(d.area);
	        },
	        sortAccessor: function sortAccessor(d) {
	          return d.area;
	        },
	        sort: null
	      }]
	    };
	    _this.searchProperties = _this.searchProperties.bind(_this);
	    _this.updateDimensions = _this.updateDimensions.bind(_this);
	    _this.handleSort = _this.handleSort.bind(_this);
	    return _this;
	  }
	
	  _createClass(SearchCityDetails, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var location = this.props.location;
	
	      window.addEventListener('resize', this.updateDimensions);
	      _bluebird2.default.all([(0, _SearchSource.searchCategories)(), (0, _SearchSource.searchCities)({ id: location.query.id })]).spread(function (categoriesResponse, cityResponse) {
	        _this2.setState({ categories: categoriesResponse.data, parent: cityResponse.data }, function () {
	          return _this2.searchProperties();
	        });
	      }).catch(console.error);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.updateDimensions);
	    }
	  }, {
	    key: 'updateDimensions',
	    value: function updateDimensions() {
	      this.forceUpdate();
	    }
	  }, {
	    key: 'searchProperties',
	    value: function searchProperties() {
	      var _this3 = this;
	
	      var _state = this.state;
	      var properties = _state.properties;
	      var categories = _state.categories;
	      var parent = _state.parent;
	      var _props$params = this.props.params;
	      var continent = _props$params.continent;
	      var country = _props$params.country;
	      var city = _props$params.city;
	
	
	      var capitalizedCountry = capitalize(country);
	      var capitalizedCity = capitalize(city);
	      var capitalizedContinent = capitalize(continent);
	
	      this.setState({ isFetching: true }, function () {
	        var settings = {
	          preferredCities: [parent],
	          minInvestment: 0,
	          minYield: 0,
	          minNoRooms: 0,
	          published: true,
	          sold: false
	        };
	        (0, _SearchSource.findProperties)({ settings: settings, skip: properties.length }).then(function (response) {
	          var _response$data = response.data;
	          var results = _response$data.results;
	          var noResults = _response$data.noResults;
	
	          if (noResults > 0) {
	            var newProperties = results.map(function (el, index) {
	              el.city = capitalizedCity;
	              el.country = capitalizedCountry;
	              el.continent = capitalizedContinent;
	              categories.forEach(function (category) {
	                if (category.id === el.category) {
	                  el.category = category;
	                  return;
	                }
	              });
	              return el;
	            });
	            var list = _ramda2.default.sortBy(_ramda2.default.prop('title'), _ramda2.default.union(properties, newProperties));
	            _this3.setState({
	              properties: list,
	              canLoadMore: results.length < noResults,
	              isFetching: false
	            });
	          } else {
	            _this3.setState({ canLoadMore: false, isFetching: false });
	          }
	        }).catch(console.error);
	      });
	    }
	  }, {
	    key: 'handleSort',
	    value: function handleSort(el) {
	      var keys = _ramda2.default.clone(this.state.tableHeaderKeys);
	      var keyIndex = _ramda2.default.findIndex(_ramda2.default.propEq('title', el.title), keys);
	      var result = (0, _Utils.sortArray)(el, this.state.properties);
	      keys.forEach(function (el) {
	        el.sort = null;
	      });
	      keys[keyIndex] = result.sortKey;
	      this.setState({ properties: result.list, tableHeaderKeys: keys });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$params2 = this.props.params;
	      var city = _props$params2.city;
	      var continent = _props$params2.continent;
	      var country = _props$params2.country;
	      var _state2 = this.state;
	      var canLoadMore = _state2.canLoadMore;
	      var isFetching = _state2.isFetching;
	      var properties = _state2.properties;
	      var keys = _state2.keys;
	      var parent = _state2.parent;
	      var _props = this.props;
	      var propertyDetails = _props.propertyDetails;
	      var router = _props.router;
	
	      var title = (0, _Utils.unslugify)(city);
	      var path = {
	        continent: (0, _Utils.unslugify)(continent),
	        country: (0, _Utils.unslugify)(country),
	        city: (0, _Utils.unslugify)(city)
	      };
	
	      return _react2.default.createElement(_SearchResult2.default, {
	        type: 'city',
	        router: router,
	        path: path,
	        propertyDetails: propertyDetails,
	        isFetching: isFetching,
	        handleClick: propertyDetails,
	        results: properties,
	        title: title,
	        tableKeys: keys,
	        handleSort: this.handleSort,
	        loadMore: this.searchProperties,
	        canLoadMore: canLoadMore,
	        parent: parent
	      });
	    }
	  }]);
	
	  return SearchCityDetails;
	}(_react.Component);
	
	SearchCityDetails.propTypes = {
	  user: _react.PropTypes.object,
	  updatePath: _react.PropTypes.func,
	  propertyDetails: _react.PropTypes.func,
	  params: _react.PropTypes.object,
	  location: _react.PropTypes.object,
	  router: _react.PropTypes.object
	};
	
	exports.default = (0, _showBackButton2.default)(SearchCityDetails);

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral([''], ['']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ramda = __webpack_require__(11);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SearchBar = __webpack_require__(245);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _Loader = __webpack_require__(45);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Defaults = __webpack_require__(34);
	
	var _AdminSource = __webpack_require__(31);
	
	var _SuccessModal = __webpack_require__(37);
	
	var _SuccessModal2 = _interopRequireDefault(_SuccessModal);
	
	var _ErrorModal = __webpack_require__(30);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	var _reactI18next = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.section(_templateObject);
	
	var Search = function (_Component) {
	  _inherits(Search, _Component);
	
	  function Search(props) {
	    _classCallCheck(this, Search);
	
	    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));
	
	    _this.state = {
	      settings: _ramda2.default.clone(_Defaults.searchQueryDefault),
	      modal: false,
	      generating: false
	    };
	    _this.updateSettings = _this.updateSettings.bind(_this);
	    _this.propertyDetails = _this.propertyDetails.bind(_this);
	    _this.exportProperties = _this.exportProperties.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: 'updateSettings',
	    value: function updateSettings(settings) {
	      this.setState({ settings: settings });
	    }
	  }, {
	    key: 'propertyDetails',
	    value: function propertyDetails(id) {
	      this.props.router.push('/property/' + id);
	    }
	  }, {
	    key: 'exportProperties',
	    value: function exportProperties() {
	      var _this2 = this;
	
	      this.setState({ generating: true }, function () {
	        (0, _AdminSource.exportPropertiesToCsv)(_this2.state.settings).then(function (response) {
	          _this2.setState({ modal: 'success', generating: false });
	        }).catch(function (error) {
	          _this2.setState({ modal: 'error', generating: false });
	          console.log(error);
	        });
	      });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.setState({ modal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var router = _props.router;
	      var user = _props.user;
	      var t = _props.t;
	
	      var isRegionSearch = router.location.pathname.indexOf('/search/find') >= 0 || router.location.pathname.indexOf('/search/region') >= 0;
	      var searchSettings = _ramda2.default.clone(this.state.settings);
	      var querySettings = _ramda2.default.clone(this.state.settings);
	
	      return _react2.default.createElement(
	        Container,
	        { isRegionSearch: isRegionSearch },
	        !isRegionSearch && _react2.default.createElement(_SearchBar2.default, {
	          exportAction: this.exportProperties,
	          settings: searchSettings,
	          updateSettings: this.updateSettings,
	          searchRequests: user.preferences
	        }),
	        _react2.default.createElement(_Loader2.default, { visible: this.state.generating }),
	        _react2.default.createElement(_SuccessModal2.default, {
	          visible: this.state.modal === 'success',
	          closeAction: this.closeModal,
	          header: t('Email Sent'),
	          message: t('An email was sent with the Excel')
	        }),
	        _react2.default.createElement(_ErrorModal2.default, {
	          visible: this.state.modal === 'error',
	          closeAction: this.closeModal,
	          header: t('Error'),
	          message: t('There was an error when creating the Excel file')
	        }),
	        children && _react2.default.cloneElement(children, {
	          settings: querySettings,
	          updateSettings: this.updateSettings,
	          propertyDetails: this.propertyDetails,
	          user: user
	        })
	      );
	    }
	  }]);
	
	  return Search;
	}(_react.Component);
	
	Search.propTypes = {
	  user: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  router: _react.PropTypes.object,
	  t: _react.PropTypes.func
	};
	exports.default = (0, _reactI18next.translate)(['common', 'forms', 'search'], { wait: true })(Search);

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alt = __webpack_require__(170);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	var _MobileActions = __webpack_require__(514);
	
	var _MobileActions2 = _interopRequireDefault(_MobileActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MobileStore = function () {
	  function MobileStore() {
	    _classCallCheck(this, MobileStore);
	
	    this.backButton = false;
	
	    this.bindListeners({
	      showBackButton: _MobileActions2.default.SHOW_BACK_BUTTON,
	      hideBackButton: _MobileActions2.default.HIDE_BACK_BUTTON
	    });
	  }
	
	  _createClass(MobileStore, [{
	    key: 'showBackButton',
	    value: function showBackButton() {
	      this.backButton = true;
	    }
	  }, {
	    key: 'hideBackButton',
	    value: function hideBackButton() {
	      this.backButton = false;
	    }
	  }]);
	
	  return MobileStore;
	}();
	
	module.exports = _alt2.default.createStore(MobileStore, 'MobileStore');

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheckCircle = function CheckCircle(props) {
	  return _react2.default.createElement(
	    'svg',
	    { width: '63', height: '63', xmlns: 'http://www.w3.org/2000/svg' },
	    _react2.default.createElement(
	      'g',
	      {
	        transform: 'translate(1 1)',
	        stroke: '#C78C2F',
	        fill: 'none',
	        fillRule: 'evenodd' },
	      _react2.default.createElement('circle', { cx: '30.5', cy: '30.5', r: '30.5' }),
	      _react2.default.createElement('path', {
	        d: 'M18 31l8.5 9.5m0 0l19-19',
	        strokeWidth: '2',
	        strokeLinecap: 'round'
	      })
	    )
	  );
	};
	
	CheckCircle.propTypes = {
	  key: _react.PropTypes.number
	};
	
	exports.default = CheckCircle;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  id: _react.PropTypes.string,
	  grey: _react.PropTypes.bool
	};
	
	var CheckboxOff = function CheckboxOff(props) {
	  return _react2.default.createElement(
	    'svg',
	    Object.assign({
	      width: '24',
	      height: '24',
	      xmlns: 'http://www.w3.org/2000/svg',
	      xmlnsXlink: 'http://www.w3.org/1999/xlink'
	    }, props),
	    _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement('path', { id: 'a-checkbox-off-' + props.id, d: 'M0 0h175v40H0z' }),
	      _react2.default.createElement(
	        'mask',
	        {
	          id: 'b-checkbox-off-' + props.id,
	          x: '0',
	          y: '0',
	          width: '175',
	          height: '40',
	          fill: '#fff' },
	        _react2.default.createElement('use', { xlinkHref: '#a-checkbox-off-' + props.id })
	      ),
	      _react2.default.createElement('path', {
	        d: 'M2 2.833v18.334c0 .46.373.833.833.833h18.334c.46 0 .833-.373.833-.833V2.833c0-.46-.373-.833-.833-.833H2.833C2.373 2 2 2.373 2 2.833zm18.333.834v16.666H3.667V3.667h16.666z',
	        id: 'c-checkbox-off-' + props.id
	      })
	    ),
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { d: 'M0 0h24v24H0z' }),
	      _react2.default.createElement(
	        'mask',
	        { id: 'd-checkbox-off-' + props.id, fill: '#fff' },
	        _react2.default.createElement('use', { xlinkHref: '#c-checkbox-off-' + props.id })
	      ),
	      _react2.default.createElement('path', {
	        d: 'M0 0h100v40H0z',
	        mask: 'url(#d-checkbox-off-' + props.id + ')',
	        fill: props.grey ? '#dfdfdf' : '#000'
	      })
	    )
	  );
	};
	
	CheckboxOff.propTypes = propTypes;
	
	exports.default = CheckboxOff;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  id: _react.PropTypes.string,
	  grey: _react.PropTypes.bool
	};
	
	var CheckboxOn = function CheckboxOn(props) {
	  return _react2.default.createElement(
	    'svg',
	    Object.assign({
	      width: '24',
	      height: '24',
	      xmlns: 'http://www.w3.org/2000/svg',
	      xmlnsXlink: 'http://www.w3.org/1999/xlink'
	    }, props),
	    _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement('path', { id: 'a-checkbox-on-' + props.id, d: 'M0 0h175v40H0z' }),
	      _react2.default.createElement(
	        'mask',
	        {
	          id: 'b-checkbox-on-' + props.id,
	          x: '0',
	          y: '0',
	          width: '175',
	          height: '40',
	          fill: '#fff' },
	        _react2.default.createElement('use', { xlinkHref: '#a-checkbox-on-' + props.id })
	      ),
	      _react2.default.createElement('path', {
	        d: 'M2 2.833v18.334c0 .46.373.833.833.833h18.334c.46 0 .833-.373.833-.833V2.833c0-.46-.373-.833-.833-.833H2.833C2.373 2 2 2.373 2 2.833zm7.744 13.09c.326.325.853.325 1.18 0l6.665-6.667c.324-.326.324-.853 0-1.18-.327-.324-.855-.324-1.18 0L10.33 14.16l-2.744-2.75c-.326-.325-.854-.325-1.18 0-.325.326-.325.854 0 1.18l3.334 3.333z',
	        id: 'c-checkbox-on-' + props.id
	      })
	    ),
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { d: 'M0 0h24v24H0z' }),
	      _react2.default.createElement(
	        'mask',
	        { id: 'd-checkbox-on-' + props.id, fill: '#fff' },
	        _react2.default.createElement('use', { xlinkHref: '#c-checkbox-on-' + props.id })
	      ),
	      _react2.default.createElement('path', {
	        d: 'M0 0h100v40H0z',
	        mask: 'url(#d-checkbox-on-' + props.id + ')',
	        fill: props.grey ? '#dfdfdf' : '#000'
	      })
	    )
	  );
	};
	
	CheckboxOn.propTypes = propTypes;
	
	exports.default = CheckboxOn;

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Filter = function Filter(props) {
	  return _react2.default.createElement(
	    'svg',
	    Object.assign({
	      width: '26',
	      height: '26',
	      xmlns: 'http://www.w3.org/2000/svg',
	      xmlnsXlink: 'http://www.w3.org/1999/xlink'
	    }, props),
	    _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement('path', {
	        d: 'M21.167 6.167a.833.833 0 0 0 0-1.667H12a.833.833 0 1 0 0 1.667h9.167zm-15.834 0a.833.833 0 0 0 0-1.667h-2.5a.833.833 0 1 0 0 1.667h2.5zM4.5 2.833v5c0 .46.373.834.833.834h3.334c.46 0 .833-.373.833-.834v-5A.833.833 0 0 0 8.667 2H5.333a.833.833 0 0 0-.833.833zm4.167.834l-.834-.834v5L8.667 7H5.333l.834.833v-5l-.834.834h3.334zm12.5 9.166a.833.833 0 1 0 0-1.666h-.834a.833.833 0 1 0 0 1.666h.834zm-7.5 0a.833.833 0 1 0 0-1.666H2.833a.833.833 0 1 0 0 1.666h10.834zM12.833 9.5v5c0 .46.373.833.834.833H17c.46 0 .833-.373.833-.833v-5A.833.833 0 0 0 17 8.667h-3.333a.833.833 0 0 0-.834.833zm4.167.833l-.833-.833v5l.833-.833h-3.333l.833.833v-5l-.833.833H17zm4.167 9.167a.833.833 0 1 0 0-1.667H12a.833.833 0 0 0 0 1.667h9.167zm-15.834 0a.833.833 0 1 0 0-1.667h-2.5a.833.833 0 0 0 0 1.667h2.5zM4.5 16.167v5c0 .46.373.833.833.833h3.334c.46 0 .833-.373.833-.833v-5a.833.833 0 0 0-.833-.834H5.333a.833.833 0 0 0-.833.834zM8.667 17l-.834-.833v5l.834-.834H5.333l.834.834v-5L5.333 17h3.334z',
	        id: 'filterA'
	      })
	    ),
	    _react2.default.createElement(
	      'g',
	      { transform: 'translate(-2 -2)', fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { d: 'M0 0h24v24H0z' }),
	      _react2.default.createElement(
	        'mask',
	        { id: 'filterB', fill: '#fff' },
	        _react2.default.createElement('use', { xlinkHref: '#filterA' })
	      ),
	      _react2.default.createElement('path', {
	        d: 'M0 0h100v40H0z',
	        mask: 'url(#filterB)',
	        fill: '#2D3030',
	        id: 'filters'
	      })
	    )
	  );
	};
	
	exports.default = Filter;

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeftArrow = function LeftArrow(props) {
	  return _react2.default.createElement(
	    'svg',
	    Object.assign({}, props, {
	      width: '14px',
	      height: '23px',
	      viewBox: '0 0 14 23',
	      version: '1.1',
	      xmlns: 'http://www.w3.org/2000/svg',
	      xmlnsXlink: 'http://www.w3.org/1999/xlink' }),
	    _react2.default.createElement(
	      'g',
	      {
	        id: 'Landing-Page',
	        stroke: 'none',
	        strokeWidth: '1',
	        fill: 'none',
	        fillRule: 'evenodd' },
	      _react2.default.createElement(
	        'g',
	        {
	          id: 'INTERESTS',
	          transform: 'translate(-302.000000, -94.000000)',
	          fill: '#D8D8D8' },
	        _react2.default.createElement('path', {
	          d: 'M309.11149,108.24257 L299.86892,99 L298,100.86892 L307.24257,110.11149 L307.222981,110.13108 L309.091901,112 L320.118531,100.97337 L318.249611,99.1044492 L309.11149,108.24257 Z',
	          id: 'Combined-Shape',
	          transform: 'translate(309.059266, 105.500000) rotate(90.000000) translate(-309.059266, -105.500000) '
	        })
	      )
	    )
	  );
	};
	
	exports.default = LeftArrow;

/***/ },
/* 1116 */
/***/ function(module, exports) {

	module.exports = {
		"country_phone_code_to_countries": {
			"1": [
				"US",
				"AG",
				"AI",
				"AS",
				"BB",
				"BM",
				"BS",
				"CA",
				"DM",
				"DO",
				"GD",
				"GU",
				"JM",
				"KN",
				"KY",
				"LC",
				"MP",
				"MS",
				"PR",
				"SX",
				"TC",
				"TT",
				"VC",
				"VG",
				"VI"
			],
			"7": [
				"RU",
				"KZ"
			],
			"20": [
				"EG"
			],
			"27": [
				"ZA"
			],
			"30": [
				"GR"
			],
			"31": [
				"NL"
			],
			"32": [
				"BE"
			],
			"33": [
				"FR"
			],
			"34": [
				"ES"
			],
			"36": [
				"HU"
			],
			"39": [
				"IT",
				"VA"
			],
			"40": [
				"RO"
			],
			"41": [
				"CH"
			],
			"43": [
				"AT"
			],
			"44": [
				"GB",
				"GG",
				"IM",
				"JE"
			],
			"45": [
				"DK"
			],
			"46": [
				"SE"
			],
			"47": [
				"NO",
				"SJ"
			],
			"48": [
				"PL"
			],
			"49": [
				"DE"
			],
			"51": [
				"PE"
			],
			"52": [
				"MX"
			],
			"53": [
				"CU"
			],
			"54": [
				"AR"
			],
			"55": [
				"BR"
			],
			"56": [
				"CL"
			],
			"57": [
				"CO"
			],
			"58": [
				"VE"
			],
			"60": [
				"MY"
			],
			"61": [
				"AU",
				"CC",
				"CX"
			],
			"62": [
				"ID"
			],
			"63": [
				"PH"
			],
			"64": [
				"NZ"
			],
			"65": [
				"SG"
			],
			"66": [
				"TH"
			],
			"81": [
				"JP"
			],
			"82": [
				"KR"
			],
			"84": [
				"VN"
			],
			"86": [
				"CN"
			],
			"90": [
				"TR"
			],
			"91": [
				"IN"
			],
			"92": [
				"PK"
			],
			"93": [
				"AF"
			],
			"94": [
				"LK"
			],
			"95": [
				"MM"
			],
			"98": [
				"IR"
			],
			"211": [
				"SS"
			],
			"212": [
				"MA",
				"EH"
			],
			"213": [
				"DZ"
			],
			"216": [
				"TN"
			],
			"218": [
				"LY"
			],
			"220": [
				"GM"
			],
			"221": [
				"SN"
			],
			"222": [
				"MR"
			],
			"223": [
				"ML"
			],
			"224": [
				"GN"
			],
			"225": [
				"CI"
			],
			"226": [
				"BF"
			],
			"227": [
				"NE"
			],
			"228": [
				"TG"
			],
			"229": [
				"BJ"
			],
			"230": [
				"MU"
			],
			"231": [
				"LR"
			],
			"232": [
				"SL"
			],
			"233": [
				"GH"
			],
			"234": [
				"NG"
			],
			"235": [
				"TD"
			],
			"236": [
				"CF"
			],
			"237": [
				"CM"
			],
			"238": [
				"CV"
			],
			"239": [
				"ST"
			],
			"240": [
				"GQ"
			],
			"241": [
				"GA"
			],
			"242": [
				"CG"
			],
			"243": [
				"CD"
			],
			"244": [
				"AO"
			],
			"245": [
				"GW"
			],
			"246": [
				"IO"
			],
			"247": [
				"AC"
			],
			"248": [
				"SC"
			],
			"249": [
				"SD"
			],
			"250": [
				"RW"
			],
			"251": [
				"ET"
			],
			"252": [
				"SO"
			],
			"253": [
				"DJ"
			],
			"254": [
				"KE"
			],
			"255": [
				"TZ"
			],
			"256": [
				"UG"
			],
			"257": [
				"BI"
			],
			"258": [
				"MZ"
			],
			"260": [
				"ZM"
			],
			"261": [
				"MG"
			],
			"262": [
				"RE",
				"YT"
			],
			"263": [
				"ZW"
			],
			"264": [
				"NA"
			],
			"265": [
				"MW"
			],
			"266": [
				"LS"
			],
			"267": [
				"BW"
			],
			"268": [
				"SZ"
			],
			"269": [
				"KM"
			],
			"290": [
				"SH",
				"TA"
			],
			"291": [
				"ER"
			],
			"297": [
				"AW"
			],
			"298": [
				"FO"
			],
			"299": [
				"GL"
			],
			"350": [
				"GI"
			],
			"351": [
				"PT"
			],
			"352": [
				"LU"
			],
			"353": [
				"IE"
			],
			"354": [
				"IS"
			],
			"355": [
				"AL"
			],
			"356": [
				"MT"
			],
			"357": [
				"CY"
			],
			"358": [
				"FI",
				"AX"
			],
			"359": [
				"BG"
			],
			"370": [
				"LT"
			],
			"371": [
				"LV"
			],
			"372": [
				"EE"
			],
			"373": [
				"MD"
			],
			"374": [
				"AM"
			],
			"375": [
				"BY"
			],
			"376": [
				"AD"
			],
			"377": [
				"MC"
			],
			"378": [
				"SM"
			],
			"380": [
				"UA"
			],
			"381": [
				"RS"
			],
			"382": [
				"ME"
			],
			"385": [
				"HR"
			],
			"386": [
				"SI"
			],
			"387": [
				"BA"
			],
			"389": [
				"MK"
			],
			"420": [
				"CZ"
			],
			"421": [
				"SK"
			],
			"423": [
				"LI"
			],
			"500": [
				"FK"
			],
			"501": [
				"BZ"
			],
			"502": [
				"GT"
			],
			"503": [
				"SV"
			],
			"504": [
				"HN"
			],
			"505": [
				"NI"
			],
			"506": [
				"CR"
			],
			"507": [
				"PA"
			],
			"508": [
				"PM"
			],
			"509": [
				"HT"
			],
			"590": [
				"GP",
				"BL",
				"MF"
			],
			"591": [
				"BO"
			],
			"592": [
				"GY"
			],
			"593": [
				"EC"
			],
			"594": [
				"GF"
			],
			"595": [
				"PY"
			],
			"596": [
				"MQ"
			],
			"597": [
				"SR"
			],
			"598": [
				"UY"
			],
			"599": [
				"CW",
				"BQ"
			],
			"670": [
				"TL"
			],
			"672": [
				"NF"
			],
			"673": [
				"BN"
			],
			"674": [
				"NR"
			],
			"675": [
				"PG"
			],
			"676": [
				"TO"
			],
			"677": [
				"SB"
			],
			"678": [
				"VU"
			],
			"679": [
				"FJ"
			],
			"680": [
				"PW"
			],
			"681": [
				"WF"
			],
			"682": [
				"CK"
			],
			"683": [
				"NU"
			],
			"685": [
				"WS"
			],
			"686": [
				"KI"
			],
			"687": [
				"NC"
			],
			"688": [
				"TV"
			],
			"689": [
				"PF"
			],
			"690": [
				"TK"
			],
			"691": [
				"FM"
			],
			"692": [
				"MH"
			],
			"800": [
				"001"
			],
			"808": [
				"001"
			],
			"850": [
				"KP"
			],
			"852": [
				"HK"
			],
			"853": [
				"MO"
			],
			"855": [
				"KH"
			],
			"856": [
				"LA"
			],
			"870": [
				"001"
			],
			"878": [
				"001"
			],
			"880": [
				"BD"
			],
			"881": [
				"001"
			],
			"882": [
				"001"
			],
			"883": [
				"001"
			],
			"886": [
				"TW"
			],
			"888": [
				"001"
			],
			"960": [
				"MV"
			],
			"961": [
				"LB"
			],
			"962": [
				"JO"
			],
			"963": [
				"SY"
			],
			"964": [
				"IQ"
			],
			"965": [
				"KW"
			],
			"966": [
				"SA"
			],
			"967": [
				"YE"
			],
			"968": [
				"OM"
			],
			"970": [
				"PS"
			],
			"971": [
				"AE"
			],
			"972": [
				"IL"
			],
			"973": [
				"BH"
			],
			"974": [
				"QA"
			],
			"975": [
				"BT"
			],
			"976": [
				"MN"
			],
			"977": [
				"NP"
			],
			"979": [
				"001"
			],
			"992": [
				"TJ"
			],
			"993": [
				"TM"
			],
			"994": [
				"AZ"
			],
			"995": [
				"GE"
			],
			"996": [
				"KG"
			],
			"998": [
				"UZ"
			]
		},
		"countries": {
			"AC": [
				"247",
				"[46]\\d{4}|[01589]\\d{5}"
			],
			"AD": [
				"376",
				"[16]\\d{5,8}|[37-9]\\d{5}",
				[
					[
						"(\\d{3})(\\d{3})",
						"$1 $2",
						[
							"[137-9]|6[0-8]"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"180",
							"180[02]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"690"
						]
					]
				]
			],
			"AE": [
				"971",
				"[2-79]\\d{7,8}|800\\d{2,9}",
				[
					[
						"([2-4679])(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2-4679][2-8]"
						]
					],
					[
						"(5\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"5"
						]
					],
					[
						"([479]00)(\\d)(\\d{5})",
						"$1 $2 $3",
						[
							"[479]0"
						],
						"$1"
					],
					[
						"([68]00)(\\d{2,9})",
						"$1 $2",
						[
							"60|8"
						],
						"$1"
					]
				],
				"0",
				"0$1"
			],
			"AF": [
				"93",
				"[2-7]\\d{8}",
				[
					[
						"([2-7]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2-7]"
						]
					]
				],
				"0",
				"0$1"
			],
			"AG": [
				"1",
				"[2589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"268"
			],
			"AI": [
				"1",
				"[2589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"264"
			],
			"AL": [
				"355",
				"[2-57]\\d{7}|6\\d{8}|8\\d{5,7}|9\\d{5}",
				[
					[
						"(4)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"4[0-6]"
						]
					],
					[
						"(6[6-9])(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"6"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2358][2-5]|4[7-9]"
						]
					],
					[
						"(\\d{3})(\\d{3,5})",
						"$1 $2",
						[
							"[235][16-9]|8[016-9]|[79]"
						]
					]
				],
				"0",
				"0$1"
			],
			"AM": [
				"374",
				"[1-9]\\d{7}",
				[
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"1|47"
						]
					],
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"4[1349]|[5-7]|9[1-9]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"[23]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"8|90"
						],
						"0 $1"
					]
				],
				"0",
				"(0$1)"
			],
			"AO": [
				"244",
				"[29]\\d{8}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3"
					]
				]
			],
			"AR": [
				"54",
				"11\\d{8}|[2368]\\d{9}|9\\d{10}",
				[
					[
						"([68]\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[68]"
						]
					],
					[
						"(9)(11)(\\d{4})(\\d{4})",
						"$2 15-$3-$4",
						[
							"911"
						],
						null,
						null,
						"$1 $2 $3-$4"
					],
					[
						"(9)(\\d{3})(\\d{3})(\\d{4})",
						"$2 15-$3-$4",
						[
							"9(?:2[234689]|3[3-8])",
							"9(?:2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[1-358]|5[138]|6[24]|7[069]|8[013578]))",
							"9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[456]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))",
							"9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1239])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"
						],
						null,
						null,
						"$1 $2 $3-$4"
					],
					[
						"(9)(\\d{4})(\\d{2})(\\d{4})",
						"$2 15-$3-$4",
						[
							"9[23]"
						],
						null,
						null,
						"$1 $2 $3-$4"
					],
					[
						"(11)(\\d{4})(\\d{4})",
						"$1 $2-$3",
						[
							"1"
						],
						null,
						"true"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2-$3",
						[
							"2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[1-358]|5[138]|6[24]|7[069]|8[013578])",
							"2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[456]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))",
							"2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1239])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"
						],
						null,
						"true"
					],
					[
						"(\\d{4})(\\d{2})(\\d{4})",
						"$1 $2-$3",
						[
							"[23]"
						],
						null,
						"true"
					]
				],
				"0",
				"0$1",
				"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))?15)?",
				"9$1"
			],
			"AS": [
				"1",
				"[5689]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"684"
			],
			"AT": [
				"43",
				"[1-9]\\d{3,12}",
				[
					[
						"(116\\d{3})",
						"$1",
						[
							"116"
						],
						"$1"
					],
					[
						"(1)(\\d{3,12})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(5\\d)(\\d{3,5})",
						"$1 $2",
						[
							"5[079]"
						]
					],
					[
						"(5\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"5[079]"
						]
					],
					[
						"(5\\d)(\\d{4})(\\d{4,7})",
						"$1 $2 $3",
						[
							"5[079]"
						]
					],
					[
						"(\\d{3})(\\d{3,10})",
						"$1 $2",
						[
							"316|46|51|732|6(?:5[0-3579]|[6-9])|7(?:[28]0)|[89]"
						]
					],
					[
						"(\\d{4})(\\d{3,9})",
						"$1 $2",
						[
							"2|3(?:1[1-578]|[3-8])|4[2378]|5[2-6]|6(?:[12]|4[1-9]|5[468])|7(?:2[1-8]|35|4[1-8]|[5-79])"
						]
					]
				],
				"0",
				"0$1"
			],
			"AU": [
				"61",
				"1\\d{4,9}|[2-578]\\d{8}",
				[
					[
						"([2378])(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[2378]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[45]|14"
						],
						"0$1"
					],
					[
						"(16)(\\d{3,4})",
						"$1 $2",
						[
							"16"
						],
						"0$1"
					],
					[
						"(16)(\\d{3})(\\d{2,4})",
						"$1 $2 $3",
						[
							"16"
						],
						"0$1"
					],
					[
						"(1[389]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1(?:[38]0|90)",
							"1(?:[38]00|90)"
						],
						"$1"
					],
					[
						"(180)(2\\d{3})",
						"$1 $2",
						[
							"180",
							"1802"
						],
						"$1"
					],
					[
						"(19\\d)(\\d{3})",
						"$1 $2",
						[
							"19[13]"
						],
						"$1"
					],
					[
						"(19\\d{2})(\\d{4})",
						"$1 $2",
						[
							"19[679]"
						],
						"$1"
					],
					[
						"(13)(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"13[1-9]"
						],
						"$1"
					]
				],
				"0",
				null,
				null,
				null,
				null,
				null,
				[
					"[237]\\d{8}|8(?:[6-8]\\d{3}|9(?:[02-9]\\d{2}|1(?:[0-57-9]\\d|6[0135-9])))\\d{4}",
					"14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[47-9]|5[0-25-9]|6[6-9]|7[02-9]|8[147-9]|9[017-9])\\d{6}",
					"180(?:0\\d{3}|2)\\d{3}",
					"19(?:0[0126]\\d|[679])\\d{5}",
					"500\\d{6}",
					null,
					null,
					"16\\d{3,7}",
					"550\\d{6}",
					"13(?:00\\d{3}|45[0-4]|\\d)\\d{3}"
				]
			],
			"AW": [
				"297",
				"[25-9]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"AX": [
				"358",
				"1\\d{5,11}|[35]\\d{5,9}|[27]\\d{4,9}|4\\d{5,10}|6\\d{7,9}|8\\d{6,9}",
				[
					[
						"(\\d{3})(\\d{3,7})",
						"$1 $2",
						[
							"(?:[1-3]00|[6-8]0)"
						]
					],
					[
						"(116\\d{3})",
						"$1",
						[
							"116"
						],
						"$1"
					],
					[
						"(\\d{2})(\\d{4,10})",
						"$1 $2",
						[
							"[14]|2[09]|50|7[135]"
						]
					],
					[
						"(\\d)(\\d{4,11})",
						"$1 $2",
						[
							"[25689][1-8]|3"
						]
					]
				],
				"0",
				"0$1",
				null,
				null,
				null,
				null,
				[
					"18[1-8]\\d{3,9}",
					"4\\d{5,10}|50\\d{4,8}",
					"800\\d{4,7}",
					"[67]00\\d{5,6}",
					null,
					null,
					"[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})"
				]
			],
			"AZ": [
				"994",
				"[1-9]\\d{8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"(?:1[28]|2(?:[45]2|[0-36])|365)"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[4-8]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"9"
						],
						"0$1"
					]
				],
				"0",
				"(0$1)"
			],
			"BA": [
				"387",
				"[3-9]\\d{7,8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2-$3",
						[
							"[3-5]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"6[1-356]|[7-9]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"6[047]"
						]
					]
				],
				"0",
				"0$1"
			],
			"BB": [
				"1",
				"[2589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"246"
			],
			"BD": [
				"880",
				"[2-79]\\d{5,9}|1\\d{9}|8[0-7]\\d{4,8}",
				[
					[
						"(2)(\\d{7,8})",
						"$1-$2",
						[
							"2"
						]
					],
					[
						"(\\d{2})(\\d{4,6})",
						"$1-$2",
						[
							"[3-79]1"
						]
					],
					[
						"(\\d{4})(\\d{3,6})",
						"$1-$2",
						[
							"1|3(?:0|[2-58]2)|4(?:0|[25]2|3[23]|[4689][25])|5(?:[02-578]2|6[25])|6(?:[0347-9]2|[26][25])|7[02-9]2|8(?:[023][23]|[4-7]2)|9(?:[02][23]|[458]2|6[016])"
						]
					],
					[
						"(\\d{3})(\\d{3,7})",
						"$1-$2",
						[
							"[3-79][2-9]|8"
						]
					]
				],
				"0",
				"0$1"
			],
			"BE": [
				"32",
				"[1-9]\\d{7,8}",
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"4[6-9]"
						]
					],
					[
						"(\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[23]|4[23]|9[2-4]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[156]|7[018]|8(?:0[1-9]|[1-79])"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"(?:80|9)0"
						]
					]
				],
				"0",
				"0$1"
			],
			"BF": [
				"226",
				"[25-7]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"BG": [
				"359",
				"[23567]\\d{5,7}|[489]\\d{6,8}",
				[
					[
						"(2)(\\d)(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"2"
						]
					],
					[
						"(2)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"43[124-7]|70[1-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{2})",
						"$1 $2 $3",
						[
							"43[124-7]|70[1-9]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"[78]00"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"999"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{2,3})",
						"$1 $2 $3",
						[
							"[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"48|8[7-9]|9[08]"
						]
					]
				],
				"0",
				"0$1"
			],
			"BH": [
				"973",
				"[136-9]\\d{7}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"BI": [
				"257",
				"[267]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"BJ": [
				"229",
				"[2689]\\d{7}|7\\d{3}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"BL": [
				"590",
				"[56]\\d{8}",
				[
					[
						"([56]90)(\\d{2})(\\d{4})",
						"$1 $2-$3"
					]
				],
				"0",
				null,
				null,
				null,
				null,
				null,
				[
					"590(?:2[7-9]|5[12]|87)\\d{4}",
					"690(?:0[0-7]|[1-9]\\d)\\d{4}"
				]
			],
			"BM": [
				"1",
				"[4589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"441"
			],
			"BN": [
				"673",
				"[2-578]\\d{6}",
				[
					[
						"([2-578]\\d{2})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"BO": [
				"591",
				"[23467]\\d{7}",
				[
					[
						"([234])(\\d{7})",
						"$1 $2",
						[
							"[234]"
						]
					],
					[
						"([67]\\d{7})",
						"$1",
						[
							"[67]"
						]
					]
				],
				"0",
				null,
				"0(1\\d)?"
			],
			"BQ": [
				"599",
				"[347]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[13-7]"
						]
					],
					[
						"(9)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"9"
						]
					]
				],
				null,
				null,
				null,
				null,
				null,
				null,
				[
					"(?:318[023]|41(?:6[023]|70)|7(?:1[578]|50)\\d)\\d{3}",
					"(?:31(?:8[14-8]|9[14578])|416[145-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"
				]
			],
			"BR": [
				"55",
				"[1-46-9]\\d{7,10}|5(?:[0-4]\\d{7,9}|5(?:[2-8]\\d{7}|9\\d{7,8}))",
				[
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2-$3",
						[
							"[1-9][1-9]"
						],
						"($1)"
					],
					[
						"(\\d{2})(\\d{5})(\\d{4})",
						"$1 $2-$3",
						[
							"(?:[14689][1-9]|2[12478]|3[1-578]|5[1-5]|7[13-579])9"
						],
						"($1)"
					],
					[
						"(\\d{4})(\\d{4})",
						"$1-$2",
						[
							"(?:300|40(?:0|20))"
						]
					],
					[
						"([3589]00)(\\d{2,3})(\\d{4})",
						"$1 $2 $3",
						[
							"[3589]00"
						],
						"0$1"
					]
				],
				"0",
				null,
				"0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
				"$2"
			],
			"BS": [
				"1",
				"[2589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"242"
			],
			"BT": [
				"975",
				"[1-8]\\d{6,7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"1|77"
						]
					],
					[
						"([2-8])(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2-68]|7[246]"
						]
					]
				]
			],
			"BW": [
				"267",
				"[2-79]\\d{6,7}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[2-6]"
						]
					],
					[
						"(7\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"7"
						]
					],
					[
						"(90)(\\d{5})",
						"$1 $2",
						[
							"9"
						]
					]
				]
			],
			"BY": [
				"375",
				"[1-4]\\d{8}|800\\d{3,7}|[89]\\d{9,10}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"17[0-3589]|2[4-9]|[34]",
							"17(?:[02358]|1[0-2]|9[0189])|2[4-9]|[34]"
						],
						"8 0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"1(?:5[24]|6[235]|7[467])|2(?:1[246]|2[25]|3[26])",
							"1(?:5[24]|6(?:2|3[04-9]|5[0346-9])|7(?:[46]|7[37-9]))|2(?:1[246]|2[25]|3[26])"
						],
						"8 0$1"
					],
					[
						"(\\d{4})(\\d{2})(\\d{3})",
						"$1 $2-$3",
						[
							"1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
							"1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
						],
						"8 0$1"
					],
					[
						"([89]\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8[01]|9"
						],
						"8 $1"
					],
					[
						"(82\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"82"
						],
						"8 $1"
					],
					[
						"(800)(\\d{3})",
						"$1 $2",
						[
							"800"
						],
						"8 $1"
					],
					[
						"(800)(\\d{2})(\\d{2,4})",
						"$1 $2 $3",
						[
							"800"
						],
						"8 $1"
					]
				],
				"8",
				null,
				"8?0?"
			],
			"BZ": [
				"501",
				"[2-8]\\d{6}|0\\d{10}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"[2-8]"
						]
					],
					[
						"(0)(800)(\\d{4})(\\d{3})",
						"$1-$2-$3-$4",
						[
							"0"
						]
					]
				]
			],
			"CA": [
				"1",
				"[2-9]\\d{9}|3\\d{6}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				null,
				[
					"(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}|310\\d{4}",
					"(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
					"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}|310\\d{4}",
					"900[2-9]\\d{6}",
					"5(?:00|22|33|44|66|77|88)[2-9]\\d{6}"
				]
			],
			"CC": [
				"61",
				"[1458]\\d{5,9}",
				[
					[
						"([2378])(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[2378]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[45]|14"
						],
						"0$1"
					],
					[
						"(16)(\\d{3,4})",
						"$1 $2",
						[
							"16"
						],
						"0$1"
					],
					[
						"(16)(\\d{3})(\\d{2,4})",
						"$1 $2 $3",
						[
							"16"
						],
						"0$1"
					],
					[
						"(1[389]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1(?:[38]0|90)",
							"1(?:[38]00|90)"
						],
						"$1"
					],
					[
						"(180)(2\\d{3})",
						"$1 $2",
						[
							"180",
							"1802"
						],
						"$1"
					],
					[
						"(19\\d)(\\d{3})",
						"$1 $2",
						[
							"19[13]"
						],
						"$1"
					],
					[
						"(19\\d{2})(\\d{4})",
						"$1 $2",
						[
							"19[679]"
						],
						"$1"
					],
					[
						"(13)(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"13[1-9]"
						],
						"$1"
					]
				],
				"0",
				null,
				null,
				null,
				null,
				null,
				[
					"89162\\d{4}",
					"14(?:5\\d|71)\\d{5}|4(?:[0-2]\\d|3[0-57-9]|4[47-9]|5[0-25-9]|6[6-9]|7[02-9]|8[147-9]|9[017-9])\\d{6}",
					"180(?:0\\d{3}|2)\\d{3}",
					"190[0126]\\d{6}",
					"500\\d{6}",
					null,
					null,
					null,
					"550\\d{6}",
					"13(?:00\\d{2})?\\d{4}"
				]
			],
			"CD": [
				"243",
				"[2-6]\\d{6}|[18]\\d{6,8}|9\\d{8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"12"
						]
					],
					[
						"([89]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8[0-2459]|9"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"88"
						]
					],
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"[1-6]"
						]
					]
				],
				"0",
				"0$1"
			],
			"CF": [
				"236",
				"[278]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"CG": [
				"242",
				"[028]\\d{8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[02]"
						]
					],
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"8"
						]
					]
				]
			],
			"CH": [
				"41",
				"[2-9]\\d{8}|860\\d{9}",
				[
					[
						"([2-9]\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[2-7]|[89]1"
						]
					],
					[
						"([89]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8[047]|90"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						[
							"860"
						]
					]
				],
				"0",
				"0$1"
			],
			"CI": [
				"225",
				"[02-8]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"CK": [
				"682",
				"[2-8]\\d{4}",
				[
					[
						"(\\d{2})(\\d{3})",
						"$1 $2"
					]
				]
			],
			"CL": [
				"56",
				"(?:[2-9]|600|123)\\d{7,8}",
				[
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2[23]"
						],
						"($1)"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[357]|4[1-35]|6[13-57]"
						],
						"($1)"
					],
					[
						"(9)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"9"
						]
					],
					[
						"(44)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"44"
						]
					],
					[
						"([68]00)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"60|8"
						],
						"$1"
					],
					[
						"(600)(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"60"
						],
						"$1"
					],
					[
						"(1230)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						],
						"$1"
					],
					[
						"(\\d{5})(\\d{4})",
						"$1 $2",
						[
							"219"
						],
						"($1)"
					]
				],
				"0",
				"0$1",
				"0|(1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))"
			],
			"CM": [
				"237",
				"[2368]\\d{7,8}",
				[
					[
						"([26])(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						[
							"[26]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[23]|88"
						]
					],
					[
						"(800)(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"80"
						]
					]
				]
			],
			"CN": [
				"86",
				"[1-7]\\d{6,11}|8[0-357-9]\\d{6,9}|9\\d{7,10}",
				[
					[
						"(80\\d{2})(\\d{4})",
						"$1 $2",
						[
							"80[2678]"
						],
						"0$1",
						"true"
					],
					[
						"([48]00)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[48]00"
						]
					],
					[
						"(\\d{2})(\\d{5,6})",
						"$1 $2",
						[
							"(?:10|2\\d)[19]",
							"(?:10|2\\d)(?:10|9[56])",
							"(?:10|2\\d)(?:100|9[56])"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"[3-9]",
							"[3-9]\\d{2}[19]",
							"[3-9]\\d{2}(?:10|9[56])"
						],
						"0$1"
					],
					[
						"(21)(\\d{4})(\\d{4,6})",
						"$1 $2 $3",
						[
							"21"
						],
						"0$1",
						"true"
					],
					[
						"([12]\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"10[1-9]|2[02-9]",
							"10[1-9]|2[02-9]",
							"10(?:[1-79]|8(?:[1-9]|0[1-9]))|2[02-9]"
						],
						"0$1",
						"true"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"
						],
						"0$1",
						"true"
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:[57]1|98)"
						],
						"0$1",
						"true"
					],
					[
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"807",
							"8078"
						],
						"0$1",
						"true"
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"1[3-578]"
						]
					],
					[
						"(10800)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"108",
							"1080",
							"10800"
						]
					],
					[
						"(\\d{3})(\\d{7,8})",
						"$1 $2",
						[
							"950"
						]
					]
				],
				"0",
				null,
				"(1(?:[129]\\d{3}|79\\d{2}))|0"
			],
			"CO": [
				"57",
				"(?:[13]\\d{0,3}|[24-8])\\d{7}",
				[
					[
						"(\\d)(\\d{7})",
						"$1 $2",
						[
							"1(?:8[2-9]|9[0-3]|[2-7])|[24-8]",
							"1(?:8[2-9]|9(?:09|[1-3])|[2-7])|[24-8]"
						],
						"($1)"
					],
					[
						"(\\d{3})(\\d{7})",
						"$1 $2",
						[
							"3"
						]
					],
					[
						"(1)(\\d{3})(\\d{7})",
						"$1-$2-$3",
						[
							"1(?:80|9[04])",
							"1(?:800|9(?:0[01]|4[78]))"
						],
						"0$1",
						null,
						"$1 $2 $3"
					]
				],
				"0",
				null,
				"0([3579]|4(?:44|56))?"
			],
			"CR": [
				"506",
				"[24-9]\\d{7,9}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[24-7]|8[3-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[89]0"
						]
					]
				],
				null,
				null,
				"(19(?:0[012468]|1[09]|20|66|77|99))"
			],
			"CU": [
				"53",
				"[2-57]\\d{5,7}",
				[
					[
						"(\\d)(\\d{6,7})",
						"$1 $2",
						[
							"7"
						]
					],
					[
						"(\\d{2})(\\d{4,6})",
						"$1 $2",
						[
							"[2-4]"
						]
					],
					[
						"(\\d)(\\d{7})",
						"$1 $2",
						[
							"5"
						],
						"0$1"
					]
				],
				"0",
				"(0$1)"
			],
			"CV": [
				"238",
				"[259]\\d{6}",
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3"
					]
				]
			],
			"CW": [
				"599",
				"[169]\\d{6,7}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[13-7]"
						]
					],
					[
						"(9)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"9"
						]
					]
				],
				null,
				null,
				null,
				null,
				null,
				null,
				[
					"9(?:[48]\\d{2}|50\\d|7(?:2[0-24]|[34]\\d|6[35-7]|77|8[7-9]))\\d{4}",
					"9(?:5(?:[12467]\\d|3[01])|6(?:[15-9]\\d|3[01]))\\d{4}",
					null,
					null,
					null,
					null,
					null,
					"955\\d{5}",
					null,
					"60[0-2]\\d{4}"
				]
			],
			"CX": [
				"61",
				"[1458]\\d{5,9}",
				[
					[
						"([2378])(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[2378]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[45]|14"
						],
						"0$1"
					],
					[
						"(16)(\\d{3,4})",
						"$1 $2",
						[
							"16"
						],
						"0$1"
					],
					[
						"(16)(\\d{3})(\\d{2,4})",
						"$1 $2 $3",
						[
							"16"
						],
						"0$1"
					],
					[
						"(1[389]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1(?:[38]0|90)",
							"1(?:[38]00|90)"
						],
						"$1"
					],
					[
						"(180)(2\\d{3})",
						"$1 $2",
						[
							"180",
							"1802"
						],
						"$1"
					],
					[
						"(19\\d)(\\d{3})",
						"$1 $2",
						[
							"19[13]"
						],
						"$1"
					],
					[
						"(19\\d{2})(\\d{4})",
						"$1 $2",
						[
							"19[679]"
						],
						"$1"
					],
					[
						"(13)(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"13[1-9]"
						],
						"$1"
					]
				],
				"0",
				null,
				null,
				null,
				null,
				null,
				[
					"89164\\d{4}",
					"14(?:5\\d|71)\\d{5}|4(?:[0-2]\\d|3[0-57-9]|4[47-9]|5[0-25-9]|6[6-9]|7[02-9]|8[147-9]|9[017-9])\\d{6}",
					"180(?:0\\d{3}|2)\\d{3}",
					"190[0126]\\d{6}",
					"500\\d{6}",
					null,
					null,
					null,
					"550\\d{6}",
					"13(?:00\\d{2})?\\d{4}"
				]
			],
			"CY": [
				"357",
				"[257-9]\\d{7}",
				[
					[
						"(\\d{2})(\\d{6})",
						"$1 $2"
					]
				]
			],
			"CZ": [
				"420",
				"[2-8]\\d{8}|9\\d{8,11}",
				[
					[
						"([2-9]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2-8]|9[015-7]"
						]
					],
					[
						"(96\\d)(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"96"
						]
					],
					[
						"(9\\d)(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"9[36]"
						]
					]
				]
			],
			"DE": [
				"49",
				"[1-35-9]\\d{3,14}|4(?:[0-8]\\d{4,12}|9(?:[0-37]\\d|4(?:[1-35-8]|4\\d?)|5\\d{1,2}|6[1-8]\\d?)\\d{2,8})",
				[
					[
						"(1\\d{2})(\\d{7,8})",
						"$1 $2",
						[
							"1[67]"
						]
					],
					[
						"(15\\d{3})(\\d{6})",
						"$1 $2",
						[
							"15[0568]"
						]
					],
					[
						"(1\\d{3})(\\d{7})",
						"$1 $2",
						[
							"15"
						]
					],
					[
						"(\\d{2})(\\d{3,11})",
						"$1 $2",
						[
							"3[02]|40|[68]9"
						]
					],
					[
						"(\\d{3})(\\d{3,11})",
						"$1 $2",
						[
							"2(?:\\d1|0[2389]|1[24]|28|34)|3(?:[3-9][15]|40)|[4-8][1-9]1|9(?:06|[1-9]1)"
						]
					],
					[
						"(\\d{4})(\\d{2,11})",
						"$1 $2",
						[
							"[24-6]|[7-9](?:\\d[1-9]|[1-9]\\d)|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])",
							"[24-6]|[7-9](?:\\d[1-9]|[1-9]\\d)|3(?:3(?:0[1-467]|2[127-9]|3[124578]|[46][1246]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|3[1357]|4[13578]|6[1246]|7[1356]|9[1346])|5(?:0[14]|2[1-3589]|3[1357]|4[1246]|6[1-4]|7[1346]|8[13568]|9[1246])|6(?:0[356]|2[1-489]|3[124-6]|4[1347]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|3[1357]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|4[1347]|6[0135-9]|7[1467]|8[136])|9(?:0[12479]|2[1358]|3[1357]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))"
						]
					],
					[
						"(3\\d{4})(\\d{1,10})",
						"$1 $2",
						[
							"3"
						]
					],
					[
						"(800)(\\d{7,12})",
						"$1 $2",
						[
							"800"
						]
					],
					[
						"(\\d{3})(\\d)(\\d{4,10})",
						"$1 $2 $3",
						[
							"(?:18|90)0|137",
							"1(?:37|80)|900[1359]"
						]
					],
					[
						"(1\\d{2})(\\d{5,11})",
						"$1 $2",
						[
							"181"
						]
					],
					[
						"(18\\d{3})(\\d{6})",
						"$1 $2",
						[
							"185",
							"1850",
							"18500"
						]
					],
					[
						"(18\\d{2})(\\d{7})",
						"$1 $2",
						[
							"18[68]"
						]
					],
					[
						"(18\\d)(\\d{8})",
						"$1 $2",
						[
							"18[2-579]"
						]
					],
					[
						"(700)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"700"
						]
					],
					[
						"(138)(\\d{4})",
						"$1 $2",
						[
							"138"
						]
					],
					[
						"(15[013-68])(\\d{2})(\\d{8})",
						"$1 $2 $3",
						[
							"15[013-68]"
						]
					],
					[
						"(15[279]\\d)(\\d{2})(\\d{7})",
						"$1 $2 $3",
						[
							"15[279]"
						]
					],
					[
						"(1[67]\\d)(\\d{2})(\\d{7,8})",
						"$1 $2 $3",
						[
							"1(?:6[023]|7)"
						]
					]
				],
				"0",
				"0$1"
			],
			"DJ": [
				"253",
				"[27]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"DK": [
				"45",
				"[2-9]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"DM": [
				"1",
				"[57-9]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"767"
			],
			"DO": [
				"1",
				"[589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"8[024]9"
			],
			"DZ": [
				"213",
				"(?:[1-4]|[5-9]\\d)\\d{7}",
				[
					[
						"([1-4]\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[1-4]"
						]
					],
					[
						"([5-8]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[5-8]"
						]
					],
					[
						"(9\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"9"
						]
					]
				],
				"0",
				"0$1"
			],
			"EC": [
				"593",
				"1\\d{9,10}|[2-8]\\d{7}|9\\d{8}",
				[
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2-$3",
						[
							"[247]|[356][2-8]"
						],
						null,
						null,
						"$1-$2-$3"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"9"
						],
						"0$1"
					],
					[
						"(1800)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"1"
						],
						"$1"
					]
				],
				"0",
				"(0$1)"
			],
			"EE": [
				"372",
				"1\\d{3,4}|[3-9]\\d{6,7}|800\\d{6,7}",
				[
					[
						"([3-79]\\d{2})(\\d{4})",
						"$1 $2",
						[
							"[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]",
							"[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]"
						]
					],
					[
						"(70)(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"70"
						]
					],
					[
						"(8000)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"800",
							"8000"
						]
					],
					[
						"([458]\\d{3})(\\d{3,4})",
						"$1 $2",
						[
							"40|5|8(?:00|[1-5])",
							"40|5|8(?:00[1-9]|[1-5])"
						]
					]
				]
			],
			"EG": [
				"20",
				"1\\d{4,9}|[2456]\\d{8}|3\\d{7}|[89]\\d{8,9}",
				[
					[
						"(\\d)(\\d{7,8})",
						"$1 $2",
						[
							"[23]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1[012]|[89]00"
						]
					],
					[
						"(\\d{2})(\\d{6,7})",
						"$1 $2",
						[
							"1[35]|[4-6]|[89][2-9]"
						]
					]
				],
				"0",
				"0$1"
			],
			"EH": [
				"212",
				"[5-9]\\d{8}",
				[
					[
						"([5-7]\\d{2})(\\d{6})",
						"$1-$2",
						[
							"5(?:2[015-7]|3[0-4])|[67]"
						]
					],
					[
						"([58]\\d{3})(\\d{5})",
						"$1-$2",
						[
							"5(?:2[2-489]|3[5-9]|92)|892",
							"5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"
						]
					],
					[
						"(5\\d{4})(\\d{4})",
						"$1-$2",
						[
							"5(?:29|38)",
							"5(?:29|38)[89]"
						]
					],
					[
						"([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"5(?:4[067]|5[03])"
						]
					],
					[
						"(8[09])(\\d{7})",
						"$1-$2",
						[
							"8(?:0|9[013-9])"
						]
					]
				],
				"0",
				"0$1",
				null,
				null,
				null,
				"528[89]"
			],
			"ER": [
				"291",
				"[178]\\d{6}",
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3"
					]
				],
				"0",
				"0$1"
			],
			"ES": [
				"34",
				"[5-9]\\d{8}",
				[
					[
						"([89]00)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[89]00"
						]
					],
					[
						"([5-9]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[568]|[79][0-8]"
						]
					]
				]
			],
			"ET": [
				"251",
				"[1-59]\\d{8}",
				[
					[
						"([1-59]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3"
					]
				],
				"0",
				"0$1"
			],
			"FI": [
				"358",
				"1\\d{4,11}|[2-9]\\d{4,10}",
				[
					[
						"(\\d{3})(\\d{3,7})",
						"$1 $2",
						[
							"(?:[1-3]00|[6-8]0)"
						]
					],
					[
						"(116\\d{3})",
						"$1",
						[
							"116"
						],
						"$1"
					],
					[
						"(\\d{2})(\\d{4,10})",
						"$1 $2",
						[
							"[14]|2[09]|50|7[135]"
						]
					],
					[
						"(\\d)(\\d{4,11})",
						"$1 $2",
						[
							"[25689][1-8]|3"
						]
					]
				],
				"0",
				"0$1",
				null,
				null,
				null,
				null,
				[
					"1(?:[3569][1-8]\\d{3,9}|[47]\\d{5,10})|2[1-8]\\d{3,9}|3(?:[1-8]\\d{3,9}|9\\d{4,8})|[5689][1-8]\\d{3,9}",
					"4\\d{5,10}|50\\d{4,8}",
					"800\\d{4,7}",
					"[67]00\\d{5,6}",
					null,
					null,
					"[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})"
				]
			],
			"FJ": [
				"679",
				"[35-9]\\d{6}|0\\d{10}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[35-9]"
						]
					],
					[
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"0"
						]
					]
				]
			],
			"FK": [
				"500",
				"[2-7]\\d{4}"
			],
			"FM": [
				"691",
				"[39]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"FO": [
				"298",
				"[2-9]\\d{5}",
				[
					[
						"(\\d{6})",
						"$1"
					]
				],
				null,
				null,
				"(10(?:01|[12]0|88))"
			],
			"FR": [
				"33",
				"[1-9]\\d{8}",
				[
					[
						"([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						[
							"[1-79]"
						]
					],
					[
						"(8\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"8"
						],
						"0 $1"
					]
				],
				"0",
				"0$1"
			],
			"GA": [
				"241",
				"0?\\d{7}",
				[
					[
						"(\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[2-7]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"0"
						]
					]
				]
			],
			"GB": [
				"44",
				"\\d{7,10}",
				[
					[
						"(7\\d{3})(\\d{6})",
						"$1 $2",
						[
							"7(?:[1-5789]|62)",
							"7(?:[1-5789]|624)",
							"7(?:[1-5789]|6242)"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2|5[56]|7[06]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:1|\\d1)|3|9[018]"
						]
					],
					[
						"(\\d{5})(\\d{4,5})",
						"$1 $2",
						[
							"1(?:38|5[23]|69|76|94)",
							"1(?:387|5(?:24|39)|697|768|946)",
							"1(?:3873|5(?:242|39[456])|697[347]|768[347]|9467)"
						]
					],
					[
						"(1\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(800)(\\d{4})",
						"$1 $2",
						[
							"800",
							"8001",
							"80011",
							"800111",
							"8001111"
						]
					],
					[
						"(845)(46)(4\\d)",
						"$1 $2 $3",
						[
							"845",
							"8454",
							"84546",
							"845464"
						]
					],
					[
						"(8\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8(?:4[2-5]|7[0-3])"
						]
					],
					[
						"(80\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"80"
						]
					],
					[
						"([58]00)(\\d{6})",
						"$1 $2",
						[
							"[58]00"
						]
					]
				],
				"0",
				"0$1",
				null,
				null,
				null,
				null,
				[
					"2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{7}|1(?:(?:1(?:3[0-48]|[46][0-4]|5[0-26-9]|[78][0-49])|21[0-7]|31[0-8]|[4-69]1\\d))\\d{6}|1(?:2(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)|3(?:0\\d|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[28][02-57-9]|[37]\\d|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|2[024-9]|3[015689]|4[02-9]|5[03-9]|6\\d|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0124578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|8\\d|9[2-57]))\\d{6}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[345])))|3(?:638[2-5]|647[23]|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[123]))|5(?:24(?:3[2-79]|6\\d)|276\\d|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[567]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|955[0-4])|7(?:26(?:6[13-9]|7[0-7])|442\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|84(?:3[2-58]))|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}|176888[2-46-8]\\d{2}|16977[23]\\d{3}",
					"7(?:[1-3]\\d{3}|4(?:[0-46-9]\\d{2}|5(?:[0-689]\\d|7[0-57-9]))|5(?:0[0-8]|[13-9]\\d|2[0-35-9])\\d|7(?:0(?:0[01]|[1-9]\\d)|[1-7]\\d{2}|8[02-9]\\d|9[0-689]\\d)|8(?:[014-9]\\d|[23][0-8])\\d|9(?:[024-9]\\d{2}|1(?:[02-9]\\d|1[028])|3[0-689]\\d))\\d{5}",
					"80(?:0(?:1111|\\d{6,7})|8\\d{7})|500\\d{6}",
					"(?:87[123]|9(?:[01]\\d|8[2349]))\\d{7}",
					"70\\d{8}",
					null,
					"(?:3[0347]|55)\\d{8}",
					"76(?:0[012]\\d|2(?:[356]\\d|4[013-9])|4[0134]\\d|5[49]\\d|6[0-369]\\d|77\\d|81\\d|9[39]\\d)\\d{5}",
					"56\\d{8}",
					"8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})"
				]
			],
			"GD": [
				"1",
				"[4589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"473"
			],
			"GE": [
				"995",
				"[34578]\\d{8}",
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[348]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"7"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"5"
						],
						"$1"
					]
				],
				"0"
			],
			"GF": [
				"594",
				"[56]\\d{8}",
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				],
				"0",
				"0$1"
			],
			"GG": [
				"44",
				"[135789]\\d{6,9}",
				[
					[
						"(7\\d{3})(\\d{6})",
						"$1 $2",
						[
							"7(?:[1-5789]|62)",
							"7(?:[1-5789]|624)",
							"7(?:[1-5789]|6242)"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2|5[56]|7[06]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:1|\\d1)|3|9[018]"
						]
					],
					[
						"(\\d{5})(\\d{4,5})",
						"$1 $2",
						[
							"1(?:38|5[23]|69|76|94)",
							"1(?:387|5(?:24|39)|697|768|946)",
							"1(?:3873|5(?:242|39[456])|697[347]|768[347]|9467)"
						]
					],
					[
						"(1\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(800)(\\d{4})",
						"$1 $2",
						[
							"800",
							"8001",
							"80011",
							"800111",
							"8001111"
						]
					],
					[
						"(845)(46)(4\\d)",
						"$1 $2 $3",
						[
							"845",
							"8454",
							"84546",
							"845464"
						]
					],
					[
						"(8\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8(?:4[2-5]|7[0-3])"
						]
					],
					[
						"(80\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"80"
						]
					],
					[
						"([58]00)(\\d{6})",
						"$1 $2",
						[
							"[58]00"
						]
					]
				],
				"0",
				"0$1",
				null,
				null,
				null,
				null,
				[
					"1481\\d{6}",
					"7(?:781\\d|839\\d|911[17])\\d{5}",
					"80(?:0(?:1111|\\d{6,7})|8\\d{7})|500\\d{6}",
					"(?:87[123]|9(?:[01]\\d|8[0-3]))\\d{7}",
					"70\\d{8}",
					null,
					"(?:3[0347]|55)\\d{8}",
					"76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}",
					"56\\d{8}",
					"8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})"
				]
			],
			"GH": [
				"233",
				"[235]\\d{8}|8\\d{7}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[235]"
						]
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"8"
						]
					]
				],
				"0",
				"0$1"
			],
			"GI": [
				"350",
				"[2568]\\d{7}",
				[
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"2"
						]
					]
				]
			],
			"GL": [
				"299",
				"[1-689]\\d{5}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3"
					]
				]
			],
			"GM": [
				"220",
				"[2-9]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"GN": [
				"224",
				"[367]\\d{7,8}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"3"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[67]"
						]
					]
				]
			],
			"GP": [
				"590",
				"[56]\\d{8}",
				[
					[
						"([56]90)(\\d{2})(\\d{4})",
						"$1 $2-$3"
					]
				],
				"0",
				"0$1",
				null,
				null,
				null,
				null,
				[
					"590(?:0[13468]|1[012]|2[0-68]|3[28]|4[0-8]|5[579]|6[0189]|70|8[0-689]|9\\d)\\d{4}",
					"690(?:0[0-7]|[1-9]\\d)\\d{4}"
				]
			],
			"GQ": [
				"240",
				"[23589]\\d{8}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[235]"
						]
					],
					[
						"(\\d{3})(\\d{6})",
						"$1 $2",
						[
							"[89]"
						]
					]
				]
			],
			"GR": [
				"30",
				"[26-9]\\d{9}",
				[
					[
						"([27]\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"21|7"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2[2-9]1|[689]"
						]
					],
					[
						"(2\\d{3})(\\d{6})",
						"$1 $2",
						[
							"2[2-9][02-9]"
						]
					]
				]
			],
			"GT": [
				"502",
				"[2-7]\\d{7}|1[89]\\d{9}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[2-7]"
						]
					],
					[
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					]
				]
			],
			"GU": [
				"1",
				"[5689]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"671"
			],
			"GW": [
				"245",
				"(?:4(?:0\\d{5}|4\\d{7})|9\\d{8})",
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"44|9[567]"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"40"
						]
					]
				]
			],
			"GY": [
				"592",
				"[2-46-9]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"HK": [
				"852",
				"[235-7]\\d{7}|8\\d{7,8}|9\\d{4,10}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[235-7]|[89](?:0[1-9]|[1-9])"
						]
					],
					[
						"(800)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"800"
						]
					],
					[
						"(900)(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"900"
						]
					],
					[
						"(900)(\\d{2,5})",
						"$1 $2",
						[
							"900"
						]
					]
				]
			],
			"HN": [
				"504",
				"[237-9]\\d{7}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1-$2"
					]
				]
			],
			"HR": [
				"385",
				"[1-7]\\d{5,8}|[89]\\d{6,8}",
				[
					[
						"(1)(\\d{4})(\\d{3})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"([2-5]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[2-5]"
						]
					],
					[
						"(9\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"9"
						]
					],
					[
						"(6[01])(\\d{2})(\\d{2,3})",
						"$1 $2 $3",
						[
							"6[01]"
						]
					],
					[
						"([67]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[67]"
						]
					],
					[
						"(80[01])(\\d{2})(\\d{2,3})",
						"$1 $2 $3",
						[
							"8"
						]
					],
					[
						"(80[01])(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8"
						]
					]
				],
				"0",
				"0$1"
			],
			"HT": [
				"509",
				"[2-489]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{4})",
						"$1 $2 $3"
					]
				]
			],
			"HU": [
				"36",
				"[1-9]\\d{7,8}",
				[
					[
						"(1)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[2-9]"
						]
					]
				],
				"06",
				"($1)"
			],
			"ID": [
				"62",
				"(?:[1-79]\\d{6,10}|8\\d{7,11})",
				[
					[
						"(\\d{2})(\\d{5,8})",
						"$1 $2",
						[
							"2[124]|[36]1"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{5,8})",
						"$1 $2",
						[
							"[4579]|2[035-9]|[36][02-9]"
						],
						"(0$1)"
					],
					[
						"(8\\d{2})(\\d{3,4})(\\d{3})",
						"$1-$2-$3",
						[
							"8[1-35-9]"
						]
					],
					[
						"(8\\d{2})(\\d{4})(\\d{4,5})",
						"$1-$2-$3",
						[
							"8[1-35-9]"
						]
					],
					[
						"(1)(500)(\\d{3})",
						"$1 $2 $3",
						[
							"15"
						],
						"$1"
					],
					[
						"(177)(\\d{6,8})",
						"$1 $2",
						[
							"17"
						]
					],
					[
						"(800)(\\d{5,7})",
						"$1 $2",
						[
							"800"
						]
					],
					[
						"(804)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"804"
						]
					],
					[
						"(80\\d)(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"80[79]"
						]
					]
				],
				"0",
				"0$1"
			],
			"IE": [
				"353",
				"[124-9]\\d{6,9}",
				[
					[
						"(1)(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"2[24-9]|47|58|6[237-9]|9[35-9]"
						]
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"40[24]|50[45]"
						]
					],
					[
						"(48)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"48"
						]
					],
					[
						"(818)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"81"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[24-69]|7[14]"
						]
					],
					[
						"([78]\\d)(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"76|8[35-9]"
						],
						"0$1"
					],
					[
						"(700)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"70"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1(?:8[059]|5)",
							"1(?:8[059]0|5)"
						],
						"$1"
					]
				],
				"0",
				"(0$1)"
			],
			"IL": [
				"972",
				"1\\d{6,11}|[2-589]\\d{3}(?:\\d{3,6})?|6\\d{3}|7\\d{6,9}",
				[
					[
						"([2-489])(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[2-489]"
						],
						"0$1"
					],
					[
						"([57]\\d)(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[57]"
						],
						"0$1"
					],
					[
						"(153)(\\d{1,2})(\\d{3})(\\d{4})",
						"$1 $2 $3 $4",
						[
							"153"
						]
					],
					[
						"(1)([7-9]\\d{2})(\\d{3})(\\d{3})",
						"$1-$2-$3-$4",
						[
							"1[7-9]"
						]
					],
					[
						"(1255)(\\d{3})",
						"$1-$2",
						[
							"125"
						]
					],
					[
						"(1200)(\\d{3})(\\d{3})",
						"$1-$2-$3",
						[
							"120"
						]
					],
					[
						"(1212)(\\d{2})(\\d{2})",
						"$1-$2-$3",
						[
							"121"
						]
					],
					[
						"(1599)(\\d{6})",
						"$1-$2",
						[
							"15"
						]
					],
					[
						"(\\d{4})",
						"*$1",
						[
							"[2-689]"
						]
					]
				],
				"0",
				"$1"
			],
			"IM": [
				"44",
				"[135789]\\d{6,9}",
				[
					[
						"(7\\d{3})(\\d{6})",
						"$1 $2",
						[
							"7(?:[1-5789]|62)",
							"7(?:[1-5789]|624)",
							"7(?:[1-5789]|6242)"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2|5[56]|7[06]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:1|\\d1)|3|9[018]"
						]
					],
					[
						"(\\d{5})(\\d{4,5})",
						"$1 $2",
						[
							"1(?:38|5[23]|69|76|94)",
							"1(?:387|5(?:24|39)|697|768|946)",
							"1(?:3873|5(?:242|39[456])|697[347]|768[347]|9467)"
						]
					],
					[
						"(1\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(800)(\\d{4})",
						"$1 $2",
						[
							"800",
							"8001",
							"80011",
							"800111",
							"8001111"
						]
					],
					[
						"(845)(46)(4\\d)",
						"$1 $2 $3",
						[
							"845",
							"8454",
							"84546",
							"845464"
						]
					],
					[
						"(8\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8(?:4[2-5]|7[0-3])"
						]
					],
					[
						"(80\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"80"
						]
					],
					[
						"([58]00)(\\d{6})",
						"$1 $2",
						[
							"[58]00"
						]
					]
				],
				"0",
				"0$1",
				null,
				null,
				null,
				null,
				[
					"1624\\d{6}",
					"7(?:4576|[59]24\\d)\\d{5}",
					"808162\\d{4}",
					"(?:872299|90[0167]624)\\d{4}",
					"70\\d{8}",
					null,
					"3(?:08162\\d|3\\d{5}|4(?:40[49]06|5624\\d)|7(?:0624\\d|2299\\d))\\d{3}|55\\d{8}",
					"76242\\d{5}",
					"56\\d{8}",
					"8(?:4(?:40[49]06|5624\\d)|70624\\d)\\d{3}"
				]
			],
			"IN": [
				"91",
				"008\\d{9}|1\\d{7,12}|[2-9]\\d{9,10}",
				[
					[
						"(\\d{5})(\\d{5})",
						"$1 $2",
						[
							"600|7(?:[02-8]|19|9[037-9])|8(?:0[015-9]|[1-9]|20)|9",
							"600|7(?:[078]|19[0-5]|2(?:[02356-9]|[14][017-9]|9[389])|3(?:[025-9]|1[07-9]|[34][017-9])|4(?:[0-35689]|[47][017-9])|5(?:[02346-9]|1[017-9]|5[017-9])|6(?:[02-9]|1[0-257-9])|9(?:[089]|31|7[02-9]))|8(?:0(?:[01589]|6[67]|7[02-9])|1(?:[0-57-9]|6[07-9])|2(?:0[078]|[14][07-9]|[235-9])|3(?:[0357-9]|[126][07-9]|4[1-9])|[45]|6(?:[02457-9]|[136][07-9])|7(?:[078][07-9]|[1-69])|8(?:[0-25-9]|3[07-9]|4[047-9])|9(?:[02-9]|1[027-9]))|9",
							"600|7(?:0|19[0-5]|2(?:[0235679]|[14][017-9]|8(?:[0-569]|[78][089])|9[389])|3(?:[05-8]|1(?:[089]|7[5-9])|2(?:[5-8]|[0-49][089])|3[017-9]|4(?:[07-9]|11)|9(?:[01689]|[2345][089]|40|7[0189]))|4(?:[056]|1(?:[0135-9]|[23][089]|2[089]|4[089])|2(?:0[089]|[1-7][089]|[89])|3(?:[0-8][089]|9)|4(?:[089]|11|7[02-8])|7(?:[089]|11|7[02-8])|8(?:[0-24-7][089]|[389])|9(?:[0-7][089]|[89]))|5(?:[0346-9]|1[017-9]|2(?:[03-9]|[12][089])|5[017-9])|6(?:[0346-9]|1[0-257-9]|2(?:[0-4]\\d|[5-9][089])|5(?:[0-367][089]|[4589]))|7(?:0(?:[02-9]|1[089])|[1-9])|8(?:[0-79]|8(?:0[0189]|11|8[013-9]|9))|9(?:[089]|313|7(?:[02-8]|9[07-9])))|8(?:0(?:[01589]|6[67]|7(?:[02-8]|9[05-9]))|1(?:[02-57-9]|1(?:[0-35-9]|4[0-46-9])|6(?:[089]|7[02-8]))|2(?:0(?:[08]|7[02])|[14](?:[089]|7[02-8])|[235-9])|3(?:[0357-9]|1(?:[089]|7[02-6])|2(?:[09]|77|8[0-689])|4[1-9]|6(?:[089]|7[02-7]))|[45]|6(?:[02457-9]|1(?:[089]|7[02-8])|3(?:[089]|7[02358])|6(?:[08]|7[02-8]|9[01]))|7(?:0[07-9]|[1-69]|7(?:[089]|7[02-8])|8(?:[089]|7[02-8]))|8(?:[0-25-9]|3(?:[089]|7[02-8])|4(?:[0489]|7[02-68]))|9(?:[02-9]|1(?:[0289]|7[2-6])))|9"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"11|2[02]|33|4[04]|79[1-9]|80[2-46]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:2[0-249]|3[0-25]|4[145]|[59][14]|7[1257]|[68][1-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|[36][25]|22|4[28]|5[12]|[78]1|9[15])|6(?:12|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)"
						]
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1(?:[23579]|[468][1-9])|[2-8]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"008"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"140"
						],
						"$1"
					],
					[
						"(\\d{4})(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"160",
							"1600"
						],
						"$1"
					],
					[
						"(\\d{4})(\\d{4,5})",
						"$1 $2",
						[
							"180",
							"1800"
						],
						"$1"
					],
					[
						"(\\d{4})(\\d{2,4})(\\d{4})",
						"$1 $2 $3",
						[
							"180",
							"1800"
						],
						"$1"
					],
					[
						"(\\d{4})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"186",
							"1860"
						],
						"$1"
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"18[06]"
						],
						"$1"
					]
				],
				"0",
				"0$1",
				null,
				null,
				true
			],
			"IO": [
				"246",
				"3\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"IQ": [
				"964",
				"[1-7]\\d{7,9}",
				[
					[
						"(1)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"([2-6]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[2-6]"
						]
					],
					[
						"(7\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						]
					]
				],
				"0",
				"0$1"
			],
			"IR": [
				"98",
				"[1-8]\\d{9}|9(?:[0-4]\\d{8}|9\\d{2,8})",
				[
					[
						"(21)(\\d{3,5})",
						"$1 $2",
						[
							"21"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[1-8]"
						]
					],
					[
						"(\\d{3})(\\d{3})",
						"$1 $2",
						[
							"9"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2,3})",
						"$1 $2 $3",
						[
							"9"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"9"
						]
					]
				],
				"0",
				"0$1"
			],
			"IS": [
				"354",
				"[4-9]\\d{6}|38\\d{7}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[4-9]"
						]
					],
					[
						"(3\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"3"
						]
					]
				]
			],
			"IT": [
				"39",
				"[01589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9})",
				[
					[
						"(\\d{2})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"0[26]|55"
						]
					],
					[
						"(0[26])(\\d{4})(\\d{5})",
						"$1 $2 $3",
						[
							"0[26]"
						]
					],
					[
						"(0[26])(\\d{4,6})",
						"$1 $2",
						[
							"0[26]"
						]
					],
					[
						"(0\\d{2})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"0[13-57-9][0159]"
						]
					],
					[
						"(\\d{3})(\\d{3,6})",
						"$1 $2",
						[
							"0[13-57-9][0159]|8(?:03|4[17]|9[245])",
							"0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"
						]
					],
					[
						"(0\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"0[13-57-9][2-46-8]"
						]
					],
					[
						"(0\\d{3})(\\d{2,6})",
						"$1 $2",
						[
							"0[13-57-9][2-46-8]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[13]|8(?:00|4[08]|9[59])",
							"[13]|8(?:00|4[08]|9(?:5[5-9]|9))"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"894",
							"894[5-9]"
						]
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"3"
						]
					]
				],
				null,
				null,
				null,
				null,
				null,
				null,
				[
					"0(?:[26]\\d{4,9}|(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2346]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[34578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7})",
					"3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})",
					"80(?:0\\d{6}|3\\d{3})",
					"0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})",
					"1(?:78\\d|99)\\d{6}",
					null,
					null,
					null,
					"55\\d{8}",
					"84(?:[08]\\d{6}|[17]\\d{3})"
				]
			],
			"JE": [
				"44",
				"[135789]\\d{6,9}",
				[
					[
						"(7\\d{3})(\\d{6})",
						"$1 $2",
						[
							"7(?:[1-5789]|62)",
							"7(?:[1-5789]|624)",
							"7(?:[1-5789]|6242)"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2|5[56]|7[06]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:1|\\d1)|3|9[018]"
						]
					],
					[
						"(\\d{5})(\\d{4,5})",
						"$1 $2",
						[
							"1(?:38|5[23]|69|76|94)",
							"1(?:387|5(?:24|39)|697|768|946)",
							"1(?:3873|5(?:242|39[456])|697[347]|768[347]|9467)"
						]
					],
					[
						"(1\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(800)(\\d{4})",
						"$1 $2",
						[
							"800",
							"8001",
							"80011",
							"800111",
							"8001111"
						]
					],
					[
						"(845)(46)(4\\d)",
						"$1 $2 $3",
						[
							"845",
							"8454",
							"84546",
							"845464"
						]
					],
					[
						"(8\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8(?:4[2-5]|7[0-3])"
						]
					],
					[
						"(80\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"80"
						]
					],
					[
						"([58]00)(\\d{6})",
						"$1 $2",
						[
							"[58]00"
						]
					]
				],
				"0",
				"0$1",
				null,
				null,
				null,
				null,
				[
					"1534\\d{6}",
					"7(?:509\\d|7(?:00[378]|97[7-9])|829\\d|937\\d)\\d{5}",
					"80(?:07(?:35|81)|8901)\\d{4}",
					"(?:871206|90(?:066[59]|1810|71(?:07|55)))\\d{4}",
					"701511\\d{4}",
					null,
					"3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))\\d{4}|55\\d{8}",
					"76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}",
					"56\\d{8}",
					"8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|70002)\\d{4}"
				]
			],
			"JM": [
				"1",
				"[589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"876"
			],
			"JO": [
				"962",
				"[235-9]\\d{7,8}",
				[
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2356]|87"
						],
						"(0$1)"
					],
					[
						"(7)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"7[457-9]"
						]
					],
					[
						"(\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"70|8[0158]|9"
						]
					]
				],
				"0",
				"0$1"
			],
			"JP": [
				"81",
				"[1-9]\\d{8,9}|00(?:[36]\\d{7,14}|7\\d{5,7}|8\\d{7})",
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1-$2-$3",
						[
							"(?:12|57|99)0"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"800"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1-$2-$3",
						[
							"[2579]0|80[1-9]"
						]
					],
					[
						"(\\d{4})(\\d)(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|5(?:76|97)|499|746|8(?:3[89]|63|47|51)|9(?:49|80|9[16])",
							"1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:76|97)9|499[2468]|7468|8(?:3(?:8[78]|96)|636|477|51[24])|9(?:496|802|9(?:1[23]|69))",
							"1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|5(?:769|979[2-69])|499[2468]|7468|8(?:3(?:8[78]|96[2457-9])|636[2-57-9]|477|51[24])|9(?:496|802|9(?:1[23]|69))"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])",
							"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:7[2-6]|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|[4-7]))",
							"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6[56]))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))",
							"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:5[78]|7[2-4]|[0468][2-9])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[89][2-8]|[4-7]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:[3578]|20|4[04-9]|6(?:5[25]|60)))|3(?:7(?:[2-5]|6[0-59])|[3-6][2-9]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5(?:[2-589]|39)|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93)",
							"1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93[34])",
							"1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:[68]|20|9[178])|64|7[347])|5(?:[2-589]|39[67])|60|8(?:[46-9]|3[279]|2[124589])|9(?:[235-8]|93(?:31|4))"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{4})",
						"$1-$2-$3",
						[
							"2(?:9[14-79]|74|[34]7|[56]9)|82|993"
						]
					],
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1-$2-$3",
						[
							"3|4(?:2[09]|7[01])|6[1-9]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[2479][1-9]"
						]
					]
				],
				"0",
				"0$1"
			],
			"KE": [
				"254",
				"20\\d{6,7}|[4-9]\\d{6,9}",
				[
					[
						"(\\d{2})(\\d{5,7})",
						"$1 $2",
						[
							"[24-6]"
						]
					],
					[
						"(\\d{3})(\\d{6})",
						"$1 $2",
						[
							"7"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[89]"
						]
					]
				],
				"0",
				"0$1",
				"005|0"
			],
			"KG": [
				"996",
				"[235-8]\\d{8,9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[25-7]|31[25]"
						]
					],
					[
						"(\\d{4})(\\d{5})",
						"$1 $2",
						[
							"3(?:1[36]|[2-9])"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d)(\\d{3})",
						"$1 $2 $3 $4",
						[
							"8"
						]
					]
				],
				"0",
				"0$1"
			],
			"KH": [
				"855",
				"[1-9]\\d{7,9}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"1\\d[1-9]|[2-9]"
						],
						"0$1"
					],
					[
						"(1[89]00)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[89]0"
						]
					]
				],
				"0"
			],
			"KI": [
				"686",
				"[2458]\\d{4}|3\\d{4,7}|7\\d{7}",
				[],
				null,
				null,
				"0"
			],
			"KM": [
				"269",
				"[3478]\\d{6}",
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3"
					]
				]
			],
			"KN": [
				"1",
				"[589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"869"
			],
			"KP": [
				"850",
				"1\\d{9}|[28]\\d{7}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8"
						]
					]
				],
				"0",
				"0$1"
			],
			"KR": [
				"82",
				"007\\d{9,11}|[1-7]\\d{3,9}|8\\d{8}",
				[
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:0|1[19]|[69]9|5[458])|[57]0",
							"1(?:0|1[19]|[69]9|5(?:44|59|8))|[57]0"
						]
					],
					[
						"(\\d{2})(\\d{3,4})(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:[01]|5[1-4]|6[2-8]|[7-9])|[68]0|[3-6][1-9][1-9]",
							"1(?:[01]|5(?:[1-3]|4[56])|6[2-8]|[7-9])|[68]0|[3-6][1-9][1-9]"
						]
					],
					[
						"(\\d{3})(\\d)(\\d{4})",
						"$1-$2-$3",
						[
							"131",
							"1312"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{4})",
						"$1-$2-$3",
						[
							"131",
							"131[13-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"13[2-9]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3-$4",
						[
							"30"
						]
					],
					[
						"(\\d)(\\d{3,4})(\\d{4})",
						"$1-$2-$3",
						[
							"2[1-9]"
						]
					],
					[
						"(\\d)(\\d{3,4})",
						"$1-$2",
						[
							"21[0-46-9]"
						]
					],
					[
						"(\\d{2})(\\d{3,4})",
						"$1-$2",
						[
							"[3-6][1-9]1",
							"[3-6][1-9]1(?:[0-46-9])"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1-$2",
						[
							"1(?:5[246-9]|6[04678]|8[03579])",
							"1(?:5(?:22|44|66|77|88|99)|6(?:00|44|6[16]|70|88)|8(?:00|33|55|77|99))"
						],
						"$1"
					]
				],
				"0",
				"0$1",
				"0(8[1-46-8]|85\\d{2})?"
			],
			"KW": [
				"965",
				"[12569]\\d{6,7}",
				[
					[
						"(\\d{4})(\\d{3,4})",
						"$1 $2",
						[
							"[16]|2(?:[0-35-9]|4[0-35-9])|9[024-9]|52[25]"
						]
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"244|5(?:[015]|66)"
						]
					]
				]
			],
			"KY": [
				"1",
				"[3589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"345"
			],
			"KZ": [
				"7",
				"(?:33\\d|7\\d{2}|80[09])\\d{7}",
				[
					[
						"([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"[34689]"
						]
					],
					[
						"(7\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						]
					]
				],
				"8",
				null,
				null,
				null,
				null,
				null,
				[
					"33622\\d{5}|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[234]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[234]\\d|5[139])|4(?:2\\d|3[1235-9]|59)|5(?:[23]\\d|4[01246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59)))\\d{5}",
					"7(?:0[012578]|47|6[02-4]|7[15-8]|85)\\d{7}",
					"800\\d{7}",
					"809\\d{7}",
					null,
					null,
					null,
					null,
					"751\\d{7}"
				]
			],
			"LA": [
				"856",
				"[2-8]\\d{7,9}",
				[
					[
						"(20)(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"20"
						]
					],
					[
						"([2-8]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2[13]|3[14]|[4-8]"
						]
					],
					[
						"(30)(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"30"
						]
					]
				],
				"0",
				"0$1"
			],
			"LB": [
				"961",
				"[13-9]\\d{6,7}",
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[13-6]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]|9"
						],
						"0$1"
					],
					[
						"([7-9]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[89][01]|7(?:[01]|6[013-9]|8[89]|9[1-3])"
						]
					]
				],
				"0"
			],
			"LC": [
				"1",
				"[5789]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"758"
			],
			"LI": [
				"423",
				"6\\d{8}|[23789]\\d{6}",
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"[23789]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"6[56]"
						]
					],
					[
						"(69)(7\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"697"
						]
					]
				],
				"0",
				null,
				"0|10(?:01|20|66)"
			],
			"LK": [
				"94",
				"[1-9]\\d{8}",
				[
					[
						"(\\d{2})(\\d{1})(\\d{6})",
						"$1 $2 $3",
						[
							"[1-689]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						]
					]
				],
				"0",
				"0$1"
			],
			"LR": [
				"231",
				"2\\d{7,8}|[378]\\d{8}|4\\d{6}|5\\d{6,8}",
				[
					[
						"(2\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"([4-5])(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[45]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[23578]"
						]
					]
				],
				"0",
				"0$1"
			],
			"LS": [
				"266",
				"[2568]\\d{7}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"LT": [
				"370",
				"[3-9]\\d{7}",
				[
					[
						"([34]\\d)(\\d{6})",
						"$1 $2",
						[
							"37|4(?:1|5[45]|6[2-4])"
						]
					],
					[
						"([3-6]\\d{2})(\\d{5})",
						"$1 $2",
						[
							"3[148]|4(?:[24]|6[09])|528|6"
						]
					],
					[
						"([7-9]\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"[7-9]"
						],
						"8 $1"
					],
					[
						"(5)(2\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"52[0-79]"
						]
					]
				],
				"8",
				"(8-$1)",
				"[08]",
				null,
				true
			],
			"LU": [
				"352",
				"[24-9]\\d{3,10}|3(?:[0-46-9]\\d{2,9}|5[013-9]\\d{1,8})",
				[
					[
						"(\\d{2})(\\d{3})",
						"$1 $2",
						[
							"[2-5]|7[1-9]|[89](?:[1-9]|0[2-9])"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"[2-5]|7[1-9]|[89](?:[1-9]|0[2-9])"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"20"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
						"$1 $2 $3 $4",
						[
							"2(?:[0367]|4[3-8])"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"20"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
						"$1 $2 $3 $4 $5",
						[
							"2(?:[0367]|4[3-8])"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{1,4})",
						"$1 $2 $3 $4",
						[
							"2(?:[12589]|4[12])|[3-5]|7[1-9]|8(?:[1-9]|0[2-9])|9(?:[1-9]|0[2-46-9])"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"70|80[01]|90[015]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"6"
						]
					]
				],
				null,
				null,
				"(15(?:0[06]|1[12]|35|4[04]|55|6[26]|77|88|99)\\d)"
			],
			"LV": [
				"371",
				"[2689]\\d{7}",
				[
					[
						"([2689]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3"
					]
				]
			],
			"LY": [
				"218",
				"[25679]\\d{8}",
				[
					[
						"([25679]\\d)(\\d{7})",
						"$1-$2"
					]
				],
				"0",
				"0$1"
			],
			"MA": [
				"212",
				"[5-9]\\d{8}",
				[
					[
						"([5-7]\\d{2})(\\d{6})",
						"$1-$2",
						[
							"5(?:2[015-7]|3[0-4])|[67]"
						]
					],
					[
						"([58]\\d{3})(\\d{5})",
						"$1-$2",
						[
							"5(?:2[2-489]|3[5-9]|92)|892",
							"5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"
						]
					],
					[
						"(5\\d{4})(\\d{4})",
						"$1-$2",
						[
							"5(?:29|38)",
							"5(?:29|38)[89]"
						]
					],
					[
						"([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"5(?:4[067]|5[03])"
						]
					],
					[
						"(8[09])(\\d{7})",
						"$1-$2",
						[
							"8(?:0|9[013-9])"
						]
					]
				],
				"0",
				"0$1",
				null,
				null,
				null,
				null,
				[
					"5(?:2(?:[015-79]\\d|2[02-9]|3[2-57]|4[2-8]|8[235-7])\\d|3(?:[0-48]\\d|[57][2-9]|6[2-8]|9[3-9])\\d|4[067]\\d{2}|5[03]\\d{2})\\d{4}",
					"(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[07][07]|6[12]))\\d{6}",
					"80\\d{7}",
					"89\\d{7}",
					null,
					null,
					null,
					null,
					"5924[01]\\d{4}"
				]
			],
			"MC": [
				"377",
				"[34689]\\d{7,8}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[39]"
						],
						"$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"4"
						]
					],
					[
						"(6)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						[
							"6"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{2})",
						"$1 $2 $3",
						[
							"8"
						],
						"$1"
					]
				],
				"0",
				"0$1"
			],
			"MD": [
				"373",
				"[235-9]\\d{7}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"22|3"
						]
					],
					[
						"([25-7]\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"2[13-9]|[5-7]"
						]
					],
					[
						"([89]\\d{2})(\\d{5})",
						"$1 $2",
						[
							"[89]"
						]
					]
				],
				"0",
				"0$1"
			],
			"ME": [
				"382",
				"[2-9]\\d{7,8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2-57-9]|6[036-9]"
						]
					]
				],
				"0",
				"0$1"
			],
			"MF": [
				"590",
				"[56]\\d{8}",
				[
					[
						"([56]90)(\\d{2})(\\d{4})",
						"$1 $2-$3"
					]
				],
				"0",
				null,
				null,
				null,
				null,
				null,
				[
					"590(?:[02][79]|13|5[0-268]|[78]7)\\d{4}",
					"690(?:0[0-7]|[1-9]\\d)\\d{4}"
				]
			],
			"MG": [
				"261",
				"[23]\\d{8}",
				[
					[
						"([23]\\d)(\\d{2})(\\d{3})(\\d{2})",
						"$1 $2 $3 $4"
					]
				],
				"0",
				"0$1"
			],
			"MH": [
				"692",
				"[2-6]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1-$2"
					]
				],
				"1"
			],
			"MK": [
				"389",
				"[2-578]\\d{7}",
				[
					[
						"(2)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"([347]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[347]"
						]
					],
					[
						"([58]\\d{2})(\\d)(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[58]"
						]
					]
				],
				"0",
				"0$1"
			],
			"ML": [
				"223",
				"[246-9]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[246-9]"
						]
					]
				]
			],
			"MM": [
				"95",
				"[1478]\\d{5,7}|[256]\\d{5,8}|9(?:[279]\\d{0,2}|[58]|[34]\\d{1,2}|6\\d?)\\d{6}",
				[
					[
						"(\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"1|2[245]"
						]
					],
					[
						"(2)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"251"
						]
					],
					[
						"(\\d)(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"16|2"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"67|81"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[4-8]"
						]
					],
					[
						"(9)(\\d{3})(\\d{4,6})",
						"$1 $2 $3",
						[
							"9(?:2[0-4]|[35-9]|4[137-9])"
						]
					],
					[
						"(9)([34]\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"9(?:3[0-36]|4[0-57-9])"
						]
					],
					[
						"(9)(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"92[56]"
						]
					],
					[
						"(9)(\\d{3})(\\d{3})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"93"
						]
					]
				],
				"0",
				"0$1"
			],
			"MN": [
				"976",
				"[12]\\d{7,9}|[57-9]\\d{7}",
				[
					[
						"([12]\\d)(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[12]1"
						]
					],
					[
						"([12]2\\d)(\\d{5,6})",
						"$1 $2",
						[
							"[12]2[1-3]"
						]
					],
					[
						"([12]\\d{3})(\\d{5})",
						"$1 $2",
						[
							"[12](?:27|[3-5])",
							"[12](?:27|[3-5]\\d)2"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[57-9]"
						],
						"$1"
					],
					[
						"([12]\\d{4})(\\d{4,5})",
						"$1 $2",
						[
							"[12](?:27|[3-5])",
							"[12](?:27|[3-5]\\d)[4-9]"
						]
					]
				],
				"0",
				"0$1"
			],
			"MO": [
				"853",
				"[268]\\d{7}",
				[
					[
						"([268]\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"MP": [
				"1",
				"[5689]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"670"
			],
			"MQ": [
				"596",
				"[56]\\d{8}",
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				],
				"0",
				"0$1"
			],
			"MR": [
				"222",
				"[2-48]\\d{7}",
				[
					[
						"([2-48]\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"MS": [
				"1",
				"[5689]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"664"
			],
			"MT": [
				"356",
				"[2357-9]\\d{7}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"MU": [
				"230",
				"[2-9]\\d{6,7}",
				[
					[
						"([2-46-9]\\d{2})(\\d{4})",
						"$1 $2",
						[
							"[2-46-9]"
						]
					],
					[
						"(5\\d{3})(\\d{4})",
						"$1 $2",
						[
							"5"
						]
					]
				]
			],
			"MV": [
				"960",
				"[346-8]\\d{6,9}|9(?:00\\d{7}|\\d{6})",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"[3467]|9(?:[1-9]|0[1-9])"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[89]00"
						]
					]
				]
			],
			"MW": [
				"265",
				"(?:1(?:\\d{2})?|[2789]\\d{2})\\d{6}",
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"(2\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[1789]"
						]
					]
				],
				"0",
				"0$1"
			],
			"MX": [
				"52",
				"[1-9]\\d{9,10}",
				[
					[
						"([358]\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"33|55|81"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"
						]
					],
					[
						"(1)([358]\\d)(\\d{4})(\\d{4})",
						"044 $2 $3 $4",
						[
							"1(?:33|55|81)"
						],
						"$1",
						null,
						"$1 $2 $3 $4"
					],
					[
						"(1)(\\d{3})(\\d{3})(\\d{4})",
						"044 $2 $3 $4",
						[
							"1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"
						],
						"$1",
						null,
						"$1 $2 $3 $4"
					]
				],
				"01",
				"01 $1",
				"0[12]|04[45](\\d{10})",
				"1$1",
				true
			],
			"MY": [
				"60",
				"[13-9]\\d{7,9}",
				[
					[
						"([4-79])(\\d{3})(\\d{4})",
						"$1-$2 $3",
						[
							"[4-79]"
						],
						"0$1"
					],
					[
						"(3)(\\d{4})(\\d{4})",
						"$1-$2 $3",
						[
							"3"
						],
						"0$1"
					],
					[
						"([18]\\d)(\\d{3})(\\d{3,4})",
						"$1-$2 $3",
						[
							"1[02-46-9][1-9]|8"
						],
						"0$1"
					],
					[
						"(1)([36-8]00)(\\d{2})(\\d{4})",
						"$1-$2-$3-$4",
						[
							"1[36-8]0"
						]
					],
					[
						"(11)(\\d{4})(\\d{4})",
						"$1-$2 $3",
						[
							"11"
						],
						"0$1"
					],
					[
						"(15[49])(\\d{3})(\\d{4})",
						"$1-$2 $3",
						[
							"15"
						],
						"0$1"
					]
				],
				"0"
			],
			"MZ": [
				"258",
				"[28]\\d{7,8}",
				[
					[
						"([28]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"2|8[2-7]"
						]
					],
					[
						"(80\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"80"
						]
					]
				]
			],
			"NA": [
				"264",
				"[68]\\d{7,8}",
				[
					[
						"(8\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8[1235]"
						]
					],
					[
						"(6\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"6"
						]
					],
					[
						"(88)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"88"
						]
					],
					[
						"(870)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"870"
						]
					]
				],
				"0",
				"0$1"
			],
			"NC": [
				"687",
				"[2-57-9]\\d{5}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1.$2.$3",
						[
							"[2-46-9]|5[0-4]"
						]
					]
				]
			],
			"NE": [
				"227",
				"[0289]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[289]|09"
						]
					],
					[
						"(08)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"08"
						]
					]
				]
			],
			"NF": [
				"672",
				"[13]\\d{5}",
				[
					[
						"(\\d{2})(\\d{4})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(\\d)(\\d{5})",
						"$1 $2",
						[
							"3"
						]
					]
				]
			],
			"NG": [
				"234",
				"[1-6]\\d{5,8}|9\\d{5,9}|[78]\\d{5,13}",
				[
					[
						"(\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[12]|9(?:0[3-9]|[1-9])"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{2,3})",
						"$1 $2 $3",
						[
							"[3-6]|7(?:[1-79]|0[1-9])|8[2-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"70|8[01]|90[235-9]"
						]
					],
					[
						"([78]00)(\\d{4})(\\d{4,5})",
						"$1 $2 $3",
						[
							"[78]00"
						]
					],
					[
						"([78]00)(\\d{5})(\\d{5,6})",
						"$1 $2 $3",
						[
							"[78]00"
						]
					],
					[
						"(78)(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"78"
						]
					]
				],
				"0",
				"0$1"
			],
			"NI": [
				"505",
				"[12578]\\d{7}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"NL": [
				"31",
				"1\\d{4,8}|[2-7]\\d{8}|[89]\\d{6,9}",
				[
					[
						"([1-578]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1[035]|2[0346]|3[03568]|4[0356]|5[0358]|7|8[4578]"
						]
					],
					[
						"([1-5]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
						]
					],
					[
						"(6)(\\d{8})",
						"$1 $2",
						[
							"6[0-57-9]"
						]
					],
					[
						"(66)(\\d{7})",
						"$1 $2",
						[
							"66"
						]
					],
					[
						"(14)(\\d{3,4})",
						"$1 $2",
						[
							"14"
						],
						"$1"
					],
					[
						"([89]0\\d)(\\d{4,7})",
						"$1 $2",
						[
							"80|9"
						]
					]
				],
				"0",
				"0$1"
			],
			"NO": [
				"47",
				"0\\d{4}|[2-9]\\d{7}",
				[
					[
						"([489]\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"[489]"
						]
					],
					[
						"([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[235-7]"
						]
					]
				],
				null,
				null,
				null,
				null,
				null,
				null,
				[
					"(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",
					"(?:4[015-8]|5[89]|87|9\\d)\\d{6}",
					"80[01]\\d{5}",
					"82[09]\\d{5}",
					"880\\d{5}",
					"81[23]\\d{5}",
					"0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}",
					null,
					"85[0-5]\\d{5}",
					"810(?:0[0-6]|[2-8]\\d)\\d{3}"
				]
			],
			"NP": [
				"977",
				"[1-8]\\d{7}|9(?:[1-69]\\d{6,8}|7[2-6]\\d{5,7}|8\\d{8})",
				[
					[
						"(1)(\\d{7})",
						"$1-$2",
						[
							"1[2-6]"
						]
					],
					[
						"(\\d{2})(\\d{6})",
						"$1-$2",
						[
							"1[01]|[2-8]|9(?:[1-69]|7[15-9])"
						]
					],
					[
						"(9\\d{2})(\\d{7})",
						"$1-$2",
						[
							"9(?:6[013]|7[245]|8)"
						],
						"$1"
					]
				],
				"0",
				"0$1"
			],
			"NR": [
				"674",
				"[458]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"NU": [
				"683",
				"[1-5]\\d{3}"
			],
			"NZ": [
				"64",
				"6[235-9]\\d{6}|[2-57-9]\\d{7,10}",
				[
					[
						"([34679])(\\d{3})(\\d{4})",
						"$1-$2 $3",
						[
							"[346]|7[2-57-9]|9[1-9]"
						]
					],
					[
						"(24099)(\\d{3})",
						"$1 $2",
						[
							"240",
							"2409",
							"24099"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"21"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,5})",
						"$1 $2 $3",
						[
							"2(?:1[1-9]|[69]|7[0-35-9])|70|86"
						]
					],
					[
						"(2\\d)(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"2[028]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"2(?:10|74)|5|[89]0"
						]
					]
				],
				"0",
				"0$1"
			],
			"OM": [
				"968",
				"(?:5|[279]\\d)\\d{6}|800\\d{5,6}",
				[
					[
						"(2\\d)(\\d{6})",
						"$1 $2",
						[
							"2"
						]
					],
					[
						"([79]\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[79]"
						]
					],
					[
						"([58]00)(\\d{4,6})",
						"$1 $2",
						[
							"[58]"
						]
					]
				]
			],
			"PA": [
				"507",
				"[1-9]\\d{6,7}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"[1-57-9]"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1-$2",
						[
							"6"
						]
					]
				]
			],
			"PE": [
				"51",
				"[14-9]\\d{7,8}",
				[
					[
						"(1)(\\d{7})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"([4-8]\\d)(\\d{6})",
						"$1 $2",
						[
							"[4-7]|8[2-4]"
						]
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"80"
						]
					],
					[
						"(9\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"9"
						],
						"$1"
					]
				],
				"0",
				"(0$1)"
			],
			"PF": [
				"689",
				"4\\d{5,7}|8\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"4[09]|8[79]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"44"
						]
					]
				]
			],
			"PG": [
				"675",
				"[1-9]\\d{6,7}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[13-689]|27"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"20|7"
						]
					]
				]
			],
			"PH": [
				"63",
				"2\\d{5,7}|[3-9]\\d{7,9}|1800\\d{7,9}",
				[
					[
						"(2)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2"
						],
						"(0$1)"
					],
					[
						"(2)(\\d{5})",
						"$1 $2",
						[
							"2"
						],
						"(0$1)"
					],
					[
						"(\\d{4})(\\d{4,6})",
						"$1 $2",
						[
							"3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|5(?:22|44)|642|8(?:62|8[245])",
							"3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
						],
						"(0$1)"
					],
					[
						"(\\d{5})(\\d{4})",
						"$1 $2",
						[
							"346|4(?:27|9[35])|883",
							"3469|4(?:279|9(?:30|56))|8834"
						],
						"(0$1)"
					],
					[
						"([3-8]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[3-8]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"81|9"
						],
						"0$1"
					],
					[
						"(1800)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"(1800)(\\d{1,2})(\\d{3})(\\d{4})",
						"$1 $2 $3 $4",
						[
							"1"
						]
					]
				],
				"0"
			],
			"PK": [
				"92",
				"1\\d{8}|[2-8]\\d{5,11}|9(?:[013-9]\\d{4,9}|2\\d(?:111\\d{6}|\\d{3,7}))",
				[
					[
						"(\\d{2})(111)(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)1",
							"(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)11",
							"(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)111"
						]
					],
					[
						"(\\d{3})(111)(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"2[349]|45|54|60|72|8[2-5]|9[2-9]",
							"(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d1",
							"(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d11",
							"(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d111"
						]
					],
					[
						"(\\d{2})(\\d{7,8})",
						"$1 $2",
						[
							"(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
						]
					],
					[
						"(\\d{3})(\\d{6,7})",
						"$1 $2",
						[
							"2[349]|45|54|60|72|8[2-5]|9[2-9]",
							"(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d[2-9]"
						]
					],
					[
						"(3\\d{2})(\\d{7})",
						"$1 $2",
						[
							"3"
						],
						"0$1"
					],
					[
						"([15]\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"58[12]|1"
						]
					],
					[
						"(586\\d{2})(\\d{5})",
						"$1 $2",
						[
							"586"
						]
					],
					[
						"([89]00)(\\d{3})(\\d{2})",
						"$1 $2 $3",
						[
							"[89]00"
						],
						"0$1"
					]
				],
				"0",
				"(0$1)"
			],
			"PL": [
				"48",
				"[12]\\d{6,8}|[3-57-9]\\d{8}|6\\d{5,8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[14]|2[0-57-9]|3[2-4]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"
						]
					],
					[
						"(\\d{2})(\\d{1})(\\d{4})",
						"$1 $2 $3",
						[
							"[12]2"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"26|39|5[0137]|6[0469]|7[02389]|8[08]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2,3})",
						"$1 $2 $3",
						[
							"64"
						]
					],
					[
						"(\\d{3})(\\d{3})",
						"$1 $2",
						[
							"64"
						]
					]
				]
			],
			"PM": [
				"508",
				"[45]\\d{5}",
				[
					[
						"([45]\\d)(\\d{2})(\\d{2})",
						"$1 $2 $3"
					]
				],
				"0",
				"0$1"
			],
			"PR": [
				"1",
				"[5789]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"787|939"
			],
			"PS": [
				"970",
				"[24589]\\d{7,8}|1(?:[78]\\d{8}|[49]\\d{2,3})",
				[
					[
						"([2489])(2\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[2489]"
						]
					],
					[
						"(5[69]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"5"
						]
					],
					[
						"(1[78]00)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[78]"
						],
						"$1"
					]
				],
				"0",
				"0$1"
			],
			"PT": [
				"351",
				"[2-46-9]\\d{8}",
				[
					[
						"(2\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2[12]"
						]
					],
					[
						"([2-46-9]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2[3-9]|[346-9]"
						]
					]
				]
			],
			"PW": [
				"680",
				"[2-8]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"PY": [
				"595",
				"5[0-5]\\d{4,7}|[2-46-9]\\d{5,8}",
				[
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"(?:[26]1|3[289]|4[124678]|7[123]|8[1236])"
						],
						"(0$1)"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"(?:[26]1|3[289]|4[124678]|7[123]|8[1236])"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3,6})",
						"$1 $2",
						[
							"[2-9]0"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{6})",
						"$1 $2",
						[
							"9[1-9]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8700"
						]
					],
					[
						"(\\d{3})(\\d{4,5})",
						"$1 $2",
						[
							"[2-8][1-9]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2-8][1-9]"
						],
						"0$1"
					]
				],
				"0"
			],
			"QA": [
				"974",
				"[2-8]\\d{6,7}",
				[
					[
						"([28]\\d{2})(\\d{4})",
						"$1 $2",
						[
							"[28]"
						]
					],
					[
						"([3-7]\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[3-7]"
						]
					]
				]
			],
			"RE": [
				"262",
				"[268]\\d{8}",
				[
					[
						"([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				],
				"0",
				"0$1",
				null,
				null,
				null,
				"262|6[49]|8"
			],
			"RO": [
				"40",
				"[23]\\d{5,8}|[7-9]\\d{8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[23]1"
						]
					],
					[
						"(\\d{2})(\\d{4})",
						"$1 $2",
						[
							"[23]1"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[23][3-7]|[7-9]"
						]
					],
					[
						"(2\\d{2})(\\d{3})",
						"$1 $2",
						[
							"2[3-6]"
						]
					]
				],
				"0",
				"0$1"
			],
			"RS": [
				"381",
				"[126-9]\\d{4,11}|3(?:[0-79]\\d{3,10}|8[2-9]\\d{2,9})",
				[
					[
						"([23]\\d{2})(\\d{4,9})",
						"$1 $2",
						[
							"(?:2[389]|39)0"
						]
					],
					[
						"([1-3]\\d)(\\d{5,10})",
						"$1 $2",
						[
							"1|2(?:[0-24-7]|[389][1-9])|3(?:[0-8]|9[1-9])"
						]
					],
					[
						"(6\\d)(\\d{6,8})",
						"$1 $2",
						[
							"6"
						]
					],
					[
						"([89]\\d{2})(\\d{3,9})",
						"$1 $2",
						[
							"[89]"
						]
					],
					[
						"(7[26])(\\d{4,9})",
						"$1 $2",
						[
							"7[26]"
						]
					],
					[
						"(7[08]\\d)(\\d{4,9})",
						"$1 $2",
						[
							"7[08]"
						]
					]
				],
				"0",
				"0$1"
			],
			"RU": [
				"7",
				"[3489]\\d{9}",
				[
					[
						"([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"[34689]"
						]
					],
					[
						"(7\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						]
					]
				],
				"8",
				"8 ($1)",
				null,
				null,
				true,
				null,
				[
					"(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",
					"9\\d{9}",
					"80[04]\\d{7}",
					"80[39]\\d{7}"
				]
			],
			"RW": [
				"250",
				"[027-9]\\d{7,8}",
				[
					[
						"(2\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2"
						],
						"$1"
					],
					[
						"([7-9]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[7-9]"
						],
						"0$1"
					],
					[
						"(0\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"0"
						]
					]
				],
				"0"
			],
			"SA": [
				"966",
				"1\\d{7,8}|(?:[2-467]|92)\\d{7}|5\\d{8}|8\\d{9}",
				[
					[
						"([1-467])(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[1-467]"
						]
					],
					[
						"(1\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1[1-467]"
						]
					],
					[
						"(5\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"5"
						]
					],
					[
						"(92\\d{2})(\\d{5})",
						"$1 $2",
						[
							"92"
						],
						"$1"
					],
					[
						"(800)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"80"
						],
						"$1"
					],
					[
						"(811)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"81"
						]
					]
				],
				"0",
				"0$1"
			],
			"SB": [
				"677",
				"[1-9]\\d{4,6}",
				[
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"[7-9]"
						]
					]
				]
			],
			"SC": [
				"248",
				"[24689]\\d{5,6}",
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[246]"
						]
					]
				]
			],
			"SD": [
				"249",
				"[19]\\d{8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3"
					]
				],
				"0",
				"0$1"
			],
			"SE": [
				"46",
				"[1-35-9]\\d{5,11}|4\\d{6,8}",
				[
					[
						"(8)(\\d{2,3})(\\d{2,3})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"8"
						],
						null,
						null,
						"$1 $2 $3 $4"
					],
					[
						"([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"
						],
						null,
						null,
						"$1 $2 $3 $4"
					],
					[
						"([1-469]\\d)(\\d{3})(\\d{2})",
						"$1-$2 $3",
						[
							"1[136]|2[136]|3[356]|4[0246]|6[03]|90"
						],
						null,
						null,
						"$1 $2 $3"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"
						],
						null,
						null,
						"$1 $2 $3 $4"
					],
					[
						"(\\d{3})(\\d{2,3})(\\d{2})",
						"$1-$2 $3",
						[
							"1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"
						],
						null,
						null,
						"$1 $2 $3"
					],
					[
						"(7\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"7"
						],
						null,
						null,
						"$1 $2 $3 $4"
					],
					[
						"(77)(\\d{2})(\\d{2})",
						"$1-$2$3",
						[
							"7"
						],
						null,
						null,
						"$1 $2 $3"
					],
					[
						"(20)(\\d{2,3})(\\d{2})",
						"$1-$2 $3",
						[
							"20"
						],
						null,
						null,
						"$1 $2 $3"
					],
					[
						"(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})",
						"$1-$2 $3 $4",
						[
							"9[034]"
						],
						null,
						null,
						"$1 $2 $3 $4"
					],
					[
						"(9[034]\\d)(\\d{4})",
						"$1-$2",
						[
							"9[034]"
						],
						null,
						null,
						"$1 $2"
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4 $5",
						[
							"25[245]|67[3-6]"
						],
						null,
						null,
						"$1 $2 $3 $4 $5"
					]
				],
				"0",
				"0$1"
			],
			"SG": [
				"65",
				"[36]\\d{7}|[17-9]\\d{7,10}",
				[
					[
						"([3689]\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[369]|8[1-9]"
						]
					],
					[
						"(1[89]00)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1[89]"
						]
					],
					[
						"(7000)(\\d{4})(\\d{3})",
						"$1 $2 $3",
						[
							"70"
						]
					],
					[
						"(800)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"80"
						]
					]
				]
			],
			"SH": [
				"290",
				"[256]\\d{4}",
				[],
				null,
				null,
				null,
				null,
				null,
				null,
				[
					"2(?:[0-57-9]\\d|6[4-9])\\d{2}",
					"[56]\\d{4}",
					null,
					null,
					null,
					null,
					null,
					null,
					"262\\d{2}"
				]
			],
			"SI": [
				"386",
				"[1-7]\\d{6,7}|[89]\\d{4,7}",
				[
					[
						"(\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[12]|3[24-8]|4[24-8]|5[2-8]|7[3-8]"
						],
						"(0$1)"
					],
					[
						"([3-7]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[37][01]|4[0139]|51|6"
						]
					],
					[
						"([89][09])(\\d{3,6})",
						"$1 $2",
						[
							"[89][09]"
						]
					],
					[
						"([58]\\d{2})(\\d{5})",
						"$1 $2",
						[
							"59|8[1-3]"
						]
					]
				],
				"0",
				"0$1"
			],
			"SJ": [
				"47",
				"0\\d{4}|[45789]\\d{7}",
				[
					[
						"([489]\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"[489]"
						]
					],
					[
						"([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[235-7]"
						]
					]
				],
				null,
				null,
				null,
				null,
				null,
				null,
				[
					"79\\d{6}",
					"(?:4[015-8]|5[89]|9\\d)\\d{6}",
					"80[01]\\d{5}",
					"82[09]\\d{5}",
					"880\\d{5}",
					"81[23]\\d{5}",
					"0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}",
					null,
					"85[0-5]\\d{5}",
					"810(?:0[0-6]|[2-8]\\d)\\d{3}"
				]
			],
			"SK": [
				"421",
				"(?:[2-68]\\d{5,8}|9\\d{6,8})",
				[
					[
						"(2)(1[67])(\\d{3,4})",
						"$1 $2 $3",
						[
							"21[67]"
						]
					],
					[
						"([3-5]\\d)(1[67])(\\d{2,3})",
						"$1 $2 $3",
						[
							"[3-5]"
						]
					],
					[
						"(2)(\\d{3})(\\d{3})(\\d{2})",
						"$1/$2 $3 $4",
						[
							"2"
						]
					],
					[
						"([3-5]\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1/$2 $3 $4",
						[
							"[3-5]"
						]
					],
					[
						"([689]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[689]"
						]
					],
					[
						"(9090)(\\d{3})",
						"$1 $2",
						[
							"9090"
						]
					]
				],
				"0",
				"0$1"
			],
			"SL": [
				"232",
				"[2-9]\\d{7}",
				[
					[
						"(\\d{2})(\\d{6})",
						"$1 $2"
					]
				],
				"0",
				"(0$1)"
			],
			"SM": [
				"378",
				"[05-7]\\d{7,9}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[5-7]"
						]
					],
					[
						"(0549)(\\d{6})",
						"$1 $2",
						[
							"0"
						],
						null,
						null,
						"($1) $2"
					],
					[
						"(\\d{6})",
						"0549 $1",
						[
							"[89]"
						],
						null,
						null,
						"(0549) $1"
					]
				],
				null,
				null,
				"(?:0549)?([89]\\d{5})",
				"0549$1"
			],
			"SN": [
				"221",
				"[3789]\\d{8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[379]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"8"
						]
					]
				]
			],
			"SO": [
				"252",
				"[1-9]\\d{5,8}",
				[
					[
						"(\\d{6})",
						"$1",
						[
							"[134]"
						]
					],
					[
						"(\\d)(\\d{6})",
						"$1 $2",
						[
							"2[0-79]|[13-5]"
						]
					],
					[
						"(\\d)(\\d{7})",
						"$1 $2",
						[
							"24|[67]"
						]
					],
					[
						"(\\d{2})(\\d{4})",
						"$1 $2",
						[
							"8[125]"
						]
					],
					[
						"(\\d{2})(\\d{5,7})",
						"$1 $2",
						[
							"15|28|6[1-35-9]|799|9[2-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"3[59]|4[89]|6[24-6]|79|8[08]|90"
						]
					]
				],
				"0"
			],
			"SR": [
				"597",
				"[2-8]\\d{5,6}",
				[
					[
						"(\\d{3})(\\d{3})",
						"$1-$2",
						[
							"[2-4]|5[2-58]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1-$2-$3",
						[
							"56"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"[6-8]"
						]
					]
				]
			],
			"SS": [
				"211",
				"[19]\\d{8}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						null,
						"0$1"
					]
				],
				"0"
			],
			"ST": [
				"239",
				"[29]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"SV": [
				"503",
				"[267]\\d{7}|[89]\\d{6}(?:\\d{4})?",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[267]"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[89]"
						]
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[89]"
						]
					]
				]
			],
			"SX": [
				"1",
				"[5789]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"721"
			],
			"SY": [
				"963",
				"[1-59]\\d{7,8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[1-5]"
						]
					],
					[
						"(9\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"9"
						]
					]
				],
				"0",
				"0$1",
				null,
				null,
				true
			],
			"SZ": [
				"268",
				"[027]\\d{7}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[027]"
						]
					]
				]
			],
			"TA": [
				"290",
				"8\\d{3}",
				[],
				null,
				null,
				null,
				null,
				null,
				null,
				[
					"8\\d{3}"
				]
			],
			"TC": [
				"1",
				"[5689]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"649"
			],
			"TD": [
				"235",
				"[2679]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"TG": [
				"228",
				"[29]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[29]"
						]
					]
				]
			],
			"TH": [
				"66",
				"[2-9]\\d{7,8}|1\\d{3}(?:\\d{5,6})?",
				[
					[
						"(2)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"([13-9]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"14|[3-9]"
						]
					],
					[
						"(1[89]00)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1"
						],
						"$1"
					]
				],
				"0",
				"0$1"
			],
			"TJ": [
				"992",
				"[3-57-9]\\d{8}",
				[
					[
						"([349]\\d{2})(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[34]7|91[78]"
						]
					],
					[
						"([457-9]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"4[148]|[578]|9(?:1[59]|[0235-9])"
						]
					],
					[
						"(331700)(\\d)(\\d{2})",
						"$1 $2 $3",
						[
							"331",
							"3317",
							"33170",
							"331700"
						]
					],
					[
						"(\\d{4})(\\d)(\\d{4})",
						"$1 $2 $3",
						[
							"3[1-5]",
							"3(?:[1245]|3(?:[02-9]|1[0-589]))"
						]
					]
				],
				"8",
				"$1",
				null,
				null,
				true
			],
			"TK": [
				"690",
				"[2-47]\\d{3,6}"
			],
			"TL": [
				"670",
				"[2-489]\\d{6}|7\\d{6,7}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[2-489]"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"7"
						]
					]
				]
			],
			"TM": [
				"993",
				"[1-6]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"12"
						]
					],
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"6"
						],
						"8 $1"
					],
					[
						"(\\d{3})(\\d)(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"13|[2-5]"
						]
					]
				],
				"8",
				"(8 $1)"
			],
			"TN": [
				"216",
				"[2-57-9]\\d{7}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3"
					]
				]
			],
			"TO": [
				"676",
				"[02-8]\\d{4,6}",
				[
					[
						"(\\d{2})(\\d{3})",
						"$1-$2",
						[
							"[1-6]|7[0-4]|8[05]"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"7[5-9]|8[47-9]"
						]
					],
					[
						"(\\d{4})(\\d{3})",
						"$1 $2",
						[
							"0"
						]
					]
				]
			],
			"TR": [
				"90",
				"[2-589]\\d{9}|444\\d{4}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[23]|4(?:[0-35-9]|4[0-35-9])"
						],
						"(0$1)",
						"true"
					],
					[
						"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"5[02-69]"
						],
						"0$1",
						"true"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"51|[89]"
						],
						"0$1",
						"true"
					],
					[
						"(444)(\\d{1})(\\d{3})",
						"$1 $2 $3",
						[
							"444"
						]
					]
				],
				"0"
			],
			"TT": [
				"1",
				"[589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"868"
			],
			"TV": [
				"688",
				"[279]\\d{4,6}"
			],
			"TW": [
				"886",
				"2\\d{6,8}|[3-689]\\d{7,8}|7\\d{7,9}",
				[
					[
						"(20)(\\d)(\\d{4})",
						"$1 $2 $3",
						[
							"202"
						]
					],
					[
						"(20)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"20[013-9]"
						]
					],
					[
						"([2-8])(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"2[23-8]|[3-6]|[78][1-9]"
						]
					],
					[
						"([89]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"80|9"
						]
					],
					[
						"(70)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"70"
						]
					]
				],
				"0",
				"0$1"
			],
			"TZ": [
				"255",
				"\\d{9}",
				[
					[
						"([24]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[24]"
						]
					],
					[
						"([67]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[67]"
						]
					],
					[
						"([89]\\d{2})(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[89]"
						]
					]
				],
				"0",
				"0$1"
			],
			"UA": [
				"380",
				"[3-9]\\d{8}",
				[
					[
						"([3-9]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[38]9|4(?:[45][0-5]|87)|5(?:0|6[37]|7[37])|6[36-8]|7|9[1-9]",
							"[38]9|4(?:[45][0-5]|87)|5(?:0|6(?:3[14-7]|7)|7[37])|6[36-8]|7|9[1-9]"
						]
					],
					[
						"([3-689]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"3[1-8]2|4[13678]2|5(?:[12457]2|6[24])|6(?:[49]2|[12][29]|5[24])|8[0-8]|90",
							"3(?:[1-46-8]2[013-9]|52)|4(?:[1378]2|62[013-9])|5(?:[12457]2|6[24])|6(?:[49]2|[12][29]|5[24])|8[0-8]|90"
						]
					],
					[
						"([3-6]\\d{3})(\\d{5})",
						"$1 $2",
						[
							"3(?:5[013-9]|[1-46-8])|4(?:[137][013-9]|6|[45][6-9]|8[4-6])|5(?:[1245][013-9]|6[0135-9]|3|7[4-6])|6(?:[49][013-9]|5[0135-9]|[12][13-8])",
							"3(?:5[013-9]|[1-46-8](?:22|[013-9]))|4(?:[137][013-9]|6(?:[013-9]|22)|[45][6-9]|8[4-6])|5(?:[1245][013-9]|6(?:3[02389]|[015689])|3|7[4-6])|6(?:[49][013-9]|5[0135-9]|[12][13-8])"
						]
					]
				],
				"0",
				"0$1"
			],
			"UG": [
				"256",
				"\\d{9}",
				[
					[
						"(\\d{3})(\\d{6})",
						"$1 $2",
						[
							"[7-9]|20(?:[013-8]|2[5-9])|4(?:6[45]|[7-9])"
						]
					],
					[
						"(\\d{2})(\\d{7})",
						"$1 $2",
						[
							"3|4(?:[1-5]|6[0-36-9])"
						]
					],
					[
						"(2024)(\\d{5})",
						"$1 $2",
						[
							"2024"
						]
					]
				],
				"0",
				"0$1"
			],
			"US": [
				"1",
				"[2-9]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				true,
				null,
				[
					"(?:2(?:0[1-35-9]|1[02-9]|2[04589]|3[149]|4[08]|5[1-46]|6[0279]|7[026]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[014679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-37]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[012])|7(?:0[1-46-8]|1[02-9]|2[0457]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-25]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[014678]|4[0179]|5[12469]|7[0-3589]|8[0459]))[2-9]\\d{6}",
					null,
					"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
					"900[2-9]\\d{6}",
					"5(?:00|22|33|44|66|77|88)[2-9]\\d{6}"
				]
			],
			"UY": [
				"598",
				"[2489]\\d{6,7}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[24]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"9[1-9]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[89]0"
						],
						"0$1"
					]
				],
				"0"
			],
			"UZ": [
				"998",
				"[679]\\d{8}",
				[
					[
						"([679]\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				],
				"8",
				"8 $1"
			],
			"VA": [
				"39",
				"(?:0(?:878\\d{5}|6698\\d{5})|[1589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9}))",
				[
					[
						"(\\d{2})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"0[26]|55"
						]
					],
					[
						"(0[26])(\\d{4})(\\d{5})",
						"$1 $2 $3",
						[
							"0[26]"
						]
					],
					[
						"(0[26])(\\d{4,6})",
						"$1 $2",
						[
							"0[26]"
						]
					],
					[
						"(0\\d{2})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"0[13-57-9][0159]"
						]
					],
					[
						"(\\d{3})(\\d{3,6})",
						"$1 $2",
						[
							"0[13-57-9][0159]|8(?:03|4[17]|9[245])",
							"0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"
						]
					],
					[
						"(0\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"0[13-57-9][2-46-8]"
						]
					],
					[
						"(0\\d{3})(\\d{2,6})",
						"$1 $2",
						[
							"0[13-57-9][2-46-8]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[13]|8(?:00|4[08]|9[59])",
							"[13]|8(?:00|4[08]|9(?:5[5-9]|9))"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"894",
							"894[5-9]"
						]
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"3"
						]
					]
				],
				null,
				null,
				null,
				null,
				null,
				null,
				[
					"06698\\d{5}",
					"3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})",
					"80(?:0\\d{6}|3\\d{3})",
					"0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})",
					"1(?:78\\d|99)\\d{6}",
					null,
					null,
					null,
					"55\\d{8}",
					"84(?:[08]\\d{6}|[17]\\d{3})"
				]
			],
			"VC": [
				"1",
				"[5789]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"784"
			],
			"VE": [
				"58",
				"[24589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{7})",
						"$1-$2"
					]
				],
				"0",
				"0$1"
			],
			"VG": [
				"1",
				"[2589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"284"
			],
			"VI": [
				"1",
				"[3589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"340"
			],
			"VN": [
				"84",
				"[167]\\d{6,9}|[2-59]\\d{7,9}|8\\d{6,8}",
				[
					[
						"([17]99)(\\d{4})",
						"$1 $2",
						[
							"[17]99"
						]
					],
					[
						"([48])(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"4|8(?:[1-57]|[689][0-79])"
						]
					],
					[
						"([235-7]\\d)(\\d{4})(\\d{3})",
						"$1 $2 $3",
						[
							"2[025-79]|3[0136-9]|5[2-9]|6[0-46-8]|7[02-79]"
						]
					],
					[
						"(80)(\\d{5})",
						"$1 $2",
						[
							"80"
						]
					],
					[
						"(69\\d)(\\d{4,5})",
						"$1 $2",
						[
							"69"
						]
					],
					[
						"([235-7]\\d{2})(\\d{4})(\\d{3})",
						"$1 $2 $3",
						[
							"2[1348]|3[25]|5[01]|65|7[18]"
						]
					],
					[
						"([89]\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"8[689]8|9"
						]
					],
					[
						"(1[2689]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:[26]|8[68]|99)"
						]
					],
					[
						"(1[89]00)(\\d{4,6})",
						"$1 $2",
						[
							"1[89]0"
						],
						"$1"
					]
				],
				"0",
				"0$1",
				null,
				null,
				true
			],
			"VU": [
				"678",
				"[2-57-9]\\d{4,6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[579]"
						]
					]
				]
			],
			"WF": [
				"681",
				"[4-8]\\d{5}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3"
					]
				]
			],
			"WS": [
				"685",
				"[2-8]\\d{4,6}",
				[
					[
						"(8\\d{2})(\\d{3,4})",
						"$1 $2",
						[
							"8"
						]
					],
					[
						"(7\\d)(\\d{5})",
						"$1 $2",
						[
							"7"
						]
					],
					[
						"(\\d{5})",
						"$1",
						[
							"[2-6]"
						]
					]
				]
			],
			"YE": [
				"967",
				"[1-7]\\d{6,8}",
				[
					[
						"([1-7])(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[1-6]|7[24-68]"
						]
					],
					[
						"(7\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"7[0137]"
						]
					]
				],
				"0",
				"0$1"
			],
			"YT": [
				"262",
				"[268]\\d{8}",
				[
					[
						"([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				],
				"0",
				"0$1",
				null,
				null,
				null,
				"269|63"
			],
			"ZA": [
				"27",
				"[1-79]\\d{8}|8\\d{4,8}",
				[
					[
						"(860)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"860"
						]
					],
					[
						"(\\d{2})(\\d{3,4})",
						"$1 $2",
						[
							"8[1-4]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{2,3})",
						"$1 $2 $3",
						[
							"8[1-4]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[1-79]|8(?:[0-57]|6[1-9])"
						]
					]
				],
				"0",
				"0$1"
			],
			"ZM": [
				"260",
				"[289]\\d{8}",
				[
					[
						"([29]\\d)(\\d{7})",
						"$1 $2",
						[
							"[29]"
						]
					],
					[
						"(800)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8"
						]
					]
				],
				"0",
				"0$1"
			],
			"ZW": [
				"263",
				"2(?:[012457-9]\\d{3,8}|6(?:[14]\\d{7}|\\d{4}))|[13-79]\\d{4,9}|8[06]\\d{8}",
				[
					[
						"([49])(\\d{3})(\\d{2,4})",
						"$1 $2 $3",
						[
							"4|9[2-9]"
						]
					],
					[
						"(7\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"7"
						]
					],
					[
						"(86\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"86[24]"
						]
					],
					[
						"([2356]\\d{2})(\\d{3,5})",
						"$1 $2",
						[
							"2(?:0[45]|2[278]|[49]8|[78])|3(?:08|17|3[78]|7[1569]|8[37]|98)|5[15][78]|6(?:[29]8|[38]7|6[78]|75|[89]8)"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"2(?:1[39]|2[0157]|6[14]|7[35]|84)|329"
						]
					],
					[
						"([1-356]\\d)(\\d{3,5})",
						"$1 $2",
						[
							"1[3-9]|2[0569]|3[0-69]|5[05689]|6[0-46-9]"
						]
					],
					[
						"([235]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[23]9|54"
						]
					],
					[
						"([25]\\d{3})(\\d{3,5})",
						"$1 $2",
						[
							"(?:25|54)8",
							"258[23]|5483"
						]
					],
					[
						"(8\\d{3})(\\d{6})",
						"$1 $2",
						[
							"86"
						]
					],
					[
						"(80\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"80"
						]
					]
				],
				"0",
				"0$1"
			],
			"001": [
				"979",
				"\\d{9}",
				[
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3"
					]
				]
			]
		}
	};

/***/ },
/* 1117 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(523);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(523);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 1120 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/default_continent.2aeac727.jpg";

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/default_country.cfd88ac9.jpg";

/***/ },
/* 1123 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/adminBackgroundImage.4ef8252d.png";

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/intro-image.eb2a905b.png";

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/intro-video.018e61db.mp4";

/***/ },
/* 1127 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA3CAYAAABZ0InLAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACXBIWXMAAAsTAAALEwEAmpwYAAABWWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgpMwidZAAAUuUlEQVRoBb2aCZRVxZnHa7nvve7XC9K4EUERCSi748YiKKPmZEQniXFJ1ERzMtHJUZMRzbhkMrZmnImAmnjOzBgziY5HjcKM43HixhhFWUUR2QQEd0DZ7e31W25Vze+7rx9ptqbbCNV93323btVX3//b6quqp9UXUIJSWsmHTojxbdcyo3FY+jCl0tUNtUbetG9v9XV9qwonX724tGtLlZCRDyjK/x60dm+/v+cyS/trtY/3gqkD2E5G5t41pE7r1OHK6KN4fbjWvl55naVBWhudAAyeP6WKDN5GVZOL1Wab0etTWbsZ0LnKcCEgszKHO+lX3nX3HnW34W7tdGMjgzcqL2Kef8/YaheaB0cqOh7O+4Xge+lg0kEFE4LRGkYV0IBVZpca7XlGPNy8ibwPJVXMN/sd8+4e+bELblWfVrVO65VFGZexDBdNe17KA/agX+fB/u8XJ/WqTsV/oXwYBYTDdAgWLFawwHwJ7tuMCk3e6FZtVZt2IU6G8jYVlKuhWZ3Sph711GAJKQNghAIQHUPrE5tSb7pQ+9a4KQvapV+HRnukzR4BrAzwcuOZUXXtjjFxCGMB09ujEFQEfz5Pm/Vw+L5R+tNM8O05EzJWpWpgPAPqSKkY1Yc45dJ5Z+NWVfJxHOlspG1fNDwQQR1Fg1Tw3mPSHgY3u1KYO+GW5YsFZGcBy/P+SrcAIjJxhURy86afcExQ9q9MMEdTgW3plFV+B03eUlG0LuXiqtiogYAZGkI4WgQA01mAp3m2whCO5XhOfFDpsA1b/VCbsFK58IFTRkxxiLZ6JPc6QMfiuZj0mji2z028dckWIcElZb/arDQsN9/LZ2dw86eOOANdTYI5MSfGDO3obb425l0Vu0GAnYQkjofMIVwCxnT09/RxvHMyBN8t3y2DCxpxTEipGC1vp365DvYllVIbADccRZ6KQCx9wKxaGf+5cTcsXdJBR4JQlyD3B1DeBwkiodQ2GXZPDsoUIZrRwS81Gf2qb1dDglEX0HCwMA0jWKeKed4Kg++D7ENj7Cb6NqOhxAdpl0IYveDtSPg+Fg0dg+f1oY/EWTCFGCBLjdUzQbA5OPcVyB7HmAWUFxnrZ4+ZsmJWApIK+u0TJO/2XURq9A6v3TP8ZOf1pcGbNomGJgp/CN5t0z66gog5RiiIlL1XLYz1OtpdqKKABqLeBIsjeX0UAA6lUVZiCCprQwib8duNAN9ofNwaezMAGuPofyLGUUUfMVUH6y9672ZEkR7igj4Lfgq8SBOZF2bq08/ubS6l387SJcBKKwG6YPqorzPmcPzoMVzpaGPCtbyv55m3+FNQzwHmJQTcgPGeTeVExHocA/SCaRgmjvLRQVO6YbK6nd47YHotr/5INH7FRXEh8uar4gpJW9yB+wbs95fQja0yFwA6hbAsFvLg6TctW1NRRAftXW6VAXep7PzQ4UPhjV+flGppyvdJaTsZIJcwu5WQZBUEFsfaPWSDPRLJX03fiVz1XOhafDCIWbXQrgVaebQLDlUNqDqe6xCMzJcSiD2mvo3nWZjof2jrHHPp91H3IMRSolvACX9ZiPX7kXKXGGVfHvv3b81jjC4L/fZfOklIz5s+6g6ixBl0bMWP/jM4/3oqZabA1KV4UAoG+VdFrhV8nYsJr8bKt3qrC8wROwvmjlbd4chgOGBPp9MQTNeiHeREMAnhfnzvd8aY86H7DTq2M24tmnvAtOaeGdO4rnknsS6+dB5zn81gIFTmn2Jr052ZmjpSFPzM+s8Q65MuYIpoFM0W0M4svs9MR3oHghkaaTMh9moonteXZyZ3IGk0GqkNKWOXx84v8Sp6yrlSfxKfSwE3QUwQlDdqG50RWXUt5vkhAervEEDO6tAk4ETo/Mk/stx36ZYGK92hBNYywQXTRp7P0yMMhAkqtBGWEOmmRqkQm6CvoO3kbNrUS4cSEnBctE2K1EXEfLkQiMoXPXObfhIaj+dLvm+k9U00HMArUsGwwzvzt9q4rDWmecwNS1+uCLtMrevPHgEUUqERBTQqP2/qcLRmfgdjEvnuxcQex1Svg/krq9JGteW9cj4AK5GyYBLJJOPxkWDlGaUQlqw2NVVWteZdCe3eU3T+CSbZKbz/a8SSxm/XBlNzmqRslfGFl+6UZMDuNOzcZsZFyl48U7nX7xo5pGj0KczamyKjflOXtcdsb40FiIOwBJlu0aeRKJKUVUW9ayPV0u4XF4vuKtB/Cyv5JgnbdyWgVMbtzMv+vneLgb0Rkagqc9Ab946eDHdPpSIdYWolIEUg/Lx0wani2mqbai+4T1lqfcflwvIxP12xaW88dKdOpNzjMmPGRVbALZw2+mtkKn/A/qL2opc0LPVngBM+RDCplpyLU5Ehy7GPE5aOkBeiPbn3tOyUNKITPxEJdlkqPjB/+ojjI2vmYZ4NhZhJu5x7dtm3Jy9xUtFkVCj5d7TLjT/5xne29iS4VMbaqUEBB1EBTLQvX5VGlXsiBAKMPFtj767J2IZiHGQS/lzSrdDd212soo2gQ/AZHEz1z6XNbbftXwG700oAyvpOEmqIigbJksqXSIznBLDcsZOk/aLpoy5gnju3OUd2KD534ErUnJOgpf9m/j2jWFWoIO7Rk+ES5mxt02Dv3OS504Z/SB44P1aFplJ7oTSp8YO8EINwuVw8M9EeC50fS8qFNGSZ06MBOyh19ybCjbNVJsrl/Y/odPnbb8/cqxsl1gVLHUqRhXFZWTLS/KkjJbk9BwHJvPUwi9ULjA5H8/1Fm6l+1uRbs6fkVm6W+W/u3aMmZbR60XnJMxMiFfjdZbpH7SDuWXPKxs4OE+ypJ015c51Y3JlDDwvqopletNoVwUSD5LksZSwZVfiUlLcdeoPodAJdN8XthW3GRPctqBm16tVprjFj9MRsxpimHMnwAfC9PZglISNh8IzZO190Z/F+3aTG2eW9nU6NmbayxbZ0MD5/rFe+P8n41jE3vrk4Emkovb0eWwCXacLiezGR1eKFbeyLLEV6/QEykIxiIA3/i+8nsu4Tx2Rong5wSQJeWYvKWi1rzwcWTh09yJswMJ2KVsWFwvGo8fxCc8l7E/8r09ZkDEus703aLjbtan0WdqvLhEKTNYBTLEzZXmDXZxu+NqDDBt6FwiexDyOK6BpwBx5dh/AYSLNaYamvjp07ffTZQYdniPnPluLSZDyFBbUeS6o40BaTZH47WwrtZLlpmdJMbboOl5IFJN1CyEXKVANOTLeY0iYP3SMASCDRzTZt5H4o/newC2aKXkLoa2JZyLCiZ2uR1UdvllOfwEwTXgpruppbDmXRRmdmqzPTpioqktOz1MSLeVFi5SmAacBKD7LskdTwLKXNBhcRfNKyg5TMmOX6g/IpGmTUOnZeS0BtAi+byqo2Zp+HekFP3uHZl1WkiwG8wTbUbGePlhUafTsw8J1VrLTHAjv6lZ+TNED0xxt5f7CLMMMlm1Jl/pLnYKyRuVh0Q73YXUdUTTCR5JnIpWVqAJfsCBgLnKIIC3i4I/+icumH+n3JsKwjcxGMUnkQC/OEjJlj35hbsiklSUaOSxbHkoB4H7ML6ZP9Gt5p17a1xpttOVPEHmUdxiTossYknUoASyMN2YLYAmnB3Ns7MRQtej/YJVisxxr9CcG+Cj+rQWeOY4Gt6KEO9WGaociimMREV0syifxLY/v1K5ov5fPtqCcvlSxg620pMD2wSk92rkIDAD8GjeRLDVBkiz2sTZcRHjQdMlBIyQ6A0auA0htA9cIzgWcTIj8CBaAfnfNFtiODq0WrhNyQ0xfPdGZY40o2ckMLlR7FHFKMbDMO2gxRw/w6gLYfArAVgvVIrj+EFrFHKRI6aAABQAhQqhD7pXw7nscM/H5GcrIRvo4p86K3h4gAhJKSgMv2Bu2SZBqwfmviqVod4tmsQ90SeiXPHMJy6COIfkIdW6FqQhyr13J5h/UydXQ4tBA6gIVIoC3rzWYiw3LGPZ2xhLf3jC99hjIGyDNJyUeaQxx4ylLnrNfJIrnsTSFsAARmGHjpG/CzVfBOgqD7gzeD8b6OI8tUNJ5tls+4LyB1oosY9oEtaMfXMBZSf54FAZvIagSXnEu+EiLzJdkxpw1po3nbOeZsT+zwip0Uv1E4KwMUVROhCKSEXTkR0m8DijO5kOWQYDTtnuHizE73IZ07G39/IIUfQvjAlrKFWNacKE89rK3lDERnANeC770MkFOpJ4oqti/DB4A5lne0JVVuc+zUdQAc95NlW2i4CY2J6o+L47CF+4fyTPszIAZgtZwJVM4KLsvHbk1bwc2rr7Zy2LJH4vuFoYZ2A5tQJR8edSWcR4VzE38LYY43bhuwTyMuyDS3ip3wPAGxH22IhWr9pMaVrdRzKoc9CmiksQbvozHpT5Tsg7wqzgiBfiS5w8gbHqAlNMKhSPGHRadvzbEPw5afTK9fuKnCnMukDPsz/lP2Re8lTv6EOhmLHYTw65TXZxA6ORvBPI16WcV2ED5VDaY4WL8qETIdyibKUyouvg2XLbgefdRJIF6EujfxA4KYqgutV3MQwBwIiMS+wSnXUBzjB4kvlul8YSChLzkhp1VIX/krnI8vgMVT0YNMUDNUlNpAyDtXwHE0sJbDoHXwNVosDG1t6du7z9oEIJqTBEEA6dNuXb0NDa3BVEVrR5mU6YVPPovNkn+rw0F5nvP2H+kok6kktLeXnN5MdLu+PmtlEhZh/dnmCt04wwlgedc7XJIvBZmarqGecdX6QtB3+1J8eYcvykr4SdazA8mmewso2i0/9nuz5Sg9scyyBkEohSzmNT7beccRpJpoM2E2YNdhwDGDnMdZRBWgb8FOWS+K34f7S6Wwrq3dXyX9a6tsJNLnK9ZCi+6WctukX68aG2FDzZjJ10pO1cDTXZBh+cO0ZOx16RCP4PtpZDLSaxFRYjVaHM9EwSygt+dcKjnLl2AjJQGYaBFU46Ys3QCgNwEg/0cWi3qYj91vhFMkxpmDn1KM3ULA/jM96xkgxTAPFksoXatJbPEt6pW1lq178W0polExXciVASfAy98REUGdNnxqTN0iINNWCC9Qf06h6IbD3L2MLKsDspNwvfOuFdP8ATTItEKLK+mHiIITwFIDH/zpBefcvLipoj1o/8kH5UGKj/OvULud5iXOsib6dNRE7SNwIwvjqkxK/Qz/ewx2/4WB+NGPcqwSp5Vif3kxhOs4PLmajHxpNScKdexrEijk5xcCSWSapP3yHZPWWQD1yka0IcOP/Tys4VLy3X9CczfT6RZkVIB+lth+PcfXS5iefgoJmY+rfLD/btJxLxKUUUxfZB76o/FHD14gGOizs5RNtFyZ7EidftMajqH1H+GEH09oWWBdEHzpJXh6EeISpRqwhTuIxU8g2R8LszAiA1zE5yPtBX9oqaSuKXr/LcA+TKBYw7uc+BRgtVwEEJCqJjYG5mDe93CS+vU41v/QXvKjGfcx2PlL6BJikjPBy4PViwF0O8+y3quj++9tWq1lcj+PZpJqulQIL0ju2diYKI1m5dIJa6WqfJ/L3idSOxXmHJLb0O7dk2llr0MiYzGHPB1zBKC75WwWad/J82lQFZNk60Z9Auo5ZD136qhuoy/mBqZsOIIfI9QmKaGKP2NC/czHqr/l5yiQmIjUx6PoPgkNFqt8n4Uv3sbwR7GCuA4wkPY1mOTT2MQM9Hg54ZADUSU5xwtyrJaYZocrVNDsAbDSaCU/oGvKmivxrmOYJsTH3rPF8HRIme9jImcjxXYYSBGHnyLReI49j69AVILNcVzVMJrzLj5zws0rSZD3LG/ed+JhHNbMR1NH87YcfbFUxiKhUP+WjsKiUqwv4ftZ8FSA0Sp+fjGTCe1pa/0ljN1HrMxa89bYG5Y+0TGC4NmpPamTiXOXAhD6oTd+J7b6t0N+v2V75nugO5yex7qM/qazqQdTrrQB07uMRiS56kIWF2MIQI+T1l3KMdqJxIzLEUDreMAxmp55kTIXDSsPPFudaWTbL9eeyxtTtYPB+zPe+7RfxP1/0dIy8o8T8cNf0KNBfE4Y5GztV7jFkpR3l2G7/AQFlWr1zsct8f/I+zLPu4KTekG81yK2zOWfbxzWUF9rvwPRIzA78bhmAsJ/swA9IlL2KgD0x0T5VZeYlXoXVl4E+LvkF5vG3LRs/V6Jd1TOmz7yQvrJBtIyVippTHUUfSchtH6wjFYTd12NAZFFeZmqiAeyYvd4sl7HoeijyaFoopA9wckwO4PM7owIOAH51caV29Nx6iF0+hEXgZWNuMheGQWLybifocRH0WZyZo7pHsdYP2QOuwNtSuafnAjvTlukLXWEh2VIhQVruBpwd6DF78LmUfIOS9rCiuB+xHYnd9mbvRRzQaYC0KzMtzY/IuCER7E66bO3Eu2tslJH5wTkycwta+8b9ODmYpZzeXWiRFcyh3O0joaa4F7BB+cyIZ+Ogscj5QEMl2+1JOyU2yvEOt9vTwAGm1GD0ci3CSBtwMXMkhXMR2j0FTS7iA3CBmzj24A/lN/GSQ4K+TB7VsuyWcJbh1ki132XRJL7fl1+I1ISgvI0Z/qIkzCns2Gil1SwuOSPxacjlBu7jdyRFbeuHnfjW0+Ve+/5WfGXhb8a/eVQ9HfA6RYSvRWY/wpt4o0qTrMXG04hevYXUwWobMhuZpJ4fuz1K5JEukJjT+q71nQLoHTpTHD+PcMaVGzOImSPQBfJb2PETCC2GV99L6ouzT3t2tUsZ8TS9m0+z943KFPvswMiflMUCqk6pDUAM/wyYiOvRKPQNKSOZNRL4qx7edI1LIHEvCHaFd3OEKPOD119r9i5aHPclJXbaTvztWkj3yCtGIPkB6HNLDMiO5G+X5yLVvCen0nyCSf7Kuf+aF1h3tSRw2MVjcT/+IFekMUrG52IyesWwiSbTGrRhCnL2HFQyW9F4aNLk9x9rC6G373pn547a1NqX733hL7GZYYTDIbxrtiUzv1WmO9Kg5V3nElejA+Oh0wLgpJVwBbscXXBF1ZO4tha6EtbufMhIutR+VwAKyPsDlRMrrpo6iqMVdrt7V7pO2/qsNGsyGSFsIaDlPUvti/5tOLvCbCyJHoMrDLm/wPm8mnZNzmz8gAAAABJRU5ErkJggg=="

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/america.a6e4e48c.jpg";

/***/ },
/* 1129 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1130 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 1131 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toUpperFirst = __webpack_require__(249)
	var getPrefix    = __webpack_require__(248)
	var properties   = __webpack_require__(526)
	
	/**
	 * Returns the given key prefixed, if the property is found in the prefixProps map.
	 *
	 * Does not test if the property supports the given value unprefixed.
	 * If you need this, use './getPrefixed' instead
	 */
	module.exports = function(key, value){
	
		if (!properties[key]){
			return key
		}
	
		var prefix = getPrefix(key)
	
		return prefix?
					prefix + toUpperFirst(key):
					key
	}

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPrefix     = __webpack_require__(248)
	var forcePrefixed = __webpack_require__(1132)
	var el            = __webpack_require__(247)
	
	var MEMORY = {}
	var STYLE
	var ELEMENT
	
	module.exports = function(key, value, force){
	
	    ELEMENT = ELEMENT || el()
	    STYLE   = STYLE   ||  ELEMENT.style
	
	    var k = key + ': ' + value
	
	    if (MEMORY[k]){
	        return MEMORY[k]
	    }
	
	    var prefix
	    var prefixed
	    var prefixedValue
	
	    if (force || !(key in STYLE)){
	
	        prefix = getPrefix('appearance')
	
	        if (prefix){
	            prefixed = forcePrefixed(key, value)
	
	            prefixedValue = '-' + prefix.toLowerCase() + '-' + value
	
	            if (prefixed in STYLE){
	                ELEMENT.style[prefixed] = ''
	                ELEMENT.style[prefixed] = prefixedValue
	
	                if (ELEMENT.style[prefixed] !== ''){
	                    value = prefixedValue
	                }
	            }
	        }
	    }
	
	    MEMORY[k] = value
	
	    return value
	}

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getStylePrefixed = __webpack_require__(1135)
	var properties       = __webpack_require__(526)
	
	module.exports = function(key, value){
	
		if (!properties[key]){
			return key
		}
	
		return getStylePrefixed(key, value)
	}

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toUpperFirst = __webpack_require__(249)
	var getPrefix    = __webpack_require__(248)
	var el           = __webpack_require__(247)
	
	var MEMORY = {}
	var STYLE
	var ELEMENT
	
	var PREFIX
	
	module.exports = function(key, value){
	
	    ELEMENT = ELEMENT || el()
	    STYLE   = STYLE   || ELEMENT.style
	
	    var k = key// + ': ' + value
	
	    if (MEMORY[k]){
	        return MEMORY[k]
	    }
	
	    var prefix
	    var prefixed
	
	    if (!(key in STYLE)){//we have to prefix
	
	        // if (PREFIX){
	        //     prefix = PREFIX
	        // } else {
	            prefix = getPrefix('appearance')
	
	        //     if (prefix){
	        //         prefix = PREFIX = prefix.toLowerCase()
	        //     }
	        // }
	
	        if (prefix){
	            prefixed = prefix + toUpperFirst(key)
	
	            if (prefixed in STYLE){
	                key = prefixed
	            }
	        }
	    }
	
	    MEMORY[k] = key
	
	    return key
	}

/***/ },
/* 1136 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(obj, prop){
		return Object.prototype.hasOwnProperty.call(obj, prop)
	}


/***/ },
/* 1137 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(fn, item){
	
		if (!item){
			return
		}
	
		if (Array.isArray(item)){
			return item.map(fn).filter(function(x){
				return !!x
			})
		} else {
			return fn(item)
		}
	}

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getCssPrefixedValue = __webpack_require__(1133)
	
	module.exports = function(target){
		target.plugins = target.plugins || [
			(function(){
				var values = {
					'flex':1,
					'inline-flex':1
				}
	
				return function(key, value){
					if (key === 'display' && value in values){
						return {
							key  : key,
							value: getCssPrefixedValue(key, value, true)
						}
					}
				}
			})()
		]
	
		target.plugin = function(fn){
			target.plugins = target.plugins || []
	
			target.plugins.push(fn)
		}
	
		return target
	}

/***/ },
/* 1139 */
224,
/* 1140 */
[1180, 132, 133],
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1140);
	var ReactElement = __webpack_require__(103);
	
	var emptyFunction = __webpack_require__(532);
	var traverseAllChildren = __webpack_require__(1150);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(103);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(103),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(404);
	
	module.exports = factory(isValidElement);

/***/ },
/* 1144 */
955,
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(527),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(103),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(530);
	var factory = __webpack_require__(277);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 1146 */
974,
/* 1147 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(132);
	
	var ReactElement = __webpack_require__(103);
	
	var invariant = __webpack_require__(133);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(132);
	
	var ReactCurrentOwner = __webpack_require__(66);
	var REACT_ELEMENT_TYPE = __webpack_require__(529);
	
	var getIteratorFn = __webpack_require__(1146);
	var invariant = __webpack_require__(133);
	var KeyEscapeUtils = __webpack_require__(1139);
	var warning = __webpack_require__(177);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 1151 */
500,
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(48)))

/***/ },
/* 1153 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _css = __webpack_require__(178);
	
	var _css2 = _interopRequireDefault(_css);
	
	var _GlobalStyle = __webpack_require__(533);
	
	var _GlobalStyle2 = _interopRequireDefault(_GlobalStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(8).any;
	
	var injectGlobal = function injectGlobal(strings) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  var globalStyle = new _GlobalStyle2.default(_css2.default.apply(undefined, [strings].concat(interpolations)));
	  globalStyle.generateAndInject();
	};
	
	exports.default = injectGlobal;
	module.exports = exports['default'];

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hash = __webpack_require__(537);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _css = __webpack_require__(178);
	
	var _css2 = _interopRequireDefault(_css);
	
	var _GlobalStyle = __webpack_require__(533);
	
	var _GlobalStyle2 = _interopRequireDefault(_GlobalStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_NameGenerator = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_NameGenerator || __webpack_require__(8).any;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(8).any;
	
	var replaceWhitespace = function replaceWhitespace(str) {
	  return str.replace(/\s|\\n/g, '');
	};
	
	exports.default = function (nameGenerator) {
	  return function (strings) {
	    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    var rules = _css2.default.apply(undefined, [strings].concat(interpolations));
	    var hash = (0, _hash2.default)(replaceWhitespace(JSON.stringify(rules)));
	    var name = nameGenerator(hash);
	    var keyframes = new _GlobalStyle2.default(rules, '@keyframes ' + name);
	    var keyframesWebkit = new _GlobalStyle2.default(rules, '@-webkit-keyframes ' + name);
	    keyframes.generateAndInject();
	    keyframesWebkit.generateAndInject();
	    return name;
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _css = __webpack_require__(178);
	
	var _css2 = _interopRequireDefault(_css);
	
	var _domElements = __webpack_require__(1161);
	
	var _domElements2 = _interopRequireDefault(_domElements);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(8).any;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(8).any;
	
	exports.default = function (styledComponent) {
	  var styled = function styled(tag) {
	    return function (strings) {
	      for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        interpolations[_key - 1] = arguments[_key];
	      }
	
	      return styledComponent(tag, _css2.default.apply(undefined, [strings].concat(interpolations)));
	    };
	  };
	
	  // Shorthands for all valid HTML Elements
	  _domElements2.default.forEach(function (domElement) {
	    styled[domElement] = styled(domElement);
	  });
	
	  return styled;
	};
	
	module.exports = exports['default'];

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ThemeProvider = __webpack_require__(134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* globals ReactClass */
	
	exports.default = function (Component) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, _class);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(_class, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var _this2 = this;
	
	        if (!this.context[_ThemeProvider.CHANNEL]) {
	          throw new Error('[withTheme] Please use ThemeProvider to be able to use withTheme');
	        }
	
	        var subscribe = this.context[_ThemeProvider.CHANNEL];
	        this.unsubscribe = subscribe(function (theme) {
	          _this2.setState({ theme: theme });
	        });
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (typeof this.unsubscribe === 'function') this.unsubscribe();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var theme = this.state.theme;
	
	
	        return _react2.default.createElement(Component, _extends({ theme: theme }, this.props));
	      }
	    }]);
	
	    return _class;
	  }(_react2.default.Component), _class.contextTypes = _defineProperty({}, _ThemeProvider.CHANNEL, _propTypes2.default.func), _temp2;
	};
	
	module.exports = exports['default'];

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ThemeProvider = __webpack_require__(134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AbstractStyledComponent = function (_Component) {
	  _inherits(AbstractStyledComponent, _Component);
	
	  function AbstractStyledComponent() {
	    _classCallCheck(this, AbstractStyledComponent);
	
	    return _possibleConstructorReturn(this, (AbstractStyledComponent.__proto__ || Object.getPrototypeOf(AbstractStyledComponent)).apply(this, arguments));
	  }
	
	  return AbstractStyledComponent;
	}(_react.Component);
	
	exports.default = AbstractStyledComponent;
	
	
	AbstractStyledComponent.contextTypes = _defineProperty({}, _ThemeProvider.CHANNEL, _propTypes2.default.func);
	module.exports = exports['default'];

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _hash = __webpack_require__(537);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _flatten = __webpack_require__(250);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _parse = __webpack_require__(539);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	var _postcssNested = __webpack_require__(538);
	
	var _postcssNested2 = _interopRequireDefault(_postcssNested);
	
	var _autoprefix = __webpack_require__(535);
	
	var _autoprefix2 = _interopRequireDefault(_autoprefix);
	
	var _StyleSheet = __webpack_require__(534);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var babelPluginFlowReactPropTypes_proptype_GlamorInsertedRule = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_GlamorInsertedRule || __webpack_require__(8).any;
	
	var babelPluginFlowReactPropTypes_proptype_NameGenerator = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_NameGenerator || __webpack_require__(8).any;
	
	var babelPluginFlowReactPropTypes_proptype_RuleSet = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_RuleSet || __webpack_require__(8).any;
	
	/*
	 ComponentStyle is all the CSS-specific stuff, not
	 the React-specific stuff.
	 */
	exports.default = function (nameGenerator) {
	  var inserted = {};
	
	  var ComponentStyle = function () {
	    function ComponentStyle(rules) {
	      _classCallCheck(this, ComponentStyle);
	
	      this.rules = rules;
	      if (!_StyleSheet2.default.injected) _StyleSheet2.default.inject();
	      this.insertedRule = _StyleSheet2.default.insert('');
	    }
	
	    /*
	     * Flattens a rule set into valid CSS
	     * Hashes it, wraps the whole chunk in a ._hashName {}
	     * Parses that with PostCSS then runs PostCSS-Nested on it
	     * Returns the hash to be injected on render()
	     * */
	
	
	    _createClass(ComponentStyle, [{
	      key: 'generateAndInjectStyles',
	      value: function generateAndInjectStyles(executionContext) {
	        var flatCSS = (0, _flatten2.default)(this.rules, executionContext).join('').replace(/^\s*\/\/.*$/gm, ''); // replace JS comments
	        var hash = (0, _hash2.default)(flatCSS);
	        if (!inserted[hash]) {
	          var selector = nameGenerator(hash);
	          inserted[hash] = selector;
	          var root = (0, _parse2.default)('.' + selector + ' { ' + flatCSS + ' }');
	          (0, _postcssNested2.default)(root);
	          (0, _autoprefix2.default)(root);
	          this.insertedRule.appendRule(root.toResult().css);
	        }
	        return inserted[hash];
	      }
	    }]);
	
	    return ComponentStyle;
	  }();
	
	  return ComponentStyle;
	};
	
	module.exports = exports['default'];

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _validAttr = __webpack_require__(1165);
	
	var _validAttr2 = _interopRequireDefault(_validAttr);
	
	var _isTag = __webpack_require__(1164);
	
	var _isTag2 = _interopRequireDefault(_isTag);
	
	var _AbstractStyledComponent = __webpack_require__(1158);
	
	var _AbstractStyledComponent2 = _interopRequireDefault(_AbstractStyledComponent);
	
	var _ThemeProvider = __webpack_require__(134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var babelPluginFlowReactPropTypes_proptype_Theme = __webpack_require__(134).babelPluginFlowReactPropTypes_proptype_Theme || __webpack_require__(8).any;
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(8).any;
	
	var babelPluginFlowReactPropTypes_proptype_RuleSet = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_RuleSet || __webpack_require__(8).any;
	
	exports.default = function (ComponentStyle) {
	  // eslint-disable-next-line no-undef
	  var createStyledComponent = function createStyledComponent(target, rules, parent) {
	    /* Handle styled(OtherStyledComponent) differently */
	    var isStyledComponent = _AbstractStyledComponent2.default.isPrototypeOf(target);
	    if (!(0, _isTag2.default)(target) && isStyledComponent) {
	      return createStyledComponent(target.target, target.rules.concat(rules), target);
	    }
	
	    var componentStyle = new ComponentStyle(rules);
	    var ParentComponent = parent || _AbstractStyledComponent2.default;
	
	    var StyledComponent = function (_ParentComponent) {
	      _inherits(StyledComponent, _ParentComponent);
	
	      function StyledComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, StyledComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StyledComponent.__proto__ || Object.getPrototypeOf(StyledComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          theme: null,
	          generatedClassName: ''
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _createClass(StyledComponent, [{
	        key: 'generateAndInjectStyles',
	        value: function generateAndInjectStyles(theme, props) {
	          var executionContext = _extends({}, props, { theme: theme });
	          return componentStyle.generateAndInjectStyles(executionContext);
	        }
	      }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	          var _this2 = this;
	
	          // If there is a theme in the context, subscribe to the event emitter. This
	          // is necessary due to pure components blocking context updates, this circumvents
	          // that by updating when an event is emitted
	          if (this.context[_ThemeProvider.CHANNEL]) {
	            var subscribe = this.context[_ThemeProvider.CHANNEL];
	            this.unsubscribe = subscribe(function (nextTheme) {
	              // This will be called once immediately
	
	              // Props should take precedence over ThemeProvider, which should take precedence over
	              // defaultProps, but React automatically puts defaultProps on props.
	              var defaultProps = _this2.constructor.defaultProps;
	
	              var isDefaultTheme = defaultProps && _this2.props.theme === defaultProps.theme;
	              var theme = _this2.props.theme && !isDefaultTheme ? _this2.props.theme : nextTheme;
	              var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
	              _this2.setState({ theme: theme, generatedClassName: generatedClassName });
	            });
	          } else {
	            var _theme = this.props.theme || {};
	            var generatedClassName = this.generateAndInjectStyles(_theme, this.props);
	            this.setState({ theme: _theme, generatedClassName: generatedClassName });
	          }
	        }
	      }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	          var _this3 = this;
	
	          this.setState(function (oldState) {
	            // Props should take precedence over ThemeProvider, which should take precedence over
	            // defaultProps, but React automatically puts defaultProps on props.
	            var defaultProps = _this3.constructor.defaultProps;
	
	            var isDefaultTheme = defaultProps && nextProps.theme === defaultProps.theme;
	            var theme = nextProps.theme && !isDefaultTheme ? nextProps.theme : oldState.theme;
	            var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
	
	            return { theme: theme, generatedClassName: generatedClassName };
	          });
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          if (this.unsubscribe) {
	            this.unsubscribe();
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _this4 = this;
	
	          var _props = this.props,
	              className = _props.className,
	              children = _props.children,
	              innerRef = _props.innerRef;
	          var generatedClassName = this.state.generatedClassName;
	
	
	          var propsForElement = {};
	          /* Don't pass through non HTML tags through to HTML elements */
	          Object.keys(this.props).filter(function (propName) {
	            return !(0, _isTag2.default)(target) || (0, _validAttr2.default)(propName);
	          }).forEach(function (propName) {
	            propsForElement[propName] = _this4.props[propName];
	          });
	          propsForElement.className = [className, generatedClassName].filter(function (x) {
	            return x;
	          }).join(' ');
	          if (innerRef) {
	            propsForElement.ref = innerRef;
	            if ((0, _isTag2.default)(target)) delete propsForElement.innerRef;
	          }
	
	          return (0, _react.createElement)(target, propsForElement, children);
	        }
	      }]);
	
	      return StyledComponent;
	    }(ParentComponent);
	
	    StyledComponent.contextTypes = ParentComponent.contextTypes;
	
	
	    StyledComponent.target = target;
	    StyledComponent.rules = rules;
	
	    StyledComponent.displayName = (0, _isTag2.default)(target) ? 'styled.' + target : 'Styled(' + (target.displayName || target.name || 'Component') + ')';
	
	    return StyledComponent;
	  };
	
	  return createStyledComponent;
	};
	
	module.exports = exports['default'];

/***/ },
/* 1161 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	// Thanks to ReactDOMFactories for this handy list!
	
	exports.default = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
	
	// SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	module.exports = exports['default'];

/***/ },
/* 1162 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
	
	/* Some high number, usually 9-digit base-10. Map it to base-😎 */
	var generateAlphabeticName = function generateAlphabeticName(code) {
	  var lastDigit = chars[code % chars.length];
	  return code > chars.length ? '' + generateAlphabeticName(Math.floor(code / chars.length)) + lastDigit : lastDigit;
	};
	
	exports.default = generateAlphabeticName;
	module.exports = exports['default'];

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(8).any;
	
	exports.default = function (strings, interpolations) {
	  return interpolations.reduce(function (array, interp, i) {
	    return array.concat(interp, strings[i + 1]);
	  }, [strings[0]]);
	};
	
	module.exports = exports['default'];

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTag;
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(28).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(8).any;
	
	function isTag(target) /* : %checks */{
	  return typeof target === 'string';
	}
	module.exports = exports['default'];

/***/ },
/* 1165 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/* Trying to avoid the unknown-prop errors on styled components
	 by filtering by React's attribute whitelist.
	 */
	
	/* Logic copied from ReactDOMUnknownPropertyHook */
	var reactProps = {
	  children: true,
	  dangerouslySetInnerHTML: true,
	  key: true,
	  ref: true,
	  autoFocus: true,
	  defaultValue: true,
	  valueLink: true,
	  defaultChecked: true,
	  checkedLink: true,
	  innerHTML: true,
	  suppressContentEditableWarning: true,
	  onFocusIn: true,
	  onFocusOut: true,
	  className: true,
	
	  /* List copied from https://facebook.github.io/react/docs/events.html */
	  onCopy: true,
	  onCut: true,
	  onPaste: true,
	  onCompositionEnd: true,
	  onCompositionStart: true,
	  onCompositionUpdate: true,
	  onKeyDown: true,
	  onKeyPress: true,
	  onKeyUp: true,
	  onFocus: true,
	  onBlur: true,
	  onChange: true,
	  onInput: true,
	  onSubmit: true,
	  onClick: true,
	  onContextMenu: true,
	  onDoubleClick: true,
	  onDrag: true,
	  onDragEnd: true,
	  onDragEnter: true,
	  onDragExit: true,
	  onDragLeave: true,
	  onDragOver: true,
	  onDragStart: true,
	  onDrop: true,
	  onMouseDown: true,
	  onMouseEnter: true,
	  onMouseLeave: true,
	  onMouseMove: true,
	  onMouseOut: true,
	  onMouseOver: true,
	  onMouseUp: true,
	  onSelect: true,
	  onTouchCancel: true,
	  onTouchEnd: true,
	  onTouchMove: true,
	  onTouchStart: true,
	  onScroll: true,
	  onWheel: true,
	  onAbort: true,
	  onCanPlay: true,
	  onCanPlayThrough: true,
	  onDurationChange: true,
	  onEmptied: true,
	  onEncrypted: true,
	  onEnded: true,
	  onError: true,
	  onLoadedData: true,
	  onLoadedMetadata: true,
	  onLoadStart: true,
	  onPause: true,
	  onPlay: true,
	  onPlaying: true,
	  onProgress: true,
	  onRateChange: true,
	  onSeeked: true,
	  onSeeking: true,
	  onStalled: true,
	  onSuspend: true,
	  onTimeUpdate: true,
	  onVolumeChange: true,
	  onWaiting: true,
	  onLoad: true,
	  onAnimationStart: true,
	  onAnimationEnd: true,
	  onAnimationIteration: true,
	  onTransitionEnd: true,
	
	  onCopyCapture: true,
	  onCutCapture: true,
	  onPasteCapture: true,
	  onCompositionEndCapture: true,
	  onCompositionStartCapture: true,
	  onCompositionUpdateCapture: true,
	  onKeyDownCapture: true,
	  onKeyPressCapture: true,
	  onKeyUpCapture: true,
	  onFocusCapture: true,
	  onBlurCapture: true,
	  onChangeCapture: true,
	  onInputCapture: true,
	  onSubmitCapture: true,
	  onClickCapture: true,
	  onContextMenuCapture: true,
	  onDoubleClickCapture: true,
	  onDragCapture: true,
	  onDragEndCapture: true,
	  onDragEnterCapture: true,
	  onDragExitCapture: true,
	  onDragLeaveCapture: true,
	  onDragOverCapture: true,
	  onDragStartCapture: true,
	  onDropCapture: true,
	  onMouseDownCapture: true,
	  onMouseEnterCapture: true,
	  onMouseLeaveCapture: true,
	  onMouseMoveCapture: true,
	  onMouseOutCapture: true,
	  onMouseOverCapture: true,
	  onMouseUpCapture: true,
	  onSelectCapture: true,
	  onTouchCancelCapture: true,
	  onTouchEndCapture: true,
	  onTouchMoveCapture: true,
	  onTouchStartCapture: true,
	  onScrollCapture: true,
	  onWheelCapture: true,
	  onAbortCapture: true,
	  onCanPlayCapture: true,
	  onCanPlayThroughCapture: true,
	  onDurationChangeCapture: true,
	  onEmptiedCapture: true,
	  onEncryptedCapture: true,
	  onEndedCapture: true,
	  onErrorCapture: true,
	  onLoadedDataCapture: true,
	  onLoadedMetadataCapture: true,
	  onLoadStartCapture: true,
	  onPauseCapture: true,
	  onPlayCapture: true,
	  onPlayingCapture: true,
	  onProgressCapture: true,
	  onRateChangeCapture: true,
	  onSeekedCapture: true,
	  onSeekingCapture: true,
	  onStalledCapture: true,
	  onSuspendCapture: true,
	  onTimeUpdateCapture: true,
	  onVolumeChangeCapture: true,
	  onWaitingCapture: true,
	  onLoadCapture: true,
	  onAnimationStartCapture: true,
	  onAnimationEndCapture: true,
	  onAnimationIterationCapture: true,
	  onTransitionEndCapture: true
	};
	
	/* From HTMLDOMPropertyConfig */
	var htmlProps = {
	  /**
	   * Standard Properties
	   */
	  accept: true,
	  acceptCharset: true,
	  accessKey: true,
	  action: true,
	  allowFullScreen: true,
	  allowTransparency: true,
	  alt: true,
	  // specifies target context for links with `preload` type
	  as: true,
	  async: true,
	  autoComplete: true,
	  // autoFocus is polyfilled/normalized by AutoFocusUtils
	  // autoFocus: true,
	  autoPlay: true,
	  capture: true,
	  cellPadding: true,
	  cellSpacing: true,
	  charSet: true,
	  challenge: true,
	  checked: true,
	  cite: true,
	  classID: true,
	  className: true,
	  cols: true,
	  colSpan: true,
	  content: true,
	  contentEditable: true,
	  contextMenu: true,
	  controls: true,
	  coords: true,
	  crossOrigin: true,
	  data: true, // For `<object />` acts as `src`.
	  dateTime: true,
	  default: true,
	  defer: true,
	  dir: true,
	  disabled: true,
	  download: true,
	  draggable: true,
	  encType: true,
	  form: true,
	  formAction: true,
	  formEncType: true,
	  formMethod: true,
	  formNoValidate: true,
	  formTarget: true,
	  frameBorder: true,
	  headers: true,
	  height: true,
	  hidden: true,
	  high: true,
	  href: true,
	  hrefLang: true,
	  htmlFor: true,
	  httpEquiv: true,
	  icon: true,
	  id: true,
	  inputMode: true,
	  integrity: true,
	  is: true,
	  keyParams: true,
	  keyType: true,
	  kind: true,
	  label: true,
	  lang: true,
	  list: true,
	  loop: true,
	  low: true,
	  manifest: true,
	  marginHeight: true,
	  marginWidth: true,
	  max: true,
	  maxLength: true,
	  media: true,
	  mediaGroup: true,
	  method: true,
	  min: true,
	  minLength: true,
	  // Caution; `option.selected` is not updated if `select.multiple` is
	  // disabled with `removeAttribute`.
	  multiple: true,
	  muted: true,
	  name: true,
	  nonce: true,
	  noValidate: true,
	  open: true,
	  optimum: true,
	  pattern: true,
	  placeholder: true,
	  playsInline: true,
	  poster: true,
	  preload: true,
	  profile: true,
	  radioGroup: true,
	  readOnly: true,
	  referrerPolicy: true,
	  rel: true,
	  required: true,
	  reversed: true,
	  role: true,
	  rows: true,
	  rowSpan: true,
	  sandbox: true,
	  scope: true,
	  scoped: true,
	  scrolling: true,
	  seamless: true,
	  selected: true,
	  shape: true,
	  size: true,
	  sizes: true,
	  span: true,
	  spellCheck: true,
	  src: true,
	  srcDoc: true,
	  srcLang: true,
	  srcSet: true,
	  start: true,
	  step: true,
	  style: true,
	  summary: true,
	  tabIndex: true,
	  target: true,
	  title: true,
	  // Setting .type throws on non-<input> tags
	  type: true,
	  useMap: true,
	  value: true,
	  width: true,
	  wmode: true,
	  wrap: true,
	
	  /**
	   * RDFa Properties
	   */
	  about: true,
	  datatype: true,
	  inlist: true,
	  prefix: true,
	  // property is also supported for OpenGraph in meta tags.
	  property: true,
	  resource: true,
	  typeof: true,
	  vocab: true,
	
	  /**
	   * Non-standard Properties
	   */
	  // autoCapitalize and autoCorrect are supported in Mobile Safari for
	  // keyboard hints.
	  autoCapitalize: true,
	  autoCorrect: true,
	  // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	  autoSave: true,
	  // color is for Safari mask-icon link
	  color: true,
	  // itemProp, itemScope, itemType are for
	  // Microdata support. See http://schema.org/docs/gs.html
	  itemProp: true,
	  itemScope: true,
	  itemType: true,
	  // itemID and itemRef are for Microdata support as well but
	  // only specified in the WHATWG spec document. See
	  // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	  itemID: true,
	  itemRef: true,
	  // results show looking glass icon and recent searches on input
	  // search fields in WebKit/Blink
	  results: true,
	  // IE-only attribute that specifies security restrictions on an iframe
	  // as an alternative to the sandbox attribute on IE<10
	  security: true,
	  // IE-only attribute that controls focus behavior
	  unselectable: 0
	};
	
	var svgProps = {
	  accentHeight: true,
	  accumulate: true,
	  additive: true,
	  alignmentBaseline: true,
	  allowReorder: true,
	  alphabetic: true,
	  amplitude: true,
	  arabicForm: true,
	  ascent: true,
	  attributeName: true,
	  attributeType: true,
	  autoReverse: true,
	  azimuth: true,
	  baseFrequency: true,
	  baseProfile: true,
	  baselineShift: true,
	  bbox: true,
	  begin: true,
	  bias: true,
	  by: true,
	  calcMode: true,
	  capHeight: true,
	  clip: true,
	  clipPath: true,
	  clipRule: true,
	  clipPathUnits: true,
	  colorInterpolation: true,
	  colorInterpolationFilters: true,
	  colorProfile: true,
	  colorRendering: true,
	  contentScriptType: true,
	  contentStyleType: true,
	  cursor: true,
	  cx: true,
	  cy: true,
	  d: true,
	  decelerate: true,
	  descent: true,
	  diffuseConstant: true,
	  direction: true,
	  display: true,
	  divisor: true,
	  dominantBaseline: true,
	  dur: true,
	  dx: true,
	  dy: true,
	  edgeMode: true,
	  elevation: true,
	  enableBackground: true,
	  end: true,
	  exponent: true,
	  externalResourcesRequired: true,
	  fill: true,
	  fillOpacity: true,
	  fillRule: true,
	  filter: true,
	  filterRes: true,
	  filterUnits: true,
	  floodColor: true,
	  floodOpacity: true,
	  focusable: true,
	  fontFamily: true,
	  fontSize: true,
	  fontSizeAdjust: true,
	  fontStretch: true,
	  fontStyle: true,
	  fontVariant: true,
	  fontWeight: true,
	  format: true,
	  from: true,
	  fx: true,
	  fy: true,
	  g1: true,
	  g2: true,
	  glyphName: true,
	  glyphOrientationHorizontal: true,
	  glyphOrientationVertical: true,
	  glyphRef: true,
	  gradientTransform: true,
	  gradientUnits: true,
	  hanging: true,
	  horizAdvX: true,
	  horizOriginX: true,
	  ideographic: true,
	  imageRendering: true,
	  in: true,
	  in2: true,
	  intercept: true,
	  k: true,
	  k1: true,
	  k2: true,
	  k3: true,
	  k4: true,
	  kernelMatrix: true,
	  kernelUnitLength: true,
	  kerning: true,
	  keyPoints: true,
	  keySplines: true,
	  keyTimes: true,
	  lengthAdjust: true,
	  letterSpacing: true,
	  lightingColor: true,
	  limitingConeAngle: true,
	  local: true,
	  markerEnd: true,
	  markerMid: true,
	  markerStart: true,
	  markerHeight: true,
	  markerUnits: true,
	  markerWidth: true,
	  mask: true,
	  maskContentUnits: true,
	  maskUnits: true,
	  mathematical: true,
	  mode: true,
	  numOctaves: true,
	  offset: true,
	  opacity: true,
	  operator: true,
	  order: true,
	  orient: true,
	  orientation: true,
	  origin: true,
	  overflow: true,
	  overlinePosition: true,
	  overlineThickness: true,
	  paintOrder: true,
	  panose1: true,
	  pathLength: true,
	  patternContentUnits: true,
	  patternTransform: true,
	  patternUnits: true,
	  pointerEvents: true,
	  points: true,
	  pointsAtX: true,
	  pointsAtY: true,
	  pointsAtZ: true,
	  preserveAlpha: true,
	  preserveAspectRatio: true,
	  primitiveUnits: true,
	  r: true,
	  radius: true,
	  refX: true,
	  refY: true,
	  renderingIntent: true,
	  repeatCount: true,
	  repeatDur: true,
	  requiredExtensions: true,
	  requiredFeatures: true,
	  restart: true,
	  result: true,
	  rotate: true,
	  rx: true,
	  ry: true,
	  scale: true,
	  seed: true,
	  shapeRendering: true,
	  slope: true,
	  spacing: true,
	  specularConstant: true,
	  specularExponent: true,
	  speed: true,
	  spreadMethod: true,
	  startOffset: true,
	  stdDeviation: true,
	  stemh: true,
	  stemv: true,
	  stitchTiles: true,
	  stopColor: true,
	  stopOpacity: true,
	  strikethroughPosition: true,
	  strikethroughThickness: true,
	  string: true,
	  stroke: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeLinecap: true,
	  strokeLinejoin: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true,
	  surfaceScale: true,
	  systemLanguage: true,
	  tableValues: true,
	  targetX: true,
	  targetY: true,
	  textAnchor: true,
	  textDecoration: true,
	  textRendering: true,
	  textLength: true,
	  to: true,
	  transform: true,
	  u1: true,
	  u2: true,
	  underlinePosition: true,
	  underlineThickness: true,
	  unicode: true,
	  unicodeBidi: true,
	  unicodeRange: true,
	  unitsPerEm: true,
	  vAlphabetic: true,
	  vHanging: true,
	  vIdeographic: true,
	  vMathematical: true,
	  values: true,
	  vectorEffect: true,
	  version: true,
	  vertAdvY: true,
	  vertOriginX: true,
	  vertOriginY: true,
	  viewBox: true,
	  viewTarget: true,
	  visibility: true,
	  widths: true,
	  wordSpacing: true,
	  writingMode: true,
	  x: true,
	  xHeight: true,
	  x1: true,
	  x2: true,
	  xChannelSelector: true,
	  xlinkActuate: true,
	  xlinkArcrole: true,
	  xlinkHref: true,
	  xlinkRole: true,
	  xlinkShow: true,
	  xlinkTitle: true,
	  xlinkType: true,
	  xmlBase: true,
	  xmlns: true,
	  xmlnsXlink: true,
	  xmlLang: true,
	  xmlSpace: true,
	  y: true,
	  y1: true,
	  y2: true,
	  yChannelSelector: true,
	  z: true,
	  zoomAndPan: true
	};
	
	/* From DOMProperty */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
	var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
	
	var hasOwnProperty = {}.hasOwnProperty;
	
	exports.default = function (name) {
	  return hasOwnProperty.call(htmlProps, name) || hasOwnProperty.call(svgProps, name) || isCustomAttribute(name.toLowerCase()) || hasOwnProperty.call(reactProps, name);
	};
	
	module.exports = exports['default'];

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	- 'polyfills' on server side
	
	
	// usage
	
	import StyleSheet from 'glamor/lib/sheet'
	let styleSheet = new StyleSheet()
	
	styleSheet.inject()
	- 'injects' the stylesheet into the page (or into memory if on server)
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	
	*/
	
	function last(arr) {
	  return arr[arr.length - 1];
	}
	
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    return tag.sheet;
	  }
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      return document.styleSheets[i];
	    }
	  }
	}
	
	var isBrowser = typeof document !== 'undefined';
	var isDev = function (x) {
	  return x === 'development' || !x;
	}(("production"));
	var isTest = ("production") === 'test';
	
	var oldIE = function () {
	  if (isBrowser) {
	    var div = document.createElement('div');
	    div.innerHTML = '<!--[if lt IE 10]><i></i><![endif]-->';
	    return div.getElementsByTagName('i').length === 1;
	  }
	}();
	
	function makeStyleTag() {
	  var tag = document.createElement('style');
	  tag.type = 'text/css';
	  tag.appendChild(document.createTextNode(''));
	  (document.head || document.getElementsByTagName('head')[0]).appendChild(tag);
	  return tag;
	}
	
	var StyleSheet = exports.StyleSheet = function () {
	  function StyleSheet() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$speedy = _ref.speedy,
	        speedy = _ref$speedy === undefined ? !isDev && !isTest : _ref$speedy,
	        _ref$maxLength = _ref.maxLength,
	        maxLength = _ref$maxLength === undefined ? isBrowser && oldIE ? 4000 : 65000 : _ref$maxLength;
	
	    _classCallCheck(this, StyleSheet);
	
	    this.isSpeedy = speedy; // the big drawback here is that the css won't be editable in devtools
	    this.sheet = undefined;
	    this.tags = [];
	    this.maxLength = maxLength;
	    this.ctr = 0;
	  }
	
	  _createClass(StyleSheet, [{
	    key: 'inject',
	    value: function inject() {
	      var _this = this;
	
	      if (this.injected) {
	        throw new Error('already injected stylesheet!');
	      }
	      if (isBrowser) {
	        // this section is just weird alchemy I found online off many sources
	        this.tags[0] = makeStyleTag();
	        // this weirdness brought to you by firefox
	        this.sheet = sheetForTag(this.tags[0]);
	      } else {
	        // server side 'polyfill'. just enough behavior to be useful.
	        this.sheet = {
	          cssRules: [],
	          insertRule: function insertRule(rule) {
	            // enough 'spec compliance' to be able to extract the rules later
	            // in other words, just the cssText field
	            var serverRule = { cssText: rule };
	            _this.sheet.cssRules.push(serverRule);
	            return { serverRule: serverRule, appendRule: function appendRule(newCss) {
	                return serverRule.cssText += newCss;
	              } };
	          }
	        };
	      }
	      this.injected = true;
	    }
	  }, {
	    key: 'speedy',
	    value: function speedy(bool) {
	      if (this.ctr !== 0) {
	        throw new Error('cannot change speedy mode after inserting any rule to sheet. Either call speedy(' + bool + ') earlier in your app, or call flush() before speedy(' + bool + ')');
	      }
	      this.isSpeedy = !!bool;
	    }
	  }, {
	    key: '_insert',
	    value: function _insert(rule) {
	      // this weirdness for perf, and chrome's weird bug
	      // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
	      try {
	        this.sheet.insertRule(rule, this.sheet.cssRules.length); // todo - correct index here
	      } catch (e) {
	        if (isDev) {
	          // might need beter dx for this
	          console.warn('whoops, illegal rule inserted', rule); //eslint-disable-line no-console
	        }
	      }
	    }
	  }, {
	    key: 'insert',
	    value: function insert(rule) {
	      var insertedRule = void 0;
	
	      if (isBrowser) {
	        // this is the ultrafast version, works across browsers
	        if (this.isSpeedy && this.sheet.insertRule) {
	          this._insert(rule);
	        } else {
	          var textNode = document.createTextNode(rule);
	          last(this.tags).appendChild(textNode);
	          insertedRule = { textNode: textNode, appendRule: function appendRule(newCss) {
	              return textNode.appendData(newCss);
	            } };
	
	          if (!this.isSpeedy) {
	            // sighhh
	            this.sheet = sheetForTag(last(this.tags));
	          }
	        }
	      } else {
	        // server side is pretty simple
	        insertedRule = this.sheet.insertRule(rule);
	      }
	
	      this.ctr++;
	      if (isBrowser && this.ctr % this.maxLength === 0) {
	        this.tags.push(makeStyleTag());
	        this.sheet = sheetForTag(last(this.tags));
	      }
	      return insertedRule;
	    }
	  }, {
	    key: 'flush',
	    value: function flush() {
	      if (isBrowser) {
	        this.tags.forEach(function (tag) {
	          return tag.parentNode.removeChild(tag);
	        });
	        this.tags = [];
	        this.sheet = null;
	        this.ctr = 0;
	        // todo - look for remnants in document.styleSheets
	      } else {
	        // simpler on server
	        this.sheet.cssRules = [];
	      }
	      this.injected = false;
	    }
	  }, {
	    key: 'rules',
	    value: function rules() {
	      if (!isBrowser) {
	        return this.sheet.cssRules;
	      }
	      var arr = [];
	      this.tags.forEach(function (tag) {
	        return arr.splice.apply(arr, [arr.length, 0].concat(_toConsumableArray(Array.from(sheetForTag(tag).cssRules))));
	      });
	      return arr;
	    }
	  }]);
	
	  return StyleSheet;
	}();

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _tokenize2 = __webpack_require__(257);
	
	var _tokenize3 = _interopRequireDefault(_tokenize2);
	
	var _comment = __webpack_require__(252);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _parser = __webpack_require__(544);
	
	var _parser2 = _interopRequireDefault(_parser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SafeParser = function (_Parser) {
	    _inherits(SafeParser, _Parser);
	
	    function SafeParser() {
	        _classCallCheck(this, SafeParser);
	
	        return _possibleConstructorReturn(this, (SafeParser.__proto__ || Object.getPrototypeOf(SafeParser)).apply(this, arguments));
	    }
	
	    _createClass(SafeParser, [{
	        key: 'tokenize',
	        value: function tokenize() {
	            this.tokens = (0, _tokenize3.default)(this.input, { ignoreErrors: true });
	        }
	    }, {
	        key: 'comment',
	        value: function comment(token) {
	            var node = new _comment2.default();
	            this.init(node, token[2], token[3]);
	            node.source.end = { line: token[4], column: token[5] };
	
	            var text = token[1].slice(2);
	            if (text.slice(-2) === '*/') text = text.slice(0, -2);
	
	            if (/^\s*$/.test(text)) {
	                node.text = '';
	                node.raws.left = text;
	                node.raws.right = '';
	            } else {
	                var match = text.match(/^(\s*)([^]*[^\s])(\s*)$/);
	                node.text = match[2];
	                node.raws.left = match[1];
	                node.raws.right = match[3];
	            }
	        }
	    }, {
	        key: 'unclosedBracket',
	        value: function unclosedBracket() {}
	    }, {
	        key: 'unknownWord',
	        value: function unknownWord(start) {
	            var buffer = this.tokens.slice(start, this.pos + 1);
	            this.spaces += buffer.map(function (i) {
	                return i[1];
	            }).join('');
	        }
	    }, {
	        key: 'unexpectedClose',
	        value: function unexpectedClose() {
	            this.current.raws.after += '}';
	        }
	    }, {
	        key: 'doubleColon',
	        value: function doubleColon() {}
	    }, {
	        key: 'unnamedAtrule',
	        value: function unnamedAtrule(node) {
	            node.name = '';
	        }
	    }, {
	        key: 'precheckMissedSemicolon',
	        value: function precheckMissedSemicolon(tokens) {
	            var colon = this.colon(tokens);
	            if (colon === false) return;
	
	            var split = void 0;
	            for (split = colon - 1; split >= 0; split--) {
	                if (tokens[split][0] === 'word') break;
	            }
	            for (split -= 1; split >= 0; split--) {
	                if (tokens[split][0] !== 'space') {
	                    split += 1;
	                    break;
	                }
	            }
	            var other = tokens.splice(split, tokens.length - split);
	            this.decl(other);
	        }
	    }, {
	        key: 'checkMissedSemicolon',
	        value: function checkMissedSemicolon() {}
	    }, {
	        key: 'endFile',
	        value: function endFile() {
	            if (this.current.nodes && this.current.nodes.length) {
	                this.current.raws.semicolon = this.semicolon;
	            }
	            this.current.raws.after = (this.current.raws.after || '') + this.spaces;
	
	            while (this.current.parent) {
	                this.current = this.current.parent;
	                this.current.raws.after = '';
	            }
	        }
	    }]);
	
	    return SafeParser;
	}(_parser2.default);
	
	exports.default = SafeParser;
	module.exports = exports['default'];

/***/ },
/* 1168 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * Contains helpers for safely splitting lists of CSS values,
	 * preserving parentheses and quotes.
	 *
	 * @example
	 * const list = postcss.list;
	 *
	 * @namespace list
	 */
	var list = {
	    split: function split(string, separators, last) {
	        var array = [];
	        var current = '';
	        var split = false;
	
	        var func = 0;
	        var quote = false;
	        var escape = false;
	
	        for (var i = 0; i < string.length; i++) {
	            var letter = string[i];
	
	            if (quote) {
	                if (escape) {
	                    escape = false;
	                } else if (letter === '\\') {
	                    escape = true;
	                } else if (letter === quote) {
	                    quote = false;
	                }
	            } else if (letter === '"' || letter === '\'') {
	                quote = letter;
	            } else if (letter === '(') {
	                func += 1;
	            } else if (letter === ')') {
	                if (func > 0) func -= 1;
	            } else if (func === 0) {
	                if (separators.indexOf(letter) !== -1) split = true;
	            }
	
	            if (split) {
	                if (current !== '') array.push(current.trim());
	                current = '';
	                split = false;
	            } else {
	                current += letter;
	            }
	        }
	
	        if (last || current !== '') array.push(current.trim());
	        return array;
	    },
	
	
	    /**
	     * Safely splits space-separated values (such as those for `background`,
	     * `border-radius`, and other shorthand properties).
	     *
	     * @param {string} string - space-separated values
	     *
	     * @return {string[]} splitted values
	     *
	     * @example
	     * postcss.list.space('1px calc(10% + 1px)') //=> ['1px', 'calc(10% + 1px)']
	     */
	    space: function space(string) {
	        var spaces = [' ', '\n', '\t'];
	        return list.split(string, spaces);
	    },
	
	
	    /**
	     * Safely splits comma-separated values (such as those for `transition-*`
	     * and `background` properties).
	     *
	     * @param {string} string - comma-separated values
	     *
	     * @return {string[]} splitted values
	     *
	     * @example
	     * postcss.list.comma('black, linear-gradient(white, black)')
	     * //=> ['black', 'linear-gradient(white, black)']
	     */
	    comma: function comma(string) {
	        var comma = ',';
	        return list.split(string, [comma], true);
	    }
	};
	
	exports.default = list;
	module.exports = exports['default'];

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lazyResult = __webpack_require__(542);
	
	var _lazyResult2 = _interopRequireDefault(_lazyResult);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @callback builder
	 * @param {string} part          - part of generated CSS connected to this node
	 * @param {Node}   node          - AST node
	 * @param {"start"|"end"} [type] - node’s part type
	 */
	
	/**
	 * @callback parser
	 *
	 * @param {string|toString} css   - string with input CSS or any object
	 *                                  with toString() method, like a Buffer
	 * @param {processOptions} [opts] - options with only `from` and `map` keys
	 *
	 * @return {Root} PostCSS AST
	 */
	
	/**
	 * @callback stringifier
	 *
	 * @param {Node} node       - start node for stringifing. Usually {@link Root}.
	 * @param {builder} builder - function to concatenate CSS from node’s parts
	 *                            or generate string and source map
	 *
	 * @return {void}
	 */
	
	/**
	 * @typedef {object} syntax
	 * @property {parser} parse          - function to generate AST by string
	 * @property {stringifier} stringify - function to generate string by AST
	 */
	
	/**
	 * @typedef {object} toString
	 * @property {function} toString
	 */
	
	/**
	 * @callback pluginFunction
	 * @param {Root} root     - parsed input CSS
	 * @param {Result} result - result to set warnings or check other plugins
	 */
	
	/**
	 * @typedef {object} Plugin
	 * @property {function} postcss - PostCSS plugin function
	 */
	
	/**
	 * @typedef {object} processOptions
	 * @property {string} from             - the path of the CSS source file.
	 *                                       You should always set `from`,
	 *                                       because it is used in source map
	 *                                       generation and syntax error messages.
	 * @property {string} to               - the path where you’ll put the output
	 *                                       CSS file. You should always set `to`
	 *                                       to generate correct source maps.
	 * @property {parser} parser           - function to generate AST by string
	 * @property {stringifier} stringifier - class to generate string by AST
	 * @property {syntax} syntax           - object with `parse` and `stringify`
	 * @property {object} map              - source map options
	 * @property {boolean} map.inline                    - does source map should
	 *                                                     be embedded in the output
	 *                                                     CSS as a base64-encoded
	 *                                                     comment
	 * @property {string|object|false|function} map.prev - source map content
	 *                                                     from a previous
	 *                                                     processing step
	 *                                                     (for example, Sass).
	 *                                                     PostCSS will try to find
	 *                                                     previous map
	 *                                                     automatically, so you
	 *                                                     could disable it by
	 *                                                     `false` value.
	 * @property {boolean} map.sourcesContent            - does PostCSS should set
	 *                                                     the origin content to map
	 * @property {string|false} map.annotation           - does PostCSS should set
	 *                                                     annotation comment to map
	 * @property {string} map.from                       - override `from` in map’s
	 *                                                     `sources`
	 */
	
	/**
	 * Contains plugins to process CSS. Create one `Processor` instance,
	 * initialize its plugins, and then use that instance on numerous CSS files.
	 *
	 * @example
	 * const processor = postcss([autoprefixer, precss]);
	 * processor.process(css1).then(result => console.log(result.css));
	 * processor.process(css2).then(result => console.log(result.css));
	 */
	var Processor = function () {
	
	  /**
	   * @param {Array.<Plugin|pluginFunction>|Processor} plugins - PostCSS
	   *        plugins. See {@link Processor#use} for plugin format.
	   */
	  function Processor() {
	    var plugins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    _classCallCheck(this, Processor);
	
	    /**
	     * @member {string} - Current PostCSS version.
	     *
	     * @example
	     * if ( result.processor.version.split('.')[0] !== '5' ) {
	     *   throw new Error('This plugin works only with PostCSS 5');
	     * }
	     */
	    this.version = '5.2.0';
	    /**
	     * @member {pluginFunction[]} - Plugins added to this processor.
	     *
	     * @example
	     * const processor = postcss([autoprefixer, precss]);
	     * processor.plugins.length //=> 2
	     */
	    this.plugins = this.normalize(plugins);
	  }
	
	  /**
	   * Adds a plugin to be used as a CSS processor.
	   *
	   * PostCSS plugin can be in 4 formats:
	   * * A plugin created by {@link postcss.plugin} method.
	   * * A function. PostCSS will pass the function a @{link Root}
	   *   as the first argument and current {@link Result} instance
	   *   as the second.
	   * * An object with a `postcss` method. PostCSS will use that method
	   *   as described in #2.
	   * * Another {@link Processor} instance. PostCSS will copy plugins
	   *   from that instance into this one.
	   *
	   * Plugins can also be added by passing them as arguments when creating
	   * a `postcss` instance (see [`postcss(plugins)`]).
	   *
	   * Asynchronous plugins should return a `Promise` instance.
	   *
	   * @param {Plugin|pluginFunction|Processor} plugin - PostCSS plugin
	   *                                                   or {@link Processor}
	   *                                                   with plugins
	   *
	   * @example
	   * const processor = postcss()
	   *   .use(autoprefixer)
	   *   .use(precss);
	   *
	   * @return {Processes} current processor to make methods chain
	   */
	
	
	  _createClass(Processor, [{
	    key: 'use',
	    value: function use(plugin) {
	      this.plugins = this.plugins.concat(this.normalize([plugin]));
	      return this;
	    }
	
	    /**
	     * Parses source CSS and returns a {@link LazyResult} Promise proxy.
	     * Because some plugins can be asynchronous it doesn’t make
	     * any transformations. Transformations will be applied
	     * in the {@link LazyResult} methods.
	     *
	     * @param {string|toString|Result} css - String with input CSS or
	     *                                       any object with a `toString()`
	     *                                       method, like a Buffer.
	     *                                       Optionally, send a {@link Result}
	     *                                       instance and the processor will
	     *                                       take the {@link Root} from it.
	     * @param {processOptions} [opts]      - options
	     *
	     * @return {LazyResult} Promise proxy
	     *
	     * @example
	     * processor.process(css, { from: 'a.css', to: 'a.out.css' })
	     *   .then(result => {
	     *      console.log(result.css);
	     *   });
	     */
	
	  }, {
	    key: 'process',
	    value: function process(css) {
	      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return new _lazyResult2.default(this, css, opts);
	    }
	  }, {
	    key: 'normalize',
	    value: function normalize(plugins) {
	      var normalized = [];
	      plugins.forEach(function (i) {
	        if (i.postcss) i = i.postcss;
	
	        if ((typeof i === 'undefined' ? 'undefined' : _typeof(i)) === 'object' && Array.isArray(i.plugins)) {
	          normalized = normalized.concat(i.plugins);
	        } else if (typeof i === 'function') {
	          normalized.push(i);
	        } else {
	          throw new Error(i + ' is not a PostCSS plugin');
	        }
	      });
	      return normalized;
	    }
	  }]);
	
	  return Processor;
	}();
	
	exports.default = Processor;
	module.exports = exports['default'];

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warning = __webpack_require__(1172);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @typedef  {object} Message
	 * @property {string} type   - message type
	 * @property {string} plugin - source PostCSS plugin name
	 */
	
	/**
	 * Provides the result of the PostCSS transformations.
	 *
	 * A Result instance is returned by {@link LazyResult#then}
	 * or {@link Root#toResult} methods.
	 *
	 * @example
	 * postcss([cssnext]).process(css).then(function (result) {
	 *    console.log(result.css);
	 * });
	 *
	 * @example
	 * var result2 = postcss.parse(css).toResult();
	 */
	var Result = function () {
	
	  /**
	   * @param {Processor} processor - processor used for this transformation.
	   * @param {Root}      root      - Root node after all transformations.
	   * @param {processOptions} opts - options from the {@link Processor#process}
	   *                                or {@link Root#toResult}
	   */
	  function Result(processor, root, opts) {
	    _classCallCheck(this, Result);
	
	    /**
	     * @member {Processor} - The Processor instance used
	     *                       for this transformation.
	     *
	     * @example
	     * for ( let plugin of result.processor.plugins) {
	     *   if ( plugin.postcssPlugin === 'postcss-bad' ) {
	     *     throw 'postcss-good is incompatible with postcss-bad';
	     *   }
	     * });
	     */
	    this.processor = processor;
	    /**
	     * @member {Message[]} - Contains messages from plugins
	     *                       (e.g., warnings or custom messages).
	     *                       Each message should have type
	     *                       and plugin properties.
	     *
	     * @example
	     * postcss.plugin('postcss-min-browser', () => {
	     *   return (root, result) => {
	     *     var browsers = detectMinBrowsersByCanIUse(root);
	     *     result.messages.push({
	     *       type:    'min-browser',
	     *       plugin:  'postcss-min-browser',
	     *       browsers: browsers
	     *     });
	     *   };
	     * });
	     */
	    this.messages = [];
	    /**
	     * @member {Root} - Root node after all transformations.
	     *
	     * @example
	     * root.toResult().root == root;
	     */
	    this.root = root;
	    /**
	     * @member {processOptions} - Options from the {@link Processor#process}
	     *                            or {@link Root#toResult} call
	     *                            that produced this Result instance.
	     *
	     * @example
	     * root.toResult(opts).opts == opts;
	     */
	    this.opts = opts;
	    /**
	     * @member {string} - A CSS string representing of {@link Result#root}.
	     *
	     * @example
	     * postcss.parse('a{}').toResult().css //=> "a{}"
	     */
	    this.css = undefined;
	    /**
	     * @member {SourceMapGenerator} - An instance of `SourceMapGenerator`
	     *                                class from the `source-map` library,
	     *                                representing changes
	     *                                to the {@link Result#root} instance.
	     *
	     * @example
	     * result.map.toJSON() //=> { version: 3, file: 'a.css', … }
	     *
	     * @example
	     * if ( result.map ) {
	     *   fs.writeFileSync(result.opts.to + '.map', result.map.toString());
	     * }
	     */
	    this.map = undefined;
	  }
	
	  /**
	   * Returns for @{link Result#css} content.
	   *
	   * @example
	   * result + '' === result.css
	   *
	   * @return {string} string representing of {@link Result#root}
	   */
	
	
	  _createClass(Result, [{
	    key: 'toString',
	    value: function toString() {
	      return this.css;
	    }
	
	    /**
	     * Creates an instance of {@link Warning} and adds it
	     * to {@link Result#messages}.
	     *
	     * @param {string} text        - warning message
	     * @param {Object} [opts]      - warning options
	     * @param {Node}   opts.node   - CSS node that caused the warning
	     * @param {string} opts.word   - word in CSS source that caused the warning
	     * @param {number} opts.index  - index in CSS node string that caused
	     *                               the warning
	     * @param {string} opts.plugin - name of the plugin that created
	     *                               this warning. {@link Result#warn} fills
	     *                               this property automatically.
	     *
	     * @return {Warning} created warning
	     */
	
	  }, {
	    key: 'warn',
	    value: function warn(text) {
	      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (!opts.plugin) {
	        if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
	          opts.plugin = this.lastPlugin.postcssPlugin;
	        }
	      }
	
	      var warning = new _warning2.default(text, opts);
	      this.messages.push(warning);
	
	      return warning;
	    }
	
	    /**
	     * Returns warnings from plugins. Filters {@link Warning} instances
	     * from {@link Result#messages}.
	     *
	     * @example
	     * result.warnings().forEach(warn => {
	     *   console.warn(warn.toString());
	     * });
	     *
	     * @return {Warning[]} warnings from plugins
	     */
	
	  }, {
	    key: 'warnings',
	    value: function warnings() {
	      return this.messages.filter(function (i) {
	        return i.type === 'warning';
	      });
	    }
	
	    /**
	     * An alias for the {@link Result#css} property.
	     * Use it with syntaxes that generate non-CSS output.
	     * @type {string}
	     *
	     * @example
	     * result.css === result.content;
	     */
	
	  }, {
	    key: 'content',
	    get: function get() {
	      return this.css;
	    }
	  }]);
	
	  return Result;
	}();
	
	exports.default = Result;
	module.exports = exports['default'];

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tokenize = __webpack_require__(257);
	
	var _tokenize2 = _interopRequireDefault(_tokenize);
	
	var _input = __webpack_require__(253);
	
	var _input2 = _interopRequireDefault(_input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HIGHLIGHT_THEME = {
	    'brackets': [36, 39], // cyan
	    'string': [31, 39], // red
	    'at-word': [31, 39], // red
	    'comment': [90, 39], // gray
	    '{': [32, 39], // green
	    '}': [32, 39], // green
	    ':': [1, 22], // bold
	    ';': [1, 22], // bold
	    '(': [1, 22], // bold
	    ')': [1, 22] // bold
	};
	
	function code(color) {
	    return '\x1B[' + color + 'm';
	}
	
	function terminalHighlight(css) {
	    var tokens = (0, _tokenize2.default)(new _input2.default(css), { ignoreErrors: true });
	    var result = [];
	    tokens.forEach(function (token) {
	        var color = HIGHLIGHT_THEME[token[0]];
	        if (color) {
	            result.push(token[1].split(/\r?\n/).map(function (i) {
	                return code(color[0]) + i + code(color[1]);
	            }).join('\n'));
	        } else {
	            result.push(token[1]);
	        }
	    });
	    return result.join('');
	}
	
	exports.default = terminalHighlight;
	module.exports = exports['default'];

/***/ },
/* 1172 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Represents a plugin’s warning. It can be created using {@link Node#warn}.
	 *
	 * @example
	 * if ( decl.important ) {
	 *     decl.warn(result, 'Avoid !important', { word: '!important' });
	 * }
	 */
	var Warning = function () {
	
	  /**
	   * @param {string} text        - warning message
	   * @param {Object} [opts]      - warning options
	   * @param {Node}   opts.node   - CSS node that caused the warning
	   * @param {string} opts.word   - word in CSS source that caused the warning
	   * @param {number} opts.index  - index in CSS node string that caused
	   *                               the warning
	   * @param {string} opts.plugin - name of the plugin that created
	   *                               this warning. {@link Result#warn} fills
	   *                               this property automatically.
	   */
	  function Warning(text) {
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Warning);
	
	    /**
	     * @member {string} - Type to filter warnings from
	     *                    {@link Result#messages}. Always equal
	     *                    to `"warning"`.
	     *
	     * @example
	     * const nonWarning = result.messages.filter(i => i.type !== 'warning')
	     */
	    this.type = 'warning';
	    /**
	     * @member {string} - The warning message.
	     *
	     * @example
	     * warning.text //=> 'Try to avoid !important'
	     */
	    this.text = text;
	
	    if (opts.node && opts.node.source) {
	      var pos = opts.node.positionBy(opts);
	      /**
	       * @member {number} - Line in the input file
	       *                    with this warning’s source
	       *
	       * @example
	       * warning.line //=> 5
	       */
	      this.line = pos.line;
	      /**
	       * @member {number} - Column in the input file
	       *                    with this warning’s source.
	       *
	       * @example
	       * warning.column //=> 6
	       */
	      this.column = pos.column;
	    }
	
	    for (var opt in opts) {
	      this[opt] = opts[opt];
	    }
	  }
	
	  /**
	   * Returns a warning position and message.
	   *
	   * @example
	   * warning.toString() //=> 'postcss-lint:a.css:10:14: Avoid !important'
	   *
	   * @return {string} warning position and message
	   */
	
	
	  _createClass(Warning, [{
	    key: 'toString',
	    value: function toString() {
	      if (this.node) {
	        return this.node.error(this.text, {
	          plugin: this.plugin,
	          index: this.index,
	          word: this.word
	        }).message;
	      } else if (this.plugin) {
	        return this.plugin + ': ' + this.text;
	      } else {
	        return this.text;
	      }
	    }
	
	    /**
	     * @memberof Warning#
	     * @member {string} plugin - The name of the plugin that created
	     *                           it will fill this property automatically.
	     *                           this warning. When you call {@link Node#warn}
	     *
	     * @example
	     * warning.plugin //=> 'postcss-important'
	     */
	
	    /**
	     * @memberof Warning#
	     * @member {Node} node - Contains the CSS node that caused the warning.
	     *
	     * @example
	     * warning.node.toString() //=> 'color: white !important'
	     */
	
	  }]);
	
	  return Warning;
	}();
	
	exports.default = Warning;
	module.exports = exports['default'];

/***/ },
/* 1173 */
979,
/* 1174 */
[1181, 1173],
/* 1175 */
986,
/* 1176 */
/***/ function(module, exports) {

	'use strict';
	module.exports = false;


/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(1152);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = __webpack_require__(__webpack_module_template_argument_0__).default;


/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(__webpack_module_template_argument_0__);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(__webpack_module_template_argument_0__);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.dd3d558b.js